/*
@license

dhtmlxSuite v.6.4.1 GPL

This software is covered by GPL license.
To use it in non-GPL project, you need obtain Commercial or Enterprise license
Please contact sales@dhtmlx.com. Usage without proper license is prohibited.
(c) XB Software.

*/
if(window.dhx&&(window.dhx_legacy=dhx,delete window.dhx),function(t,e){"object"==typeof exports&&"object"==typeof module?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.dhx=e():t.dhx=e()}(window,function(){return function(t){var e={};function i(n){if(e[n])return e[n].exports;var o=e[n]={i:n,l:!1,exports:{}};return t[n].call(o.exports,o,o.exports,i),o.l=!0,o.exports}return i.m=t,i.c=e,i.d=function(t,e,n){i.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:n})},i.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},i.t=function(t,e){if(1&e&&(t=i(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var n=Object.create(null);if(i.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var o in t)i.d(n,o,function(e){return t[e]}.bind(null,o));return n},i.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return i.d(e,"a",e),e},i.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},i.p="/codebase/",i(i.s=83)}([function(t,e,i){"use strict";(function(t){Object.defineProperty(e,"__esModule",{value:!0});var n=i(90);function o(t){var i=window.ResizeObserver,n=function(e){var i=e.el.offsetHeight,n=e.el.offsetWidth;t(n,i)};return i?e.el("div.dhx-resize-observer",{_hooks:{didInsert:function(t){new i(function(){return n(t)}).observe(t.el)}}}):e.el("iframe.dhx-resize-observer",{_hooks:{didInsert:function(t){t.el.contentWindow.onresize=function(){return n(t)},n(t)}}})}e.el=n.defineElement,e.sv=n.defineSvgElement,e.view=n.defineView,e.create=n.createView,e.inject=n.injectView,e.KEYED_LIST=n.KEYED_LIST,e.disableHelp=function(){n.DEVMODE.mutations=!1,n.DEVMODE.warnings=!1,n.DEVMODE.verbose=!1,n.DEVMODE.UNKEYED_INPUT=!1},e.resizer=o,e.resizeHandler=function(t,i){return e.create({render:function(){return o(i)}}).mount(t)},e.awaitRedraw=function(){return new t(function(t){requestAnimationFrame(function(){t()})})}}).call(this,i(12))},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(2),o=(new Date).valueOf();e.uid=function(){return"u"+o++},e.extend=function t(e,i,n){if(void 0===n&&(n=!0),i)for(var o in i){var r=i[o],s=e[o];void 0===r?delete e[o]:!n||"object"!=typeof s||s instanceof Date||s instanceof Array?e[o]=r:t(s,r)}return e},e.copy=function(t,e){var i={};for(var n in t)e&&"$"===n[0]||(i[n]=t[n]);return i},e.naturalSort=function(t){return t.sort(function(t,e){return"string"==typeof t?t.localeCompare(e):t-e})},e.findIndex=function(t,e){for(var i=t.length,n=0;n<i;n++)if(e(t[n]))return n;return-1},e.isEqualString=function(t,e){if(t.length>e.length)return!1;for(var i=0;i<t.length;i++)if(t[i].toLowerCase()!==e[i].toLowerCase())return!1;return!0},e.singleOuterClick=function(t){var e=function(i){t(i)&&document.removeEventListener("click",e)};document.addEventListener("click",e)},e.detectWidgetClick=function(t,e){var i=function(i){return e(n.locate(i,"dhx_widget_id")===t)};return document.addEventListener("click",i),function(){return document.removeEventListener("click",i)}},e.unwrapBox=function(t){return Array.isArray(t)?t[0]:t},e.wrapBox=function(t){return Array.isArray(t)?t:[t]},e.isDefined=function(t){return null!==t&&void 0!==t},e.range=function(t,e){if(t>e)return[];for(var i=[];t<=e;)i.push(t++);return i},e.isNumeric=function(t){return!isNaN(t-parseFloat(t))},e.downloadFile=function(t,e,i){void 0===i&&(i="text/plain");var n=new Blob([t],{type:i});if(window.navigator.msSaveOrOpenBlob)window.navigator.msSaveOrOpenBlob(n,e);else{var o=document.createElement("a"),r=URL.createObjectURL(n);o.href=r,o.download=e,document.body.appendChild(o),o.click(),setTimeout(function(){document.body.removeChild(o),window.URL.revokeObjectURL(r)},0)}},e.debounce=function(t,e,i){var n;return function(){var o=this,r=arguments,s=i&&!n;clearTimeout(n),n=setTimeout(function(){n=null,i||t.apply(o,r)},e),s&&t.apply(this,r)}},e.compare=function t(e,i){for(var n in e){if(e.hasOwnProperty(n)!==i.hasOwnProperty(n))return!1;switch(typeof e[n]){case"object":if(!t(e[n],i[n]))return!1;break;case"function":if(void 0===i[n]||"compare"!==n&&e[n].toString()!==i[n].toString())return!1;break;default:if(e[n]!==i[n])return!1}}for(var n in i)if(void 0===e[n])return!1;return!0}},function(t,e,i){"use strict";var n=this&&this.__assign||function(){return(n=Object.assign||function(t){for(var e,i=1,n=arguments.length;i<n;i++)for(var o in e=arguments[i])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)};function o(t,e,i){for(void 0===e&&(e="dhx_id"),void 0===i&&(i="target"),t instanceof Event&&(t=t[i]);t;){if(t.getAttribute&&t.getAttribute(e))return t;t=t.parentNode}}Object.defineProperty(e,"__esModule",{value:!0}),i(86),e.toNode=function(t){return"string"==typeof t&&(t=document.getElementById(t)||document.querySelector(t)),t||document.body},e.eventHandler=function(t,e){var i=Object.keys(e);return function(n){for(var o=t(n),r=n.target;r;){var s=r.getAttribute&&r.getAttribute("class")||"";if(s.length)for(var a=s.split(" "),c=0;c<i.length;c++)if(a.indexOf(i[c])>-1)return e[i[c]](n,o);r=r.parentNode}return!0}},e.locate=function(t,e){void 0===e&&(e="dhx_id");var i=o(t,e);return i?i.getAttribute(e):""},e.locateNode=o,e.locateNodeByClassName=function(t,e){for(t instanceof Event&&(t=t.target);t;){if(e){if(t.classList&&t.classList.contains(e))return t}else if(t.getAttribute&&t.getAttribute("dhx_id"))return t;t=t.parentNode}},e.getBox=function(t){var e=t.getBoundingClientRect(),i=document.body,n=window.pageYOffset||i.scrollTop,o=window.pageXOffset||i.scrollLeft;return{top:e.top+n,left:e.left+o,right:i.offsetWidth-e.right,bottom:i.offsetHeight-e.bottom,width:e.right-e.left,height:e.bottom-e.top}};var r,s=-1;function a(t){var e=t.getBoundingClientRect();return{left:e.left+window.pageXOffset,right:e.right+window.pageXOffset,top:e.top+window.pageYOffset,bottom:e.bottom+window.pageYOffset}}function c(t,e){var i=e.mode===r.bottom||e.mode===r.top?u(t,e):d(t,e),n=i.left,o=i.top;return{left:Math.round(n)+"px",top:Math.round(o)+"px",minWidth:Math.round(e.width)+"px",position:"absolute"}}function l(){return{rightBorder:window.pageXOffset+window.innerWidth,bottomBorder:window.pageYOffset+window.innerHeight}}function u(t,e){var i,o,s=l(),a=s.rightBorder,c=s.bottomBorder-t.bottom-e.height,u=t.top-e.height;if(e.mode===r.bottom?c>=0?o=t.bottom:u>=0&&(o=u):u>=0?o=u:c>=0&&(o=t.bottom),c<0&&u<0){if(e.auto)return d(t,n(n({},e),{mode:r.right,auto:!1}));o=c>u?t.bottom:u}if(e.centering)i=function(t,e,i){var n=(e-(t.right-t.left))/2,o=t.left-n,r=t.right+n;return o>=0&&r<=i?o:o<0?0:i-e}(t,e.width,a);else{var h=a-t.left-e.width,f=t.right-e.width;i=h>=0?t.left:f>=0?f:f>h?t.left:f}return{left:i,top:o}}function d(t,e){var i,o,s=l(),a=s.rightBorder,c=s.bottomBorder,d=a-t.right-e.width,h=t.left-e.width;if(e.mode===r.right?d>=0?i=t.right:h>=0&&(i=h):h>=0?i=h:d>=0&&(i=t.right),h<0&&d<0){if(e.auto)return u(t,n(n({},e),{mode:r.bottom,auto:!1}));i=h>d?h:t.right}if(e.centering)o=function(t,e,i){var n=(e-(t.bottom-t.top))/2,o=t.top-n,r=t.bottom+n;return o>=0&&r<=i?o:o<0?0:i-e}(t,e.height,a);else{var f=t.bottom-e.height,p=c-t.top-e.height;o=p>=0?t.top:f>0?f:f>p?f:t.top}return{left:i,top:o}}e.getScrollbarWidth=function(){if(s>-1)return s;var t=document.createElement("div");return document.body.appendChild(t),t.style.cssText="position: absolute;left: -99999px;overflow:scroll;width: 100px;height: 100px;",s=t.offsetWidth-t.clientWidth,document.body.removeChild(t),s},e.fitPosition=function(t,e){return c(a(t),e)},e.isIE=function(){var t=window.navigator.userAgent;return t.indexOf("MSIE ")>-1||t.indexOf("Trident/")>-1},e.getRealPosition=a,function(t){t.left="left",t.right="right",t.bottom="bottom",t.top="top"}(r=e.Position||(e.Position={})),e.calculatePosition=c},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=function(){function t(t){this.events={},this.context=t||this}return t.prototype.on=function(t,e,i){var n=t.toLowerCase();this.events[n]=this.events[n]||[],this.events[n].push({callback:e,context:i||this.context})},t.prototype.detach=function(t,e){var i=t.toLowerCase(),n=this.events[i];if(e&&n&&n.length)for(var o=n.length-1;o>=0;o--)n[o].context===e&&n.splice(o,1);else this.events[i]=[]},t.prototype.fire=function(t,e){void 0===e&&(e=[]);var i=t.toLowerCase();return!this.events[i]||this.events[i].map(function(t){return t.callback.apply(t.context,e)}).indexOf(!1)<0},t.prototype.clear=function(){this.events={}},t}();e.EventSystem=n,e.EventsMixin=function(t){var e=new n(t=t||{});t.detachEvent=e.detach.bind(e),t.attachEvent=e.on.bind(e),t.callEvent=e.fire.bind(e)}},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(1),o=i(2),r=function(){function t(t,e){this._uid=n.uid(),this.config=e||{}}return t.prototype.mount=function(t,e){e&&(this._view=e),t&&this._view&&this._view.mount&&(this._container=o.toNode(t),this._container.tagName?this._view.mount(this._container):this._container.attach&&this._container.attach(this))},t.prototype.unmount=function(){var t=this.getRootView();t&&t.node&&(t.unmount(),this._view=null)},t.prototype.getRootView=function(){return this._view},t.prototype.getRootNode=function(){return this._view&&this._view.node&&this._view.node.el},t.prototype.paint=function(){this._view&&(this._view.node||this._container)&&(this._doNotRepaint=!1,this._view.redraw())},t}();e.View=r,e.toViewLike=function(t){return{getRootView:function(){return t},paint:function(){return t.node&&t.redraw()},mount:function(e){return t.mount(e)}}}},function(t,e,i){"use strict";var n=this&&this.__assign||function(){return(n=Object.assign||function(t){for(var e,i=1,n=arguments.length;i<n;i++)for(var o in e=arguments[i])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)};Object.defineProperty(e,"__esModule",{value:!0});var o=i(0),r=i(6),s=["#394E79","#5E83BA","#C2D2E9","#647B37","#98A468","#F0D0A9","#EEB98E","#9A8BA5","#E3C5D5"];function a(t){var e={};return function(i){return e[i]?e[i]:e[i]=t(i)}}e.getDefaultColor=function(t){return void 0===t&&(t=0),s[t]},e.locator=function(t){return t?"string"==typeof t?function(e){return e[t]}:t:function(){return""}},e.log10=function(t){return Math.log(t)/Math.LN10},e.getTextWidth=function(t){var e={};return function(){for(var i=[],n=0;n<arguments.length;n++)i[n]=arguments[n];for(var o=e,r=0;r<i.length-1;r++)o[i[r]]=o[i[r]]||{},o=o[i[r]];var s=i.length-1;return o[s]?o[s]:o[s]=t.apply(void 0,i)}}(function(t,e){void 0===e&&(e="");var i=document.createElement("canvas").getContext("2d");return e&&(i.font=e),i.measureText(t).width});var c=a(function(t){var e=document.createElement("canvas").getContext("2d");e.fillStyle=t,e.fillRect(0,0,2,2);var i=e.getImageData(1,1,1,1).data;return[i[0],i[1],i[2]]});e.getColorShade=function(t,e){var i=c(t).map(function(t){return Math.floor(t*e+255*(1-e))});return"rgb("+i[0]+","+i[1]+","+i[2]+")"},e.getFontStyle=a(function(t){var e=document.createElementNS("http://www.w3.org/2000/svg","svg");e.setAttribute("class","dhx_chart");var i=document.createElementNS("http://www.w3.org/2000/svg","text");i.setAttribute("class",t),e.setAttribute("visibility","hidden"),i.textContent="test",e.appendChild(i),document.body.appendChild(e);var n=getComputedStyle(i),o=n.fontSize+" "+n.fontFamily;return document.body.removeChild(e),o}),e.linearGradient=function(t,e){var i=t.stops.map(function(t){return o.sv("stop",{offset:100*t.offset+"%","stop-color":t.color,"stop-opacity":t.opacity||1})});return o.sv("linearGradient",{id:e,gradientTransform:"rotate(90)"},i)},e.getRadialGradient=function(t,e,i){var r=e.map(function(t){return o.sv("stop",{offset:t.offset,"stop-color":t.color,"stop-opacity":t.opacity||1})});return o.sv("radialGradient",n({id:i,cx:0,cy:0,gradientUnits:"userSpaceOnUse"},t),r)},e.euclideanDistance=function(t,e,i,n){return Math.sqrt((t-i)*(t-i)+(e-n)*(e-n))},e.verticalCenteredText=function(t){return o.sv("tspan",{dy:"0.5ex"},t)},e.verticalTopText=function(t){return o.sv("tspan",{dy:"-0.5ex"},t)},e.verticalBottomText=function(t){return o.sv("tspan",{dy:"1.5ex"},t)},e.calcPointRef=function(t,e){return t+"_"+e},e.getClassesForRotateScale=function(t,e){var i="",n=[];switch(t===r.ScaleType.left||t===r.ScaleType.top?n.push("start-text","end-text"):t!==r.ScaleType.right&&t!==r.ScaleType.bottom||n.push("end-text","start-text"),t){case r.ScaleType.left:case r.ScaleType.right:0===e?i=n[1]:e>0?180===e?i=n[0]:e>180?e<270?i=n[0]:e>270&&(i=n[1]):e<180&&(e>90?i=n[0]:e<90&&(i=n[1])):e<0&&(-180===e?i=n[0]:e<-180?e>-270?i=n[0]:e<-270&&(i=n[1]):e>-180&&(e<-90?i=n[0]:e>-90&&(i=n[1])));break;case r.ScaleType.top:case r.ScaleType.bottom:e>0?e>180?i=n[0]:e<180&&(i=n[1]):e<0&&(e>-180?i=n[0]:e<-180&&(i=n[1]))}return i},e.getScales=function(t){var e=[];for(var i in t){var n=t[i];(n.min||n.max||n.maxTicks||n.text||n.value)&&e.push(i)}return e}},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),function(t){t.bar="bar",t.line="line",t.spline="spline",t.scatter="scatter",t.area="area",t.donut="donut",t.pie="pie",t.pie3D="pie3D",t.radar="radar",t.xBar="xbar",t.splineArea="splineArea"}(e.ChartType||(e.ChartType={})),function(t){t.toggleSeries="toggleSeries",t.chartMouseMove="chartMouseMove",t.chartMouseLeave="chartMouseLeave",t.resize="resize",t.serieClick="serieClick"}(e.ChartEvents||(e.ChartEvents={})),function(t){t.left="left",t.right="right",t.top="top",t.bottom="bottom",t.radial="radial"}(e.ScaleType||(e.ScaleType={})),function(t){t.circle="circle",t.rect="rect",t.triangle="triangle",t.rhombus="rhombus",t.simpleRect="simpleRect",t.simpleCircle="simpleCircle",t.empty="empty"}(e.PointType||(e.PointType={})),function(t){t.simple="simple",t.right="right",t.left="left",t.top="top",t.bot="bot"}(e.TooltipType||(e.TooltipType={})),function(t){t.rect="rect",t.circle="circle"}(e.Shape||(e.Shape={})),function(t){t.left="left",t.center="center",t.right="right"}(e.HorizontalPosition||(e.HorizontalPosition={})),function(t){t.top="top",t.middle="middle",t.bottom="bottom"}(e.VerticalPosition||(e.VerticalPosition={})),function(t){t.basic="basic",t.percentOnly="percentOnly",t.valueOnly="valueOnly"}(e.NoScaleSubType||(e.NoScaleSubType={}))},function(t,e,i){"use strict";function n(t){for(var i in t)e.hasOwnProperty(i)||(e[i]=t[i])}Object.defineProperty(e,"__esModule",{value:!0}),n(i(15)),n(i(57)),n(i(95)),n(i(96)),n(i(21)),n(i(98)),n(i(16)),n(i(60)),n(i(59)),n(i(99)),n(i(58)),n(i(34))},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),function(t){t.block="block",t.input="input",t.button="button",t.combo="combo",t.slider="slider",t.radioButton="radioButton",t.radioGroup="radioGroup",t.checkbox="checkbox",t.select="select",t.simpleVault="simpleVault",t.textarea="textarea",t.timepicker="timepicker",t.datepicker="datepicker",t.colorpicker="colorpicker",t.text="text"}(e.FormItemType||(e.FormItemType={})),function(t){t.change="change",t.buttonClick="buttonclick",t.validationFail="validationfail",t.beforeSend="beforesend",t.afterSend="aftersend"}(e.FormEvents||(e.FormEvents={})),function(t){t.change="change",t.configUpdate="configUpdate"}(e.BaseElementEvent||(e.BaseElementEvent={})),function(t){t.empty="",t.validEmail="email",t.validInteger="integer",t.validNumeric="numeric",t.validAplhaNumeric="alphanumeric",t.validIPv4="IPv4"}(e.Validation||(e.Validation={})),function(t){t[t.pre=0]="pre",t[t.error=1]="error",t[t.success=2]="success"}(e.ValidationStatus||(e.ValidationStatus={})),function(t){t.value="value",t.validation="validation"}(e.ClearMethod||(e.ClearMethod={}))},function(t,e,i){"use strict";var n;Object.defineProperty(e,"__esModule",{value:!0});var o=i(8);e.getFormItemCss=function(t,e){var i,n=t.labelPosition,r=t.required,s=t.disabled,a=t.hiddenLabel,c=t.css,l=t.$validationStatus,u=(i={},i[o.ValidationStatus.pre]="",i[o.ValidationStatus.error]=" dhx_form-group--state_error",i[o.ValidationStatus.success]=" dhx_form-group--state_success",i)[l]||"",d="right"===n||"left"===n?" dhx_form-group--inline":"",h=s?" dhx_form-group--disabled":"",f=a?" dhx_form-group--label_sr":"";return e?c||""+d+u+(r?" dhx_form-group--required":"")+h+f:c||""+d+h+f};var r=((n={})[o.Validation.validAplhaNumeric]=/^[a-zA-Z0-9_]+$/,n[o.Validation.validEmail]=/^.+@.+\..+$/,n[o.Validation.validInteger]=/^\d+$/,n[o.Validation.validIPv4]=/\b((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\.|$)){4}\b/,n[o.Validation.validNumeric]=/^\d+(\.\d+)?$/,n);e.getValidationMessage=function(t){var e;return(e={undefined:t.preMessage},e[o.ValidationStatus.pre]=t.preMessage,e[o.ValidationStatus.error]=t.errorMessage,e[o.ValidationStatus.success]=t.successMessage,e)[t.$validationStatus]||""},e.validateTemplate=function(t,e){return!r[t]||r[t].test(e)},e.isBlock=function(t){return Boolean(t.rows)||Boolean(t.cols)},e.validateInput=function(t,e){var i=!0;if("function"==typeof e)i=e(t);else{var n=r[e];n&&(i=n.test(t))}return i},e.isTimeFormat=function(t,e){return 12===e?/(^0?([1-9][0-2]?):[0-5][0-9]?([AP][M]?)$)/i.test(t):/(^(0[0-9]|1[0-9]|2[0-3]|[0-9]):[0-5][0-9]$)/i.test(t)},e.isEmptyObj=function(t){for(var e in t)return!1;return!0}},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),function(t){t.input="input",t.select="select",t.datepicker="datePicker",t.checkbox="checkbox",t.combobox="combobox"}(e.EditorType||(e.EditorType={})),function(t){t.scroll="scroll",t.sort="sort",t.expand="expand",t.filterChange="filterChange",t.beforeResizeStart="beforeResizeStart",t.resize="resize",t.afterResizeEnd="afterResizeEnd",t.cellClick="cellClick",t.cellRightClick="cellRightClick",t.cellMouseOver="cellMouseOver",t.cellMouseDown="cellMouseDown",t.cellDblClick="cellDblClick",t.headerCellClick="headerCellClick",t.footerCellClick="footerCellClick",t.headerCellMouseOver="headerCellMouseOver",t.footerCellMouseOver="footerCellMouseOver",t.headerCellMouseDown="headerCellMouseDown",t.footerCellMouseDown="footerCellMouseDown",t.headerCellDblClick="headerCellDblClick",t.footerCellDblClick="footerCellDblClick",t.headerCellRightClick="headerCellRightClick",t.footerCellRightClick="footerCellRightClick",t.beforeEditStart="beforeEditStart",t.afterEditStart="afterEditStart",t.beforeEditEnd="beforeEditEnd",t.afterEditEnd="afterEditEnd",t.beforeKeyDown="beforeKeyDown",t.afterKeyDown="afterKeyDown",t.headerInput="headerInput"}(e.GridEvents||(e.GridEvents={}))},function(t,e,i){"use strict";function n(t){for(var i in t)e.hasOwnProperty(i)||(e[i]=t[i])}Object.defineProperty(e,"__esModule",{value:!0}),n(i(131)),n(i(64))},function(t,e,i){(function(e,i){!function(){var n=1,o={},r=!1;function s(t){e.setImmediate?i(t):e.importScripts?setTimeout(t):(o[++n]=t,e.postMessage(n,"*"))}function a(t){"use strict";if("function"!=typeof t&&void 0!=t)throw TypeError();if("object"!=typeof this||this&&this.then)throw TypeError();var e,i,n=this,o=0,r=0,c=[];n.promise=n,n.resolve=function(t){return e=n.fn,i=n.er,o||(r=t,o=1,s(d)),n},n.reject=function(t){return e=n.fn,i=n.er,o||(r=t,o=2,s(d)),n},n._d=1,n.then=function(t,e){if(1!=this._d)throw TypeError();var i=new a;return i.fn=t,i.er=e,3==o?i.resolve(r):4==o?i.reject(r):c.push(i),i},n.catch=function(t){return n.then(null,t)};var l=function(t){o=t||4,c.map(function(t){3==o&&t.resolve(r)||t.reject(r)})};try{"function"==typeof t&&t(n.resolve,n.reject)}catch(t){n.reject(t)}return n;function u(t,e,i,n){if(2==o)return n();if("object"!=typeof r&&"function"!=typeof r||"function"!=typeof t)n();else try{var s=0;t.call(r,function(t){s++||(r=t,e())},function(t){s++||(r=t,i())})}catch(t){r=t,i()}}function d(){var t;try{t=r&&r.then}catch(t){return r=t,o=2,d()}u(t,function(){o=1,d()},function(){o=2,d()},function(){try{1==o&&"function"==typeof e?r=e(r):2==o&&"function"==typeof i&&(r=i(r),o=1)}catch(t){return r=t,l()}r==n?(r=TypeError(),l()):u(t,function(){l(3)},l,function(){l(1==o&&3)})})}}(e=this).setImmediate||e.addEventListener("message",function(t){if(t.source==e)if(r)s(o[t.data]);else{r=!0;try{o[t.data]()}catch(t){}delete o[t.data],r=!1}}),a.resolve=function(t){if(1!=this._d)throw TypeError();return t instanceof a?t:new a(function(e){e(t)})},a.reject=function(t){if(1!=this._d)throw TypeError();return new a(function(e,i){i(t)})},a.all=function(t){if(1!=this._d)throw TypeError();if(!(t instanceof Array))return a.reject(TypeError());var e=new a;return function i(n,o){return o?e.resolve(o):n?e.reject(n):(0==t.reduce(function(t,e){return e&&e.then?t+1:t},0)&&e.resolve(t),void t.map(function(e,n){e&&e.then&&e.then(function(e){return t[n]=e,i(),e},i)}))}(),e},a.race=function(t){if(1!=this._d)throw TypeError();if(!(t instanceof Array))return a.reject(TypeError());if(0==t.length)return new a;var e=new a;return function i(n,o){return o?e.resolve(o):n?e.reject(n):(0==t.reduce(function(t,e){return e&&e.then?t+1:t},0)&&e.resolve(t),void t.map(function(t,e){t&&t.then&&t.then(function(t){i(null,t)},i)}))}(),e},a._d=1,t.exports=a}()}).call(this,i(33),i(87).setImmediate)},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(2);function o(t){for(var e=t.toLowerCase().match(/\w+/g),i=0,n="",o=0;o<e.length;o++){var r=e[o];"ctrl"===r?i+=4:"shift"===r?i+=2:"alt"===r?i+=1:n=r}return i+n}var r=function(){function t(){var t=this;this._keysStorage={},document.addEventListener("keydown",function(e){var i,o=(e.ctrlKey||e.metaKey?4:0)+(e.shiftKey?2:0)+(e.altKey?1:0)+((i=e.which>=48&&e.which<=57||e.which>=65&&e.which<=90?String.fromCharCode(e.which):32!==e.which||n.isIE()?e.key:e.code)&&i.toLowerCase()),r=t._keysStorage[o];if(r)for(var s=0;s<r.length;s++)r[s].handler(e)})}return t.prototype.addHotKey=function(t,e,i){var n=o(t);this._keysStorage[n]||(this._keysStorage[n]=[]),this._keysStorage[n].push({handler:e,scope:i})},t.prototype.removeHotKey=function(t,e){var i=this._keysStorage;t&&delete i[n=o(t)];if(e)for(var n in i){for(var r=[],s=0;s<i[n].length;s++)i[n][s].scope===e&&r.push(s);if(i[n].length===r.length)delete i[n];else for(s=r.length-1;s>=0;s--)i[n].splice(r[s],1)}},t.prototype.exist=function(t){var e=o(t);return!!this._keysStorage[e]},t}();e.keyManager=new r,e.addHotkeys=function(t,i){var n=new Date,o=function(t){return function(e){i&&!1===i()||t(e)}};for(var r in t)e.keyManager.addHotKey(r,o(t[r]),n);return function(){return e.keyManager.removeHotKey(void 0,n)}}},function(t,e,i){"use strict";function n(t){for(var i in t)e.hasOwnProperty(i)||(e[i]=t[i])}Object.defineProperty(e,"__esModule",{value:!0}),n(i(102)),n(i(28))},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),function(t){t.all="all",t.level="level",t.leafs="leafs"}(e.TreeFilterType||(e.TreeFilterType={})),function(t){t.top="top",t.bot="bot",t.in="in"}(e.DropPosition||(e.DropPosition={})),function(t){t.afterAdd="afteradd",t.beforeAdd="beforeadd",t.removeAll="removeall",t.beforeRemove="beforeremove",t.afterRemove="afterremove",t.change="change",t.load="load",t.loadError="loaderror",t.beforeLazyLoad="beforelazyload",t.afterLazyLoad="afterlazyload"}(e.DataEvents||(e.DataEvents={})),function(t){t.beforeDrag="beforedrag",t.beforeDrop="beforeDrop",t.dragStart="dragstart",t.dragEnd="dragend",t.canDrop="candrop",t.cancelDrop="canceldrop",t.dropComplete="dropcomplete",t.dragOut="dragOut",t.dragIn="dragIn"}(e.DragEvents||(e.DragEvents={})),function(t){t.target="target",t.both="both",t.source="source"}(e.DragMode||(e.DragMode={})),function(t){t.child="child",t.sibling="sibling",t.complex="complex"}(e.DropBehaviour||(e.DropBehaviour={})),function(t){t.json="json",t.csv="csv",t.xml="xml"}(e.DataDriver||(e.DataDriver={}))},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(21),o=i(58);e.isEqualObj=function(t,e){for(var i in t)if(t[i]!==e[i])return!1;return!0},e.naturalCompare=function(t,e){if(isNaN(t)||isNaN(e)){var i=[],n=[];for(t.replace(/(\d+)|(\D+)/g,function(t,e,n){i.push([e||1/0,n||""])}),e.replace(/(\d+)|(\D+)/g,function(t,e,i){n.push([e||1/0,i||""])});i.length&&n.length;){var o=i.shift(),r=n.shift(),s=o[0]-r[0]||o[1].localeCompare(r[1]);if(s)return s}return i.length-n.length}return t-e},e.findByConf=function(t,e){if("function"==typeof e){if(e.call(this,t))return t}else if(e.by&&e.match&&t[e.by]===e.match)return t},e.isDebug=function(){var t=window.dhx;if(void 0!==t)return void 0!==t.debug&&t.debug},e.dhxWarning=function(t){console.warn(t)},e.dhxError=function(t){throw new Error(t)},e.toProxy=function(t){var e=typeof t;return"string"===e?new n.DataProxy(t):"object"===e?t:void 0},e.toDataDriver=function(t){if("string"==typeof t){var e=window.dhx,i=e&&e.dataDrivers||o.dataDrivers;if(i[t])return new i[t];console.warn("Incorrect data driver type:",t),console.warn("Available types:",JSON.stringify(Object.keys(i)))}else if("object"==typeof t)return t},e.copyWithoutInner=function(t,e){var i={};for(var n in t)"$"===n[0]||e&&e[n]||(i[n]=t[n]);return i},e.isTreeCollection=function(t){return Boolean(t.getRoot)},e.hasJsonOrArrayStructure=function(t){if("object"==typeof t)return!0;if("string"!=typeof t)return!1;try{var e=JSON.parse(t);return"[object Object]"===Object.prototype.toString.call(e)||Array.isArray(e)}catch(t){return!1}}},function(t,e,i){"use strict";function n(t){for(var i in t)e.hasOwnProperty(i)||(e[i]=t[i])}Object.defineProperty(e,"__esModule",{value:!0}),n(i(109)),n(i(110)),n(i(23))},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),o=this&&this.__assign||function(){return(o=Object.assign||function(t){for(var e,i=1,n=arguments.length;i<n;i++)for(var o in e=arguments[i])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)};Object.defineProperty(e,"__esModule",{value:!0});var r=i(0),s=i(4),a=i(11),c=i(2),l=function(t){function e(e,i){void 0===i&&(i={});var n=t.call(this,e,i)||this;n.config.helpMessage=n.config.helpMessage||n.config.help,n.config.labelInline&&(n.config.labelPosition="left"),n._handlers=o({showHelper:function(t){t.preventDefault(),t.stopPropagation(),n._helper.show(t.target,{mode:"left"===n.config.labelPosition?c.Position.right:c.Position.bottom})}},n._getHandlers());return n.mount(e,r.create({render:function(){return n._draw()}})),n}return n(e,t),e.prototype._getHandlers=function(){return{}},e.prototype._init=function(){},e.prototype._draw=function(){return this._drawLabel()},e.prototype._drawLabel=function(){this.config.helpMessage&&(this._helper?this._helper.attachHTML(this.config.helpMessage):(this._helper=new a.Popup({css:"dhx_tooltip dhx_tooltip--forced dhx_tooltip--light"}),this._helper.attachHTML(this.config.helpMessage)));var t=this.config,e=t.id,i=t.labelPosition,n=t.label,o=t.labelWidth,s=t.helpMessage,c="left"===i&&o?o:"";return r.el("label.dhx_label",{for:e||this._uid,style:{minWidth:c,maxWidth:c},class:s?"dhx_label--with-help":""},s?[r.el("span.dhx_label__holder",n),r.el("span.dhx_label-help.dxi.dxi-help-circle-outline",{tabindex:"0",role:"button",onclick:this._handlers.showHelper})]:n)},e}(s.View);e.Label=l},function(t,e,i){"use strict";function n(t){for(var i in t)e.hasOwnProperty(i)||(e[i]=t[i])}Object.defineProperty(e,"__esModule",{value:!0}),n(i(105)),n(i(106)),n(i(107)),n(i(62)),n(i(35))},function(t,e,i){"use strict";function n(t){if("#"===t.substr(0,1))return t;var e=/(.*?)rgb[a]?\((\d+), *(\d+), *(\d+),* *([\d]*)\)/.exec(t);return"#"+parseInt(e[2],10).toString(16)+parseInt(e[3],10).toString(16)+parseInt(e[4],10).toString(16)}Object.defineProperty(e,"__esModule",{value:!0}),e.rgbToHex=n,e.transpose=function(t,e){for(var i=[],n=0;n<t.length;n++)for(var o=t[n],r=0;r<o.length;r++){i[r]=i[r]||[];var s=e?e(o[r]):o[r];i[r].push(s)}return i},e.getStrWidth=function(t,e){void 0===e&&(e="14px Arial");var i=document.createElement("canvas").getContext("2d");return i.font=e,Math.round(i.measureText(t).width)},e.getStyleByClass=function(t,e,i,o){var r=e.querySelector("."+i),s=function(t,e){return"string"==typeof e?(t.insertAdjacentHTML("beforeend",e),t.lastChild):(t.appendChild(e),e)}(r,'<div class="'+t+'"></div>'),a=window.getComputedStyle(s),c={color:"rgb(0, 0, 0)"===a.color?o.color:n(a.color),background:"rgba(0, 0, 0, 0)"===a.backgroundColor?o.background:n(a.backgroundColor),fontSize:parseFloat(a.fontSize)};return r.removeChild(s),c.color===o.color&&c.background===o.background&&c.fontSize===o.fontSize?null:c},e.removeHTMLTags=function(t){return"string"!=typeof t&&"number"!=typeof t&&"boolean"!=typeof t?"":(""+(void 0===t||null===t?"":t)).replace(/<[^>]*>/g,"").replace(/[\"]/g,"&quot;").trim()},e.isCssSupport=function(t,e){try{return CSS.supports(t,e)}catch(n){var i=document.createElement("div");return i.style[t]=e,i.style[t]===e}},e.isRowEmpty=function(t){if(t)return Object.keys(t).reduce(function(e,i){return"id"===i||"$"===i[0]?e:(!e||void 0===t[i]||""===t[i])&&e},!0)},e.isSortable=function(t,e){return!1!==e.sortable&&t.sortable||e.sortable},e.isAutoWidth=function(t,e){if(!e){var i=!1;return t.columns.map(function(e){(!1!==e.autoWidth&&t.autoWidth||e.autoWidth)&&(i=!0)}),i}return!1!==e.autoWidth&&t.autoWidth||e.autoWidth}},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(34),o=function(){function t(t,e){this.url=this._url=t,this.config=e}return t.prototype.updateUrl=function(t,e){for(var i in void 0===e&&(e={}),this._url=this.url=t||this._url,this.url+="?",e)this.config[i]=e[i],this.url+=i+"="+encodeURIComponent(e[i])+"&";this.url=this.url.slice(0,-1)},t.prototype.load=function(){return n.ajax.get(this.url,null,{responseType:"text"})},t.prototype.save=function(t,e){switch(e){case"delete":return n.ajax.delete(this.url,t);case"update":case"insert":default:return n.ajax.post(this.url,t)}},t}();e.DataProxy=o},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),function(t){t.beforeUnSelect="beforeunselect",t.afterUnSelect="afterunselect",t.beforeSelect="beforeselect",t.afterSelect="afterselect"}(e.SelectionEvents||(e.SelectionEvents={}))},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(7);e.DataEvents=n.DataEvents,function(t){t.button="button",t.imageButton="imageButton",t.selectButton="selectButton",t.customHTMLButton="customButton",t.input="input",t.separator="separator",t.title="title",t.spacer="spacer",t.menuItem="menuItem",t.block="block",t.navItem="navItem",t.customHTML="customHTML"}(e.ItemType||(e.ItemType={})),function(t){t.inputCreated="inputCreated",t.click="click",t.openMenu="openmenu",t.beforeHide="beforeHide",t.afterHide="afterHide",t.inputFocus="inputfocus",t.inputBlur="inputblur"}(e.NavigationBarEvents||(e.NavigationBarEvents={})),function(t){t.pointer="pointer",t.click="click"}(e.NavigationType||(e.NavigationType={}))},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(0),o=i(23);e.getCount=function(t,e,i){var o={danger:" dhx_navbar-count--color_danger",secondary:" dhx_navbar-count--color_secondary",primary:" dhx_navbar-count--color_primary",success:" dhx_navbar-count--color_success"}[t.countColor]||" dhx_navbar-count--color_danger";return n.el(".dhx_navbar-count",{class:e+o+(!i&&parseInt(t.count,10)>99?" dhx_navbar-count--overlimit":"")},i&&parseInt(t.count,10)>99?"99+":t.count)},e.getIcon=function(t,e){return void 0===t&&(t=""),"dxi"===t.slice(0,3)&&(t="dxi "+t),n.el("span",{class:"dhx_"+e+"__icon "+t})},e.navbarComponentMixin=function(t,e,i,s){var a=r(t,e,i),c="ribbon"===t&&(e.type===o.ItemType.navItem||e.type===o.ItemType.imageButton);return n.el("li",{_key:e.id,class:a+(e.icon&&!e.value&&c?" dhx_ribbon__item--icon":"")+(e.src&&!e.value&&c?" dhx_ribbon__item--icon":"")+(e.size&&c?" dhx_ribbon__item--"+e.size:""),".innerHTML":e.type===o.ItemType.customHTML?e.html:void 0,dhx_id:e.type===o.ItemType.customHTML?e.id:void 0},e.type!==o.ItemType.customHTML?[s]:void 0)},e.getNavbarButtonCSS=function(t,e){var i=t.color,n=t.size,o=t.view,r=t.full,s=t.icon,a=t.circle,c=t.loading,l=t.value,u=t.active;return({danger:" dhx_button--color_danger",secondary:" dhx_button--color_secondary",primary:" dhx_button--color_primary",success:" dhx_button--color_success"}[i]||" dhx_button--color_primary")+({small:" dhx_button--size_small",medium:" dhx_button--size_medium"}[n]||" dhx_button--size_medium")+({flat:" dhx_button--view_flat",link:" dhx_button--view_link"}[o]||" dhx_button--view_flat")+(r?" dhx_button--width_full":"")+(a?" dhx_button--circle":"")+(c?" dhx_button--loading":"")+(u?" dhx_button--active":"")+(s&&!l?" dhx_button--icon":"")};var r=function(t,e,i){var n="",r="";return r=(n=i?"dhx_menu-item":"dhx_"+t+"__item")+(e.css?" "+e.css:""),e.type!==o.ItemType.spacer&&e.type!==o.ItemType.separator||(r+=" "+n+"--"+e.type),"button"!==e.type||"sidebar"!==t||e.icon||(r+=" dhx_navbar-item--colapse_hidden"),r}},function(t,e,i){"use strict";function n(t){for(var i in t)e.hasOwnProperty(i)||(e[i]=t[i])}Object.defineProperty(e,"__esModule",{value:!0}),n(i(128)),n(i(68)),n(i(41))},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(0),o=i(5);function r(t,e,i){return[Math.cos(2*Math.PI*t)*e,Math.sin(2*Math.PI*t)*i]}function s(t,e){return t-1e-6<e&&t+1e-6>e}function a(t,e){return"M"+-t+",0A"+t+","+t+" 0 "+(e?0:1)+" 1 "+t+",0A"+t+","+t+" 0 "+(e?0:1)+" 1 "+-t+",0"}e.getCoordinates=r,e.shiftCoordinates=function(t,e,i){return[t[0]+e,t[1]+i]},e.pieLikeHandlers={onmouseover:function(t,e,i,n){n.el.setAttribute("transform","translate("+t+", "+e+") scale(1.05)"),n.el.classList.add("dhx_pie-transform-delay")},onmouseout:function(t,e){e.el.setAttribute("transform","translate(0, 0)"),e.el.classList.remove("dhx_pie-transform-delay")}},e.radarScale=function(t,e,i){var c=i/2,l=1/t.scales.length,u=l>.5?1:0,d=[],h=function(t,e){return n.sv("circle",{cx:0,cy:0,r:t,fill:e,stroke:"none",class:"background-circle"})}(c,"#FAFBFD");d.push(h);for(var f=-.25,p=[],_=t.axis,v="radar-grid "+(t.zebra?"zebra":""),g=1;g<_.length;g+=2){var m=c*_[g-1],y=c*_[g],b=a(m,!0)+" "+a(y,!1),x=n.sv("path",{d:b,fill:"none",stroke:"black",class:v});p.push(x)}if(d.push(p),t.scales.forEach(function(t){var e=r(f,c,c),i=e[0],a=e[1],h=f+l,p=r(h,c,c),_=p[0],v=p[1],g="M "+i+" "+a+" A "+c+" "+c+" 0 "+u+" 1 "+_+" "+v+" L 0 0",m=n.sv("path",{d:g,stroke:"black",fill:"none",class:"radar-scale"});d.push(m);var y=[8,8],b=y[0],x=y[1],w=s(f,0)||s(f,.5)?0:f<0||f>.5?-b:b,k=s(f,-.25)||s(f,.25)?0:f<-.25||f>.25?-x:x;if(s(f,-.25)||s(f,.25)){var C=s(f,-.25)?o.verticalTopText:o.verticalBottomText,E=n.sv("text",{x:i+k,y:a+w,class:"scale-text"},[C(t)]);d.push(E)}else{var S=f>=-.25&&f<=.25?"start-text scale-text":"end-text scale-text";E=n.sv("text",{x:i+k,y:a+w,class:S},[o.verticalCenteredText(t)]),d.push(E)}f=h}),f=-.25,t.realAxis){var w=t.realAxis.map(function(t,e){var i=r(-.25,c*_[e],c*_[e]),s=i[0],a=i[1];return n.sv("text",{x:s,y:a,dx:-10,class:"radar-axis-text"},[o.verticalCenteredText(t.toString())])});d.push(w)}return n.sv("g",{transform:"translate("+e/2+", "+i/2+")"},d)}},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});i(7);!function(t){t.queue="queue",t.uploaded="uploaded",t.failed="failed",t.inprogress="inprogress"}(e.FileStatus||(e.FileStatus={})),function(t){t.uploadBegin="uploadbegin",t.beforeUploadFile="beforeuploadfile",t.uploadFile="uploadfile",t.uploadFail="uploadfail",t.uploadComplete="uploadcomplete",t.uploadProgress="uploadprogress"}(e.UploaderEvents||(e.UploaderEvents={})),function(t){t.cancel="cancel"}(e.ProgressBarEvents||(e.ProgressBarEvents={})),function(t){t.grid="grid",t.list="list"}(e.VaultMode||(e.VaultMode={}))},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),function(t){t.beforeShow="beforeShow",t.afterShow="afterShow",t.beforeHide="beforeHide",t.afterHide="afterHide",t.beforeResizeStart="beforeResizeStart",t.resize="resize",t.afterResizeEnd="afterResizeEnd",t.beforeAdd="beforeAdd",t.afterAdd="afterAdd",t.beforeRemove="beforeRemove",t.afterRemove="afterRemove",t.beforeCollapse="beforeCollapse",t.afterCollapse="afterCollapse",t.beforeExpand="beforeExpand",t.afterExpand="afterExpand"}(e.LayoutEvents||(e.LayoutEvents={})),function(t){t[t.unknown=0]="unknown",t[t.percents=1]="percents",t[t.pixels=2]="pixels",t[t.mixedpx1=3]="mixedpx1",t[t.mixedpx2=4]="mixedpx2",t[t.mixedperc1=5]="mixedperc1",t[t.mixedperc2=6]="mixedperc2"}(e.resizeMode||(e.resizeMode={}))},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),function(t){for(var i in t)e.hasOwnProperty(i)||(e[i]=t[i])}(i(108));var n=i(17);e.ItemType=n.ItemType,e.NavigationBarEvents=n.NavigationBarEvents},function(t,e,i){"use strict";function n(t){for(var i in t)e.hasOwnProperty(i)||(e[i]=t[i])}Object.defineProperty(e,"__esModule",{value:!0}),n(i(129)),n(i(67))},function(t,e,i){"use strict";function n(t){for(var i in t)e.hasOwnProperty(i)||(e[i]=t[i])}Object.defineProperty(e,"__esModule",{value:!0}),n(i(135)),n(i(69)),n(i(43));var o=i(44);e.locale=o.default},function(t,e,i){"use strict";function n(t){for(var i in t)e.hasOwnProperty(i)||(e[i]=t[i])}Object.defineProperty(e,"__esModule",{value:!0}),n(i(161)),n(i(74))},function(t,e){var i;i=function(){return this}();try{i=i||new Function("return this")()}catch(t){"object"==typeof window&&(i=window)}t.exports=i},function(t,e,i){"use strict";(function(t){Object.defineProperty(e,"__esModule",{value:!0});var n=i(15),o=i(16);function r(t){return t?t.indexOf("json")>=0?"json":t.indexOf("xml")>=0?"xml":"text":"text"}function s(e,i,s,a,c){var l=a||{};if(c&&(l.Accept="application/"+c),"GET"!==s&&(l["Content-Type"]=l["Content-Type"]||"application/json"),"GET"===s){var u=i&&"object"==typeof i?function(t){return Object.keys(t).reduce(function(e,i){var n="object"==typeof t[i]?JSON.stringify(t[i]):t[i];return e.push(i+"="+encodeURIComponent(n)),e},[]).join("&")}(i):i&&"string"==typeof i?i:"";u&&(e+=-1===e.indexOf("?")?"?":"&",e+=u),i=null}return window.fetch?window.fetch(e,{method:s,body:i?JSON.stringify(i):null,headers:l}).then(function(e){if(!e.ok)return e.text().then(function(i){return t.reject({status:e.status,statusText:e.statusText,message:i})});var i=c||r(e.headers.get("Content-Type"));if("raw"===i)return{headers:Object.fromEntries(e.headers.entries()),url:e.url,body:e.body};if(204!==e.status)switch(i){case"json":return e.json();case"xml":var s=o.toDataDriver(n.DataDriver.xml);return s?e.text().then(function(t){return s.toJsonObject(t)}):e.text();default:return e.text()}}):new t(function(t,a){var u=new XMLHttpRequest;for(var d in u.onload=function(){u.status>=200&&u.status<300?("raw"===c&&t({url:u.responseURL,headers:u.getAllResponseHeaders().trim().split(/[\r\n]+/).reduce(function(t,e){var i=e.split(": ");return t[i[0]]=i[1],t},{}),body:u.response}),204===u.status?t():t(function(t,e){switch(e){case"json":return JSON.parse(t);case"text":return t;case"xml":var i=o.toDataDriver(n.DataDriver.xml);return i?i.toJsonObject(t):{parseError:"Incorrect data driver type: 'xml'"};default:return t}}(u.responseText,c||r(u.getResponseHeader("Content-Type"))))):a({status:u.status,statusText:u.statusText})},u.onerror=function(){a({status:u.status,statusText:u.statusText,message:u.responseText})},u.open(s,e),l)u.setRequestHeader(d,l[d]);switch(s){case"POST":case"DELETE":case"PUT":u.send(void 0!==i?JSON.stringify(i):"");break;case"GET":default:u.send()}})}e.ajax={get:function(t,e,i){return s(t,e,"GET",i&&i.headers,void 0!==i?i.responseType:void 0)},post:function(t,e,i){return s(t,e,"POST",i&&i.headers,void 0!==i?i.responseType:void 0)},put:function(t,e,i){return s(t,e,"PUT",i&&i.headers,void 0!==i?i.responseType:void 0)},delete:function(t,e,i){return s(t,e,"DELETE",i&&i.headers,void 0!==i?i.responseType:void 0)}}}).call(this,i(12))},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),function(t){t.left="left",t.right="right",t.top="top",t.bottom="bottom",t.center="center"}(e.RealPosition||(e.RealPosition={})),function(t){t.right="right",t.bottom="bottom",t.center="center"}(e.Position||(e.Position={})),function(t){t.topLeft="top-left",t.topRight="top-right",t.bottomLeft="bottom-left",t.bottomRight="bottom-right"}(e.MessageContainerPosition||(e.MessageContainerPosition={}))},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});e.default={apply:"apply",reject:"reject"}},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});e.default={dragAndDrop:"Drag & drop",or:"or",browse:"Browse files",filesOrFoldersHere:"files or folders here",cancel:"Cancel",clearAll:"Clear all",clear:"Clear",add:"Add",upload:"Upload",download:"Download",error:"error",byte:"B",kilobyte:"KB",megabyte:"MB",gigabyte:"GB"}},function(t,e,i){"use strict";function n(t){for(var i in t)e.hasOwnProperty(i)||(e[i]=t[i])}Object.defineProperty(e,"__esModule",{value:!0}),n(i(124)),n(i(63)),n(i(39))},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),function(t){t.click="click",t.doubleClick="doubleclick",t.focusChange="focuschange",t.beforeEditStart="beforeEditStart",t.afterEditStart="afterEditStart",t.beforeEditEnd="beforeEditEnd",t.afterEditEnd="afterEditEnd",t.itemRightClick="itemRightClick",t.itemMouseOver="itemMouseOver",t.contextmenu="contextmenu"}(e.ListEvents||(e.ListEvents={}))},function(t,e,i){"use strict";function n(t){for(var i in t)e.hasOwnProperty(i)||(e[i]=t[i])}Object.defineProperty(e,"__esModule",{value:!0}),n(i(130)),n(i(65))},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n,o=i(42),r=i(1),s={"%d":function(t){var e=t.getDate();return e<10?"0"+e:e},"%j":function(t){return t.getDate()},"%l":function(t){return o.default.days[t.getDay()]},"%D":function(t){return o.default.daysShort[t.getDay()]},"%m":function(t){var e=t.getMonth()+1;return e<10?"0"+e:e},"%n":function(t){return t.getMonth()+1},"%M":function(t){return o.default.monthsShort[t.getMonth()]},"%F":function(t){return o.default.months[t.getMonth()]},"%y":function(t){return t.getFullYear().toString().slice(2)},"%Y":function(t){return t.getFullYear()},"%h":function(t){var e=t.getHours()%12;return 0===e&&(e=12),e<10?"0"+e:e},"%g":function(t){var e=t.getHours()%12;return 0===e&&(e=12),e},"%H":function(t){var e=t.getHours();return e<10?"0"+e:e},"%G":function(t){return t.getHours()},"%i":function(t){var e=t.getMinutes();return e<10?"0"+e:e},"%s":function(t){var e=t.getSeconds();return e<10?"0"+e:e},"%a":function(t){return t.getHours()>=12?"pm":"am"},"%A":function(t){return t.getHours()>=12?"PM":"AM"},"%u":function(t){return t.getMilliseconds()}},a={"%d":function(t,e){/(^([0-9][0-9])$)/i.test(e)?t.setDate(Number(e)):t.setDate(Number(1))},"%j":function(t,e){/(^([0-9]?[0-9])$)/i.test(e)?t.setDate(Number(e)):t.setDate(Number(1))},"%m":function(t,e){/(^([0-9][0-9])$)/i.test(e)?t.setMonth(Number(e)-1):t.setMonth(Number(0))},"%n":function(t,e){/(^([0-9]?[0-9])$)/i.test(e)?t.setMonth(Number(e)-1):t.setMonth(Number(0))},"%M":function(t,e){var i=r.findIndex(o.default.monthsShort,function(t){return t===e});-1===i?t.setMonth(0):t.setMonth(i)},"%F":function(t,e){var i=r.findIndex(o.default.months,function(t){return t===e});-1===i?t.setMonth(0):t.setMonth(i)},"%y":function(t,e){/(^([0-9][0-9])$)/i.test(e)?t.setFullYear(Number("20"+e)):t.setFullYear(Number("2000"))},"%Y":function(t,e){/(^([0-9][0-9][0-9][0-9])$)/i.test(e)?t.setFullYear(Number(e)):t.setFullYear(Number("2000"))},"%h":function(t,e,i){/(^0[1-9]|1[0-2]$)/i.test(e)&&"pm"===i||"PM"===i?t.setHours(Number(e)):t.setHours(Number(0))},"%g":function(t,e,i){/(^[1-9]$)|(^0[1-9]|1[0-2]$)/i.test(e)&&"pm"===i||"PM"===i?t.setHours(Number(e)):t.setHours(Number(0))},"%H":function(t,e){/(^[0-9][0-3]$)/i.test(e)?t.setHours(Number(e)):t.setHours(Number(0))},"%G":function(t,e){/(^([0-9]$)|[0-9][0-3]$)/i.test(e)?t.setHours(Number(e)):t.setHours(Number(0))},"%i":function(t,e){/(^([0-5][0-9])$)/i.test(e)?t.setMinutes(Number(e)):t.setMinutes(Number(0))},"%s":function(t,e){/(^([0-5][0-9])$)/i.test(e)?t.setSeconds(Number(e)):t.setSeconds(Number(0))},"%a":function(t,e){"pm"===e&&t.setHours(t.getHours()+12)},"%A":function(t,e){"PM"===e&&t.setHours(t.getHours()+12)}};function c(t){for(var e=[],i="",o=0;o<t.length;o++)"%"===t[o]?(i.length>0&&(e.push({type:n.separator,value:i}),i=""),e.push({type:n.datePart,value:t[o]+t[o+1]}),o++):i+=t[o];return i.length>0&&e.push({type:n.separator,value:i}),e}e.getFormatedDate=function(t,e){return c(t).reduce(function(t,i){return i.type===n.separator?t+i.value:s[i.value]?t+s[i.value](e):t},"")},function(t){t[t.separator=0]="separator",t[t.datePart=1]="datePart"}(n||(n={})),e.stringToDate=function(t,e,i){if("string"==typeof t){for(var o,r=[],s=0,l=null,u=0,d=c(e);u<d.length;u++){var h=d[u];if(h.type===n.separator){var f=t.indexOf(h.value,s);if(-1===f){if(i)return!1;throw new Error("Incorrect date, see docs: https://docs.dhtmlx.com/suite/calendar__api__calendar_dateformat_config.html")}l&&(r.push({formatter:l,value:t.slice(s,f)}),l=null),s=f+h.value.length}else h.type===n.datePart&&(l=h.value)}l&&r.push({formatter:l,value:t.slice(s)}),r.reverse();for(var p=0,_=r;p<_.length;p++)"%A"!==(y=_[p]).formatter&&"%a"!==y.formatter||(o=y.value);for(var v=new Date,g=0,m=r;g<m.length;g++){var y=m[g];a[y.formatter]&&a[y.formatter](v,y.value,o)}return!!i||v}}},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});e.default={monthsShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],months:["January","February","March","April","May","June","July","August","September","October","November","December"],daysShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],days:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Monday"],cancel:"Cancel"}},function(t,e,i){"use strict";function n(t){t=t.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i,function(t,e,i,n){return e+e+i+i+n+n});var e=/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(t);return e?{r:parseInt(e[1],16),g:parseInt(e[2],16),b:parseInt(e[3],16)}:null}function o(t){var e,i,n=t.r/255,o=t.g/255,r=t.b/255,s=Math.max(n,o,r),a=s-Math.min(n,o,r),c=function(t){return(s-t)/6/a+.5};if(0===a)e=i=0;else{i=a/s;var l=c(n),u=c(o),d=c(r);n===s?e=d-u:o===s?e=1/3+l-d:r===s&&(e=2/3+u-l),e<0?e+=1:e>1&&(e-=1)}return{h:Math.floor(360*e),s:i,v:s}}Object.defineProperty(e,"__esModule",{value:!0}),e.HSVtoRGB=function(t){var e={r:0,g:0,b:0},i=t.h/60,n=t.s,o=t.v,r=Math.floor(i)%6,s=i-Math.floor(i),a=255*o*(1-n),c=255*o*(1-n*s),l=255*o*(1-n*(1-s));switch(o*=255,r){case 0:e.r=o,e.g=l,e.b=a;break;case 1:e.r=c,e.g=o,e.b=a;break;case 2:e.r=a,e.g=o,e.b=l;break;case 3:e.r=a,e.g=c,e.b=o;break;case 4:e.r=l,e.g=a,e.b=o;break;case 5:e.r=o,e.g=a,e.b=c}for(var u in e)e[u]=Math.round(e[u]);return e},e.RGBToHex=function(t){return Object.keys(t).reduce(function(e,i){var n=t[i].toString(16).toUpperCase();return e+(n=1===n.length?"0"+n:n)},"#")},e.HexToRGB=n,e.RGBToHSV=o,e.HexToHSV=function(t){return o(n(t))},e.isHex=function(t){return/(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(t)}},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});e.default={cancel:"Cancel",select:"Select",rightClickToDelete:"Right click to delete",customColors:"Custom colors",addNewColor:"Add new color"}},function(t,e,i){"use strict";var n=this&&this.__assign||function(){return(n=Object.assign||function(t){for(var e,i=1,n=arguments.length;i<n;i++)for(var o in e=arguments[i])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)};Object.defineProperty(e,"__esModule",{value:!0});var o=i(148),r=i(6),s=i(70),a=i(5),c={left:s.left,right:s.right,bottom:s.bottom,top:s.top},l={left:s.leftGrid,right:s.rightGrid,bottom:s.bottomGrid,top:s.topGrid},u=function(){function t(t,e,i){this._data=t,this._padding=!1,this._charts=[],this._position=i,this._setDefaults(e),this._isXDirection=i===r.ScaleType.bottom||i===r.ScaleType.top,i!==r.ScaleType.radial&&(i===r.ScaleType.left||i===r.ScaleType.right?this.config.size=this.config.size||40+(this.config.title?40:0):this.config.size=this.config.size||20+(this.config.title?40:0))}return t.prototype.addPadding=function(){this._padding=!0},t.prototype.getSize=function(){return this.config.size},t.prototype.scaleReady=function(t){var e=[];this._charts.forEach(function(t){t.getPoints().forEach(function(t){return e.push(t[1])})}),this._axis=new o.AxisCreator(e,this.config).getScale();var i=this._position;"radial"!==i&&(t[i]+=this.config.size)},t.prototype.point=function(t){return this.config.log?this._logPoint(t):this._isXDirection?(t-this._axis.min)/(this._axis.max-this._axis.min):1-(t-this._axis.min)/(this._axis.max-this._axis.min)},t.prototype.add=function(t){this._charts.push(t)},t.prototype.paint=function(t,e){var i=this;if(this.config.hidden)return null;var n=this._axis.steps.map(function(n){return[i._isXDirection?i.point(n)*t:i.point(n)*e,n]});return c[this._position](n,this.config,t,e)},t.prototype.scaleGrid=function(){var t=this,e=this._position,i=this.config.grid,n=this.config.dashed,o=this.config.hidden;return{paint:function(r,s){var a=t._axis.steps.indexOf(t.config.targetLine),c=function(e,i){return t._axis.steps.map(function(n){return[t._isXDirection?t.point(n)*e:t.point(n)*i,n]})}(r,s),u=t.point(t.config.targetValue),d={targetLine:a,dashed:n,grid:i,targetValue:u,hidden:o};return l[e](c,r,s,d)}}},t.prototype._setDefaults=function(t){t.locator&&(this.locator=a.locator(t.locator)),this.config=n(n({},{scalePadding:20,textPadding:11,grid:!0,targetLine:null,showText:!0}),t)},t.prototype._logPoint=function(t){var e,i=Math.abs(t)/t,n=this._axis.steps,o=n.length-1,r=n.indexOf(t);-1!==r?e=r/o:e=((this._axis.min<0?n.indexOf(0):0)+i*(a.log10(Math.abs(t))-1))/o;return this._isXDirection?e:1-e},t}();e.Scale=u},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}();Object.defineProperty(e,"__esModule",{value:!0});var o=i(5),r=i(6),s=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return n(e,t),e.prototype.addScale=function(t,e){t===r.ScaleType.bottom||t===r.ScaleType.top?(this.xScale=e,this._xLocator=e.locator):(this.yScale=e,this._yLocator=o.locator(this.config.value))},e.prototype.paint=function(e,i){t.prototype.paint.call(this,e,i)},e.prototype.dataReady=function(t){var e=this;return this.config.active?(this._points=this._data.map(function(i,n){var o=e._xLocator(i),r=e._yLocator(i),s=[o,r,i.id,o,r];return t&&(s[1]+=t[n][1]),s}),this._points):this._points=[]},e.prototype._calckFinalPoints=function(t,e){var i=this;this._points.forEach(function(n,o){n[0]=i.xScale.point(n[0])*t,n[1]=i.yScale.point(n[1])*e})},e.prototype._defaultLocator=function(t){return[this._yLocator(t),this._xLocator(t)]},e}(i(47).default);e.default=s},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(1),o=i(6),r=i(5),s=i(151),a=function(){function t(t,e,i){this._data=t,this.id=e.id=e.id||n.uid(),this._events=i,this._points=[],this._setDefaults(e)}return t.prototype.toggle=function(){this.config.active=!this.config.active},t.prototype.getClosest=function(t,e){for(var i=[1/0,null,null,null],n=0,o=this._points;n<o.length;n++){var r=o[n],s=this._getClosestDist(t,e,r[0],r[1]);i[0]>s&&(i[0]=s,i[1]=r[0],i[2]=r[1],i[3]=r[2])}return i},t.prototype.getTooltipType=function(t){return o.TooltipType.top},t.prototype.getTooltipText=function(t){if(this.config.tooltip){var e=this._defaultLocator(this._data.getItem(t));return this.config.tooltipTemplate?this.config.tooltipTemplate(e):e[0]}},t.prototype.dataReady=function(t){return this._points=[]},t.prototype.paint=function(t,e){return this._calckFinalPoints(t,e)},t.prototype.getPoints=function(){return this._points},t.prototype.addScale=function(t,e){},t.prototype._getClosestDist=function(t,e,i,n){return r.euclideanDistance(t,e,i,n)},t.prototype._calckFinalPoints=function(t,e){},t.prototype._setDefaults=function(t){this.config=t},t.prototype._defaultLocator=function(t){return[null,null]},t.prototype._getPointType=function(t,e,i){return i?s.getShadeHelper(t,e,s.hoverMode):s.getShadeHelper(t,e,s.standarMode)},t}();e.default=a},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),o=this&&this.__assign||function(){return(o=Object.assign||function(t){for(var e,i=1,n=arguments.length;i<n;i++)for(var o in e=arguments[i])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)};Object.defineProperty(e,"__esModule",{value:!0});var r=i(5),s=i(6),a=function(t){function e(){var e=null!==t&&t.apply(this,arguments)||this;return e._center=[0,0],e._tooltipData=[],e}return n(e,t),e.prototype.scaleReady=function(t){for(var e in t)t[e]+=this.config.paddings;return t},e.prototype.dataReady=function(){var t=this,e=this._data;return this._sum=e.reduce(function(e,i){return i.$hidden?e:e+parseFloat(t._valueLocator(i))},0),this._points=e.reduce(function(e,i,n){if(i.$hidden)return e;var o=t._textLocator(i),s=t._valueLocator(i),a=s/t._sum,c=t._colorLocator?t._colorLocator(i):r.getDefaultColor(n);return e.push([a,s,i.id,o,c]),e},[]),this._points},e.prototype.toggle=function(t){var e=this._data.getItem(t);e&&this._data.update(t,{$hidden:!e.$hidden})},e.prototype.getClosest=function(t,e){for(var i=1-(Math.atan2(t-this._center[0],e-this._center[1])+Math.PI)/Math.PI/2,n=this._points,o=0;o<n.length;o++){if(n[o][0]>=i)return[0,this._tooltipData[o][0],this._tooltipData[o][1],n[o][2]];i-=n[o][0]}return[1/0,null,null,null]},e.prototype.getTooltipText=function(t){if(this.config.tooltip){var e=this._defaultLocator(this._data.getItem(t));return this.config.tooltipTemplate?this.config.tooltipTemplate(e):e[0]}},e.prototype.getTooltipType=function(t){return s.TooltipType.simple},e.prototype._setDefaults=function(t){var e=this,i={subType:s.NoScaleSubType.basic,paddings:20};this.config=o(o({},i),t),this._drawPointType=this._getPointType(s.PointType.empty,"none",this.config.tooltip),this._valueLocator=r.locator(t.value),this._textLocator=r.locator(t.text),t.color?this._colorLocator=r.locator(t.color):t.monochrome&&(this._colorLocator=function(i){return r.getColorShade(t.monochrome,2*e._getPercent(i))})},e.prototype._defaultLocator=function(t){return[this._valueLocator(t),this._textLocator(t)]},e.prototype._getPercent=function(t){return parseFloat(this._valueLocator(t))/this._sum},e}(i(47).default);e.default=a},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),o=this&&this.__assign||function(){return(o=Object.assign||function(t){for(var e,i=1,n=arguments.length;i<n;i++)for(var o in e=arguments[i])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)};Object.defineProperty(e,"__esModule",{value:!0});var r=i(0),s=i(5),a=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return n(e,t),e.prototype.paint=function(e,i){var n=this;t.prototype.paint.call(this,e,i);var o=this.config.pointColor||this.config.color,a="chart "+this.config.type+" "+(this.config.css||"")+" "+(this.config.dashed?"dash-line":""),c=[];if(this.config.strokeWidth&&c.push(this._getForm(this._points,this.config,a,e,i)),this.config.pointType){var l=this._getPointType(this.config.pointType,o,!1);c=c.concat(this._points.map(function(t){return l(t[0],t[1],s.calcPointRef(t[2],n.id))}))}return r.sv("g",{class:"seria",_key:this.id},c)},e.prototype._getForm=function(t,e,i,n,o){var s=t.map(function(t,e){return(e?"L":"M")+t[0]+" "+t[1]}).join(" ");return r.sv("path",{id:"seria"+e.id,d:s,stroke:e.color,class:i,"stroke-width":this.config.strokeWidth,fill:"none"})},e.prototype._setDefaults=function(t){this.config=o(o({},{alpha:1,strokeWidth:2,active:!0,tooltip:!0}),t)},e}(i(46).default);e.default=a},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default={notFound:"Not Found",selectAll:"Select All",unselectAll:"Unselect All",selectedItems:"selected items"}},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),function(t){t.click="click",t.doubleClick="doubleclick",t.focusChange="focuschange",t.beforeEditStart="beforeEditStart",t.afterEditStart="afterEditStart",t.beforeEditEnd="beforeEditEnd",t.afterEditEnd="afterEditEnd",t.itemRightClick="itemRightClick",t.itemMouseOver="itemMouseOver",t.contextmenu="contextmenu"}(e.DataViewEvents||(e.DataViewEvents={}))},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}();Object.defineProperty(e,"__esModule",{value:!0});var o=i(0),r=i(1),s=i(9),a=i(18),c=i(3),l=i(8),u=500,d=function(t){function e(e,i){void 0===i&&(i={});var n=t.call(this,null,i)||this;return n.events=new c.EventSystem,n._debounceTime=u,n._initView(i),n}return n(e,t),e.prototype.disable=function(){this.config.disabled=!0,this.paint()},e.prototype.enable=function(){this.config.disabled=!1,this.paint()},e.prototype.isDisabled=function(){return this.config.disabled},e.prototype.validate=function(){var t=!this.config.required||this.config.value,e=!this.config.validation||s.validateInput(this.config.value,this.config.validation);return this.config.$validationStatus=t&&e?l.ValidationStatus.success:l.ValidationStatus.error,this.paint(),t&&e},e.prototype.clearValidate=function(){this.config.$validationStatus=l.ValidationStatus.pre,this.paint()},e.prototype.clear=function(){this.config.value="",this.paint()},e.prototype.setValue=function(t){this.events.fire(l.BaseElementEvent.change,[t]),this.config.value=t,this.paint()},e.prototype.getValue=function(){return this.config.value||""},e.prototype.setConfig=function(t){this._initView(t)},e.prototype._initView=function(t){var e=this;if(!s.isEmptyObj(t)){for(var i in this.config={type:this.config.type,id:this.config.id,name:this.config.name,disabled:!1,value:""},t)"id"!==i&&"type"!==i&&"name"!==i&&(this.config[i]=t[i]);this.events.on(l.BaseElementEvent.change,function(t){e.config.value=t||""}),this.events.fire(l.BaseElementEvent.configUpdate,[this.config]),this.paint()}},e.prototype._init=function(){var t=this.config,e=t.validation,i=t.value;if(e&&i){var n=s.validateInput(i,e);this.config.$validationStatus=n?l.ValidationStatus.success:l.ValidationStatus.error}},e.prototype._getHandlers=function(){var t=this;return{oninput:function(e){var i=e.target.value.trim();t.config.value=i,t._debounceTimer&&clearTimeout(t._debounceTimer);var n=Date.now(),o=t._last?n-t._last:t._debounceTime;t._last=n,t._debounceTime=(o+t._debounceTime)/2+300,t._debounceTimer=setTimeout(function(){t._validate(i)},t._debounceTime)},onblur:function(){t._validate(t.config.value,!0)}}},e.prototype._draw=function(){var t=this.config,e=t.id,i=t.value,n=t.disabled,a=t.name,c=t.icon,l=t.placeholder,u=t.required,d=t.inputType,h=t.validation,f=t.hidden,p=t.autocomplete,_=t.readOnly,v=t.maxlength,g=f?" dhx_form-group--hidden":"";return o.el("div.dhx_form-group",{class:s.getFormItemCss(this.config,Boolean(u)||Boolean(h))+g},[this._drawLabel(),o.el(".dhx_input__wrapper",{},[o.el("div.dhx_input__container",{},[this.config.icon?o.el(".dhx_input__icon",{class:this.config.icon}):null,o.el("input.dhx_input",{type:d,id:e||this._uid,placeholder:l||"",value:r.isDefined(i)?i:"",name:a||"",disabled:n,required:u,readOnly:_,maxlength:v,onblur:this._handlers.onblur,oninput:this._handlers.oninput,class:c?"dhx_input--icon-padding":"",autocomplete:p?"on":"off"})]),s.getValidationMessage(this.config)&&o.el("span.dhx_input__caption",s.getValidationMessage(this.config))])])},e.prototype._validate=function(t,e){if(e&&this._debounceTimer&&clearTimeout(this._debounceTimer),this._last=null,this._debounceTimer=null,this._debounceTime=u,this.config.validation){if(!s.validateInput(t,this.config.validation))return this.config.$validationStatus=l.ValidationStatus.error,void this.paint();this.config.$validationStatus=l.ValidationStatus.success,this.paint()}else this.config.required&&(""===t?(this.config.$validationStatus=l.ValidationStatus.error,this.paint()):(this.config.$validationStatus=l.ValidationStatus.success,this.paint()));this.events.fire(l.BaseElementEvent.change,[t])},e}(a.Label);e.Input=d},function(t,e,i){"use strict";function n(t,e){t[e]&&("string"==typeof t[e]?t[e]=[{text:""+t[e]}]:t[e]=t[e].map(function(t){return"string"==typeof t&&(t={text:t}),t}))}Object.defineProperty(e,"__esModule",{value:!0}),e.normalizeColumns=function(t){for(var e=0,i=t;e<i.length;e++){var o=i[e];o.$cellCss=o.$cellCss||{},n(o,"header"),n(o,"footer"),o.header.reduce(function(t,e){return t||!!e.content},!1)&&(o.$uniqueData=[]),o.width=o.width||100,o.width<o.minWidth&&(o.width=o.minWidth),o.width>o.maxWidth&&(o.width=o.maxWidth)}},e.countColumns=function(t,e){var i=0,n=0,o=0,r=!1,s=0,a=!1;return e.map(function(t){if(i=Math.max(i,t.header.length),o+=t.hidden?0:t.width,t.footer&&(n=Math.max(n,t.footer.length),a||(a=!0)),!r)for(var e=0,s=t.header;e<s.length;e++)if(s[e].colspan)return void(r=!0)}),e.map(function(t){if(t.header.length<i)for(var e=0;e<i;e++)t.header[e]=t.header[e]||{text:""};if(a&&(t.footer=t.footer||[]),t.footer&&t.footer.length<n)for(e=0;e<n;e++)t.footer[e]=t.footer[e]||{text:""};t.header.map(function(t){t.css=t.css||"",t.text||/dhx_cell-empty/.test(t.css)||(t.css+=" dhx_cell-empty")}),""===t.header[0].text&&s++}),t.$totalWidth=o,t.$headerLevel=i,t.$footerLevel=n,t.$colspans=r,t.$footer=a,s},e.calculatePositions=function(t,e,i,n){for(var o=n.$totalWidth/n.columns.length,r=Math.round(t/o),s=Math.round(e/n.rowHeight),a=Math.round(i.top/n.rowHeight)||0,c=a-1>=0?a-1:0,l=a+s+1,u=0,d=i.left,h=0;h<n.columns.length&&(d-=n.columns[h].width)+o/2>0;h++)u++;return{xStart:u-1>=0?u-1:0,xEnd:u+r+1,yStart:c,yEnd:l}},e.getUnique=function(t,e){return t.map(function(t){return t[e]}).filter(function(t,e,i){return i.indexOf(t)===e}).sort()}},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.getWidth=function(t,e,i){return e?t.reduce(function(t,n,o){return t+=o>=i&&o<i+e?n.width:0},0):t[i].width}},function(t,e,i){"use strict";function n(t){for(var i in t)e.hasOwnProperty(i)||(e[i]=t[i])}Object.defineProperty(e,"__esModule",{value:!0}),n(i(56)),n(i(100)),n(i(27))},function(t,e,i){"use strict";(function(t){Object.defineProperty(e,"__esModule",{value:!0});var n=i(1),o=i(2),r=i(7),s=i(27),a=function(){function e(t,e,i){void 0===t&&(t={}),this.config=n.extend({autosend:!0,updateFromResponse:!0,fieldName:"file"},t),this.data=e||new r.DataCollection,this.events=i||this.data.events,this.isActive=!1,this._fileInput=document.createElement("input"),this._fileInput.type="file",this._fileInput.multiple=!0,this._initEvents(),this._dropAreas=new Map}return e.prototype.selectFile=function(){this._fileInput.click()},e.prototype.linkDropArea=function(t){var e=this,i=o.toNode(t),n=function(t){return t.preventDefault()},r=function(t){t.preventDefault(),e.parseFiles(t.dataTransfer)};i.addEventListener("dragover",n),i.addEventListener("drop",r),this._dropAreas.set(i,{dragover:n,drop:r})},e.prototype.unlinkDropArea=function(t){var e=this;if(t){var i=o.toNode(t);this._unlinkDropArea(i),this._dropAreas.delete(i)}else this._dropAreas.forEach(function(t,i){e._unlinkDropArea(i)}),this._dropAreas.clear()},e.prototype.parseFiles=function(t){if(t.items&&t.items[0]&&t.items[0].webkitGetAsEntry)this._parseAsWebkitEntry(t.items);else{for(var e=t.files,i=0;i<e.length;i++)this._addFile(e[i]);this.config.autosend&&this.send()}},e.prototype.send=function(t){var e=this;if(!this._uploadInfo||!this.isActive){var i=this.data.findAll(function(t){return t.status===s.FileStatus.queue||t.status===s.FileStatus.failed}).filter(function(t){return e.events.fire(s.UploaderEvents.beforeUploadFile,[t])});if(i.length)if(this.isActive=!0,this._uploadInfo={files:i,count:i.length,size:i.reduce(function(t,e){return t+e.file.size},0)},this.events.fire(s.UploaderEvents.uploadBegin,[i]),this.events.fire(s.UploaderEvents.uploadProgress,[0,0,this._uploadInfo.size]),this.config.singleRequest)this._xhrSend(i,t);else for(var n=0,o=i;n<o.length;n++){var r=o[n];this._xhrSend([r],t)}}},e.prototype.abort=function(t){if(t){var e=this.data.getItem(t);e&&e.request&&4!==e.request.readyState&&e.request.abort()}else{if(!this._uploadInfo||!this._uploadInfo.files)return;for(var i=0,n=this._uploadInfo.files;i<n.length;i++){var o=n[i];this.abort(o.id)}}},e.prototype._unlinkDropArea=function(t){var e=this._dropAreas.get(t);if(e){var i=e.dragover,n=e.drop;t.removeEventListener("dragover",i),t.removeEventListener("drop",n)}},e.prototype._initEvents=function(){var t=this;this._fileInput.addEventListener("change",function(){for(var e=t._fileInput.files,i=0;i<e.length;i++)t._addFile(e[i]);t.config.autosend&&t.send(),t._fileInput.value=null})},e.prototype._xhrSend=function(t,e){for(var i=this,n=this._createFormData(t,e),o=new XMLHttpRequest,r=0,a=t;r<a.length;r++){var c=a[r];this.data.update(c.id,{request:o,status:s.FileStatus.inprogress,progress:0})}o.open("POST",this.config.target),o.upload.onprogress=function(e){for(var n=0,o=t;n<o.length;n++){var r=o[n];i.data.update(r.id,{progress:e.loaded/e.total,status:s.FileStatus.inprogress})}var a=i._uploadInfo.files.reduce(function(t,e){return t+e.size*e.progress},0)||0,c=i._uploadInfo.size,l=a/i._uploadInfo.size*100||0;i.events.fire(s.UploaderEvents.uploadProgress,[l,a,c])},o.onloadend=function(){i._uploadInfo.count=i.config.singleRequest?0:i._uploadInfo.count-1;for(var e=200===o.status?s.FileStatus.uploaded:s.FileStatus.failed,n=200===o.status&&o.response?JSON.parse(o.response):null,r=0,a=t;r<a.length;r++){var c=a[r];i.data.update(c.id,{status:e}),e===s.FileStatus.uploaded?(i.config.updateFromResponse&&n&&(i.config.singleRequest&&n[c.id]?i.data.update(c.id,n[c.id]):i.config.singleRequest||i.data.update(c.id,n)),i.events.fire(s.UploaderEvents.uploadFile,[c,n])):i.events.fire(s.UploaderEvents.uploadFail,[c])}0===i._uploadInfo.count&&(i.isActive=!1,i.events.fire(s.UploaderEvents.uploadComplete,[i._uploadInfo.files]))},o.send(n)},e.prototype._parseAsWebkitEntry=function(e){for(var i=this,n=[],o=0;o<e.length;o++){var r=e[o].webkitGetAsEntry();n.push(this._traverseFileTree(r))}t.all(n).then(function(){i.config.autosend&&i.send()})},e.prototype._createFormData=function(t,e){var i=this.config.fieldName,n=new FormData,o=this.config.params;if(e)for(var r in e)n.append(r,e[r]);if(o)for(var r in o)n.append(r,o[r]);for(var s=t.length>1?"[]":"",a=0,c=t;a<c.length;a++){var l=c[a];n.append(i+s,l.file,l.file.name),n.append(i+"_fullname"+s,l.path+l.file.name),n.append(i+"_id"+s,l.id)}return n},e.prototype._addFile=function(t,e){void 0===e&&(e="");var i={id:n.uid(),file:t,progress:0,status:s.FileStatus.queue,src:null,path:e};this.data.add(i)},e.prototype._traverseFileTree=function(e){var i=this;return new t(function(t){var n=0,o=function(e,o){if(e.isFile)n++,e.file(function(e){n--,i._addFile(e,o),0===n&&t()});else if(e.isDirectory){var s=e.createReader();r(s,o+e.name+"/")}},r=function(e,i){n++,e.readEntries(function(e){n--;for(var r=0,s=e;r<s.length;r++){var a=s[r];o(a,i)}0===n&&t()})};o(e,"")})},e}();e.Uploader=a}).call(this,i(12))},function(t,e,i){"use strict";var n=this&&this.__assign||function(){return(n=Object.assign||function(t){for(var e,i=1,n=arguments.length;i<n;i++)for(var o in e=arguments[i])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)};Object.defineProperty(e,"__esModule",{value:!0});var o=i(3),r=i(91),s=i(94),a=i(21),c=i(16),l=i(15),u=i(1),d=function(){function t(t,e){this.config=t||{},this._order=[],this._pull={},this._changes={order:[]},this._initOrder=null,this._sort=new s.Sort,this._loader=new r.Loader(this,this._changes),this.events=e||new o.EventSystem(this),this.events.on(l.DataEvents.loadError,function(t){"string"!=typeof t?c.dhxError(t):c.dhxWarning(t)})}return t.prototype.add=function(t,e){var i=this;if(this.events.fire(l.DataEvents.beforeAdd,[t]))return Array.isArray(t)?t.map(function(t,n){return 0!==n&&(e+=1),i._add(t,e)}):this._add(t,e)},t.prototype.remove=function(t){var e=this;t&&(t instanceof Array?t.map(function(t){e._remove(t)}):this._remove(t))},t.prototype.removeAll=function(){this._removeAll(),this.events.fire(l.DataEvents.removeAll),this.events.fire(l.DataEvents.change)},t.prototype.exists=function(t){return!!this._pull[t]},t.prototype.getNearId=function(t){if(!this._pull[t])return this._order[0].id||""},t.prototype.getItem=function(t){return this._pull[t]},t.prototype.update=function(t,e,i){var n=this.getItem(t);if(n){if(c.isEqualObj(e,n))return;e.id&&t!==e.id?(c.dhxWarning("this method doesn't allow change id"),c.isDebug()):(u.extend(this._pull[t],e,!1),this.config.update&&this.config.update(this._pull[t]),i||this._onChange("update",t,this._pull[t]))}else c.dhxWarning("item not found")},t.prototype.getIndex=function(t){var e=u.findIndex(this._order,function(e){return e.id===t});return this._pull[t]&&e>=0?e:-1},t.prototype.getId=function(t){if(this._order[t])return this._order[t].id},t.prototype.getLength=function(){return this._order.length},t.prototype.isDataLoaded=function(t,e){return void 0===t&&(t=0),void 0===e&&(e=this._order.length),u.isNumeric(t)&&u.isNumeric(e)?0===this._order.slice(t,e).filter(function(t){return t.$empty}).length:!this.find(function(t){return t.$empty})},t.prototype.filter=function(t,e){if(this.isDataLoaded()){if((e=u.extend({add:!1,multiple:!0},e)).add||(this._order=this._initOrder||this._order,this._initOrder=null),this._filters=this._filters||{},e.multiple&&t||(this._filters={}),t){if("function"==typeof t){this._filters._={match:"_",compare:t}}else t.match?(t.compare=t.compare||function(t,e){return t===e},this._filters[t.by]=t):delete this._filters[t.by];this._applyFilters()}this.events.fire(l.DataEvents.change)}else c.dhxWarning("the method doesn't work with lazyLoad")},t.prototype.find=function(t){for(var e in this._pull){var i=c.findByConf(this._pull[e],t);if(i)return i}return null},t.prototype.findAll=function(t){var e=[];for(var i in this._pull){var n=c.findByConf(this._pull[i],t);n&&e.push(n)}return e},t.prototype.sort=function(t){if(this.isDataLoaded()){if(t)this._sort.sort(this._order,t),this._initOrder&&this._initOrder.length&&this._sort.sort(this._initOrder,t);else{for(var e in this._order=[],this._pull)this._order.push(this._pull[e]);this._applyFilters()}this.events.fire(l.DataEvents.change)}else c.dhxWarning("the method doesn't work with lazyLoad")},t.prototype.copy=function(t,e,i,n){var o=this;return t instanceof Array?t.map(function(t,r){return o._copy(t,e,i,n,r)}):this._copy(t,e,i,n)},t.prototype.move=function(t,e,i,n){var o=this;return t instanceof Array?t.map(function(t,r){return o._move(t,e,i,n,r)}):this._move(t,e,i,n)},t.prototype.forEach=function(t){for(var e=0;e<this._order.length;e++)t.call(this,this._order[e],e,this._order)},t.prototype.load=function(t,e){return"string"==typeof t&&(this.dataProxy=t=new a.DataProxy(t)),this.dataProxy=t,this._loader.load(t,e)},t.prototype.parse=function(t,e){return this._removeAll(),this._loader.parse(t,e)},t.prototype.$parse=function(t){var e=this.config.approximate;e&&(t=this._approximate(t,e.value,e.maxNum)),this._parse_data(t),this.events.fire(l.DataEvents.change,["load"]),this.events.fire(l.DataEvents.load)},t.prototype.save=function(t){this._loader.save(t)},t.prototype.changeId=function(t,e,i){if(void 0===e&&(e=u.uid()),i||this.isDataLoaded()){var n=this.getItem(t);n?(n.id=e,u.extend(this._pull[t],n),this._pull[e]=this._pull[t],i||this._onChange("update",e,this._pull[e]),delete this._pull[t]):c.dhxWarning("item not found")}else c.dhxWarning("the method doesn't work with lazyLoad")},t.prototype.isSaved=function(){return!this._changes.order.length},t.prototype.map=function(t){for(var e=[],i=0;i<this._order.length;i++)e.push(t.call(this,this._order[i],i,this._order));return e},t.prototype.mapRange=function(t,e,i){t<0&&(t=0),e>this._order.length-1&&(e=this._order.length-1);for(var n=this._order.slice(t,e),o=[],r=t;r<=e;r++)o.push(i.call(this,this._order[r],r,n));return o},t.prototype.reduce=function(t,e){for(var i=0;i<this._order.length;i++)e=t.call(this,e,this._order[i],i);return e},t.prototype.serialize=function(t){void 0===t&&(t=l.DataDriver.json);var e=this.map(function(t){var e=n({},t);return Object.keys(e).forEach(function(t){"$"===t[0]&&delete e[t]}),e}),i=c.toDataDriver(t);if(i)return i.serialize(e)},t.prototype.getInitialData=function(){return this._initOrder},t.prototype._add=function(t,e){if(this.isDataLoaded()){var i=this._addCore(t,e);return this._onChange("add",t.id,t),this.events.fire(l.DataEvents.afterAdd,[t]),i}c.dhxWarning("the method doesn't work with lazyLoad")},t.prototype._remove=function(t){if(this.isDataLoaded()){var e=this._pull[t];if(e){if(!this.events.fire(l.DataEvents.beforeRemove,[e]))return;this._removeCore(e.id),this._onChange("remove",t,e)}this.events.fire(l.DataEvents.afterRemove,[e])}else c.dhxWarning("the method doesn't work with lazyLoad")},t.prototype._copy=function(e,i,o,r,s){if(this.isDataLoaded()){if(!this.exists(e))return null;var a=u.uid();return s&&(i=-1===i?-1:i+s),o?o instanceof t||!r?o.exists(e)?(o.add(n(n({},c.copyWithoutInner(this.getItem(e))),{id:a}),i),a):(o.add(c.copyWithoutInner(this.getItem(e)),i),e):void o.add(c.copyWithoutInner(this.getItem(e)),i):(this.add(n(n({},c.copyWithoutInner(this.getItem(e))),{id:a}),i),a)}c.dhxWarning("the method doesn't work with lazyLoad")},t.prototype._move=function(t,e,i,n,o){if(this.isDataLoaded()){if(o&&(e=-1===e?-1:e+o),i&&i!==this&&this.exists(t)){var r=u.copy(this.getItem(t),!0);return i.exists(t)&&(r.id=u.uid()),n&&(r.parent=n),i.add(r,e),this.remove(t),r.id}if(this.getIndex(t)===e)return null;var s=this._order.splice(this.getIndex(t),1)[0];return-1===e&&(e=this._order.length),this._order.splice(e,0,s),this.events.fire(l.DataEvents.change),t}c.dhxWarning("the method doesn't work with lazyLoad")},t.prototype._removeAll=function(){this._pull={},this._order=[],this._changes.order=[],this._initOrder=null},t.prototype._addCore=function(t,e){return this.config.init&&(t=this.config.init(t)),t.id=t.id?t.id.toString():u.uid(),this._pull[t.id]&&c.dhxError("Item already exist"),this._initOrder&&this._initOrder.length&&this._addToOrder(this._initOrder,t,e),this._addToOrder(this._order,t,e),t.id},t.prototype._removeCore=function(t){this.getIndex(t)>=0&&(this._order=this._order.filter(function(e){return e.id!==t}),delete this._pull[t]),this._initOrder&&this._initOrder.length&&(this._initOrder=this._initOrder.filter(function(e){return e.id!==t}))},t.prototype._parse_data=function(t){var e=this._order.length;this.config.prep&&(t=this.config.prep(t));for(var i=0,n=t;i<n.length;i++){var o=n[i];this.config.init&&(o=this.config.init(o)),o.id=o.id||0===o.id?o.id:u.uid(),this._pull[o.id]=o,this._order[e++]=o}},t.prototype._approximate=function(t,e,i){for(var n=t.length,o=e.length,r=Math.floor(n/i),s=Array(Math.ceil(n/r)),a=0,c=0;c<n;c+=r){for(var l=u.copy(t[c]),d=Math.min(n,c+r),h=0;h<o;h++){for(var f=0,p=c;p<d;p++)f+=t[p][e[h]];l[e[h]]=f/(d-c)}s[a++]=l}return s},t.prototype._onChange=function(t,e,i){for(var o=0,r=this._changes.order;o<r.length;o++){var s=r[o];if(s.id===e&&!s.saving)return s.error&&(s.error=!1),s=n(n({},s),{obj:i,status:t}),void this.events.fire(l.DataEvents.change,[e,t,i])}this._changes.order.push({id:e,status:t,obj:n({},i),saving:!1}),this.events.fire(l.DataEvents.change,[e,t,i])},t.prototype._addToOrder=function(t,e,i){i>=0&&t[i]?(this._pull[e.id]=e,t.splice(i,0,e)):(this._pull[e.id]=e,t.push(e))},t.prototype._applyFilters=function(){var t=this;if(this._filters&&Object.keys(this._filters).length){var e=this._order.filter(function(e){return Object.keys(t._filters).every(function(i){return e[i]?t._filters[i].compare(e[i],t._filters[i].match,e):t._filters[i].compare(e)})});this._initOrder||(this._initOrder=this._order),this._order=e}},t}();e.DataCollection=d},function(t,e,i){"use strict";var n=this&&this.__assign||function(){return(n=Object.assign||function(t){for(var e,i=1,n=arguments.length;i<n;i++)for(var o in e=arguments[i])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)};Object.defineProperty(e,"__esModule",{value:!0});var o=i(59),r=i(60),s=i(92);e.dataDrivers={json:o.JsonDriver,csv:r.CsvDriver},e.dataDriversPro=n(n({},e.dataDrivers),{xml:s.XMLDriver})},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=function(){function t(){}return t.prototype.toJsonArray=function(t){return this.getRows(t)},t.prototype.serialize=function(t){return t},t.prototype.getFields=function(t){return t},t.prototype.getRows=function(t){return"string"==typeof t?JSON.parse(t):t},t}();e.JsonDriver=n},function(t,e,i){"use strict";var n=this&&this.__assign||function(){return(n=Object.assign||function(t){for(var e,i=1,n=arguments.length;i<n;i++)for(var o in e=arguments[i])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)};Object.defineProperty(e,"__esModule",{value:!0});var o=function(){function t(t){this.config=n(n({},{skipHeader:0,nameByHeader:!1,rowDelimiter:"\n",columnDelimiter:","}),t),this.config.nameByHeader&&(this.config.skipHeader=1)}return t.prototype.getFields=function(t,e){for(var i=t.trim().split(this.config.columnDelimiter),n={},o=0;o<i.length;o++)n[e?e[o]:o+1]=i[o];return n},t.prototype.getRows=function(t){return t.trim().split(this.config.rowDelimiter)},t.prototype.toJsonArray=function(t){var e=this,i=this.getRows(t),n=this.config.names;if(this.config.skipHeader){var o=i.splice(0,this.config.skipHeader);this.config.nameByHeader&&(n=o[0].trim().split(this.config.columnDelimiter))}return i.map(function(t){return e.getFields(t,n)})},t.prototype.serialize=function(t,e){var i=t[0]?Object.keys(t[0]).filter(function(t){return"$"!==t[0]}).join(this.config.columnDelimiter):"",n=this._serialize(t);return e?n:i+n},t.prototype._serialize=function(t){var e=this;return t.reduce(function(t,i){var n=Object.keys(i).reduce(function(t,n,o){return"$"===n[0]||"items"===n?t:""+t+i[n]+(o===i.length-1?"":e.config.columnDelimiter)},"");return i.items?t+"\n"+n+e._serialize(i.items):""+t+e.config.rowDelimiter+n},"")},t}();e.CsvDriver=o},function(t,e,i){"use strict";function n(t){var e=document.activeElement;e.classList.contains("dhx_alert__confirm-reject")||e.classList.contains("dhx_alert__confirm-aply")||t.preventDefault()}Object.defineProperty(e,"__esModule",{value:!0}),e.blockScreen=function(t){var e=document.createElement("div");return e.className="dhx_alert__overlay "+(t||""),document.body.appendChild(e),document.addEventListener("keydown",n),function(){document.body.removeChild(e),document.removeEventListener("keydown",n)}}},function(t,e,i){"use strict";var n=this&&this.__assign||function(){return(n=Object.assign||function(t){for(var e,i=1,n=arguments.length;i<n;i++)for(var o in e=arguments[i])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)};Object.defineProperty(e,"__esModule",{value:!0});var o=i(2),r=i(35),s=750,a=200;function c(t,e,i,n){var o,s,a;switch(e){case r.Position.center:return(s=t.left+window.pageXOffset+(t.width-i)/2)+8<window.pageXOffset&&(s=t.left+window.pageXOffset),{left:s,top:a=t.top+window.pageYOffset+(t.height-n)/2,pos:o=r.RealPosition.center};case r.Position.right:return o=r.RealPosition.right,(s=t.right+window.pageXOffset)+i+8>window.innerWidth+window.pageXOffset&&(s=window.pageXOffset+t.left-i,o=r.RealPosition.left),{left:s,top:a=window.pageYOffset+t.top+(t.height-n)/2,pos:o};case r.Position.bottom:default:return(s=window.pageXOffset+t.left+(t.width-i)/2)+i>window.innerWidth+window.pageXOffset?s=window.innerWidth+window.pageXOffset-i:s<0&&(s=0),o=r.RealPosition.bottom,(a=window.pageYOffset+t.bottom)+n+8>window.innerHeight+window.pageYOffset&&(a=window.pageYOffset+t.top-n,o=r.RealPosition.top),{left:s,top:a,pos:o}}}e.findPosition=c;var l=document.createElement("div"),u=document.createElement("span");u.className="dhx_tooltip__text",l.appendChild(u),l.style.position="absolute";var d,h=null,f=!1,p=null,_=null;function v(t,e,i,n,o){void 0===o&&(o=!1);var s=t.getBoundingClientRect();u.textContent=e,document.body.appendChild(l),l.className="dhx_widget dhx_tooltip"+(o?" dhx_tooltip--forced":"");var a=l.getBoundingClientRect(),d=c(s,i,a.width,a.height),h=d.left,p=d.top,_=d.pos;switch(_){case r.RealPosition.bottom:case r.RealPosition.top:case r.RealPosition.left:case r.RealPosition.right:case r.RealPosition.center:l.style.left=h+"px",l.style.top=p+"px"}l.className+=" dhx_tooltip--"+_+" "+(n||""),f=!0,o||setTimeout(function(){l.className+=" dhx_tooltip--animate"})}function g(t,e,i){var n=i.force,o=i.showDelay,c=i.hideDelay,u=i.position,g=i.css;n||(_=setTimeout(function(){v(t,e,u||r.Position.bottom,g)},o||s));var m=function(){f&&function(t){h&&(p=setTimeout(function(){document.body.removeChild(l),f=!1,p=null},t||a))}(c),clearTimeout(_),t.removeEventListener("mouseleave",m),t.removeEventListener("blur",m),document.removeEventListener("mousedown",m),h=null,d=null};n&&v(t,e,u,g,n),t.addEventListener("mouseleave",m),t.addEventListener("blur",m),document.addEventListener("mousedown",m),d=m}function m(t,e){var i=o.toNode(e.node);i!==h&&(d&&(d(),d=null),h=i,p?(clearTimeout(p),p=null,g(i,t,n(n({},e),{force:!0}))):g(i,t,e))}function y(t){var e=o.locateNode(t,"dhx_tooltip_text");e&&m(e.getAttribute("dhx_tooltip_text"),{position:e.getAttribute("dhx_tooltip_position")||r.Position.bottom,node:e})}e.tooltip=m,e.enableTooltip=function(){document.addEventListener("mousemove",y)},e.disableTooltip=function(){document.removeEventListener("mousemove",y)}},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(22),o=i(7),r=function(){function t(t,e){var i=this;if(this.config=t,this.events=e.events,this._data=e,this._selected=[],this._lastShiftSelectedIndexes=[],this._data.events.on(o.DataEvents.removeAll,function(){i._selected=[]}),"string"==typeof this.config.multiselection){-1===["click","ctrlClick"].indexOf(this.config.multiselection)&&(this.config.multiselection=!1)}this._data.events.on(o.DataEvents.afterRemove,function(t){if(i._selected=i._selected.filter(function(e){return e!==t.id}),!i.config.multiselection||0===i.getId().length){var e=i._data.getId(i._lastSelectedIndex);if(e)i.add(e);else{var n=i._data.getId(i._data.getLength()-1);n&&i.add(n)}}})}return t.prototype.getId=function(){return this.config.multiselection?this._selected:this._selected[0]},t.prototype.getItem=function(){var t=this;if(this._selected.length){var e=this._selected.map(function(e){return t._data.getItem(e)});return this.config.multiselection?e:e[0]}return null},t.prototype.contains=function(t){return t?this._selected.indexOf(t)>-1:this._selected.length>0},t.prototype.remove=function(t){var e=this;if(t)return!t&&!this._selected.length||(t?this._unselectItem(t):(this._selected.forEach(function(t){return e._unselectItem(t)}),!0));this._data.map(function(t){t.$selected=!1,e._selected=[]})},t.prototype.add=function(t,e,i){var o=this;if(this.events.fire(n.SelectionEvents.beforeSelect))return t?void(this.config.multiselection?this._addMulti(t,e,i):this._addSingle(t,e)):(this._selected=[],void this._data.map(function(t){t.$selected=!0,o._selected.push(t.id)}))},t.prototype._addMulti=function(t,e,i){var o=this,r=this._data.getIndex(t);"click"!==this.config.multiselection&&!0!==this.config.multiselection||(i?(this._addWithShift(r),this.events.fire(n.SelectionEvents.afterSelect,[t])):(this._isSelected(t)?this._unselectItem(t):this._selectItem(t),this._lastSelectedIndex=this._data.getIndex(this._selected[this._selected.length-1]),this._lastShiftSelectedIndexes=[])),"ctrlClick"===this.config.multiselection&&(i||e||(this._data.map(function(t){t.$selected=!1,o._selected=[]}),this._isSelected(t)?this._unselectItem(t):this._selectItem(t),this._lastSelectedIndex=this._data.getIndex(this._selected[this._selected.length-1]),this._lastShiftSelectedIndexes=[]),i&&(this._addWithShift(r),this.events.fire(n.SelectionEvents.afterSelect,[t])),e&&(this._isSelected(t)?this._unselectItem(t):this._selectItem(t),this._lastSelectedIndex=this._data.getIndex(this._selected[this._selected.length-1]),this._lastShiftSelectedIndexes=[]))},t.prototype._addWithShift=function(t){var e=this;t>=this._lastSelectedIndex&&(this._data.map(function(t,i){-1!==e._lastShiftSelectedIndexes.indexOf(i)&&(t.$selected=!1,e._selected=e._selected.filter(function(t){return t!==e._data.getId(i)}),e._lastShiftSelectedIndexes=e._lastShiftSelectedIndexes.filter(function(t){return t!==i&&t!==e._lastSelectedIndex}))}),this._data.map(function(i,n){n>=e._lastSelectedIndex&&n<=t&&(i.$selected=!0,-1===e._selected.indexOf(i.id)&&e._selected.push(i.id),n!==e._lastSelectedIndex&&-1===e._lastShiftSelectedIndexes.indexOf(n)&&e._lastShiftSelectedIndexes.push(n))})),t<=this._lastSelectedIndex&&(this._data.map(function(t,i){-1!==e._lastShiftSelectedIndexes.indexOf(i)&&(t.$selected=!1,e._selected=e._selected.filter(function(t){return t!==e._data.getId(i)}),e._lastShiftSelectedIndexes=e._lastShiftSelectedIndexes.filter(function(t){return t!==i&&t!==e._lastSelectedIndex}))}),this._data.map(function(i,n){n<=e._lastSelectedIndex&&n>=t&&(i.$selected=!0,-1===e._selected.indexOf(i.id)&&e._selected.push(i.id),n!==e._lastSelectedIndex&&-1===e._lastShiftSelectedIndexes.indexOf(n)&&e._lastShiftSelectedIndexes.push(n))}))},t.prototype._addSingle=function(t,e){this.remove(),this.config&&"ctrlClick"!==this.config.multiselection?this._selectItem(t):e&&this._selectItem(t)},t.prototype._isSelected=function(t){return-1!==this._selected.indexOf(t)},t.prototype._selectItem=function(t){this._selected.push(t),this._data.update(t,{$selected:!0}),this._lastSelectedIndex=this._data.getIndex(t),this.events.fire(n.SelectionEvents.afterSelect,[t])},t.prototype._unselectItem=function(t){return!!this.events.fire(n.SelectionEvents.beforeUnSelect,[t])&&(this._data.update(t,{$selected:!1}),this._selected=this._selected.filter(function(e){return e!==t}),this.events.fire(n.SelectionEvents.afterUnSelect,[t]),!0)},t}();e.Selection=r},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),function(t){t.beforeHide="beforeHide",t.beforeShow="beforeShow",t.afterHide="afterHide",t.afterShow="afterShow",t.click="click"}(e.PopupEvents||(e.PopupEvents={}))},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),function(t){t.vertical="vertical",t.horizontal="horizontal"}(e.Direction||(e.Direction={})),function(t){t.change="change",t.mousedown="mousedown",t.mouseup="mouseup"}(e.SliderEvents||(e.SliderEvents={}))},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});e.default={hours:"Hours",minutes:"Minutes",save:"save"}},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),function(t){t.change="change",t.apply="apply",t.beforeClose="beforeClose",t.afterClose="afterClose",t.close="close",t.save="save"}(e.TimepickerEvents||(e.TimepickerEvents={}))},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),function(t){t.calendar="calendar",t.years="year",t.months="month",t.timepicker="timepicker"}(e.ViewMode||(e.ViewMode={})),function(t){t.change="change",t.beforeChange="beforechange",t.modeChange="modeChange",t.monthSelected="monthSelected",t.yearSelected="yearSelected",t.cancelClick="cancelClick",t.dateMouseOver="dateMouseOver",t.dateHover="dateHover"}(e.CalendarEvents||(e.CalendarEvents={}))},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),function(t){t.change="change",t.apply="apply",t.cancelClick="cancelClick",t.modeChange="modeChange",t.selectClick="selectClick",t.colorChange="colorChange",t.viewChange="viewChange"}(e.ColorpickerEvents||(e.ColorpickerEvents={})),function(t){t.palette="palette",t.picker="picker"}(e.ViewsMode||(e.ViewsMode={}))},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(1),o=i(0),r=i(5),s=i(2),a=function(t){return t.toString()};e.bottom=function(t,e,i,c){var l=e.title,u=e.textPadding,d=e.scalePadding,h=e.textTemplate,f=e.showText,p=e.scaleRotate,_=h||a,v=[],g=0;if(f){g=u;var m=p&&!isNaN(p),y=c+u;v=t.map(function(t){var e=t[0],i=m?"rotate("+p+" "+e+" "+y+")":"",n=["scale-text","top-text"];if(m){var a=p%360;n.push(r.getClassesForRotateScale(s.Position.bottom,a))}return o.sv("text",{x:e,y:y,class:n.join(" "),transform:i},[r.verticalCenteredText(_(t[1]))])})}var b=n.uid(),x=null,w=o.sv("path",{class:"main-scale",d:"M0 "+c+" H"+(i-.5),id:b});return l&&(x=o.sv("text",{dx:i/2,dy:d+g},[o.sv("textPath",{href:"#"+b,class:"scale-title "},l)])),o.sv("g",[w,x].concat(v))},e.bottomGrid=function(t,e,i,n){for(var r=n.dashed,s=n.grid,a=n.targetLine,c=n.targetValue,l=t.length,u=[],d="grid-line "+(r?"dash-line":""),h=0;h<l;h++)if(0!==h||0!==t[h][0]||n.hidden)if(h!==a){if(s&&(_="M"+t[h][0]+" 0 V "+i,v=o.sv("path",{d:_,class:d}),u.push(v),h===l-1&&t[h][0]!==e)){var f="M"+e+" 0 V "+i,p=o.sv("path",{d:f,class:d});u.push(p)}}else{var _="M"+t[h][0]+" 0 V "+i,v=o.sv("path",{d:_,class:d+" spec-grid-line"});u.push(v)}c&&(_="M"+c*e+" 0 V "+i,v=o.sv("path",{d:_,class:d+" spec-grid-line"}),u.push(v));return o.sv("g",u)},e.top=function(t,e,i,c){var l=e.title,u=e.textPadding,d=e.scalePadding,h=e.textTemplate,f=e.showText,p=e.scaleRotate,_=h||a,v=[],g=0;if(f){g=u;var m=p&&!isNaN(p),y=-u;v=t.map(function(t){var e=["scale-text"],i=t[0],n=m?"rotate("+p+" "+i+" "+y+")":"";if(m){var a=p%360;e.push(r.getClassesForRotateScale(s.Position.top,a))}return o.sv("text",{x:i,y:y,class:e.join(" "),transform:n},[r.verticalCenteredText(_(t[1]))])})}var b=n.uid(),x=o.sv("path",{d:"M0 0 H"+i,class:"main-scale",id:b}),w=null;return l&&(w=o.sv("text",{dx:i/2,dy:-d-g},[o.sv("textPath",{href:"#"+b,class:"scale-title"},l)])),o.sv("g",[x,w].concat(v))},e.topGrid=function(t,e,i,n){for(var r=n.dashed,s=n.grid,a=n.targetLine,c=t.length,l=[],u="grid-line "+(r?"dash-line":""),d=0;d<c;d++)if(0!==d||0!==t[d][0]||n.hidden)if(d!==a){if(s&&(p="M"+t[d][0]+" 0 V "+i,_=o.sv("path",{d:p,class:u}),l.push(_),d===c-1&&0!==t[d][0])){var h="M0 0 V "+i,f=o.sv("path",{d:h,class:u});l.push(f)}}else{var p="M"+t[d][0]+" 0 V "+i,_=o.sv("path",{d:p,class:u+" spec-grid-line"});l.push(_)}return o.sv("g",l)},e.left=function(t,e,i,c){var l=e.title,u=e.textPadding,d=e.scalePadding,h=e.textTemplate,f=e.showText,p=e.scaleRotate,_=h||a,v=[],g=0;if(f){var m=r.getFontStyle("scale-text"),y=0,b=p&&!isNaN(p);v=t.map(function(t){var e=t[0],i=-u,n=b?"rotate("+p+" "+i+" "+e+")":"",a=["scale-text"],c=_(t[1]);if(l){var d=r.getTextWidth(c,m);y<d&&(y=d)}if(b){var h=p%360;a.push(r.getClassesForRotateScale(s.Position.left,h))}else a.push("end-text");return o.sv("text",{x:i,y:e,class:a.join(" "),transform:n},[r.verticalCenteredText(c)])}),g=y+u}var x=n.uid(),w=o.sv("path",{class:"main-scale",d:"M0 "+c+" V 0.5",id:x}),k=null;return l&&(k=o.sv("text",{dx:c/2,dy:-d-g},[o.sv("textPath",{href:"#"+x,class:"scale-title"},l)])),o.sv("g",[w,k].concat(v))},e.leftGrid=function(t,e,i,n){for(var r=n.dashed,s=n.grid,a=n.targetLine,c=n.targetValue,l=t.length,u=[],d="grid-line "+(r?"dash-line":""),h=0;h<l;h++)if(0!==h||t[h][0]!==i||n.hidden)if(a!==h){if(s&&(_="M0 "+t[h][0]+" H "+e,v=o.sv("path",{d:_,class:d}),u.push(v),h===l-1&&t[h][0]!==e)){var f="M0 0 H"+e,p=o.sv("path",{d:f,class:d});u.push(p)}}else{var _="M0 "+t[h][0]+" H "+e,v=o.sv("path",{d:_,class:d+" spec-grid-line"});u.push(v)}c&&(_="M0 "+c*i+" H "+e,v=o.sv("path",{d:_,class:d+" spec-grid-line"}),u.push(v));return o.sv("g",u)},e.right=function(t,e,i,c){var l=e.title,u=e.textPadding,d=e.scalePadding,h=e.textTemplate,f=e.showText,p=e.scaleRotate,_=h||a,v=[],g=0;if(f){var m=r.getFontStyle("scale-text"),y=0,b=p&&!isNaN(p);v=t.map(function(t){var e=_(t[1]),n=t[0],a=i+u,c=b?"rotate("+p+" "+a+" "+n+")":"",d=["scale-text"];if(l){var h=r.getTextWidth(e,m);y<h&&(y=h)}if(b){var f=p%360;d.push(r.getClassesForRotateScale(s.Position.right,f))}else d.push("start-text");return o.sv("text",{x:a,y:n,class:d.join(" "),transform:c},[r.verticalCenteredText(e)])}),g=u+y}var x=n.uid(),w=o.sv("path",{d:"M"+i+" "+c+" V 0",class:"main-scale",id:x}),k=null;return l&&(k=o.sv("text",{dx:c/2,dy:d+g},[o.sv("textPath",{href:"#"+x,class:"scale-title"},l)])),o.sv("g",[w,k].concat(v))},e.rightGrid=function(t,e,i,n){for(var r=n.dashed,s=n.grid,a=n.targetLine,c=t.length,l=[],u="grid-line "+(r?"dash-line":""),d=0;d<c;d++)if(0!==d||t[d][0]!==i||n.hidden)if(a!==d){if(s&&(p="M0 "+t[d][0]+" H "+e,_=o.sv("path",{d:p,class:u}),l.push(_),d===c-1&&t[d][0]!==e)){var h="M0 0 H"+e,f=o.sv("path",{d:h,class:u});l.push(f)}}else{var p="M0 "+t[d][0]+" H "+e,_=o.sv("path",{d:p,class:u+" spec-grid-line"});l.push(_)}return o.sv("g",l)}},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),o=this&&this.__assign||function(){return(o=Object.assign||function(t){for(var e,i=1,n=arguments.length;i<n;i++)for(var o in e=arguments[i])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)};Object.defineProperty(e,"__esModule",{value:!0});var r=i(0),s=i(5),a=i(6),c=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return n(e,t),e.prototype.paint=function(e,i,n){t.prototype.paint.call(this,e,i);var o=[];return this._form(e,i,o,n),this._markers(o),r.sv("g",{class:"seria",_key:this.id},o)},e.prototype.paintformAndMarkers=function(e,i,n){t.prototype.paint.call(this,e,i);var o=[],s=[];return this._form(e,i,o,n),this._markers(s),[r.sv("g",{class:"seria",_key:this.id},o),r.sv("g",{class:"seria_markers",_key:this.id+"_markers"},s)]},e.prototype._markers=function(t){var e=this;if(this.config.pointType){var i=this.config.pointColor||this.config.color,n=this._getPointType(this.config.pointType,i,!1);t.push.apply(t,this._points.map(function(t){return n(t[0],t[1],s.calcPointRef(t[2],e.id))}))}},e.prototype._form=function(t,e,i,n){var o="chart "+this.config.type+" "+(this.config.css||"")+" "+(this.config.dashed?"dash-line":""),s=this.config,a=s.id,c=s.fill,l=s.alpha,u=s.color,d=s.strokeWidth,h=this._points,f=h[h.length-1],p="";if(n){for(var _=n.length-1;_>=0;_--){var v=n[_];p+=_===h.length-1?"M"+v[0]+" "+v[1]+" ":"L"+v[0]+" "+v[1]+" "}p+=h.map(function(t,e){return e?"L "+t[0]+" "+t[1]:"V "+t[1]}).join(" ")+"Z"}else p+=h.map(function(t,i){return i?"L"+t[0]+" "+t[1]:"M0 "+e+" L0 "+t[1]+" L"+t[0]+" "+t[1]}).join(" ")+"L"+t+" "+f[1]+" V "+e;if(d){var g=h.length-1,m=h.map(function(t,e){return(e?"L":"M")+(t[0]+function(t){return t===g?-.5:t?0:.5}(e))+" "+t[1]}).join(" "),y=r.sv("path",{d:m,"stroke-width":d,stroke:u,fill:"none",class:o});i.push(y)}var b=r.sv("path",{id:"seria"+a,d:p,class:o,fill:c,"fill-opacity":l,stroke:"none"});return i.push(b),i},e.prototype._setDefaults=function(t){var e={alpha:.3,strokeWidth:2,fill:t.color||"#5E83BA",color:"#5E83BA",active:!0,tooltip:!0,pointType:a.PointType.empty};this.config=o(o({},e),t);var i=this.config.tooltip,n=this.config.pointType,r=this.config.pointColor||this.config.color;n&&(this._drawPointType=this._getPointType(n,r,i))},e}(i(46).default);e.default=c},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),o=this&&this.__assign||function(){return(o=Object.assign||function(t){for(var e,i=1,n=arguments.length;i<n;i++)for(var o in e=arguments[i])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)};Object.defineProperty(e,"__esModule",{value:!0});var r=i(1),s=i(0),a=i(5),c=i(6),l=function(t){function e(){var e=null!==t&&t.apply(this,arguments)||this;return e._shift=0,e._handlers={onclick:function(t,i){return e._events.fire(c.ChartEvents.serieClick,[t,i])}},e}return n(e,t),e.prototype.addScale=function(e,i){t.prototype.addScale.call(this,e,i),i.addPadding()},e.prototype.seriesShift=function(t){return this._shift=t,this.config.barWidth},e.prototype.paint=function(e,i,n){if(t.prototype.paint.call(this,e,i),!this.config.active)return null;var o=[];this._gradient&&o.push(s.sv("defs",[this._gradient()]));var r="chart "+this.config.type+" "+(this.config.css||"")+" "+(this.config.dashed?"dash-line":""),a=this._getForm(this._points,r,e,i,n);return o=o.concat(a),s.sv("g",{class:"seria",_key:this.id},o)},e.prototype.getTooltipType=function(t,e,i){return void 0!==this.config.baseLine&&this._baseLinePosition<i?c.TooltipType.bot:c.TooltipType.top},e.prototype._getClosestDist=function(t,e,i,n){return this.config.stacked&&e<n?1/0:Math.abs(t-i)},e.prototype._path=function(t,e){return t[0]+=this._shift,"\nM "+(t[0]-this.config.barWidth/2)+" "+e+"\nV "+t[1]+"\nh "+this.config.barWidth+"\nV "+e},e.prototype._base=function(t){var e=this.config.baseLine;return this._baseLinePosition=void 0!==e?this.yScale.point(e)*t:t-1},e.prototype._text=function(t,e,i){var n=t[0],o=(e+t[1])/2;return{x:n,y:o,class:"bar-text",transform:i&&!isNaN(i)?"rotate("+i+" "+n+" "+o+")":""}},e.prototype._getForm=function(t,e,i,n,o){var r=this,c=this.config,l=c.fill,u=c.alpha,d=c.showText,h=c.showTextTemplate,f=c.showTextRotate,p=[],_=this._base(n),v=function(t){return o?o[t][1]:_},g=t.map(function(t,i){return s.sv("path",{_key:"seria"+r.config.id+i,d:r._path(t,v(i)),class:e,fill:l,onclick:[r._handlers.onclick,t[2],r.config.value],"fill-opacity":u})});if(p.push.apply(p,g),d||h||f){var m=t.map(function(t,e){var i=r._getText(t);return function(t,e){return Math.abs(v(e)-t[1])>16}(t,e)?s.sv("text",r._text(t,v(e),f),[h?a.verticalCenteredText(h(i)):a.verticalCenteredText(i)]):null});p.push.apply(p,m)}return p},e.prototype._getText=function(t){return t[4].toString()},e.prototype._setDefaults=function(t){var e={barWidth:30,alpha:1,active:!0,tooltip:!0,pointType:c.PointType.empty};this.config=o(o({},e),t);var i=this.config.tooltip,n=this.config.pointType,s=this.config.pointColor||this.config.color;if(n&&(this.config.pointType=n,this._drawPointType=this._getPointType(n,s,i)),this.config.gradient){var l="gradient"+r.uid(),u=this.config.gradient(this.config.fill);this._gradient=function(){return a.linearGradient(u,l)},this.config.fill="url(#"+l+")"}},e}(i(46).default);e.default=l},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default=function(t,e){var i,n=t.length;if(n<3)i=t;else{var o=t[0],r=t[0],s=t[1],a=t[2];i=[t[0].slice(0,2)];for(var c=1;c<n;c++)i.push([(-o[0]+6*r[0]+s[0])/6,(-o[1]+6*r[1]+s[1])/6,(r[0]+6*s[0]-a[0])/6,(r[1]+6*s[1]-a[1])/6,s[0],s[1]]),o=r,r=s,s=a,a=t[c+2]||a}var l="";for(c=0;c<i.length;c++){var u=i[c],d=u.length;l+=c?d>4?"C"+u[0]+" "+u[1]+"\n\t\t\t\t"+u[2]+" "+u[3]+"\n\t\t\t\t"+u[4]+" "+u[5]:"S"+u[0]+" "+u[1]+"\n\t\t\t\t"+u[2]+" "+u[3]:(e?"L":"M")+u[d-2]+" "+u[d-1]}return l}},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),function(t){t.change="change",t.open="open",t.input="input",t.beforeClose="beforeClose",t.afterClose="afterClose",t.close="close"}(e.ComboboxEvents||(e.ComboboxEvents={})),function(t){t[t.default=0]="default",t[t.error=1]="error",t[t.success=2]="success"}(e.ComboState||(e.ComboState={}))},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default={simpleVaultText:"Drag & drop files or folders here or",simpleVaultLabel:"browse files"}},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(1),o=i(0),r=i(54),s=i(20),a=i(10),c=i(190),l=i(2);function u(t,e,i,n,o){var r=l.locateNodeByClassName(o.target,"dhx_grid-cell");if(r){var s=r.parentNode,a=s.parentNode,c=Array.prototype.indexOf.call(s.childNodes,r),u=i.columns[e+c],d=Array.prototype.indexOf.call(a.childNodes,s),h=i.data[t+d];i.events.fire(n,[h,u,o])}}e.getHandlers=function(t,e,i){return{onclick:[u,t,e,i,a.GridEvents.cellClick],onmouseover:[u,t,e,i,a.GridEvents.cellMouseOver],onmousedown:[u,t,e,i,a.GridEvents.cellMouseDown],ondblclick:[u,t,e,i,a.GridEvents.cellDblClick],oncontextmenu:[u,t,e,i,a.GridEvents.cellRightClick]}},e.getCells=function(t){if(!t.data||!t.columns)return[];var e=t.$positions,i=t.data?t.data.slice(e.yStart,e.yEnd):[],r=t.columns.slice(e.xStart,e.xEnd);return i.map(function(e,a){var l=i.length-1===a,u="";return t.rowCss&&(u=t.rowCss(e)),e.$css&&(u+=e.$css),o.el(".dhx_grid-row",{style:{height:l?t.rowHeight+1:t.rowHeight},dhx_id:e.id,class:u,_key:e.id,_flags:o.KEYED_LIST},r.map(function(i){if(!i.hidden){var r=i.template?i.template(e[i.id],e,i):function(t){return"boolean"!=typeof t&&"boolean"!==i.type||"string"==typeof t?t||0===t?t:"":""+Boolean(t)}(e[i.id]);"string"==typeof r&&(r=o.el("div.dhx_cell-content",i.template&&(t.htmlEnable&&!1!==i.htmlEnable||i.htmlEnable)?{".innerHTML":r}:r));var a=((i.$cellCss[e.id]||"")+" dhx_"+i.type+"-cell").replace(/\s+/g," "),l=i.width,u=t.$editable&&t.$editable.row===e.id&&t.$editable.col===i.id;if((u||"boolean"===i.type&&(t.editable||i.editable))&&(t.splitAt&&t.columns.length!==t.splitAt&&t.columns.indexOf(i)<t.splitAt||(r=function(t,e,i){return c.getEditor(t,e,i)}(e,i,t).toHTML(),a+=" dhx_grid-cell__editable",t.splitAt===t.columns.indexOf(i)+1&&(l-=1))),"tree"===t.type&&t.firstColId===i.id)return function(t,e,i,n){var r=n.$editable&&n.$editable.row===e.id&&n.$editable.col===i.id,a="";n.dragMode&&"row"===n.dragItem&&(a+=(e.$drophere&&!r?" dhx_grid-cell--drophere":"")+(e.$dragtarget&&!r?" dhx_grid-cell--dragtarget":"")+(r?"":" dhx_grid-cell--drag"));var c=24*e.$level;return o.el(".dhx_grid-cell",{class:"dhx_tree-cell "+(i.$cellCss[e.id]||"")+" "+(e.$items?"dhx_grid-expand-cell":"")+" "+(r?"dhx_tree-editing-cell":"")+" "+a,style:{width:i.width,lineHeight:n.rowHeight-1+"px",padding:e.$items?0:"0 0 0 "+c+"px"}},[e.$items?o.el(".dhx_grid-expand-cell-icon",{class:e.$opened?"dxi dxi-chevron-up":"dxi dxi-chevron-down",dhx_id:e.id,style:{padding:e.$level?"0 4px 0 "+c+"px":"0 0 0 4px"}}):null,o.el(".dhx_tree-cell",{title:s.removeHTMLTags(e[i.id]),style:{width:"100%",height:"100%",textAlign:"left"}},[t])])}(r,e,i,t);var d=void 0;return"boolean"===i.type&&(d=n.findIndex(i.header,function(t){return void 0!==t.text})),t.dragMode&&"row"===t.dragItem&&(a+=(e.$drophere&&!u?" dhx_grid-cell--drophere":"")+(e.$dragtarget&&!u?" dhx_grid-cell--dragtarget":"")+(u?"":" dhx_grid-cell--drag")),o.el(".dhx_grid-cell",{class:a,style:{width:l,lineHeight:t.rowHeight-1+"px"},_key:i.id,title:"boolean"===i.type?d.text:s.removeHTMLTags("string"==typeof r?r:e[i.id])},[r])}}))})},e.getSpans=function(t){var e=[],i=t.columns;if(!i.length)return null;if(!t.spans)return null;for(var a=t.spans.sort(function(t,e){return"string"==typeof t.row&&"string"==typeof e.row?t.row.localeCompare(e.row):t.row-e.row}),c=t.rowHeight,l=function(l){var u=a[l].row,d=a[l].column,h=a[l].rowspan,f=a[l].colspan,p=a[l].css;if(1===h)return"continue";var _=n.findIndex(i,function(t){return""+t.id==""+d}),v=n.findIndex(t.data,function(t){return""+t.id==""+u});if(_<0||v<0)return"continue";var g=i[_],m=t.data[v];if(g.hidden)return"continue";var y=a[l].text?a[l].text:void 0===m[d]?"":m[d],b=y;y="string"==typeof(y=(g.template||function(t,e,i){return t||0===t?t:""})(y,m,g))?o.el("div.dhx_span-cell-content",{".innerHTML":y}):y;for(var x=t.rowHeight*v-1,w=0,k=_-1;k>=0;k--)w+=i[k].width;var C=g.header[0].text?"dhx_span-cell":"dhx_span-cell dhx_span-cell--title";p&&(C+=" "+p),0===v&&(C+=" dhx_span-first-row"),0===_&&(C+=" dhx_span-first-col");var E=_===i.length-1,S=_+f===i.length;(E||S)&&(C+=" dhx_span-last-col"),C+=f?" dhx_span-string-cell":" dhx_span-"+(g.type||"string")+"-cell";var O=f>1?r.getWidth(t.columns,f,_):g.width;e.push(o.el("div",{class:C,style:{width:O,height:(h||1)*c,top:x,left:w,lineHeight:t.rowHeight+"px"},title:s.removeHTMLTags(b)},[y]))},u=0;u<a.length;u++)l(u);return e},e.getShifts=function(t){return{x:t.columns.slice(0,t.$positions.xStart).reduce(function(t,e){return t+e.width},0),y:t.$positions.yStart*t.rowHeight}}},function(t,e,i){"use strict";var n=this&&this.__assign||function(){return(n=Object.assign||function(t){for(var e,i=1,n=arguments.length;i<n;i++)for(var o in e=arguments[i])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)},o=this&&this.__spreadArrays||function(){for(var t=0,e=0,i=arguments.length;e<i;e++)t+=arguments[e].length;var n=Array(t),o=0;for(e=0;e<i;e++)for(var r=arguments[e],s=0,a=r.length;s<a;s++,o++)n[o]=r[s];return n};Object.defineProperty(e,"__esModule",{value:!0});var r=i(0),s=i(54),a=i(20),c=i(10),l=i(78);function u(t,e,i,n){e.events.fire(i,[t,n])}function d(t,e,i){return{onclick:[u,t,i,c.GridEvents[e+"CellClick"]],onmouseover:[u,t,i,c.GridEvents[e+"CellMouseOver"]],onmousedown:[u,t,i,c.GridEvents[e+"CellMouseDown"]],ondblclick:[u,t,i,c.GridEvents[e+"CellDblClick"]],oncontextmenu:[u,t,i,c.GridEvents[e+"CellRightClick"]]}}function h(t,e){if(!t.data||!t.columns)return[];var i=e.name,o=t.currentColumns,s=t[i+"RowHeight"]||40,c=function(t,e){var i=t.map(function(t){return t[e]||[{}]});return a.transpose(i)}(o,i);return c.map(function(e,u){return r.el(".dhx_"+i+"-row",{style:{height:s}},e.map(function(e,h){var f=e.css||"",p=o[h],_="dxi dxi-sort-variant dhx_grid-sort-icon";t.sortBy&&""+p.id===t.sortBy&&!e.content&&(_+=" dhx_grid-sort-icon--"+(t.sortDir||"asc"),f+=" dhx_grid-"+i+"-cell--sorted ");var v=a.isSortable(t,p)&&e.text&&"footer"!==i;v&&(f+=" dhx_grid-header-cell--sortable");var g=0===h?"dhx_first-column-cell":"",m=h===o.length-1?"dhx_last-column-cell":"";e.content||(f+=" dhx_grid-header-cell--"+("number"===p.type?"align_right":"align_left")+" "),f+=g+" "+m;var y=void 0!==p.resizable?p.resizable:t.resizable;return y&&(y=r.el("div",{class:"dhx_resizer_grip_wrap"},[r.el("div",{class:"dhx_resizer_grip",dhx_resized:p.id,style:{height:100*c.length+"%"}},[r.el("div",{class:"dhx_resizer_grip_line"})])]),("footer"===i||u>0)&&(y=null)),e.content?function(t,e,i,o,s){void 0===s&&(s="");var a=i[o+"RowHeight"]-10+1||31,c=e.type?"dhx_"+e.type+"-cell":"dhx_string_cell";return r.el(".dhx_grid-"+o+"-cell.dhx_grid-custom-content-cell."+c,n({class:s,style:{width:e.width,lineHeight:a+"px"}},d(e,o,i)),[l.content[t.content]&&l.content[t.content].toHtml(e,i)])}(e,p,t,i,f):p.hidden?null:r.el(".dhx_grid-"+i+"-cell",n(n({class:f.trim(),dhx_id:p.id,_key:h,style:{width:p.width,lineHeight:s+1+"px"}},d(p,i,t)),{title:a.removeHTMLTags(e.text)}),[r.el("div",{class:"dhx_grid-header-cell-text"},[r.el("div",{".innerHTML":e.text}),y||null]),v&&r.el("div",{class:_})])}))})}function f(t,e){var i=t.columns,n=a.transpose(i.map(function(t){return t[e.name]||[]})),o=t[e.name+"RowHeight"]||40,c=0;return n.map(function(n,l){return c=0,r.el(".dhx_span-row",{style:{top:o*l+"px",height:o}},n.map(function(n,u){var d=i[u];c+=d.hidden?0:d.width;var h=0===u?"dhx_first-column-cell":"",f=u===i.length-1||(n.colspan||0)+(u-1)>=i.length-1?"dhx_last-column-cell":"",p=o;n.rowspan&&(p=p*n.rowspan-1);var _=a.isSortable(t,d)&&n.rowspan&&n.text&&"footer"!==e.name,v="dxi dxi-sort-variant dhx_grid-sort-icon";t.sortBy&&""+d.id===t.sortBy&&!n.content&&(v+=" dhx_grid-sort-icon--"+(t.sortDir||"asc"));var g=h+" "+f+" "+(n.rowspan?"dhx_span-cell__rowspan":"");_&&(g+=" dhx_grid-header-cell  dhx_grid-header-cell--sortable"),n.content||(g+=" dhx_grid-header-cell--"+("number"===d.type?"align_right":"align_left")+" ");var m="";return c-d.width>0&&(m="1px solid #e4e4e4"),!n.colspan&&!n.rowspan||d.hidden?null:r.el(".dhx_span-cell",{style:{width:s.getWidth(t.columns,n.colspan,u),height:p,left:c-d.width,borderLeft:m,top:o*l,lineHeight:p+"px"},class:g.trim(),title:a.removeHTMLTags(n.text),dhx_id:d.id},[r.el("div",{".innerHTML":n.text}),_&&r.el("div",{class:v})])}).filter(function(t){return t}))})}e.getRows=h,e.getSpans=f,e.getFixedRows=function(t,e){var i,s=h(t,e),a=f(t,e),c=null;"footer"!==e.name||e.sticky||(c=t.splitAt>=0&&h(n(n({},t),{currentColumns:t.columns.slice(0,t.splitAt),$positions:n(n({},t.$positions),{xStart:0,xEnd:t.splitAt})}),e));var l,u=((i={position:"sticky"})[e.position]=0,i);return e.sticky||(u.left=-t.scroll.left,l=-t.scroll.left,u.position="relative"),r.el(".dhx_"+e.name+"-wrapper",{class:e.sticky?"":"dhx_compatible-"+e.name,style:n(n({},u),{left:e.sticky?l:0,height:t[e.name+"Height"],width:e.sticky?t.$totalWidth:e.wrapper.width-2})},[r.el(".dhx_grid-"+e.name,{style:{height:t[e.name+"Height"],left:l,paddingLeft:e.shifts.x,width:t.$totalWidth}},[r.el(".dhx_"+e.name+"-rows",o(s)),r.el(".dhx_"+e.name+"-spans",{style:{marginLeft:-e.shifts.x}},a),c&&r.el(".dhx_"+e.name+"-fixed-cols",{style:{position:"absolute",top:0,left:t.scroll.left+"px",height:"100%"}},c)]),r.el("div",{style:{width:t.$totalWidth}})])}},function(t,e,i){"use strict";var n=this&&this.__spreadArrays||function(){for(var t=0,e=0,i=arguments.length;e<i;e++)t+=arguments[e].length;var n=Array(t),o=0;for(e=0;e<i;e++)for(var r=arguments[e],s=0,a=r.length;s<a;s++,o++)n[o]=r[s];return n},o=this;Object.defineProperty(e,"__esModule",{value:!0});var r,s=i(0),a=i(32),c=i(7),l=i(10);function u(t,e,i,n,o){var s=function(){n.value[e]=o.target.value,t.fire(l.GridEvents.filterChange,[o.target.value,e,i]),t.fire(l.GridEvents.headerInput,[o.target.value,e,i])};"selectFilter"!==i?(r&&clearTimeout(r),r=setTimeout(s,250)):s()}function d(t,e,i,n){var o=t.id,r=n?n(o,e.data):e.data.reduce(function(t,e){return void 0===e[o]||""===e[o]||isNaN(e[o])||t.push(parseFloat(e[o])),t},[]),s=r;return"tree"===e.type&&(s=e.data.reduce(function(t,i){if(0===i.$level)if(void 0===i[o]||""===i[o]||isNaN(i[o])){var n=0;e.datacollection.eachChild(i.id,function(t){e.datacollection.haveItems(t.id)||(n+=parseFloat(t[o]))}),t.push(n)}else t.push(parseFloat(i[o])||0);return t},[])),i(r,s)}e.content={inputFilter:{toHtml:function(t,e){return s.el("label.dhx_grid-filter__label.dxi.dxi-magnify",[s.el("input",{type:"text",class:"dhx_input dhx_grid-filter",oninput:[u,e.events,t.id,"inputFilter",this],_key:t.id,value:this.value[t.id]||""})])},match:function(t,e){return new RegExp(""+e,"i").test(t)},value:{}},selectFilter:{toHtml:function(t,e){return s.el("label.dhx_grid-filter__label.dxi.dxi-menu-down",[s.el("select.dxi.dxi-menu-down",{type:"text",class:"dhx_input dhx_grid-filter dhx_grid-filter--select",onchange:[u,e.events,t.id,"selectFilter",this],_key:t.id,value:this.value[t.id]||""},n([s.el("option",{value:""},"")],t.$uniqueData.map(function(t){return t&&s.el("option",{value:t},t)})))])},match:function(t,e){return t===e},value:{}},comboFilter:{toHtml:function(t,e){var i,n=t.id.toString();if(this.combo[n])i=this.combo[t.id];else{var o=t.header.filter(function(t){return void 0!==t.filterConfig})[0];(i=o&&o.filterConfig?new a.Combobox(null,JSON.parse(JSON.stringify(o.filterConfig))):new a.Combobox(null,{})).data.parse(t.$uniqueData.map(function(t){return{value:t}})),e.events.on(c.DataEvents.load,function(){i.data.parse(t.$uniqueData.map(function(t){return{value:t}}))}),this.combo[n]=i,i.events.on("change",function(t){if(t){var o=void 0;i.data.getItem(t)?(o=i.list.selection.getItem().value,e.events.fire(l.GridEvents.filterChange,[o,n,"comboFilter"]),e.events.fire(l.GridEvents.headerInput,[o,n,"comboFilter"])):(e.events.fire(l.GridEvents.filterChange,["",n,"comboFilter"]),e.events.fire(l.GridEvents.headerInput,["",n,"comboFilter"]))}}),i.popup.events.on("afterHide",function(){i.list.selection.getItem()||(i.clear(),e.events.fire(l.GridEvents.filterChange,["",n,"comboFilter"]),e.events.fire(l.GridEvents.headerInput,["",n,"comboFilter"]))})}return s.inject(i.getRootView())},match:function(t,e){return new RegExp(""+e,"i").test(t)&&0===new RegExp(""+e,"i").exec(t).index},destroy:function(){var t=o.content.comboFilter.combo;if(t)for(var e in t)t[e].destructor(),delete t[e]},value:{},combo:{}},sum:{calculate:function(t,e){return e.reduce(function(t,e){return t+(parseFloat(e)||0)},0).toFixed(3)},toHtml:function(t,e){return d(t,e,this.calculate)}},avg:{calculate:function(t,e){return(e.reduce(function(t,e){return t+e},0)/t.length).toFixed(3)},toHtml:function(t,e){return d(t,e,this.calculate)}},min:{calculate:function(t){return Math.min.apply(Math,t).toFixed(3)},toHtml:function(t,e){return d(t,e,this.calculate)}},max:{calculate:function(t){return Math.max.apply(Math,t).toFixed(3)},toHtml:function(t,e){return d(t,e,this.calculate)}},count:{calculate:function(t,e){return e.reduce(function(t,e){return t+e},0)},validate:function(t,e){return e.reduce(function(e,i){return void 0!==i[t]&&""!==i[t]&&(isNaN(i)?e.push(1):e.push(i)),e},[])},toHtml:function(t,e){return d(t,e,this.calculate,this.validate)}}}},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),function(t){t.beforeCollapse="beforeCollapse",t.afterCollapse="afterCollapse",t.beforeExpand="beforeExpand",t.afterExpand="afterExpand",t.toggle="toggle"}(e.SidebarEvents||(e.SidebarEvents={}))},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),function(t){t.top="top",t.bottom="bottom",t.left="left",t.right="right"}(e.RenderMode||(e.RenderMode={})),function(t){t.change="change",t.beforeClose="beforeClose",t.afterClose="afterClose",t.close="close"}(e.TabbarEvents||(e.TabbarEvents={}))},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n,o,r=i(0),s=i(3),a=i(2),c=i(13);!function(t){t.editText="text",t.selectItem="select"}(n=e.EditorMode||(e.EditorMode={})),function(t){t.begin="begin",t.end="end"}(o=e.EditorEvents||(e.EditorEvents={}));var l=function(){function t(){var t=this;this.events=new s.EventSystem,this._documentClick=function(e){a.locate(e,"id")!=="input_"+t._item.id&&(t._removeClickListener(),t._finishEdit())},this._handlers={editText:function(e){t._currentValue=e.target.value},itemSelected:function(e){t._currentValue=e.target.value,t._finishEdit()}}}return t.prototype.edit=function(t,e){return this._active&&this._item!==e.item&&this._finishEdit(),this._active=!0,this.events.fire(o.begin,[t]),this._targetId=t,this.config=e,this._item=e.item,this._currentValue=this._item.value,this._initOuterClick(),this._addHotkeys(),this._draw()},t.prototype._draw=function(){var t=this;if(this.config.mode===n.selectItem){var e=this.config.options;return r.el("select",{id:"input_"+this._item.id,dhx_id:this._item.id,onchange:this._handlers.itemSelected},e.map(function(e){return r.el("option",{class:"editor-select",value:e,selected:t._currentValue===e,style:{border:"1px solid"}},e)}))}return r.el("input",{_hooks:{didInsert:function(t){t.el.focus()}},id:"input_"+this._item.id,class:"dhx_tree-input",oninput:this._handlers.editText,value:this._item.value,autofocus:!0})},t.prototype._addHotkeys=function(){var t=this;c.keyManager.addHotKey("escape",function(){t._finishEdit()},this),c.keyManager.addHotKey("enter",function(){t._finishEdit()},this)},t.prototype._removeHotkeys=function(){c.keyManager.removeHotKey(null,this)},t.prototype._finishEdit=function(){this.events.fire(o.end,[this._targetId,this._item.id,this._currentValue]),this._clear()},t.prototype._clear=function(){this._active=!1,this._removeClickListener(),this._removeHotkeys()},t.prototype._initOuterClick=function(){document.addEventListener("click",this._documentClick)},t.prototype._removeClickListener=function(){document.removeEventListener("click",this._documentClick)},t}();e.default=new l},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),function(t){t[t.unselected=0]="unselected",t[t.selected=1]="selected",t[t.indeterminate=2]="indeterminate"}(e.SelectStatus||(e.SelectStatus={})),function(t){t.file="file",t.folder="folder",t.openFolder="openFolder"}(e.ItemIcon||(e.ItemIcon={})),function(t){t.itemClick="itemclick",t.itemDblClick="itemdblclick",t.itemRightClick="itemrightclick",t.beforeCollapse="beforeCollapse",t.afterCollapse="afterCollapse",t.beforeExpand="beforeExpand",t.afterExpand="afterExpand",t.itemContextMenu="itemcontextmenu"}(e.TreeEvents||(e.TreeEvents={}))},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),i(84);var n=i(85);e.cssManager=n.cssManager;var o=i(3);e.EventSystem=o.EventSystem;var r=i(0);e.awaitRedraw=r.awaitRedraw,e.resizeHandler=r.resizeHandler;var s=i(55);e.Uploader=s.Uploader;var a=i(7);e.DataCollection=a.DataCollection,e.TreeCollection=a.TreeCollection,e.DataProxy=a.DataProxy,e.dataDrivers=a.dataDrivers,e.ajax=a.ajax;var c=i(14);e.Layout=c.Layout;var l=i(38);e.List=l.List;var u=i(25);e.Calendar=u.Calendar;var d=i(31);e.Colorpicker=d.Colorpicker;var h=i(139);e.Chart=h.Chart;var f=i(32);e.Combobox=f.Combobox;var p=i(165);e.DataView=p.DataView;var _=i(169);e.Form=_.Form;var v=i(184);e.Grid=v.Grid;var g=i(19);e.message=g.message,e.alert=g.alert,e.confirm=g.confirm,e.enableTooltip=g.enableTooltip,e.disableTooltip=g.disableTooltip,e.tooltip=g.tooltip;var m=i(198);e.Menu=m.Menu,e.ContextMenu=m.ContextMenu;var y=i(11);e.Popup=y.Popup;var b=i(201);e.Ribbon=b.Ribbon;var x=i(203);e.Sidebar=x.Sidebar;var w=i(40);e.Slider=w.Slider;var k=i(205);e.Tabbar=k.Tabbar;var C=i(30);e.Timepicker=C.Timepicker;var E=i(29);e.Toolbar=E.Toolbar;var S=i(207);e.Tree=S.Tree;var O=i(210);e.Window=O.Window;var M=i(31),T=i(36),I=i(42),D=i(50),P=i(75),V=i(66),L=window;e.i18n=L.dhx&&L.dhx.i18n?L.dhx.i18:{},e.i18n.setLocale=function(t,i){var n=e.i18n[t];for(var o in i)n[o]=i[o]},e.i18n.colorpicker=e.i18n.colorpicker||M.locale,e.i18n.message=e.i18n.message||T.default,e.i18n.calendar=e.i18n.calendar||I.default,e.i18n.combobox=e.i18n.combobox||D.default,e.i18n.form=e.i18n.form||P.default,e.i18n.timepicker=e.i18n.timepicker||V.default},function(t,e,i){},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(1),o=function(){function t(){this._classes={};var t=document.createElement("style");t.id="dhx_generated_styles",this._styleCont=document.head.appendChild(t)}return t.prototype.update=function(){document.head.appendChild(this._styleCont),this._styleCont.innerHTML=this._generateCss()},t.prototype.remove=function(t){delete this._classes[t],this.update()},t.prototype.add=function(t,e,i){void 0===i&&(i=!1);var n=this._toCssString(t),o=this._findSameClassId(n);return o&&e&&e!==o?(this._classes[e]=this._classes[o],e):o||this._addNewClass(n,e,i)},t.prototype.get=function(t){if(this._classes[t]){for(var e={},i=0,n=this._classes[t].split(";");i<n.length;i++){var o=n[i];if(o){var r=o.split(":");e[r[0]]=r[1]}}return e}return null},t.prototype._findSameClassId=function(t){for(var e in this._classes)if(t===this._classes[e])return e;return null},t.prototype._addNewClass=function(t,e,i){var o=e||"dhx_generated_class_"+n.uid();return this._classes[o]=t,i||this.update(),o},t.prototype._toCssString=function(t){var e="";for(var i in t){var n=t[i];e+=i.replace(/[A-Z]{1}/g,function(t){return"-"+t.toLowerCase()})+":"+n+";"}return e},t.prototype._generateCss=function(){var t="";for(var e in this._classes){t+="."+e+"{"+this._classes[e]+"}\n"}return t},t}();e.CssManager=o,e.cssManager=new o},function(t,e){if(Element&&!Element.prototype.matches){var i=Element.prototype;i.matches=i.matchesSelector||i.mozMatchesSelector||i.msMatchesSelector||i.oMatchesSelector||i.webkitMatchesSelector}},function(t,e,i){(function(t){var n=void 0!==t&&t||"undefined"!=typeof self&&self||window,o=Function.prototype.apply;function r(t,e){this._id=t,this._clearFn=e}e.setTimeout=function(){return new r(o.call(setTimeout,n,arguments),clearTimeout)},e.setInterval=function(){return new r(o.call(setInterval,n,arguments),clearInterval)},e.clearTimeout=e.clearInterval=function(t){t&&t.close()},r.prototype.unref=r.prototype.ref=function(){},r.prototype.close=function(){this._clearFn.call(n,this._id)},e.enroll=function(t,e){clearTimeout(t._idleTimeoutId),t._idleTimeout=e},e.unenroll=function(t){clearTimeout(t._idleTimeoutId),t._idleTimeout=-1},e._unrefActive=e.active=function(t){clearTimeout(t._idleTimeoutId);var e=t._idleTimeout;e>=0&&(t._idleTimeoutId=setTimeout(function(){t._onTimeout&&t._onTimeout()},e))},i(88),e.setImmediate="undefined"!=typeof self&&self.setImmediate||void 0!==t&&t.setImmediate||this&&this.setImmediate,e.clearImmediate="undefined"!=typeof self&&self.clearImmediate||void 0!==t&&t.clearImmediate||this&&this.clearImmediate}).call(this,i(33))},function(t,e,i){(function(t,e){!function(t,i){"use strict";if(!t.setImmediate){var n,o=1,r={},s=!1,a=t.document,c=Object.getPrototypeOf&&Object.getPrototypeOf(t);c=c&&c.setTimeout?c:t,"[object process]"==={}.toString.call(t.process)?n=function(t){e.nextTick(function(){u(t)})}:function(){if(t.postMessage&&!t.importScripts){var e=!0,i=t.onmessage;return t.onmessage=function(){e=!1},t.postMessage("","*"),t.onmessage=i,e}}()?function(){var e="setImmediate$"+Math.random()+"$",i=function(i){i.source===t&&"string"==typeof i.data&&0===i.data.indexOf(e)&&u(+i.data.slice(e.length))};t.addEventListener?t.addEventListener("message",i,!1):t.attachEvent("onmessage",i),n=function(i){t.postMessage(e+i,"*")}}():t.MessageChannel?function(){var t=new MessageChannel;t.port1.onmessage=function(t){u(t.data)},n=function(e){t.port2.postMessage(e)}}():a&&"onreadystatechange"in a.createElement("script")?function(){var t=a.documentElement;n=function(e){var i=a.createElement("script");i.onreadystatechange=function(){u(e),i.onreadystatechange=null,t.removeChild(i),i=null},t.appendChild(i)}}():n=function(t){setTimeout(u,0,t)},c.setImmediate=function(t){"function"!=typeof t&&(t=new Function(""+t));for(var e=new Array(arguments.length-1),i=0;i<e.length;i++)e[i]=arguments[i+1];var s={callback:t,args:e};return r[o]=s,n(o),o++},c.clearImmediate=l}function l(t){delete r[t]}function u(t){if(s)setTimeout(u,0,t);else{var e=r[t];if(e){s=!0;try{!function(t){var e=t.callback,n=t.args;switch(n.length){case 0:e();break;case 1:e(n[0]);break;case 2:e(n[0],n[1]);break;case 3:e(n[0],n[1],n[2]);break;default:e.apply(i,n)}}(e)}finally{l(t),s=!1}}}}}("undefined"==typeof self?void 0===t?this:t:self)}).call(this,i(33),i(89))},function(t,e){var i,n,o=t.exports={};function r(){throw new Error("setTimeout has not been defined")}function s(){throw new Error("clearTimeout has not been defined")}function a(t){if(i===setTimeout)return setTimeout(t,0);if((i===r||!i)&&setTimeout)return i=setTimeout,setTimeout(t,0);try{return i(t,0)}catch(e){try{return i.call(null,t,0)}catch(e){return i.call(this,t,0)}}}!function(){try{i="function"==typeof setTimeout?setTimeout:r}catch(t){i=r}try{n="function"==typeof clearTimeout?clearTimeout:s}catch(t){n=s}}();var c,l=[],u=!1,d=-1;function h(){u&&c&&(u=!1,c.length?l=c.concat(l):d=-1,l.length&&f())}function f(){if(!u){var t=a(h);u=!0;for(var e=l.length;e;){for(c=l,l=[];++d<e;)c&&c[d].run();d=-1,e=l.length}c=null,u=!1,function(t){if(n===clearTimeout)return clearTimeout(t);if((n===s||!n)&&clearTimeout)return n=clearTimeout,clearTimeout(t);try{n(t)}catch(e){try{return n.call(null,t)}catch(e){return n.call(this,t)}}}(t)}}function p(t,e){this.fun=t,this.array=e}function _(){}o.nextTick=function(t){var e=new Array(arguments.length-1);if(arguments.length>1)for(var i=1;i<arguments.length;i++)e[i-1]=arguments[i];l.push(new p(t,e)),1!==l.length||u||a(f)},p.prototype.run=function(){this.fun.apply(null,this.array)},o.title="browser",o.browser=!0,o.env={},o.argv=[],o.version="",o.versions={},o.on=_,o.addListener=_,o.once=_,o.off=_,o.removeListener=_,o.removeAllListeners=_,o.emit=_,o.prependListener=_,o.prependOnceListener=_,o.listeners=function(t){return[]},o.binding=function(t){throw new Error("process.binding is not supported")},o.cwd=function(){return"/"},o.chdir=function(t){throw new Error("process.chdir is not supported")},o.umask=function(){return 0}},function(t,e,i){
/**
* Copyright (c) 2017, Leon Sorokin
* All rights reserved. (MIT Licensed)
*
* domvm.js (DOM ViewModel)
* A thin, fast, dependency-free vdom view layer
* @preserve https://github.com/leeoniya/domvm (v3.2.6, micro build)
*/
t.exports=function(){"use strict";var t=1,e=2,i=3,n=4,o=5,r="undefined"!=typeof window,s=(r?window:{}).requestAnimationFrame,a={};function c(){}var l=Array.isArray;function u(t){return null!=t}function d(t){return null!=t&&t.constructor===Object}function h(t,e,i,n){t.splice.apply(t,[i,n].concat(e))}function f(t){var e=typeof t;return"string"===e||"number"===e}function p(t){return"function"==typeof t}function _(t){for(var e=arguments,i=1;i<e.length;i++)for(var n in e[i])t[n]=e[i][n];return t}function v(t,e){for(var i=[],n=e;n<t.length;n++)i.push(t[n]);return i}function g(t,e){for(var i in t)if(t[i]!==e[i])return!1;return!0}function m(t,e){var i=t.length;if(e.length!==i)return!1;for(var n=0;n<i;n++)if(t[n]!==e[n])return!1;return!0}function y(t){if(!s)return t;var e,i,n;function o(){e=0,t.apply(i,n)}return function(){i=this,n=arguments,e||(e=s(o))}}function b(t){return"o"===t[0]&&"n"===t[1]}function x(t){return"_"===t[0]}function w(t){return"style"===t}function k(t){t&&t.el&&t.el.offsetHeight}function C(t){return null!=t.node&&null!=t.node.el}function E(t,e){switch(e){case"value":case"checked":case"selected":return!0}return!1}function S(t){for(t=t||a;null==t.vm&&t.parent;)t=t.parent;return t.vm}function O(){}var M=O.prototype={constructor:O,type:null,vm:null,key:null,ref:null,data:null,hooks:null,ns:null,el:null,tag:null,attrs:null,body:null,flags:0,_class:null,_diff:null,_dead:!1,_lis:!1,idx:null,parent:null};function T(t){var i=new O;return i.type=e,i.body=t,i}var I={},D=/\[(\w+)(?:=(\w+))?\]/g,P=1,V=2,L=4,j=8;function H(e,i,n,o){var r=new O;r.type=t,u(o)&&(r.flags=o),r.attrs=i;var s=function(t){var e,i,n,o,r=I[t];if(null==r)for(I[t]=r={tag:(e=t.match(/^[-\w]+/))?e[0]:"div",id:(i=t.match(/#([-\w]+)/))?i[1]:null,class:(n=t.match(/\.([-\w.]+)/))?n[1].replace(/\./g," "):null,attrs:null};o=D.exec(t);)null==r.attrs&&(r.attrs={}),r.attrs[o[1]]=o[2]||"";return r}(e);if(r.tag=s.tag,s.id||s.class||s.attrs){var a=r.attrs||{};if(s.id&&!u(a.id)&&(a.id=s.id),s.class&&(r._class=s.class,a.class=s.class+(u(a.class)?" "+a.class:"")),s.attrs)for(var c in s.attrs)u(a[c])||(a[c]=s.attrs[c]);r.attrs=a}var l=r.attrs;return u(l)&&(u(l._key)&&(r.key=l._key),u(l._ref)&&(r.ref=l._ref),u(l._hooks)&&(r.hooks=l._hooks),u(l._data)&&(r.data=l._data),u(l._flags)&&(r.flags=l._flags),u(r.key)||(u(r.ref)?r.key=r.ref:u(l.id)?r.key=l.id:u(l.name)&&(r.key=l.name+("radio"===l.type||"checkbox"===l.type?l.value:"")))),null!=n&&(r.body=n),r}function A(t,i,r,s){if(t.type!==o&&t.type!==n){t.parent=i,t.idx=r,t.vm=s,null!=t.ref&&function(t,e,i){var n=["refs"].concat(e.split("."));!function(t,e,i){for(var n;n=e.shift();)0===e.length?t[n]=i:t[n]=t=t[n]||{}}(t,n,i)}(S(t),t.ref,t);var a=t.hooks,c=s&&s.hooks;(a&&(a.willRemove||a.didRemove)||c&&(c.willUnmount||c.didUnmount))&&function(t){for(;t=t.parent;)t.flags|=P}(t),l(t.body)&&function(t){for(var i=t.body,n=0;n<i.length;n++){var o=i[n];!1===o||null==o?i.splice(n--,1):l(o)?h(i,o,n--,1):(null==o.type&&(i[n]=o=T(""+o)),o.type===e?null==o.body||""===o.body?i.splice(n--,1):n>0&&i[n-1].type===e?(i[n-1].body+=o.body,i.splice(n--,1)):A(o,t,n,null):A(o,t,n,null))}}(t)}}var R={animationIterationCount:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridColumn:!0,order:!0,lineClamp:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,fontWeight:!0,lineHeight:!0,opacity:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0};function F(t,e){return isNaN(e)||R[t]?e:e+"px"}function B(t,e){var i=(t.attrs||a).style,n=e?(e.attrs||a).style:null;if(null==i||f(i))t.el.style.cssText=i;else{for(var o in i){var r=i[o];(null==n||null!=r&&r!==n[o])&&(t.el.style[o]=F(o,r))}if(n)for(var s in n)null==i[s]&&(t.el.style[s]="")}}var z=[];function N(t,e,i,n,o){if(null!=t){var r=i.hooks[e];if(r){if("d"!==e[0]||"i"!==e[1]||"d"!==e[2])return r(i,n);o?k(i.parent)&&r(i,n):z.push([r,i,n])}}}function $(t){var e;if(z.length)for(k(t.node);e=z.shift();)e[0](e[1],e[2])}var W=r?document:null;function U(t){return t.nextSibling}function G(t,e,i){var n=e._node,o=n.vm;if(l(n.body))if((n.flags&P)===P)for(var r=0;r<n.body.length;r++)G(e,n.body[r].el);else q(n);delete e._node,t.removeChild(e),N(n.hooks,"didRemove",n,null,i),null!=o&&(N(o.hooks,"didUnmount",o,o.data,i),o.node=null)}function Y(t,e){var i=e._node;if(!i._dead){var n=function t(e){var i=e.vm,n=null!=i&&N(i.hooks,"willUnmount",i,i.data),o=N(e.hooks,"willRemove",e);if((e.flags&P)===P&&l(e.body))for(var r=0;r<e.body.length;r++)t(e.body[r]);return n||o}(i);null!=n&&function(t){return"object"==typeof t&&p(t.then)}(n)?(i._dead=!0,n.then(function(t,e,i){return function(){return t.apply(i,e)}}(G,[t,e,!0]))):G(t,e)}}function q(t){for(var e=t.body,i=0;i<e.length;i++){var n=e[i];delete n.el._node,null!=n.vm&&(n.vm.node=null),l(n.body)&&q(n)}}function X(t){var e=t.el;if(0==(t.flags&P))l(t.body)&&q(t),e.textContent=null;else{var i=e.firstChild;do{var n=U(i);Y(e,i)}while(i=n)}}function K(t,e,i){var n=e._node,o=null!=e.parentNode,r=e!==i&&o?null:n.vm;null!=r&&N(r.hooks,"willMount",r,r.data),N(n.hooks,o?"willReinsert":"willInsert",n),t.insertBefore(e,i),N(n.hooks,o?"didReinsert":"didInsert",n),null!=r&&N(r.hooks,"didMount",r,r.data)}function J(t,e,i){K(t,e,i?U(i):null)}var Z={},Q=c;function tt(t,e,i){t[e]=i}function et(t,e,i,n,o){var r=t.apply(o,e.concat([i,n,o,o.data]));o.onevent(i,n,o,o.data,e),Q.call(null,i,n,o,o.data,e),!1===r&&(i.preventDefault(),i.stopPropagation())}function it(t){var e,i,n=function(t){for(;null==t._node;)t=t.parentNode;return t._node}(t.target),o=S(n),r=t.currentTarget._node.attrs["on"+t.type];if(l(r))e=r[0],i=r.slice(1),et(e,i,t,n,o);else for(var s in r)if(t.target.matches(s)){var a=r[s];l(a)?(e=a[0],i=a.slice(1)):(e=a,i=[]),et(e,i,t,n,o)}}function nt(t,e,i,n){if(i!==n){var o=t.el;null==i||p(i)?tt(o,e,i):null==n&&tt(o,e,it)}}function ot(t,e,i){"."===e[0]&&(e=e.substr(1),i=!0),i?t.el[e]="":t.el.removeAttribute(e)}function rt(t,e,i,n,o){var r=t.el;null==i?!o&&ot(t,e,!1):null!=t.ns?r.setAttribute(e,i):"class"===e?r.className=i:"id"===e||"boolean"==typeof i||n?r[e]=i:"."===e[0]?r[e.substr(1)]=i:r.setAttribute(e,i)}function st(t,e,i){var n=t.attrs||a,o=e.attrs||a;if(n===o);else{for(var r in n){var s=n[r],c=E(t.tag,r),l=c?t.el[r]:o[r];s===l||(w(r)?B(t,e):x(r)||(b(r)?nt(t,r,s,l):rt(t,r,s,c,i)))}for(var r in o)!(r in n)&&!x(r)&&ot(t,r,E(t.tag,r)||b(r))}}function at(t,e,i,o){return t.type===n&&(e=t.data,i=t.key,o=t.opts,t=t.view),new wt(t,e,i,o)}function ct(t){for(var e=0;e<t.body.length;e++){var r=t.body[e],s=r.type;if(s<=i)K(t.el,lt(r));else if(s===n){var a=at(r.view,r.data,r.key,r.opts)._redraw(t,e,!1);s=a.node.type,K(t.el,lt(a.node))}else if(s===o){var a=r.vm;a._redraw(t,e),s=a.node.type,K(t.el,a.node.el)}}}function lt(n,o){return null==n.el&&(n.type===t?(n.el=o||function(t,e){return null!=e?W.createElementNS(e,t):W.createElement(t)}(n.tag,n.ns),null!=n.attrs&&st(n,a,!0),(n.flags&j)===j&&n.body.body(n),l(n.body)?ct(n):null!=n.body&&""!==n.body&&(n.el.textContent=n.body)):n.type===e?n.el=o||function(t){return W.createTextNode(t)}(n.body):n.type===i&&(n.el=o||function(t){return W.createComment(t)}(n.body))),n.el._node=n,n.el}window.lisMove=ft;var ut=1,dt=2;function ht(t,e,i,n,o,r,s,a){return function(c,l,u,d,h,f){var p,_;if(null!=d[n]){if(null==(p=d[n]._node))return void(d[n]=t(d[n]));if(function(t){return t.parent}(p)!==c)return _=t(d[n]),null!=p.vm?p.vm.unmount(!0):Y(l,d[n]),void(d[n]=_)}if(d[o]==h)return dt;if(null==d[o].el)i(l,lt(d[o]),d[n]),d[o]=e(d[o],u);else if(d[o].el===d[n])d[o]=e(d[o],u),d[n]=t(d[n]);else{if(f||p!==d[s])return f&&null!=d[n]?ft(t,e,i,n,o,l,u,p,d):ut;_=d[n],d[n]=t(_),a(l,_,d[r]),d[r]=_}}}function ft(t,e,i,n,o,r,s,a,c){if(a._lis)i(r,c[o].el,c[n]),c[o]=e(c[o],s);else{var l=function(t,e){var i,n=0,o=e.length-1;if(o<=2147483647)for(;n<=o;){if(e[i=n+o>>1]===t)return i;e[i]<t?n=i+1:o=i-1}else for(;n<=o;){if(i=Math.floor((n+o)/2),e[i]===t)return i;e[i]<t?n=i+1:o=i-1}return n==e.length?null:n}(a.idx,c.tombs);a._lis=!0;var u=t(c[n]);i(r,c[n],null!=l?s[c.tombs[l]].el:l),null==l?c.tombs.push(a.idx):c.tombs.splice(l,0,a.idx),c[n]=u}}var pt=ht(U,function(t,e){return e[t.idx+1]},K,"lftSib","lftNode","rgtSib","rgtNode",J),_t=ht(function(t){return t.previousSibling},function(t,e){return e[t.idx-1]},J,"rgtSib","rgtNode","lftSib","lftNode",K);function vt(t,e,i,n){for(var o=Array.prototype.slice.call(e.childNodes),r=[],s=0;s<o.length;s++){var a=o[s]._node;a.parent===t&&r.push(a.idx)}for(var c=function(t){var e,i,n=t.slice(),o=[];o.push(0);for(var r=0,s=t.length;r<s;++r){var a=o[o.length-1];if(t[a]<t[r])n[r]=a,o.push(r);else{for(e=0,i=o.length-1;e<i;){var c=(e+i)/2|0;t[o[c]]<t[r]?e=c+1:i=c}t[r]<t[o[e]]&&(e>0&&(n[r]=o[e-1]),o[e]=r)}}for(e=o.length,i=o[e-1];e-- >0;)o[e]=i,i=n[i];return o}(r).map(function(t){return r[t]}),l=0;l<c.length;l++)i[c[l]]._lis=!0;for(n.tombs=c;;){var u=pt(t,e,i,n,null,!0);if(u===dt)break}}function gt(t){return t.el._node.parent!==t.parent}function mt(t,e,i){return e[i]}function yt(t,e,i){for(;i<e.length;i++){var r=e[i];if(null!=r.vm){if(t.type===n&&r.vm.view===t.view&&r.vm.key===t.key||t.type===o&&r.vm===t.vm)return r}else if(!gt(r)&&t.tag===r.tag&&t.type===r.type&&t.key===r.key&&(t.flags&~P)==(r.flags&~P))return r}return null}function bt(t,e,i){return e[e._keys[t.key]]}function xt(r,s){N(s.hooks,"willRecycle",s,r);var c=r.el=s.el,u=s.body,d=r.body;if(c._node=r,r.type!==e||d===u){null==r.attrs&&null==s.attrs||st(r,s,!1);var h=l(u),f=l(d),p=(r.flags&j)===j;h?f||p?function(e,r){var s=e.body,c=s.length,l=r.body,u=l.length,d=(e.flags&j)===j,h=(e.flags&V)===V,f=(e.flags&L)===L,p=!h&&e.type===t,_=!0,v=f?bt:h||d?mt:yt;if(f){for(var g={},m=0;m<l.length;m++)g[l[m].key]=m;l._keys=g}if(p&&0===c)return X(r),void(d&&(e.body=[]));var y,b,x=0,w=!1,k=0;if(d)var E={key:null},S=Array(c);for(var m=0;m<c;m++){if(d){var O=!1,M=null;_&&(f&&(E.key=s.key(m)),y=v(E,l,k)),null!=y?(b=y.idx,!0===(M=s.diff(m,y))?((T=y).parent=e,T.idx=m,T._lis=!1):O=!0):O=!0,O&&(A(T=s.tpl(m),e,m),T._diff=null!=M?M:s.diff(m),null!=y&&xt(T,y)),S[m]=T}else{var T=s[m],I=T.type;if(I<=i)(y=_&&v(T,l,k))&&(xt(T,y),b=y.idx);else if(I===n){if(y=_&&v(T,l,k)){b=y.idx;var D=y.vm._update(T.data,e,m)}else var D=at(T.view,T.data,T.key,T.opts)._redraw(e,m,!1);I=D.node.type}else if(I===o){var P=C(T.vm),D=T.vm._update(T.data,e,m,P);I=D.node.type}}if(!f&&null!=y&&(b===k?++k===u&&c>u&&(y=null,_=!1):w=!0,u>100&&w&&++x%10==0))for(;k<u&&gt(l[k]);)k++}d&&(e.body=S),p&&function(t,e){var i=e.body,n=t.el,o=t.body,r={lftNode:o[0],rgtNode:o[o.length-1],lftSib:(i[0]||a).el,rgtSib:(i[i.length-1]||a).el};t:for(;;){for(;;){var s=pt(t,n,o,r,null,!1);if(s===ut)break;if(s===dt)break t}for(;;){var c=_t(t,n,o,r,r.lftNode,!1);if(c===ut)break;if(c===dt)break t}vt(t,n,o,r);break}}(e,r)}(r,s):d!==u&&(null!=d?c.textContent=d:X(s)):f?(X(s),ct(r)):d!==u&&(c.firstChild?c.firstChild.nodeValue=d:c.textContent=d),N(s.hooks,"didRecycle",s,r)}else c.nodeValue=d}function wt(t,e,i,n){var o=this;o.view=t,o.data=e,o.key=i,n&&(o.opts=n,o.config(n));var r=d(t)?t:t.call(o,o,e,i,n);p(r)?o.render=r:(o.render=r.render,o.config(r)),o._redrawAsync=y(function(t){return o.redraw(!0)}),o._updateAsync=y(function(t){return o.update(t,!0)}),o.init&&o.init.call(o,o,o.data,o.key,n)}var kt=wt.prototype={constructor:wt,_diff:null,init:null,view:null,key:null,data:null,state:null,api:null,opts:null,node:null,hooks:null,onevent:c,refs:null,render:null,mount:function(t,e){var i=this;return e?(X({el:t,flags:0}),i._redraw(null,null,!1),t.nodeName.toLowerCase()!==i.node.tag?(lt(i.node),K(t.parentNode,i.node.el,t),t.parentNode.removeChild(t)):K(t.parentNode,lt(i.node,t),t)):(i._redraw(null,null),t&&K(t,i.node.el)),t&&$(i),i},unmount:function(t){var e=this.node;Y(e.el.parentNode,e.el),t||$(this)},config:function(t){var e=this;t.init&&(e.init=t.init),t.diff&&(e.diff=t.diff),t.onevent&&(e.onevent=t.onevent),t.hooks&&(e.hooks=_(e.hooks||{},t.hooks)),t.onemit&&(e.onemit=_(e.onemit||{},t.onemit))},parent:function(){return S(this.node.parent)},root:function(){for(var t=this.node;t.parent;)t=t.parent;return t.vm},redraw:function(t){return t?this._redraw(null,null,C(this)):this._redrawAsync(),this},update:function(t,e){return e?this._update(t,null,null,C(this)):this._updateAsync(t),this},_update:function(t,e,i,n){var o=this;return null!=t&&o.data!==t&&(N(o.hooks,"willUpdate",o,t),o.data=t),o._redraw(e,i,n)},_redraw:function(t,e,i){var n,o,r=null==t,s=this,a=s.node&&s.node.el&&s.node.el.parentNode,c=s.node;if(null!=s.diff&&(n=s._diff,s._diff=o=s.diff(s,s.data),null!=c)){var u=l(n)?m:g,d=n===o||u(n,o);if(d)return Ct(s,c,t,e)}a&&N(s.hooks,"willRedraw",s,s.data);var h=s.render.call(s,s,s.data,n,o);if(h===c)return Ct(s,c,t,e);if(s.refs=null,null!=s.key&&h.key!==s.key&&(h.key=s.key),s.node=h,t?(A(h,t,e,s),t.body[e]=h):c&&c.parent?(A(h,c.parent,c.idx,s),c.parent.body[c.idx]=h):A(h,null,null,s),!1!==i)if(c)if(c.tag!==h.tag||c.key!==h.key){c.vm=h.vm=null;var f=c.el.parentNode,p=U(c.el);Y(f,c.el),K(f,lt(h),p),c.el=h.el,h.vm=s}else xt(h,c);else lt(h);return a&&N(s.hooks,"didRedraw",s,s.data),r&&a&&$(s),s},_redrawAsync:null,_updateAsync:null};function Ct(t,e,i,n){return null!=i&&(i.body[n]=e,e.idx=n,e.parent=i,e._lis=!1),t}function Et(t,e,i,n){var o,r;return null==i?d(e)?o=e:r=e:(o=e,r=i),H(t,o,r,n)}var St="http://www.w3.org/2000/svg";function Ot(t,e,i,n){this.view=t,this.data=e,this.key=i,this.opts=n}function Mt(t){this.vm=t}Ot.prototype={constructor:Ot,type:n,view:null,data:null,key:null,opts:null},Mt.prototype={constructor:Mt,type:o,vm:null};var Tt={config:function(t){Q=t.onevent||Q,t.onemit&&function(t){_(Z,t)}(t.onemit)},ViewModel:wt,VNode:O,createView:at,defineElement:Et,defineSvgElement:function(t,e,i,n){var o=Et(t,e,i,n);return o.ns=St,o},defineText:T,defineComment:function(t){var e=new O;return e.type=i,e.body=t,e},defineView:function(t,e,i,n){return new Ot(t,e,i,n)},injectView:function(t){return new Mt(t)},injectElement:function(e){var i=new O;return i.type=t,i.el=i.key=e,i},lazyList:function(t,e){var i=t.length,n={items:t,length:i,key:function(i){return e.key(t[i],i)},diff:function(i,n){var o=e.diff(t[i],i);if(null==n)return o;var r=n._diff,s=o===r||l(r)?m(o,r):g(o,r);return s||o},tpl:function(i){return e.tpl(t[i],i)},map:function(t){return e.tpl=t,n},body:function(t){for(var e=Array(i),o=0;o<i;o++){var r=n.tpl(o);r._diff=n.diff(o),e[o]=r,A(r,t,o)}t.body=e}};return n},FIXED_BODY:V,DEEP_REMOVE:P,KEYED_LIST:L,LAZY_LIST:j};function It(t){var e,i,n=arguments,o=n.length;if(o>1){var r=1;d(n[1])&&(i=n[1],r=2),e=o===r+1&&(f(n[r])||l(n[r])||i&&(i._flags&j)===j)?n[r]:v(n,r)}return H(t,i,e)}return M.patch=function(t,e){!function(t,e,i){if(null!=e.type){if(null!=t.vm)return;A(e,t.parent,t.idx,null),t.parent.body[t.idx]=e,xt(e,t),i&&k(e),$(S(e))}else{var n=Object.create(t);n.attrs=_({},t.attrs);var o=_(t.attrs,e);if(null!=t._class){var r=o.class;o.class=null!=r&&""!==r?t._class+" "+r:t._class}st(t,n),i&&k(t)}}(this,t,e)},kt.emit=function(t){var e=this,i=e,n=v(arguments,1).concat(i,i.data);do{var o=e.onemit,r=o?o[t]:null;if(r){r.apply(e,n);break}}while(e=e.parent());Z[t]&&Z[t].apply(e,n)},kt.onemit=null,kt.body=function(){return function t(e,i){var n=e.body;if(l(n))for(var o=0;o<n.length;o++){var r=n[o];null!=r.vm?i.push(r.vm):t(r,i)}return i}(this.node,[])},Tt.defineElementSpread=It,Tt.defineSvgElementSpread=function(){var t=It.apply(null,arguments);return t.ns=St,t},Tt}()},function(t,e,i){"use strict";(function(t){var n=this&&this.__assign||function(){return(n=Object.assign||function(t){for(var e,i=1,n=arguments.length;i<n;i++)for(var o in e=arguments[i])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)};Object.defineProperty(e,"__esModule",{value:!0});var o=i(16),r=i(15),s=function(){function e(t,e){this._parent=t,this._changes=e}return e.prototype.load=function(t,e){var i=this;if(!t.config||this._parent.events.fire(r.DataEvents.beforeLazyLoad,[]))return this._parent.loadData=t.load().then(function(t){return t?i.parse(t,e):[]}).catch(function(t){i._parent.events.fire(r.DataEvents.loadError,[t])})},e.prototype.parse=function(t,e){var i=this;if(void 0===e&&(e="json"),"json"!==e||o.hasJsonOrArrayStructure(t)||this._parent.events.fire(r.DataEvents.loadError,["Uncaught SyntaxError: Unexpected end of input"]),!((t=(e=o.toDataDriver(e)).toJsonArray(t))instanceof Array)){var s=t.total_count-1,a=t.from;if(t=t.data,0!==this._parent.getLength())return t.forEach(function(t,e){var r=a+e,s=i._parent.getId(r);if(s){var c=i._parent.getItem(s);c&&c.$empty&&(i._parent.changeId(s,t.id,!0),i._parent.update(t.id,n(n({},t),{$empty:void 0}),!0))}else o.dhxWarning("item not found")}),this._parent.events.fire(r.DataEvents.afterLazyLoad,[a,t.length]),this._parent.events.fire(r.DataEvents.change),t;for(var c=[],l=0,u=0;l<=s;l++)l>=a&&l<=a+t.length-1?(c.push(t[u]),u++):c.push({$empty:!0});t=c}return this._parent.getInitialData()&&this._parent.removeAll(),this._parent.$parse(t),t},e.prototype.save=function(e){for(var i=this,n=function(n){if(n.saving||n.pending)o.dhxWarning("item is saving");else{var s=r._findPrevState(n.id);if(s&&s.saving){var a=new t(function(t,r){s.promise.then(function(){n.pending=!1,t(i._setPromise(n,e))}).catch(function(t){i._removeFromOrder(s),i._setPromise(n,e),o.dhxWarning(t),r(t)})});r._addToChain(a),n.pending=!0}else r._setPromise(n,e)}},r=this,s=0,a=this._changes.order;s<a.length;s++){n(a[s])}this._parent.saveData.then(function(){i._saving=!1})},e.prototype._setPromise=function(t,e){var i=this;return t.promise=e.save(t.obj,t.status),t.promise.then(function(){i._removeFromOrder(t)}).catch(function(e){t.saving=!1,t.error=!0,o.dhxError(e)}),t.saving=!0,this._saving=!0,this._addToChain(t.promise),t.promise},e.prototype._addToChain=function(t){this._parent.saveData&&this._saving?this._parent.saveData=this._parent.saveData.then(function(){return t}):this._parent.saveData=t},e.prototype._findPrevState=function(t){for(var e=0,i=this._changes.order;e<i.length;e++){var n=i[e];if(n.id===t)return n}return null},e.prototype._removeFromOrder=function(t){this._changes.order=this._changes.order.filter(function(e){return!o.isEqualObj(e,t)})},e}();e.Loader=s}).call(this,i(12))},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(93);var o=function(){function t(){}return t.prototype.toJsonArray=function(t){return this.getRows(t)},t.prototype.toJsonObject=function(t){var e;return"string"==typeof t&&(e=this._fromString(t)),function t(e,i){i=i||{};var n=e.attributes;if(n&&n.length)for(var o=0;o<n.length;o++)i[n[o].name]=n[o].value;var r=e.childNodes;for(o=0;o<r.length;o++)if(1===r[o].nodeType){var s=r[o].tagName;i[s]?("function"!=typeof i[s].push&&(i[s]=[i[s]]),i[s].push(t(r[o],{}))):i[s]=t(r[o],{})}return i}(e)},t.prototype.serialize=function(t){return n.jsonToXML(t)},t.prototype.getFields=function(t){return t},t.prototype.getRows=function(t){if("string"==typeof t&&(t=this._fromString(t)),t){var e=t.childNodes&&t.childNodes[0]&&t.childNodes[0].childNodes;return e&&e.length?this._getRows(e):null}return[]},t.prototype._getRows=function(t){for(var e=[],i=0;i<t.length;i++)"item"===t[i].tagName&&e.push(this._nodeToJS(t[i]));return e},t.prototype._fromString=function(t){try{return(new DOMParser).parseFromString(t,"text/xml")}catch(t){return null}},t.prototype._nodeToJS=function(t){var e={};if(this._haveAttrs(t))for(var i=t.attributes,n=0;n<i.length;n++){var o=i[n],r=o.name,s=o.value;e[r]=this._toType(s)}if(3===t.nodeType)return e.value=e.value||this._toType(t.textContent),e;var a=t.childNodes;if(a)for(n=0;n<a.length;n++){var c=a[n],l=c.tagName;l&&("items"===l&&c.childNodes?e[l]=this._getRows(c.childNodes):this._haveAttrs(c)?e[l]=this._nodeToJS(c):e[l]=this._toType(c.textContent))}return e},t.prototype._toType=function(t){return"false"===t||"true"===t?"true"===t:isNaN(t)?t:Number(t)},t.prototype._haveAttrs=function(t){return t.attributes&&t.attributes.length},t}();e.XMLDriver=o},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=4;function o(t){return" ".repeat(t)}function r(t,e){void 0===e&&(e=n);var i=o(e)+"<item>\n";for(var s in t)Array.isArray(t[s])?(i+=o(e+n)+"<"+s+">\n",i+=t[s].map(function(t){return r(t,e+2*n)}).join("\n")+"\n",i+=o(e+n)+"</"+s+">\n"):i+=o(e+n)+"<"+s+">"+t[s]+"</"+s+">\n";return i+=o(e)+"</item>"}e.jsonToXML=function(t,e){void 0===e&&(e="root");for(var i='<?xml version="1.0" encoding="iso-8859-1"?>\n<'+e+">",n=0;n<t.length;n++)i+="\n"+r(t[n]);return i+"\n</"+e+">"}},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(16),o=function(){function t(){}return t.prototype.sort=function(t,e){var i=this;e.rule&&"function"==typeof e.rule?this._sort(t,e):e.by&&(e.rule=function(t,o){var r=i._checkVal(e.as,t[e.by]),s=i._checkVal(e.as,o[e.by]);return n.naturalCompare(r.toString(),s.toString())},this._sort(t,e))},t.prototype._checkVal=function(t,e){return t?t.call(this,e):e},t.prototype._sort=function(t,e){var i=this,n={asc:1,desc:-1};return t.sort(function(t,o){return e.rule.call(i,t,o)*(n[e.dir]||n.asc)})},t}();e.Sort=o},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),o=this&&this.__spreadArrays||function(){for(var t=0,e=0,i=arguments.length;e<i;e++)t+=arguments[e].length;var n=Array(t),o=0;for(e=0;e<i;e++)for(var r=arguments[e],s=0,a=r.length;s<a;s++,o++)n[o]=r[s];return n};Object.defineProperty(e,"__esModule",{value:!0});var r=i(1),s=i(57),a=i(21),c=i(16),l=i(15);function u(t,e,i,n){void 0!==n&&-1!==n&&t[i]&&t[i][n]?t[i].splice(n,0,e):(t[i]||(t[i]=[]),t[i].push(e))}var d=function(t){function e(e,i){var n,o=t.call(this,e,i)||this,s=o._root="_ROOT_"+r.uid();return o._childs=((n={})[s]=[],n),o._initChilds=null,o}return n(e,t),e.prototype.add=function(t,e,i){var n=this;return void 0===e&&(e=-1),void 0===i&&(i=this._root),"object"!=typeof t&&(t={value:t}),Array.isArray(t)?t.map(function(t,o){return n._add(t,e,i,o)}):this._add(t,e,i)},e.prototype.getRoot=function(){return this._root},e.prototype.getParent=function(t,e){if(void 0===e&&(e=!1),!this._pull[t])return null;var i=this._pull[t].parent;return e?this._pull[i]:i},e.prototype.getItems=function(t){return this._childs&&this._childs[t]?this._childs[t]:[]},e.prototype.getLength=function(t){return void 0===t&&(t=this._root),this._childs[t]?this._childs[t].length:null},e.prototype.removeAll=function(e){var i;if(e)for(var n=0,r=o(this._childs[e]);n<r.length;n++){var s=r[n];this.remove(s.id)}else{t.prototype.removeAll.call(this);var a=this._root;this._initChilds=null,this._childs=((i={})[a]=[],i)}},e.prototype.getIndex=function(t){var e=this.getParent(t);return e&&this._childs[e]?r.findIndex(this._childs[e],function(e){return e.id===t}):-1},e.prototype.sort=function(t){var e=this;if(t){for(var i in this._childs)this._sort.sort(this._childs[i],t);if(this._initChilds&&Object.keys(this._initChilds).length)for(var i in this._initChilds)this._sort.sort(this._initChilds[i],t)}else if(this._childs={},this._parse_data(Object.keys(this._pull).map(function(t){return e._pull[t]})),this._filters)for(var i in this._filters){var n=this._filters[i];this.filter(n.rule,n.config)}this.events.fire(l.DataEvents.change)},e.prototype.filter=function(t,e){var i=this;if(void 0===e&&(e={}),t){this._initChilds||(this._initChilds=this._childs),e.type=e.type||l.TreeFilterType.all,this._filters={},this._filters._={rule:t,config:e};var n={};this._recursiveFilter(t,e,this._root,0,n),Object.keys(n).forEach(function(t){for(var e=i.getParent(t),o=i.getItem(t);e;)n[e]||(n[e]=[]),o&&!n[e].find(function(t){return t.id===o.id})&&n[e].push(o),o=i.getItem(e),e=i.getParent(e)}),this._childs=n,this.events.fire(l.DataEvents.change)}else this.restoreOrder()},e.prototype.restoreOrder=function(){this._initChilds&&(this._childs=this._initChilds,this._initChilds=null),this.events.fire(l.DataEvents.change)},e.prototype.copy=function(t,e,i,n){var o=this;return void 0===i&&(i=this),void 0===n&&(n=this._root),t instanceof Array?t.map(function(t,r){return o._copy(t,e,i,n,r)}):this._copy(t,e,i,n)},e.prototype.move=function(t,e,i,n){var o=this;return void 0===i&&(i=this),void 0===n&&(n=this._root),t instanceof Array?t.map(function(t,r){return o._move(t,e,i,n,r)}):this._move(t,e,i,n)},e.prototype.forEach=function(t,e,i){if(void 0===e&&(e=this._root),void 0===i&&(i=1/0),this.haveItems(e)&&!(i<1))for(var n=this._childs[e],o=0;o<n.length;o++)t.call(this,n[o],o,n),this.haveItems(n[o].id)&&this.forEach(t,n[o].id,--i)},e.prototype.eachChild=function(t,e,i,n){if(void 0===i&&(i=!0),void 0===n&&(n=function(){return!0}),this.haveItems(t))for(var o=0;o<this._childs[t].length;o++)e.call(this,this._childs[t][o],o),i&&n(this._childs[t][o])&&this.eachChild(this._childs[t][o].id,e,i,n)},e.prototype.getNearId=function(t){return t},e.prototype.loadItems=function(t,e){var i=this;void 0===e&&(e="json");var n=this.config.autoload+"?id="+t;new a.DataProxy(n).load().then(function(n){n=(e=c.toDataDriver(e)).toJsonArray(n),i._parse_data(n,t),i.events.fire(l.DataEvents.change)})},e.prototype.refreshItems=function(t,e){void 0===e&&(e="json"),this.removeAll(t),this.loadItems(t,e)},e.prototype.eachParent=function(t,e,i){void 0===i&&(i=!1);var n=this.getItem(t);if(n&&(i&&e.call(this,n),n.parent!==this._root)){var o=this.getItem(n.parent);e.call(this,o),this.eachParent(n.parent,e)}},e.prototype.haveItems=function(t){return t in this._childs},e.prototype.canCopy=function(t,e){if(t===e)return!1;var i=!0;return this.eachParent(e,function(e){return e.id===t?i=!1:null}),i},e.prototype.serialize=function(t,e){void 0===t&&(t=l.DataDriver.json);var i=this._serialize(this._root,e),n=c.toDataDriver(t);if(n)return n.serialize(i)},e.prototype.getId=function(t,e){if(void 0===e&&(e=this._root),this._childs[e]&&this._childs[e][t])return this._childs[e][t].id},e.prototype.map=function(t,e,i){void 0===e&&(e=this._root),void 0===i&&(i=!0);var n=[];if(!this.haveItems(e))return n;for(var o=0;o<this._childs[e].length;o++)if(n.push(t.call(this,this._childs[e][o],o,this._childs)),i){var r=this.map(t,this._childs[e][o].id,i);n=n.concat(r)}return n},e.prototype._add=function(e,i,n,o){void 0===i&&(i=-1),void 0===n&&(n=this._root),e.parent=e.parent?e.parent.toString():n,o>0&&-1!==i&&(i+=1);var r=t.prototype._add.call(this,e,i);if(Array.isArray(e.items))for(var s=0,a=e.items;s<a.length;s++){var c=a[s];this.add(c,-1,e.id)}return r},e.prototype._copy=function(t,e,i,n,o){if(void 0===i&&(i=this),void 0===n&&(n=this._root),!this.exists(t))return null;var s=this._childs[t];if(o&&(e=-1===e?-1:e+o),i===this&&!this.canCopy(t,n))return null;var a=c.copyWithoutInner(this.getItem(t),{items:!0});if(i.exists(t)&&(a.id=r.uid()),c.isTreeCollection(i)){if(this.exists(t)&&(a.parent=n,i!==this&&n===this._root&&(a.parent=i.getRoot()),i.add(a,e),t=a.id),s)for(var l=0,u=s;l<u.length;l++){var d=u[l].id,h=this.getIndex(d);"string"==typeof t&&this.copy(d,h,i,t)}return t}i.add(a,e)},e.prototype._move=function(t,e,i,n,o){if(void 0===i&&(i=this),void 0===n&&(n=this._root),!this.exists(t))return null;if(o&&(e=-1===e?-1:e+o),i!==this){if(!c.isTreeCollection(i))return i.add(c.copyWithoutInner(this.getItem(t)),e),void this.remove(t);var r=this.copy(t,e,i,n);return this.remove(t),r}if(!this.canCopy(t,n))return null;var s=this.getParent(t),a=this.getIndex(t),u=this._childs[s].splice(a,1)[0];return u.parent=n,this._childs[s].length||delete this._childs[s],this.haveItems(n)||(this._childs[n]=[]),-1===e?e=this._childs[n].push(u):this._childs[n].splice(e,0,u),this.events.fire(l.DataEvents.change),t},e.prototype._removeAll=function(e){var i;if(e)for(var n=0,r=o(this._childs[e]);n<r.length;n++){var s=r[n];this.remove(s.id)}else{t.prototype._removeAll.call(this);var a=this._root;this._initChilds=null,this._childs=((i={})[a]=[],i)}},e.prototype._removeCore=function(t){if(this._pull[t]){var e=this.getParent(t);this._childs[e]=this._childs[e].filter(function(e){return e.id!==t}),e===this._root||this._childs[e].length||delete this._childs[e],this._initChilds&&this._initChilds[e]&&(this._initChilds[e]=this._initChilds[e].filter(function(e){return e.id!==t}),e===this._root||this._initChilds[e].length||delete this._initChilds[e]),this._fastDeleteChilds(this._childs,t),this._initChilds&&this._fastDeleteChilds(this._initChilds,t)}},e.prototype._addToOrder=function(t,e,i){var n=this._childs,o=this._initChilds,r=e.parent;this._pull[e.id]=e,u(n,e,r,i),o&&u(o,e,r,i)},e.prototype._parse_data=function(t,e){void 0===e&&(e=this._root);for(var i=0,n=t;i<n.length;i++){var o=n[i];this.config.init&&(o=this.config.init(o)),"object"!=typeof o&&(o={value:o}),o.id=o.id?o.id.toString():r.uid(),o.parent=o.parent?o.parent.toString():e,this._pull[o.id]=o,this._childs[o.parent]||(this._childs[o.parent]=[]),this._childs[o.parent].push(o),o.items&&o.items instanceof Object&&this._parse_data(o.items,o.id)}},e.prototype._fastDeleteChilds=function(t,e){if(this._pull[e]&&delete this._pull[e],t[e]){for(var i=0;i<t[e].length;i++)this._fastDeleteChilds(t,t[e][i].id);delete t[e]}},e.prototype._recursiveFilter=function(t,e,i,n,o){var r=this,s=this._childs[i];if(s){var a=function(t){switch(e.type){case l.TreeFilterType.all:return!0;case l.TreeFilterType.level:return n===e.level;case l.TreeFilterType.leafs:return!r.haveItems(t.id)}};if("function"==typeof t){var c=function(e){return a(e)&&t(e)};(u=s.filter(c)).length&&(o[i]=u)}else if(t.by&&t.match){var u;c=function(e){return a(e)&&-1!==e[t.by].toString().toLowerCase().indexOf(t.match.toString().toLowerCase())};(u=s.filter(c)).length&&(o[i]=u)}for(var d=0,h=s;d<h.length;d++){var f=h[d];this._recursiveFilter(t,e,f.id,n+1,o)}}},e.prototype._serialize=function(t,e){var i=this;return void 0===t&&(t=this._root),this.map(function(t){var n={};for(var o in t)"parent"!==o&&"items"!==o&&(n[o]=t[o]);return e&&(n=e(n)),i.haveItems(t.id)&&(n.items=i._serialize(t.id,e)),n},t,!1)},e}(s.DataCollection);e.TreeCollection=d},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(2),o=i(97),r=i(15),s=i(16);var a=function(){function t(){var t=this;this._transferData={},this._canMove=!0,this._selectedIds=[],this._onMouseMove=function(e){if(t._transferData.id){var i=e.pageX,n=e.pageY;if(!t._transferData.ghost){if(Math.abs(t._transferData.x-i)<3&&Math.abs(t._transferData.y-n)<3)return;var o=t._onDragStart(t._transferData.id,t._transferData.targetId);if(!o)return void t._endDrop();t._transferData.ghost=o,document.body.appendChild(t._transferData.ghost)}t._moveGhost(i,n),t._onDrag(e)}},this._onMouseUp=function(){t._transferData.x&&(t._transferData.ghost?(t._removeGhost(),t._onDrop()):t._endDrop(),document.removeEventListener("mousemove",t._onMouseMove),document.removeEventListener("mouseup",t._onMouseUp))}}return t.prototype.setItem=function(t,e){o.collectionStore.setItem(t,e)},t.prototype.onMouseDown=function(t,e,i){if(1===t.which){t.preventDefault(),document.addEventListener("mousemove",this._onMouseMove),document.addEventListener("mouseup",this._onMouseUp);var o=n.locateNode(t,"dhx_id"),r=o&&o.getAttribute("dhx_id"),s=n.locate(t,"dhx_widget_id");if(e&&-1!==e.indexOf(r)&&e.length>1?(this._selectedIds=e,this._itemsForGhost=i):(this._selectedIds=[],this._itemsForGhost=null),r&&s){var a=n.getBox(o),c=a.left,l=a.top;this._transferData.initXOffset=t.pageX-c,this._transferData.initYOffset=t.pageY-l,this._transferData.x=t.pageX,this._transferData.y=t.pageY,this._transferData.targetId=s,this._transferData.id=r,this._transferData.item=o}}},t.prototype._moveGhost=function(t,e){this._transferData.ghost&&(this._transferData.ghost.style.left=t-this._transferData.initXOffset+"px",this._transferData.ghost.style.top=e-this._transferData.initYOffset+"px")},t.prototype._removeGhost=function(){document.body.removeChild(this._transferData.ghost)},t.prototype._onDrop=function(){if(this._canMove){var t=o.collectionStore.getItem(this._lastCollectionId),e=t&&t.config;if(t&&e.dragMode!==r.DragMode.source){if(t.events.fire(r.DragEvents.beforeDrop,[this._lastId,this._transferData.target])){var i={id:this._lastId,target:t},n={id:this._transferData.id,target:this._transferData.target};this._move(n,i),i.target.events.fire(r.DragEvents.dropComplete,[i.id,this._transferData.dropPosition])}this._endDrop()}else this._endDrop()}else this._endDrop()},t.prototype._onDragStart=function(t,e){var i=o.collectionStore.getItem(e),n=i.config;if(n.dragMode===r.DragMode.target)return null;var s=i.data.getItem(t),a=function(t,e){var i=t.getBoundingClientRect(),n=document.createElement("div"),o=t.cloneNode(!0);return o.style.width=i.width+"px",o.style.height=i.height+"px",o.style.maxHeight=i.height+"px",o.style.fontSize=window.getComputedStyle(t.parentElement).fontSize,o.style.opacity="0.8",o.style.fontSize=window.getComputedStyle(t.parentElement).fontSize,n.appendChild(o),e&&e.length&&e.forEach(function(t,e){var o=t.cloneNode(!0);o.style.width=i.width+"px",o.style.height=i.height+"px",o.style.maxHeight=i.height+"px",o.style.top=12*(e+1)-i.height-i.height*e+"px",o.style.left=12*(e+1)+"px",o.style.opacity="0.6",o.style.zIndex=""+(-e-1),n.appendChild(o)}),n.className="dhx_drag-ghost",n}(this._transferData.item,this._itemsForGhost);return i.events.fire(r.DragEvents.beforeDrag,[s,a])&&t?(i.events.fire(r.DragEvents.dragStart,[t,this._selectedIds]),this._toggleTextSelection(!0),this._transferData.target=i,this._transferData.dragConfig=n,a):null},t.prototype._onDrag=function(t){var e=t.clientX,i=t.clientY,a=document.elementFromPoint(e,i),c=n.locate(a,"dhx_widget_id");if(c){var l=o.collectionStore.getItem(c),u=n.locate(a,"dhx_id");if(!u)return this._cancelCanDrop(),this._lastCollectionId=c,this._lastId=null,void this._canDrop();if(l.config.dropBehaviour===r.DropBehaviour.complex){var d=function(t){var e=t.clientY,i=n.locateNode(t);if(!i)return null;var o=i.childNodes[0].getBoundingClientRect();return(e-o.top)/o.height}(t);this._transferData.dropPosition=d<=.25?r.DropPosition.top:d>=.75?r.DropPosition.bot:r.DropPosition.in}else if(this._lastId===u&&this._lastCollectionId===c)return;var h={id:this._transferData.id,target:this._transferData.target};if("source"!==l.config.dragMode)if(h.target.events.fire(r.DragEvents.dragOut,[u,l]),c!==this._transferData.targetId||!s.isTreeCollection(h.target.data)||s.isTreeCollection(h.target.data)&&h.target.data.canCopy(h.id,u))this._cancelCanDrop(),this._lastId=u,this._lastCollectionId=c,h.target.events.fire(r.DragEvents.dragIn,[u,this._transferData.dropPosition,o.collectionStore.getItem(c)])&&this._canDrop();else this._cancelCanDrop()}else this._canMove&&this._cancelCanDrop()},t.prototype._move=function(t,e){var i=t.target.data,n=e.target.data,o=0,a=e.id;switch(s.isTreeCollection(n)?e.target.config.dropBehaviour:void 0){case r.DropBehaviour.child:break;case r.DropBehaviour.sibling:a=n.getParent(a),o=n.getIndex(e.id)+1;break;case r.DropBehaviour.complex:var c=this._transferData.dropPosition;c===r.DropPosition.top?(a=n.getParent(a),o=n.getIndex(e.id)):c===r.DropPosition.bot&&(a=n.getParent(a),o=n.getIndex(e.id)+1);break;default:o=e.id?t.target===e.target&&n.getIndex(t.id)<n.getIndex(e.id)?n.getIndex(e.id)-1:n.getIndex(e.id):-1}this._transferData.dragConfig.dragCopy?this._selectedIds instanceof Array&&this._selectedIds.length>1?this._selectedIds.map(function(t){i.copy(t,o,n,a),o>-1&&o++}):i.copy(t.id,o,n,a):this._selectedIds instanceof Array&&this._selectedIds.length>1?this._selectedIds.map(function(t){i.move(t,o,n,a),o>-1&&o++}):i.move(t.id,o,n,a)},t.prototype._endDrop=function(){this._toggleTextSelection(!1),this._transferData.target&&this._transferData.target.events.fire(r.DragEvents.dragEnd,[this._transferData.id,this._selectedIds]),this._cancelCanDrop(),this._canMove=!0,this._transferData={},this._lastId=null,this._lastCollectionId=null},t.prototype._cancelCanDrop=function(){this._canMove=!1;var t=o.collectionStore.getItem(this._lastCollectionId);t&&this._lastId&&t.events.fire(r.DragEvents.cancelDrop,[this._lastId]),this._lastCollectionId=null,this._lastId=null},t.prototype._canDrop=function(){this._canMove=!0;var t=o.collectionStore.getItem(this._lastCollectionId);t&&this._lastId&&t.events.fire(r.DragEvents.canDrop,[this._lastId,this._transferData.dropPosition])},t.prototype._toggleTextSelection=function(t){t?document.body.classList.add("dhx_no-select"):document.body.classList.remove("dhx_no-select")},t}(),c=window.dhxHelpers=window.dhxHelpers||{};c.dragManager=c.dragManager||new a,e.dragManager=c.dragManager},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=function(){function t(){this._store={}}return t.prototype.setItem=function(t,e){this._store[t]=e},t.prototype.getItem=function(t){return this._store[t]?this._store[t]:null},t}(),o=window.dhxHelpers=window.dhxHelpers||{};o.collectionStore=o.collectionStore||new n,e.collectionStore=o.collectionStore},function(t,e,i){"use strict";(function(t){var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}();Object.defineProperty(e,"__esModule",{value:!0});var o=i(21),r=i(1),s=i(34),a=function(e){function i(t,i){var n=e.call(this,t)||this;return n.config=r.extend({from:0,limit:50,delay:50,prepare:0},i),n.updateUrl(t,{from:n.config.from,limit:n.config.limit}),n}return n(i,e),i.prototype.load=function(){var e=this;return new t(function(t){e._timeout?(clearTimeout(e._timeout),e._timeout=setTimeout(function(){s.ajax.get(e.url,{responseType:"text"}).then(t),e._cooling=!0},e.config.delay),e._cooling&&(t(null),e._cooling=!1)):(s.ajax.get(e.url,{responseType:"text"}).then(t),e._cooling=!0,e._timeout=setTimeout(function(){}))})},i}(o.DataProxy);e.LazyDataProxy=a}).call(this,i(12))},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(3),o=i(22),r=i(15),s=function(){function t(t,e,i){var o=this;this.events=i||new n.EventSystem(this),this._data=e,this._data.events.on(r.DataEvents.removeAll,function(){o._selected=null}),this._data.events.on(r.DataEvents.change,function(){if(o._selected){var t=o._data.getNearId(o._selected);t!==o._selected&&(o._selected=null,t&&o.add(t))}})}return t.prototype.getId=function(){return this._selected},t.prototype.getItem=function(){return this._selected?this._data.getItem(this._selected):null},t.prototype.remove=function(t){return!(t=t||this._selected)||!!this.events.fire(o.SelectionEvents.beforeUnSelect,[t])&&(this._data.update(t,{$selected:!1}),this._selected=null,this.events.fire(o.SelectionEvents.afterUnSelect,[t]),!0)},t.prototype.add=function(t){this._selected!==t&&(this.remove(),this.events.fire(o.SelectionEvents.beforeSelect,[t])&&(this._selected=t,this._data.update(t,{$selected:!0}),this.events.fire(o.SelectionEvents.afterSelect,[t])))},t}();e.Selection=s},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),o=this&&this.__assign||function(){return(o=Object.assign||function(t){for(var e,i=1,n=arguments.length;i<n;i++)for(var o in e=arguments[i])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)},r=this&&this.__spreadArrays||function(){for(var t=0,e=0,i=arguments.length;e<i;e++)t+=arguments[e].length;var n=Array(t),o=0;for(e=0;e<i;e++)for(var r=arguments[e],s=0,a=r.length;s<a;s++,o++)n[o]=r[s];return n};Object.defineProperty(e,"__esModule",{value:!0});var s=i(1),a=i(0),c=i(3),l=i(2),u=i(101),d=i(4),h=i(7),f=i(14),p=i(19),_=i(29),v=i(37),g=i(27),m=i(56),y=i(120),b=i(121),x=i(122),w=i(123),k=function(t){function e(e,i){void 0===i&&(i={});var n=t.call(this,null,s.extend({mode:g.VaultMode.list,toolbar:!0,updateFromResponse:!0,scaleFactor:4,customScroll:!0,uploader:{},progressBar:{}},i))||this;return n.config.toolbar||(n.config.uploader.autosend=!0),i.data?(n.data=i.data,n.events=i.data.events,n.events.context=n):(n.events=new c.EventSystem(n),n.data=new h.DataCollection({},n.events)),n.data.config.init=function(t){return t.status=t.status||g.FileStatus.uploaded,t.file?(t.size=t.file.size,t.name=t.file.name):(t.size=t.size||0,t.name=t.name||""),n.config.mode===g.VaultMode.grid&&t.file&&b.isImage(t)&&n._readStack.add(t,n.uploader.config.autosend),t},n._readStack=new w.ReadStackPreview(n.data),n.uploader=new m.Uploader(n.config.uploader,n.data,n.events),n._scrollView=new u.ScrollView(function(){return n._vaultView.getRootView()}),n._progressBar=new x.ProgressBar(n.events,n.config.progressBar),n.events.on(g.UploaderEvents.uploadProgress,function(t,e,i){return n._progressBar.setState(t,{current:e,total:i})}),n._initHandlers(),n._initUI(e),n._initEvents(),n}return n(e,t),e.prototype.destructor=function(){this.toolbar.destructor(),this._readStack.stop(),this.uploader.unlinkDropArea(),this.uploader.abort()},e.prototype.getRootView=function(){return this._layout.getRootView()},e.prototype._initUI=function(t){var e=this,i=this.config.toolbar?y.layoutConfig:y.layoutConfigWithoutTopbar;i.on=this._getDragEvents();var n=this._layout=new f.Layout(t,i),o=this.toolbar=new _.Toolbar(null,{css:"vault-toolbar"});this.toolbar.data.parse([{id:"add",tooltip:v.default.add,type:_.ItemType.button,icon:"dxi-plus"},{id:"upload",tooltip:v.default.upload,type:_.ItemType.button,icon:"dxi icon-upload"},{id:"spacer",type:_.ItemType.spacer},{id:"remove-all",tooltip:v.default.clearAll,type:_.ItemType.button,icon:"dxi-delete-forever"}]),this._hideUploadAndDeleteButtons(),this._vaultView=d.toViewLike(a.create({render:function(){return e._draw()}})),this.config.toolbar&&n.getCell("topbar").attach(o),n.getCell("vault").attach(this._vaultView)},e.prototype._initHandlers=function(){var t=this;this._handlers={onclick:{".action-add":function(){return t.uploader.selectFile()},".action-remove-file":function(e){var i=l.locate(e);i&&(t.data.update(i,{$toRemove:!0}),setTimeout(function(){t.data.update(i,{$toRemove:!1},!0),t.data.remove(i)},200))}},onmouseover:{".action-download":function(t){p.tooltip(v.default.download,{node:t.target,position:p.Position.bottom})},".action-remove-file":function(t){p.tooltip(v.default.clear,{node:t.target,position:p.Position.bottom})},".title-content, .dhx-file-name":function(e){var i=l.locate(e),n=t.data.getItem(i);p.tooltip(n.name,{node:e.target,position:p.Position.bottom,css:"tooltip-light"})}}}},e.prototype._getDragEvents=function(){var t=this,e={left:null,top:null,width:null,height:null};return{dragleave:function(i){t._canDrop&&(i.pageX>e.left+e.width-1||i.pageX<e.left||i.pageY>e.top+e.height-1||i.pageY<e.top)&&(t._canDrop=!1,t.config.toolbar&&t._layout.getCell("topbar").show(),t._layout.config.css="vault-layout",t._layout.paint())},dragenter:function(i){if(i.preventDefault(),!t.uploader.isActive&&!t._canDrop){for(var n=0,o=i.dataTransfer.types;n<o.length;n++){var r=o[n];if("Files"!==r&&"application/x-moz-file"!==r)return void(t._canDrop=!1)}t._canDrop=!0;var s=t.getRootView().node.el.getBoundingClientRect();e.left=s.left+window.pageXOffset,e.top=s.top+window.pageYOffset,e.width=s.width,e.height=s.height,t._canDrop=!0,t.config.toolbar&&t._layout.getCell("topbar").hide(),t._layout.config.css="vault-layout dhx-dragin",t._layout.paint()}},dragover:function(t){t.preventDefault()},drop:function(e){if(e.preventDefault(),t._canDrop){var i=e.dataTransfer;t.uploader.parseFiles(i),t._canDrop=!1,t.config.toolbar&&t._layout.getCell("topbar").show(),t._layout.config.css="vault-layout",t._layout.paint()}}}},e.prototype._hideUploadAndDeleteButtons=function(){this.toolbar.hide(["upload","remove-all"])},e.prototype._showUploadAndDeleteButtons=function(){this.uploader.config.autosend?this.toolbar.show("remove-all"):this.toolbar.show(["upload","remove-all"])},e.prototype._initEvents=function(){var t=this;this.data.events.on(h.DataEvents.change,function(){t.data.getLength()?t._showUploadAndDeleteButtons():t._hideUploadAndDeleteButtons(),t._vaultView.paint()}),this.events.on(g.UploaderEvents.uploadBegin,function(){t.config.toolbar&&t._layout.getCell("topbar").attach(t._progressBar)}),this.events.on(g.UploaderEvents.uploadComplete,function(){t.config.mode===g.VaultMode.grid&&t.uploader.config.autosend&&t._readStack.read(),t.config.toolbar&&t._layout.getCell("topbar").attach(t.toolbar)}),this.toolbar.events.on(_.NavigationBarEvents.click,function(e){switch(e){case"add":t.uploader.selectFile();break;case"remove-all":t.data.removeAll();break;case"upload":t.uploader.send()}}),this.events.on(g.ProgressBarEvents.cancel,function(){t.uploader.abort(),t._vaultView.paint()})},e.prototype._draw=function(){var t=!this.data.getLength(),e=this.config.mode===g.VaultMode.grid?this._drawGrid():this._drawList();return a.el("div",o(o({class:"vault dhx_widget"+(this._canDrop?" drop-here":"")},this._handlers),{dhx_widget_id:this._uid}),[this._canDrop||t?this._drawDropableArea():this.config.customScroll?this._scrollView.render(e):e])},e.prototype._getFileActions=function(t){var e=[],i=[],n=[a.el(".dhx-default-actions",e),a.el(".dhx-hover-actions",i)];if(t.status===g.FileStatus.inprogress)return n;if(t.status!==g.FileStatus.failed&&t.link){var o=(this.config.downloadURL||"")+t.link,r=o.split("/").pop().split("?")[0],s=a.el("a",{download:r,class:"download-link",href:o},[a.el(".icon-btn.dxi.dxi-download.action-download")]);i.push(s)}var c=a.el(".icon-btn.dxi.dxi-delete-forever.action-remove-file");if(i.push(c),t.status===g.FileStatus.failed){var l=a.el(".dxi.dxi-alert-circle.warning-status");e.push(l)}if(t.status===g.FileStatus.uploaded){var u=a.el(".dxi.dxi-checkbox-marked-circle.uploaded-status");e.push(u)}return n},e.prototype._drawList=function(){var t=this;return a.el(".dhx-files-block.dhx-webkit-scroll",this.data.map(function(e){var i=e.status===g.FileStatus.failed&&e.request,n=e.status===g.FileStatus.inprogress,o=e.status===g.FileStatus.queue,r=e.status!==g.FileStatus.uploaded;return a.el("div",{class:"dhx-file-item"+(e.$toRemove?" to-remove":"")+(o?" in-queue":""),dhx_id:e.id,_key:e.id},[a.el(".dhx-file-icon",[a.el("div",{class:"dhx-file-type "+b.getFileClassName(e)+(r?" not-loaded":"")})]),a.el(".dhx-file-title",[a.el(".dhx-title-content",e.name),a.el(".dhx-file-info",[i&&a.el(".warn-message",e.request.statusText||v.default.error),n?a.el(".progress-value",(100*e.progress).toFixed(1)+"%"):a.el(".dhx-size"+(i?".dhx-size-error":""),b.getBasis(e.size))])]),n&&a.el(".dhx-download-progress",{style:{width:(100*e.progress).toFixed(1)+"%"}}),!n&&a.el(".dhx-file-action",t._getFileActions(e))])}))},e.prototype._drawDropableArea=function(){return a.el(".dhx-dropable-area.drop-files-here",[a.el(".dhx-big-icon-block",[a.el(".dxi.icon-upload")]),!this._canDrop&&a.el(".drop-area-bold-text",v.default.dragAndDrop),!this._canDrop&&a.el(".drop-area-bold-text",v.default.filesOrFoldersHere),!this._canDrop&&a.el(".drop-area-light-text",v.default.or),!this._canDrop&&a.el("button.dhx_btn.dhx_btn--flat.dhx_btn--small.action-add",v.default.browse)])},e.prototype._drawGrid=function(){var t=this;return a.el("div",{class:"dhx-files-grid dhx-webkit-scroll"},[a.el(".dhx-grid-content",this.data.map(function(e){var i=e.status===g.FileStatus.inprogress,n=e.status===g.FileStatus.queue,o=e.status===g.FileStatus.failed;return a.el("div",{class:"dhx-file-grid-item"+(i?" in-progress":"")+(e.$toRemove?" to-remove":"")+(n?" in-queue":"")+(o?" failed":""),dhx_id:e.id,_key:e.id},[a.el(".dhx-preview-wrapper",r([e.preview?a.el(".dhx-server-file-preview",[a.el("img",{src:e.preview})]):e.image?a.el("canvas",{width:98*t.config.scaleFactor,height:98*t.config.scaleFactor,_hooks:{didInsert:function(i){var n=b.calculateCover(e.image),o=n.dx,r=n.dy,s=n.sx,a=n.sy,c=n.sHeight,l=n.sWidth;i.el.getContext("2d").drawImage(e.image,s,a,l,c,o,r,98*t.config.scaleFactor,98*t.config.scaleFactor)}}}):a.el("div",{class:"dhx-file-preview dhx-file-type "+b.getFileClassName(e)}),i&&t._drawCircle(e.progress)],t._getFileActions(e),[a.el(".dhx-file-info",[o&&a.el(".warn-message",e.request.statusText||v.default.error),!i&&a.el(".dhx-size"+(o?".dhx-size-error":""),b.getBasis(e.size))])])),a.el(".dhx-file-name",b.truncateWord(e.name))])}))])},e.prototype._drawCircle=function(t){return a.el(".progress-layout",[a.el(".progress-amount",(100*t).toFixed(1)+"%"),a.sv("svg",{xmlns:"http://www.w3.org/2000/svg",class:"progress-circle",viewBox:"0 0 60 60"},[a.sv("circle",{cx:30,cy:30,r:28,"stroke-width":4,class:"progress-bar-background"}),a.sv("circle.active-circle",{cx:30,cy:30,r:28,"stroke-width":4,"stroke-dasharray":"175.9 175.9","stroke-dashoffset":175.9*(1-t),class:"progress-bar-active"})])])},e}(d.View);e.Vault=k},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(1),o=i(0),r=i(2),s=function(){function t(t,e){var i,o=this;void 0===e&&(e={}),this.config=n.extend({speed:20},e),this._wheelName=r.isIE()?"onmousewheel":"onwheel",this._getRootView=t,this._scrollTop=0,this._runnerTop=0,this._runnerHeight=0,this._visibleArea=1,this._scrollWidth=r.getScrollbarWidth(),this._handlers=((i={onscroll:function(){o._update()}})[this._wheelName]=function(t){t.preventDefault();var e=((t.deltaY||-t.wheelDelta)>0?1:-1)*o.config.speed,i=o._getRefs().area,n=i.scrollHeight-o._runnerHeight,r=o._scrollTop+e;i.scrollTop=r<0?0:r>n?n:r,o._update()},i.onmousedownRunner=function(t){t.preventDefault();var e=o._getRefs(),i=e.area,n=e.runner,r=i.getBoundingClientRect(),s=r.top+window.pageYOffset,a=r.bottom+window.pageYOffset,c=i.scrollHeight-o._runnerHeight,l=t.pageY-n.getBoundingClientRect().top-window.pageYOffset,u=function(t){var e=t.pageY-l;i.scrollTop=e<=s?0:e>a?c:(e-s)/o._visibleArea,o._update()},d=function(){document.removeEventListener("mousemove",u),document.removeEventListener("mouseup",d),document.body.classList.remove("dhx-no-select")};document.body.classList.add("dhx-no-select"),document.addEventListener("mousemove",u),document.addEventListener("mouseup",d)},i.onmousedownTrack=function(t){if(!t.target.classList.contains("scroll-runner")){t.preventDefault();var e=function(){document.removeEventListener("mouseup",e),window.clearInterval(c)},i=o._getRefs().area,n=t.target.getBoundingClientRect().top+window.pageYOffset,r=i.scrollHeight-o._runnerHeight,s=t.pageY,a=function(){var t;if(s<n+o._runnerTop)(t=o._scrollTop-i.clientHeight)<0&&(t=0);else{if(!(s>n+o._runnerTop+o._runnerHeight))return;(t=o._scrollTop+i.clientHeight)>r&&(t=r)}i.scrollTop=t,o._update()};a();var c=setInterval(a,100);document.addEventListener("mouseup",e)}},i)}return t.prototype.render=function(t){var e,i=this;return 0===this._scrollWidth?t:o.el(".scroll-view-wrapper",{style:{width:"100%",height:"100%",overflow:"hidden",position:"relative"}},[o.el(".scroll-view",{onscroll:this._handlers.onscroll,_ref:"scroll-view",_hooks:{didInsert:function(){i._update()},didRecycle:function(){i._update()}},style:{height:"100%",width:"calc(100% + "+this._scrollWidth+"px)",overflowY:"scroll","-ms-overflow-style":"scrollbar"}},[t]),o.el(".y-scroll",(e={onmousedown:this._handlers.onmousedownTrack},e[this._wheelName]=this._handlers[this._wheelName],e.style={width:"10px",height:"100%",right:0,top:0,position:"absolute"},e),[o.el(".scroll-runner",{_ref:"scroll-runner",onmousedown:this._handlers.onmousedownRunner,style:{height:this._runnerHeight+"px",right:"2px",top:this._runnerTop,width:"6px",position:"absolute"}})])])},t.prototype._update=function(){var t=this._getRefs();if(t){var e=t.area,i=t.runner;this._visibleArea=e.clientHeight/e.scrollHeight,this._scrollTop=e.scrollTop,this._runnerTop=this._scrollTop*this._visibleArea,this._visibleArea<1?this._runnerHeight=e.clientHeight*this._visibleArea:this._runnerHeight=0,i.style.top=this._runnerTop+"px",i.style.height=this._runnerHeight+"px"}},t.prototype._getRefs=function(){var t=this._getRootView();if(t.refs&&t.refs["scroll-view"]&&t.refs["scroll-runner"])return{area:t.refs["scroll-view"].el,runner:t.refs["scroll-runner"].el}},t}();e.ScrollView=s},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}();Object.defineProperty(e,"__esModule",{value:!0});var o=i(103),r=i(28),s=i(0),a=function(t){function e(e,i){var n=t.call(this,e,i)||this;if(n._root=n.config.parent||n,n._all={},n._parseConfig(),n.config.activeTab&&(n.config.activeView=n.config.activeTab),n.config.views&&(n.config.activeView=n.config.activeView||n._cells[0].id,n._isViewLayout=!0),!i.parent){var o=s.create({render:function(){return n.toVDOM()}},n);n.mount(e,o)}return n}return n(e,t),e.prototype.toVDOM=function(){if(this._isViewLayout){var e=[this.getCell(this.config.activeView).toVDOM()];return t.prototype.toVDOM.call(this,e)}var i=[];return this._cells.forEach(function(t){var e=t.toVDOM();Array.isArray(e)?i=i.concat(e):i.push(e)}),t.prototype.toVDOM.call(this,i)},e.prototype.removeCell=function(t){if(this.events.fire(r.LayoutEvents.beforeRemove,[t])){var e=this.config.parent||this;if(e!==this)return e.removeCell(t);var i=this.getCell(t);if(i){var n=i.getParent();delete this._all[t],n._cells=n._cells.filter(function(e){return e.id!==t}),n.paint()}this.events.fire(r.LayoutEvents.afterRemove,[t])}},e.prototype.addCell=function(t,e){if(void 0===e&&(e=-1),this.events.fire(r.LayoutEvents.beforeAdd,[t.id])){var i=this._createCell(t);e<0&&(e=this._cells.length+e+1),this._cells.splice(e,0,i),this.paint(),this.events.fire(r.LayoutEvents.afterAdd,[t.id])}},e.prototype.getId=function(t){return t<0&&(t=this._cells.length+t),this._cells[t]?this._cells[t].id:void 0},e.prototype.getRefs=function(t){return this._root.getRootView().refs[t]},e.prototype.getCell=function(t){return this._root._all[t]},e.prototype.forEach=function(t,e,i){if(void 0===i&&(i=1/0),this._haveCells(e)&&!(i<1)){var n;n=e?this._root._all[e]._cells:this._root._cells;for(var o=0;o<n.length;o++){var r=n[o];t.call(this,r,o,n),this._haveCells(r.id)&&r.forEach(t,r.id,--i)}}},e.prototype.cell=function(t){return this.getCell(t)},e.prototype._getCss=function(e){var i=this._xLayout?"dhx_layout-columns":"dhx_layout-rows",n=this.config.align?" "+i+"--"+this.config.align:"";if(e)return i+" dhx_layout-cell"+(this.config.align?" dhx_layout-cell--"+this.config.align:"");var o=this.config.parent?t.prototype._getCss.call(this):"dhx_widget dhx_layout",r=this.config.parent?"":" dhx_layout-cell";return o+(this.config.full?r:" "+i)+n},e.prototype._parseConfig=function(){var t=this,e=this.config,i=e.rows||e.cols||e.views||[];this._xLayout=!e.rows,this._cells=i.map(function(e){return t._createCell(e)})},e.prototype._createCell=function(t){var i;return t.rows||t.cols||t.views?(t.parent=this._root,i=new e(this,t)):i=new o.Cell(this,t),this._root._all[i.id]=i,i},e.prototype._haveCells=function(t){if(t){var e=this._root._all[t];return e._cells&&e._cells.length>0}return Object.keys(this._all).length>0},e}(o.Cell);e.Layout=a},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),o=this&&this.__assign||function(){return(o=Object.assign||function(t){for(var e,i=1,n=arguments.length;i<n;i++)for(var o in e=arguments[i])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)};Object.defineProperty(e,"__esModule",{value:!0});var r=i(1),s=i(0),a=i(4),c=i(28),l=i(104),u=i(3),d=function(t){function e(e,i){var n=t.call(this,e,r.extend({gravity:!0,collapsed:!1},i))||this;n._disabled=[];var o=e;return o&&o.isVisible&&(n._parent=o),n._parent&&n._parent.events?n.events=n._parent.events:n.events=new u.EventSystem(n),n.config.full=void 0===n.config.full?Boolean(n.config.header||n.config.collapsable||n.config.headerHeight||n.config.headerIcon||n.config.headerImage):n.config.full,n._initHandlers(),n.id=n.config.id||r.uid(),n}return n(e,t),e.prototype.paint=function(){if(this.isVisible()){var t=this.getRootView();t?t.redraw():this._parent.paint()}},e.prototype.isVisible=function(){if(!this._parent)return!(!this._container||!this._container.tagName)||Boolean(this.getRootNode());var t=this._parent.config.activeView;return(!t||t===this.id)&&(!this.config.hidden&&(!this._parent||this._parent.isVisible()))},e.prototype.hide=function(){this.events.fire(c.LayoutEvents.beforeHide,[this.id])&&(this.config.hidden=!0,this._parent&&this._parent.paint&&this._parent.paint(),this.events.fire(c.LayoutEvents.afterHide,[this.id]))},e.prototype.show=function(){this.events.fire(c.LayoutEvents.beforeShow,[this.id])&&(this._parent&&this._parent.config.activeView?this._parent.config.activeView=this.id:this.config.hidden=!1,this._parent&&!this._parent.isVisible()&&this._parent.show(),this.paint(),this.events.fire(c.LayoutEvents.afterHide,[this.id]))},e.prototype.expand=function(){this.events.fire(c.LayoutEvents.beforeExpand,[this.id])&&(this.config.collapsed=!1,this.events.fire(c.LayoutEvents.afterExpand,[this.id]),this.paint())},e.prototype.collapse=function(){this.events.fire(c.LayoutEvents.beforeCollapse,[this.id])&&(this.config.collapsed=!0,this.events.fire(c.LayoutEvents.afterCollapse,[this.id]),this.paint())},e.prototype.toggle=function(){this.config.collapsed?this.expand():this.collapse()},e.prototype.getParent=function(){return this._parent},e.prototype.destructor=function(){this.config=null,this.unmount()},e.prototype.getWidget=function(){return this._ui},e.prototype.getCellView=function(){return this._parent&&this._parent.getRefs(this._uid)},e.prototype.attach=function(t,e){return this.config.html=null,"object"==typeof t?this._ui=t:"string"==typeof t?this._ui=new window.dhx[t](null,e):"function"==typeof t&&(t.prototype instanceof a.View?this._ui=new t(null,e):this._ui={getRootView:function(){return t(e)}}),this.paint(),this._ui},e.prototype.attachHTML=function(t){this.config.html=t,this.paint()},e.prototype.toVDOM=function(t){var e;if(null===this.config&&(this.config={}),!this.config.hidden){var i,n=this._calculateStyle(),a=r.isDefined(this.config.padding)?{padding:this.config.padding}:{};if(!this.config.html)if(this._ui){var c=this._ui.getRootView();c.render&&(c=s.inject(c)),i=[c]}else i=t||null;var l=!this.config.resizable||this._isLastCell()||this.config.collapsed?null:s.el(".dhx_layout-resizer."+(this._isXDirection()?"dhx_layout-resizer--x":"dhx_layout-resizer--y"),o(o({},this._resizerHandlers),{_ref:"resizer_"+this._uid}),[s.el("span.dhx_layout-resizer__icon",{class:"dxi "+(this._isXDirection()?"dxi-dots-vertical":"dxi-dots-horizontal")})]),u={};if(this.config.on)for(var d in this.config.on)u["on"+d]=this.config.on[d];var h=s.el("div",o(o(((e={_key:this._uid,style:this.config.full||this.config.html?n:o(o({},n),a),_ref:this._uid})["aria-labelledby"]=this.config.id?"tab-content-"+this.config.id:null,e),u),{class:this._getCss(!1)+(this.config.css?" "+this.config.css:"")+(this.config.collapsed?" dhx_layout-cell--collapsed":"")+(this.config.resizable?" dhx_layout-cell--resizeble":"")+(this.config.gravity?" dhx_layout-cell--gravity":"")}),this.config.full?[s.el("div",{tabindex:this.config.collapsable?"0":"-1",class:"dhx_layout-cell-header"+(this._isXDirection()?" dhx_layout-cell-header--col":" dhx_layout-cell-header--row")+(this.config.collapsable?" dhx_layout-cell-header--collapseble":"")+(this.config.collapsed?" dhx_layout-cell-header--collapsed":"")+(((this.getParent()||{}).config||{}).isAccordion?" dhx_layout-cell-header--accordion":""),style:{height:this.config.headerHeight},onclick:this._handlers.toggle,onkeydown:this._handlers.enterCollapse},[this.config.headerIcon&&s.el("span.dhx_layout-cell-header__icon",{class:this.config.headerIcon}),this.config.headerImage&&s.el(".dhx_layout-cell-header__image-wrapper",[s.el("img",{src:this.config.headerImage,class:"dhx_layout-cell-header__image"})]),this.config.header&&s.el("h3.dhx_layout-cell-header__title",this.config.header),this.config.collapsable?s.el("div.dhx_layout-cell-header__collapse-icon",{class:this._getCollapseIcon()}):s.el("div.dhx_layout-cell-header__collapse-icon",{class:"dxi dxi-empty"})]),this.config.collapsed?null:s.el("div",{style:o(o({},a),{height:"calc(100% - "+(this.config.headerHeight||37)+"px)"}),".innerHTML":this.config.html,class:this._getCss(!0)+" dhx_layout-cell-content"},i)]:this.config.html?[s.el(".dhx_layout-cell-content",{".innerHTML":this.config.html,style:a})]:i);return l?[h,l]:h}},e.prototype._getCss=function(t){return"dhx_layout-cell"},e.prototype._initHandlers=function(){var t=this;this._handlers={enterCollapse:function(e){13===e.keyCode&&t._handlers.toggle()},collapse:function(){t.config.collapsable&&t.collapse()},expand:function(){t.config.collapsable&&t.expand()},toggle:function(){t.config.collapsable&&t.toggle()}};var e={left:null,top:null,isActive:!1,range:null,xLayout:null,nextCell:null,size:null,resizerLength:null,mode:null,percentsum:null},i=function(){e.isActive=!1,document.body.classList.remove("dhx_no-select--resize"),document.removeEventListener("mouseup",i),document.removeEventListener("mousemove",n),t.events.fire(c.LayoutEvents.afterResizeEnd,[t.id])},n=function(i){if(e.isActive&&e.mode!==c.resizeMode.unknown){var n=e.xLayout?i.x-e.range.min+window.pageXOffset:i.y-e.range.min+window.pageYOffset,o=e.xLayout?"width":"height";switch(n<0?n=e.resizerLength/2:n>e.size&&(n=e.size-e.resizerLength),e.mode){case c.resizeMode.pixels:t.config[o]=n-e.resizerLength/2+"px",e.nextCell.config[o]=e.size-n-e.resizerLength/2+"px";break;case c.resizeMode.mixedpx1:t.config[o]=n-e.resizerLength/2+"px";break;case c.resizeMode.mixedpx2:e.nextCell.config[o]=e.size-n-e.resizerLength/2+"px";break;case c.resizeMode.percents:t.config[o]=n/e.size*e.percentsum+"%",e.nextCell.config[o]=(e.size-n)/e.size*e.percentsum+"%";break;case c.resizeMode.mixedperc1:t.config[o]=n/e.size*e.percentsum+"%";break;case c.resizeMode.mixedperc2:e.nextCell.config[o]=(e.size-n)/e.size*e.percentsum+"%"}t.paint(),t.events.fire(c.LayoutEvents.resize,[t.id])}};this._resizerHandlers={onmousedown:function(o){if(3!==o.which&&(e.isActive&&i(),t.events.fire(c.LayoutEvents.beforeResizeStart,[t.id]))){document.body.classList.add("dhx_no-select--resize");var r=t.getCellView(),s=t._getNextCell(),a=s.getCellView(),u=t._getResizerView(),d=r.el.getBoundingClientRect(),h=u.el.getBoundingClientRect(),f=a.el.getBoundingClientRect();if(e.xLayout=t._isXDirection(),e.left=d.left+window.pageXOffset,e.top=d.top+window.pageYOffset,e.range=l.getBlockRange(d,f,e.xLayout),e.size=e.range.max-e.range.min,e.isActive=!0,e.nextCell=s,e.resizerLength=e.xLayout?h.width:h.height,e.mode=l.getResizeMode(e.xLayout,t.config,s.config),e.mode===c.resizeMode.percents){var p=e.xLayout?"width":"height";e.percentsum=parseFloat(t.config[p])+parseFloat(s.config[p])}if(e.mode===c.resizeMode.mixedperc1){p=e.xLayout?"width":"height";e.percentsum=1/(d[p]/(e.size-e.resizerLength))*parseFloat(t.config[p])}if(e.mode===c.resizeMode.mixedperc2){p=e.xLayout?"width":"height";e.percentsum=1/(f[p]/(e.size-e.resizerLength))*parseFloat(s.config[p])}document.addEventListener("mouseup",i),document.addEventListener("mousemove",n)}},ondragstart:function(t){return t.preventDefault()}}},e.prototype._getCollapseIcon=function(){return this._isXDirection()&&this.config.collapsed?"dxi dxi-chevron-right":this._isXDirection()&&!this.config.collapsed?"dxi dxi-chevron-left":!this._isXDirection()&&this.config.collapsed?"dxi dxi-chevron-up":this._isXDirection()||this.config.collapsed?void 0:"dxi dxi-chevron-down"},e.prototype._isLastCell=function(){var t=this._parent;return t&&t._cells.indexOf(this)===t._cells.length-1},e.prototype._getNextCell=function(){var t=this._parent,e=t._cells.indexOf(this);return t._cells[e+1]},e.prototype._getResizerView=function(){return this._parent.getRefs("resizer_"+this._uid)},e.prototype._isXDirection=function(){return this._parent&&this._parent._xLayout},e.prototype._calculateStyle=function(){var t=this.config;if(t){var e={};return this._isXDirection()?(void 0===t.width||t.collapsed||(e.flexBasis=t.width,e.width=t.width),void 0!==t.height&&(e.height=t.height)):(void 0===t.height||t.collapsed||(e.height=t.height),void 0!==t.width&&(e.width=t.width)),e}},e}(a.View);e.Cell=d},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(28);e.getResizeMode=function(t,e,i){var o=t?"width":"height",r=e[o]&&-1!==e[o].indexOf("%"),s=i[o]&&-1!==i[o].indexOf("%"),a=e[o]&&-1!==e[o].indexOf("px"),c=i[o]&&-1!==i[o].indexOf("px");return r&&s?n.resizeMode.percents:a&&c?n.resizeMode.pixels:a&&!c?n.resizeMode.mixedpx1:c&&!a?n.resizeMode.mixedpx2:r?n.resizeMode.mixedperc1:s?n.resizeMode.mixedperc2:n.resizeMode.unknown},e.getBlockRange=function(t,e,i){return void 0===i&&(i=!0),i?{min:t.left+window.pageXOffset,max:e.right+window.pageXOffset}:{min:t.top+window.pageYOffset,max:e.bottom+window.pageYOffset}}},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(2),o=i(35),r=new WeakMap,s=new Map;function a(t,e){e&&clearTimeout(r.get(t));var i=t.parentNode,n=i.getAttribute("data-position"),o=i.parentNode,a=s.get(o);if(a){var c=a[n];if(c){var l=c.stack,u=l.indexOf(t);return-1!==u?(i.removeChild(t),l.splice(u,1),void(0===l.length&&o.removeChild(i))):void 0}}}function c(t,e){var i=document.createElement("div");return i.setAttribute("data-position",e),i.className="dhx_message-container dhx_message-container--"+e+(t===document.body?" dhx_message-container--in-body":""),i}e.message=function(t){var e;"string"==typeof t&&(t={text:t}),t.position=t.position||o.MessageContainerPosition.topRight;var i=document.createElement("div");i.className="dhx_widget dhx_message "+(t.css||""),t.html?i.innerHTML=t.html:i.innerHTML='<span class="dhx_message__text">'+t.text+"</span>\n\t\t"+(t.icon?'<span class="dhx_message__icon dxi '+t.icon+'"></span>':"");var l=t.node?n.toNode(t.node):document.body;"static"===getComputedStyle(l).position&&(l.style.position="relative");var u=s.get(l);u?u[t.position]||(u[t.position]={stack:[],container:c(l,t.position)}):s.set(l,((e={})[t.position]={stack:[],container:c(l,t.position)},e));var d=s.get(l)[t.position],h=d.stack,f=d.container;if(0===h.length&&l.appendChild(f),h.push(i),f.appendChild(i),t.expire){var p=setTimeout(function(){return a(i)},t.expire);r.set(i,p)}i.onclick=function(){return a(i,!0)}}},function(t,e,i){"use strict";(function(t){Object.defineProperty(e,"__esModule",{value:!0});var n=i(36),o=i(61);e.alert=function(e){var i=e.buttons&&e.buttons[0]?e.buttons[0]:n.default.apply,r=o.blockScreen(e.blockerCss);return new t(function(t){var n=document.createElement("div");n.className="dhx_widget dhx_alert "+(e.css||""),n.innerHTML="\n\t\t\t"+(e.header?'<div class="dhx_alert__header"> '+e.header+" </div>":"")+"\n\t\t\t"+(e.text?'<div class="dhx_alert__content">'+e.text+"</div>":"")+'\n\t\t\t<div class="dhx_alert__footer '+(e.buttonsAlignment?"dhx_alert__footer--"+e.buttonsAlignment:"")+'">\n\t\t\t\t<button class="dhx_alert__apply-button dhx_button dhx_button--view_flat dhx_button--color_primary dhx_button--size_medium">'+i+"</button>\n\t\t\t</div>",document.body.appendChild(n),n.querySelector(".dhx_alert__apply-button").focus(),n.querySelector("button").addEventListener("click",function(){r(),document.body.removeChild(n),t(!0)})})}}).call(this,i(12))},function(t,e,i){"use strict";(function(t){Object.defineProperty(e,"__esModule",{value:!0});var n=i(36),o=i(61);e.confirm=function(e){var i=e.buttons&&e.buttons[0]?e.buttons[0]:n.default.apply,r=e.buttons&&e.buttons[1]?e.buttons[1]:n.default.reject,s=o.blockScreen(e.blockerCss);return new t(function(t){var n=document.createElement("div");n.className="dhx_widget dhx_alert dhx_alert--confirm"+(e.css?" "+e.css:""),n.innerHTML="\n\t\t"+(e.header?'<div class="dhx_alert__header"> '+e.header+" </div>":"")+"\n\t\t"+(e.text?'<div class="dhx_alert__content">'+e.text+"</div>":"")+'\n\t\t\t<div class="dhx_alert__footer '+(e.buttonsAlignment?"dhx_alert__footer--"+e.buttonsAlignment:"")+'">\n\t\t\t\t<button class="dhx_alert__confirm-aply dhx_button dhx_button--view_link dhx_button--color_primary dhx_button--size_medium">'+i+'</button>\n\t\t\t\t<button class="dhx_alert__confirm-reject dhx_button dhx_button--view_flat dhx_button--color_primary dhx_button--size_medium">'+r+"</button>\n\t\t\t</div>",document.body.appendChild(n),n.querySelector(".dhx_alert__confirm-reject").focus();var o=function(e){"BUTTON"===e.target.tagName&&function(e){s(),n.removeEventListener("click",o),document.body.removeChild(n),t(e)}(e.target.classList.contains("dhx_alert__confirm-aply"))};n.addEventListener("click",o)})}}).call(this,i(12))},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}();Object.defineProperty(e,"__esModule",{value:!0});var o=i(1),r=i(0),s=i(2),a=i(17),c=i(19),l=function(t){function e(e,i){var n=t.call(this,e,o.extend({navigationType:"click"},i))||this;n._currentRoot=null;return n.mount(e,r.create({render:function(){return n._draw()}})),n}return n(e,t),e.prototype.getState=function(){var t={};for(var e in this.data.eachChild(this.data.getRoot(),function(e){e.twoState&&!e.group?t[e.id]=e.active:e.type!==a.ItemType.input&&e.type!==a.ItemType.selectButton||(t[e.id]=e.value)},!1),this._groups)this._groups[e].active&&(t[e]=this._groups[e].active);return t},e.prototype.setState=function(t){for(var e in t)if(this._groups&&this._groups[e])this._groups[e].active&&(this.data.update(this._groups[e].active,{active:!1}),this._groups[e].active=t[e],this.data.update(t[e],{active:!0}));else{var i=this.data.getItem(e);i.type===a.ItemType.input||i.type===a.ItemType.selectButton?this.data.update(e,{value:t[e]}):this.data.update(e,{active:t[e]})}},e.prototype._customHandlers=function(){var t=this;return{input:function(e){var i=s.locate(e);t.data.update(i,{value:e.target.value})},tooltip:function(e){var i=s.locateNode(e);if(i){var n=i.getAttribute("dhx_id"),o=t.data.getItem(n);o.tooltip&&c.tooltip(o.tooltip,{node:i,position:c.Position.bottom})}}}},e.prototype._getFactory=function(){return a.createFactory({widget:this,defaultType:a.ItemType.navItem,allowedTypes:[a.ItemType.button,a.ItemType.customHTMLButton,a.ItemType.imageButton,a.ItemType.input,a.ItemType.selectButton,a.ItemType.separator,a.ItemType.spacer,a.ItemType.title,a.ItemType.navItem,a.ItemType.menuItem,a.ItemType.customHTML],widgetName:"toolbar"})},e.prototype._draw=function(){var t=this;return r.el("nav.dhx_widget.dhx_toolbar",{class:this.config.css?this.config.css:""},[r.el("ul.dhx_navbar.dhx_navbar--horizontal",{dhx_widget_id:this._uid,tabindex:0,onclick:this._handlers.onclick,onmousedown:this._handlers.onmousedown,oninput:this._handlers.input,onmouseover:this._handlers.tooltip,_hooks:{didInsert:function(e){e.el.addEventListener("keyup",function(e){if(9===e.which){var i=s.locateNode(document.activeElement);if(i){var n=i.getAttribute("dhx_id"),o=t.data.getItem(n);o.tooltip&&c.tooltip(o.tooltip,{node:i,position:c.Position.bottom,force:!0})}}},!0)}}},this.data.map(function(e){return t._factory(e)},this.data.getRoot(),!1))])},e.prototype._getMode=function(t,e){return t.id===e?"bottom":"right"},e.prototype._close=function(e){this._activePosition=null,this._currentRoot=null,t.prototype._close.call(this,e)},e.prototype._setRoot=function(t){this.data.getParent(t)===this.data.getRoot()&&(this._currentRoot=t)},e}(a.Navbar);e.Toolbar=l},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),o=this&&this.__assign||function(){return(o=Object.assign||function(t){for(var e,i=1,n=arguments.length;i<n;i++)for(var o in e=arguments[i])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)};Object.defineProperty(e,"__esModule",{value:!0});var r=i(1),s=i(0),a=i(3),c=i(2),l=i(13),u=i(4),d=i(7),h=i(23),f=function(t){function e(e,i){var n=t.call(this,e,r.extend({},i))||this;return n._isContextMenu=!1,n._documentHaveListener=!1,n._rootItem={},Array.isArray(n.config.data)?(n.events=new a.EventSystem(n),n.data=new d.TreeCollection({},n.events)):n.config.data&&n.config.data.events?(n.data=n.config.data,n.events=n.data.events,n.events.context=n):(n.events=new a.EventSystem(n),n.data=new d.TreeCollection({},n.events)),n._documentClick=function(t){n._documentHaveListener&&(document.removeEventListener("click",n._documentClick),n._documentHaveListener=!1,n._close(t))},n._currentRoot=n.data.getRoot(),n._factory=n._getFactory(),n._initHandlers(),n._init(),n._initEvents(),Array.isArray(n.config.data)&&n.data.parse(n.config.data),n}return n(e,t),e.prototype.paint=function(){t.prototype.paint.call(this),this._vpopups.redraw()},e.prototype.disable=function(t){this._setProp(t,"disabled",!0)},e.prototype.enable=function(t){this._setProp(t,"disabled",!1)},e.prototype.isDisabled=function(t){var e=this.data.getItem(t);if(e)return e.disabled||!1},e.prototype.show=function(t){this._setProp(t,"hidden",!1)},e.prototype.hide=function(t){this._setProp(t,"hidden",!0)},e.prototype.destructor=function(){this.unmount(),l.keyManager.removeHotKey(null,this),this._vpopups.unmount()},e.prototype._customHandlers=function(){return{}},e.prototype._close=function(t){var e=this;this._popupActive&&this.events.fire(h.NavigationBarEvents.beforeHide,[this._activeMenu,t])&&(this._activeParents&&this._activeParents.forEach(function(t){return e.data.exists(t)&&e.data.update(t,{$activeParent:!1})}),this.config.navigationType===h.NavigationType.click&&(this._isActive=!1),clearTimeout(this._currentTimeout),this._popupActive=!1,this._activeMenu=null,this.events.fire(h.NavigationBarEvents.afterHide,[t]),this.paint())},e.prototype._init=function(){var t=this;this._vpopups=s.create({render:function(){return s.el("div",{dhx_widget_id:t._uid,class:"dhx_"+(t._isContextMenu?" dhx_context-menu":""),onmousemove:t._handlers.onmousemove,onmouseleave:t._handlers.onmouseleave,onclick:t._handlers.onclick,onmousedown:t._handlers.onmousedown},t._drawPopups())}}),this._vpopups.mount(document.body)},e.prototype._initHandlers=function(){var t=this;this._isActive=this.config.navigationType!==h.NavigationType.click,this._handlers=o({onmousemove:function(e){if(t._isActive){var i=c.locateNode(e);if(i){var n=i.getAttribute("dhx_id");if(t._activeMenu!==n){if(t.data.haveItems(n)){var o=c.getRealPosition(i);t.data.update(n,{$position:o},!1)}t._activeItemChange(n,e)}}}},onmouseleave:function(e){if(t.config.navigationType!==h.NavigationType.click){if(t._popupActive){var i=c.locateNode(e,"dhx_id","relatedTarget");if(i){var n=i.getAttribute("dhx_id");t.data.getItem(n)||t._close(e)}else t._close(e)}t._activeItemChange(null,e)}},onclick:function(e){var i=c.locateNode(e);if(i){var n=i.getAttribute("dhx_id"),o=t.data.getItem(n);if(!o.multiClick)if(t.data.haveItems(n)){if(n===t._currentRoot)return;t._isActive||(t._isActive=!0),t._setRoot(n);var r=c.getRealPosition(i);t.data.update(n,{$position:r},!1),t._activeItemChange(n,e)}else switch(o.type){case h.ItemType.input:case h.ItemType.title:break;case h.ItemType.menuItem:case h.ItemType.selectButton:t._onMenuItemClick(n,e);break;case h.ItemType.imageButton:case h.ItemType.button:case h.ItemType.customHTMLButton:case h.ItemType.navItem:o.twoState&&t.data.update(o.id,{active:!o.active}),t.events.fire(h.NavigationBarEvents.click,[n,e]);default:t._close(e)}}},onmousedown:function(e){var i=c.locateNode(e);if(i){var n=i.getAttribute("dhx_id");if(t.data.getItem(n).multiClick){var o,r=365,s=function(){t.events.fire(h.NavigationBarEvents.click,[n,e]),r>50&&(r-=55),o=setTimeout(s,r)},a=function(){clearTimeout(o),document.removeEventListener("mouseup",a)};s(),document.addEventListener("mouseup",a)}}}},this._customHandlers())},e.prototype._initEvents=function(){var t=this,e=null;this.data.events.on(h.DataEvents.change,function(){t.paint(),e&&clearTimeout(e),e=setTimeout(function(){var i={};t.data.eachChild(t.data.getRoot(),function(t){t.group&&(t.twoState=!0,function(t,e){t[e.group]?(e.active&&(t[e.group].active=e.id),t[e.group].elements.push(e.id)):t[e.group]={active:e.active?e.id:null,elements:[e.id]}}(i,t))},!0),t._groups=i,t._resetHotkeys(),e=null,t.paint()},100)}),this.events.on(h.NavigationBarEvents.click,function(e){var i=t.data.getItem(e),n=t.data.getItem(i.parent);if(n&&n.type===h.ItemType.selectButton&&t.data.update(i.parent,{value:i.value,icon:i.icon}),i.group){var o=t._groups[i.group];o.active&&t.data.update(o.active,{active:!1}),o.active=i.id,t.data.update(i.id,{active:!0})}}),this._customInitEvents()},e.prototype._getMode=function(t,e,i){return void 0===i&&(i=!1),t.parent===e?"bottom":"right"},e.prototype._drawMenuItems=function(t,e){var i=this;return void 0===e&&(e=!0),this.data.map(function(t){return i._factory(t,e)},t,!1)},e.prototype._setRoot=function(t){},e.prototype._getParents=function(t,e){var i=[],n=!1,o=this.data.getItem(t),r=o&&o.disabled;return this.data.eachParent(t,function(t){t.id===e?(i.push(t.id),n=!0):n||i.push(t.id)},!r),this._isContextMenu&&this._activePosition&&i.push(e),i},e.prototype._listenOuterClick=function(){this._documentHaveListener||(document.addEventListener("click",this._documentClick,!0),this._documentHaveListener=!0)},e.prototype._customInitEvents=function(){},e.prototype._drawPopups=function(){var t=this,e=this._activeMenu;if(!this._isContextMenu&&!e)return null;var i=this._currentRoot;if(this._isContextMenu&&!this._activePosition)return null;var n=this._getParents(e,i);return this._activeParents=n,n.forEach(function(e){return t.data.exists(e)&&t.data.update(e,{$activeParent:!0},!1)}),n.map(function(e){if(!t.data.haveItems(e))return null;var n=t.data.getItem(e)||t._rootItem;return t._popupActive=!0,s.el("ul",{class:"dhx_widget dhx_menu"+(t.config.menuCss?" "+t.config.menuCss:""),_key:e,_hooks:{didInsert:function(o){var r=o.el.getBoundingClientRect(),s=r.width,a=r.height,l=t._isContextMenu&&t._activePosition&&e===i?t._activePosition:n.$position,u=t._getMode(n,i,l===t._activePosition),d=c.calculatePosition(l,{mode:u,width:s,height:a});n.$style=d,o.patch({style:d})},didRecycle:function(o,r){if(t._isContextMenu&&t._activePosition&&e===i){var s=r.el.getBoundingClientRect(),a=s.width,l=s.height,u=c.calculatePosition(t._activePosition,{mode:t._getMode(n,i,!0),width:a,height:l});n.$style=u,r.patch({style:u})}}},tabindex:0,style:n.$style||{position:"absolute"}},t._drawMenuItems(e))}).reverse()},e.prototype._onMenuItemClick=function(t,e){var i=this.data.getItem(t);i.disabled||(i.twoState&&this.data.update(i.id,{active:!i.active}),this.events.fire(h.NavigationBarEvents.click,[t,e]),this._close(e))},e.prototype._activeItemChange=function(t,e){var i=this;if(this._activeParents){var n=this._getParents(t,this._currentRoot);this._activeParents.forEach(function(t){i.data.exists(t)&&-1===n.indexOf(t)&&i.data.update(t,{$activeParent:!1},!1)})}t&&!this._documentHaveListener&&this._listenOuterClick(),t&&this.data.haveItems(t)?(this._activeMenu===t&&this._popupActive||this.events.fire(h.NavigationBarEvents.openMenu,[t]),this._activeMenu=t,clearTimeout(this._currentTimeout),this.paint()):(clearTimeout(this._currentTimeout),this._currentTimeout=setTimeout(function(){return i.paint()},400))},e.prototype._resetHotkeys=function(){var t=this;l.keyManager.removeHotKey(null,this),this.data.map(function(e){e.hotkey&&l.keyManager.addHotKey(e.hotkey,function(){return t._onMenuItemClick(e.id,null)},t)})},e.prototype._setProp=function(t,e,i){var n,o=this;Array.isArray(t)?t.forEach(function(t){var n;return o.data.update(t,((n={})[e]=i,n))}):this.data.update(t,((n={})[e]=i,n))},e}(u.View);e.Navbar=f},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(111),o=i(112),r=i(113),s=i(114),a=i(115),c=i(116),l=i(117),u=i(118),d=i(119),h=i(23),f=i(24);e.createFactory=function(t){for(var e=t.defaultType,i=t.allowedTypes,p=t.widgetName,_=t.widget,v=new Set,g=0,m=i;g<m.length;g++){var y=m[g];v.add(y)}var b=_.config,x=_.events,w=_.data;return function(t,i){if(t.hidden)return null;if(!(t.type&&"button"!==t.type&&"navItem"!==t.type&&"menuItem"!==t.type||t.value||t.icon||t.html))return null;t.type=t.type||e,v&&!v.has(t.type)&&(t.type=e),t.type===h.ItemType.imageButton&&"ribbon"!==p&&(t.active=!1),i&&t.type!==h.ItemType.spacer&&t.type!==h.ItemType.separator&&t.type!==h.ItemType.customHTML&&(t.type=h.ItemType.menuItem),w.haveItems(t.id)&&function(t,e,i){switch(t){case"sidebar":case"context-menu":e.$openIcon="right";break;case"toolbar":e.parent===i.getRoot()?e.$openIcon="right":e.$openIcon="bot";break;case"menu":e.parent!==this.data.getRoot()&&(e.$openIcon="right");break;case"ribbon":var n=i.getItem(e.parent);n&&e.type!==h.ItemType.block&&(n.type===h.ItemType.block?e.$openIcon="bot":e.$openIcon="right")}}(p,t,w);var _=t.type!==h.ItemType.customHTML&&function(t,e,i,f){switch(t.type){case h.ItemType.navItem:case h.ItemType.selectButton:return o.navItem(t,i,f.collapsed);case h.ItemType.button:return n.button(t,i);case h.ItemType.title:return d.title(t,i);case h.ItemType.separator:return l.separator(t,i);case h.ItemType.spacer:return u.spacer(t,i);case h.ItemType.input:return a.input(t,e,i);case h.ItemType.imageButton:return s.imageButton(t,i);case h.ItemType.menuItem:return c.menuItem(t,i,f.asMenuItem);case h.ItemType.customHTMLButton:return r.customHTMLButton(t,i,f.asMenuItem);case h.ItemType.block:default:throw new Error("unknown item type "+t.type)}}(t,x,p,{asMenuItem:i,collapsed:"sidebar"!==p||b.collapsed});return f.navbarComponentMixin(p,t,i,_)}}},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(0),o=i(24);e.button=function(t,e){var i=t.icon&&!t.value,r=i?" dhx_navbar-count--absolute":" dhx_navbar-count--button-inline";return n.el("button.dhx_button",{class:o.getNavbarButtonCSS(t,e),dhx_id:t.id,disabled:t.disabled,type:"button"},[t.icon?o.getIcon(t.icon,"button"):null,t.html?n.el("div.dhx_button__text",{".innerHTML":t.html}):t.value&&n.el("span.dhx_button__text",t.value),t.count>0&&o.getCount(t,r,i),t.value&&t.$openIcon?n.el("span.dhx_button__icon.dhx_button__icon--menu.dxi.dxi-menu-right"):null,t.loading&&n.el("span.dhx_button__loading",[n.el("span.dhx_button__loading-icon.dxi.dxi-loading")])])}},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(0),o=i(24);e.navItem=function(t,e,i){var r=" dhx_"+e+"-button";return n.el("button",{class:"dhx_button"+r+(t.active||t.$activeParent?r+"--active":"")+(t.disabled?r+"--disabled":"")+(t.$openIcon?r+"--select":"")+(t.circle?r+"--circle":"")+(t.size?" "+r+"--"+t.size:"")+(!t.value&&t.icon?r+"--icon":"")+(t.css?" "+t.css:""),dhx_id:t.id,disabled:t.disabled,type:"button"},[t.icon&&n.el("span",{class:t.icon+r+"__icon"}),t.html&&n.el("div",{class:r.trim()+"__html",".innerHTML":t.html}),!t.html&&t.value&&n.el("span",{class:r.trim()+"__text"},t.value),t.count>0&&o.getCount(t,r+"__count",i),t.$openIcon&&n.el("span.dxi.dxi-menu-right",{class:r+"__caret"})])}},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(0);e.customHTMLButton=function(t,e,i){var o=i?" dhx_button dhx_menu-button":" dhx_button dhx_nav-menu-button";return n.el("button",{class:"dhx_custom-button"+o+(t.$activeParent?o+"--active":""),dhx_id:t.id,type:"button",".innerHTML":t.html},t.html?"":t.value)}},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(0),o=i(24);e.imageButton=function(t,e){var i="dhx_"+e+"-button-image",r="ribbon"===e;return n.el("button.dhx_button",{class:i+(t.size?" "+i+"--"+t.size:"")+(!t.value&&t.src?" "+i+"--icon":"")+(r&&t.$openIcon?" "+i+"--select":"")+(t.active?" "+i+"--active":""),dhx_id:t.id,type:"button"},[r&&t.value&&t.$openIcon&&n.el("span.dxi.dxi-menu-right",{class:i+"__caret"}),t.html?n.el("div",{class:i+"__text",".innerHTML":t.html}):t.value&&n.el("span",{class:i+"__text"},t.value),t.src&&n.el("span",{class:i+"__image",style:{backgroundImage:"url("+t.src+")"}}),t.count>0&&o.getCount(t,i+"__count",!0)])}},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(0),o=i(23);function r(t,e){t.fire(o.NavigationBarEvents.inputBlur,[e])}function s(t,e){t.fire(o.NavigationBarEvents.inputFocus,[e])}e.input=function(t,e,i){return n.el(".dhx_form-group.dhx_form-group--no-message-holder.dhx_form-group--label_sr.dhx_"+i+"__input",{style:{width:t.width?t.width:"200px"}},[n.el("label.dhx_label",{for:t.id},t.label),n.el(".dhx_input__wrapper",[n.el("input.dhx_input",{placeholder:t.placeholder,class:t.icon?"dhx_input--icon-padding":"",value:t.value,onblur:[r,e,t.id],onfocus:[s,e,t.id],dhx_id:t.id,_hooks:{didInsert:function(i){e&&e.fire(o.NavigationBarEvents.inputCreated,[t.id,i.el])}},_key:t.id}),t.icon?n.el(".dhx_input__icon",{class:t.icon}):null])])}},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(0),o=i(24);e.menuItem=function(t,e,i){var r=i?" dhx_menu-button":" dhx_nav-menu-button";return n.el("button",{class:"dhx_button"+r+(t.disabled?r+"--disabled":"")+(t.$activeParent?r+"--active":""),disabled:t.disabled,dhx_id:t.id,type:"button"},i?[t.icon||t.value||t.html?n.el("span.dhx_menu-button__block.dhx_menu-button__block--left",[t.icon&&n.el("span.dhx_menu-button__icon",{class:t.icon}),t.html?n.el("div.dhx_menu-button__text",{".innerHTML":t.html}):t.value&&n.el("span.dhx_menu-button__text",t.value)]):null,t.count>0||t.hotkey||t.items?n.el("span.dhx_menu-button__block.dhx_menu-button__block--right",[t.count>0&&o.getCount(t," dhx_menu-button__count",!1),t.hotkey&&n.el("span.dhx_menu-button__hotkey",t.hotkey),t.items&&n.el("span.dhx_menu-button__caret.dxi.dxi-menu-right")]):null]:[t.icon&&n.el("span.dhx_menu-button__icon",{class:t.icon}),t.html?n.el("div.dhx_menu-button__text",{".innerHTML":t.html}):t.value&&n.el("span.dhx_nav-menu-button__text",t.value)])}},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.separator=function(t,e){return null}},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.spacer=function(t,e){return null}},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(0);e.title=function(t,e){return n.el("span",{class:"dhx_navbar-title dhx_navbar-title--"+e,".innerHTML":t.html},t.html?null:t.value)}},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.layoutConfig={css:"vault-layout",rows:[{id:"topbar",css:"vault-topbar"},{id:"vault",css:"vault-file-grid"}]},e.layoutConfigWithoutTopbar={css:"vault-layout",rows:[{id:"vault",css:"vault-file-grid"}]}},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(37),o=["byte","kilobyte","megabyte","gigabyte"];e.getBasis=function(t,e){return void 0===t&&(t=0),void 0===e&&(e=0),t<1024?t+" "+n.default[o[e]]:this.getBasis(Math.round(t/1024),e+1)};var r,s=13;function a(t){return{extension:t.name.split(".").pop()||"none",mime:t.file?t.file.type:""}}function c(t,e){switch(t){case"jpg":case"jpeg":case"gif":case"png":case"bmp":case"tiff":case"pcx":case"svg":case"ico":return r.image;case"avi":case"mpg":case"mpeg":case"rm":case"move":case"mov":case"mkv":case"flv":case"f4v":case"mp4":case"3gp":case"wmv":case"webm":case"vob":return r.video;case"rar":case"zip":case"tar":case"tgz":case"arj":case"gzip":case"bzip2":case"7z":case"ace":case"apk":case"deb":case"zipx":case"cab":case"tar-gz":case"rpm":case"xar":return r.archive;case"xlr":case"xls":case"xlsm":case"xlsx":case"ods":case"csv":case"tsv":return r.table;case"doc":case"docx":case"docm":case"dot":case"dotx":case"odt":case"wpd":case"wps":case"pages":return r.document;case"wav":case"aiff":case"au":case"mp3":case"aac":case"wma":case"ogg":case"flac":case"ape":case"wv":case"m4a":case"mid":case"midi":return r.audio;case"pot":case"potm":case"potx":case"pps":case"ppsm":case"ppsx":case"ppt":case"pptx":case"pptm":case"odp":return r.presentation;case"html":case"htm":case"eml":return r.web;case"exe":return r.application;case"dmg":return r.apple;case"pdf":case"ps":case"eps":return r.pdf;case"psd":return r.psd;case"txt":case"djvu":case"nfo":case"xml":return r.text;default:switch(e.split("/")[0]){case"image":return r.image;case"audio":return r.audio;case"video":return r.video;default:return r.other}}}e.truncateWord=function(t,e){var i,n;if(void 0===e&&(e=s),t.length<=e)return t;var o=t.lastIndexOf(".");if(-1===o)n=t.substr(t.length-4),i=t.substr(0,e-7);else{var r=o-3;n=t.substr(r),i=t.substr(0,e-(t.length-r))}return i+"..."+n},e.calculateCover=function(t){var e,i,n,o,r=t.width,s=t.height,a=r/s;return a>1?(e=s,n=(r-(i=s))/2,o=0):a<1?(i=r,n=0,o=(s-(e=r))/2):(e=r,i=r,n=0,o=0),{sx:n,sy:o,sWidth:i,sHeight:e,dx:0,dy:0}},function(t){t.image="image",t.video="video",t.archive="archive",t.table="table",t.document="document",t.presentation="presentation",t.application="application",t.web="web",t.apple="apple",t.pdf="pdf",t.psd="psd",t.audio="audio",t.other="other",t.text="text"}(r=e.FileType||(e.FileType={})),e.getFileType=c,e.getFileClassName=function(t){var e=a(t),i=e.mime,n=e.extension;return c(n,i)+" extension-"+n},e.isImage=function(t){var e=a(t),i=e.mime;return c(e.extension,i)===r.image}},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}();Object.defineProperty(e,"__esModule",{value:!0});var o=i(0),r=i(4),s=i(37),a=i(27),c=function(t){function e(e,i){var n=t.call(this,null,i)||this;n.events=e,n._progress=0;return n.mount(null,o.create({render:function(){return n._draw()}})),n._abortUpload=function(){n.events.fire(a.ProgressBarEvents.cancel)},n}return n(e,t),e.prototype.setState=function(t,e){this._progress=t,this.config.template?this._progressText=this.config.template(t,e):this._progressText=this._progress.toFixed(1)+"%",this.paint()},e.prototype._draw=function(){return o.el(".progress-bar",{_key:this._uid},[o.el(".progress-indicator",{style:{width:this._progress+"%"}}),o.el(".progress-text",{".innerHTML":this._progressText}),o.el("button",{class:"dhx_btn dhx_btn--flat dhx_btn_small action-abort-all",onclick:this._abortUpload},s.default.cancel)])},e}(r.View);e.ProgressBar=c},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=function(){function t(t){this._readerStack=[],this._isActive=!1,this._data=t}return t.prototype.add=function(t,e){void 0===e&&(e=!1),this._readerStack.push(t),e||this.read()},t.prototype.read=function(){var t=this;if(this._readerStack.length&&!this._isActive){var e=this._readerStack.shift();this._isActive=!0;var i=new FileReader;i.readAsDataURL(e.file),i.onload=function(i){var n=new Image;n.src=i.target.result,n.onload=function(){t._data.exists(e.id)&&t._data.update(e.id,{image:n}),t._isActive=!1,t.read()}},i.onerror=function(){t._isActive=!1,t.read()}}},t.prototype.stop=function(){this._readerStack=[]},t}();e.ReadStackPreview=n},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),o=this&&this.__assign||function(){return(o=Object.assign||function(t){for(var e,i=1,n=arguments.length;i<n;i++)for(var o in e=arguments[i])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)};Object.defineProperty(e,"__esModule",{value:!0});var r=i(1),s=i(7),a=i(0),c=i(3),l=i(13),u=i(22),d=i(4),h=i(63),f=i(2),p=i(39),_=i(125),v=i(127),g=function(t){function e(e,i){void 0===i&&(i={});var n=t.call(this,e,r.extend({itemHeight:i.virtual?37:i.itemHeight||null,keyNavigation:!1,multiselectionMode:i.multiselectionMode?i.multiselectionMode:"click",editable:!1},i))||this;"ctrlClick"===n.config.multiselectionMode&&(n.config.multiselection="ctrlClick"),n.config.editable=n.config.editable||n.config.editing,Array.isArray(n.config.data)?(n.events=new c.EventSystem(n),n.data=new s.DataCollection({},n.events),n.data.parse(n.config.data)):n.config.data&&n.config.data.events?(n.data=n.config.data,n.events=n.data.events,n.events.context=n):(n.events=new c.EventSystem(n),n.data=new s.DataCollection({},n.events)),n.selection=new h.Selection({multiselection:n.config.multiselection},n.data),n._getHotkeys();var l=function(t){return function(e,i){i&&i instanceof Array?i.map(function(e){return n.data.exists(e)&&n.data.update(e,t)}):n.data.exists(e)&&n.data.update(e,t)}};n.events.on(s.DataEvents.change,function(){n.paint()}),n.events.on(s.DataEvents.load,function(){n.config.virtual&&n._updateVirtual(0),n.data.map(function(t){t.$selected&&(n.selection.add(t.id),n.events.fire(p.ListEvents.click,[t.id,null]))})}),n.events.on(s.DragEvents.canDrop,l({$drophere:!0})),n.events.on(s.DragEvents.cancelDrop,l({$drophere:void 0})),n.events.on(s.DragEvents.dragStart,l({$dragtarget:!0})),n.events.on(s.DragEvents.dragEnd,l({$dragtarget:void 0})),n.events.on(p.ListEvents.afterEditEnd,function(t,e){var i=n.data.getItem(e);n.data.update(e,o(o({},i),{value:t})),n._edited=null,n._getHotkeys(),n.paint()}),n.selection.events.on(u.SelectionEvents.afterSelect,function(t){t&&n.setFocus(t)}),n._handlers={onmousedown:function(t){var e=[],i=f.locateNode(t,"dhx_id"),o=i&&i.getAttribute("dhx_id"),r=n.selection.getId();return n.config.multiselection&&r instanceof Array&&r.map(function(t){t!==o&&e.push(n.getRootView().refs[t].el)}),n.config.dragMode&&!n._edited?s.dragManager.onMouseDown(t,n.selection.getId(),e):null},ondragstart:function(){return!(n.config.dragMode&&!n._edited)&&null},oncontextmenu:function(t){var e=f.locate(t);e&&(n.events.fire(p.ListEvents.itemRightClick,[e,t]),n.events.fire(p.ListEvents.contextmenu,[e,t]))},onclick:function(t){var e=f.locate(t);e&&(n.selection.add(e,t.ctrlKey||t.metaKey,t.shiftKey),n.events.fire(p.ListEvents.click,[e,t]))},ondblclick:function(t){var e=f.locate(t);e&&(n.config.editable&&n.editItem(e),n.events.fire(p.ListEvents.doubleClick,[e,t]))},onscroll:function(t){n.config.virtual&&(n._lazyLoad(t),n._updateVirtual(t.target.scrollTop))},onmouseover:function(t){var e=f.locate(t),i=f.locateNode(t,"dhx_id","relatedTarget");if(i||!e){if(i){var o=i.getAttribute("dhx_id")?i.getAttribute("dhx_id"):null;e&&e!==(o||"")&&n.events.fire(p.ListEvents.itemMouseOver,[e,t])}}else n.events.fire(p.ListEvents.itemMouseOver,[e,t])}},n.config.dragMode&&s.dragManager.setItem(n._uid,n),n.config.virtual&&(n._range=[0,0],n._topOffset=0);var d=a.create({render:function(){return n.config.virtual?n._renderVirtualList():n._renderList()},hooks:{didMount:function(t){if(!n.config.height){var e=t.node.el;n.config.height=e&&e.parentNode&&e.parentNode.offsetHeight||200}n.config.virtual&&(n._visibleHeight=n.config.height,n._updateVirtual(0)),n.paint()}}});return n.mount(e,d),n}return n(e,t),e.prototype.editItem=function(t){this._edited=t,this.data.getItem(this._edited)&&this.events.fire(p.ListEvents.beforeEditStart,[t])?(this._getHotkeys(),this.paint(),this.events.fire(p.ListEvents.afterEditStart,[t])):this._edited=null},e.prototype.getFocusItem=function(){return this.data.getItem(this.data.getId(this._focusIndex))},e.prototype.setFocus=function(t){var e=this.data.getIndex(t);this._setFocusIndex(e)},e.prototype.getFocus=function(){var t=this.data.getId(this._focusIndex);if(t)return t},e.prototype.destructor=function(){this._navigationDestructor&&this._navigationDestructor(),this._documentClickDestuctor&&this._documentClickDestuctor(),this.unmount()},e.prototype.getFocusIndex=function(){return this._focusIndex},e.prototype.setFocusIndex=function(t){this._setFocusIndex(t)},e.prototype.edit=function(t){this.editItem(t)},e.prototype._renderItem=function(t,e){var i=this.config.template&&this.config.template(t)||t.html,n=e===this._focusIndex;return t.id===this._edited?_.getEditor(t,this).toHTML():i?this._renderAsHtml(i,t,n):this._renderAsValue(t,n)},e.prototype._renderAsHtml=function(t,e,i){var n=this.config.itemHeight;return a.el("li",{class:"dhx_list-item"+(e.$selected?" dhx_list-item--selected":"")+(i?" dhx_list-item--focus":"")+(e.$drophere&&!this._edited?" dhx_list-item--drophere":"")+(e.$dragtarget&&!this._edited?" dhx_list-item--dragtarget":"")+(this.config.dragMode&&!this._edited?" dhx_list-item--drag":"")+(e.css?" "+e.css:""),dhx_id:e.id,_ref:e.id,style:{height:n},_key:e.id,".innerHTML":t})},e.prototype._renderAsValue=function(t,e){var i=this.config.itemHeight;return a.el("li",{class:"dhx_list-item dhx_list-item--text"+(t.$selected?" dhx_list-item--selected":"")+(e?" dhx_list-item--focus":"")+(t.$drophere&&!this._edited?" dhx_list-item--drophere":"")+(t.$dragtarget&&!this._edited?" dhx_list-item--dragtarget":"")+(this.config.dragMode&&!this._edited?" dhx_list-item--drag":"")+(t.css?" "+t.css:""),dhx_id:t.id,_ref:t.id,style:{height:i},_key:t.id},t.text||t.value)},e.prototype._renderList=function(){var t=this,e=this.data.map(function(e,i){return t._renderItem(e,i)});return a.el("ul.dhx_widget.dhx_list",o({style:{"min-height":this.config.itemHeight,"max-height":this.config.height,position:"relative"},class:this.config.css+(this.config.multiselection&&this.selection.getItem()?" dhx_no-select--pointer":""),dhx_widget_id:this._uid},this._handlers),e)},e.prototype._renderVirtualList=function(){var t=this,e=this.data.mapRange(this._range[0],this._range[1],function(e,i){return t._renderItem(e,i)});return a.el(".dhx_widget.dhx_virtual-list-wrapper",o({dhx_widget_id:this._uid,style:{"min-height":this.config.itemHeight,"max-height":this._visibleHeight}},this._handlers),[a.el("ul.dhx_list.dhx_list--virtual",{class:this.config.css+(this.config.multiselection&&this.selection.getItem()?" dhx_no-select--pointer":""),style:{height:this._getHeight()+v.defineUnit(this.config.itemHeight),"padding-top":this._topOffset}},e)])},e.prototype._setFocusIndex=function(t){if(!(t<0||t>this.data.getLength()-1)){this._focusIndex=t;var e=this.getRootView();if(e&&e.node&&e.node.el){var i=this.getRootNode();if(i){if(this.config.virtual){var n=t*v.defineValue(this.config.itemHeight);(n>=v.defineValue(this._visibleHeight)+this._topOffset||n<this._topOffset)&&i.scrollTo(0,n)}else{var o=i.children[t];if(!o)return;o.offsetTop>=i.scrollTop+i.clientHeight-o.clientHeight?i.scrollTop=o.offsetTop-i.clientHeight+o.clientHeight:o.offsetTop<i.scrollTop&&(i.scrollTop=o.offsetTop)}this.events.fire(p.ListEvents.focusChange,[this._focusIndex,this.data.getId(this._focusIndex)]),this.paint()}}}},e.prototype._updateVirtual=function(t){var e=this._getHeight();t>e-v.defineValue(this._visibleHeight)&&(t=e-v.defineValue(this._visibleHeight));var i=Math.floor(v.defineValue(this._visibleHeight)/v.defineValue(this.config.itemHeight))+5,n=Math.floor(t/v.defineValue(this.config.itemHeight));this._range=[n,i+n],this._topOffset=t,this.paint()},e.prototype._getHeight=function(){return this.data.getLength()*v.defineValue(this.config.itemHeight)},e.prototype._getHotkeys=function(){var t=this;if(this.config.keyNavigation)if(this._edited)this._navigationDestructor&&this._navigationDestructor();else{var e=this.config.keyNavigation;"function"!=typeof this.config.keyNavigation&&(this._widgetInFocus=!1,e=function(){return t._widgetInFocus},this._documentClickDestuctor=r.detectWidgetClick(this._uid,function(e){return t._widgetInFocus=e}));var i=function(t){return function(e){e.preventDefault(),t()}},n={arrowDown:i(function(){return t.setFocusIndex(t._focusIndex+1)}),arrowUp:i(function(){return t.setFocusIndex(t._focusIndex-1)}),enter:function(e){var i=t.data.getId(t._focusIndex);t.selection.add(i),t.events.fire(p.ListEvents.click,[i,e])},"enter+shift":function(e){var i=t.data.getId(t._focusIndex);t.selection.add(i,!1,!0),t.events.fire(p.ListEvents.click,[i,e])},"enter+ctrl":function(e){var i=t.data.getId(t._focusIndex);t.selection.add(i,!0,!1),t.events.fire(p.ListEvents.click,[i,e])}};f.isIE()&&(delete(n=o({up:n.arrowUp,down:n.arrowDown},n)).arrowUp,delete n.arrowDown),this._navigationDestructor=l.addHotkeys(n,e)}},e.prototype._lazyLoad=function(t){var e=t.target.scrollTop,i=Math.round(e/v.defineValue(this.config.itemHeight)),n=this._container.clientHeight/v.defineValue(this.config.itemHeight),o=this.data.dataProxy;o&&o.config&&!this.data.isDataLoaded(i,n+i+o.config.prepare)&&(o.updateUrl(null,{from:i,limit:o.config.limit}),this.data.load(o))},e}(d.View);e.List=g},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(126);e.getEditor=function(t,e){return new n.InputEditor(t,e)}},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(0),o=i(39),r=function(){function t(t,e){var i=this;this._list=e,this._config=e.config,this._item=t,this._list.events.on(o.ListEvents.focusChange,function(t,e){i._mode&&e!==i._item.id&&i.endEdit()}),this._initHandlers()}return t.prototype.endEdit=function(){if(this._input){var t=this._input.value;this._list.events.fire(o.ListEvents.beforeEditEnd,[t,this._item.id])?(this._input.removeEventListener("blur",this._handlers.onBlur),this._input.removeEventListener("change",this._handlers.onChange),this._handlers={},this._mode=!1,this._list.events.fire(o.ListEvents.afterEditEnd,[t,this._item.id])):this._input.focus()}},t.prototype.toHTML=function(){this._mode=!0;var t=this._config.itemHeight;return n.el(".dhx_input__wrapper",{},[n.el("div.dhx_input__container",{},[n.el("input.dhx_input",{class:this._item.css?" "+this._item.css:"",style:{height:t,width:"100%",padding:"8px, 12px"},_hooks:{didInsert:this._handlers.didInsert},_key:this._item.id,dhx_id:this._item.id})])])},t.prototype._initHandlers=function(){var t=this;this._handlers={onBlur:function(){t.endEdit()},onChange:function(){t.endEdit()},didInsert:function(e){var i=e.el;t._input=i,i.focus(),i.value=t._item.value,i.setSelectionRange(0,i.value.length),i.addEventListener("change",t._handlers.onChange),i.addEventListener("blur",t._handlers.onBlur)}}},t}();e.InputEditor=r},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.defineValue=function(t){if(t){var e=t.toString().trim();if(-1===e.indexOf("calc"))return parseInt(e.split(/\D+/g)[0],null)}},e.defineUnit=function(t){if(t){var e=t.toString().trim();if(-1===e.indexOf("calc"))return e.slice(e.split(/\D+/g)[0].length)}}},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),o=this&&this.__assign||function(){return(o=Object.assign||function(t){for(var e,i=1,n=arguments.length;i<n;i++)for(var o in e=arguments[i])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)},r=this&&this.__spreadArrays||function(){for(var t=0,e=0,i=arguments.length;e<i;e++)t+=arguments[e].length;var n=Array(t),o=0;for(e=0;e<i;e++)for(var r=arguments[e],s=0,a=r.length;s<a;s++,o++)n[o]=r[s];return n};Object.defineProperty(e,"__esModule",{value:!0});var s=i(1),a=i(0),c=i(3),l=i(4),u=i(30),d=i(133),h=i(41),f=i(134),p=i(42),_=i(68),v=function(t){function e(e,i){void 0===i&&(i={});var n=t.call(this,e,s.extend({weekStart:"sunday",thisMonthOnly:!1,dateFormat:window&&window.dhx&&window.dhx.dateFormat,width:"250px"},i))||this;switch(n._selected=[],n.events=new c.EventSystem,n.config.disabledDates=n.config.disabledDates||n.config.block,n.config.mode=n.config.mode||n.config.view,n.config.dateFormat||(n.config.timePicker?12===n.config.timeFormat?n.config.dateFormat="%d/%m/%y %h:%i %A":n.config.dateFormat="%d/%m/%y %H:%i":n.config.dateFormat="%d/%m/%y"),n.config.value&&n._setSelected(n.config.value),n.config.date?n._currentDate=d.DateHelper.toDateObject(n.config.date,n.config.dateFormat):n._getSelected()?n._currentDate=d.DateHelper.copy(n._getSelected()):n._currentDate=new Date,n.config.mode){case _.ViewMode.months:n._currentViewMode=_.ViewMode.months;break;case _.ViewMode.years:n._currentViewMode=_.ViewMode.years;break;default:n._currentViewMode=_.ViewMode.calendar}if(n._initHandlers(),n.config.timePicker){n._timepicker=new u.Timepicker(null,{timeFormat:n.config.timeFormat,controls:!0});var o=n._getSelected()||new Date;n._timepicker.setValue(o),n._time=n._timepicker.getValue(),n._timepicker.events.on(u.TimepickerEvents.afterClose,function(){n._timepicker.setValue(n._time),n.showDate(null,_.ViewMode.calendar)}),n._timepicker.events.on(u.TimepickerEvents.apply,function(){var t=n._timepicker.getValue(!0),e=t.hour,i=t.minute,o=t.AM,r=n._getSelected(),s=d.DateHelper.withHoursAndMinutes(n._getSelected()||new Date,e,i,o);n.events.fire(_.CalendarEvents.beforeChange,[s,r,!0])&&(n._selected[n._selected.length-1]=s,n.events.fire(_.CalendarEvents.change,[s,r,!0])),n._time=n._timepicker.getValue(),n.showDate(null,_.ViewMode.calendar)})}return n.mount(e,a.create({render:function(){return n._draw()}})),n}return n(e,t),e.prototype.setValue=function(t){if(!t||t instanceof Array&&0===t.length)return!1;this._selected=[];var e=t instanceof Array?t[0]:t,i=d.DateHelper.toDateObject(e,this.config.dateFormat),n=d.DateHelper.copy(this._getSelected());return!!this.events.fire(_.CalendarEvents.beforeChange,[i,n,!1])&&(this._setSelected(t),this._timepicker&&(this._timepicker.setValue(i),this._time=this._timepicker.getValue()),this.showDate(this._getSelected()),this.events.fire(_.CalendarEvents.change,[i,n,!1]),this.paint(),!0)},e.prototype.getValue=function(t){var e=this;return this._selected[0]?this.config.range?t?this._selected.map(function(t){return d.DateHelper.copy(t)}):this._selected.map(function(t){return h.getFormatedDate(e.config.dateFormat,t)}):t?d.DateHelper.copy(this._selected[0]):h.getFormatedDate(this.config.dateFormat,this._selected[0]):""},e.prototype.getCurrentMode=function(){return this._currentViewMode},e.prototype.showDate=function(t,e){t&&(this._currentDate=d.DateHelper.copy(t)),e&&(this._currentViewMode=e),this.paint()},e.prototype.destructor=function(){this._linkedCalendar&&this._unlink(),this._timepicker&&this._timepicker.destructor(),this.unmount()},e.prototype.clear=function(){this.config.timePicker&&(this._timepicker.clear(),this._time=this._timepicker.getValue()),this._selected=[],this.showDate(null,this.config.mode)},e.prototype.link=function(t){var e=this;this._linkedCalendar&&this._unlink(),this._linkedCalendar=t;var i=this.getValue(!0),n=t.getValue(!0),o=i&&d.DateHelper.dayStart(i),r=n&&d.DateHelper.dayStart(n),s=function(t){if(d.DateHelper.isSameDay(r,o))return null;var e="dhx_calendar-day--in-range";return d.DateHelper.isSameDay(t,o)&&(e+=" dhx_calendar-day--first-date"),d.DateHelper.isSameDay(t,r)&&(e+=" dhx_calendar-day--last-date"),e};this.config.$rangeMark&&this._linkedCalendar.config.$rangeMark||(this.config.$rangeMark=this._linkedCalendar.config.$rangeMark=function(t){if(o&&r)return t>=o&&t<=r&&s(t)}),this.config.disabledDates&&this._linkedCalendar.config.disabledDates||(this.config.disabledDates=function(t){if(r)return t>r},this._linkedCalendar.config.disabledDates=function(t){if(o)return t<o}),this.config.thisMonthOnly=!0,t.config.thisMonthOnly=!0,this.events.on(_.CalendarEvents.change,function(t){o=d.DateHelper.dayStart(t),e._linkedCalendar.paint()},"link"),this._linkedCalendar.events.on(_.CalendarEvents.change,function(t){r=d.DateHelper.dayStart(t),e.paint()},"link"),this._linkedCalendar.paint(),this.paint()},e.prototype._unlink=function(){this._linkedCalendar&&(this.config.$rangeMark=this._linkedCalendar.config.$rangeMark=null,this.config.disabledDates=this._linkedCalendar.config.disabledDates=null,this.events.detach(_.CalendarEvents.change,"link"),this._linkedCalendar.events.detach(_.CalendarEvents.change,"link"),this._linkedCalendar.paint(),this.paint(),this._linkedCalendar=null)},e.prototype._setSelected=function(t){var e=this,i=t instanceof Array?t[0]:t,n=d.DateHelper.toDateObject(i,this.config.dateFormat);if(t instanceof Array&&this.config.range){var o=[];t.forEach(function(t,i){i<2&&o.push(d.DateHelper.toDateObject(t,e.config.dateFormat))}),2===o.length&&o[0]<o[1]?o.forEach(function(t){return e._selected.push(t)}):this._selected[0]=o[0]}else this._selected[0]=n},e.prototype._getSelected=function(){return this._selected[this._selected.length-1]},e.prototype._draw=function(){switch(this._currentViewMode){case _.ViewMode.calendar:return this.events.fire(_.CalendarEvents.modeChange,[_.ViewMode.calendar]),this._drawCalendar();case _.ViewMode.months:return this.events.fire(_.CalendarEvents.modeChange,[_.ViewMode.months]),this._drawMonthSelector();case _.ViewMode.years:return this.events.fire(_.CalendarEvents.modeChange,[_.ViewMode.years]),this._drawYearSelector();case _.ViewMode.timepicker:return this.events.fire(_.CalendarEvents.modeChange,[_.ViewMode.timepicker]),this._drawTimepicker()}},e.prototype._initHandlers=function(){var t=this;this._handlers={onclick:{".dhx_calendar-year, .dhx_calendar-month, .dhx_calendar-day":function(e,i){var n=i.attrs._date,o=d.DateHelper.copy(t._getSelected());switch(t._currentViewMode){case _.ViewMode.calendar:var r=t.config.timePicker?d.DateHelper.mergeHoursAndMinutes(n,t._getSelected()||t._currentDate):n;if(!t.events.fire(_.CalendarEvents.beforeChange,[r,o,!0]))return;t.config.range&&1===t._selected.length&&t._selected[0]<r?t._selected.push(r):(t._selected=[],t._selected[0]=r),t.showDate(t._getSelected()),t.events.fire(_.CalendarEvents.change,[n,o,!0]);break;case _.ViewMode.months:if(t.config.mode!==_.ViewMode.months)d.DateHelper.setMonth(t._currentDate,n),t.showDate(null,_.ViewMode.calendar),t.events.fire(_.CalendarEvents.monthSelected,[n]);else{var s=d.DateHelper.fromYearAndMonth(t._currentDate.getFullYear()||t._getSelected().getFullYear(),n);if(!t.events.fire(_.CalendarEvents.beforeChange,[s,o,!0]))return;t._currentDate=s,t._selected[0]=s,t.events.fire(_.CalendarEvents.change,[t._getSelected(),o,!0]),t.events.fire(_.CalendarEvents.monthSelected,[n]),t.paint()}break;case _.ViewMode.years:if(t.config.mode!==_.ViewMode.years)d.DateHelper.setYear(t._currentDate,n),t.showDate(null,_.ViewMode.months),t.events.fire(_.CalendarEvents.yearSelected,[n]);else{s=d.DateHelper.fromYear(n);if(!t.events.fire(_.CalendarEvents.beforeChange,[s,o,!0]))return;t._currentDate=s,t._selected[0]=s,t.events.fire(_.CalendarEvents.change,[t._getSelected(),o,!0]),t.events.fire(_.CalendarEvents.yearSelected,[n]),t.paint()}}},".dhx_calendar-action__cancel":function(){t.showDate(t._getSelected(),_.ViewMode.calendar),t.events.fire(_.CalendarEvents.cancelClick,[])},".dhx_calendar-action__show-month":function(){return t.showDate(null,_.ViewMode.months)},".dhx_calendar-action__show-year":function(){return t.showDate(null,_.ViewMode.years)},".dhx_calendar-action__next":function(){var e;switch(t._currentViewMode){case _.ViewMode.calendar:e=d.DateHelper.addMonth(t._currentDate,1);break;case _.ViewMode.months:e=d.DateHelper.addYear(t._currentDate,1);break;case _.ViewMode.years:e=d.DateHelper.addYear(t._currentDate,12)}t.showDate(e)},".dhx_calendar-action__prev":function(){var e;switch(t._currentViewMode){case _.ViewMode.calendar:e=d.DateHelper.addMonth(t._currentDate,-1);break;case _.ViewMode.months:e=d.DateHelper.addYear(t._currentDate,-1);break;case _.ViewMode.years:e=d.DateHelper.addYear(t._currentDate,-12)}t.showDate(e)},".dhx_calendar-action__show-timepicker":function(){t._currentViewMode=_.ViewMode.timepicker,t.paint()}},onmouseover:{".dhx_calendar-day":function(e,i){t.events.fire(_.CalendarEvents.dateMouseOver,[new Date(i.attrs._date),e]),t.events.fire(_.CalendarEvents.dateHover,[new Date(i.attrs._date),e])}}}},e.prototype._getData=function(t){for(var e=this,i="monday"===this.config.weekStart?1:0,n=[],o=6,r=d.DateHelper.weekStart(d.DateHelper.monthStart(t),i);o--;){for(var s=d.DateHelper.getWeekNumber(r),a=0,c=7,l=[],u=function(){var i=d.DateHelper.isWeekEnd(r),n=t.getMonth()===r.getMonth(),o=h.config.disabledDates&&h.config.disabledDates(r),s=[];if(h.config.range&&h._selected[0]&&h._selected[1]){var c=function(){if(e._selected[0]&&e._selected[1]){var t=d.DateHelper.dayStart(e._selected[0]),i=d.DateHelper.dayStart(e._selected[1]);return r>=t&&r<=i&&u()}},u=function(){return d.DateHelper.isSameDay(e._selected[0],e._selected[1])?null:"dhx_calendar-day--in-range"};h.config.$rangeMark=c}if(i&&n&&s.push("dhx_calendar-day--weekend"),n||(h.config.thisMonthOnly?(a++,s.push("dhx_calendar-day--hidden")):s.push("dhx_calendar-day--muffled")),h.config.mark){var f=h.config.mark(r);f&&s.push(f)}h.config.$rangeMark&&((c=h.config.$rangeMark(r))&&s.push(c));o&&(i?s.push("dhx_calendar-day--weekend-disabled"):s.push("dhx_calendar-day--disabled")),h._selected.forEach(function(t,i){if(t&&d.DateHelper.isSameDay(t,r)){var n="dhx_calendar-day--selected";e.config.range&&(n+=" dhx_calendar-day--selected-"+(0===i?"first ":"last")),s.push(n)}}),l.push({date:r,day:r.getDate(),css:s.join(" ")}),r=d.DateHelper.addDay(r)},h=this;c--;)u();n.push({weekNumber:s,days:l,disabledWeekNumber:7===a})}return n},e.prototype._drawCalendar=function(){for(var t,e=this._currentDate,i=this.config,n=i.weekStart,s=i.thisMonthOnly,c=i.css,l=i.timePicker,u=i.width,d=("monday"===n?r(p.default.daysShort.slice(1),[p.default.daysShort[0]]):p.default.daysShort).map(function(t){return a.el(".dhx_calendar-weekday",t)}),h=[],f=[],_=0,v=this._getData(e);_<v.length;_++){var g=v[_],m=g.days.map(function(t){return a.el("div.dhx_calendar-day",{class:t.css,_date:t.date,tabIndex:1},t.day)});!this.config.weekNumbers||g.disabledWeekNumber&&s||f.push(a.el("div",{class:"dhx_calendar-week-number"},g.weekNumber)),h=h.concat(m)}this.config.weekNumbers&&(t=a.el(".dhx_calendar__week-numbers",f));var y="dhx_calendar dhx_widget"+(c?" "+c:"")+(l?" dhx_calendar--with_timepicker":"")+(this.config.weekNumbers?" dhx_calendar--with_week-numbers":"");return a.el("div",o({class:y,style:{width:this.config.weekNumbers?"calc("+u+" + 48px )":u}},this._handlers),[a.el(".dhx_calendar__wrapper",[this._drawHeader(a.el("button.dhx_calendar-action__show-month.dhx_button.dhx_button--view_link.dhx_button--size_small.dhx_button--color_secondary.dhx_button--circle",p.default.months[e.getMonth()]+" "+e.getFullYear())),this.config.weekNumbers&&a.el(".dhx_calendar__dates-wrapper",[a.el(".dhx_calendar__weekdays",d),a.el(".dhx_calendar__days",h),t]),!this.config.weekNumbers&&a.el(".dhx_calendar__weekdays",d),!this.config.weekNumbers&&a.el(".dhx_calendar__days",h),l?a.el(".dhx_timepicker__actions",[a.el("button.dhx_calendar__timepicker-button.dhx_button.dhx_button--view_link.dhx_button--size_small.dhx_button--color_secondary.dhx_button--width_full.dhx_button--circle.dhx_calendar-action__show-timepicker",[a.el("span.dhx_button__icon.dxi.dxi-clock-outline"),a.el("span.dhx_button__text",this._time)])]):null])])},e.prototype._drawMonthSelector=function(){var t=this._currentDate,e=t.getMonth(),i=this._getSelected()?this._getSelected().getFullYear():null,n=this.config,r=n.css,s=n.timePicker,c=n.weekNumbers,l=n.width,u=n.mode,d="dhx_calendar dhx_widget"+(r?" "+r:"")+(s?" dhx_calendar--with_timepicker":"")+(c?" dhx_calendar--with_week-numbers":"");return a.el("div",o({class:d,style:{width:c?"calc("+l+" + 48px)":l}},this._handlers),[a.el(".dhx_calendar__wrapper",[this._drawHeader(a.el("button.dhx_calendar-action__show-year.dhx_button.dhx_button--view_link.dhx_button--size_small.dhx_button--color_secondary.dhx_button--circle",t.getFullYear())),a.el(".dhx_calendar__months",p.default.monthsShort.map(function(n,o){return a.el("div",{class:"dhx_calendar-month"+(e===o&&i===t.getFullYear()?" dhx_calendar-month--selected":""),tabIndex:1,_date:o},n)})),u!==_.ViewMode.months?a.el(".dhx_calendar__actions",[a.el("button.dhx_button.dhx_button--color_primary.dhx_button--view_link.dhx_button--size_small.dhx_button--width_full.dhx_button--circle.dhx_calendar-action__cancel",p.default.cancel)]):null])])},e.prototype._drawYearSelector=function(){var t=this,e=this._currentDate,i=d.DateHelper.getTwelweYears(e),n=this.config,r=n.css,s=n.timePicker,c=n.weekNumbers,l=n.width,u=n.mode,h="dhx_calendar dhx_widget"+(r?" "+r:"")+(s?" dhx_calendar--with_timepicker":"")+(c?" dhx_calendar--with_week-numbers":"");return a.el("div",o({class:h,style:{width:c?"calc("+l+" + 48px)":l}},this._handlers),[a.el(".dhx_calendar__wrapper",[this._drawHeader(a.el("button.dhx_button.dhx_button--view_link.dhx_button--size_small.dhx_button--color_secondary.dhx_button--circle",i[0]+"-"+i[i.length-1])),a.el(".dhx_calendar__years",i.map(function(e){return a.el("div",{class:"dhx_calendar-year"+(t._getSelected()&&e===t._getSelected().getFullYear()?" dhx_calendar-year--selected":""),_date:e,tabIndex:1},e)})),u!==_.ViewMode.years&&u!==_.ViewMode.months?a.el(".dhx_calendar__actions",[a.el("button.dhx_button.dhx_button--color_primary.dhx_button--view_link.dhx_button--size_small.dhx_button--width_full.dhx_button--circle.dhx_calendar-action__cancel",p.default.cancel)]):null])])},e.prototype._drawHeader=function(t){return a.el(".dhx_calendar__navigation",[a.el("button.dhx_calendar-navigation__button.dhx_calendar-action__prev"+f.linkButtonClasses+".dhx_button--icon.dhx_button--circle",[a.el(".dhx_button__icon.dxi.dxi-chevron-left")]),t,a.el("button.dhx_calendar-navigation__button.dhx_calendar-action__next"+f.linkButtonClasses+".dhx_button--icon.dhx_button--circle",[a.el(".dhx_button__icon.dxi.dxi-chevron-right")])])},e.prototype._drawTimepicker=function(){var t=this.config,e=t.css,i=t.weekNumbers,n=t.width;return a.el(".dhx_widget.dhx-calendar",{class:e?" "+e:"",style:{width:i?"calc("+n+" + 48px)":n}},[a.inject(this._timepicker.getRootView())])},e}(l.View);e.Calendar=v},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),o=this&&this.__assign||function(){return(o=Object.assign||function(t){for(var e,i=1,n=arguments.length;i<n;i++)for(var o in e=arguments[i])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)};Object.defineProperty(e,"__esModule",{value:!0});var r=i(1),s=i(0),a=i(3),c=i(4),l=i(14),u=i(40),d=i(66),h=i(132),f=i(67),p=function(t){function e(e,i){void 0===i&&(i={});var n=t.call(this,e,r.extend({timeFormat:24,controls:!1,actions:!1},i))||this;return n.events=new a.EventSystem(n),n._time={hour:0,minute:0,AM:!0},12===n.config.timeFormat&&(n._time.hour=12),n.config.controls=n.config.controls||n.config.actions,n._initUI(e),n._initHandlers(),n._initEvents(),n}return n(e,t),e.prototype.getValue=function(t){var e=this._time,i=e.hour,n=e.minute,o=e.AM;if(t){var r={hour:i,minute:n};return 12===this.config.timeFormat&&(r.AM=o),r}return(i<10?"0"+i:i)+":"+(n<10?"0"+n:n)+(12===this.config.timeFormat?o?"AM":"PM":"")},e.prototype.setValue=function(t){var e,i,n;if("number"==typeof t&&(t=new Date(t)),t instanceof Date)e=t.getMinutes(),i=t.getHours();else if(Array.isArray(t))i=_(t[0],23),e=_(t[1],59),t[2]&&"pm"===t[2].toLowerCase()&&(n=!0);else{var o=t.match(/\d+/g);i=_(+o[0],23),e=_(+o[1],59),-1!==t.toLowerCase().indexOf("pm")&&(n=!0)}n&&i<12&&(i+=12),this._hoursSlider.setValue(i),this._minutesSlider.setValue(e),h.isTimeCheck(t)&&(this._hoursSlider.setValue(0),this._minutesSlider.setValue(e),this._time.AM=!0),this._inputsView.paint()},e.prototype.clear=function(){24===this.config.timeFormat?this.setValue("00:00"):this.setValue("12:00AM")},e.prototype.destructor=function(){this._minutesSlider.destructor(),this._hoursSlider.destructor(),this.events.clear(),this.unmount()},e.prototype.getRootView=function(){return this.layout.getRootView()},e.prototype._initUI=function(t){var e=this,i={gravity:!1,css:"dhx_widget dhx_timepicker "+(this.config.css?this.config.css:"")+(this.config.controls?" dhx_timepicker--with-controls":""),rows:[{id:"timepicker",css:"dhx_timepicker__inputs"},{id:"hour-slider",css:"dhx_timepicker__hour"},{id:"minute-slider",css:"dhx_timepicker__minute"}]};this.config.controls&&(i.rows.unshift({id:"close-action",css:"dhx_timepicker__close"}),i.rows.push({id:"save-action",css:"dhx_timepicker__save"}));var n=this.layout=new l.Layout(t,i),o=s.create({render:function(){return e._draw()}}),r=this._inputsView=c.toViewLike(o),a=this._minutesSlider=new u.Slider(null,{min:0,max:59,step:1,tooltip:!1,labelPosition:"top",label:d.default.minutes}),h=this._hoursSlider=new u.Slider(null,{min:0,max:23,step:1,tooltip:!1,labelPosition:"top",label:d.default.hours});if(n.getCell("timepicker").attach(r),n.getCell("hour-slider").attach(h),n.getCell("minute-slider").attach(a),this.config.controls){n.getCell("save-action").attach(function(){return s.el("button.dhx_timepicker__button-save.dhx_button.dhx_button--view_flat.dhx_button--color_primary.dhx_button--size_medium.dhx_button--circle.dhx_button--width_full",{onclick:e._outerHandlers.save},d.default.save)}),n.getCell("close-action").attach(function(){return s.el("button.dhx_timepicker__button-close.dhx_button.dhx_button--view_link.dhx_button--size_medium.dhx_button--view_link.dhx_button--color_secondary.dhx_button--icon.dhx_button--circle",{onclick:e._outerHandlers.close},[s.el("span.dhx_button__icon.dxi.dxi-close")])})}},e.prototype._initHandlers=function(){var t=this;this._handlers={onchange:{".dhx_timepicker-input--hour":function(e){var i=_(parseInt(e.target.value,10),23);e.target.value=i,t._hoursSlider.setValue(i)},".dhx_timepicker-input--minutes":function(e){var i=_(parseInt(e.target.value,10),59);e.target.value=i,t._minutesSlider.setValue(i)}}},this._outerHandlers={close:function(){t.events.fire(f.TimepickerEvents.beforeClose,[])&&(t.events.fire(f.TimepickerEvents.afterClose,[]),t.events.fire(f.TimepickerEvents.close,[]))},save:function(){t.events.fire(f.TimepickerEvents.apply,[t._time]),t.events.fire(f.TimepickerEvents.save,[t._time])}}},e.prototype._initEvents=function(){var t=this;this._hoursSlider.events.on(u.SliderEvents.change,function(e){e<t._hoursSlider.config.min||e>t._hoursSlider.config.max||(12===t.config.timeFormat?(t._time.AM=e<12,t._time.hour=e%12||12):t._time.hour=e,t.events.fire(f.TimepickerEvents.change,[t.getValue()]),t._inputsView.paint())}),this._minutesSlider.events.on(u.SliderEvents.change,function(e){e<t._minutesSlider.config.min||e>t._minutesSlider.config.max||(t._time.minute=e,t.events.fire(f.TimepickerEvents.change,[t.getValue()]),t._inputsView.paint())})},e.prototype._draw=function(){return s.el(".dhx_timepicker-inputs",o({},this._handlers),[s.el("input.dhx_timepicker-input.dhx_timepicker-input--hour",{_key:"hour",value:this._time.hour<10?"0"+this._time.hour:this._time.hour}),s.el("span.dhx_timepicker-delimer",":"),s.el("input.dhx_timepicker-input.dhx_timepicker-input--minutes",{_key:"minute",value:this._time.minute<10?"0"+this._time.minute:this._time.minute}),12===this.config.timeFormat?s.el(".dhx_timepicker-ampm",this._time.AM?"AM":"PM"):null])},e}(c.View);function _(t,e){return isNaN(t)?0:Math.min(e,Math.max(0,t))}e.Timepicker=p},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}();Object.defineProperty(e,"__esModule",{value:!0});var o=i(1),r=i(0),s=i(3),a=i(13),c=i(4),l=i(11),u=i(65);function d(t,e,i){return t<e?e:t>i?i:t}var h=function(t){function e(e,i){var n=t.call(this,e,o.extend({mode:u.Direction.horizontal,min:0,max:100,step:1,tooltip:!0},i))||this;n._disabled=!1,n.config.helpMessage=n.config.helpMessage||n.config.help,void 0!==n.config.thumbLabel&&(n.config.tooltip=n.config.thumbLabel),n.config.labelInline&&(n.config.labelPosition="left"),n.events=new s.EventSystem(n),n._axis=n.config.mode===u.Direction.horizontal?"clientX":"clientY",n._initStartPosition(),n._initHotkeys();var a=r.create({render:function(){return n._draw()},hooks:{didMount:function(){return n._calcSliderPosition()},didRedraw:function(){return n._calcSliderPosition()}}});return n._initHandlers(),n.mount(e,a),n}return n(e,t),e.prototype.disable=function(){this._disabled=!0,this.paint()},e.prototype.enable=function(){this._disabled=!1,this.paint()},e.prototype.isDisabled=function(){return this._disabled},e.prototype.focus=function(t){this.getRootView().refs[t?"extraRunner":"runner"].el.focus()},e.prototype.getValue=function(){var t;if(this.config.range){var e=this._getValue(this._currentPosition),i=this._getValue(this._extraCurrentPosition);t=e<i?[e,i]:[i,e]}else t=[this._getValue(this._currentPosition)];return t},e.prototype.setValue=function(t){var e=this._getValue(this._currentPosition);if(Array.isArray(t)&&t.length>1){var i=this._getValue(this._extraCurrentPosition);this._setValue(t[0],!1),this.events.fire(u.SliderEvents.change,[t[0],e,!1]),this._setValue(t[1],!0),this.events.fire(u.SliderEvents.change,[t[1],i,!0])}else{if(t=parseFloat(t),isNaN(t))throw new Error("Wrong value type, for more info check documentation https://docs.dhtmlx.com/suite/slider__api__slider_setvalue_method.html");this._setValue(t),this.events.fire(u.SliderEvents.change,[t,e,!1])}this.paint()},e.prototype.destructor=function(){this._hotkeysDestructor(),this.unmount()},e.prototype._calcSliderPosition=function(){var t=this.getRootView();if(t){var e=t.refs.track.el.getBoundingClientRect();this._offsets={left:e.left+window.pageXOffset,top:e.top+window.pageYOffset},this._length=this.config.mode===u.Direction.horizontal?e.width:e.height}},e.prototype._initHotkeys=function(){var t=this;this._hotkeysDestructor=a.addHotkeys({arrowleft:function(e){t.config.mode!==u.Direction.vertical&&(e.preventDefault(),t._move(-t.config.step,e.target.classList.contains("dhx_slider__thumb--extra")))},arrowright:function(e){t.config.mode!==u.Direction.vertical&&(e.preventDefault(),t._move(t.config.step,e.target.classList.contains("dhx_slider__thumb--extra")))},arrowup:function(e){t.config.mode!==u.Direction.horizontal&&(e.preventDefault(),t._move(t.config.step,e.target.classList.contains("dhx_slider__thumb--extra")))},arrowdown:function(e){t.config.mode!==u.Direction.horizontal&&(e.preventDefault(),t._move(-t.config.step,e.target.classList.contains("dhx_slider__thumb--extra")))}},function(){var e=document.activeElement,i=t.getRootView().refs;if(!i)return!1;var n=i.runner;return!(!n||n.el!==e)||!(!t.config.range||!i.extraRunner||i.extraRunner.el!==e)})},e.prototype._move=function(t,e){this.config.inverse&&(t=-t);var i=this.config,n=i.max,o=i.min,r=e?this._getValue(this._extraCurrentPosition):this._getValue(this._currentPosition),s=r+t;this._setValue(r+t,e),(s>n||s<o)&&(s=r),this.events.fire(u.SliderEvents.change,[s,r,e]),this.paint()},e.prototype._initStartPosition=function(){var t=this.config,e=t.max,i=t.min,n=t.range,o=function(t,e,i){var n;return(n=void 0===t?[]:Array.isArray(t)?t:"string"==typeof t?t.split(",").map(function(t){return parseInt(t,10)}):[t])[0]=void 0===n[0]?e:d(n[0],e,i),n[1]=void 0===n[1]?i:d(n[1],e,i),n}(this.config.value,this.config.min,this.config.max),r=o[0],s=o[1];this._currentPosition=(r-i)/(e-i)*100,n&&(this._extraCurrentPosition=(e-s)/(e-i)*100),this._currentPosition=(r-i)/(e-i)*100,n&&(this._extraCurrentPosition=(s-i)/(e-i)*100),this._isInverse()&&(this._currentPosition=100-this._currentPosition,n&&(this._extraCurrentPosition=100-this._extraCurrentPosition))},e.prototype._getValue=function(t){this._isInverse()&&(t=100-t);var e=this.config,i=e.min,n=e.max,o=e.step;if(100===t)return n;if(0===t)return i;var r=t*(n-i)/100,s=r%o,a=s>=o/2?o:0;return+(Number(i)+Number(r)-s+a).toFixed(5)},e.prototype._setValue=function(t,e){void 0===e&&(e=!1);var i=this.config,n=i.max,o=i.min;if(t>n||t<o)return!1;var r=(t-o)/(n-o)*100,s=this._isInverse()?100-r:r;e?this._extraCurrentPosition=s:this._currentPosition=s},e.prototype._initHandlers=function(){var t=this,e=function(e){e.preventDefault();var i=(e[t._axis]-t._getBegining())/t._length*100;if(t._findNewDirection){if(Math.abs(t._currentPosition-i)<1)return;i>t._currentPosition?t._possibleRange=[t._currentPosition,100]:t._possibleRange=[0,t._currentPosition],t._findNewDirection=null}t._inSide(i)&&t._updatePosition(i,t._isExtraActive),t.paint()},i=function(n){t.events.fire(u.SliderEvents.mouseup,[n]),setTimeout(function(){t._isMouseMoving=!1,t.paint()},4),document.removeEventListener("mouseup",i),document.removeEventListener("mousemove",e)};this.config.helpMessage&&(this._helper=new l.Popup({css:"dhx_tooltip dhx_tooltip--forced dhx_tooltip--light"}),this._helper.attachHTML(this.config.helpMessage)),this._handlers={showHelper:function(e){e.preventDefault(),e.stopPropagation(),t._helper.show(e.target)},onmousedown:function(n){if(!t._disabled&&3!==n.which){var o;if(t.events.fire(u.SliderEvents.mousedown,[n]),t._isMouseMoving=!0,n.target.classList.contains("dhx_slider__thumb--extra")?(t._isExtraActive=!0,o=t._extraCurrentPosition):(t._isExtraActive=!1,o=t._currentPosition),t._findNewDirection=null,t.config.range){var r=t._currentPosition>t._extraCurrentPosition?[t._currentPosition,t._extraCurrentPosition]:[t._extraCurrentPosition,t._currentPosition],s=r[0],a=r[1];t._currentPosition===t._extraCurrentPosition?(t._findNewDirection=o,t._possibleRange=[0,100]):t._possibleRange=o<s?[0,s]:[a,100]}else t._possibleRange=[0,100];document.addEventListener("mousemove",e),document.addEventListener("mouseup",i)}},onlabelClick:function(){t.getRootView().refs.runner.el.focus()},onclick:function(e){if(!t._disabled&&!t._isMouseMoving&&3!==e.which){var i=(e[t._axis]-t._getBegining())/t._length*100,n=t.getRootView().refs;if(t.config.range)Math.abs(t._currentPosition-i)<Math.abs(t._extraCurrentPosition-i)?(t._updatePosition(i,!1),n.runner.el.focus()):(t._updatePosition(i,!0),n.extraRunner.el.focus());else t._updatePosition(i,!1),n.runner.el.focus();t.paint()}},onmouseover:function(){t._mouseIn=!0,t.paint()},onmouseout:function(){t._mouseIn=!1,t.paint()},onfocus:function(){t._focusIn=!0,t.paint()},onblur:function(){t._focusIn=!1,t.paint()}}},e.prototype._getBegining=function(){return this.config.mode===u.Direction.horizontal?this._offsets.left-window.pageXOffset:this._offsets.top-window.pageYOffset},e.prototype._inSide=function(t){var e=this._possibleRange;return t<e[0]?(this._updatePosition(e[0],this._isExtraActive),!1):!(t>e[1])||(this._updatePosition(e[1],this._isExtraActive),!1)},e.prototype._updatePosition=function(t,e){void 0===e&&(e=!1),t>100&&(t=100),t<0&&(t=0);var i=this.config,n=i.max,o=i.min,r=e?this._extraCurrentPosition:this._currentPosition,s=this._getValue(r),a=this._getValue(t);if(s!==a){var c=(a-o)/(n-o)*100,l=this._isInverse()?100-c:c;e?this._extraCurrentPosition=l:this._currentPosition=l,this.events.fire(u.SliderEvents.change,[a,s,e])}},e.prototype._getRunnerStyle=function(t){var e;void 0===t&&(t=!1);var i=this.config.mode===u.Direction.horizontal?"left":"top",n=t?this._extraCurrentPosition:this._currentPosition;return(e={})[i]=n+"%",e},e.prototype._isInverse=function(){return this.config.inverse&&this.config.mode===u.Direction.horizontal||!this.config.inverse&&this.config.mode===u.Direction.vertical},e.prototype._getRunnerCss=function(t){return void 0===t&&(t=!1),"dhx_slider__thumb"+(t?" dhx_slider__thumb--extra":"")+(this._isMouseMoving&&(t&&this._isExtraActive||!t&&!this._isExtraActive)?" dhx_slider__thumb--active":"")+(this._disabled?" dhx_slider__thumb--disabled":"")+(this._isNullable(t?this._extraCurrentPosition:this._currentPosition)&&!this.config.range?" dhx_slider__thumb--nullable":"")},e.prototype._draw=function(){var t=this.config,e=t.labelPosition,i=t.labelWidth,n=t.mode,o=t.label,s=t.hiddenLabel,a=t.tick,c=t.majorTick,l=t.css,u=t.helpMessage,d="left"===e&&i?i:"";return r.el("div",{class:"dhx_slider dhx_slider--mode_"+n+(o&&"left"===e?" dhx_slider--label-inline":"")+(s?" dhx_slider--label_sr":"")+(a?" dhx_slider--ticks":"")+(c?" dhx_slider--major-ticks":"")+(l?" "+l:"")+(this._disabled?" dhx_slider--disabled":"")},[o?r.el("label.dhx_label.dhx_slider__label",{style:{minWidth:d,maxWidth:d},class:u?"dhx_label--with-help":"",onclick:this._handlers.onlabelClick},u?[r.el("span.dhx_label__holder",o),r.el("span.dhx_label-help.dxi.dxi-help-circle-outline",{tabindex:"0",role:"button",onclick:this._handlers.showHelper})]:o):null,this._drawSlider()])},e.prototype._drawSlider=function(){return r.el(".dhx_widget.dhx_slider__track-holder",{dhx_widget_id:this._uid},[r.el(".dhx_slider__track",{_ref:"track",onmouseover:this._handlers.onmouseover,onmouseout:this._handlers.onmouseout,onclick:this._handlers.onclick},[this._getDetector(),r.el("div",{_ref:"runner",class:this._getRunnerCss(),onmousedown:this._handlers.onmousedown,onmousemove:this._handlers.onmousemove,onfocus:this._handlers.onfocus,onblur:this._handlers.onblur,style:this._getRunnerStyle(),tabindex:0}),this.config.tooltip&&(this._mouseIn||this._focusIn||this._isMouseMoving)?this._drawTooltip():null,this.config.tooltip&&this.config.range&&(this._mouseIn||this._focusIn||this._isMouseMoving)?this._drawTooltip(!0):null,this.config.range?r.el("div",{_ref:"extraRunner",class:this._getRunnerCss(!0),onmousedown:this._handlers.onmousedown,onmousemove:this._handlers.onmousemove,onfocus:this._handlers.onfocus,onblur:this._handlers.onblur,style:this._getRunnerStyle(!0),tabindex:0}):null]),this.config.tick?this._drawTicks():null])},e.prototype._getDetector=function(){var t,e,i;if(this._disabled)return r.el(".dhx_slider__range");var n=this.config.mode===u.Direction.horizontal?"left":"top",o=this.config.mode===u.Direction.horizontal?"width":"height";if(this.config.range){var s=this._currentPosition>this._extraCurrentPosition?[this._currentPosition,this._extraCurrentPosition]:[this._extraCurrentPosition,this._currentPosition],a=s[0],c=s[1];return r.el(".dhx_slider__range",{style:(t={},t[n]=c+"%",t[o]=a-c+"%",t)})}return this._isInverse()?r.el(".dhx_slider__range",{style:(e={},e[n]=this._currentPosition+"%",e[o]=100-this._currentPosition+"%",e)}):r.el(".dhx_slider__range",{style:(i={},i[n]=0,i[o]=this._currentPosition+"%",i)})},e.prototype._drawTooltip=function(t){var e;void 0===t&&(t=!1);var i=t?this._extraCurrentPosition:this._currentPosition,n=this.config.mode===u.Direction.horizontal?"left":"top",o=this.config.mode===u.Direction.horizontal?".dhx_slider__thumb-label--horizontal":".dhx_slider__thumb-label--vertical";(t&&this._isExtraActive||!t&&!this._isExtraActive)&&(o+=".dhx_slider__thumb-label--active");var s=((e={})[n]=i+"%",e);return r.el(".dhx_slider__thumb-label"+o,{style:s},this._getValue(i))},e.prototype._getTicks=function(){for(var t=this.config,e=t.max,i=t.min,n=t.step,o=t.tick,r=t.majorTick,s=e-i,a=n*o/s,c=[],l=0,u=0;l<1;){var d=+(Number(i)+l*s).toFixed(5),h=u%r==0;c.push({position:(this._isInverse()?100*(1-l):100*l)+"%",isMultiple:h,label:h&&"function"==typeof this.config.tickTemplate?this.config.tickTemplate(d):null}),l+=a,u++}return c.push({position:(this._isInverse()?0:100)+"%",isMultiple:!0,label:"function"==typeof this.config.tickTemplate?this.config.tickTemplate(e):null}),c},e.prototype._drawTicks=function(){var t=this.config.mode===u.Direction.horizontal?"left":"top";return r.el(".dhx_slider__ticks-holder",this._getTicks().map(function(e){var i;return r.el("div",{class:"dhx_slider__tick"+(e.isMultiple?" dhx_slider__tick--major":""),style:(i={},i[t]=e.position,i)},void 0!==e.label?[r.el(".dhx_slider__tick-label",e.label)]:null)}))},e.prototype._isNullable=function(t){return this._isInverse()?100===t:0===t},e}(c.View);e.Slider=h},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),o=this&&this.__assign||function(){return(o=Object.assign||function(t){for(var e,i=1,n=arguments.length;i<n;i++)for(var o in e=arguments[i])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)};Object.defineProperty(e,"__esModule",{value:!0});var r=i(1),s=i(0),a=i(3),c=i(2),l=i(4),u=i(64),d=function(t){function e(e){void 0===e&&(e={});var i=t.call(this,null,r.extend({},e))||this,n=i._popup=document.createElement("div");return n.className="dhx_widget dhx_popup"+(i.config.css?" "+i.config.css:""),n.style.position="absolute",i.mount(n,s.create({render:function(){return i.toVDOM()}})),i._clickEvent=function(t){return i.events.fire(u.PopupEvents.click,[t])},i.events=e.events||new a.EventSystem(i),i._isActive=!1,i}return n(e,t),e.prototype.show=function(t,e,i){var n=this;void 0===e&&(e={}),this.events.fire(u.PopupEvents.beforeShow,[t])&&(t=c.toNode(t),this._isActive?this._setPopupSize(t,e):(i&&this.attach(i),this._popup.style.left="0",this._popup.style.top="0",document.body.appendChild(this._popup),this._setPopupSize(t,e),this._isActive=!0,s.awaitRedraw().then(function(){n.events.fire(u.PopupEvents.afterShow,[t]),n._outerClickDestructor=n._detectOuterClick(t)})))},e.prototype.hide=function(){this._hide(!1,null)},e.prototype.isVisible=function(){return this._isActive},e.prototype.attach=function(t,e){return this._html=null,"object"==typeof t?this._ui=t:"string"==typeof t?this._ui=new window.dhx[t](null,e):"function"==typeof t&&(t.prototype instanceof l.View?this._ui=new t(null,e):this._ui={getRootView:function(){return t(e)}}),this.paint(),this._ui},e.prototype.attachHTML=function(t){this._html=t,this.paint()},e.prototype.getWidget=function(){return this._ui},e.prototype.getContainer=function(){return this.getRootView().refs.content.el},e.prototype.toVDOM=function(){var t;return this._html?t=s.el(".dhx_popup__inner-html-content",{".innerHTML":this._html}):(t=this._ui?this._ui.getRootView():null)&&t.render&&(t=s.inject(t)),s.el("div",{class:"dhx_popup-content",onclick:this._clickEvent,_key:this._uid,_ref:"content"},[t])},e.prototype.destructor=function(){this.hide(),this._outerClickDestructor&&this._outerClickDestructor(),this._popup=null},e.prototype._setPopupSize=function(t,e,i){var n=this;void 0===i&&(i=3);var r=this._popup.getBoundingClientRect(),s=r.width,a=r.height;if(this._timeout&&(clearTimeout(this._timeout),this._timeout=null),!i||0!==s&&0!==a){var l=c.fitPosition(t,o(o({centering:!0,mode:c.Position.bottom},e),{width:s,height:a})),u=l.left,d=l.top;if(this._popup.style.left=u,this._popup.style.top=d,e.indent&&0!==e.indent)switch(e.mode){case c.Position.top:this._popup.style.top=parseInt(this._popup.style.top.slice(0,-2),null)-parseInt(e.indent.toString(),null)+"px";break;case c.Position.bottom:this._popup.style.top=parseInt(this._popup.style.top.slice(0,-2),null)+parseInt(e.indent.toString(),null)+"px";break;case c.Position.left:this._popup.style.left=parseInt(this._popup.style.left.slice(0,-2),null)-parseInt(e.indent.toString(),null)+"px";break;case c.Position.right:this._popup.style.left=parseInt(this._popup.style.left.slice(0,-2),null)+parseInt(e.indent.toString(),null)+"px";break;default:this._popup.style.top=parseInt(this._popup.style.top.slice(0,-2),null)+parseInt(e.indent.toString(),null)+"px"}}else this._timeout=setTimeout(function(){n._isActive&&(n._setPopupSize(t,e,i-1),n._timeout=null)})},e.prototype._detectOuterClick=function(t){var e=this,i=function(n){for(var o=n.target;o;){if(o===t||o===e._popup)return;o=o.parentNode}e._hide(!0,n)&&document.removeEventListener("click",i)};return document.addEventListener("click",i),function(){return document.removeEventListener("click",i)}},e.prototype._hide=function(t,e){if(this._isActive)return!!this.events.fire(u.PopupEvents.beforeHide,[t,e])&&(document.body.removeChild(this._popup),this._isActive=!1,this._outerClickDestructor&&(this._outerClickDestructor(),this._outerClickDestructor=null),this.events.fire(u.PopupEvents.afterHide,[e]),!0)},e}(l.View);e.Popup=d},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.isTimeCheck=function(t){return/(^12:[0-5][0-9]?AM$)/i.test(t)}},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(1),o=i(41),r=function(){function t(){}return t.copy=function(t){return new Date(t)},t.fromYear=function(t){return new Date(t,0,1)},t.fromYearAndMonth=function(t,e){return new Date(t,e,1)},t.weekStart=function(t,e){var i=(t.getDay()+7-e)%7;return new Date(t.getFullYear(),t.getMonth(),t.getDate()-i)},t.monthStart=function(t){return new Date(t.getFullYear(),t.getMonth(),1)},t.yearStart=function(t){return new Date(t.getFullYear(),0,1)},t.dayStart=function(t){return new Date(t.getFullYear(),t.getMonth(),t.getDate())},t.addDay=function(t,e){return void 0===e&&(e=1),new Date(t.getFullYear(),t.getMonth(),t.getDate()+e)},t.addMonth=function(t,e){return void 0===e&&(e=1),new Date(t.getFullYear(),t.getMonth()+e)},t.addYear=function(t,e){return void 0===e&&(e=1),new Date(t.getFullYear()+e,t.getMonth())},t.withHoursAndMinutes=function(t,e,i,n){return void 0===n||!n&&12===e||n&&12!==e?new Date(t.getFullYear(),t.getMonth(),t.getDate(),e,i):n&&12===e?new Date(t.getFullYear(),t.getMonth(),t.getDate(),0,i):new Date(t.getFullYear(),t.getMonth(),t.getDate(),e+12,i)},t.setMonth=function(t,e){t.setMonth(e)},t.setYear=function(t,e){t.setFullYear(e)},t.mergeHoursAndMinutes=function(t,e){return new Date(t.getFullYear(),t.getMonth(),t.getDate(),e.getHours(),e.getMinutes())},t.isWeekEnd=function(t){return 0===t.getDay()||6===t.getDay()},t.getTwelweYears=function(t){var e=t.getFullYear(),i=e-e%12;return n.range(i,i+11)},t.getWeekNumber=function(e){6!==e.getDay()&&(e=t.addDay(e,6-e.getDay()));var i=(e.valueOf()-t.yearStart(e).valueOf())/864e5;return Math.floor((i-e.getDay()+10)/7)},t.isSameDay=function(t,e){return t.getFullYear()===e.getFullYear()&&t.getMonth()===e.getMonth()&&t.getDate()===e.getDate()},t.toDateObject=function(t,e){return"string"==typeof t?o.stringToDate(t,e):new Date(t)},t.nullTimestampDate=new Date(0),t}();e.DateHelper=r},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.linkButtonClasses=".dhx_button.dhx_button--view_link.dhx_button--icon.dhx_button--size_medium.dhx_button--color_secondary"},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),o=this&&this.__spreadArrays||function(){for(var t=0,e=0,i=arguments.length;e<i;e++)t+=arguments[e].length;var n=Array(t),o=0;for(e=0;e<i;e++)for(var r=arguments[e],s=0,a=r.length;s<a;s++,o++)n[o]=r[s];return n};Object.defineProperty(e,"__esModule",{value:!0});var r=i(0),s=i(3),a=i(2),c=i(4),l=i(1),u=i(43),d=i(136),h=i(44),f=i(69),p=i(62),_=i(19),v=i(137),g=i(138),m=function(t){function e(e,i){var n=t.call(this,e,i)||this;n._setPaletteGrip=function(t){var e=n.getRootView().refs.picker_palette.el.getBoundingClientRect(),i=t.clientY-e.top,o=t.clientX-e.left,r=g.calculatePaletteGrip(e,i,o),s=r.s,a=r.v;n._pickerState.hsv.s=s,n._pickerState.hsv.v=a,n.paint()},n._setRangeGrip=function(t){var e=n.getRootView().refs.hue_range.el.getBoundingClientRect(),i=t.clientX-e.left,o=g.calculateRangeGrip(e,i),r=o.h,s=o.rangeLeft;n._pickerState.hsv.h=r,n._pickerState.rangeLeft=s,n.paint()},n._onColorClick=function(t,e){n._selected=e.data.color.toUpperCase(),n.events.fire(f.ColorpickerEvents.change,[n._selected]),n.events.fire(f.ColorpickerEvents.colorChange,[n._selected])},n._container=e,n.config=l.extend({css:"",grayShades:!0,pickerOnly:!1,paletteOnly:!1,customColors:[],palette:d.palette,width:"238px",mode:f.ViewsMode.palette},n.config),n.config.palette||(n.config.palette=d.palette),n.config.customColors&&(n.config.customColors=n.config.customColors.map(function(t){return t.toUpperCase()})),n._pickerState={hsv:{h:0,s:1,v:1},customHex:""},n.events=new s.EventSystem(n),n._setHandlers();var o=r.create({render:function(){return n._getContent()}});return n.mount(n._container,o),n}return n(e,t),e.prototype.destructor=function(){this.unmount()},e.prototype.clear=function(){this._selected="",this.paint()},e.prototype.setValue=function(t){this._focusColor(t)&&(this.paint(),this.events.fire(f.ColorpickerEvents.change,[this._selected]),this.events.fire(f.ColorpickerEvents.colorChange,[this._selected]))},e.prototype.setFocus=function(t){this._focusColor(t)&&this.paint()},e.prototype.getValue=function(){return this._selected||""},e.prototype.getCustomColors=function(){return this.config.customColors},e.prototype.setCustomColors=function(t){this.config.customColors=t.map(function(t){return t.toUpperCase()}),this.paint()},e.prototype.setCurrentMode=function(t){f.ViewsMode[t]&&(this.config.mode=t,this.events.fire(f.ColorpickerEvents.modeChange,[t]),this.events.fire(f.ColorpickerEvents.viewChange,[t]),this.paint())},e.prototype.getCurrentMode=function(){return this.config.mode},e.prototype.getView=function(){return this.getCurrentMode()},e.prototype.setView=function(t){this.setCurrentMode(t)},e.prototype.focusValue=function(t){this.setFocus(t)},e.prototype._setHandlers=function(){var t=this;this._handlers={click:{".dhx_palette__cell":this._onColorClick},mousedown:function(e){var i=a.locate(e);t._pickerState.customHex="","picker_palette"===i?t._setPaletteGrip(e):t._setRangeGrip(e);var n="picker_palette"===i?t._setPaletteGrip:t._setRangeGrip;document.addEventListener("mousemove",n),document.addEventListener("mouseup",function(){document.removeEventListener("mousemove",n)}),t.paint()},buttonsClick:function(e){t.setCurrentMode(f.ViewsMode.palette),"cancel"!==e?"apply"===e&&-1===t.config.customColors.indexOf(t._pickerState.background)&&(t.setValue(t._pickerState.background),t.events.fire(f.ColorpickerEvents.apply,[]),t.events.fire(f.ColorpickerEvents.selectClick,[])):t.events.fire(f.ColorpickerEvents.cancelClick,[])},customColorClick:function(){t.setView(f.ViewsMode.picker)},oninput:function(e){t._inputTimeout&&clearTimeout(t._inputTimeout),t._inputTimeout=setTimeout(function(){var i=e.target.value;-1===i.indexOf("#")&&(i="#"+i),t._pickerState.customHex=i,u.isHex(i)&&(t._pickerState.hsv=u.HexToHSV(i),t.paint())},100)},contextmenu:{".dhx_palette__cell":function(e,i){e.preventDefault();var n=t.config.customColors.indexOf(i.data.color);-1!==n&&t._removeCustomColor(n),t.paint()}},mouseover:{".dhx_palette__cell":function(t){t.target&&p.tooltip(h.default.rightClickToDelete,{node:t.target,position:_.Position.bottom})},".dhx_colorpicker-custom-colors__picker":function(t){t.target&&p.tooltip(h.default.addNewColor,{node:t.target,position:_.Position.bottom})}}},this.events.on(f.ColorpickerEvents.change,function(){t.paint()}),this.events.on(f.ColorpickerEvents.colorChange,function(){t.paint()})},e.prototype._focusColor=function(t){if(void 0===t||t.length<4)return!1;var e=t.toUpperCase();if(!u.isHex(e))return!1;var i=this.config.palette.reduce(function(t,i){return t||(i.forEach(function(i){i.toUpperCase()!==e||(t=!0)}),t)},!1),n=-1!==d.grayShades.indexOf(e);if(!i&&!n){var o=this.getCustomColors();-1===o.indexOf(e.toUpperCase())&&o.push(e.toUpperCase())}return this._selected=e||null,this._pickerState.hsv=u.HexToHSV(e),!0},e.prototype._removeCustomColor=function(t){this.config.customColors.splice(t,1)},e.prototype._getCells=function(t,e){var i=this;return void 0===e&&(e=""),t.reduce(function(t,n){var o=(i._selected||"").toUpperCase()===n.toUpperCase()?"dhx_palette__cell--selected":"";return t.push(r.el(".dhx_palette__cell",{class:o+" "+e,_data:{color:n},style:"background:"+n})),t},[])},e.prototype._getGrayShades=function(){return r.el(".dhx_palette__row",this._getCells(d.grayShades))},e.prototype._getPalette=function(){var t=this;return this.config.palette.reduce(function(e,i){return e.push(r.el(".dhx_palette__col",t._getCells(i))),e},[])},e.prototype._getContent=function(){var t;return t=this.config.pickerOnly?[v.getPicker(this,this._pickerState,this._handlers)]:"palette"===this.config.mode?o([this.config.grayShades&&this._getGrayShades()],this._getPalette(),[!this.config.paletteOnly&&r.el(".dhx_colorpicker-custom-colors",{onmouseover:this._handlers.mouseover},[r.el(".dhx_colorpicker-custom-colors__header",[h.default.customColors]),r.el(".dhx_palette--custom.dhx_palette__row",o(this._getCells(this.config.customColors,"dhx_custom-color__cell"),[r.el(".dhx_colorpicker-custom-colors__picker",{class:"dxi dxi-plus",onclick:this._handlers.customColorClick,onmouseover:this._handlers.mouseover})]))])]):[v.getPicker(this,this._pickerState,this._handlers)],r.el(".dhx_widget.dhx_colorpicker",{class:this.config.css,style:{width:this.config.width}},[r.el(".dhx_palette",{onclick:this._handlers.click,oncontextmenu:this._handlers.contextmenu},t)])},e}(c.View);e.Colorpicker=m},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.grayShades=["#000000","#4C4C4C","#666666","#808080","#999999","#B3B3B3","#CCCCCC","#E6E6E6","#F2F2F2","#FFFFFF"],e.palette=[["#D4DAE4","#B0B8CD","#949DB1","#727A8C","#5E6677","#3F4757","#1D2534"],["#FFCDD2","#FE9998","#F35C4E","#E94633","#D73C2D","#CA3626","#BB2B1A"],["#F9E6AD","#F4D679","#EDB90F","#EAA100","#EA8F00","#EA7E00","#EA5D00"],["#BCE4CE","#90D2AF","#33B579","#36955F","#247346","#1D5B38","#17492D"],["#BDF0E9","#92E7DC","#02D7C5","#11B3A5","#018B80","#026B60","#024F43"],["#B3E5FC","#81D4FA","#29B6F6","#039BE5","#0288D1","#0277BD","#01579B"],["#AEC1FF","#88A3F9","#5874CD","#2349AE","#163FA2","#083596","#002381"],["#C5C0DA","#9F97C1","#7E6BAD","#584A8F","#4F4083","#473776","#3A265F"],["#D6BDCC","#C492AC","#A9537C","#963A64","#81355A","#6E3051","#4C2640"],["#D2C5C1","#B4A09A","#826358","#624339","#5D4037","#4E342E","#3E2723"]]},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(43),o=i(0),r=i(44);e.getPicker=function(t,e,i){var s=n.HSVtoRGB(e.hsv);e.background=n.RGBToHex(s);var a=n.RGBToHex(n.HSVtoRGB({h:e.hsv.h,s:1,v:1})),c=t.getRootView(),l=c.refs?c.refs.picker_palette.el.getBoundingClientRect():{height:200,width:218,x:0,y:0},u=l.height-2,d=l.width-2,h=u-e.hsv.v*u-4,f=e.hsv.s*d-4,p=l.width-6,_=p-(360-e.hsv.h)/360*p,v=e.customHex?e.customHex.replace("#",""):e.background.replace("#","");return o.el(".dhx_colorpicker-picker",{},[o.el(".dhx_colorpicker-picker__palette",{style:{height:132,background:a},onmousedown:i.mousedown,dhx_id:"picker_palette",_ref:"picker_palette"},[o.el(".dhx_palette_grip",{style:{top:h,left:f}})]),o.el(".dhx_colorpicker-hue-range",{style:{height:16},onmousedown:i.mousedown,dhx_id:"hue_range",_key:"hue_range",_ref:"hue_range"},[o.el(".dhx_colorpicker-hue-range__grip",{style:{left:_}})]),o.el(".dhx_colorpicker-value",[o.el(".dhx_colorpicker-value__color",{style:{background:e.background}}),o.el(".dhx_colorpicker-value__input__wrapper",[o.el("input",{class:"dhx_colorpicker-value__input",value:v,oninput:i.oninput,maxlength:"7",_key:"hex_input"})])]),o.el(".dhx_colorpicker-picker__buttons",[!t.config.pickerOnly&&o.el("button",{class:"dhx_button dhx_button--size_medium dhx_button--view_link dhx_button--color_primary",onclick:[i.buttonsClick,"cancel"]},r.default.cancel),o.el("button",{class:"dhx_button dhx_button--size_medium dhx_button--view_flat dhx_button--color_primary",onclick:[i.buttonsClick,"apply"]},r.default.select)])])},e.calculatePaletteGrip=function(t,e,i){var n=t.refs.picker_palette.el.getBoundingClientRect(),o=n.height,r=n.width;e=e<0?0:e>o?o:e,i=i<0?0:i>r?r:i;var s=Math.round(i/(r/100)),a=100-Math.round(e/(o/100));this._pickerState.hsv.s=s/100,this._pickerState.hsv.v=a/100}},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.calculatePaletteGrip=function(t,e,i){var n=t.height,o=t.width;return e=e<0?0:e>n?n:e,i=i<0?0:i>o?o:i,{s:Math.round(i/(o/100))/100,v:(100-Math.round(e/(n/100)))/100}},e.calculateRangeGrip=function(t,e){var i=t.width;return e=e<0?0:e>i?i:e,{h:Math.round(e/i*360),rangeLeft:e}}},function(t,e,i){"use strict";function n(t){for(var i in t)e.hasOwnProperty(i)||(e[i]=t[i])}Object.defineProperty(e,"__esModule",{value:!0}),n(i(140)),n(i(6))},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),o=this&&this.__assign||function(){return(o=Object.assign||function(t){for(var e,i=1,n=arguments.length;i<n;i++)for(var o in e=arguments[i])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)};Object.defineProperty(e,"__esModule",{value:!0});var r=i(0),s=i(3),a=i(4),c=i(7),l=i(141),u=i(143),d=i(145),h=i(6),f=i(146),p=i(150),_=i(160),v=i(5),g=function(t){function e(e,i){void 0===i&&(i={});var n=t.call(this,null,i)||this;n._width=0,n._height=0,n._left=0,n._top=0;var o={};i.maxPoints&&(o.approximate={value:i.series.map(function(t){return t.value}),maxNum:i.maxPoints}),Array.isArray(i.data)?(n.events=new s.EventSystem(n),n.data=new c.DataCollection(o,n.events),n.data.parse(i.data)):i.data&&i.data.events?(n.data=i.data,n.events=n.data.events,n.events.context=n):(n.events=new s.EventSystem(n),n.data=new c.DataCollection(o,n.events)),n._globalHTMLHandlers={onmousemove:function(t){var e=n._layers.getSizes(),i=e.left,o=e.top,r=e.bottom,s=e.right,a=t.pageX,c=t.pageY,l=n.getRootView().node.el.getBoundingClientRect();n._left=l.left+window.pageXOffset,n._top=l.top+window.pageYOffset;var u=a-i-n._left,d=c-o-n._top;u>=0&&u<=n._width-s-i&&d>=0&&d<=n._height-r-o?n.events.fire(h.ChartEvents.chartMouseMove,[u,d,n._left+i,n._top+o]):n.events.fire(h.ChartEvents.chartMouseLeave)},onmouseleave:function(){return n.events.fire(h.ChartEvents.chartMouseLeave)}},n._layers=new l.ComposeLayer,n.setConfig(i),n._initEvents();return n.mount(e,r.create({render:function(t,e){if(!n.data.getLength())return r.el("div");var o=[r.resizer(function(t,e){n._width=t,n._height=e||400;var i=n.getRootView();if(i&&i.node&&i.node.el){var o=i.node.el.getBoundingClientRect();n._left=o.left+window.pageXOffset,n._top=o.top+window.pageYOffset}n.events.fire(h.ChartEvents.resize,[{width:n._width,height:n._height}]),n.paint()})];return n._width&&n._height&&o.push(n._layers.toVDOM(n._width,n._height)),r.el(".dhx_widget.dhx_chart",{class:i.css?i.css:"",onmousemove:n._globalHTMLHandlers.onmousemove,onmouseleave:n._globalHTMLHandlers.onmouseleave},o)}})),n}return n(e,t),e.prototype.getSeries=function(t){return this._series[t]},e.prototype.eachSeries=function(t){var e=[];for(var i in this._series)e.push(t.call(this,this._series[i]));return e},e.prototype.destructor=function(){this._tooltip.destructor(),this.events.clear(),this.unmount()},e.prototype.setConfig=function(t){var e,i=this;if(this.config=t,this._layers.clear(),this._series={},this._scales={},t.scales)for(var n in t.scales){var r=o({},t.scales[n]);void 0!==t.scales[n].min&&(e=t.scales[n].min),r.type=r.type||this._detectScaleType(r,n),t.scales.radial&&"radial"!==n&&(r.hidden=!0),this._setScale(r,n)}var s=new _.default;if(this._layers.add(s),t.series.forEach(function(n){void 0!==n.baseLine&&n.baseLine<e&&(n.baseLine=void 0);var r=o({},n);r.type=r.type||t.type;var a=p.default[r.type];(r.barWidth||i.config.barWidth)&&(r.barWidth=r.barWidth||i.config.barWidth);var c=new a(i.data,r,i.events),l=v.getScales(t.scales);(l.length>1&&"radial"!==l[0]?l:"radial"===l[0]?l:[h.ScaleType.bottom,h.ScaleType.left]).forEach(function(t){var e=i._scales[t];e&&(c.addScale(t,e),r.stacked?e.add(s):e.add(c))}),i._series[c.id]=c,r.stacked?s.add(c):i._layers.add(c)}),t.legend){var a=o({},t.legend);a.series&&(a.$seriesInfo=a.series.map(function(t){return i._series[t]}));var c=new u.Legend(this.data,a,this.events);this._layers.add(c)}this._tooltip=new d.Tooltip(document.body,{chart:this}),this.paint()},e.prototype._setScale=function(t,e){var i=new f.default[t.type](this.data,t,e);i.config.grid&&"radial"!==i.config.type&&this._layers.add(i.scaleGrid()),this._layers.add(i),this._scales[e]=i},e.prototype._detectScaleType=function(t,e){return"radial"===e?e:t.text?"text":"numeric"},e.prototype._initEvents=function(){var t=this;this.events.on(h.ChartEvents.toggleSeries,function(e,i){if(i){var n=t._series[Object.keys(t._series)[0]];n&&(n.toggle(e),t.paint())}else t._series[e]&&(t._series[e].toggle(),t.paint())},this),this.events.on(c.DataEvents.change,function(){return t.paint()})},e}(a.View);e.Chart=g},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(0),o=i(142),r=function(){function t(){this._data=[],this._sizes={left:20,right:20,top:10,bottom:10}}return t.prototype.add=function(t){this._data.push(t)},t.prototype.clear=function(){this._data.forEach(function(t){return t.destructor&&t.destructor()}),this._data=[]},t.prototype.getSizes=function(){return this._sizes},t.prototype.toVDOM=function(t,e){var i={left:20,right:20,top:10,bottom:10},r=this._data.filter(function(t){return!t.dataReady||t.dataReady().length});this._data.forEach(function(t){return!t.scaleReady||t.scaleReady(i)});var s=0,a=0;r.forEach(function(t){t.seriesShift&&(s+=t.seriesShift(),a++)});var c=s/a;s=a?(c-s)/2:0,r.forEach(function(t){t.seriesShift&&(t.seriesShift(s),s+=c)}),this._sizes=i;var l=n.sv("g",{transform:"translate("+i.left+", "+i.top+")"},[n.sv("rect.dhx_chart-graph_area",{width:t-i.left-i.right,height:e-i.top-i.bottom,fill:"transparent"}),r.map(function(n){return n.paint(t-(i.left+i.right),e-(i.top+i.bottom))})]),u=n.sv("defs",[o.dropShadow(),o.shadow()]);return n.sv("svg",{width:t,height:e},[u,l])},t}();e.ComposeLayer=r},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(0);e.shadow=function(){return n.sv("filter",{id:"shadow"},[n.sv("feDiffuseLighting",{in:"SourceGraphic",result:"light","lighting-color":"white"},[n.sv("feDistantLight",{azimuth:90,elevation:25})]),n.sv("feComposite",{in:"SourceGraphic",in2:"light",operator:"arithmetic",k1:"1",k2:"0",k3:"0",k4:"0"})])},e.dropShadow=function(){return n.sv("filter",{id:"dropshadow",x:"-100%",y:"-100%",width:"300%",height:"300%"},[n.sv("feGaussianBlur",{in:"SourceAlpha",stdDeviation:2}),n.sv("feOffset",{dx:0,dy:0,result:"offsetblur"}),n.sv("feOffset",{dx:0,dy:0,result:"offsetblur"}),n.sv("feFlood",{"flood-color":"rgba(85,85,85,0.5)"}),n.sv("feComposite",{in2:"offsetblur",operator:"in"}),n.sv("feMerge",[n.sv("feMergeNode"),n.sv("feMergeNode",{in:"SourceGraphic"})])])}},function(t,e,i){"use strict";var n=this&&this.__assign||function(){return(n=Object.assign||function(t){for(var e,i=1,n=arguments.length;i<n;i++)for(var o in e=arguments[i])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)};Object.defineProperty(e,"__esModule",{value:!0});var o=i(6),r=i(0),s=i(5),a=i(144);var c=function(){function t(t,e,i){var r=this;this._data=t,this._events=i;var s={form:o.Shape.rect,itemPadding:20,halign:o.HorizontalPosition.right,valign:o.VerticalPosition.middle};this.config=n(n({},s),e),this.config.margin=e.margin||function(t,e){switch(e){case o.VerticalPosition.middle:switch(t){case o.HorizontalPosition.right:return 60;case o.HorizontalPosition.left:return 120;case o.HorizontalPosition.center:throw new Error("cant place legend on center, middle")}case o.VerticalPosition.top:return 20;case o.VerticalPosition.bottom:return 60}}(this.config.halign,this.config.valign),this._handlers={onclick:function(t,e){return r._events.fire(o.ChartEvents.toggleSeries,[t,e])}}}return t.prototype.scaleReady=function(t){this.config.valign===o.VerticalPosition.middle?this.config.halign===o.HorizontalPosition.right?t.right+=this.config.size||200:this.config.halign===o.HorizontalPosition.left&&(t.left+=this.config.size||200):this.config.valign===o.VerticalPosition.top?t.top+=this.config.size||40:this.config.valign===o.VerticalPosition.bottom&&(t.bottom+=this.config.size||40)},t.prototype.paint=function(t,e){var i,n,c=this,l=this._getData(),u=this.config,d=s.getFontStyle("legend-text"),h=u.margin,f=u.itemPadding,p=[],_=u.valign===o.VerticalPosition.middle,v=0,g=0;switch(l.forEach(function(t){if(p.push(r.sv("g",{transform:"translate("+v+","+g+")",onclick:[c._handlers.onclick,t.id,c.config.values],class:"legend-item "+(t.active?"":"not-active")},[r.sv("text",{x:10,y:0,class:"start-text legend-text"},[s.verticalCenteredText(t.text)]),a.legendShape(u.form,t)])),_)g+=f+2;else{var e=s.getTextWidth(t.text,d);v+=e+f+15}}),u.valign){case o.VerticalPosition.top:n=-h-5;break;case o.VerticalPosition.middle:n=(e-g)/2+f/2;break;case o.VerticalPosition.bottom:n=e+h}switch(u.halign){case o.HorizontalPosition.left:i=_?-h:5;break;case o.HorizontalPosition.center:i=(t-v)/2;break;case o.HorizontalPosition.right:i=_?t+h+5:t-v+f+5}return r.sv("g",{transform:"translate("+i+", "+n+")"},p)},t.prototype._getData=function(){var t=[];if(this.config.values){var e=s.locator(this.config.values.text),i=s.locator(this.config.values.color);this._data.map(function(n){t.push({id:n.id,text:e(n).toString(),alpha:1,fill:i(n).toString(),active:!n.$hidden})})}else{var n=this.config.$seriesInfo;for(var o in n){var r=n[o].config,a=r.fill&&r.color;t.push({id:r.id,text:r.name||r.value,alpha:r.alpha,fill:r.fill||r.color,color:a&&r.color,active:r.active})}}return t},t}();e.Legend=c},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(1),o=i(0),r={circle:function(t,e,i){return o.sv("circle",{id:n.uid(),r:5,fill:e,class:"figure "+("none"!==t?"with-stroke":""),"stroke-width":2,"fill-opacity":i,stroke:t,transform:"translate(0, -1)"})},rect:function(t,e,i){return o.sv("rect",{id:n.uid(),fill:e,"fill-opacity":i,width:10,"stroke-width":2,height:10,class:"figure "+("none"!==t?"with-stroke":""),stroke:t,transform:"translate(-5, -5)"})}};e.legendShape=function(t,e){return"string"==typeof t&&(t=r[t]),t(e.color||"none",e.fill,e.alpha||1)}},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}();Object.defineProperty(e,"__esModule",{value:!0});var o=i(0),r=i(5),s=i(6),a=function(t){function e(e,i){var n=t.call(this,e,i)||this;return n._chart=i.chart,n._state={leftOffset:0,topOffset:0,value:"",x:0,y:0,type:null,chartType:null,isVisible:!1},n.mount(e,o.create({render:function(){return n._draw()}})),n._chart.events.on(s.ChartEvents.chartMouseMove,function(t,e,i,o){var s=[1/0,null,null,null,null];n._chart.eachSeries(function(i){var n=i.getClosest(t,e);s[0]>n[0]&&(s[0]=n[0],s[1]=n[1],s[2]=n[2],s[3]=n[3],s[4]=i.id)});var a=n._chart.getSeries(s[4]);if(a){var c=r.calcPointRef(s[3],s[4]);if(c===n._lastPointRef)return;var l=a.getTooltipText(s[3]);if(l){var u=a.getTooltipType(s[3],s[1],s[2]);n._enableActivePoint(c),n._state.leftOffset=i,n._state.topOffset=o,n._state.value=l,n._state.x=s[1],n._state.y=s[2],n._state.type=u,n._state.chartType=a.config.type,n._state.isVisible=!0,n.paint()}}},n),n._chart.events.on(s.ChartEvents.chartMouseLeave,function(){return n._hide()},n),n}return n(e,t),e.prototype.destructor=function(){this._chart.events.detach(s.ChartEvents.chartMouseLeave,this),this._chart.events.detach(s.ChartEvents.chartMouseMove,this),this.unmount()},e.prototype._hide=function(){this._disableLastActivePoint(),this._state.isVisible=!1,this.paint()},e.prototype._enableActivePoint=function(t){var e=this._chart.getRootView(),i=e&&e.refs&&e.refs[t];i&&(this._disableLastActivePoint(),this._lastPointRef=t,i.patch({class:i.attrs.class+" active-figure"}))},e.prototype._disableLastActivePoint=function(){if(this._lastPointRef){var t=this._chart.getRootView(),e=t&&t.refs&&t.refs[this._lastPointRef];e&&e.patch({class:e.attrs.class.replace(" active-figure","")}),this._lastPointRef=null}},e.prototype._draw=function(){var t,e=this._state,i=e.value,n=e.x,a=e.y,c=e.type,l=e.chartType,u=e.isVisible;if(u&&""!==i){var d=r.getFontStyle("tooltip-text");t=function(t,e,i,n,o){var r=o===s.ChartType.bar?5:0;switch(n){case s.TooltipType.top:return{d:"M0 0 l4 -4 h"+(a=(t+20-8-4)/2)+" a2 2 0 0 0 2 -2 v-18 a2 2 0 0 0 -2 -2 h"+-(t+20-4)+" a2 2 0 0 0 -2 2 v18 a2 2 0 0 0 2 2 h"+a+" Z",left:e,top:i-6+r,textX:0,textY:-15};case s.TooltipType.bot:var a;return{d:"M0 0 l4 4 h"+(a=(t+20-8-4)/2)+" a2 2 0 0 1 2 2 v18 a2 2 0 0 1 -2 2 h"+-(t+20-4)+" a2 2 0 0 1 -2 -2 v-18 a2 2 0 0 1 2 -2 h"+a+" Z",left:e,top:i+6-r,textX:0,textY:15};case s.TooltipType.right:return{d:"M0 0 l4 -4 v-5 a2 2 0 0 1 2 -2 h"+(c=t+20-4)+" a2 2 0 0 1 2 2 v18 a2 2 0 0 1 -2 2 h"+-c+" a2 2 0 0 1 -2 -2 v-5 Z",left:e+1,top:i,textX:c/2+6,textY:0};case s.TooltipType.left:return{d:"M0 0 l-4 -4 v-5 a2 2 0 0 0 -2 -2 h"+-(c=t+20-4)+" a2 2 0 0 0 -2 2 v18 a2 2 0 0 0 2 2 h"+c+" a2 2 0 0 0 2 -2 v-5 Z",left:e-1,top:i,textX:-c/2-6,textY:0};case s.TooltipType.simple:var c;return{d:"M0 0 v-4 a2 2 0 0 1 2 -2 h"+(c=t+20-4)+" a2 2 0 0 1 2 2 v18 a2 2 0 0 1 -2 2 h"+-c+" a2 2 0 0 1 -2 -2 v-6 Z",left:e-c/2-2,top:i-5,textX:c/2+2,textY:6}}}(r.getTextWidth(i,d),n,a,c||s.TooltipType.top,l)}else t={textX:0,textY:0,d:null,left:0,top:0};return o.el(".dhx_chart.tooltip-container",{style:{pointerEvents:"none",width:0,height:0,visibility:u?"visible":"hidden",position:"absolute",left:t.left+this._state.leftOffset+"px",top:t.top+this._state.topOffset+"px"}},u?[o.sv("svg",[o.sv("path",{d:t.d,class:"tooltip-form"}),o.sv("text",{x:t.textX,y:t.textY,class:"tooltip-text"},[r.verticalCenteredText(i)])])]:null)},e}(i(4).View);e.Tooltip=a},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(147),o=i(45),r=i(149),s={radial:n.RadialScale,text:r.TextScale,numeric:o.Scale};e.default=s},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}();Object.defineProperty(e,"__esModule",{value:!0});var o=i(26),r=i(6),s=function(t){function e(e,i){return t.call(this,e,i,r.ScaleType.radial)||this}return n(e,t),e.prototype.paint=function(t,e){var i=this;if(this.config.hidden)return null;var n=this.config.zebra,r=this.config.value,s=this.config.showAxis?this._axis.steps:null,a=this._axis.steps.map(function(t){return i.point(t)}),c={scales:this._data.map(function(t){return t[r]}),axis:a,realAxis:s,zebra:n};return o.radarScale(c,t,e)},e.prototype.point=function(t){return(t-this._axis.min)/(this._axis.max-this._axis.min)},e}(i(45).Scale);e.RadialScale=s},function(t,e,i){"use strict";var n=this&&this.__assign||function(){return(n=Object.assign||function(t){for(var e,i=1,n=arguments.length;i<n;i++)for(var o in e=arguments[i])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)},o=this&&this.__spreadArrays||function(){for(var t=0,e=0,i=arguments.length;e<i;e++)t+=arguments[e].length;var n=Array(t),o=0;for(e=0;e<i;e++)for(var r=arguments[e],s=0,a=r.length;s<a;s++,o++)n[o]=r[s];return n};Object.defineProperty(e,"__esModule",{value:!0});var r=i(5),s=[1,2,3,5,10],a=function(){function t(t,e){void 0===e&&(e={}),this._data=t;var i={min:Math.min.apply(Math,this._data),max:Math.max.apply(Math,this._data),maxTicks:this._data.length<20?this._data.length:20};this.config=n(n({},i),e),this.config.padding&&this._addPadding()}return t.prototype.getScale=function(){var t;if(this.config.log)t=this._logSteps();else{var e=this._getStep();t=this._calculateSteps(e)}return{min:t[0],max:t[t.length-1],steps:t}},t.prototype._getStep=function(){var t=this.config.maxTicks,e=this.config.max-this.config.min,i=Math.floor(r.log10(e/t)),n=Math.pow(10,i),a=e/n/t;return s[o(s,[a]).sort(function(t,e){return t-e}).indexOf(a)]*n},t.prototype._calculateSteps=function(t){for(var e=Math.floor(this.config.min/t),i=Math.ceil(this.config.max/t),n=[],o=e;o<=i;o++){var r=t*o;Math.floor(r)!==r&&(r=parseFloat(r.toFixed(8))),n.push(r)}return n},t.prototype._logSteps=function(){var t=[];if(this.config.min<0){for(var e=Math.ceil(r.log10(-this.config.min));e>0;e--)t.push(-Math.pow(10,e));t.push(0)}if(this.config.max>0){var i=Math.ceil(r.log10(this.config.max));for(e=1;e<=i;e++)t.push(Math.pow(10,e))}return t},t.prototype._addPadding=function(){this.config.min-=this.config.padding},t}();e.AxisCreator=a},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),o=this&&this.__assign||function(){return(o=Object.assign||function(t){for(var e,i=1,n=arguments.length;i<n;i++)for(var o in e=arguments[i])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)};Object.defineProperty(e,"__esModule",{value:!0});var r=i(5),s=i(45),a=i(70),c={left:a.left,right:a.right,bottom:a.bottom,top:a.top},l={left:a.leftGrid,right:a.rightGrid,bottom:a.bottomGrid,top:a.topGrid},u=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return n(e,t),e.prototype.scaleReady=function(t){var e=this._data.getLength()-1,i=this._data.map(this.locator);this._axis={max:e,steps:i},t[this._position]+=this.config.size},e.prototype.point=function(t){var e=this._axis.steps.indexOf(t);if(this._padding){var i=this._axis.max+1,n=.5/i,o=e/i;return this._isXDirection?n+o:1-n-o}return this._isXDirection?e/this._axis.max:1-e/this._axis.max},e.prototype.paint=function(t,e){var i=this;if(this.config.hidden)return null;var n=this._axis.steps.map(function(n,o){return[i._isXDirection?i._getAxisPoint(o)*t:i.point(n)*e,n]});return c[this._position](n,this.config,t,e)},e.prototype.scaleGrid=function(){var t=this,e=this._position,i=this.config.grid,n=this.config.dashed,o=this.config.hidden;return{paint:function(r,s){var a=t._axis.steps.indexOf(t.config.targetLine),c=function(e,i){return t._axis.steps.map(function(n,o){return[t._isXDirection?t._getAxisPoint(o)*e:t._getAxisPoint(o)*i,n]})}(r,s),u={targetLine:a,dashed:n,grid:i,hidden:o};return l[e](c,r,s,u)}}},e.prototype._setDefaults=function(t){this.locator=r.locator(t.text),this.config=o(o({},{scalePadding:30,textPadding:12,grid:!0,targetLine:null,showText:!0}),t)},e.prototype._getAxisPoint=function(t){var e=this._axis.max;if(this._padding){var i=e+1,n=.5/i,o=t/i;return this._isXDirection?n+o:1-n-o}return this._isXDirection?t/e:1-t/e},e}(s.Scale);e.TextScale=u},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(71),o=i(72),r=i(152),s=i(153),a=i(49),c=i(154),l=i(155),u=i(156),d=i(157),h=i(158),f=i(159),p={line:a.default,spline:h.default,area:n.default,splineArea:f.default,scatter:d.default,pie:c.default,pie3D:l.default,donut:s.default,radar:u.default,bar:o.default,xbar:r.default};e.default=p},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(0),o=i(5);e.hoverMode=function(t){return t},e.standarMode=function(t){return t};var r={circle:function(t,e,i,o,r,s,a){var c={_ref:s,cx:o,cy:r,r:4,class:"figure point-circle",fill:e,stroke:t,"stroke-width":2};return n.sv("circle",a(c))},rect:function(t,e,i,o,r,s,a){var c={_ref:s,x:o-4,y:r-4,width:8,height:8,class:"figure point-rect",fill:e,stroke:t,"stroke-width":2};return n.sv("rect",a(c))},rhombus:function(t,e,i,o,r,s,a){var c={_ref:s,points:o-5+","+r+" "+o+","+(r+5)+" "+(o+5)+","+r+" "+o+","+(r-5),class:"figure point-rhombus",fill:e,stroke:t,"stroke-width":2};return n.sv("polygon",a(c))},triangle:function(t,e,i,o,r,s,a){var c={_ref:s,points:o+","+(r-5)+" "+(o+5)+","+(r+5)+" "+(o-5)+","+(r+5),class:"figure point-triangle",fill:e,stroke:t,"stroke-width":2};return n.sv("polygon",a(c))},simpleCircle:function(t,e,i,o,r,s,a){var c={_ref:s,cx:o,cy:r,r:3,class:"figure point-simple-circle",fill:t};return n.sv("circle",a(c))},simpleRect:function(t,e,i,o,r,s,a){var c={_ref:s,x:o-3,y:r-3,width:6,height:6,class:"figure point-simple-rect",fill:t};return n.sv("rect",a(c))},empty:function(){return null}};function s(t){var e=r[t.toString()];if(!e)throw new Error("unknown point type");return e}e.getHelper=s,e.getShadeHelper=function(t,e,i){var n=s(t);e=e||"none";var r=o.getColorShade(e,.2);return function(t,o,s){return n(e,r,"",t,o,s,i)}}},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}();Object.defineProperty(e,"__esModule",{value:!0});var o=i(6),r=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return n(e,t),e.prototype.addScale=function(e,i){var n=e===o.ScaleType.top||e===o.ScaleType.bottom?o.ScaleType.left:o.ScaleType.top;t.prototype.addScale.call(this,n,i)},e.prototype.paint=function(e,i,n){return t.prototype.paint.call(this,i,e,n)},e.prototype.getTooltipType=function(t,e,i){return void 0!==this.config.baseLine&&this._baseLinePosition>e?o.TooltipType.left:o.TooltipType.right},e.prototype.getClosest=function(t,e){for(var i=[1/0,null,null,null],n=0,o=this._points;n<o.length;n++){var r=o[n],s=this._getClosestDist(t,e,r[1],r[0]);i[0]>s&&(i[0]=s,i[1]=r[1],i[2]=r[0],i[3]=r[2])}return i},e.prototype._getText=function(t){return t[4].toString()},e.prototype._getClosestDist=function(t,e,i,n){return this.config.stacked&&t>i?1/0:Math.abs(e-n)},e.prototype._path=function(t,e){return t[0]+=this._shift,"\nM "+e+" "+(t[0]-this.config.barWidth/2)+"\nH "+t[1]+"\nv "+this.config.barWidth+"\nH "+e},e.prototype._base=function(t){var e=this.config.baseLine;return this._baseLinePosition=void 0!==e?this.yScale.point(e)*t:0},e.prototype._text=function(t,e,i){var n=(e+t[1])/2,o=t[0];return{x:n,y:o,class:"bar-text",transform:i&&!isNaN(i)?"rotate("+i+" "+n+" "+o+")":""}},e}(i(72).default);e.default=r},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}();Object.defineProperty(e,"__esModule",{value:!0});var o=i(0),r=i(26),s=i(5),a=i(6),c=function(t){function e(){var e=null!==t&&t.apply(this,arguments)||this;return e._handlers={onclick:function(t,i){return e._events.fire(a.ChartEvents.serieClick,[t,i])}},e}return n(e,t),e.prototype.paint=function(t,e){var i=this,n=e/2,c=-.25,l=[],u=[],d=[],h=1===this._points.length?-1e-6:0;return this._points.forEach(function(f){var p=f[0],_=f[1],v=f[2],g=f[3],m=f[4],y=r.getCoordinates(c,n,n),b=y[0],x=y[1],w=c+p/2;c+=p+h;var k=r.getCoordinates(c,n,n),C=k[0],E=k[1],S=p>.5?1:0,O=r.getCoordinates(w,n,n),M=w>-.25&&w<.25,T=w>.5||w<0;switch(i.config.subType){case a.NoScaleSubType.basic:var I=M?"donut-value-title start-text":"donut-value-title end-text",D=10,P=T?2*-D:D,V=r.getCoordinates(w,n+10,n+10),L=M?"donut-value start-text":"donut-value end-text",j=o.sv("text",{x:V[0],y:V[1]+P,class:I},[s.verticalCenteredText(g.toString())]),H=o.sv("text",{x:V[0],y:V[1]+P+16,class:L},[s.verticalCenteredText(_.toString())]);u.push(j),u.push(H);break;case a.NoScaleSubType.valueOnly:I=M?"donut-value start-text":"donut-value end-text",D=10,P=T?-D:D,V=r.getCoordinates(w,n+10,n+10);var A=o.sv("text",{x:V[0],y:V[1]+P,class:I},[s.verticalCenteredText(g.toString())]);u.push(A);break;case a.NoScaleSubType.percentOnly:var R=o.sv("text",{x:7*O[0]/9,y:7*O[1]/9,class:"pie-inner-value"},[s.verticalCenteredText(Math.round(100*p)+"%")]);u.push(R)}var F="M "+b+" "+x+" A "+n+" "+n+" 0 "+S+" 1 "+C+" "+E+" L 0 0",B=r.getCoordinates(w,4,4),z=B[0],N=B[1],$=o.sv("path",{d:F,_key:v,fill:m,class:"chart donut",onclick:[i._handlers.onclick,f[1],f[2]],onmouseout:[r.pieLikeHandlers.onmouseout],onmouseover:[r.pieLikeHandlers.onmouseover,z,N]});l.push($),1===i._points.length?d.push([t/2,e/2]):d.push([.8*O[0]+t/2,.8*O[1]+e/2])}),this._center=[t/2,e/2],this._tooltipData=d,l.push(o.sv("circle",{cx:0,cy:0,r:5*n/9,fill:"#FFFFFF"})),l=l.concat(u),o.sv("g",{transform:"translate("+t/2+", "+e/2+")"},l)},e}(i(48).default);e.default=c},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),o=this&&this.__assign||function(){return(o=Object.assign||function(t){for(var e,i=1,n=arguments.length;i<n;i++)for(var o in e=arguments[i])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)};Object.defineProperty(e,"__esModule",{value:!0});var r=i(1),s=i(0),a=i(26),c=i(5),l=i(6),u=function(t){function e(){var e=null!==t&&t.apply(this,arguments)||this;return e._handlers={onclick:function(t,i){return e._events.fire(l.ChartEvents.serieClick,[t,i])}},e}return n(e,t),e.prototype.paint=function(t,e){var i=this,n=this.config,u=n.stroke,d=n.strokeWidth,h=n.gradient,f=n.useLines,p=n.showText,_=n.showTextTemplate,v=n.subType,g=e/2,m=-.25,y=[],b=[],x=[],w=[],k=[],C=[],E=1===this._points.length?-1e-6:0;return this._points.forEach(function(n){var b=n[0],S=n[1],O=n[2],M=n[3],T=n[4],I=T;if(h){var D=h(T),P="gradient"+r.uid(),V=c.getRadialGradient(D.options,D.stops,P);I="url(#"+P+")",x.push(V)}var L=a.getCoordinates(m,g,g),j=L[0],H=L[1],A=m+b/2,R=A<.25?5:-5,F=a.getCoordinates(A,g,g),B=[5,30],z=B[0],N=B[1],$=[a.getCoordinates(A,g+z,g+z),a.getCoordinates(A,g+N,g+N)],W=$[0],U=$[1],G=A>-.25&&A<.25?"pie-value start-text":"pie-value end-text";if(f){w.push(s.sv("path",{d:"M"+W[0]+" "+W[1]+" L"+U[0]+" "+U[1]+" h "+R,class:"pie-value-connector"}));var Y=s.sv("text",{x:U[0],y:U[1],dx:R/2+R>0?10:-10,class:G},[c.verticalCenteredText(M.toString())]);w.push(Y)}else{var q=A>.5||A<0?-5:5;Y=s.sv("text",{x:W[0],y:W[1]+q,class:G},[c.verticalCenteredText(M.toString())]);w.push(Y)}if(p||_){var X=s.sv("text",{x:.7*F[0],y:.7*F[1],class:"pie-inner-value"},[_?c.verticalCenteredText(_(S.toString())):c.verticalCenteredText(S.toString())]);w.push(X)}if(v===l.NoScaleSubType.percentOnly){var K=s.sv("text",{x:.5*F[0],y:.5*F[1],class:"pie-inner-value"},[c.verticalCenteredText(Math.round(100*b)+"%")]);w.push(K)}m+=b+E;var J=a.getCoordinates(m,g,g),Z=J[0],Q=J[1],tt="M "+j+" "+H+" A "+g+" "+g+" 0 "+(b>.5?1:0)+" 1 "+Z+" "+Q+" L 0 0",et=a.getCoordinates(A,4,4),it=et[0],nt=et[1],ot=s.sv("path",{d:tt,class:"chart pie",_key:O,fill:I,onclick:[i._handlers.onclick,n[1],n[2]],onmouseover:[a.pieLikeHandlers.onmouseover,it,nt],onmouseout:[a.pieLikeHandlers.onmouseout]});if(k.push(ot),i._points.length>1&&u){var rt={"stroke-width":d,stroke:u},st=s.sv("path",o({d:"M0 0 L"+Z+" "+Q,fill:"none"},rt));C.push(st)}1===i._points.length?y.push([t/2,e/2]):y.push([.7*F[0]+t/2,.7*F[1]+e/2])}),this._center=[t/2,e/2],this._tooltipData=y,b.push(s.sv("defs",x)),b=(b=(b=b.concat(k)).concat(C)).concat(w),s.sv("g",{transform:"translate("+t/2+", "+e/2+")"},b)},e}(i(48).default);e.default=u},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}();Object.defineProperty(e,"__esModule",{value:!0});var o=i(0),r=i(26),s=i(5),a=i(6),c=function(t){function e(){var e=null!==t&&t.apply(this,arguments)||this;return e._handlers={onclick:function(t,i){return e._events.fire(a.ChartEvents.serieClick,[t,i])}},e}return n(e,t),e.prototype.paint=function(t,e){var i=this,n=this.config,c=n.subType,l=n.useLines,u=n.showText,d=n.showTextTemplate,h=e/2,f=.5*h,p=h/5,_=[],v=-.25,g=[],m=[],y=1===this._points.length?-1e-6:0;return this._points.forEach(function(n){var b=n[0],x=n[1],w=n[2],k=n[3],C=n[4],E=r.getCoordinates(v,h,f),S=E[0],O=E[1],M=v+b/2,T=M<.25?5:-5,I=r.getCoordinates(M,h,f),D=0;M>0&&M<.5&&(D=p*Math.sin(2*Math.PI*M));var P=r.getCoordinates(M,h+5+D,f+5+D),V=r.getCoordinates(M,h+30+D,f+30+D),L=v+b+y,j=r.getCoordinates(L,h,f),H=j[0],A=j[1],R=b>.5?1:0,F=M>-.25&&M<.25?"pie-value start-text":"pie-value end-text";if(l){m.push(o.sv("path",{d:"M"+P[0]+" "+P[1]+" L"+V[0]+" "+V[1]+" h "+T,class:"pie-value-connector"}));var B=o.sv("text",{x:V[0],y:V[1],dx:T/2+T>0?10:-10,class:F},[s.verticalCenteredText(k.toString())]);m.push(B)}else{var z=M>.5||M<0?-10:10;B=o.sv("text",{x:P[0],y:P[1]+z,class:F},[s.verticalCenteredText(k.toString())]);m.push(B)}if(u||d){B=o.sv("text",{x:.7*I[0],y:.7*I[1],class:"pie-inner-value"},[d?s.verticalCenteredText(d(x)):s.verticalCenteredText(x.toString())]);m.push(B)}if(c===a.NoScaleSubType.percentOnly){var N=o.sv("text",{x:.6*I[0],y:.6*I[1],class:"pie-inner-value"},[s.verticalCenteredText(Math.round(100*b)+"%")]);m.push(N)}var $="";if(v<=0&&L>=.5?$="M "+h+" 0 v "+p+" A "+h+" "+f+" 0 1 1 "+-h+" "+p+" v "+-p:v<=0&&L<.5?$="M "+h+" 0 v "+p+" A "+h+" "+f+" 0 0 1 "+H+" "+(A+p)+" v "+-p:v>0&&v<=.5&&L>=.5?$="M "+S+" "+O+" v "+p+" A "+h+" "+f+" 0 0 1 "+-h+" "+p+" v "+-p:v>0&&L<.5&&($="M "+S+" "+O+" v "+p+" A "+h+" "+f+" 0 0 1 "+H+" "+(A+p)+" v "+-p),$){var W=o.sv("path",{_key:w+"__shadow__",d:$,fill:C,onclick:[i._handlers.onclick,n[1],n[2]],class:"chart pie3d addition",stroke:"none",filter:"url(#shadow)"});g.push(W)}var U="M "+S+" "+O+" A "+h+" "+f+" 0 "+R+" 1 "+H+" "+A+" L 0 0";g.push(o.sv("path",{d:U,_key:w,fill:C,stroke:"none",onclick:[i._handlers.onclick,n[1],n[2]],class:"chart pie3d"})),1===i._points.length?_.push([t/2,e/2]):_.push([.7*I[0]+t/2,.7*I[1]+e/2]),v=L}),this._center=[t/2,e/2],this._tooltipData=_,g=g.concat(m),o.sv("g",{transform:"translate("+t/2+", "+e/2+")"},g)},e}(i(48).default);e.default=c},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),o=this&&this.__assign||function(){return(o=Object.assign||function(t){for(var e,i=1,n=arguments.length;i<n;i++)for(var o in e=arguments[i])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)};Object.defineProperty(e,"__esModule",{value:!0});var r=i(0),s=i(26),a=i(5),c=i(6),l=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return n(e,t),e.prototype.addScale=function(t,e){this._scale=e},e.prototype.scaleReady=function(t){for(var e in t)t[e]+=this.config.paddings;return t},e.prototype.dataReady=function(t){var e=this;return this.config.active?(this._points=this._data.map(function(i,n){var o=e._locator(i),r=[o,o,i.id,o,o];return t&&(r[1]+=t[n][1]),r}),this._points):this._points=[]},e.prototype.getTooltipText=function(t){if(this.config.tooltip){var e=this._defaultLocator(this._data.getItem(t));return this.config.tooltipTemplate?this.config.tooltipTemplate(e):e}},e.prototype.paint=function(e,i){var n=this;if(t.prototype.paint.call(this,e,i),this.config.active){var o=this.config,s=[],c=this._points.map(function(t,e){return(e?"L":"M")+t[0]+" "+t[1]}).join(" ")+"Z";if(s.push(r.sv("path",{d:c,stroke:o.color,"stroke-width":o.strokeWidth,fill:o.fill,"fill-opacity":o.alpha,class:"chart radar"})),o.pointType){var l=this._points.map(function(t){return n._drawPointType(t[0],t[1],a.calcPointRef(t[2],n.id))});s.push(r.sv("g",l))}return r.sv("g",{id:"seria"+o.id},s)}},e.prototype._calckFinalPoints=function(t,e){var i=this,n=e/2,o=1/this._data.getLength(),r=-.25-o;this._points.forEach(function(a,c){r+=o;var l=i._scale.point(a[0]),u=s.getCoordinates(r,l*n,l*n);a[0]=u[0]+t/2,a[1]=u[1]+e/2})},e.prototype._defaultLocator=function(t){return this._locator(t)},e.prototype._setDefaults=function(t){var e={strokeWidth:2,active:!0,tooltip:!0,paddings:5,color:"none",fill:"none",pointType:c.PointType.circle};if(this._locator=a.locator(t.value),t.scales=t.scales||[c.ScaleType.radial],this.config=o(o({},e),t),this.config.pointType){var i=this.config.pointColor||this.config.color;this._drawPointType=this._getPointType(this.config.pointType,i,this.config.tooltip)}},e}(i(47).default);e.default=l},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),o=this&&this.__assign||function(){return(o=Object.assign||function(t){for(var e,i=1,n=arguments.length;i<n;i++)for(var o in e=arguments[i])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)};Object.defineProperty(e,"__esModule",{value:!0});var r=i(6),s=i(49),a=i(5),c=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return n(e,t),e.prototype.addScale=function(t,e){t===r.ScaleType.bottom||t===r.ScaleType.top?(this.xScale=e,this._xLocator=a.locator(this.config.value)):(this.yScale=e,this._yLocator=a.locator(this.config.valueY))},e.prototype._setDefaults=function(t){var e={active:!0,tooltip:!0,pointType:r.PointType.rect};this.config=o(o({},e),t);var i=this.config.tooltip,n=this.config.pointType,s=this.config.pointColor||this.config.color;n&&(this._drawPointType=this._getPointType(n,s,i))},e}(s.default);e.default=c},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}();Object.defineProperty(e,"__esModule",{value:!0});var o=i(0),r=i(73),s=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return n(e,t),e.prototype._getForm=function(t,e,i,n,s){var a=e.color,c=e.css,l=r.default(t);return o.sv("path",{id:"seria"+e.id,d:l,class:c,stroke:a,"stroke-width":2,fill:"none"})},e}(i(49).default);e.default=s},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}();Object.defineProperty(e,"__esModule",{value:!0});var o=i(0),r=i(73),s=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return n(e,t),e.prototype._form=function(t,e,i,n){var s=this.config,a=s.fill,c=s.alpha,l=s.strokeWidth,u=s.color,d=s.id,h=this.config.css,f="",p=this._points[0];if(f=n?r.default([].concat(n).reverse())+" "+r.default(this._points,!0)+" Z":"M"+p[0]+" "+e+" V "+p[1]+" "+r.default(this._points)+" V"+e+" H "+p[0],l){var _=r.default(this._points),v=o.sv("path",{d:_,"stroke-width":l,stroke:u,fill:"none","stroke-linecap":"butt",class:h});i.push(v)}var g=o.sv("path",{id:"seria"+d,d:f,class:h,fill:a,"fill-opacity":c,stroke:"none"});return i.push(g),i},e}(i(71).default);e.default=s},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(0),o=function(){function t(){this._series=[]}return t.prototype.add=function(t){this._series.push(t)},t.prototype.dataReady=function(t){return this._toPaint=this._series.filter(function(e){var i=e.dataReady(t);return!!i.length&&(t=i,!0)}),t||[]},t.prototype.getPoints=function(){return this._toPaint.length?this._toPaint[0].getPoints().concat(this._toPaint[this._toPaint.length-1].getPoints()):[]},t.prototype.paint=function(t,e,i){var o=[],r=[];return this._toPaint.forEach(function(n){if(n.paintformAndMarkers){var s=n.paintformAndMarkers(t,e,i),a=s[0],c=s[1];o.push(a),r.push(c)}else{a=n.paint(t,e,i);o.push(a)}i=n.getPoints()}),n.sv("g",o.concat(r))},t}();e.default=o},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),o=this&&this.__spreadArrays||function(){for(var t=0,e=0,i=arguments.length;e<i;e++)t+=arguments[e].length;var n=Array(t),o=0;for(e=0;e<i;e++)for(var r=arguments[e],s=0,a=r.length;s<a;s++,o++)n[o]=r[s];return n};Object.defineProperty(e,"__esModule",{value:!0});var r=i(1),s=i(0),a=i(3),c=i(2),l=i(162),u=i(4),d=i(7),h=i(14),f=i(38),p=i(11),_=i(163),v=i(50),g=i(164),m=i(74),y=function(t){return t.icon?'<span class="'+t.icon+' dhx_combobox-options__icon"></span> <span class="dhx_combobox-options__value">'+t.value+"</span>":t.src?'<img src="'+t.src+'" class="dhx_combobox-options__image"></img> <span class="dhx_combobox-options__value">'+t.value+"</span>":'<span class="dhx_combobox-options__value">'+t.value+"</span>"},b=function(t){function e(e,i){var n=t.call(this,e,r.extend({template:y,listHeight:224,itemHeight:32,disabled:!1},i))||this;n.config.itemsCount=n.config.itemsCount||n.config.showItemsCount,n.config.helpMessage=n.config.helpMessage||n.config.help,n.config.cellHeight&&32===n.config.itemHeight&&(n.config.itemHeight=n.config.cellHeight),n.config.labelInline&&(n.config.labelPosition="left"),Array.isArray(n.config.data)?(n.events=new a.EventSystem(n),n.data=new d.DataCollection({},n.events),n.data.parse(n.config.data)):n.config.data?(n.data=n.config.data,n.events=n.data.events,n.events.context=n):(n.events=new a.EventSystem(n),n.data=new d.DataCollection({},n.events)),n.popup=new p.Popup,n.popup.events.on(p.PopupEvents.afterShow,function(){n.paint()}),n.popup.events.on(p.PopupEvents.afterHide,function(){n.config.multiselection&&(n._state.value=""),n.paint()}),n.popup.events.on(p.PopupEvents.beforeHide,function(t){if(t){if(!n.events.fire(m.ComboboxEvents.beforeClose))return;n.events.fire(m.ComboboxEvents.afterClose),n.events.fire(m.ComboboxEvents.close)}}),n.config.readonly&&(n._keyListener=new _.KeyListener),n._state={value:"",ignoreNext:!1,canDelete:!1,unselectActive:!1,currentState:m.ComboState.default},n._initHandlers(),n._createLayout(),n._initEvents();var o=s.create({render:function(){return n._draw()},hooks:{didRedraw:function(){n.popup.isVisible()&&(n.focus(),n._configurePopup())}}});return n.mount(e,o),n}return n(e,t),e.prototype.focus=function(){if(this.config.disabled)return!1;this.getRootView().refs.input.el.focus()},e.prototype.enable=function(){this.config.disabled=!1,this.paint()},e.prototype.disable=function(){this.config.disabled=!0,this.paint()},e.prototype.isDisabled=function(){return this.config.disabled},e.prototype.clear=function(){if(this.config.disabled)return!1;this.list.selection.remove(),this._state.value="",this._filter(),this.paint()},e.prototype.getValue=function(t){var e=this.list.selection.getId();return t?r.wrapBox(e):Array.isArray(e)?e.join(","):e},e.prototype.setValue=function(t){var e=this;if(this.config.disabled)return!1;if(this._filter(),this.list.selection.remove(),this._state.value="",this.config.multiselection)"string"==typeof t&&(t=t.split(",")),t.forEach(function(t){return e.list.selection.add(t)});else{var i=r.unwrapBox(t);this.list.selection.add(i);var n=this.data.getItem(i);n&&(this._state.value=this._getItemText(n))}this.paint()},e.prototype.destructor=function(){this.popup.destructor(),this.events.clear(),this.list.destructor(),this._layout.config=null,this._layout.destructor(),this.unmount()},e.prototype.setState=function(t){switch(t){case"success":this._state.currentState=m.ComboState.success;break;case"error":this._state.currentState=m.ComboState.error;break;default:this._state.currentState=m.ComboState.default}this.paint()},e.prototype._createLayout=function(){var t=this,e=this.list=new f.List(null,{template:this.config.template,virtual:this.config.virtual,keyNavigation:function(){return t.popup.isVisible()},multiselection:this.config.multiselection,itemHeight:this.config.itemHeight,height:this.config.listHeight,data:this.data}),i=this._layout=new h.Layout(this.popup.getContainer(),{css:"dhx_combobox-options dhx_combobox__options",rows:[{id:"select-unselect-all",hidden:!this.config.multiselection||!this.config.selectAllButton},{id:"list",css:"dhx_layout-cell--gravity"},{id:"not-found",hidden:!0}],on:{click:{".dhx_combobox__action-select-all":this._handlers.selectAll}}});i.getCell("list").attach(e),this.config.multiselection&&this.config.selectAllButton&&i.getCell("select-unselect-all").attach(g.selectAllView)},e.prototype._initHandlers=function(){var t=this;this.config.helpMessage&&(this._helper=new p.Popup({css:"dhx_tooltip dhx_tooltip--forced dhx_tooltip--light"}),this._helper.attachHTML(this.config.helpMessage)),this._handlers={showHelper:function(e){e.preventDefault(),e.stopPropagation(),t._helper.show(e.target)},selectAll:function(){t.list.selection.remove(),t._state.unselectActive?(t.data.filter(),t.list.selection.getId().forEach(function(e){t.list.selection.remove(e)}),t.config.selectAllButton&&(t._layout.getCell("select-unselect-all").attach(g.selectAllView),t._state.unselectActive=!1)):(t.data.filter(),t.list.selection.add(),t.config.selectAllButton&&(t._layout.getCell("select-unselect-all").attach(g.unselectAllView),t._state.unselectActive=!0)),t.paint()},onkeydown:function(e){var i;(t.popup.isVisible()||e.which!==l.KEY_CODES.DOWN_ARROW||t._showOptions(),t.popup.isVisible()&&e.which===l.KEY_CODES.RIGHT_ARROW)&&(t.config.readonly&&!t.config.multiselection&&(i=t.list.getFocusIndex())>=0&&i<=t.data.getLength()&&(e.preventDefault(),t.list.setFocusIndex(i+1)));t.popup.isVisible()&&e.which===l.KEY_CODES.LEFT_ARROW&&(t.config.readonly&&!t.config.multiselection&&(i=t.list.getFocusIndex())>=0&&i<=t.data.getLength()&&(e.preventDefault(),t.list.setFocusIndex(i-1)));t.popup.isVisible()&&e.which===l.KEY_CODES.ESC&&t._hideOptions(),t.popup.isVisible()&&e.which===l.KEY_CODES.ENTER&&t.setValue(t.list.data.getId(t.list.getFocusIndex()))},onkeyup:function(e){if(t.config.multiselection&&!t.config.itemsCount)if(t._state.ignoreNext)t._state.ignoreNext=!1;else if(e.which===l.KEY_CODES.BACKSPACE&&t._state.canDelete&&t.list.selection.getId().length){var i=t.list.selection.getId(),n=i[i.length-1];t.list.selection.remove(n),t.paint(),t.paint()}},oninput:function(e){if(!t.config.disabled){var i=e.target.value;t.events.fire(m.ComboboxEvents.input,[i]),t._state.value=i,t._filter(),i.length?t._state.canDelete=!1:(t._state.ignoreNext=!0,t._state.canDelete=!0),t.config.multiselection||(t.list.selection.remove(),t.paint()),t.popup.isVisible()||t._showOptions()}},oninputclick:function(e){if(!t.config.disabled){if(t.focus(),e.target.classList.contains("dhx_combobox__action-remove")){var i=c.locate(e);if(!i)return;return t.list.selection.remove(i),void t.paint()}if(e.target.classList.contains("dhx_combobox__action-clear-all"))return t.list.selection.getId().forEach(function(e){return t.list.selection.remove(e)}),t.config.selectAllButton&&t._state.unselectActive&&(t._layout.getCell("select-unselect-all").attach(g.selectAllView),t._state.unselectActive=!1),void t.paint();e.preventDefault(),t.popup.isVisible()?t.focus():t._showOptions()}},toggleIcon:function(){t.focus(),t.popup.isVisible()?t._hideOptions():t._showOptions()}}},e.prototype._initEvents=function(){var t=this;this.list.events.on(f.ListEvents.click,function(){t.config.multiselection||t._hideOptions()}),this.data.events.on(d.DataEvents.change,function(e,i,n){n&&n.hasOwnProperty("$selected")&&t._updateSelectedItem(e)}),this.config.readonly&&this.popup.events.on(p.PopupEvents.afterShow,function(){if(t._state.value){var e=t.list.selection.getId();t.list.setFocus(e)}else t.list.setFocus(t.data.getId(0));t._keyListener.startNewListen(function(e){return t._findBest(e)})})},e.prototype._showOptions=function(){this._state.value.length&&(this._state.canDelete=!0),this._filter(),this._configurePopup()&&this.events.fire(m.ComboboxEvents.open)},e.prototype._configurePopup=function(){var t=this.getRootView();if(!t||!t.refs||!t.refs.holder)return!1;if(!this.popup.isVisible()){var e=t.refs.holder.el;this.popup.getContainer().style.width=e.offsetWidth+"px",this.popup.show(e,{mode:c.Position.bottom})}return!0},e.prototype._hideOptions=function(){this.events.fire(m.ComboboxEvents.beforeClose)&&(this.config.readonly&&this._keyListener.endListen(),this.list.setFocus(this.data.getId(0)),this.config.multiselection||this.config.readonly||this.list.selection.contains()||(this._state.value=""),this.popup.hide(),this.paint(),this.events.fire(m.ComboboxEvents.afterClose),this.events.fire(m.ComboboxEvents.close))},e.prototype._filter=function(){var t=this;if(!this.config.readonly){if(this.data.filter(function(e){return t.config.filter?t.config.filter(e,t._state.value):r.isEqualString(t._state.value,t._getItemText(e))}),this.config.multiselection)this.list.setFocus(this.data.getId(0));else{var e=this.data.getIndex(this.list.selection.getId());this.list.setFocus(this.data.getId(e>-1?e:0))}0===this.data.getLength()?(this.config.multiselection&&this.config.selectAllButton&&this._layout.getCell("select-unselect-all").hide(),this._layout.getCell("list").hide(),this._layout.getCell("not-found").attach(g.emptyListView),this._layout.getCell("not-found").show()):(this.config.multiselection&&this.config.selectAllButton&&this._layout.getCell("select-unselect-all").show(),this._layout.getCell("not-found").isVisible()&&(this._layout.getCell("list").show(),this._layout.getCell("not-found").hide()))}},e.prototype._findBest=function(t){var e=this,i=this.data.find(function(i){return r.isEqualString(t,e._getItemText(i))});i&&this.list.selection.getId()!==i.id&&(this.list.setFocus(i.id),this.list.selection.add(i.id),this.paint())},e.prototype._draw=function(){var t=this.config,e=t.multiselection,i=t.labelPosition,n=t.labelWidth,r=t.hiddenLabel,a=t.required,c=t.disabled,l=t.css,u=t.label,d=t.helpMessage,h=t.readonly,f=t.placeholder,p=e?null:this.data.getItem(this.list.selection.getId()),_=!this.list.selection.getId()||0===this.list.selection.getId().length,v="left"===i&&n?n:"";return s.el(".dhx_widget.dhx_combobox"+("left"===i?".dhx_combobox--label-inline":"")+(r?".dhx_combobox--sr_only":"")+(a?".dhx_combobox--required":"")+(c?".dhx_combobox--disabled":"")+(l?"."+l:""),{dhx_widget_id:this._uid,onkeydown:this._handlers.onkeydown,onkeyup:this._handlers.onkeyup},[u?s.el("label.dhx_label.dhx_combobox__label",{style:{minWidth:v,maxWidth:v},class:d?"dhx_label--with-help":"",onclick:this._handlers.oninputclick},d?[s.el("span.dhx_label__holder",u),s.el("span.dhx_label-help.dxi.dxi-help-circle-outline",{tabindex:"0",role:"button",onclick:this._handlers.showHelper})]:u):null,s.el("div.dhx_combobox-input-box"+(c?".dhx_combobox-input-box--disabled":"")+(h?".dhx_combobox-input-box--readonly":"")+(this._state.currentState===m.ComboState.error?".dhx_combobox-input-box--state_error":"")+(this._state.currentState===m.ComboState.success?".dhx_combobox-input-box--state_success":""),{_ref:"holder"},[s.el("div.dhx_combobox-input__icon",{onclick:this._handlers.toggleIcon},[s.el("span"+(this.popup.isVisible()?".dxi.dxi-menu-up":".dxi.dxi-menu-down"))]),s.el("div.dhx_combobox-input-list-wrapper",{onclick:this._handlers.oninputclick},[s.el("ul.dhx_combobox-input-list",o(this._drawSelectedItems(),[s.el("li.dhx_combobox-input-list__item.dhx_combobox-input-list__item--input",[s.el("input.dhx_combobox-input",{oninput:this._handlers.oninput,_ref:"input",_key:this._uid,type:"text",placeHolder:_&&f?f:void 0,value:h&&p?this._getItemText(p):this._state.value,readOnly:h||c,required:a})])]))])])])},e.prototype._drawSelectedItems=function(){var t=this;if(!this.config.multiselection)return[];if(this.config.itemsCount){var e=this.list.selection.getId().length;return e?[s.el("li.dhx_combobox-input-list__item.dhx_combobox-tag",[s.el("span.dhx_combobox-tag__value",function(t,e){return"function"==typeof e?e(t):t+" "+v.default.selectedItems}(e,this.config.itemsCount)),s.el("button.dhx_button.dhx_combobox-tag__action.dhx_combobox__action-clear-all",[s.el("span.dhx_button__icon.dxi.dxi-close-circle")])])]:[]}return this.list.selection.getId().map(function(e){var i=t.data.getItem(e);return i?s.el("li.dhx_combobox-input-list__item.dhx_combobox-tag",{dhx_id:e},[t._drawImageOrIcon(i),s.el("span.dhx_combobox-tag__value",t._getItemText(i)),s.el("button.dhx_button.dhx_button--icon.dhx_combobox-tag__action.dhx_combobox__action-remove",{type:"button"},[s.el("span.dhx_button__icon.dxi.dxi-close-circle")])]):null})},e.prototype._drawImageOrIcon=function(t){return t.src?s.el("img.dhx_combobox-tag__image",{src:t.src}):t.icon?s.el("span.dhx_combobox-tag__icon",{class:t.icon}):null},e.prototype._getItemText=function(t){return t?t.value:null},e.prototype._updateSelectedItem=function(t){if(this.config.multiselection)return this.data.getItem(t).$selected?this.config.selectAllButton&&!this._state.unselectActive&&this.data.getLength()===this.list.selection.getId().length&&(this._layout.getCell("select-unselect-all").attach(g.unselectAllView),this._state.unselectActive=!0):this.config.selectAllButton&&this._state.unselectActive&&(this._layout.getCell("select-unselect-all").attach(g.selectAllView),this._state.unselectActive=!1),this._state.value.length||(this._state.canDelete=!0),void this.paint();this._state.value=this._getItemText(this.data.getItem(t))||"",this.paint()},e}(u.View);e.Combobox=b},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.KEY_CODES={BACKSPACE:8,ENTER:13,ESC:27,DOWN_ARROW:40,LEFT_ARROW:37,RIGHT_ARROW:39}},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=function(){function t(){var t=this;this._sequence="",document.addEventListener("keydown",function(e){if(t._isActive){var i=e.key;"Backspace"===i&&t._sequence.length>0&&(t._sequence=t._sequence.slice(0,t._sequence.length-1),t._change()),i.length<2&&(t._sequence+=i,t._change())}})}return t.prototype.startNewListen=function(t){this._isActive=!0,this._sequence="",this._currentAction=t},t.prototype.endListen=function(){this._currentAction=null,this.reset(),this._isActive=!1},t.prototype.reset=function(){this._sequence=""},t.prototype._change=function(){this._currentAction(this._sequence),this._addClearTimeout()},t.prototype._addClearTimeout=function(){var t=this;this._clearTimeout&&clearTimeout(this._clearTimeout),this._clearTimeout=setTimeout(function(){t.reset(),t._clearTimeout=null},2e3)},t}();e.KeyListener=n},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(0),o=i(50);e.selectAllView=function(){return n.el(".dhx_list-item.dhx_combobox-options__item.dhx_combobox-options__item--select-all.dhx_combobox__action-select-all",o.default.selectAll)},e.unselectAllView=function(){return n.el(".dhx_list-item.dhx_combobox-options__item.dhx_combobox-options__item--select-all.dhx_combobox__action-select-all",o.default.unselectAll)},e.emptyListView=function(){return n.el("ul.dhx_list",[n.el("li.dhx_list-item.dhx_combobox-options__item",{},o.default.notFound)])}},function(t,e,i){"use strict";function n(t){for(var i in t)e.hasOwnProperty(i)||(e[i]=t[i])}Object.defineProperty(e,"__esModule",{value:!0}),n(i(166)),n(i(51))},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),o=this&&this.__assign||function(){return(o=Object.assign||function(t){for(var e,i=1,n=arguments.length;i<n;i++)for(var o in e=arguments[i])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)};Object.defineProperty(e,"__esModule",{value:!0});var r=i(1),s=i(0),a=i(13),c=i(38),l=i(4),u=i(7),d=i(3),h=i(2),f=i(22),p=i(51),_=i(167),v=function(t){function e(e,i){void 0===i&&(i={});var n=t.call(this,e,r.extend({keyNavigation:!0,itemsInRow:1,multiselectionMode:i.multiselectionMode?i.multiselectionMode:"click",gap:"0px",editable:!1},i))||this;"ctrlClick"===n.config.multiselectionMode&&(n.config.multiselection="ctrlClick"),n.config.editable=n.config.editable||n.config.editing,Array.isArray(n.config.data)?(n.events=new d.EventSystem(n),n.data=new u.DataCollection({},n.events),n.data.parse(n.config.data)):n.config.data&&n.config.data.events?(n.data=n.config.data,n.events=n.data.events,n.events.context=n):(n.events=new d.EventSystem(n),n.data=new u.DataCollection({},n.events)),n.selection=new c.Selection({multiselection:n.config.multiselection},n.data),n._getHotkeys();var a=function(t){return function(e,i){i&&i instanceof Array?i.map(function(e){return n.data.exists(e)&&n.data.update(e,t)}):n.data.exists(e)&&n.data.update(e,t)}};n.events.on(u.DataEvents.change,function(){n.paint()}),n.events.on(u.DragEvents.canDrop,a({$drophere:!0})),n.events.on(u.DragEvents.cancelDrop,a({$drophere:void 0})),n.events.on(u.DragEvents.dragStart,a({$dragtarget:!0})),n.events.on(u.DragEvents.dragEnd,a({$dragtarget:void 0})),n.events.on(p.DataViewEvents.afterEditEnd,function(t,e){var i=n.data.getItem(e);n.data.update(e,o(o({},i),{value:t})),n._edited=null,n._getHotkeys(),n.paint()}),n.selection.events.on(f.SelectionEvents.afterSelect,function(t){n.setFocus(t)}),n._handlers={onmousedown:function(t){var e=[],i=h.locateNode(t,"dhx_id"),o=i&&i.getAttribute("dhx_id"),r=n.selection.getId();return n.config.multiselection&&r instanceof Array&&r.map(function(t){t!==o&&e.push(n.getRootView().refs[t].el)}),n.config.dragMode&&!n._edited?u.dragManager.onMouseDown(t,n.selection.getId(),e):null},ondragstart:function(){return!(n.config.dragMode&&!n._edited)&&null},oncontextmenu:function(t){var e=h.locate(t);e&&(n.events.fire(p.DataViewEvents.itemRightClick,[e,t]),n.events.fire(p.DataViewEvents.contextmenu,[e,t]))},ondblclick:function(t){var e=h.locate(t);e&&(n.config.editable&&n.editItem(e),n.events.fire(p.DataViewEvents.doubleClick,[e,t]))},onclick:function(t){var e=h.locate(t);e&&(n.setFocus(e),n.selection.add(e,t.ctrlKey||t.metaKey,t.shiftKey),n.events.fire(p.DataViewEvents.click,[e,t]))},onmouseover:function(t){var e=h.locate(t),i=h.locateNode(t,"dhx_id","relatedTarget");if(i||!e){if(i){var o=i.getAttribute("dhx_id")?i.getAttribute("dhx_id"):null;e&&e!==(o||"")&&n.events.fire(p.DataViewEvents.itemMouseOver,[e,t])}}else n.events.fire(p.DataViewEvents.itemMouseOver,[e,t])}},n.config.dragMode&&u.dragManager.setItem(n._uid,n);var l=s.create({render:function(){return n._draw()},hooks:{didRedraw:function(t){var e=t.node.el,i=e.scrollHeight>e.offsetHeight,n=t.node.attrs.class.replace(" dhx_dataview--has-scroll",""),o=i?n+" dhx_dataview--has-scroll":n;t.node.patch({class:o})}}});return n.mount(e,l),n}return n(e,t),e.prototype.editItem=function(t){this._edited=t,this.data.getItem(this._edited)&&this.events.fire(p.DataViewEvents.beforeEditStart,[t])?(this._getHotkeys(),this.paint(),this.events.fire(p.DataViewEvents.afterEditStart,[t])):this._edited=null},e.prototype.getFocusItem=function(){return this.data.getItem(this.data.getId(this._focusIndex))},e.prototype.setItemInRow=function(t){this.config.itemsInRow=t,this.paint()},e.prototype.setFocus=function(t){var e=this.data.getIndex(t);this._setFocusIndex(e)},e.prototype.getFocus=function(){var t=this.data.getItem(this.data.getId(this._focusIndex));if(t)return t.id},e.prototype.destructor=function(){this.events.clear(),this._navigationDestructor&&this._navigationDestructor(),this._documentClickDestuctor&&this._documentClickDestuctor(),this.unmount()},e.prototype.getFocusIndex=function(){return this._focusIndex},e.prototype.setFocusIndex=function(t){this._setFocusIndex(t)},e.prototype.edit=function(t){this.editItem(t)},e.prototype._setFocusIndex=function(t){if(!(t<0||t>this.data.getLength()-1)){this._focusIndex=t;var e=this.getRootNode();if(e&&e.parentNode){var i=e.children[Math.floor(this._focusIndex/this.config.itemsInRow)];if(i){var n=i.children[this._focusIndex%this.config.itemsInRow],o=parseInt(this.config.gap.toString().replace("px",""),null);n.offsetTop>=e.clientHeight+e.scrollTop-n.clientHeight?e.scrollTop=n.offsetTop-e.clientHeight+n.clientHeight+o:n.offsetTop<e.scrollTop-o&&(e.scrollTop=n.offsetTop-o)}this.events.fire(p.DataViewEvents.focusChange,[this._focusIndex,this.data.getId(this._focusIndex)]),this.paint()}}},e.prototype._renderItem=function(t,e,i){var n=this.config,o=n.itemsInRow,r=n.gap,a=n.template,c=n.itemHeight,l=a?a(t):t.htmlContent,u=function(t){return parseFloat(t)};return t.id===this._edited?_.getEditor(t,this).toHTML(i):s.el("div",{class:"dhx_dataview-item"+(t.$selected?" dhx_dataview-item--selected":"")+(e?" dhx_dataview-item--focus":"")+(t.$drophere&&!this._edited?" dhx_dataview-item--drophere":"")+(t.$dragtarget&&!this._edited?" dhx_dataview-item--dragtarget":"")+(this.config.dragMode&&!this._edited?" dhx_dataview-item--drag":"")+(u(r)?" dhx_dataview-item--with-gap":"")+(t.css&&t.$selected||t.css&&e?"":t.css?" "+t.css:"")+(i?" dhx_dataview-item--last-item-in-row":""),style:{width:"calc("+100/o+"% - "+u(r)+" * "+(o-1)/o+"px)","margin-right":i?"":r,height:a?null:c},_key:t.id,dhx_id:t.id,_ref:t.id},l?[s.el(".dhx_dataview-item__inner-html",{".innerHTML":l})]:t.value||t.text||t.value)},e.prototype._draw=function(){var t=this,e=this.config,i=e.itemsInRow,n=e.css,r=e.gap,a=0,c=this.data.reduce(function(e,n,o){return 0===a&&e.push([]),e[e.length-1].push(t._renderItem(n,o===t._focusIndex,a===i-1)),a=(a+1)%i,e},[]);return s.el("",o(o({},this._handlers),{dhx_widget_id:this._uid,class:(n||"")+" dhx_widget dhx_dataview"+(this.config.multiselection&&this.selection.getItem()?" dhx_no-select--pointer":""),style:{height:this.config.height}}),c.map(function(t){return s.el(".dhx_dataview-row",{style:{margin:r}},t)}))},e.prototype._getHotkeys=function(){var t=this;if(this.config.keyNavigation)if(this._edited)this._navigationDestructor&&this._navigationDestructor();else{var e=this.config.keyNavigation;"function"!=typeof this.config.keyNavigation&&(this._widgetInFocus=!1,e=function(){return t._widgetInFocus},this._documentClickDestuctor=r.detectWidgetClick(this._uid,function(e){return t._widgetInFocus=e}));var i=function(t){return function(e){e.preventDefault(),t()}},n={arrowDown:i(function(){return t.setFocusIndex(t._focusIndex+t.config.itemsInRow)}),arrowUp:i(function(){return t.setFocusIndex(t._focusIndex-t.config.itemsInRow)}),arrowLeft:i(function(){return t.setFocusIndex(t._focusIndex-1)}),arrowRight:i(function(){return t.setFocusIndex(t._focusIndex+1)}),enter:function(e){var i=t.data.getId(t._focusIndex);t.selection.add(i),t.events.fire(p.DataViewEvents.click,[i,e])},"enter+shift":function(e){var i=t.data.getId(t._focusIndex);t.selection.add(i,!1,!0),t.events.fire(p.DataViewEvents.click,[i,e])},"enter+ctrl":function(e){var i=t.data.getId(t._focusIndex);t.selection.add(i,!0,!1),t.events.fire(p.DataViewEvents.click,[i,e])}};h.isIE()&&(delete(n=o({up:n.arrowUp,down:n.arrowDown,right:n.arrowRight,left:n.arrowLeft},n)).arrowUp,delete n.arrowDown,delete n.arrowRight,delete n.arrowLeft),this._navigationDestructor=a.addHotkeys(n,e)}},e}(l.View);e.DataView=v},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(168);e.getEditor=function(t,e){return new n.InputEditor(t,e)}},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(0),o=i(51),r=function(){function t(t,e){var i=this;this._dataView=e,this._config=e.config,this._item=t,this._dataView.events.on(o.DataViewEvents.focusChange,function(t,e){i._mode&&e!==i._item.id&&i.endEdit()}),this._initHandlers()}return t.prototype.endEdit=function(){if(this._input){var t=this._input.value;this._dataView.events.fire(o.DataViewEvents.beforeEditEnd,[t,this._item.id])?(this._input.removeEventListener("blur",this._handlers.onBlur),this._input.removeEventListener("change",this._handlers.onChange),this._handlers={},this._mode=!1,this._dataView.events.fire(o.DataViewEvents.afterEditEnd,[t,this._item.id])):this._input.focus()}},t.prototype.toHTML=function(t){this._mode=!0;var e=this._config,i=e.itemsInRow,o=e.gap,r=function(t){return parseFloat(t)};return n.el(".dhx_input__wrapper",{style:{width:"calc("+100/i+"% - "+r(o)+" * "+(i-1)/i+"px)",maxWidth:"calc("+100/i+"% - "+r(o)+" * "+(i-1)/i+"px)",marginRight:t?"":o}},[n.el("div.dhx_input__container",{style:{height:"100%"}},[n.el("input.dhx_input",{class:(this._item.css?" "+this._item.css:"")+(t?" dhx_dataview-item--last-item-in-row":""),style:{padding:"8px, 12px",width:"100%",height:"100%"},_hooks:{didInsert:this._handlers.didInsert},_key:this._item.id,dhx_id:this._item.id})])])},t.prototype._initHandlers=function(){var t=this;this._handlers={onBlur:function(){t.endEdit()},onChange:function(){t.endEdit()},didInsert:function(e){var i=e.el;t._input=i,i.focus(),i.value=t._item.value,i.setSelectionRange(0,i.value.length),i.addEventListener("change",t._handlers.onChange),i.addEventListener("blur",t._handlers.onBlur)}}},t}();e.InputEditor=r},function(t,e,i){"use strict";function n(t){for(var i in t)e.hasOwnProperty(i)||(e[i]=t[i])}Object.defineProperty(e,"__esModule",{value:!0}),n(i(170)),n(i(8));var o=i(8);e.FormEvents=o.FormEvents},function(t,e,i){"use strict";(function(t){var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),o=this&&this.__rest||function(t,e){var i={};for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&e.indexOf(n)<0&&(i[n]=t[n]);if(null!=t&&"function"==typeof Object.getOwnPropertySymbols){var o=0;for(n=Object.getOwnPropertySymbols(t);o<n.length;o++)e.indexOf(n[o])<0&&Object.prototype.propertyIsEnumerable.call(t,n[o])&&(i[n[o]]=t[n[o]])}return i};Object.defineProperty(e,"__esModule",{value:!0});var r=i(3),s=i(4),a=i(14),c=i(25),l=i(1),u=i(30),d=i(31),h=i(171),f=i(172),p=i(173),_=i(52),v=i(174),g=i(176),m=i(177),y=i(178),b=i(179),x=i(180),w=i(9),k=i(181),C=i(182),E=i(183),S=i(8),O=function(e){function i(t,i){var n=e.call(this,null,l.extend({labelWidth:"auto",inputType:"text",disabled:!1},i))||this;return n._state={},n.events=new r.EventSystem(n),n.container=t,n._initUI(t),n.config.disabled&&n.disable(),n}return n(i,e),i.prototype.send=function(e,i,n){var o=this;if(void 0===i&&(i="POST"),this.events.fire(S.FormEvents.beforeSend))return new t(function(t,r){var s=new XMLHttpRequest;switch(s.onload=function(){200===s.status?t(s.response||s.responseText):r({status:s.status,statusText:s.statusText})},s.onloadend=function(){s.readyState===XMLHttpRequest.DONE&&200===s.status&&o.events.fire(S.FormEvents.afterSend)},s.onerror=function(){r({status:s.status,statusText:s.statusText})},"GET"===i&&(e+="?"+encodeURIComponent(JSON.stringify(o.getValue()))),s.open(i,e),n||s.setRequestHeader("Content-Type","application/json"),i){case"POST":case"DELETE":case"PUT":s.send(n?o.getValue(!0):JSON.stringify(o.getValue()));break;case"GET":s.send();default:s.send()}})},i.prototype.clear=function(t){switch(t){case S.ClearMethod.value:this._clear();break;case S.ClearMethod.validation:this._clearValidate();break;default:this._clear(),this._clearValidate()}this.paint()},i.prototype.setValue=function(t){for(var e in t)for(var i in this._attachments)"function"==typeof this._attachments[i].setValue&&(this._attachments[i].config.name===e||this._attachments[i].config.id===e&&!this._attachments[i].config.name)&&this._attachments[i].setValue(t[e])},i.prototype.getValue=function(t){if(t){var e=new FormData;for(var i in this._state)if(Array.isArray(this._state[i]))for(var n=0,o=this._state[i];n<o.length;n++){var r=o[n];e.append(i+"[]",r)}else e.append(i,this._state[i]);return e}return this._state},i.prototype.getItem=function(t){for(var e in this._attachments)if(e===t)return this._attachments[e]},i.prototype.validate=function(){var t=this._attachments,e=!0;for(var i in t){var n=t[i];n.validate&&!n.validate()&&(e=!1,this.events.fire(S.FormEvents.validationFail,[i,n]))}return e},i.prototype.getRootView=function(){return this.layout.getRootView()},i.prototype.disable=function(){for(var t in this.config.disabled=!0,this._attachments)"function"==typeof this._attachments[t].disable&&this._attachments[t].disable()},i.prototype.enable=function(){for(var t in this.config.disabled=!1,this._attachments)"function"==typeof this._attachments[t].enable&&this._attachments[t].enable()},i.prototype.isDisabled=function(t){if(!t)return this.config.disabled;for(var e in this._attachments)if(e===t)return this._attachments[e].config.disabled},i.prototype.forEach=function(t){for(var e=Object.values(this._attachments),i=0;i<e.length;i++)t.call(this,e[i],i,e)},i.prototype.destructor=function(){this.events.clear(),this.unmount()},i.prototype.setConfig=function(t){this._setConfig(t)},i.prototype._setConfig=function(t){this.unmount(),this.config=t,this._initUI(this.container),this.paint()},i.prototype._addLayoutItem=function(t){var e=this;t.id=t.id||l.uid();var i=t.id,n=t.name||t.id,r=t.width,s=t.height,a=t.css,w=(t.gravity,o(t,["width","height","css","gravity"])),O={id:i,width:r,height:s,css:a};switch("gravity"in t&&(O.gravity=t.gravity),w.type){case S.FormItemType.button:(this._attachments[i]=new f.Button(null,w)).events.on(f.ButtonEvents.click,function(t){t.preventDefault(),w.submit?e.validate()&&(e.send(w.url),e.events.fire(S.FormEvents.buttonClick,[i,t])):e.events.fire(S.FormEvents.buttonClick,[i,t])});break;case S.FormItemType.datepicker:var M=this._attachments[i]=new h.DateInput(null,w);this._state[n]=M.getValue(),M.calendar.events.on(c.CalendarEvents.change,function(){var t=M.getValue();e._state[n]=t,e.events.fire(S.FormEvents.change,[n,t])}),M.events.on(S.BaseElementEvent.configUpdate,function(t){var i=M.getValue();e._state[n]=i,e.layout.getCell(M.config.id).config=e._checkLayoutConfig(t,{}),M.calendar.events.on(c.CalendarEvents.change,function(){i=M.getValue(),e._state[n]=i,e.events.fire(S.FormEvents.change,[n,i])})});break;case S.FormItemType.checkbox:var T=this._attachments[i]=new p.Checkbox(null,w);this._state[n]=T.getValue(),T.events.on(S.BaseElementEvent.change,function(){var t=T.getValue();e._state[n]=t,e.events.fire(S.FormEvents.change,[n,t])}),T.events.on(S.BaseElementEvent.configUpdate,function(t){var i=T.getValue();e._state[n]=i,e.layout.getCell(T.config.id).config=e._checkLayoutConfig(t,{})});break;case S.FormItemType.combo:var I=this._attachments[i]=new b.Combo(null,w);this._state[n]=I.getValue(),I.events.on(S.BaseElementEvent.change,function(t){var i=I.getValue();e._state[n]=i,e.events.fire(S.FormEvents.change,[n,t])}),I.events.on(S.BaseElementEvent.configUpdate,function(t){var i=I.getValue();e._state[n]=i,e.layout.getCell(I.config.id).config=e._checkLayoutConfig(t,{})});break;case S.FormItemType.input:var D=this._attachments[i]=new _.Input(null,w);this._state[n]=D.getValue(),D.events.on(S.BaseElementEvent.change,function(){var t=D.getValue();e._state[n]=t,e.events.fire(S.FormEvents.change,[n,t])}),D.events.on(S.BaseElementEvent.configUpdate,function(t){var i=D.getValue();e._state[n]=i,e.layout.getCell(D.config.id).config=e._checkLayoutConfig(t,{})});break;case S.FormItemType.radioGroup:var P=this._attachments[i]=new v.RadioGroup(null,w);this._state[n]=P.getValue(),P.events.on(S.BaseElementEvent.change,function(){var t=P.getValue();e._state[n]=t,e.events.fire(S.FormEvents.change,[n,t])}),P.events.on(S.BaseElementEvent.configUpdate,function(t){var i=P.getValue();e._state[n]=i,e.layout.getCell(P.config.id).config=e._checkLayoutConfig(t,{})});break;case S.FormItemType.select:var V=this._attachments[i]=new g.Select(null,w);this._state[n]=V.getValue(),V.events.on(S.BaseElementEvent.change,function(){var t=V.getValue();e._state[n]=t,e.events.fire(S.FormEvents.change,[n,t])}),V.events.on(S.BaseElementEvent.configUpdate,function(t){var i=V.getValue();e._state[n]=i,e.layout.getCell(V.config.id).config=e._checkLayoutConfig(t,{})});break;case S.FormItemType.simpleVault:w.$vaultHeight=s;var L=this._attachments[i]=new k.SimpleVault(null,w);this._state[n]=L.getValue(),L.events.on(S.BaseElementEvent.change,function(){var t=L.getValue();e._state[n]=t,e.events.fire(S.FormEvents.change,[n,t])}),L.events.on(S.BaseElementEvent.configUpdate,function(t){var i=L.getValue();e._state[n]=i,e.layout.getCell(L.config.id).config=e._checkLayoutConfig(t,{})});break;case S.FormItemType.slider:var j=this._attachments[i]=new x.SliderForm(null,w);this._state[n]=j.getValue(),j.events.on(S.BaseElementEvent.change,function(){var t=j.getValue();e._state[n]=t,e.events.fire(S.FormEvents.change,[n,t])}),j.events.on(S.BaseElementEvent.configUpdate,function(t){var i=j.getValue();e._state[n]=i,e.layout.getCell(j.config.id).config=e._checkLayoutConfig(t,{})});break;case S.FormItemType.textarea:var H=this._attachments[i]=new m.Textarea(null,w);this._state[n]=H.getValue(),H.events.on(S.BaseElementEvent.change,function(){var t=H.getValue();e._state[n]=t,e.events.fire(S.FormEvents.change,[n,t])}),H.events.on(S.BaseElementEvent.configUpdate,function(t){var i=H.getValue();e._state[n]=i,e.layout.getCell(H.config.id).config=e._checkLayoutConfig(t,{})});break;case S.FormItemType.text:var A=this._attachments[i]=new y.Text(null,w);A.events.on(S.BaseElementEvent.configUpdate,function(t){e.layout.getCell(A.config.id).config=e._checkLayoutConfig(t,{})});break;case S.FormItemType.timepicker:var R=this._attachments[i]=new C.TimeInput(null,w);this._state[n]=R.getValue(),R.config.controls?R.timepicker.events.on(u.TimepickerEvents.apply,function(){var t=R.getValue();e._state[n]=t,e.events.fire(S.FormEvents.change,[n,t])}):R.timepicker.events.on(u.TimepickerEvents.change,function(){var t=R.getValue();e._state[n]=t,e.events.fire(S.FormEvents.change,[n,t])}),R.events.on(S.BaseElementEvent.configUpdate,function(t){var i=R.getValue();e._state[n]=i,e.layout.getCell(R.config.id).config=e._checkLayoutConfig(t,{}),R.config.controls?R.timepicker.events.on(u.TimepickerEvents.apply,function(){i=R.getValue(),e._state[n]=i,e.events.fire(S.FormEvents.change,[n,i])}):R.timepicker.events.on(u.TimepickerEvents.change,function(){i=R.getValue(),e._state[n]=i,e.events.fire(S.FormEvents.change,[n,i])})});break;case S.FormItemType.colorpicker:var F=this._attachments[i]=new E.ColorpickerInput(null,w);this._state[n]=F.getValue(),F.colorpicker.events.on(d.ColorpickerEvents.change,function(){var t=F.getValue();e._state[n]=t,e.events.fire(S.FormEvents.change,[n,t])}),F.events.on(S.BaseElementEvent.configUpdate,function(t){var i=F.getValue();e._state[n]=i,e.layout.getCell(F.config.id).config=e._checkLayoutConfig(t,{}),F.colorpicker.events.on(d.ColorpickerEvents.change,function(){i=F.getValue(),e._state[n]=i,e.events.fire(S.FormEvents.change,[n,i])})})}return O},i.prototype._addLayoutItems=function(t,e,i){var n=this;return t.map(function(t){if(t.type=t.type||e,w.isBlock(t)){var o={};return n._createLayoutConfig(t,o),o}return t.name=t.name||i,n._addLayoutItem(t)})},i.prototype._checkLayoutConfig=function(t,e){return l.isDefined(t.css)&&(e.css=t.css),l.isDefined(t.title)&&(e.header=t.title),l.isDefined(t.padding)&&(e.padding=t.padding),l.isDefined(t.gravity)&&(e.gravity=t.gravity),l.isDefined(t.width)&&(e.width=t.width),l.isDefined(t.height)&&(e.height=t.height),l.isDefined(t.align)&&(e.align=t.align),e},i.prototype._createLayoutConfig=function(t,e){e=this._checkLayoutConfig(t,e),l.isDefined(t.rows)?e.rows=this._addLayoutItems(t.rows,t.group,t.groupName):l.isDefined(t.cols)&&(e.cols=this._addLayoutItems(t.cols,t.group,t.groupName))},i.prototype._initUI=function(t){var e=this._attachments={},i={padding:"8px"};this.config.css=this.config.css||this.config.cellCss,this._createLayoutConfig(this.config,i);var n=this.layout=new a.Layout(t,i);for(var o in e)n.getCell(o).attach(e[o])},i.prototype._clear=function(){for(var t in this._state={},this._attachments){var e=this._attachments[t].config.name;"function"==typeof this._attachments[t].clear&&(this._attachments[t].clear(),e?this._state[e]=this._attachments[t].getValue():this._state[t]=this._attachments[t].getValue())}},i.prototype._clearValidate=function(){for(var t in this._attachments)"function"==typeof this._attachments[t].clearValidate&&this._attachments[t].clearValidate()},i}(s.View);e.Form=O}).call(this,i(12))},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}();Object.defineProperty(e,"__esModule",{value:!0});var o=i(25),r=i(3),s=i(0),a=i(18),c=i(11),l=i(8),u=i(9),d=function(t){function e(e,i){var n=t.call(this,null,i)||this;n.events=new r.EventSystem,n._initView(i);return n.mount(e,s.create({render:function(){return n._draw()}})),n}return n(e,t),e.prototype.disable=function(){this.config.disabled=!0,this.paint()},e.prototype.enable=function(){this.config.disabled=!1,this.paint()},e.prototype.isDisabled=function(){return this.config.disabled},e.prototype.validate=function(){var t,e=this.config,i=e.required,n=e.value;return t=e.validation?this.config.validation(n):!i||Boolean(n),this.config.$validationStatus=t?l.ValidationStatus.success:l.ValidationStatus.error,this.paint(),t},e.prototype.clearValidate=function(){this.config.$validationStatus=l.ValidationStatus.pre,this.paint()},e.prototype.setValue=function(t){this.calendar.setValue(t),this.paint()},e.prototype.getValue=function(t){var e=this.config.value;return t&&""!==e||"Date"===this.config.valueFormat&&""!==e?o.stringToDate(e,this.calendar.config.dateFormat)||"":e||""},e.prototype.clear=function(){this.config.value="",this.paint()},e.prototype.getWidget=function(){return this.calendar},e.prototype.setConfig=function(t){this._initView(t)},e.prototype._initView=function(t){var e=this;if(!u.isEmptyObj(t)){for(var i in this.calendar&&this.calendar.destructor(),this._popup&&this._popup.destructor(),this.config={type:this.config.type,id:this.config.id,name:this.config.name,disabled:!1,editable:!1,value:"",valueFormat:"string"},t)"id"!==i&&"type"!==i&&"name"!==i&&(this.config[i]=t[i]);this.config.editable=this.config.editable||this.config.editing,this._popup=new c.Popup({css:"dhx_widget--border-shadow"}),this.calendar=new o.Calendar(null,t),this._popup.attach(this.calendar),this.config.value&&(this.calendar.setValue(this.config.value),this.config.value=this.calendar.getValue()),this.calendar.events.on(o.CalendarEvents.change,function(){e.config.value=e.calendar.getValue(),e._popup.hide(),e.validate()}),this.events.on(l.BaseElementEvent.change,function(t){e.config.value=e._inputValidate(t),e._inputValidate(t)?e.calendar.setValue(t):e.validate()}),this.events.fire(l.BaseElementEvent.configUpdate,[this.config]),this.clearValidate()}},e.prototype._getHandlers=function(){var t=this;return{onfocus:function(){if(!t._popup.isVisible()){var e=t.getRootView().refs.input.el;t._popup.show(e)}},onchange:function(e){var i=e.target.value;t.events.fire(l.BaseElementEvent.change,[i])},onkeyup:function(e){13===e.keyCode&&(t._popup.isVisible()&&t._popup.hide(),t.getRootView().refs.input.el.blur())}}},e.prototype._inputValidate=function(t){var e=this.calendar.config.dateFormat;return o.stringToDate(t,e,!0)?t:""},e.prototype._draw=function(){var t=this.config,e=t.value,i=t.icon,n=t.required,o=t.disabled,r=t.placeholder,a=t.name,c=t.id,l=t.validation,d=t.editable;return s.el("div.dhx_form-group",{class:u.getFormItemCss(this.config,Boolean(n)||Boolean(l))},[this._drawLabel(),s.el(".dhx_input__wrapper",[s.el("div.dhx_input__container",{},[s.el(".dhx_input__icon",{class:i||"dxi dxi-calendar-today"}),s.el("input.dhx_input.dhx_input--icon-padding",{_key:this._uid,value:e,type:"text",_ref:"input",required:n,disabled:o,placeholder:r||"",name:a||"",id:c||this._uid,onfocus:this._handlers.onfocus,onchange:this._handlers.onchange,onkeyup:this._handlers.onkeyup,autocomplete:"off",readOnly:!d})]),u.getValidationMessage(this.config)&&s.el("span.dhx_input__caption",{},u.getValidationMessage(this.config))])])},e}(a.Label);e.DateInput=d},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),o=this&&this.__assign||function(){return(o=Object.assign||function(t){for(var e,i=1,n=arguments.length;i<n;i++)for(var o in e=arguments[i])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)};Object.defineProperty(e,"__esModule",{value:!0});var r,s=i(0),a=i(4),c=i(3);!function(t){t.click="click"}(r=e.ButtonEvents||(e.ButtonEvents={}));var l=function(t){function e(e,i){var n=t.call(this,e,o({disabled:!1},i))||this;n.events=new c.EventSystem,n._handlers={onclick:function(t){return n.events.fire(r.click,[t])}};return n.mount(e,s.create({render:function(){return n._draw()}})),n}return n(e,t),e.prototype.disable=function(){this.config.disabled=!0,this.paint()},e.prototype.enable=function(){this.config.disabled=!1,this.paint()},e.prototype.isDisabled=function(){return this.config.disabled},e.prototype.setValue=function(t){this.config.value=t,this.paint()},e.prototype._draw=function(){var t=this.config,e=t.color,i=t.size,n=t.view,o=t.full,r=t.loading,a=t.circle,c=t.icon,l=t.value,u=t.disabled,d=t.submit,h=t.id,f={danger:" dhx_button--color_danger",secondary:" dhx_button--color_secondary",primary:" dhx_button--color_primary",success:" dhx_button--color_success"}[e]||" dhx_button--color_primary",p={small:" dhx_button--size_small",medium:" dhx_button--size_medium"}[i]||" dhx_button--size_medium",_={flat:" dhx_button--view_flat",link:" dhx_button--view_link"}[n]||" dhx_button--view_flat",v=o?" dhx_button--width_full":"",g=a?" dhx_button--circle":"",m=r?" dhx_button--loading":"",y=c&&!l?" dhx_button--icon":"";return s.el("button",{disabled:u,id:h,onclick:this._handlers.onclick,type:d?"submit":"button",class:"dhx_button"+f+p+_+v+g+m+y},[c&&s.el("span.dhx_button__icon",{class:c}),l&&s.el("span.dhx_button__text",l),r&&s.el("span.dhx_button__loading",[s.el("span.dhx_button__loading-icon.dxi.dxi-loading")])])},e}(a.View);e.Button=l},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}();Object.defineProperty(e,"__esModule",{value:!0});var o=i(0),r=i(3),s=i(4),a=i(9),c=i(11),l=i(8),u=function(t){function e(e,i){void 0===i&&(i={});var n=t.call(this,e,i)||this;n._initView(i);return n.mount(e,o.create({render:function(){return n._draw()}})),n}return n(e,t),e.prototype.disable=function(){this.config.disabled=!0,this.paint()},e.prototype.enable=function(){this.config.disabled=!1,this.paint()},e.prototype.isDisabled=function(){return this.config.disabled},e.prototype.clear=function(){this.config.checked=!1,this.paint()},e.prototype.clearValidate=function(){this.config.$validationStatus=l.ValidationStatus.pre,this.paint()},e.prototype.setValue=function(t){this.events.fire(l.BaseElementEvent.change,[t]),this.config.checked=t,this.paint()},e.prototype.getValue=function(){return this.config.checked||!1},e.prototype.setConfig=function(t){this._initView(t)},e.prototype.validate=function(){var t=!this.config.required||this.config.checked;return this.config.$validationStatus=t?l.ValidationStatus.success:l.ValidationStatus.error,this.paint(),t},e.prototype._initView=function(t){var e=this;if(!a.isEmptyObj(t)){for(var i in this.config={type:this.config.type,id:this.config.id,name:this.config.name,disabled:!1},t)"id"!==i&&"type"!==i&&"name"!==i&&(this.config[i]=t[i]);this.config.helpMessage=this.config.helpMessage||this.config.help,this.config.labelInline&&(this.config.labelPosition="right"),this.events=new r.EventSystem,this._handlers={showHelper:function(t){t.preventDefault(),t.stopPropagation(),e._helper.show(t.target)},cancelUnusefulClick:function(t){t.preventDefault()},onchange:function(t){e.config.checked=t.target.checked,e.events.fire(l.BaseElementEvent.change,[t.target.checked]),e.validate()}},this.events.on(l.BaseElementEvent.change,function(t){e.config.checked=t}),this.events.fire(l.BaseElementEvent.configUpdate,[this.config]),this.clearValidate()}},e.prototype._draw=function(){this.config.helpMessage&&(this._helper?this._helper.attachHTML(this.config.helpMessage):(this._helper=new c.Popup({css:"dhx_tooltip dhx_tooltip--forced dhx_tooltip--light"}),this._helper.attachHTML(this.config.helpMessage)));var t=this.config,e=t.id,i=t.value,n=t.label,r=t.checked,s=t.disabled,l=t.name,u=t.helpMessage,d=t.labelWidth,h=t.labelPosition,f=t.required,p=t.hidden?" dhx_form-group--hidden":"";return o.el("label.dhx_checkbox.dhx_form-group",{class:a.getFormItemCss(this.config,Boolean(f))+p,style:{"margin-left":d&&"right"===h?"calc("+d+" + 16px)":""}},[o.el("input.dhx_checkbox__input",{type:"checkbox",id:e,value:i||"",name:l||"",disabled:s,checked:r,onchange:this._handlers.onchange,required:f}),o.el("span.dhx_checkbox__visual-input"),o.el("span.dhx_label",{class:u?"dhx_label--with-help":""},u?[o.el("span.dhx_label__holder",n),o.el("span.dhx_label-help.dxi.dxi-help-circle-outline",{tabindex:"0",role:"button",onclick:this._handlers.showHelper})]:n),a.getValidationMessage(this.config)&&o.el("span.dhx_input-caption",{onclick:this._handlers.cancelUnusefulClick},a.getValidationMessage(this.config))])},e}(s.View);e.Checkbox=u},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}();Object.defineProperty(e,"__esModule",{value:!0});var o=i(0),r=i(1),s=i(14),a=i(3),c=i(4),l=i(175),u=i(9),d=i(8),h=function(t){function e(e,i){var n=t.call(this,null,i)||this;n.events=new a.EventSystem,n._buttons=[],n._initView(i);return n.mount(e,o.create({render:function(){return n._draw()}})),n}return n(e,t),e.prototype.disable=function(){this.config.disabled=!0,this.paint()},e.prototype.enable=function(){this.config.disabled=!1,this.paint()},e.prototype.isDisabled=function(){return this.config.disabled},e.prototype.validate=function(){var t=this,e=!1;return this._buttons.map(function(i){t.config.required&&!i.config.checked||(e=!0)}),this._buttons.map(function(t){t.config.$validationStatus=e?d.ValidationStatus.success:d.ValidationStatus.error}),this.config.$validationStatus=e?d.ValidationStatus.success:d.ValidationStatus.error,this.paint(),e},e.prototype.clearValidate=function(){this.config.$validationStatus=d.ValidationStatus.pre,this._buttons.map(function(t){t.clearValidate()}),this.paint()},e.prototype.clear=function(){this._buttons.map(function(t){t.clear()}),this.paint()},e.prototype.getValue=function(){var t=this;return this._buttons.map(function(e){e.getValue()&&(t.config.value=e.getValue()||"")}),this.config.value||""},e.prototype.setValue=function(t){this._buttons.map(function(e){t===e.config.value?e.setValue(!0):e.setValue(!1)}),this.events.fire(d.BaseElementEvent.change),this.paint()},e.prototype.setConfig=function(t){this._initView(t)},e.prototype._initView=function(t){var e=this;if(!u.isEmptyObj(t)&&!u.isEmptyObj(t.options)){for(var i in this.layout&&this.layout.destructor(),0!==this._buttons.length&&(this._buttons.map(function(t){t.destructor()}),this._buttons=[]),this.config={type:this.config.type,id:this.config.id,name:this.config.name,disabled:!1,options:{}},t)"id"!==i&&"type"!==i&&"name"!==i&&(this.config[i]=t[i]);var n=this.config.options.rows||this.config.options.cols,o=this.config,a=o.preMessage,c=o.errorMessage,h=o.successMessage;n.map(function(t){t.id=t.id||r.uid()}),this.layout=new s.Layout(null,this.config.options),n.map(function(i){var n=new l.RadioButton(null,i);n.config.disabled=t.disabled,n.config.name=t.name,n.config.required=t.required,n.config.css=t.css,(a||c||h)&&(n.config.preMessage="",n.config.errorMessage="",n.config.successMessage=""),e._buttons.push(n),e.layout.getCell(i.id).attach(n),n.events.on(l.RadioButtonEvents.change,function(){e._buttons.map(function(t){t.config.id!==n.config.id&&t.setValue(!1)}),e.events.fire(d.BaseElementEvent.change,[]),e.validate()})}),this.events.fire(d.BaseElementEvent.configUpdate,[this.config]),this.clearValidate()}},e.prototype._draw=function(){var t=this._buttons[0].config,e=t.labelWidth,i=t.labelPosition,n=this.config.hidden?" dhx_form-group--hidden":"";return o.el("div.dhx_form-group",{class:u.getFormItemCss(this.config,Boolean(this.config.required))+n},[o.el("div.dhx_radio-group--container",{},[o.inject(this.layout.getRootView())]),o.el("div.dhx_caption--container",{style:{"margin-left":e&&"right"===i?"calc("+e+" + 16px)":""}},[o.el("span.dhx_input__caption",u.getValidationMessage(this.config))])])},e}(c.View);e.RadioGroup=h},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}();Object.defineProperty(e,"__esModule",{value:!0});var o,r=i(0),s=i(3),a=i(4),c=i(9),l=i(11),u=i(8);!function(t){t.change="change"}(o=e.RadioButtonEvents||(e.RadioButtonEvents={}));var d=function(t){function e(e,i){void 0===i&&(i={});var n=t.call(this,e,i)||this;n.config.helpMessage=n.config.helpMessage||n.config.help,n.config.helpMessage&&(n._helper=new l.Popup({css:"dhx_tooltip dhx_tooltip--forced dhx_tooltip--light"}),n._helper.attachHTML(n.config.helpMessage)),n.config.labelInline&&(n.config.labelPosition="right"),n._handlers={showHelper:function(t){t.preventDefault(),t.stopPropagation(),n._helper.show(t.target)},cancelUnusefulClick:function(t){t.preventDefault()},onchange:function(t){n.config.checked=t.target.checked,n.events.fire(o.change,[t.target.checked])}},n.events=new s.EventSystem;return n.mount(e,r.create({render:function(){return n._draw()}})),n}return n(e,t),e.prototype.clearValidate=function(){this.config.$validationStatus=u.ValidationStatus.pre,this.paint()},e.prototype.clear=function(){this.config.checked=!1,this.paint()},e.prototype.getValue=function(){if(this.config.checked)return this.config.value},e.prototype.setValue=function(t){this.config.checked=t,this.paint()},e.prototype.destructor=function(){this._helper.destructor(),this.events.clear(),this.unmount()},e.prototype._draw=function(){var t=this.config,e=t.id,i=t.value,n=t.label,o=t.checked,s=t.disabled,a=t.name,l=t.helpMessage,u=t.labelWidth,d=t.labelPosition,h=t.required;return r.el("label.dhx_radiobutton.dhx_form-group",{class:c.getFormItemCss(this.config,Boolean(h)),style:{"margin-left":u&&"right"===d?"calc("+u+" + 16px)":""}},[r.el("input.dhx_radiobutton__input",{type:"radio",id:e,value:i||"",name:a||"",disabled:s,checked:o,onchange:this._handlers.onchange,required:h}),r.el("span.dhx_radiobutton__visual-input"),r.el("span.dhx_label",{class:l?"dhx_label--with-help":""},l?[r.el("span.dhx_label__holder",n),r.el("span.dhx_label-help.dxi.dxi-help-circle-outline",{tabindex:"0",role:"button",onclick:this._handlers.showHelper})]:n),r.el("span.dhx_input__caption",{onclick:this._handlers.cancelUnusefulClick},c.getValidationMessage(this.config))])},e}(a.View);e.RadioButton=d},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}();Object.defineProperty(e,"__esModule",{value:!0});var o=i(0),r=i(18),s=i(9),a=i(3),c=i(8),l=function(t){function e(e,i){var n=t.call(this,null,i)||this;return n.events=new a.EventSystem,n._initView(i),n}return n(e,t),e.prototype.disable=function(){this.config.disabled=!0,this.paint()},e.prototype.enable=function(){this.config.disabled=!1,this.paint()},e.prototype.isDisabled=function(){return this.config.disabled},e.prototype.validate=function(){var t,e=this.config,i=e.required,n=e.value;return t=e.validation?this.config.validation(n):!i||Boolean(n),this.config.$validationStatus=t?c.ValidationStatus.success:c.ValidationStatus.error,this.paint(),t},e.prototype.clearValidate=function(){this.config.$validationStatus=c.ValidationStatus.pre,this.paint()},e.prototype.clear=function(){this.config.value=this.config.options[0].value,this.paint()},e.prototype.setValue=function(t){this.config.value=t,this.events.fire(c.BaseElementEvent.change,[t]),this.paint()},e.prototype.getValue=function(){return this.config.value||""},e.prototype.setConfig=function(t){this._initView(t)},e.prototype._initView=function(t){if(!s.isEmptyObj(t)){for(var e in this.config={type:this.config.type,id:this.config.id,name:this.config.name,options:t.options,disabled:!1,value:t.options[0].value},t)"id"!==e&&"type"!==e&&"name"!==e&&(this.config[e]=t[e]);this.events.fire(c.BaseElementEvent.configUpdate,[this.config]),this.paint()}},e.prototype._getHandlers=function(){var t=this;return{onchange:function(e){var i=e.target.value;t.config.value=i,t.events.fire(c.BaseElementEvent.change,[i]),t.validate()}}},e.prototype._draw=function(){var t=this.config,e=t.id,i=t.options,n=t.icon,r=t.required,a=t.value,c=t.validation;return o.el(".dhx_form-group",{class:s.getFormItemCss(this.config,Boolean(r)||Boolean(c))},[this._drawLabel(),o.el(".dhx_input__wrapper",{},[o.el("div.dhx_input__container",{},[o.el(".dhx_input__icon",{class:n||"dxi dxi-menu-down"}),o.el("select",{id:e,class:"dhx_select dhx_input",onchange:this._handlers.onchange},i&&i.map(function(t){return o.el("option",{value:t.value,disabled:t.disabled,selected:t.selected||a===t.value},t.content)}))]),s.getValidationMessage(this.config)&&o.el("span.dhx_input__caption",s.getValidationMessage(this.config))])])},e}(r.Label);e.Select=l},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}();Object.defineProperty(e,"__esModule",{value:!0});var o=i(0),r=i(9),s=i(52),a=i(1),c=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return n(e,t),e.prototype._draw=function(){var t=this.config,e=t.id,i=t.value,n=t.disabled,s=t.name,c=t.placeholder,l=t.required,u=t.resizable,d=t.readOnly,h=t.validation;return o.el("div.dhx_form-group.dhx_form-group--textarea",{class:r.getFormItemCss(this.config,Boolean(l)||Boolean(h))},[this._drawLabel(),o.el(".dhx_input__wrapper",[o.el("textarea.dhx_input.dhx_input--textarea",{type:"text",id:e,placeholder:c||"",value:a.isDefined(i)?i:"",name:s||"",disabled:n,required:l,readOnly:d,onblur:this._handlers.onblur,oninput:this._handlers.oninput,style:{resize:u?"both":"none"}}),r.getValidationMessage(this.config)&&o.el("span.dhx_input__caption",{},r.getValidationMessage(this.config))])])},e}(s.Input);e.Textarea=c},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}();Object.defineProperty(e,"__esModule",{value:!0});var o=i(0),r=i(1),s=i(9),a=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return n(e,t),e.prototype._draw=function(){var t=this.config,e=t.id,i=t.value;return o.el("div.dhx_form-group.dhx_form-group--textinput",{class:s.getFormItemCss(this.config)},[this._drawLabel(),o.el(".dhx_input__wrapper",[o.el("input.dhx_input.dhx_input--textinput",{type:"text",readOnly:!0,id:e,value:r.isDefined(i)?i:"",name:name||""})])])},e}(i(52).Input);e.Text=a},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}();Object.defineProperty(e,"__esModule",{value:!0});var o=i(0),r=i(9),s=i(32),a=i(3),c=i(18),l=i(8),u=function(t){function e(e,i){var n=t.call(this,null,i)||this;return n.events=new a.EventSystem,n._initView(i),n}return n(e,t),e.prototype.disable=function(){this.config.disabled=!0,this.combobox.disable(),this.paint()},e.prototype.enable=function(){this.config.disabled=!1,this.combobox.enable(),this.paint()},e.prototype.isDisabled=function(){return this.config.disabled},e.prototype.clear=function(){this.combobox.clear(),this.paint()},e.prototype.getValue=function(){return this.config.multiselection?this.combobox.getValue(!0):this.combobox.getValue()||""},e.prototype.setValue=function(t){t&&this.combobox.setValue(t),this.paint()},e.prototype.validate=function(){var t=this.combobox.getValue(),e=this.config,i=e.validation,n=e.required;if(i){var o=this.config.validation(t);return this.config.$validationStatus=o?l.ValidationStatus.success:l.ValidationStatus.error,this._validationStatus(),this.paint(),o}return n?(this.config.$validationStatus=Boolean(t)?l.ValidationStatus.success:l.ValidationStatus.error,this._validationStatus(),this.paint(),Boolean(t)):(this.paint(),!0)},e.prototype.clearValidate=function(){this.config.$validationStatus=l.ValidationStatus.pre,this._validationStatus(),this.paint()},e.prototype.getWidget=function(){return this.combobox},e.prototype.setConfig=function(t){this._initView(t)},e.prototype._initView=function(t){var e=this;if(!r.isEmptyObj(t)){this.combobox&&this.combobox.destructor(),this.config={type:this.config.type,id:this.config.id,name:this.config.name,disabled:!1,value:""};var i={};for(var n in t)"id"!==n&&"type"!==n&&"name"!==n&&(this.config[n]=t[n],"validation"!==n&&(i[n]=t[n]));this.config.labelInline&&(this.config.labelPosition="left"),this.combobox=new s.Combobox(null,i),this.combobox.events.on(s.ComboboxEvents.change,function(t){e.events.fire(l.BaseElementEvent.change,[t])}),this.events.fire(l.BaseElementEvent.configUpdate,[this.config]),this.setValue(this.config.value),this.events.on(l.BaseElementEvent.change,function(t){"load"!==t&&e.validate()}),this.clearValidate()}},e.prototype._validationStatus=function(){switch(this.config.$validationStatus){case l.ValidationStatus.pre:this.combobox.config.css=this.config.css||"";break;case l.ValidationStatus.success:this.combobox.config.css=(this.config.css||"")+"dhx_form-group--state_success";break;case l.ValidationStatus.error:this.combobox.config.css=(this.config.css||"")+"dhx_form-group--state_error";break;default:this.combobox.config.css=this.config.css||""}},e.prototype._getRootView=function(){return this.combobox.paint(),this.combobox.getRootView()},e.prototype._draw=function(){var t=this.config,e=t.labelWidth,i=t.labelPosition,n=t.$validationStatus;return o.el(".dhx_form-group",{},[o.inject(this._getRootView()),o.el("div",{style:{"margin-left":e&&"left"===i?"calc("+e+" + 16px)":""},class:1===n?"dhx_form-group--state_error":2===n?"dhx_form-group--state_success":""},[o.el("span.dhx_input__caption",r.getValidationMessage(this.config))])])},e}(c.Label);e.Combo=u},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),o=this&&this.__assign||function(){return(o=Object.assign||function(t){for(var e,i=1,n=arguments.length;i<n;i++)for(var o in e=arguments[i])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)};Object.defineProperty(e,"__esModule",{value:!0});var r=i(0),s=i(40),a=i(3),c=i(18),l=i(9),u=i(8),d=function(t){function e(e,i){var n=t.call(this,null,i)||this;n.events=new a.EventSystem,n._initView(i);return n.mount(e,r.create({render:function(){return n._drawSlider()}})),n}return n(e,t),e.prototype.disable=function(){this.config.disabled=!0,this.slider.disable(),this.paint()},e.prototype.enable=function(){this.config.disabled=!1,this.slider.enable(),this.paint()},e.prototype.isDisabled=function(){return this.config.disabled},e.prototype.clear=function(){this.config.value=this.config.min,this.slider.setValue(this.config.value)},e.prototype.getValue=function(){return this.slider.getValue()},e.prototype.setValue=function(t){this.slider.setValue(t)},e.prototype.validate=function(){return!0},e.prototype.getWidget=function(){return this.slider},e.prototype.setConfig=function(t){this._initView(t)},e.prototype._initView=function(t){var e=this;if(!l.isEmptyObj(t)){this.slider&&this.slider.destructor();var i={type:this.config.type,id:this.config.id,name:this.config.name,mode:s.Direction.horizontal,min:0,max:100,step:1,tooltip:!0,disabled:!1};for(var n in t)"id"!==n&&"type"!==n&&"name"!==n&&(i[n]=t[n]);this.config=o({type:this.config.type},i),this.slider=new s.Slider(null,i),this.config.disabled&&this.slider.disable(),this.config.value=this.slider.getValue(),this.slider.events.on(s.SliderEvents.change,function(){e.config.value=e.slider.getValue(),e.events.fire(u.BaseElementEvent.change,[e.config.value]),e.validate()}),this.events.fire(u.BaseElementEvent.configUpdate,[this.config])}},e.prototype._getRootView=function(){return this.slider.paint(),this.slider.getRootView()},e.prototype._drawSlider=function(){return r.el("div.dhx_form-group",{},[r.inject(this._getRootView())])},e}(c.Label);e.SliderForm=d},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),o=this&&this.__assign||function(){return(o=Object.assign||function(t){for(var e,i=1,n=arguments.length;i<n;i++)for(var o in e=arguments[i])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)};Object.defineProperty(e,"__esModule",{value:!0});var r=i(0),s=i(3),a=i(2),c=i(4),l=i(7),u=i(55),d=i(11),h=i(9),f=i(75),p=i(8),_=function(t){function e(e,i){var n=t.call(this,e,i)||this;n.events=new s.EventSystem(n),n.data=new l.DataCollection({},n.events),n._uploader=new u.Uploader(o(o({},i),{autosend:!1}),n.data,n.events),n._initView(i),n._handlers={add:function(t){n.config.disabled||(t.preventDefault(),n._uploader.selectFile())},remove:function(t){if(!n.config.disabled){var e=a.locate(t);e&&n.data.remove(e)}},ondragover:function(t){for(var e=0,i=t.dataTransfer.types;e<i.length;e++){var o=i[e];if("Files"!==o&&"application/x-moz-file"!==o)return}n._dragoverTimeout?clearTimeout(n._dragoverTimeout):n.paint(),n._dragover=!0,n._dragoverTimeout=setTimeout(function(){n._dragover=!1,n._dragoverTimeout=null,n.paint()},150)},showHelper:function(t){t.stopPropagation(),t.preventDefault(),n._helper.show(t.target)}};return n.mount(e,r.create({render:function(){return n._draw()}})),n}return n(e,t),e.prototype.disable=function(){this.config.disabled=!0,this.paint()},e.prototype.enable=function(){this.config.disabled=!1,this.paint()},e.prototype.isDisabled=function(){return this.config.disabled},e.prototype.validate=function(){var t=!this.config.required||this.data.getLength()>0;return this.config.$validationStatus=t?p.ValidationStatus.success:p.ValidationStatus.error,this.paint(),t},e.prototype.clearValidate=function(){this.config.$validationStatus=p.ValidationStatus.pre,this.paint()},e.prototype.clear=function(){this.data.removeAll(),this.paint()},e.prototype.getValue=function(){return this.data.map(function(t){return t.file})||[]},e.prototype.getWidget=function(){return this._uploader},e.prototype.setConfig=function(t){this._initView(t)},e.prototype._initView=function(t){var e=this;if(!h.isEmptyObj(t)){for(var i in this.config={type:this.config.type,id:this.config.id,name:this.config.name,disabled:!1},t)"id"!==i&&"type"!==i&&"name"!==i&&(this.config[i]=t[i]);this.config.labelInline&&(this.config.labelPosition="left"),this.config.helpMessage=this.config.helpMessage||this.config.help,this.events.on(p.BaseElementEvent.change,function(){e.validate(),e.paint()}),this.events.fire(p.BaseElementEvent.configUpdate,[this.config]),this.paint()}},e.prototype._draw=function(){var t=this;this.config.helpMessage&&(this._helper?this._helper.attachHTML(this.config.helpMessage):(this._helper=new d.Popup({css:"dhx_tooltip dhx_tooltip--forced dhx_tooltip--light"}),this._helper.attachHTML(this.config.helpMessage)));var e=this.data.getLength()?r.el("ul.dhx_simplevault__files.dhx_simplevault-files",{class:this.config.$vaultHeight?"":"dhx_simplevault-files__fixed"},this.data.map(function(e){return r.el("li.dhx_simplevault-files__item",[r.el("span.dhx_simplevault-files__item-name",e.file.name),r.el(".dhx_button.dhx_simplevault-files__delete.dhx_button--icon.dhx_button--view_link.dhx_button--size_small.dhx_button--color_secondary.dhx_button--circle",{dhx_id:e.id,onclick:t._handlers.remove},[r.el("span.dxi.dxi-delete-forever")])])})):null,i=this.config,n=i.id,o=i.labelPosition,s=i.label,a=i.labelWidth,c=i.helpMessage,l=i.disabled,u=i.required,p=i.validation,_="left"===o&&a?a:"";return r.el(".dhx_form-group.dhx_form-group--simplevault",{class:h.getFormItemCss(this.config,Boolean(u)||Boolean(p))},[r.el("label.dhx_label",{for:n||this._uid,style:{minWidth:_,maxWidth:_},class:c?"dhx_label--with-help":"",onclick:this._handlers.add},c?[r.el("span.dhx_label__holder",s),r.el("span.dhx_label-help.dxi.dxi-help-circle-outline",{tabindex:"0",role:"button",onclick:this._handlers.showHelper})]:s),r.el(".dhx_input__wrapper",[r.el("div",{_hooks:{didInsert:function(e){t._uploader.linkDropArea(e.el)}},ondragover:this._handlers.ondragover,class:"dhx_simplevault"+(this._dragover?" dhx_simplevault--on-drag":"")},[r.el("div.dhx_simplevault-loader",[r.el("span.dhx_simplevault__icon.dxi.dxi-vault")]),r.el(".dhx_simplevault__drop-area",[r.el("input.dhx_simplevault__input",{type:"file",id:n,disabled:l}),r.el("span.dhx_simplevault__icon.dxi.dxi-vault"),r.el("span.dhx_simplevault__title",[r.el("span",f.default.simpleVaultText),r.el("br"),r.el("label.dhx_simplevault__label",{onclick:this._handlers.add,for:n}," "+f.default.simpleVaultLabel)])]),e]),h.getValidationMessage(this.config)&&r.el("span.dhx_input__caption",{},h.getValidationMessage(this.config))])])},e}(c.View);e.SimpleVault=_},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}();Object.defineProperty(e,"__esModule",{value:!0});var o=i(30),r=i(0),s=i(18),a=i(11),c=i(3),l=i(8),u=i(9),d=function(t){function e(e,i){var n=t.call(this,null,i)||this;n.events=new c.EventSystem,n._initView(i);return n.mount(e,r.create({render:function(){return n._draw()}})),n}return n(e,t),e.prototype.disable=function(){this.config.disabled=!0,this.paint()},e.prototype.enable=function(){this.config.disabled=!1,this.paint()},e.prototype.isDisabled=function(){return this.config.disabled},e.prototype.validate=function(){var t,e=this.config,i=e.required,n=e.value;return t=e.validation?this.config.validation(n):!i||Boolean(n),this.config.$validationStatus=t?l.ValidationStatus.success:l.ValidationStatus.error,this.paint(),t},e.prototype.clearValidate=function(){this.config.$validationStatus=l.ValidationStatus.pre,this.paint()},e.prototype.setValue=function(t){this.timepicker.setValue(t),this.config.controls&&this.timepicker.events.fire(o.TimepickerEvents.apply,[]),this.paint()},e.prototype.getValue=function(){return this.config.value||""},e.prototype.clear=function(){12===this.config.timeFormat?this.timepicker.setValue("12:00AM"):this.timepicker.setValue("00:00"),this.config.value=""},e.prototype.getWidget=function(){return this.timepicker},e.prototype.setConfig=function(t){this._initView(t)},e.prototype._initView=function(t){var e=this;if(!u.isEmptyObj(t)){for(var i in this.timepicker&&this.timepicker.destructor(),this._popup&&this._popup.destructor(),this.config={type:this.config.type,id:this.config.id,name:this.config.name,disabled:!1,editable:!1,value:""},t)"id"!==i&&"type"!==i&&"name"!==i&&(this.config[i]=t[i]);this.config.editable=this.config.editable||this.config.editing,this._popup=new a.Popup({css:"dhx_widget--border-shadow"}),this.timepicker=new o.Timepicker(null,t),this._popup.attach(this.timepicker),this.config.value&&(this.timepicker.setValue(this.config.value),this.config.value=this.timepicker.getValue()),this.config.controls?(this.timepicker.events.on(o.TimepickerEvents.close,function(){e._popup.hide()}),this.timepicker.events.on(o.TimepickerEvents.apply,function(){e.config.value=e.timepicker.getValue(),e.validate(),e._popup.hide()}),this._popup.events.on(a.PopupEvents.afterHide,function(){var t=e.config.value;t&&t!==e.timepicker.getValue()&&e.timepicker.setValue(t),""===t&&e.clear(),e.paint()})):(this.timepicker.events.on(o.TimepickerEvents.change,function(){e.config.value=e.timepicker.getValue(),e.validate()}),this._popup.events.on(a.PopupEvents.afterHide,function(){e.paint()})),this.events.on(l.BaseElementEvent.change,function(t){var i=12===e.config.timeFormat?7:5;if(t.length>=i){var n=e._inputValidate(t);e._inputValidate(t)?e.timepicker.setValue(n):e.validate()}}),this.events.fire(l.BaseElementEvent.configUpdate,[this.config]),this.clearValidate()}},e.prototype._getHandlers=function(){var t=this;return{onfocus:function(){if(!t._popup.isVisible()){var e=t.getRootView().refs.input.el;t._popup.show(e)}},onkeyup:function(e){var i=e.target.value.trim();t.config.controls||13!==e.keyCode||(t._popup.isVisible()&&t._popup.hide(),t.getRootView().refs.input.el.blur());(e.which>=48&&e.which<=57||e.which>=65&&e.which<=90||e.which>=96&&e.which<=105)&&t.events.fire(l.BaseElementEvent.change,[i])}}},e.prototype._inputValidate=function(t){var e=this.config.timeFormat;return u.isTimeFormat(t,e)?t:""},e.prototype._draw=function(){var t=this.config,e=t.value,i=t.required,n=t.disabled,o=t.placeholder,s=t.name,a=t.id,c=t.validation,l=t.editable;return r.el("div.dhx_form-group",{class:u.getFormItemCss(this.config,Boolean(i)||Boolean(c))},[this._drawLabel(),r.el(".dhx_input__wrapper",[r.el("div.dhx_input__container",{},[r.el(".dhx_input__icon.dxi.dxi-clock-outline"),r.el("input.dhx_input.dhx_input--icon-padding",{_key:this._uid,value:e,type:"text",_ref:"input",required:i,disabled:n,placeholder:o||"",name:s||"",id:a||this._uid,onfocus:this._handlers.onfocus,onkeyup:this._handlers.onkeyup,autocomplete:"off",readOnly:!l})]),u.getValidationMessage(this.config)&&r.el("span.dhx_input__caption",{},u.getValidationMessage(this.config))])])},e}(s.Label);e.TimeInput=d},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}();Object.defineProperty(e,"__esModule",{value:!0});var o=i(31),r=i(3),s=i(0),a=i(18),c=i(11),l=i(8),u=i(9),d=function(t){function e(e,i){var n=t.call(this,null,i)||this;n.events=new r.EventSystem,n._initView(i);return n.mount(e,s.create({render:function(){return n._draw()}})),n}return n(e,t),e.prototype.disable=function(){this.config.disabled=!0,this.paint()},e.prototype.enable=function(){this.config.disabled=!1,this.paint()},e.prototype.isDisabled=function(){return this.config.disabled},e.prototype.validate=function(){var t,e=this.config,i=e.required,n=e.value;return t=e.validation?this.config.validation(n):!i||Boolean(n),this.config.$validationStatus=t?l.ValidationStatus.success:l.ValidationStatus.error,this.paint(),t},e.prototype.clearValidate=function(){this.config.$validationStatus=l.ValidationStatus.pre,this.paint()},e.prototype.setValue=function(t){this.config.value=t,this.colorpicker.setValue(t),this.paint()},e.prototype.getValue=function(){return this.config.value||""},e.prototype.clear=function(){this.config.value="",this.paint()},e.prototype.getWidget=function(){return this.colorpicker},e.prototype.setConfig=function(t){this._initView(t)},e.prototype._initView=function(t){var e=this;if(!u.isEmptyObj(t)){for(var i in this.colorpicker&&this.colorpicker.destructor(),this._popup&&this._popup.destructor(),this.config={type:this.config.type,id:this.config.id,name:this.config.name,disabled:!1,editable:!1,value:""},t)"id"!==i&&"type"!==i&&"name"!==i&&(this.config[i]=t[i]);this.config.editable=this.config.editable||this.config.editing,this._popup=new c.Popup({css:"dhx_widget--border-shadow"}),this.colorpicker=new o.Colorpicker(null,t),this._popup.attach(this.colorpicker),this.config.value&&(this.colorpicker.setValue(this.config.value),this.config.value=this.colorpicker.getValue()),this.colorpicker.events.on(o.ColorpickerEvents.change,function(){e.config.value=e.colorpicker.getValue(),e._popup.hide(),e.validate()}),this.events.on(l.BaseElementEvent.change,function(t){var i=e._inputValidate(t);e._inputValidate(t)?e.setValue(i):e.validate()}),this.events.fire(l.BaseElementEvent.configUpdate,[this.config]),this.clearValidate()}},e.prototype._getHandlers=function(){var t=this;return{onfocus:function(){if(!t._popup.isVisible()){var e=t.getRootView().refs.input.el;t._popup.show(e)}},onchange:function(e){var i=e.target.value;t.events.fire(l.BaseElementEvent.change,[i])},onkeyup:function(e){13===e.keyCode&&(t._popup.isVisible()&&t._popup.hide(),t.getRootView().refs.input.el.blur())}}},e.prototype._inputValidate=function(t){return o.isHex(t)?t:""},e.prototype._draw=function(){var t=this.config,e=t.required,i=t.value,n=t.icon,o=t.disabled,r=t.placeholder,a=t.name,c=t.id,l=t.editable;return s.el("div.dhx_form-group",{class:u.getFormItemCss(this.config,Boolean(e)||Boolean(this.config.validation))},[this._drawLabel(),s.el(".dhx_input__wrapper",[s.el("div.dhx_input__container",{},[s.el(".dhx_input__icon",{class:n||"dxi dxi-eyedropper-variant"+(i?" dhx_input__icon--color-selected":""),style:{"background-color":i||"transparent"}}),s.el("input.dhx_input.dhx_input--icon-padding",{_key:this._uid,value:i,type:"text",_ref:"input",required:e,disabled:o,placeholder:r||"",name:a||"",id:c||this._uid,onfocus:this._handlers.onfocus,onchange:this._handlers.onchange,onkeyup:this._handlers.onkeyup,autocomplete:"off",readOnly:!l})]),u.getValidationMessage(this.config)&&s.el("span.dhx_input__caption",{},u.getValidationMessage(this.config))])])},e}(a.Label);e.ColorpickerInput=d},function(t,e,i){"use strict";function n(t){for(var i in t)e.hasOwnProperty(i)||(e[i]=t[i])}Object.defineProperty(e,"__esModule",{value:!0}),n(i(185)),n(i(10)),n(i(54)),n(i(53)),n(i(20))},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),o=this&&this.__assign||function(){return(o=Object.assign||function(t){for(var e,i=1,n=arguments.length;i<n;i++)for(var o in e=arguments[i])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)};Object.defineProperty(e,"__esModule",{value:!0});var r=i(0),s=i(3),a=i(2),c=i(4),l=i(7),u=i(186),d=i(53),h=i(20),f=i(187),p=i(188),_=i(10),v=i(189),g=i(1),m=i(25),y=i(78),b=i(197),x=function(t){function e(e,i){var n=t.call(this,e,i)||this;n.config=g.extend({rowHeight:40,headerRowHeight:40,footerRowHeight:40,keyNavigation:!0,sortable:!0,columns:[],data:[],headerSort:!0},i),n.content=y.content,n._scroll={top:0,left:0},n.config.autoWidth=n.config.autoWidth||n.config.fitToContainer,n.config.adjust=n.config.adjust||n.config.columnsAutoWidth,n.config.editable=n.config.editable||n.config.editing,n.config.sortable&&n.config.headerSort||(n.config.sortable=!1);var o={onclick:a.eventHandler(function(t){return a.locate(t)},{"dhx_grid-header-cell":function(t,e){var i=t.target.getAttribute("dhx_resized"),o=n._getColumn(e);o&&h.isSortable(n.config,o)&&!i&&n.events.fire(_.GridEvents.sort,[e])},"dhx_grid-expand-cell":function(t,e){t.target.classList.contains("dhx_grid-expand-cell-icon")&&n.events.fire(_.GridEvents.expand,[e])}}),onscroll:function(t){n._lazyLoad(t),n.events.fire(_.GridEvents.scroll,[{y:t.target.scrollTop,x:t.target.scrollLeft}])}};n.config.dragMode&&(l.dragManager.setItem(n._uid,n),n.config.dragItem||(n.config.dragItem="row")),n._init(),n.config.columns&&n._parseColumns(),n.config.data&&n.config.data instanceof Array&&n.config.data.length&&n.config.columns&&n.data.parse(n.config.data),n.config.selection&&(n.selection=new f.Selection(n));var s=r.create({render:function(t,e){return v.render(t,e,n._currentData,o,n.selection,n._uid)}},n);return n.mount(e,s),r.awaitRedraw().then(function(){p.initHotkeys(n)}),i.autoEmptyRow&&0===n.data.getLength()&&(n.data.add(n.config.columns.reduce(function(t,e){return t[e.id]="",t},{})),n.paint()),n}return n(e,t),e.prototype.destructor=function(){this.unmount(),this.config.selection&&this.selection.destructor(),this._destroyContent(),this.events.events={},this.events.context=null,this._currentData=this.data=this.config=this._scroll=this.content=null},e.prototype.setColumns=function(t){this.config.columns=t,this._parseColumns()},e.prototype.addRowCss=function(t,e){var i=this.data.getItem(t),n=i.$css||"";if(!n.match(new RegExp(e,"g"))){i.$css=n+" "+e;var o=this._getRowIndex(t);o>=0&&(this._currentData[o].$css=i.$css),this.paint()}},e.prototype.removeRowCss=function(t,e){var i=this.data.getItem(t),n=i.$css?i.$css.replace(e,""):"";i.$css=n},e.prototype.addCellCss=function(t,e,i){var n=this._getColumn(e);n&&(n.$cellCss[t]?n.$cellCss[t]+=n.$cellCss[t].match(new RegExp(i,"g"))?"":" "+i:this.data.getItem(t)&&(n.$cellCss[t]=i+" "),this.paint())},e.prototype.removeCellCss=function(t,e,i){var n=this._getColumn(e);n&&(n.$cellCss[t]?(n.$cellCss[t]=n.$cellCss[t].replace(i,""),this.paint()):this.data.getItem(t)&&(n.$cellCss[t]=""))},e.prototype.showColumn=function(t){var e=this._getColumn(t);e&&e.hidden&&(e.hidden=!1,this.config.$totalWidth+=e.width,this.paint())},e.prototype.hideColumn=function(t){var e=this._getColumn(t);e&&!e.hidden&&(e.hidden=!0,this.config.$totalWidth-=e.width,this.paint())},e.prototype.isColumnHidden=function(t){var e=this._getColumn(t);if(e)return!!e.hidden},e.prototype.getScrollState=function(){return{x:this._scroll.left,y:this._scroll.top}},e.prototype.scroll=function(t,e){var i=this.getRootView().refs.grid_body.el;i.scrollLeft="number"==typeof t?t:i.scrollLeft,i.scrollTop="number"==typeof e?e:i.scrollTop},e.prototype.scrollTo=function(t,e){var i=g.findIndex(this.config.columns,function(t){return t.id===e}),n=this.config.splitAt?this.config.columns.slice(0,this.config.splitAt).reduce(function(t,e){return t+e.width},0):0,o=this.config.columns.slice(0,i).reduce(function(t,e){return t+e.width},0)-n,r=this.data.getIndex(t)*this.config.rowHeight,s=this.getScrollState(),a=this.config.width+s.x,c=this.config.height+s.y-this.config.headerRowHeight*this.config.$headerLevel,l=r-s.y-this.config.rowHeight,u=o-s.x-this.config.columns[i].width,d=r+2*this.config.rowHeight+18-c,h=o+2*this.config.columns[i].width+18-a,f=l>0&&d<0?0:l<0?l:d,p=u>0&&h<0?0:u<0?u:h;this.scroll(p+s.x,f+s.y)},e.prototype.adjustColumnWidth=function(t,e){var i=this;void 0===e&&(e=!0);var n=g.findIndex(this.config.columns,function(e){return e.id===t}),o=this.config.columns[n],r=[];"header"!==e&&!0!==e||o.header.forEach(function(t){r.push(h.getStrWidth(h.removeHTMLTags(t.text))+(h.isSortable(i.config,o)?40:20))}),"data"!==e&&!0!==e||this.data.map(function(t){"string"!=typeof t[o.id]&&"number"!=typeof t[o.id]||r.push(h.getStrWidth(h.removeHTMLTags(t[o.id]))+20)}),r.length>0&&(this.config.$totalWidth=this.config.columns.reduce(function(t,e,i){return i===n&&(e.width=Math.max.apply(Math,r)),t+(e.hidden?0:e.width)},0),this.paint())},e.prototype.getCellRect=function(t,e){var i=g.findIndex(this.config.columns,function(t){return t.id===e}),n=this._getRowIndex(t);return{x:this.config.columns.slice(0,i).reduce(function(t,e){return t+e.width},0),y:n*this.config.rowHeight,height:this.config.rowHeight,width:this.config.columns[i].width}},e.prototype.getColumn=function(t){var e=g.findIndex(this.config.columns,function(e){return e.id===t});if(e>=0)return this.config.columns[e]},e.prototype.addSpan=function(t){this.config.spans=this.config.spans||[];var e=g.findIndex(this.config.spans,function(e){return""+e.row==""+t.row&&""+e.column==""+t.column});e>=0?this.config.spans[e]=t:this.config.spans.push(t)},e.prototype.getSpan=function(t,e){if(this.config.spans){var i=g.findIndex(this.config.spans,function(i){return""+i.row==""+t&&""+i.column==""+e});return this.config.spans[i]}},e.prototype.removeSpan=function(t,e){if(this.config.spans){var i=g.findIndex(this.config.spans,function(i){return""+i.row==""+t&&""+i.column==""+e});this.config.spans.splice(i,1)}},e.prototype.editCell=function(t,e,i){void 0===i&&(i=_.EditorType.input);var n=this.data.getItem(t),o=this.getColumn(e);n&&void 0!==n[e]?this.events.fire(_.GridEvents.beforeEditStart,[n,o,i])&&("date"===o.type&&(i=_.EditorType.datepicker),"boolean"===o.type&&(i=_.EditorType.checkbox),this.config.$editable&&this.config.$editable.row===t&&this.config.$editable.col===e&&this.config.$editable.editorType===i||(this.config.$editable={row:t,col:e,editorType:i},this.selection&&this.selection.setCell(t.toString(),e.toString()),this.paint(),this.events.fire(_.GridEvents.afterEditStart,[n,o,i]))):l.dhxWarning("item not found")},e.prototype.editEnd=function(t){this.config.$editable&&this.config.$editable.editor&&this.config.$editable.editor.endEdit(t)},e.prototype.getSortingState=function(){return{dir:this._sortDir,by:this._sortBy}},e.prototype.edit=function(t,e,i){void 0===i&&(i=_.EditorType.input),this.editCell(t,e,i)},e.prototype._parseColumns=function(){var t=this.config.columns;d.normalizeColumns(t),d.countColumns(this.config,t)},e.prototype._parseData=function(){this.data.getId(0)&&(this.config.columns.length&&this._checkColumns(),this._currentData=this.data.serialize()||[]),this._checkFilters(),this._checkMarks(),this._render()},e.prototype._checkColumns=function(){this._detectColsTypes()},e.prototype._createCollection=function(t){this.data=new l.DataCollection({prep:t},this.events)},e.prototype._getRowIndex=function(t){return this.data.getIndex(t)},e.prototype._setEventHandlers=function(){var t=this,e=function(e){return function(i,n){n&&n instanceof Array?n.map(function(i){return t.data.exists(i)&&t.data.update(i,e)}):t.data.exists(i)&&t.data.update(i,e)}};this.data.events.on(l.DataEvents.load,function(){t._parseData()}),this.data.events.on(l.DataEvents.change,function(e,i,n){if("remove"!==i||!n.$emptyRow){if(t._currentData=t.data.map(function(t){return t})||[],t._detectColsTypes(),t._checkMarks(),t._adjustColumns(),t.config.autoEmptyRow){var o=t.data.find({by:"$emptyRow",match:!0});o?t.data.move(o.id,t.data.getLength()-1):t._addEmptyRow()}t._render()}}),this.data.events.on(l.DataEvents.removeAll,function(){t.config.columns.map(function(t){t.header.map(function(e){!e.content||"selectFilter"!==e.content&&"comboFilter"!==e.content||(t.$uniqueData=[])})})}),this.events.on(l.DragEvents.canDrop,e({$drophere:!0})),this.events.on(l.DragEvents.cancelDrop,e({$drophere:void 0})),this.events.on(l.DragEvents.dragStart,e({$dragtarget:!0})),this.events.on(l.DragEvents.dragEnd,e({$dragtarget:void 0})),this.events.on(_.GridEvents.sort,function(e){e&&t._sort(e)}),this.events.on(_.GridEvents.cellMouseDown,function(e,i,n){if(t.config.dragMode&&"row"===t.config.dragItem&&!t.config.$editable){var o=a.locateNode(n,"dhx_id"),r=o&&o.getAttribute("dhx_id");return l.dragManager.onMouseDown(n,[r],[o])}}),this.events.on(_.GridEvents.headerInput,function(e,i,n){if(t.config.autoEmptyRow){var o=t.data.find({by:"$emptyRow",match:!0});o&&t.data.remove(o.id)}t.data.filter({by:i,match:e,compare:t.content[n].match},{multiple:!0})}),this.events.on(_.GridEvents.filterChange,function(e,i,n){if(t.config.autoEmptyRow){var o=t.data.find({by:"$emptyRow",match:!0});o&&t.data.remove(o.id)}t.data.filter({by:i,match:e,compare:t.content[n].match},{multiple:!0})}),this.events.on(_.GridEvents.scroll,function(e){t._scroll={top:e.y,left:e.x},t.paint()}),this.events.on(_.GridEvents.cellDblClick,function(e,i){(!1!==i.editable&&t.config.editable||i.editable)&&t.editCell(e.id,i.id,i.editorType)}),this.events.on(_.GridEvents.afterEditEnd,function(e,i,n){var r,s,a;t.config.$editable?(s=t.config.$editable.row,a=t.config.$editable.col):(s=i.id,a=n.id);var c=t.data.getItem(s);delete c.$emptyRow,void 0!==e&&t.data.update(s,o(o({},c),((r={})[a]=e,r))),t.config.$editable=null,t._checkFilters(),t.paint()}),this.events.on(_.GridEvents.headerCellMouseDown,function(e,i){var n=i.target.getAttribute("dhx_resized");n&&t.events.fire(_.GridEvents.beforeResizeStart,[e,i])&&b.startResize(t,n.toString(),i,function(){t.paint(),t.config.$resizing=null,t.events.fire(_.GridEvents.afterResizeEnd,[e,i])})})},e.prototype._addEmptyRow=function(){var t=this.data.getId(this.data.getLength()-1),e=this.data.getItem(t);h.isRowEmpty(e)||this.data.add(this.config.columns.reduce(function(t,e){return t[e.id]="",t},{$emptyRow:!0}))},e.prototype._sort=function(t,e){var i=this;e?this._sortDir=e:this._sortBy===t?this._sortDir="asc"===this._sortDir?"desc":"asc":this._sortDir="desc",this._sortBy=t,this.data.sort({by:t,dir:this._sortDir,as:function(e){var n=i.getColumn(t);return e&&"date"===n.type?""+m.stringToDate(e,n.dateFormat).getTime():e?""+e:""}})},e.prototype._getColumn=function(t){for(var e=0,i=this.config.columns;e<i.length;e++){var n=i[e];if(n.id===t)return n}},e.prototype._init=function(){this.events=new s.EventSystem(this),this._attachDataCollection(),this.export=new u.Exporter(this),this._setEventHandlers()},e.prototype._attachDataCollection=function(){var t=this;if(this.config.data instanceof l.DataCollection)return this.data=this.config.data,this.config.data=[],void this._parseData();this._createCollection(function(e){return e.spans&&(t.config.spans=e.spans,e=e.data),e})},e.prototype._setMarks=function(t,e){for(var i=this.data.map(function(e){return{id:e.id,data:e[t.id],row:e}}),n=this.data.map(function(e){return e[t.id]}),o=function(i){var o=e(i.data,n,i.row,t);if(o){t.$cellCss=t.$cellCss||{};var r=(t.$cellCss[i.id]||"").split(" ");o.split(" ").map(function(t){-1===r.indexOf(t)&&r.push(t)}),t.$cellCss[i.id]=r.join(" ")}},r=0,s=i;r<s.length;r++){o(s[r])}},e.prototype._checkMarks=function(){var t=this;this.config.columns.map(function(e){var i=e.mark;i&&("function"==typeof i?t._setMarks(e,i):t._setMarks(e,function(t,e){var n=e.filter(function(t){return null!==t&&void 0!==t&&""!==t}),o=Math.min.apply(Math,n),r=Math.max.apply(Math,n);return i.max&&r===parseFloat(t)?i.max:!(!i.min||o!==parseFloat(t))&&i.min}))})},e.prototype._adjustColumns=function(){var t=this;this.config.columns.map(function(e,i){(!1!==e.adjust&&t.config.adjust||e.adjust)&&t.adjustColumnWidth(e.id,e.adjust||t.config.adjust)})},e.prototype._detectColsTypes=function(){var t=this.data.getItem(this.data.getId(0));t&&this.config.columns.map(function(e){if(e.type)return e;var i=t?t[e.id]:"",n=parseFloat(i),o=isNaN(n)?i:n;return o?(e.type=typeof o,e):void 0})},e.prototype._checkFilters=function(){var t=this._currentData;this.config.columns.map(function(e){e.header.map(function(i){if(i.content&&("selectFilter"===i.content||"comboFilter"===i.content)){var n=d.getUnique(t,e.id);e.$uniqueData&&e.$uniqueData.length>n.length?n.forEach(function(t){-1===e.$uniqueData.indexOf(t)&&e.$uniqueData.push(t)}):e.$uniqueData=n}})})},e.prototype._destroyContent=function(){for(var t in this.content)"comboFilter"===t&&this.content[t].destroy()},e.prototype._render=function(){this.paint()},e.prototype._lazyLoad=function(t){var e=t.target.scrollTop;if(this.getScrollState().y!==e){var i=Math.round(e/this.config.rowHeight),n=(this.config.height-this.config.headerRowHeight)/this.config.rowHeight,o=this.data.dataProxy;o&&o.config&&!this.data.isDataLoaded(i,n+i+o.config.prepare)&&(o.updateUrl(null,{from:i,limit:o.config.limit}),this.data.load(o))}},e}(c.View);e.Grid=x},function(t,e,i){"use strict";var n=this&&this.__assign||function(){return(n=Object.assign||function(t){for(var e,i=1,n=arguments.length;i<n;i++)for(var o in e=arguments[i])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)},o=this&&this.__spreadArrays||function(){for(var t=0,e=0,i=arguments.length;e<i;e++)t+=arguments[e].length;var n=Array(t),o=0;for(e=0;e<i;e++)for(var r=arguments[e],s=0,a=r.length;s<a;s++,o++)n[o]=r[s];return n};Object.defineProperty(e,"__esModule",{value:!0});var r=i(20),s=i(7),a=i(1);var c=function(){function t(t){this._view=t}return t.prototype.xlsx=function(t){return this._export(t)},t.prototype.csv=function(t){var e;void 0===t&&(t={}),t=n({asFile:!0,rowDelimiter:"\n",columnDelimiter:",",skipHeader:0},t),e="getRoot"in this._view.data&&t.flat?this.getFlatCSV(t):this._getCSV(t);var i=t.name||"grid_export";return t.asFile&&a.downloadFile(e,i+".csv","text/csv"),e},t.prototype._export=function(t){void 0===t&&(t={});for(var e=this._view.config.columns,i={},n=r.transpose(this._view.config.columns.map(function(t){return t.header.map(function(t){return t.text||" "})})),o=[],s={default:{color:"#000000",background:"#FFFFFF",fontSize:14}},a=[],c={},l=this._view.data.serialize().map(function(t,n){return i[t.id]=n,e.map(function(e,i){return c[e.id]=i,r.removeHTMLTags(t[e.id])})}),u=0,d=e;u<d.length;u++){var h=d[u];for(var f in o.push({width:h.width}),h.$cellCss){var p=h.$cellCss[f],_=p.split("").reduce(function(t,e){var i=(t<<5)-t+e.charCodeAt(0);return Math.abs(i&i)},0).toString();if(!s[_]){var v=document.body,g=r.getStyleByClass(p,v,"dhx_grid-row",s.default);g&&(s[_]=g)}s[_]&&a.push([i[f],h.id,_])}}var m={name:t.name||"data",columns:o,header:n,data:l,styles:{cells:a,css:s}};if(t.url){var y=document.createElement("form");y.setAttribute("target","_blank"),y.setAttribute("action",t.url),y.setAttribute("method","POST"),y.style.visibility="hidden";var b=document.createElement("textarea");b.setAttribute("name","data"),b.value=JSON.stringify(m),y.appendChild(b),document.body.appendChild(y),y.submit(),setTimeout(function(){y.parentNode.removeChild(y)},100)}return m},t.prototype.getFlatCSV=function(t){var e=this._view.data,i=e.getRoot(),n=this._view.config.columns[0],r=e.getMaxLevel(),a="";e.eachChild(i,function(i){var o=function(t,e){for(var i=[],o=0;o<=r;o++)if(t&&t[n.id]){i[t.$level]=t[n.id];var s=e.getParent(t.id,!0);t=s&&s.id?s:null}else i[o]="";return i}(i,e).join(t.columnDelimiter);a+=o+Object.keys(i).reduce(function(e,n,o){return"id"!==n&&"parent"!==n&&"$"!==n[0]&&0!==o?e+t.columnDelimiter+(null===i[n]?"":i[n]):e},""),a+=t.rowDelimiter});var c=this._export(t),l=function(t,e){for(var i=0;i<t.length;i++)t[i]=e;return t}(new Array(r+1),""),u=c.header.map(function(t){return t.splice.apply(t,o([0,1],l)),t});return new s.CsvDriver(t).serialize(u,!0)+t.rowDelimiter+a},t.prototype._getCSV=function(t){var e=this._export(t),i=e.header,n=new s.CsvDriver(t);return n.serialize(i,!0)+n.serialize(e.data,!0)},t}();e.Exporter=c},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(0),o=i(1),r=i(10),s=i(7),a=function(){function t(t){this._grid=t;this._selectedCells=[],this._type=-1!==["cell","row","complex"].indexOf(this._grid.config.selection)?this._grid.config.selection:"complex",this._multiselection=t.config.multiselection&&"complex"!==this._type,this._init()}return t.prototype.destructor=function(){document.removeEventListener("click",this._outerClick)},t.prototype.setCell=function(t,e,i,n){var o=this;if(void 0===i&&(i=!1),void 0===n&&(n=!1),!this._grid.config.$editable){if(t){var r=this._oldSelectedCell?this._oldSelectedCell:void 0;if(t=t.id?t:this._grid.data.getItem(t),e||(e=this._grid.config.columns[0]),e=e.id?e:this._grid.getColumn(e),this._selectedCell={row:t,column:e},this._multiselection&&n&&r?this._oldSelectedCell=r:this._oldSelectedCell=this._selectedCell,this._multiselection)if(n&&!i&&this._selectedCells.length>0){var s=this._grid.data.getIndex(this._oldSelectedCell.row.id),a=this._grid.data.getIndex(t.id);if(s>a){var c=s;s=a,a=c}if(this._selectedCells=[this._oldSelectedCell],"cell"===this._type){var l=this._grid.config.columns.map(function(t){return t.id}),u=l.indexOf(r.column.id),d=l.indexOf(e.id);if(-1!==u&&-1!==d){if(u>d){c=u;u=d,d=c}var h=this._grid.config.columns.slice(u,d+1);this._grid.data.mapRange(s,a,function(t){h.forEach(function(e){var i={row:t,column:e};-1===o._findIndex(i)&&o._selectedCells.push(i)})})}}else this._grid.data.mapRange(s,a,function(t){var i={row:t,column:e};-1===o._findIndex(i)&&o._selectedCells.push({row:t,column:e})})}else if(i&&!n){var f=this._findIndex();-1===f?this._selectedCells.push(this._selectedCell):this._selectedCells.splice(f,1)}else this._selectedCells=[this._selectedCell];else this._selectedCells=[this._selectedCell]}else this._selectedCell=void 0,this._selectedCells=[];this._grid.paint()}},t.prototype.getCell=function(){return this._selectedCell},t.prototype.getCells=function(){if(this._multiselection)return this._selectedCells},t.prototype.toHTML=function(){var t=this;if(!this._isUnselected()){if(this._multiselection){var e=[];return this._selectedCells.forEach(function(i,n,o){e.push(t._toHTML(i.row,i.column,n===o.length-1||"cell"===t._type))}),e}return this._toHTML(this._selectedCell.row,this._selectedCell.column,!0)}},t.prototype._init=function(){var t=this;this._grid.events.on(r.GridEvents.cellClick,function(e,i,n){t.setCell(e,i,n.ctrlKey||n.metaKey,n.shiftKey)}),this._grid.data.events.on(s.DataEvents.beforeRemove,function(e){if(e&&t._selectedCell&&t._selectedCell.row){var i=t._grid.data.getIndex(String(t._selectedCell.row.id)),n=t._grid.data.getId(i+1);if(n)t.setCell(n);else{var o=t._grid.data.getId(i-1);o&&t.setCell(o)}t._grid.paint()}}),this._outerClick=function(e){if(!t._grid.config.$editable){for(var i=t._grid.getRootView().data.getRootNode(),n=e.target,o=!1;n;){if(n===i)return void(o=!0);n=n.parentNode}!o&&t._selectedCell&&t.setCell()}},document.addEventListener("click",this._outerClick)},t.prototype._toHTML=function(t,e,i){void 0===i&&(i=!1);var o,r=(this._grid.config.splitAt?this._grid.config.columns.slice(0,this._grid.config.splitAt):[]).map(function(t){return t.id}),s=this._grid.getCellRect(t.id,e.id);if(-1!==r.indexOf(e.id)&&i){var a=this._grid.getScrollState();o=n.el(".dhx_grid-selected-cell",{style:{width:this._grid.config.splitAt===r.indexOf(e.id)+1?s.width-1:s.width,height:s.height,top:s.y,left:s.x+a.x,position:"absolute",zIndex:10}})}var c=this._grid.config.$totalWidth;return n.el(".dhx_grid-selection",{},[("row"===this._type||"complex"===this._type)&&n.el(".dhx_grid-selected-row",{style:{width:c,height:s.height-1,top:s.y,left:0,position:"absolute"}}),("cell"===this._type||"complex"===this._type)&&o||("cell"===this._type||"complex"===this._type)&&i&&n.el(".dhx_grid-selected-cell",{style:{width:s.width,height:s.height-1,top:s.y,left:s.x,position:"absolute"}})])},t.prototype._isUnselected=function(){return!this._selectedCell||!this._selectedCell.row||!this._selectedCell.column||0===this._selectedCells.length},t.prototype._findIndex=function(t){var e=this;void 0===t&&(t=this._selectedCell);var i=-1;return this._selectedCells.some(function(n,r){if("cell"===e._type){if(o.compare(n.row,t.row)&&o.compare(n.column,t.column))return i=r,!0}else if("row"===e._type&&o.compare(n.row,t.row))return i=r,!0}),i},t}();e.Selection=a},function(t,e,i){"use strict";var n=this;Object.defineProperty(e,"__esModule",{value:!0});var o=i(13),r=i(10),s=i(2),a={focusedID:void 0,isFocus:function(t){return n.focusedID===t},getFocusState:function(){return n.focusedID},setFocusState:function(t){return n.focusedID=t}};function c(t){return"cell"===t||"complex"===t}function l(t,e,i,n,o,r,s){if(void 0===o&&(o=!1),void 0===r&&(r=!1),void 0===s&&(s=!1),!e.config.$editable&&e.config.selection){t&&t.preventDefault();var a=e.selection.getCell();if(a)if("vertical"===i)if(o){var c=1===n?e.data.getItem(e.data.getId(e.data.getLength()-1)):e.data.getItem(e.data.getId(0));e.selection.setCell(c.id,a.column.id,r,s),e.scrollTo(c.id,a.column.id.toString())}else{if((l=e.data.getIndex(a.row.id.toString()))+n>=0&&l+n<e.data.getLength()){c=e.data.getItem(e.data.getId(l+n));e.selection.setCell(c.id,a.column.id,r,s),e.scrollTo(c.id,a.column.id.toString())}}else if(o){c=1===n?e.config.columns[e.config.columns.length-1]:e.config.columns[0];e.selection.setCell(a.row.id,c.id,r,s),e.scrollTo(a.row.id.toString(),c.id.toString())}else{var l;(l=e.config.columns.indexOf(a.column))+n>=0&&l+n<e.config.columns.length&&(e.selection.setCell(a.row.id,e.config.columns[l+n].id,r,s),e.scrollTo(a.row.id.toString(),e.config.columns[l+n].id.toString()))}}}e.initHotkeys=function(t){var e=t.getRootView().data.getRootNode(),i=t.getRootView().refs.grid_body.el,n=e.getAttribute("dhx_widget_id");if(a.setFocusState(n),t.config.keyNavigation){var u={arrowLeft:s.isIE()?"left":"arrowLeft",arrowRight:s.isIE()?"right":"arrowRight",arrowUp:s.isIE()?"up":"arrowUp",arrowDown:s.isIE()?"down":"arrowDown",escape:s.isIE()?"esc":"escape",space:s.isIE()?"spacebar":"space"},d=function(e,i){o.keyManager.addHotKey(e,function(e){a.isFocus(n)&&t.events.fire(r.GridEvents.beforeKeyDown,[e])&&(i(e),t.events.fire(r.GridEvents.afterKeyDown,[e]))})};document.addEventListener("mousedown",function(t){var i=t.target;a.isFocus(n)||!function(t,e){for(var i=e.parentNode;null!==i;){if(i===t)return!0;i=i.parentNode}return!1}(e,i)&&!i.isEqualNode(e)?s.locateNode(t)||"null"===a.getFocusState()||a.setFocusState("null"):a.setFocusState(n)}),d("enter",function(){if(c(t.config.selection)){var e=t.selection.getCell();e&&(!1!==e.column.editable&&t.config.editable||e.column.editable)&&(t.config.$editable?t.editEnd():"boolean"!==e.column.type?t.edit(e.row.id,e.column.id,e.column.editorType):t.events.fire(r.GridEvents.afterEditEnd,[!e.row[e.column.id],e.row,e.column]))}}),d(u.space,function(e){if(c(t.config.selection)&&t.config.editable&&!t.config.$editable){var i=t.selection.getCell();i&&"boolean"===i.column.type&&(e.preventDefault(),t.events.fire(r.GridEvents.afterEditEnd,[!i.row[i.column.id],i.row,i.column]))}}),d(u.escape,function(){t.config.$editable&&t.editEnd(!0)}),d("pageUp",function(t){t.preventDefault(),i.scrollTop-=i.clientHeight}),d("pageDown",function(t){t.preventDefault(),i.scrollTop+=i.clientHeight}),d("home",function(t){t.preventDefault(),i.scrollTop=0}),d("end",function(t){t.preventDefault(),i.scrollTop+=i.scrollHeight}),d("tab",function(e){if(!t.config.$editable&&t.config.selection){e&&e.preventDefault();var i=t.selection.getCell();if(i){var n=t.config.columns.indexOf(i.column)+1;if(n>=0&&n<t.config.columns.length)t.selection.setCell(i.row.id,t.config.columns[n].id),t.scrollTo(i.row.id.toString(),t.config.columns[n].id.toString());else if(n>=0){var o=t.data.getIndex(i.row.id.toString())+1;o<t.data.getLength()&&(t.selection.setCell(t.data.getId(o),t.config.columns[0].id),t.scrollTo(t.data.getId(o),t.config.columns[0].id.toString()))}}}}),d("shift+tab",function(e){if(!t.config.$editable&&t.config.selection){e&&e.preventDefault();var i=t.selection.getCell();if(i){var n=t.config.columns.indexOf(i.column)-1;if(n>=0&&n<t.config.columns.length)t.selection.setCell(i.row.id,t.config.columns[n].id),t.scrollTo(i.row.id.toString(),t.config.columns[n].id.toString());else if(n<t.data.getLength()){var o=t.data.getIndex(i.row.id.toString())-1;o>=0&&(t.selection.setCell(t.data.getId(o),t.config.columns[t.config.columns.length-1].id),t.scrollTo(t.data.getId(o),t.config.columns[t.config.columns.length-1].id.toString()))}}}}),d(u.arrowUp,function(e){l(e,t,"vertical",-1)}),d("ctrl+"+u.arrowUp,function(e){l(e,t,"vertical",-1,!0)}),d("shift+"+u.arrowUp,function(e){t.config.multiselection&&l(e,t,"vertical",-1,!1,!1,!0)}),d("ctrl+shift+"+u.arrowUp,function(e){t.config.multiselection&&l(e,t,"vertical",-1,!0,!1,!0)}),d(u.arrowDown,function(e){l(e,t,"vertical",1)}),d("ctrl+"+u.arrowDown,function(e){l(e,t,"vertical",1,!0)}),d("shift+"+u.arrowDown,function(e){t.config.multiselection&&l(e,t,"vertical",1,!1,!1,!0)}),d("ctrl+shift+"+u.arrowDown,function(e){t.config.multiselection&&l(e,t,"vertical",1,!0,!1,!0)}),d(u.arrowRight,function(e){l(e,t,"horizontal",1)}),d("ctrl+"+u.arrowRight,function(e){l(e,t,"horizontal",1,!0)}),d("shift+"+u.arrowRight,function(e){t.config.multiselection&&l(e,t,"horizontal",1,!1,!1,!0)}),d("ctrl+shift+"+u.arrowRight,function(e){t.config.multiselection&&l(e,t,"horizontal",1,!0,!1,!0)}),d(u.arrowLeft,function(e){l(e,t,"horizontal",-1)}),d("ctrl+"+u.arrowLeft,function(e){l(e,t,"horizontal",-1,!0)}),d("shift+"+u.arrowLeft,function(e){t.config.multiselection&&l(e,t,"horizontal",-1,!1,!1,!0)}),d("ctrl+shift+"+u.arrowLeft,function(e){t.config.multiselection&&l(e,t,"horizontal",-1,!0,!1,!0)})}}},function(t,e,i){"use strict";var n=this&&this.__assign||function(){return(n=Object.assign||function(t){for(var e,i=1,n=arguments.length;i<n;i++)for(var o in e=arguments[i])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)};Object.defineProperty(e,"__esModule",{value:!0});var o=i(0),r=i(2),s=i(53),a=i(20),c=i(76),l=i(196),u=i(77),d=i(1),h=2;function f(t){if(!t)return{width:1,height:1};var e=t.currentStyle||window.getComputedStyle(t),i=parseFloat(e.paddingLeft)+parseFloat(e.paddingRight)||0,n=parseFloat(e.paddingTop)+parseFloat(e.paddingBottom)||0;return{width:t.clientWidth-i,height:t.clientHeight-n}}e.render=function(t,e,i,p,_,v){if(e._container||(e.config.width=1,e.config.height=1),t&&t.node&&t.node.parent&&t.node.parent.el){var g=f(t.node.parent.el);e.config.width=g.width,e.config.height=g.height}var m=e.config;if(!m)return o.el("div");if(!m.columns.length)return o.el(".dhx_grid");i&&e.data||(i=[]),m.columns.reduce(function(t,e){return e.hidden?t:e.hidden},!0)?m.$totalHeight=0:m.$totalHeight=i.length*m.rowHeight;var y=f(e._container),b={width:m.width?m.width:y.width,height:m.height?m.height:y.height};if(a.isAutoWidth(m)){var x=m.$totalHeight>b.height?r.getScrollbarWidth():0;m.$totalWidth=b.width-h-x;var w=m.columns.reduce(function(t,e){return e.hidden?t:t+e.width},0),k=m.$totalWidth/w,C=m.columns.reduce(function(t,e){var i=k>0?e.width*k:20;return!a.isAutoWidth(m,e)||e.maxWidth&&e.maxWidth<i||e.minWidth&&e.minWidth>i?t+e.width:t},0),E=(m.$totalWidth-C)/(w-C);m.$totalWidth=0,m.columns.map(function(t){var e=E>0?t.width*E:20,i=!a.isAutoWidth(m,t)||t.maxWidth&&t.maxWidth<e||t.minWidth&&t.minWidth>e;t.width=i?t.maxWidth||t.minWidth||t.width:e,m.$totalWidth+=t.hidden?0:t.width})}m.width=b.width,m.height=b.height;var S=function(t,e,i){var o=t.config,r=s.calculatePositions(i.width,i.height,t._scroll,o);return n(n({},o),{data:e,scroll:t._scroll,$positions:r,headerHeight:o.$headerLevel*o.headerRowHeight,footerHeight:o.$footerLevel*o.footerRowHeight,firstColId:o.columns[0].id,events:t.events,currentColumns:o.columns.slice(r.xStart,r.xEnd),sortBy:t._sortBy,sortDir:t._sortDir})}(e,i,b);S.selection=_,S.datacollection=e.data;var O=c.getShifts(S),M=a.isCssSupport("position","sticky"),T=function(t,e,i){var n=i.height-h;n=e?n:n-t.headerHeight;var o=t.$footer,s=t.$totalHeight+h<i.height;return t.splitAt&&s?t.$totalHeight+t.footerHeight+t.headerHeight+r.getScrollbarWidth():n=o?e?n:n-t.footerHeight:n}(S,M,b),I={wrapper:b,sticky:M,shifts:O,gridBodyHeight:T},D=u.getFixedRows(S,n(n({},I),{name:"header",position:"top"})),P=S.$footer?u.getFixedRows(S,n(n({},I),{name:"footer",position:"bottom"})):null,V=S.$totalWidth+h<b.width?"dhx_grid-less-width":"",L=S.$totalHeight+h<b.height?"dhx_grid-less-height":"";return o.el(".dhx_grid.dhx_widget",{class:(S.css||"")+(M?"":" dhx_grid_border")+(m.multiselection?" dhx_no-select--pointer":""),dhx_widget_id:v},[o.resizer(function(){return e.paint()}),o.el(".dhx_grid-content",{style:n({},b),onclick:p.onclick,class:(V+" "+L).trim()},[M?null:D,o.el(".dhx_grid-body",{style:{height:T,width:b.width-h},onscroll:p.onscroll,_ref:"grid_body"},[M?D:null,function(t,e){var i,r=c.getCells(t),s=c.getSpans(t);if(t.$resizing){var a=d.findIndex(t.columns,function(e){return e.id===t.$resizing}),l=t.columns.slice(0,a).reduce(function(t,e){return t+=e.width},0)+t.columns[a].width;i=o.el(".dhx_grid-resize-line",{style:{top:0,left:l,height:t.$totalHeight}})}var u=t.selection?t.selection.toHTML():null;u="string"==typeof u?o.el("div.dhx_selection",{".innerHTML":u}):u;var h=t.$positions;return o.el(".dhx_data-wrap",{style:{height:t.$totalHeight,width:t.$totalWidth,"padding-left":e.x,"padding-top":e.y}},[o.el(".dhx_grid_data",n({_flags:o.KEYED_LIST},c.getHandlers(h.yStart,h.xStart,t)),r),o.el(".dhx_span-spans",s),o.el(".dhx_grid_selection",{_ref:"selection"},[u,i])])}(S,O),M?P:null]),l.getFixedCols(S,I),M?null:P])])}},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n,o=i(10),r=i(191),s=i(192),a=i(193),c=i(194),l=i(195),u={cell:{row:null,col:null},editor:null};e.getEditor=function(t,e,i){var d="boolean"===e.type?o.EditorType.checkbox:i.$editable.editorType;if(u.cell.row===t.id&&u.cell.col===e.id)return u.editor;switch(u.cell={row:t.id,col:e.id},n||(n=function(){u={cell:{row:null,col:null},editor:null}},i.events.on(o.GridEvents.afterEditEnd,n)),d){case o.EditorType.input:return u.editor=new r.InputEditor(t,e,i);case o.EditorType.select:return u.editor=new s.SelectEditor(t,e,i);case o.EditorType.datepicker:return u.editor=new a.DateEditor(t,e,i);case o.EditorType.checkbox:return u.editor=new c.CheckboxEditor(t,e,i);case o.EditorType.combobox:return u.editor=new l.ComboboxEditor(t,e,i);default:return u.editor=new r.InputEditor(t,e,i)}}},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(0),o=i(10),r=i(1),s=function(){function t(t,e,i){this._config=i,this._cell={row:t,col:e},this._initHandlers()}return t.prototype.endEdit=function(t){var e;t||(e=this._input.value),this._config.events.fire(o.GridEvents.beforeEditEnd,[e,this._cell.row,this._cell.col])?(this._input.removeEventListener("blur",this._handlers.onBlur),this._input.removeEventListener("change",this._handlers.onChange),this._handlers={},"string"!==this._cell.col.type&&r.isNumeric(e)&&(e=parseFloat(e)),this._config.events.fire(o.GridEvents.afterEditEnd,[e,this._cell.row,this._cell.col])):this._input.focus()},t.prototype.toHTML=function(){var t=this._cell.row[this._cell.col.id];return this._input&&(t=this._input.value),this._config.$editable.editor=this,n.el("input.dhx_cell-editor.dhx_cell-editor__input",{_hooks:{didInsert:this._handlers.didInsert},_key:"cell_editor",dhx_id:"cell_editor",value:t})},t.prototype._initHandlers=function(){var t=this;this._handlers={onBlur:function(){t.endEdit()},onChange:function(){t.endEdit()},didInsert:function(e){var i=e.el;t._input=i,i.focus(),i.setSelectionRange(0,i.value.length),i.addEventListener("change",t._handlers.onChange),i.addEventListener("blur",t._handlers.onBlur)}}},t}();e.InputEditor=s},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(0),o=i(10),r=function(){function t(t,e,i){this._config=i,this._cell={row:t,col:e},this._initHandlers()}return t.prototype.endEdit=function(t){var e;t||(e=this._input.value),this._config.events.fire(o.GridEvents.beforeEditEnd,[e,this._cell.row,this._cell.col])?(this._input.removeEventListener("blur",this._handlers.onBlur),this._handlers={},this._config.events.fire(o.GridEvents.afterEditEnd,[e,this._cell.row,this._cell.col])):this._input.focus()},t.prototype.toHTML=function(){var t=this._cell.col.options||[],e=this._cell.row[this._cell.col.id];this._input&&(e=this._input.options[this._input.selectedIndex].value);var i=t.map(function(t){return n.el("option",{selected:t===e},t)});return this._config.$editable.editor=this,n.el("select.dhx_cell-editor.dhx_cell-editor__select",{_hooks:{didInsert:this._handlers.didInsert},_key:"cell_editor",dhx_id:"cell_editor"},i)},t.prototype._initHandlers=function(){var t=this;this._handlers={onBlur:function(){t.endEdit()},didInsert:function(e){var i=e.el;t._input=i,i.focus(),i.addEventListener("blur",t._handlers.onBlur)}}},t}();e.SelectEditor=r},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(0),o=i(10),r=i(25),s=i(11),a=i(2),c=function(){function t(t,e,i){var n=this;this._config=i,this._cell={row:t,col:e},this._calendar=new r.Calendar(null,{dateFormat:e.dateFormat});var o=this._cell.row[this._cell.col.id],a=this._calendar.config.dateFormat;(r.stringToDate(o,a,!0)||o instanceof Date)&&(this._calendar.setValue(o),this._value=this._calendar.getValue(),this._cell.row[this._cell.col.id]=this._value),this._popup=new s.Popup({css:"dhx_widget--bordered"}),this._popup.attach(this._calendar),this._calendar.events.on(r.CalendarEvents.change,function(){n.endEdit(!1,!0)}),this._popup.events.on(s.PopupEvents.afterHide,function(){n.endEdit()}),this._initHandlers()}return t.prototype.endEdit=function(t,e){if(this._handlers){var i=this._calendar.config.dateFormat,n=this._cell.row[this._cell.col.id];t||(n instanceof Date||e?(this._value=this._calendar.getValue(),this._input.value=this._value):r.stringToDate(this._input.value,i,!0)&&this._input.value.length===n.length&&(this._value=this._input.value)),this._config.events.fire(o.GridEvents.beforeEditEnd,[this._value,this._cell.row,this._cell.col])?(this._input.removeEventListener("focus",this._handlers.onFocus),this._input.removeEventListener("change",this._handlers.onChange),this._handlers={},this._popup.destructor(),this._calendar.destructor(),this._config.events.fire(o.GridEvents.afterEditEnd,[this._value,this._cell.row,this._cell.col])):this._input.focus()}},t.prototype.toHTML=function(){var t=this._cell.row[this._cell.col.id];return this._config.$editable.editor=this,n.el("input.dhx_cell-editor.dhx_cell-editor__input.dhx_cell-editor__datepicker",{_hooks:{didInsert:this._handlers.didInsert},_key:"cell_editor",dhx_id:"cell_editor",value:t})},t.prototype._initHandlers=function(){var t=this;this._handlers={onFocus:function(){n.awaitRedraw().then(function(){t._popup.show(t._input,{centering:!0,mode:a.Position.bottom})})},onChange:function(){t.endEdit()},didInsert:function(e){var i=e.el;t._input=i,t._input.addEventListener("focus",t._handlers.onFocus),t._input.addEventListener("change",t._handlers.onChange),i.focus(),i.setSelectionRange(i.value.length,i.value.length)}}},t}();e.DateEditor=c},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(0),o=i(10),r=function(){function t(t,e,i){this._config=i,this._cell={row:t,col:e},this._initHandlers()}return t.prototype.endEdit=function(){var t=this._checked;this._config.events.fire(o.GridEvents.beforeEditEnd,[t,this._cell.row,this._cell.col])&&(this._handlers={},this._config.events.fire(o.GridEvents.afterEditEnd,[t,this._cell.row,this._cell.col]))},t.prototype.toHTML=function(){if(void 0===this._checked&&(this._checked=this._cell.row[this._cell.col.id]),!this._input)return n.el("label.dhx_checkbox.dhx_cell-editor__checkbox",[n.el("input.dhx_checkbox__input",{type:"checkbox",_hooks:{didInsert:this._handlers.didInsert},_key:"cell_editor",dhx_id:"cell_editor",checked:this._checked,style:{userSelect:"none"}}),n.el("span.dhx_checkbox__visual-input")])},t.prototype._initHandlers=function(){var t=this;this._handlers={onChange:function(e){t._checked=e.target.checked,t.endEdit()},didInsert:function(e){t._checkbox=e.el.parentNode.lastChild,t._input=e.el.parentNode.firstChild,t._input.addEventListener("change",t._handlers.onChange)}}},t}();e.CheckboxEditor=r},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(0),o=i(10),r=i(32),s=function(){function t(t,e,i){this._config=i,this._cell={row:t,col:e},this._initHandlers()}return t.prototype.endEdit=function(t){var e;t||(e=this._input.getValue()),this._config.events.fire(o.GridEvents.beforeEditEnd,[e,this._cell.row,this._cell.col])?(document.removeEventListener("click",this._handlers.onOuterClick),this._handlers={},this._config.events.fire(o.GridEvents.afterEditEnd,[e,this._cell.row,this._cell.col])):this._input.focus()},t.prototype.toHTML=function(){var t=this,e=this._cell.col.options.map(function(t){return{id:""+t,value:t}})||[];return this._input||(this._input=new r.Combobox(null,{readonly:!0,cellHeight:37,css:"dhx_cell-editor__combobox"}),this._input.data.parse(e),this._input.setValue(this._cell.row[this._cell.col.id])),document.addEventListener("click",this._handlers.onOuterClick),this._config.$editable.editor=this,n.awaitRedraw().then(function(){var e=t._input.getRootView().refs.holder.el;t._input.popup.getContainer().style.width=e.offsetWidth+"px",t._input.popup.show(e)}),n.inject(this._input.getRootView())},t.prototype._initHandlers=function(){var t=this;this._handlers={onOuterClick:function(e){e.target instanceof Node&&t._input.getRootNode()&&t._input.getRootNode().contains(e.target)||t.endEdit()}}},t}();e.ComboboxEditor=s},function(t,e,i){"use strict";var n=this&&this.__assign||function(){return(n=Object.assign||function(t){for(var e,i=1,n=arguments.length;i<n;i++)for(var o in e=arguments[i])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)};Object.defineProperty(e,"__esModule",{value:!0});var o=i(0),r=i(2),s=i(76),a=i(77);e.getFixedCols=function(t,e){var i=t.columns.reduce(function(t,e){return e.hidden?t+1:t},0);if("number"==typeof t.splitAt&&i!==t.splitAt){var c=t.$totalWidth<=e.wrapper.width?0:r.getScrollbarWidth(),l=(e.sticky?e.gridBodyHeight:e.gridBodyHeight+t.headerHeight)-c,u=t.columns.slice(0,t.splitAt);t.fixedColumnsWidth=u.reduce(function(t,e){return t+(e.hidden?0:e.width||100)},0);var d=s.getCells(n(n({},t),{columns:u,$positions:n(n({},t.$positions),{xStart:0,xEnd:t.splitAt})})),h=e.sticky,f=n(n({},e),{name:"header",position:"top"}),p=n(n({},e),{name:"footer",position:"bottom"}),_=t.splitAt>=0&&a.getRows(n(n({},t),{currentColumns:t.columns.slice(0,t.splitAt),$positions:n(n({},t.$positions),{xStart:0,xEnd:t.splitAt})}),n(n({},e),{name:"header",position:"top"})),v=t.splitAt>=0&&a.getRows(n(n({},t),{currentColumns:t.columns.slice(0,t.splitAt),$positions:n(n({},t.$positions),{xStart:0,xEnd:t.splitAt})}),n(n({},e),{name:"footer",position:"bottom"})),g=_&&o.el(".dhx_"+f.name+"-fixed-cols",{style:{position:"absolute",top:0,left:0,zIndex:999999}},_),m=h?v&&o.el(".dhx_"+p.name+"-fixed-cols",{style:{position:"absolute",bottom:0,left:0,zIndex:999999}},v):null,y=t.$positions;return o.el(".dhx_grid-fixed-cols-wrap",{style:{height:l,paddingTop:t.headerHeight,overflow:"hidden",width:t.fixedColumnsWidth}},[g,o.el(".dhx_grid-fixed-cols",n({style:{top:-t.scroll.top+t.headerHeight-1+"px",paddingTop:e.shifts.y,height:t.$totalHeight,position:"absolute"},_flags:o.KEYED_LIST},s.getHandlers(y.yStart,y.xStart,t)),d),t.$footer&&m,o.el(".dhx_frozen-cols-border")])}}},function(t,e,i){"use strict";var n=this&&this.__spreadArrays||function(){for(var t=0,e=0,i=arguments.length;e<i;e++)t+=arguments[e].length;var n=Array(t),o=0;for(e=0;e<i;e++)for(var r=arguments[e],s=0,a=r.length;s<a;s++,o++)n[o]=r[s];return n};Object.defineProperty(e,"__esModule",{value:!0});var o=i(1),r=i(10),s=i(2);e.startResize=function(t,e,i,a){var c=i.clientX,l=0;t.config.$resizing=e;var u=function(i){var a=o.findIndex(t.config.columns,function(t){return t.id===e}),u=i.clientX-t.getRootNode().getBoundingClientRect().left,d=t.config.$totalHeight>t.config.height?s.getScrollbarWidth():0;if(!(t.config.splitAt===a+1&&u>=t.config.width-d-2)){l=l||t.config.columns[a].width;var h,f=t.config.columns[a].minWidth||20,p=t.config.columns[a].maxWidth,_=i.clientX-c,v=n(t.config.columns),g=l+_;p&&g>=p||g<=f?(g<=f&&(h=f),g>=p&&(h=p)):h=g,v[a].width=h,t.events.fire(r.GridEvents.resize,[t.config.columns[a],i]),t.paint()}},d=function(){document.removeEventListener("mousemove",u),document.removeEventListener("mouseup",d),a()};document.addEventListener("mousemove",u),document.addEventListener("mouseup",d),t.paint()}},function(t,e,i){"use strict";function n(t){for(var i in t)e.hasOwnProperty(i)||(e[i]=t[i])}Object.defineProperty(e,"__esModule",{value:!0}),n(i(199)),n(i(200));var o=i(17);e.ItemType=o.ItemType,e.NavigationBarEvents=o.NavigationBarEvents},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}();Object.defineProperty(e,"__esModule",{value:!0});var o=i(2),r=i(17),s=function(t){function e(){var e=null!==t&&t.apply(this,arguments)||this;return e._isContextMenu=!0,e}return n(e,t),e.prototype.showAt=function(t,e){if(void 0===e&&(e="bottom"),t instanceof MouseEvent)this._changeActivePosition({left:window.pageXOffset+t.x+1,right:window.pageXOffset+t.x+1,top:window.pageYOffset+t.y,bottom:window.pageYOffset+t.y},e);else{var i=o.toNode(t);this._changeActivePosition(o.getRealPosition(i),e)}},e.prototype._getFactory=function(){return r.createFactory({widget:this,defaultType:r.ItemType.menuItem,allowedTypes:[r.ItemType.menuItem,r.ItemType.spacer,r.ItemType.separator,r.ItemType.customHTML,r.ItemType.customHTMLButton],widgetName:"context-menu"})},e.prototype._close=function(e){t.prototype._close.call(this,e),this._activeMenu=null,this._changeActivePosition(null,null)},e.prototype._getMode=function(t,e,i){return i?this._mode:"right"},e.prototype._changeActivePosition=function(t,e){this._activePosition=t,this._mode=e,this._listenOuterClick(),this.paint()},e}(r.Navbar);e.ContextMenu=s},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}();Object.defineProperty(e,"__esModule",{value:!0});var o=i(0),r=i(17),s=function(t){function e(e,i){var n=t.call(this,e,i)||this;return n.mount(e,o.create({render:function(){return n._draw()}})),n}return n(e,t),e.prototype._getFactory=function(){return r.createFactory({widget:this,defaultType:r.ItemType.menuItem,allowedTypes:[r.ItemType.menuItem,r.ItemType.spacer,r.ItemType.separator,r.ItemType.customHTML,r.ItemType.customHTMLButton],widgetName:"menu-nav"})},e.prototype._draw=function(){return o.el("ul.dhx_widget",{dhx_widget_id:this._uid,onmousemove:this._handlers.onmousemove,onmouseleave:this._handlers.onmouseleave,onclick:this._handlers.onclick,onmousedown:this._handlers.onmousedown,class:"dhx_menu-nav "+(this.config.css?this.config.css:"")},this._drawMenuItems(this.data.getRoot(),!1))},e}(r.Navbar);e.Menu=s},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),function(t){for(var i in t)e.hasOwnProperty(i)||(e[i]=t[i])}(i(202))},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}();Object.defineProperty(e,"__esModule",{value:!0});var o=i(0),r=i(29),s=i(17),a=i(1),c=i(2),l=i(19),u=function(t){function e(e,i){var n=t.call(this,e,a.extend({navigationType:"click"},i))||this;n._listeners={input:function(t){var e=c.locate(t);n.data.update(e,{value:t.target.value})},tooltip:function(t){var e=c.locateNode(t);if(e){var i=e.getAttribute("dhx_id"),o=n.data.getItem(i);o.tooltip&&l.tooltip(o.tooltip,{node:e,position:l.Position.bottom})}}},n._currentRoot=null;return n.mount(e,o.create({render:function(){return n._draw()}})),n}return n(e,t),e.prototype.getState=function(){var t={};for(var e in this.data.eachChild(this.data.getRoot(),function(e){e.twoState&&!e.group?t[e.id]=e.active:e.type!==r.ItemType.input&&e.type!==r.ItemType.selectButton||(t[e.id]=e.value)},!0),this._groups)this._groups[e].active&&(t[e]=this._groups[e].active);return t},e.prototype.setState=function(t){for(var e in t)if(this._groups&&this._groups[e])this._groups[e].active&&(this.data.update(this._groups[e].active,{active:!1}),this._groups[e].active=t[e],this.data.update(t[e],{active:!0}));else{var i=this.data.getItem(e);i.type===r.ItemType.input||i.type===r.ItemType.selectButton?this.data.update(e,{value:t[e]}):this.data.update(e,{active:t[e]})}},e.prototype._getFactory=function(){return s.createFactory({widget:this,defaultType:r.ItemType.navItem,allowedTypes:[r.ItemType.navItem,r.ItemType.button,r.ItemType.customHTMLButton,r.ItemType.customHTML,r.ItemType.imageButton,r.ItemType.input,r.ItemType.selectButton,r.ItemType.separator,r.ItemType.spacer,r.ItemType.title],widgetName:"ribbon"})},e.prototype._getMode=function(t,e){return t.id===e?"bottom":"right"},e.prototype._close=function(e){this._activePosition=null,this._currentRoot=null,t.prototype._close.call(this,e)},e.prototype._draw=function(){var t=this;return o.el("ul.dhx_ribbon.dhx_widget",{dhx_widget_id:this._uid,class:this.config.css?this.config.css:"",tabindex:0,onclick:this._handlers.onclick,onmousedown:this._handlers.onmousedown,oninput:this._listeners.input,onmouseover:this._listeners.tooltip,_hooks:{didInsert:function(e){e.el.addEventListener("keyup",function(e){if(9===e.which){var i=c.locateNode(document.activeElement);if(i){var n=i.getAttribute("dhx_id"),o=t.data.getItem(n);o.tooltip&&l.tooltip(o.tooltip,{node:i,position:l.Position.bottom,force:!0})}}},!0)}}},[o.el("li",{class:"dhx_ribbon-block dhx_ribbon-block--root"},[o.el("ul.dhx_ribbon-content.dhx_ribbon-content--full-width",this.data.map(function(e){return"block"===e.type?t._drawBlock(e,!0):t._factory(e)},this.data.getRoot(),!1))])])},e.prototype._setRoot=function(t){var e=this.data.getParent(t);this.data.getItem(e).type===r.ItemType.block&&(this._currentRoot=t)},e.prototype._drawBlock=function(t,e){var i=this;if(!t||t.hidden)return null;var n="dhx_ribbon-block dhx_ribbon-block"+("col"===t.direction?"--col":"--row")+(t.title?" dhx_ribbon-block--title":"")+(t.css?" "+t.css:"")+(e?" dhx_ribbon-block--indented":""),s=this.data.map(function(t){return t.type===r.ItemType.block?i._drawBlock(t):t.type!==r.ItemType.separator&&t.type!==r.ItemType.spacer?i._factory(t):null},t.id,!1);return o.el("li",{class:n},[o.el("ul.dhx_ribbon-content",s),t.title?o.el("span.dhx_ribbon-content-label-wrapper",[o.el("span.dhx_ribbon-content-label",t.title)]):null])},e}(s.Navbar);e.Ribbon=u},function(t,e,i){"use strict";function n(t){for(var i in t)e.hasOwnProperty(i)||(e[i]=t[i])}Object.defineProperty(e,"__esModule",{value:!0}),n(i(204)),n(i(79))},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}();Object.defineProperty(e,"__esModule",{value:!0});var o=i(0),r=i(2),s=i(79),a=i(19),c=i(17),l=i(1),u=function(t){function e(e,i){var n=t.call(this,e,l.extend({navigationType:"click",width:"200",minWidth:"44",collapsed:!1},i))||this;n._currentRoot=null;return n.mount(e,o.create({render:function(){return n._draw()}})),n}return n(e,t),e.prototype.toggle=function(){this.config.collapsed?this.expand():this.collapse(),this.events.fire(s.SidebarEvents.toggle,[this.config.collapsed]),this.paint()},e.prototype.collapse=function(){this.events.fire(s.SidebarEvents.beforeCollapse,[])&&(this.config.collapsed=!0,this.events.fire(s.SidebarEvents.afterCollapse,[]),this.paint())},e.prototype.expand=function(){this.events.fire(s.SidebarEvents.beforeExpand,[])&&(this.config.collapsed=!1,this.events.fire(s.SidebarEvents.afterExpand,[]),this.paint())},e.prototype.isCollapsed=function(){return this.config.collapsed},e.prototype._getFactory=function(){return c.createFactory({widget:this,defaultType:c.ItemType.navItem,allowedTypes:[c.ItemType.navItem,c.ItemType.menuItem,c.ItemType.customHTMLButton,c.ItemType.customHTML,c.ItemType.separator,c.ItemType.spacer,c.ItemType.title],widgetName:"sidebar"})},e.prototype._close=function(e){this._activePosition=null,this._currentRoot=null,t.prototype._close.call(this,e)},e.prototype._setRoot=function(t){this.data.getParent(t)===this.data.getRoot()&&(this._currentRoot=t)},e.prototype._customHandlers=function(){var t=this;return{tooltip:function(e){var i=r.locateNode(e);if(i){var n=i.getAttribute("dhx_id"),o=t.data.getItem(n);(o.tooltip||t.config.collapsed&&o.value)&&a.tooltip(o.tooltip||o.value,{node:i,position:a.Position.right})}}}},e.prototype._draw=function(){var t=this,e=this.config,i=e.width,n=e.minWidth,s=this.config.collapsed?n:i;return o.el("nav.dhx_widget.dhx_sidebar",{class:(this.config.css?this.config.css:"")+(this.config.collapsed?" dhx_sidebar--minimized":""),style:{width:s+"px"}},[o.el("ul.dhx_navbar.dhx_navbar--vertical",{dhx_widget_id:this._uid,tabindex:0,onclick:this._handlers.onclick,onmousedown:this._handlers.onmousedown,oninput:this._handlers.input,onmouseover:this._handlers.tooltip,_hooks:{didInsert:function(e){e.el.addEventListener("keyup",function(e){if(9===e.which){var i=r.locateNode(document.activeElement);if(i){var n=i.getAttribute("dhx_id"),o=t.data.getItem(n);(o.tooltip||t.config.collapsed&&o.value)&&a.tooltip(o.tooltip||o.value,{node:i,position:a.Position.right,force:!0})}}},!0)}}},this.data.map(function(e){return t._factory(e)},this.data.getRoot(),!1))])},e.prototype._getMode=function(){return"right"},e.prototype._customInitEvents=function(){var t=this;this.events.on(c.NavigationBarEvents.inputBlur,function(){t._waitRestore&&(t.toggle(),t._waitRestore=!1)}),this.events.on(c.NavigationBarEvents.inputFocus,function(){t.config.collapsed&&(t._waitRestore=!0,t.toggle())})},e}(c.Navbar);e.Sidebar=u},function(t,e,i){"use strict";function n(t){for(var i in t)e.hasOwnProperty(i)||(e[i]=t[i])}Object.defineProperty(e,"__esModule",{value:!0}),n(i(206)),n(i(80))},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),o=this&&this.__assign||function(){return(o=Object.assign||function(t){for(var e,i=1,n=arguments.length;i<n;i++)for(var o in e=arguments[i])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)},r=this&&this.__spreadArrays||function(){for(var t=0,e=0,i=arguments.length;e<i;e++)t+=arguments[e].length;var n=Array(t),o=0;for(e=0;e<i;e++)for(var r=arguments[e],s=0,a=r.length;s<a;s++,o++)n[o]=r[s];return n};Object.defineProperty(e,"__esModule",{value:!0});var s=i(1),a=i(0),c=i(3),l=i(2),u=i(13),d=i(14),h=i(80),f=function(t){function e(e,i){var n=t.call(this,e,s.extend({mode:h.RenderMode.top,tabWidth:200,tabHeight:45},i))||this;if(n.config.disabled){var o=n.config.disabled,r=n._cells.map(function(t){return t.id});Array.isArray(o)?o.forEach(function(t){-1!==r.indexOf(t)&&-1===n._disabled.indexOf(t)&&n._disabled.push(t)}):-1!==r.indexOf(o)&&-1===n._disabled.indexOf(o)&&n._disabled.push(o),n.paint()}return n.events=new c.EventSystem(n),n}return n(e,t),e.prototype.toVDOM=function(){var t=null;if(!this.config.noContent&&(t=this.getCell(this.config.activeView))){var e=-1!==this._disabled.indexOf(this.config.activeView)?" dhx_tabbar-content--disabled":"";t.config.css?-1!==t.config.css.indexOf("dhx_tabbar-content--disabled")?t.config.css=t.config.css.replace("dhx_tabbar-content--disabled",""):t.config.css=t.config.css+e:t.config.css=e}return a.el("div",{class:"dhx_widget dhx_tabbar"+(this.config.mode?" dhx_tabbar--"+this.config.mode:"")+(this.config.css?" "+this.config.css:"")},[this._drawTabs(),t?t.toVDOM():null])},e.prototype.destructor=function(){this._hotkeysDestructor(),t.prototype.destructor.call(this)},e.prototype.getWidget=function(){var t=this;return this._cells.filter(function(e){return t.getActive()===e.id})[0].getWidget()},e.prototype.setActive=function(t){if(-1!==this._cells.map(function(t){return t.id}).indexOf(t)&&-1===this._disabled.indexOf(t)){var e=this.config.activeView;this.getCell(t).show(),this._focusTab(t),this.events.fire(h.TabbarEvents.change,[t,e])}},e.prototype.getActive=function(){return this.config?this.config.activeView:null},e.prototype.addTab=function(t,e){this.addCell(t,e)},e.prototype.removeTab=function(e){var i=this;if(this.events.fire(h.TabbarEvents.beforeClose,[e])){if(e===this.config.activeView){var n=this._getEnableTabs().length,o=s.findIndex(this._getEnableTabs(),function(t){return t.id===i.config.activeView});if(o<0)return;o===n-1&&(o-=1),t.prototype.removeCell.call(this,e),1===n?this.config.activeView=null:this.setActive(this._getEnableTabs()[o].id)}else t.prototype.removeCell.call(this,e);this.events.fire(h.TabbarEvents.afterClose,[e]),this.events.fire(h.TabbarEvents.close,[e])}},e.prototype.disableTab=function(t){return-1!==this._cells.map(function(t){return t.id}).indexOf(t)&&-1===this._disabled.indexOf(t)&&(this._disabled.push(t),this.paint(),!0)},e.prototype.enableTab=function(t){if(-1!==this._disabled.indexOf(t)){var e=this._disabled.filter(function(e){return e!==t});this._disabled=r(e),this.paint()}},e.prototype.isDisabled=function(t){return-1!==this._disabled.indexOf(t||this.config.activeView)},e.prototype.removeCell=function(t){this.removeTab(t)},e.prototype._initHandlers=function(){var e=this;t.prototype._initHandlers.call(this),this._handlers=o(o({},this._handlers),{onTabClick:function(t){var i=l.locate(t,"dhx_tabid");if(i&&-1===e._disabled.indexOf(i)){var n=e.config.activeView;t.target.classList.contains("dhx_tabbar-tab__close")?e.removeTab(i):(e.config.activeView=i,e.events.fire(h.TabbarEvents.change,[e.config.activeView,n])),e.paint()}}});var i=function(t){t.preventDefault();var i=e._getEnableTabs(),n=s.findIndex(i,function(t){return t.id===e.config.activeView}),o=e.config.activeView;-1!==n&&(n===i.length-1?e.config.activeView=i[0].id:e.config.activeView=i[n+1].id,e.events.fire(h.TabbarEvents.change,[e.config.activeView,o]),e._focusTab(e.config.activeView),e.paint())},n=function(t){t.preventDefault();var i=e._getEnableTabs(),n=s.findIndex(i,function(t){return t.id===e.config.activeView}),o=e.config.activeView;-1!==n&&(e.config.activeView=0===n?i[i.length-1].id:i[n-1].id,e.events.fire(h.TabbarEvents.change,[e.config.activeView,o]),e._focusTab(e.config.activeView),e.paint())},r="right"===this.config.mode||"left"===this.config.mode;this._hotkeysDestructor=u.addHotkeys({arrowright:i,arrowup:r?n:i,arrowleft:n,arrowdown:r?i:n},function(){return l.locate(document.activeElement,"tabs_id")===e._uid})},e.prototype._focusTab=function(t){var e=this;a.awaitRedraw().then(function(){e.getRootView().refs[t].el.focus()})},e.prototype._getEnableTabs=function(){var t=this;return this._cells.filter(function(e){return-1===t._disabled.indexOf(e.config.id)})},e.prototype._getIndicatorPosition=function(){var t=this,e=s.findIndex(this._cells,function(e){return e.id===t.config.activeView});switch(-1===e&&(e=0),this.config.mode){case h.RenderMode.bottom:case h.RenderMode.top:return{transform:"translateX("+this.config.tabWidth*e+"px)",width:this.config.tabWidth+"px",height:"2px"};case h.RenderMode.left:case h.RenderMode.right:return{transform:"translateY("+this.config.tabHeight*e+"px)",height:this.config.tabHeight+"px",width:"2px"}}},e.prototype._drawTabs=function(){var t=this;if(!this._cells.length)return null;var e=this.config.tabWidth?{width:this.config.tabWidth+"px",height:this.config.tabHeight+"px"}:null;return a.el(".dhx_tabbar-header__wrapper",[a.el(".dhx_tabbar-header-active",{style:this._getIndicatorPosition()}),a.el("ul."+this.config.mode,{tabs_id:this._uid,class:"dhx_tabbar-header ",onclick:this._handlers.onTabClick},r(this._cells.map(function(i){var n=t.config,o=n.closable,r=n.closeButtons,s=n.activeView;return a.el("li",{class:"dhx_tabbar-tab"+(i.config.tabCss?" "+i.config.tabCss:""),dhx_tabid:i.id,role:"presentation"},[a.el("button.dhx_button.dhx_tabbar-tab-button"+(s===i.id?".dhx_tabbar-tab-button--active":"")+(-1!==t._disabled.indexOf(i.config.id)?".dhx_tabbar-tab-button--disabled":""),{tabindex:"0",style:e,"aria-controls":i.id,id:"tab-content-"+i.id,"aria-selected":""+(s===i.id),_ref:i.id},[a.el("span.dhx_button__text",i.config.tab)]),Array.isArray(o)&&-1!==o.indexOf(i.config.id)&&-1===t._disabled.indexOf(i.config.id)||o&&"boolean"==typeof o&&-1===t._disabled.indexOf(i.config.id)||r&&"boolean"==typeof r&&-1===t._disabled.indexOf(i.config.id)?a.el("div.dhx_tabbar-tab__close.dxi--small.dxi.dxi-close",{tabindex:0,role:"button","aria-pressed":"false"}):null])})))])},e}(d.Layout);e.Tabbar=f},function(t,e,i){"use strict";function n(t){for(var i in t)e.hasOwnProperty(i)||(e[i]=t[i])}Object.defineProperty(e,"__esModule",{value:!0}),n(i(208)),n(i(81)),n(i(82))},function(t,e,i){"use strict";var n=this&&this.__extends||function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function n(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),o=this&&this.__assign||function(){return(o=Object.assign||function(t){for(var e,i=1,n=arguments.length;i<n;i++)for(var o in e=arguments[i])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)};Object.defineProperty(e,"__esModule",{value:!0});var r=i(1),s=i(0),a=i(3),c=i(2),l=i(22),u=i(4),d=i(7),h=i(81),f=i(209),p=i(82);function _(t){return 20*t}var v=function(t){function e(e,i){void 0===i&&(i={});var n=t.call(this,e,r.extend({dropBehaviour:d.DropBehaviour.child,icon:{file:"dxi dxi-file-outline",folder:"dxi dxi-folder",openFolder:"dxi dxi-folder-open"},editable:!1},i))||this;n.config.editable=n.config.editable||n.config.editing;var o=function(t){return t.opened=t.opened,t.$mark=p.SelectStatus.unselected,t.checkbox=n.config.checkbox,t.$autoload=Boolean(t.items&&n.config.autoload),t.$editor=!1,t};Array.isArray(n.config.data)?(n.events=new a.EventSystem(n),n.data=new d.TreeCollection({autoload:n.config.autoload,init:o},n.events),n.data.parse(n.config.data)):n.config.data&&n.config.data.events?(n.data=n.config.data,n.data.config.init=o,n.events=n.data.events,n.events.context=n):(n.events=new a.EventSystem(n),n.data=new d.TreeCollection({autoload:n.config.autoload,init:o},n.events)),n._isSelectionActive=!0,n.selection=new d.Selection({},n.data,n.events),n.config.keyNavigation&&f.keyNavigation.add(n._uid,n),n._editor=h.default,n._initEvents(),n._initHandlers(),n.config.dragMode&&d.dragManager.setItem(n._uid,n),n._root=n.data.getRoot();return n.mount(e,s.create({render:function(){return n._draw()}})),n}return n(e,t),e.prototype.focusItem=function(t){var e=this;this._focusId=t,this.data.eachParent(t,function(t){t.opened||e.expand(t.id)}),this.paint()},e.prototype.destructor=function(){this.events.clear(),this.unmount()},e.prototype.editItem=function(t,e){this.data.update(t,{$edit:!0,$editConfig:e})},e.prototype.getState=function(){var t={};return this.data.eachChild(this._root,function(e){t[e.id]={open:e.opened,selected:e.$mark}},!0),t},e.prototype.setState=function(t){this.data.eachChild(this._root,function(e){e.id in t&&(e.opened=t[e.id].open,e.$mark=t[e.id].selected)},!0),this.paint()},e.prototype.toggle=function(t){var e=this.data.getItem(t);e.$autoload?(this.data.loadItems(t),this.data.update(t,{$autoload:!1,opened:!0})):e.opened?this.collapse(t):this.expand(t)},e.prototype.getChecked=function(){var t=[];return this.data.eachChild(this._root,function(e){e.$mark===p.SelectStatus.selected&&t.push(e.id)}),t},e.prototype.checkItem=function(t){this._updateItemCheck(t,p.SelectStatus.selected)},e.prototype.collapse=function(t){if(this.data.haveItems(t)){if(!this.events.fire(p.TreeEvents.beforeCollapse,[t]))return;this.data.update(t,{opened:!1}),this.events.fire(p.TreeEvents.afterCollapse,[t])}},e.prototype.collapseAll=function(){var t=this;this.data.eachChild(this._root,function(e){var i=e.id;return t.collapse(i)},!0)},e.prototype.expand=function(t){if(this.data.haveItems(t)){if(!this.events.fire(p.TreeEvents.beforeExpand,[t]))return;this.data.update(t,{opened:!0}),this.events.fire(p.TreeEvents.afterExpand,[t])}},e.prototype.expandAll=function(){var t=this;this.data.eachChild(this._root,function(e){var i=e.id;return t.expand(i)},!0)},e.prototype.uncheckItem=function(t){this._updateItemCheck(t,p.SelectStatus.unselected)},e.prototype.close=function(t){this.collapse(t)},e.prototype.closeAll=function(){this.collapseAll()},e.prototype.open=function(t){this.expand(t)},e.prototype.openAll=function(){this.expandAll()},e.prototype.unCheckItem=function(t){this.uncheckItem(t)},e.prototype._draw=function(){var t=this._drawItems(this.data.getRoot());return s.el("ul",o({class:"dhx_widget dhx_tree"+(this._isSelectionActive?"":" dhx_tree--no-selection ")+(this.config.css?" "+this.config.css:""),dhx_widget_id:this._uid},this._handlers),t)},e.prototype._initEvents=function(){var t=this;this.data.events.on(d.DataEvents.change,function(e,i,n){"remove"===i&&t._updateParents(n.parent,!0),"add"===i&&t._updateParents(e),t.paint()}),this._editor.events.on(h.EditorEvents.end,function(e,i,n){t._uid===e&&t.data.update(i,{$edit:!1,value:n}),f.keyNavigation.block(!1)}),this._editor.events.on(h.EditorEvents.begin,function(e){e===t._uid&&f.keyNavigation.block(!0)}),this.events.on(d.DragEvents.beforeDrag,function(e,i){var n=g(t.config.isFolder?t.config.isFolder(e):t.data.haveItems(e.id),e.opened),o=(e.icon||t.config.icon)[n]||t.config.icon[n];i.innerHTML='<div class="dhx_tree-list-item__icon '+o+'"></div><span class="dhx_tree-list-item__text">'+(e.text||e.value)+"</span>"}),this.events.on(d.DragEvents.canDrop,function(e,i){var n;n=t.config.dropBehaviour===d.DropBehaviour.complex?i===d.DropPosition.top?"dhx_tree-drop--top":i===d.DropPosition.bot?"dhx_tree-drop--bottom":"dhx_tree-drop--in-folder":t.config.dropBehaviour===d.DropBehaviour.child?"dhx_tree-drop--in-folder":"dhx_tree-drop--bottom",t.data.exists(e)&&t.data.update(e,{$drophere:n})}),this.events.on(d.DragEvents.cancelDrop,function(e){t.data.exists(e)&&t.data.update(e,{$drophere:null})}),this.events.on(d.DragEvents.dropComplete,function(e,i){(t.config.dropBehaviour===d.DropBehaviour.child||t.config.dropBehaviour===d.DropBehaviour.complex&&i===d.DropPosition.in)&&t.expand(e)}),this.events.on(d.DragEvents.dragStart,function(){t._isSelectionActive=!1,t.paint()}),this.events.on(d.DragEvents.dragEnd,function(){t._isSelectionActive=!0,t.paint()}),this.events.on(l.SelectionEvents.afterSelect,function(e){return t._focusId=e}),this.config.editable&&this.events.on(p.TreeEvents.itemDblClick,function(e){return t.editItem(e)})},e.prototype._initHandlers=function(){var t=this;this._handlers={onmouseleave:function(t){d.dragManager._cancelCanDrop()},onclick:function(e){var i=c.locate(e);i&&(e.target.classList.contains("dhx_tree-toggle-button")?t.toggle(i):e.target.classList.contains("dhx_tree-checkbox")?t.data.getItem(i).$mark===p.SelectStatus.unselected?t.checkItem(i):t.uncheckItem(i):(t.events.fire(p.TreeEvents.itemClick,[i,e]),t.data.exists(i)&&t.selection.add(i)))},ondblclick:function(e){var i=c.locate(e);t.events.fire(p.TreeEvents.itemDblClick,[i,e])},ondragstart:function(t){t.preventDefault()},onmousedown:function(e){t.config.dragMode&&t.config.dragMode!==d.DragMode.target&&d.dragManager.onMouseDown(e)},oncontextmenu:function(e){var i=c.locate(e);i&&(t.events.fire(p.TreeEvents.itemRightClick,[i,e]),t.events.fire(p.TreeEvents.itemContextMenu,[i,e]))}}},e.prototype._drawItems=function(t,e){var i=this;return void 0===e&&(e=0),this.data.map(function(t){if(t){var n,r,a,c=!!i.config.isFolder&&i.config.isFolder(t);if((t.$autoload||i.data.haveItems(t.id))&&(c=!0,n=s.el("div",{class:"dxi dxi-menu-right dhx_tree-toggle-button"},""),t.opened&&(n=s.el("div",{class:"dxi dxi-menu-down dhx_tree-toggle-button dhx_tree-toggle-button--open"},""),r=i._drawItems(t.id,e+1))),t.checkbox){var l=t.$mark===p.SelectStatus.indeterminate?"dxi-minus-box":t.$mark===p.SelectStatus.selected?"dxi-checkbox-marked":"dxi-checkbox-blank-outline";a=s.el("div",{class:"dhx_tree-checkbox dxi "+l})}var u,d=g(c,t.opened),h=(t.icon||i.config.icon)[d]||i.config.icon[d];return u=t.$edit?i._editor.edit(i._uid,o({item:t},t.$editConfig)):s.el("span",{class:"dhx_tree-list-item__text"},t.text||t.value),c?s.el("li",{class:"dhx_tree-list-item dhx_tree-list-item--parent"+(t.css?" "+t.css:""),dhx_id:t.id,_key:t.id},[s.el("div.dhx_tree-folder",{class:(t.id===i._focusId?" dhx_tree-folder--focused":"")+(t.$selected?" dhx_tree-folder--selected":"")+(t.$drophere?" "+t.$drophere:""),style:{left:-_(e)+"px",right:-_(e)+"px","margin-left":_(e)+"px"}},[n,s.el("div.dhx_tree-list-item__content",[a,s.el("div",{class:"dhx_tree-list-item__icon "+h}),u])]),r&&s.el("ul.dhx_tree-list",r)]):s.el("li",{class:"dhx_tree-list__item dhx_tree-list-item"+(t.id===i._focusId?" dhx_tree-list-item--focused":"")+(t.$selected?" dhx_tree-list-item--selected":"")+(t.$drophere?" "+t.$drophere:"")+(c?"dhx_tree-list-item--folder":""),style:{left:-_(e)+"px",right:-_(e)+"px","margin-left":_(e)+"px"},dhx_id:t.id,level:e},[n,s.el("div",{class:"dhx_tree-list-item__content"},[a,s.el("div",{class:"dhx_tree-list-item__icon "+h}),u])])}},t,!1)},e.prototype._updateItemCheck=function(t,e){this.data.update(t,{$mark:e}),this.data.eachChild(t,function(t){return t.$mark=e}),this._updateParents(t)},e.prototype._updateParents=function(t,e){var i=this;void 0===e&&(e=!1),t!==this._root&&this.data.eachParent(t,function(t){var e=0,n=0;i.data.eachChild(t.id,function(t){if(t.checkbox)switch(t.$mark){case p.SelectStatus.unselected:n++;break;case p.SelectStatus.selected:e++}},!0),t.$mark=0!==e&&0!==n?p.SelectStatus.indeterminate:0===e&&0!==n?p.SelectStatus.unselected:p.SelectStatus.selected},e)},e}(u.View);function g(t,e){return t?e?p.ItemIcon.openFolder:p.ItemIcon.folder:p.ItemIcon.file}e.Tree=v},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(1),o=i(2),r=i(13),s=function(){function t(){this._store={},this._keyManager=r.keyManager,this._listen=!1,this._blocked=!1}return t.prototype.add=function(t,e){this._listen||(this._listen=!0,this._initKeys(),this._addListeners()),this._store[t]=e},t.prototype.block=function(t){this._blocked=t},t.prototype._initKeys=function(){var t=this;this._keyManager.addHotKey("arrowleft",function(e){if(!t._blocked){e.preventDefault();var i=t._store[t._activeTarget];if(i){var n=t._getFocused(),o=i.data.getParent(n);if(i.data.getRoot()!==o)!i.data.getItem(n).opened?i.focusItem(o):n!==i.data.getRoot()&&i.collapse(n);else i.collapse(n)}}}),this._keyManager.addHotKey("arrowright",function(e){if(!t._blocked){e.preventDefault();var i=t._store[t._activeTarget];if(i){var n=t._getFocused();i.data.haveItems(n)&&i.expand(n)}}}),this._keyManager.addHotKey("arrowup",function(e){if(!t._blocked){e.preventDefault();var i=t._store[t._activeTarget];if(i){var n=t._getFocused(),o=i.data,r=t._getClosestTop(n,o);r&&i.focusItem(r)}}}),this._keyManager.addHotKey("arrowdown",function(e){if(!t._blocked){e.preventDefault();var i=t._store[t._activeTarget];if(i){var n=t._getFocused(),o=i.data,r=t._getClosestBot(n,o);r&&i.focusItem(r)}}}),this._keyManager.addHotKey("enter",function(){if(!t._blocked){var e=t._store[t._activeTarget];if(e){var i=t._getFocused();i&&e.selection.add(i)}}})},t.prototype._getFocused=function(){var t=this._store[this._activeTarget],e=t._focusId;if(e)return e;var i=t.data.getRoot();return t.data.getItems(i)[0].id},t.prototype._addListeners=function(){var t=this;document.addEventListener("click",function(e){var i=o.locate(e,"dhx_widget_id");i in t._store&&(t._activeTarget=i)}),r.keyManager.addHotKey("tab",function(e){var i=o.locate(e,"dhx_widget_id");i in t._store&&(t._activeTarget=i)},this)},t.prototype._getClosestBot=function(t,e,i){void 0===i&&(i=!1);var o=e.getItem(t);if(e.haveItems(t)&&o.opened&&!i)return e.getItems(t)[0].id;var r=e.getParent(t),s=e.getItems(r),a=n.findIndex(s,function(e){return e.id===t});return a+1<s.length?s[a+1].id:r===e.getRoot()?null:this._getClosestBot(r,e,!0)},t.prototype._getClosestTop=function(t,e){var i=e.getIndex(t),n=e.getParent(t);if(i>0){var o=e.getItems(n)[i-1];if(!e.haveItems(o.id)||!o.opened)return o.id;for(;e.haveItems(o.id)&&o.opened;){var r=e.getItems(o.id);o=r[r.length-1]}return o.id}return n===e.getRoot()?null:n},t}();e.keyNavigation=new s},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),function(t){for(var i in t)e.hasOwnProperty(i)||(e[i]=t[i])}(i(211))},function(t,e,i){"use strict";(function(t){Object.defineProperty(e,"__esModule",{value:!0});var n=i(1),o=i(0),r=i(3),s=i(13),a=i(14),c=i(29),l=i(212),u=i(213);function d(e){return new t(function(t){var i=setTimeout(function(){n()},1e3),n=function(){document.removeEventListener("mousemove",o),document.removeEventListener("mouseup",n),t(!1)},o=function(r){(Math.abs(r.pageX-e.pageX)>4||Math.abs(r.pageY-e.pageY)>4)&&(document.removeEventListener("mousemove",o),document.removeEventListener("mouseup",n),clearTimeout(i),t({x:e.pageX,y:e.pageY}))};document.addEventListener("mousemove",o),document.addEventListener("mouseup",n)})}var h=function(){function t(t){this.config=n.extend({movable:!1,resizable:!1,header:!1,closable:t.modal},t),this.config.node&&"string"==typeof this.config.node?this.config.node=document.getElementById(this.config.node):this.config.node||(this.config.node=document.body),this._uid=n.uid(),this.events=new r.EventSystem(this),(this._popup=document.createElement("div")).tabIndex=1,this.config.modal||u.default.add(this._uid,this._popup),this._isActive=!1,this._initHandlers(),this._initUI(),this.config.html&&this.attachHTML(this.config.html)}return t.prototype.paint=function(){this._layout.paint()},t.prototype.setFullScreen=function(){this.setSize(window.innerWidth,window.innerHeight),this.setPosition(window.pageXOffset,window.pageYOffset)},t.prototype.setSize=function(t,e){var i={width:this._popup.offsetWidth,height:this._popup.offsetHeight},o={width:i.width,height:i.height};n.isDefined(t)&&(this.config.width=o.width=t),n.isDefined(e)&&(this.config.height=o.height=e),this._popup.style.width=o.width+"px",this._popup.style.height=o.height+"px",this.events.fire(l.WindowEvents.resize,[o,i,{left:!0,top:!0,bottom:!0,right:!0}])},t.prototype.getSize=function(){return{width:this._popup.offsetWidth,height:this._popup.offsetHeight}},t.prototype.setPosition=function(t,e){var i={left:this._popup.offsetLeft,top:this._popup.offsetTop},o={left:i.left,top:i.top};n.isDefined(t)&&(this.config.left=o.left=t),n.isDefined(e)&&(this.config.top=o.top=e),this._popup.style.left=o.left+"px",this._popup.style.top=o.top+"px",this.events.fire(l.WindowEvents.resize,[o,i,{left:!0,top:!0,bottom:!0,right:!0}])},t.prototype.getPosition=function(){return{left:this._popup.offsetLeft,top:this._popup.offsetTop}},t.prototype.show=function(t,e){if(void 0===t&&(t=this.config.left),void 0===e&&(e=this.config.top),this.events.fire(l.WindowEvents.beforeShow,[t,e])){this._popup.className="dhx_popup dhx_widget dhx_popup--window"+(this.config.modal?" dhx_popup--window_modal":"")+(this.config.css?" "+this.config.css:""),this._popup.style.position=this.config.modal?"fixed":"absolute";var i=this._getContainerParams(),o=i.containerInnerWidth,r=i.containerInnerHeight,s=i.containerXOffset,a=i.containerYOffset,c=this.config.width=this.config.width||this.config.minWidth||o/2,d=this.config.height=this.config.height||this.config.minHeight||r/2;if(this.config.left=t=n.isDefined(t)?t:(o-c)/(this.config.modal?2:2+s),this.config.top=e=n.isDefined(e)?e:(r-d)/(this.config.modal?2:2+a),this._isActive)return this._popup.style.left=t+"px",void(this._popup.style.top=e+"px");this.config.viewportOverflow&&u.default.openFreeWindow(this.config.node),this.config.modal&&this._blockScreen(),this._popup.style.width=c+"px",this._popup.style.height=d+"px",this._popup.style.left=t+"px",this._popup.style.top=e+"px",this.config.node.appendChild(this._popup),this._popup.focus(),this._isActive=!0,this.events.fire(l.WindowEvents.afterShow,[])}},t.prototype.hide=function(){this._isActive&&this.events.fire(l.WindowEvents.beforeHide,[])&&(this.config.viewportOverflow&&u.default.closeFreeWindow(this.config.node),this._blocker&&(this.config.node.removeChild(this._blocker),this.config.closable&&s.keyManager.removeHotKey(null,this),this._blocker=null),this.config.node.removeChild(this._popup),this._isActive=!1,this.events.fire(l.WindowEvents.afterHide,[]))},t.prototype.isVisible=function(){return this._isActive},t.prototype.getWidget=function(){return this._layout.getCell("content").getWidget()},t.prototype.getContainer=function(){return this.getRootView().data._container},t.prototype.attach=function(t,e){this._layout.getCell("content").attach(t,e)},t.prototype.attachHTML=function(t){this._layout.getCell("content").attach(function(){return o.el(".dhx_window__inner-html-content",{".innerHTML":t})})},t.prototype.getRootView=function(){return this._layout.getRootView()},t.prototype.destructor=function(){this._isActive&&this.hide(),this.header&&this.header.destructor(),this.footer&&this.footer.destructor(),this._layout.destructor(),this._popup=null},t.prototype.fullScreen=function(){this.setFullScreen()},t.prototype._initHandlers=function(){var t=this;this._handlers={headerDblClick:function(){return t.events.fire(l.WindowEvents.headerDoubleClick,[])},move:function(e){3!==e.which&&(e.preventDefault(),u.default.setActive(t._uid),d(e).then(function(e){e&&t._startDrag(e.x,e.y)}))},resize:{".dhx_window-resizer":function(e){3!==e.which&&(e.preventDefault(),u.default.setActive(t._uid),d(e).then(function(i){if(i){var n=e.target.classList;n.contains("dhx_window-resizer--left")?t._startResize({left:!0}):n.contains("dhx_window-resizer--right")?t._startResize({right:!0}):n.contains("dhx_window-resizer--top")?t._startResize({top:!0}):n.contains("dhx_window-resizer--bottom")?t._startResize({bottom:!0}):n.contains("dhx_window-resizer--bottom_left")?t._startResize({left:!0,bottom:!0}):n.contains("dhx_window-resizer--bottom_right")?t._startResize({bottom:!0,right:!0}):n.contains("dhx_window-resizer--top_left")?t._startResize({top:!0,left:!0}):n.contains("dhx_window-resizer--top_right")&&t._startResize({top:!0,right:!0})}}))}},setActive:function(){u.default.setActive(t._uid)}}},t.prototype._initUI=function(){var t=this,e=[],i=this.config.header||this.config.title||this.config.closable||this.config.movable;i&&e.push({id:"header",gravity:!1,css:"dhx_window-header "+(this.config.movable?"dhx_window-header--movable":""),on:{mousedown:this.config.movable&&this._handlers.move,dblclick:this._handlers.headerDblClick}}),e.push({id:"content",css:i?"dhx_window-content":"dhx_window-content-without-header"}),this.config.footer&&e.push({id:"footer",gravity:!1,css:"dhx_window-footer"}),this.config.resizable&&e.push({id:"resizers",gravity:!1,css:"resizers"});var n=this._layout=new a.Layout(this._popup,{css:"dhx_window"+(this.config.modal?" dhx_window--modal":""),rows:e,on:{click:this._handlers.setActive}});if(i){var o=this.header=new c.Toolbar;this.config.title&&this.header.data.add({type:c.ItemType.title,value:this.config.title,id:"title"}),this.config.closable&&(this.header.data.add({type:c.ItemType.spacer}),this.header.data.add({id:"close",type:c.ItemType.button,view:"link",size:"medium",color:"secondary",circle:!0,icon:"dxi dxi-close"}),o.events.on(c.NavigationBarEvents.click,function(e){"close"===e&&t.hide()})),n.getCell("header").attach(o)}if(this.config.footer){var r=this.footer=new c.Toolbar;n.getCell("footer").attach(r)}this.config.resizable&&n.getCell("resizers").attach(function(){return t._drawResizers()})},t.prototype._drawResizers=function(){return o.el(".dhx-resizers",{onmousedown:this._handlers.resize},[o.el(".dhx_window-resizer.dhx_window-resizer--left"),o.el(".dhx_window-resizer.dhx_window-resizer--right"),o.el(".dhx_window-resizer.dhx_window-resizer--bottom"),o.el(".dhx_window-resizer.dhx_window-resizer--top"),o.el(".dhx_window-resizer.dhx_window-resizer--bottom_right"),o.el(".dhx_window-resizer.dhx_window-resizer--bottom_left"),o.el(".dhx_window-resizer.dhx_window-resizer--top_right"),o.el(".dhx_window-resizer.dhx_window-resizer--top_left")])},t.prototype._startDrag=function(t,e){var i=this;this.config.node.classList.add("dhx_window--stop_selection");var n=t-this._popup.offsetLeft,o=e-this._popup.offsetTop,r=this._popup.offsetWidth,s=this._popup.offsetHeight,a=function(t){var e={left:i._popup.offsetLeft,top:i._popup.offsetTop},a=t.pageX-n,c=t.pageY-o;if(!i.config.viewportOverflow){var u=i._getContainerParams(),d=u.containerXOffset,h=u.containerYOffset,f=u.containerInnerWidth,p=u.containerInnerHeight;a<d?a=d:a>d+f-r&&(a=d+f-r),c<h?c=h:c>h+p-s&&(c=h+p-s)}i.config.left=a,i.config.top=c,i._popup.style.left=a+"px",i._popup.style.top=c+"px";var _={left:a,top:c};i.events.fire(l.WindowEvents.move,[_,e,{left:!0,top:!0,bottom:!0,right:!0}])},c=function(){document.removeEventListener("mouseup",c),document.removeEventListener("mousemove",a),i.config.node.classList.remove("dhx_window--stop_selection")};document.addEventListener("mouseup",c),document.addEventListener("mousemove",a)},t.prototype._startResize=function(t){var e,i=this,n=100|this.config.minWidth,o=100|this.config.minHeight,r=this._popup.offsetLeft,s=this._popup.offsetTop,a=this._popup.offsetWidth,c=this._popup.offsetHeight;switch(!0){case t.bottom&&t.left:e="dhx_window-body-pointer--bottom_left";break;case t.bottom&&t.right:e="dhx_window-body-pointer--bottom_right";break;case t.top&&t.left:e="dhx_window-body-pointer--top_left";break;case t.top&&t.right:e="dhx_window-body-pointer--top-right";break;case t.top:e="dhx_window-body-pointer--top";break;case t.bottom:e="dhx_window-body-pointer--bottom";break;case t.left:e="dhx_window-body-pointer--left";break;case t.right:e="dhx_window-body-pointer--right"}this.config.node.classList.add("dhx_window--stop_selection"),this.config.node.classList.add(e);var u=function(e){var u=i._getContainerParams(),d=u.containerInnerWidth,h=u.containerInnerHeight,f=u.containerXOffset,p=u.containerYOffset,_={width:i._notInNode()?e.pageX-r:e.pageX-i.config.node.offsetLeft-r,height:i._notInNode()?e.pageY-s:e.pageY-i.config.node.offsetTop-s,left:i._notInNode()?e.pageX:e.pageX-i.config.node.offsetLeft,top:i._notInNode()?e.pageY:e.pageY-i.config.node.offsetTop};t.right&&(_.width<n?_.width=n:_.width>f+d-r&&(_.width=f+d-r),i._popup.style.width=_.width+"px"),t.bottom&&(_.height<o?_.height=o:_.height>p+h-s&&(_.height=p+h-s),i._popup.style.height=_.height+"px"),t.left&&(r+a-_.left<n&&(_.left=r+a-n),_.width=r+a-_.left,i.config.left=_.left,i._popup.style.left=_.left+"px",i._popup.style.width=_.width+"px"),t.top&&(_.top<p?_.top=p:s+c-_.top<o&&(_.top=s+c-o),_.height=s+c-_.top,i.config.top=_.top,i._popup.style.top=_.top+"px",i._popup.style.height=_.height+"px"),i.config.width=i._popup.offsetWidth,i.config.height=i._popup.offsetHeight,i.events.fire(l.WindowEvents.resize,[_,{left:r,top:s,height:c,width:a},t])},d=function(){document.removeEventListener("mouseup",d),document.removeEventListener("mousemove",u),i.config.node.classList.remove("dhx_window--stop_selection"),i.config.node.classList.remove(e)};document.addEventListener("mouseup",d),document.addEventListener("mousemove",u)},t.prototype._blockScreen=function(){var t=this,e=document.createElement("div");e.className="dhx_window__overlay",this.config.node.appendChild(e),this._blocker=e,this.config.closable&&(e.addEventListener("click",function(){return t.hide()}),s.keyManager.addHotKey("escape",function(){return t.hide()},this))},t.prototype._notInNode=function(){return this.config.node===document.body||this.config.modal},t.prototype._getContainerParams=function(){var t=this._notInNode();return{containerInnerWidth:t?window.innerWidth:this.config.node.offsetWidth,containerInnerHeight:t?window.innerHeight:this.config.node.offsetHeight,containerXOffset:t?window.pageXOffset:this.config.node.scrollLeft,containerYOffset:t?window.pageYOffset:this.config.node.scrollTop}},t}();e.Window=h}).call(this,i(12))},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),function(t){t.resize="resize",t.headerDoubleClick="headerdoubleclick",t.move="move",t.afterShow="aftershow",t.afterHide="afterhide",t.beforeShow="beforeshow",t.beforeHide="beforehide"}(e.WindowEvents||(e.WindowEvents={}))},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default={popups:{},lastActive:null,freeCount:0,add:function(t,e){this.lastActive&&this.popups[this.lastActive].classList.remove("dhx_popup--window_active"),this.lastActive=t,e.classList.add("dhx_popup--window_active"),this.popups[t]=e},setActive:function(t){if(t!==this.lastActive){var e=this.popups[t];e&&(this.lastActive&&this.popups[this.lastActive].classList.remove("dhx_popup--window_active"),this.lastActive=t,e.classList.add("dhx_popup--window_active"))}},openFreeWindow:function(t){0===this.freeCount&&t.classList.add("dhx_window--no-scroll"),this.freeCount++},closeFreeWindow:function(t){this.freeCount--,0===this.freeCount&&t.classList.remove("dhx_window--no-scroll")}}}])}),window.dhx_legacy){if(window.dhx)for(var key in dhx)dhx_legacy[key]=dhx[key];window.dhx=dhx_legacy,delete window.dhx_legacy}
(function (w, o, d, s) {
    w['_itlk'] = 'e43befb60a941a66fe54447-2';
    w['_itlt'] = []; w['_itlq'] = []; w['_itld'] = s; w[o] = w[o] || { log: function (t, v, p) { w['_itlt'].push([t, v, p]) }, stream: function (q) { w['_itlq'].push([q]) } };
    var pa = d.createElement('script'), ae = d.getElementsByTagName('script')[0], protocol = (('https:' == d.location.protocol) ? 'https://' : 'http://'); pa.async = 1; pa.src = protocol + 'io.innertrends.com/itl.js'; pa.type = 'text/javascript'; ae.parentNode.insertBefore(pa, ae);
})(window, '_itl', document, "");
(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],2:[function(require,module,exports){
"use strict";

var Gettext = require("node-gettext");
window.gt = window.gt || new Gettext();
window.T2 = window.T2 || {
    _: function _(str, domain) {
        return window.gt.dgettext(domain, str);
    }
};
},{"node-gettext":4}],3:[function(require,module,exports){
(function (global){
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],4:[function(require,module,exports){
(function (process){
'use strict';

var get = require('lodash.get');
var plurals = require('./plurals');

module.exports = Gettext;

/**
 * Creates and returns a new Gettext instance.
 *
 * @constructor
 * @param  {Object}  [options]        A set of options
 * @param  {Boolean} options.debug  Whether to output debug info into the
 *                                  console.
 * @return {Object}  A Gettext instance
 */
function Gettext(options) {
    options = options || {};

    this.catalogs = {};
    this.locale = '';
    this.domain = 'messages';

    this.listeners = [];

    // Set debug flag
    if ('debug' in options) {
        this.debug = options.debug === true;
    }
    else if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV) {
        this.debug = process.env.NODE_ENV !== 'production';
    }
    else {
        this.debug = false;
    }
}

/**
 * Adds an event listener.
 *
 * @param  {String}   eventName  An event name
 * @param  {Function} callback   An event handler function
 */
Gettext.prototype.on = function(eventName, callback) {
    this.listeners.push({
        eventName: eventName,
        callback: callback
    });
};

/**
 * Removes an event listener.
 *
 * @param  {String}   eventName  An event name
 * @param  {Function} callback   A previously registered event handler function
 */
Gettext.prototype.off = function(eventName, callback) {
    this.listeners = this.listeners.filter(function(listener) {
        return (
            listener.eventName === eventName &&
            listener.callback === callback
        ) === false;
    });
};

/**
 * Emits an event to all registered event listener.
 *
 * @private
 * @param  {String} eventName  An event name
 * @param  {any}    eventData  Data to pass to event listeners
 */
Gettext.prototype.emit = function(eventName, eventData) {
    for (var i = 0; i < this.listeners.length; i++) {
        var listener = this.listeners[i];
        if (listener.eventName === eventName) {
            listener.callback(eventData);
        }
    }
};

/**
 * Logs a warning to the console if debug mode is enabled.
 *
 * @ignore
 * @param  {String} message  A warning message
 */
Gettext.prototype.warn = function(message) {
    if (this.debug) {
        console.warn(message);
    }

    this.emit('error', message);
};

/**
 * Stores a set of translations in the set of gettext
 * catalogs.
 *
 * @example
 *     gt.addTranslations('sv-SE', 'messages', translationsObject)
 *
 * @param {String} locale        A locale string
 * @param {String} domain        A domain name
 * @param {Object} translations  An object of gettext-parser JSON shape
 */
Gettext.prototype.addTranslations = function(locale, domain, translations) {
    if (!this.catalogs[locale]) {
        this.catalogs[locale] = {};
    }

    this.catalogs[locale][domain] = translations;
};

/**
 * Sets the locale to get translated messages for.
 *
 * @example
 *     gt.setLocale('sv-SE')
 *
 * @param {String} locale  A locale
 */
Gettext.prototype.setLocale = function(locale) {
    if (typeof locale !== 'string') {
        this.warn(
            'You called setLocale() with an argument of type ' + (typeof locale) + '. ' +
            'The locale must be a string.'
        );
        return;
    }

    if (locale.trim() === '') {
        this.warn('You called setLocale() with an empty value, which makes little sense.');
    }

    if (!this.catalogs[locale]) {
        this.warn('You called setLocale() with "' + locale + '", but no translations for that locale has been added.');
    }

    this.locale = locale;
};

/**
 * Sets the default gettext domain.
 *
 * @example
 *     gt.setTextDomain('domainname')
 *
 * @param {String} domain  A gettext domain name
 */
Gettext.prototype.setTextDomain = function(domain) {
    if (typeof domain !== 'string') {
        this.warn(
            'You called setTextDomain() with an argument of type ' + (typeof domain) + '. ' +
            'The domain must be a string.'
        );
        return;
    }

    if (domain.trim() === '') {
        this.warn('You called setTextDomain() with an empty `domain` value.');
    }

    this.domain = domain;
};

/**
 * Translates a string using the default textdomain
 *
 * @example
 *     gt.gettext('Some text')
 *
 * @param  {String} msgid  String to be translated
 * @return {String} Translation or the original string if no translation was found
 */
Gettext.prototype.gettext = function(msgid) {
    return this.dnpgettext(this.domain, '', msgid);
};

/**
 * Translates a string using a specific domain
 *
 * @example
 *     gt.dgettext('domainname', 'Some text')
 *
 * @param  {String} domain  A gettext domain name
 * @param  {String} msgid   String to be translated
 * @return {String} Translation or the original string if no translation was found
 */
Gettext.prototype.dgettext = function(domain, msgid) {
    return this.dnpgettext(domain, '', msgid);
};

/**
 * Translates a plural string using the default textdomain
 *
 * @example
 *     gt.ngettext('One thing', 'Many things', numberOfThings)
 *
 * @param  {String} msgid        String to be translated when count is not plural
 * @param  {String} msgidPlural  String to be translated when count is plural
 * @param  {Number} count        Number count for the plural
 * @return {String} Translation or the original string if no translation was found
 */
Gettext.prototype.ngettext = function(msgid, msgidPlural, count) {
    return this.dnpgettext(this.domain, '', msgid, msgidPlural, count);
};

/**
 * Translates a plural string using a specific textdomain
 *
 * @example
 *     gt.dngettext('domainname', 'One thing', 'Many things', numberOfThings)
 *
 * @param  {String} domain       A gettext domain name
 * @param  {String} msgid        String to be translated when count is not plural
 * @param  {String} msgidPlural  String to be translated when count is plural
 * @param  {Number} count        Number count for the plural
 * @return {String} Translation or the original string if no translation was found
 */
Gettext.prototype.dngettext = function(domain, msgid, msgidPlural, count) {
    return this.dnpgettext(domain, '', msgid, msgidPlural, count);
};

/**
 * Translates a string from a specific context using the default textdomain
 *
 * @example
 *    gt.pgettext('sports', 'Back')
 *
 * @param  {String} msgctxt  Translation context
 * @param  {String} msgid    String to be translated
 * @return {String} Translation or the original string if no translation was found
 */
Gettext.prototype.pgettext = function(msgctxt, msgid) {
    return this.dnpgettext(this.domain, msgctxt, msgid);
};

/**
 * Translates a string from a specific context using s specific textdomain
 *
 * @example
 *     gt.dpgettext('domainname', 'sports', 'Back')
 *
 * @param  {String} domain   A gettext domain name
 * @param  {String} msgctxt  Translation context
 * @param  {String} msgid    String to be translated
 * @return {String} Translation or the original string if no translation was found
 */
Gettext.prototype.dpgettext = function(domain, msgctxt, msgid) {
    return this.dnpgettext(domain, msgctxt, msgid);
};

/**
 * Translates a plural string from a specific context using the default textdomain
 *
 * @example
 *     gt.npgettext('sports', 'Back', '%d backs', numberOfBacks)
 *
 * @param  {String} msgctxt      Translation context
 * @param  {String} msgid        String to be translated when count is not plural
 * @param  {String} msgidPlural  String to be translated when count is plural
 * @param  {Number} count        Number count for the plural
 * @return {String} Translation or the original string if no translation was found
 */
Gettext.prototype.npgettext = function(msgctxt, msgid, msgidPlural, count) {
    return this.dnpgettext(this.domain, msgctxt, msgid, msgidPlural, count);
};

/**
 * Translates a plural string from a specifi context using a specific textdomain
 *
 * @example
 *     gt.dnpgettext('domainname', 'sports', 'Back', '%d backs', numberOfBacks)
 *
 * @param  {String} domain       A gettext domain name
 * @param  {String} msgctxt      Translation context
 * @param  {String} msgid        String to be translated
 * @param  {String} msgidPlural  If no translation was found, return this on count!=1
 * @param  {Number} count        Number count for the plural
 * @return {String} Translation or the original string if no translation was found
 */
Gettext.prototype.dnpgettext = function(domain, msgctxt, msgid, msgidPlural, count) {
    var defaultTranslation = msgid;
    var translation;
    var index;

    msgctxt = msgctxt || '';

    if (!isNaN(count) && count !== 1) {
        defaultTranslation = msgidPlural || msgid;
    }

    translation = this._getTranslation(domain, msgctxt, msgid);

    if (translation) {
        if (typeof count === 'number') {
            var pluralsFunc = plurals[Gettext.getLanguageCode(this.locale)].pluralsFunc;
            index = pluralsFunc(count);
            if (typeof index === 'boolean') {
                index = index ? 1 : 0;
            }
        } else {
            index = 0;
        }

        return translation.msgstr[index] || defaultTranslation;
    }
    else {
        this.warn('No translation was found for msgid "' + msgid + '" in msgctxt "' + msgctxt + '" and domain "' + domain + '"');
    }

    return defaultTranslation;
};

/**
 * Retrieves comments object for a translation. The comments object
 * has the shape `{ translator, extracted, reference, flag, previous }`.
 *
 * @example
 *     const comment = gt.getComment('domainname', 'sports', 'Backs')
 *
 * @private
 * @param  {String} domain   A gettext domain name
 * @param  {String} msgctxt  Translation context
 * @param  {String} msgid    String to be translated
 * @return {Object} Comments object or false if not found
 */
Gettext.prototype.getComment = function(domain, msgctxt, msgid) {
    var translation;

    translation = this._getTranslation(domain, msgctxt, msgid);
    if (translation) {
        return translation.comments || {};
    }

    return {};
};

/**
 * Retrieves translation object from the domain and context
 *
 * @private
 * @param  {String} domain   A gettext domain name
 * @param  {String} msgctxt  Translation context
 * @param  {String} msgid    String to be translated
 * @return {Object} Translation object or false if not found
 */
Gettext.prototype._getTranslation = function(domain, msgctxt, msgid) {
    msgctxt = msgctxt || '';

    return get(this.catalogs, [this.locale, domain, 'translations', msgctxt, msgid]);
};

/**
 * Returns the language code part of a locale
 *
 * @example
 *     Gettext.getLanguageCode('sv-SE')
 *     // -> "sv"
 *
 * @private
 * @param   {String} locale  A case-insensitive locale string
 * @returns {String} A language code
 */
Gettext.getLanguageCode = function(locale) {
    return locale.split(/[\-_]/)[0].toLowerCase();
};

/* C-style aliases */

/**
 * C-style alias for [setTextDomain](#gettextsettextdomaindomain)
 *
 * @see Gettext#setTextDomain
 */
Gettext.prototype.textdomain = function(domain) {
    if (this.debug) {
        console.warn('textdomain(domain) was used to set locales in node-gettext v1. ' +
            'Make sure you are using it for domains, and switch to setLocale(locale) if you are not.\n\n ' +
            'To read more about the migration from node-gettext v1 to v2, ' +
            'see https://github.com/alexanderwallin/node-gettext/#migrating-from-1x-to-2x\n\n' +
            'This warning will be removed in the final 2.0.0');
    }

    this.setTextDomain(domain);
};

/**
 * C-style alias for [setLocale](#gettextsetlocalelocale)
 *
 * @see Gettext#setLocale
 */
Gettext.prototype.setlocale = function(locale) {
    this.setLomain(locale);
};

/* Deprecated functions */

/**
 * This function will be removed in the final 2.0.0 release.
 *
 * @deprecated
 */
Gettext.prototype.addTextdomain = function() {
    console.error('addTextdomain() is deprecated.\n\n' +
        '* To add translations, use addTranslations()\n' +
        '* To set the default domain, use setTextDomain() (or its alias textdomain())\n' +
        '\n' +
        'To read more about the migration from node-gettext v1 to v2, ' +
        'see https://github.com/alexanderwallin/node-gettext/#migrating-from-1x-to-2x');
};

}).call(this,require('_process'))
},{"./plurals":5,"_process":1,"lodash.get":3}],5:[function(require,module,exports){
'use strict';

module.exports = {
    ach: {
        name: 'Acholi',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n > 1)',
        pluralsFunc: function(n) {
            return (n > 1);
        }
    },
    af: {
        name: 'Afrikaans',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    ak: {
        name: 'Akan',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n > 1)',
        pluralsFunc: function(n) {
            return (n > 1);
        }
    },
    am: {
        name: 'Amharic',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n > 1)',
        pluralsFunc: function(n) {
            return (n > 1);
        }
    },
    an: {
        name: 'Aragonese',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    ar: {
        name: 'Arabic',
        examples: [{
            plural: 0,
            sample: 0
        }, {
            plural: 1,
            sample: 1
        }, {
            plural: 2,
            sample: 2
        }, {
            plural: 3,
            sample: 3
        }, {
            plural: 4,
            sample: 11
        }, {
            plural: 5,
            sample: 100
        }],
        nplurals: 6,
        pluralsText: 'nplurals = 6; plural = (n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5)',
        pluralsFunc: function(n) {
            return (n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
        }
    },
    arn: {
        name: 'Mapudungun',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n > 1)',
        pluralsFunc: function(n) {
            return (n > 1);
        }
    },
    ast: {
        name: 'Asturian',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    ay: {
        name: 'Aymará',
        examples: [{
            plural: 0,
            sample: 1
        }],
        nplurals: 1,
        pluralsText: 'nplurals = 1; plural = 0',
        pluralsFunc: function() {
            return 0;
        }
    },
    az: {
        name: 'Azerbaijani',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    be: {
        name: 'Belarusian',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }, {
            plural: 2,
            sample: 5
        }],
        nplurals: 3,
        pluralsText: 'nplurals = 3; plural = (n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2)',
        pluralsFunc: function(n) {
            return (n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
        }
    },
    bg: {
        name: 'Bulgarian',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    bn: {
        name: 'Bengali',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    bo: {
        name: 'Tibetan',
        examples: [{
            plural: 0,
            sample: 1
        }],
        nplurals: 1,
        pluralsText: 'nplurals = 1; plural = 0',
        pluralsFunc: function() {
            return 0;
        }
    },
    br: {
        name: 'Breton',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n > 1)',
        pluralsFunc: function(n) {
            return (n > 1);
        }
    },
    brx: {
        name: 'Bodo',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    bs: {
        name: 'Bosnian',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }, {
            plural: 2,
            sample: 5
        }],
        nplurals: 3,
        pluralsText: 'nplurals = 3; plural = (n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2)',
        pluralsFunc: function(n) {
            return (n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
        }
    },
    ca: {
        name: 'Catalan',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    cgg: {
        name: 'Chiga',
        examples: [{
            plural: 0,
            sample: 1
        }],
        nplurals: 1,
        pluralsText: 'nplurals = 1; plural = 0',
        pluralsFunc: function() {
            return 0;
        }
    },
    cs: {
        name: 'Czech',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }, {
            plural: 2,
            sample: 5
        }],
        nplurals: 3,
        pluralsText: 'nplurals = 3; plural = (n === 1 ? 0 : (n >= 2 && n <= 4) ? 1 : 2)',
        pluralsFunc: function(n) {
            return (n === 1 ? 0 : (n >= 2 && n <= 4) ? 1 : 2);
        }
    },
    csb: {
        name: 'Kashubian',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }, {
            plural: 2,
            sample: 5
        }],
        nplurals: 3,
        pluralsText: 'nplurals = 3; plural = (n === 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2)',
        pluralsFunc: function(n) {
            return (n === 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
        }
    },
    cy: {
        name: 'Welsh',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }, {
            plural: 2,
            sample: 3
        }, {
            plural: 3,
            sample: 8
        }],
        nplurals: 4,
        pluralsText: 'nplurals = 4; plural = (n === 1 ? 0 : n === 2 ? 1 : (n !== 8 && n !== 11) ? 2 : 3)',
        pluralsFunc: function(n) {
            return (n === 1 ? 0 : n === 2 ? 1 : (n !== 8 && n !== 11) ? 2 : 3);
        }
    },
    da: {
        name: 'Danish',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    de: {
        name: 'German',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    doi: {
        name: 'Dogri',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    dz: {
        name: 'Dzongkha',
        examples: [{
            plural: 0,
            sample: 1
        }],
        nplurals: 1,
        pluralsText: 'nplurals = 1; plural = 0',
        pluralsFunc: function() {
            return 0;
        }
    },
    el: {
        name: 'Greek',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    en: {
        name: 'English',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    eo: {
        name: 'Esperanto',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    es: {
        name: 'Spanish',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    et: {
        name: 'Estonian',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    eu: {
        name: 'Basque',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    fa: {
        name: 'Persian',
        examples: [{
            plural: 0,
            sample: 1
        }],
        nplurals: 1,
        pluralsText: 'nplurals = 1; plural = 0',
        pluralsFunc: function() {
            return 0;
        }
    },
    ff: {
        name: 'Fulah',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    fi: {
        name: 'Finnish',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    fil: {
        name: 'Filipino',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n > 1)',
        pluralsFunc: function(n) {
            return (n > 1);
        }
    },
    fo: {
        name: 'Faroese',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    fr: {
        name: 'French',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n > 1)',
        pluralsFunc: function(n) {
            return (n > 1);
        }
    },
    fur: {
        name: 'Friulian',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    fy: {
        name: 'Frisian',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    ga: {
        name: 'Irish',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }, {
            plural: 2,
            sample: 3
        }, {
            plural: 3,
            sample: 7
        }, {
            plural: 4,
            sample: 11
        }],
        nplurals: 5,
        pluralsText: 'nplurals = 5; plural = (n === 1 ? 0 : n === 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4)',
        pluralsFunc: function(n) {
            return (n === 1 ? 0 : n === 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
        }
    },
    gd: {
        name: 'Scottish Gaelic',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }, {
            plural: 2,
            sample: 3
        }, {
            plural: 3,
            sample: 20
        }],
        nplurals: 4,
        pluralsText: 'nplurals = 4; plural = ((n === 1 || n === 11) ? 0 : (n === 2 || n === 12) ? 1 : (n > 2 && n < 20) ? 2 : 3)',
        pluralsFunc: function(n) {
            return ((n === 1 || n === 11) ? 0 : (n === 2 || n === 12) ? 1 : (n > 2 && n < 20) ? 2 : 3);
        }
    },
    gl: {
        name: 'Galician',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    gu: {
        name: 'Gujarati',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    gun: {
        name: 'Gun',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n > 1)',
        pluralsFunc: function(n) {
            return (n > 1);
        }
    },
    ha: {
        name: 'Hausa',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    he: {
        name: 'Hebrew',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    hi: {
        name: 'Hindi',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    hne: {
        name: 'Chhattisgarhi',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    hr: {
        name: 'Croatian',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }, {
            plural: 2,
            sample: 5
        }],
        nplurals: 3,
        pluralsText: 'nplurals = 3; plural = (n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2)',
        pluralsFunc: function(n) {
            return (n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
        }
    },
    hu: {
        name: 'Hungarian',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    hy: {
        name: 'Armenian',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    id: {
        name: 'Indonesian',
        examples: [{
            plural: 0,
            sample: 1
        }],
        nplurals: 1,
        pluralsText: 'nplurals = 1; plural = 0',
        pluralsFunc: function() {
            return 0;
        }
    },
    is: {
        name: 'Icelandic',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n % 10 !== 1 || n % 100 === 11)',
        pluralsFunc: function(n) {
            return (n % 10 !== 1 || n % 100 === 11);
        }
    },
    it: {
        name: 'Italian',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    ja: {
        name: 'Japanese',
        examples: [{
            plural: 0,
            sample: 1
        }],
        nplurals: 1,
        pluralsText: 'nplurals = 1; plural = 0',
        pluralsFunc: function() {
            return 0;
        }
    },
    jbo: {
        name: 'Lojban',
        examples: [{
            plural: 0,
            sample: 1
        }],
        nplurals: 1,
        pluralsText: 'nplurals = 1; plural = 0',
        pluralsFunc: function() {
            return 0;
        }
    },
    jv: {
        name: 'Javanese',
        examples: [{
            plural: 0,
            sample: 0
        }, {
            plural: 1,
            sample: 1
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 0)',
        pluralsFunc: function(n) {
            return (n !== 0);
        }
    },
    ka: {
        name: 'Georgian',
        examples: [{
            plural: 0,
            sample: 1
        }],
        nplurals: 1,
        pluralsText: 'nplurals = 1; plural = 0',
        pluralsFunc: function() {
            return 0;
        }
    },
    kk: {
        name: 'Kazakh',
        examples: [{
            plural: 0,
            sample: 1
        }],
        nplurals: 1,
        pluralsText: 'nplurals = 1; plural = 0',
        pluralsFunc: function() {
            return 0;
        }
    },
    km: {
        name: 'Khmer',
        examples: [{
            plural: 0,
            sample: 1
        }],
        nplurals: 1,
        pluralsText: 'nplurals = 1; plural = 0',
        pluralsFunc: function() {
            return 0;
        }
    },
    kn: {
        name: 'Kannada',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    ko: {
        name: 'Korean',
        examples: [{
            plural: 0,
            sample: 1
        }],
        nplurals: 1,
        pluralsText: 'nplurals = 1; plural = 0',
        pluralsFunc: function() {
            return 0;
        }
    },
    ku: {
        name: 'Kurdish',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    kw: {
        name: 'Cornish',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }, {
            plural: 2,
            sample: 3
        }, {
            plural: 3,
            sample: 4
        }],
        nplurals: 4,
        pluralsText: 'nplurals = 4; plural = (n === 1 ? 0 : n === 2 ? 1 : n === 3 ? 2 : 3)',
        pluralsFunc: function(n) {
            return (n === 1 ? 0 : n === 2 ? 1 : n === 3 ? 2 : 3);
        }
    },
    ky: {
        name: 'Kyrgyz',
        examples: [{
            plural: 0,
            sample: 1
        }],
        nplurals: 1,
        pluralsText: 'nplurals = 1; plural = 0',
        pluralsFunc: function() {
            return 0;
        }
    },
    lb: {
        name: 'Letzeburgesch',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    ln: {
        name: 'Lingala',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n > 1)',
        pluralsFunc: function(n) {
            return (n > 1);
        }
    },
    lo: {
        name: 'Lao',
        examples: [{
            plural: 0,
            sample: 1
        }],
        nplurals: 1,
        pluralsText: 'nplurals = 1; plural = 0',
        pluralsFunc: function() {
            return 0;
        }
    },
    lt: {
        name: 'Lithuanian',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }, {
            plural: 2,
            sample: 10
        }],
        nplurals: 3,
        pluralsText: 'nplurals = 3; plural = (n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2)',
        pluralsFunc: function(n) {
            return (n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
        }
    },
    lv: {
        name: 'Latvian',
        examples: [{
            plural: 2,
            sample: 0
        }, {
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 3,
        pluralsText: 'nplurals = 3; plural = (n % 10 === 1 && n % 100 !== 11 ? 0 : n !== 0 ? 1 : 2)',
        pluralsFunc: function(n) {
            return (n % 10 === 1 && n % 100 !== 11 ? 0 : n !== 0 ? 1 : 2);
        }
    },
    mai: {
        name: 'Maithili',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    mfe: {
        name: 'Mauritian Creole',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n > 1)',
        pluralsFunc: function(n) {
            return (n > 1);
        }
    },
    mg: {
        name: 'Malagasy',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n > 1)',
        pluralsFunc: function(n) {
            return (n > 1);
        }
    },
    mi: {
        name: 'Maori',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n > 1)',
        pluralsFunc: function(n) {
            return (n > 1);
        }
    },
    mk: {
        name: 'Macedonian',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n === 1 || n % 10 === 1 ? 0 : 1)',
        pluralsFunc: function(n) {
            return (n === 1 || n % 10 === 1 ? 0 : 1);
        }
    },
    ml: {
        name: 'Malayalam',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    mn: {
        name: 'Mongolian',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    mni: {
        name: 'Manipuri',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    mnk: {
        name: 'Mandinka',
        examples: [{
            plural: 0,
            sample: 0
        }, {
            plural: 1,
            sample: 1
        }, {
            plural: 2,
            sample: 2
        }],
        nplurals: 3,
        pluralsText: 'nplurals = 3; plural = (n === 0 ? 0 : n === 1 ? 1 : 2)',
        pluralsFunc: function(n) {
            return (n === 0 ? 0 : n === 1 ? 1 : 2);
        }
    },
    mr: {
        name: 'Marathi',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    ms: {
        name: 'Malay',
        examples: [{
            plural: 0,
            sample: 1
        }],
        nplurals: 1,
        pluralsText: 'nplurals = 1; plural = 0',
        pluralsFunc: function() {
            return 0;
        }
    },
    mt: {
        name: 'Maltese',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }, {
            plural: 2,
            sample: 11
        }, {
            plural: 3,
            sample: 20
        }],
        nplurals: 4,
        pluralsText: 'nplurals = 4; plural = (n === 1 ? 0 : n === 0 || ( n % 100 > 1 && n % 100 < 11) ? 1 : (n % 100 > 10 && n % 100 < 20 ) ? 2 : 3)',
        pluralsFunc: function(n) {
            return (n === 1 ? 0 : n === 0 || (n % 100 > 1 && n % 100 < 11) ? 1 : (n % 100 > 10 && n % 100 < 20) ? 2 : 3);
        }
    },
    my: {
        name: 'Burmese',
        examples: [{
            plural: 0,
            sample: 1
        }],
        nplurals: 1,
        pluralsText: 'nplurals = 1; plural = 0',
        pluralsFunc: function() {
            return 0;
        }
    },
    nah: {
        name: 'Nahuatl',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    nap: {
        name: 'Neapolitan',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    nb: {
        name: 'Norwegian Bokmal',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    ne: {
        name: 'Nepali',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    nl: {
        name: 'Dutch',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    nn: {
        name: 'Norwegian Nynorsk',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    no: {
        name: 'Norwegian',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    nso: {
        name: 'Northern Sotho',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    oc: {
        name: 'Occitan',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n > 1)',
        pluralsFunc: function(n) {
            return (n > 1);
        }
    },
    or: {
        name: 'Oriya',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    pa: {
        name: 'Punjabi',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    pap: {
        name: 'Papiamento',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    pl: {
        name: 'Polish',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }, {
            plural: 2,
            sample: 5
        }],
        nplurals: 3,
        pluralsText: 'nplurals = 3; plural = (n === 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2)',
        pluralsFunc: function(n) {
            return (n === 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
        }
    },
    pms: {
        name: 'Piemontese',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    ps: {
        name: 'Pashto',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    pt: {
        name: 'Portuguese',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    rm: {
        name: 'Romansh',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    ro: {
        name: 'Romanian',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }, {
            plural: 2,
            sample: 20
        }],
        nplurals: 3,
        pluralsText: 'nplurals = 3; plural = (n === 1 ? 0 : (n === 0 || (n % 100 > 0 && n % 100 < 20)) ? 1 : 2)',
        pluralsFunc: function(n) {
            return (n === 1 ? 0 : (n === 0 || (n % 100 > 0 && n % 100 < 20)) ? 1 : 2);
        }
    },
    ru: {
        name: 'Russian',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }, {
            plural: 2,
            sample: 5
        }],
        nplurals: 3,
        pluralsText: 'nplurals = 3; plural = (n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2)',
        pluralsFunc: function(n) {
            return (n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
        }
    },
    rw: {
        name: 'Kinyarwanda',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    sah: {
        name: 'Yakut',
        examples: [{
            plural: 0,
            sample: 1
        }],
        nplurals: 1,
        pluralsText: 'nplurals = 1; plural = 0',
        pluralsFunc: function() {
            return 0;
        }
    },
    sat: {
        name: 'Santali',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    sco: {
        name: 'Scots',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    sd: {
        name: 'Sindhi',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    se: {
        name: 'Northern Sami',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    si: {
        name: 'Sinhala',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    sk: {
        name: 'Slovak',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }, {
            plural: 2,
            sample: 5
        }],
        nplurals: 3,
        pluralsText: 'nplurals = 3; plural = (n === 1 ? 0 : (n >= 2 && n <= 4) ? 1 : 2)',
        pluralsFunc: function(n) {
            return (n === 1 ? 0 : (n >= 2 && n <= 4) ? 1 : 2);
        }
    },
    sl: {
        name: 'Slovenian',
        examples: [{
            plural: 1,
            sample: 1
        }, {
            plural: 2,
            sample: 2
        }, {
            plural: 3,
            sample: 3
        }, {
            plural: 0,
            sample: 5
        }],
        nplurals: 4,
        pluralsText: 'nplurals = 4; plural = (n % 100 === 1 ? 1 : n % 100 === 2 ? 2 : n % 100 === 3 || n % 100 === 4 ? 3 : 0)',
        pluralsFunc: function(n) {
            return (n % 100 === 1 ? 1 : n % 100 === 2 ? 2 : n % 100 === 3 || n % 100 === 4 ? 3 : 0);
        }
    },
    so: {
        name: 'Somali',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    son: {
        name: 'Songhay',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    sq: {
        name: 'Albanian',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    sr: {
        name: 'Serbian',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }, {
            plural: 2,
            sample: 5
        }],
        nplurals: 3,
        pluralsText: 'nplurals = 3; plural = (n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2)',
        pluralsFunc: function(n) {
            return (n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
        }
    },
    su: {
        name: 'Sundanese',
        examples: [{
            plural: 0,
            sample: 1
        }],
        nplurals: 1,
        pluralsText: 'nplurals = 1; plural = 0',
        pluralsFunc: function() {
            return 0;
        }
    },
    sv: {
        name: 'Swedish',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    sw: {
        name: 'Swahili',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    ta: {
        name: 'Tamil',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    te: {
        name: 'Telugu',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    tg: {
        name: 'Tajik',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n > 1)',
        pluralsFunc: function(n) {
            return (n > 1);
        }
    },
    th: {
        name: 'Thai',
        examples: [{
            plural: 0,
            sample: 1
        }],
        nplurals: 1,
        pluralsText: 'nplurals = 1; plural = 0',
        pluralsFunc: function() {
            return 0;
        }
    },
    ti: {
        name: 'Tigrinya',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n > 1)',
        pluralsFunc: function(n) {
            return (n > 1);
        }
    },
    tk: {
        name: 'Turkmen',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    tr: {
        name: 'Turkish',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n > 1)',
        pluralsFunc: function(n) {
            return (n > 1);
        }
    },
    tt: {
        name: 'Tatar',
        examples: [{
            plural: 0,
            sample: 1
        }],
        nplurals: 1,
        pluralsText: 'nplurals = 1; plural = 0',
        pluralsFunc: function() {
            return 0;
        }
    },
    ug: {
        name: 'Uyghur',
        examples: [{
            plural: 0,
            sample: 1
        }],
        nplurals: 1,
        pluralsText: 'nplurals = 1; plural = 0',
        pluralsFunc: function() {
            return 0;
        }
    },
    uk: {
        name: 'Ukrainian',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }, {
            plural: 2,
            sample: 5
        }],
        nplurals: 3,
        pluralsText: 'nplurals = 3; plural = (n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2)',
        pluralsFunc: function(n) {
            return (n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
        }
    },
    ur: {
        name: 'Urdu',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    uz: {
        name: 'Uzbek',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n > 1)',
        pluralsFunc: function(n) {
            return (n > 1);
        }
    },
    vi: {
        name: 'Vietnamese',
        examples: [{
            plural: 0,
            sample: 1
        }],
        nplurals: 1,
        pluralsText: 'nplurals = 1; plural = 0',
        pluralsFunc: function() {
            return 0;
        }
    },
    wa: {
        name: 'Walloon',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n > 1)',
        pluralsFunc: function(n) {
            return (n > 1);
        }
    },
    wo: {
        name: 'Wolof',
        examples: [{
            plural: 0,
            sample: 1
        }],
        nplurals: 1,
        pluralsText: 'nplurals = 1; plural = 0',
        pluralsFunc: function() {
            return 0;
        }
    },
    yo: {
        name: 'Yoruba',
        examples: [{
            plural: 0,
            sample: 1
        }, {
            plural: 1,
            sample: 2
        }],
        nplurals: 2,
        pluralsText: 'nplurals = 2; plural = (n !== 1)',
        pluralsFunc: function(n) {
            return (n !== 1);
        }
    },
    zh: {
        name: 'Chinese',
        examples: [{
            plural: 0,
            sample: 1
        }],
        nplurals: 1,
        pluralsText: 'nplurals = 1; plural = 0',
        pluralsFunc: function() {
            return 0;
        }
    }
};
},{}]},{},[2]);

var T;
(function (T) {
    function _(str, domain) {
        var _a;
        var result = (_a = window.ZakekeTranslation) === null || _a === void 0 ? void 0 : _a.statics.find(function (z) {
            return z.original.toLowerCase() === str.toLowerCase();
        });
        if (result === null || result === void 0 ? void 0 : result.localization) {
            return result === null || result === void 0 ? void 0 : result.localization;
        }
        return window.T2._(str, domain);
    }
    T._ = _;
    function _d(str) {
        var _a, _b, _c;
        return (_c = (_b = (_a = window.ZakekeTranslation) === null || _a === void 0 ? void 0 : _a.dynamics.find(function (z) { return z.original.toLowerCase() === str.toLowerCase(); })) === null || _b === void 0 ? void 0 : _b.localization) !== null && _c !== void 0 ? _c : str;
    }
    T._d = _d;
})(T || (T = {}));

var Zakeke;
(function (Zakeke) {
    Zakeke.config = {
        apiHost: 'https://api.zakeke.com',
        avaibleLanguages: [
            'it',
            'en',
            'es',
            'fr',
            'de',
            'af',
            'fa',
            'sq',
            'am',
            'ar',
            'hy',
            'az',
            'eu',
            'bn',
            'my',
            'bs',
            'bg',
            'ca',
            'cs',
            'ny',
            'zh',
            'zh-TW',
            'ko',
            'co',
            'hr',
            'ku',
            'da',
            'he',
            'et',
            'fil',
            'fi',
            'gl',
            'cy',
            'ka',
            'ja',
            'jv',
            'el',
            'gu',
            'ha',
            'haw',
            'hi',
            'hmn',
            'id',
            'is',
            'kn',
            'kk',
            'km',
            'ky',
            'lo',
            'lv',
            'lt',
            'lb',
            'mk',
            'ml',
            'ms',
            'mg',
            'mt',
            'mi',
            'mr',
            'mn',
            'ne',
            'no',
            'nb',
            'nl',
            'ps',
            'pl',
            'pt',
            'pa',
            'ro',
            'ru',
            'sm',
            'sr',
            'st',
            'sn',
            'sd',
            'si',
            'sk',
            'sl',
            'so',
            'su',
            'sv',
            'sw',
            'tg',
            'tai',
            'ta',
            'tr',
            'uk',
            'hu',
            'ur',
            'uz',
            'vi',
            'xh',
            'yi',
            'yo',
            'zu',
            'nb'
        ],
        banubaSettings: {
            token: 'jLr5ekMAhNnfID7hTIS92zRKfl6KoEI4M7W1GH3HmBnIrkvZ5UFkfyXBArfdDPJ+ruILLhDjOrIbQji4RQLoFqZ6zIvTZOOVAcdrM/qGgzdNiv1jLHq12mexlUOOm7mxDBeuccYFsN5AggiYDzhEQAD42AxMTvFOvMP+3tmO8h9yOzUbFjK4AlOFL0jWE703NrxoOfEsu93UfNvhgHjOZwMreVD8EO+/WUOGxi3S/RG6H6xvg9v7OZUCtoxZp2Pp2Hs/r+Id2/7WwqUx4N3+g75l5B1UwBsQv73urcNXlx4AeW+3p5opSq9L4TGg0+ZrRBvzffK5uUkZyaDTNmyca7Bxn4Xq9RAcNUtdijPckDB9Z1kGxCTsnEtYif1xElYpFcNf9gO6hX/24puAdiIFLPF9v/vwR469ACF9seIDMYd4kw==',
            url: 'https://zakeke-demo.sites.banuba.net/test-frame/index.html'
        },
        baseAdminUrl: 'https://admin.zakeke.com/',
        baseApiUrl: 'https://api.zakeke.com/api/',
        baseImageGeneratePreviewApiUrl: 'https://aks-prod.zakeke.com/api',
        baseImageTasksApiUrl: 'https://api.zakeke.com/api/',
        baseImagesUploadApiUrl: 'https://api.zakeke.com/api/',
        localizationsUrl: 'https://cdn.zakeke.com/cdn/production/localizations/',
        baseScenesApiUrl: 'https://api.zakeke.com/api/',
        baseUrl: 'https://portal.zakeke.com/',
        cloudFlareApiUrl: 'https://zakeke-worker-prod.zakeke.workers.dev/api/',
        damSettings: {
            analyticsUrl: 'https://api.stg.3dsuite.io/api/v1/rpc/3d-models/analytics-event'
        },
        deepARSettings: {
            token: 'd7c878a74e21f5a1d62644f8f70d451ce4e2656ea8088aaa225720c43f5f0dc956facb3fd4702c17',
            url: 'https://vto.zakeke.com/'
        },
        facebookAppID: '1157894994331979',
        graphqlUrl: 'https://apollo.zakeke.com/graphql',
        imagesUploadApiHost: 'https://api.zakeke.com',
        instagramClientID: '1066407470424468',
        maxUploadSize: 10485760,
        mazingSettings: { url: 'https://glass.mazing.link/?customStyle=true' },
        tryOnApiUrl: 'https://api.zakeke.com/api/',
        modelViewerPage: 'https://files.zakeke.com/files/ar-viewer/model-viewer/model-viewer.html'
    };
})(Zakeke || (Zakeke = {}));

// ┌───────────────────────────────────────────────────────────────────────────────────────────────────────┐ \\
// │ Raphaël 2.3.0 - JavaScript Vector Library                                                             │ \\
// ├───────────────────────────────────────────────────────────────────────────────────────────────────────┤ \\
// │ Copyright © 2008-2016 Dmitry Baranovskiy (http://raphaeljs.com)                                       │ \\
// │ Copyright © 2008-2016 Sencha Labs (http://sencha.com)                                                 │ \\
// ├───────────────────────────────────────────────────────────────────────────────────────────────────────┤ \\
// │ Licensed under the MIT (https://github.com/DmitryBaranovskiy/raphael/blob/master/license.txt) license.│ \\
// └───────────────────────────────────────────────────────────────────────────────────────────────────────┘ \\

(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Raphael"] = factory();
	else
		root["Raphael"] = factory();
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./dev/raphael.amd.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./dev/raphael.amd.js":
/*!****************************!*\
  !*** ./dev/raphael.amd.js ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! ./raphael.core */ "./dev/raphael.core.js"), __webpack_require__(/*! ./raphael.svg */ "./dev/raphael.svg.js"), __webpack_require__(/*! ./raphael.vml */ "./dev/raphael.vml.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function(R) {

    return R;

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "./dev/raphael.core.js":
/*!*****************************!*\
  !*** ./dev/raphael.core.js ***!
  \*****************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! eve */ "./node_modules/eve-raphael/eve.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function(eve) {

    /*\
     * Raphael
     [ method ]
     **
     * Creates a canvas object on which to draw.
     * You must do this first, as all future calls to drawing methods
     * from this instance will be bound to this canvas.
     > Parameters
     **
     - container (HTMLElement|string) DOM element or its ID which is going to be a parent for drawing surface
     - width (number)
     - height (number)
     - callback (function) #optional callback function which is going to be executed in the context of newly created paper
     * or
     - x (number)
     - y (number)
     - width (number)
     - height (number)
     - callback (function) #optional callback function which is going to be executed in the context of newly created paper
     * or
     - all (array) (first 3 or 4 elements in the array are equal to [containerID, width, height] or [x, y, width, height]. The rest are element descriptions in format {type: type, <attributes>}). See @Paper.add.
     - callback (function) #optional callback function which is going to be executed in the context of newly created paper
     * or
     - onReadyCallback (function) function that is going to be called on DOM ready event. You can also subscribe to this event via Eve’s “DOMLoad” event. In this case method returns `undefined`.
     = (object) @Paper
     > Usage
     | // Each of the following examples create a canvas
     | // that is 320px wide by 200px high.
     | // Canvas is created at the viewport’s 10,50 coordinate.
     | var paper = Raphael(10, 50, 320, 200);
     | // Canvas is created at the top left corner of the #notepad element
     | // (or its top right corner in dir="rtl" elements)
     | var paper = Raphael(document.getElementById("notepad"), 320, 200);
     | // Same as above
     | var paper = Raphael("notepad", 320, 200);
     | // Image dump
     | var set = Raphael(["notepad", 320, 200, {
     |     type: "rect",
     |     x: 10,
     |     y: 10,
     |     width: 25,
     |     height: 25,
     |     stroke: "#f00"
     | }, {
     |     type: "text",
     |     x: 30,
     |     y: 40,
     |     text: "Dump"
     | }]);
    \*/
    function R(first) {
        if (R.is(first, "function")) {
            return loaded ? first() : eve.on("raphael.DOMload", first);
        } else if (R.is(first, array)) {
            return R._engine.create[apply](R, first.splice(0, 3 + R.is(first[0], nu))).add(first);
        } else {
            var args = Array.prototype.slice.call(arguments, 0);
            if (R.is(args[args.length - 1], "function")) {
                var f = args.pop();
                return loaded ? f.call(R._engine.create[apply](R, args)) : eve.on("raphael.DOMload", function () {
                    f.call(R._engine.create[apply](R, args));
                });
            } else {
                return R._engine.create[apply](R, arguments);
            }
        }
    }
    R.version = "2.3.0";
    R.eve = eve;
    var loaded,
        separator = /[, ]+/,
        elements = {circle: 1, rect: 1, path: 1, ellipse: 1, text: 1, image: 1},
        formatrg = /\{(\d+)\}/g,
        proto = "prototype",
        has = "hasOwnProperty",
        g = {
            doc: document,
            win: window
        },
        oldRaphael = {
            was: Object.prototype[has].call(g.win, "Raphael"),
            is: g.win.Raphael
        },
        Paper = function () {
            /*\
             * Paper.ca
             [ property (object) ]
             **
             * Shortcut for @Paper.customAttributes
            \*/
            /*\
             * Paper.customAttributes
             [ property (object) ]
             **
             * If you have a set of attributes that you would like to represent
             * as a function of some number you can do it easily with custom attributes:
             > Usage
             | paper.customAttributes.hue = function (num) {
             |     num = num % 1;
             |     return {fill: "hsb(" + num + ", 0.75, 1)"};
             | };
             | // Custom attribute “hue” will change fill
             | // to be given hue with fixed saturation and brightness.
             | // Now you can use it like this:
             | var c = paper.circle(10, 10, 10).attr({hue: .45});
             | // or even like this:
             | c.animate({hue: 1}, 1e3);
             |
             | // You could also create custom attribute
             | // with multiple parameters:
             | paper.customAttributes.hsb = function (h, s, b) {
             |     return {fill: "hsb(" + [h, s, b].join(",") + ")"};
             | };
             | c.attr({hsb: "0.5 .8 1"});
             | c.animate({hsb: [1, 0, 0.5]}, 1e3);
            \*/
            this.ca = this.customAttributes = {};
        },
        paperproto,
        appendChild = "appendChild",
        apply = "apply",
        concat = "concat",
        //taken from Modernizr touch test: https://github.com/Modernizr/Modernizr/blob/master/feature-detects/touchevents.js#L40
        supportsTouch = ('ontouchstart' in window) || window.TouchEvent || window.DocumentTouch && document instanceof DocumentTouch,
        E = "",
        S = " ",
        Str = String,
        split = "split",
        events = "click dblclick mousedown mousemove mouseout mouseover mouseup touchstart touchmove touchend touchcancel"[split](S),
        touchMap = {
            mousedown: "touchstart",
            mousemove: "touchmove",
            mouseup: "touchend"
        },
        lowerCase = Str.prototype.toLowerCase,
        math = Math,
        mmax = math.max,
        mmin = math.min,
        abs = math.abs,
        pow = math.pow,
        PI = math.PI,
        nu = "number",
        string = "string",
        array = "array",
        toString = "toString",
        fillString = "fill",
        objectToString = Object.prototype.toString,
        paper = {},
        push = "push",
        ISURL = R._ISURL = /^url\(['"]?(.+?)['"]?\)$/i,
        colourRegExp = /^\s*((#[a-f\d]{6})|(#[a-f\d]{3})|rgba?\(\s*([\d\.]+%?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+%?(?:\s*,\s*[\d\.]+%?)?)\s*\)|hsba?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?)%?\s*\)|hsla?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?)%?\s*\))\s*$/i,
        isnan = {"NaN": 1, "Infinity": 1, "-Infinity": 1},
        bezierrg = /^(?:cubic-)?bezier\(([^,]+),([^,]+),([^,]+),([^\)]+)\)/,
        round = math.round,
        setAttribute = "setAttribute",
        toFloat = parseFloat,
        toInt = parseInt,
        upperCase = Str.prototype.toUpperCase,
        availableAttrs = R._availableAttrs = {
            "arrow-end": "none",
            "arrow-start": "none",
            blur: 0,
            "clip-rect": "0 0 1e9 1e9",
            cursor: "default",
            cx: 0,
            cy: 0,
            fill: "#fff",
            "fill-opacity": 1,
            font: '10px "Arial"',
            "font-family": '"Arial"',
            "font-size": "10",
            "font-style": "normal",
            "font-weight": 400,
            gradient: 0,
            height: 0,
            href: "http://raphaeljs.com/",
            "letter-spacing": 0,
            opacity: 1,
            path: "M0,0",
            r: 0,
            rx: 0,
            ry: 0,
            src: "",
            stroke: "#000",
            "stroke-dasharray": "",
            "stroke-linecap": "butt",
            "stroke-linejoin": "butt",
            "stroke-miterlimit": 0,
            "stroke-opacity": 1,
            "stroke-width": 1,
            target: "_blank",
            "text-anchor": "middle",
            title: "Raphael",
            transform: "",
            width: 0,
            x: 0,
            y: 0,
            "class": ""
        },
        availableAnimAttrs = R._availableAnimAttrs = {
            blur: nu,
            "clip-rect": "csv",
            cx: nu,
            cy: nu,
            fill: "colour",
            "fill-opacity": nu,
            "font-size": nu,
            height: nu,
            opacity: nu,
            path: "path",
            r: nu,
            rx: nu,
            ry: nu,
            stroke: "colour",
            "stroke-opacity": nu,
            "stroke-width": nu,
            transform: "transform",
            width: nu,
            x: nu,
            y: nu
        },
        whitespace = /[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]/g,
        commaSpaces = /[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*,[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*/,
        hsrg = {hs: 1, rg: 1},
        p2s = /,?([achlmqrstvxz]),?/gi,
        pathCommand = /([achlmrqstvz])[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029,]*((-?\d*\.?\d*(?:e[\-+]?\d+)?[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*,?[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*)+)/ig,
        tCommand = /([rstm])[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029,]*((-?\d*\.?\d*(?:e[\-+]?\d+)?[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*,?[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*)+)/ig,
        pathValues = /(-?\d*\.?\d*(?:e[\-+]?\d+)?)[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*,?[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*/ig,
        radial_gradient = R._radial_gradient = /^r(?:\(([^,]+?)[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*,[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*([^\)]+?)\))?/,
        eldata = {},
        sortByKey = function (a, b) {
            return a.key - b.key;
        },
        sortByNumber = function (a, b) {
            return toFloat(a) - toFloat(b);
        },
        fun = function () {},
        pipe = function (x) {
            return x;
        },
        rectPath = R._rectPath = function (x, y, w, h, r) {
            if (r) {
                return [["M", x + r, y], ["l", w - r * 2, 0], ["a", r, r, 0, 0, 1, r, r], ["l", 0, h - r * 2], ["a", r, r, 0, 0, 1, -r, r], ["l", r * 2 - w, 0], ["a", r, r, 0, 0, 1, -r, -r], ["l", 0, r * 2 - h], ["a", r, r, 0, 0, 1, r, -r], ["z"]];
            }
            return [["M", x, y], ["l", w, 0], ["l", 0, h], ["l", -w, 0], ["z"]];
        },
        ellipsePath = function (x, y, rx, ry) {
            if (ry == null) {
                ry = rx;
            }
            return [["M", x, y], ["m", 0, -ry], ["a", rx, ry, 0, 1, 1, 0, 2 * ry], ["a", rx, ry, 0, 1, 1, 0, -2 * ry], ["z"]];
        },
        getPath = R._getPath = {
            path: function (el) {
                return el.attr("path");
            },
            circle: function (el) {
                var a = el.attrs;
                return ellipsePath(a.cx, a.cy, a.r);
            },
            ellipse: function (el) {
                var a = el.attrs;
                return ellipsePath(a.cx, a.cy, a.rx, a.ry);
            },
            rect: function (el) {
                var a = el.attrs;
                return rectPath(a.x, a.y, a.width, a.height, a.r);
            },
            image: function (el) {
                var a = el.attrs;
                return rectPath(a.x, a.y, a.width, a.height);
            },
            text: function (el) {
                var bbox = el._getBBox();
                return rectPath(bbox.x, bbox.y, bbox.width, bbox.height);
            },
            set : function(el) {
                var bbox = el._getBBox();
                return rectPath(bbox.x, bbox.y, bbox.width, bbox.height);
            }
        },
        /*\
         * Raphael.mapPath
         [ method ]
         **
         * Transform the path string with given matrix.
         > Parameters
         - path (string) path string
         - matrix (object) see @Matrix
         = (string) transformed path string
        \*/
        mapPath = R.mapPath = function (path, matrix) {
            if (!matrix) {
                return path;
            }
            var x, y, i, j, ii, jj, pathi;
            path = path2curve(path);
            for (i = 0, ii = path.length; i < ii; i++) {
                pathi = path[i];
                for (j = 1, jj = pathi.length; j < jj; j += 2) {
                    x = matrix.x(pathi[j], pathi[j + 1]);
                    y = matrix.y(pathi[j], pathi[j + 1]);
                    pathi[j] = x;
                    pathi[j + 1] = y;
                }
            }
            return path;
        };

    R._g = g;
    /*\
     * Raphael.type
     [ property (string) ]
     **
     * Can be “SVG”, “VML” or empty, depending on browser support.
    \*/
    R.type = (g.win.SVGAngle || g.doc.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#BasicStructure", "1.1") ? "SVG" : "VML");
    if (R.type == "VML") {
        var d = g.doc.createElement("div"),
            b;
        d.innerHTML = '<v:shape adj="1"/>';
        b = d.firstChild;
        b.style.behavior = "url(#default#VML)";
        if (!(b && typeof b.adj == "object")) {
            return (R.type = E);
        }
        d = null;
    }
    /*\
     * Raphael.svg
     [ property (boolean) ]
     **
     * `true` if browser supports SVG.
    \*/
    /*\
     * Raphael.vml
     [ property (boolean) ]
     **
     * `true` if browser supports VML.
    \*/
    R.svg = !(R.vml = R.type == "VML");
    R._Paper = Paper;
    /*\
     * Raphael.fn
     [ property (object) ]
     **
     * You can add your own method to the canvas. For example if you want to draw a pie chart,
     * you can create your own pie chart function and ship it as a Raphaël plugin. To do this
     * you need to extend the `Raphael.fn` object. You should modify the `fn` object before a
     * Raphaël instance is created, otherwise it will take no effect. Please note that the
     * ability for namespaced plugins was removed in Raphael 2.0. It is up to the plugin to
     * ensure any namespacing ensures proper context.
     > Usage
     | Raphael.fn.arrow = function (x1, y1, x2, y2, size) {
     |     return this.path( ... );
     | };
     | // or create namespace
     | Raphael.fn.mystuff = {
     |     arrow: function () {…},
     |     star: function () {…},
     |     // etc…
     | };
     | var paper = Raphael(10, 10, 630, 480);
     | // then use it
     | paper.arrow(10, 10, 30, 30, 5).attr({fill: "#f00"});
     | paper.mystuff.arrow();
     | paper.mystuff.star();
    \*/
    R.fn = paperproto = Paper.prototype = R.prototype;
    R._id = 0;
    /*\
     * Raphael.is
     [ method ]
     **
     * Handful of replacements for `typeof` operator.
     > Parameters
     - o (…) any object or primitive
     - type (string) name of the type, i.e. “string”, “function”, “number”, etc.
     = (boolean) is given value is of given type
    \*/
    R.is = function (o, type) {
        type = lowerCase.call(type);
        if (type == "finite") {
            return !isnan[has](+o);
        }
        if (type == "array") {
            return o instanceof Array;
        }
        return  (type == "null" && o === null) ||
                (type == typeof o && o !== null) ||
                (type == "object" && o === Object(o)) ||
                (type == "array" && Array.isArray && Array.isArray(o)) ||
                objectToString.call(o).slice(8, -1).toLowerCase() == type;
    };

    function clone(obj) {
        if (typeof obj == "function" || Object(obj) !== obj) {
            return obj;
        }
        var res = new obj.constructor;
        for (var key in obj) if (obj[has](key)) {
            res[key] = clone(obj[key]);
        }
        return res;
    }

    /*\
     * Raphael.angle
     [ method ]
     **
     * Returns angle between two or three points
     > Parameters
     - x1 (number) x coord of first point
     - y1 (number) y coord of first point
     - x2 (number) x coord of second point
     - y2 (number) y coord of second point
     - x3 (number) #optional x coord of third point
     - y3 (number) #optional y coord of third point
     = (number) angle in degrees.
    \*/
    R.angle = function (x1, y1, x2, y2, x3, y3) {
        if (x3 == null) {
            var x = x1 - x2,
                y = y1 - y2;
            if (!x && !y) {
                return 0;
            }
            return (180 + math.atan2(-y, -x) * 180 / PI + 360) % 360;
        } else {
            return R.angle(x1, y1, x3, y3) - R.angle(x2, y2, x3, y3);
        }
    };
    /*\
     * Raphael.rad
     [ method ]
     **
     * Transform angle to radians
     > Parameters
     - deg (number) angle in degrees
     = (number) angle in radians.
    \*/
    R.rad = function (deg) {
        return deg % 360 * PI / 180;
    };
    /*\
     * Raphael.deg
     [ method ]
     **
     * Transform angle to degrees
     > Parameters
     - rad (number) angle in radians
     = (number) angle in degrees.
    \*/
    R.deg = function (rad) {
        return Math.round ((rad * 180 / PI% 360)* 1000) / 1000;
    };
    /*\
     * Raphael.snapTo
     [ method ]
     **
     * Snaps given value to given grid.
     > Parameters
     - values (array|number) given array of values or step of the grid
     - value (number) value to adjust
     - tolerance (number) #optional tolerance for snapping. Default is `10`.
     = (number) adjusted value.
    \*/
    R.snapTo = function (values, value, tolerance) {
        tolerance = R.is(tolerance, "finite") ? tolerance : 10;
        if (R.is(values, array)) {
            var i = values.length;
            while (i--) if (abs(values[i] - value) <= tolerance) {
                return values[i];
            }
        } else {
            values = +values;
            var rem = value % values;
            if (rem < tolerance) {
                return value - rem;
            }
            if (rem > values - tolerance) {
                return value - rem + values;
            }
        }
        return value;
    };

    /*\
     * Raphael.createUUID
     [ method ]
     **
     * Returns RFC4122, version 4 ID
    \*/
    var createUUID = R.createUUID = (function (uuidRegEx, uuidReplacer) {
        return function () {
            return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(uuidRegEx, uuidReplacer).toUpperCase();
        };
    })(/[xy]/g, function (c) {
        var r = math.random() * 16 | 0,
            v = c == "x" ? r : (r & 3 | 8);
        return v.toString(16);
    });

    /*\
     * Raphael.setWindow
     [ method ]
     **
     * Used when you need to draw in `&lt;iframe>`. Switched window to the iframe one.
     > Parameters
     - newwin (window) new window object
    \*/
    R.setWindow = function (newwin) {
        eve("raphael.setWindow", R, g.win, newwin);
        g.win = newwin;
        g.doc = g.win.document;
        if (R._engine.initWin) {
            R._engine.initWin(g.win);
        }
    };
    var toHex = function (color) {
        if (R.vml) {
            // http://dean.edwards.name/weblog/2009/10/convert-any-colour-value-to-hex-in-msie/
            var trim = /^\s+|\s+$/g;
            var bod;
            try {
                var docum = new ActiveXObject("htmlfile");
                docum.write("<body>");
                docum.close();
                bod = docum.body;
            } catch(e) {
                bod = createPopup().document.body;
            }
            var range = bod.createTextRange();
            toHex = cacher(function (color) {
                try {
                    bod.style.color = Str(color).replace(trim, E);
                    var value = range.queryCommandValue("ForeColor");
                    value = ((value & 255) << 16) | (value & 65280) | ((value & 16711680) >>> 16);
                    return "#" + ("000000" + value.toString(16)).slice(-6);
                } catch(e) {
                    return "none";
                }
            });
        } else {
            var i = g.doc.createElement("i");
            i.title = "Rapha\xebl Colour Picker";
            i.style.display = "none";
            g.doc.body.appendChild(i);
            toHex = cacher(function (color) {
                i.style.color = color;
                return g.doc.defaultView.getComputedStyle(i, E).getPropertyValue("color");
            });
        }
        return toHex(color);
    },
    hsbtoString = function () {
        return "hsb(" + [this.h, this.s, this.b] + ")";
    },
    hsltoString = function () {
        return "hsl(" + [this.h, this.s, this.l] + ")";
    },
    rgbtoString = function () {
        return this.hex;
    },
    prepareRGB = function (r, g, b) {
        if (g == null && R.is(r, "object") && "r" in r && "g" in r && "b" in r) {
            b = r.b;
            g = r.g;
            r = r.r;
        }
        if (g == null && R.is(r, string)) {
            var clr = R.getRGB(r);
            r = clr.r;
            g = clr.g;
            b = clr.b;
        }
        if (r > 1 || g > 1 || b > 1) {
            r /= 255;
            g /= 255;
            b /= 255;
        }

        return [r, g, b];
    },
    packageRGB = function (r, g, b, o) {
        r *= 255;
        g *= 255;
        b *= 255;
        var rgb = {
            r: r,
            g: g,
            b: b,
            hex: R.rgb(r, g, b),
            toString: rgbtoString
        };
        R.is(o, "finite") && (rgb.opacity = o);
        return rgb;
    };

    /*\
     * Raphael.color
     [ method ]
     **
     * Parses the color string and returns object with all values for the given color.
     > Parameters
     - clr (string) color string in one of the supported formats (see @Raphael.getRGB)
     = (object) Combined RGB & HSB object in format:
     o {
     o     r (number) red,
     o     g (number) green,
     o     b (number) blue,
     o     hex (string) color in HTML/CSS format: #••••••,
     o     error (boolean) `true` if string can’t be parsed,
     o     h (number) hue,
     o     s (number) saturation,
     o     v (number) value (brightness),
     o     l (number) lightness
     o }
    \*/
    R.color = function (clr) {
        var rgb;
        if (R.is(clr, "object") && "h" in clr && "s" in clr && "b" in clr) {
            rgb = R.hsb2rgb(clr);
            clr.r = rgb.r;
            clr.g = rgb.g;
            clr.b = rgb.b;
            clr.hex = rgb.hex;
        } else if (R.is(clr, "object") && "h" in clr && "s" in clr && "l" in clr) {
            rgb = R.hsl2rgb(clr);
            clr.r = rgb.r;
            clr.g = rgb.g;
            clr.b = rgb.b;
            clr.hex = rgb.hex;
        } else {
            if (R.is(clr, "string")) {
                clr = R.getRGB(clr);
            }
            if (R.is(clr, "object") && "r" in clr && "g" in clr && "b" in clr) {
                rgb = R.rgb2hsl(clr);
                clr.h = rgb.h;
                clr.s = rgb.s;
                clr.l = rgb.l;
                rgb = R.rgb2hsb(clr);
                clr.v = rgb.b;
            } else {
                clr = {hex: "none"};
                clr.r = clr.g = clr.b = clr.h = clr.s = clr.v = clr.l = -1;
            }
        }
        clr.toString = rgbtoString;
        return clr;
    };
    /*\
     * Raphael.hsb2rgb
     [ method ]
     **
     * Converts HSB values to RGB object.
     > Parameters
     - h (number) hue
     - s (number) saturation
     - v (number) value or brightness
     = (object) RGB object in format:
     o {
     o     r (number) red,
     o     g (number) green,
     o     b (number) blue,
     o     hex (string) color in HTML/CSS format: #••••••
     o }
    \*/
    R.hsb2rgb = function (h, s, v, o) {
        if (this.is(h, "object") && "h" in h && "s" in h && "b" in h) {
            v = h.b;
            s = h.s;
            o = h.o;
            h = h.h;
        }
        h *= 360;
        var R, G, B, X, C;
        h = (h % 360) / 60;
        C = v * s;
        X = C * (1 - abs(h % 2 - 1));
        R = G = B = v - C;

        h = ~~h;
        R += [C, X, 0, 0, X, C][h];
        G += [X, C, C, X, 0, 0][h];
        B += [0, 0, X, C, C, X][h];
        return packageRGB(R, G, B, o);
    };
    /*\
     * Raphael.hsl2rgb
     [ method ]
     **
     * Converts HSL values to RGB object.
     > Parameters
     - h (number) hue
     - s (number) saturation
     - l (number) luminosity
     = (object) RGB object in format:
     o {
     o     r (number) red,
     o     g (number) green,
     o     b (number) blue,
     o     hex (string) color in HTML/CSS format: #••••••
     o }
    \*/
    R.hsl2rgb = function (h, s, l, o) {
        if (this.is(h, "object") && "h" in h && "s" in h && "l" in h) {
            l = h.l;
            s = h.s;
            h = h.h;
        }
        if (h > 1 || s > 1 || l > 1) {
            h /= 360;
            s /= 100;
            l /= 100;
        }
        h *= 360;
        var R, G, B, X, C;
        h = (h % 360) / 60;
        C = 2 * s * (l < .5 ? l : 1 - l);
        X = C * (1 - abs(h % 2 - 1));
        R = G = B = l - C / 2;

        h = ~~h;
        R += [C, X, 0, 0, X, C][h];
        G += [X, C, C, X, 0, 0][h];
        B += [0, 0, X, C, C, X][h];
        return packageRGB(R, G, B, o);
    };
    /*\
     * Raphael.rgb2hsb
     [ method ]
     **
     * Converts RGB values to HSB object.
     > Parameters
     - r (number) red
     - g (number) green
     - b (number) blue
     = (object) HSB object in format:
     o {
     o     h (number) hue
     o     s (number) saturation
     o     b (number) brightness
     o }
    \*/
    R.rgb2hsb = function (r, g, b) {
        b = prepareRGB(r, g, b);
        r = b[0];
        g = b[1];
        b = b[2];

        var H, S, V, C;
        V = mmax(r, g, b);
        C = V - mmin(r, g, b);
        H = (C == 0 ? null :
             V == r ? (g - b) / C :
             V == g ? (b - r) / C + 2 :
                      (r - g) / C + 4
            );
        H = ((H + 360) % 6) * 60 / 360;
        S = C == 0 ? 0 : C / V;
        return {h: H, s: S, b: V, toString: hsbtoString};
    };
    /*\
     * Raphael.rgb2hsl
     [ method ]
     **
     * Converts RGB values to HSL object.
     > Parameters
     - r (number) red
     - g (number) green
     - b (number) blue
     = (object) HSL object in format:
     o {
     o     h (number) hue
     o     s (number) saturation
     o     l (number) luminosity
     o }
    \*/
    R.rgb2hsl = function (r, g, b) {
        b = prepareRGB(r, g, b);
        r = b[0];
        g = b[1];
        b = b[2];

        var H, S, L, M, m, C;
        M = mmax(r, g, b);
        m = mmin(r, g, b);
        C = M - m;
        H = (C == 0 ? null :
             M == r ? (g - b) / C :
             M == g ? (b - r) / C + 2 :
                      (r - g) / C + 4);
        H = ((H + 360) % 6) * 60 / 360;
        L = (M + m) / 2;
        S = (C == 0 ? 0 :
             L < .5 ? C / (2 * L) :
                      C / (2 - 2 * L));
        return {h: H, s: S, l: L, toString: hsltoString};
    };
    R._path2string = function () {
        return this.join(",").replace(p2s, "$1");
    };
    function repush(array, item) {
        for (var i = 0, ii = array.length; i < ii; i++) if (array[i] === item) {
            return array.push(array.splice(i, 1)[0]);
        }
    }
    function cacher(f, scope, postprocessor) {
        function newf() {
            var arg = Array.prototype.slice.call(arguments, 0),
                args = arg.join("\u2400"),
                cache = newf.cache = newf.cache || {},
                count = newf.count = newf.count || [];
            if (cache[has](args)) {
                repush(count, args);
                return postprocessor ? postprocessor(cache[args]) : cache[args];
            }
            count.length >= 1e3 && delete cache[count.shift()];
            count.push(args);
            cache[args] = f[apply](scope, arg);
            return postprocessor ? postprocessor(cache[args]) : cache[args];
        }
        return newf;
    }

    var preload = R._preload = function (src, f) {
        var img = g.doc.createElement("img");
        img.style.cssText = "position:absolute;left:-9999em;top:-9999em";
        img.onload = function () {
            f.call(this);
            this.onload = null;
            g.doc.body.removeChild(this);
        };
        img.onerror = function () {
            g.doc.body.removeChild(this);
        };
        g.doc.body.appendChild(img);
        img.src = src;
    };

    function clrToString() {
        return this.hex;
    }

    /*\
     * Raphael.getRGB
     [ method ]
     **
     * Parses colour string as RGB object
     > Parameters
     - colour (string) colour string in one of formats:
     # <ul>
     #     <li>Colour name (“<code>red</code>”, “<code>green</code>”, “<code>cornflowerblue</code>”, etc)</li>
     #     <li>#••• — shortened HTML colour: (“<code>#000</code>”, “<code>#fc0</code>”, etc)</li>
     #     <li>#•••••• — full length HTML colour: (“<code>#000000</code>”, “<code>#bd2300</code>”)</li>
     #     <li>rgb(•••, •••, •••) — red, green and blue channels’ values: (“<code>rgb(200,&nbsp;100,&nbsp;0)</code>”)</li>
     #     <li>rgb(•••%, •••%, •••%) — same as above, but in %: (“<code>rgb(100%,&nbsp;175%,&nbsp;0%)</code>”)</li>
     #     <li>hsb(•••, •••, •••) — hue, saturation and brightness values: (“<code>hsb(0.5,&nbsp;0.25,&nbsp;1)</code>”)</li>
     #     <li>hsb(•••%, •••%, •••%) — same as above, but in %</li>
     #     <li>hsl(•••, •••, •••) — same as hsb</li>
     #     <li>hsl(•••%, •••%, •••%) — same as hsb</li>
     # </ul>
     = (object) RGB object in format:
     o {
     o     r (number) red,
     o     g (number) green,
     o     b (number) blue
     o     hex (string) color in HTML/CSS format: #••••••,
     o     error (boolean) true if string can’t be parsed
     o }
    \*/
    R.getRGB = cacher(function (colour) {
        if (!colour || !!((colour = Str(colour)).indexOf("-") + 1)) {
            return {r: -1, g: -1, b: -1, hex: "none", error: 1, toString: clrToString};
        }
        if (colour == "none") {
            return {r: -1, g: -1, b: -1, hex: "none", toString: clrToString};
        }
        !(hsrg[has](colour.toLowerCase().substring(0, 2)) || colour.charAt() == "#") && (colour = toHex(colour));
        var res,
            red,
            green,
            blue,
            opacity,
            t,
            values,
            rgb = colour.match(colourRegExp);
        if (rgb) {
            if (rgb[2]) {
                blue = toInt(rgb[2].substring(5), 16);
                green = toInt(rgb[2].substring(3, 5), 16);
                red = toInt(rgb[2].substring(1, 3), 16);
            }
            if (rgb[3]) {
                blue = toInt((t = rgb[3].charAt(3)) + t, 16);
                green = toInt((t = rgb[3].charAt(2)) + t, 16);
                red = toInt((t = rgb[3].charAt(1)) + t, 16);
            }
            if (rgb[4]) {
                values = rgb[4][split](commaSpaces);
                red = toFloat(values[0]);
                values[0].slice(-1) == "%" && (red *= 2.55);
                green = toFloat(values[1]);
                values[1].slice(-1) == "%" && (green *= 2.55);
                blue = toFloat(values[2]);
                values[2].slice(-1) == "%" && (blue *= 2.55);
                rgb[1].toLowerCase().slice(0, 4) == "rgba" && (opacity = toFloat(values[3]));
                values[3] && values[3].slice(-1) == "%" && (opacity /= 100);
            }
            if (rgb[5]) {
                values = rgb[5][split](commaSpaces);
                red = toFloat(values[0]);
                values[0].slice(-1) == "%" && (red *= 2.55);
                green = toFloat(values[1]);
                values[1].slice(-1) == "%" && (green *= 2.55);
                blue = toFloat(values[2]);
                values[2].slice(-1) == "%" && (blue *= 2.55);
                (values[0].slice(-3) == "deg" || values[0].slice(-1) == "\xb0") && (red /= 360);
                rgb[1].toLowerCase().slice(0, 4) == "hsba" && (opacity = toFloat(values[3]));
                values[3] && values[3].slice(-1) == "%" && (opacity /= 100);
                return R.hsb2rgb(red, green, blue, opacity);
            }
            if (rgb[6]) {
                values = rgb[6][split](commaSpaces);
                red = toFloat(values[0]);
                values[0].slice(-1) == "%" && (red *= 2.55);
                green = toFloat(values[1]);
                values[1].slice(-1) == "%" && (green *= 2.55);
                blue = toFloat(values[2]);
                values[2].slice(-1) == "%" && (blue *= 2.55);
                (values[0].slice(-3) == "deg" || values[0].slice(-1) == "\xb0") && (red /= 360);
                rgb[1].toLowerCase().slice(0, 4) == "hsla" && (opacity = toFloat(values[3]));
                values[3] && values[3].slice(-1) == "%" && (opacity /= 100);
                return R.hsl2rgb(red, green, blue, opacity);
            }
            rgb = {r: red, g: green, b: blue, toString: clrToString};
            rgb.hex = "#" + (16777216 | blue | (green << 8) | (red << 16)).toString(16).slice(1);
            R.is(opacity, "finite") && (rgb.opacity = opacity);
            return rgb;
        }
        return {r: -1, g: -1, b: -1, hex: "none", error: 1, toString: clrToString};
    }, R);
    /*\
     * Raphael.hsb
     [ method ]
     **
     * Converts HSB values to hex representation of the colour.
     > Parameters
     - h (number) hue
     - s (number) saturation
     - b (number) value or brightness
     = (string) hex representation of the colour.
    \*/
    R.hsb = cacher(function (h, s, b) {
        return R.hsb2rgb(h, s, b).hex;
    });
    /*\
     * Raphael.hsl
     [ method ]
     **
     * Converts HSL values to hex representation of the colour.
     > Parameters
     - h (number) hue
     - s (number) saturation
     - l (number) luminosity
     = (string) hex representation of the colour.
    \*/
    R.hsl = cacher(function (h, s, l) {
        return R.hsl2rgb(h, s, l).hex;
    });
    /*\
     * Raphael.rgb
     [ method ]
     **
     * Converts RGB values to hex representation of the colour.
     > Parameters
     - r (number) red
     - g (number) green
     - b (number) blue
     = (string) hex representation of the colour.
    \*/
    R.rgb = cacher(function (r, g, b) {
        function round(x) { return (x + 0.5) | 0; }
        return "#" + (16777216 | round(b) | (round(g) << 8) | (round(r) << 16)).toString(16).slice(1);
    });
    /*\
     * Raphael.getColor
     [ method ]
     **
     * On each call returns next colour in the spectrum. To reset it back to red call @Raphael.getColor.reset
     > Parameters
     - value (number) #optional brightness, default is `0.75`
     = (string) hex representation of the colour.
    \*/
    R.getColor = function (value) {
        var start = this.getColor.start = this.getColor.start || {h: 0, s: 1, b: value || .75},
            rgb = this.hsb2rgb(start.h, start.s, start.b);
        start.h += .075;
        if (start.h > 1) {
            start.h = 0;
            start.s -= .2;
            start.s <= 0 && (this.getColor.start = {h: 0, s: 1, b: start.b});
        }
        return rgb.hex;
    };
    /*\
     * Raphael.getColor.reset
     [ method ]
     **
     * Resets spectrum position for @Raphael.getColor back to red.
    \*/
    R.getColor.reset = function () {
        delete this.start;
    };

    // http://schepers.cc/getting-to-the-point
    function catmullRom2bezier(crp, z) {
        var d = [];
        for (var i = 0, iLen = crp.length; iLen - 2 * !z > i; i += 2) {
            var p = [
                        {x: +crp[i - 2], y: +crp[i - 1]},
                        {x: +crp[i],     y: +crp[i + 1]},
                        {x: +crp[i + 2], y: +crp[i + 3]},
                        {x: +crp[i + 4], y: +crp[i + 5]}
                    ];
            if (z) {
                if (!i) {
                    p[0] = {x: +crp[iLen - 2], y: +crp[iLen - 1]};
                } else if (iLen - 4 == i) {
                    p[3] = {x: +crp[0], y: +crp[1]};
                } else if (iLen - 2 == i) {
                    p[2] = {x: +crp[0], y: +crp[1]};
                    p[3] = {x: +crp[2], y: +crp[3]};
                }
            } else {
                if (iLen - 4 == i) {
                    p[3] = p[2];
                } else if (!i) {
                    p[0] = {x: +crp[i], y: +crp[i + 1]};
                }
            }
            d.push(["C",
                  (-p[0].x + 6 * p[1].x + p[2].x) / 6,
                  (-p[0].y + 6 * p[1].y + p[2].y) / 6,
                  (p[1].x + 6 * p[2].x - p[3].x) / 6,
                  (p[1].y + 6*p[2].y - p[3].y) / 6,
                  p[2].x,
                  p[2].y
            ]);
        }

        return d;
    }
    /*\
     * Raphael.parsePathString
     [ method ]
     **
     * Utility method
     **
     * Parses given path string into an array of arrays of path segments.
     > Parameters
     - pathString (string|array) path string or array of segments (in the last case it will be returned straight away)
     = (array) array of segments.
    \*/
    R.parsePathString = function (pathString) {
        if (!pathString) {
            return null;
        }
        var pth = paths(pathString);
        if (pth.arr) {
            return pathClone(pth.arr);
        }

        var paramCounts = {a: 7, c: 6, h: 1, l: 2, m: 2, r: 4, q: 4, s: 4, t: 2, v: 1, z: 0},
            data = [];
        if (R.is(pathString, array) && R.is(pathString[0], array)) { // rough assumption
            data = pathClone(pathString);
        }
        if (!data.length) {
            Str(pathString).replace(pathCommand, function (a, b, c) {
                var params = [],
                    name = b.toLowerCase();
                c.replace(pathValues, function (a, b) {
                    b && params.push(+b);
                });
                if (name == "m" && params.length > 2) {
                    data.push([b][concat](params.splice(0, 2)));
                    name = "l";
                    b = b == "m" ? "l" : "L";
                }
                if (name == "r") {
                    data.push([b][concat](params));
                } else while (params.length >= paramCounts[name]) {
                    data.push([b][concat](params.splice(0, paramCounts[name])));
                    if (!paramCounts[name]) {
                        break;
                    }
                }
            });
        }
        data.toString = R._path2string;
        pth.arr = pathClone(data);
        return data;
    };
    /*\
     * Raphael.parseTransformString
     [ method ]
     **
     * Utility method
     **
     * Parses given path string into an array of transformations.
     > Parameters
     - TString (string|array) transform string or array of transformations (in the last case it will be returned straight away)
     = (array) array of transformations.
    \*/
    R.parseTransformString = cacher(function (TString) {
        if (!TString) {
            return null;
        }
        var paramCounts = {r: 3, s: 4, t: 2, m: 6},
            data = [];
        if (R.is(TString, array) && R.is(TString[0], array)) { // rough assumption
            data = pathClone(TString);
        }
        if (!data.length) {
            Str(TString).replace(tCommand, function (a, b, c) {
                var params = [],
                    name = lowerCase.call(b);
                c.replace(pathValues, function (a, b) {
                    b && params.push(+b);
                });
                data.push([b][concat](params));
            });
        }
        data.toString = R._path2string;
        return data;
    }, this, function(elem) {
        if (!elem) return elem;
        var newData = [];
        for (var i = 0; i < elem.length; i++) {
            var newLevel = [];
            for (var j = 0; j < elem[i].length; j++) {
                newLevel.push(elem[i][j]);
            }
            newData.push(newLevel);
        }
      return newData; } );
    // PATHS
    var paths = function (ps) {
        var p = paths.ps = paths.ps || {};
        if (p[ps]) {
            p[ps].sleep = 100;
        } else {
            p[ps] = {
                sleep: 100
            };
        }
        setTimeout(function () {
            for (var key in p) if (p[has](key) && key != ps) {
                p[key].sleep--;
                !p[key].sleep && delete p[key];
            }
        });
        return p[ps];
    };
    /*\
     * Raphael.findDotsAtSegment
     [ method ]
     **
     * Utility method
     **
     * Find dot coordinates on the given cubic bezier curve at the given t.
     > Parameters
     - p1x (number) x of the first point of the curve
     - p1y (number) y of the first point of the curve
     - c1x (number) x of the first anchor of the curve
     - c1y (number) y of the first anchor of the curve
     - c2x (number) x of the second anchor of the curve
     - c2y (number) y of the second anchor of the curve
     - p2x (number) x of the second point of the curve
     - p2y (number) y of the second point of the curve
     - t (number) position on the curve (0..1)
     = (object) point information in format:
     o {
     o     x: (number) x coordinate of the point
     o     y: (number) y coordinate of the point
     o     m: {
     o         x: (number) x coordinate of the left anchor
     o         y: (number) y coordinate of the left anchor
     o     }
     o     n: {
     o         x: (number) x coordinate of the right anchor
     o         y: (number) y coordinate of the right anchor
     o     }
     o     start: {
     o         x: (number) x coordinate of the start of the curve
     o         y: (number) y coordinate of the start of the curve
     o     }
     o     end: {
     o         x: (number) x coordinate of the end of the curve
     o         y: (number) y coordinate of the end of the curve
     o     }
     o     alpha: (number) angle of the curve derivative at the point
     o }
    \*/
    R.findDotsAtSegment = function (p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, t) {
        var t1 = 1 - t,
            t13 = pow(t1, 3),
            t12 = pow(t1, 2),
            t2 = t * t,
            t3 = t2 * t,
            x = t13 * p1x + t12 * 3 * t * c1x + t1 * 3 * t * t * c2x + t3 * p2x,
            y = t13 * p1y + t12 * 3 * t * c1y + t1 * 3 * t * t * c2y + t3 * p2y,
            mx = p1x + 2 * t * (c1x - p1x) + t2 * (c2x - 2 * c1x + p1x),
            my = p1y + 2 * t * (c1y - p1y) + t2 * (c2y - 2 * c1y + p1y),
            nx = c1x + 2 * t * (c2x - c1x) + t2 * (p2x - 2 * c2x + c1x),
            ny = c1y + 2 * t * (c2y - c1y) + t2 * (p2y - 2 * c2y + c1y),
            ax = t1 * p1x + t * c1x,
            ay = t1 * p1y + t * c1y,
            cx = t1 * c2x + t * p2x,
            cy = t1 * c2y + t * p2y,
            alpha = (90 - math.atan2(mx - nx, my - ny) * 180 / PI);
        (mx > nx || my < ny) && (alpha += 180);
        return {
            x: x,
            y: y,
            m: {x: mx, y: my},
            n: {x: nx, y: ny},
            start: {x: ax, y: ay},
            end: {x: cx, y: cy},
            alpha: alpha
        };
    };
    /*\
     * Raphael.bezierBBox
     [ method ]
     **
     * Utility method
     **
     * Return bounding box of a given cubic bezier curve
     > Parameters
     - p1x (number) x of the first point of the curve
     - p1y (number) y of the first point of the curve
     - c1x (number) x of the first anchor of the curve
     - c1y (number) y of the first anchor of the curve
     - c2x (number) x of the second anchor of the curve
     - c2y (number) y of the second anchor of the curve
     - p2x (number) x of the second point of the curve
     - p2y (number) y of the second point of the curve
     * or
     - bez (array) array of six points for bezier curve
     = (object) point information in format:
     o {
     o     min: {
     o         x: (number) x coordinate of the left point
     o         y: (number) y coordinate of the top point
     o     }
     o     max: {
     o         x: (number) x coordinate of the right point
     o         y: (number) y coordinate of the bottom point
     o     }
     o }
    \*/
    R.bezierBBox = function (p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y) {
        if (!R.is(p1x, "array")) {
            p1x = [p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y];
        }
        var bbox = curveDim.apply(null, p1x);
        return {
            x: bbox.min.x,
            y: bbox.min.y,
            x2: bbox.max.x,
            y2: bbox.max.y,
            width: bbox.max.x - bbox.min.x,
            height: bbox.max.y - bbox.min.y
        };
    };
    /*\
     * Raphael.isPointInsideBBox
     [ method ]
     **
     * Utility method
     **
     * Returns `true` if given point is inside bounding boxes.
     > Parameters
     - bbox (string) bounding box
     - x (string) x coordinate of the point
     - y (string) y coordinate of the point
     = (boolean) `true` if point inside
    \*/
    R.isPointInsideBBox = function (bbox, x, y) {
        return x >= bbox.x && x <= bbox.x2 && y >= bbox.y && y <= bbox.y2;
    };
    /*\
     * Raphael.isBBoxIntersect
     [ method ]
     **
     * Utility method
     **
     * Returns `true` if two bounding boxes intersect
     > Parameters
     - bbox1 (string) first bounding box
     - bbox2 (string) second bounding box
     = (boolean) `true` if they intersect
    \*/
    R.isBBoxIntersect = function (bbox1, bbox2) {
        var i = R.isPointInsideBBox;
        return i(bbox2, bbox1.x, bbox1.y)
            || i(bbox2, bbox1.x2, bbox1.y)
            || i(bbox2, bbox1.x, bbox1.y2)
            || i(bbox2, bbox1.x2, bbox1.y2)
            || i(bbox1, bbox2.x, bbox2.y)
            || i(bbox1, bbox2.x2, bbox2.y)
            || i(bbox1, bbox2.x, bbox2.y2)
            || i(bbox1, bbox2.x2, bbox2.y2)
            || (bbox1.x < bbox2.x2 && bbox1.x > bbox2.x || bbox2.x < bbox1.x2 && bbox2.x > bbox1.x)
            && (bbox1.y < bbox2.y2 && bbox1.y > bbox2.y || bbox2.y < bbox1.y2 && bbox2.y > bbox1.y);
    };
    function base3(t, p1, p2, p3, p4) {
        var t1 = -3 * p1 + 9 * p2 - 9 * p3 + 3 * p4,
            t2 = t * t1 + 6 * p1 - 12 * p2 + 6 * p3;
        return t * t2 - 3 * p1 + 3 * p2;
    }
    function bezlen(x1, y1, x2, y2, x3, y3, x4, y4, z) {
        if (z == null) {
            z = 1;
        }
        z = z > 1 ? 1 : z < 0 ? 0 : z;
        var z2 = z / 2,
            n = 12,
            Tvalues = [-0.1252,0.1252,-0.3678,0.3678,-0.5873,0.5873,-0.7699,0.7699,-0.9041,0.9041,-0.9816,0.9816],
            Cvalues = [0.2491,0.2491,0.2335,0.2335,0.2032,0.2032,0.1601,0.1601,0.1069,0.1069,0.0472,0.0472],
            sum = 0;
        for (var i = 0; i < n; i++) {
            var ct = z2 * Tvalues[i] + z2,
                xbase = base3(ct, x1, x2, x3, x4),
                ybase = base3(ct, y1, y2, y3, y4),
                comb = xbase * xbase + ybase * ybase;
            sum += Cvalues[i] * math.sqrt(comb);
        }
        return z2 * sum;
    }
    function getTatLen(x1, y1, x2, y2, x3, y3, x4, y4, ll) {
        if (ll < 0 || bezlen(x1, y1, x2, y2, x3, y3, x4, y4) < ll) {
            return;
        }
        var t = 1,
            step = t / 2,
            t2 = t - step,
            l,
            e = .01;
        l = bezlen(x1, y1, x2, y2, x3, y3, x4, y4, t2);
        while (abs(l - ll) > e) {
            step /= 2;
            t2 += (l < ll ? 1 : -1) * step;
            l = bezlen(x1, y1, x2, y2, x3, y3, x4, y4, t2);
        }
        return t2;
    }
    function intersect(x1, y1, x2, y2, x3, y3, x4, y4) {
        if (
            mmax(x1, x2) < mmin(x3, x4) ||
            mmin(x1, x2) > mmax(x3, x4) ||
            mmax(y1, y2) < mmin(y3, y4) ||
            mmin(y1, y2) > mmax(y3, y4)
        ) {
            return;
        }
        var nx = (x1 * y2 - y1 * x2) * (x3 - x4) - (x1 - x2) * (x3 * y4 - y3 * x4),
            ny = (x1 * y2 - y1 * x2) * (y3 - y4) - (y1 - y2) * (x3 * y4 - y3 * x4),
            denominator = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);

        if (!denominator) {
            return;
        }
        var px = nx / denominator,
            py = ny / denominator,
            px2 = +px.toFixed(2),
            py2 = +py.toFixed(2);
        if (
            px2 < +mmin(x1, x2).toFixed(2) ||
            px2 > +mmax(x1, x2).toFixed(2) ||
            px2 < +mmin(x3, x4).toFixed(2) ||
            px2 > +mmax(x3, x4).toFixed(2) ||
            py2 < +mmin(y1, y2).toFixed(2) ||
            py2 > +mmax(y1, y2).toFixed(2) ||
            py2 < +mmin(y3, y4).toFixed(2) ||
            py2 > +mmax(y3, y4).toFixed(2)
        ) {
            return;
        }
        return {x: px, y: py};
    }
    function inter(bez1, bez2) {
        return interHelper(bez1, bez2);
    }
    function interCount(bez1, bez2) {
        return interHelper(bez1, bez2, 1);
    }
    function interHelper(bez1, bez2, justCount) {
        var bbox1 = R.bezierBBox(bez1),
            bbox2 = R.bezierBBox(bez2);
        if (!R.isBBoxIntersect(bbox1, bbox2)) {
            return justCount ? 0 : [];
        }
        var l1 = bezlen.apply(0, bez1),
            l2 = bezlen.apply(0, bez2),
            n1 = mmax(~~(l1 / 5), 1),
            n2 = mmax(~~(l2 / 5), 1),
            dots1 = [],
            dots2 = [],
            xy = {},
            res = justCount ? 0 : [];
        for (var i = 0; i < n1 + 1; i++) {
            var p = R.findDotsAtSegment.apply(R, bez1.concat(i / n1));
            dots1.push({x: p.x, y: p.y, t: i / n1});
        }
        for (i = 0; i < n2 + 1; i++) {
            p = R.findDotsAtSegment.apply(R, bez2.concat(i / n2));
            dots2.push({x: p.x, y: p.y, t: i / n2});
        }
        for (i = 0; i < n1; i++) {
            for (var j = 0; j < n2; j++) {
                var di = dots1[i],
                    di1 = dots1[i + 1],
                    dj = dots2[j],
                    dj1 = dots2[j + 1],
                    ci = abs(di1.x - di.x) < .001 ? "y" : "x",
                    cj = abs(dj1.x - dj.x) < .001 ? "y" : "x",
                    is = intersect(di.x, di.y, di1.x, di1.y, dj.x, dj.y, dj1.x, dj1.y);
                if (is) {
                    if (xy[is.x.toFixed(4)] == is.y.toFixed(4)) {
                        continue;
                    }
                    xy[is.x.toFixed(4)] = is.y.toFixed(4);
                    var t1 = di.t + abs((is[ci] - di[ci]) / (di1[ci] - di[ci])) * (di1.t - di.t),
                        t2 = dj.t + abs((is[cj] - dj[cj]) / (dj1[cj] - dj[cj])) * (dj1.t - dj.t);
                    if (t1 >= 0 && t1 <= 1.001 && t2 >= 0 && t2 <= 1.001) {
                        if (justCount) {
                            res++;
                        } else {
                            res.push({
                                x: is.x,
                                y: is.y,
                                t1: mmin(t1, 1),
                                t2: mmin(t2, 1)
                            });
                        }
                    }
                }
            }
        }
        return res;
    }
    /*\
     * Raphael.pathIntersection
     [ method ]
     **
     * Utility method
     **
     * Finds intersections of two paths
     > Parameters
     - path1 (string) path string
     - path2 (string) path string
     = (array) dots of intersection
     o [
     o     {
     o         x: (number) x coordinate of the point
     o         y: (number) y coordinate of the point
     o         t1: (number) t value for segment of path1
     o         t2: (number) t value for segment of path2
     o         segment1: (number) order number for segment of path1
     o         segment2: (number) order number for segment of path2
     o         bez1: (array) eight coordinates representing beziér curve for the segment of path1
     o         bez2: (array) eight coordinates representing beziér curve for the segment of path2
     o     }
     o ]
    \*/
    R.pathIntersection = function (path1, path2) {
        return interPathHelper(path1, path2);
    };
    R.pathIntersectionNumber = function (path1, path2) {
        return interPathHelper(path1, path2, 1);
    };
    function interPathHelper(path1, path2, justCount) {
        path1 = R._path2curve(path1);
        path2 = R._path2curve(path2);
        var x1, y1, x2, y2, x1m, y1m, x2m, y2m, bez1, bez2,
            res = justCount ? 0 : [];
        for (var i = 0, ii = path1.length; i < ii; i++) {
            var pi = path1[i];
            if (pi[0] == "M") {
                x1 = x1m = pi[1];
                y1 = y1m = pi[2];
            } else {
                if (pi[0] == "C") {
                    bez1 = [x1, y1].concat(pi.slice(1));
                    x1 = bez1[6];
                    y1 = bez1[7];
                } else {
                    bez1 = [x1, y1, x1, y1, x1m, y1m, x1m, y1m];
                    x1 = x1m;
                    y1 = y1m;
                }
                for (var j = 0, jj = path2.length; j < jj; j++) {
                    var pj = path2[j];
                    if (pj[0] == "M") {
                        x2 = x2m = pj[1];
                        y2 = y2m = pj[2];
                    } else {
                        if (pj[0] == "C") {
                            bez2 = [x2, y2].concat(pj.slice(1));
                            x2 = bez2[6];
                            y2 = bez2[7];
                        } else {
                            bez2 = [x2, y2, x2, y2, x2m, y2m, x2m, y2m];
                            x2 = x2m;
                            y2 = y2m;
                        }
                        var intr = interHelper(bez1, bez2, justCount);
                        if (justCount) {
                            res += intr;
                        } else {
                            for (var k = 0, kk = intr.length; k < kk; k++) {
                                intr[k].segment1 = i;
                                intr[k].segment2 = j;
                                intr[k].bez1 = bez1;
                                intr[k].bez2 = bez2;
                            }
                            res = res.concat(intr);
                        }
                    }
                }
            }
        }
        return res;
    }
    /*\
     * Raphael.isPointInsidePath
     [ method ]
     **
     * Utility method
     **
     * Returns `true` if given point is inside a given closed path.
     > Parameters
     - path (string) path string
     - x (number) x of the point
     - y (number) y of the point
     = (boolean) true, if point is inside the path
    \*/
    R.isPointInsidePath = function (path, x, y) {
        var bbox = R.pathBBox(path);
        return R.isPointInsideBBox(bbox, x, y) &&
               interPathHelper(path, [["M", x, y], ["H", bbox.x2 + 10]], 1) % 2 == 1;
    };
    R._removedFactory = function (methodname) {
        return function () {
            eve("raphael.log", null, "Rapha\xebl: you are calling to method \u201c" + methodname + "\u201d of removed object", methodname);
        };
    };
    /*\
     * Raphael.pathBBox
     [ method ]
     **
     * Utility method
     **
     * Return bounding box of a given path
     > Parameters
     - path (string) path string
     = (object) bounding box
     o {
     o     x: (number) x coordinate of the left top point of the box
     o     y: (number) y coordinate of the left top point of the box
     o     x2: (number) x coordinate of the right bottom point of the box
     o     y2: (number) y coordinate of the right bottom point of the box
     o     width: (number) width of the box
     o     height: (number) height of the box
     o     cx: (number) x coordinate of the center of the box
     o     cy: (number) y coordinate of the center of the box
     o }
    \*/
    var pathDimensions = R.pathBBox = function (path) {
        var pth = paths(path);
        if (pth.bbox) {
            return clone(pth.bbox);
        }
        if (!path) {
            return {x: 0, y: 0, width: 0, height: 0, x2: 0, y2: 0};
        }
        path = path2curve(path);
        var x = 0,
            y = 0,
            X = [],
            Y = [],
            p;
        for (var i = 0, ii = path.length; i < ii; i++) {
            p = path[i];
            if (p[0] == "M") {
                x = p[1];
                y = p[2];
                X.push(x);
                Y.push(y);
            } else {
                var dim = curveDim(x, y, p[1], p[2], p[3], p[4], p[5], p[6]);
                X = X[concat](dim.min.x, dim.max.x);
                Y = Y[concat](dim.min.y, dim.max.y);
                x = p[5];
                y = p[6];
            }
        }
        var xmin = mmin[apply](0, X),
            ymin = mmin[apply](0, Y),
            xmax = mmax[apply](0, X),
            ymax = mmax[apply](0, Y),
            width = xmax - xmin,
            height = ymax - ymin,
                bb = {
                x: xmin,
                y: ymin,
                x2: xmax,
                y2: ymax,
                width: width,
                height: height,
                cx: xmin + width / 2,
                cy: ymin + height / 2
            };
        pth.bbox = clone(bb);
        return bb;
    },
        pathClone = function (pathArray) {
            var res = clone(pathArray);
            res.toString = R._path2string;
            return res;
        },
        pathToRelative = R._pathToRelative = function (pathArray) {
            var pth = paths(pathArray);
            if (pth.rel) {
                return pathClone(pth.rel);
            }
            if (!R.is(pathArray, array) || !R.is(pathArray && pathArray[0], array)) { // rough assumption
                pathArray = R.parsePathString(pathArray);
            }
            var res = [],
                x = 0,
                y = 0,
                mx = 0,
                my = 0,
                start = 0;
            if (pathArray[0][0] == "M") {
                x = pathArray[0][1];
                y = pathArray[0][2];
                mx = x;
                my = y;
                start++;
                res.push(["M", x, y]);
            }
            for (var i = start, ii = pathArray.length; i < ii; i++) {
                var r = res[i] = [],
                    pa = pathArray[i];
                if (pa[0] != lowerCase.call(pa[0])) {
                    r[0] = lowerCase.call(pa[0]);
                    switch (r[0]) {
                        case "a":
                            r[1] = pa[1];
                            r[2] = pa[2];
                            r[3] = pa[3];
                            r[4] = pa[4];
                            r[5] = pa[5];
                            r[6] = +(pa[6] - x).toFixed(3);
                            r[7] = +(pa[7] - y).toFixed(3);
                            break;
                        case "v":
                            r[1] = +(pa[1] - y).toFixed(3);
                            break;
                        case "m":
                            mx = pa[1];
                            my = pa[2];
                        default:
                            for (var j = 1, jj = pa.length; j < jj; j++) {
                                r[j] = +(pa[j] - ((j % 2) ? x : y)).toFixed(3);
                            }
                    }
                } else {
                    r = res[i] = [];
                    if (pa[0] == "m") {
                        mx = pa[1] + x;
                        my = pa[2] + y;
                    }
                    for (var k = 0, kk = pa.length; k < kk; k++) {
                        res[i][k] = pa[k];
                    }
                }
                var len = res[i].length;
                switch (res[i][0]) {
                    case "z":
                        x = mx;
                        y = my;
                        break;
                    case "h":
                        x += +res[i][len - 1];
                        break;
                    case "v":
                        y += +res[i][len - 1];
                        break;
                    default:
                        x += +res[i][len - 2];
                        y += +res[i][len - 1];
                }
            }
            res.toString = R._path2string;
            pth.rel = pathClone(res);
            return res;
        },
        pathToAbsolute = R._pathToAbsolute = function (pathArray) {
            var pth = paths(pathArray);
            if (pth.abs) {
                return pathClone(pth.abs);
            }
            if (!R.is(pathArray, array) || !R.is(pathArray && pathArray[0], array)) { // rough assumption
                pathArray = R.parsePathString(pathArray);
            }
            if (!pathArray || !pathArray.length) {
                return [["M", 0, 0]];
            }
            var res = [],
                x = 0,
                y = 0,
                mx = 0,
                my = 0,
                start = 0;
            if (pathArray[0][0] == "M") {
                x = +pathArray[0][1];
                y = +pathArray[0][2];
                mx = x;
                my = y;
                start++;
                res[0] = ["M", x, y];
            }
            var crz = pathArray.length == 3 && pathArray[0][0] == "M" && pathArray[1][0].toUpperCase() == "R" && pathArray[2][0].toUpperCase() == "Z";
            for (var r, pa, i = start, ii = pathArray.length; i < ii; i++) {
                res.push(r = []);
                pa = pathArray[i];
                if (pa[0] != upperCase.call(pa[0])) {
                    r[0] = upperCase.call(pa[0]);
                    switch (r[0]) {
                        case "A":
                            r[1] = pa[1];
                            r[2] = pa[2];
                            r[3] = pa[3];
                            r[4] = pa[4];
                            r[5] = pa[5];
                            r[6] = +(pa[6] + x);
                            r[7] = +(pa[7] + y);
                            break;
                        case "V":
                            r[1] = +pa[1] + y;
                            break;
                        case "H":
                            r[1] = +pa[1] + x;
                            break;
                        case "R":
                            var dots = [x, y][concat](pa.slice(1));
                            for (var j = 2, jj = dots.length; j < jj; j++) {
                                dots[j] = +dots[j] + x;
                                dots[++j] = +dots[j] + y;
                            }
                            res.pop();
                            res = res[concat](catmullRom2bezier(dots, crz));
                            break;
                        case "M":
                            mx = +pa[1] + x;
                            my = +pa[2] + y;
                        default:
                            for (j = 1, jj = pa.length; j < jj; j++) {
                                r[j] = +pa[j] + ((j % 2) ? x : y);
                            }
                    }
                } else if (pa[0] == "R") {
                    dots = [x, y][concat](pa.slice(1));
                    res.pop();
                    res = res[concat](catmullRom2bezier(dots, crz));
                    r = ["R"][concat](pa.slice(-2));
                } else {
                    for (var k = 0, kk = pa.length; k < kk; k++) {
                        r[k] = pa[k];
                    }
                }
                switch (r[0]) {
                    case "Z":
                        x = mx;
                        y = my;
                        break;
                    case "H":
                        x = r[1];
                        break;
                    case "V":
                        y = r[1];
                        break;
                    case "M":
                        mx = r[r.length - 2];
                        my = r[r.length - 1];
                    default:
                        x = r[r.length - 2];
                        y = r[r.length - 1];
                }
            }
            res.toString = R._path2string;
            pth.abs = pathClone(res);
            return res;
        },
        l2c = function (x1, y1, x2, y2) {
            return [x1, y1, x2, y2, x2, y2];
        },
        q2c = function (x1, y1, ax, ay, x2, y2) {
            var _13 = 1 / 3,
                _23 = 2 / 3;
            return [
                    _13 * x1 + _23 * ax,
                    _13 * y1 + _23 * ay,
                    _13 * x2 + _23 * ax,
                    _13 * y2 + _23 * ay,
                    x2,
                    y2
                ];
        },
        a2c = function (x1, y1, rx, ry, angle, large_arc_flag, sweep_flag, x2, y2, recursive) {
            // for more information of where this math came from visit:
            // http://www.w3.org/TR/SVG11/implnote.html#ArcImplementationNotes
            var _120 = PI * 120 / 180,
                rad = PI / 180 * (+angle || 0),
                res = [],
                xy,
                rotate = cacher(function (x, y, rad) {
                    var X = x * math.cos(rad) - y * math.sin(rad),
                        Y = x * math.sin(rad) + y * math.cos(rad);
                    return {x: X, y: Y};
                });
            if (!recursive) {
                xy = rotate(x1, y1, -rad);
                x1 = xy.x;
                y1 = xy.y;
                xy = rotate(x2, y2, -rad);
                x2 = xy.x;
                y2 = xy.y;
                var cos = math.cos(PI / 180 * angle),
                    sin = math.sin(PI / 180 * angle),
                    x = (x1 - x2) / 2,
                    y = (y1 - y2) / 2;
                var h = (x * x) / (rx * rx) + (y * y) / (ry * ry);
                if (h > 1) {
                    h = math.sqrt(h);
                    rx = h * rx;
                    ry = h * ry;
                }
                var rx2 = rx * rx,
                    ry2 = ry * ry,
                    k = (large_arc_flag == sweep_flag ? -1 : 1) *
                        math.sqrt(abs((rx2 * ry2 - rx2 * y * y - ry2 * x * x) / (rx2 * y * y + ry2 * x * x))),
                    cx = k * rx * y / ry + (x1 + x2) / 2,
                    cy = k * -ry * x / rx + (y1 + y2) / 2,
                    f1 = math.asin(((y1 - cy) / ry).toFixed(9)),
                    f2 = math.asin(((y2 - cy) / ry).toFixed(9));

                f1 = x1 < cx ? PI - f1 : f1;
                f2 = x2 < cx ? PI - f2 : f2;
                f1 < 0 && (f1 = PI * 2 + f1);
                f2 < 0 && (f2 = PI * 2 + f2);
                if (sweep_flag && f1 > f2) {
                    f1 = f1 - PI * 2;
                }
                if (!sweep_flag && f2 > f1) {
                    f2 = f2 - PI * 2;
                }
            } else {
                f1 = recursive[0];
                f2 = recursive[1];
                cx = recursive[2];
                cy = recursive[3];
            }
            var df = f2 - f1;
            if (abs(df) > _120) {
                var f2old = f2,
                    x2old = x2,
                    y2old = y2;
                f2 = f1 + _120 * (sweep_flag && f2 > f1 ? 1 : -1);
                x2 = cx + rx * math.cos(f2);
                y2 = cy + ry * math.sin(f2);
                res = a2c(x2, y2, rx, ry, angle, 0, sweep_flag, x2old, y2old, [f2, f2old, cx, cy]);
            }
            df = f2 - f1;
            var c1 = math.cos(f1),
                s1 = math.sin(f1),
                c2 = math.cos(f2),
                s2 = math.sin(f2),
                t = math.tan(df / 4),
                hx = 4 / 3 * rx * t,
                hy = 4 / 3 * ry * t,
                m1 = [x1, y1],
                m2 = [x1 + hx * s1, y1 - hy * c1],
                m3 = [x2 + hx * s2, y2 - hy * c2],
                m4 = [x2, y2];
            m2[0] = 2 * m1[0] - m2[0];
            m2[1] = 2 * m1[1] - m2[1];
            if (recursive) {
                return [m2, m3, m4][concat](res);
            } else {
                res = [m2, m3, m4][concat](res).join()[split](",");
                var newres = [];
                for (var i = 0, ii = res.length; i < ii; i++) {
                    newres[i] = i % 2 ? rotate(res[i - 1], res[i], rad).y : rotate(res[i], res[i + 1], rad).x;
                }
                return newres;
            }
        },
        findDotAtSegment = function (p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, t) {
            var t1 = 1 - t;
            return {
                x: pow(t1, 3) * p1x + pow(t1, 2) * 3 * t * c1x + t1 * 3 * t * t * c2x + pow(t, 3) * p2x,
                y: pow(t1, 3) * p1y + pow(t1, 2) * 3 * t * c1y + t1 * 3 * t * t * c2y + pow(t, 3) * p2y
            };
        },
        curveDim = cacher(function (p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y) {
            var a = (c2x - 2 * c1x + p1x) - (p2x - 2 * c2x + c1x),
                b = 2 * (c1x - p1x) - 2 * (c2x - c1x),
                c = p1x - c1x,
                t1 = (-b + math.sqrt(b * b - 4 * a * c)) / 2 / a,
                t2 = (-b - math.sqrt(b * b - 4 * a * c)) / 2 / a,
                y = [p1y, p2y],
                x = [p1x, p2x],
                dot;
            abs(t1) > "1e12" && (t1 = .5);
            abs(t2) > "1e12" && (t2 = .5);
            if (t1 > 0 && t1 < 1) {
                dot = findDotAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, t1);
                x.push(dot.x);
                y.push(dot.y);
            }
            if (t2 > 0 && t2 < 1) {
                dot = findDotAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, t2);
                x.push(dot.x);
                y.push(dot.y);
            }
            a = (c2y - 2 * c1y + p1y) - (p2y - 2 * c2y + c1y);
            b = 2 * (c1y - p1y) - 2 * (c2y - c1y);
            c = p1y - c1y;
            t1 = (-b + math.sqrt(b * b - 4 * a * c)) / 2 / a;
            t2 = (-b - math.sqrt(b * b - 4 * a * c)) / 2 / a;
            abs(t1) > "1e12" && (t1 = .5);
            abs(t2) > "1e12" && (t2 = .5);
            if (t1 > 0 && t1 < 1) {
                dot = findDotAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, t1);
                x.push(dot.x);
                y.push(dot.y);
            }
            if (t2 > 0 && t2 < 1) {
                dot = findDotAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, t2);
                x.push(dot.x);
                y.push(dot.y);
            }
            return {
                min: {x: mmin[apply](0, x), y: mmin[apply](0, y)},
                max: {x: mmax[apply](0, x), y: mmax[apply](0, y)}
            };
        }),
        path2curve = R._path2curve = cacher(function (path, path2) {
            var pth = !path2 && paths(path);
            if (!path2 && pth.curve) {
                return pathClone(pth.curve);
            }
            var p = pathToAbsolute(path),
                p2 = path2 && pathToAbsolute(path2),
                attrs = {x: 0, y: 0, bx: 0, by: 0, X: 0, Y: 0, qx: null, qy: null},
                attrs2 = {x: 0, y: 0, bx: 0, by: 0, X: 0, Y: 0, qx: null, qy: null},
                processPath = function (path, d, pcom) {
                    var nx, ny, tq = {T:1, Q:1};
                    if (!path) {
                        return ["C", d.x, d.y, d.x, d.y, d.x, d.y];
                    }
                    !(path[0] in tq) && (d.qx = d.qy = null);
                    switch (path[0]) {
                        case "M":
                            d.X = path[1];
                            d.Y = path[2];
                            break;
                        case "A":
                            path = ["C"][concat](a2c[apply](0, [d.x, d.y][concat](path.slice(1))));
                            break;
                        case "S":
                            if (pcom == "C" || pcom == "S") { // In "S" case we have to take into account, if the previous command is C/S.
                                nx = d.x * 2 - d.bx;          // And reflect the previous
                                ny = d.y * 2 - d.by;          // command's control point relative to the current point.
                            }
                            else {                            // or some else or nothing
                                nx = d.x;
                                ny = d.y;
                            }
                            path = ["C", nx, ny][concat](path.slice(1));
                            break;
                        case "T":
                            if (pcom == "Q" || pcom == "T") { // In "T" case we have to take into account, if the previous command is Q/T.
                                d.qx = d.x * 2 - d.qx;        // And make a reflection similar
                                d.qy = d.y * 2 - d.qy;        // to case "S".
                            }
                            else {                            // or something else or nothing
                                d.qx = d.x;
                                d.qy = d.y;
                            }
                            path = ["C"][concat](q2c(d.x, d.y, d.qx, d.qy, path[1], path[2]));
                            break;
                        case "Q":
                            d.qx = path[1];
                            d.qy = path[2];
                            path = ["C"][concat](q2c(d.x, d.y, path[1], path[2], path[3], path[4]));
                            break;
                        case "L":
                            path = ["C"][concat](l2c(d.x, d.y, path[1], path[2]));
                            break;
                        case "H":
                            path = ["C"][concat](l2c(d.x, d.y, path[1], d.y));
                            break;
                        case "V":
                            path = ["C"][concat](l2c(d.x, d.y, d.x, path[1]));
                            break;
                        case "Z":
                            path = ["C"][concat](l2c(d.x, d.y, d.X, d.Y));
                            break;
                    }
                    return path;
                },
                fixArc = function (pp, i) {
                    if (pp[i].length > 7) {
                        pp[i].shift();
                        var pi = pp[i];
                        while (pi.length) {
                            pcoms1[i]="A"; // if created multiple C:s, their original seg is saved
                            p2 && (pcoms2[i]="A"); // the same as above
                            pp.splice(i++, 0, ["C"][concat](pi.splice(0, 6)));
                        }
                        pp.splice(i, 1);
                        ii = mmax(p.length, p2 && p2.length || 0);
                    }
                },
                fixM = function (path1, path2, a1, a2, i) {
                    if (path1 && path2 && path1[i][0] == "M" && path2[i][0] != "M") {
                        path2.splice(i, 0, ["M", a2.x, a2.y]);
                        a1.bx = 0;
                        a1.by = 0;
                        a1.x = path1[i][1];
                        a1.y = path1[i][2];
                        ii = mmax(p.length, p2 && p2.length || 0);
                    }
                },
                pcoms1 = [], // path commands of original path p
                pcoms2 = [], // path commands of original path p2
                pfirst = "", // temporary holder for original path command
                pcom = ""; // holder for previous path command of original path
            for (var i = 0, ii = mmax(p.length, p2 && p2.length || 0); i < ii; i++) {
                p[i] && (pfirst = p[i][0]); // save current path command

                if (pfirst != "C") // C is not saved yet, because it may be result of conversion
                {
                    pcoms1[i] = pfirst; // Save current path command
                    i && ( pcom = pcoms1[i-1]); // Get previous path command pcom
                }
                p[i] = processPath(p[i], attrs, pcom); // Previous path command is inputted to processPath

                if (pcoms1[i] != "A" && pfirst == "C") pcoms1[i] = "C"; // A is the only command
                // which may produce multiple C:s
                // so we have to make sure that C is also C in original path

                fixArc(p, i); // fixArc adds also the right amount of A:s to pcoms1

                if (p2) { // the same procedures is done to p2
                    p2[i] && (pfirst = p2[i][0]);
                    if (pfirst != "C")
                    {
                        pcoms2[i] = pfirst;
                        i && (pcom = pcoms2[i-1]);
                    }
                    p2[i] = processPath(p2[i], attrs2, pcom);

                    if (pcoms2[i]!="A" && pfirst=="C") pcoms2[i]="C";

                    fixArc(p2, i);
                }
                fixM(p, p2, attrs, attrs2, i);
                fixM(p2, p, attrs2, attrs, i);
                var seg = p[i],
                    seg2 = p2 && p2[i],
                    seglen = seg.length,
                    seg2len = p2 && seg2.length;
                attrs.x = seg[seglen - 2];
                attrs.y = seg[seglen - 1];
                attrs.bx = toFloat(seg[seglen - 4]) || attrs.x;
                attrs.by = toFloat(seg[seglen - 3]) || attrs.y;
                attrs2.bx = p2 && (toFloat(seg2[seg2len - 4]) || attrs2.x);
                attrs2.by = p2 && (toFloat(seg2[seg2len - 3]) || attrs2.y);
                attrs2.x = p2 && seg2[seg2len - 2];
                attrs2.y = p2 && seg2[seg2len - 1];
            }
            if (!p2) {
                pth.curve = pathClone(p);
            }
            return p2 ? [p, p2] : p;
        }, null, pathClone),
        parseDots = R._parseDots = cacher(function (gradient) {
            var dots = [];
            for (var i = 0, ii = gradient.length; i < ii; i++) {
                var dot = {},
                    par = gradient[i].match(/^([^:]*):?([\d\.]*)/);
                dot.color = R.getRGB(par[1]);
                if (dot.color.error) {
                    return null;
                }
                dot.opacity = dot.color.opacity;
                dot.color = dot.color.hex;
                par[2] && (dot.offset = par[2] + "%");
                dots.push(dot);
            }
            for (i = 1, ii = dots.length - 1; i < ii; i++) {
                if (!dots[i].offset) {
                    var start = toFloat(dots[i - 1].offset || 0),
                        end = 0;
                    for (var j = i + 1; j < ii; j++) {
                        if (dots[j].offset) {
                            end = dots[j].offset;
                            break;
                        }
                    }
                    if (!end) {
                        end = 100;
                        j = ii;
                    }
                    end = toFloat(end);
                    var d = (end - start) / (j - i + 1);
                    for (; i < j; i++) {
                        start += d;
                        dots[i].offset = start + "%";
                    }
                }
            }
            return dots;
        }),
        tear = R._tear = function (el, paper) {
            el == paper.top && (paper.top = el.prev);
            el == paper.bottom && (paper.bottom = el.next);
            el.next && (el.next.prev = el.prev);
            el.prev && (el.prev.next = el.next);
        },
        tofront = R._tofront = function (el, paper) {
            if (paper.top === el) {
                return;
            }
            tear(el, paper);
            el.next = null;
            el.prev = paper.top;
            paper.top.next = el;
            paper.top = el;
        },
        toback = R._toback = function (el, paper) {
            if (paper.bottom === el) {
                return;
            }
            tear(el, paper);
            el.next = paper.bottom;
            el.prev = null;
            paper.bottom.prev = el;
            paper.bottom = el;
        },
        insertafter = R._insertafter = function (el, el2, paper) {
            tear(el, paper);
            el2 == paper.top && (paper.top = el);
            el2.next && (el2.next.prev = el);
            el.next = el2.next;
            el.prev = el2;
            el2.next = el;
        },
        insertbefore = R._insertbefore = function (el, el2, paper) {
            tear(el, paper);
            el2 == paper.bottom && (paper.bottom = el);
            el2.prev && (el2.prev.next = el);
            el.prev = el2.prev;
            el2.prev = el;
            el.next = el2;
        },
        /*\
         * Raphael.toMatrix
         [ method ]
         **
         * Utility method
         **
         * Returns matrix of transformations applied to a given path
         > Parameters
         - path (string) path string
         - transform (string|array) transformation string
         = (object) @Matrix
        \*/
        toMatrix = R.toMatrix = function (path, transform) {
            var bb = pathDimensions(path),
                el = {
                    _: {
                        transform: E
                    },
                    getBBox: function () {
                        return bb;
                    }
                };
            extractTransform(el, transform);
            return el.matrix;
        },
        /*\
         * Raphael.transformPath
         [ method ]
         **
         * Utility method
         **
         * Returns path transformed by a given transformation
         > Parameters
         - path (string) path string
         - transform (string|array) transformation string
         = (string) path
        \*/
        transformPath = R.transformPath = function (path, transform) {
            return mapPath(path, toMatrix(path, transform));
        },
        extractTransform = R._extractTransform = function (el, tstr) {
            if (tstr == null) {
                return el._.transform;
            }
            tstr = Str(tstr).replace(/\.{3}|\u2026/g, el._.transform || E);
            var tdata = R.parseTransformString(tstr),
                deg = 0,
                dx = 0,
                dy = 0,
                sx = 1,
                sy = 1,
                _ = el._,
                m = new Matrix;
            _.transform = tdata || [];
            if (tdata) {
                for (var i = 0, ii = tdata.length; i < ii; i++) {
                    var t = tdata[i],
                        tlen = t.length,
                        command = Str(t[0]).toLowerCase(),
                        absolute = t[0] != command,
                        inver = absolute ? m.invert() : 0,
                        x1,
                        y1,
                        x2,
                        y2,
                        bb;
                    if (command == "t" && tlen == 3) {
                        if (absolute) {
                            x1 = inver.x(0, 0);
                            y1 = inver.y(0, 0);
                            x2 = inver.x(t[1], t[2]);
                            y2 = inver.y(t[1], t[2]);
                            m.translate(x2 - x1, y2 - y1);
                        } else {
                            m.translate(t[1], t[2]);
                        }
                    } else if (command == "r") {
                        if (tlen == 2) {
                            bb = bb || el.getBBox(1);
                            m.rotate(t[1], bb.x + bb.width / 2, bb.y + bb.height / 2);
                            deg += t[1];
                        } else if (tlen == 4) {
                            if (absolute) {
                                x2 = inver.x(t[2], t[3]);
                                y2 = inver.y(t[2], t[3]);
                                m.rotate(t[1], x2, y2);
                            } else {
                                m.rotate(t[1], t[2], t[3]);
                            }
                            deg += t[1];
                        }
                    } else if (command == "s") {
                        if (tlen == 2 || tlen == 3) {
                            bb = bb || el.getBBox(1);
                            m.scale(t[1], t[tlen - 1], bb.x + bb.width / 2, bb.y + bb.height / 2);
                            sx *= t[1];
                            sy *= t[tlen - 1];
                        } else if (tlen == 5) {
                            if (absolute) {
                                x2 = inver.x(t[3], t[4]);
                                y2 = inver.y(t[3], t[4]);
                                m.scale(t[1], t[2], x2, y2);
                            } else {
                                m.scale(t[1], t[2], t[3], t[4]);
                            }
                            sx *= t[1];
                            sy *= t[2];
                        }
                    } else if (command == "m" && tlen == 7) {
                        m.add(t[1], t[2], t[3], t[4], t[5], t[6]);
                    }
                    _.dirtyT = 1;
                    el.matrix = m;
                }
            }

            /*\
             * Element.matrix
             [ property (object) ]
             **
             * Keeps @Matrix object, which represents element transformation
            \*/
            el.matrix = m;

            _.sx = sx;
            _.sy = sy;
            _.deg = deg;
            _.dx = dx = m.e;
            _.dy = dy = m.f;

            if (sx == 1 && sy == 1 && !deg && _.bbox) {
                _.bbox.x += +dx;
                _.bbox.y += +dy;
            } else {
                _.dirtyT = 1;
            }
        },
        getEmpty = function (item) {
            var l = item[0];
            switch (l.toLowerCase()) {
                case "t": return [l, 0, 0];
                case "m": return [l, 1, 0, 0, 1, 0, 0];
                case "r": if (item.length == 4) {
                    return [l, 0, item[2], item[3]];
                } else {
                    return [l, 0];
                }
                case "s": if (item.length == 5) {
                    return [l, 1, 1, item[3], item[4]];
                } else if (item.length == 3) {
                    return [l, 1, 1];
                } else {
                    return [l, 1];
                }
            }
        },
        equaliseTransform = R._equaliseTransform = function (t1, t2) {
            t2 = Str(t2).replace(/\.{3}|\u2026/g, t1);
            t1 = R.parseTransformString(t1) || [];
            t2 = R.parseTransformString(t2) || [];
            var maxlength = mmax(t1.length, t2.length),
                from = [],
                to = [],
                i = 0, j, jj,
                tt1, tt2;
            for (; i < maxlength; i++) {
                tt1 = t1[i] || getEmpty(t2[i]);
                tt2 = t2[i] || getEmpty(tt1);
                if ((tt1[0] != tt2[0]) ||
                    (tt1[0].toLowerCase() == "r" && (tt1[2] != tt2[2] || tt1[3] != tt2[3])) ||
                    (tt1[0].toLowerCase() == "s" && (tt1[3] != tt2[3] || tt1[4] != tt2[4]))
                    ) {
                    return;
                }
                from[i] = [];
                to[i] = [];
                for (j = 0, jj = mmax(tt1.length, tt2.length); j < jj; j++) {
                    j in tt1 && (from[i][j] = tt1[j]);
                    j in tt2 && (to[i][j] = tt2[j]);
                }
            }
            return {
                from: from,
                to: to
            };
        };
    R._getContainer = function (x, y, w, h) {
        var container;
        container = h == null && !R.is(x, "object") ? g.doc.getElementById(x) : x;
        if (container == null) {
            return;
        }
        if (container.tagName) {
            if (y == null) {
                return {
                    container: container,
                    width: container.style.pixelWidth || container.offsetWidth,
                    height: container.style.pixelHeight || container.offsetHeight
                };
            } else {
                return {
                    container: container,
                    width: y,
                    height: w
                };
            }
        }
        return {
            container: 1,
            x: x,
            y: y,
            width: w,
            height: h
        };
    };
    /*\
     * Raphael.pathToRelative
     [ method ]
     **
     * Utility method
     **
     * Converts path to relative form
     > Parameters
     - pathString (string|array) path string or array of segments
     = (array) array of segments.
    \*/
    R.pathToRelative = pathToRelative;
    R._engine = {};
    /*\
     * Raphael.path2curve
     [ method ]
     **
     * Utility method
     **
     * Converts path to a new path where all segments are cubic bezier curves.
     > Parameters
     - pathString (string|array) path string or array of segments
     = (array) array of segments.
    \*/
    R.path2curve = path2curve;
    /*\
     * Raphael.matrix
     [ method ]
     **
     * Utility method
     **
     * Returns matrix based on given parameters.
     > Parameters
     - a (number)
     - b (number)
     - c (number)
     - d (number)
     - e (number)
     - f (number)
     = (object) @Matrix
    \*/
    R.matrix = function (a, b, c, d, e, f) {
        return new Matrix(a, b, c, d, e, f);
    };
    function Matrix(a, b, c, d, e, f) {
        if (a != null) {
            this.a = +a;
            this.b = +b;
            this.c = +c;
            this.d = +d;
            this.e = +e;
            this.f = +f;
        } else {
            this.a = 1;
            this.b = 0;
            this.c = 0;
            this.d = 1;
            this.e = 0;
            this.f = 0;
        }
    }
    (function (matrixproto) {
        /*\
         * Matrix.add
         [ method ]
         **
         * Adds given matrix to existing one.
         > Parameters
         - a (number)
         - b (number)
         - c (number)
         - d (number)
         - e (number)
         - f (number)
         or
         - matrix (object) @Matrix
        \*/
        matrixproto.add = function (a, b, c, d, e, f) {
            var out = [[], [], []],
                m = [[this.a, this.c, this.e], [this.b, this.d, this.f], [0, 0, 1]],
                matrix = [[a, c, e], [b, d, f], [0, 0, 1]],
                x, y, z, res;

            if (a && a instanceof Matrix) {
                matrix = [[a.a, a.c, a.e], [a.b, a.d, a.f], [0, 0, 1]];
            }

            for (x = 0; x < 3; x++) {
                for (y = 0; y < 3; y++) {
                    res = 0;
                    for (z = 0; z < 3; z++) {
                        res += m[x][z] * matrix[z][y];
                    }
                    out[x][y] = res;
                }
            }
            this.a = out[0][0];
            this.b = out[1][0];
            this.c = out[0][1];
            this.d = out[1][1];
            this.e = out[0][2];
            this.f = out[1][2];
        };
        /*\
         * Matrix.invert
         [ method ]
         **
         * Returns inverted version of the matrix
         = (object) @Matrix
        \*/
        matrixproto.invert = function () {
            var me = this,
                x = me.a * me.d - me.b * me.c;
            return new Matrix(me.d / x, -me.b / x, -me.c / x, me.a / x, (me.c * me.f - me.d * me.e) / x, (me.b * me.e - me.a * me.f) / x);
        };
        /*\
         * Matrix.clone
         [ method ]
         **
         * Returns copy of the matrix
         = (object) @Matrix
        \*/
        matrixproto.clone = function () {
            return new Matrix(this.a, this.b, this.c, this.d, this.e, this.f);
        };
        /*\
         * Matrix.translate
         [ method ]
         **
         * Translate the matrix
         > Parameters
         - x (number)
         - y (number)
        \*/
        matrixproto.translate = function (x, y) {
            this.add(1, 0, 0, 1, x, y);
        };
        /*\
         * Matrix.scale
         [ method ]
         **
         * Scales the matrix
         > Parameters
         - x (number)
         - y (number) #optional
         - cx (number) #optional
         - cy (number) #optional
        \*/
        matrixproto.scale = function (x, y, cx, cy) {
            y == null && (y = x);
            (cx || cy) && this.add(1, 0, 0, 1, cx, cy);
            this.add(x, 0, 0, y, 0, 0);
            (cx || cy) && this.add(1, 0, 0, 1, -cx, -cy);
        };
        /*\
         * Matrix.rotate
         [ method ]
         **
         * Rotates the matrix
         > Parameters
         - a (number)
         - x (number)
         - y (number)
        \*/
        matrixproto.rotate = function (a, x, y) {
            a = R.rad(a);
            x = x || 0;
            y = y || 0;
            var cos = +math.cos(a).toFixed(9),
                sin = +math.sin(a).toFixed(9);
            this.add(cos, sin, -sin, cos, x, y);
            this.add(1, 0, 0, 1, -x, -y);
        };
        /*\
         * Matrix.x
         [ method ]
         **
         * Return x coordinate for given point after transformation described by the matrix. See also @Matrix.y
         > Parameters
         - x (number)
         - y (number)
         = (number) x
        \*/
        matrixproto.x = function (x, y) {
            return x * this.a + y * this.c + this.e;
        };
        /*\
         * Matrix.y
         [ method ]
         **
         * Return y coordinate for given point after transformation described by the matrix. See also @Matrix.x
         > Parameters
         - x (number)
         - y (number)
         = (number) y
        \*/
        matrixproto.y = function (x, y) {
            return x * this.b + y * this.d + this.f;
        };
        matrixproto.get = function (i) {
            return +this[Str.fromCharCode(97 + i)].toFixed(4);
        };
        matrixproto.toString = function () {
            return R.svg ?
                "matrix(" + [this.get(0), this.get(1), this.get(2), this.get(3), this.get(4), this.get(5)].join() + ")" :
                [this.get(0), this.get(2), this.get(1), this.get(3), 0, 0].join();
        };
        matrixproto.toFilter = function () {
            return "progid:DXImageTransform.Microsoft.Matrix(M11=" + this.get(0) +
                ", M12=" + this.get(2) + ", M21=" + this.get(1) + ", M22=" + this.get(3) +
                ", Dx=" + this.get(4) + ", Dy=" + this.get(5) + ", sizingmethod='auto expand')";
        };
        matrixproto.offset = function () {
            return [this.e.toFixed(4), this.f.toFixed(4)];
        };
        function norm(a) {
            return a[0] * a[0] + a[1] * a[1];
        }
        function normalize(a) {
            var mag = math.sqrt(norm(a));
            a[0] && (a[0] /= mag);
            a[1] && (a[1] /= mag);
        }
        /*\
         * Matrix.split
         [ method ]
         **
         * Splits matrix into primitive transformations
         = (object) in format:
         o dx (number) translation by x
         o dy (number) translation by y
         o scalex (number) scale by x
         o scaley (number) scale by y
         o shear (number) shear
         o rotate (number) rotation in deg
         o isSimple (boolean) could it be represented via simple transformations
        \*/
        matrixproto.split = function () {
            var out = {};
            // translation
            out.dx = this.e;
            out.dy = this.f;

            // scale and shear
            var row = [[this.a, this.c], [this.b, this.d]];
            out.scalex = math.sqrt(norm(row[0]));
            normalize(row[0]);

            out.shear = row[0][0] * row[1][0] + row[0][1] * row[1][1];
            row[1] = [row[1][0] - row[0][0] * out.shear, row[1][1] - row[0][1] * out.shear];

            out.scaley = math.sqrt(norm(row[1]));
            normalize(row[1]);
            out.shear /= out.scaley;

            // rotation
            var sin = -row[0][1],
                cos = row[1][1];
            if (cos < 0) {
                out.rotate = R.deg(math.acos(cos));
                if (sin < 0) {
                    out.rotate = 360 - out.rotate;
                }
            } else {
                out.rotate = R.deg(math.asin(sin));
            }

            out.isSimple = !+out.shear.toFixed(9) && (out.scalex.toFixed(9) == out.scaley.toFixed(9) || !out.rotate);
            out.isSuperSimple = !+out.shear.toFixed(9) && out.scalex.toFixed(9) == out.scaley.toFixed(9) && !out.rotate;
            out.noRotation = !+out.shear.toFixed(9) && !out.rotate;
            return out;
        };
        /*\
         * Matrix.toTransformString
         [ method ]
         **
         * Return transform string that represents given matrix
         = (string) transform string
        \*/
        matrixproto.toTransformString = function (shorter) {
            var s = shorter || this[split]();
            if (s.isSimple) {
                s.scalex = +s.scalex.toFixed(4);
                s.scaley = +s.scaley.toFixed(4);
                s.rotate = +s.rotate.toFixed(4);
                return  (s.dx || s.dy ? "t" + [s.dx, s.dy] : E) +
                        (s.scalex != 1 || s.scaley != 1 ? "s" + [s.scalex, s.scaley, 0, 0] : E) +
                        (s.rotate ? "r" + [s.rotate, 0, 0] : E);
            } else {
                return "m" + [this.get(0), this.get(1), this.get(2), this.get(3), this.get(4), this.get(5)];
            }
        };
    })(Matrix.prototype);

    var preventDefault = function () {
        this.returnValue = false;
    },
    preventTouch = function () {
        return this.originalEvent.preventDefault();
    },
    stopPropagation = function () {
        this.cancelBubble = true;
    },
    stopTouch = function () {
        return this.originalEvent.stopPropagation();
    },
    getEventPosition = function (e) {
        var scrollY = g.doc.documentElement.scrollTop || g.doc.body.scrollTop,
            scrollX = g.doc.documentElement.scrollLeft || g.doc.body.scrollLeft;

        return {
            x: e.clientX + scrollX,
            y: e.clientY + scrollY
        };
    },
    addEvent = (function () {
        if (g.doc.addEventListener) {
            return function (obj, type, fn, element) {
                var f = function (e) {
                    var pos = getEventPosition(e);
                    return fn.call(element, e, pos.x, pos.y);
                };
                obj.addEventListener(type, f, false);

                if (supportsTouch && touchMap[type]) {
                    var _f = function (e) {
                        var pos = getEventPosition(e),
                            olde = e;

                        for (var i = 0, ii = e.targetTouches && e.targetTouches.length; i < ii; i++) {
                            if (e.targetTouches[i].target == obj) {
                                e = e.targetTouches[i];
                                e.originalEvent = olde;
                                e.preventDefault = preventTouch;
                                e.stopPropagation = stopTouch;
                                break;
                            }
                        }

                        return fn.call(element, e, pos.x, pos.y);
                    };
                    obj.addEventListener(touchMap[type], _f, false);
                }

                return function () {
                    obj.removeEventListener(type, f, false);

                    if (supportsTouch && touchMap[type])
                        obj.removeEventListener(touchMap[type], _f, false);

                    return true;
                };
            };
        } else if (g.doc.attachEvent) {
            return function (obj, type, fn, element) {
                var f = function (e) {
                    e = e || g.win.event;
                    var scrollY = g.doc.documentElement.scrollTop || g.doc.body.scrollTop,
                        scrollX = g.doc.documentElement.scrollLeft || g.doc.body.scrollLeft,
                        x = e.clientX + scrollX,
                        y = e.clientY + scrollY;
                    e.preventDefault = e.preventDefault || preventDefault;
                    e.stopPropagation = e.stopPropagation || stopPropagation;
                    return fn.call(element, e, x, y);
                };
                obj.attachEvent("on" + type, f);
                var detacher = function () {
                    obj.detachEvent("on" + type, f);
                    return true;
                };
                return detacher;
            };
        }
    })(),
    drag = [],
    dragMove = function (e) {
        var x = e.clientX,
            y = e.clientY,
            scrollY = g.doc.documentElement.scrollTop || g.doc.body.scrollTop,
            scrollX = g.doc.documentElement.scrollLeft || g.doc.body.scrollLeft,
            dragi,
            j = drag.length;
        while (j--) {
            dragi = drag[j];
            if (supportsTouch && e.touches) {
                var i = e.touches.length,
                    touch;
                while (i--) {
                    touch = e.touches[i];
                    if (touch.identifier == dragi.el._drag.id) {
                        x = touch.clientX;
                        y = touch.clientY;
                        (e.originalEvent ? e.originalEvent : e).preventDefault();
                        break;
                    }
                }
            } else {
                e.preventDefault();
            }
            var node = dragi.el.node,
                o,
                next = node.nextSibling,
                parent = node.parentNode,
                display = node.style.display;
            g.win.opera && parent.removeChild(node);
            node.style.display = "none";
            o = dragi.el.paper.getElementByPoint(x, y);
            node.style.display = display;
            g.win.opera && (next ? parent.insertBefore(node, next) : parent.appendChild(node));
            o && eve("raphael.drag.over." + dragi.el.id, dragi.el, o);
            x += scrollX;
            y += scrollY;
            eve("raphael.drag.move." + dragi.el.id, dragi.move_scope || dragi.el, x - dragi.el._drag.x, y - dragi.el._drag.y, x, y, e);
        }
    },
    dragUp = function (e) {
        R.unmousemove(dragMove).unmouseup(dragUp);
        var i = drag.length,
            dragi;
        while (i--) {
            dragi = drag[i];
            dragi.el._drag = {};
            eve("raphael.drag.end." + dragi.el.id, dragi.end_scope || dragi.start_scope || dragi.move_scope || dragi.el, e);
        }
        drag = [];
    },
    /*\
     * Raphael.el
     [ property (object) ]
     **
     * You can add your own method to elements. This is useful when you want to hack default functionality or
     * want to wrap some common transformation or attributes in one method. In difference to canvas methods,
     * you can redefine element method at any time. Expending element methods wouldn’t affect set.
     > Usage
     | Raphael.el.red = function () {
     |     this.attr({fill: "#f00"});
     | };
     | // then use it
     | paper.circle(100, 100, 20).red();
    \*/
    elproto = R.el = {};
    /*\
     * Element.click
     [ method ]
     **
     * Adds event handler for click for the element.
     > Parameters
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.unclick
     [ method ]
     **
     * Removes event handler for click for the element.
     > Parameters
     - handler (function) #optional handler for the event
     = (object) @Element
    \*/

    /*\
     * Element.dblclick
     [ method ]
     **
     * Adds event handler for double click for the element.
     > Parameters
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.undblclick
     [ method ]
     **
     * Removes event handler for double click for the element.
     > Parameters
     - handler (function) #optional handler for the event
     = (object) @Element
    \*/

    /*\
     * Element.mousedown
     [ method ]
     **
     * Adds event handler for mousedown for the element.
     > Parameters
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.unmousedown
     [ method ]
     **
     * Removes event handler for mousedown for the element.
     > Parameters
     - handler (function) #optional handler for the event
     = (object) @Element
    \*/

    /*\
     * Element.mousemove
     [ method ]
     **
     * Adds event handler for mousemove for the element.
     > Parameters
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.unmousemove
     [ method ]
     **
     * Removes event handler for mousemove for the element.
     > Parameters
     - handler (function) #optional handler for the event
     = (object) @Element
    \*/

    /*\
     * Element.mouseout
     [ method ]
     **
     * Adds event handler for mouseout for the element.
     > Parameters
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.unmouseout
     [ method ]
     **
     * Removes event handler for mouseout for the element.
     > Parameters
     - handler (function) #optional handler for the event
     = (object) @Element
    \*/

    /*\
     * Element.mouseover
     [ method ]
     **
     * Adds event handler for mouseover for the element.
     > Parameters
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.unmouseover
     [ method ]
     **
     * Removes event handler for mouseover for the element.
     > Parameters
     - handler (function) #optional handler for the event
     = (object) @Element
    \*/

    /*\
     * Element.mouseup
     [ method ]
     **
     * Adds event handler for mouseup for the element.
     > Parameters
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.unmouseup
     [ method ]
     **
     * Removes event handler for mouseup for the element.
     > Parameters
     - handler (function) #optional handler for the event
     = (object) @Element
    \*/

    /*\
     * Element.touchstart
     [ method ]
     **
     * Adds event handler for touchstart for the element.
     > Parameters
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.untouchstart
     [ method ]
     **
     * Removes event handler for touchstart for the element.
     > Parameters
     - handler (function) #optional handler for the event
     = (object) @Element
    \*/

    /*\
     * Element.touchmove
     [ method ]
     **
     * Adds event handler for touchmove for the element.
     > Parameters
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.untouchmove
     [ method ]
     **
     * Removes event handler for touchmove for the element.
     > Parameters
     - handler (function) #optional handler for the event
     = (object) @Element
    \*/

    /*\
     * Element.touchend
     [ method ]
     **
     * Adds event handler for touchend for the element.
     > Parameters
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.untouchend
     [ method ]
     **
     * Removes event handler for touchend for the element.
     > Parameters
     - handler (function) #optional handler for the event
     = (object) @Element
    \*/

    /*\
     * Element.touchcancel
     [ method ]
     **
     * Adds event handler for touchcancel for the element.
     > Parameters
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.untouchcancel
     [ method ]
     **
     * Removes event handler for touchcancel for the element.
     > Parameters
     - handler (function) #optional handler for the event
     = (object) @Element
    \*/
    for (var i = events.length; i--;) {
        (function (eventName) {
            R[eventName] = elproto[eventName] = function (fn, scope) {
                if (R.is(fn, "function")) {
                    this.events = this.events || [];
                    this.events.push({name: eventName, f: fn, unbind: addEvent(this.shape || this.node || g.doc, eventName, fn, scope || this)});
                }
                return this;
            };
            R["un" + eventName] = elproto["un" + eventName] = function (fn) {
                var events = this.events || [],
                    l = events.length;
                while (l--){
                    if (events[l].name == eventName && (R.is(fn, "undefined") || events[l].f == fn)) {
                        events[l].unbind();
                        events.splice(l, 1);
                        !events.length && delete this.events;
                    }
                }
                return this;
            };
        })(events[i]);
    }

    /*\
     * Element.data
     [ method ]
     **
     * Adds or retrieves given value associated with given key.
     **
     * See also @Element.removeData
     > Parameters
     - key (string) key to store data
     - value (any) #optional value to store
     = (object) @Element
     * or, if value is not specified:
     = (any) value
     * or, if key and value are not specified:
     = (object) Key/value pairs for all the data associated with the element.
     > Usage
     | for (var i = 0, i < 5, i++) {
     |     paper.circle(10 + 15 * i, 10, 10)
     |          .attr({fill: "#000"})
     |          .data("i", i)
     |          .click(function () {
     |             alert(this.data("i"));
     |          });
     | }
    \*/
    elproto.data = function (key, value) {
        var data = eldata[this.id] = eldata[this.id] || {};
        if (arguments.length == 0) {
            return data;
        }
        if (arguments.length == 1) {
            if (R.is(key, "object")) {
                for (var i in key) if (key[has](i)) {
                    this.data(i, key[i]);
                }
                return this;
            }
            eve("raphael.data.get." + this.id, this, data[key], key);
            return data[key];
        }
        data[key] = value;
        eve("raphael.data.set." + this.id, this, value, key);
        return this;
    };
    /*\
     * Element.removeData
     [ method ]
     **
     * Removes value associated with an element by given key.
     * If key is not provided, removes all the data of the element.
     > Parameters
     - key (string) #optional key
     = (object) @Element
    \*/
    elproto.removeData = function (key) {
        if (key == null) {
            delete eldata[this.id];
        } else {
            eldata[this.id] && delete eldata[this.id][key];
        }
        return this;
    };
     /*\
     * Element.getData
     [ method ]
     **
     * Retrieves the element data
     = (object) data
    \*/
    elproto.getData = function () {
        return clone(eldata[this.id] || {});
    };
    /*\
     * Element.hover
     [ method ]
     **
     * Adds event handlers for hover for the element.
     > Parameters
     - f_in (function) handler for hover in
     - f_out (function) handler for hover out
     - icontext (object) #optional context for hover in handler
     - ocontext (object) #optional context for hover out handler
     = (object) @Element
    \*/
    elproto.hover = function (f_in, f_out, scope_in, scope_out) {
        return this.mouseover(f_in, scope_in).mouseout(f_out, scope_out || scope_in);
    };
    /*\
     * Element.unhover
     [ method ]
     **
     * Removes event handlers for hover for the element.
     > Parameters
     - f_in (function) handler for hover in
     - f_out (function) handler for hover out
     = (object) @Element
    \*/
    elproto.unhover = function (f_in, f_out) {
        return this.unmouseover(f_in).unmouseout(f_out);
    };
    var draggable = [];
    /*\
     * Element.drag
     [ method ]
     **
     * Adds event handlers for drag of the element.
     > Parameters
     - onmove (function) handler for moving
     - onstart (function) handler for drag start
     - onend (function) handler for drag end
     - mcontext (object) #optional context for moving handler
     - scontext (object) #optional context for drag start handler
     - econtext (object) #optional context for drag end handler
     * Additionally following `drag` events will be triggered: `drag.start.<id>` on start,
     * `drag.end.<id>` on end and `drag.move.<id>` on every move. When element will be dragged over another element
     * `drag.over.<id>` will be fired as well.
     *
     * Start event and start handler will be called in specified context or in context of the element with following parameters:
     o x (number) x position of the mouse
     o y (number) y position of the mouse
     o event (object) DOM event object
     * Move event and move handler will be called in specified context or in context of the element with following parameters:
     o dx (number) shift by x from the start point
     o dy (number) shift by y from the start point
     o x (number) x position of the mouse
     o y (number) y position of the mouse
     o event (object) DOM event object
     * End event and end handler will be called in specified context or in context of the element with following parameters:
     o event (object) DOM event object
     = (object) @Element
    \*/
    elproto.drag = function (onmove, onstart, onend, move_scope, start_scope, end_scope) {
        function start(e) {
            (e.originalEvent || e).preventDefault();
            var x = e.clientX,
                y = e.clientY,
                scrollY = g.doc.documentElement.scrollTop || g.doc.body.scrollTop,
                scrollX = g.doc.documentElement.scrollLeft || g.doc.body.scrollLeft;
            this._drag.id = e.identifier;
            if (supportsTouch && e.touches) {
                var i = e.touches.length, touch;
                while (i--) {
                    touch = e.touches[i];
                    this._drag.id = touch.identifier;
                    if (touch.identifier == this._drag.id) {
                        x = touch.clientX;
                        y = touch.clientY;
                        break;
                    }
                }
            }
            this._drag.x = x + scrollX;
            this._drag.y = y + scrollY;
            !drag.length && R.mousemove(dragMove).mouseup(dragUp);
            drag.push({el: this, move_scope: move_scope, start_scope: start_scope, end_scope: end_scope});
            onstart && eve.on("raphael.drag.start." + this.id, onstart);
            onmove && eve.on("raphael.drag.move." + this.id, onmove);
            onend && eve.on("raphael.drag.end." + this.id, onend);
            eve("raphael.drag.start." + this.id, start_scope || move_scope || this, this._drag.x, this._drag.y, e);
        }
        this._drag = {};
        draggable.push({el: this, start: start});
        this.mousedown(start);
        return this;
    };
    /*\
     * Element.onDragOver
     [ method ]
     **
     * Shortcut for assigning event handler for `drag.over.<id>` event, where id is id of the element (see @Element.id).
     > Parameters
     - f (function) handler for event, first argument would be the element you are dragging over
    \*/
    elproto.onDragOver = function (f) {
        f ? eve.on("raphael.drag.over." + this.id, f) : eve.unbind("raphael.drag.over." + this.id);
    };
    /*\
     * Element.undrag
     [ method ]
     **
     * Removes all drag event handlers from given element.
    \*/
    elproto.undrag = function () {
        var i = draggable.length;
        while (i--) if (draggable[i].el == this) {
            this.unmousedown(draggable[i].start);
            draggable.splice(i, 1);
            eve.unbind("raphael.drag.*." + this.id);
        }
        !draggable.length && R.unmousemove(dragMove).unmouseup(dragUp);
        drag = [];
    };
    /*\
     * Paper.circle
     [ method ]
     **
     * Draws a circle.
     **
     > Parameters
     **
     - x (number) x coordinate of the centre
     - y (number) y coordinate of the centre
     - r (number) radius
     = (object) Raphaël element object with type “circle”
     **
     > Usage
     | var c = paper.circle(50, 50, 40);
    \*/
    paperproto.circle = function (x, y, r) {
        var out = R._engine.circle(this, x || 0, y || 0, r || 0);
        this.__set__ && this.__set__.push(out);
        return out;
    };
    /*\
     * Paper.rect
     [ method ]
     *
     * Draws a rectangle.
     **
     > Parameters
     **
     - x (number) x coordinate of the top left corner
     - y (number) y coordinate of the top left corner
     - width (number) width
     - height (number) height
     - r (number) #optional radius for rounded corners, default is 0
     = (object) Raphaël element object with type “rect”
     **
     > Usage
     | // regular rectangle
     | var c = paper.rect(10, 10, 50, 50);
     | // rectangle with rounded corners
     | var c = paper.rect(40, 40, 50, 50, 10);
    \*/
    paperproto.rect = function (x, y, w, h, r) {
        var out = R._engine.rect(this, x || 0, y || 0, w || 0, h || 0, r || 0);
        this.__set__ && this.__set__.push(out);
        return out;
    };
    /*\
     * Paper.ellipse
     [ method ]
     **
     * Draws an ellipse.
     **
     > Parameters
     **
     - x (number) x coordinate of the centre
     - y (number) y coordinate of the centre
     - rx (number) horizontal radius
     - ry (number) vertical radius
     = (object) Raphaël element object with type “ellipse”
     **
     > Usage
     | var c = paper.ellipse(50, 50, 40, 20);
    \*/
    paperproto.ellipse = function (x, y, rx, ry) {
        var out = R._engine.ellipse(this, x || 0, y || 0, rx || 0, ry || 0);
        this.__set__ && this.__set__.push(out);
        return out;
    };
    /*\
     * Paper.path
     [ method ]
     **
     * Creates a path element by given path data string.
     > Parameters
     - pathString (string) #optional path string in SVG format.
     * Path string consists of one-letter commands, followed by comma seprarated arguments in numercal form. Example:
     | "M10,20L30,40"
     * Here we can see two commands: “M”, with arguments `(10, 20)` and “L” with arguments `(30, 40)`. Upper case letter mean command is absolute, lower case—relative.
     *
     # <p>Here is short list of commands available, for more details see <a href="http://www.w3.org/TR/SVG/paths.html#PathData" title="Details of a path's data attribute's format are described in the SVG specification.">SVG path string format</a>.</p>
     # <table><thead><tr><th>Command</th><th>Name</th><th>Parameters</th></tr></thead><tbody>
     # <tr><td>M</td><td>moveto</td><td>(x y)+</td></tr>
     # <tr><td>Z</td><td>closepath</td><td>(none)</td></tr>
     # <tr><td>L</td><td>lineto</td><td>(x y)+</td></tr>
     # <tr><td>H</td><td>horizontal lineto</td><td>x+</td></tr>
     # <tr><td>V</td><td>vertical lineto</td><td>y+</td></tr>
     # <tr><td>C</td><td>curveto</td><td>(x1 y1 x2 y2 x y)+</td></tr>
     # <tr><td>S</td><td>smooth curveto</td><td>(x2 y2 x y)+</td></tr>
     # <tr><td>Q</td><td>quadratic Bézier curveto</td><td>(x1 y1 x y)+</td></tr>
     # <tr><td>T</td><td>smooth quadratic Bézier curveto</td><td>(x y)+</td></tr>
     # <tr><td>A</td><td>elliptical arc</td><td>(rx ry x-axis-rotation large-arc-flag sweep-flag x y)+</td></tr>
     # <tr><td>R</td><td><a href="http://en.wikipedia.org/wiki/Catmull–Rom_spline#Catmull.E2.80.93Rom_spline">Catmull-Rom curveto</a>*</td><td>x1 y1 (x y)+</td></tr></tbody></table>
     * * “Catmull-Rom curveto” is a not standard SVG command and added in 2.0 to make life easier.
     * Note: there is a special case when path consist of just three commands: “M10,10R…z”. In this case path will smoothly connects to its beginning.
     > Usage
     | var c = paper.path("M10 10L90 90");
     | // draw a diagonal line:
     | // move to 10,10, line to 90,90
     * For example of path strings, check out these icons: http://raphaeljs.com/icons/
    \*/
    paperproto.path = function (pathString) {
        pathString && !R.is(pathString, string) && !R.is(pathString[0], array) && (pathString += E);
        var out = R._engine.path(R.format[apply](R, arguments), this);
        this.__set__ && this.__set__.push(out);
        return out;
    };
    /*\
     * Paper.image
     [ method ]
     **
     * Embeds an image into the surface.
     **
     > Parameters
     **
     - src (string) URI of the source image
     - x (number) x coordinate position
     - y (number) y coordinate position
     - width (number) width of the image
     - height (number) height of the image
     = (object) Raphaël element object with type “image”
     **
     > Usage
     | var c = paper.image("apple.png", 10, 10, 80, 80);
    \*/
    paperproto.image = function (src, x, y, w, h) {
        var out = R._engine.image(this, src || "about:blank", x || 0, y || 0, w || 0, h || 0);
        this.__set__ && this.__set__.push(out);
        return out;
    };
    /*\
     * Paper.text
     [ method ]
     **
     * Draws a text string. If you need line breaks, put “\n” in the string.
     **
     > Parameters
     **
     - x (number) x coordinate position
     - y (number) y coordinate position
     - text (string) The text string to draw
     = (object) Raphaël element object with type “text”
     **
     > Usage
     | var t = paper.text(50, 50, "Raphaël\nkicks\nbutt!");
    \*/
    paperproto.text = function (x, y, text) {
        var out = R._engine.text(this, x || 0, y || 0, Str(text));
        this.__set__ && this.__set__.push(out);
        return out;
    };
    /*\
     * Paper.set
     [ method ]
     **
     * Creates array-like object to keep and operate several elements at once.
     * Warning: it doesn’t create any elements for itself in the page, it just groups existing elements.
     * Sets act as pseudo elements — all methods available to an element can be used on a set.
     = (object) array-like object that represents set of elements
     **
     > Usage
     | var st = paper.set();
     | st.push(
     |     paper.circle(10, 10, 5),
     |     paper.circle(30, 10, 5)
     | );
     | st.attr({fill: "red"}); // changes the fill of both circles
    \*/
    paperproto.set = function (itemsArray) {
        !R.is(itemsArray, "array") && (itemsArray = Array.prototype.splice.call(arguments, 0, arguments.length));
        var out = new Set(itemsArray);
        this.__set__ && this.__set__.push(out);
        out["paper"] = this;
        out["type"] = "set";
        return out;
    };
    /*\
     * Paper.setStart
     [ method ]
     **
     * Creates @Paper.set. All elements that will be created after calling this method and before calling
     * @Paper.setFinish will be added to the set.
     **
     > Usage
     | paper.setStart();
     | paper.circle(10, 10, 5),
     | paper.circle(30, 10, 5)
     | var st = paper.setFinish();
     | st.attr({fill: "red"}); // changes the fill of both circles
    \*/
    paperproto.setStart = function (set) {
        this.__set__ = set || this.set();
    };
    /*\
     * Paper.setFinish
     [ method ]
     **
     * See @Paper.setStart. This method finishes catching and returns resulting set.
     **
     = (object) set
    \*/
    paperproto.setFinish = function (set) {
        var out = this.__set__;
        delete this.__set__;
        return out;
    };
    /*\
     * Paper.getSize
     [ method ]
     **
     * Obtains current paper actual size.
     **
     = (object)
     \*/
    paperproto.getSize = function () {
        var container = this.canvas.parentNode;
        return {
            width: container.offsetWidth,
            height: container.offsetHeight
                };
        };
    /*\
     * Paper.setSize
     [ method ]
     **
     * If you need to change dimensions of the canvas call this method
     **
     > Parameters
     **
     - width (number) new width of the canvas
     - height (number) new height of the canvas
    \*/
    paperproto.setSize = function (width, height) {
        return R._engine.setSize.call(this, width, height);
    };
    /*\
     * Paper.setViewBox
     [ method ]
     **
     * Sets the view box of the paper. Practically it gives you ability to zoom and pan whole paper surface by
     * specifying new boundaries.
     **
     > Parameters
     **
     - x (number) new x position, default is `0`
     - y (number) new y position, default is `0`
     - w (number) new width of the canvas
     - h (number) new height of the canvas
     - fit (boolean) `true` if you want graphics to fit into new boundary box
    \*/
    paperproto.setViewBox = function (x, y, w, h, fit) {
        return R._engine.setViewBox.call(this, x, y, w, h, fit);
    };
    /*\
     * Paper.top
     [ property ]
     **
     * Points to the topmost element on the paper
    \*/
    /*\
     * Paper.bottom
     [ property ]
     **
     * Points to the bottom element on the paper
    \*/
    paperproto.top = paperproto.bottom = null;
    /*\
     * Paper.raphael
     [ property ]
     **
     * Points to the @Raphael object/function
    \*/
    paperproto.raphael = R;
    var getOffset = function (elem) {
        var box = elem.getBoundingClientRect(),
            doc = elem.ownerDocument,
            body = doc.body,
            docElem = doc.documentElement,
            clientTop = docElem.clientTop || body.clientTop || 0, clientLeft = docElem.clientLeft || body.clientLeft || 0,
            top  = box.top  + (g.win.pageYOffset || docElem.scrollTop || body.scrollTop ) - clientTop,
            left = box.left + (g.win.pageXOffset || docElem.scrollLeft || body.scrollLeft) - clientLeft;
        return {
            y: top,
            x: left
        };
    };
    /*\
     * Paper.getElementByPoint
     [ method ]
     **
     * Returns you topmost element under given point.
     **
     = (object) Raphaël element object
     > Parameters
     **
     - x (number) x coordinate from the top left corner of the window
     - y (number) y coordinate from the top left corner of the window
     > Usage
     | paper.getElementByPoint(mouseX, mouseY).attr({stroke: "#f00"});
    \*/
    paperproto.getElementByPoint = function (x, y) {
        var paper = this,
            svg = paper.canvas,
            target = g.doc.elementFromPoint(x, y);
        if (g.win.opera && target.tagName == "svg") {
            var so = getOffset(svg),
                sr = svg.createSVGRect();
            sr.x = x - so.x;
            sr.y = y - so.y;
            sr.width = sr.height = 1;
            var hits = svg.getIntersectionList(sr, null);
            if (hits.length) {
                target = hits[hits.length - 1];
            }
        }
        if (!target) {
            return null;
        }
        while (target.parentNode && target != svg.parentNode && !target.raphael) {
            target = target.parentNode;
        }
        target == paper.canvas.parentNode && (target = svg);
        target = target && target.raphael ? paper.getById(target.raphaelid) : null;
        return target;
    };

    /*\
     * Paper.getElementsByBBox
     [ method ]
     **
     * Returns set of elements that have an intersecting bounding box
     **
     > Parameters
     **
     - bbox (object) bbox to check with
     = (object) @Set
     \*/
    paperproto.getElementsByBBox = function (bbox) {
        var set = this.set();
        this.forEach(function (el) {
            if (R.isBBoxIntersect(el.getBBox(), bbox)) {
                set.push(el);
            }
        });
        return set;
    };

    /*\
     * Paper.getById
     [ method ]
     **
     * Returns you element by its internal ID.
     **
     > Parameters
     **
     - id (number) id
     = (object) Raphaël element object
    \*/
    paperproto.getById = function (id) {
        var bot = this.bottom;
        while (bot) {
            if (bot.id == id) {
                return bot;
            }
            bot = bot.next;
        }
        return null;
    };
    /*\
     * Paper.forEach
     [ method ]
     **
     * Executes given function for each element on the paper
     *
     * If callback function returns `false` it will stop loop running.
     **
     > Parameters
     **
     - callback (function) function to run
     - thisArg (object) context object for the callback
     = (object) Paper object
     > Usage
     | paper.forEach(function (el) {
     |     el.attr({ stroke: "blue" });
     | });
    \*/
    paperproto.forEach = function (callback, thisArg) {
        var bot = this.bottom;
        while (bot) {
            if (callback.call(thisArg, bot) === false) {
                return this;
            }
            bot = bot.next;
        }
        return this;
    };
    /*\
     * Paper.getElementsByPoint
     [ method ]
     **
     * Returns set of elements that have common point inside
     **
     > Parameters
     **
     - x (number) x coordinate of the point
     - y (number) y coordinate of the point
     = (object) @Set
    \*/
    paperproto.getElementsByPoint = function (x, y) {
        var set = this.set();
        this.forEach(function (el) {
            if (el.isPointInside(x, y)) {
                set.push(el);
            }
        });
        return set;
    };
    function x_y() {
        return this.x + S + this.y;
    }
    function x_y_w_h() {
        return this.x + S + this.y + S + this.width + " \xd7 " + this.height;
    }
    /*\
     * Element.isPointInside
     [ method ]
     **
     * Determine if given point is inside this element’s shape
     **
     > Parameters
     **
     - x (number) x coordinate of the point
     - y (number) y coordinate of the point
     = (boolean) `true` if point inside the shape
    \*/
    elproto.isPointInside = function (x, y) {
        var rp = this.realPath = getPath[this.type](this);
        if (this.attr('transform') && this.attr('transform').length) {
            rp = R.transformPath(rp, this.attr('transform'));
        }
        return R.isPointInsidePath(rp, x, y);
    };
    /*\
     * Element.getBBox
     [ method ]
     **
     * Return bounding box for a given element
     **
     > Parameters
     **
     - isWithoutTransform (boolean) flag, `true` if you want to have bounding box before transformations. Default is `false`.
     = (object) Bounding box object:
     o {
     o     x: (number) top left corner x
     o     y: (number) top left corner y
     o     x2: (number) bottom right corner x
     o     y2: (number) bottom right corner y
     o     width: (number) width
     o     height: (number) height
     o }
    \*/
    elproto.getBBox = function (isWithoutTransform) {
        if (this.removed) {
            return {};
        }
        var _ = this._;
        if (isWithoutTransform) {
            if (_.dirty || !_.bboxwt) {
                this.realPath = getPath[this.type](this);
                _.bboxwt = pathDimensions(this.realPath);
                _.bboxwt.toString = x_y_w_h;
                _.dirty = 0;
            }
            return _.bboxwt;
        }
        if (_.dirty || _.dirtyT || !_.bbox) {
            if (_.dirty || !this.realPath) {
                _.bboxwt = 0;
                this.realPath = getPath[this.type](this);
            }
            _.bbox = pathDimensions(mapPath(this.realPath, this.matrix));
            _.bbox.toString = x_y_w_h;
            _.dirty = _.dirtyT = 0;
        }
        return _.bbox;
    };
    /*\
     * Element.clone
     [ method ]
     **
     = (object) clone of a given element
     **
    \*/
    elproto.clone = function () {
        if (this.removed) {
            return null;
        }
        var out = this.paper[this.type]().attr(this.attr());
        this.__set__ && this.__set__.push(out);
        return out;
    };
    /*\
     * Element.glow
     [ method ]
     **
     * Return set of elements that create glow-like effect around given element. See @Paper.set.
     *
     * Note: Glow is not connected to the element. If you change element attributes it won’t adjust itself.
     **
     > Parameters
     **
     - glow (object) #optional parameters object with all properties optional:
     o {
     o     width (number) size of the glow, default is `10`
     o     fill (boolean) will it be filled, default is `false`
     o     opacity (number) opacity, default is `0.5`
     o     offsetx (number) horizontal offset, default is `0`
     o     offsety (number) vertical offset, default is `0`
     o     color (string) glow colour, default is `black`
     o }
     = (object) @Paper.set of elements that represents glow
    \*/
    elproto.glow = function (glow) {
        if (this.type == "text") {
            return null;
        }
        glow = glow || {};
        var s = {
            width: (glow.width || 10) + (+this.attr("stroke-width") || 1),
            fill: glow.fill || false,
            opacity: glow.opacity == null ? .5 : glow.opacity,
            offsetx: glow.offsetx || 0,
            offsety: glow.offsety || 0,
            color: glow.color || "#000"
        },
            c = s.width / 2,
            r = this.paper,
            out = r.set(),
            path = this.realPath || getPath[this.type](this);
        path = this.matrix ? mapPath(path, this.matrix) : path;
        for (var i = 1; i < c + 1; i++) {
            out.push(r.path(path).attr({
                stroke: s.color,
                fill: s.fill ? s.color : "none",
                "stroke-linejoin": "round",
                "stroke-linecap": "round",
                "stroke-width": +(s.width / c * i).toFixed(3),
                opacity: +(s.opacity / c).toFixed(3)
            }));
        }
        return out.insertBefore(this).translate(s.offsetx, s.offsety);
    };
    var curveslengths = {},
    getPointAtSegmentLength = function (p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, length) {
        if (length == null) {
            return bezlen(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y);
        } else {
            return R.findDotsAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, getTatLen(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, length));
        }
    },
    getLengthFactory = function (istotal, subpath) {
        return function (path, length, onlystart) {
            path = path2curve(path);
            var x, y, p, l, sp = "", subpaths = {}, point,
                len = 0;
            for (var i = 0, ii = path.length; i < ii; i++) {
                p = path[i];
                if (p[0] == "M") {
                    x = +p[1];
                    y = +p[2];
                } else {
                    l = getPointAtSegmentLength(x, y, p[1], p[2], p[3], p[4], p[5], p[6]);
                    if (len + l > length) {
                        if (subpath && !subpaths.start) {
                            point = getPointAtSegmentLength(x, y, p[1], p[2], p[3], p[4], p[5], p[6], length - len);
                            sp += ["C" + point.start.x, point.start.y, point.m.x, point.m.y, point.x, point.y];
                            if (onlystart) {return sp;}
                            subpaths.start = sp;
                            sp = ["M" + point.x, point.y + "C" + point.n.x, point.n.y, point.end.x, point.end.y, p[5], p[6]].join();
                            len += l;
                            x = +p[5];
                            y = +p[6];
                            continue;
                        }
                        if (!istotal && !subpath) {
                            point = getPointAtSegmentLength(x, y, p[1], p[2], p[3], p[4], p[5], p[6], length - len);
                            return {x: point.x, y: point.y, alpha: point.alpha};
                        }
                    }
                    len += l;
                    x = +p[5];
                    y = +p[6];
                }
                sp += p.shift() + p;
            }
            subpaths.end = sp;
            point = istotal ? len : subpath ? subpaths : R.findDotsAtSegment(x, y, p[0], p[1], p[2], p[3], p[4], p[5], 1);
            point.alpha && (point = {x: point.x, y: point.y, alpha: point.alpha});
            return point;
        };
    };
    var getTotalLength = getLengthFactory(1),
        getPointAtLength = getLengthFactory(),
        getSubpathsAtLength = getLengthFactory(0, 1);
    /*\
     * Raphael.getTotalLength
     [ method ]
     **
     * Returns length of the given path in pixels.
     **
     > Parameters
     **
     - path (string) SVG path string.
     **
     = (number) length.
    \*/
    R.getTotalLength = getTotalLength;
    /*\
     * Raphael.getPointAtLength
     [ method ]
     **
     * Return coordinates of the point located at the given length on the given path.
     **
     > Parameters
     **
     - path (string) SVG path string
     - length (number)
     **
     = (object) representation of the point:
     o {
     o     x: (number) x coordinate
     o     y: (number) y coordinate
     o     alpha: (number) angle of derivative
     o }
    \*/
    R.getPointAtLength = getPointAtLength;
    /*\
     * Raphael.getSubpath
     [ method ]
     **
     * Return subpath of a given path from given length to given length.
     **
     > Parameters
     **
     - path (string) SVG path string
     - from (number) position of the start of the segment
     - to (number) position of the end of the segment
     **
     = (string) pathstring for the segment
    \*/
    R.getSubpath = function (path, from, to) {
        if (this.getTotalLength(path) - to < 1e-6) {
            return getSubpathsAtLength(path, from).end;
        }
        var a = getSubpathsAtLength(path, to, 1);
        return from ? getSubpathsAtLength(a, from).end : a;
    };
    /*\
     * Element.getTotalLength
     [ method ]
     **
     * Returns length of the path in pixels. Only works for element of “path” type.
     = (number) length.
    \*/
    elproto.getTotalLength = function () {
        var path = this.getPath();
        if (!path) {
            return;
        }

        if (this.node.getTotalLength) {
            return this.node.getTotalLength();
        }

        return getTotalLength(path);
    };
    /*\
     * Element.getPointAtLength
     [ method ]
     **
     * Return coordinates of the point located at the given length on the given path. Only works for element of “path” type.
     **
     > Parameters
     **
     - length (number)
     **
     = (object) representation of the point:
     o {
     o     x: (number) x coordinate
     o     y: (number) y coordinate
     o     alpha: (number) angle of derivative
     o }
    \*/
    elproto.getPointAtLength = function (length) {
        var path = this.getPath();
        if (!path) {
            return;
        }

        return getPointAtLength(path, length);
    };
    /*\
     * Element.getPath
     [ method ]
     **
     * Returns path of the element. Only works for elements of “path” type and simple elements like circle.
     = (object) path
     **
    \*/
    elproto.getPath = function () {
        var path,
            getPath = R._getPath[this.type];

        if (this.type == "text" || this.type == "set") {
            return;
        }

        if (getPath) {
            path = getPath(this);
        }

        return path;
    };
    /*\
     * Element.getSubpath
     [ method ]
     **
     * Return subpath of a given element from given length to given length. Only works for element of “path” type.
     **
     > Parameters
     **
     - from (number) position of the start of the segment
     - to (number) position of the end of the segment
     **
     = (string) pathstring for the segment
    \*/
    elproto.getSubpath = function (from, to) {
        var path = this.getPath();
        if (!path) {
            return;
        }

        return R.getSubpath(path, from, to);
    };
    /*\
     * Raphael.easing_formulas
     [ property ]
     **
     * Object that contains easing formulas for animation. You could extend it with your own. By default it has following list of easing:
     # <ul>
     #     <li>“linear”</li>
     #     <li>“&lt;” or “easeIn” or “ease-in”</li>
     #     <li>“>” or “easeOut” or “ease-out”</li>
     #     <li>“&lt;>” or “easeInOut” or “ease-in-out”</li>
     #     <li>“backIn” or “back-in”</li>
     #     <li>“backOut” or “back-out”</li>
     #     <li>“elastic”</li>
     #     <li>“bounce”</li>
     # </ul>
     # <p>See also <a href="http://raphaeljs.com/easing.html">Easing demo</a>.</p>
    \*/
    var ef = R.easing_formulas = {
        linear: function (n) {
            return n;
        },
        "<": function (n) {
            return pow(n, 1.7);
        },
        ">": function (n) {
            return pow(n, .48);
        },
        "<>": function (n) {
            var q = .48 - n / 1.04,
                Q = math.sqrt(.1734 + q * q),
                x = Q - q,
                X = pow(abs(x), 1 / 3) * (x < 0 ? -1 : 1),
                y = -Q - q,
                Y = pow(abs(y), 1 / 3) * (y < 0 ? -1 : 1),
                t = X + Y + .5;
            return (1 - t) * 3 * t * t + t * t * t;
        },
        backIn: function (n) {
            var s = 1.70158;
            return n * n * ((s + 1) * n - s);
        },
        backOut: function (n) {
            n = n - 1;
            var s = 1.70158;
            return n * n * ((s + 1) * n + s) + 1;
        },
        elastic: function (n) {
            if (n == !!n) {
                return n;
            }
            return pow(2, -10 * n) * math.sin((n - .075) * (2 * PI) / .3) + 1;
        },
        bounce: function (n) {
            var s = 7.5625,
                p = 2.75,
                l;
            if (n < (1 / p)) {
                l = s * n * n;
            } else {
                if (n < (2 / p)) {
                    n -= (1.5 / p);
                    l = s * n * n + .75;
                } else {
                    if (n < (2.5 / p)) {
                        n -= (2.25 / p);
                        l = s * n * n + .9375;
                    } else {
                        n -= (2.625 / p);
                        l = s * n * n + .984375;
                    }
                }
            }
            return l;
        }
    };
    ef.easeIn = ef["ease-in"] = ef["<"];
    ef.easeOut = ef["ease-out"] = ef[">"];
    ef.easeInOut = ef["ease-in-out"] = ef["<>"];
    ef["back-in"] = ef.backIn;
    ef["back-out"] = ef.backOut;

    var animationElements = [],
        requestAnimFrame = window.requestAnimationFrame       ||
                           window.webkitRequestAnimationFrame ||
                           window.mozRequestAnimationFrame    ||
                           window.oRequestAnimationFrame      ||
                           window.msRequestAnimationFrame     ||
                           function (callback) {
                               setTimeout(callback, 16);
                           },
        animation = function () {
            var Now = +new Date,
                l = 0;
            for (; l < animationElements.length; l++) {
                var e = animationElements[l];
                if (e.el.removed || e.paused) {
                    continue;
                }
                var time = Now - e.start,
                    ms = e.ms,
                    easing = e.easing,
                    from = e.from,
                    diff = e.diff,
                    to = e.to,
                    t = e.t,
                    that = e.el,
                    set = {},
                    now,
                    init = {},
                    key;
                if (e.initstatus) {
                    time = (e.initstatus * e.anim.top - e.prev) / (e.percent - e.prev) * ms;
                    e.status = e.initstatus;
                    delete e.initstatus;
                    e.stop && animationElements.splice(l--, 1);
                } else {
                    e.status = (e.prev + (e.percent - e.prev) * (time / ms)) / e.anim.top;
                }
                if (time < 0) {
                    continue;
                }
                if (time < ms) {
                    var pos = easing(time / ms);
                    for (var attr in from) if (from[has](attr)) {
                        switch (availableAnimAttrs[attr]) {
                            case nu:
                                now = +from[attr] + pos * ms * diff[attr];
                                break;
                            case "colour":
                                now = "rgb(" + [
                                    upto255(round(from[attr].r + pos * ms * diff[attr].r)),
                                    upto255(round(from[attr].g + pos * ms * diff[attr].g)),
                                    upto255(round(from[attr].b + pos * ms * diff[attr].b))
                                ].join(",") + ")";
                                break;
                            case "path":
                                now = [];
                                for (var i = 0, ii = from[attr].length; i < ii; i++) {
                                    now[i] = [from[attr][i][0]];
                                    for (var j = 1, jj = from[attr][i].length; j < jj; j++) {
                                        now[i][j] = +from[attr][i][j] + pos * ms * diff[attr][i][j];
                                    }
                                    now[i] = now[i].join(S);
                                }
                                now = now.join(S);
                                break;
                            case "transform":
                                if (diff[attr].real) {
                                    now = [];
                                    for (i = 0, ii = from[attr].length; i < ii; i++) {
                                        now[i] = [from[attr][i][0]];
                                        for (j = 1, jj = from[attr][i].length; j < jj; j++) {
                                            now[i][j] = from[attr][i][j] + pos * ms * diff[attr][i][j];
                                        }
                                    }
                                } else {
                                    var get = function (i) {
                                        return +from[attr][i] + pos * ms * diff[attr][i];
                                    };
                                    // now = [["r", get(2), 0, 0], ["t", get(3), get(4)], ["s", get(0), get(1), 0, 0]];
                                    now = [["m", get(0), get(1), get(2), get(3), get(4), get(5)]];
                                }
                                break;
                            case "csv":
                                if (attr == "clip-rect") {
                                    now = [];
                                    i = 4;
                                    while (i--) {
                                        now[i] = +from[attr][i] + pos * ms * diff[attr][i];
                                    }
                                }
                                break;
                            default:
                                var from2 = [][concat](from[attr]);
                                now = [];
                                i = that.paper.customAttributes[attr].length;
                                while (i--) {
                                    now[i] = +from2[i] + pos * ms * diff[attr][i];
                                }
                                break;
                        }
                        set[attr] = now;
                    }
                    that.attr(set);
                    (function (id, that, anim) {
                        setTimeout(function () {
                            eve("raphael.anim.frame." + id, that, anim);
                        });
                    })(that.id, that, e.anim);
                } else {
                    (function(f, el, a) {
                        setTimeout(function() {
                            eve("raphael.anim.frame." + el.id, el, a);
                            eve("raphael.anim.finish." + el.id, el, a);
                            R.is(f, "function") && f.call(el);
                        });
                    })(e.callback, that, e.anim);
                    that.attr(to);
                    animationElements.splice(l--, 1);
                    if (e.repeat > 1 && !e.next) {
                        for (key in to) if (to[has](key)) {
                            init[key] = e.totalOrigin[key];
                        }
                        e.el.attr(init);
                        runAnimation(e.anim, e.el, e.anim.percents[0], null, e.totalOrigin, e.repeat - 1);
                    }
                    if (e.next && !e.stop) {
                        runAnimation(e.anim, e.el, e.next, null, e.totalOrigin, e.repeat);
                    }
                }
            }
            animationElements.length && requestAnimFrame(animation);
        },
        upto255 = function (color) {
            return color > 255 ? 255 : color < 0 ? 0 : color;
        };
    /*\
     * Element.animateWith
     [ method ]
     **
     * Acts similar to @Element.animate, but ensure that given animation runs in sync with another given element.
     **
     > Parameters
     **
     - el (object) element to sync with
     - anim (object) animation to sync with
     - params (object) #optional final attributes for the element, see also @Element.attr
     - ms (number) #optional number of milliseconds for animation to run
     - easing (string) #optional easing type. Accept on of @Raphael.easing_formulas or CSS format: `cubic&#x2010;bezier(XX,&#160;XX,&#160;XX,&#160;XX)`
     - callback (function) #optional callback function. Will be called at the end of animation.
     * or
     - element (object) element to sync with
     - anim (object) animation to sync with
     - animation (object) #optional animation object, see @Raphael.animation
     **
     = (object) original element
    \*/
    elproto.animateWith = function (el, anim, params, ms, easing, callback) {
        var element = this;
        if (element.removed) {
            callback && callback.call(element);
            return element;
        }
        var a = params instanceof Animation ? params : R.animation(params, ms, easing, callback),
            x, y;
        runAnimation(a, element, a.percents[0], null, element.attr());
        for (var i = 0, ii = animationElements.length; i < ii; i++) {
            if (animationElements[i].anim == anim && animationElements[i].el == el) {
                animationElements[ii - 1].start = animationElements[i].start;
                break;
            }
        }
        return element;
        //
        //
        // var a = params ? R.animation(params, ms, easing, callback) : anim,
        //     status = element.status(anim);
        // return this.animate(a).status(a, status * anim.ms / a.ms);
    };
    function CubicBezierAtTime(t, p1x, p1y, p2x, p2y, duration) {
        var cx = 3 * p1x,
            bx = 3 * (p2x - p1x) - cx,
            ax = 1 - cx - bx,
            cy = 3 * p1y,
            by = 3 * (p2y - p1y) - cy,
            ay = 1 - cy - by;
        function sampleCurveX(t) {
            return ((ax * t + bx) * t + cx) * t;
        }
        function solve(x, epsilon) {
            var t = solveCurveX(x, epsilon);
            return ((ay * t + by) * t + cy) * t;
        }
        function solveCurveX(x, epsilon) {
            var t0, t1, t2, x2, d2, i;
            for(t2 = x, i = 0; i < 8; i++) {
                x2 = sampleCurveX(t2) - x;
                if (abs(x2) < epsilon) {
                    return t2;
                }
                d2 = (3 * ax * t2 + 2 * bx) * t2 + cx;
                if (abs(d2) < 1e-6) {
                    break;
                }
                t2 = t2 - x2 / d2;
            }
            t0 = 0;
            t1 = 1;
            t2 = x;
            if (t2 < t0) {
                return t0;
            }
            if (t2 > t1) {
                return t1;
            }
            while (t0 < t1) {
                x2 = sampleCurveX(t2);
                if (abs(x2 - x) < epsilon) {
                    return t2;
                }
                if (x > x2) {
                    t0 = t2;
                } else {
                    t1 = t2;
                }
                t2 = (t1 - t0) / 2 + t0;
            }
            return t2;
        }
        return solve(t, 1 / (200 * duration));
    }
    elproto.onAnimation = function (f) {
        f ? eve.on("raphael.anim.frame." + this.id, f) : eve.unbind("raphael.anim.frame." + this.id);
        return this;
    };
    function Animation(anim, ms) {
        var percents = [],
            newAnim = {};
        this.ms = ms;
        this.times = 1;
        if (anim) {
            for (var attr in anim) if (anim[has](attr)) {
                newAnim[toFloat(attr)] = anim[attr];
                percents.push(toFloat(attr));
            }
            percents.sort(sortByNumber);
        }
        this.anim = newAnim;
        this.top = percents[percents.length - 1];
        this.percents = percents;
    }
    /*\
     * Animation.delay
     [ method ]
     **
     * Creates a copy of existing animation object with given delay.
     **
     > Parameters
     **
     - delay (number) number of ms to pass between animation start and actual animation
     **
     = (object) new altered Animation object
     | var anim = Raphael.animation({cx: 10, cy: 20}, 2e3);
     | circle1.animate(anim); // run the given animation immediately
     | circle2.animate(anim.delay(500)); // run the given animation after 500 ms
    \*/
    Animation.prototype.delay = function (delay) {
        var a = new Animation(this.anim, this.ms);
        a.times = this.times;
        a.del = +delay || 0;
        return a;
    };
    /*\
     * Animation.repeat
     [ method ]
     **
     * Creates a copy of existing animation object with given repetition.
     **
     > Parameters
     **
     - repeat (number) number iterations of animation. For infinite animation pass `Infinity`
     **
     = (object) new altered Animation object
    \*/
    Animation.prototype.repeat = function (times) {
        var a = new Animation(this.anim, this.ms);
        a.del = this.del;
        a.times = math.floor(mmax(times, 0)) || 1;
        return a;
    };
    function runAnimation(anim, element, percent, status, totalOrigin, times) {
        percent = toFloat(percent);
        var params,
            isInAnim,
            isInAnimSet,
            percents = [],
            next,
            prev,
            timestamp,
            ms = anim.ms,
            from = {},
            to = {},
            diff = {};
        if (status) {
            for (i = 0, ii = animationElements.length; i < ii; i++) {
                var e = animationElements[i];
                if (e.el.id == element.id && e.anim == anim) {
                    if (e.percent != percent) {
                        animationElements.splice(i, 1);
                        isInAnimSet = 1;
                    } else {
                        isInAnim = e;
                    }
                    element.attr(e.totalOrigin);
                    break;
                }
            }
        } else {
            status = +to; // NaN
        }
        for (var i = 0, ii = anim.percents.length; i < ii; i++) {
            if (anim.percents[i] == percent || anim.percents[i] > status * anim.top) {
                percent = anim.percents[i];
                prev = anim.percents[i - 1] || 0;
                ms = ms / anim.top * (percent - prev);
                next = anim.percents[i + 1];
                params = anim.anim[percent];
                break;
            } else if (status) {
                element.attr(anim.anim[anim.percents[i]]);
            }
        }
        if (!params) {
            return;
        }
        if (!isInAnim) {
            for (var attr in params) if (params[has](attr)) {
                if (availableAnimAttrs[has](attr) || element.paper.customAttributes[has](attr)) {
                    from[attr] = element.attr(attr);
                    (from[attr] == null) && (from[attr] = availableAttrs[attr]);
                    to[attr] = params[attr];
                    switch (availableAnimAttrs[attr]) {
                        case nu:
                            diff[attr] = (to[attr] - from[attr]) / ms;
                            break;
                        case "colour":
                            from[attr] = R.getRGB(from[attr]);
                            var toColour = R.getRGB(to[attr]);
                            diff[attr] = {
                                r: (toColour.r - from[attr].r) / ms,
                                g: (toColour.g - from[attr].g) / ms,
                                b: (toColour.b - from[attr].b) / ms
                            };
                            break;
                        case "path":
                            var pathes = path2curve(from[attr], to[attr]),
                                toPath = pathes[1];
                            from[attr] = pathes[0];
                            diff[attr] = [];
                            for (i = 0, ii = from[attr].length; i < ii; i++) {
                                diff[attr][i] = [0];
                                for (var j = 1, jj = from[attr][i].length; j < jj; j++) {
                                    diff[attr][i][j] = (toPath[i][j] - from[attr][i][j]) / ms;
                                }
                            }
                            break;
                        case "transform":
                            var _ = element._,
                                eq = equaliseTransform(_[attr], to[attr]);
                            if (eq) {
                                from[attr] = eq.from;
                                to[attr] = eq.to;
                                diff[attr] = [];
                                diff[attr].real = true;
                                for (i = 0, ii = from[attr].length; i < ii; i++) {
                                    diff[attr][i] = [from[attr][i][0]];
                                    for (j = 1, jj = from[attr][i].length; j < jj; j++) {
                                        diff[attr][i][j] = (to[attr][i][j] - from[attr][i][j]) / ms;
                                    }
                                }
                            } else {
                                var m = (element.matrix || new Matrix),
                                    to2 = {
                                        _: {transform: _.transform},
                                        getBBox: function () {
                                            return element.getBBox(1);
                                        }
                                    };
                                from[attr] = [
                                    m.a,
                                    m.b,
                                    m.c,
                                    m.d,
                                    m.e,
                                    m.f
                                ];
                                extractTransform(to2, to[attr]);
                                to[attr] = to2._.transform;
                                diff[attr] = [
                                    (to2.matrix.a - m.a) / ms,
                                    (to2.matrix.b - m.b) / ms,
                                    (to2.matrix.c - m.c) / ms,
                                    (to2.matrix.d - m.d) / ms,
                                    (to2.matrix.e - m.e) / ms,
                                    (to2.matrix.f - m.f) / ms
                                ];
                                // from[attr] = [_.sx, _.sy, _.deg, _.dx, _.dy];
                                // var to2 = {_:{}, getBBox: function () { return element.getBBox(); }};
                                // extractTransform(to2, to[attr]);
                                // diff[attr] = [
                                //     (to2._.sx - _.sx) / ms,
                                //     (to2._.sy - _.sy) / ms,
                                //     (to2._.deg - _.deg) / ms,
                                //     (to2._.dx - _.dx) / ms,
                                //     (to2._.dy - _.dy) / ms
                                // ];
                            }
                            break;
                        case "csv":
                            var values = Str(params[attr])[split](separator),
                                from2 = Str(from[attr])[split](separator);
                            if (attr == "clip-rect") {
                                from[attr] = from2;
                                diff[attr] = [];
                                i = from2.length;
                                while (i--) {
                                    diff[attr][i] = (values[i] - from[attr][i]) / ms;
                                }
                            }
                            to[attr] = values;
                            break;
                        default:
                            values = [][concat](params[attr]);
                            from2 = [][concat](from[attr]);
                            diff[attr] = [];
                            i = element.paper.customAttributes[attr].length;
                            while (i--) {
                                diff[attr][i] = ((values[i] || 0) - (from2[i] || 0)) / ms;
                            }
                            break;
                    }
                }
            }
            var easing = params.easing,
                easyeasy = R.easing_formulas[easing];
            if (!easyeasy) {
                easyeasy = Str(easing).match(bezierrg);
                if (easyeasy && easyeasy.length == 5) {
                    var curve = easyeasy;
                    easyeasy = function (t) {
                        return CubicBezierAtTime(t, +curve[1], +curve[2], +curve[3], +curve[4], ms);
                    };
                } else {
                    easyeasy = pipe;
                }
            }
            timestamp = params.start || anim.start || +new Date;
            e = {
                anim: anim,
                percent: percent,
                timestamp: timestamp,
                start: timestamp + (anim.del || 0),
                status: 0,
                initstatus: status || 0,
                stop: false,
                ms: ms,
                easing: easyeasy,
                from: from,
                diff: diff,
                to: to,
                el: element,
                callback: params.callback,
                prev: prev,
                next: next,
                repeat: times || anim.times,
                origin: element.attr(),
                totalOrigin: totalOrigin
            };
            animationElements.push(e);
            if (status && !isInAnim && !isInAnimSet) {
                e.stop = true;
                e.start = new Date - ms * status;
                if (animationElements.length == 1) {
                    return animation();
                }
            }
            if (isInAnimSet) {
                e.start = new Date - e.ms * status;
            }
            animationElements.length == 1 && requestAnimFrame(animation);
        } else {
            isInAnim.initstatus = status;
            isInAnim.start = new Date - isInAnim.ms * status;
        }
        eve("raphael.anim.start." + element.id, element, anim);
    }
    /*\
     * Raphael.animation
     [ method ]
     **
     * Creates an animation object that can be passed to the @Element.animate or @Element.animateWith methods.
     * See also @Animation.delay and @Animation.repeat methods.
     **
     > Parameters
     **
     - params (object) final attributes for the element, see also @Element.attr
     - ms (number) number of milliseconds for animation to run
     - easing (string) #optional easing type. Accept one of @Raphael.easing_formulas or CSS format: `cubic&#x2010;bezier(XX,&#160;XX,&#160;XX,&#160;XX)`
     - callback (function) #optional callback function. Will be called at the end of animation.
     **
     = (object) @Animation
    \*/
    R.animation = function (params, ms, easing, callback) {
        if (params instanceof Animation) {
            return params;
        }
        if (R.is(easing, "function") || !easing) {
            callback = callback || easing || null;
            easing = null;
        }
        params = Object(params);
        ms = +ms || 0;
        var p = {},
            json,
            attr;
        for (attr in params) if (params[has](attr) && toFloat(attr) != attr && toFloat(attr) + "%" != attr) {
            json = true;
            p[attr] = params[attr];
        }
        if (!json) {
            // if percent-like syntax is used and end-of-all animation callback used
            if(callback){
                // find the last one
                var lastKey = 0;
                for(var i in params){
                    var percent = toInt(i);
                    if(params[has](i) && percent > lastKey){
                        lastKey = percent;
                    }
                }
                lastKey += '%';
                // if already defined callback in the last keyframe, skip
                !params[lastKey].callback && (params[lastKey].callback = callback);
            }
          return new Animation(params, ms);
        } else {
            easing && (p.easing = easing);
            callback && (p.callback = callback);
            return new Animation({100: p}, ms);
        }
    };
    /*\
     * Element.animate
     [ method ]
     **
     * Creates and starts animation for given element.
     **
     > Parameters
     **
     - params (object) final attributes for the element, see also @Element.attr
     - ms (number) number of milliseconds for animation to run
     - easing (string) #optional easing type. Accept one of @Raphael.easing_formulas or CSS format: `cubic&#x2010;bezier(XX,&#160;XX,&#160;XX,&#160;XX)`
     - callback (function) #optional callback function. Will be called at the end of animation.
     * or
     - animation (object) animation object, see @Raphael.animation
     **
     = (object) original element
    \*/
    elproto.animate = function (params, ms, easing, callback) {
        var element = this;
        if (element.removed) {
            callback && callback.call(element);
            return element;
        }
        var anim = params instanceof Animation ? params : R.animation(params, ms, easing, callback);
        runAnimation(anim, element, anim.percents[0], null, element.attr());
        return element;
    };
    /*\
     * Element.setTime
     [ method ]
     **
     * Sets the status of animation of the element in milliseconds. Similar to @Element.status method.
     **
     > Parameters
     **
     - anim (object) animation object
     - value (number) number of milliseconds from the beginning of the animation
     **
     = (object) original element if `value` is specified
     * Note, that during animation following events are triggered:
     *
     * On each animation frame event `anim.frame.<id>`, on start `anim.start.<id>` and on end `anim.finish.<id>`.
    \*/
    elproto.setTime = function (anim, value) {
        if (anim && value != null) {
            this.status(anim, mmin(value, anim.ms) / anim.ms);
        }
        return this;
    };
    /*\
     * Element.status
     [ method ]
     **
     * Gets or sets the status of animation of the element.
     **
     > Parameters
     **
     - anim (object) #optional animation object
     - value (number) #optional 0 – 1. If specified, method works like a setter and sets the status of a given animation to the value. This will cause animation to jump to the given position.
     **
     = (number) status
     * or
     = (array) status if `anim` is not specified. Array of objects in format:
     o {
     o     anim: (object) animation object
     o     status: (number) status
     o }
     * or
     = (object) original element if `value` is specified
    \*/
    elproto.status = function (anim, value) {
        var out = [],
            i = 0,
            len,
            e;
        if (value != null) {
            runAnimation(anim, this, -1, mmin(value, 1));
            return this;
        } else {
            len = animationElements.length;
            for (; i < len; i++) {
                e = animationElements[i];
                if (e.el.id == this.id && (!anim || e.anim == anim)) {
                    if (anim) {
                        return e.status;
                    }
                    out.push({
                        anim: e.anim,
                        status: e.status
                    });
                }
            }
            if (anim) {
                return 0;
            }
            return out;
        }
    };
    /*\
     * Element.pause
     [ method ]
     **
     * Stops animation of the element with ability to resume it later on.
     **
     > Parameters
     **
     - anim (object) #optional animation object
     **
     = (object) original element
    \*/
    elproto.pause = function (anim) {
        for (var i = 0; i < animationElements.length; i++) if (animationElements[i].el.id == this.id && (!anim || animationElements[i].anim == anim)) {
            if (eve("raphael.anim.pause." + this.id, this, animationElements[i].anim) !== false) {
                animationElements[i].paused = true;
            }
        }
        return this;
    };
    /*\
     * Element.resume
     [ method ]
     **
     * Resumes animation if it was paused with @Element.pause method.
     **
     > Parameters
     **
     - anim (object) #optional animation object
     **
     = (object) original element
    \*/
    elproto.resume = function (anim) {
        for (var i = 0; i < animationElements.length; i++) if (animationElements[i].el.id == this.id && (!anim || animationElements[i].anim == anim)) {
            var e = animationElements[i];
            if (eve("raphael.anim.resume." + this.id, this, e.anim) !== false) {
                delete e.paused;
                this.status(e.anim, e.status);
            }
        }
        return this;
    };
    /*\
     * Element.stop
     [ method ]
     **
     * Stops animation of the element.
     **
     > Parameters
     **
     - anim (object) #optional animation object
     **
     = (object) original element
    \*/
    elproto.stop = function (anim) {
        for (var i = 0; i < animationElements.length; i++) if (animationElements[i].el.id == this.id && (!anim || animationElements[i].anim == anim)) {
            if (eve("raphael.anim.stop." + this.id, this, animationElements[i].anim) !== false) {
                animationElements.splice(i--, 1);
            }
        }
        return this;
    };
    function stopAnimation(paper) {
        for (var i = 0; i < animationElements.length; i++) if (animationElements[i].el.paper == paper) {
            animationElements.splice(i--, 1);
        }
    }
    eve.on("raphael.remove", stopAnimation);
    eve.on("raphael.clear", stopAnimation);
    elproto.toString = function () {
        return "Rapha\xebl\u2019s object";
    };

    // Set
    var Set = function (items) {
        this.items = [];
        this.length = 0;
        this.type = "set";
        if (items) {
            for (var i = 0, ii = items.length; i < ii; i++) {
                if (items[i] && (items[i].constructor == elproto.constructor || items[i].constructor == Set)) {
                    this[this.items.length] = this.items[this.items.length] = items[i];
                    this.length++;
                }
            }
        }
    },
    setproto = Set.prototype;
    /*\
     * Set.push
     [ method ]
     **
     * Adds each argument to the current set.
     = (object) original element
    \*/
    setproto.push = function () {
        var item,
            len;
        for (var i = 0, ii = arguments.length; i < ii; i++) {
            item = arguments[i];
            if (item && (item.constructor == elproto.constructor || item.constructor == Set)) {
                len = this.items.length;
                this[len] = this.items[len] = item;
                this.length++;
            }
        }
        return this;
    };
    /*\
     * Set.pop
     [ method ]
     **
     * Removes last element and returns it.
     = (object) element
    \*/
    setproto.pop = function () {
        this.length && delete this[this.length--];
        return this.items.pop();
    };
    /*\
     * Set.forEach
     [ method ]
     **
     * Executes given function for each element in the set.
     *
     * If function returns `false` it will stop loop running.
     **
     > Parameters
     **
     - callback (function) function to run
     - thisArg (object) context object for the callback
     = (object) Set object
    \*/
    setproto.forEach = function (callback, thisArg) {
        for (var i = 0, ii = this.items.length; i < ii; i++) {
            if (callback.call(thisArg, this.items[i], i) === false) {
                return this;
            }
        }
        return this;
    };
    for (var method in elproto) if (elproto[has](method)) {
        setproto[method] = (function (methodname) {
            return function () {
                var arg = arguments;
                return this.forEach(function (el) {
                    el[methodname][apply](el, arg);
                });
            };
        })(method);
    }
    setproto.attr = function (name, value) {
        if (name && R.is(name, array) && R.is(name[0], "object")) {
            for (var j = 0, jj = name.length; j < jj; j++) {
                this.items[j].attr(name[j]);
            }
        } else {
            for (var i = 0, ii = this.items.length; i < ii; i++) {
                this.items[i].attr(name, value);
            }
        }
        return this;
    };
    /*\
     * Set.clear
     [ method ]
     **
     * Removes all elements from the set
    \*/
    setproto.clear = function () {
        while (this.length) {
            this.pop();
        }
    };
    /*\
     * Set.splice
     [ method ]
     **
     * Removes given element from the set
     **
     > Parameters
     **
     - index (number) position of the deletion
     - count (number) number of element to remove
     - insertion… (object) #optional elements to insert
     = (object) set elements that were deleted
    \*/
    setproto.splice = function (index, count, insertion) {
        index = index < 0 ? mmax(this.length + index, 0) : index;
        count = mmax(0, mmin(this.length - index, count));
        var tail = [],
            todel = [],
            args = [],
            i;
        for (i = 2; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        for (i = 0; i < count; i++) {
            todel.push(this[index + i]);
        }
        for (; i < this.length - index; i++) {
            tail.push(this[index + i]);
        }
        var arglen = args.length;
        for (i = 0; i < arglen + tail.length; i++) {
            this.items[index + i] = this[index + i] = i < arglen ? args[i] : tail[i - arglen];
        }
        i = this.items.length = this.length -= count - arglen;
        while (this[i]) {
            delete this[i++];
        }
        return new Set(todel);
    };
    /*\
     * Set.exclude
     [ method ]
     **
     * Removes given element from the set
     **
     > Parameters
     **
     - element (object) element to remove
     = (boolean) `true` if object was found & removed from the set
    \*/
    setproto.exclude = function (el) {
        for (var i = 0, ii = this.length; i < ii; i++) if (this[i] == el) {
            this.splice(i, 1);
            return true;
        }
    };
    setproto.animate = function (params, ms, easing, callback) {
        (R.is(easing, "function") || !easing) && (callback = easing || null);
        var len = this.items.length,
            i = len,
            item,
            set = this,
            collector;
        if (!len) {
            return this;
        }
        callback && (collector = function () {
            !--len && callback.call(set);
        });
        easing = R.is(easing, string) ? easing : collector;
        var anim = R.animation(params, ms, easing, collector);
        item = this.items[--i].animate(anim);
        while (i--) {
            this.items[i] && !this.items[i].removed && this.items[i].animateWith(item, anim, anim);
            (this.items[i] && !this.items[i].removed) || len--;
        }
        return this;
    };
    setproto.insertAfter = function (el) {
        var i = this.items.length;
        while (i--) {
            this.items[i].insertAfter(el);
        }
        return this;
    };
    setproto.getBBox = function () {
        var x = [],
            y = [],
            x2 = [],
            y2 = [];
        for (var i = this.items.length; i--;) if (!this.items[i].removed) {
            var box = this.items[i].getBBox();
            x.push(box.x);
            y.push(box.y);
            x2.push(box.x + box.width);
            y2.push(box.y + box.height);
        }
        x = mmin[apply](0, x);
        y = mmin[apply](0, y);
        x2 = mmax[apply](0, x2);
        y2 = mmax[apply](0, y2);
        return {
            x: x,
            y: y,
            x2: x2,
            y2: y2,
            width: x2 - x,
            height: y2 - y
        };
    };
    setproto.clone = function (s) {
        s = this.paper.set();
        for (var i = 0, ii = this.items.length; i < ii; i++) {
            s.push(this.items[i].clone());
        }
        return s;
    };
    setproto.toString = function () {
        return "Rapha\xebl\u2018s set";
    };

    setproto.glow = function(glowConfig) {
        var ret = this.paper.set();
        this.forEach(function(shape, index){
            var g = shape.glow(glowConfig);
            if(g != null){
                g.forEach(function(shape2, index2){
                    ret.push(shape2);
                });
            }
        });
        return ret;
    };


    /*\
     * Set.isPointInside
     [ method ]
     **
     * Determine if given point is inside this set’s elements
     **
     > Parameters
     **
     - x (number) x coordinate of the point
     - y (number) y coordinate of the point
     = (boolean) `true` if point is inside any of the set's elements
     \*/
    setproto.isPointInside = function (x, y) {
        var isPointInside = false;
        this.forEach(function (el) {
            if (el.isPointInside(x, y)) {
                isPointInside = true;
                return false; // stop loop
            }
        });
        return isPointInside;
    };

    /*\
     * Raphael.registerFont
     [ method ]
     **
     * Adds given font to the registered set of fonts for Raphaël. Should be used as an internal call from within Cufón’s font file.
     * Returns original parameter, so it could be used with chaining.
     # <a href="http://wiki.github.com/sorccu/cufon/about">More about Cufón and how to convert your font form TTF, OTF, etc to JavaScript file.</a>
     **
     > Parameters
     **
     - font (object) the font to register
     = (object) the font you passed in
     > Usage
     | Cufon.registerFont(Raphael.registerFont({…}));
    \*/
    R.registerFont = function (font) {
        if (!font.face) {
            return font;
        }
        this.fonts = this.fonts || {};
        var fontcopy = {
                w: font.w,
                face: {},
                glyphs: {}
            },
            family = font.face["font-family"];
        for (var prop in font.face) if (font.face[has](prop)) {
            fontcopy.face[prop] = font.face[prop];
        }
        if (this.fonts[family]) {
            this.fonts[family].push(fontcopy);
        } else {
            this.fonts[family] = [fontcopy];
        }
        if (!font.svg) {
            fontcopy.face["units-per-em"] = toInt(font.face["units-per-em"], 10);
            for (var glyph in font.glyphs) if (font.glyphs[has](glyph)) {
                var path = font.glyphs[glyph];
                fontcopy.glyphs[glyph] = {
                    w: path.w,
                    k: {},
                    d: path.d && "M" + path.d.replace(/[mlcxtrv]/g, function (command) {
                            return {l: "L", c: "C", x: "z", t: "m", r: "l", v: "c"}[command] || "M";
                        }) + "z"
                };
                if (path.k) {
                    for (var k in path.k) if (path[has](k)) {
                        fontcopy.glyphs[glyph].k[k] = path.k[k];
                    }
                }
            }
        }
        return font;
    };
    /*\
     * Paper.getFont
     [ method ]
     **
     * Finds font object in the registered fonts by given parameters. You could specify only one word from the font name, like “Myriad” for “Myriad Pro”.
     **
     > Parameters
     **
     - family (string) font family name or any word from it
     - weight (string) #optional font weight
     - style (string) #optional font style
     - stretch (string) #optional font stretch
     = (object) the font object
     > Usage
     | paper.print(100, 100, "Test string", paper.getFont("Times", 800), 30);
    \*/
    paperproto.getFont = function (family, weight, style, stretch) {
        stretch = stretch || "normal";
        style = style || "normal";
        weight = +weight || {normal: 400, bold: 700, lighter: 300, bolder: 800}[weight] || 400;
        if (!R.fonts) {
            return;
        }
        var font = R.fonts[family];
        if (!font) {
            var name = new RegExp("(^|\\s)" + family.replace(/[^\w\d\s+!~.:_-]/g, E) + "(\\s|$)", "i");
            for (var fontName in R.fonts) if (R.fonts[has](fontName)) {
                if (name.test(fontName)) {
                    font = R.fonts[fontName];
                    break;
                }
            }
        }
        var thefont;
        if (font) {
            for (var i = 0, ii = font.length; i < ii; i++) {
                thefont = font[i];
                if (thefont.face["font-weight"] == weight && (thefont.face["font-style"] == style || !thefont.face["font-style"]) && thefont.face["font-stretch"] == stretch) {
                    break;
                }
            }
        }
        return thefont;
    };
    /*\
     * Paper.print
     [ method ]
     **
     * Creates path that represent given text written using given font at given position with given size.
     * Result of the method is path element that contains whole text as a separate path.
     **
     > Parameters
     **
     - x (number) x position of the text
     - y (number) y position of the text
     - string (string) text to print
     - font (object) font object, see @Paper.getFont
     - size (number) #optional size of the font, default is `16`
     - origin (string) #optional could be `"baseline"` or `"middle"`, default is `"middle"`
     - letter_spacing (number) #optional number in range `-1..1`, default is `0`
     - line_spacing (number) #optional number in range `1..3`, default is `1`
     = (object) resulting path element, which consist of all letters
     > Usage
     | var txt = r.print(10, 50, "print", r.getFont("Museo"), 30).attr({fill: "#fff"});
    \*/
    paperproto.print = function (x, y, string, font, size, origin, letter_spacing, line_spacing) {
        origin = origin || "middle"; // baseline|middle
        letter_spacing = mmax(mmin(letter_spacing || 0, 1), -1);
        line_spacing = mmax(mmin(line_spacing || 1, 3), 1);
        var letters = Str(string)[split](E),
            shift = 0,
            notfirst = 0,
            path = E,
            scale;
        R.is(font, "string") && (font = this.getFont(font));
        if (font) {
            scale = (size || 16) / font.face["units-per-em"];
            var bb = font.face.bbox[split](separator),
                top = +bb[0],
                lineHeight = bb[3] - bb[1],
                shifty = 0,
                height = +bb[1] + (origin == "baseline" ? lineHeight + (+font.face.descent) : lineHeight / 2);
            for (var i = 0, ii = letters.length; i < ii; i++) {
                if (letters[i] == "\n") {
                    shift = 0;
                    curr = 0;
                    notfirst = 0;
                    shifty += lineHeight * line_spacing;
                } else {
                    var prev = notfirst && font.glyphs[letters[i - 1]] || {},
                        curr = font.glyphs[letters[i]];
                    shift += notfirst ? (prev.w || font.w) + (prev.k && prev.k[letters[i]] || 0) + (font.w * letter_spacing) : 0;
                    notfirst = 1;
                }
                if (curr && curr.d) {
                    path += R.transformPath(curr.d, ["t", shift * scale, shifty * scale, "s", scale, scale, top, height, "t", (x - top) / scale, (y - height) / scale]);
                }
            }
        }
        return this.path(path).attr({
            fill: "#000",
            stroke: "none"
        });
    };

    /*\
     * Paper.add
     [ method ]
     **
     * Imports elements in JSON array in format `{type: type, <attributes>}`
     **
     > Parameters
     **
     - json (array)
     = (object) resulting set of imported elements
     > Usage
     | paper.add([
     |     {
     |         type: "circle",
     |         cx: 10,
     |         cy: 10,
     |         r: 5
     |     },
     |     {
     |         type: "rect",
     |         x: 10,
     |         y: 10,
     |         width: 10,
     |         height: 10,
     |         fill: "#fc0"
     |     }
     | ]);
    \*/
    paperproto.add = function (json) {
        if (R.is(json, "array")) {
            var res = this.set(),
                i = 0,
                ii = json.length,
                j;
            for (; i < ii; i++) {
                j = json[i] || {};
                elements[has](j.type) && res.push(this[j.type]().attr(j));
            }
        }
        return res;
    };

    /*\
     * Raphael.format
     [ method ]
     **
     * Simple format function. Replaces construction of type “`{<number>}`” to the corresponding argument.
     **
     > Parameters
     **
     - token (string) string to format
     - … (string) rest of arguments will be treated as parameters for replacement
     = (string) formated string
     > Usage
     | var x = 10,
     |     y = 20,
     |     width = 40,
     |     height = 50;
     | // this will draw a rectangular shape equivalent to "M10,20h40v50h-40z"
     | paper.path(Raphael.format("M{0},{1}h{2}v{3}h{4}z", x, y, width, height, -width));
    \*/
    R.format = function (token, params) {
        var args = R.is(params, array) ? [0][concat](params) : arguments;
        token && R.is(token, string) && args.length - 1 && (token = token.replace(formatrg, function (str, i) {
            return args[++i] == null ? E : args[i];
        }));
        return token || E;
    };
    /*\
     * Raphael.fullfill
     [ method ]
     **
     * A little bit more advanced format function than @Raphael.format. Replaces construction of type “`{<name>}`” to the corresponding argument.
     **
     > Parameters
     **
     - token (string) string to format
     - json (object) object which properties will be used as a replacement
     = (string) formated string
     > Usage
     | // this will draw a rectangular shape equivalent to "M10,20h40v50h-40z"
     | paper.path(Raphael.fullfill("M{x},{y}h{dim.width}v{dim.height}h{dim['negative width']}z", {
     |     x: 10,
     |     y: 20,
     |     dim: {
     |         width: 40,
     |         height: 50,
     |         "negative width": -40
     |     }
     | }));
    \*/
    R.fullfill = (function () {
        var tokenRegex = /\{([^\}]+)\}/g,
            objNotationRegex = /(?:(?:^|\.)(.+?)(?=\[|\.|$|\()|\[('|")(.+?)\2\])(\(\))?/g, // matches .xxxxx or ["xxxxx"] to run over object properties
            replacer = function (all, key, obj) {
                var res = obj;
                key.replace(objNotationRegex, function (all, name, quote, quotedName, isFunc) {
                    name = name || quotedName;
                    if (res) {
                        if (name in res) {
                            res = res[name];
                        }
                        typeof res == "function" && isFunc && (res = res());
                    }
                });
                res = (res == null || res == obj ? all : res) + "";
                return res;
            };
        return function (str, obj) {
            return String(str).replace(tokenRegex, function (all, key) {
                return replacer(all, key, obj);
            });
        };
    })();
    /*\
     * Raphael.ninja
     [ method ]
     **
     * If you want to leave no trace of Raphaël (Well, Raphaël creates only one global variable `Raphael`, but anyway.) You can use `ninja` method.
     * Beware, that in this case plugins could stop working, because they are depending on global variable existence.
     **
     = (object) Raphael object
     > Usage
     | (function (local_raphael) {
     |     var paper = local_raphael(10, 10, 320, 200);
     |     …
     | })(Raphael.ninja());
    \*/
    R.ninja = function () {
        if (oldRaphael.was) {
            g.win.Raphael = oldRaphael.is;
        } else {
            // IE8 raises an error when deleting window property
            window.Raphael = undefined;
            try {
                delete window.Raphael;
            } catch(e) {}
        }
        return R;
    };
    /*\
     * Raphael.st
     [ property (object) ]
     **
     * You can add your own method to elements and sets. It is wise to add a set method for each element method
     * you added, so you will be able to call the same method on sets too.
     **
     * See also @Raphael.el.
     > Usage
     | Raphael.el.red = function () {
     |     this.attr({fill: "#f00"});
     | };
     | Raphael.st.red = function () {
     |     this.forEach(function (el) {
     |         el.red();
     |     });
     | };
     | // then use it
     | paper.set(paper.circle(100, 100, 20), paper.circle(110, 100, 20)).red();
    \*/
    R.st = setproto;

    eve.on("raphael.DOMload", function () {
        loaded = true;
    });

    // Firefox <3.6 fix: http://webreflection.blogspot.com/2009/11/195-chars-to-help-lazy-loading.html
    (function (doc, loaded, f) {
        if (doc.readyState == null && doc.addEventListener){
            doc.addEventListener(loaded, f = function () {
                doc.removeEventListener(loaded, f, false);
                doc.readyState = "complete";
            }, false);
            doc.readyState = "loading";
        }
        function isLoaded() {
            (/in/).test(doc.readyState) ? setTimeout(isLoaded, 9) : R.eve("raphael.DOMload");
        }
        isLoaded();
    })(document, "DOMContentLoaded");

    return R;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./dev/raphael.svg.js":
/*!****************************!*\
  !*** ./dev/raphael.svg.js ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! ./raphael.core */ "./dev/raphael.core.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function(R) {
    if (R && !R.svg) {
        return;
    }

    var has = "hasOwnProperty",
        Str = String,
        toFloat = parseFloat,
        toInt = parseInt,
        math = Math,
        mmax = math.max,
        abs = math.abs,
        pow = math.pow,
        separator = /[, ]+/,
        eve = R.eve,
        E = "",
        S = " ";
    var xlink = "http://www.w3.org/1999/xlink",
        markers = {
            block: "M5,0 0,2.5 5,5z",
            classic: "M5,0 0,2.5 5,5 3.5,3 3.5,2z",
            diamond: "M2.5,0 5,2.5 2.5,5 0,2.5z",
            open: "M6,1 1,3.5 6,6",
            oval: "M2.5,0A2.5,2.5,0,0,1,2.5,5 2.5,2.5,0,0,1,2.5,0z"
        },
        markerCounter = {};
    R.toString = function () {
        return  "Your browser supports SVG.\nYou are running Rapha\xebl " + this.version;
    };
    var $ = function (el, attr) {
        if (attr) {
            if (typeof el == "string") {
                el = $(el);
            }
            for (var key in attr) if (attr[has](key)) {
                if (key.substring(0, 6) == "xlink:") {
                    el.setAttributeNS(xlink, key.substring(6), Str(attr[key]));
                } else {
                    el.setAttribute(key, Str(attr[key]));
                }
            }
        } else {
            el = R._g.doc.createElementNS("http://www.w3.org/2000/svg", el);
            el.style && (el.style.webkitTapHighlightColor = "rgba(0,0,0,0)");
        }
        return el;
    },
    addGradientFill = function (element, gradient) {
        var type = "linear",
            id = element.id + gradient,
            fx = .5, fy = .5,
            o = element.node,
            SVG = element.paper,
            s = o.style,
            el = R._g.doc.getElementById(id);
        if (!el) {
            gradient = Str(gradient).replace(R._radial_gradient, function (all, _fx, _fy) {
                type = "radial";
                if (_fx && _fy) {
                    fx = toFloat(_fx);
                    fy = toFloat(_fy);
                    var dir = ((fy > .5) * 2 - 1);
                    pow(fx - .5, 2) + pow(fy - .5, 2) > .25 &&
                        (fy = math.sqrt(.25 - pow(fx - .5, 2)) * dir + .5) &&
                        fy != .5 &&
                        (fy = fy.toFixed(5) - 1e-5 * dir);
                }
                return E;
            });
            gradient = gradient.split(/\s*\-\s*/);
            if (type == "linear") {
                var angle = gradient.shift();
                angle = -toFloat(angle);
                if (isNaN(angle)) {
                    return null;
                }
                var vector = [0, 0, math.cos(R.rad(angle)), math.sin(R.rad(angle))],
                    max = 1 / (mmax(abs(vector[2]), abs(vector[3])) || 1);
                vector[2] *= max;
                vector[3] *= max;
                if (vector[2] < 0) {
                    vector[0] = -vector[2];
                    vector[2] = 0;
                }
                if (vector[3] < 0) {
                    vector[1] = -vector[3];
                    vector[3] = 0;
                }
            }
            var dots = R._parseDots(gradient);
            if (!dots) {
                return null;
            }
            id = id.replace(/[\(\)\s,\xb0#]/g, "_");

            if (element.gradient && id != element.gradient.id) {
                SVG.defs.removeChild(element.gradient);
                delete element.gradient;
            }

            if (!element.gradient) {
                el = $(type + "Gradient", {id: id});
                element.gradient = el;
                $(el, type == "radial" ? {
                    fx: fx,
                    fy: fy
                } : {
                    x1: vector[0],
                    y1: vector[1],
                    x2: vector[2],
                    y2: vector[3],
                    gradientTransform: element.matrix.invert()
                });
                SVG.defs.appendChild(el);
                for (var i = 0, ii = dots.length; i < ii; i++) {
                    el.appendChild($("stop", {
                        offset: dots[i].offset ? dots[i].offset : i ? "100%" : "0%",
                        "stop-color": dots[i].color || "#fff",
                        "stop-opacity": isFinite(dots[i].opacity) ? dots[i].opacity : 1
                    }));
                }
            }
        }
        $(o, {
            fill: fillurl(id),
            opacity: 1,
            "fill-opacity": 1
        });
        s.fill = E;
        s.opacity = 1;
        s.fillOpacity = 1;
        return 1;
    },
    isIE9or10 = function () {
      var mode = document.documentMode;
      return mode && (mode === 9 || mode === 10);
    },
    fillurl = function (id) {
      if (isIE9or10()) {
          return "url('#" + id + "')";
      }
      var location = document.location;
      var locationString = (
          location.protocol + '//' +
          location.host +
          location.pathname +
          location.search
      );
      return "url('" + locationString + "#" + id + "')";
    },
    updatePosition = function (o) {
        var bbox = o.getBBox(1);
        $(o.pattern, {patternTransform: o.matrix.invert() + " translate(" + bbox.x + "," + bbox.y + ")"});
    },
    addArrow = function (o, value, isEnd) {
        if (o.type == "path") {
            var values = Str(value).toLowerCase().split("-"),
                p = o.paper,
                se = isEnd ? "end" : "start",
                node = o.node,
                attrs = o.attrs,
                stroke = attrs["stroke-width"],
                i = values.length,
                type = "classic",
                from,
                to,
                dx,
                refX,
                attr,
                w = 3,
                h = 3,
                t = 5;
            while (i--) {
                switch (values[i]) {
                    case "block":
                    case "classic":
                    case "oval":
                    case "diamond":
                    case "open":
                    case "none":
                        type = values[i];
                        break;
                    case "wide": h = 5; break;
                    case "narrow": h = 2; break;
                    case "long": w = 5; break;
                    case "short": w = 2; break;
                }
            }
            if (type == "open") {
                w += 2;
                h += 2;
                t += 2;
                dx = 1;
                refX = isEnd ? 4 : 1;
                attr = {
                    fill: "none",
                    stroke: attrs.stroke
                };
            } else {
                refX = dx = w / 2;
                attr = {
                    fill: attrs.stroke,
                    stroke: "none"
                };
            }
            if (o._.arrows) {
                if (isEnd) {
                    o._.arrows.endPath && markerCounter[o._.arrows.endPath]--;
                    o._.arrows.endMarker && markerCounter[o._.arrows.endMarker]--;
                } else {
                    o._.arrows.startPath && markerCounter[o._.arrows.startPath]--;
                    o._.arrows.startMarker && markerCounter[o._.arrows.startMarker]--;
                }
            } else {
                o._.arrows = {};
            }
            if (type != "none") {
                var pathId = "raphael-marker-" + type,
                    markerId = "raphael-marker-" + se + type + w + h + "-obj" + o.id;
                if (!R._g.doc.getElementById(pathId)) {
                    p.defs.appendChild($($("path"), {
                        "stroke-linecap": "round",
                        d: markers[type],
                        id: pathId
                    }));
                    markerCounter[pathId] = 1;
                } else {
                    markerCounter[pathId]++;
                }
                var marker = R._g.doc.getElementById(markerId),
                    use;
                if (!marker) {
                    marker = $($("marker"), {
                        id: markerId,
                        markerHeight: h,
                        markerWidth: w,
                        orient: "auto",
                        refX: refX,
                        refY: h / 2
                    });
                    use = $($("use"), {
                        "xlink:href": "#" + pathId,
                        transform: (isEnd ? "rotate(180 " + w / 2 + " " + h / 2 + ") " : E) + "scale(" + w / t + "," + h / t + ")",
                        "stroke-width": (1 / ((w / t + h / t) / 2)).toFixed(4)
                    });
                    marker.appendChild(use);
                    p.defs.appendChild(marker);
                    markerCounter[markerId] = 1;
                } else {
                    markerCounter[markerId]++;
                    use = marker.getElementsByTagName("use")[0];
                }
                $(use, attr);
                var delta = dx * (type != "diamond" && type != "oval");
                if (isEnd) {
                    from = o._.arrows.startdx * stroke || 0;
                    to = R.getTotalLength(attrs.path) - delta * stroke;
                } else {
                    from = delta * stroke;
                    to = R.getTotalLength(attrs.path) - (o._.arrows.enddx * stroke || 0);
                }
                attr = {};
                attr["marker-" + se] = "url(#" + markerId + ")";
                if (to || from) {
                    attr.d = R.getSubpath(attrs.path, from, to);
                }
                $(node, attr);
                o._.arrows[se + "Path"] = pathId;
                o._.arrows[se + "Marker"] = markerId;
                o._.arrows[se + "dx"] = delta;
                o._.arrows[se + "Type"] = type;
                o._.arrows[se + "String"] = value;
            } else {
                if (isEnd) {
                    from = o._.arrows.startdx * stroke || 0;
                    to = R.getTotalLength(attrs.path) - from;
                } else {
                    from = 0;
                    to = R.getTotalLength(attrs.path) - (o._.arrows.enddx * stroke || 0);
                }
                o._.arrows[se + "Path"] && $(node, {d: R.getSubpath(attrs.path, from, to)});
                delete o._.arrows[se + "Path"];
                delete o._.arrows[se + "Marker"];
                delete o._.arrows[se + "dx"];
                delete o._.arrows[se + "Type"];
                delete o._.arrows[se + "String"];
            }
            for (attr in markerCounter) if (markerCounter[has](attr) && !markerCounter[attr]) {
                var item = R._g.doc.getElementById(attr);
                item && item.parentNode.removeChild(item);
            }
        }
    },
    dasharray = {
        "-": [3, 1],
        ".": [1, 1],
        "-.": [3, 1, 1, 1],
        "-..": [3, 1, 1, 1, 1, 1],
        ". ": [1, 3],
        "- ": [4, 3],
        "--": [8, 3],
        "- .": [4, 3, 1, 3],
        "--.": [8, 3, 1, 3],
        "--..": [8, 3, 1, 3, 1, 3]
    },
    addDashes = function (o, value, params) {
        value = dasharray[Str(value).toLowerCase()];
        if (value) {
            var width = o.attrs["stroke-width"] || "1",
                butt = {round: width, square: width, butt: 0}[o.attrs["stroke-linecap"] || params["stroke-linecap"]] || 0,
                dashes = [],
                i = value.length;
            while (i--) {
                dashes[i] = value[i] * width + ((i % 2) ? 1 : -1) * butt;
            }
            $(o.node, {"stroke-dasharray": dashes.join(",")});
        }
        else {
          $(o.node, {"stroke-dasharray": "none"});
        }
    },
    setFillAndStroke = function (o, params) {
        var node = o.node,
            attrs = o.attrs,
            vis = node.style.visibility;
        node.style.visibility = "hidden";
        for (var att in params) {
            if (params[has](att)) {
                if (!R._availableAttrs[has](att)) {
                    continue;
                }
                var value = params[att];
                attrs[att] = value;
                switch (att) {
                    case "blur":
                        o.blur(value);
                        break;
                    case "title":
                        var title = node.getElementsByTagName("title");

                        // Use the existing <title>.
                        if (title.length && (title = title[0])) {
                          title.firstChild.nodeValue = value;
                        } else {
                          title = $("title");
                          var val = R._g.doc.createTextNode(value);
                          title.appendChild(val);
                          node.appendChild(title);
                        }
                        break;
                    case "href":
                    case "target":
                        var pn = node.parentNode;
                        if (pn.tagName.toLowerCase() != "a") {
                            var hl = $("a");
                            pn.insertBefore(hl, node);
                            hl.appendChild(node);
                            pn = hl;
                        }
                        if (att == "target") {
                            pn.setAttributeNS(xlink, "show", value == "blank" ? "new" : value);
                        } else {
                            pn.setAttributeNS(xlink, att, value);
                        }
                        break;
                    case "cursor":
                        node.style.cursor = value;
                        break;
                    case "transform":
                        o.transform(value);
                        break;
                    case "arrow-start":
                        addArrow(o, value);
                        break;
                    case "arrow-end":
                        addArrow(o, value, 1);
                        break;
                    case "clip-rect":
                        var rect = Str(value).split(separator);
                        if (rect.length == 4) {
                            o.clip && o.clip.parentNode.parentNode.removeChild(o.clip.parentNode);
                            var el = $("clipPath"),
                                rc = $("rect");
                            el.id = R.createUUID();
                            $(rc, {
                                x: rect[0],
                                y: rect[1],
                                width: rect[2],
                                height: rect[3]
                            });
                            el.appendChild(rc);
                            o.paper.defs.appendChild(el);
                            $(node, {"clip-path": "url(#" + el.id + ")"});
                            o.clip = rc;
                        }
                        if (!value) {
                            var path = node.getAttribute("clip-path");
                            if (path) {
                                var clip = R._g.doc.getElementById(path.replace(/(^url\(#|\)$)/g, E));
                                clip && clip.parentNode.removeChild(clip);
                                $(node, {"clip-path": E});
                                delete o.clip;
                            }
                        }
                    break;
                    case "path":
                        if (o.type == "path") {
                            $(node, {d: value ? attrs.path = R._pathToAbsolute(value) : "M0,0"});
                            o._.dirty = 1;
                            if (o._.arrows) {
                                "startString" in o._.arrows && addArrow(o, o._.arrows.startString);
                                "endString" in o._.arrows && addArrow(o, o._.arrows.endString, 1);
                            }
                        }
                        break;
                    case "width":
                        node.setAttribute(att, value);
                        o._.dirty = 1;
                        if (attrs.fx) {
                            att = "x";
                            value = attrs.x;
                        } else {
                            break;
                        }
                    case "x":
                        if (attrs.fx) {
                            value = -attrs.x - (attrs.width || 0);
                        }
                    case "rx":
                        if (att == "rx" && o.type == "rect") {
                            break;
                        }
                    case "cx":
                        node.setAttribute(att, value);
                        o.pattern && updatePosition(o);
                        o._.dirty = 1;
                        break;
                    case "height":
                        node.setAttribute(att, value);
                        o._.dirty = 1;
                        if (attrs.fy) {
                            att = "y";
                            value = attrs.y;
                        } else {
                            break;
                        }
                    case "y":
                        if (attrs.fy) {
                            value = -attrs.y - (attrs.height || 0);
                        }
                    case "ry":
                        if (att == "ry" && o.type == "rect") {
                            break;
                        }
                    case "cy":
                        node.setAttribute(att, value);
                        o.pattern && updatePosition(o);
                        o._.dirty = 1;
                        break;
                    case "r":
                        if (o.type == "rect") {
                            $(node, {rx: value, ry: value});
                        } else {
                            node.setAttribute(att, value);
                        }
                        o._.dirty = 1;
                        break;
                    case "src":
                        if (o.type == "image") {
                            node.setAttributeNS(xlink, "href", value);
                        }
                        break;
                    case "stroke-width":
                        if (o._.sx != 1 || o._.sy != 1) {
                            value /= mmax(abs(o._.sx), abs(o._.sy)) || 1;
                        }
                        node.setAttribute(att, value);
                        if (attrs["stroke-dasharray"]) {
                            addDashes(o, attrs["stroke-dasharray"], params);
                        }
                        if (o._.arrows) {
                            "startString" in o._.arrows && addArrow(o, o._.arrows.startString);
                            "endString" in o._.arrows && addArrow(o, o._.arrows.endString, 1);
                        }
                        break;
                    case "stroke-dasharray":
                        addDashes(o, value, params);
                        break;
                    case "fill":
                        var isURL = Str(value).match(R._ISURL);
                        if (isURL) {
                            el = $("pattern");
                            var ig = $("image");
                            el.id = R.createUUID();
                            $(el, {x: 0, y: 0, patternUnits: "userSpaceOnUse", height: 1, width: 1});
                            $(ig, {x: 0, y: 0, "xlink:href": isURL[1]});
                            el.appendChild(ig);

                            (function (el) {
                                R._preload(isURL[1], function () {
                                    var w = this.offsetWidth,
                                        h = this.offsetHeight;
                                    $(el, {width: w, height: h});
                                    $(ig, {width: w, height: h});
                                });
                            })(el);
                            o.paper.defs.appendChild(el);
                            $(node, {fill: "url(#" + el.id + ")"});
                            o.pattern = el;
                            o.pattern && updatePosition(o);
                            break;
                        }
                        var clr = R.getRGB(value);
                        if (!clr.error) {
                            delete params.gradient;
                            delete attrs.gradient;
                            !R.is(attrs.opacity, "undefined") &&
                                R.is(params.opacity, "undefined") &&
                                $(node, {opacity: attrs.opacity});
                            !R.is(attrs["fill-opacity"], "undefined") &&
                                R.is(params["fill-opacity"], "undefined") &&
                                $(node, {"fill-opacity": attrs["fill-opacity"]});
                        } else if ((o.type == "circle" || o.type == "ellipse" || Str(value).charAt() != "r") && addGradientFill(o, value)) {
                            if ("opacity" in attrs || "fill-opacity" in attrs) {
                                var gradient = R._g.doc.getElementById(node.getAttribute("fill").replace(/^url\(#|\)$/g, E));
                                if (gradient) {
                                    var stops = gradient.getElementsByTagName("stop");
                                    $(stops[stops.length - 1], {"stop-opacity": ("opacity" in attrs ? attrs.opacity : 1) * ("fill-opacity" in attrs ? attrs["fill-opacity"] : 1)});
                                }
                            }
                            attrs.gradient = value;
                            attrs.fill = "none";
                            break;
                        }
                        clr[has]("opacity") && $(node, {"fill-opacity": clr.opacity > 1 ? clr.opacity / 100 : clr.opacity});
                    case "stroke":
                        clr = R.getRGB(value);
                        node.setAttribute(att, clr.hex);
                        att == "stroke" && clr[has]("opacity") && $(node, {"stroke-opacity": clr.opacity > 1 ? clr.opacity / 100 : clr.opacity});
                        if (att == "stroke" && o._.arrows) {
                            "startString" in o._.arrows && addArrow(o, o._.arrows.startString);
                            "endString" in o._.arrows && addArrow(o, o._.arrows.endString, 1);
                        }
                        break;
                    case "gradient":
                        (o.type == "circle" || o.type == "ellipse" || Str(value).charAt() != "r") && addGradientFill(o, value);
                        break;
                    case "opacity":
                        if (attrs.gradient && !attrs[has]("stroke-opacity")) {
                            $(node, {"stroke-opacity": value > 1 ? value / 100 : value});
                        }
                        // fall
                    case "fill-opacity":
                        if (attrs.gradient) {
                            gradient = R._g.doc.getElementById(node.getAttribute("fill").replace(/^url\(#|\)$/g, E));
                            if (gradient) {
                                stops = gradient.getElementsByTagName("stop");
                                $(stops[stops.length - 1], {"stop-opacity": value});
                            }
                            break;
                        }
                    default:
                        att == "font-size" && (value = toInt(value, 10) + "px");
                        var cssrule = att.replace(/(\-.)/g, function (w) {
                            return w.substring(1).toUpperCase();
                        });
                        node.style[cssrule] = value;
                        o._.dirty = 1;
                        node.setAttribute(att, value);
                        break;
                }
            }
        }

        tuneText(o, params);
        node.style.visibility = vis;
    },
    leading = 1.2,
    tuneText = function (el, params) {
        if (el.type != "text" || !(params[has]("text") || params[has]("font") || params[has]("font-size") || params[has]("x") || params[has]("y"))) {
            return;
        }
        var a = el.attrs,
            node = el.node,
            fontSize = node.firstChild ? toInt(R._g.doc.defaultView.getComputedStyle(node.firstChild, E).getPropertyValue("font-size"), 10) : 10;

        if (params[has]("text")) {
            a.text = params.text;
            while (node.firstChild) {
                node.removeChild(node.firstChild);
            }
            var texts = Str(params.text).split("\n"),
                tspans = [],
                tspan;
            for (var i = 0, ii = texts.length; i < ii; i++) {
                tspan = $("tspan");
                i && $(tspan, {dy: fontSize * leading, x: a.x});
                tspan.appendChild(R._g.doc.createTextNode(texts[i]));
                node.appendChild(tspan);
                tspans[i] = tspan;
            }
        } else {
            tspans = node.getElementsByTagName("tspan");
            for (i = 0, ii = tspans.length; i < ii; i++) if (i) {
                $(tspans[i], {dy: fontSize * leading, x: a.x});
            } else {
                $(tspans[0], {dy: 0});
            }
        }
        $(node, {x: a.x, y: a.y});
        el._.dirty = 1;
        var bb = el._getBBox(),
            dif = a.y - (bb.y + bb.height / 2);
        dif && R.is(dif, "finite") && $(tspans[0], {dy: dif});
    },
    getRealNode = function (node) {
        if (node.parentNode && node.parentNode.tagName.toLowerCase() === "a") {
            return node.parentNode;
        } else {
            return node;
        }
    },
    Element = function (node, svg) {
        var X = 0,
            Y = 0;
        /*\
         * Element.node
         [ property (object) ]
         **
         * Gives you a reference to the DOM object, so you can assign event handlers or just mess around.
         **
         * Note: Don’t mess with it.
         > Usage
         | // draw a circle at coordinate 10,10 with radius of 10
         | var c = paper.circle(10, 10, 10);
         | c.node.onclick = function () {
         |     c.attr("fill", "red");
         | };
        \*/
        this[0] = this.node = node;
        /*\
         * Element.raphael
         [ property (object) ]
         **
         * Internal reference to @Raphael object. In case it is not available.
         > Usage
         | Raphael.el.red = function () {
         |     var hsb = this.paper.raphael.rgb2hsb(this.attr("fill"));
         |     hsb.h = 1;
         |     this.attr({fill: this.paper.raphael.hsb2rgb(hsb).hex});
         | }
        \*/
        node.raphael = true;
        /*\
         * Element.id
         [ property (number) ]
         **
         * Unique id of the element. Especially useful when you want to listen to events of the element,
         * because all events are fired in format `<module>.<action>.<id>`. Also useful for @Paper.getById method.
        \*/
        this.id = guid();
        node.raphaelid = this.id;

        /**
        * Method that returns a 5 letter/digit id, enough for 36^5 = 60466176 elements
        * @returns {string} id
        */
        function guid() {
            return ("0000" + (Math.random()*Math.pow(36,5) << 0).toString(36)).slice(-5);
        }

        this.matrix = R.matrix();
        this.realPath = null;
        /*\
         * Element.paper
         [ property (object) ]
         **
         * Internal reference to “paper” where object drawn. Mainly for use in plugins and element extensions.
         > Usage
         | Raphael.el.cross = function () {
         |     this.attr({fill: "red"});
         |     this.paper.path("M10,10L50,50M50,10L10,50")
         |         .attr({stroke: "red"});
         | }
        \*/
        this.paper = svg;
        this.attrs = this.attrs || {};
        this._ = {
            transform: [],
            sx: 1,
            sy: 1,
            deg: 0,
            dx: 0,
            dy: 0,
            dirty: 1
        };
        !svg.bottom && (svg.bottom = this);
        /*\
         * Element.prev
         [ property (object) ]
         **
         * Reference to the previous element in the hierarchy.
        \*/
        this.prev = svg.top;
        svg.top && (svg.top.next = this);
        svg.top = this;
        /*\
         * Element.next
         [ property (object) ]
         **
         * Reference to the next element in the hierarchy.
        \*/
        this.next = null;
    },
    elproto = R.el;

    Element.prototype = elproto;
    elproto.constructor = Element;

    R._engine.path = function (pathString, SVG) {
        var el = $("path");
        SVG.canvas && SVG.canvas.appendChild(el);
        var p = new Element(el, SVG);
        p.type = "path";
        setFillAndStroke(p, {
            fill: "none",
            stroke: "#000",
            path: pathString
        });
        return p;
    };
    /*\
     * Element.rotate
     [ method ]
     **
     * Deprecated! Use @Element.transform instead.
     * Adds rotation by given angle around given point to the list of
     * transformations of the element.
     > Parameters
     - deg (number) angle in degrees
     - cx (number) #optional x coordinate of the centre of rotation
     - cy (number) #optional y coordinate of the centre of rotation
     * If cx & cy aren’t specified centre of the shape is used as a point of rotation.
     = (object) @Element
    \*/
    elproto.rotate = function (deg, cx, cy) {
        if (this.removed) {
            return this;
        }
        deg = Str(deg).split(separator);
        if (deg.length - 1) {
            cx = toFloat(deg[1]);
            cy = toFloat(deg[2]);
        }
        deg = toFloat(deg[0]);
        (cy == null) && (cx = cy);
        if (cx == null || cy == null) {
            var bbox = this.getBBox(1);
            cx = bbox.x + bbox.width / 2;
            cy = bbox.y + bbox.height / 2;
        }
        this.transform(this._.transform.concat([["r", deg, cx, cy]]));
        return this;
    };
    /*\
     * Element.scale
     [ method ]
     **
     * Deprecated! Use @Element.transform instead.
     * Adds scale by given amount relative to given point to the list of
     * transformations of the element.
     > Parameters
     - sx (number) horisontal scale amount
     - sy (number) vertical scale amount
     - cx (number) #optional x coordinate of the centre of scale
     - cy (number) #optional y coordinate of the centre of scale
     * If cx & cy aren’t specified centre of the shape is used instead.
     = (object) @Element
    \*/
    elproto.scale = function (sx, sy, cx, cy) {
        if (this.removed) {
            return this;
        }
        sx = Str(sx).split(separator);
        if (sx.length - 1) {
            sy = toFloat(sx[1]);
            cx = toFloat(sx[2]);
            cy = toFloat(sx[3]);
        }
        sx = toFloat(sx[0]);
        (sy == null) && (sy = sx);
        (cy == null) && (cx = cy);
        if (cx == null || cy == null) {
            var bbox = this.getBBox(1);
        }
        cx = cx == null ? bbox.x + bbox.width / 2 : cx;
        cy = cy == null ? bbox.y + bbox.height / 2 : cy;
        this.transform(this._.transform.concat([["s", sx, sy, cx, cy]]));
        return this;
    };
    /*\
     * Element.translate
     [ method ]
     **
     * Deprecated! Use @Element.transform instead.
     * Adds translation by given amount to the list of transformations of the element.
     > Parameters
     - dx (number) horisontal shift
     - dy (number) vertical shift
     = (object) @Element
    \*/
    elproto.translate = function (dx, dy) {
        if (this.removed) {
            return this;
        }
        dx = Str(dx).split(separator);
        if (dx.length - 1) {
            dy = toFloat(dx[1]);
        }
        dx = toFloat(dx[0]) || 0;
        dy = +dy || 0;
        this.transform(this._.transform.concat([["t", dx, dy]]));
        return this;
    };
    /*\
     * Element.transform
     [ method ]
     **
     * Adds transformation to the element which is separate to other attributes,
     * i.e. translation doesn’t change `x` or `y` of the rectange. The format
     * of transformation string is similar to the path string syntax:
     | "t100,100r30,100,100s2,2,100,100r45s1.5"
     * Each letter is a command. There are four commands: `t` is for translate, `r` is for rotate, `s` is for
     * scale and `m` is for matrix.
     *
     * There are also alternative “absolute” translation, rotation and scale: `T`, `R` and `S`. They will not take previous transformation into account. For example, `...T100,0` will always move element 100 px horisontally, while `...t100,0` could move it vertically if there is `r90` before. Just compare results of `r90t100,0` and `r90T100,0`.
     *
     * So, the example line above could be read like “translate by 100, 100; rotate 30° around 100, 100; scale twice around 100, 100;
     * rotate 45° around centre; scale 1.5 times relative to centre”. As you can see rotate and scale commands have origin
     * coordinates as optional parameters, the default is the centre point of the element.
     * Matrix accepts six parameters.
     > Usage
     | var el = paper.rect(10, 20, 300, 200);
     | // translate 100, 100, rotate 45°, translate -100, 0
     | el.transform("t100,100r45t-100,0");
     | // if you want you can append or prepend transformations
     | el.transform("...t50,50");
     | el.transform("s2...");
     | // or even wrap
     | el.transform("t50,50...t-50-50");
     | // to reset transformation call method with empty string
     | el.transform("");
     | // to get current value call it without parameters
     | console.log(el.transform());
     > Parameters
     - tstr (string) #optional transformation string
     * If tstr isn’t specified
     = (string) current transformation string
     * else
     = (object) @Element
    \*/
    elproto.transform = function (tstr) {
        var _ = this._;
        if (tstr == null) {
            return _.transform;
        }
        R._extractTransform(this, tstr);

        this.clip && $(this.clip, {transform: this.matrix.invert()});
        this.pattern && updatePosition(this);
        this.node && $(this.node, {transform: this.matrix});

        if (_.sx != 1 || _.sy != 1) {
            var sw = this.attrs[has]("stroke-width") ? this.attrs["stroke-width"] : 1;
            this.attr({"stroke-width": sw});
        }

        return this;
    };
    /*\
     * Element.hide
     [ method ]
     **
     * Makes element invisible. See @Element.show.
     = (object) @Element
    \*/
    elproto.hide = function () {
        if(!this.removed) this.node.style.display = "none";
        return this;
    };
    /*\
     * Element.show
     [ method ]
     **
     * Makes element visible. See @Element.hide.
     = (object) @Element
    \*/
    elproto.show = function () {
        if(!this.removed) this.node.style.display = "";
        return this;
    };
    /*\
     * Element.remove
     [ method ]
     **
     * Removes element from the paper.
    \*/
    elproto.remove = function () {
        var node = getRealNode(this.node);
        if (this.removed || !node.parentNode) {
            return;
        }
        var paper = this.paper;
        paper.__set__ && paper.__set__.exclude(this);
        eve.unbind("raphael.*.*." + this.id);
        if (this.gradient) {
            paper.defs.removeChild(this.gradient);
        }
        R._tear(this, paper);

        node.parentNode.removeChild(node);

        // Remove custom data for element
        this.removeData();

        for (var i in this) {
            this[i] = typeof this[i] == "function" ? R._removedFactory(i) : null;
        }
        this.removed = true;
    };
    elproto._getBBox = function () {
        if (this.node.style.display == "none") {
            this.show();
            var hide = true;
        }
        var canvasHidden = false,
            containerStyle;
        if (this.paper.canvas.parentElement) {
          containerStyle = this.paper.canvas.parentElement.style;
        } //IE10+ can't find parentElement
        else if (this.paper.canvas.parentNode) {
          containerStyle = this.paper.canvas.parentNode.style;
        }

        if(containerStyle && containerStyle.display == "none") {
          canvasHidden = true;
          containerStyle.display = "";
        }
        var bbox = {};
        try {
            bbox = this.node.getBBox();
        } catch(e) {
            // Firefox 3.0.x, 25.0.1 (probably more versions affected) play badly here - possible fix
            bbox = {
                x: this.node.clientLeft,
                y: this.node.clientTop,
                width: this.node.clientWidth,
                height: this.node.clientHeight
            }
        } finally {
            bbox = bbox || {};
            if(canvasHidden){
              containerStyle.display = "none";
            }
        }
        hide && this.hide();
        return bbox;
    };
    /*\
     * Element.attr
     [ method ]
     **
     * Sets the attributes of the element.
     > Parameters
     - attrName (string) attribute’s name
     - value (string) value
     * or
     - params (object) object of name/value pairs
     * or
     - attrName (string) attribute’s name
     * or
     - attrNames (array) in this case method returns array of current values for given attribute names
     = (object) @Element if attrsName & value or params are passed in.
     = (...) value of the attribute if only attrsName is passed in.
     = (array) array of values of the attribute if attrsNames is passed in.
     = (object) object of attributes if nothing is passed in.
     > Possible parameters
     # <p>Please refer to the <a href="http://www.w3.org/TR/SVG/" title="The W3C Recommendation for the SVG language describes these properties in detail.">SVG specification</a> for an explanation of these parameters.</p>
     o arrow-end (string) arrowhead on the end of the path. The format for string is `<type>[-<width>[-<length>]]`. Possible types: `classic`, `block`, `open`, `oval`, `diamond`, `none`, width: `wide`, `narrow`, `medium`, length: `long`, `short`, `midium`.
     o clip-rect (string) comma or space separated values: x, y, width and height
     o cursor (string) CSS type of the cursor
     o cx (number) the x-axis coordinate of the center of the circle, or ellipse
     o cy (number) the y-axis coordinate of the center of the circle, or ellipse
     o fill (string) colour, gradient or image
     o fill-opacity (number)
     o font (string)
     o font-family (string)
     o font-size (number) font size in pixels
     o font-weight (string)
     o height (number)
     o href (string) URL, if specified element behaves as hyperlink
     o opacity (number)
     o path (string) SVG path string format
     o r (number) radius of the circle, ellipse or rounded corner on the rect
     o rx (number) horisontal radius of the ellipse
     o ry (number) vertical radius of the ellipse
     o src (string) image URL, only works for @Element.image element
     o stroke (string) stroke colour
     o stroke-dasharray (string) [“”, “none”, “`-`”, “`.`”, “`-.`”, “`-..`”, “`. `”, “`- `”, “`--`”, “`- .`”, “`--.`”, “`--..`”]
     o stroke-linecap (string) [“`butt`”, “`square`”, “`round`”]
     o stroke-linejoin (string) [“`bevel`”, “`round`”, “`miter`”]
     o stroke-miterlimit (number)
     o stroke-opacity (number)
     o stroke-width (number) stroke width in pixels, default is '1'
     o target (string) used with href
     o text (string) contents of the text element. Use `\n` for multiline text
     o text-anchor (string) [“`start`”, “`middle`”, “`end`”], default is “`middle`”
     o title (string) will create tooltip with a given text
     o transform (string) see @Element.transform
     o width (number)
     o x (number)
     o y (number)
     > Gradients
     * Linear gradient format: “`‹angle›-‹colour›[-‹colour›[:‹offset›]]*-‹colour›`”, example: “`90-#fff-#000`” – 90°
     * gradient from white to black or “`0-#fff-#f00:20-#000`” – 0° gradient from white via red (at 20%) to black.
     *
     * radial gradient: “`r[(‹fx›, ‹fy›)]‹colour›[-‹colour›[:‹offset›]]*-‹colour›`”, example: “`r#fff-#000`” –
     * gradient from white to black or “`r(0.25, 0.75)#fff-#000`” – gradient from white to black with focus point
     * at 0.25, 0.75. Focus point coordinates are in 0..1 range. Radial gradients can only be applied to circles and ellipses.
     > Path String
     # <p>Please refer to <a href="http://www.w3.org/TR/SVG/paths.html#PathData" title="Details of a path’s data attribute’s format are described in the SVG specification.">SVG documentation regarding path string</a>. Raphaël fully supports it.</p>
     > Colour Parsing
     # <ul>
     #     <li>Colour name (“<code>red</code>”, “<code>green</code>”, “<code>cornflowerblue</code>”, etc)</li>
     #     <li>#••• — shortened HTML colour: (“<code>#000</code>”, “<code>#fc0</code>”, etc)</li>
     #     <li>#•••••• — full length HTML colour: (“<code>#000000</code>”, “<code>#bd2300</code>”)</li>
     #     <li>rgb(•••, •••, •••) — red, green and blue channels’ values: (“<code>rgb(200,&nbsp;100,&nbsp;0)</code>”)</li>
     #     <li>rgb(•••%, •••%, •••%) — same as above, but in %: (“<code>rgb(100%,&nbsp;175%,&nbsp;0%)</code>”)</li>
     #     <li>rgba(•••, •••, •••, •••) — red, green and blue channels’ values: (“<code>rgba(200,&nbsp;100,&nbsp;0, .5)</code>”)</li>
     #     <li>rgba(•••%, •••%, •••%, •••%) — same as above, but in %: (“<code>rgba(100%,&nbsp;175%,&nbsp;0%, 50%)</code>”)</li>
     #     <li>hsb(•••, •••, •••) — hue, saturation and brightness values: (“<code>hsb(0.5,&nbsp;0.25,&nbsp;1)</code>”)</li>
     #     <li>hsb(•••%, •••%, •••%) — same as above, but in %</li>
     #     <li>hsba(•••, •••, •••, •••) — same as above, but with opacity</li>
     #     <li>hsl(•••, •••, •••) — almost the same as hsb, see <a href="http://en.wikipedia.org/wiki/HSL_and_HSV" title="HSL and HSV - Wikipedia, the free encyclopedia">Wikipedia page</a></li>
     #     <li>hsl(•••%, •••%, •••%) — same as above, but in %</li>
     #     <li>hsla(•••, •••, •••, •••) — same as above, but with opacity</li>
     #     <li>Optionally for hsb and hsl you could specify hue as a degree: “<code>hsl(240deg,&nbsp;1,&nbsp;.5)</code>” or, if you want to go fancy, “<code>hsl(240°,&nbsp;1,&nbsp;.5)</code>”</li>
     # </ul>
    \*/
    elproto.attr = function (name, value) {
        if (this.removed) {
            return this;
        }
        if (name == null) {
            var res = {};
            for (var a in this.attrs) if (this.attrs[has](a)) {
                res[a] = this.attrs[a];
            }
            res.gradient && res.fill == "none" && (res.fill = res.gradient) && delete res.gradient;
            res.transform = this._.transform;
            return res;
        }
        if (value == null && R.is(name, "string")) {
            if (name == "fill" && this.attrs.fill == "none" && this.attrs.gradient) {
                return this.attrs.gradient;
            }
            if (name == "transform") {
                return this._.transform;
            }
            var names = name.split(separator),
                out = {};
            for (var i = 0, ii = names.length; i < ii; i++) {
                name = names[i];
                if (name in this.attrs) {
                    out[name] = this.attrs[name];
                } else if (R.is(this.paper.customAttributes[name], "function")) {
                    out[name] = this.paper.customAttributes[name].def;
                } else {
                    out[name] = R._availableAttrs[name];
                }
            }
            return ii - 1 ? out : out[names[0]];
        }
        if (value == null && R.is(name, "array")) {
            out = {};
            for (i = 0, ii = name.length; i < ii; i++) {
                out[name[i]] = this.attr(name[i]);
            }
            return out;
        }
        if (value != null) {
            var params = {};
            params[name] = value;
        } else if (name != null && R.is(name, "object")) {
            params = name;
        }
        for (var key in params) {
            eve("raphael.attr." + key + "." + this.id, this, params[key]);
        }
        for (key in this.paper.customAttributes) if (this.paper.customAttributes[has](key) && params[has](key) && R.is(this.paper.customAttributes[key], "function")) {
            var par = this.paper.customAttributes[key].apply(this, [].concat(params[key]));
            this.attrs[key] = params[key];
            for (var subkey in par) if (par[has](subkey)) {
                params[subkey] = par[subkey];
            }
        }
        setFillAndStroke(this, params);
        return this;
    };
    /*\
     * Element.toFront
     [ method ]
     **
     * Moves the element so it is the closest to the viewer’s eyes, on top of other elements.
     = (object) @Element
    \*/
    elproto.toFront = function () {
        if (this.removed) {
            return this;
        }
        var node = getRealNode(this.node);
        node.parentNode.appendChild(node);
        var svg = this.paper;
        svg.top != this && R._tofront(this, svg);
        return this;
    };
    /*\
     * Element.toBack
     [ method ]
     **
     * Moves the element so it is the furthest from the viewer’s eyes, behind other elements.
     = (object) @Element
    \*/
    elproto.toBack = function () {
        if (this.removed) {
            return this;
        }
        var node = getRealNode(this.node);
        var parentNode = node.parentNode;
        parentNode.insertBefore(node, parentNode.firstChild);
        R._toback(this, this.paper);
        var svg = this.paper;
        return this;
    };
    /*\
     * Element.insertAfter
     [ method ]
     **
     * Inserts current object after the given one.
     = (object) @Element
    \*/
    elproto.insertAfter = function (element) {
        if (this.removed || !element) {
            return this;
        }

        var node = getRealNode(this.node);
        var afterNode = getRealNode(element.node || element[element.length - 1].node);
        if (afterNode.nextSibling) {
            afterNode.parentNode.insertBefore(node, afterNode.nextSibling);
        } else {
            afterNode.parentNode.appendChild(node);
        }
        R._insertafter(this, element, this.paper);
        return this;
    };
    /*\
     * Element.insertBefore
     [ method ]
     **
     * Inserts current object before the given one.
     = (object) @Element
    \*/
    elproto.insertBefore = function (element) {
        if (this.removed || !element) {
            return this;
        }

        var node = getRealNode(this.node);
        var beforeNode = getRealNode(element.node || element[0].node);
        beforeNode.parentNode.insertBefore(node, beforeNode);
        R._insertbefore(this, element, this.paper);
        return this;
    };
    elproto.blur = function (size) {
        // Experimental. No Safari support. Use it on your own risk.
        var t = this;
        if (+size !== 0) {
            var fltr = $("filter"),
                blur = $("feGaussianBlur");
            t.attrs.blur = size;
            fltr.id = R.createUUID();
            $(blur, {stdDeviation: +size || 1.5});
            fltr.appendChild(blur);
            t.paper.defs.appendChild(fltr);
            t._blur = fltr;
            $(t.node, {filter: "url(#" + fltr.id + ")"});
        } else {
            if (t._blur) {
                t._blur.parentNode.removeChild(t._blur);
                delete t._blur;
                delete t.attrs.blur;
            }
            t.node.removeAttribute("filter");
        }
        return t;
    };
    R._engine.circle = function (svg, x, y, r) {
        var el = $("circle");
        svg.canvas && svg.canvas.appendChild(el);
        var res = new Element(el, svg);
        res.attrs = {cx: x, cy: y, r: r, fill: "none", stroke: "#000"};
        res.type = "circle";
        $(el, res.attrs);
        return res;
    };
    R._engine.rect = function (svg, x, y, w, h, r) {
        var el = $("rect");
        svg.canvas && svg.canvas.appendChild(el);
        var res = new Element(el, svg);
        res.attrs = {x: x, y: y, width: w, height: h, rx: r || 0, ry: r || 0, fill: "none", stroke: "#000"};
        res.type = "rect";
        $(el, res.attrs);
        return res;
    };
    R._engine.ellipse = function (svg, x, y, rx, ry) {
        var el = $("ellipse");
        svg.canvas && svg.canvas.appendChild(el);
        var res = new Element(el, svg);
        res.attrs = {cx: x, cy: y, rx: rx, ry: ry, fill: "none", stroke: "#000"};
        res.type = "ellipse";
        $(el, res.attrs);
        return res;
    };
    R._engine.image = function (svg, src, x, y, w, h) {
        var el = $("image");
        $(el, {x: x, y: y, width: w, height: h, preserveAspectRatio: "none"});
        el.setAttributeNS(xlink, "href", src);
        svg.canvas && svg.canvas.appendChild(el);
        var res = new Element(el, svg);
        res.attrs = {x: x, y: y, width: w, height: h, src: src};
        res.type = "image";
        return res;
    };
    R._engine.text = function (svg, x, y, text) {
        var el = $("text");
        svg.canvas && svg.canvas.appendChild(el);
        var res = new Element(el, svg);
        res.attrs = {
            x: x,
            y: y,
            "text-anchor": "middle",
            text: text,
            "font-family": R._availableAttrs["font-family"],
            "font-size": R._availableAttrs["font-size"],
            stroke: "none",
            fill: "#000"
        };
        res.type = "text";
        setFillAndStroke(res, res.attrs);
        return res;
    };
    R._engine.setSize = function (width, height) {
        this.width = width || this.width;
        this.height = height || this.height;
        this.canvas.setAttribute("width", this.width);
        this.canvas.setAttribute("height", this.height);
        if (this._viewBox) {
            this.setViewBox.apply(this, this._viewBox);
        }
        return this;
    };
    R._engine.create = function () {
        var con = R._getContainer.apply(0, arguments),
            container = con && con.container;
        if (!container) {
            throw new Error("SVG container not found.");
        }
        var x = con.x,
            y = con.y,
            width = con.width,
            height = con.height,
            cnvs = $("svg"),
            css = "overflow:hidden;",
            isFloating;
        x = x || 0;
        y = y || 0;
        width = width || 512;
        height = height || 342;
        $(cnvs, {
            height: height,
            version: 1.1,
            width: width,
            xmlns: "http://www.w3.org/2000/svg",
            "xmlns:xlink": "http://www.w3.org/1999/xlink"
        });
        if (container == 1) {
            cnvs.style.cssText = css + "position:absolute;left:" + x + "px;top:" + y + "px";
            R._g.doc.body.appendChild(cnvs);
            isFloating = 1;
        } else {
            cnvs.style.cssText = css + "position:relative";
            if (container.firstChild) {
                container.insertBefore(cnvs, container.firstChild);
            } else {
                container.appendChild(cnvs);
            }
        }
        container = new R._Paper;
        container.width = width;
        container.height = height;
        container.canvas = cnvs;
        container.clear();
        container._left = container._top = 0;
        isFloating && (container.renderfix = function () {});
        container.renderfix();
        return container;
    };
    R._engine.setViewBox = function (x, y, w, h, fit) {
        eve("raphael.setViewBox", this, this._viewBox, [x, y, w, h, fit]);
        var paperSize = this.getSize(),
            size = mmax(w / paperSize.width, h / paperSize.height),
            top = this.top,
            aspectRatio = fit ? "xMidYMid meet" : "xMinYMin",
            vb,
            sw;
        if (x == null) {
            if (this._vbSize) {
                size = 1;
            }
            delete this._vbSize;
            vb = "0 0 " + this.width + S + this.height;
        } else {
            this._vbSize = size;
            vb = x + S + y + S + w + S + h;
        }
        $(this.canvas, {
            viewBox: vb,
            preserveAspectRatio: aspectRatio
        });
        while (size && top) {
            sw = "stroke-width" in top.attrs ? top.attrs["stroke-width"] : 1;
            top.attr({"stroke-width": sw});
            top._.dirty = 1;
            top._.dirtyT = 1;
            top = top.prev;
        }
        this._viewBox = [x, y, w, h, !!fit];
        return this;
    };
    /*\
     * Paper.renderfix
     [ method ]
     **
     * Fixes the issue of Firefox and IE9 regarding subpixel rendering. If paper is dependent
     * on other elements after reflow it could shift half pixel which cause for lines to lost their crispness.
     * This method fixes the issue.
     **
       Special thanks to Mariusz Nowak (http://www.medikoo.com/) for this method.
    \*/
    R.prototype.renderfix = function () {
        var cnvs = this.canvas,
            s = cnvs.style,
            pos;
        try {
            pos = cnvs.getScreenCTM() || cnvs.createSVGMatrix();
        } catch (e) {
            pos = cnvs.createSVGMatrix();
        }
        var left = -pos.e % 1,
            top = -pos.f % 1;
        if (left || top) {
            if (left) {
                this._left = (this._left + left) % 1;
                s.left = this._left + "px";
            }
            if (top) {
                this._top = (this._top + top) % 1;
                s.top = this._top + "px";
            }
        }
    };
    /*\
     * Paper.clear
     [ method ]
     **
     * Clears the paper, i.e. removes all the elements.
    \*/
    R.prototype.clear = function () {
        R.eve("raphael.clear", this);
        var c = this.canvas;
        while (c.firstChild) {
            c.removeChild(c.firstChild);
        }
        this.bottom = this.top = null;
        (this.desc = $("desc")).appendChild(R._g.doc.createTextNode("Created with Rapha\xebl " + R.version));
        c.appendChild(this.desc);
        c.appendChild(this.defs = $("defs"));
    };
    /*\
     * Paper.remove
     [ method ]
     **
     * Removes the paper from the DOM.
    \*/
    R.prototype.remove = function () {
        eve("raphael.remove", this);
        this.canvas.parentNode && this.canvas.parentNode.removeChild(this.canvas);
        for (var i in this) {
            this[i] = typeof this[i] == "function" ? R._removedFactory(i) : null;
        }
    };
    var setproto = R.st;
    for (var method in elproto) if (elproto[has](method) && !setproto[has](method)) {
        setproto[method] = (function (methodname) {
            return function () {
                var arg = arguments;
                return this.forEach(function (el) {
                    el[methodname].apply(el, arg);
                });
            };
        })(method);
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./dev/raphael.vml.js":
/*!****************************!*\
  !*** ./dev/raphael.vml.js ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! ./raphael.core */ "./dev/raphael.core.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function(R) {
    if (R && !R.vml) {
        return;
    }

    var has = "hasOwnProperty",
        Str = String,
        toFloat = parseFloat,
        math = Math,
        round = math.round,
        mmax = math.max,
        mmin = math.min,
        abs = math.abs,
        fillString = "fill",
        separator = /[, ]+/,
        eve = R.eve,
        ms = " progid:DXImageTransform.Microsoft",
        S = " ",
        E = "",
        map = {M: "m", L: "l", C: "c", Z: "x", m: "t", l: "r", c: "v", z: "x"},
        bites = /([clmz]),?([^clmz]*)/gi,
        blurregexp = / progid:\S+Blur\([^\)]+\)/g,
        val = /-?[^,\s-]+/g,
        cssDot = "position:absolute;left:0;top:0;width:1px;height:1px;behavior:url(#default#VML)",
        zoom = 21600,
        pathTypes = {path: 1, rect: 1, image: 1},
        ovalTypes = {circle: 1, ellipse: 1},
        path2vml = function (path) {
            var total =  /[ahqstv]/ig,
                command = R._pathToAbsolute;
            Str(path).match(total) && (command = R._path2curve);
            total = /[clmz]/g;
            if (command == R._pathToAbsolute && !Str(path).match(total)) {
                var res = Str(path).replace(bites, function (all, command, args) {
                    var vals = [],
                        isMove = command.toLowerCase() == "m",
                        res = map[command];
                    args.replace(val, function (value) {
                        if (isMove && vals.length == 2) {
                            res += vals + map[command == "m" ? "l" : "L"];
                            vals = [];
                        }
                        vals.push(round(value * zoom));
                    });
                    return res + vals;
                });
                return res;
            }
            var pa = command(path), p, r;
            res = [];
            for (var i = 0, ii = pa.length; i < ii; i++) {
                p = pa[i];
                r = pa[i][0].toLowerCase();
                r == "z" && (r = "x");
                for (var j = 1, jj = p.length; j < jj; j++) {
                    r += round(p[j] * zoom) + (j != jj - 1 ? "," : E);
                }
                res.push(r);
            }
            return res.join(S);
        },
        compensation = function (deg, dx, dy) {
            var m = R.matrix();
            m.rotate(-deg, .5, .5);
            return {
                dx: m.x(dx, dy),
                dy: m.y(dx, dy)
            };
        },
        setCoords = function (p, sx, sy, dx, dy, deg) {
            var _ = p._,
                m = p.matrix,
                fillpos = _.fillpos,
                o = p.node,
                s = o.style,
                y = 1,
                flip = "",
                dxdy,
                kx = zoom / sx,
                ky = zoom / sy;
            s.visibility = "hidden";
            if (!sx || !sy) {
                return;
            }
            o.coordsize = abs(kx) + S + abs(ky);
            s.rotation = deg * (sx * sy < 0 ? -1 : 1);
            if (deg) {
                var c = compensation(deg, dx, dy);
                dx = c.dx;
                dy = c.dy;
            }
            sx < 0 && (flip += "x");
            sy < 0 && (flip += " y") && (y = -1);
            s.flip = flip;
            o.coordorigin = (dx * -kx) + S + (dy * -ky);
            if (fillpos || _.fillsize) {
                var fill = o.getElementsByTagName(fillString);
                fill = fill && fill[0];
                o.removeChild(fill);
                if (fillpos) {
                    c = compensation(deg, m.x(fillpos[0], fillpos[1]), m.y(fillpos[0], fillpos[1]));
                    fill.position = c.dx * y + S + c.dy * y;
                }
                if (_.fillsize) {
                    fill.size = _.fillsize[0] * abs(sx) + S + _.fillsize[1] * abs(sy);
                }
                o.appendChild(fill);
            }
            s.visibility = "visible";
        };
    R.toString = function () {
        return  "Your browser doesn\u2019t support SVG. Falling down to VML.\nYou are running Rapha\xebl " + this.version;
    };
    var addArrow = function (o, value, isEnd) {
        var values = Str(value).toLowerCase().split("-"),
            se = isEnd ? "end" : "start",
            i = values.length,
            type = "classic",
            w = "medium",
            h = "medium";
        while (i--) {
            switch (values[i]) {
                case "block":
                case "classic":
                case "oval":
                case "diamond":
                case "open":
                case "none":
                    type = values[i];
                    break;
                case "wide":
                case "narrow": h = values[i]; break;
                case "long":
                case "short": w = values[i]; break;
            }
        }
        var stroke = o.node.getElementsByTagName("stroke")[0];
        stroke[se + "arrow"] = type;
        stroke[se + "arrowlength"] = w;
        stroke[se + "arrowwidth"] = h;
    },
    setFillAndStroke = function (o, params) {
        // o.paper.canvas.style.display = "none";
        o.attrs = o.attrs || {};
        var node = o.node,
            a = o.attrs,
            s = node.style,
            xy,
            newpath = pathTypes[o.type] && (params.x != a.x || params.y != a.y || params.width != a.width || params.height != a.height || params.cx != a.cx || params.cy != a.cy || params.rx != a.rx || params.ry != a.ry || params.r != a.r),
            isOval = ovalTypes[o.type] && (a.cx != params.cx || a.cy != params.cy || a.r != params.r || a.rx != params.rx || a.ry != params.ry),
            res = o;


        for (var par in params) if (params[has](par)) {
            a[par] = params[par];
        }
        if (newpath) {
            a.path = R._getPath[o.type](o);
            o._.dirty = 1;
        }
        params.href && (node.href = params.href);
        params.title && (node.title = params.title);
        params.target && (node.target = params.target);
        params.cursor && (s.cursor = params.cursor);
        "blur" in params && o.blur(params.blur);
        if (params.path && o.type == "path" || newpath) {
            node.path = path2vml(~Str(a.path).toLowerCase().indexOf("r") ? R._pathToAbsolute(a.path) : a.path);
            o._.dirty = 1;
            if (o.type == "image") {
                o._.fillpos = [a.x, a.y];
                o._.fillsize = [a.width, a.height];
                setCoords(o, 1, 1, 0, 0, 0);
            }
        }
        "transform" in params && o.transform(params.transform);
        if (isOval) {
            var cx = +a.cx,
                cy = +a.cy,
                rx = +a.rx || +a.r || 0,
                ry = +a.ry || +a.r || 0;
            node.path = R.format("ar{0},{1},{2},{3},{4},{1},{4},{1}x", round((cx - rx) * zoom), round((cy - ry) * zoom), round((cx + rx) * zoom), round((cy + ry) * zoom), round(cx * zoom));
            o._.dirty = 1;
        }
        if ("clip-rect" in params) {
            var rect = Str(params["clip-rect"]).split(separator);
            if (rect.length == 4) {
                rect[2] = +rect[2] + (+rect[0]);
                rect[3] = +rect[3] + (+rect[1]);
                var div = node.clipRect || R._g.doc.createElement("div"),
                    dstyle = div.style;
                dstyle.clip = R.format("rect({1}px {2}px {3}px {0}px)", rect);
                if (!node.clipRect) {
                    dstyle.position = "absolute";
                    dstyle.top = 0;
                    dstyle.left = 0;
                    dstyle.width = o.paper.width + "px";
                    dstyle.height = o.paper.height + "px";
                    node.parentNode.insertBefore(div, node);
                    div.appendChild(node);
                    node.clipRect = div;
                }
            }
            if (!params["clip-rect"]) {
                node.clipRect && (node.clipRect.style.clip = "auto");
            }
        }
        if (o.textpath) {
            var textpathStyle = o.textpath.style;
            params.font && (textpathStyle.font = params.font);
            params["font-family"] && (textpathStyle.fontFamily = '"' + params["font-family"].split(",")[0].replace(/^['"]+|['"]+$/g, E) + '"');
            params["font-size"] && (textpathStyle.fontSize = params["font-size"]);
            params["font-weight"] && (textpathStyle.fontWeight = params["font-weight"]);
            params["font-style"] && (textpathStyle.fontStyle = params["font-style"]);
        }
        if ("arrow-start" in params) {
            addArrow(res, params["arrow-start"]);
        }
        if ("arrow-end" in params) {
            addArrow(res, params["arrow-end"], 1);
        }
        if (params.opacity != null ||
            params.fill != null ||
            params.src != null ||
            params.stroke != null ||
            params["stroke-width"] != null ||
            params["stroke-opacity"] != null ||
            params["fill-opacity"] != null ||
            params["stroke-dasharray"] != null ||
            params["stroke-miterlimit"] != null ||
            params["stroke-linejoin"] != null ||
            params["stroke-linecap"] != null) {
            var fill = node.getElementsByTagName(fillString),
                newfill = false;
            fill = fill && fill[0];
            !fill && (newfill = fill = createNode(fillString));
            if (o.type == "image" && params.src) {
                fill.src = params.src;
            }
            params.fill && (fill.on = true);
            if (fill.on == null || params.fill == "none" || params.fill === null) {
                fill.on = false;
            }
            if (fill.on && params.fill) {
                var isURL = Str(params.fill).match(R._ISURL);
                if (isURL) {
                    fill.parentNode == node && node.removeChild(fill);
                    fill.rotate = true;
                    fill.src = isURL[1];
                    fill.type = "tile";
                    var bbox = o.getBBox(1);
                    fill.position = bbox.x + S + bbox.y;
                    o._.fillpos = [bbox.x, bbox.y];

                    R._preload(isURL[1], function () {
                        o._.fillsize = [this.offsetWidth, this.offsetHeight];
                    });
                } else {
                    fill.color = R.getRGB(params.fill).hex;
                    fill.src = E;
                    fill.type = "solid";
                    if (R.getRGB(params.fill).error && (res.type in {circle: 1, ellipse: 1} || Str(params.fill).charAt() != "r") && addGradientFill(res, params.fill, fill)) {
                        a.fill = "none";
                        a.gradient = params.fill;
                        fill.rotate = false;
                    }
                }
            }
            if ("fill-opacity" in params || "opacity" in params) {
                var opacity = ((+a["fill-opacity"] + 1 || 2) - 1) * ((+a.opacity + 1 || 2) - 1) * ((+R.getRGB(params.fill).o + 1 || 2) - 1);
                opacity = mmin(mmax(opacity, 0), 1);
                fill.opacity = opacity;
                if (fill.src) {
                    fill.color = "none";
                }
            }
            node.appendChild(fill);
            var stroke = (node.getElementsByTagName("stroke") && node.getElementsByTagName("stroke")[0]),
            newstroke = false;
            !stroke && (newstroke = stroke = createNode("stroke"));
            if ((params.stroke && params.stroke != "none") ||
                params["stroke-width"] ||
                params["stroke-opacity"] != null ||
                params["stroke-dasharray"] ||
                params["stroke-miterlimit"] ||
                params["stroke-linejoin"] ||
                params["stroke-linecap"]) {
                stroke.on = true;
            }
            (params.stroke == "none" || params.stroke === null || stroke.on == null || params.stroke == 0 || params["stroke-width"] == 0) && (stroke.on = false);
            var strokeColor = R.getRGB(params.stroke);
            stroke.on && params.stroke && (stroke.color = strokeColor.hex);
            opacity = ((+a["stroke-opacity"] + 1 || 2) - 1) * ((+a.opacity + 1 || 2) - 1) * ((+strokeColor.o + 1 || 2) - 1);
            var width = (toFloat(params["stroke-width"]) || 1) * .75;
            opacity = mmin(mmax(opacity, 0), 1);
            params["stroke-width"] == null && (width = a["stroke-width"]);
            params["stroke-width"] && (stroke.weight = width);
            width && width < 1 && (opacity *= width) && (stroke.weight = 1);
            stroke.opacity = opacity;

            params["stroke-linejoin"] && (stroke.joinstyle = params["stroke-linejoin"] || "miter");
            stroke.miterlimit = params["stroke-miterlimit"] || 8;
            params["stroke-linecap"] && (stroke.endcap = params["stroke-linecap"] == "butt" ? "flat" : params["stroke-linecap"] == "square" ? "square" : "round");
            if ("stroke-dasharray" in params) {
                var dasharray = {
                    "-": "shortdash",
                    ".": "shortdot",
                    "-.": "shortdashdot",
                    "-..": "shortdashdotdot",
                    ". ": "dot",
                    "- ": "dash",
                    "--": "longdash",
                    "- .": "dashdot",
                    "--.": "longdashdot",
                    "--..": "longdashdotdot"
                };
                stroke.dashstyle = dasharray[has](params["stroke-dasharray"]) ? dasharray[params["stroke-dasharray"]] : E;
            }
            newstroke && node.appendChild(stroke);
        }
        if (res.type == "text") {
            res.paper.canvas.style.display = E;
            var span = res.paper.span,
                m = 100,
                fontSize = a.font && a.font.match(/\d+(?:\.\d*)?(?=px)/);
            s = span.style;
            a.font && (s.font = a.font);
            a["font-family"] && (s.fontFamily = a["font-family"]);
            a["font-weight"] && (s.fontWeight = a["font-weight"]);
            a["font-style"] && (s.fontStyle = a["font-style"]);
            fontSize = toFloat(a["font-size"] || fontSize && fontSize[0]) || 10;
            s.fontSize = fontSize * m + "px";
            res.textpath.string && (span.innerHTML = Str(res.textpath.string).replace(/</g, "&#60;").replace(/&/g, "&#38;").replace(/\n/g, "<br>"));
            var brect = span.getBoundingClientRect();
            res.W = a.w = (brect.right - brect.left) / m;
            res.H = a.h = (brect.bottom - brect.top) / m;
            // res.paper.canvas.style.display = "none";
            res.X = a.x;
            res.Y = a.y + res.H / 2;

            ("x" in params || "y" in params) && (res.path.v = R.format("m{0},{1}l{2},{1}", round(a.x * zoom), round(a.y * zoom), round(a.x * zoom) + 1));
            var dirtyattrs = ["x", "y", "text", "font", "font-family", "font-weight", "font-style", "font-size"];
            for (var d = 0, dd = dirtyattrs.length; d < dd; d++) if (dirtyattrs[d] in params) {
                res._.dirty = 1;
                break;
            }

            // text-anchor emulation
            switch (a["text-anchor"]) {
                case "start":
                    res.textpath.style["v-text-align"] = "left";
                    res.bbx = res.W / 2;
                break;
                case "end":
                    res.textpath.style["v-text-align"] = "right";
                    res.bbx = -res.W / 2;
                break;
                default:
                    res.textpath.style["v-text-align"] = "center";
                    res.bbx = 0;
                break;
            }
            res.textpath.style["v-text-kern"] = true;
        }
        // res.paper.canvas.style.display = E;
    },
    addGradientFill = function (o, gradient, fill) {
        o.attrs = o.attrs || {};
        var attrs = o.attrs,
            pow = Math.pow,
            opacity,
            oindex,
            type = "linear",
            fxfy = ".5 .5";
        o.attrs.gradient = gradient;
        gradient = Str(gradient).replace(R._radial_gradient, function (all, fx, fy) {
            type = "radial";
            if (fx && fy) {
                fx = toFloat(fx);
                fy = toFloat(fy);
                pow(fx - .5, 2) + pow(fy - .5, 2) > .25 && (fy = math.sqrt(.25 - pow(fx - .5, 2)) * ((fy > .5) * 2 - 1) + .5);
                fxfy = fx + S + fy;
            }
            return E;
        });
        gradient = gradient.split(/\s*\-\s*/);
        if (type == "linear") {
            var angle = gradient.shift();
            angle = -toFloat(angle);
            if (isNaN(angle)) {
                return null;
            }
        }
        var dots = R._parseDots(gradient);
        if (!dots) {
            return null;
        }
        o = o.shape || o.node;
        if (dots.length) {
            o.removeChild(fill);
            fill.on = true;
            fill.method = "none";
            fill.color = dots[0].color;
            fill.color2 = dots[dots.length - 1].color;
            var clrs = [];
            for (var i = 0, ii = dots.length; i < ii; i++) {
                dots[i].offset && clrs.push(dots[i].offset + S + dots[i].color);
            }
            fill.colors = clrs.length ? clrs.join() : "0% " + fill.color;
            if (type == "radial") {
                fill.type = "gradientTitle";
                fill.focus = "100%";
                fill.focussize = "0 0";
                fill.focusposition = fxfy;
                fill.angle = 0;
            } else {
                // fill.rotate= true;
                fill.type = "gradient";
                fill.angle = (270 - angle) % 360;
            }
            o.appendChild(fill);
        }
        return 1;
    },
    Element = function (node, vml) {
        this[0] = this.node = node;
        node.raphael = true;
        this.id = R._oid++;
        node.raphaelid = this.id;
        this.X = 0;
        this.Y = 0;
        this.attrs = {};
        this.paper = vml;
        this.matrix = R.matrix();
        this._ = {
            transform: [],
            sx: 1,
            sy: 1,
            dx: 0,
            dy: 0,
            deg: 0,
            dirty: 1,
            dirtyT: 1
        };
        !vml.bottom && (vml.bottom = this);
        this.prev = vml.top;
        vml.top && (vml.top.next = this);
        vml.top = this;
        this.next = null;
    };
    var elproto = R.el;

    Element.prototype = elproto;
    elproto.constructor = Element;
    elproto.transform = function (tstr) {
        if (tstr == null) {
            return this._.transform;
        }
        var vbs = this.paper._viewBoxShift,
            vbt = vbs ? "s" + [vbs.scale, vbs.scale] + "-1-1t" + [vbs.dx, vbs.dy] : E,
            oldt;
        if (vbs) {
            oldt = tstr = Str(tstr).replace(/\.{3}|\u2026/g, this._.transform || E);
        }
        R._extractTransform(this, vbt + tstr);
        var matrix = this.matrix.clone(),
            skew = this.skew,
            o = this.node,
            split,
            isGrad = ~Str(this.attrs.fill).indexOf("-"),
            isPatt = !Str(this.attrs.fill).indexOf("url(");
        matrix.translate(1, 1);
        if (isPatt || isGrad || this.type == "image") {
            skew.matrix = "1 0 0 1";
            skew.offset = "0 0";
            split = matrix.split();
            if ((isGrad && split.noRotation) || !split.isSimple) {
                o.style.filter = matrix.toFilter();
                var bb = this.getBBox(),
                    bbt = this.getBBox(1),
                    dx = bb.x - bbt.x,
                    dy = bb.y - bbt.y;
                o.coordorigin = (dx * -zoom) + S + (dy * -zoom);
                setCoords(this, 1, 1, dx, dy, 0);
            } else {
                o.style.filter = E;
                setCoords(this, split.scalex, split.scaley, split.dx, split.dy, split.rotate);
            }
        } else {
            o.style.filter = E;
            skew.matrix = Str(matrix);
            skew.offset = matrix.offset();
        }
        if (oldt !== null) { // empty string value is true as well
            this._.transform = oldt;
            R._extractTransform(this, oldt);
        }
        return this;
    };
    elproto.rotate = function (deg, cx, cy) {
        if (this.removed) {
            return this;
        }
        if (deg == null) {
            return;
        }
        deg = Str(deg).split(separator);
        if (deg.length - 1) {
            cx = toFloat(deg[1]);
            cy = toFloat(deg[2]);
        }
        deg = toFloat(deg[0]);
        (cy == null) && (cx = cy);
        if (cx == null || cy == null) {
            var bbox = this.getBBox(1);
            cx = bbox.x + bbox.width / 2;
            cy = bbox.y + bbox.height / 2;
        }
        this._.dirtyT = 1;
        this.transform(this._.transform.concat([["r", deg, cx, cy]]));
        return this;
    };
    elproto.translate = function (dx, dy) {
        if (this.removed) {
            return this;
        }
        dx = Str(dx).split(separator);
        if (dx.length - 1) {
            dy = toFloat(dx[1]);
        }
        dx = toFloat(dx[0]) || 0;
        dy = +dy || 0;
        if (this._.bbox) {
            this._.bbox.x += dx;
            this._.bbox.y += dy;
        }
        this.transform(this._.transform.concat([["t", dx, dy]]));
        return this;
    };
    elproto.scale = function (sx, sy, cx, cy) {
        if (this.removed) {
            return this;
        }
        sx = Str(sx).split(separator);
        if (sx.length - 1) {
            sy = toFloat(sx[1]);
            cx = toFloat(sx[2]);
            cy = toFloat(sx[3]);
            isNaN(cx) && (cx = null);
            isNaN(cy) && (cy = null);
        }
        sx = toFloat(sx[0]);
        (sy == null) && (sy = sx);
        (cy == null) && (cx = cy);
        if (cx == null || cy == null) {
            var bbox = this.getBBox(1);
        }
        cx = cx == null ? bbox.x + bbox.width / 2 : cx;
        cy = cy == null ? bbox.y + bbox.height / 2 : cy;

        this.transform(this._.transform.concat([["s", sx, sy, cx, cy]]));
        this._.dirtyT = 1;
        return this;
    };
    elproto.hide = function () {
        !this.removed && (this.node.style.display = "none");
        return this;
    };
    elproto.show = function () {
        !this.removed && (this.node.style.display = E);
        return this;
    };
    // Needed to fix the vml setViewBox issues
    elproto.auxGetBBox = R.el.getBBox;
    elproto.getBBox = function(){
      var b = this.auxGetBBox();
      if (this.paper && this.paper._viewBoxShift)
      {
        var c = {};
        var z = 1/this.paper._viewBoxShift.scale;
        c.x = b.x - this.paper._viewBoxShift.dx;
        c.x *= z;
        c.y = b.y - this.paper._viewBoxShift.dy;
        c.y *= z;
        c.width  = b.width  * z;
        c.height = b.height * z;
        c.x2 = c.x + c.width;
        c.y2 = c.y + c.height;
        return c;
      }
      return b;
    };
    elproto._getBBox = function () {
        if (this.removed) {
            return {};
        }
        return {
            x: this.X + (this.bbx || 0) - this.W / 2,
            y: this.Y - this.H,
            width: this.W,
            height: this.H
        };
    };
    elproto.remove = function () {
        if (this.removed || !this.node.parentNode) {
            return;
        }
        this.paper.__set__ && this.paper.__set__.exclude(this);
        R.eve.unbind("raphael.*.*." + this.id);
        R._tear(this, this.paper);
        this.node.parentNode.removeChild(this.node);
        this.shape && this.shape.parentNode.removeChild(this.shape);
        for (var i in this) {
            this[i] = typeof this[i] == "function" ? R._removedFactory(i) : null;
        }
        this.removed = true;
    };
    elproto.attr = function (name, value) {
        if (this.removed) {
            return this;
        }
        if (name == null) {
            var res = {};
            for (var a in this.attrs) if (this.attrs[has](a)) {
                res[a] = this.attrs[a];
            }
            res.gradient && res.fill == "none" && (res.fill = res.gradient) && delete res.gradient;
            res.transform = this._.transform;
            return res;
        }
        if (value == null && R.is(name, "string")) {
            if (name == fillString && this.attrs.fill == "none" && this.attrs.gradient) {
                return this.attrs.gradient;
            }
            var names = name.split(separator),
                out = {};
            for (var i = 0, ii = names.length; i < ii; i++) {
                name = names[i];
                if (name in this.attrs) {
                    out[name] = this.attrs[name];
                } else if (R.is(this.paper.customAttributes[name], "function")) {
                    out[name] = this.paper.customAttributes[name].def;
                } else {
                    out[name] = R._availableAttrs[name];
                }
            }
            return ii - 1 ? out : out[names[0]];
        }
        if (this.attrs && value == null && R.is(name, "array")) {
            out = {};
            for (i = 0, ii = name.length; i < ii; i++) {
                out[name[i]] = this.attr(name[i]);
            }
            return out;
        }
        var params;
        if (value != null) {
            params = {};
            params[name] = value;
        }
        value == null && R.is(name, "object") && (params = name);
        for (var key in params) {
            eve("raphael.attr." + key + "." + this.id, this, params[key]);
        }
        if (params) {
            for (key in this.paper.customAttributes) if (this.paper.customAttributes[has](key) && params[has](key) && R.is(this.paper.customAttributes[key], "function")) {
                var par = this.paper.customAttributes[key].apply(this, [].concat(params[key]));
                this.attrs[key] = params[key];
                for (var subkey in par) if (par[has](subkey)) {
                    params[subkey] = par[subkey];
                }
            }
            // this.paper.canvas.style.display = "none";
            if (params.text && this.type == "text") {
                this.textpath.string = params.text;
            }
            setFillAndStroke(this, params);
            // this.paper.canvas.style.display = E;
        }
        return this;
    };
    elproto.toFront = function () {
        !this.removed && this.node.parentNode.appendChild(this.node);
        this.paper && this.paper.top != this && R._tofront(this, this.paper);
        return this;
    };
    elproto.toBack = function () {
        if (this.removed) {
            return this;
        }
        if (this.node.parentNode.firstChild != this.node) {
            this.node.parentNode.insertBefore(this.node, this.node.parentNode.firstChild);
            R._toback(this, this.paper);
        }
        return this;
    };
    elproto.insertAfter = function (element) {
        if (this.removed) {
            return this;
        }
        if (element.constructor == R.st.constructor) {
            element = element[element.length - 1];
        }
        if (element.node.nextSibling) {
            element.node.parentNode.insertBefore(this.node, element.node.nextSibling);
        } else {
            element.node.parentNode.appendChild(this.node);
        }
        R._insertafter(this, element, this.paper);
        return this;
    };
    elproto.insertBefore = function (element) {
        if (this.removed) {
            return this;
        }
        if (element.constructor == R.st.constructor) {
            element = element[0];
        }
        element.node.parentNode.insertBefore(this.node, element.node);
        R._insertbefore(this, element, this.paper);
        return this;
    };
    elproto.blur = function (size) {
        var s = this.node.runtimeStyle,
            f = s.filter;
        f = f.replace(blurregexp, E);
        if (+size !== 0) {
            this.attrs.blur = size;
            s.filter = f + S + ms + ".Blur(pixelradius=" + (+size || 1.5) + ")";
            s.margin = R.format("-{0}px 0 0 -{0}px", round(+size || 1.5));
        } else {
            s.filter = f;
            s.margin = 0;
            delete this.attrs.blur;
        }
        return this;
    };

    R._engine.path = function (pathString, vml) {
        var el = createNode("shape");
        el.style.cssText = cssDot;
        el.coordsize = zoom + S + zoom;
        el.coordorigin = vml.coordorigin;
        var p = new Element(el, vml),
            attr = {fill: "none", stroke: "#000"};
        pathString && (attr.path = pathString);
        p.type = "path";
        p.path = [];
        p.Path = E;
        setFillAndStroke(p, attr);
        vml.canvas && vml.canvas.appendChild(el);
        var skew = createNode("skew");
        skew.on = true;
        el.appendChild(skew);
        p.skew = skew;
        p.transform(E);
        return p;
    };
    R._engine.rect = function (vml, x, y, w, h, r) {
        var path = R._rectPath(x, y, w, h, r),
            res = vml.path(path),
            a = res.attrs;
        res.X = a.x = x;
        res.Y = a.y = y;
        res.W = a.width = w;
        res.H = a.height = h;
        a.r = r;
        a.path = path;
        res.type = "rect";
        return res;
    };
    R._engine.ellipse = function (vml, x, y, rx, ry) {
        var res = vml.path(),
            a = res.attrs;
        res.X = x - rx;
        res.Y = y - ry;
        res.W = rx * 2;
        res.H = ry * 2;
        res.type = "ellipse";
        setFillAndStroke(res, {
            cx: x,
            cy: y,
            rx: rx,
            ry: ry
        });
        return res;
    };
    R._engine.circle = function (vml, x, y, r) {
        var res = vml.path(),
            a = res.attrs;
        res.X = x - r;
        res.Y = y - r;
        res.W = res.H = r * 2;
        res.type = "circle";
        setFillAndStroke(res, {
            cx: x,
            cy: y,
            r: r
        });
        return res;
    };
    R._engine.image = function (vml, src, x, y, w, h) {
        var path = R._rectPath(x, y, w, h),
            res = vml.path(path).attr({stroke: "none"}),
            a = res.attrs,
            node = res.node,
            fill = node.getElementsByTagName(fillString)[0];
        a.src = src;
        res.X = a.x = x;
        res.Y = a.y = y;
        res.W = a.width = w;
        res.H = a.height = h;
        a.path = path;
        res.type = "image";
        fill.parentNode == node && node.removeChild(fill);
        fill.rotate = true;
        fill.src = src;
        fill.type = "tile";
        res._.fillpos = [x, y];
        res._.fillsize = [w, h];
        node.appendChild(fill);
        setCoords(res, 1, 1, 0, 0, 0);
        return res;
    };
    R._engine.text = function (vml, x, y, text) {
        var el = createNode("shape"),
            path = createNode("path"),
            o = createNode("textpath");
        x = x || 0;
        y = y || 0;
        text = text || "";
        path.v = R.format("m{0},{1}l{2},{1}", round(x * zoom), round(y * zoom), round(x * zoom) + 1);
        path.textpathok = true;
        o.string = Str(text);
        o.on = true;
        el.style.cssText = cssDot;
        el.coordsize = zoom + S + zoom;
        el.coordorigin = "0 0";
        var p = new Element(el, vml),
            attr = {
                fill: "#000",
                stroke: "none",
                font: R._availableAttrs.font,
                text: text
            };
        p.shape = el;
        p.path = path;
        p.textpath = o;
        p.type = "text";
        p.attrs.text = Str(text);
        p.attrs.x = x;
        p.attrs.y = y;
        p.attrs.w = 1;
        p.attrs.h = 1;
        setFillAndStroke(p, attr);
        el.appendChild(o);
        el.appendChild(path);
        vml.canvas.appendChild(el);
        var skew = createNode("skew");
        skew.on = true;
        el.appendChild(skew);
        p.skew = skew;
        p.transform(E);
        return p;
    };
    R._engine.setSize = function (width, height) {
        var cs = this.canvas.style;
        this.width = width;
        this.height = height;
        width == +width && (width += "px");
        height == +height && (height += "px");
        cs.width = width;
        cs.height = height;
        cs.clip = "rect(0 " + width + " " + height + " 0)";
        if (this._viewBox) {
            R._engine.setViewBox.apply(this, this._viewBox);
        }
        return this;
    };
    R._engine.setViewBox = function (x, y, w, h, fit) {
        R.eve("raphael.setViewBox", this, this._viewBox, [x, y, w, h, fit]);
        var paperSize = this.getSize(),
            width = paperSize.width,
            height = paperSize.height,
            H, W;
        if (fit) {
            H = height / h;
            W = width / w;
            if (w * H < width) {
                x -= (width - w * H) / 2 / H;
            }
            if (h * W < height) {
                y -= (height - h * W) / 2 / W;
            }
        }
        this._viewBox = [x, y, w, h, !!fit];
        this._viewBoxShift = {
            dx: -x,
            dy: -y,
            scale: paperSize
        };
        this.forEach(function (el) {
            el.transform("...");
        });
        return this;
    };
    var createNode;
    R._engine.initWin = function (win) {
            var doc = win.document;
            if (doc.styleSheets.length < 31) {
                doc.createStyleSheet().addRule(".rvml", "behavior:url(#default#VML)");
            } else {
                // no more room, add to the existing one
                // http://msdn.microsoft.com/en-us/library/ms531194%28VS.85%29.aspx
                doc.styleSheets[0].addRule(".rvml", "behavior:url(#default#VML)");
            }
            try {
                !doc.namespaces.rvml && doc.namespaces.add("rvml", "urn:schemas-microsoft-com:vml");
                createNode = function (tagName) {
                    return doc.createElement('<rvml:' + tagName + ' class="rvml">');
                };
            } catch (e) {
                createNode = function (tagName) {
                    return doc.createElement('<' + tagName + ' xmlns="urn:schemas-microsoft.com:vml" class="rvml">');
                };
            }
        };
    R._engine.initWin(R._g.win);
    R._engine.create = function () {
        var con = R._getContainer.apply(0, arguments),
            container = con.container,
            height = con.height,
            s,
            width = con.width,
            x = con.x,
            y = con.y;
        if (!container) {
            throw new Error("VML container not found.");
        }
        var res = new R._Paper,
            c = res.canvas = R._g.doc.createElement("div"),
            cs = c.style;
        x = x || 0;
        y = y || 0;
        width = width || 512;
        height = height || 342;
        res.width = width;
        res.height = height;
        width == +width && (width += "px");
        height == +height && (height += "px");
        res.coordsize = zoom * 1e3 + S + zoom * 1e3;
        res.coordorigin = "0 0";
        res.span = R._g.doc.createElement("span");
        res.span.style.cssText = "position:absolute;left:-9999em;top:-9999em;padding:0;margin:0;line-height:1;";
        c.appendChild(res.span);
        cs.cssText = R.format("top:0;left:0;width:{0};height:{1};display:inline-block;position:relative;clip:rect(0 {0} {1} 0);overflow:hidden", width, height);
        if (container == 1) {
            R._g.doc.body.appendChild(c);
            cs.left = x + "px";
            cs.top = y + "px";
            cs.position = "absolute";
        } else {
            if (container.firstChild) {
                container.insertBefore(c, container.firstChild);
            } else {
                container.appendChild(c);
            }
        }
        res.renderfix = function () {};
        return res;
    };
    R.prototype.clear = function () {
        R.eve("raphael.clear", this);
        this.canvas.innerHTML = E;
        this.span = R._g.doc.createElement("span");
        this.span.style.cssText = "position:absolute;left:-9999em;top:-9999em;padding:0;margin:0;line-height:1;display:inline;";
        this.canvas.appendChild(this.span);
        this.bottom = this.top = null;
    };
    R.prototype.remove = function () {
        R.eve("raphael.remove", this);
        this.canvas.parentNode.removeChild(this.canvas);
        for (var i in this) {
            this[i] = typeof this[i] == "function" ? R._removedFactory(i) : null;
        }
        return true;
    };

    var setproto = R.st;
    for (var method in elproto) if (elproto[has](method) && !setproto[has](method)) {
        setproto[method] = (function (methodname) {
            return function () {
                var arg = arguments;
                return this.forEach(function (el) {
                    el[methodname].apply(el, arg);
                });
            };
        })(method);
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./node_modules/eve-raphael/eve.js":
/*!*****************************************!*\
  !*** ./node_modules/eve-raphael/eve.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
// 
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// 
// http://www.apache.org/licenses/LICENSE-2.0
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// ┌────────────────────────────────────────────────────────────┐ \\
// │ Eve 0.5.0 - JavaScript Events Library                      │ \\
// ├────────────────────────────────────────────────────────────┤ \\
// │ Author Dmitry Baranovskiy (http://dmitry.baranovskiy.com/) │ \\
// └────────────────────────────────────────────────────────────┘ \\

(function (glob) {
    var version = "0.5.0",
        has = "hasOwnProperty",
        separator = /[\.\/]/,
        comaseparator = /\s*,\s*/,
        wildcard = "*",
        fun = function () {},
        numsort = function (a, b) {
            return a - b;
        },
        current_event,
        stop,
        events = {n: {}},
        firstDefined = function () {
            for (var i = 0, ii = this.length; i < ii; i++) {
                if (typeof this[i] != "undefined") {
                    return this[i];
                }
            }
        },
        lastDefined = function () {
            var i = this.length;
            while (--i) {
                if (typeof this[i] != "undefined") {
                    return this[i];
                }
            }
        },
        objtos = Object.prototype.toString,
        Str = String,
        isArray = Array.isArray || function (ar) {
            return ar instanceof Array || objtos.call(ar) == "[object Array]";
        };
    /*\
     * eve
     [ method ]

     * Fires event with given `name`, given scope and other parameters.

     > Arguments

     - name (string) name of the *event*, dot (`.`) or slash (`/`) separated
     - scope (object) context for the event handlers
     - varargs (...) the rest of arguments will be sent to event handlers

     = (object) array of returned values from the listeners. Array has two methods `.firstDefined()` and `.lastDefined()` to get first or last not `undefined` value.
    \*/
        var eve = function (name, scope) {
            var e = events,
                oldstop = stop,
                args = Array.prototype.slice.call(arguments, 2),
                listeners = eve.listeners(name),
                z = 0,
                f = false,
                l,
                indexed = [],
                queue = {},
                out = [],
                ce = current_event,
                errors = [];
            out.firstDefined = firstDefined;
            out.lastDefined = lastDefined;
            current_event = name;
            stop = 0;
            for (var i = 0, ii = listeners.length; i < ii; i++) if ("zIndex" in listeners[i]) {
                indexed.push(listeners[i].zIndex);
                if (listeners[i].zIndex < 0) {
                    queue[listeners[i].zIndex] = listeners[i];
                }
            }
            indexed.sort(numsort);
            while (indexed[z] < 0) {
                l = queue[indexed[z++]];
                out.push(l.apply(scope, args));
                if (stop) {
                    stop = oldstop;
                    return out;
                }
            }
            for (i = 0; i < ii; i++) {
                l = listeners[i];
                if ("zIndex" in l) {
                    if (l.zIndex == indexed[z]) {
                        out.push(l.apply(scope, args));
                        if (stop) {
                            break;
                        }
                        do {
                            z++;
                            l = queue[indexed[z]];
                            l && out.push(l.apply(scope, args));
                            if (stop) {
                                break;
                            }
                        } while (l)
                    } else {
                        queue[l.zIndex] = l;
                    }
                } else {
                    out.push(l.apply(scope, args));
                    if (stop) {
                        break;
                    }
                }
            }
            stop = oldstop;
            current_event = ce;
            return out;
        };
        // Undocumented. Debug only.
        eve._events = events;
    /*\
     * eve.listeners
     [ method ]

     * Internal method which gives you array of all event handlers that will be triggered by the given `name`.

     > Arguments

     - name (string) name of the event, dot (`.`) or slash (`/`) separated

     = (array) array of event handlers
    \*/
    eve.listeners = function (name) {
        var names = isArray(name) ? name : name.split(separator),
            e = events,
            item,
            items,
            k,
            i,
            ii,
            j,
            jj,
            nes,
            es = [e],
            out = [];
        for (i = 0, ii = names.length; i < ii; i++) {
            nes = [];
            for (j = 0, jj = es.length; j < jj; j++) {
                e = es[j].n;
                items = [e[names[i]], e[wildcard]];
                k = 2;
                while (k--) {
                    item = items[k];
                    if (item) {
                        nes.push(item);
                        out = out.concat(item.f || []);
                    }
                }
            }
            es = nes;
        }
        return out;
    };
    /*\
     * eve.separator
     [ method ]

     * If for some reasons you don’t like default separators (`.` or `/`) you can specify yours
     * here. Be aware that if you pass a string longer than one character it will be treated as
     * a list of characters.

     - separator (string) new separator. Empty string resets to default: `.` or `/`.
    \*/
    eve.separator = function (sep) {
        if (sep) {
            sep = Str(sep).replace(/(?=[\.\^\]\[\-])/g, "\\");
            sep = "[" + sep + "]";
            separator = new RegExp(sep);
        } else {
            separator = /[\.\/]/;
        }
    };
    /*\
     * eve.on
     [ method ]
     **
     * Binds given event handler with a given name. You can use wildcards “`*`” for the names:
     | eve.on("*.under.*", f);
     | eve("mouse.under.floor"); // triggers f
     * Use @eve to trigger the listener.
     **
     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
     - f (function) event handler function
     **
     - name (array) if you don’t want to use separators, you can use array of strings
     - f (function) event handler function
     **
     = (function) returned function accepts a single numeric parameter that represents z-index of the handler. It is an optional feature and only used when you need to ensure that some subset of handlers will be invoked in a given order, despite of the order of assignment. 
     > Example:
     | eve.on("mouse", eatIt)(2);
     | eve.on("mouse", scream);
     | eve.on("mouse", catchIt)(1);
     * This will ensure that `catchIt` function will be called before `eatIt`.
     *
     * If you want to put your handler before non-indexed handlers, specify a negative value.
     * Note: I assume most of the time you don’t need to worry about z-index, but it’s nice to have this feature “just in case”.
    \*/
    eve.on = function (name, f) {
        if (typeof f != "function") {
            return function () {};
        }
        var names = isArray(name) ? (isArray(name[0]) ? name : [name]) : Str(name).split(comaseparator);
        for (var i = 0, ii = names.length; i < ii; i++) {
            (function (name) {
                var names = isArray(name) ? name : Str(name).split(separator),
                    e = events,
                    exist;
                for (var i = 0, ii = names.length; i < ii; i++) {
                    e = e.n;
                    e = e.hasOwnProperty(names[i]) && e[names[i]] || (e[names[i]] = {n: {}});
                }
                e.f = e.f || [];
                for (i = 0, ii = e.f.length; i < ii; i++) if (e.f[i] == f) {
                    exist = true;
                    break;
                }
                !exist && e.f.push(f);
            }(names[i]));
        }
        return function (zIndex) {
            if (+zIndex == +zIndex) {
                f.zIndex = +zIndex;
            }
        };
    };
    /*\
     * eve.f
     [ method ]
     **
     * Returns function that will fire given event with optional arguments.
     * Arguments that will be passed to the result function will be also
     * concated to the list of final arguments.
     | el.onclick = eve.f("click", 1, 2);
     | eve.on("click", function (a, b, c) {
     |     console.log(a, b, c); // 1, 2, [event object]
     | });
     > Arguments
     - event (string) event name
     - varargs (…) and any other arguments
     = (function) possible event handler function
    \*/
    eve.f = function (event) {
        var attrs = [].slice.call(arguments, 1);
        return function () {
            eve.apply(null, [event, null].concat(attrs).concat([].slice.call(arguments, 0)));
        };
    };
    /*\
     * eve.stop
     [ method ]
     **
     * Is used inside an event handler to stop the event, preventing any subsequent listeners from firing.
    \*/
    eve.stop = function () {
        stop = 1;
    };
    /*\
     * eve.nt
     [ method ]
     **
     * Could be used inside event handler to figure out actual name of the event.
     **
     > Arguments
     **
     - subname (string) #optional subname of the event
     **
     = (string) name of the event, if `subname` is not specified
     * or
     = (boolean) `true`, if current event’s name contains `subname`
    \*/
    eve.nt = function (subname) {
        var cur = isArray(current_event) ? current_event.join(".") : current_event;
        if (subname) {
            return new RegExp("(?:\\.|\\/|^)" + subname + "(?:\\.|\\/|$)").test(cur);
        }
        return cur;
    };
    /*\
     * eve.nts
     [ method ]
     **
     * Could be used inside event handler to figure out actual name of the event.
     **
     **
     = (array) names of the event
    \*/
    eve.nts = function () {
        return isArray(current_event) ? current_event : current_event.split(separator);
    };
    /*\
     * eve.off
     [ method ]
     **
     * Removes given function from the list of event listeners assigned to given name.
     * If no arguments specified all the events will be cleared.
     **
     > Arguments
     **
     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
     - f (function) event handler function
    \*/
    /*\
     * eve.unbind
     [ method ]
     **
     * See @eve.off
    \*/
    eve.off = eve.unbind = function (name, f) {
        if (!name) {
            eve._events = events = {n: {}};
            return;
        }
        var names = isArray(name) ? (isArray(name[0]) ? name : [name]) : Str(name).split(comaseparator);
        if (names.length > 1) {
            for (var i = 0, ii = names.length; i < ii; i++) {
                eve.off(names[i], f);
            }
            return;
        }
        names = isArray(name) ? name : Str(name).split(separator);
        var e,
            key,
            splice,
            i, ii, j, jj,
            cur = [events];
        for (i = 0, ii = names.length; i < ii; i++) {
            for (j = 0; j < cur.length; j += splice.length - 2) {
                splice = [j, 1];
                e = cur[j].n;
                if (names[i] != wildcard) {
                    if (e[names[i]]) {
                        splice.push(e[names[i]]);
                    }
                } else {
                    for (key in e) if (e[has](key)) {
                        splice.push(e[key]);
                    }
                }
                cur.splice.apply(cur, splice);
            }
        }
        for (i = 0, ii = cur.length; i < ii; i++) {
            e = cur[i];
            while (e.n) {
                if (f) {
                    if (e.f) {
                        for (j = 0, jj = e.f.length; j < jj; j++) if (e.f[j] == f) {
                            e.f.splice(j, 1);
                            break;
                        }
                        !e.f.length && delete e.f;
                    }
                    for (key in e.n) if (e.n[has](key) && e.n[key].f) {
                        var funcs = e.n[key].f;
                        for (j = 0, jj = funcs.length; j < jj; j++) if (funcs[j] == f) {
                            funcs.splice(j, 1);
                            break;
                        }
                        !funcs.length && delete e.n[key].f;
                    }
                } else {
                    delete e.f;
                    for (key in e.n) if (e.n[has](key) && e.n[key].f) {
                        delete e.n[key].f;
                    }
                }
                e = e.n;
            }
        }
    };
    /*\
     * eve.once
     [ method ]
     **
     * Binds given event handler with a given name to only run once then unbind itself.
     | eve.once("login", f);
     | eve("login"); // triggers f
     | eve("login"); // no listeners
     * Use @eve to trigger the listener.
     **
     > Arguments
     **
     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
     - f (function) event handler function
     **
     = (function) same return function as @eve.on
    \*/
    eve.once = function (name, f) {
        var f2 = function () {
            eve.off(name, f2);
            return f.apply(this, arguments);
        };
        return eve.on(name, f2);
    };
    /*\
     * eve.version
     [ property (string) ]
     **
     * Current version of the library.
    \*/
    eve.version = version;
    eve.toString = function () {
        return "You are running Eve " + version;
    };
    ( true && module.exports) ? (module.exports = eve) : ( true ? (!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() { return eve; }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))) : (undefined));
})(this);


/***/ })

/******/ });
});
!function(e,r){"object"==typeof exports&&"object"==typeof module?module.exports=r():"function"==typeof define&&define.amd?define([],r):"object"==typeof exports?exports.rgbAsterLib=r():e.rgbAsterLib=r()}(self,(()=>(()=>{var e={728:function(e){var r,t;e.exports=(r=function(e,r){void 0===r&&(r=1);var t=new Image;return e.startsWith("data")||(t.crossOrigin="Anonymous"),new Promise((function(o,n){t.onload=function(){var e=t.width*r,n=t.height*r,a=function(e,r){var t=document.createElement("canvas");return t.setAttribute("width",e),t.setAttribute("height",r),t.getContext("2d")}(e,n);a.drawImage(t,0,0,e,n);var i=a.getImageData(0,0,e,n);o(i.data)};var a=function(){return n(new Error("An error occurred attempting to load image"))};t.onerror=a,t.onabort=a,t.src=e}))},t={ignore:[],scale:1},function(e,o){void 0===o&&(o=t);try{var n=(o=Object.assign({},t,o)).ignore,a=o.scale;return(a>1||a<=0)&&console.warn("You set scale to "+a+", which isn't between 0-1. This is either pointless (> 1) or a no-op (≤ 0)"),Promise.resolve(r(e,a)).then((function(e){return function(e,r){for(var t={},o=0;o<e.length;o+=4){var n=e[o+3];if(0!==n){var a=Array.from(e.subarray(o,o+3));if(-1===a.indexOf(void 0)){var i=n&&255!==n?"rgba("+a.concat([n]).join(",")+")":"rgb("+a.join(",")+")";-1===r.indexOf(i)&&(t[i]?t[i].count++:t[i]={color:i,count:1})}}}return Object.values(t).sort((function(e,r){return r.count-e.count}))}(e,n)}))}catch(e){return Promise.reject(e)}})}},r={};function t(o){var n=r[o];if(void 0!==n)return n.exports;var a=r[o]={exports:{}};return e[o].call(a.exports,a,a.exports,t),a.exports}t.n=e=>{var r=e&&e.__esModule?()=>e.default:()=>e;return t.d(r,{a:r}),r},t.d=(e,r)=>{for(var o in r)t.o(r,o)&&!t.o(e,o)&&Object.defineProperty(e,o,{enumerable:!0,get:r[o]})},t.o=(e,r)=>Object.prototype.hasOwnProperty.call(e,r),t.r=e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})};var o={};return(()=>{"use strict";t.r(o),t.d(o,{rgbAster:()=>r});var e=t(728),r=t.n(e)()})(),o})()));
//# sourceMappingURL=assets\customizer\Scripts\libs\rgbaster\rgbaster.js.map
/*! For license information please see replace_color.js.LICENSE.txt */
!function(t,e){"object"==typeof exports&&"object"==typeof module?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.replaceColorLib=e():t.replaceColorLib=e()}(self,(()=>(()=>{var t={30:t=>{"use strict";function e(t,e){this.x1=t,this.x2=e}e.prototype.getDeltaE=function(){var t=this.x1,e=this.x2;return Math.sqrt(Math.pow(e.L-t.L,2)+Math.pow(e.A-t.A,2)+Math.pow(e.B-t.B,2))},t.exports=e},31:t=>{"use strict";t.exports={aliceblue:[240,248,255],antiquewhite:[250,235,215],aqua:[0,255,255],aquamarine:[127,255,212],azure:[240,255,255],beige:[245,245,220],bisque:[255,228,196],black:[0,0,0],blanchedalmond:[255,235,205],blue:[0,0,255],blueviolet:[138,43,226],brown:[165,42,42],burlywood:[222,184,135],cadetblue:[95,158,160],chartreuse:[127,255,0],chocolate:[210,105,30],coral:[255,127,80],cornflowerblue:[100,149,237],cornsilk:[255,248,220],crimson:[220,20,60],cyan:[0,255,255],darkblue:[0,0,139],darkcyan:[0,139,139],darkgoldenrod:[184,134,11],darkgray:[169,169,169],darkgreen:[0,100,0],darkgrey:[169,169,169],darkkhaki:[189,183,107],darkmagenta:[139,0,139],darkolivegreen:[85,107,47],darkorange:[255,140,0],darkorchid:[153,50,204],darkred:[139,0,0],darksalmon:[233,150,122],darkseagreen:[143,188,143],darkslateblue:[72,61,139],darkslategray:[47,79,79],darkslategrey:[47,79,79],darkturquoise:[0,206,209],darkviolet:[148,0,211],deeppink:[255,20,147],deepskyblue:[0,191,255],dimgray:[105,105,105],dimgrey:[105,105,105],dodgerblue:[30,144,255],firebrick:[178,34,34],floralwhite:[255,250,240],forestgreen:[34,139,34],fuchsia:[255,0,255],gainsboro:[220,220,220],ghostwhite:[248,248,255],gold:[255,215,0],goldenrod:[218,165,32],gray:[128,128,128],green:[0,128,0],greenyellow:[173,255,47],grey:[128,128,128],honeydew:[240,255,240],hotpink:[255,105,180],indianred:[205,92,92],indigo:[75,0,130],ivory:[255,255,240],khaki:[240,230,140],lavender:[230,230,250],lavenderblush:[255,240,245],lawngreen:[124,252,0],lemonchiffon:[255,250,205],lightblue:[173,216,230],lightcoral:[240,128,128],lightcyan:[224,255,255],lightgoldenrodyellow:[250,250,210],lightgray:[211,211,211],lightgreen:[144,238,144],lightgrey:[211,211,211],lightpink:[255,182,193],lightsalmon:[255,160,122],lightseagreen:[32,178,170],lightskyblue:[135,206,250],lightslategray:[119,136,153],lightslategrey:[119,136,153],lightsteelblue:[176,196,222],lightyellow:[255,255,224],lime:[0,255,0],limegreen:[50,205,50],linen:[250,240,230],magenta:[255,0,255],maroon:[128,0,0],mediumaquamarine:[102,205,170],mediumblue:[0,0,205],mediumorchid:[186,85,211],mediumpurple:[147,112,219],mediumseagreen:[60,179,113],mediumslateblue:[123,104,238],mediumspringgreen:[0,250,154],mediumturquoise:[72,209,204],mediumvioletred:[199,21,133],midnightblue:[25,25,112],mintcream:[245,255,250],mistyrose:[255,228,225],moccasin:[255,228,181],navajowhite:[255,222,173],navy:[0,0,128],oldlace:[253,245,230],olive:[128,128,0],olivedrab:[107,142,35],orange:[255,165,0],orangered:[255,69,0],orchid:[218,112,214],palegoldenrod:[238,232,170],palegreen:[152,251,152],paleturquoise:[175,238,238],palevioletred:[219,112,147],papayawhip:[255,239,213],peachpuff:[255,218,185],peru:[205,133,63],pink:[255,192,203],plum:[221,160,221],powderblue:[176,224,230],purple:[128,0,128],rebeccapurple:[102,51,153],red:[255,0,0],rosybrown:[188,143,143],royalblue:[65,105,225],saddlebrown:[139,69,19],salmon:[250,128,114],sandybrown:[244,164,96],seagreen:[46,139,87],seashell:[255,245,238],sienna:[160,82,45],silver:[192,192,192],skyblue:[135,206,235],slateblue:[106,90,205],slategray:[112,128,144],slategrey:[112,128,144],snow:[255,250,250],springgreen:[0,255,127],steelblue:[70,130,180],tan:[210,180,140],teal:[0,128,128],thistle:[216,191,216],tomato:[255,99,71],turquoise:[64,224,208],violet:[238,130,238],wheat:[245,222,179],white:[255,255,255],whitesmoke:[245,245,245],yellow:[255,255,0],yellowgreen:[154,205,50]}},54:(t,e,r)=>{"use strict";var n=r(30),i=r(794),a=r(267);function o(){}o.prototype.getDeltaE76=function(t,e){return new n(t,e).getDeltaE()},o.prototype.getDeltaE94=function(t,e){return new i(t,e).getDeltaE()},o.prototype.getDeltaE00=function(t,e){return new a(t,e).getDeltaE()},t.exports=new o},76:t=>{t.exports=t=>!isNaN(parseFloat(t))&&isFinite(t)},133:(t,e,r)=>{const n=r(962),i=r(315);t.exports=n,t.exports.ReplaceColorError=i},220:(t,e,r)=>{if((void 0===n||!n)&&"undefined"!=typeof self)var n=self;t.exports=function t(e,r,n){function i(o,s){if(!r[o]){if(!e[o]){if(a)return a(o,!0);var l=new Error("Cannot find module '"+o+"'");throw l.code="MODULE_NOT_FOUND",l}var u=r[o]={exports:{}};e[o][0].call(u.exports,(function(t){return i(e[o][1][t]||t)}),u,u.exports,t,e,r,n)}return r[o].exports}for(var a=void 0,o=0;o<n.length;o++)i(n[o]);return i}({1:[function(t,e,r){e.exports=function(t){if(Array.isArray(t))return t}},{}],2:[function(t,e,r){e.exports=function(t){if(Array.isArray(t)){for(var e=0,r=new Array(t.length);e<t.length;e++)r[e]=t[e];return r}}},{}],3:[function(t,e,r){e.exports=function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}},{}],4:[function(t,e,r){e.exports=function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}},{}],5:[function(t,e,r){var n=t("./setPrototypeOf");function i(t,r,a){return function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(t){return!1}}()?e.exports=i=Reflect.construct:e.exports=i=function(t,e,r){var i=[null];i.push.apply(i,e);var a=new(Function.bind.apply(t,i));return r&&n(a,r.prototype),a},i.apply(null,arguments)}e.exports=i},{"./setPrototypeOf":17}],6:[function(t,e,r){function n(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}e.exports=function(t,e,r){return e&&n(t.prototype,e),r&&n(t,r),t}},{}],7:[function(t,e,r){e.exports=function(t,e,r){return e in t?Object.defineProperty(t,e,{value:r,enumerable:!0,configurable:!0,writable:!0}):t[e]=r,t}},{}],8:[function(t,e,r){function n(t){return e.exports=n=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)},n(t)}e.exports=n},{}],9:[function(t,e,r){var n=t("./setPrototypeOf");e.exports=function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&n(t,e)}},{"./setPrototypeOf":17}],10:[function(t,e,r){e.exports=function(t){return t&&t.__esModule?t:{default:t}}},{}],11:[function(t,e,r){var n=t("../helpers/typeof");function i(){if("function"!=typeof WeakMap)return null;var t=new WeakMap;return i=function(){return t},t}e.exports=function(t){if(t&&t.__esModule)return t;if(null===t||"object"!==n(t)&&"function"!=typeof t)return{default:t};var e=i();if(e&&e.has(t))return e.get(t);var r={},a=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var o in t)if(Object.prototype.hasOwnProperty.call(t,o)){var s=a?Object.getOwnPropertyDescriptor(t,o):null;s&&(s.get||s.set)?Object.defineProperty(r,o,s):r[o]=t[o]}return r.default=t,e&&e.set(t,r),r}},{"../helpers/typeof":20}],12:[function(t,e,r){e.exports=function(t){if(Symbol.iterator in Object(t)||"[object Arguments]"===Object.prototype.toString.call(t))return Array.from(t)}},{}],13:[function(t,e,r){e.exports=function(t,e){if(Symbol.iterator in Object(t)||"[object Arguments]"===Object.prototype.toString.call(t)){var r=[],n=!0,i=!1,a=void 0;try{for(var o,s=t[Symbol.iterator]();!(n=(o=s.next()).done)&&(r.push(o.value),!e||r.length!==e);n=!0);}catch(t){i=!0,a=t}finally{try{n||null==s.return||s.return()}finally{if(i)throw a}}return r}}},{}],14:[function(t,e,r){e.exports=function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}},{}],15:[function(t,e,r){e.exports=function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}},{}],16:[function(t,e,r){var n=t("../helpers/typeof"),i=t("./assertThisInitialized");e.exports=function(t,e){return!e||"object"!==n(e)&&"function"!=typeof e?i(t):e}},{"../helpers/typeof":20,"./assertThisInitialized":3}],17:[function(t,e,r){function n(t,r){return e.exports=n=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t},n(t,r)}e.exports=n},{}],18:[function(t,e,r){var n=t("./arrayWithHoles"),i=t("./iterableToArrayLimit"),a=t("./nonIterableRest");e.exports=function(t,e){return n(t)||i(t,e)||a()}},{"./arrayWithHoles":1,"./iterableToArrayLimit":13,"./nonIterableRest":14}],19:[function(t,e,r){var n=t("./arrayWithoutHoles"),i=t("./iterableToArray"),a=t("./nonIterableSpread");e.exports=function(t){return n(t)||i(t)||a()}},{"./arrayWithoutHoles":2,"./iterableToArray":12,"./nonIterableSpread":15}],20:[function(t,e,r){function n(t){return n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},n(t)}function i(t){return"function"==typeof Symbol&&"symbol"===n(Symbol.iterator)?e.exports=i=function(t){return n(t)}:e.exports=i=function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":n(t)},i(t)}e.exports=i},{}],21:[function(t,e,r){e.exports=t("regenerator-runtime")},{"regenerator-runtime":332}],22:[function(t,e,r){var n=t("./src/converter");function i(t,e){var r=new n(t,e);return function(t){return r.convert(t)}}i.BIN="01",i.OCT="01234567",i.DEC="0123456789",i.HEX="0123456789abcdef",e.exports=i},{"./src/converter":23}],23:[function(t,e,r){"use strict";function n(t,e){if(!(t&&e&&t.length&&e.length))throw new Error("Bad alphabet");this.srcAlphabet=t,this.dstAlphabet=e}n.prototype.convert=function(t){var e,r,n,i={},a=this.srcAlphabet.length,o=this.dstAlphabet.length,s=t.length,l="string"==typeof t?"":[];if(!this.isValid(t))throw new Error('Number "'+t+'" contains of non-alphabetic digits ('+this.srcAlphabet+")");if(this.srcAlphabet===this.dstAlphabet)return t;for(e=0;e<s;e++)i[e]=this.srcAlphabet.indexOf(t[e]);do{for(r=0,n=0,e=0;e<s;e++)(r=r*a+i[e])>=o?(i[n++]=parseInt(r/o,10),r%=o):n>0&&(i[n++]=0);s=n,l=this.dstAlphabet.slice(r,r+1).concat(l)}while(0!==n);return l},n.prototype.isValid=function(t){for(var e=0;e<t.length;++e)if(-1===this.srcAlphabet.indexOf(t[e]))return!1;return!0},e.exports=n},{}],24:[function(t,e,i){(function(r){"use strict";var n=t("object-assign");function i(t,e){if(t===e)return 0;for(var r=t.length,n=e.length,i=0,a=Math.min(r,n);i<a;++i)if(t[i]!==e[i]){r=t[i],n=e[i];break}return r<n?-1:n<r?1:0}function a(t){return r.Buffer&&"function"==typeof r.Buffer.isBuffer?r.Buffer.isBuffer(t):!(null==t||!t._isBuffer)}var o=t("util/"),s=Object.prototype.hasOwnProperty,l=Array.prototype.slice,u="foo"===function(){}.name;function f(t){return Object.prototype.toString.call(t)}function h(t){return!a(t)&&"function"==typeof r.ArrayBuffer&&("function"==typeof ArrayBuffer.isView?ArrayBuffer.isView(t):!!t&&(t instanceof DataView||!!(t.buffer&&t.buffer instanceof ArrayBuffer)))}var c=e.exports=y,d=/\s*function\s+([^\(\s]*)\s*/;function p(t){if(o.isFunction(t)){if(u)return t.name;var e=t.toString().match(d);return e&&e[1]}}function b(t,e){return"string"==typeof t?t.length<e?t:t.slice(0,e):t}function m(t){if(u||!o.isFunction(t))return o.inspect(t);var e=p(t);return"[Function"+(e?": "+e:"")+"]"}function g(t,e,r,n,i){throw new c.AssertionError({message:r,actual:t,expected:e,operator:n,stackStartFunction:i})}function y(t,e){t||g(t,!0,e,"==",c.ok)}function v(t,e,r,n){if(t===e)return!0;if(a(t)&&a(e))return 0===i(t,e);if(o.isDate(t)&&o.isDate(e))return t.getTime()===e.getTime();if(o.isRegExp(t)&&o.isRegExp(e))return t.source===e.source&&t.global===e.global&&t.multiline===e.multiline&&t.lastIndex===e.lastIndex&&t.ignoreCase===e.ignoreCase;if(null!==t&&"object"==typeof t||null!==e&&"object"==typeof e){if(h(t)&&h(e)&&f(t)===f(e)&&!(t instanceof Float32Array||t instanceof Float64Array))return 0===i(new Uint8Array(t.buffer),new Uint8Array(e.buffer));if(a(t)!==a(e))return!1;var s=(n=n||{actual:[],expected:[]}).actual.indexOf(t);return-1!==s&&s===n.expected.indexOf(e)||(n.actual.push(t),n.expected.push(e),function(t,e,r,n){if(null==t||null==e)return!1;if(o.isPrimitive(t)||o.isPrimitive(e))return t===e;if(r&&Object.getPrototypeOf(t)!==Object.getPrototypeOf(e))return!1;var i=_(t),a=_(e);if(i&&!a||!i&&a)return!1;if(i)return v(t=l.call(t),e=l.call(e),r);var s,u,f=E(t),h=E(e);if(f.length!==h.length)return!1;for(f.sort(),h.sort(),u=f.length-1;u>=0;u--)if(f[u]!==h[u])return!1;for(u=f.length-1;u>=0;u--)if(!v(t[s=f[u]],e[s],r,n))return!1;return!0}(t,e,r,n))}return r?t===e:t==e}function _(t){return"[object Arguments]"==Object.prototype.toString.call(t)}function w(t,e){if(!t||!e)return!1;if("[object RegExp]"==Object.prototype.toString.call(e))return e.test(t);try{if(t instanceof e)return!0}catch(t){}return!Error.isPrototypeOf(e)&&!0===e.call({},t)}function x(t,e,r,n){var i;if("function"!=typeof e)throw new TypeError('"block" argument must be a function');"string"==typeof r&&(n=r,r=null),i=function(t){var e;try{t()}catch(t){e=t}return e}(e),n=(r&&r.name?" ("+r.name+").":".")+(n?" "+n:"."),t&&!i&&g(i,r,"Missing expected exception"+n);var a="string"==typeof n,s=!t&&i&&!r;if((!t&&o.isError(i)&&a&&w(i,r)||s)&&g(i,r,"Got unwanted exception"+n),t&&i&&r&&!w(i,r)||!t&&i)throw i}c.AssertionError=function(t){this.name="AssertionError",this.actual=t.actual,this.expected=t.expected,this.operator=t.operator,t.message?(this.message=t.message,this.generatedMessage=!1):(this.message=function(t){return b(m(t.actual),128)+" "+t.operator+" "+b(m(t.expected),128)}(this),this.generatedMessage=!0);var e=t.stackStartFunction||g;if(Error.captureStackTrace)Error.captureStackTrace(this,e);else{var r=new Error;if(r.stack){var n=r.stack,i=p(e),a=n.indexOf("\n"+i);if(a>=0){var o=n.indexOf("\n",a+1);n=n.substring(o+1)}this.stack=n}}},o.inherits(c.AssertionError,Error),c.fail=g,c.ok=y,c.equal=function(t,e,r){t!=e&&g(t,e,r,"==",c.equal)},c.notEqual=function(t,e,r){t==e&&g(t,e,r,"!=",c.notEqual)},c.deepEqual=function(t,e,r){v(t,e,!1)||g(t,e,r,"deepEqual",c.deepEqual)},c.deepStrictEqual=function(t,e,r){v(t,e,!0)||g(t,e,r,"deepStrictEqual",c.deepStrictEqual)},c.notDeepEqual=function(t,e,r){v(t,e,!1)&&g(t,e,r,"notDeepEqual",c.notDeepEqual)},c.notDeepStrictEqual=function t(e,r,n){v(e,r,!0)&&g(e,r,n,"notDeepStrictEqual",t)},c.strictEqual=function(t,e,r){t!==e&&g(t,e,r,"===",c.strictEqual)},c.notStrictEqual=function(t,e,r){t===e&&g(t,e,r,"!==",c.notStrictEqual)},c.throws=function(t,e,r){x(!0,t,e,r)},c.doesNotThrow=function(t,e,r){x(!1,t,e,r)},c.ifError=function(t){if(t)throw t},c.strict=n((function t(e,r){e||g(e,!0,r,"==",t)}),c,{equal:c.strictEqual,deepEqual:c.deepStrictEqual,notEqual:c.notStrictEqual,notDeepEqual:c.notDeepStrictEqual}),c.strict.strict=c.strict;var E=Object.keys||function(t){var e=[];for(var r in t)s.call(t,r)&&e.push(r);return e}}).call(this,void 0!==r.g?r.g:"undefined"!=typeof self?self:void 0!==n?n:{})},{"object-assign":263,"util/":27}],25:[function(t,e,r){"function"==typeof Object.create?e.exports=function(t,e){t.super_=e,t.prototype=Object.create(e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}})}:e.exports=function(t,e){t.super_=e;var r=function(){};r.prototype=e.prototype,t.prototype=new r,t.prototype.constructor=t}},{}],26:[function(t,e,r){e.exports=function(t){return t&&"object"==typeof t&&"function"==typeof t.copy&&"function"==typeof t.fill&&"function"==typeof t.readUInt8}},{}],27:[function(t,e,i){(function(e,r){var n=/%[sdj%]/g;i.format=function(t){if(!g(t)){for(var e=[],r=0;r<arguments.length;r++)e.push(s(arguments[r]));return e.join(" ")}r=1;for(var i=arguments,a=i.length,o=String(t).replace(n,(function(t){if("%%"===t)return"%";if(r>=a)return t;switch(t){case"%s":return String(i[r++]);case"%d":return Number(i[r++]);case"%j":try{return JSON.stringify(i[r++])}catch(t){return"[Circular]"}default:return t}})),l=i[r];r<a;l=i[++r])b(l)||!_(l)?o+=" "+l:o+=" "+s(l);return o},i.deprecate=function(t,n){if(y(r.process))return function(){return i.deprecate(t,n).apply(this,arguments)};if(!0===e.noDeprecation)return t;var a=!1;return function(){if(!a){if(e.throwDeprecation)throw new Error(n);e.traceDeprecation?console.trace(n):console.error(n),a=!0}return t.apply(this,arguments)}};var a,o={};function s(t,e){var r={seen:[],stylize:u};return arguments.length>=3&&(r.depth=arguments[2]),arguments.length>=4&&(r.colors=arguments[3]),p(e)?r.showHidden=e:e&&i._extend(r,e),y(r.showHidden)&&(r.showHidden=!1),y(r.depth)&&(r.depth=2),y(r.colors)&&(r.colors=!1),y(r.customInspect)&&(r.customInspect=!0),r.colors&&(r.stylize=l),f(r,t,r.depth)}function l(t,e){var r=s.styles[e];return r?"["+s.colors[r][0]+"m"+t+"["+s.colors[r][1]+"m":t}function u(t,e){return t}function f(t,e,r){if(t.customInspect&&e&&E(e.inspect)&&e.inspect!==i.inspect&&(!e.constructor||e.constructor.prototype!==e)){var n=e.inspect(r,t);return g(n)||(n=f(t,n,r)),n}var a=function(t,e){if(y(e))return t.stylize("undefined","undefined");if(g(e)){var r="'"+JSON.stringify(e).replace(/^"|"$/g,"").replace(/'/g,"\\'").replace(/\\"/g,'"')+"'";return t.stylize(r,"string")}return m(e)?t.stylize(""+e,"number"):p(e)?t.stylize(""+e,"boolean"):b(e)?t.stylize("null","null"):void 0}(t,e);if(a)return a;var o=Object.keys(e),s=function(t){var e={};return t.forEach((function(t,r){e[t]=!0})),e}(o);if(t.showHidden&&(o=Object.getOwnPropertyNames(e)),x(e)&&(o.indexOf("message")>=0||o.indexOf("description")>=0))return h(e);if(0===o.length){if(E(e)){var l=e.name?": "+e.name:"";return t.stylize("[Function"+l+"]","special")}if(v(e))return t.stylize(RegExp.prototype.toString.call(e),"regexp");if(w(e))return t.stylize(Date.prototype.toString.call(e),"date");if(x(e))return h(e)}var u,_="",k=!1,j=["{","}"];return d(e)&&(k=!0,j=["[","]"]),E(e)&&(_=" [Function"+(e.name?": "+e.name:"")+"]"),v(e)&&(_=" "+RegExp.prototype.toString.call(e)),w(e)&&(_=" "+Date.prototype.toUTCString.call(e)),x(e)&&(_=" "+h(e)),0!==o.length||k&&0!=e.length?r<0?v(e)?t.stylize(RegExp.prototype.toString.call(e),"regexp"):t.stylize("[Object]","special"):(t.seen.push(e),u=k?function(t,e,r,n,i){for(var a=[],o=0,s=e.length;o<s;++o)A(e,String(o))?a.push(c(t,e,r,n,String(o),!0)):a.push("");return i.forEach((function(i){i.match(/^\d+$/)||a.push(c(t,e,r,n,i,!0))})),a}(t,e,r,s,o):o.map((function(n){return c(t,e,r,s,n,k)})),t.seen.pop(),function(t,e,r){return t.reduce((function(t,e){return e.indexOf("\n"),t+e.replace(/\u001b\[\d\d?m/g,"").length+1}),0)>60?r[0]+(""===e?"":e+"\n ")+" "+t.join(",\n  ")+" "+r[1]:r[0]+e+" "+t.join(", ")+" "+r[1]}(u,_,j)):j[0]+_+j[1]}function h(t){return"["+Error.prototype.toString.call(t)+"]"}function c(t,e,r,n,i,a){var o,s,l;if((l=Object.getOwnPropertyDescriptor(e,i)||{value:e[i]}).get?s=l.set?t.stylize("[Getter/Setter]","special"):t.stylize("[Getter]","special"):l.set&&(s=t.stylize("[Setter]","special")),A(n,i)||(o="["+i+"]"),s||(t.seen.indexOf(l.value)<0?(s=b(r)?f(t,l.value,null):f(t,l.value,r-1)).indexOf("\n")>-1&&(s=a?s.split("\n").map((function(t){return"  "+t})).join("\n").substr(2):"\n"+s.split("\n").map((function(t){return"   "+t})).join("\n")):s=t.stylize("[Circular]","special")),y(o)){if(a&&i.match(/^\d+$/))return s;(o=JSON.stringify(""+i)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)?(o=o.substr(1,o.length-2),o=t.stylize(o,"name")):(o=o.replace(/'/g,"\\'").replace(/\\"/g,'"').replace(/(^"|"$)/g,"'"),o=t.stylize(o,"string"))}return o+": "+s}function d(t){return Array.isArray(t)}function p(t){return"boolean"==typeof t}function b(t){return null===t}function m(t){return"number"==typeof t}function g(t){return"string"==typeof t}function y(t){return void 0===t}function v(t){return _(t)&&"[object RegExp]"===k(t)}function _(t){return"object"==typeof t&&null!==t}function w(t){return _(t)&&"[object Date]"===k(t)}function x(t){return _(t)&&("[object Error]"===k(t)||t instanceof Error)}function E(t){return"function"==typeof t}function k(t){return Object.prototype.toString.call(t)}function j(t){return t<10?"0"+t.toString(10):t.toString(10)}i.debuglog=function(t){if(y(a)&&(a=e.env.NODE_DEBUG||""),t=t.toUpperCase(),!o[t])if(new RegExp("\\b"+t+"\\b","i").test(a)){var r=e.pid;o[t]=function(){var e=i.format.apply(i,arguments);console.error("%s %d: %s",t,r,e)}}else o[t]=function(){};return o[t]},i.inspect=s,s.colors={bold:[1,22],italic:[3,23],underline:[4,24],inverse:[7,27],white:[37,39],grey:[90,39],black:[30,39],blue:[34,39],cyan:[36,39],green:[32,39],magenta:[35,39],red:[31,39],yellow:[33,39]},s.styles={special:"cyan",number:"yellow",boolean:"yellow",undefined:"grey",null:"bold",string:"green",date:"magenta",regexp:"red"},i.isArray=d,i.isBoolean=p,i.isNull=b,i.isNullOrUndefined=function(t){return null==t},i.isNumber=m,i.isString=g,i.isSymbol=function(t){return"symbol"==typeof t},i.isUndefined=y,i.isRegExp=v,i.isObject=_,i.isDate=w,i.isError=x,i.isFunction=E,i.isPrimitive=function(t){return null===t||"boolean"==typeof t||"number"==typeof t||"string"==typeof t||"symbol"==typeof t||void 0===t},i.isBuffer=t("./support/isBuffer");var S=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];function A(t,e){return Object.prototype.hasOwnProperty.call(t,e)}i.log=function(){var t,e;console.log("%s - %s",(t=new Date,e=[j(t.getHours()),j(t.getMinutes()),j(t.getSeconds())].join(":"),[t.getDate(),S[t.getMonth()],e].join(" ")),i.format.apply(i,arguments))},i.inherits=t("inherits"),i._extend=function(t,e){if(!e||!_(e))return t;for(var r=Object.keys(e),n=r.length;n--;)t[r[n]]=e[r[n]];return t}}).call(this,t("_process"),void 0!==r.g?r.g:"undefined"!=typeof self?self:void 0!==n?n:{})},{"./support/isBuffer":26,_process:312,inherits:25}],28:[function(t,e,r){"use strict";r.byteLength=function(t){var e=l(t),r=e[0],n=e[1];return 3*(r+n)/4-n},r.toByteArray=function(t){var e,r,n=l(t),o=n[0],s=n[1],u=new a(function(t,e,r){return 3*(e+r)/4-r}(0,o,s)),f=0,h=s>0?o-4:o;for(r=0;r<h;r+=4)e=i[t.charCodeAt(r)]<<18|i[t.charCodeAt(r+1)]<<12|i[t.charCodeAt(r+2)]<<6|i[t.charCodeAt(r+3)],u[f++]=e>>16&255,u[f++]=e>>8&255,u[f++]=255&e;return 2===s&&(e=i[t.charCodeAt(r)]<<2|i[t.charCodeAt(r+1)]>>4,u[f++]=255&e),1===s&&(e=i[t.charCodeAt(r)]<<10|i[t.charCodeAt(r+1)]<<4|i[t.charCodeAt(r+2)]>>2,u[f++]=e>>8&255,u[f++]=255&e),u},r.fromByteArray=function(t){for(var e,r=t.length,i=r%3,a=[],o=16383,s=0,l=r-i;s<l;s+=o)a.push(u(t,s,s+o>l?l:s+o));return 1===i?(e=t[r-1],a.push(n[e>>2]+n[e<<4&63]+"==")):2===i&&(e=(t[r-2]<<8)+t[r-1],a.push(n[e>>10]+n[e>>4&63]+n[e<<2&63]+"=")),a.join("")};for(var n=[],i=[],a="undefined"!=typeof Uint8Array?Uint8Array:Array,o="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",s=0;s<64;++s)n[s]=o[s],i[o.charCodeAt(s)]=s;function l(t){var e=t.length;if(e%4>0)throw new Error("Invalid string. Length must be a multiple of 4");var r=t.indexOf("=");return-1===r&&(r=e),[r,r===e?0:4-r%4]}function u(t,e,r){for(var i,a=[],o=e;o<r;o+=3)i=(t[o]<<16&16711680)+(t[o+1]<<8&65280)+(255&t[o+2]),a.push(n[(s=i)>>18&63]+n[s>>12&63]+n[s>>6&63]+n[63&s]);var s;return a.join("")}i["-".charCodeAt(0)]=62,i["_".charCodeAt(0)]=63},{}],29:[function(t,e,r){var n=t("./lib/encoder"),i=t("./lib/decoder");e.exports={encode:n,decode:i}},{"./lib/decoder":30,"./lib/encoder":31}],30:[function(t,e,r){(function(t){function r(t,e){if(this.pos=0,this.buffer=t,this.is_with_alpha=!!e,this.bottom_up=!0,this.flag=this.buffer.toString("utf-8",0,this.pos+=2),"BM"!=this.flag)throw new Error("Invalid BMP File");this.parseHeader(),this.parseRGBA()}r.prototype.parseHeader=function(){if(this.fileSize=this.buffer.readUInt32LE(this.pos),this.pos+=4,this.reserved=this.buffer.readUInt32LE(this.pos),this.pos+=4,this.offset=this.buffer.readUInt32LE(this.pos),this.pos+=4,this.headerSize=this.buffer.readUInt32LE(this.pos),this.pos+=4,this.width=this.buffer.readUInt32LE(this.pos),this.pos+=4,this.height=this.buffer.readInt32LE(this.pos),this.pos+=4,this.planes=this.buffer.readUInt16LE(this.pos),this.pos+=2,this.bitPP=this.buffer.readUInt16LE(this.pos),this.pos+=2,this.compress=this.buffer.readUInt32LE(this.pos),this.pos+=4,this.rawSize=this.buffer.readUInt32LE(this.pos),this.pos+=4,this.hr=this.buffer.readUInt32LE(this.pos),this.pos+=4,this.vr=this.buffer.readUInt32LE(this.pos),this.pos+=4,this.colors=this.buffer.readUInt32LE(this.pos),this.pos+=4,this.importantColors=this.buffer.readUInt32LE(this.pos),this.pos+=4,16===this.bitPP&&this.is_with_alpha&&(this.bitPP=15),this.bitPP<15){var t=0===this.colors?1<<this.bitPP:this.colors;this.palette=new Array(t);for(var e=0;e<t;e++){var r=this.buffer.readUInt8(this.pos++),n=this.buffer.readUInt8(this.pos++),i=this.buffer.readUInt8(this.pos++),a=this.buffer.readUInt8(this.pos++);this.palette[e]={red:i,green:n,blue:r,quad:a}}}this.height<0&&(this.height*=-1,this.bottom_up=!1)},r.prototype.parseRGBA=function(){var e="bit"+this.bitPP,r=this.width*this.height*4;this.data=new t(r),this[e]()},r.prototype.bit1=function(){var t=Math.ceil(this.width/8),e=t%4,r=this.height>=0?this.height-1:-this.height;for(r=this.height-1;r>=0;r--){for(var n=this.bottom_up?r:this.height-1-r,i=0;i<t;i++)for(var a=this.buffer.readUInt8(this.pos++),o=n*this.width*4+8*i*4,s=0;s<8&&8*i+s<this.width;s++){var l=this.palette[a>>7-s&1];this.data[o+4*s]=0,this.data[o+4*s+1]=l.blue,this.data[o+4*s+2]=l.green,this.data[o+4*s+3]=l.red}0!=e&&(this.pos+=4-e)}},r.prototype.bit4=function(){if(2==this.compress){this.data.fill(255);for(var t=0,e=this.bottom_up?this.height-1:0,r=!1;t<this.data.length;){var n=this.buffer.readUInt8(this.pos++),i=this.buffer.readUInt8(this.pos++);if(0==n){if(0==i){this.bottom_up?e--:e++,t=e*this.width*4,r=!1;continue}if(1==i)break;if(2==i){var a=this.buffer.readUInt8(this.pos++),o=this.buffer.readUInt8(this.pos++);this.bottom_up?e-=o:e+=o,t+=o*this.width*4+4*a}else{for(var s=this.buffer.readUInt8(this.pos++),l=0;l<i;l++)r?u.call(this,15&s):u.call(this,(240&s)>>4),1&l&&l+1<i&&(s=this.buffer.readUInt8(this.pos++)),r=!r;1==(i+1>>1&1)&&this.pos++}}else for(l=0;l<n;l++)r?u.call(this,15&i):u.call(this,(240&i)>>4),r=!r}function u(e){var r=this.palette[e];this.data[t]=0,this.data[t+1]=r.blue,this.data[t+2]=r.green,this.data[t+3]=r.red,t+=4}}else{var f=Math.ceil(this.width/2),h=f%4;for(o=this.height-1;o>=0;o--){var c=this.bottom_up?o:this.height-1-o;for(a=0;a<f;a++){i=this.buffer.readUInt8(this.pos++),t=c*this.width*4+2*a*4;var d=i>>4,p=15&i,b=this.palette[d];if(this.data[t]=0,this.data[t+1]=b.blue,this.data[t+2]=b.green,this.data[t+3]=b.red,2*a+1>=this.width)break;b=this.palette[p],this.data[t+4]=0,this.data[t+4+1]=b.blue,this.data[t+4+2]=b.green,this.data[t+4+3]=b.red}0!=h&&(this.pos+=4-h)}}},r.prototype.bit8=function(){if(1==this.compress){this.data.fill(255);for(var t=0,e=this.bottom_up?this.height-1:0;t<this.data.length;){var r=this.buffer.readUInt8(this.pos++),n=this.buffer.readUInt8(this.pos++);if(0==r){if(0==n){this.bottom_up?e--:e++,t=e*this.width*4;continue}if(1==n)break;if(2==n){var i=this.buffer.readUInt8(this.pos++),a=this.buffer.readUInt8(this.pos++);this.bottom_up?e-=a:e+=a,t+=a*this.width*4+4*i}else{for(var o=0;o<n;o++){var s=this.buffer.readUInt8(this.pos++);l.call(this,s)}!0&n&&this.pos++}}else for(o=0;o<r;o++)l.call(this,n)}function l(e){var r=this.palette[e];this.data[t]=0,this.data[t+1]=r.blue,this.data[t+2]=r.green,this.data[t+3]=r.red,t+=4}}else{var u=this.width%4;for(a=this.height-1;a>=0;a--){var f=this.bottom_up?a:this.height-1-a;for(i=0;i<this.width;i++)if(n=this.buffer.readUInt8(this.pos++),t=f*this.width*4+4*i,n<this.palette.length){var h=this.palette[n];this.data[t]=0,this.data[t+1]=h.blue,this.data[t+2]=h.green,this.data[t+3]=h.red}else this.data[t]=0,this.data[t+1]=255,this.data[t+2]=255,this.data[t+3]=255;0!=u&&(this.pos+=4-u)}}},r.prototype.bit15=function(){for(var t=this.width%3,e=parseInt("11111",2),r=this.height-1;r>=0;r--){for(var n=this.bottom_up?r:this.height-1-r,i=0;i<this.width;i++){var a=this.buffer.readUInt16LE(this.pos);this.pos+=2;var o=(a&e)/e*255|0,s=(a>>5&e)/e*255|0,l=(a>>10&e)/e*255|0,u=a>>15?255:0,f=n*this.width*4+4*i;this.data[f]=u,this.data[f+1]=o,this.data[f+2]=s,this.data[f+3]=l}this.pos+=t}},r.prototype.bit16=function(){var t=this.width%2*2;this.maskRed=31744,this.maskGreen=992,this.maskBlue=31,this.mask0=0,3==this.compress&&(this.maskRed=this.buffer.readUInt32LE(this.pos),this.pos+=4,this.maskGreen=this.buffer.readUInt32LE(this.pos),this.pos+=4,this.maskBlue=this.buffer.readUInt32LE(this.pos),this.pos+=4,this.mask0=this.buffer.readUInt32LE(this.pos),this.pos+=4);for(var e=[0,0,0],r=0;r<16;r++)this.maskRed>>r&1&&e[0]++,this.maskGreen>>r&1&&e[1]++,this.maskBlue>>r&1&&e[2]++;e[1]+=e[0],e[2]+=e[1],e[0]=8-e[0],e[1]-=8,e[2]-=8;for(var n=this.height-1;n>=0;n--){for(var i=this.bottom_up?n:this.height-1-n,a=0;a<this.width;a++){var o=this.buffer.readUInt16LE(this.pos);this.pos+=2;var s=(o&this.maskBlue)<<e[0],l=(o&this.maskGreen)>>e[1],u=(o&this.maskRed)>>e[2],f=i*this.width*4+4*a;this.data[f]=0,this.data[f+1]=s,this.data[f+2]=l,this.data[f+3]=u}this.pos+=t}},r.prototype.bit24=function(){for(var t=this.height-1;t>=0;t--){for(var e=this.bottom_up?t:this.height-1-t,r=0;r<this.width;r++){var n=this.buffer.readUInt8(this.pos++),i=this.buffer.readUInt8(this.pos++),a=this.buffer.readUInt8(this.pos++),o=e*this.width*4+4*r;this.data[o]=0,this.data[o+1]=n,this.data[o+2]=i,this.data[o+3]=a}this.pos+=this.width%4}},r.prototype.bit32=function(){if(3==this.compress){this.maskRed=this.buffer.readUInt32LE(this.pos),this.pos+=4,this.maskGreen=this.buffer.readUInt32LE(this.pos),this.pos+=4,this.maskBlue=this.buffer.readUInt32LE(this.pos),this.pos+=4,this.mask0=this.buffer.readUInt32LE(this.pos),this.pos+=4;for(var t=this.height-1;t>=0;t--)for(var e=this.bottom_up?t:this.height-1-t,r=0;r<this.width;r++){var n=this.buffer.readUInt8(this.pos++),i=this.buffer.readUInt8(this.pos++),a=this.buffer.readUInt8(this.pos++),o=this.buffer.readUInt8(this.pos++),s=e*this.width*4+4*r;this.data[s]=n,this.data[s+1]=i,this.data[s+2]=a,this.data[s+3]=o}}else for(t=this.height-1;t>=0;t--)for(e=this.bottom_up?t:this.height-1-t,r=0;r<this.width;r++)i=this.buffer.readUInt8(this.pos++),a=this.buffer.readUInt8(this.pos++),o=this.buffer.readUInt8(this.pos++),n=this.buffer.readUInt8(this.pos++),s=e*this.width*4+4*r,this.data[s]=n,this.data[s+1]=i,this.data[s+2]=a,this.data[s+3]=o},r.prototype.getData=function(){return this.data},e.exports=function(t){return new r(t)}}).call(this,t("buffer").Buffer)},{buffer:47}],31:[function(t,e,r){(function(t){function r(t){this.buffer=t.data,this.width=t.width,this.height=t.height,this.extraBytes=this.width%4,this.rgbSize=this.height*(3*this.width+this.extraBytes),this.headerInfoSize=40,this.data=[],this.flag="BM",this.reserved=0,this.offset=54,this.fileSize=this.rgbSize+this.offset,this.planes=1,this.bitPP=24,this.compress=0,this.hr=0,this.vr=0,this.colors=0,this.importantColors=0}r.prototype.encode=function(){var e=new t(this.offset+this.rgbSize);this.pos=0,e.write(this.flag,this.pos,2),this.pos+=2,e.writeUInt32LE(this.fileSize,this.pos),this.pos+=4,e.writeUInt32LE(this.reserved,this.pos),this.pos+=4,e.writeUInt32LE(this.offset,this.pos),this.pos+=4,e.writeUInt32LE(this.headerInfoSize,this.pos),this.pos+=4,e.writeUInt32LE(this.width,this.pos),this.pos+=4,e.writeInt32LE(-this.height,this.pos),this.pos+=4,e.writeUInt16LE(this.planes,this.pos),this.pos+=2,e.writeUInt16LE(this.bitPP,this.pos),this.pos+=2,e.writeUInt32LE(this.compress,this.pos),this.pos+=4,e.writeUInt32LE(this.rgbSize,this.pos),this.pos+=4,e.writeUInt32LE(this.hr,this.pos),this.pos+=4,e.writeUInt32LE(this.vr,this.pos),this.pos+=4,e.writeUInt32LE(this.colors,this.pos),this.pos+=4,e.writeUInt32LE(this.importantColors,this.pos),this.pos+=4;for(var r=0,n=3*this.width+this.extraBytes,i=0;i<this.height;i++){for(var a=0;a<this.width;a++){var o=this.pos+i*n+3*a;r++,e[o]=this.buffer[r++],e[o+1]=this.buffer[r++],e[o+2]=this.buffer[r++]}if(this.extraBytes>0){var s=this.pos+i*n+3*this.width;e.fill(0,s,s+this.extraBytes)}}return e},e.exports=function(t,e){return void 0===e&&(e=100),{data:new r(t).encode(),width:t.width,height:t.height}}}).call(this,t("buffer").Buffer)},{buffer:47}],32:[function(t,e,r){},{}],33:[function(t,e,r){(function(e,n){"use strict";var i=t("assert"),a=t("pako/lib/zlib/zstream"),o=t("pako/lib/zlib/deflate.js"),s=t("pako/lib/zlib/inflate.js"),l=t("pako/lib/zlib/constants");for(var u in l)r[u]=l[u];function f(t){if("number"!=typeof t||t<r.DEFLATE||t>r.UNZIP)throw new TypeError("Bad argument");this.dictionary=null,this.err=0,this.flush=0,this.init_done=!1,this.level=0,this.memLevel=0,this.mode=t,this.strategy=0,this.windowBits=0,this.write_in_progress=!1,this.pending_close=!1,this.gzip_id_bytes_read=0}r.NONE=0,r.DEFLATE=1,r.INFLATE=2,r.GZIP=3,r.GUNZIP=4,r.DEFLATERAW=5,r.INFLATERAW=6,r.UNZIP=7,f.prototype.close=function(){this.write_in_progress?this.pending_close=!0:(this.pending_close=!1,i(this.init_done,"close before init"),i(this.mode<=r.UNZIP),this.mode===r.DEFLATE||this.mode===r.GZIP||this.mode===r.DEFLATERAW?o.deflateEnd(this.strm):this.mode!==r.INFLATE&&this.mode!==r.GUNZIP&&this.mode!==r.INFLATERAW&&this.mode!==r.UNZIP||s.inflateEnd(this.strm),this.mode=r.NONE,this.dictionary=null)},f.prototype.write=function(t,e,r,n,i,a,o){return this._write(!0,t,e,r,n,i,a,o)},f.prototype.writeSync=function(t,e,r,n,i,a,o){return this._write(!1,t,e,r,n,i,a,o)},f.prototype._write=function(t,a,o,s,l,u,f,h){if(i.equal(arguments.length,8),i(this.init_done,"write before init"),i(this.mode!==r.NONE,"already finalized"),i.equal(!1,this.write_in_progress,"write already in progress"),i.equal(!1,this.pending_close,"close is pending"),this.write_in_progress=!0,i.equal(!1,void 0===a,"must provide flush value"),this.write_in_progress=!0,a!==r.Z_NO_FLUSH&&a!==r.Z_PARTIAL_FLUSH&&a!==r.Z_SYNC_FLUSH&&a!==r.Z_FULL_FLUSH&&a!==r.Z_FINISH&&a!==r.Z_BLOCK)throw new Error("Invalid flush value");if(null==o&&(o=n.alloc(0),l=0,s=0),this.strm.avail_in=l,this.strm.input=o,this.strm.next_in=s,this.strm.avail_out=h,this.strm.output=u,this.strm.next_out=f,this.flush=a,!t)return this._process(),this._checkError()?this._afterSync():void 0;var c=this;return e.nextTick((function(){c._process(),c._after()})),this},f.prototype._afterSync=function(){var t=this.strm.avail_out,e=this.strm.avail_in;return this.write_in_progress=!1,[e,t]},f.prototype._process=function(){var t=null;switch(this.mode){case r.DEFLATE:case r.GZIP:case r.DEFLATERAW:this.err=o.deflate(this.strm,this.flush);break;case r.UNZIP:switch(this.strm.avail_in>0&&(t=this.strm.next_in),this.gzip_id_bytes_read){case 0:if(null===t)break;if(31!==this.strm.input[t]){this.mode=r.INFLATE;break}if(this.gzip_id_bytes_read=1,t++,1===this.strm.avail_in)break;case 1:if(null===t)break;139===this.strm.input[t]?(this.gzip_id_bytes_read=2,this.mode=r.GUNZIP):this.mode=r.INFLATE;break;default:throw new Error("invalid number of gzip magic number bytes read")}case r.INFLATE:case r.GUNZIP:case r.INFLATERAW:for(this.err=s.inflate(this.strm,this.flush),this.err===r.Z_NEED_DICT&&this.dictionary&&(this.err=s.inflateSetDictionary(this.strm,this.dictionary),this.err===r.Z_OK?this.err=s.inflate(this.strm,this.flush):this.err===r.Z_DATA_ERROR&&(this.err=r.Z_NEED_DICT));this.strm.avail_in>0&&this.mode===r.GUNZIP&&this.err===r.Z_STREAM_END&&0!==this.strm.next_in[0];)this.reset(),this.err=s.inflate(this.strm,this.flush);break;default:throw new Error("Unknown mode "+this.mode)}},f.prototype._checkError=function(){switch(this.err){case r.Z_OK:case r.Z_BUF_ERROR:if(0!==this.strm.avail_out&&this.flush===r.Z_FINISH)return this._error("unexpected end of file"),!1;break;case r.Z_STREAM_END:break;case r.Z_NEED_DICT:return null==this.dictionary?this._error("Missing dictionary"):this._error("Bad dictionary"),!1;default:return this._error("Zlib error"),!1}return!0},f.prototype._after=function(){if(this._checkError()){var t=this.strm.avail_out,e=this.strm.avail_in;this.write_in_progress=!1,this.callback(e,t),this.pending_close&&this.close()}},f.prototype._error=function(t){this.strm.msg&&(t=this.strm.msg),this.onerror(t,this.err),this.write_in_progress=!1,this.pending_close&&this.close()},f.prototype.init=function(t,e,n,a,o){i(4===arguments.length||5===arguments.length,"init(windowBits, level, memLevel, strategy, [dictionary])"),i(t>=8&&t<=15,"invalid windowBits"),i(e>=-1&&e<=9,"invalid compression level"),i(n>=1&&n<=9,"invalid memlevel"),i(a===r.Z_FILTERED||a===r.Z_HUFFMAN_ONLY||a===r.Z_RLE||a===r.Z_FIXED||a===r.Z_DEFAULT_STRATEGY,"invalid strategy"),this._init(e,t,n,a,o),this._setDictionary()},f.prototype.params=function(){throw new Error("deflateParams Not supported")},f.prototype.reset=function(){this._reset(),this._setDictionary()},f.prototype._init=function(t,e,n,i,l){switch(this.level=t,this.windowBits=e,this.memLevel=n,this.strategy=i,this.flush=r.Z_NO_FLUSH,this.err=r.Z_OK,this.mode!==r.GZIP&&this.mode!==r.GUNZIP||(this.windowBits+=16),this.mode===r.UNZIP&&(this.windowBits+=32),this.mode!==r.DEFLATERAW&&this.mode!==r.INFLATERAW||(this.windowBits=-1*this.windowBits),this.strm=new a,this.mode){case r.DEFLATE:case r.GZIP:case r.DEFLATERAW:this.err=o.deflateInit2(this.strm,this.level,r.Z_DEFLATED,this.windowBits,this.memLevel,this.strategy);break;case r.INFLATE:case r.GUNZIP:case r.INFLATERAW:case r.UNZIP:this.err=s.inflateInit2(this.strm,this.windowBits);break;default:throw new Error("Unknown mode "+this.mode)}this.err!==r.Z_OK&&this._error("Init error"),this.dictionary=l,this.write_in_progress=!1,this.init_done=!0},f.prototype._setDictionary=function(){if(null!=this.dictionary){switch(this.err=r.Z_OK,this.mode){case r.DEFLATE:case r.DEFLATERAW:this.err=o.deflateSetDictionary(this.strm,this.dictionary)}this.err!==r.Z_OK&&this._error("Failed to set dictionary")}},f.prototype._reset=function(){switch(this.err=r.Z_OK,this.mode){case r.DEFLATE:case r.DEFLATERAW:case r.GZIP:this.err=o.deflateReset(this.strm);break;case r.INFLATE:case r.INFLATERAW:case r.GUNZIP:this.err=s.inflateReset(this.strm)}this.err!==r.Z_OK&&this._error("Failed to reset stream")},r.Zlib=f}).call(this,t("_process"),t("buffer").Buffer)},{_process:312,assert:24,buffer:47,"pako/lib/zlib/constants":37,"pako/lib/zlib/deflate.js":39,"pako/lib/zlib/inflate.js":41,"pako/lib/zlib/zstream":45}],34:[function(t,e,r){(function(e){"use strict";var n=t("buffer").Buffer,i=t("stream").Transform,a=t("./binding"),o=t("util"),s=t("assert").ok,l=t("buffer").kMaxLength,u="Cannot create final Buffer. It would be larger than 0x"+l.toString(16)+" bytes";a.Z_MIN_WINDOWBITS=8,a.Z_MAX_WINDOWBITS=15,a.Z_DEFAULT_WINDOWBITS=15,a.Z_MIN_CHUNK=64,a.Z_MAX_CHUNK=1/0,a.Z_DEFAULT_CHUNK=16384,a.Z_MIN_MEMLEVEL=1,a.Z_MAX_MEMLEVEL=9,a.Z_DEFAULT_MEMLEVEL=8,a.Z_MIN_LEVEL=-1,a.Z_MAX_LEVEL=9,a.Z_DEFAULT_LEVEL=a.Z_DEFAULT_COMPRESSION;for(var f=Object.keys(a),h=0;h<f.length;h++){var c=f[h];c.match(/^Z/)&&Object.defineProperty(r,c,{enumerable:!0,value:a[c],writable:!1})}for(var d={Z_OK:a.Z_OK,Z_STREAM_END:a.Z_STREAM_END,Z_NEED_DICT:a.Z_NEED_DICT,Z_ERRNO:a.Z_ERRNO,Z_STREAM_ERROR:a.Z_STREAM_ERROR,Z_DATA_ERROR:a.Z_DATA_ERROR,Z_MEM_ERROR:a.Z_MEM_ERROR,Z_BUF_ERROR:a.Z_BUF_ERROR,Z_VERSION_ERROR:a.Z_VERSION_ERROR},p=Object.keys(d),b=0;b<p.length;b++){var m=p[b];d[d[m]]=m}function g(t,e,r){var i=[],a=0;function o(){for(var e;null!==(e=t.read());)i.push(e),a+=e.length;t.once("readable",o)}function s(){var e,o=null;a>=l?o=new RangeError(u):e=n.concat(i,a),i=[],t.close(),r(o,e)}t.on("error",(function(e){t.removeListener("end",s),t.removeListener("readable",o),r(e)})),t.on("end",s),t.end(e),o()}function y(t,e){if("string"==typeof e&&(e=n.from(e)),!n.isBuffer(e))throw new TypeError("Not a string or buffer");var r=t._finishFlushFlag;return t._processChunk(e,r)}function v(t){if(!(this instanceof v))return new v(t);A.call(this,t,a.DEFLATE)}function _(t){if(!(this instanceof _))return new _(t);A.call(this,t,a.INFLATE)}function w(t){if(!(this instanceof w))return new w(t);A.call(this,t,a.GZIP)}function x(t){if(!(this instanceof x))return new x(t);A.call(this,t,a.GUNZIP)}function E(t){if(!(this instanceof E))return new E(t);A.call(this,t,a.DEFLATERAW)}function k(t){if(!(this instanceof k))return new k(t);A.call(this,t,a.INFLATERAW)}function j(t){if(!(this instanceof j))return new j(t);A.call(this,t,a.UNZIP)}function S(t){return t===a.Z_NO_FLUSH||t===a.Z_PARTIAL_FLUSH||t===a.Z_SYNC_FLUSH||t===a.Z_FULL_FLUSH||t===a.Z_FINISH||t===a.Z_BLOCK}function A(t,e){var o=this;if(this._opts=t=t||{},this._chunkSize=t.chunkSize||r.Z_DEFAULT_CHUNK,i.call(this,t),t.flush&&!S(t.flush))throw new Error("Invalid flush flag: "+t.flush);if(t.finishFlush&&!S(t.finishFlush))throw new Error("Invalid flush flag: "+t.finishFlush);if(this._flushFlag=t.flush||a.Z_NO_FLUSH,this._finishFlushFlag=void 0!==t.finishFlush?t.finishFlush:a.Z_FINISH,t.chunkSize&&(t.chunkSize<r.Z_MIN_CHUNK||t.chunkSize>r.Z_MAX_CHUNK))throw new Error("Invalid chunk size: "+t.chunkSize);if(t.windowBits&&(t.windowBits<r.Z_MIN_WINDOWBITS||t.windowBits>r.Z_MAX_WINDOWBITS))throw new Error("Invalid windowBits: "+t.windowBits);if(t.level&&(t.level<r.Z_MIN_LEVEL||t.level>r.Z_MAX_LEVEL))throw new Error("Invalid compression level: "+t.level);if(t.memLevel&&(t.memLevel<r.Z_MIN_MEMLEVEL||t.memLevel>r.Z_MAX_MEMLEVEL))throw new Error("Invalid memLevel: "+t.memLevel);if(t.strategy&&t.strategy!=r.Z_FILTERED&&t.strategy!=r.Z_HUFFMAN_ONLY&&t.strategy!=r.Z_RLE&&t.strategy!=r.Z_FIXED&&t.strategy!=r.Z_DEFAULT_STRATEGY)throw new Error("Invalid strategy: "+t.strategy);if(t.dictionary&&!n.isBuffer(t.dictionary))throw new Error("Invalid dictionary: it should be a Buffer instance");this._handle=new a.Zlib(e);var s=this;this._hadError=!1,this._handle.onerror=function(t,e){T(s),s._hadError=!0;var n=new Error(t);n.errno=e,n.code=r.codes[e],s.emit("error",n)};var l=r.Z_DEFAULT_COMPRESSION;"number"==typeof t.level&&(l=t.level);var u=r.Z_DEFAULT_STRATEGY;"number"==typeof t.strategy&&(u=t.strategy),this._handle.init(t.windowBits||r.Z_DEFAULT_WINDOWBITS,l,t.memLevel||r.Z_DEFAULT_MEMLEVEL,u,t.dictionary),this._buffer=n.allocUnsafe(this._chunkSize),this._offset=0,this._level=l,this._strategy=u,this.once("end",this.close),Object.defineProperty(this,"_closed",{get:function(){return!o._handle},configurable:!0,enumerable:!0})}function T(t,r){r&&e.nextTick(r),t._handle&&(t._handle.close(),t._handle=null)}function I(t){t.emit("close")}Object.defineProperty(r,"codes",{enumerable:!0,value:Object.freeze(d),writable:!1}),r.Deflate=v,r.Inflate=_,r.Gzip=w,r.Gunzip=x,r.DeflateRaw=E,r.InflateRaw=k,r.Unzip=j,r.createDeflate=function(t){return new v(t)},r.createInflate=function(t){return new _(t)},r.createDeflateRaw=function(t){return new E(t)},r.createInflateRaw=function(t){return new k(t)},r.createGzip=function(t){return new w(t)},r.createGunzip=function(t){return new x(t)},r.createUnzip=function(t){return new j(t)},r.deflate=function(t,e,r){return"function"==typeof e&&(r=e,e={}),g(new v(e),t,r)},r.deflateSync=function(t,e){return y(new v(e),t)},r.gzip=function(t,e,r){return"function"==typeof e&&(r=e,e={}),g(new w(e),t,r)},r.gzipSync=function(t,e){return y(new w(e),t)},r.deflateRaw=function(t,e,r){return"function"==typeof e&&(r=e,e={}),g(new E(e),t,r)},r.deflateRawSync=function(t,e){return y(new E(e),t)},r.unzip=function(t,e,r){return"function"==typeof e&&(r=e,e={}),g(new j(e),t,r)},r.unzipSync=function(t,e){return y(new j(e),t)},r.inflate=function(t,e,r){return"function"==typeof e&&(r=e,e={}),g(new _(e),t,r)},r.inflateSync=function(t,e){return y(new _(e),t)},r.gunzip=function(t,e,r){return"function"==typeof e&&(r=e,e={}),g(new x(e),t,r)},r.gunzipSync=function(t,e){return y(new x(e),t)},r.inflateRaw=function(t,e,r){return"function"==typeof e&&(r=e,e={}),g(new k(e),t,r)},r.inflateRawSync=function(t,e){return y(new k(e),t)},o.inherits(A,i),A.prototype.params=function(t,n,i){if(t<r.Z_MIN_LEVEL||t>r.Z_MAX_LEVEL)throw new RangeError("Invalid compression level: "+t);if(n!=r.Z_FILTERED&&n!=r.Z_HUFFMAN_ONLY&&n!=r.Z_RLE&&n!=r.Z_FIXED&&n!=r.Z_DEFAULT_STRATEGY)throw new TypeError("Invalid strategy: "+n);if(this._level!==t||this._strategy!==n){var o=this;this.flush(a.Z_SYNC_FLUSH,(function(){s(o._handle,"zlib binding closed"),o._handle.params(t,n),o._hadError||(o._level=t,o._strategy=n,i&&i())}))}else e.nextTick(i)},A.prototype.reset=function(){return s(this._handle,"zlib binding closed"),this._handle.reset()},A.prototype._flush=function(t){this._transform(n.alloc(0),"",t)},A.prototype.flush=function(t,r){var i=this,o=this._writableState;("function"==typeof t||void 0===t&&!r)&&(r=t,t=a.Z_FULL_FLUSH),o.ended?r&&e.nextTick(r):o.ending?r&&this.once("end",r):o.needDrain?r&&this.once("drain",(function(){return i.flush(t,r)})):(this._flushFlag=t,this.write(n.alloc(0),"",r))},A.prototype.close=function(t){T(this,t),e.nextTick(I,this)},A.prototype._transform=function(t,e,r){var i,o=this._writableState,s=(o.ending||o.ended)&&(!t||o.length===t.length);return null===t||n.isBuffer(t)?this._handle?(s?i=this._finishFlushFlag:(i=this._flushFlag,t.length>=o.length&&(this._flushFlag=this._opts.flush||a.Z_NO_FLUSH)),void this._processChunk(t,i,r)):r(new Error("zlib binding closed")):r(new Error("invalid input"))},A.prototype._processChunk=function(t,e,r){var i=t&&t.length,a=this._chunkSize-this._offset,o=0,f=this,h="function"==typeof r;if(!h){var c,d=[],p=0;this.on("error",(function(t){c=t})),s(this._handle,"zlib binding closed");do{var b=this._handle.writeSync(e,t,o,i,this._buffer,this._offset,a)}while(!this._hadError&&y(b[0],b[1]));if(this._hadError)throw c;if(p>=l)throw T(this),new RangeError(u);var m=n.concat(d,p);return T(this),m}s(this._handle,"zlib binding closed");var g=this._handle.write(e,t,o,i,this._buffer,this._offset,a);function y(l,u){if(this&&(this.buffer=null,this.callback=null),!f._hadError){var c=a-u;if(s(c>=0,"have should not go down"),c>0){var b=f._buffer.slice(f._offset,f._offset+c);f._offset+=c,h?f.push(b):(d.push(b),p+=b.length)}if((0===u||f._offset>=f._chunkSize)&&(a=f._chunkSize,f._offset=0,f._buffer=n.allocUnsafe(f._chunkSize)),0===u){if(o+=i-l,i=l,!h)return!0;var m=f._handle.write(e,t,o,i,f._buffer,f._offset,f._chunkSize);return m.callback=y,void(m.buffer=t)}if(!h)return!1;r()}}g.buffer=t,g.callback=y},o.inherits(v,A),o.inherits(_,A),o.inherits(w,A),o.inherits(x,A),o.inherits(E,A),o.inherits(k,A),o.inherits(j,A)}).call(this,t("_process"))},{"./binding":33,_process:312,assert:24,buffer:47,stream:334,util:365}],35:[function(t,e,r){"use strict";var n="undefined"!=typeof Uint8Array&&"undefined"!=typeof Uint16Array&&"undefined"!=typeof Int32Array;function i(t,e){return Object.prototype.hasOwnProperty.call(t,e)}r.assign=function(t){for(var e=Array.prototype.slice.call(arguments,1);e.length;){var r=e.shift();if(r){if("object"!=typeof r)throw new TypeError(r+"must be non-object");for(var n in r)i(r,n)&&(t[n]=r[n])}}return t},r.shrinkBuf=function(t,e){return t.length===e?t:t.subarray?t.subarray(0,e):(t.length=e,t)};var a={arraySet:function(t,e,r,n,i){if(e.subarray&&t.subarray)t.set(e.subarray(r,r+n),i);else for(var a=0;a<n;a++)t[i+a]=e[r+a]},flattenChunks:function(t){var e,r,n,i,a,o;for(n=0,e=0,r=t.length;e<r;e++)n+=t[e].length;for(o=new Uint8Array(n),i=0,e=0,r=t.length;e<r;e++)a=t[e],o.set(a,i),i+=a.length;return o}},o={arraySet:function(t,e,r,n,i){for(var a=0;a<n;a++)t[i+a]=e[r+a]},flattenChunks:function(t){return[].concat.apply([],t)}};r.setTyped=function(t){t?(r.Buf8=Uint8Array,r.Buf16=Uint16Array,r.Buf32=Int32Array,r.assign(r,a)):(r.Buf8=Array,r.Buf16=Array,r.Buf32=Array,r.assign(r,o))},r.setTyped(n)},{}],36:[function(t,e,r){"use strict";e.exports=function(t,e,r,n){for(var i=65535&t,a=t>>>16&65535,o=0;0!==r;){r-=o=r>2e3?2e3:r;do{a=a+(i=i+e[n++]|0)|0}while(--o);i%=65521,a%=65521}return i|a<<16}},{}],37:[function(t,e,r){"use strict";e.exports={Z_NO_FLUSH:0,Z_PARTIAL_FLUSH:1,Z_SYNC_FLUSH:2,Z_FULL_FLUSH:3,Z_FINISH:4,Z_BLOCK:5,Z_TREES:6,Z_OK:0,Z_STREAM_END:1,Z_NEED_DICT:2,Z_ERRNO:-1,Z_STREAM_ERROR:-2,Z_DATA_ERROR:-3,Z_BUF_ERROR:-5,Z_NO_COMPRESSION:0,Z_BEST_SPEED:1,Z_BEST_COMPRESSION:9,Z_DEFAULT_COMPRESSION:-1,Z_FILTERED:1,Z_HUFFMAN_ONLY:2,Z_RLE:3,Z_FIXED:4,Z_DEFAULT_STRATEGY:0,Z_BINARY:0,Z_TEXT:1,Z_UNKNOWN:2,Z_DEFLATED:8}},{}],38:[function(t,e,r){"use strict";var n=function(){for(var t,e=[],r=0;r<256;r++){t=r;for(var n=0;n<8;n++)t=1&t?3988292384^t>>>1:t>>>1;e[r]=t}return e}();e.exports=function(t,e,r,i){var a=n,o=i+r;t^=-1;for(var s=i;s<o;s++)t=t>>>8^a[255&(t^e[s])];return-1^t}},{}],39:[function(t,e,r){"use strict";var n,i=t("../utils/common"),a=t("./trees"),o=t("./adler32"),s=t("./crc32"),l=t("./messages"),u=-2,f=258,h=262,c=103,d=113,p=666;function b(t,e){return t.msg=l[e],e}function m(t){return(t<<1)-(t>4?9:0)}function g(t){for(var e=t.length;--e>=0;)t[e]=0}function y(t){var e=t.state,r=e.pending;r>t.avail_out&&(r=t.avail_out),0!==r&&(i.arraySet(t.output,e.pending_buf,e.pending_out,r,t.next_out),t.next_out+=r,e.pending_out+=r,t.total_out+=r,t.avail_out-=r,e.pending-=r,0===e.pending&&(e.pending_out=0))}function v(t,e){a._tr_flush_block(t,t.block_start>=0?t.block_start:-1,t.strstart-t.block_start,e),t.block_start=t.strstart,y(t.strm)}function _(t,e){t.pending_buf[t.pending++]=e}function w(t,e){t.pending_buf[t.pending++]=e>>>8&255,t.pending_buf[t.pending++]=255&e}function x(t,e){var r,n,i=t.max_chain_length,a=t.strstart,o=t.prev_length,s=t.nice_match,l=t.strstart>t.w_size-h?t.strstart-(t.w_size-h):0,u=t.window,c=t.w_mask,d=t.prev,p=t.strstart+f,b=u[a+o-1],m=u[a+o];t.prev_length>=t.good_match&&(i>>=2),s>t.lookahead&&(s=t.lookahead);do{if(u[(r=e)+o]===m&&u[r+o-1]===b&&u[r]===u[a]&&u[++r]===u[a+1]){a+=2,r++;do{}while(u[++a]===u[++r]&&u[++a]===u[++r]&&u[++a]===u[++r]&&u[++a]===u[++r]&&u[++a]===u[++r]&&u[++a]===u[++r]&&u[++a]===u[++r]&&u[++a]===u[++r]&&a<p);if(n=f-(p-a),a=p-f,n>o){if(t.match_start=e,o=n,n>=s)break;b=u[a+o-1],m=u[a+o]}}}while((e=d[e&c])>l&&0!==--i);return o<=t.lookahead?o:t.lookahead}function E(t){var e,r,n,a,l,u,f,c,d,p,b=t.w_size;do{if(a=t.window_size-t.lookahead-t.strstart,t.strstart>=b+(b-h)){i.arraySet(t.window,t.window,b,b,0),t.match_start-=b,t.strstart-=b,t.block_start-=b,e=r=t.hash_size;do{n=t.head[--e],t.head[e]=n>=b?n-b:0}while(--r);e=r=b;do{n=t.prev[--e],t.prev[e]=n>=b?n-b:0}while(--r);a+=b}if(0===t.strm.avail_in)break;if(u=t.strm,f=t.window,c=t.strstart+t.lookahead,d=a,p=void 0,(p=u.avail_in)>d&&(p=d),r=0===p?0:(u.avail_in-=p,i.arraySet(f,u.input,u.next_in,p,c),1===u.state.wrap?u.adler=o(u.adler,f,p,c):2===u.state.wrap&&(u.adler=s(u.adler,f,p,c)),u.next_in+=p,u.total_in+=p,p),t.lookahead+=r,t.lookahead+t.insert>=3)for(l=t.strstart-t.insert,t.ins_h=t.window[l],t.ins_h=(t.ins_h<<t.hash_shift^t.window[l+1])&t.hash_mask;t.insert&&(t.ins_h=(t.ins_h<<t.hash_shift^t.window[l+3-1])&t.hash_mask,t.prev[l&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=l,l++,t.insert--,!(t.lookahead+t.insert<3)););}while(t.lookahead<h&&0!==t.strm.avail_in)}function k(t,e){for(var r,n;;){if(t.lookahead<h){if(E(t),t.lookahead<h&&0===e)return 1;if(0===t.lookahead)break}if(r=0,t.lookahead>=3&&(t.ins_h=(t.ins_h<<t.hash_shift^t.window[t.strstart+3-1])&t.hash_mask,r=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),0!==r&&t.strstart-r<=t.w_size-h&&(t.match_length=x(t,r)),t.match_length>=3)if(n=a._tr_tally(t,t.strstart-t.match_start,t.match_length-3),t.lookahead-=t.match_length,t.match_length<=t.max_lazy_match&&t.lookahead>=3){t.match_length--;do{t.strstart++,t.ins_h=(t.ins_h<<t.hash_shift^t.window[t.strstart+3-1])&t.hash_mask,r=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart}while(0!==--t.match_length);t.strstart++}else t.strstart+=t.match_length,t.match_length=0,t.ins_h=t.window[t.strstart],t.ins_h=(t.ins_h<<t.hash_shift^t.window[t.strstart+1])&t.hash_mask;else n=a._tr_tally(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++;if(n&&(v(t,!1),0===t.strm.avail_out))return 1}return t.insert=t.strstart<2?t.strstart:2,4===e?(v(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(v(t,!1),0===t.strm.avail_out)?1:2}function j(t,e){for(var r,n,i;;){if(t.lookahead<h){if(E(t),t.lookahead<h&&0===e)return 1;if(0===t.lookahead)break}if(r=0,t.lookahead>=3&&(t.ins_h=(t.ins_h<<t.hash_shift^t.window[t.strstart+3-1])&t.hash_mask,r=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),t.prev_length=t.match_length,t.prev_match=t.match_start,t.match_length=2,0!==r&&t.prev_length<t.max_lazy_match&&t.strstart-r<=t.w_size-h&&(t.match_length=x(t,r),t.match_length<=5&&(1===t.strategy||3===t.match_length&&t.strstart-t.match_start>4096)&&(t.match_length=2)),t.prev_length>=3&&t.match_length<=t.prev_length){i=t.strstart+t.lookahead-3,n=a._tr_tally(t,t.strstart-1-t.prev_match,t.prev_length-3),t.lookahead-=t.prev_length-1,t.prev_length-=2;do{++t.strstart<=i&&(t.ins_h=(t.ins_h<<t.hash_shift^t.window[t.strstart+3-1])&t.hash_mask,r=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart)}while(0!==--t.prev_length);if(t.match_available=0,t.match_length=2,t.strstart++,n&&(v(t,!1),0===t.strm.avail_out))return 1}else if(t.match_available){if((n=a._tr_tally(t,0,t.window[t.strstart-1]))&&v(t,!1),t.strstart++,t.lookahead--,0===t.strm.avail_out)return 1}else t.match_available=1,t.strstart++,t.lookahead--}return t.match_available&&(n=a._tr_tally(t,0,t.window[t.strstart-1]),t.match_available=0),t.insert=t.strstart<2?t.strstart:2,4===e?(v(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(v(t,!1),0===t.strm.avail_out)?1:2}function S(t,e,r,n,i){this.good_length=t,this.max_lazy=e,this.nice_length=r,this.max_chain=n,this.func=i}function A(){this.strm=null,this.status=0,this.pending_buf=null,this.pending_buf_size=0,this.pending_out=0,this.pending=0,this.wrap=0,this.gzhead=null,this.gzindex=0,this.method=8,this.last_flush=-1,this.w_size=0,this.w_bits=0,this.w_mask=0,this.window=null,this.window_size=0,this.prev=null,this.head=null,this.ins_h=0,this.hash_size=0,this.hash_bits=0,this.hash_mask=0,this.hash_shift=0,this.block_start=0,this.match_length=0,this.prev_match=0,this.match_available=0,this.strstart=0,this.match_start=0,this.lookahead=0,this.prev_length=0,this.max_chain_length=0,this.max_lazy_match=0,this.level=0,this.strategy=0,this.good_match=0,this.nice_match=0,this.dyn_ltree=new i.Buf16(1146),this.dyn_dtree=new i.Buf16(122),this.bl_tree=new i.Buf16(78),g(this.dyn_ltree),g(this.dyn_dtree),g(this.bl_tree),this.l_desc=null,this.d_desc=null,this.bl_desc=null,this.bl_count=new i.Buf16(16),this.heap=new i.Buf16(573),g(this.heap),this.heap_len=0,this.heap_max=0,this.depth=new i.Buf16(573),g(this.depth),this.l_buf=0,this.lit_bufsize=0,this.last_lit=0,this.d_buf=0,this.opt_len=0,this.static_len=0,this.matches=0,this.insert=0,this.bi_buf=0,this.bi_valid=0}function T(t){var e;return t&&t.state?(t.total_in=t.total_out=0,t.data_type=2,(e=t.state).pending=0,e.pending_out=0,e.wrap<0&&(e.wrap=-e.wrap),e.status=e.wrap?42:d,t.adler=2===e.wrap?0:1,e.last_flush=0,a._tr_init(e),0):b(t,u)}function I(t){var e,r=T(t);return 0===r&&((e=t.state).window_size=2*e.w_size,g(e.head),e.max_lazy_match=n[e.level].max_lazy,e.good_match=n[e.level].good_length,e.nice_match=n[e.level].nice_length,e.max_chain_length=n[e.level].max_chain,e.strstart=0,e.block_start=0,e.lookahead=0,e.insert=0,e.match_length=e.prev_length=2,e.match_available=0,e.ins_h=0),r}function P(t,e,r,n,a,o){if(!t)return u;var s=1;if(-1===e&&(e=6),n<0?(s=0,n=-n):n>15&&(s=2,n-=16),a<1||a>9||8!==r||n<8||n>15||e<0||e>9||o<0||o>4)return b(t,u);8===n&&(n=9);var l=new A;return t.state=l,l.strm=t,l.wrap=s,l.gzhead=null,l.w_bits=n,l.w_size=1<<l.w_bits,l.w_mask=l.w_size-1,l.hash_bits=a+7,l.hash_size=1<<l.hash_bits,l.hash_mask=l.hash_size-1,l.hash_shift=~~((l.hash_bits+3-1)/3),l.window=new i.Buf8(2*l.w_size),l.head=new i.Buf16(l.hash_size),l.prev=new i.Buf16(l.w_size),l.lit_bufsize=1<<a+6,l.pending_buf_size=4*l.lit_bufsize,l.pending_buf=new i.Buf8(l.pending_buf_size),l.d_buf=1*l.lit_bufsize,l.l_buf=3*l.lit_bufsize,l.level=e,l.strategy=o,l.method=r,I(t)}n=[new S(0,0,0,0,(function(t,e){var r=65535;for(r>t.pending_buf_size-5&&(r=t.pending_buf_size-5);;){if(t.lookahead<=1){if(E(t),0===t.lookahead&&0===e)return 1;if(0===t.lookahead)break}t.strstart+=t.lookahead,t.lookahead=0;var n=t.block_start+r;if((0===t.strstart||t.strstart>=n)&&(t.lookahead=t.strstart-n,t.strstart=n,v(t,!1),0===t.strm.avail_out))return 1;if(t.strstart-t.block_start>=t.w_size-h&&(v(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,4===e?(v(t,!0),0===t.strm.avail_out?3:4):(t.strstart>t.block_start&&(v(t,!1),t.strm.avail_out),1)})),new S(4,4,8,4,k),new S(4,5,16,8,k),new S(4,6,32,32,k),new S(4,4,16,16,j),new S(8,16,32,32,j),new S(8,16,128,128,j),new S(8,32,128,256,j),new S(32,128,258,1024,j),new S(32,258,258,4096,j)],r.deflateInit=function(t,e){return P(t,e,8,15,8,0)},r.deflateInit2=P,r.deflateReset=I,r.deflateResetKeep=T,r.deflateSetHeader=function(t,e){return t&&t.state?2!==t.state.wrap?u:(t.state.gzhead=e,0):u},r.deflate=function(t,e){var r,i,o,l;if(!t||!t.state||e>5||e<0)return t?b(t,u):u;if(i=t.state,!t.output||!t.input&&0!==t.avail_in||i.status===p&&4!==e)return b(t,0===t.avail_out?-5:u);if(i.strm=t,r=i.last_flush,i.last_flush=e,42===i.status)if(2===i.wrap)t.adler=0,_(i,31),_(i,139),_(i,8),i.gzhead?(_(i,(i.gzhead.text?1:0)+(i.gzhead.hcrc?2:0)+(i.gzhead.extra?4:0)+(i.gzhead.name?8:0)+(i.gzhead.comment?16:0)),_(i,255&i.gzhead.time),_(i,i.gzhead.time>>8&255),_(i,i.gzhead.time>>16&255),_(i,i.gzhead.time>>24&255),_(i,9===i.level?2:i.strategy>=2||i.level<2?4:0),_(i,255&i.gzhead.os),i.gzhead.extra&&i.gzhead.extra.length&&(_(i,255&i.gzhead.extra.length),_(i,i.gzhead.extra.length>>8&255)),i.gzhead.hcrc&&(t.adler=s(t.adler,i.pending_buf,i.pending,0)),i.gzindex=0,i.status=69):(_(i,0),_(i,0),_(i,0),_(i,0),_(i,0),_(i,9===i.level?2:i.strategy>=2||i.level<2?4:0),_(i,3),i.status=d);else{var h=8+(i.w_bits-8<<4)<<8;h|=(i.strategy>=2||i.level<2?0:i.level<6?1:6===i.level?2:3)<<6,0!==i.strstart&&(h|=32),h+=31-h%31,i.status=d,w(i,h),0!==i.strstart&&(w(i,t.adler>>>16),w(i,65535&t.adler)),t.adler=1}if(69===i.status)if(i.gzhead.extra){for(o=i.pending;i.gzindex<(65535&i.gzhead.extra.length)&&(i.pending!==i.pending_buf_size||(i.gzhead.hcrc&&i.pending>o&&(t.adler=s(t.adler,i.pending_buf,i.pending-o,o)),y(t),o=i.pending,i.pending!==i.pending_buf_size));)_(i,255&i.gzhead.extra[i.gzindex]),i.gzindex++;i.gzhead.hcrc&&i.pending>o&&(t.adler=s(t.adler,i.pending_buf,i.pending-o,o)),i.gzindex===i.gzhead.extra.length&&(i.gzindex=0,i.status=73)}else i.status=73;if(73===i.status)if(i.gzhead.name){o=i.pending;do{if(i.pending===i.pending_buf_size&&(i.gzhead.hcrc&&i.pending>o&&(t.adler=s(t.adler,i.pending_buf,i.pending-o,o)),y(t),o=i.pending,i.pending===i.pending_buf_size)){l=1;break}l=i.gzindex<i.gzhead.name.length?255&i.gzhead.name.charCodeAt(i.gzindex++):0,_(i,l)}while(0!==l);i.gzhead.hcrc&&i.pending>o&&(t.adler=s(t.adler,i.pending_buf,i.pending-o,o)),0===l&&(i.gzindex=0,i.status=91)}else i.status=91;if(91===i.status)if(i.gzhead.comment){o=i.pending;do{if(i.pending===i.pending_buf_size&&(i.gzhead.hcrc&&i.pending>o&&(t.adler=s(t.adler,i.pending_buf,i.pending-o,o)),y(t),o=i.pending,i.pending===i.pending_buf_size)){l=1;break}l=i.gzindex<i.gzhead.comment.length?255&i.gzhead.comment.charCodeAt(i.gzindex++):0,_(i,l)}while(0!==l);i.gzhead.hcrc&&i.pending>o&&(t.adler=s(t.adler,i.pending_buf,i.pending-o,o)),0===l&&(i.status=c)}else i.status=c;if(i.status===c&&(i.gzhead.hcrc?(i.pending+2>i.pending_buf_size&&y(t),i.pending+2<=i.pending_buf_size&&(_(i,255&t.adler),_(i,t.adler>>8&255),t.adler=0,i.status=d)):i.status=d),0!==i.pending){if(y(t),0===t.avail_out)return i.last_flush=-1,0}else if(0===t.avail_in&&m(e)<=m(r)&&4!==e)return b(t,-5);if(i.status===p&&0!==t.avail_in)return b(t,-5);if(0!==t.avail_in||0!==i.lookahead||0!==e&&i.status!==p){var x=2===i.strategy?function(t,e){for(var r;;){if(0===t.lookahead&&(E(t),0===t.lookahead)){if(0===e)return 1;break}if(t.match_length=0,r=a._tr_tally(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++,r&&(v(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,4===e?(v(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(v(t,!1),0===t.strm.avail_out)?1:2}(i,e):3===i.strategy?function(t,e){for(var r,n,i,o,s=t.window;;){if(t.lookahead<=f){if(E(t),t.lookahead<=f&&0===e)return 1;if(0===t.lookahead)break}if(t.match_length=0,t.lookahead>=3&&t.strstart>0&&(n=s[i=t.strstart-1])===s[++i]&&n===s[++i]&&n===s[++i]){o=t.strstart+f;do{}while(n===s[++i]&&n===s[++i]&&n===s[++i]&&n===s[++i]&&n===s[++i]&&n===s[++i]&&n===s[++i]&&n===s[++i]&&i<o);t.match_length=f-(o-i),t.match_length>t.lookahead&&(t.match_length=t.lookahead)}if(t.match_length>=3?(r=a._tr_tally(t,1,t.match_length-3),t.lookahead-=t.match_length,t.strstart+=t.match_length,t.match_length=0):(r=a._tr_tally(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++),r&&(v(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,4===e?(v(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(v(t,!1),0===t.strm.avail_out)?1:2}(i,e):n[i.level].func(i,e);if(3!==x&&4!==x||(i.status=p),1===x||3===x)return 0===t.avail_out&&(i.last_flush=-1),0;if(2===x&&(1===e?a._tr_align(i):5!==e&&(a._tr_stored_block(i,0,0,!1),3===e&&(g(i.head),0===i.lookahead&&(i.strstart=0,i.block_start=0,i.insert=0))),y(t),0===t.avail_out))return i.last_flush=-1,0}return 4!==e?0:i.wrap<=0?1:(2===i.wrap?(_(i,255&t.adler),_(i,t.adler>>8&255),_(i,t.adler>>16&255),_(i,t.adler>>24&255),_(i,255&t.total_in),_(i,t.total_in>>8&255),_(i,t.total_in>>16&255),_(i,t.total_in>>24&255)):(w(i,t.adler>>>16),w(i,65535&t.adler)),y(t),i.wrap>0&&(i.wrap=-i.wrap),0!==i.pending?0:1)},r.deflateEnd=function(t){var e;return t&&t.state?42!==(e=t.state.status)&&69!==e&&73!==e&&91!==e&&e!==c&&e!==d&&e!==p?b(t,u):(t.state=null,e===d?b(t,-3):0):u},r.deflateSetDictionary=function(t,e){var r,n,a,s,l,f,h,c,d=e.length;if(!t||!t.state)return u;if(2===(s=(r=t.state).wrap)||1===s&&42!==r.status||r.lookahead)return u;for(1===s&&(t.adler=o(t.adler,e,d,0)),r.wrap=0,d>=r.w_size&&(0===s&&(g(r.head),r.strstart=0,r.block_start=0,r.insert=0),c=new i.Buf8(r.w_size),i.arraySet(c,e,d-r.w_size,r.w_size,0),e=c,d=r.w_size),l=t.avail_in,f=t.next_in,h=t.input,t.avail_in=d,t.next_in=0,t.input=e,E(r);r.lookahead>=3;){n=r.strstart,a=r.lookahead-2;do{r.ins_h=(r.ins_h<<r.hash_shift^r.window[n+3-1])&r.hash_mask,r.prev[n&r.w_mask]=r.head[r.ins_h],r.head[r.ins_h]=n,n++}while(--a);r.strstart=n,r.lookahead=2,E(r)}return r.strstart+=r.lookahead,r.block_start=r.strstart,r.insert=r.lookahead,r.lookahead=0,r.match_length=r.prev_length=2,r.match_available=0,t.next_in=f,t.input=h,t.avail_in=l,r.wrap=s,0},r.deflateInfo="pako deflate (from Nodeca project)"},{"../utils/common":35,"./adler32":36,"./crc32":38,"./messages":43,"./trees":44}],40:[function(t,e,r){"use strict";e.exports=function(t,e){var r,n,i,a,o,s,l,u,f,h,c,d,p,b,m,g,y,v,_,w,x,E,k,j,S;r=t.state,n=t.next_in,j=t.input,i=n+(t.avail_in-5),a=t.next_out,S=t.output,o=a-(e-t.avail_out),s=a+(t.avail_out-257),l=r.dmax,u=r.wsize,f=r.whave,h=r.wnext,c=r.window,d=r.hold,p=r.bits,b=r.lencode,m=r.distcode,g=(1<<r.lenbits)-1,y=(1<<r.distbits)-1;t:do{p<15&&(d+=j[n++]<<p,p+=8,d+=j[n++]<<p,p+=8),v=b[d&g];e:for(;;){if(d>>>=_=v>>>24,p-=_,0==(_=v>>>16&255))S[a++]=65535&v;else{if(!(16&_)){if(64&_){if(32&_){r.mode=12;break t}t.msg="invalid literal/length code",r.mode=30;break t}v=b[(65535&v)+(d&(1<<_)-1)];continue e}for(w=65535&v,(_&=15)&&(p<_&&(d+=j[n++]<<p,p+=8),w+=d&(1<<_)-1,d>>>=_,p-=_),p<15&&(d+=j[n++]<<p,p+=8,d+=j[n++]<<p,p+=8),v=m[d&y];;){if(d>>>=_=v>>>24,p-=_,16&(_=v>>>16&255)){if(x=65535&v,p<(_&=15)&&(d+=j[n++]<<p,(p+=8)<_&&(d+=j[n++]<<p,p+=8)),(x+=d&(1<<_)-1)>l){t.msg="invalid distance too far back",r.mode=30;break t}if(d>>>=_,p-=_,x>(_=a-o)){if((_=x-_)>f&&r.sane){t.msg="invalid distance too far back",r.mode=30;break t}if(E=0,k=c,0===h){if(E+=u-_,_<w){w-=_;do{S[a++]=c[E++]}while(--_);E=a-x,k=S}}else if(h<_){if(E+=u+h-_,(_-=h)<w){w-=_;do{S[a++]=c[E++]}while(--_);if(E=0,h<w){w-=_=h;do{S[a++]=c[E++]}while(--_);E=a-x,k=S}}}else if(E+=h-_,_<w){w-=_;do{S[a++]=c[E++]}while(--_);E=a-x,k=S}for(;w>2;)S[a++]=k[E++],S[a++]=k[E++],S[a++]=k[E++],w-=3;w&&(S[a++]=k[E++],w>1&&(S[a++]=k[E++]))}else{E=a-x;do{S[a++]=S[E++],S[a++]=S[E++],S[a++]=S[E++],w-=3}while(w>2);w&&(S[a++]=S[E++],w>1&&(S[a++]=S[E++]))}break}if(64&_){t.msg="invalid distance code",r.mode=30;break t}v=m[(65535&v)+(d&(1<<_)-1)]}}break}}while(n<i&&a<s);n-=w=p>>3,d&=(1<<(p-=w<<3))-1,t.next_in=n,t.next_out=a,t.avail_in=n<i?i-n+5:5-(n-i),t.avail_out=a<s?s-a+257:257-(a-s),r.hold=d,r.bits=p}},{}],41:[function(t,e,r){"use strict";var n=t("../utils/common"),i=t("./adler32"),a=t("./crc32"),o=t("./inffast"),s=t("./inftrees"),l=-2,u=12,f=30;function h(t){return(t>>>24&255)+(t>>>8&65280)+((65280&t)<<8)+((255&t)<<24)}function c(){this.mode=0,this.last=!1,this.wrap=0,this.havedict=!1,this.flags=0,this.dmax=0,this.check=0,this.total=0,this.head=null,this.wbits=0,this.wsize=0,this.whave=0,this.wnext=0,this.window=null,this.hold=0,this.bits=0,this.length=0,this.offset=0,this.extra=0,this.lencode=null,this.distcode=null,this.lenbits=0,this.distbits=0,this.ncode=0,this.nlen=0,this.ndist=0,this.have=0,this.next=null,this.lens=new n.Buf16(320),this.work=new n.Buf16(288),this.lendyn=null,this.distdyn=null,this.sane=0,this.back=0,this.was=0}function d(t){var e;return t&&t.state?(e=t.state,t.total_in=t.total_out=e.total=0,t.msg="",e.wrap&&(t.adler=1&e.wrap),e.mode=1,e.last=0,e.havedict=0,e.dmax=32768,e.head=null,e.hold=0,e.bits=0,e.lencode=e.lendyn=new n.Buf32(852),e.distcode=e.distdyn=new n.Buf32(592),e.sane=1,e.back=-1,0):l}function p(t){var e;return t&&t.state?((e=t.state).wsize=0,e.whave=0,e.wnext=0,d(t)):l}function b(t,e){var r,n;return t&&t.state?(n=t.state,e<0?(r=0,e=-e):(r=1+(e>>4),e<48&&(e&=15)),e&&(e<8||e>15)?l:(null!==n.window&&n.wbits!==e&&(n.window=null),n.wrap=r,n.wbits=e,p(t))):l}function m(t,e){var r,n;return t?(n=new c,t.state=n,n.window=null,0!==(r=b(t,e))&&(t.state=null),r):l}var g,y,v=!0;function _(t){if(v){var e;for(g=new n.Buf32(512),y=new n.Buf32(32),e=0;e<144;)t.lens[e++]=8;for(;e<256;)t.lens[e++]=9;for(;e<280;)t.lens[e++]=7;for(;e<288;)t.lens[e++]=8;for(s(1,t.lens,0,288,g,0,t.work,{bits:9}),e=0;e<32;)t.lens[e++]=5;s(2,t.lens,0,32,y,0,t.work,{bits:5}),v=!1}t.lencode=g,t.lenbits=9,t.distcode=y,t.distbits=5}function w(t,e,r,i){var a,o=t.state;return null===o.window&&(o.wsize=1<<o.wbits,o.wnext=0,o.whave=0,o.window=new n.Buf8(o.wsize)),i>=o.wsize?(n.arraySet(o.window,e,r-o.wsize,o.wsize,0),o.wnext=0,o.whave=o.wsize):((a=o.wsize-o.wnext)>i&&(a=i),n.arraySet(o.window,e,r-i,a,o.wnext),(i-=a)?(n.arraySet(o.window,e,r-i,i,0),o.wnext=i,o.whave=o.wsize):(o.wnext+=a,o.wnext===o.wsize&&(o.wnext=0),o.whave<o.wsize&&(o.whave+=a))),0}r.inflateReset=p,r.inflateReset2=b,r.inflateResetKeep=d,r.inflateInit=function(t){return m(t,15)},r.inflateInit2=m,r.inflate=function(t,e){var r,c,d,p,b,m,g,y,v,x,E,k,j,S,A,T,I,P,M,O,R,L,C,B,D=0,N=new n.Buf8(4),U=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];if(!t||!t.state||!t.output||!t.input&&0!==t.avail_in)return l;(r=t.state).mode===u&&(r.mode=13),b=t.next_out,d=t.output,g=t.avail_out,p=t.next_in,c=t.input,m=t.avail_in,y=r.hold,v=r.bits,x=m,E=g,L=0;t:for(;;)switch(r.mode){case 1:if(0===r.wrap){r.mode=13;break}for(;v<16;){if(0===m)break t;m--,y+=c[p++]<<v,v+=8}if(2&r.wrap&&35615===y){r.check=0,N[0]=255&y,N[1]=y>>>8&255,r.check=a(r.check,N,2,0),y=0,v=0,r.mode=2;break}if(r.flags=0,r.head&&(r.head.done=!1),!(1&r.wrap)||(((255&y)<<8)+(y>>8))%31){t.msg="incorrect header check",r.mode=f;break}if(8!=(15&y)){t.msg="unknown compression method",r.mode=f;break}if(v-=4,R=8+(15&(y>>>=4)),0===r.wbits)r.wbits=R;else if(R>r.wbits){t.msg="invalid window size",r.mode=f;break}r.dmax=1<<R,t.adler=r.check=1,r.mode=512&y?10:u,y=0,v=0;break;case 2:for(;v<16;){if(0===m)break t;m--,y+=c[p++]<<v,v+=8}if(r.flags=y,8!=(255&r.flags)){t.msg="unknown compression method",r.mode=f;break}if(57344&r.flags){t.msg="unknown header flags set",r.mode=f;break}r.head&&(r.head.text=y>>8&1),512&r.flags&&(N[0]=255&y,N[1]=y>>>8&255,r.check=a(r.check,N,2,0)),y=0,v=0,r.mode=3;case 3:for(;v<32;){if(0===m)break t;m--,y+=c[p++]<<v,v+=8}r.head&&(r.head.time=y),512&r.flags&&(N[0]=255&y,N[1]=y>>>8&255,N[2]=y>>>16&255,N[3]=y>>>24&255,r.check=a(r.check,N,4,0)),y=0,v=0,r.mode=4;case 4:for(;v<16;){if(0===m)break t;m--,y+=c[p++]<<v,v+=8}r.head&&(r.head.xflags=255&y,r.head.os=y>>8),512&r.flags&&(N[0]=255&y,N[1]=y>>>8&255,r.check=a(r.check,N,2,0)),y=0,v=0,r.mode=5;case 5:if(1024&r.flags){for(;v<16;){if(0===m)break t;m--,y+=c[p++]<<v,v+=8}r.length=y,r.head&&(r.head.extra_len=y),512&r.flags&&(N[0]=255&y,N[1]=y>>>8&255,r.check=a(r.check,N,2,0)),y=0,v=0}else r.head&&(r.head.extra=null);r.mode=6;case 6:if(1024&r.flags&&((k=r.length)>m&&(k=m),k&&(r.head&&(R=r.head.extra_len-r.length,r.head.extra||(r.head.extra=new Array(r.head.extra_len)),n.arraySet(r.head.extra,c,p,k,R)),512&r.flags&&(r.check=a(r.check,c,k,p)),m-=k,p+=k,r.length-=k),r.length))break t;r.length=0,r.mode=7;case 7:if(2048&r.flags){if(0===m)break t;k=0;do{R=c[p+k++],r.head&&R&&r.length<65536&&(r.head.name+=String.fromCharCode(R))}while(R&&k<m);if(512&r.flags&&(r.check=a(r.check,c,k,p)),m-=k,p+=k,R)break t}else r.head&&(r.head.name=null);r.length=0,r.mode=8;case 8:if(4096&r.flags){if(0===m)break t;k=0;do{R=c[p+k++],r.head&&R&&r.length<65536&&(r.head.comment+=String.fromCharCode(R))}while(R&&k<m);if(512&r.flags&&(r.check=a(r.check,c,k,p)),m-=k,p+=k,R)break t}else r.head&&(r.head.comment=null);r.mode=9;case 9:if(512&r.flags){for(;v<16;){if(0===m)break t;m--,y+=c[p++]<<v,v+=8}if(y!==(65535&r.check)){t.msg="header crc mismatch",r.mode=f;break}y=0,v=0}r.head&&(r.head.hcrc=r.flags>>9&1,r.head.done=!0),t.adler=r.check=0,r.mode=u;break;case 10:for(;v<32;){if(0===m)break t;m--,y+=c[p++]<<v,v+=8}t.adler=r.check=h(y),y=0,v=0,r.mode=11;case 11:if(0===r.havedict)return t.next_out=b,t.avail_out=g,t.next_in=p,t.avail_in=m,r.hold=y,r.bits=v,2;t.adler=r.check=1,r.mode=u;case u:if(5===e||6===e)break t;case 13:if(r.last){y>>>=7&v,v-=7&v,r.mode=27;break}for(;v<3;){if(0===m)break t;m--,y+=c[p++]<<v,v+=8}switch(r.last=1&y,v-=1,3&(y>>>=1)){case 0:r.mode=14;break;case 1:if(_(r),r.mode=20,6===e){y>>>=2,v-=2;break t}break;case 2:r.mode=17;break;case 3:t.msg="invalid block type",r.mode=f}y>>>=2,v-=2;break;case 14:for(y>>>=7&v,v-=7&v;v<32;){if(0===m)break t;m--,y+=c[p++]<<v,v+=8}if((65535&y)!=(y>>>16^65535)){t.msg="invalid stored block lengths",r.mode=f;break}if(r.length=65535&y,y=0,v=0,r.mode=15,6===e)break t;case 15:r.mode=16;case 16:if(k=r.length){if(k>m&&(k=m),k>g&&(k=g),0===k)break t;n.arraySet(d,c,p,k,b),m-=k,p+=k,g-=k,b+=k,r.length-=k;break}r.mode=u;break;case 17:for(;v<14;){if(0===m)break t;m--,y+=c[p++]<<v,v+=8}if(r.nlen=257+(31&y),y>>>=5,v-=5,r.ndist=1+(31&y),y>>>=5,v-=5,r.ncode=4+(15&y),y>>>=4,v-=4,r.nlen>286||r.ndist>30){t.msg="too many length or distance symbols",r.mode=f;break}r.have=0,r.mode=18;case 18:for(;r.have<r.ncode;){for(;v<3;){if(0===m)break t;m--,y+=c[p++]<<v,v+=8}r.lens[U[r.have++]]=7&y,y>>>=3,v-=3}for(;r.have<19;)r.lens[U[r.have++]]=0;if(r.lencode=r.lendyn,r.lenbits=7,C={bits:r.lenbits},L=s(0,r.lens,0,19,r.lencode,0,r.work,C),r.lenbits=C.bits,L){t.msg="invalid code lengths set",r.mode=f;break}r.have=0,r.mode=19;case 19:for(;r.have<r.nlen+r.ndist;){for(;T=(D=r.lencode[y&(1<<r.lenbits)-1])>>>16&255,I=65535&D,!((A=D>>>24)<=v);){if(0===m)break t;m--,y+=c[p++]<<v,v+=8}if(I<16)y>>>=A,v-=A,r.lens[r.have++]=I;else{if(16===I){for(B=A+2;v<B;){if(0===m)break t;m--,y+=c[p++]<<v,v+=8}if(y>>>=A,v-=A,0===r.have){t.msg="invalid bit length repeat",r.mode=f;break}R=r.lens[r.have-1],k=3+(3&y),y>>>=2,v-=2}else if(17===I){for(B=A+3;v<B;){if(0===m)break t;m--,y+=c[p++]<<v,v+=8}v-=A,R=0,k=3+(7&(y>>>=A)),y>>>=3,v-=3}else{for(B=A+7;v<B;){if(0===m)break t;m--,y+=c[p++]<<v,v+=8}v-=A,R=0,k=11+(127&(y>>>=A)),y>>>=7,v-=7}if(r.have+k>r.nlen+r.ndist){t.msg="invalid bit length repeat",r.mode=f;break}for(;k--;)r.lens[r.have++]=R}}if(r.mode===f)break;if(0===r.lens[256]){t.msg="invalid code -- missing end-of-block",r.mode=f;break}if(r.lenbits=9,C={bits:r.lenbits},L=s(1,r.lens,0,r.nlen,r.lencode,0,r.work,C),r.lenbits=C.bits,L){t.msg="invalid literal/lengths set",r.mode=f;break}if(r.distbits=6,r.distcode=r.distdyn,C={bits:r.distbits},L=s(2,r.lens,r.nlen,r.ndist,r.distcode,0,r.work,C),r.distbits=C.bits,L){t.msg="invalid distances set",r.mode=f;break}if(r.mode=20,6===e)break t;case 20:r.mode=21;case 21:if(m>=6&&g>=258){t.next_out=b,t.avail_out=g,t.next_in=p,t.avail_in=m,r.hold=y,r.bits=v,o(t,E),b=t.next_out,d=t.output,g=t.avail_out,p=t.next_in,c=t.input,m=t.avail_in,y=r.hold,v=r.bits,r.mode===u&&(r.back=-1);break}for(r.back=0;T=(D=r.lencode[y&(1<<r.lenbits)-1])>>>16&255,I=65535&D,!((A=D>>>24)<=v);){if(0===m)break t;m--,y+=c[p++]<<v,v+=8}if(T&&!(240&T)){for(P=A,M=T,O=I;T=(D=r.lencode[O+((y&(1<<P+M)-1)>>P)])>>>16&255,I=65535&D,!(P+(A=D>>>24)<=v);){if(0===m)break t;m--,y+=c[p++]<<v,v+=8}y>>>=P,v-=P,r.back+=P}if(y>>>=A,v-=A,r.back+=A,r.length=I,0===T){r.mode=26;break}if(32&T){r.back=-1,r.mode=u;break}if(64&T){t.msg="invalid literal/length code",r.mode=f;break}r.extra=15&T,r.mode=22;case 22:if(r.extra){for(B=r.extra;v<B;){if(0===m)break t;m--,y+=c[p++]<<v,v+=8}r.length+=y&(1<<r.extra)-1,y>>>=r.extra,v-=r.extra,r.back+=r.extra}r.was=r.length,r.mode=23;case 23:for(;T=(D=r.distcode[y&(1<<r.distbits)-1])>>>16&255,I=65535&D,!((A=D>>>24)<=v);){if(0===m)break t;m--,y+=c[p++]<<v,v+=8}if(!(240&T)){for(P=A,M=T,O=I;T=(D=r.distcode[O+((y&(1<<P+M)-1)>>P)])>>>16&255,I=65535&D,!(P+(A=D>>>24)<=v);){if(0===m)break t;m--,y+=c[p++]<<v,v+=8}y>>>=P,v-=P,r.back+=P}if(y>>>=A,v-=A,r.back+=A,64&T){t.msg="invalid distance code",r.mode=f;break}r.offset=I,r.extra=15&T,r.mode=24;case 24:if(r.extra){for(B=r.extra;v<B;){if(0===m)break t;m--,y+=c[p++]<<v,v+=8}r.offset+=y&(1<<r.extra)-1,y>>>=r.extra,v-=r.extra,r.back+=r.extra}if(r.offset>r.dmax){t.msg="invalid distance too far back",r.mode=f;break}r.mode=25;case 25:if(0===g)break t;if(k=E-g,r.offset>k){if((k=r.offset-k)>r.whave&&r.sane){t.msg="invalid distance too far back",r.mode=f;break}k>r.wnext?(k-=r.wnext,j=r.wsize-k):j=r.wnext-k,k>r.length&&(k=r.length),S=r.window}else S=d,j=b-r.offset,k=r.length;k>g&&(k=g),g-=k,r.length-=k;do{d[b++]=S[j++]}while(--k);0===r.length&&(r.mode=21);break;case 26:if(0===g)break t;d[b++]=r.length,g--,r.mode=21;break;case 27:if(r.wrap){for(;v<32;){if(0===m)break t;m--,y|=c[p++]<<v,v+=8}if(E-=g,t.total_out+=E,r.total+=E,E&&(t.adler=r.check=r.flags?a(r.check,d,E,b-E):i(r.check,d,E,b-E)),E=g,(r.flags?y:h(y))!==r.check){t.msg="incorrect data check",r.mode=f;break}y=0,v=0}r.mode=28;case 28:if(r.wrap&&r.flags){for(;v<32;){if(0===m)break t;m--,y+=c[p++]<<v,v+=8}if(y!==(4294967295&r.total)){t.msg="incorrect length check",r.mode=f;break}y=0,v=0}r.mode=29;case 29:L=1;break t;case f:L=-3;break t;case 31:return-4;default:return l}return t.next_out=b,t.avail_out=g,t.next_in=p,t.avail_in=m,r.hold=y,r.bits=v,(r.wsize||E!==t.avail_out&&r.mode<f&&(r.mode<27||4!==e))&&w(t,t.output,t.next_out,E-t.avail_out)?(r.mode=31,-4):(x-=t.avail_in,E-=t.avail_out,t.total_in+=x,t.total_out+=E,r.total+=E,r.wrap&&E&&(t.adler=r.check=r.flags?a(r.check,d,E,t.next_out-E):i(r.check,d,E,t.next_out-E)),t.data_type=r.bits+(r.last?64:0)+(r.mode===u?128:0)+(20===r.mode||15===r.mode?256:0),(0===x&&0===E||4===e)&&0===L&&(L=-5),L)},r.inflateEnd=function(t){if(!t||!t.state)return l;var e=t.state;return e.window&&(e.window=null),t.state=null,0},r.inflateGetHeader=function(t,e){var r;return t&&t.state&&2&(r=t.state).wrap?(r.head=e,e.done=!1,0):l},r.inflateSetDictionary=function(t,e){var r,n=e.length;return t&&t.state?0!==(r=t.state).wrap&&11!==r.mode?l:11===r.mode&&i(1,e,n,0)!==r.check?-3:w(t,e,n,n)?(r.mode=31,-4):(r.havedict=1,0):l},r.inflateInfo="pako inflate (from Nodeca project)"},{"../utils/common":35,"./adler32":36,"./crc32":38,"./inffast":40,"./inftrees":42}],42:[function(t,e,r){"use strict";var n=t("../utils/common"),i=15,a=[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,0,0],o=[16,16,16,16,16,16,16,16,17,17,17,17,18,18,18,18,19,19,19,19,20,20,20,20,21,21,21,21,16,72,78],s=[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577,0,0],l=[16,16,16,16,17,17,18,18,19,19,20,20,21,21,22,22,23,23,24,24,25,25,26,26,27,27,28,28,29,29,64,64];e.exports=function(t,e,r,u,f,h,c,d){var p,b,m,g,y,v,_,w,x,E=d.bits,k=0,j=0,S=0,A=0,T=0,I=0,P=0,M=0,O=0,R=0,L=null,C=0,B=new n.Buf16(16),D=new n.Buf16(16),N=null,U=0;for(k=0;k<=i;k++)B[k]=0;for(j=0;j<u;j++)B[e[r+j]]++;for(T=E,A=i;A>=1&&0===B[A];A--);if(T>A&&(T=A),0===A)return f[h++]=20971520,f[h++]=20971520,d.bits=1,0;for(S=1;S<A&&0===B[S];S++);for(T<S&&(T=S),M=1,k=1;k<=i;k++)if(M<<=1,(M-=B[k])<0)return-1;if(M>0&&(0===t||1!==A))return-1;for(D[1]=0,k=1;k<i;k++)D[k+1]=D[k]+B[k];for(j=0;j<u;j++)0!==e[r+j]&&(c[D[e[r+j]]++]=j);if(0===t?(L=N=c,v=19):1===t?(L=a,C-=257,N=o,U-=257,v=256):(L=s,N=l,v=-1),R=0,j=0,k=S,y=h,I=T,P=0,m=-1,g=(O=1<<T)-1,1===t&&O>852||2===t&&O>592)return 1;for(;;){_=k-P,c[j]<v?(w=0,x=c[j]):c[j]>v?(w=N[U+c[j]],x=L[C+c[j]]):(w=96,x=0),p=1<<k-P,S=b=1<<I;do{f[y+(R>>P)+(b-=p)]=_<<24|w<<16|x}while(0!==b);for(p=1<<k-1;R&p;)p>>=1;if(0!==p?(R&=p-1,R+=p):R=0,j++,0===--B[k]){if(k===A)break;k=e[r+c[j]]}if(k>T&&(R&g)!==m){for(0===P&&(P=T),y+=S,M=1<<(I=k-P);I+P<A&&!((M-=B[I+P])<=0);)I++,M<<=1;if(O+=1<<I,1===t&&O>852||2===t&&O>592)return 1;f[m=R&g]=T<<24|I<<16|y-h}}return 0!==R&&(f[y+R]=k-P<<24|64<<16),d.bits=T,0}},{"../utils/common":35}],43:[function(t,e,r){"use strict";e.exports={2:"need dictionary",1:"stream end",0:"","-1":"file error","-2":"stream error","-3":"data error","-4":"insufficient memory","-5":"buffer error","-6":"incompatible version"}},{}],44:[function(t,e,r){"use strict";var n=t("../utils/common");function i(t){for(var e=t.length;--e>=0;)t[e]=0}var a=256,o=286,s=30,l=15,u=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0],f=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13],h=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7],c=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],d=new Array(576);i(d);var p=new Array(60);i(p);var b=new Array(512);i(b);var m=new Array(256);i(m);var g=new Array(29);i(g);var y,v,_,w=new Array(s);function x(t,e,r,n,i){this.static_tree=t,this.extra_bits=e,this.extra_base=r,this.elems=n,this.max_length=i,this.has_stree=t&&t.length}function E(t,e){this.dyn_tree=t,this.max_code=0,this.stat_desc=e}function k(t){return t<256?b[t]:b[256+(t>>>7)]}function j(t,e){t.pending_buf[t.pending++]=255&e,t.pending_buf[t.pending++]=e>>>8&255}function S(t,e,r){t.bi_valid>16-r?(t.bi_buf|=e<<t.bi_valid&65535,j(t,t.bi_buf),t.bi_buf=e>>16-t.bi_valid,t.bi_valid+=r-16):(t.bi_buf|=e<<t.bi_valid&65535,t.bi_valid+=r)}function A(t,e,r){S(t,r[2*e],r[2*e+1])}function T(t,e){var r=0;do{r|=1&t,t>>>=1,r<<=1}while(--e>0);return r>>>1}function I(t,e,r){var n,i,a=new Array(16),o=0;for(n=1;n<=l;n++)a[n]=o=o+r[n-1]<<1;for(i=0;i<=e;i++){var s=t[2*i+1];0!==s&&(t[2*i]=T(a[s]++,s))}}function P(t){var e;for(e=0;e<o;e++)t.dyn_ltree[2*e]=0;for(e=0;e<s;e++)t.dyn_dtree[2*e]=0;for(e=0;e<19;e++)t.bl_tree[2*e]=0;t.dyn_ltree[512]=1,t.opt_len=t.static_len=0,t.last_lit=t.matches=0}function M(t){t.bi_valid>8?j(t,t.bi_buf):t.bi_valid>0&&(t.pending_buf[t.pending++]=t.bi_buf),t.bi_buf=0,t.bi_valid=0}function O(t,e,r,n){var i=2*e,a=2*r;return t[i]<t[a]||t[i]===t[a]&&n[e]<=n[r]}function R(t,e,r){for(var n=t.heap[r],i=r<<1;i<=t.heap_len&&(i<t.heap_len&&O(e,t.heap[i+1],t.heap[i],t.depth)&&i++,!O(e,n,t.heap[i],t.depth));)t.heap[r]=t.heap[i],r=i,i<<=1;t.heap[r]=n}function L(t,e,r){var n,i,o,s,l=0;if(0!==t.last_lit)do{n=t.pending_buf[t.d_buf+2*l]<<8|t.pending_buf[t.d_buf+2*l+1],i=t.pending_buf[t.l_buf+l],l++,0===n?A(t,i,e):(A(t,(o=m[i])+a+1,e),0!==(s=u[o])&&S(t,i-=g[o],s),A(t,o=k(--n),r),0!==(s=f[o])&&S(t,n-=w[o],s))}while(l<t.last_lit);A(t,256,e)}function C(t,e){var r,n,i,a=e.dyn_tree,o=e.stat_desc.static_tree,s=e.stat_desc.has_stree,u=e.stat_desc.elems,f=-1;for(t.heap_len=0,t.heap_max=573,r=0;r<u;r++)0!==a[2*r]?(t.heap[++t.heap_len]=f=r,t.depth[r]=0):a[2*r+1]=0;for(;t.heap_len<2;)a[2*(i=t.heap[++t.heap_len]=f<2?++f:0)]=1,t.depth[i]=0,t.opt_len--,s&&(t.static_len-=o[2*i+1]);for(e.max_code=f,r=t.heap_len>>1;r>=1;r--)R(t,a,r);i=u;do{r=t.heap[1],t.heap[1]=t.heap[t.heap_len--],R(t,a,1),n=t.heap[1],t.heap[--t.heap_max]=r,t.heap[--t.heap_max]=n,a[2*i]=a[2*r]+a[2*n],t.depth[i]=(t.depth[r]>=t.depth[n]?t.depth[r]:t.depth[n])+1,a[2*r+1]=a[2*n+1]=i,t.heap[1]=i++,R(t,a,1)}while(t.heap_len>=2);t.heap[--t.heap_max]=t.heap[1],function(t,e){var r,n,i,a,o,s,u=e.dyn_tree,f=e.max_code,h=e.stat_desc.static_tree,c=e.stat_desc.has_stree,d=e.stat_desc.extra_bits,p=e.stat_desc.extra_base,b=e.stat_desc.max_length,m=0;for(a=0;a<=l;a++)t.bl_count[a]=0;for(u[2*t.heap[t.heap_max]+1]=0,r=t.heap_max+1;r<573;r++)(a=u[2*u[2*(n=t.heap[r])+1]+1]+1)>b&&(a=b,m++),u[2*n+1]=a,n>f||(t.bl_count[a]++,o=0,n>=p&&(o=d[n-p]),s=u[2*n],t.opt_len+=s*(a+o),c&&(t.static_len+=s*(h[2*n+1]+o)));if(0!==m){do{for(a=b-1;0===t.bl_count[a];)a--;t.bl_count[a]--,t.bl_count[a+1]+=2,t.bl_count[b]--,m-=2}while(m>0);for(a=b;0!==a;a--)for(n=t.bl_count[a];0!==n;)(i=t.heap[--r])>f||(u[2*i+1]!==a&&(t.opt_len+=(a-u[2*i+1])*u[2*i],u[2*i+1]=a),n--)}}(t,e),I(a,f,t.bl_count)}function B(t,e,r){var n,i,a=-1,o=e[1],s=0,l=7,u=4;for(0===o&&(l=138,u=3),e[2*(r+1)+1]=65535,n=0;n<=r;n++)i=o,o=e[2*(n+1)+1],++s<l&&i===o||(s<u?t.bl_tree[2*i]+=s:0!==i?(i!==a&&t.bl_tree[2*i]++,t.bl_tree[32]++):s<=10?t.bl_tree[34]++:t.bl_tree[36]++,s=0,a=i,0===o?(l=138,u=3):i===o?(l=6,u=3):(l=7,u=4))}function D(t,e,r){var n,i,a=-1,o=e[1],s=0,l=7,u=4;for(0===o&&(l=138,u=3),n=0;n<=r;n++)if(i=o,o=e[2*(n+1)+1],!(++s<l&&i===o)){if(s<u)do{A(t,i,t.bl_tree)}while(0!==--s);else 0!==i?(i!==a&&(A(t,i,t.bl_tree),s--),A(t,16,t.bl_tree),S(t,s-3,2)):s<=10?(A(t,17,t.bl_tree),S(t,s-3,3)):(A(t,18,t.bl_tree),S(t,s-11,7));s=0,a=i,0===o?(l=138,u=3):i===o?(l=6,u=3):(l=7,u=4)}}i(w);var N=!1;function U(t,e,r,i){S(t,0+(i?1:0),3),function(t,e,r,i){M(t),i&&(j(t,r),j(t,~r)),n.arraySet(t.pending_buf,t.window,e,r,t.pending),t.pending+=r}(t,e,r,!0)}r._tr_init=function(t){N||(function(){var t,e,r,n,i,a=new Array(16);for(r=0,n=0;n<28;n++)for(g[n]=r,t=0;t<1<<u[n];t++)m[r++]=n;for(m[r-1]=n,i=0,n=0;n<16;n++)for(w[n]=i,t=0;t<1<<f[n];t++)b[i++]=n;for(i>>=7;n<s;n++)for(w[n]=i<<7,t=0;t<1<<f[n]-7;t++)b[256+i++]=n;for(e=0;e<=l;e++)a[e]=0;for(t=0;t<=143;)d[2*t+1]=8,t++,a[8]++;for(;t<=255;)d[2*t+1]=9,t++,a[9]++;for(;t<=279;)d[2*t+1]=7,t++,a[7]++;for(;t<=287;)d[2*t+1]=8,t++,a[8]++;for(I(d,287,a),t=0;t<s;t++)p[2*t+1]=5,p[2*t]=T(t,5);y=new x(d,u,257,o,l),v=new x(p,f,0,s,l),_=new x(new Array(0),h,0,19,7)}(),N=!0),t.l_desc=new E(t.dyn_ltree,y),t.d_desc=new E(t.dyn_dtree,v),t.bl_desc=new E(t.bl_tree,_),t.bi_buf=0,t.bi_valid=0,P(t)},r._tr_stored_block=U,r._tr_flush_block=function(t,e,r,n){var i,o,s=0;t.level>0?(2===t.strm.data_type&&(t.strm.data_type=function(t){var e,r=4093624447;for(e=0;e<=31;e++,r>>>=1)if(1&r&&0!==t.dyn_ltree[2*e])return 0;if(0!==t.dyn_ltree[18]||0!==t.dyn_ltree[20]||0!==t.dyn_ltree[26])return 1;for(e=32;e<a;e++)if(0!==t.dyn_ltree[2*e])return 1;return 0}(t)),C(t,t.l_desc),C(t,t.d_desc),s=function(t){var e;for(B(t,t.dyn_ltree,t.l_desc.max_code),B(t,t.dyn_dtree,t.d_desc.max_code),C(t,t.bl_desc),e=18;e>=3&&0===t.bl_tree[2*c[e]+1];e--);return t.opt_len+=3*(e+1)+5+5+4,e}(t),i=t.opt_len+3+7>>>3,(o=t.static_len+3+7>>>3)<=i&&(i=o)):i=o=r+5,r+4<=i&&-1!==e?U(t,e,r,n):4===t.strategy||o===i?(S(t,2+(n?1:0),3),L(t,d,p)):(S(t,4+(n?1:0),3),function(t,e,r,n){var i;for(S(t,e-257,5),S(t,r-1,5),S(t,n-4,4),i=0;i<n;i++)S(t,t.bl_tree[2*c[i]+1],3);D(t,t.dyn_ltree,e-1),D(t,t.dyn_dtree,r-1)}(t,t.l_desc.max_code+1,t.d_desc.max_code+1,s+1),L(t,t.dyn_ltree,t.dyn_dtree)),P(t),n&&M(t)},r._tr_tally=function(t,e,r){return t.pending_buf[t.d_buf+2*t.last_lit]=e>>>8&255,t.pending_buf[t.d_buf+2*t.last_lit+1]=255&e,t.pending_buf[t.l_buf+t.last_lit]=255&r,t.last_lit++,0===e?t.dyn_ltree[2*r]++:(t.matches++,e--,t.dyn_ltree[2*(m[r]+a+1)]++,t.dyn_dtree[2*k(e)]++),t.last_lit===t.lit_bufsize-1},r._tr_align=function(t){S(t,2,3),A(t,256,d),function(t){16===t.bi_valid?(j(t,t.bi_buf),t.bi_buf=0,t.bi_valid=0):t.bi_valid>=8&&(t.pending_buf[t.pending++]=255&t.bi_buf,t.bi_buf>>=8,t.bi_valid-=8)}(t)}},{"../utils/common":35}],45:[function(t,e,r){"use strict";e.exports=function(){this.input=null,this.next_in=0,this.avail_in=0,this.total_in=0,this.output=null,this.next_out=0,this.avail_out=0,this.total_out=0,this.msg="",this.state=null,this.data_type=2,this.adler=0}},{}],46:[function(t,e,r){arguments[4][32][0].apply(r,arguments)},{dup:32}],47:[function(t,e,r){(function(e){"use strict";var n=t("base64-js"),i=t("ieee754"),a="function"==typeof Symbol&&"function"==typeof Symbol.for?Symbol.for("nodejs.util.inspect.custom"):null;r.Buffer=e,r.SlowBuffer=function(t){return+t!=t&&(t=0),e.alloc(+t)},r.INSPECT_MAX_BYTES=50;var o=2147483647;function s(t){if(t>o)throw new RangeError('The value "'+t+'" is invalid for option "size"');var r=new Uint8Array(t);return Object.setPrototypeOf(r,e.prototype),r}function e(t,e,r){if("number"==typeof t){if("string"==typeof e)throw new TypeError('The "string" argument must be of type string. Received type number');return f(t)}return l(t,e,r)}function l(t,r,n){if("string"==typeof t)return function(t,r){if("string"==typeof r&&""!==r||(r="utf8"),!e.isEncoding(r))throw new TypeError("Unknown encoding: "+r);var n=0|d(t,r),i=s(n),a=i.write(t,r);return a!==n&&(i=i.slice(0,a)),i}(t,r);if(ArrayBuffer.isView(t))return h(t);if(null==t)throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type "+typeof t);if(z(t,ArrayBuffer)||t&&z(t.buffer,ArrayBuffer))return function(t,r,n){if(r<0||t.byteLength<r)throw new RangeError('"offset" is outside of buffer bounds');if(t.byteLength<r+(n||0))throw new RangeError('"length" is outside of buffer bounds');var i;return i=void 0===r&&void 0===n?new Uint8Array(t):void 0===n?new Uint8Array(t,r):new Uint8Array(t,r,n),Object.setPrototypeOf(i,e.prototype),i}(t,r,n);if("number"==typeof t)throw new TypeError('The "value" argument must not be of type number. Received type number');var i=t.valueOf&&t.valueOf();if(null!=i&&i!==t)return e.from(i,r,n);var a=function(t){if(e.isBuffer(t)){var r=0|c(t.length),n=s(r);return 0===n.length||t.copy(n,0,0,r),n}return void 0!==t.length?"number"!=typeof t.length||F(t.length)?s(0):h(t):"Buffer"===t.type&&Array.isArray(t.data)?h(t.data):void 0}(t);if(a)return a;if("undefined"!=typeof Symbol&&null!=Symbol.toPrimitive&&"function"==typeof t[Symbol.toPrimitive])return e.from(t[Symbol.toPrimitive]("string"),r,n);throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type "+typeof t)}function u(t){if("number"!=typeof t)throw new TypeError('"size" argument must be of type number');if(t<0)throw new RangeError('The value "'+t+'" is invalid for option "size"')}function f(t){return u(t),s(t<0?0:0|c(t))}function h(t){for(var e=t.length<0?0:0|c(t.length),r=s(e),n=0;n<e;n+=1)r[n]=255&t[n];return r}function c(t){if(t>=o)throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x"+o.toString(16)+" bytes");return 0|t}function d(t,r){if(e.isBuffer(t))return t.length;if(ArrayBuffer.isView(t)||z(t,ArrayBuffer))return t.byteLength;if("string"!=typeof t)throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type '+typeof t);var n=t.length,i=arguments.length>2&&!0===arguments[2];if(!i&&0===n)return 0;for(var a=!1;;)switch(r){case"ascii":case"latin1":case"binary":return n;case"utf8":case"utf-8":return D(t).length;case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return 2*n;case"hex":return n>>>1;case"base64":return N(t).length;default:if(a)return i?-1:D(t).length;r=(""+r).toLowerCase(),a=!0}}function p(t,e,r){var n=!1;if((void 0===e||e<0)&&(e=0),e>this.length)return"";if((void 0===r||r>this.length)&&(r=this.length),r<=0)return"";if((r>>>=0)<=(e>>>=0))return"";for(t||(t="utf8");;)switch(t){case"hex":return I(this,e,r);case"utf8":case"utf-8":return j(this,e,r);case"ascii":return A(this,e,r);case"latin1":case"binary":return T(this,e,r);case"base64":return k(this,e,r);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return P(this,e,r);default:if(n)throw new TypeError("Unknown encoding: "+t);t=(t+"").toLowerCase(),n=!0}}function b(t,e,r){var n=t[e];t[e]=t[r],t[r]=n}function m(t,r,n,i,a){if(0===t.length)return-1;if("string"==typeof n?(i=n,n=0):n>2147483647?n=2147483647:n<-2147483648&&(n=-2147483648),F(n=+n)&&(n=a?0:t.length-1),n<0&&(n=t.length+n),n>=t.length){if(a)return-1;n=t.length-1}else if(n<0){if(!a)return-1;n=0}if("string"==typeof r&&(r=e.from(r,i)),e.isBuffer(r))return 0===r.length?-1:g(t,r,n,i,a);if("number"==typeof r)return r&=255,"function"==typeof Uint8Array.prototype.indexOf?a?Uint8Array.prototype.indexOf.call(t,r,n):Uint8Array.prototype.lastIndexOf.call(t,r,n):g(t,[r],n,i,a);throw new TypeError("val must be string, number or Buffer")}function g(t,e,r,n,i){var a,o=1,s=t.length,l=e.length;if(void 0!==n&&("ucs2"===(n=String(n).toLowerCase())||"ucs-2"===n||"utf16le"===n||"utf-16le"===n)){if(t.length<2||e.length<2)return-1;o=2,s/=2,l/=2,r/=2}function u(t,e){return 1===o?t[e]:t.readUInt16BE(e*o)}if(i){var f=-1;for(a=r;a<s;a++)if(u(t,a)===u(e,-1===f?0:a-f)){if(-1===f&&(f=a),a-f+1===l)return f*o}else-1!==f&&(a-=a-f),f=-1}else for(r+l>s&&(r=s-l),a=r;a>=0;a--){for(var h=!0,c=0;c<l;c++)if(u(t,a+c)!==u(e,c)){h=!1;break}if(h)return a}return-1}function y(t,e,r,n){r=Number(r)||0;var i=t.length-r;n?(n=Number(n))>i&&(n=i):n=i;var a=e.length;n>a/2&&(n=a/2);for(var o=0;o<n;++o){var s=parseInt(e.substr(2*o,2),16);if(F(s))return o;t[r+o]=s}return o}function v(t,e,r,n){return U(D(e,t.length-r),t,r,n)}function _(t,e,r,n){return U(function(t){for(var e=[],r=0;r<t.length;++r)e.push(255&t.charCodeAt(r));return e}(e),t,r,n)}function w(t,e,r,n){return _(t,e,r,n)}function x(t,e,r,n){return U(N(e),t,r,n)}function E(t,e,r,n){return U(function(t,e){for(var r,n,i,a=[],o=0;o<t.length&&!((e-=2)<0);++o)n=(r=t.charCodeAt(o))>>8,i=r%256,a.push(i),a.push(n);return a}(e,t.length-r),t,r,n)}function k(t,e,r){return 0===e&&r===t.length?n.fromByteArray(t):n.fromByteArray(t.slice(e,r))}function j(t,e,r){r=Math.min(t.length,r);for(var n=[],i=e;i<r;){var a,o,s,l,u=t[i],f=null,h=u>239?4:u>223?3:u>191?2:1;if(i+h<=r)switch(h){case 1:u<128&&(f=u);break;case 2:128==(192&(a=t[i+1]))&&(l=(31&u)<<6|63&a)>127&&(f=l);break;case 3:a=t[i+1],o=t[i+2],128==(192&a)&&128==(192&o)&&(l=(15&u)<<12|(63&a)<<6|63&o)>2047&&(l<55296||l>57343)&&(f=l);break;case 4:a=t[i+1],o=t[i+2],s=t[i+3],128==(192&a)&&128==(192&o)&&128==(192&s)&&(l=(15&u)<<18|(63&a)<<12|(63&o)<<6|63&s)>65535&&l<1114112&&(f=l)}null===f?(f=65533,h=1):f>65535&&(f-=65536,n.push(f>>>10&1023|55296),f=56320|1023&f),n.push(f),i+=h}return function(t){var e=t.length;if(e<=S)return String.fromCharCode.apply(String,t);for(var r="",n=0;n<e;)r+=String.fromCharCode.apply(String,t.slice(n,n+=S));return r}(n)}r.kMaxLength=o,e.TYPED_ARRAY_SUPPORT=function(){try{var t=new Uint8Array(1),e={foo:function(){return 42}};return Object.setPrototypeOf(e,Uint8Array.prototype),Object.setPrototypeOf(t,e),42===t.foo()}catch(t){return!1}}(),e.TYPED_ARRAY_SUPPORT||"undefined"==typeof console||"function"!=typeof console.error||console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."),Object.defineProperty(e.prototype,"parent",{enumerable:!0,get:function(){if(e.isBuffer(this))return this.buffer}}),Object.defineProperty(e.prototype,"offset",{enumerable:!0,get:function(){if(e.isBuffer(this))return this.byteOffset}}),"undefined"!=typeof Symbol&&null!=Symbol.species&&e[Symbol.species]===e&&Object.defineProperty(e,Symbol.species,{value:null,configurable:!0,enumerable:!1,writable:!1}),e.poolSize=8192,e.from=function(t,e,r){return l(t,e,r)},Object.setPrototypeOf(e.prototype,Uint8Array.prototype),Object.setPrototypeOf(e,Uint8Array),e.alloc=function(t,e,r){return function(t,e,r){return u(t),t<=0?s(t):void 0!==e?"string"==typeof r?s(t).fill(e,r):s(t).fill(e):s(t)}(t,e,r)},e.allocUnsafe=function(t){return f(t)},e.allocUnsafeSlow=function(t){return f(t)},e.isBuffer=function(t){return null!=t&&!0===t._isBuffer&&t!==e.prototype},e.compare=function(t,r){if(z(t,Uint8Array)&&(t=e.from(t,t.offset,t.byteLength)),z(r,Uint8Array)&&(r=e.from(r,r.offset,r.byteLength)),!e.isBuffer(t)||!e.isBuffer(r))throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');if(t===r)return 0;for(var n=t.length,i=r.length,a=0,o=Math.min(n,i);a<o;++a)if(t[a]!==r[a]){n=t[a],i=r[a];break}return n<i?-1:i<n?1:0},e.isEncoding=function(t){switch(String(t).toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"latin1":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return!0;default:return!1}},e.concat=function(t,r){if(!Array.isArray(t))throw new TypeError('"list" argument must be an Array of Buffers');if(0===t.length)return e.alloc(0);var n;if(void 0===r)for(r=0,n=0;n<t.length;++n)r+=t[n].length;var i=e.allocUnsafe(r),a=0;for(n=0;n<t.length;++n){var o=t[n];if(z(o,Uint8Array)&&(o=e.from(o)),!e.isBuffer(o))throw new TypeError('"list" argument must be an Array of Buffers');o.copy(i,a),a+=o.length}return i},e.byteLength=d,e.prototype._isBuffer=!0,e.prototype.swap16=function(){var t=this.length;if(t%2!=0)throw new RangeError("Buffer size must be a multiple of 16-bits");for(var e=0;e<t;e+=2)b(this,e,e+1);return this},e.prototype.swap32=function(){var t=this.length;if(t%4!=0)throw new RangeError("Buffer size must be a multiple of 32-bits");for(var e=0;e<t;e+=4)b(this,e,e+3),b(this,e+1,e+2);return this},e.prototype.swap64=function(){var t=this.length;if(t%8!=0)throw new RangeError("Buffer size must be a multiple of 64-bits");for(var e=0;e<t;e+=8)b(this,e,e+7),b(this,e+1,e+6),b(this,e+2,e+5),b(this,e+3,e+4);return this},e.prototype.toString=function(){var t=this.length;return 0===t?"":0===arguments.length?j(this,0,t):p.apply(this,arguments)},e.prototype.toLocaleString=e.prototype.toString,e.prototype.equals=function(t){if(!e.isBuffer(t))throw new TypeError("Argument must be a Buffer");return this===t||0===e.compare(this,t)},e.prototype.inspect=function(){var t="",e=r.INSPECT_MAX_BYTES;return t=this.toString("hex",0,e).replace(/(.{2})/g,"$1 ").trim(),this.length>e&&(t+=" ... "),"<Buffer "+t+">"},a&&(e.prototype[a]=e.prototype.inspect),e.prototype.compare=function(t,r,n,i,a){if(z(t,Uint8Array)&&(t=e.from(t,t.offset,t.byteLength)),!e.isBuffer(t))throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type '+typeof t);if(void 0===r&&(r=0),void 0===n&&(n=t?t.length:0),void 0===i&&(i=0),void 0===a&&(a=this.length),r<0||n>t.length||i<0||a>this.length)throw new RangeError("out of range index");if(i>=a&&r>=n)return 0;if(i>=a)return-1;if(r>=n)return 1;if(this===t)return 0;for(var o=(a>>>=0)-(i>>>=0),s=(n>>>=0)-(r>>>=0),l=Math.min(o,s),u=this.slice(i,a),f=t.slice(r,n),h=0;h<l;++h)if(u[h]!==f[h]){o=u[h],s=f[h];break}return o<s?-1:s<o?1:0},e.prototype.includes=function(t,e,r){return-1!==this.indexOf(t,e,r)},e.prototype.indexOf=function(t,e,r){return m(this,t,e,r,!0)},e.prototype.lastIndexOf=function(t,e,r){return m(this,t,e,r,!1)},e.prototype.write=function(t,e,r,n){if(void 0===e)n="utf8",r=this.length,e=0;else if(void 0===r&&"string"==typeof e)n=e,r=this.length,e=0;else{if(!isFinite(e))throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");e>>>=0,isFinite(r)?(r>>>=0,void 0===n&&(n="utf8")):(n=r,r=void 0)}var i=this.length-e;if((void 0===r||r>i)&&(r=i),t.length>0&&(r<0||e<0)||e>this.length)throw new RangeError("Attempt to write outside buffer bounds");n||(n="utf8");for(var a=!1;;)switch(n){case"hex":return y(this,t,e,r);case"utf8":case"utf-8":return v(this,t,e,r);case"ascii":return _(this,t,e,r);case"latin1":case"binary":return w(this,t,e,r);case"base64":return x(this,t,e,r);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return E(this,t,e,r);default:if(a)throw new TypeError("Unknown encoding: "+n);n=(""+n).toLowerCase(),a=!0}},e.prototype.toJSON=function(){return{type:"Buffer",data:Array.prototype.slice.call(this._arr||this,0)}};var S=4096;function A(t,e,r){var n="";r=Math.min(t.length,r);for(var i=e;i<r;++i)n+=String.fromCharCode(127&t[i]);return n}function T(t,e,r){var n="";r=Math.min(t.length,r);for(var i=e;i<r;++i)n+=String.fromCharCode(t[i]);return n}function I(t,e,r){var n=t.length;(!e||e<0)&&(e=0),(!r||r<0||r>n)&&(r=n);for(var i="",a=e;a<r;++a)i+=H[t[a]];return i}function P(t,e,r){for(var n=t.slice(e,r),i="",a=0;a<n.length;a+=2)i+=String.fromCharCode(n[a]+256*n[a+1]);return i}function M(t,e,r){if(t%1!=0||t<0)throw new RangeError("offset is not uint");if(t+e>r)throw new RangeError("Trying to access beyond buffer length")}function O(t,r,n,i,a,o){if(!e.isBuffer(t))throw new TypeError('"buffer" argument must be a Buffer instance');if(r>a||r<o)throw new RangeError('"value" argument is out of bounds');if(n+i>t.length)throw new RangeError("Index out of range")}function R(t,e,r,n,i,a){if(r+n>t.length)throw new RangeError("Index out of range");if(r<0)throw new RangeError("Index out of range")}function L(t,e,r,n,a){return e=+e,r>>>=0,a||R(t,0,r,4),i.write(t,e,r,n,23,4),r+4}function C(t,e,r,n,a){return e=+e,r>>>=0,a||R(t,0,r,8),i.write(t,e,r,n,52,8),r+8}e.prototype.slice=function(t,r){var n=this.length;(t=~~t)<0?(t+=n)<0&&(t=0):t>n&&(t=n),(r=void 0===r?n:~~r)<0?(r+=n)<0&&(r=0):r>n&&(r=n),r<t&&(r=t);var i=this.subarray(t,r);return Object.setPrototypeOf(i,e.prototype),i},e.prototype.readUIntLE=function(t,e,r){t>>>=0,e>>>=0,r||M(t,e,this.length);for(var n=this[t],i=1,a=0;++a<e&&(i*=256);)n+=this[t+a]*i;return n},e.prototype.readUIntBE=function(t,e,r){t>>>=0,e>>>=0,r||M(t,e,this.length);for(var n=this[t+--e],i=1;e>0&&(i*=256);)n+=this[t+--e]*i;return n},e.prototype.readUInt8=function(t,e){return t>>>=0,e||M(t,1,this.length),this[t]},e.prototype.readUInt16LE=function(t,e){return t>>>=0,e||M(t,2,this.length),this[t]|this[t+1]<<8},e.prototype.readUInt16BE=function(t,e){return t>>>=0,e||M(t,2,this.length),this[t]<<8|this[t+1]},e.prototype.readUInt32LE=function(t,e){return t>>>=0,e||M(t,4,this.length),(this[t]|this[t+1]<<8|this[t+2]<<16)+16777216*this[t+3]},e.prototype.readUInt32BE=function(t,e){return t>>>=0,e||M(t,4,this.length),16777216*this[t]+(this[t+1]<<16|this[t+2]<<8|this[t+3])},e.prototype.readIntLE=function(t,e,r){t>>>=0,e>>>=0,r||M(t,e,this.length);for(var n=this[t],i=1,a=0;++a<e&&(i*=256);)n+=this[t+a]*i;return n>=(i*=128)&&(n-=Math.pow(2,8*e)),n},e.prototype.readIntBE=function(t,e,r){t>>>=0,e>>>=0,r||M(t,e,this.length);for(var n=e,i=1,a=this[t+--n];n>0&&(i*=256);)a+=this[t+--n]*i;return a>=(i*=128)&&(a-=Math.pow(2,8*e)),a},e.prototype.readInt8=function(t,e){return t>>>=0,e||M(t,1,this.length),128&this[t]?-1*(255-this[t]+1):this[t]},e.prototype.readInt16LE=function(t,e){t>>>=0,e||M(t,2,this.length);var r=this[t]|this[t+1]<<8;return 32768&r?4294901760|r:r},e.prototype.readInt16BE=function(t,e){t>>>=0,e||M(t,2,this.length);var r=this[t+1]|this[t]<<8;return 32768&r?4294901760|r:r},e.prototype.readInt32LE=function(t,e){return t>>>=0,e||M(t,4,this.length),this[t]|this[t+1]<<8|this[t+2]<<16|this[t+3]<<24},e.prototype.readInt32BE=function(t,e){return t>>>=0,e||M(t,4,this.length),this[t]<<24|this[t+1]<<16|this[t+2]<<8|this[t+3]},e.prototype.readFloatLE=function(t,e){return t>>>=0,e||M(t,4,this.length),i.read(this,t,!0,23,4)},e.prototype.readFloatBE=function(t,e){return t>>>=0,e||M(t,4,this.length),i.read(this,t,!1,23,4)},e.prototype.readDoubleLE=function(t,e){return t>>>=0,e||M(t,8,this.length),i.read(this,t,!0,52,8)},e.prototype.readDoubleBE=function(t,e){return t>>>=0,e||M(t,8,this.length),i.read(this,t,!1,52,8)},e.prototype.writeUIntLE=function(t,e,r,n){t=+t,e>>>=0,r>>>=0,n||O(this,t,e,r,Math.pow(2,8*r)-1,0);var i=1,a=0;for(this[e]=255&t;++a<r&&(i*=256);)this[e+a]=t/i&255;return e+r},e.prototype.writeUIntBE=function(t,e,r,n){t=+t,e>>>=0,r>>>=0,n||O(this,t,e,r,Math.pow(2,8*r)-1,0);var i=r-1,a=1;for(this[e+i]=255&t;--i>=0&&(a*=256);)this[e+i]=t/a&255;return e+r},e.prototype.writeUInt8=function(t,e,r){return t=+t,e>>>=0,r||O(this,t,e,1,255,0),this[e]=255&t,e+1},e.prototype.writeUInt16LE=function(t,e,r){return t=+t,e>>>=0,r||O(this,t,e,2,65535,0),this[e]=255&t,this[e+1]=t>>>8,e+2},e.prototype.writeUInt16BE=function(t,e,r){return t=+t,e>>>=0,r||O(this,t,e,2,65535,0),this[e]=t>>>8,this[e+1]=255&t,e+2},e.prototype.writeUInt32LE=function(t,e,r){return t=+t,e>>>=0,r||O(this,t,e,4,4294967295,0),this[e+3]=t>>>24,this[e+2]=t>>>16,this[e+1]=t>>>8,this[e]=255&t,e+4},e.prototype.writeUInt32BE=function(t,e,r){return t=+t,e>>>=0,r||O(this,t,e,4,4294967295,0),this[e]=t>>>24,this[e+1]=t>>>16,this[e+2]=t>>>8,this[e+3]=255&t,e+4},e.prototype.writeIntLE=function(t,e,r,n){if(t=+t,e>>>=0,!n){var i=Math.pow(2,8*r-1);O(this,t,e,r,i-1,-i)}var a=0,o=1,s=0;for(this[e]=255&t;++a<r&&(o*=256);)t<0&&0===s&&0!==this[e+a-1]&&(s=1),this[e+a]=(t/o|0)-s&255;return e+r},e.prototype.writeIntBE=function(t,e,r,n){if(t=+t,e>>>=0,!n){var i=Math.pow(2,8*r-1);O(this,t,e,r,i-1,-i)}var a=r-1,o=1,s=0;for(this[e+a]=255&t;--a>=0&&(o*=256);)t<0&&0===s&&0!==this[e+a+1]&&(s=1),this[e+a]=(t/o|0)-s&255;return e+r},e.prototype.writeInt8=function(t,e,r){return t=+t,e>>>=0,r||O(this,t,e,1,127,-128),t<0&&(t=255+t+1),this[e]=255&t,e+1},e.prototype.writeInt16LE=function(t,e,r){return t=+t,e>>>=0,r||O(this,t,e,2,32767,-32768),this[e]=255&t,this[e+1]=t>>>8,e+2},e.prototype.writeInt16BE=function(t,e,r){return t=+t,e>>>=0,r||O(this,t,e,2,32767,-32768),this[e]=t>>>8,this[e+1]=255&t,e+2},e.prototype.writeInt32LE=function(t,e,r){return t=+t,e>>>=0,r||O(this,t,e,4,2147483647,-2147483648),this[e]=255&t,this[e+1]=t>>>8,this[e+2]=t>>>16,this[e+3]=t>>>24,e+4},e.prototype.writeInt32BE=function(t,e,r){return t=+t,e>>>=0,r||O(this,t,e,4,2147483647,-2147483648),t<0&&(t=4294967295+t+1),this[e]=t>>>24,this[e+1]=t>>>16,this[e+2]=t>>>8,this[e+3]=255&t,e+4},e.prototype.writeFloatLE=function(t,e,r){return L(this,t,e,!0,r)},e.prototype.writeFloatBE=function(t,e,r){return L(this,t,e,!1,r)},e.prototype.writeDoubleLE=function(t,e,r){return C(this,t,e,!0,r)},e.prototype.writeDoubleBE=function(t,e,r){return C(this,t,e,!1,r)},e.prototype.copy=function(t,r,n,i){if(!e.isBuffer(t))throw new TypeError("argument should be a Buffer");if(n||(n=0),i||0===i||(i=this.length),r>=t.length&&(r=t.length),r||(r=0),i>0&&i<n&&(i=n),i===n)return 0;if(0===t.length||0===this.length)return 0;if(r<0)throw new RangeError("targetStart out of bounds");if(n<0||n>=this.length)throw new RangeError("Index out of range");if(i<0)throw new RangeError("sourceEnd out of bounds");i>this.length&&(i=this.length),t.length-r<i-n&&(i=t.length-r+n);var a=i-n;if(this===t&&"function"==typeof Uint8Array.prototype.copyWithin)this.copyWithin(r,n,i);else if(this===t&&n<r&&r<i)for(var o=a-1;o>=0;--o)t[o+r]=this[o+n];else Uint8Array.prototype.set.call(t,this.subarray(n,i),r);return a},e.prototype.fill=function(t,r,n,i){if("string"==typeof t){if("string"==typeof r?(i=r,r=0,n=this.length):"string"==typeof n&&(i=n,n=this.length),void 0!==i&&"string"!=typeof i)throw new TypeError("encoding must be a string");if("string"==typeof i&&!e.isEncoding(i))throw new TypeError("Unknown encoding: "+i);if(1===t.length){var a=t.charCodeAt(0);("utf8"===i&&a<128||"latin1"===i)&&(t=a)}}else"number"==typeof t?t&=255:"boolean"==typeof t&&(t=Number(t));if(r<0||this.length<r||this.length<n)throw new RangeError("Out of range index");if(n<=r)return this;var o;if(r>>>=0,n=void 0===n?this.length:n>>>0,t||(t=0),"number"==typeof t)for(o=r;o<n;++o)this[o]=t;else{var s=e.isBuffer(t)?t:e.from(t,i),l=s.length;if(0===l)throw new TypeError('The value "'+t+'" is invalid for argument "value"');for(o=0;o<n-r;++o)this[o+r]=s[o%l]}return this};var B=/[^+/0-9A-Za-z-_]/g;function D(t,e){var r;e=e||1/0;for(var n=t.length,i=null,a=[],o=0;o<n;++o){if((r=t.charCodeAt(o))>55295&&r<57344){if(!i){if(r>56319){(e-=3)>-1&&a.push(239,191,189);continue}if(o+1===n){(e-=3)>-1&&a.push(239,191,189);continue}i=r;continue}if(r<56320){(e-=3)>-1&&a.push(239,191,189),i=r;continue}r=65536+(i-55296<<10|r-56320)}else i&&(e-=3)>-1&&a.push(239,191,189);if(i=null,r<128){if((e-=1)<0)break;a.push(r)}else if(r<2048){if((e-=2)<0)break;a.push(r>>6|192,63&r|128)}else if(r<65536){if((e-=3)<0)break;a.push(r>>12|224,r>>6&63|128,63&r|128)}else{if(!(r<1114112))throw new Error("Invalid code point");if((e-=4)<0)break;a.push(r>>18|240,r>>12&63|128,r>>6&63|128,63&r|128)}}return a}function N(t){return n.toByteArray(function(t){if((t=(t=t.split("=")[0]).trim().replace(B,"")).length<2)return"";for(;t.length%4!=0;)t+="=";return t}(t))}function U(t,e,r,n){for(var i=0;i<n&&!(i+r>=e.length||i>=t.length);++i)e[i+r]=t[i];return i}function z(t,e){return t instanceof e||null!=t&&null!=t.constructor&&null!=t.constructor.name&&t.constructor.name===e.name}function F(t){return t!=t}var H=function(){for(var t="0123456789abcdef",e=new Array(256),r=0;r<16;++r)for(var n=16*r,i=0;i<16;++i)e[n+i]=t[r]+t[i];return e}()}).call(this,t("buffer").Buffer)},{"base64-js":28,buffer:47,ieee754:253}],48:[function(t,e,r){var n=t("buffer").Buffer;e.exports=function(t,e){if(n.isBuffer(t)&&n.isBuffer(e)){if("function"==typeof t.equals)return t.equals(e);if(t.length!==e.length)return!1;for(var r=0;r<t.length;r++)if(t[r]!==e[r])return!1;return!0}}},{buffer:47}],49:[function(t,e,r){e.exports={100:"Continue",101:"Switching Protocols",102:"Processing",200:"OK",201:"Created",202:"Accepted",203:"Non-Authoritative Information",204:"No Content",205:"Reset Content",206:"Partial Content",207:"Multi-Status",208:"Already Reported",226:"IM Used",300:"Multiple Choices",301:"Moved Permanently",302:"Found",303:"See Other",304:"Not Modified",305:"Use Proxy",307:"Temporary Redirect",308:"Permanent Redirect",400:"Bad Request",401:"Unauthorized",402:"Payment Required",403:"Forbidden",404:"Not Found",405:"Method Not Allowed",406:"Not Acceptable",407:"Proxy Authentication Required",408:"Request Timeout",409:"Conflict",410:"Gone",411:"Length Required",412:"Precondition Failed",413:"Payload Too Large",414:"URI Too Long",415:"Unsupported Media Type",416:"Range Not Satisfiable",417:"Expectation Failed",418:"I'm a teapot",421:"Misdirected Request",422:"Unprocessable Entity",423:"Locked",424:"Failed Dependency",425:"Unordered Collection",426:"Upgrade Required",428:"Precondition Required",429:"Too Many Requests",431:"Request Header Fields Too Large",451:"Unavailable For Legal Reasons",500:"Internal Server Error",501:"Not Implemented",502:"Bad Gateway",503:"Service Unavailable",504:"Gateway Timeout",505:"HTTP Version Not Supported",506:"Variant Also Negotiates",507:"Insufficient Storage",508:"Loop Detected",509:"Bandwidth Limit Exceeded",510:"Not Extended",511:"Network Authentication Required"}},{}],50:[function(t,e,r){e.exports=function(t){if("function"!=typeof t)throw TypeError(String(t)+" is not a function");return t}},{}],51:[function(t,e,r){var n=t("../internals/is-object");e.exports=function(t){if(!n(t)&&null!==t)throw TypeError("Can't set "+String(t)+" as a prototype");return t}},{"../internals/is-object":105}],52:[function(t,e,r){var n=t("../internals/well-known-symbol"),i=t("../internals/object-create"),a=t("../internals/create-non-enumerable-property"),o=n("unscopables"),s=Array.prototype;null==s[o]&&a(s,o,i(null)),e.exports=function(t){s[o][t]=!0}},{"../internals/create-non-enumerable-property":76,"../internals/object-create":118,"../internals/well-known-symbol":169}],53:[function(t,e,r){"use strict";var n=t("../internals/string-multibyte").charAt;e.exports=function(t,e,r){return e+(r?n(t,e).length:1)}},{"../internals/string-multibyte":151}],54:[function(t,e,r){e.exports=function(t,e,r){if(!(t instanceof e))throw TypeError("Incorrect "+(r?r+" ":"")+"invocation");return t}},{}],55:[function(t,e,r){var n=t("../internals/is-object");e.exports=function(t){if(!n(t))throw TypeError(String(t)+" is not an object");return t}},{"../internals/is-object":105}],56:[function(t,e,r){"use strict";var n,i=t("../internals/descriptors"),a=t("../internals/global"),o=t("../internals/is-object"),s=t("../internals/has"),l=t("../internals/classof"),u=t("../internals/create-non-enumerable-property"),f=t("../internals/redefine"),h=t("../internals/object-define-property").f,c=t("../internals/object-get-prototype-of"),d=t("../internals/object-set-prototype-of"),p=t("../internals/well-known-symbol"),b=t("../internals/uid"),m=a.DataView,g=m&&m.prototype,y=a.Int8Array,v=y&&y.prototype,_=a.Uint8ClampedArray,w=_&&_.prototype,x=y&&c(y),E=v&&c(v),k=Object.prototype,j=k.isPrototypeOf,S=p("toStringTag"),A=b("TYPED_ARRAY_TAG"),T=!(!a.ArrayBuffer||!m),I=T&&!!d&&"Opera"!==l(a.opera),P=!1,M={Int8Array:1,Uint8Array:1,Uint8ClampedArray:1,Int16Array:2,Uint16Array:2,Int32Array:4,Uint32Array:4,Float32Array:4,Float64Array:8},O=function(t){return o(t)&&s(M,l(t))};for(n in M)a[n]||(I=!1);if((!I||"function"!=typeof x||x===Function.prototype)&&(x=function(){throw TypeError("Incorrect invocation")},I))for(n in M)a[n]&&d(a[n],x);if((!I||!E||E===k)&&(E=x.prototype,I))for(n in M)a[n]&&d(a[n].prototype,E);if(I&&c(w)!==E&&d(w,E),i&&!s(E,S))for(n in P=!0,h(E,S,{get:function(){return o(this)?this[A]:void 0}}),M)a[n]&&u(a[n],A,n);T&&d&&c(g)!==k&&d(g,k),e.exports={NATIVE_ARRAY_BUFFER:T,NATIVE_ARRAY_BUFFER_VIEWS:I,TYPED_ARRAY_TAG:P&&A,aTypedArray:function(t){if(O(t))return t;throw TypeError("Target is not a typed array")},aTypedArrayConstructor:function(t){if(d){if(j.call(x,t))return t}else for(var e in M)if(s(M,n)){var r=a[e];if(r&&(t===r||j.call(r,t)))return t}throw TypeError("Target is not a typed array constructor")},exportProto:function(t,e,r){if(i){if(r)for(var n in M){var o=a[n];o&&s(o.prototype,t)&&delete o.prototype[t]}E[t]&&!r||f(E,t,r?e:I&&v[t]||e)}},exportStatic:function(t,e,r){var n,o;if(i){if(d){if(r)for(n in M)(o=a[n])&&s(o,t)&&delete o[t];if(x[t]&&!r)return;try{return f(x,t,r?e:I&&y[t]||e)}catch(t){}}for(n in M)!(o=a[n])||o[t]&&!r||f(o,t,e)}},isView:function(t){var e=l(t);return"DataView"===e||s(M,e)},isTypedArray:O,TypedArray:x,TypedArrayPrototype:E}},{"../internals/classof":71,"../internals/create-non-enumerable-property":76,"../internals/descriptors":81,"../internals/global":92,"../internals/has":93,"../internals/is-object":105,"../internals/object-define-property":120,"../internals/object-get-prototype-of":125,"../internals/object-set-prototype-of":129,"../internals/redefine":138,"../internals/uid":166,"../internals/well-known-symbol":169}],57:[function(t,e,r){"use strict";var n=t("../internals/global"),i=t("../internals/descriptors"),a=t("../internals/array-buffer-view-core").NATIVE_ARRAY_BUFFER,o=t("../internals/create-non-enumerable-property"),s=t("../internals/redefine-all"),l=t("../internals/fails"),u=t("../internals/an-instance"),f=t("../internals/to-integer"),h=t("../internals/to-length"),c=t("../internals/to-index"),d=t("../internals/object-get-own-property-names").f,p=t("../internals/object-define-property").f,b=t("../internals/array-fill"),m=t("../internals/set-to-string-tag"),g=t("../internals/internal-state"),y=g.get,v=g.set,_="ArrayBuffer",w="DataView",x="prototype",E="Wrong index",k=n[_],j=k,S=n[w],A=n.Math,T=n.RangeError,I=1/0,P=A.abs,M=A.pow,O=A.floor,R=A.log,L=A.LN2,C=function(t,e,r){var n,i,a,o=new Array(r),s=8*r-e-1,l=(1<<s)-1,u=l>>1,f=23===e?M(2,-24)-M(2,-77):0,h=t<0||0===t&&1/t<0?1:0,c=0;for((t=P(t))!=t||t===I?(i=t!=t?1:0,n=l):(n=O(R(t)/L),t*(a=M(2,-n))<1&&(n--,a*=2),(t+=n+u>=1?f/a:f*M(2,1-u))*a>=2&&(n++,a/=2),n+u>=l?(i=0,n=l):n+u>=1?(i=(t*a-1)*M(2,e),n+=u):(i=t*M(2,u-1)*M(2,e),n=0));e>=8;o[c++]=255&i,i/=256,e-=8);for(n=n<<e|i,s+=e;s>0;o[c++]=255&n,n/=256,s-=8);return o[--c]|=128*h,o},B=function(t,e){var r,n=t.length,i=8*n-e-1,a=(1<<i)-1,o=a>>1,s=i-7,l=n-1,u=t[l--],f=127&u;for(u>>=7;s>0;f=256*f+t[l],l--,s-=8);for(r=f&(1<<-s)-1,f>>=-s,s+=e;s>0;r=256*r+t[l],l--,s-=8);if(0===f)f=1-o;else{if(f===a)return r?NaN:u?-1/0:I;r+=M(2,e),f-=o}return(u?-1:1)*r*M(2,f-e)},D=function(t){return t[3]<<24|t[2]<<16|t[1]<<8|t[0]},N=function(t){return[255&t]},U=function(t){return[255&t,t>>8&255]},z=function(t){return[255&t,t>>8&255,t>>16&255,t>>24&255]},F=function(t){return C(t,23,4)},H=function(t){return C(t,52,8)},G=function(t,e){p(t[x],e,{get:function(){return y(this)[e]}})},q=function(t,e,r,n){var i=c(+r),a=y(t);if(i+e>a.byteLength)throw T(E);var o=y(a.buffer).bytes,s=i+a.byteOffset,l=o.slice(s,s+e);return n?l:l.reverse()},W=function(t,e,r,n,i,a){var o=c(+r),s=y(t);if(o+e>s.byteLength)throw T(E);for(var l=y(s.buffer).bytes,u=o+s.byteOffset,f=n(+i),h=0;h<e;h++)l[u+h]=f[a?h:e-h-1]};if(a){if(!l((function(){k(1)}))||!l((function(){new k(-1)}))||l((function(){return new k,new k(1.5),new k(NaN),k.name!=_}))){for(var Z,V=(j=function(t){return u(this,j),new k(c(t))})[x]=k[x],Y=d(k),X=0;Y.length>X;)(Z=Y[X++])in j||o(j,Z,k[Z]);V.constructor=j}var J=new S(new j(2)),K=S[x].setInt8;J.setInt8(0,2147483648),J.setInt8(1,2147483649),!J.getInt8(0)&&J.getInt8(1)||s(S[x],{setInt8:function(t,e){K.call(this,t,e<<24>>24)},setUint8:function(t,e){K.call(this,t,e<<24>>24)}},{unsafe:!0})}else j=function(t){u(this,j,_);var e=c(t);v(this,{bytes:b.call(new Array(e),0),byteLength:e}),i||(this.byteLength=e)},S=function(t,e,r){u(this,S,w),u(t,j,w);var n=y(t).byteLength,a=f(e);if(a<0||a>n)throw T("Wrong offset");if(a+(r=void 0===r?n-a:h(r))>n)throw T("Wrong length");v(this,{buffer:t,byteLength:r,byteOffset:a}),i||(this.buffer=t,this.byteLength=r,this.byteOffset=a)},i&&(G(j,"byteLength"),G(S,"buffer"),G(S,"byteLength"),G(S,"byteOffset")),s(S[x],{getInt8:function(t){return q(this,1,t)[0]<<24>>24},getUint8:function(t){return q(this,1,t)[0]},getInt16:function(t){var e=q(this,2,t,arguments.length>1?arguments[1]:void 0);return(e[1]<<8|e[0])<<16>>16},getUint16:function(t){var e=q(this,2,t,arguments.length>1?arguments[1]:void 0);return e[1]<<8|e[0]},getInt32:function(t){return D(q(this,4,t,arguments.length>1?arguments[1]:void 0))},getUint32:function(t){return D(q(this,4,t,arguments.length>1?arguments[1]:void 0))>>>0},getFloat32:function(t){return B(q(this,4,t,arguments.length>1?arguments[1]:void 0),23)},getFloat64:function(t){return B(q(this,8,t,arguments.length>1?arguments[1]:void 0),52)},setInt8:function(t,e){W(this,1,t,N,e)},setUint8:function(t,e){W(this,1,t,N,e)},setInt16:function(t,e){W(this,2,t,U,e,arguments.length>2?arguments[2]:void 0)},setUint16:function(t,e){W(this,2,t,U,e,arguments.length>2?arguments[2]:void 0)},setInt32:function(t,e){W(this,4,t,z,e,arguments.length>2?arguments[2]:void 0)},setUint32:function(t,e){W(this,4,t,z,e,arguments.length>2?arguments[2]:void 0)},setFloat32:function(t,e){W(this,4,t,F,e,arguments.length>2?arguments[2]:void 0)},setFloat64:function(t,e){W(this,8,t,H,e,arguments.length>2?arguments[2]:void 0)}});m(j,_),m(S,w),e.exports={ArrayBuffer:j,DataView:S}},{"../internals/an-instance":54,"../internals/array-buffer-view-core":56,"../internals/array-fill":59,"../internals/create-non-enumerable-property":76,"../internals/descriptors":81,"../internals/fails":86,"../internals/global":92,"../internals/internal-state":100,"../internals/object-define-property":120,"../internals/object-get-own-property-names":123,"../internals/redefine-all":137,"../internals/set-to-string-tag":145,"../internals/to-index":155,"../internals/to-integer":157,"../internals/to-length":158}],58:[function(t,e,r){"use strict";var n=t("../internals/to-object"),i=t("../internals/to-absolute-index"),a=t("../internals/to-length"),o=Math.min;e.exports=[].copyWithin||function(t,e){var r=n(this),s=a(r.length),l=i(t,s),u=i(e,s),f=arguments.length>2?arguments[2]:void 0,h=o((void 0===f?s:i(f,s))-u,s-l),c=1;for(u<l&&l<u+h&&(c=-1,u+=h-1,l+=h-1);h-- >0;)u in r?r[l]=r[u]:delete r[l],l+=c,u+=c;return r}},{"../internals/to-absolute-index":154,"../internals/to-length":158,"../internals/to-object":159}],59:[function(t,e,r){"use strict";var n=t("../internals/to-object"),i=t("../internals/to-absolute-index"),a=t("../internals/to-length");e.exports=function(t){for(var e=n(this),r=a(e.length),o=arguments.length,s=i(o>1?arguments[1]:void 0,r),l=o>2?arguments[2]:void 0,u=void 0===l?r:i(l,r);u>s;)e[s++]=t;return e}},{"../internals/to-absolute-index":154,"../internals/to-length":158,"../internals/to-object":159}],60:[function(t,e,r){"use strict";var n=t("../internals/array-iteration").forEach,i=t("../internals/sloppy-array-method");e.exports=i("forEach")?function(t){return n(this,t,arguments.length>1?arguments[1]:void 0)}:[].forEach},{"../internals/array-iteration":62,"../internals/sloppy-array-method":149}],61:[function(t,e,r){var n=t("../internals/to-indexed-object"),i=t("../internals/to-length"),a=t("../internals/to-absolute-index"),o=function(t){return function(e,r,o){var s,l=n(e),u=i(l.length),f=a(o,u);if(t&&r!=r){for(;u>f;)if((s=l[f++])!=s)return!0}else for(;u>f;f++)if((t||f in l)&&l[f]===r)return t||f||0;return!t&&-1}};e.exports={includes:o(!0),indexOf:o(!1)}},{"../internals/to-absolute-index":154,"../internals/to-indexed-object":156,"../internals/to-length":158}],62:[function(t,e,r){var n=t("../internals/bind-context"),i=t("../internals/indexed-object"),a=t("../internals/to-object"),o=t("../internals/to-length"),s=t("../internals/array-species-create"),l=[].push,u=function(t){var e=1==t,r=2==t,u=3==t,f=4==t,h=6==t,c=5==t||h;return function(d,p,b,m){for(var g,y,v=a(d),_=i(v),w=n(p,b,3),x=o(_.length),E=0,k=m||s,j=e?k(d,x):r?k(d,0):void 0;x>E;E++)if((c||E in _)&&(y=w(g=_[E],E,v),t))if(e)j[E]=y;else if(y)switch(t){case 3:return!0;case 5:return g;case 6:return E;case 2:l.call(j,g)}else if(f)return!1;return h?-1:u||f?f:j}};e.exports={forEach:u(0),map:u(1),filter:u(2),some:u(3),every:u(4),find:u(5),findIndex:u(6)}},{"../internals/array-species-create":66,"../internals/bind-context":67,"../internals/indexed-object":98,"../internals/to-length":158,"../internals/to-object":159}],63:[function(t,e,r){"use strict";var n=t("../internals/to-indexed-object"),i=t("../internals/to-integer"),a=t("../internals/to-length"),o=t("../internals/sloppy-array-method"),s=Math.min,l=[].lastIndexOf,u=!!l&&1/[1].lastIndexOf(1,-0)<0,f=o("lastIndexOf");e.exports=u||f?function(t){if(u)return l.apply(this,arguments)||0;var e=n(this),r=a(e.length),o=r-1;for(arguments.length>1&&(o=s(o,i(arguments[1]))),o<0&&(o=r+o);o>=0;o--)if(o in e&&e[o]===t)return o||0;return-1}:l},{"../internals/sloppy-array-method":149,"../internals/to-indexed-object":156,"../internals/to-integer":157,"../internals/to-length":158}],64:[function(t,e,r){var n=t("../internals/fails"),i=t("../internals/well-known-symbol"),a=t("../internals/v8-version"),o=i("species");e.exports=function(t){return a>=51||!n((function(){var e=[];return(e.constructor={})[o]=function(){return{foo:1}},1!==e[t](Boolean).foo}))}},{"../internals/fails":86,"../internals/v8-version":168,"../internals/well-known-symbol":169}],65:[function(t,e,r){var n=t("../internals/a-function"),i=t("../internals/to-object"),a=t("../internals/indexed-object"),o=t("../internals/to-length"),s=function(t){return function(e,r,s,l){n(r);var u=i(e),f=a(u),h=o(u.length),c=t?h-1:0,d=t?-1:1;if(s<2)for(;;){if(c in f){l=f[c],c+=d;break}if(c+=d,t?c<0:h<=c)throw TypeError("Reduce of empty array with no initial value")}for(;t?c>=0:h>c;c+=d)c in f&&(l=r(l,f[c],c,u));return l}};e.exports={left:s(!1),right:s(!0)}},{"../internals/a-function":50,"../internals/indexed-object":98,"../internals/to-length":158,"../internals/to-object":159}],66:[function(t,e,r){var n=t("../internals/is-object"),i=t("../internals/is-array"),a=t("../internals/well-known-symbol")("species");e.exports=function(t,e){var r;return i(t)&&("function"!=typeof(r=t.constructor)||r!==Array&&!i(r.prototype)?n(r)&&null===(r=r[a])&&(r=void 0):r=void 0),new(void 0===r?Array:r)(0===e?0:e)}},{"../internals/is-array":102,"../internals/is-object":105,"../internals/well-known-symbol":169}],67:[function(t,e,r){var n=t("../internals/a-function");e.exports=function(t,e,r){if(n(t),void 0===e)return t;switch(r){case 0:return function(){return t.call(e)};case 1:return function(r){return t.call(e,r)};case 2:return function(r,n){return t.call(e,r,n)};case 3:return function(r,n,i){return t.call(e,r,n,i)}}return function(){return t.apply(e,arguments)}}},{"../internals/a-function":50}],68:[function(t,e,r){var n=t("../internals/an-object");e.exports=function(t,e,r,i){try{return i?e(n(r)[0],r[1]):e(r)}catch(e){var a=t.return;throw void 0!==a&&n(a.call(t)),e}}},{"../internals/an-object":55}],69:[function(t,e,r){var n=t("../internals/well-known-symbol")("iterator"),i=!1;try{var a=0,o={next:function(){return{done:!!a++}},return:function(){i=!0}};o[n]=function(){return this},Array.from(o,(function(){throw 2}))}catch(t){}e.exports=function(t,e){if(!e&&!i)return!1;var r=!1;try{var a={};a[n]=function(){return{next:function(){return{done:r=!0}}}},t(a)}catch(t){}return r}},{"../internals/well-known-symbol":169}],70:[function(t,e,r){var n={}.toString;e.exports=function(t){return n.call(t).slice(8,-1)}},{}],71:[function(t,e,r){var n=t("../internals/classof-raw"),i=t("../internals/well-known-symbol")("toStringTag"),a="Arguments"==n(function(){return arguments}());e.exports=function(t){var e,r,o;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(r=function(t,e){try{return t[e]}catch(t){}}(e=Object(t),i))?r:a?n(e):"Object"==(o=n(e))&&"function"==typeof e.callee?"Arguments":o}},{"../internals/classof-raw":70,"../internals/well-known-symbol":169}],72:[function(t,e,r){var n=t("../internals/has"),i=t("../internals/own-keys"),a=t("../internals/object-get-own-property-descriptor"),o=t("../internals/object-define-property");e.exports=function(t,e){for(var r=i(e),s=o.f,l=a.f,u=0;u<r.length;u++){var f=r[u];n(t,f)||s(t,f,l(e,f))}}},{"../internals/has":93,"../internals/object-define-property":120,"../internals/object-get-own-property-descriptor":121,"../internals/own-keys":132}],73:[function(t,e,r){var n=t("../internals/well-known-symbol")("match");e.exports=function(t){var e=/./;try{"/./"[t](e)}catch(r){try{return e[n]=!1,"/./"[t](e)}catch(t){}}return!1}},{"../internals/well-known-symbol":169}],74:[function(t,e,r){var n=t("../internals/fails");e.exports=!n((function(){function t(){}return t.prototype.constructor=null,Object.getPrototypeOf(new t)!==t.prototype}))},{"../internals/fails":86}],75:[function(t,e,r){"use strict";var n=t("../internals/iterators-core").IteratorPrototype,i=t("../internals/object-create"),a=t("../internals/create-property-descriptor"),o=t("../internals/set-to-string-tag"),s=t("../internals/iterators"),l=function(){return this};e.exports=function(t,e,r){var u=e+" Iterator";return t.prototype=i(n,{next:a(1,r)}),o(t,u,!1,!0),s[u]=l,t}},{"../internals/create-property-descriptor":77,"../internals/iterators":110,"../internals/iterators-core":109,"../internals/object-create":118,"../internals/set-to-string-tag":145}],76:[function(t,e,r){var n=t("../internals/descriptors"),i=t("../internals/object-define-property"),a=t("../internals/create-property-descriptor");e.exports=n?function(t,e,r){return i.f(t,e,a(1,r))}:function(t,e,r){return t[e]=r,t}},{"../internals/create-property-descriptor":77,"../internals/descriptors":81,"../internals/object-define-property":120}],77:[function(t,e,r){e.exports=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}}},{}],78:[function(t,e,r){"use strict";var n=t("../internals/to-primitive"),i=t("../internals/object-define-property"),a=t("../internals/create-property-descriptor");e.exports=function(t,e,r){var o=n(e);o in t?i.f(t,o,a(0,r)):t[o]=r}},{"../internals/create-property-descriptor":77,"../internals/object-define-property":120,"../internals/to-primitive":162}],79:[function(t,e,r){"use strict";var n=t("../internals/export"),i=t("../internals/create-iterator-constructor"),a=t("../internals/object-get-prototype-of"),o=t("../internals/object-set-prototype-of"),s=t("../internals/set-to-string-tag"),l=t("../internals/create-non-enumerable-property"),u=t("../internals/redefine"),f=t("../internals/well-known-symbol"),h=t("../internals/is-pure"),c=t("../internals/iterators"),d=t("../internals/iterators-core"),p=d.IteratorPrototype,b=d.BUGGY_SAFARI_ITERATORS,m=f("iterator"),g="keys",y="values",v="entries",_=function(){return this};e.exports=function(t,e,r,f,d,w,x){i(r,e,f);var E,k,j,S=function(t){if(t===d&&M)return M;if(!b&&t in I)return I[t];switch(t){case g:case y:case v:return function(){return new r(this,t)}}return function(){return new r(this)}},A=e+" Iterator",T=!1,I=t.prototype,P=I[m]||I["@@iterator"]||d&&I[d],M=!b&&P||S(d),O="Array"==e&&I.entries||P;if(O&&(E=a(O.call(new t)),p!==Object.prototype&&E.next&&(h||a(E)===p||(o?o(E,p):"function"!=typeof E[m]&&l(E,m,_)),s(E,A,!0,!0),h&&(c[A]=_))),d==y&&P&&P.name!==y&&(T=!0,M=function(){return P.call(this)}),h&&!x||I[m]===M||l(I,m,M),c[e]=M,d)if(k={values:S(y),keys:w?M:S(g),entries:S(v)},x)for(j in k)(b||T||!(j in I))&&u(I,j,k[j]);else n({target:e,proto:!0,forced:b||T},k);return k}},{"../internals/create-iterator-constructor":75,"../internals/create-non-enumerable-property":76,"../internals/export":85,"../internals/is-pure":106,"../internals/iterators":110,"../internals/iterators-core":109,"../internals/object-get-prototype-of":125,"../internals/object-set-prototype-of":129,"../internals/redefine":138,"../internals/set-to-string-tag":145,"../internals/well-known-symbol":169}],80:[function(t,e,r){var n=t("../internals/path"),i=t("../internals/has"),a=t("../internals/wrapped-well-known-symbol"),o=t("../internals/object-define-property").f;e.exports=function(t){var e=n.Symbol||(n.Symbol={});i(e,t)||o(e,t,{value:a.f(t)})}},{"../internals/has":93,"../internals/object-define-property":120,"../internals/path":134,"../internals/wrapped-well-known-symbol":171}],81:[function(t,e,r){var n=t("../internals/fails");e.exports=!n((function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a}))},{"../internals/fails":86}],82:[function(t,e,r){var n=t("../internals/global"),i=t("../internals/is-object"),a=n.document,o=i(a)&&i(a.createElement);e.exports=function(t){return o?a.createElement(t):{}}},{"../internals/global":92,"../internals/is-object":105}],83:[function(t,e,r){e.exports={CSSRuleList:0,CSSStyleDeclaration:0,CSSValueList:0,ClientRectList:0,DOMRectList:0,DOMStringList:0,DOMTokenList:1,DataTransferItemList:0,FileList:0,HTMLAllCollection:0,HTMLCollection:0,HTMLFormElement:0,HTMLSelectElement:0,MediaList:0,MimeTypeArray:0,NamedNodeMap:0,NodeList:1,PaintRequestList:0,Plugin:0,PluginArray:0,SVGLengthList:0,SVGNumberList:0,SVGPathSegList:0,SVGPointList:0,SVGStringList:0,SVGTransformList:0,SourceBufferList:0,StyleSheetList:0,TextTrackCueList:0,TextTrackList:0,TouchList:0}},{}],84:[function(t,e,r){e.exports=["constructor","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","toLocaleString","toString","valueOf"]},{}],85:[function(t,e,r){var n=t("../internals/global"),i=t("../internals/object-get-own-property-descriptor").f,a=t("../internals/create-non-enumerable-property"),o=t("../internals/redefine"),s=t("../internals/set-global"),l=t("../internals/copy-constructor-properties"),u=t("../internals/is-forced");e.exports=function(t,e){var r,f,h,c,d,p=t.target,b=t.global,m=t.stat;if(r=b?n:m?n[p]||s(p,{}):(n[p]||{}).prototype)for(f in e){if(c=e[f],h=t.noTargetGet?(d=i(r,f))&&d.value:r[f],!u(b?f:p+(m?".":"#")+f,t.forced)&&void 0!==h){if(typeof c==typeof h)continue;l(c,h)}(t.sham||h&&h.sham)&&a(c,"sham",!0),o(r,f,c,t)}}},{"../internals/copy-constructor-properties":72,"../internals/create-non-enumerable-property":76,"../internals/global":92,"../internals/is-forced":103,"../internals/object-get-own-property-descriptor":121,"../internals/redefine":138,"../internals/set-global":143}],86:[function(t,e,r){e.exports=function(t){try{return!!t()}catch(t){return!0}}},{}],87:[function(t,e,r){"use strict";var n=t("../internals/create-non-enumerable-property"),i=t("../internals/redefine"),a=t("../internals/fails"),o=t("../internals/well-known-symbol"),s=t("../internals/regexp-exec"),l=o("species"),u=!a((function(){var t=/./;return t.exec=function(){var t=[];return t.groups={a:"7"},t},"7"!=="".replace(t,"$<a>")})),f=!a((function(){var t=/(?:)/,e=t.exec;t.exec=function(){return e.apply(this,arguments)};var r="ab".split(t);return 2!==r.length||"a"!==r[0]||"b"!==r[1]}));e.exports=function(t,e,r,h){var c=o(t),d=!a((function(){var e={};return e[c]=function(){return 7},7!=""[t](e)})),p=d&&!a((function(){var e=!1,r=/a/;return"split"===t&&((r={}).constructor={},r.constructor[l]=function(){return r},r.flags="",r[c]=/./[c]),r.exec=function(){return e=!0,null},r[c](""),!e}));if(!d||!p||"replace"===t&&!u||"split"===t&&!f){var b=/./[c],m=r(c,""[t],(function(t,e,r,n,i){return e.exec===s?d&&!i?{done:!0,value:b.call(e,r,n)}:{done:!0,value:t.call(r,e,n)}:{done:!1}})),g=m[0],y=m[1];i(String.prototype,t,g),i(RegExp.prototype,c,2==e?function(t,e){return y.call(t,this,e)}:function(t){return y.call(t,this)}),h&&n(RegExp.prototype[c],"sham",!0)}}},{"../internals/create-non-enumerable-property":76,"../internals/fails":86,"../internals/redefine":138,"../internals/regexp-exec":140,"../internals/well-known-symbol":169}],88:[function(t,e,r){"use strict";var n=t("../internals/a-function"),i=t("../internals/is-object"),a=[].slice,o={};e.exports=Function.bind||function(t){var e=n(this),r=a.call(arguments,1),s=function(){var n=r.concat(a.call(arguments));return this instanceof s?function(t,e,r){if(!(e in o)){for(var n=[],i=0;i<e;i++)n[i]="a["+i+"]";o[e]=Function("C,a","return new C("+n.join(",")+")")}return o[e](t,r)}(e,n.length,n):e.apply(t,n)};return i(e.prototype)&&(s.prototype=e.prototype),s}},{"../internals/a-function":50,"../internals/is-object":105}],89:[function(t,e,r){var n=t("../internals/shared");e.exports=n("native-function-to-string",Function.toString)},{"../internals/shared":148}],90:[function(t,e,r){var n=t("../internals/path"),i=t("../internals/global"),a=function(t){return"function"==typeof t?t:void 0};e.exports=function(t,e){return arguments.length<2?a(n[t])||a(i[t]):n[t]&&n[t][e]||i[t]&&i[t][e]}},{"../internals/global":92,"../internals/path":134}],91:[function(t,e,r){var n=t("../internals/classof"),i=t("../internals/iterators"),a=t("../internals/well-known-symbol")("iterator");e.exports=function(t){if(null!=t)return t[a]||t["@@iterator"]||i[n(t)]}},{"../internals/classof":71,"../internals/iterators":110,"../internals/well-known-symbol":169}],92:[function(t,e,i){(function(t){var r=function(t){return t&&t.Math==Math&&t};e.exports=r("object"==typeof globalThis&&globalThis)||r("object"==typeof n&&n)||r("object"==typeof self&&self)||r("object"==typeof t&&t)||Function("return this")()}).call(this,void 0!==r.g?r.g:"undefined"!=typeof self?self:void 0!==n?n:{})},{}],93:[function(t,e,r){var n={}.hasOwnProperty;e.exports=function(t,e){return n.call(t,e)}},{}],94:[function(t,e,r){e.exports={}},{}],95:[function(t,e,r){var n=t("../internals/global");e.exports=function(t,e){var r=n.console;r&&r.error&&(1===arguments.length?r.error(t):r.error(t,e))}},{"../internals/global":92}],96:[function(t,e,r){var n=t("../internals/get-built-in");e.exports=n("document","documentElement")},{"../internals/get-built-in":90}],97:[function(t,e,r){var n=t("../internals/descriptors"),i=t("../internals/fails"),a=t("../internals/document-create-element");e.exports=!n&&!i((function(){return 7!=Object.defineProperty(a("div"),"a",{get:function(){return 7}}).a}))},{"../internals/descriptors":81,"../internals/document-create-element":82,"../internals/fails":86}],98:[function(t,e,r){var n=t("../internals/fails"),i=t("../internals/classof-raw"),a="".split;e.exports=n((function(){return!Object("z").propertyIsEnumerable(0)}))?function(t){return"String"==i(t)?a.call(t,""):Object(t)}:Object},{"../internals/classof-raw":70,"../internals/fails":86}],99:[function(t,e,r){var n=t("../internals/is-object"),i=t("../internals/object-set-prototype-of");e.exports=function(t,e,r){var a,o;return i&&"function"==typeof(a=e.constructor)&&a!==r&&n(o=a.prototype)&&o!==r.prototype&&i(t,o),t}},{"../internals/is-object":105,"../internals/object-set-prototype-of":129}],100:[function(t,e,r){var n,i,a,o=t("../internals/native-weak-map"),s=t("../internals/global"),l=t("../internals/is-object"),u=t("../internals/create-non-enumerable-property"),f=t("../internals/has"),h=t("../internals/shared-key"),c=t("../internals/hidden-keys"),d=s.WeakMap;if(o){var p=new d,b=p.get,m=p.has,g=p.set;n=function(t,e){return g.call(p,t,e),e},i=function(t){return b.call(p,t)||{}},a=function(t){return m.call(p,t)}}else{var y=h("state");c[y]=!0,n=function(t,e){return u(t,y,e),e},i=function(t){return f(t,y)?t[y]:{}},a=function(t){return f(t,y)}}e.exports={set:n,get:i,has:a,enforce:function(t){return a(t)?i(t):n(t,{})},getterFor:function(t){return function(e){var r;if(!l(e)||(r=i(e)).type!==t)throw TypeError("Incompatible receiver, "+t+" required");return r}}}},{"../internals/create-non-enumerable-property":76,"../internals/global":92,"../internals/has":93,"../internals/hidden-keys":94,"../internals/is-object":105,"../internals/native-weak-map":114,"../internals/shared-key":146}],101:[function(t,e,r){var n=t("../internals/well-known-symbol"),i=t("../internals/iterators"),a=n("iterator"),o=Array.prototype;e.exports=function(t){return void 0!==t&&(i.Array===t||o[a]===t)}},{"../internals/iterators":110,"../internals/well-known-symbol":169}],102:[function(t,e,r){var n=t("../internals/classof-raw");e.exports=Array.isArray||function(t){return"Array"==n(t)}},{"../internals/classof-raw":70}],103:[function(t,e,r){var n=t("../internals/fails"),i=/#|\.prototype\./,a=function(t,e){var r=s[o(t)];return r==u||r!=l&&("function"==typeof e?n(e):!!e)},o=a.normalize=function(t){return String(t).replace(i,".").toLowerCase()},s=a.data={},l=a.NATIVE="N",u=a.POLYFILL="P";e.exports=a},{"../internals/fails":86}],104:[function(t,e,r){var n=t("../internals/user-agent");e.exports=/(iphone|ipod|ipad).*applewebkit/i.test(n)},{"../internals/user-agent":167}],105:[function(t,e,r){e.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},{}],106:[function(t,e,r){e.exports=!1},{}],107:[function(t,e,r){var n=t("../internals/is-object"),i=t("../internals/classof-raw"),a=t("../internals/well-known-symbol")("match");e.exports=function(t){var e;return n(t)&&(void 0!==(e=t[a])?!!e:"RegExp"==i(t))}},{"../internals/classof-raw":70,"../internals/is-object":105,"../internals/well-known-symbol":169}],108:[function(t,e,r){var n=t("../internals/an-object"),i=t("../internals/is-array-iterator-method"),a=t("../internals/to-length"),o=t("../internals/bind-context"),s=t("../internals/get-iterator-method"),l=t("../internals/call-with-safe-iteration-closing"),u=function(t,e){this.stopped=t,this.result=e};(e.exports=function(t,e,r,f,h){var c,d,p,b,m,g,y,v=o(e,r,f?2:1);if(h)c=t;else{if("function"!=typeof(d=s(t)))throw TypeError("Target is not iterable");if(i(d)){for(p=0,b=a(t.length);b>p;p++)if((m=f?v(n(y=t[p])[0],y[1]):v(t[p]))&&m instanceof u)return m;return new u(!1)}c=d.call(t)}for(g=c.next;!(y=g.call(c)).done;)if("object"==typeof(m=l(c,v,y.value,f))&&m&&m instanceof u)return m;return new u(!1)}).stop=function(t){return new u(!0,t)}},{"../internals/an-object":55,"../internals/bind-context":67,"../internals/call-with-safe-iteration-closing":68,"../internals/get-iterator-method":91,"../internals/is-array-iterator-method":101,"../internals/to-length":158}],109:[function(t,e,r){"use strict";var n,i,a,o=t("../internals/object-get-prototype-of"),s=t("../internals/create-non-enumerable-property"),l=t("../internals/has"),u=t("../internals/well-known-symbol"),f=t("../internals/is-pure"),h=u("iterator"),c=!1;[].keys&&("next"in(a=[].keys())?(i=o(o(a)))!==Object.prototype&&(n=i):c=!0),null==n&&(n={}),f||l(n,h)||s(n,h,(function(){return this})),e.exports={IteratorPrototype:n,BUGGY_SAFARI_ITERATORS:c}},{"../internals/create-non-enumerable-property":76,"../internals/has":93,"../internals/is-pure":106,"../internals/object-get-prototype-of":125,"../internals/well-known-symbol":169}],110:[function(t,e,r){arguments[4][94][0].apply(r,arguments)},{dup:94}],111:[function(t,e,r){var n,i,a,o,s,l,u,f,h=t("../internals/global"),c=t("../internals/object-get-own-property-descriptor").f,d=t("../internals/classof-raw"),p=t("../internals/task").set,b=t("../internals/is-ios"),m=h.MutationObserver||h.WebKitMutationObserver,g=h.process,y=h.Promise,v="process"==d(g),_=c(h,"queueMicrotask"),w=_&&_.value;w||(n=function(){var t,e;for(v&&(t=g.domain)&&t.exit();i;){e=i.fn,i=i.next;try{e()}catch(t){throw i?o():a=void 0,t}}a=void 0,t&&t.enter()},v?o=function(){g.nextTick(n)}:m&&!b?(s=!0,l=document.createTextNode(""),new m(n).observe(l,{characterData:!0}),o=function(){l.data=s=!s}):y&&y.resolve?(u=y.resolve(void 0),f=u.then,o=function(){f.call(u,n)}):o=function(){p.call(h,n)}),e.exports=w||function(t){var e={fn:t,next:void 0};a&&(a.next=e),i||(i=e,o()),a=e}},{"../internals/classof-raw":70,"../internals/global":92,"../internals/is-ios":104,"../internals/object-get-own-property-descriptor":121,"../internals/task":153}],112:[function(t,e,r){var n=t("../internals/global");e.exports=n.Promise},{"../internals/global":92}],113:[function(t,e,r){var n=t("../internals/fails");e.exports=!!Object.getOwnPropertySymbols&&!n((function(){return!String(Symbol())}))},{"../internals/fails":86}],114:[function(t,e,r){var n=t("../internals/global"),i=t("../internals/function-to-string"),a=n.WeakMap;e.exports="function"==typeof a&&/native code/.test(i.call(a))},{"../internals/function-to-string":89,"../internals/global":92}],115:[function(t,e,r){"use strict";var n=t("../internals/a-function"),i=function(t){var e,r;this.promise=new t((function(t,n){if(void 0!==e||void 0!==r)throw TypeError("Bad Promise constructor");e=t,r=n})),this.resolve=n(e),this.reject=n(r)};e.exports.f=function(t){return new i(t)}},{"../internals/a-function":50}],116:[function(t,e,r){var n=t("../internals/is-regexp");e.exports=function(t){if(n(t))throw TypeError("The method doesn't accept regular expressions");return t}},{"../internals/is-regexp":107}],117:[function(t,e,r){"use strict";var n=t("../internals/descriptors"),i=t("../internals/fails"),a=t("../internals/object-keys"),o=t("../internals/object-get-own-property-symbols"),s=t("../internals/object-property-is-enumerable"),l=t("../internals/to-object"),u=t("../internals/indexed-object"),f=Object.assign;e.exports=!f||i((function(){var t={},e={},r=Symbol(),n="abcdefghijklmnopqrst";return t[r]=7,n.split("").forEach((function(t){e[t]=t})),7!=f({},t)[r]||a(f({},e)).join("")!=n}))?function(t,e){for(var r=l(t),i=arguments.length,f=1,h=o.f,c=s.f;i>f;)for(var d,p=u(arguments[f++]),b=h?a(p).concat(h(p)):a(p),m=b.length,g=0;m>g;)d=b[g++],n&&!c.call(p,d)||(r[d]=p[d]);return r}:f},{"../internals/descriptors":81,"../internals/fails":86,"../internals/indexed-object":98,"../internals/object-get-own-property-symbols":124,"../internals/object-keys":127,"../internals/object-property-is-enumerable":128,"../internals/to-object":159}],118:[function(t,e,r){var n=t("../internals/an-object"),i=t("../internals/object-define-properties"),a=t("../internals/enum-bug-keys"),o=t("../internals/hidden-keys"),s=t("../internals/html"),l=t("../internals/document-create-element"),u=t("../internals/shared-key")("IE_PROTO"),f="prototype",h=function(){},c=function(){var t,e=l("iframe"),r=a.length,n="script",i="java"+n+":";for(e.style.display="none",s.appendChild(e),e.src=String(i),(t=e.contentWindow.document).open(),t.write("<"+n+">document.F=Object</"+n+">"),t.close(),c=t.F;r--;)delete c[f][a[r]];return c()};e.exports=Object.create||function(t,e){var r;return null!==t?(h[f]=n(t),r=new h,h[f]=null,r[u]=t):r=c(),void 0===e?r:i(r,e)},o[u]=!0},{"../internals/an-object":55,"../internals/document-create-element":82,"../internals/enum-bug-keys":84,"../internals/hidden-keys":94,"../internals/html":96,"../internals/object-define-properties":119,"../internals/shared-key":146}],119:[function(t,e,r){var n=t("../internals/descriptors"),i=t("../internals/object-define-property"),a=t("../internals/an-object"),o=t("../internals/object-keys");e.exports=n?Object.defineProperties:function(t,e){a(t);for(var r,n=o(e),s=n.length,l=0;s>l;)i.f(t,r=n[l++],e[r]);return t}},{"../internals/an-object":55,"../internals/descriptors":81,"../internals/object-define-property":120,"../internals/object-keys":127}],120:[function(t,e,r){var n=t("../internals/descriptors"),i=t("../internals/ie8-dom-define"),a=t("../internals/an-object"),o=t("../internals/to-primitive"),s=Object.defineProperty;r.f=n?s:function(t,e,r){if(a(t),e=o(e,!0),a(r),i)try{return s(t,e,r)}catch(t){}if("get"in r||"set"in r)throw TypeError("Accessors not supported");return"value"in r&&(t[e]=r.value),t}},{"../internals/an-object":55,"../internals/descriptors":81,"../internals/ie8-dom-define":97,"../internals/to-primitive":162}],121:[function(t,e,r){var n=t("../internals/descriptors"),i=t("../internals/object-property-is-enumerable"),a=t("../internals/create-property-descriptor"),o=t("../internals/to-indexed-object"),s=t("../internals/to-primitive"),l=t("../internals/has"),u=t("../internals/ie8-dom-define"),f=Object.getOwnPropertyDescriptor;r.f=n?f:function(t,e){if(t=o(t),e=s(e,!0),u)try{return f(t,e)}catch(t){}if(l(t,e))return a(!i.f.call(t,e),t[e])}},{"../internals/create-property-descriptor":77,"../internals/descriptors":81,"../internals/has":93,"../internals/ie8-dom-define":97,"../internals/object-property-is-enumerable":128,"../internals/to-indexed-object":156,"../internals/to-primitive":162}],122:[function(t,e,r){var i=t("../internals/to-indexed-object"),a=t("../internals/object-get-own-property-names").f,o={}.toString,s="object"==typeof n&&n&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(n):[];e.exports.f=function(t){return s&&"[object Window]"==o.call(t)?function(t){try{return a(t)}catch(t){return s.slice()}}(t):a(i(t))}},{"../internals/object-get-own-property-names":123,"../internals/to-indexed-object":156}],123:[function(t,e,r){var n=t("../internals/object-keys-internal"),i=t("../internals/enum-bug-keys").concat("length","prototype");r.f=Object.getOwnPropertyNames||function(t){return n(t,i)}},{"../internals/enum-bug-keys":84,"../internals/object-keys-internal":126}],124:[function(t,e,r){r.f=Object.getOwnPropertySymbols},{}],125:[function(t,e,r){var n=t("../internals/has"),i=t("../internals/to-object"),a=t("../internals/shared-key"),o=t("../internals/correct-prototype-getter"),s=a("IE_PROTO"),l=Object.prototype;e.exports=o?Object.getPrototypeOf:function(t){return t=i(t),n(t,s)?t[s]:"function"==typeof t.constructor&&t instanceof t.constructor?t.constructor.prototype:t instanceof Object?l:null}},{"../internals/correct-prototype-getter":74,"../internals/has":93,"../internals/shared-key":146,"../internals/to-object":159}],126:[function(t,e,r){var n=t("../internals/has"),i=t("../internals/to-indexed-object"),a=t("../internals/array-includes").indexOf,o=t("../internals/hidden-keys");e.exports=function(t,e){var r,s=i(t),l=0,u=[];for(r in s)!n(o,r)&&n(s,r)&&u.push(r);for(;e.length>l;)n(s,r=e[l++])&&(~a(u,r)||u.push(r));return u}},{"../internals/array-includes":61,"../internals/has":93,"../internals/hidden-keys":94,"../internals/to-indexed-object":156}],127:[function(t,e,r){var n=t("../internals/object-keys-internal"),i=t("../internals/enum-bug-keys");e.exports=Object.keys||function(t){return n(t,i)}},{"../internals/enum-bug-keys":84,"../internals/object-keys-internal":126}],128:[function(t,e,r){"use strict";var n={}.propertyIsEnumerable,i=Object.getOwnPropertyDescriptor,a=i&&!n.call({1:2},1);r.f=a?function(t){var e=i(this,t);return!!e&&e.enumerable}:n},{}],129:[function(t,e,r){var n=t("../internals/an-object"),i=t("../internals/a-possible-prototype");e.exports=Object.setPrototypeOf||("__proto__"in{}?function(){var t,e=!1,r={};try{(t=Object.getOwnPropertyDescriptor(Object.prototype,"__proto__").set).call(r,[]),e=r instanceof Array}catch(t){}return function(r,a){return n(r),i(a),e?t.call(r,a):r.__proto__=a,r}}():void 0)},{"../internals/a-possible-prototype":51,"../internals/an-object":55}],130:[function(t,e,r){var n=t("../internals/descriptors"),i=t("../internals/object-keys"),a=t("../internals/to-indexed-object"),o=t("../internals/object-property-is-enumerable").f,s=function(t){return function(e){for(var r,s=a(e),l=i(s),u=l.length,f=0,h=[];u>f;)r=l[f++],n&&!o.call(s,r)||h.push(t?[r,s[r]]:s[r]);return h}};e.exports={entries:s(!0),values:s(!1)}},{"../internals/descriptors":81,"../internals/object-keys":127,"../internals/object-property-is-enumerable":128,"../internals/to-indexed-object":156}],131:[function(t,e,r){"use strict";var n=t("../internals/classof"),i={};i[t("../internals/well-known-symbol")("toStringTag")]="z",e.exports="[object z]"!==String(i)?function(){return"[object "+n(this)+"]"}:i.toString},{"../internals/classof":71,"../internals/well-known-symbol":169}],132:[function(t,e,r){var n=t("../internals/get-built-in"),i=t("../internals/object-get-own-property-names"),a=t("../internals/object-get-own-property-symbols"),o=t("../internals/an-object");e.exports=n("Reflect","ownKeys")||function(t){var e=i.f(o(t)),r=a.f;return r?e.concat(r(t)):e}},{"../internals/an-object":55,"../internals/get-built-in":90,"../internals/object-get-own-property-names":123,"../internals/object-get-own-property-symbols":124}],133:[function(t,e,r){var n=t("../internals/global"),i=t("../internals/string-trim").trim,a=t("../internals/whitespaces"),o=n.parseInt,s=/^[+-]?0[Xx]/,l=8!==o(a+"08")||22!==o(a+"0x16");e.exports=l?function(t,e){var r=i(String(t));return o(r,e>>>0||(s.test(r)?16:10))}:o},{"../internals/global":92,"../internals/string-trim":152,"../internals/whitespaces":170}],134:[function(t,e,r){e.exports=t("../internals/global")},{"../internals/global":92}],135:[function(t,e,r){e.exports=function(t){try{return{error:!1,value:t()}}catch(t){return{error:!0,value:t}}}},{}],136:[function(t,e,r){var n=t("../internals/an-object"),i=t("../internals/is-object"),a=t("../internals/new-promise-capability");e.exports=function(t,e){if(n(t),i(e)&&e.constructor===t)return e;var r=a.f(t);return(0,r.resolve)(e),r.promise}},{"../internals/an-object":55,"../internals/is-object":105,"../internals/new-promise-capability":115}],137:[function(t,e,r){var n=t("../internals/redefine");e.exports=function(t,e,r){for(var i in e)n(t,i,e[i],r);return t}},{"../internals/redefine":138}],138:[function(t,e,r){var n=t("../internals/global"),i=t("../internals/shared"),a=t("../internals/create-non-enumerable-property"),o=t("../internals/has"),s=t("../internals/set-global"),l=t("../internals/function-to-string"),u=t("../internals/internal-state"),f=u.get,h=u.enforce,c=String(l).split("toString");i("inspectSource",(function(t){return l.call(t)})),(e.exports=function(t,e,r,i){var l=!!i&&!!i.unsafe,u=!!i&&!!i.enumerable,f=!!i&&!!i.noTargetGet;"function"==typeof r&&("string"!=typeof e||o(r,"name")||a(r,"name",e),h(r).source=c.join("string"==typeof e?e:"")),t!==n?(l?!f&&t[e]&&(u=!0):delete t[e],u?t[e]=r:a(t,e,r)):u?t[e]=r:s(e,r)})(Function.prototype,"toString",(function(){return"function"==typeof this&&f(this).source||l.call(this)}))},{"../internals/create-non-enumerable-property":76,"../internals/function-to-string":89,"../internals/global":92,"../internals/has":93,"../internals/internal-state":100,"../internals/set-global":143,"../internals/shared":148}],139:[function(t,e,r){var n=t("./classof-raw"),i=t("./regexp-exec");e.exports=function(t,e){var r=t.exec;if("function"==typeof r){var a=r.call(t,e);if("object"!=typeof a)throw TypeError("RegExp exec method returned something other than an Object or null");return a}if("RegExp"!==n(t))throw TypeError("RegExp#exec called on incompatible receiver");return i.call(t,e)}},{"./classof-raw":70,"./regexp-exec":140}],140:[function(t,e,r){"use strict";var n,i,a=t("./regexp-flags"),o=RegExp.prototype.exec,s=String.prototype.replace,l=o,u=(n=/a/,i=/b*/g,o.call(n,"a"),o.call(i,"a"),0!==n.lastIndex||0!==i.lastIndex),f=void 0!==/()??/.exec("")[1];(u||f)&&(l=function(t){var e,r,n,i,l=this;return f&&(r=new RegExp("^"+l.source+"$(?!\\s)",a.call(l))),u&&(e=l.lastIndex),n=o.call(l,t),u&&n&&(l.lastIndex=l.global?n.index+n[0].length:e),f&&n&&n.length>1&&s.call(n[0],r,(function(){for(i=1;i<arguments.length-2;i++)void 0===arguments[i]&&(n[i]=void 0)})),n}),e.exports=l},{"./regexp-flags":141}],141:[function(t,e,r){"use strict";var n=t("../internals/an-object");e.exports=function(){var t=n(this),e="";return t.global&&(e+="g"),t.ignoreCase&&(e+="i"),t.multiline&&(e+="m"),t.dotAll&&(e+="s"),t.unicode&&(e+="u"),t.sticky&&(e+="y"),e}},{"../internals/an-object":55}],142:[function(t,e,r){e.exports=function(t){if(null==t)throw TypeError("Can't call method on "+t);return t}},{}],143:[function(t,e,r){var n=t("../internals/global"),i=t("../internals/create-non-enumerable-property");e.exports=function(t,e){try{i(n,t,e)}catch(r){n[t]=e}return e}},{"../internals/create-non-enumerable-property":76,"../internals/global":92}],144:[function(t,e,r){"use strict";var n=t("../internals/get-built-in"),i=t("../internals/object-define-property"),a=t("../internals/well-known-symbol"),o=t("../internals/descriptors"),s=a("species");e.exports=function(t){var e=n(t),r=i.f;o&&e&&!e[s]&&r(e,s,{configurable:!0,get:function(){return this}})}},{"../internals/descriptors":81,"../internals/get-built-in":90,"../internals/object-define-property":120,"../internals/well-known-symbol":169}],145:[function(t,e,r){var n=t("../internals/object-define-property").f,i=t("../internals/has"),a=t("../internals/well-known-symbol")("toStringTag");e.exports=function(t,e,r){t&&!i(t=r?t:t.prototype,a)&&n(t,a,{configurable:!0,value:e})}},{"../internals/has":93,"../internals/object-define-property":120,"../internals/well-known-symbol":169}],146:[function(t,e,r){var n=t("../internals/shared"),i=t("../internals/uid"),a=n("keys");e.exports=function(t){return a[t]||(a[t]=i(t))}},{"../internals/shared":148,"../internals/uid":166}],147:[function(t,e,r){var n=t("../internals/global"),i=t("../internals/set-global"),a="__core-js_shared__",o=n[a]||i(a,{});e.exports=o},{"../internals/global":92,"../internals/set-global":143}],148:[function(t,e,r){var n=t("../internals/is-pure"),i=t("../internals/shared-store");(e.exports=function(t,e){return i[t]||(i[t]=void 0!==e?e:{})})("versions",[]).push({version:"3.4.1",mode:n?"pure":"global",copyright:"© 2019 Denis Pushkarev (zloirock.ru)"})},{"../internals/is-pure":106,"../internals/shared-store":147}],149:[function(t,e,r){"use strict";var n=t("../internals/fails");e.exports=function(t,e){var r=[][t];return!r||!n((function(){r.call(null,e||function(){throw 1},1)}))}},{"../internals/fails":86}],150:[function(t,e,r){var n=t("../internals/an-object"),i=t("../internals/a-function"),a=t("../internals/well-known-symbol")("species");e.exports=function(t,e){var r,o=n(t).constructor;return void 0===o||null==(r=n(o)[a])?e:i(r)}},{"../internals/a-function":50,"../internals/an-object":55,"../internals/well-known-symbol":169}],151:[function(t,e,r){var n=t("../internals/to-integer"),i=t("../internals/require-object-coercible"),a=function(t){return function(e,r){var a,o,s=String(i(e)),l=n(r),u=s.length;return l<0||l>=u?t?"":void 0:(a=s.charCodeAt(l))<55296||a>56319||l+1===u||(o=s.charCodeAt(l+1))<56320||o>57343?t?s.charAt(l):a:t?s.slice(l,l+2):o-56320+(a-55296<<10)+65536}};e.exports={codeAt:a(!1),charAt:a(!0)}},{"../internals/require-object-coercible":142,"../internals/to-integer":157}],152:[function(t,e,r){var n=t("../internals/require-object-coercible"),i="["+t("../internals/whitespaces")+"]",a=RegExp("^"+i+i+"*"),o=RegExp(i+i+"*$"),s=function(t){return function(e){var r=String(n(e));return 1&t&&(r=r.replace(a,"")),2&t&&(r=r.replace(o,"")),r}};e.exports={start:s(1),end:s(2),trim:s(3)}},{"../internals/require-object-coercible":142,"../internals/whitespaces":170}],153:[function(t,e,r){var n,i,a,o=t("../internals/global"),s=t("../internals/fails"),l=t("../internals/classof-raw"),u=t("../internals/bind-context"),f=t("../internals/html"),h=t("../internals/document-create-element"),c=t("../internals/is-ios"),d=o.location,p=o.setImmediate,b=o.clearImmediate,m=o.process,g=o.MessageChannel,y=o.Dispatch,v=0,_={},w="onreadystatechange",x=function(t){if(_.hasOwnProperty(t)){var e=_[t];delete _[t],e()}},E=function(t){return function(){x(t)}},k=function(t){x(t.data)},j=function(t){o.postMessage(t+"",d.protocol+"//"+d.host)};p&&b||(p=function(t){for(var e=[],r=1;arguments.length>r;)e.push(arguments[r++]);return _[++v]=function(){("function"==typeof t?t:Function(t)).apply(void 0,e)},n(v),v},b=function(t){delete _[t]},"process"==l(m)?n=function(t){m.nextTick(E(t))}:y&&y.now?n=function(t){y.now(E(t))}:g&&!c?(a=(i=new g).port2,i.port1.onmessage=k,n=u(a.postMessage,a,1)):!o.addEventListener||"function"!=typeof postMessage||o.importScripts||s(j)?n=w in h("script")?function(t){f.appendChild(h("script"))[w]=function(){f.removeChild(this),x(t)}}:function(t){setTimeout(E(t),0)}:(n=j,o.addEventListener("message",k,!1))),e.exports={set:p,clear:b}},{"../internals/bind-context":67,"../internals/classof-raw":70,"../internals/document-create-element":82,"../internals/fails":86,"../internals/global":92,"../internals/html":96,"../internals/is-ios":104}],154:[function(t,e,r){var n=t("../internals/to-integer"),i=Math.max,a=Math.min;e.exports=function(t,e){var r=n(t);return r<0?i(r+e,0):a(r,e)}},{"../internals/to-integer":157}],155:[function(t,e,r){var n=t("../internals/to-integer"),i=t("../internals/to-length");e.exports=function(t){if(void 0===t)return 0;var e=n(t),r=i(e);if(e!==r)throw RangeError("Wrong length or index");return r}},{"../internals/to-integer":157,"../internals/to-length":158}],156:[function(t,e,r){var n=t("../internals/indexed-object"),i=t("../internals/require-object-coercible");e.exports=function(t){return n(i(t))}},{"../internals/indexed-object":98,"../internals/require-object-coercible":142}],157:[function(t,e,r){var n=Math.ceil,i=Math.floor;e.exports=function(t){return isNaN(t=+t)?0:(t>0?i:n)(t)}},{}],158:[function(t,e,r){var n=t("../internals/to-integer"),i=Math.min;e.exports=function(t){return t>0?i(n(t),9007199254740991):0}},{"../internals/to-integer":157}],159:[function(t,e,r){var n=t("../internals/require-object-coercible");e.exports=function(t){return Object(n(t))}},{"../internals/require-object-coercible":142}],160:[function(t,e,r){var n=t("../internals/to-positive-integer");e.exports=function(t,e){var r=n(t);if(r%e)throw RangeError("Wrong offset");return r}},{"../internals/to-positive-integer":161}],161:[function(t,e,r){var n=t("../internals/to-integer");e.exports=function(t){var e=n(t);if(e<0)throw RangeError("The argument can't be less than 0");return e}},{"../internals/to-integer":157}],162:[function(t,e,r){var n=t("../internals/is-object");e.exports=function(t,e){if(!n(t))return t;var r,i;if(e&&"function"==typeof(r=t.toString)&&!n(i=r.call(t)))return i;if("function"==typeof(r=t.valueOf)&&!n(i=r.call(t)))return i;if(!e&&"function"==typeof(r=t.toString)&&!n(i=r.call(t)))return i;throw TypeError("Can't convert object to primitive value")}},{"../internals/is-object":105}],163:[function(t,e,r){"use strict";var n=t("../internals/export"),i=t("../internals/global"),a=t("../internals/descriptors"),o=t("../internals/typed-arrays-constructors-requires-wrappers"),s=t("../internals/array-buffer-view-core"),l=t("../internals/array-buffer"),u=t("../internals/an-instance"),f=t("../internals/create-property-descriptor"),h=t("../internals/create-non-enumerable-property"),c=t("../internals/to-length"),d=t("../internals/to-index"),p=t("../internals/to-offset"),b=t("../internals/to-primitive"),m=t("../internals/has"),g=t("../internals/classof"),y=t("../internals/is-object"),v=t("../internals/object-create"),_=t("../internals/object-set-prototype-of"),w=t("../internals/object-get-own-property-names").f,x=t("../internals/typed-array-from"),E=t("../internals/array-iteration").forEach,k=t("../internals/set-species"),j=t("../internals/object-define-property"),S=t("../internals/object-get-own-property-descriptor"),A=t("../internals/internal-state"),T=t("../internals/inherit-if-required"),I=A.get,P=A.set,M=j.f,O=S.f,R=Math.round,L=i.RangeError,C=l.ArrayBuffer,B=l.DataView,D=s.NATIVE_ARRAY_BUFFER_VIEWS,N=s.TYPED_ARRAY_TAG,U=s.TypedArray,z=s.TypedArrayPrototype,F=s.aTypedArrayConstructor,H=s.isTypedArray,G="BYTES_PER_ELEMENT",q="Wrong length",W=function(t,e){for(var r=0,n=e.length,i=new(F(t))(n);n>r;)i[r]=e[r++];return i},Z=function(t,e){M(t,e,{get:function(){return I(this)[e]}})},V=function(t){var e;return t instanceof C||"ArrayBuffer"==(e=g(t))||"SharedArrayBuffer"==e},Y=function(t,e){return H(t)&&"symbol"!=typeof e&&e in t&&String(+e)==String(e)},X=function(t,e){return Y(t,e=b(e,!0))?f(2,t[e]):O(t,e)},J=function(t,e,r){return!(Y(t,e=b(e,!0))&&y(r)&&m(r,"value"))||m(r,"get")||m(r,"set")||r.configurable||m(r,"writable")&&!r.writable||m(r,"enumerable")&&!r.enumerable?M(t,e,r):(t[e]=r.value,t)};a?(D||(S.f=X,j.f=J,Z(z,"buffer"),Z(z,"byteOffset"),Z(z,"byteLength"),Z(z,"length")),n({target:"Object",stat:!0,forced:!D},{getOwnPropertyDescriptor:X,defineProperty:J}),e.exports=function(t,e,r,a){var s=t+(a?"Clamped":"")+"Array",l="get"+t,f="set"+t,b=i[s],m=b,g=m&&m.prototype,j={},S=function(t,r){M(t,r,{get:function(){return function(t,r){var n=I(t);return n.view[l](r*e+n.byteOffset,!0)}(this,r)},set:function(t){return function(t,r,n){var i=I(t);a&&(n=(n=R(n))<0?0:n>255?255:255&n),i.view[f](r*e+i.byteOffset,n,!0)}(this,r,t)},enumerable:!0})};D?o&&(m=r((function(t,r,n,i){return u(t,m,s),T(y(r)?V(r)?void 0!==i?new b(r,p(n,e),i):void 0!==n?new b(r,p(n,e)):new b(r):H(r)?W(m,r):x.call(m,r):new b(d(r)),t,m)})),_&&_(m,U),E(w(b),(function(t){t in m||h(m,t,b[t])})),m.prototype=g):(m=r((function(t,r,n,i){u(t,m,s);var a,o,l,f=0,h=0;if(y(r)){if(!V(r))return H(r)?W(m,r):x.call(m,r);a=r,h=p(n,e);var b=r.byteLength;if(void 0===i){if(b%e)throw L(q);if((o=b-h)<0)throw L(q)}else if((o=c(i)*e)+h>b)throw L(q);l=o/e}else l=d(r),a=new C(o=l*e);for(P(t,{buffer:a,byteOffset:h,byteLength:o,length:l,view:new B(a)});f<l;)S(t,f++)})),_&&_(m,U),g=m.prototype=v(z)),g.constructor!==m&&h(g,"constructor",m),N&&h(g,N,s),j[s]=m,n({global:!0,forced:m!=b,sham:!D},j),G in m||h(m,G,e),G in g||h(g,G,e),k(s)}):e.exports=function(){}},{"../internals/an-instance":54,"../internals/array-buffer":57,"../internals/array-buffer-view-core":56,"../internals/array-iteration":62,"../internals/classof":71,"../internals/create-non-enumerable-property":76,"../internals/create-property-descriptor":77,"../internals/descriptors":81,"../internals/export":85,"../internals/global":92,"../internals/has":93,"../internals/inherit-if-required":99,"../internals/internal-state":100,"../internals/is-object":105,"../internals/object-create":118,"../internals/object-define-property":120,"../internals/object-get-own-property-descriptor":121,"../internals/object-get-own-property-names":123,"../internals/object-set-prototype-of":129,"../internals/set-species":144,"../internals/to-index":155,"../internals/to-length":158,"../internals/to-offset":160,"../internals/to-primitive":162,"../internals/typed-array-from":164,"../internals/typed-arrays-constructors-requires-wrappers":165}],164:[function(t,e,r){var n=t("../internals/to-object"),i=t("../internals/to-length"),a=t("../internals/get-iterator-method"),o=t("../internals/is-array-iterator-method"),s=t("../internals/bind-context"),l=t("../internals/array-buffer-view-core").aTypedArrayConstructor;e.exports=function(t){var e,r,u,f,h,c,d=n(t),p=arguments.length,b=p>1?arguments[1]:void 0,m=void 0!==b,g=a(d);if(null!=g&&!o(g))for(c=(h=g.call(d)).next,d=[];!(f=c.call(h)).done;)d.push(f.value);for(m&&p>2&&(b=s(b,arguments[2],2)),r=i(d.length),u=new(l(this))(r),e=0;r>e;e++)u[e]=m?b(d[e],e):d[e];return u}},{"../internals/array-buffer-view-core":56,"../internals/bind-context":67,"../internals/get-iterator-method":91,"../internals/is-array-iterator-method":101,"../internals/to-length":158,"../internals/to-object":159}],165:[function(t,e,r){var n=t("../internals/global"),i=t("../internals/fails"),a=t("../internals/check-correctness-of-iteration"),o=t("../internals/array-buffer-view-core").NATIVE_ARRAY_BUFFER_VIEWS,s=n.ArrayBuffer,l=n.Int8Array;e.exports=!o||!i((function(){l(1)}))||!i((function(){new l(-1)}))||!a((function(t){new l,new l(null),new l(1.5),new l(t)}),!0)||i((function(){return 1!==new l(new s(2),1,void 0).length}))},{"../internals/array-buffer-view-core":56,"../internals/check-correctness-of-iteration":69,"../internals/fails":86,"../internals/global":92}],166:[function(t,e,r){var n=0,i=Math.random();e.exports=function(t){return"Symbol("+String(void 0===t?"":t)+")_"+(++n+i).toString(36)}},{}],167:[function(t,e,r){var n=t("../internals/get-built-in");e.exports=n("navigator","userAgent")||""},{"../internals/get-built-in":90}],168:[function(t,e,r){var n,i,a=t("../internals/global"),o=t("../internals/user-agent"),s=a.process,l=s&&s.versions,u=l&&l.v8;u?i=(n=u.split("."))[0]+n[1]:o&&(!(n=o.match(/Edge\/(\d+)/))||n[1]>=74)&&(n=o.match(/Chrome\/(\d+)/))&&(i=n[1]),e.exports=i&&+i},{"../internals/global":92,"../internals/user-agent":167}],169:[function(t,e,r){var n=t("../internals/global"),i=t("../internals/shared"),a=t("../internals/uid"),o=t("../internals/native-symbol"),s=n.Symbol,l=i("wks");e.exports=function(t){return l[t]||(l[t]=o&&s[t]||(o?s:a)("Symbol."+t))}},{"../internals/global":92,"../internals/native-symbol":113,"../internals/shared":148,"../internals/uid":166}],170:[function(t,e,r){e.exports="\t\n\v\f\r                　\u2028\u2029\ufeff"},{}],171:[function(t,e,r){r.f=t("../internals/well-known-symbol")},{"../internals/well-known-symbol":169}],172:[function(t,e,r){"use strict";var n=t("../internals/export"),i=t("../internals/fails"),a=t("../internals/array-buffer"),o=t("../internals/an-object"),s=t("../internals/to-absolute-index"),l=t("../internals/to-length"),u=t("../internals/species-constructor"),f=a.ArrayBuffer,h=a.DataView,c=f.prototype.slice;n({target:"ArrayBuffer",proto:!0,unsafe:!0,forced:i((function(){return!new f(2).slice(1,void 0).byteLength}))},{slice:function(t,e){if(void 0!==c&&void 0===e)return c.call(o(this),t);for(var r=o(this).byteLength,n=s(t,r),i=s(void 0===e?r:e,r),a=new(u(this,f))(l(i-n)),d=new h(this),p=new h(a),b=0;n<i;)p.setUint8(b++,d.getUint8(n++));return a}})},{"../internals/an-object":55,"../internals/array-buffer":57,"../internals/export":85,"../internals/fails":86,"../internals/species-constructor":150,"../internals/to-absolute-index":154,"../internals/to-length":158}],173:[function(t,e,r){"use strict";var n=t("../internals/export"),i=t("../internals/fails"),a=t("../internals/is-array"),o=t("../internals/is-object"),s=t("../internals/to-object"),l=t("../internals/to-length"),u=t("../internals/create-property"),f=t("../internals/array-species-create"),h=t("../internals/array-method-has-species-support"),c=t("../internals/well-known-symbol"),d=t("../internals/v8-version"),p=c("isConcatSpreadable"),b=9007199254740991,m="Maximum allowed index exceeded",g=d>=51||!i((function(){var t=[];return t[p]=!1,t.concat()[0]!==t})),y=h("concat"),v=function(t){if(!o(t))return!1;var e=t[p];return void 0!==e?!!e:a(t)};n({target:"Array",proto:!0,forced:!g||!y},{concat:function(t){var e,r,n,i,a,o=s(this),h=f(o,0),c=0;for(e=-1,n=arguments.length;e<n;e++)if(v(a=-1===e?o:arguments[e])){if(c+(i=l(a.length))>b)throw TypeError(m);for(r=0;r<i;r++,c++)r in a&&u(h,c,a[r])}else{if(c>=b)throw TypeError(m);u(h,c++,a)}return h.length=c,h}})},{"../internals/array-method-has-species-support":64,"../internals/array-species-create":66,"../internals/create-property":78,"../internals/export":85,"../internals/fails":86,"../internals/is-array":102,"../internals/is-object":105,"../internals/to-length":158,"../internals/to-object":159,"../internals/v8-version":168,"../internals/well-known-symbol":169}],174:[function(t,e,r){var n=t("../internals/export"),i=t("../internals/array-fill"),a=t("../internals/add-to-unscopables");n({target:"Array",proto:!0},{fill:i}),a("fill")},{"../internals/add-to-unscopables":52,"../internals/array-fill":59,"../internals/export":85}],175:[function(t,e,r){"use strict";var n=t("../internals/export"),i=t("../internals/array-iteration").filter;n({target:"Array",proto:!0,forced:!t("../internals/array-method-has-species-support")("filter")},{filter:function(t){return i(this,t,arguments.length>1?arguments[1]:void 0)}})},{"../internals/array-iteration":62,"../internals/array-method-has-species-support":64,"../internals/export":85}],176:[function(t,e,r){"use strict";var n=t("../internals/export"),i=t("../internals/array-iteration").findIndex,a=t("../internals/add-to-unscopables"),o="findIndex",s=!0;o in[]&&Array(1)[o]((function(){s=!1})),n({target:"Array",proto:!0,forced:s},{findIndex:function(t){return i(this,t,arguments.length>1?arguments[1]:void 0)}}),a(o)},{"../internals/add-to-unscopables":52,"../internals/array-iteration":62,"../internals/export":85}],177:[function(t,e,r){"use strict";var n=t("../internals/export"),i=t("../internals/array-iteration").find,a=t("../internals/add-to-unscopables"),o="find",s=!0;o in[]&&Array(1)[o]((function(){s=!1})),n({target:"Array",proto:!0,forced:s},{find:function(t){return i(this,t,arguments.length>1?arguments[1]:void 0)}}),a(o)},{"../internals/add-to-unscopables":52,"../internals/array-iteration":62,"../internals/export":85}],178:[function(t,e,r){"use strict";var n=t("../internals/export"),i=t("../internals/array-for-each");n({target:"Array",proto:!0,forced:[].forEach!=i},{forEach:i})},{"../internals/array-for-each":60,"../internals/export":85}],179:[function(t,e,r){"use strict";var n=t("../internals/export"),i=t("../internals/array-includes").includes,a=t("../internals/add-to-unscopables");n({target:"Array",proto:!0},{includes:function(t){return i(this,t,arguments.length>1?arguments[1]:void 0)}}),a("includes")},{"../internals/add-to-unscopables":52,"../internals/array-includes":61,"../internals/export":85}],180:[function(t,e,r){"use strict";var n=t("../internals/export"),i=t("../internals/array-includes").indexOf,a=t("../internals/sloppy-array-method"),o=[].indexOf,s=!!o&&1/[1].indexOf(1,-0)<0,l=a("indexOf");n({target:"Array",proto:!0,forced:s||l},{indexOf:function(t){return s?o.apply(this,arguments)||0:i(this,t,arguments.length>1?arguments[1]:void 0)}})},{"../internals/array-includes":61,"../internals/export":85,"../internals/sloppy-array-method":149}],181:[function(t,e,r){t("../internals/export")({target:"Array",stat:!0},{isArray:t("../internals/is-array")})},{"../internals/export":85,"../internals/is-array":102}],182:[function(t,e,r){"use strict";var n=t("../internals/to-indexed-object"),i=t("../internals/add-to-unscopables"),a=t("../internals/iterators"),o=t("../internals/internal-state"),s=t("../internals/define-iterator"),l="Array Iterator",u=o.set,f=o.getterFor(l);e.exports=s(Array,"Array",(function(t,e){u(this,{type:l,target:n(t),index:0,kind:e})}),(function(){var t=f(this),e=t.target,r=t.kind,n=t.index++;return!e||n>=e.length?(t.target=void 0,{value:void 0,done:!0}):"keys"==r?{value:n,done:!1}:"values"==r?{value:e[n],done:!1}:{value:[n,e[n]],done:!1}}),"values"),a.Arguments=a.Array,i("keys"),i("values"),i("entries")},{"../internals/add-to-unscopables":52,"../internals/define-iterator":79,"../internals/internal-state":100,"../internals/iterators":110,"../internals/to-indexed-object":156}],183:[function(t,e,r){"use strict";var n=t("../internals/export"),i=t("../internals/indexed-object"),a=t("../internals/to-indexed-object"),o=t("../internals/sloppy-array-method"),s=[].join,l=i!=Object,u=o("join",",");n({target:"Array",proto:!0,forced:l||u},{join:function(t){return s.call(a(this),void 0===t?",":t)}})},{"../internals/export":85,"../internals/indexed-object":98,"../internals/sloppy-array-method":149,"../internals/to-indexed-object":156}],184:[function(t,e,r){"use strict";var n=t("../internals/export"),i=t("../internals/array-iteration").map;n({target:"Array",proto:!0,forced:!t("../internals/array-method-has-species-support")("map")},{map:function(t){return i(this,t,arguments.length>1?arguments[1]:void 0)}})},{"../internals/array-iteration":62,"../internals/array-method-has-species-support":64,"../internals/export":85}],185:[function(t,e,r){"use strict";var n=t("../internals/export"),i=t("../internals/is-array"),a=[].reverse,o=[1,2];n({target:"Array",proto:!0,forced:String(o)===String(o.reverse())},{reverse:function(){return i(this)&&(this.length=this.length),a.call(this)}})},{"../internals/export":85,"../internals/is-array":102}],186:[function(t,e,r){"use strict";var n=t("../internals/export"),i=t("../internals/is-object"),a=t("../internals/is-array"),o=t("../internals/to-absolute-index"),s=t("../internals/to-length"),l=t("../internals/to-indexed-object"),u=t("../internals/create-property"),f=t("../internals/array-method-has-species-support"),h=t("../internals/well-known-symbol")("species"),c=[].slice,d=Math.max;n({target:"Array",proto:!0,forced:!f("slice")},{slice:function(t,e){var r,n,f,p=l(this),b=s(p.length),m=o(t,b),g=o(void 0===e?b:e,b);if(a(p)&&("function"!=typeof(r=p.constructor)||r!==Array&&!a(r.prototype)?i(r)&&null===(r=r[h])&&(r=void 0):r=void 0,r===Array||void 0===r))return c.call(p,m,g);for(n=new(void 0===r?Array:r)(d(g-m,0)),f=0;m<g;m++,f++)m in p&&u(n,f,p[m]);return n.length=f,n}})},{"../internals/array-method-has-species-support":64,"../internals/create-property":78,"../internals/export":85,"../internals/is-array":102,"../internals/is-object":105,"../internals/to-absolute-index":154,"../internals/to-indexed-object":156,"../internals/to-length":158,"../internals/well-known-symbol":169}],187:[function(t,e,r){var n=t("../internals/redefine"),i=Date.prototype,a="Invalid Date",o="toString",s=i[o],l=i.getTime;new Date(NaN)+""!=a&&n(i,o,(function(){var t=l.call(this);return t==t?s.call(this):a}))},{"../internals/redefine":138}],188:[function(t,e,r){t("../internals/export")({target:"Function",proto:!0},{bind:t("../internals/function-bind")})},{"../internals/export":85,"../internals/function-bind":88}],189:[function(t,e,r){"use strict";var n=t("../internals/descriptors"),i=t("../internals/global"),a=t("../internals/is-forced"),o=t("../internals/redefine"),s=t("../internals/has"),l=t("../internals/classof-raw"),u=t("../internals/inherit-if-required"),f=t("../internals/to-primitive"),h=t("../internals/fails"),c=t("../internals/object-create"),d=t("../internals/object-get-own-property-names").f,p=t("../internals/object-get-own-property-descriptor").f,b=t("../internals/object-define-property").f,m=t("../internals/string-trim").trim,g="Number",y=i[g],v=y.prototype,_=l(c(v))==g,w=function(t){var e,r,n,i,a,o,s,l,u=f(t,!1);if("string"==typeof u&&u.length>2)if(43===(e=(u=m(u)).charCodeAt(0))||45===e){if(88===(r=u.charCodeAt(2))||120===r)return NaN}else if(48===e){switch(u.charCodeAt(1)){case 66:case 98:n=2,i=49;break;case 79:case 111:n=8,i=55;break;default:return+u}for(o=(a=u.slice(2)).length,s=0;s<o;s++)if((l=a.charCodeAt(s))<48||l>i)return NaN;return parseInt(a,n)}return+u};if(a(g,!y(" 0o1")||!y("0b1")||y("+0x1"))){for(var x,E=function(t){var e=arguments.length<1?0:t,r=this;return r instanceof E&&(_?h((function(){v.valueOf.call(r)})):l(r)!=g)?u(new y(w(e)),r,E):w(e)},k=n?d(y):"MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","),j=0;k.length>j;j++)s(y,x=k[j])&&!s(E,x)&&b(E,x,p(y,x));E.prototype=v,v.constructor=E,o(i,g,E)}},{"../internals/classof-raw":70,"../internals/descriptors":81,"../internals/fails":86,"../internals/global":92,"../internals/has":93,"../internals/inherit-if-required":99,"../internals/is-forced":103,"../internals/object-create":118,"../internals/object-define-property":120,"../internals/object-get-own-property-descriptor":121,"../internals/object-get-own-property-names":123,"../internals/redefine":138,"../internals/string-trim":152,"../internals/to-primitive":162}],190:[function(t,e,r){var n=t("../internals/export"),i=t("../internals/object-assign");n({target:"Object",stat:!0,forced:Object.assign!==i},{assign:i})},{"../internals/export":85,"../internals/object-assign":117}],191:[function(t,e,r){var n=t("../internals/export"),i=t("../internals/descriptors");n({target:"Object",stat:!0,forced:!i,sham:!i},{defineProperties:t("../internals/object-define-properties")})},{"../internals/descriptors":81,"../internals/export":85,"../internals/object-define-properties":119}],192:[function(t,e,r){var n=t("../internals/export"),i=t("../internals/descriptors");n({target:"Object",stat:!0,forced:!i,sham:!i},{defineProperty:t("../internals/object-define-property").f})},{"../internals/descriptors":81,"../internals/export":85,"../internals/object-define-property":120}],193:[function(t,e,r){var n=t("../internals/export"),i=t("../internals/object-to-array").entries;n({target:"Object",stat:!0},{entries:function(t){return i(t)}})},{"../internals/export":85,"../internals/object-to-array":130}],194:[function(t,e,r){var n=t("../internals/export"),i=t("../internals/fails"),a=t("../internals/to-indexed-object"),o=t("../internals/object-get-own-property-descriptor").f,s=t("../internals/descriptors"),l=i((function(){o(1)}));n({target:"Object",stat:!0,forced:!s||l,sham:!s},{getOwnPropertyDescriptor:function(t,e){return o(a(t),e)}})},{"../internals/descriptors":81,"../internals/export":85,"../internals/fails":86,"../internals/object-get-own-property-descriptor":121,"../internals/to-indexed-object":156}],195:[function(t,e,r){var n=t("../internals/export"),i=t("../internals/descriptors"),a=t("../internals/own-keys"),o=t("../internals/to-indexed-object"),s=t("../internals/object-get-own-property-descriptor"),l=t("../internals/create-property");n({target:"Object",stat:!0,sham:!i},{getOwnPropertyDescriptors:function(t){for(var e,r,n=o(t),i=s.f,u=a(n),f={},h=0;u.length>h;)void 0!==(r=i(n,e=u[h++]))&&l(f,e,r);return f}})},{"../internals/create-property":78,"../internals/descriptors":81,"../internals/export":85,"../internals/object-get-own-property-descriptor":121,"../internals/own-keys":132,"../internals/to-indexed-object":156}],196:[function(t,e,r){var n=t("../internals/export"),i=t("../internals/to-object"),a=t("../internals/object-keys");n({target:"Object",stat:!0,forced:t("../internals/fails")((function(){a(1)}))},{keys:function(t){return a(i(t))}})},{"../internals/export":85,"../internals/fails":86,"../internals/object-keys":127,"../internals/to-object":159}],197:[function(t,e,r){var n=t("../internals/redefine"),i=t("../internals/object-to-string"),a=Object.prototype;i!==a.toString&&n(a,"toString",i,{unsafe:!0})},{"../internals/object-to-string":131,"../internals/redefine":138}],198:[function(t,e,r){var n=t("../internals/export"),i=t("../internals/parse-int");n({global:!0,forced:parseInt!=i},{parseInt:i})},{"../internals/export":85,"../internals/parse-int":133}],199:[function(t,e,r){"use strict";var n,i,a,o,s=t("../internals/export"),l=t("../internals/is-pure"),u=t("../internals/global"),f=t("../internals/get-built-in"),h=t("../internals/native-promise-constructor"),c=t("../internals/redefine"),d=t("../internals/redefine-all"),p=t("../internals/shared"),b=t("../internals/set-to-string-tag"),m=t("../internals/set-species"),g=t("../internals/is-object"),y=t("../internals/a-function"),v=t("../internals/an-instance"),_=t("../internals/classof-raw"),w=t("../internals/iterate"),x=t("../internals/check-correctness-of-iteration"),E=t("../internals/species-constructor"),k=t("../internals/task").set,j=t("../internals/microtask"),S=t("../internals/promise-resolve"),A=t("../internals/host-report-errors"),T=t("../internals/new-promise-capability"),I=t("../internals/perform"),P=t("../internals/internal-state"),M=t("../internals/is-forced"),O=t("../internals/well-known-symbol"),R=t("../internals/v8-version"),L=O("species"),C="Promise",B=P.get,D=P.set,N=P.getterFor(C),U=h,z=u.TypeError,F=u.document,H=u.process,G=p("inspectSource"),q=f("fetch"),W=T.f,Z=W,V="process"==_(H),Y=!!(F&&F.createEvent&&u.dispatchEvent),X="unhandledrejection",J=M(C,(function(){var t=G(U)!==String(U);if(66===R)return!0;if(!t&&!V&&"function"!=typeof PromiseRejectionEvent)return!0;if(l&&!U.prototype.finally)return!0;if(R>=51&&/native code/.test(U))return!1;var e=U.resolve(1),r=function(t){t((function(){}),(function(){}))};return(e.constructor={})[L]=r,!(e.then((function(){}))instanceof r)})),K=J||!x((function(t){U.all(t).catch((function(){}))})),Q=function(t){var e;return!(!g(t)||"function"!=typeof(e=t.then))&&e},$=function(t,e,r){if(!e.notified){e.notified=!0;var n=e.reactions;j((function(){for(var i=e.value,a=1==e.state,o=0;n.length>o;){var s,l,u,f=n[o++],h=a?f.ok:f.fail,c=f.resolve,d=f.reject,p=f.domain;try{h?(a||(2===e.rejection&&nt(t,e),e.rejection=1),!0===h?s=i:(p&&p.enter(),s=h(i),p&&(p.exit(),u=!0)),s===f.promise?d(z("Promise-chain cycle")):(l=Q(s))?l.call(s,c,d):c(s)):d(i)}catch(t){p&&!u&&p.exit(),d(t)}}e.reactions=[],e.notified=!1,r&&!e.rejection&&et(t,e)}))}},tt=function(t,e,r){var n,i;Y?((n=F.createEvent("Event")).promise=e,n.reason=r,n.initEvent(t,!1,!0),u.dispatchEvent(n)):n={promise:e,reason:r},(i=u["on"+t])?i(n):t===X&&A("Unhandled promise rejection",r)},et=function(t,e){k.call(u,(function(){var r,n=e.value;if(rt(e)&&(r=I((function(){V?H.emit("unhandledRejection",n,t):tt(X,t,n)})),e.rejection=V||rt(e)?2:1,r.error))throw r.value}))},rt=function(t){return 1!==t.rejection&&!t.parent},nt=function(t,e){k.call(u,(function(){V?H.emit("rejectionHandled",t):tt("rejectionhandled",t,e.value)}))},it=function(t,e,r,n){return function(i){t(e,r,i,n)}},at=function(t,e,r,n){e.done||(e.done=!0,n&&(e=n),e.value=r,e.state=2,$(t,e,!0))},ot=function(t,e,r,n){if(!e.done){e.done=!0,n&&(e=n);try{if(t===r)throw z("Promise can't be resolved itself");var i=Q(r);i?j((function(){var n={done:!1};try{i.call(r,it(ot,t,n,e),it(at,t,n,e))}catch(r){at(t,n,r,e)}})):(e.value=r,e.state=1,$(t,e,!1))}catch(r){at(t,{done:!1},r,e)}}};J&&(U=function(t){v(this,U,C),y(t),n.call(this);var e=B(this);try{t(it(ot,this,e),it(at,this,e))}catch(t){at(this,e,t)}},(n=function(t){D(this,{type:C,done:!1,notified:!1,parent:!1,reactions:[],rejection:!1,state:0,value:void 0})}).prototype=d(U.prototype,{then:function(t,e){var r=N(this),n=W(E(this,U));return n.ok="function"!=typeof t||t,n.fail="function"==typeof e&&e,n.domain=V?H.domain:void 0,r.parent=!0,r.reactions.push(n),0!=r.state&&$(this,r,!1),n.promise},catch:function(t){return this.then(void 0,t)}}),i=function(){var t=new n,e=B(t);this.promise=t,this.resolve=it(ot,t,e),this.reject=it(at,t,e)},T.f=W=function(t){return t===U||t===a?new i(t):Z(t)},l||"function"!=typeof h||(o=h.prototype.then,c(h.prototype,"then",(function(t,e){var r=this;return new U((function(t,e){o.call(r,t,e)})).then(t,e)}),{unsafe:!0}),"function"==typeof q&&s({global:!0,enumerable:!0,forced:!0},{fetch:function(t){return S(U,q.apply(u,arguments))}}))),s({global:!0,wrap:!0,forced:J},{Promise:U}),b(U,C,!1,!0),m(C),a=f(C),s({target:C,stat:!0,forced:J},{reject:function(t){var e=W(this);return e.reject.call(void 0,t),e.promise}}),s({target:C,stat:!0,forced:l||J},{resolve:function(t){return S(l&&this===a?U:this,t)}}),s({target:C,stat:!0,forced:K},{all:function(t){var e=this,r=W(e),n=r.resolve,i=r.reject,a=I((function(){var r=y(e.resolve),a=[],o=0,s=1;w(t,(function(t){var l=o++,u=!1;a.push(void 0),s++,r.call(e,t).then((function(t){u||(u=!0,a[l]=t,--s||n(a))}),i)})),--s||n(a)}));return a.error&&i(a.value),r.promise},race:function(t){var e=this,r=W(e),n=r.reject,i=I((function(){var i=y(e.resolve);w(t,(function(t){i.call(e,t).then(r.resolve,n)}))}));return i.error&&n(i.value),r.promise}})},{"../internals/a-function":50,"../internals/an-instance":54,"../internals/check-correctness-of-iteration":69,"../internals/classof-raw":70,"../internals/export":85,"../internals/get-built-in":90,"../internals/global":92,"../internals/host-report-errors":95,"../internals/internal-state":100,"../internals/is-forced":103,"../internals/is-object":105,"../internals/is-pure":106,"../internals/iterate":108,"../internals/microtask":111,"../internals/native-promise-constructor":112,"../internals/new-promise-capability":115,"../internals/perform":135,"../internals/promise-resolve":136,"../internals/redefine":138,"../internals/redefine-all":137,"../internals/set-species":144,"../internals/set-to-string-tag":145,"../internals/shared":148,"../internals/species-constructor":150,"../internals/task":153,"../internals/v8-version":168,"../internals/well-known-symbol":169}],200:[function(t,e,r){"use strict";var n=t("../internals/export"),i=t("../internals/regexp-exec");n({target:"RegExp",proto:!0,forced:/./.exec!==i},{exec:i})},{"../internals/export":85,"../internals/regexp-exec":140}],201:[function(t,e,r){"use strict";var n=t("../internals/redefine"),i=t("../internals/an-object"),a=t("../internals/fails"),o=t("../internals/regexp-flags"),s="toString",l=RegExp.prototype,u=l[s],f=a((function(){return"/a/b"!=u.call({source:"a",flags:"b"})})),h=u.name!=s;(f||h)&&n(RegExp.prototype,s,(function(){var t=i(this),e=String(t.source),r=t.flags;return"/"+e+"/"+String(void 0===r&&t instanceof RegExp&&!("flags"in l)?o.call(t):r)}),{unsafe:!0})},{"../internals/an-object":55,"../internals/fails":86,"../internals/redefine":138,"../internals/regexp-flags":141}],202:[function(t,e,r){"use strict";var n=t("../internals/export"),i=t("../internals/not-a-regexp"),a=t("../internals/require-object-coercible");n({target:"String",proto:!0,forced:!t("../internals/correct-is-regexp-logic")("includes")},{includes:function(t){return!!~String(a(this)).indexOf(i(t),arguments.length>1?arguments[1]:void 0)}})},{"../internals/correct-is-regexp-logic":73,"../internals/export":85,"../internals/not-a-regexp":116,"../internals/require-object-coercible":142}],203:[function(t,e,r){"use strict";var n=t("../internals/string-multibyte").charAt,i=t("../internals/internal-state"),a=t("../internals/define-iterator"),o="String Iterator",s=i.set,l=i.getterFor(o);a(String,"String",(function(t){s(this,{type:o,string:String(t),index:0})}),(function(){var t,e=l(this),r=e.string,i=e.index;return i>=r.length?{value:void 0,done:!0}:(t=n(r,i),e.index+=t.length,{value:t,done:!1})}))},{"../internals/define-iterator":79,"../internals/internal-state":100,"../internals/string-multibyte":151}],204:[function(t,e,r){"use strict";var n=t("../internals/fix-regexp-well-known-symbol-logic"),i=t("../internals/an-object"),a=t("../internals/to-length"),o=t("../internals/require-object-coercible"),s=t("../internals/advance-string-index"),l=t("../internals/regexp-exec-abstract");n("match",1,(function(t,e,r){return[function(e){var r=o(this),n=null==e?void 0:e[t];return void 0!==n?n.call(e,r):new RegExp(e)[t](String(r))},function(t){var n=r(e,t,this);if(n.done)return n.value;var o=i(t),u=String(this);if(!o.global)return l(o,u);var f=o.unicode;o.lastIndex=0;for(var h,c=[],d=0;null!==(h=l(o,u));){var p=String(h[0]);c[d]=p,""===p&&(o.lastIndex=s(u,a(o.lastIndex),f)),d++}return 0===d?null:c}]}))},{"../internals/advance-string-index":53,"../internals/an-object":55,"../internals/fix-regexp-well-known-symbol-logic":87,"../internals/regexp-exec-abstract":139,"../internals/require-object-coercible":142,"../internals/to-length":158}],205:[function(t,e,r){"use strict";var n=t("../internals/fix-regexp-well-known-symbol-logic"),i=t("../internals/an-object"),a=t("../internals/to-object"),o=t("../internals/to-length"),s=t("../internals/to-integer"),l=t("../internals/require-object-coercible"),u=t("../internals/advance-string-index"),f=t("../internals/regexp-exec-abstract"),h=Math.max,c=Math.min,d=Math.floor,p=/\$([$&'`]|\d\d?|<[^>]*>)/g,b=/\$([$&'`]|\d\d?)/g;n("replace",2,(function(t,e,r){return[function(r,n){var i=l(this),a=null==r?void 0:r[t];return void 0!==a?a.call(r,i,n):e.call(String(i),r,n)},function(t,a){var l=r(e,t,this,a);if(l.done)return l.value;var d=i(t),p=String(this),b="function"==typeof a;b||(a=String(a));var m,g=d.global;if(g){var y=d.unicode;d.lastIndex=0}for(var v=[];;){var _=f(d,p);if(null===_)break;if(v.push(_),!g)break;""===String(_[0])&&(d.lastIndex=u(p,o(d.lastIndex),y))}for(var w="",x=0,E=0;E<v.length;E++){_=v[E];for(var k=String(_[0]),j=h(c(s(_.index),p.length),0),S=[],A=1;A<_.length;A++)S.push(void 0===(m=_[A])?m:String(m));var T=_.groups;if(b){var I=[k].concat(S,j,p);void 0!==T&&I.push(T);var P=String(a.apply(void 0,I))}else P=n(k,p,j,S,T,a);j>=x&&(w+=p.slice(x,j)+P,x=j+k.length)}return w+p.slice(x)}];function n(t,r,n,i,o,s){var l=n+t.length,u=i.length,f=b;return void 0!==o&&(o=a(o),f=p),e.call(s,f,(function(e,a){var s;switch(a.charAt(0)){case"$":return"$";case"&":return t;case"`":return r.slice(0,n);case"'":return r.slice(l);case"<":s=o[a.slice(1,-1)];break;default:var f=+a;if(0===f)return e;if(f>u){var h=d(f/10);return 0===h?e:h<=u?void 0===i[h-1]?a.charAt(1):i[h-1]+a.charAt(1):e}s=i[f-1]}return void 0===s?"":s}))}}))},{"../internals/advance-string-index":53,"../internals/an-object":55,"../internals/fix-regexp-well-known-symbol-logic":87,"../internals/regexp-exec-abstract":139,"../internals/require-object-coercible":142,"../internals/to-integer":157,"../internals/to-length":158,"../internals/to-object":159}],206:[function(t,e,r){"use strict";var n=t("../internals/fix-regexp-well-known-symbol-logic"),i=t("../internals/is-regexp"),a=t("../internals/an-object"),o=t("../internals/require-object-coercible"),s=t("../internals/species-constructor"),l=t("../internals/advance-string-index"),u=t("../internals/to-length"),f=t("../internals/regexp-exec-abstract"),h=t("../internals/regexp-exec"),c=t("../internals/fails"),d=[].push,p=Math.min,b=4294967295,m=!c((function(){return!RegExp(b,"y")}));n("split",2,(function(t,e,r){var n;return n="c"=="abbc".split(/(b)*/)[1]||4!="test".split(/(?:)/,-1).length||2!="ab".split(/(?:ab)*/).length||4!=".".split(/(.?)(.?)/).length||".".split(/()()/).length>1||"".split(/.?/).length?function(t,r){var n=String(o(this)),a=void 0===r?b:r>>>0;if(0===a)return[];if(void 0===t)return[n];if(!i(t))return e.call(n,t,a);for(var s,l,u,f=[],c=(t.ignoreCase?"i":"")+(t.multiline?"m":"")+(t.unicode?"u":"")+(t.sticky?"y":""),p=0,m=new RegExp(t.source,c+"g");(s=h.call(m,n))&&!((l=m.lastIndex)>p&&(f.push(n.slice(p,s.index)),s.length>1&&s.index<n.length&&d.apply(f,s.slice(1)),u=s[0].length,p=l,f.length>=a));)m.lastIndex===s.index&&m.lastIndex++;return p===n.length?!u&&m.test("")||f.push(""):f.push(n.slice(p)),f.length>a?f.slice(0,a):f}:"0".split(void 0,0).length?function(t,r){return void 0===t&&0===r?[]:e.call(this,t,r)}:e,[function(e,r){var i=o(this),a=null==e?void 0:e[t];return void 0!==a?a.call(e,i,r):n.call(String(i),e,r)},function(t,i){var o=r(n,t,this,i,n!==e);if(o.done)return o.value;var h=a(t),c=String(this),d=s(h,RegExp),g=h.unicode,y=(h.ignoreCase?"i":"")+(h.multiline?"m":"")+(h.unicode?"u":"")+(m?"y":"g"),v=new d(m?h:"^(?:"+h.source+")",y),_=void 0===i?b:i>>>0;if(0===_)return[];if(0===c.length)return null===f(v,c)?[c]:[];for(var w=0,x=0,E=[];x<c.length;){v.lastIndex=m?x:0;var k,j=f(v,m?c:c.slice(x));if(null===j||(k=p(u(v.lastIndex+(m?0:x)),c.length))===w)x=l(c,x,g);else{if(E.push(c.slice(w,x)),E.length===_)return E;for(var S=1;S<=j.length-1;S++)if(E.push(j[S]),E.length===_)return E;x=w=k}}return E.push(c.slice(w)),E}]}),!m)},{"../internals/advance-string-index":53,"../internals/an-object":55,"../internals/fails":86,"../internals/fix-regexp-well-known-symbol-logic":87,"../internals/is-regexp":107,"../internals/regexp-exec":140,"../internals/regexp-exec-abstract":139,"../internals/require-object-coercible":142,"../internals/species-constructor":150,"../internals/to-length":158}],207:[function(t,e,r){"use strict";var n=t("../internals/export"),i=t("../internals/global"),a=t("../internals/get-built-in"),o=t("../internals/is-pure"),s=t("../internals/descriptors"),l=t("../internals/native-symbol"),u=t("../internals/fails"),f=t("../internals/has"),h=t("../internals/is-array"),c=t("../internals/is-object"),d=t("../internals/an-object"),p=t("../internals/to-object"),b=t("../internals/to-indexed-object"),m=t("../internals/to-primitive"),g=t("../internals/create-property-descriptor"),y=t("../internals/object-create"),v=t("../internals/object-keys"),_=t("../internals/object-get-own-property-names"),w=t("../internals/object-get-own-property-names-external"),x=t("../internals/object-get-own-property-symbols"),E=t("../internals/object-get-own-property-descriptor"),k=t("../internals/object-define-property"),j=t("../internals/object-property-is-enumerable"),S=t("../internals/create-non-enumerable-property"),A=t("../internals/redefine"),T=t("../internals/shared"),I=t("../internals/shared-key"),P=t("../internals/hidden-keys"),M=t("../internals/uid"),O=t("../internals/well-known-symbol"),R=t("../internals/wrapped-well-known-symbol"),L=t("../internals/define-well-known-symbol"),C=t("../internals/set-to-string-tag"),B=t("../internals/internal-state"),D=t("../internals/array-iteration").forEach,N=I("hidden"),U="Symbol",z="prototype",F=O("toPrimitive"),H=B.set,G=B.getterFor(U),q=Object[z],W=i.Symbol,Z=a("JSON","stringify"),V=E.f,Y=k.f,X=w.f,J=j.f,K=T("symbols"),Q=T("op-symbols"),$=T("string-to-symbol-registry"),tt=T("symbol-to-string-registry"),et=T("wks"),rt=i.QObject,nt=!rt||!rt[z]||!rt[z].findChild,it=s&&u((function(){return 7!=y(Y({},"a",{get:function(){return Y(this,"a",{value:7}).a}})).a}))?function(t,e,r){var n=V(q,e);n&&delete q[e],Y(t,e,r),n&&t!==q&&Y(q,e,n)}:Y,at=function(t,e){var r=K[t]=y(W[z]);return H(r,{type:U,tag:t,description:e}),s||(r.description=e),r},ot=l&&"symbol"==typeof W.iterator?function(t){return"symbol"==typeof t}:function(t){return Object(t)instanceof W},st=function(t,e,r){t===q&&st(Q,e,r),d(t);var n=m(e,!0);return d(r),f(K,n)?(r.enumerable?(f(t,N)&&t[N][n]&&(t[N][n]=!1),r=y(r,{enumerable:g(0,!1)})):(f(t,N)||Y(t,N,g(1,{})),t[N][n]=!0),it(t,n,r)):Y(t,n,r)},lt=function(t,e){d(t);var r=b(e),n=v(r).concat(ct(r));return D(n,(function(e){s&&!ut.call(r,e)||st(t,e,r[e])})),t},ut=function(t){var e=m(t,!0),r=J.call(this,e);return!(this===q&&f(K,e)&&!f(Q,e))&&(!(r||!f(this,e)||!f(K,e)||f(this,N)&&this[N][e])||r)},ft=function(t,e){var r=b(t),n=m(e,!0);if(r!==q||!f(K,n)||f(Q,n)){var i=V(r,n);return!i||!f(K,n)||f(r,N)&&r[N][n]||(i.enumerable=!0),i}},ht=function(t){var e=X(b(t)),r=[];return D(e,(function(t){f(K,t)||f(P,t)||r.push(t)})),r},ct=function(t){var e=t===q,r=X(e?Q:b(t)),n=[];return D(r,(function(t){!f(K,t)||e&&!f(q,t)||n.push(K[t])})),n};l||(W=function(){if(this instanceof W)throw TypeError("Symbol is not a constructor");var t=arguments.length&&void 0!==arguments[0]?String(arguments[0]):void 0,e=M(t),r=function(t){this===q&&r.call(Q,t),f(this,N)&&f(this[N],e)&&(this[N][e]=!1),it(this,e,g(1,t))};return s&&nt&&it(q,e,{configurable:!0,set:r}),at(e,t)},A(W[z],"toString",(function(){return G(this).tag})),j.f=ut,k.f=st,E.f=ft,_.f=w.f=ht,x.f=ct,s&&(Y(W[z],"description",{configurable:!0,get:function(){return G(this).description}}),o||A(q,"propertyIsEnumerable",ut,{unsafe:!0})),R.f=function(t){return at(O(t),t)}),n({global:!0,wrap:!0,forced:!l,sham:!l},{Symbol:W}),D(v(et),(function(t){L(t)})),n({target:U,stat:!0,forced:!l},{for:function(t){var e=String(t);if(f($,e))return $[e];var r=W(e);return $[e]=r,tt[r]=e,r},keyFor:function(t){if(!ot(t))throw TypeError(t+" is not a symbol");if(f(tt,t))return tt[t]},useSetter:function(){nt=!0},useSimple:function(){nt=!1}}),n({target:"Object",stat:!0,forced:!l,sham:!s},{create:function(t,e){return void 0===e?y(t):lt(y(t),e)},defineProperty:st,defineProperties:lt,getOwnPropertyDescriptor:ft}),n({target:"Object",stat:!0,forced:!l},{getOwnPropertyNames:ht,getOwnPropertySymbols:ct}),n({target:"Object",stat:!0,forced:u((function(){x.f(1)}))},{getOwnPropertySymbols:function(t){return x.f(p(t))}}),Z&&n({target:"JSON",stat:!0,forced:!l||u((function(){var t=W();return"[null]"!=Z([t])||"{}"!=Z({a:t})||"{}"!=Z(Object(t))}))},{stringify:function(t,e,r){for(var n,i=[t],a=1;arguments.length>a;)i.push(arguments[a++]);if(n=e,(c(e)||void 0!==t)&&!ot(t))return h(e)||(e=function(t,e){if("function"==typeof n&&(e=n.call(this,t,e)),!ot(e))return e}),i[1]=e,Z.apply(null,i)}}),W[z][F]||S(W[z],F,W[z].valueOf),C(W,U),P[N]=!0},{"../internals/an-object":55,"../internals/array-iteration":62,"../internals/create-non-enumerable-property":76,"../internals/create-property-descriptor":77,"../internals/define-well-known-symbol":80,"../internals/descriptors":81,"../internals/export":85,"../internals/fails":86,"../internals/get-built-in":90,"../internals/global":92,"../internals/has":93,"../internals/hidden-keys":94,"../internals/internal-state":100,"../internals/is-array":102,"../internals/is-object":105,"../internals/is-pure":106,"../internals/native-symbol":113,"../internals/object-create":118,"../internals/object-define-property":120,"../internals/object-get-own-property-descriptor":121,"../internals/object-get-own-property-names":123,"../internals/object-get-own-property-names-external":122,"../internals/object-get-own-property-symbols":124,"../internals/object-keys":127,"../internals/object-property-is-enumerable":128,"../internals/redefine":138,"../internals/set-to-string-tag":145,"../internals/shared":148,"../internals/shared-key":146,"../internals/to-indexed-object":156,"../internals/to-object":159,"../internals/to-primitive":162,"../internals/uid":166,"../internals/well-known-symbol":169,"../internals/wrapped-well-known-symbol":171}],208:[function(t,e,r){"use strict";var n=t("../internals/array-buffer-view-core"),i=t("../internals/array-copy-within"),a=n.aTypedArray;n.exportProto("copyWithin",(function(t,e){return i.call(a(this),t,e,arguments.length>2?arguments[2]:void 0)}))},{"../internals/array-buffer-view-core":56,"../internals/array-copy-within":58}],209:[function(t,e,r){"use strict";var n=t("../internals/array-buffer-view-core"),i=t("../internals/array-iteration").every,a=n.aTypedArray;n.exportProto("every",(function(t){return i(a(this),t,arguments.length>1?arguments[1]:void 0)}))},{"../internals/array-buffer-view-core":56,"../internals/array-iteration":62}],210:[function(t,e,r){"use strict";var n=t("../internals/array-buffer-view-core"),i=t("../internals/array-fill"),a=n.aTypedArray;n.exportProto("fill",(function(t){return i.apply(a(this),arguments)}))},{"../internals/array-buffer-view-core":56,"../internals/array-fill":59}],211:[function(t,e,r){"use strict";var n=t("../internals/array-buffer-view-core"),i=t("../internals/array-iteration").filter,a=t("../internals/species-constructor"),o=n.aTypedArray,s=n.aTypedArrayConstructor;n.exportProto("filter",(function(t){for(var e=i(o(this),t,arguments.length>1?arguments[1]:void 0),r=a(this,this.constructor),n=0,l=e.length,u=new(s(r))(l);l>n;)u[n]=e[n++];return u}))},{"../internals/array-buffer-view-core":56,"../internals/array-iteration":62,"../internals/species-constructor":150}],212:[function(t,e,r){"use strict";var n=t("../internals/array-buffer-view-core"),i=t("../internals/array-iteration").findIndex,a=n.aTypedArray;n.exportProto("findIndex",(function(t){return i(a(this),t,arguments.length>1?arguments[1]:void 0)}))},{"../internals/array-buffer-view-core":56,"../internals/array-iteration":62}],213:[function(t,e,r){"use strict";var n=t("../internals/array-buffer-view-core"),i=t("../internals/array-iteration").find,a=n.aTypedArray;n.exportProto("find",(function(t){return i(a(this),t,arguments.length>1?arguments[1]:void 0)}))},{"../internals/array-buffer-view-core":56,"../internals/array-iteration":62}],214:[function(t,e,r){t("../internals/typed-array-constructor")("Float32",4,(function(t){return function(e,r,n){return t(this,e,r,n)}}))},{"../internals/typed-array-constructor":163}],215:[function(t,e,r){t("../internals/typed-array-constructor")("Float64",8,(function(t){return function(e,r,n){return t(this,e,r,n)}}))},{"../internals/typed-array-constructor":163}],216:[function(t,e,r){"use strict";var n=t("../internals/array-buffer-view-core"),i=t("../internals/array-iteration").forEach,a=n.aTypedArray;n.exportProto("forEach",(function(t){i(a(this),t,arguments.length>1?arguments[1]:void 0)}))},{"../internals/array-buffer-view-core":56,"../internals/array-iteration":62}],217:[function(t,e,r){"use strict";var n=t("../internals/array-buffer-view-core"),i=t("../internals/array-includes").includes,a=n.aTypedArray;n.exportProto("includes",(function(t){return i(a(this),t,arguments.length>1?arguments[1]:void 0)}))},{"../internals/array-buffer-view-core":56,"../internals/array-includes":61}],218:[function(t,e,r){"use strict";var n=t("../internals/array-buffer-view-core"),i=t("../internals/array-includes").indexOf,a=n.aTypedArray;n.exportProto("indexOf",(function(t){return i(a(this),t,arguments.length>1?arguments[1]:void 0)}))},{"../internals/array-buffer-view-core":56,"../internals/array-includes":61}],219:[function(t,e,r){"use strict";var n=t("../internals/global"),i=t("../internals/array-buffer-view-core"),a=t("../modules/es.array.iterator"),o=t("../internals/well-known-symbol")("iterator"),s=n.Uint8Array,l=a.values,u=a.keys,f=a.entries,h=i.aTypedArray,c=i.exportProto,d=s&&s.prototype[o],p=!!d&&("values"==d.name||null==d.name),b=function(){return l.call(h(this))};c("entries",(function(){return f.call(h(this))})),c("keys",(function(){return u.call(h(this))})),c("values",b,!p),c(o,b,!p)},{"../internals/array-buffer-view-core":56,"../internals/global":92,"../internals/well-known-symbol":169,"../modules/es.array.iterator":182}],220:[function(t,e,r){"use strict";var n=t("../internals/array-buffer-view-core"),i=n.aTypedArray,a=[].join;n.exportProto("join",(function(t){return a.apply(i(this),arguments)}))},{"../internals/array-buffer-view-core":56}],221:[function(t,e,r){"use strict";var n=t("../internals/array-buffer-view-core"),i=t("../internals/array-last-index-of"),a=n.aTypedArray;n.exportProto("lastIndexOf",(function(t){return i.apply(a(this),arguments)}))},{"../internals/array-buffer-view-core":56,"../internals/array-last-index-of":63}],222:[function(t,e,r){"use strict";var n=t("../internals/array-buffer-view-core"),i=t("../internals/array-iteration").map,a=t("../internals/species-constructor"),o=n.aTypedArray,s=n.aTypedArrayConstructor;n.exportProto("map",(function(t){return i(o(this),t,arguments.length>1?arguments[1]:void 0,(function(t,e){return new(s(a(t,t.constructor)))(e)}))}))},{"../internals/array-buffer-view-core":56,"../internals/array-iteration":62,"../internals/species-constructor":150}],223:[function(t,e,r){"use strict";var n=t("../internals/array-buffer-view-core"),i=t("../internals/array-reduce").right,a=n.aTypedArray;n.exportProto("reduceRight",(function(t){return i(a(this),t,arguments.length,arguments.length>1?arguments[1]:void 0)}))},{"../internals/array-buffer-view-core":56,"../internals/array-reduce":65}],224:[function(t,e,r){"use strict";var n=t("../internals/array-buffer-view-core"),i=t("../internals/array-reduce").left,a=n.aTypedArray;n.exportProto("reduce",(function(t){return i(a(this),t,arguments.length,arguments.length>1?arguments[1]:void 0)}))},{"../internals/array-buffer-view-core":56,"../internals/array-reduce":65}],225:[function(t,e,r){"use strict";var n=t("../internals/array-buffer-view-core"),i=n.aTypedArray,a=Math.floor;n.exportProto("reverse",(function(){for(var t,e=this,r=i(e).length,n=a(r/2),o=0;o<n;)t=e[o],e[o++]=e[--r],e[r]=t;return e}))},{"../internals/array-buffer-view-core":56}],226:[function(t,e,r){"use strict";var n=t("../internals/array-buffer-view-core"),i=t("../internals/to-length"),a=t("../internals/to-offset"),o=t("../internals/to-object"),s=t("../internals/fails"),l=n.aTypedArray,u=s((function(){new Int8Array(1).set({})}));n.exportProto("set",(function(t){l(this);var e=a(arguments.length>1?arguments[1]:void 0,1),r=this.length,n=o(t),s=i(n.length),u=0;if(s+e>r)throw RangeError("Wrong length");for(;u<s;)this[e+u]=n[u++]}),u)},{"../internals/array-buffer-view-core":56,"../internals/fails":86,"../internals/to-length":158,"../internals/to-object":159,"../internals/to-offset":160}],227:[function(t,e,r){"use strict";var n=t("../internals/array-buffer-view-core"),i=t("../internals/species-constructor"),a=t("../internals/fails"),o=n.aTypedArray,s=n.aTypedArrayConstructor,l=[].slice,u=a((function(){new Int8Array(1).slice()}));n.exportProto("slice",(function(t,e){for(var r=l.call(o(this),t,e),n=i(this,this.constructor),a=0,u=r.length,f=new(s(n))(u);u>a;)f[a]=r[a++];return f}),u)},{"../internals/array-buffer-view-core":56,"../internals/fails":86,"../internals/species-constructor":150}],228:[function(t,e,r){"use strict";var n=t("../internals/array-buffer-view-core"),i=t("../internals/array-iteration").some,a=n.aTypedArray;n.exportProto("some",(function(t){return i(a(this),t,arguments.length>1?arguments[1]:void 0)}))},{"../internals/array-buffer-view-core":56,"../internals/array-iteration":62}],229:[function(t,e,r){"use strict";var n=t("../internals/array-buffer-view-core"),i=n.aTypedArray,a=[].sort;n.exportProto("sort",(function(t){return a.call(i(this),t)}))},{"../internals/array-buffer-view-core":56}],230:[function(t,e,r){"use strict";var n=t("../internals/array-buffer-view-core"),i=t("../internals/to-length"),a=t("../internals/to-absolute-index"),o=t("../internals/species-constructor"),s=n.aTypedArray;n.exportProto("subarray",(function(t,e){var r=s(this),n=r.length,l=a(t,n);return new(o(r,r.constructor))(r.buffer,r.byteOffset+l*r.BYTES_PER_ELEMENT,i((void 0===e?n:a(e,n))-l))}))},{"../internals/array-buffer-view-core":56,"../internals/species-constructor":150,"../internals/to-absolute-index":154,"../internals/to-length":158}],231:[function(t,e,r){"use strict";var n=t("../internals/global"),i=t("../internals/array-buffer-view-core"),a=t("../internals/fails"),o=n.Int8Array,s=i.aTypedArray,l=[].toLocaleString,u=[].slice,f=!!o&&a((function(){l.call(new o(1))})),h=a((function(){return[1,2].toLocaleString()!=new o([1,2]).toLocaleString()}))||!a((function(){o.prototype.toLocaleString.call([1,2])}));i.exportProto("toLocaleString",(function(){return l.apply(f?u.call(s(this)):s(this),arguments)}),h)},{"../internals/array-buffer-view-core":56,"../internals/fails":86,"../internals/global":92}],232:[function(t,e,r){"use strict";var n=t("../internals/global"),i=t("../internals/array-buffer-view-core"),a=t("../internals/fails"),o=n.Uint8Array,s=o&&o.prototype,l=[].toString,u=[].join;a((function(){l.call({})}))&&(l=function(){return u.call(this)}),i.exportProto("toString",l,(s||{}).toString!=l)},{"../internals/array-buffer-view-core":56,"../internals/fails":86,"../internals/global":92}],233:[function(t,e,r){t("../internals/typed-array-constructor")("Uint8",1,(function(t){return function(e,r,n){return t(this,e,r,n)}}))},{"../internals/typed-array-constructor":163}],234:[function(t,e,r){t("../internals/typed-array-constructor")("Uint8",1,(function(t){return function(e,r,n){return t(this,e,r,n)}}),!0)},{"../internals/typed-array-constructor":163}],235:[function(t,e,r){var n=t("../internals/global"),i=t("../internals/dom-iterables"),a=t("../internals/array-for-each"),o=t("../internals/create-non-enumerable-property");for(var s in i){var l=n[s],u=l&&l.prototype;if(u&&u.forEach!==a)try{o(u,"forEach",a)}catch(t){u.forEach=a}}},{"../internals/array-for-each":60,"../internals/create-non-enumerable-property":76,"../internals/dom-iterables":83,"../internals/global":92}],236:[function(t,e,r){var n=t("../internals/global"),i=t("../internals/dom-iterables"),a=t("../modules/es.array.iterator"),o=t("../internals/create-non-enumerable-property"),s=t("../internals/well-known-symbol"),l=s("iterator"),u=s("toStringTag"),f=a.values;for(var h in i){var c=n[h],d=c&&c.prototype;if(d){if(d[l]!==f)try{o(d,l,f)}catch(t){d[l]=f}if(d[u]||o(d,u,h),i[h])for(var p in a)if(d[p]!==a[p])try{o(d,p,a[p])}catch(t){d[p]=a[p]}}}},{"../internals/create-non-enumerable-property":76,"../internals/dom-iterables":83,"../internals/global":92,"../internals/well-known-symbol":169,"../modules/es.array.iterator":182}],237:[function(t,e,r){var n=t("../internals/export"),i=t("../internals/global"),a=t("../internals/user-agent"),o=[].slice,s=function(t){return function(e,r){var n=arguments.length>2,i=n?o.call(arguments,2):void 0;return t(n?function(){("function"==typeof e?e:Function(e)).apply(this,i)}:e,r)}};n({global:!0,bind:!0,forced:/MSIE .\./.test(a)},{setTimeout:s(i.setTimeout),setInterval:s(i.setInterval)})},{"../internals/export":85,"../internals/global":92,"../internals/user-agent":167}],238:[function(t,e,r){(function(t){function e(t){return Object.prototype.toString.call(t)}r.isArray=function(t){return Array.isArray?Array.isArray(t):"[object Array]"===e(t)},r.isBoolean=function(t){return"boolean"==typeof t},r.isNull=function(t){return null===t},r.isNullOrUndefined=function(t){return null==t},r.isNumber=function(t){return"number"==typeof t},r.isString=function(t){return"string"==typeof t},r.isSymbol=function(t){return"symbol"==typeof t},r.isUndefined=function(t){return void 0===t},r.isRegExp=function(t){return"[object RegExp]"===e(t)},r.isObject=function(t){return"object"==typeof t&&null!==t},r.isDate=function(t){return"[object Date]"===e(t)},r.isError=function(t){return"[object Error]"===e(t)||t instanceof Error},r.isFunction=function(t){return"function"==typeof t},r.isPrimitive=function(t){return null===t||"boolean"==typeof t||"number"==typeof t||"string"==typeof t||"symbol"==typeof t||void 0===t},r.isBuffer=t.isBuffer}).call(this,{isBuffer:t("../../is-buffer/index.js")})},{"../../is-buffer/index.js":255}],239:[function(t,e,r){var n=Object.create||function(t){var e=function(){};return e.prototype=t,new e},i=Object.keys||function(t){var e=[];for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&e.push(r);return r},a=Function.prototype.bind||function(t){var e=this;return function(){return e.apply(t,arguments)}};function o(){this._events&&Object.prototype.hasOwnProperty.call(this,"_events")||(this._events=n(null),this._eventsCount=0),this._maxListeners=this._maxListeners||void 0}e.exports=o,o.EventEmitter=o,o.prototype._events=void 0,o.prototype._maxListeners=void 0;var s,l=10;try{var u={};Object.defineProperty&&Object.defineProperty(u,"x",{value:0}),s=0===u.x}catch(t){s=!1}function f(t){return void 0===t._maxListeners?o.defaultMaxListeners:t._maxListeners}function h(t,e,r,i){var a,o,s;if("function"!=typeof r)throw new TypeError('"listener" argument must be a function');if((o=t._events)?(o.newListener&&(t.emit("newListener",e,r.listener?r.listener:r),o=t._events),s=o[e]):(o=t._events=n(null),t._eventsCount=0),s){if("function"==typeof s?s=o[e]=i?[r,s]:[s,r]:i?s.unshift(r):s.push(r),!s.warned&&(a=f(t))&&a>0&&s.length>a){s.warned=!0;var l=new Error("Possible EventEmitter memory leak detected. "+s.length+' "'+String(e)+'" listeners added. Use emitter.setMaxListeners() to increase limit.');l.name="MaxListenersExceededWarning",l.emitter=t,l.type=e,l.count=s.length,"object"==typeof console&&console.warn&&console.warn("%s: %s",l.name,l.message)}}else s=o[e]=r,++t._eventsCount;return t}function c(){if(!this.fired)switch(this.target.removeListener(this.type,this.wrapFn),this.fired=!0,arguments.length){case 0:return this.listener.call(this.target);case 1:return this.listener.call(this.target,arguments[0]);case 2:return this.listener.call(this.target,arguments[0],arguments[1]);case 3:return this.listener.call(this.target,arguments[0],arguments[1],arguments[2]);default:for(var t=new Array(arguments.length),e=0;e<t.length;++e)t[e]=arguments[e];this.listener.apply(this.target,t)}}function d(t,e,r){var n={fired:!1,wrapFn:void 0,target:t,type:e,listener:r},i=a.call(c,n);return i.listener=r,n.wrapFn=i,i}function p(t,e,r){var n=t._events;if(!n)return[];var i=n[e];return i?"function"==typeof i?r?[i.listener||i]:[i]:r?function(t){for(var e=new Array(t.length),r=0;r<e.length;++r)e[r]=t[r].listener||t[r];return e}(i):m(i,i.length):[]}function b(t){var e=this._events;if(e){var r=e[t];if("function"==typeof r)return 1;if(r)return r.length}return 0}function m(t,e){for(var r=new Array(e),n=0;n<e;++n)r[n]=t[n];return r}s?Object.defineProperty(o,"defaultMaxListeners",{enumerable:!0,get:function(){return l},set:function(t){if("number"!=typeof t||t<0||t!=t)throw new TypeError('"defaultMaxListeners" must be a positive number');l=t}}):o.defaultMaxListeners=l,o.prototype.setMaxListeners=function(t){if("number"!=typeof t||t<0||isNaN(t))throw new TypeError('"n" argument must be a positive number');return this._maxListeners=t,this},o.prototype.getMaxListeners=function(){return f(this)},o.prototype.emit=function(t){var e,r,n,i,a,o,s="error"===t;if(o=this._events)s=s&&null==o.error;else if(!s)return!1;if(s){if(arguments.length>1&&(e=arguments[1]),e instanceof Error)throw e;var l=new Error('Unhandled "error" event. ('+e+")");throw l.context=e,l}if(!(r=o[t]))return!1;var u="function"==typeof r;switch(n=arguments.length){case 1:!function(t,e,r){if(e)t.call(r);else for(var n=t.length,i=m(t,n),a=0;a<n;++a)i[a].call(r)}(r,u,this);break;case 2:!function(t,e,r,n){if(e)t.call(r,n);else for(var i=t.length,a=m(t,i),o=0;o<i;++o)a[o].call(r,n)}(r,u,this,arguments[1]);break;case 3:!function(t,e,r,n,i){if(e)t.call(r,n,i);else for(var a=t.length,o=m(t,a),s=0;s<a;++s)o[s].call(r,n,i)}(r,u,this,arguments[1],arguments[2]);break;case 4:!function(t,e,r,n,i,a){if(e)t.call(r,n,i,a);else for(var o=t.length,s=m(t,o),l=0;l<o;++l)s[l].call(r,n,i,a)}(r,u,this,arguments[1],arguments[2],arguments[3]);break;default:for(i=new Array(n-1),a=1;a<n;a++)i[a-1]=arguments[a];!function(t,e,r,n){if(e)t.apply(r,n);else for(var i=t.length,a=m(t,i),o=0;o<i;++o)a[o].apply(r,n)}(r,u,this,i)}return!0},o.prototype.addListener=function(t,e){return h(this,t,e,!1)},o.prototype.on=o.prototype.addListener,o.prototype.prependListener=function(t,e){return h(this,t,e,!0)},o.prototype.once=function(t,e){if("function"!=typeof e)throw new TypeError('"listener" argument must be a function');return this.on(t,d(this,t,e)),this},o.prototype.prependOnceListener=function(t,e){if("function"!=typeof e)throw new TypeError('"listener" argument must be a function');return this.prependListener(t,d(this,t,e)),this},o.prototype.removeListener=function(t,e){var r,i,a,o,s;if("function"!=typeof e)throw new TypeError('"listener" argument must be a function');if(!(i=this._events))return this;if(!(r=i[t]))return this;if(r===e||r.listener===e)0===--this._eventsCount?this._events=n(null):(delete i[t],i.removeListener&&this.emit("removeListener",t,r.listener||e));else if("function"!=typeof r){for(a=-1,o=r.length-1;o>=0;o--)if(r[o]===e||r[o].listener===e){s=r[o].listener,a=o;break}if(a<0)return this;0===a?r.shift():function(t,e){for(var r=e,n=r+1,i=t.length;n<i;r+=1,n+=1)t[r]=t[n];t.pop()}(r,a),1===r.length&&(i[t]=r[0]),i.removeListener&&this.emit("removeListener",t,s||e)}return this},o.prototype.removeAllListeners=function(t){var e,r,a;if(!(r=this._events))return this;if(!r.removeListener)return 0===arguments.length?(this._events=n(null),this._eventsCount=0):r[t]&&(0===--this._eventsCount?this._events=n(null):delete r[t]),this;if(0===arguments.length){var o,s=i(r);for(a=0;a<s.length;++a)"removeListener"!==(o=s[a])&&this.removeAllListeners(o);return this.removeAllListeners("removeListener"),this._events=n(null),this._eventsCount=0,this}if("function"==typeof(e=r[t]))this.removeListener(t,e);else if(e)for(a=e.length-1;a>=0;a--)this.removeListener(t,e[a]);return this},o.prototype.listeners=function(t){return p(this,t,!0)},o.prototype.rawListeners=function(t){return p(this,t,!1)},o.listenerCount=function(t,e){return"function"==typeof t.listenerCount?t.listenerCount(e):b.call(t,e)},o.prototype.listenerCount=b,o.prototype.eventNames=function(){return this._eventsCount>0?Reflect.ownKeys(this._events):[]}},{}],240:[function(t,e,r){var n=t("./lib/parser");e.exports={create:function(e,r){if(e instanceof(r=r||(0,eval)("this")).ArrayBuffer){var i=t("./lib/dom-bufferstream");return new n(new i(e,0,e.byteLength,!0,r))}var a=t("./lib/bufferstream");return new n(new a(e,0,e.length,!0))}}},{"./lib/bufferstream":241,"./lib/dom-bufferstream":243,"./lib/parser":247}],241:[function(t,e,r){function n(t,e,r,n){this.buffer=t,this.offset=e||0,r="number"==typeof r?r:t.length,this.endPosition=this.offset+r,this.setBigEndian(n)}n.prototype={setBigEndian:function(t){this.bigEndian=!!t},nextUInt8:function(){var t=this.buffer.readUInt8(this.offset);return this.offset+=1,t},nextInt8:function(){var t=this.buffer.readInt8(this.offset);return this.offset+=1,t},nextUInt16:function(){var t=this.bigEndian?this.buffer.readUInt16BE(this.offset):this.buffer.readUInt16LE(this.offset);return this.offset+=2,t},nextUInt32:function(){var t=this.bigEndian?this.buffer.readUInt32BE(this.offset):this.buffer.readUInt32LE(this.offset);return this.offset+=4,t},nextInt16:function(){var t=this.bigEndian?this.buffer.readInt16BE(this.offset):this.buffer.readInt16LE(this.offset);return this.offset+=2,t},nextInt32:function(){var t=this.bigEndian?this.buffer.readInt32BE(this.offset):this.buffer.readInt32LE(this.offset);return this.offset+=4,t},nextFloat:function(){var t=this.bigEndian?this.buffer.readFloatBE(this.offset):this.buffer.readFloatLE(this.offset);return this.offset+=4,t},nextDouble:function(){var t=this.bigEndian?this.buffer.readDoubleBE(this.offset):this.buffer.readDoubleLE(this.offset);return this.offset+=8,t},nextBuffer:function(t){var e=this.buffer.slice(this.offset,this.offset+t);return this.offset+=t,e},remainingLength:function(){return this.endPosition-this.offset},nextString:function(t){var e=this.buffer.toString("utf8",this.offset,this.offset+t);return this.offset+=t,e},mark:function(){var t=this;return{openWithOffset:function(e){return e=(e||0)+this.offset,new n(t.buffer,e,t.endPosition-e,t.bigEndian)},offset:this.offset}},offsetFrom:function(t){return this.offset-t.offset},skip:function(t){this.offset+=t},branch:function(t,e){return e="number"==typeof e?e:this.endPosition-(this.offset+t),new n(this.buffer,this.offset+t,e,this.bigEndian)}},e.exports=n},{}],242:[function(t,e,r){function n(t){return parseInt(t,10)}function i(t,e){t=t.map(n),e=e.map(n);var r=t[0],i=t[1]-1,a=t[2],o=e[0],s=e[1],l=e[2];return Date.UTC(r,i,a,o,s,l,0)/1e3}function a(t){var e=t.substr(0,10).split("-"),r=t.substr(11,8).split(":"),a=t.substr(19,6).split(":").map(n),o=3600*a[0]+60*a[1],s=i(e,r);if("number"==typeof(s-=o)&&!isNaN(s))return s}function o(t){var e=t.split(" "),r=i(e[0].split(":"),e[1].split(":"));if("number"==typeof r&&!isNaN(r))return r}e.exports={parseDateWithSpecFormat:o,parseDateWithTimezoneFormat:a,parseExifDate:function(t){var e=19===t.length&&":"===t.charAt(4);return 25===t.length&&"T"===t.charAt(10)?a(t):e?o(t):void 0}}},{}],243:[function(t,e,r){function n(t,e,r,n,i,a){this.global=i,e=e||0,r=r||t.byteLength-e,this.arrayBuffer=t.slice(e,e+r),this.view=new i.DataView(this.arrayBuffer,0,this.arrayBuffer.byteLength),this.setBigEndian(n),this.offset=0,this.parentOffset=(a||0)+e}n.prototype={setBigEndian:function(t){this.littleEndian=!t},nextUInt8:function(){var t=this.view.getUint8(this.offset);return this.offset+=1,t},nextInt8:function(){var t=this.view.getInt8(this.offset);return this.offset+=1,t},nextUInt16:function(){var t=this.view.getUint16(this.offset,this.littleEndian);return this.offset+=2,t},nextUInt32:function(){var t=this.view.getUint32(this.offset,this.littleEndian);return this.offset+=4,t},nextInt16:function(){var t=this.view.getInt16(this.offset,this.littleEndian);return this.offset+=2,t},nextInt32:function(){var t=this.view.getInt32(this.offset,this.littleEndian);return this.offset+=4,t},nextFloat:function(){var t=this.view.getFloat32(this.offset,this.littleEndian);return this.offset+=4,t},nextDouble:function(){var t=this.view.getFloat64(this.offset,this.littleEndian);return this.offset+=8,t},nextBuffer:function(t){var e=this.arrayBuffer.slice(this.offset,this.offset+t);return this.offset+=t,e},remainingLength:function(){return this.arrayBuffer.byteLength-this.offset},nextString:function(t){var e=this.arrayBuffer.slice(this.offset,this.offset+t);return e=String.fromCharCode.apply(null,new this.global.Uint8Array(e)),this.offset+=t,e},mark:function(){var t=this;return{openWithOffset:function(e){return e=(e||0)+this.offset,new n(t.arrayBuffer,e,t.arrayBuffer.byteLength-e,!t.littleEndian,t.global,t.parentOffset)},offset:this.offset,getParentOffset:function(){return t.parentOffset}}},offsetFrom:function(t){return this.parentOffset+this.offset-(t.offset+t.getParentOffset())},skip:function(t){this.offset+=t},branch:function(t,e){return e="number"==typeof e?e:this.arrayBuffer.byteLength-(this.offset+t),new n(this.arrayBuffer,this.offset+t,e,!this.littleEndian,this.global,this.parentOffset)}},e.exports=n},{}],244:[function(t,e,r){e.exports={exif:{1:"InteropIndex",2:"InteropVersion",11:"ProcessingSoftware",254:"SubfileType",255:"OldSubfileType",256:"ImageWidth",257:"ImageHeight",258:"BitsPerSample",259:"Compression",262:"PhotometricInterpretation",263:"Thresholding",264:"CellWidth",265:"CellLength",266:"FillOrder",269:"DocumentName",270:"ImageDescription",271:"Make",272:"Model",273:"StripOffsets",274:"Orientation",277:"SamplesPerPixel",278:"RowsPerStrip",279:"StripByteCounts",280:"MinSampleValue",281:"MaxSampleValue",282:"XResolution",283:"YResolution",284:"PlanarConfiguration",285:"PageName",286:"XPosition",287:"YPosition",288:"FreeOffsets",289:"FreeByteCounts",290:"GrayResponseUnit",291:"GrayResponseCurve",292:"T4Options",293:"T6Options",296:"ResolutionUnit",297:"PageNumber",300:"ColorResponseUnit",301:"TransferFunction",305:"Software",306:"ModifyDate",315:"Artist",316:"HostComputer",317:"Predictor",318:"WhitePoint",319:"PrimaryChromaticities",320:"ColorMap",321:"HalftoneHints",322:"TileWidth",323:"TileLength",324:"TileOffsets",325:"TileByteCounts",326:"BadFaxLines",327:"CleanFaxData",328:"ConsecutiveBadFaxLines",330:"SubIFD",332:"InkSet",333:"InkNames",334:"NumberofInks",336:"DotRange",337:"TargetPrinter",338:"ExtraSamples",339:"SampleFormat",340:"SMinSampleValue",341:"SMaxSampleValue",342:"TransferRange",343:"ClipPath",344:"XClipPathUnits",345:"YClipPathUnits",346:"Indexed",347:"JPEGTables",351:"OPIProxy",400:"GlobalParametersIFD",401:"ProfileType",402:"FaxProfile",403:"CodingMethods",404:"VersionYear",405:"ModeNumber",433:"Decode",434:"DefaultImageColor",435:"T82Options",437:"JPEGTables",512:"JPEGProc",513:"ThumbnailOffset",514:"ThumbnailLength",515:"JPEGRestartInterval",517:"JPEGLosslessPredictors",518:"JPEGPointTransforms",519:"JPEGQTables",520:"JPEGDCTables",521:"JPEGACTables",529:"YCbCrCoefficients",530:"YCbCrSubSampling",531:"YCbCrPositioning",532:"ReferenceBlackWhite",559:"StripRowCounts",700:"ApplicationNotes",999:"USPTOMiscellaneous",4096:"RelatedImageFileFormat",4097:"RelatedImageWidth",4098:"RelatedImageHeight",18246:"Rating",18247:"XP_DIP_XML",18248:"StitchInfo",18249:"RatingPercent",32781:"ImageID",32931:"WangTag1",32932:"WangAnnotation",32933:"WangTag3",32934:"WangTag4",32995:"Matteing",32996:"DataType",32997:"ImageDepth",32998:"TileDepth",33405:"Model2",33421:"CFARepeatPatternDim",33422:"CFAPattern2",33423:"BatteryLevel",33424:"KodakIFD",33432:"Copyright",33434:"ExposureTime",33437:"FNumber",33445:"MDFileTag",33446:"MDScalePixel",33447:"MDColorTable",33448:"MDLabName",33449:"MDSampleInfo",33450:"MDPrepDate",33451:"MDPrepTime",33452:"MDFileUnits",33550:"PixelScale",33589:"AdventScale",33590:"AdventRevision",33628:"UIC1Tag",33629:"UIC2Tag",33630:"UIC3Tag",33631:"UIC4Tag",33723:"IPTC-NAA",33918:"IntergraphPacketData",33919:"IntergraphFlagRegisters",33920:"IntergraphMatrix",33921:"INGRReserved",33922:"ModelTiePoint",34016:"Site",34017:"ColorSequence",34018:"IT8Header",34019:"RasterPadding",34020:"BitsPerRunLength",34021:"BitsPerExtendedRunLength",34022:"ColorTable",34023:"ImageColorIndicator",34024:"BackgroundColorIndicator",34025:"ImageColorValue",34026:"BackgroundColorValue",34027:"PixelIntensityRange",34028:"TransparencyIndicator",34029:"ColorCharacterization",34030:"HCUsage",34031:"TrapIndicator",34032:"CMYKEquivalent",34118:"SEMInfo",34152:"AFCP_IPTC",34232:"PixelMagicJBIGOptions",34264:"ModelTransform",34306:"WB_GRGBLevels",34310:"LeafData",34377:"PhotoshopSettings",34665:"ExifOffset",34675:"ICC_Profile",34687:"TIFF_FXExtensions",34688:"MultiProfiles",34689:"SharedData",34690:"T88Options",34732:"ImageLayer",34735:"GeoTiffDirectory",34736:"GeoTiffDoubleParams",34737:"GeoTiffAsciiParams",34850:"ExposureProgram",34852:"SpectralSensitivity",34853:"GPSInfo",34855:"ISO",34856:"Opto-ElectricConvFactor",34857:"Interlace",34858:"TimeZoneOffset",34859:"SelfTimerMode",34864:"SensitivityType",34865:"StandardOutputSensitivity",34866:"RecommendedExposureIndex",34867:"ISOSpeed",34868:"ISOSpeedLatitudeyyy",34869:"ISOSpeedLatitudezzz",34908:"FaxRecvParams",34909:"FaxSubAddress",34910:"FaxRecvTime",34954:"LeafSubIFD",36864:"ExifVersion",36867:"DateTimeOriginal",36868:"CreateDate",37121:"ComponentsConfiguration",37122:"CompressedBitsPerPixel",37377:"ShutterSpeedValue",37378:"ApertureValue",37379:"BrightnessValue",37380:"ExposureCompensation",37381:"MaxApertureValue",37382:"SubjectDistance",37383:"MeteringMode",37384:"LightSource",37385:"Flash",37386:"FocalLength",37387:"FlashEnergy",37388:"SpatialFrequencyResponse",37389:"Noise",37390:"FocalPlaneXResolution",37391:"FocalPlaneYResolution",37392:"FocalPlaneResolutionUnit",37393:"ImageNumber",37394:"SecurityClassification",37395:"ImageHistory",37396:"SubjectArea",37397:"ExposureIndex",37398:"TIFF-EPStandardID",37399:"SensingMethod",37434:"CIP3DataFile",37435:"CIP3Sheet",37436:"CIP3Side",37439:"StoNits",37500:"MakerNote",37510:"UserComment",37520:"SubSecTime",37521:"SubSecTimeOriginal",37522:"SubSecTimeDigitized",37679:"MSDocumentText",37680:"MSPropertySetStorage",37681:"MSDocumentTextPosition",37724:"ImageSourceData",40091:"XPTitle",40092:"XPComment",40093:"XPAuthor",40094:"XPKeywords",40095:"XPSubject",40960:"FlashpixVersion",40961:"ColorSpace",40962:"ExifImageWidth",40963:"ExifImageHeight",40964:"RelatedSoundFile",40965:"InteropOffset",41483:"FlashEnergy",41484:"SpatialFrequencyResponse",41485:"Noise",41486:"FocalPlaneXResolution",41487:"FocalPlaneYResolution",41488:"FocalPlaneResolutionUnit",41489:"ImageNumber",41490:"SecurityClassification",41491:"ImageHistory",41492:"SubjectLocation",41493:"ExposureIndex",41494:"TIFF-EPStandardID",41495:"SensingMethod",41728:"FileSource",41729:"SceneType",41730:"CFAPattern",41985:"CustomRendered",41986:"ExposureMode",41987:"WhiteBalance",41988:"DigitalZoomRatio",41989:"FocalLengthIn35mmFormat",41990:"SceneCaptureType",41991:"GainControl",41992:"Contrast",41993:"Saturation",41994:"Sharpness",41995:"DeviceSettingDescription",41996:"SubjectDistanceRange",42016:"ImageUniqueID",42032:"OwnerName",42033:"SerialNumber",42034:"LensInfo",42035:"LensMake",42036:"LensModel",42037:"LensSerialNumber",42112:"GDALMetadata",42113:"GDALNoData",42240:"Gamma",44992:"ExpandSoftware",44993:"ExpandLens",44994:"ExpandFilm",44995:"ExpandFilterLens",44996:"ExpandScanner",44997:"ExpandFlashLamp",48129:"PixelFormat",48130:"Transformation",48131:"Uncompressed",48132:"ImageType",48256:"ImageWidth",48257:"ImageHeight",48258:"WidthResolution",48259:"HeightResolution",48320:"ImageOffset",48321:"ImageByteCount",48322:"AlphaOffset",48323:"AlphaByteCount",48324:"ImageDataDiscard",48325:"AlphaDataDiscard",50215:"OceScanjobDesc",50216:"OceApplicationSelector",50217:"OceIDNumber",50218:"OceImageLogic",50255:"Annotations",50341:"PrintIM",50560:"USPTOOriginalContentType",50706:"DNGVersion",50707:"DNGBackwardVersion",50708:"UniqueCameraModel",50709:"LocalizedCameraModel",50710:"CFAPlaneColor",50711:"CFALayout",50712:"LinearizationTable",50713:"BlackLevelRepeatDim",50714:"BlackLevel",50715:"BlackLevelDeltaH",50716:"BlackLevelDeltaV",50717:"WhiteLevel",50718:"DefaultScale",50719:"DefaultCropOrigin",50720:"DefaultCropSize",50721:"ColorMatrix1",50722:"ColorMatrix2",50723:"CameraCalibration1",50724:"CameraCalibration2",50725:"ReductionMatrix1",50726:"ReductionMatrix2",50727:"AnalogBalance",50728:"AsShotNeutral",50729:"AsShotWhiteXY",50730:"BaselineExposure",50731:"BaselineNoise",50732:"BaselineSharpness",50733:"BayerGreenSplit",50734:"LinearResponseLimit",50735:"CameraSerialNumber",50736:"DNGLensInfo",50737:"ChromaBlurRadius",50738:"AntiAliasStrength",50739:"ShadowScale",50740:"DNGPrivateData",50741:"MakerNoteSafety",50752:"RawImageSegmentation",50778:"CalibrationIlluminant1",50779:"CalibrationIlluminant2",50780:"BestQualityScale",50781:"RawDataUniqueID",50784:"AliasLayerMetadata",50827:"OriginalRawFileName",50828:"OriginalRawFileData",50829:"ActiveArea",50830:"MaskedAreas",50831:"AsShotICCProfile",50832:"AsShotPreProfileMatrix",50833:"CurrentICCProfile",50834:"CurrentPreProfileMatrix",50879:"ColorimetricReference",50898:"PanasonicTitle",50899:"PanasonicTitle2",50931:"CameraCalibrationSig",50932:"ProfileCalibrationSig",50933:"ProfileIFD",50934:"AsShotProfileName",50935:"NoiseReductionApplied",50936:"ProfileName",50937:"ProfileHueSatMapDims",50938:"ProfileHueSatMapData1",50939:"ProfileHueSatMapData2",50940:"ProfileToneCurve",50941:"ProfileEmbedPolicy",50942:"ProfileCopyright",50964:"ForwardMatrix1",50965:"ForwardMatrix2",50966:"PreviewApplicationName",50967:"PreviewApplicationVersion",50968:"PreviewSettingsName",50969:"PreviewSettingsDigest",50970:"PreviewColorSpace",50971:"PreviewDateTime",50972:"RawImageDigest",50973:"OriginalRawFileDigest",50974:"SubTileBlockSize",50975:"RowInterleaveFactor",50981:"ProfileLookTableDims",50982:"ProfileLookTableData",51008:"OpcodeList1",51009:"OpcodeList2",51022:"OpcodeList3",51041:"NoiseProfile",51043:"TimeCodes",51044:"FrameRate",51058:"TStop",51081:"ReelName",51089:"OriginalDefaultFinalSize",51090:"OriginalBestQualitySize",51091:"OriginalDefaultCropSize",51105:"CameraLabel",51107:"ProfileHueSatMapEncoding",51108:"ProfileLookTableEncoding",51109:"BaselineExposureOffset",51110:"DefaultBlackRender",51111:"NewRawImageDigest",51112:"RawToPreviewGain",51125:"DefaultUserCrop",59932:"Padding",59933:"OffsetSchema",65e3:"OwnerName",65001:"SerialNumber",65002:"Lens",65024:"KDC_IFD",65100:"RawFile",65101:"Converter",65102:"WhiteBalance",65105:"Exposure",65106:"Shadows",65107:"Brightness",65108:"Contrast",65109:"Saturation",65110:"Sharpness",65111:"Smoothness",65112:"MoireFilter"},gps:{0:"GPSVersionID",1:"GPSLatitudeRef",2:"GPSLatitude",3:"GPSLongitudeRef",4:"GPSLongitude",5:"GPSAltitudeRef",6:"GPSAltitude",7:"GPSTimeStamp",8:"GPSSatellites",9:"GPSStatus",10:"GPSMeasureMode",11:"GPSDOP",12:"GPSSpeedRef",13:"GPSSpeed",14:"GPSTrackRef",15:"GPSTrack",16:"GPSImgDirectionRef",17:"GPSImgDirection",18:"GPSMapDatum",19:"GPSDestLatitudeRef",20:"GPSDestLatitude",21:"GPSDestLongitudeRef",22:"GPSDestLongitude",23:"GPSDestBearingRef",24:"GPSDestBearing",25:"GPSDestDistanceRef",26:"GPSDestDistance",27:"GPSProcessingMethod",28:"GPSAreaInformation",29:"GPSDateStamp",30:"GPSDifferential",31:"GPSHPositioningError"}}},{}],245:[function(t,e,r){function n(t,e){switch(t){case 1:return e.nextUInt8();case 3:case 8:return e.nextUInt16();case 4:case 9:return e.nextUInt32();case 5:return[e.nextUInt32(),e.nextUInt32()];case 6:return e.nextInt8();case 10:return[e.nextInt32(),e.nextInt32()];case 11:return e.nextFloat();case 12:return e.nextDouble();default:throw new Error("Invalid format while decoding: "+t)}}function i(t,e){var r,i,a=e.nextUInt16(),o=e.nextUInt16(),s=function(t){switch(t){case 1:case 2:case 6:case 7:return 1;case 3:case 8:return 2;case 4:case 9:case 11:return 4;case 5:case 10:case 12:return 8;default:return 0}}(o),l=e.nextUInt32(),u=s*l;if(u>4&&(e=t.openWithOffset(e.nextUInt32())),2===o){var f=(r=e.nextString(l)).indexOf("\0");-1!==f&&(r=r.substr(0,f))}else if(7===o)r=e.nextBuffer(l);else if(0!==o)for(r=[],i=0;i<l;++i)r.push(n(o,e));return u<4&&e.skip(4-u),[a,r,o]}function a(t,e,r){var n,a,o=e.nextUInt16();for(a=0;a<o;++a)r((n=i(t,e))[0],n[1],n[2])}e.exports={IFD0:1,IFD1:2,GPSIFD:3,SubIFD:4,InteropIFD:5,parseTags:function(t,e){var r,n,i,o;try{r=function(t){if("Exif\0\0"!==t.nextString(6))throw new Error("Invalid EXIF header");var e=t.mark(),r=t.nextUInt16();if(18761===r)t.setBigEndian(!1);else{if(19789!==r)throw new Error("Invalid TIFF header");t.setBigEndian(!0)}if(42!==t.nextUInt16())throw new Error("Invalid TIFF data");return e}(t)}catch(t){return!1}var s=r.openWithOffset(t.nextUInt32()),l=this.IFD0;a(r,s,(function(t,r,a){switch(t){case 34853:i=r[0];break;case 34665:n=r[0];break;default:e(l,t,r,a)}}));var u=s.nextUInt32();if(0!==u){var f=r.openWithOffset(u);a(r,f,e.bind(null,this.IFD1))}if(i){var h=r.openWithOffset(i);a(r,h,e.bind(null,this.GPSIFD))}if(n){var c=r.openWithOffset(n),d=this.InteropIFD;a(r,c,(function(t,r,n){40965===t?o=r[0]:e(d,t,r,n)}))}if(o){var p=r.openWithOffset(o);a(r,p,e.bind(null,this.InteropIFD))}return!0}}},{}],246:[function(t,e,r){e.exports={parseSections:function(t,e){var r,n;for(t.setBigEndian(!0);t.remainingLength()>0&&218!==n;){if(255!==t.nextUInt8())throw new Error("Invalid JPEG section offset");r=(n=t.nextUInt8())>=208&&n<=217||218===n?0:t.nextUInt16()-2,e(n,t.branch(0,r)),t.skip(r)}},getSizeFromSOFSection:function(t){return t.skip(1),{height:t.nextUInt16(),width:t.nextUInt16()}},getSectionName:function(t){var e,r;switch(t){case 216:e="SOI";break;case 196:e="DHT";break;case 219:e="DQT";break;case 221:e="DRI";break;case 218:e="SOS";break;case 254:e="COM";break;case 217:e="EOI";break;default:t>=224&&t<=239?(e="APP",r=t-224):t>=192&&t<=207&&196!==t&&200!==t&&204!==t?(e="SOF",r=t-192):t>=208&&t<=215&&(e="RST",r=t-208)}var n={name:e};return"number"==typeof r&&(n.index=r),n}}},{}],247:[function(t,e,r){var n=t("./jpeg"),i=t("./exif"),a=t("./simplify");function o(t,e,r,n,i,a,o){this.startMarker=t,this.tags=e,this.imageSize=r,this.thumbnailOffset=n,this.thumbnailLength=i,this.thumbnailType=a,this.app1Offset=o}function s(t){this.stream=t,this.flags={readBinaryTags:!1,resolveTagNames:!0,simplifyValues:!0,imageSize:!0,hidePointers:!0,returnTags:!0}}o.prototype={hasThumbnail:function(t){return!(!this.thumbnailOffset||!this.thumbnailLength||"string"==typeof t&&("image/jpeg"===t.toLowerCase().trim()?6!==this.thumbnailType:"image/tiff"!==t.toLowerCase().trim()||1!==this.thumbnailType))},getThumbnailOffset:function(){return this.app1Offset+6+this.thumbnailOffset},getThumbnailLength:function(){return this.thumbnailLength},getThumbnailBuffer:function(){return this._getThumbnailStream().nextBuffer(this.thumbnailLength)},_getThumbnailStream:function(){return this.startMarker.openWithOffset(this.getThumbnailOffset())},getImageSize:function(){return this.imageSize},getThumbnailSize:function(){var t,e=this._getThumbnailStream();return n.parseSections(e,(function(e,r){"SOF"===n.getSectionName(e).name&&(t=n.getSizeFromSOFSection(r))})),t}},s.prototype={enableBinaryFields:function(t){return this.flags.readBinaryTags=!!t,this},enablePointers:function(t){return this.flags.hidePointers=!t,this},enableTagNames:function(t){return this.flags.resolveTagNames=!!t,this},enableImageSize:function(t){return this.flags.imageSize=!!t,this},enableReturnTags:function(t){return this.flags.returnTags=!!t,this},enableSimpleValues:function(t){return this.flags.simplifyValues=!!t,this},parse:function(){var e,r,s,l,u,f,h,c,d,p=this.stream.mark(),b=p.openWithOffset(0),m=this.flags;return m.resolveTagNames&&(h=t("./exif-tags")),m.resolveTagNames?(e={},c=function(t){return e[t.name]},d=function(t,r){e[t.name]=r}):(e=[],c=function(t){var r;for(r=0;r<e.length;++r)if(e[r].type===t.type&&e[r].section===t.section)return e.value},d=function(t,r){var n;for(n=0;n<e.length;++n)if(e[n].type===t.type&&e[n].section===t.section)return void(e.value=r)}),n.parseSections(b,(function(t,o){var c=o.offsetFrom(p);225===t?i.parseTags(o,(function(t,r,n,o){if(m.readBinaryTags||7!==o){if(513===r){if(s=n[0],m.hidePointers)return}else if(514===r){if(l=n[0],m.hidePointers)return}else if(259===r&&(u=n[0],m.hidePointers))return;if(m.returnTags)if(m.simplifyValues&&(n=a.simplifyValue(n,o)),m.resolveTagNames){var f=(t===i.GPSIFD?h.gps:h.exif)[r];f||(f=h.exif[r]),e.hasOwnProperty(f)||(e[f]=n)}else e.push({section:t,type:r,value:n})}}))&&(f=c):m.imageSize&&"SOF"===n.getSectionName(t).name&&(r=n.getSizeFromSOFSection(o))})),m.simplifyValues&&(a.castDegreeValues(c,d),a.castDateValues(c,d)),new o(p,e,r,s,l,u,f)}},e.exports=s},{"./exif":245,"./exif-tags":244,"./jpeg":246,"./simplify":248}],248:[function(t,e,r){var n=t("./exif"),i=t("./date"),a=[{section:n.GPSIFD,type:2,name:"GPSLatitude",refType:1,refName:"GPSLatitudeRef",posVal:"N"},{section:n.GPSIFD,type:4,name:"GPSLongitude",refType:3,refName:"GPSLongitudeRef",posVal:"E"}],o=[{section:n.SubIFD,type:306,name:"ModifyDate"},{section:n.SubIFD,type:36867,name:"DateTimeOriginal"},{section:n.SubIFD,type:36868,name:"CreateDate"},{section:n.SubIFD,type:306,name:"ModifyDate"}];e.exports={castDegreeValues:function(t,e){a.forEach((function(r){var n=t(r);if(n){var i=t({section:r.section,type:r.refType,name:r.refName})===r.posVal?1:-1,a=(n[0]+n[1]/60+n[2]/3600)*i;e(r,a)}}))},castDateValues:function(t,e){o.forEach((function(r){var n=t(r);if(n){var a=i.parseExifDate(n);void 0!==a&&e(r,a)}}))},simplifyValue:function(t,e){return Array.isArray(t)&&1===(t=t.map((function(t){return 10===e||5===e?t[0]/t[1]:t}))).length&&(t=t[0]),t}}},{"./date":242,"./exif":245}],249:[function(t,e,r){"use strict";var n=t("@babel/runtime/helpers/interopRequireDefault")(t("@babel/runtime/helpers/toConsumableArray")),i=function(t){return(0,n.default)(t).map((function(t){return t.charCodeAt(0)}))},a=i("META-INF/mozilla.rsa"),o=i("[Content_Types].xml"),s=i("_rels/.rels");e.exports=function(t){var e=t instanceof Uint8Array?t:new Uint8Array(t);if(!(e&&e.length>1))return null;var r=function(t,r){r=Object.assign({offset:0},r);for(var n=0;n<t.length;n++)if(r.mask){if(t[n]!==(r.mask[n]&e[n+r.offset]))return!1}else if(t[n]!==e[n+r.offset])return!1;return!0},l=function(t,e){return r(i(t),e)};if(r([255,216,255]))return{ext:"jpg",mime:"image/jpeg"};if(r([137,80,78,71,13,10,26,10]))return{ext:"png",mime:"image/png"};if(r([71,73,70]))return{ext:"gif",mime:"image/gif"};if(r([87,69,66,80],{offset:8}))return{ext:"webp",mime:"image/webp"};if(r([70,76,73,70]))return{ext:"flif",mime:"image/flif"};if((r([73,73,42,0])||r([77,77,0,42]))&&r([67,82],{offset:8}))return{ext:"cr2",mime:"image/x-canon-cr2"};if(r([73,73,42,0])||r([77,77,0,42]))return{ext:"tif",mime:"image/tiff"};if(r([66,77]))return{ext:"bmp",mime:"image/bmp"};if(r([73,73,188]))return{ext:"jxr",mime:"image/vnd.ms-photo"};if(r([56,66,80,83]))return{ext:"psd",mime:"image/vnd.adobe.photoshop"};if(r([80,75,3,4])){if(r([109,105,109,101,116,121,112,101,97,112,112,108,105,99,97,116,105,111,110,47,101,112,117,98,43,122,105,112],{offset:30}))return{ext:"epub",mime:"application/epub+zip"};if(r(a,{offset:30}))return{ext:"xpi",mime:"application/x-xpinstall"};if(l("mimetypeapplication/vnd.oasis.opendocument.text",{offset:30}))return{ext:"odt",mime:"application/vnd.oasis.opendocument.text"};if(l("mimetypeapplication/vnd.oasis.opendocument.spreadsheet",{offset:30}))return{ext:"ods",mime:"application/vnd.oasis.opendocument.spreadsheet"};if(l("mimetypeapplication/vnd.oasis.opendocument.presentation",{offset:30}))return{ext:"odp",mime:"application/vnd.oasis.opendocument.presentation"};var u=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;return t.findIndex((function(t,r,n){return r>=e&&80===n[r]&&75===n[r+1]&&3===n[r+2]&&4===n[r+3]}))},f=0,h=!1,c=null;do{var d=f+30;if(h||(h=r(o,{offset:d})||r(s,{offset:d})),c||(l("word/",{offset:d})?c={ext:"docx",mime:"application/vnd.openxmlformats-officedocument.wordprocessingml.document"}:l("ppt/",{offset:d})?c={ext:"pptx",mime:"application/vnd.openxmlformats-officedocument.presentationml.presentation"}:l("xl/",{offset:d})&&(c={ext:"xlsx",mime:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"})),h&&c)return c;f=u(e,d)}while(f>=0);if(c)return c}if(r([80,75])&&(3===e[2]||5===e[2]||7===e[2])&&(4===e[3]||6===e[3]||8===e[3]))return{ext:"zip",mime:"application/zip"};if(r([117,115,116,97,114],{offset:257}))return{ext:"tar",mime:"application/x-tar"};if(r([82,97,114,33,26,7])&&(0===e[6]||1===e[6]))return{ext:"rar",mime:"application/x-rar-compressed"};if(r([31,139,8]))return{ext:"gz",mime:"application/gzip"};if(r([66,90,104]))return{ext:"bz2",mime:"application/x-bzip2"};if(r([55,122,188,175,39,28]))return{ext:"7z",mime:"application/x-7z-compressed"};if(r([120,1]))return{ext:"dmg",mime:"application/x-apple-diskimage"};if(r([51,103,112,53])||r([0,0,0])&&r([102,116,121,112],{offset:4})&&(r([109,112,52,49],{offset:8})||r([109,112,52,50],{offset:8})||r([105,115,111,109],{offset:8})||r([105,115,111,50],{offset:8})||r([109,109,112,52],{offset:8})||r([77,52,86],{offset:8})||r([100,97,115,104],{offset:8})))return{ext:"mp4",mime:"video/mp4"};if(r([77,84,104,100]))return{ext:"mid",mime:"audio/midi"};if(r([26,69,223,163])){var p=e.subarray(4,4100),b=p.findIndex((function(t,e,r){return 66===r[e]&&130===r[e+1]}));if(-1!==b){var m=b+3,g=function(t){return(0,n.default)(t).every((function(t,e){return p[m+e]===t.charCodeAt(0)}))};if(g("matroska"))return{ext:"mkv",mime:"video/x-matroska"};if(g("webm"))return{ext:"webm",mime:"video/webm"}}}if(r([0,0,0,20,102,116,121,112,113,116,32,32])||r([102,114,101,101],{offset:4})||r([102,116,121,112,113,116,32,32],{offset:4})||r([109,100,97,116],{offset:4})||r([119,105,100,101],{offset:4}))return{ext:"mov",mime:"video/quicktime"};if(r([82,73,70,70])){if(r([65,86,73],{offset:8}))return{ext:"avi",mime:"video/vnd.avi"};if(r([87,65,86,69],{offset:8}))return{ext:"wav",mime:"audio/vnd.wave"};if(r([81,76,67,77],{offset:8}))return{ext:"qcp",mime:"audio/qcelp"}}if(r([48,38,178,117,142,102,207,17,166,217]))return{ext:"wmv",mime:"video/x-ms-wmv"};if(r([0,0,1,186])||r([0,0,1,179]))return{ext:"mpg",mime:"video/mpeg"};if(r([102,116,121,112,51,103],{offset:4}))return{ext:"3gp",mime:"video/3gpp"};for(var y=0;y<2&&y<e.length-16;y++){if(r([73,68,51],{offset:y})||r([255,226],{offset:y,mask:[255,226]}))return{ext:"mp3",mime:"audio/mpeg"};if(r([255,228],{offset:y,mask:[255,228]}))return{ext:"mp2",mime:"audio/mpeg"};if(r([255,248],{offset:y,mask:[255,252]}))return{ext:"mp2",mime:"audio/mpeg"};if(r([255,240],{offset:y,mask:[255,252]}))return{ext:"mp4",mime:"audio/mpeg"}}if(r([102,116,121,112,77,52,65],{offset:4})||r([77,52,65,32]))return{ext:"m4a",mime:"audio/mp4"};if(r([79,112,117,115,72,101,97,100],{offset:28}))return{ext:"opus",mime:"audio/opus"};if(r([79,103,103,83]))return r([128,116,104,101,111,114,97],{offset:28})?{ext:"ogv",mime:"video/ogg"}:r([1,118,105,100,101,111,0],{offset:28})?{ext:"ogm",mime:"video/ogg"}:r([127,70,76,65,67],{offset:28})?{ext:"oga",mime:"audio/ogg"}:r([83,112,101,101,120,32,32],{offset:28})?{ext:"spx",mime:"audio/ogg"}:r([1,118,111,114,98,105,115],{offset:28})?{ext:"ogg",mime:"audio/ogg"}:{ext:"ogx",mime:"application/ogg"};if(r([102,76,97,67]))return{ext:"flac",mime:"audio/x-flac"};if(r([77,65,67,32]))return{ext:"ape",mime:"audio/ape"};if(r([119,118,112,107]))return{ext:"wv",mime:"audio/wavpack"};if(r([35,33,65,77,82,10]))return{ext:"amr",mime:"audio/amr"};if(r([37,80,68,70]))return{ext:"pdf",mime:"application/pdf"};if(r([77,90]))return{ext:"exe",mime:"application/x-msdownload"};if((67===e[0]||70===e[0])&&r([87,83],{offset:1}))return{ext:"swf",mime:"application/x-shockwave-flash"};if(r([123,92,114,116,102]))return{ext:"rtf",mime:"application/rtf"};if(r([0,97,115,109]))return{ext:"wasm",mime:"application/wasm"};if(r([119,79,70,70])&&(r([0,1,0,0],{offset:4})||r([79,84,84,79],{offset:4})))return{ext:"woff",mime:"font/woff"};if(r([119,79,70,50])&&(r([0,1,0,0],{offset:4})||r([79,84,84,79],{offset:4})))return{ext:"woff2",mime:"font/woff2"};if(r([76,80],{offset:34})&&(r([0,0,1],{offset:8})||r([1,0,2],{offset:8})||r([2,0,2],{offset:8})))return{ext:"eot",mime:"application/vnd.ms-fontobject"};if(r([0,1,0,0,0]))return{ext:"ttf",mime:"font/ttf"};if(r([79,84,84,79,0]))return{ext:"otf",mime:"font/otf"};if(r([0,0,1,0]))return{ext:"ico",mime:"image/x-icon"};if(r([0,0,2,0]))return{ext:"cur",mime:"image/x-icon"};if(r([70,76,86,1]))return{ext:"flv",mime:"video/x-flv"};if(r([37,33]))return{ext:"ps",mime:"application/postscript"};if(r([253,55,122,88,90,0]))return{ext:"xz",mime:"application/x-xz"};if(r([83,81,76,105]))return{ext:"sqlite",mime:"application/x-sqlite3"};if(r([78,69,83,26]))return{ext:"nes",mime:"application/x-nintendo-nes-rom"};if(r([67,114,50,52]))return{ext:"crx",mime:"application/x-google-chrome-extension"};if(r([77,83,67,70])||r([73,83,99,40]))return{ext:"cab",mime:"application/vnd.ms-cab-compressed"};if(r([33,60,97,114,99,104,62,10,100,101,98,105,97,110,45,98,105,110,97,114,121]))return{ext:"deb",mime:"application/x-deb"};if(r([33,60,97,114,99,104,62]))return{ext:"ar",mime:"application/x-unix-archive"};if(r([237,171,238,219]))return{ext:"rpm",mime:"application/x-rpm"};if(r([31,160])||r([31,157]))return{ext:"Z",mime:"application/x-compress"};if(r([76,90,73,80]))return{ext:"lz",mime:"application/x-lzip"};if(r([208,207,17,224,161,177,26,225]))return{ext:"msi",mime:"application/x-msi"};if(r([6,14,43,52,2,5,1,1,13,1,2,1,1,2]))return{ext:"mxf",mime:"application/mxf"};if(r([71],{offset:4})&&(r([71],{offset:192})||r([71],{offset:196})))return{ext:"mts",mime:"video/mp2t"};if(r([66,76,69,78,68,69,82]))return{ext:"blend",mime:"application/x-blender"};if(r([66,80,71,251]))return{ext:"bpg",mime:"image/bpg"};if(r([0,0,0,12,106,80,32,32,13,10,135,10])){if(r([106,112,50,32],{offset:20}))return{ext:"jp2",mime:"image/jp2"};if(r([106,112,120,32],{offset:20}))return{ext:"jpx",mime:"image/jpx"};if(r([106,112,109,32],{offset:20}))return{ext:"jpm",mime:"image/jpm"};if(r([109,106,112,50],{offset:20}))return{ext:"mj2",mime:"image/mj2"}}if(r([70,79,82,77,0]))return{ext:"aif",mime:"audio/aiff"};if(l("<?xml "))return{ext:"xml",mime:"application/xml"};if(r([66,79,79,75,77,79,66,73],{offset:60}))return{ext:"mobi",mime:"application/x-mobipocket-ebook"};if(r([102,116,121,112],{offset:4})){if(r([109,105,102,49],{offset:8}))return{ext:"heic",mime:"image/heif"};if(r([109,115,102,49],{offset:8}))return{ext:"heic",mime:"image/heif-sequence"};if(r([104,101,105,99],{offset:8})||r([104,101,105,120],{offset:8}))return{ext:"heic",mime:"image/heic"};if(r([104,101,118,99],{offset:8})||r([104,101,118,120],{offset:8}))return{ext:"heic",mime:"image/heic-sequence"}}return r([171,75,84,88,32,49,49,187,13,10,26,10])?{ext:"ktx",mime:"image/ktx"}:null}},{"@babel/runtime/helpers/interopRequireDefault":10,"@babel/runtime/helpers/toConsumableArray":19}],250:[function(t,e,r){"use strict";var n=t("is-callable"),i=Object.prototype.toString,a=Object.prototype.hasOwnProperty;e.exports=function(t,e,r){if(!n(e))throw new TypeError("iterator must be a function");var o;arguments.length>=3&&(o=r),"[object Array]"===i.call(t)?function(t,e,r){for(var n=0,i=t.length;n<i;n++)a.call(t,n)&&(null==r?e(t[n],n,t):e.call(r,t[n],n,t))}(t,e,o):"string"==typeof t?function(t,e,r){for(var n=0,i=t.length;n<i;n++)null==r?e(t.charAt(n),n,t):e.call(r,t.charAt(n),n,t)}(t,e,o):function(t,e,r){for(var n in t)a.call(t,n)&&(null==r?e(t[n],n,t):e.call(r,t[n],n,t))}(t,e,o)}},{"is-callable":256}],251:[function(t,e,i){(function(t){var r;r=void 0!==n?n:void 0!==t?t:"undefined"!=typeof self?self:{},e.exports=r}).call(this,void 0!==r.g?r.g:"undefined"!=typeof self?self:void 0!==n?n:{})},{}],252:[function(t,e,r){var n=t("http"),i=t("url"),a=e.exports;for(var o in n)n.hasOwnProperty(o)&&(a[o]=n[o]);function s(t){if("string"==typeof t&&(t=i.parse(t)),t.protocol||(t.protocol="https:"),"https:"!==t.protocol)throw new Error('Protocol "'+t.protocol+'" not supported. Expected "https:"');return t}a.request=function(t,e){return t=s(t),n.request.call(this,t,e)},a.get=function(t,e){return t=s(t),n.get.call(this,t,e)}},{http:335,url:359}],253:[function(t,e,r){r.read=function(t,e,r,n,i){var a,o,s=8*i-n-1,l=(1<<s)-1,u=l>>1,f=-7,h=r?i-1:0,c=r?-1:1,d=t[e+h];for(h+=c,a=d&(1<<-f)-1,d>>=-f,f+=s;f>0;a=256*a+t[e+h],h+=c,f-=8);for(o=a&(1<<-f)-1,a>>=-f,f+=n;f>0;o=256*o+t[e+h],h+=c,f-=8);if(0===a)a=1-u;else{if(a===l)return o?NaN:1/0*(d?-1:1);o+=Math.pow(2,n),a-=u}return(d?-1:1)*o*Math.pow(2,a-n)},r.write=function(t,e,r,n,i,a){var o,s,l,u=8*a-i-1,f=(1<<u)-1,h=f>>1,c=23===i?Math.pow(2,-24)-Math.pow(2,-77):0,d=n?0:a-1,p=n?1:-1,b=e<0||0===e&&1/e<0?1:0;for(e=Math.abs(e),isNaN(e)||e===1/0?(s=isNaN(e)?1:0,o=f):(o=Math.floor(Math.log(e)/Math.LN2),e*(l=Math.pow(2,-o))<1&&(o--,l*=2),(e+=o+h>=1?c/l:c*Math.pow(2,1-h))*l>=2&&(o++,l/=2),o+h>=f?(s=0,o=f):o+h>=1?(s=(e*l-1)*Math.pow(2,i),o+=h):(s=e*Math.pow(2,h-1)*Math.pow(2,i),o=0));i>=8;t[r+d]=255&s,d+=p,s/=256,i-=8);for(o=o<<i|s,u+=i;u>0;t[r+d]=255&o,d+=p,o/=256,u-=8);t[r+d-p]|=128*b}},{}],254:[function(t,e,r){"function"==typeof Object.create?e.exports=function(t,e){e&&(t.super_=e,t.prototype=Object.create(e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}))}:e.exports=function(t,e){if(e){t.super_=e;var r=function(){};r.prototype=e.prototype,t.prototype=new r,t.prototype.constructor=t}}},{}],255:[function(t,e,r){function n(t){return!!t.constructor&&"function"==typeof t.constructor.isBuffer&&t.constructor.isBuffer(t)}e.exports=function(t){return null!=t&&(n(t)||function(t){return"function"==typeof t.readFloatLE&&"function"==typeof t.slice&&n(t.slice(0,0))}(t)||!!t._isBuffer)}},{}],256:[function(t,e,r){"use strict";var n=Function.prototype.toString,i=/^\s*class\b/,a=function(t){try{var e=n.call(t);return i.test(e)}catch(t){return!1}},o=Object.prototype.toString,s="function"==typeof Symbol&&"symbol"==typeof Symbol.toStringTag;e.exports=function(t){if(!t)return!1;if("function"!=typeof t&&"object"!=typeof t)return!1;if("function"==typeof t&&!t.prototype)return!0;if(s)return function(t){try{return!a(t)&&(n.call(t),!0)}catch(t){return!1}}(t);if(a(t))return!1;var e=o.call(t);return"[object Function]"===e||"[object GeneratorFunction]"===e}},{}],257:[function(t,e,r){e.exports=function(t){var e=i.call(t);return"[object Function]"===e||"function"==typeof t&&"[object RegExp]"!==e||void 0!==n&&(t===n.setTimeout||t===n.alert||t===n.confirm||t===n.prompt)};var i=Object.prototype.toString},{}],258:[function(t,e,r){var n={}.toString;e.exports=Array.isArray||function(t){return"[object Array]"==n.call(t)}},{}],259:[function(t,e,r){var n=t("./lib/encoder"),i=t("./lib/decoder");e.exports={encode:n,decode:i}},{"./lib/decoder":260,"./lib/encoder":261}],260:[function(t,e,r){(function(t){var r=function(){"use strict";var t=new Int32Array([0,1,8,16,9,2,3,10,17,24,32,25,18,11,4,5,12,19,26,33,40,48,41,34,27,20,13,6,7,14,21,28,35,42,49,56,57,50,43,36,29,22,15,23,30,37,44,51,58,59,52,45,38,31,39,46,53,60,61,54,47,55,62,63]),e=4017,r=799,n=3406,i=2276,a=1567,o=3784,s=5793,l=2896;function u(){}function f(t,e){for(var r,n,i=0,a=[],o=16;o>0&&!t[o-1];)o--;a.push({children:[],index:0});var s,l=a[0];for(r=0;r<o;r++){for(n=0;n<t[r];n++){for((l=a.pop()).children[l.index]=e[i];l.index>0;)l=a.pop();for(l.index++,a.push(l);a.length<=r;)a.push(s={children:[],index:0}),l.children[l.index]=s.children,l=s;i++}r+1<o&&(a.push(s={children:[],index:0}),l.children[l.index]=s.children,l=s)}return a[0].children}function h(e,r,n,i,a,o,s,l,u){n.precision,n.samplesPerLine,n.scanLines;var f=n.mcusPerLine,h=n.progressive,c=(n.maxH,n.maxV,r),d=0,p=0;function b(){if(p>0)return p--,d>>p&1;if(255==(d=e[r++])){var t=e[r++];if(t)throw new Error("unexpected marker: "+(d<<8|t).toString(16))}return p=7,d>>>7}function m(t){for(var e,r=t;null!==(e=b());){if("number"==typeof(r=r[e]))return r;if("object"!=typeof r)throw new Error("invalid huffman sequence")}return null}function g(t){for(var e=0;t>0;){var r=b();if(null===r)return;e=e<<1|r,t--}return e}function y(t){var e=g(t);return e>=1<<t-1?e:e+(-1<<t)+1}var v,_=0,w=0;function x(t,e,r,n,i){var a=r%f,o=(r/f|0)*t.v+n,s=a*t.h+i;e(t,t.blocks[o][s])}function E(t,e,r){var n=r/t.blocksPerLine|0,i=r%t.blocksPerLine;e(t,t.blocks[n][i])}var k,j,S,A,T,I,P=i.length;I=h?0===o?0===l?function(t,e){var r=m(t.huffmanTableDC),n=0===r?0:y(r)<<u;e[0]=t.pred+=n}:function(t,e){e[0]|=b()<<u}:0===l?function(e,r){if(_>0)_--;else for(var n=o,i=s;n<=i;){var a=m(e.huffmanTableAC),l=15&a,f=a>>4;if(0!==l)r[t[n+=f]]=y(l)*(1<<u),n++;else{if(f<15){_=g(f)+(1<<f)-1;break}n+=16}}}:function(e,r){for(var n=o,i=s,a=0;n<=i;){var l=t[n],f=r[l]<0?-1:1;switch(w){case 0:var h=m(e.huffmanTableAC),c=15&h;if(a=h>>4,0===c)a<15?(_=g(a)+(1<<a),w=4):(a=16,w=1);else{if(1!==c)throw new Error("invalid ACn encoding");v=y(c),w=a?2:3}continue;case 1:case 2:r[l]?r[l]+=(b()<<u)*f:0===--a&&(w=2==w?3:0);break;case 3:r[l]?r[l]+=(b()<<u)*f:(r[l]=v<<u,w=0);break;case 4:r[l]&&(r[l]+=(b()<<u)*f)}n++}4===w&&0===--_&&(w=0)}:function(e,r){var n=m(e.huffmanTableDC),i=0===n?0:y(n);r[0]=e.pred+=i;for(var a=1;a<64;){var o=m(e.huffmanTableAC),s=15&o,l=o>>4;if(0!==s)r[t[a+=l]]=y(s),a++;else{if(l<15)break;a+=16}}};var M,O,R,L,C=0;for(O=1==P?i[0].blocksPerLine*i[0].blocksPerColumn:f*n.mcusPerColumn,a||(a=O);C<O;){for(j=0;j<P;j++)i[j].pred=0;if(_=0,1==P)for(k=i[0],T=0;T<a;T++)E(k,I,C),C++;else for(T=0;T<a;T++){for(j=0;j<P;j++)for(R=(k=i[j]).h,L=k.v,S=0;S<L;S++)for(A=0;A<R;A++)x(k,I,C,S,A);if(++C===O)break}if(p=0,(M=e[r]<<8|e[r+1])<65280)throw new Error("marker was not found");if(!(M>=65488&&M<=65495))break;r+=2}return r-c}function c(t,u){var f,h,c=[],d=u.blocksPerLine,p=u.blocksPerColumn,b=d<<3,m=new Int32Array(64),g=new Uint8Array(64);function y(t,f,h){var c,d,p,b,m,g,y,v,_,w,x=u.quantizationTable,E=h;for(w=0;w<64;w++)E[w]=t[w]*x[w];for(w=0;w<8;++w){var k=8*w;0!=E[1+k]||0!=E[2+k]||0!=E[3+k]||0!=E[4+k]||0!=E[5+k]||0!=E[6+k]||0!=E[7+k]?(c=s*E[0+k]+128>>8,d=s*E[4+k]+128>>8,p=E[2+k],b=E[6+k],m=l*(E[1+k]-E[7+k])+128>>8,v=l*(E[1+k]+E[7+k])+128>>8,g=E[3+k]<<4,y=E[5+k]<<4,_=c-d+1>>1,c=c+d+1>>1,d=_,_=p*o+b*a+128>>8,p=p*a-b*o+128>>8,b=_,_=m-y+1>>1,m=m+y+1>>1,y=_,_=v+g+1>>1,g=v-g+1>>1,v=_,_=c-b+1>>1,c=c+b+1>>1,b=_,_=d-p+1>>1,d=d+p+1>>1,p=_,_=m*i+v*n+2048>>12,m=m*n-v*i+2048>>12,v=_,_=g*r+y*e+2048>>12,g=g*e-y*r+2048>>12,y=_,E[0+k]=c+v,E[7+k]=c-v,E[1+k]=d+y,E[6+k]=d-y,E[2+k]=p+g,E[5+k]=p-g,E[3+k]=b+m,E[4+k]=b-m):(_=s*E[0+k]+512>>10,E[0+k]=_,E[1+k]=_,E[2+k]=_,E[3+k]=_,E[4+k]=_,E[5+k]=_,E[6+k]=_,E[7+k]=_)}for(w=0;w<8;++w){var j=w;0!=E[8+j]||0!=E[16+j]||0!=E[24+j]||0!=E[32+j]||0!=E[40+j]||0!=E[48+j]||0!=E[56+j]?(c=s*E[0+j]+2048>>12,d=s*E[32+j]+2048>>12,p=E[16+j],b=E[48+j],m=l*(E[8+j]-E[56+j])+2048>>12,v=l*(E[8+j]+E[56+j])+2048>>12,g=E[24+j],y=E[40+j],_=c-d+1>>1,c=c+d+1>>1,d=_,_=p*o+b*a+2048>>12,p=p*a-b*o+2048>>12,b=_,_=m-y+1>>1,m=m+y+1>>1,y=_,_=v+g+1>>1,g=v-g+1>>1,v=_,_=c-b+1>>1,c=c+b+1>>1,b=_,_=d-p+1>>1,d=d+p+1>>1,p=_,_=m*i+v*n+2048>>12,m=m*n-v*i+2048>>12,v=_,_=g*r+y*e+2048>>12,g=g*e-y*r+2048>>12,y=_,E[0+j]=c+v,E[56+j]=c-v,E[8+j]=d+y,E[48+j]=d-y,E[16+j]=p+g,E[40+j]=p-g,E[24+j]=b+m,E[32+j]=b-m):(_=s*h[w+0]+8192>>14,E[0+j]=_,E[8+j]=_,E[16+j]=_,E[24+j]=_,E[32+j]=_,E[40+j]=_,E[48+j]=_,E[56+j]=_)}for(w=0;w<64;++w){var S=128+(E[w]+8>>4);f[w]=S<0?0:S>255?255:S}}for(var v=0;v<p;v++){var _=v<<3;for(f=0;f<8;f++)c.push(new Uint8Array(b));for(var w=0;w<d;w++){y(u.blocks[v][w],g,m);var x=0,E=w<<3;for(h=0;h<8;h++){var k=c[_+h];for(f=0;f<8;f++)k[E+f]=g[x++]}}}return c}function d(t){return t<0?0:t>255?255:t}return u.prototype={load:function(t){var e=new XMLHttpRequest;e.open("GET",t,!0),e.responseType="arraybuffer",e.onload=function(){var t=new Uint8Array(e.response||e.mozResponseArrayBuffer);this.parse(t),this.onload&&this.onload()}.bind(this),e.send(null)},parse:function(e){var r=0;function n(){var t=e[r]<<8|e[r+1];return r+=2,t}function i(t){var e,r,n=0,i=0;for(r in t.components)t.components.hasOwnProperty(r)&&(n<(e=t.components[r]).h&&(n=e.h),i<e.v&&(i=e.v));var a=Math.ceil(t.samplesPerLine/8/n),o=Math.ceil(t.scanLines/8/i);for(r in t.components)if(t.components.hasOwnProperty(r)){e=t.components[r];for(var s=Math.ceil(Math.ceil(t.samplesPerLine/8)*e.h/n),l=Math.ceil(Math.ceil(t.scanLines/8)*e.v/i),u=a*e.h,f=o*e.v,h=[],c=0;c<f;c++){for(var d=[],p=0;p<u;p++)d.push(new Int32Array(64));h.push(d)}e.blocksPerLine=s,e.blocksPerColumn=l,e.blocks=h}t.maxH=n,t.maxV=i,t.mcusPerLine=a,t.mcusPerColumn=o}e.length;var a,o,s,l,u=null,d=null,p=[],b=[],m=[],g=[],y=n();if(65496!=y)throw new Error("SOI not found");for(y=n();65497!=y;){switch(y){case 65280:break;case 65504:case 65505:case 65506:case 65507:case 65508:case 65509:case 65510:case 65511:case 65512:case 65513:case 65514:case 65515:case 65516:case 65517:case 65518:case 65519:case 65534:var v=(s=void 0,l=void 0,s=n(),l=e.subarray(r,r+s-2),r+=l.length,l);65504===y&&74===v[0]&&70===v[1]&&73===v[2]&&70===v[3]&&0===v[4]&&(u={version:{major:v[5],minor:v[6]},densityUnits:v[7],xDensity:v[8]<<8|v[9],yDensity:v[10]<<8|v[11],thumbWidth:v[12],thumbHeight:v[13],thumbData:v.subarray(14,14+3*v[12]*v[13])}),65518===y&&65===v[0]&&100===v[1]&&111===v[2]&&98===v[3]&&101===v[4]&&0===v[5]&&(d={version:v[6],flags0:v[7]<<8|v[8],flags1:v[9]<<8|v[10],transformCode:v[11]});break;case 65499:for(var _=n()+r-2;r<_;){var w=e[r++],x=new Int32Array(64);if(w>>4){if(w>>4!=1)throw new Error("DQT: invalid table spec");for(H=0;H<64;H++)x[t[H]]=n()}else for(H=0;H<64;H++)x[t[H]]=e[r++];p[15&w]=x}break;case 65472:case 65473:case 65474:n(),(a={}).extended=65473===y,a.progressive=65474===y,a.precision=e[r++],a.scanLines=n(),a.samplesPerLine=n(),a.components={},a.componentsOrder=[];var E,k=e[r++];for(z=0;z<k;z++){E=e[r];var j=e[r+1]>>4,S=15&e[r+1],A=e[r+2];a.componentsOrder.push(E),a.components[E]={h:j,v:S,quantizationIdx:A},r+=3}i(a),b.push(a);break;case 65476:var T=n();for(z=2;z<T;){var I=e[r++],P=new Uint8Array(16),M=0;for(H=0;H<16;H++,r++)M+=P[H]=e[r];var O=new Uint8Array(M);for(H=0;H<M;H++,r++)O[H]=e[r];z+=17+M,(I>>4?m:g)[15&I]=f(P,O)}break;case 65501:n(),o=n();break;case 65498:n();var R=e[r++],L=[];for(z=0;z<R;z++){G=a.components[e[r++]];var C=e[r++];G.huffmanTableDC=g[C>>4],G.huffmanTableAC=m[15&C],L.push(G)}var B=e[r++],D=e[r++],N=e[r++],U=h(e,r,a,L,o,B,D,N>>4,15&N);r+=U;break;case 65535:255!==e[r]&&r--;break;default:if(255==e[r-3]&&e[r-2]>=192&&e[r-2]<=254){r-=3;break}throw new Error("unknown JPEG marker "+y.toString(16))}y=n()}if(1!=b.length)throw new Error("only single frame JPEGs supported");for(var z=0;z<b.length;z++){var F=b[z].components;for(var H in F)F[H].quantizationTable=p[F[H].quantizationIdx],delete F[H].quantizationIdx}for(this.width=a.samplesPerLine,this.height=a.scanLines,this.jfif=u,this.adobe=d,this.components=[],z=0;z<a.componentsOrder.length;z++){var G=a.components[a.componentsOrder[z]];this.components.push({lines:c(0,G),scaleX:G.h/a.maxH,scaleY:G.v/a.maxV})}},getData:function(t,e){var r,n,i,a,o,s,l,u,f,h,c,p,b,m,g,y,v,_,w,x,E,k=this.width/t,j=this.height/e,S=0,A=t*e*this.components.length,T=new Uint8Array(A);switch(this.components.length){case 1:for(r=this.components[0],h=0;h<e;h++)for(o=r.lines[0|h*r.scaleY*j],f=0;f<t;f++)c=o[0|f*r.scaleX*k],T[S++]=c;break;case 2:for(r=this.components[0],n=this.components[1],h=0;h<e;h++)for(o=r.lines[0|h*r.scaleY*j],s=n.lines[0|h*n.scaleY*j],f=0;f<t;f++)c=o[0|f*r.scaleX*k],T[S++]=c,c=s[0|f*n.scaleX*k],T[S++]=c;break;case 3:for(E=!0,this.adobe&&this.adobe.transformCode?E=!0:void 0!==this.colorTransform&&(E=!!this.colorTransform),r=this.components[0],n=this.components[1],i=this.components[2],h=0;h<e;h++)for(o=r.lines[0|h*r.scaleY*j],s=n.lines[0|h*n.scaleY*j],l=i.lines[0|h*i.scaleY*j],f=0;f<t;f++)E?(c=o[0|f*r.scaleX*k],p=s[0|f*n.scaleX*k],_=d(c+1.402*((b=l[0|f*i.scaleX*k])-128)),w=d(c-.3441363*(p-128)-.71413636*(b-128)),x=d(c+1.772*(p-128))):(_=o[0|f*r.scaleX*k],w=s[0|f*n.scaleX*k],x=l[0|f*i.scaleX*k]),T[S++]=_,T[S++]=w,T[S++]=x;break;case 4:if(!this.adobe)throw"Unsupported color mode (4 components)";for(E=!1,this.adobe&&this.adobe.transformCode?E=!0:void 0!==this.colorTransform&&(E=!!this.colorTransform),r=this.components[0],n=this.components[1],i=this.components[2],a=this.components[3],h=0;h<e;h++)for(o=r.lines[0|h*r.scaleY*j],s=n.lines[0|h*n.scaleY*j],l=i.lines[0|h*i.scaleY*j],u=a.lines[0|h*a.scaleY*j],f=0;f<t;f++)E?(c=o[0|f*r.scaleX*k],p=s[0|f*n.scaleX*k],b=l[0|f*i.scaleX*k],m=u[0|f*a.scaleX*k],g=255-d(c+1.402*(b-128)),y=255-d(c-.3441363*(p-128)-.71413636*(b-128)),v=255-d(c+1.772*(p-128))):(g=o[0|f*r.scaleX*k],y=s[0|f*n.scaleX*k],v=l[0|f*i.scaleX*k],m=u[0|f*a.scaleX*k]),T[S++]=255-g,T[S++]=255-y,T[S++]=255-v,T[S++]=255-m;break;default:throw"Unsupported color mode"}return T},copyToImageData:function(t){var e,r,n,i,a,o,s,l,u,f=t.width,h=t.height,c=t.data,p=this.getData(f,h),b=0,m=0;switch(this.components.length){case 1:for(r=0;r<h;r++)for(e=0;e<f;e++)n=p[b++],c[m++]=n,c[m++]=n,c[m++]=n,c[m++]=255;break;case 3:for(r=0;r<h;r++)for(e=0;e<f;e++)s=p[b++],l=p[b++],u=p[b++],c[m++]=s,c[m++]=l,c[m++]=u,c[m++]=255;break;case 4:for(r=0;r<h;r++)for(e=0;e<f;e++)a=p[b++],o=p[b++],n=p[b++],s=255-d(a*(1-(i=p[b++])/255)+i),l=255-d(o*(1-i/255)+i),u=255-d(n*(1-i/255)+i),c[m++]=s,c[m++]=l,c[m++]=u,c[m++]=255;break;default:throw"Unsupported color mode"}}},u}();e.exports=function(e,n){var i=new Uint8Array(e),a=new r;a.parse(i);var o={width:a.width,height:a.height,data:n?new Uint8Array(a.width*a.height*4):new t(a.width*a.height*4)};return a.copyToImageData(o),o}}).call(this,t("buffer").Buffer)},{buffer:47}],261:[function(t,e,r){(function(t){function r(e){Math.round;var r,n,i,a,o,s=Math.floor,l=new Array(64),u=new Array(64),f=new Array(64),h=new Array(64),c=new Array(65535),d=new Array(65535),p=new Array(64),b=new Array(64),m=[],g=0,y=7,v=new Array(64),_=new Array(64),w=new Array(64),x=new Array(256),E=new Array(2048),k=[0,1,5,6,14,15,27,28,2,4,7,13,16,26,29,42,3,8,12,17,25,30,41,43,9,11,18,24,31,40,44,53,10,19,23,32,39,45,52,54,20,22,33,38,46,51,55,60,21,34,37,47,50,56,59,61,35,36,48,49,57,58,62,63],j=[0,0,1,5,1,1,1,1,1,1,0,0,0,0,0,0,0],S=[0,1,2,3,4,5,6,7,8,9,10,11],A=[0,0,2,1,3,3,2,4,3,5,5,4,4,0,0,1,125],T=[1,2,3,0,4,17,5,18,33,49,65,6,19,81,97,7,34,113,20,50,129,145,161,8,35,66,177,193,21,82,209,240,36,51,98,114,130,9,10,22,23,24,25,26,37,38,39,40,41,42,52,53,54,55,56,57,58,67,68,69,70,71,72,73,74,83,84,85,86,87,88,89,90,99,100,101,102,103,104,105,106,115,116,117,118,119,120,121,122,131,132,133,134,135,136,137,138,146,147,148,149,150,151,152,153,154,162,163,164,165,166,167,168,169,170,178,179,180,181,182,183,184,185,186,194,195,196,197,198,199,200,201,202,210,211,212,213,214,215,216,217,218,225,226,227,228,229,230,231,232,233,234,241,242,243,244,245,246,247,248,249,250],I=[0,0,3,1,1,1,1,1,1,1,1,1,0,0,0,0,0],P=[0,1,2,3,4,5,6,7,8,9,10,11],M=[0,0,2,1,2,4,4,3,4,7,5,4,4,0,1,2,119],O=[0,1,2,3,17,4,5,33,49,6,18,65,81,7,97,113,19,34,50,129,8,20,66,145,161,177,193,9,35,51,82,240,21,98,114,209,10,22,36,52,225,37,241,23,24,25,26,38,39,40,41,42,53,54,55,56,57,58,67,68,69,70,71,72,73,74,83,84,85,86,87,88,89,90,99,100,101,102,103,104,105,106,115,116,117,118,119,120,121,122,130,131,132,133,134,135,136,137,138,146,147,148,149,150,151,152,153,154,162,163,164,165,166,167,168,169,170,178,179,180,181,182,183,184,185,186,194,195,196,197,198,199,200,201,202,210,211,212,213,214,215,216,217,218,226,227,228,229,230,231,232,233,234,242,243,244,245,246,247,248,249,250];function R(t,e){for(var r=0,n=0,i=new Array,a=1;a<=16;a++){for(var o=1;o<=t[a];o++)i[e[n]]=[],i[e[n]][0]=r,i[e[n]][1]=a,n++,r++;r*=2}return i}function L(t){for(var e=t[0],r=t[1]-1;r>=0;)e&1<<r&&(g|=1<<y),r--,--y<0&&(255==g?(C(255),C(0)):C(g),y=7,g=0)}function C(t){m.push(t)}function B(t){C(t>>8&255),C(255&t)}function D(t,e,r,n,i){for(var a,o=i[0],s=i[240],l=function(t,e){var r,n,i,a,o,s,l,u,f,h,c=0;for(f=0;f<8;++f){r=t[c],n=t[c+1],i=t[c+2],a=t[c+3],o=t[c+4],s=t[c+5],l=t[c+6];var d=r+(u=t[c+7]),b=r-u,m=n+l,g=n-l,y=i+s,v=i-s,_=a+o,w=a-o,x=d+_,E=d-_,k=m+y,j=m-y;t[c]=x+k,t[c+4]=x-k;var S=.707106781*(j+E);t[c+2]=E+S,t[c+6]=E-S;var A=.382683433*((x=w+v)-(j=g+b)),T=.5411961*x+A,I=1.306562965*j+A,P=.707106781*(k=v+g),M=b+P,O=b-P;t[c+5]=O+T,t[c+3]=O-T,t[c+1]=M+I,t[c+7]=M-I,c+=8}for(c=0,f=0;f<8;++f){r=t[c],n=t[c+8],i=t[c+16],a=t[c+24],o=t[c+32],s=t[c+40],l=t[c+48];var R=r+(u=t[c+56]),L=r-u,C=n+l,B=n-l,D=i+s,N=i-s,U=a+o,z=a-o,F=R+U,H=R-U,G=C+D,q=C-D;t[c]=F+G,t[c+32]=F-G;var W=.707106781*(q+H);t[c+16]=H+W,t[c+48]=H-W;var Z=.382683433*((F=z+N)-(q=B+L)),V=.5411961*F+Z,Y=1.306562965*q+Z,X=.707106781*(G=N+B),J=L+X,K=L-X;t[c+40]=K+V,t[c+24]=K-V,t[c+8]=J+Y,t[c+56]=J-Y,c++}for(f=0;f<64;++f)h=t[f]*e[f],p[f]=h>0?h+.5|0:h-.5|0;return p}(t,e),u=0;u<64;++u)b[k[u]]=l[u];var f=b[0]-r;r=b[0],0==f?L(n[0]):(L(n[d[a=32767+f]]),L(c[a]));for(var h=63;h>0&&0==b[h];h--);if(0==h)return L(o),r;for(var m,g=1;g<=h;){for(var y=g;0==b[g]&&g<=h;++g);var v=g-y;if(v>=16){m=v>>4;for(var _=1;_<=m;++_)L(s);v&=15}a=32767+b[g],L(i[(v<<4)+d[a]]),L(c[a]),g++}return 63!=h&&L(o),r}function N(t){t<=0&&(t=1),t>100&&(t=100),o!=t&&(function(t){for(var e=[16,11,10,16,24,40,51,61,12,12,14,19,26,58,60,55,14,13,16,24,40,57,69,56,14,17,22,29,51,87,80,62,18,22,37,56,68,109,103,77,24,35,55,64,81,104,113,92,49,64,78,87,103,121,120,101,72,92,95,98,112,100,103,99],r=0;r<64;r++){var n=s((e[r]*t+50)/100);n<1?n=1:n>255&&(n=255),l[k[r]]=n}for(var i=[17,18,24,47,99,99,99,99,18,21,26,66,99,99,99,99,24,26,56,99,99,99,99,99,47,66,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99],a=0;a<64;a++){var o=s((i[a]*t+50)/100);o<1?o=1:o>255&&(o=255),u[k[a]]=o}for(var c=[1,1.387039845,1.306562965,1.175875602,1,.785694958,.5411961,.275899379],d=0,p=0;p<8;p++)for(var b=0;b<8;b++)f[d]=1/(l[k[d]]*c[p]*c[b]*8),h[d]=1/(u[k[d]]*c[p]*c[b]*8),d++}(t<50?Math.floor(5e3/t):Math.floor(200-2*t)),o=t)}this.encode=function(e,o){(new Date).getTime(),o&&N(o),m=new Array,g=0,y=7,B(65496),B(65504),B(16),C(74),C(70),C(73),C(70),C(0),C(1),C(1),C(0),B(1),B(1),C(0),C(0),function(){B(65499),B(132),C(0);for(var t=0;t<64;t++)C(l[t]);C(1);for(var e=0;e<64;e++)C(u[e])}(),function(t,e){B(65472),B(17),C(8),B(e),B(t),C(3),C(1),C(17),C(0),C(2),C(17),C(1),C(3),C(17),C(1)}(e.width,e.height),function(){B(65476),B(418),C(0);for(var t=0;t<16;t++)C(j[t+1]);for(var e=0;e<=11;e++)C(S[e]);C(16);for(var r=0;r<16;r++)C(A[r+1]);for(var n=0;n<=161;n++)C(T[n]);C(1);for(var i=0;i<16;i++)C(I[i+1]);for(var a=0;a<=11;a++)C(P[a]);C(17);for(var o=0;o<16;o++)C(M[o+1]);for(var s=0;s<=161;s++)C(O[s])}(),B(65498),B(12),C(3),C(1),C(0),C(2),C(17),C(3),C(17),C(0),C(63),C(0);var s=0,c=0,d=0;g=0,y=7,this.encode.displayName="_encode_";for(var p,b,x,k,R,U,z,F,H,G=e.data,q=e.width,W=e.height,Z=4*q,V=0;V<W;){for(p=0;p<Z;){for(U=R=Z*V+p,z=-1,F=0,H=0;H<64;H++)U=R+(F=H>>3)*Z+(z=4*(7&H)),V+F>=W&&(U-=Z*(V+1+F-W)),p+z>=Z&&(U-=p+z-Z+4),b=G[U++],x=G[U++],k=G[U++],v[H]=(E[b]+E[x+256|0]+E[k+512|0]>>16)-128,_[H]=(E[b+768|0]+E[x+1024|0]+E[k+1280|0]>>16)-128,w[H]=(E[b+1280|0]+E[x+1536|0]+E[k+1792|0]>>16)-128;s=D(v,f,s,r,i),c=D(_,h,c,n,a),d=D(w,h,d,n,a),p+=32}V+=8}if(y>=0){var Y=[];Y[1]=y+1,Y[0]=(1<<y+1)-1,L(Y)}return B(65497),new t(m)},(new Date).getTime(),e||(e=50),function(){for(var t=String.fromCharCode,e=0;e<256;e++)x[e]=t(e)}(),r=R(j,S),n=R(I,P),i=R(A,T),a=R(M,O),function(){for(var t=1,e=2,r=1;r<=15;r++){for(var n=t;n<e;n++)d[32767+n]=r,c[32767+n]=[],c[32767+n][1]=r,c[32767+n][0]=n;for(var i=-(e-1);i<=-t;i++)d[32767+i]=r,c[32767+i]=[],c[32767+i][1]=r,c[32767+i][0]=e-1+i;t<<=1,e<<=1}}(),function(){for(var t=0;t<256;t++)E[t]=19595*t,E[t+256|0]=38470*t,E[t+512|0]=7471*t+32768,E[t+768|0]=-11059*t,E[t+1024|0]=-21709*t,E[t+1280|0]=32768*t+8421375,E[t+1536|0]=-27439*t,E[t+1792|0]=-5329*t}(),N(e),(new Date).getTime()}e.exports=function(t,e){return void 0===e&&(e=50),{data:new r(e).encode(t,e),width:t.width,height:t.height}}}).call(this,t("buffer").Buffer)},{buffer:47}],262:[function(t,e,r){(function(r){var n=t("path"),i=t("fs"),a=parseInt("0777",8);function o(t,e,s,l){"function"==typeof e?(s=e,e={}):e&&"object"==typeof e||(e={mode:e});var u=e.mode,f=e.fs||i;void 0===u&&(u=a&~r.umask()),l||(l=null);var h=s||function(){};t=n.resolve(t),f.mkdir(t,u,(function(r){if(!r)return h(null,l=l||t);"ENOENT"===r.code?o(n.dirname(t),e,(function(r,n){r?h(r,n):o(t,e,h,n)})):f.stat(t,(function(t,e){t||!e.isDirectory()?h(r,l):h(null,l)}))}))}e.exports=o.mkdirp=o.mkdirP=o,o.sync=function t(e,o,s){o&&"object"==typeof o||(o={mode:o});var l=o.mode,u=o.fs||i;void 0===l&&(l=a&~r.umask()),s||(s=null),e=n.resolve(e);try{u.mkdirSync(e,l),s=s||e}catch(r){if("ENOENT"===r.code)s=t(n.dirname(e),o,s),t(e,o,s);else{var f;try{f=u.statSync(e)}catch(t){throw r}if(!f.isDirectory())throw r}}return s}}).call(this,t("_process"))},{_process:312,fs:46,path:286}],263:[function(t,e,r){"use strict";var n=Object.getOwnPropertySymbols,i=Object.prototype.hasOwnProperty,a=Object.prototype.propertyIsEnumerable;e.exports=function(){try{if(!Object.assign)return!1;var t=new String("abc");if(t[5]="de","5"===Object.getOwnPropertyNames(t)[0])return!1;for(var e={},r=0;r<10;r++)e["_"+String.fromCharCode(r)]=r;if("0123456789"!==Object.getOwnPropertyNames(e).map((function(t){return e[t]})).join(""))return!1;var n={};return"abcdefghijklmnopqrst".split("").forEach((function(t){n[t]=t})),"abcdefghijklmnopqrst"===Object.keys(Object.assign({},n)).join("")}catch(t){return!1}}()?Object.assign:function(t,e){for(var r,o,s=function(t){if(null==t)throw new TypeError("Object.assign cannot be called with null or undefined");return Object(t)}(t),l=1;l<arguments.length;l++){for(var u in r=Object(arguments[l]))i.call(r,u)&&(s[u]=r[u]);if(n){o=n(r);for(var f=0;f<o.length;f++)a.call(r,o[f])&&(s[o[f]]=r[o[f]])}}return s}},{}],264:[function(t,e,r){"use strict";function n(t,e,r,n){for(var i=t[e++],a=1<<i,o=a+1,s=o+1,l=i+1,u=(1<<l)-1,f=0,h=0,c=0,d=t[e++],p=new Int32Array(4096),b=null;;){for(;f<16&&0!==d;)h|=t[e++]<<f,f+=8,1===d?d=t[e++]:--d;if(f<l)break;var m=h&u;if(h>>=l,f-=l,m!==a){if(m===o)break;for(var g=m<s?m:b,y=0,v=g;v>a;)v=p[v]>>8,++y;var _=v;if(c+y+(g!==m?1:0)>n)return void console.log("Warning, gif stream longer than expected.");r[c++]=_;var w=c+=y;for(g!==m&&(r[c++]=_),v=g;y--;)v=p[v],r[--w]=255&v,v>>=8;null!==b&&s<4096&&(p[s++]=b<<8|_,s>=u+1&&l<12&&(++l,u=u<<1|1)),b=m}else s=o+1,u=(1<<(l=i+1))-1,b=null}return c!==n&&console.log("Warning, gif stream shorter than expected."),r}try{r.GifWriter=function(t,e,r,n){var i=0,a=void 0===(n=void 0===n?{}:n).loop?null:n.loop,o=void 0===n.palette?null:n.palette;if(e<=0||r<=0||e>65535||r>65535)throw new Error("Width/Height invalid.");function s(t){var e=t.length;if(e<2||e>256||e&e-1)throw new Error("Invalid code/color length, must be power of 2 and 2 .. 256.");return e}t[i++]=71,t[i++]=73,t[i++]=70,t[i++]=56,t[i++]=57,t[i++]=97;var l=0,u=0;if(null!==o){for(var f=s(o);f>>=1;)++l;if(f=1<<l,--l,void 0!==n.background){if((u=n.background)>=f)throw new Error("Background index out of range.");if(0===u)throw new Error("Background index explicitly passed as 0.")}}if(t[i++]=255&e,t[i++]=e>>8&255,t[i++]=255&r,t[i++]=r>>8&255,t[i++]=(null!==o?128:0)|l,t[i++]=u,t[i++]=0,null!==o)for(var h=0,c=o.length;h<c;++h){var d=o[h];t[i++]=d>>16&255,t[i++]=d>>8&255,t[i++]=255&d}if(null!==a){if(a<0||a>65535)throw new Error("Loop count invalid.");t[i++]=33,t[i++]=255,t[i++]=11,t[i++]=78,t[i++]=69,t[i++]=84,t[i++]=83,t[i++]=67,t[i++]=65,t[i++]=80,t[i++]=69,t[i++]=50,t[i++]=46,t[i++]=48,t[i++]=3,t[i++]=1,t[i++]=255&a,t[i++]=a>>8&255,t[i++]=0}var p=!1;this.addFrame=function(e,r,n,a,l,u){if(!0===p&&(--i,p=!1),u=void 0===u?{}:u,e<0||r<0||e>65535||r>65535)throw new Error("x/y invalid.");if(n<=0||a<=0||n>65535||a>65535)throw new Error("Width/Height invalid.");if(l.length<n*a)throw new Error("Not enough pixels for the frame size.");var f=!0,h=u.palette;if(null==h&&(f=!1,h=o),null==h)throw new Error("Must supply either a local or global palette.");for(var c=s(h),d=0;c>>=1;)++d;c=1<<d;var b=void 0===u.delay?0:u.delay,m=void 0===u.disposal?0:u.disposal;if(m<0||m>3)throw new Error("Disposal out of range.");var g=!1,y=0;if(void 0!==u.transparent&&null!==u.transparent&&(g=!0,(y=u.transparent)<0||y>=c))throw new Error("Transparent color index.");if((0!==m||g||0!==b)&&(t[i++]=33,t[i++]=249,t[i++]=4,t[i++]=m<<2|(!0===g?1:0),t[i++]=255&b,t[i++]=b>>8&255,t[i++]=y,t[i++]=0),t[i++]=44,t[i++]=255&e,t[i++]=e>>8&255,t[i++]=255&r,t[i++]=r>>8&255,t[i++]=255&n,t[i++]=n>>8&255,t[i++]=255&a,t[i++]=a>>8&255,t[i++]=!0===f?128|d-1:0,!0===f)for(var v=0,_=h.length;v<_;++v){var w=h[v];t[i++]=w>>16&255,t[i++]=w>>8&255,t[i++]=255&w}return i=function(t,e,r,n){t[e++]=r;var i=e++,a=1<<r,o=a-1,s=a+1,l=s+1,u=r+1,f=0,h=0;function c(r){for(;f>=r;)t[e++]=255&h,h>>=8,f-=8,e===i+256&&(t[i]=255,i=e++)}function d(t){h|=t<<f,f+=u,c(8)}var p=n[0]&o,b={};d(a);for(var m=1,g=n.length;m<g;++m){var y=n[m]&o,v=p<<8|y,_=b[v];if(void 0===_){for(h|=p<<f,f+=u;f>=8;)t[e++]=255&h,h>>=8,f-=8,e===i+256&&(t[i]=255,i=e++);4096===l?(d(a),l=s+1,u=r+1,b={}):(l>=1<<u&&++u,b[v]=l++),p=y}else p=_}return d(p),d(s),c(1),i+1===e?t[i]=0:(t[i]=e-i-1,t[e++]=0),e}(t,i,d<2?2:d,l)},this.end=function(){return!1===p&&(t[i++]=59,p=!0),i},this.getOutputBuffer=function(){return t},this.setOutputBuffer=function(e){t=e},this.getOutputBufferPosition=function(){return i},this.setOutputBufferPosition=function(t){i=t}},r.GifReader=function(t){var e=0;if(71!==t[e++]||73!==t[e++]||70!==t[e++]||56!==t[e++]||56!=(t[e++]+1&253)||97!==t[e++])throw new Error("Invalid GIF 87a/89a header.");var r=t[e++]|t[e++]<<8,i=t[e++]|t[e++]<<8,a=t[e++],o=a>>7,s=1<<1+(7&a);t[e++],t[e++];var l=null,u=null;o&&(l=e,u=s,e+=3*s);var f=!0,h=[],c=0,d=null,p=0,b=null;for(this.width=r,this.height=i;f&&e<t.length;)switch(t[e++]){case 33:switch(t[e++]){case 255:if(11!==t[e]||78==t[e+1]&&69==t[e+2]&&84==t[e+3]&&83==t[e+4]&&67==t[e+5]&&65==t[e+6]&&80==t[e+7]&&69==t[e+8]&&50==t[e+9]&&46==t[e+10]&&48==t[e+11]&&3==t[e+12]&&1==t[e+13]&&0==t[e+16])e+=14,b=t[e++]|t[e++]<<8,e++;else for(e+=12;;){if(!((T=t[e++])>=0))throw Error("Invalid block size");if(0===T)break;e+=T}break;case 249:if(4!==t[e++]||0!==t[e+4])throw new Error("Invalid graphics extension block.");var m=t[e++];c=t[e++]|t[e++]<<8,d=t[e++],1&m||(d=null),p=m>>2&7,e++;break;case 254:for(;;){if(!((T=t[e++])>=0))throw Error("Invalid block size");if(0===T)break;e+=T}break;default:throw new Error("Unknown graphic control label: 0x"+t[e-1].toString(16))}break;case 44:var g=t[e++]|t[e++]<<8,y=t[e++]|t[e++]<<8,v=t[e++]|t[e++]<<8,_=t[e++]|t[e++]<<8,w=t[e++],x=w>>6&1,E=1<<1+(7&w),k=l,j=u,S=!1;w>>7&&(S=!0,k=e,j=E,e+=3*E);var A=e;for(e++;;){var T;if(!((T=t[e++])>=0))throw Error("Invalid block size");if(0===T)break;e+=T}h.push({x:g,y,width:v,height:_,has_local_palette:S,palette_offset:k,palette_size:j,data_offset:A,data_length:e-A,transparent_index:d,interlaced:!!x,delay:c,disposal:p});break;case 59:f=!1;break;default:throw new Error("Unknown gif block: 0x"+t[e-1].toString(16))}this.numFrames=function(){return h.length},this.loopCount=function(){return b},this.frameInfo=function(t){if(t<0||t>=h.length)throw new Error("Frame index out of range.");return h[t]},this.decodeAndBlitFrameBGRA=function(e,i){var a=this.frameInfo(e),o=a.width*a.height,s=new Uint8Array(o);n(t,a.data_offset,s,o);var l=a.palette_offset,u=a.transparent_index;null===u&&(u=256);var f=a.width,h=r-f,c=f,d=4*(a.y*r+a.x),p=4*((a.y+a.height)*r+a.x),b=d,m=4*h;!0===a.interlaced&&(m+=4*r*7);for(var g=8,y=0,v=s.length;y<v;++y){var _=s[y];if(0===c&&(c=f,(b+=m)>=p&&(m=4*h+4*r*(g-1),b=d+(f+h)*(g<<1),g>>=1)),_===u)b+=4;else{var w=t[l+3*_],x=t[l+3*_+1],E=t[l+3*_+2];i[b++]=E,i[b++]=x,i[b++]=w,i[b++]=255}--c}},this.decodeAndBlitFrameRGBA=function(e,i){var a=this.frameInfo(e),o=a.width*a.height,s=new Uint8Array(o);n(t,a.data_offset,s,o);var l=a.palette_offset,u=a.transparent_index;null===u&&(u=256);var f=a.width,h=r-f,c=f,d=4*(a.y*r+a.x),p=4*((a.y+a.height)*r+a.x),b=d,m=4*h;!0===a.interlaced&&(m+=4*r*7);for(var g=8,y=0,v=s.length;y<v;++y){var _=s[y];if(0===c&&(c=f,(b+=m)>=p&&(m=4*h+4*r*(g-1),b=d+(f+h)*(g<<1),g>>=1)),_===u)b+=4;else{var w=t[l+3*_],x=t[l+3*_+1],E=t[l+3*_+2];i[b++]=w,i[b++]=x,i[b++]=E,i[b++]=255}--c}}}}catch(t){}},{}],265:[function(t,e,r){"use strict";var n={};(0,t("./lib/utils/common").assign)(n,t("./lib/deflate"),t("./lib/inflate"),t("./lib/zlib/constants")),e.exports=n},{"./lib/deflate":266,"./lib/inflate":267,"./lib/utils/common":268,"./lib/zlib/constants":271}],266:[function(t,e,r){"use strict";var n=t("./zlib/deflate"),i=t("./utils/common"),a=t("./utils/strings"),o=t("./zlib/messages"),s=t("./zlib/zstream"),l=Object.prototype.toString;function u(t){if(!(this instanceof u))return new u(t);this.options=i.assign({level:-1,method:8,chunkSize:16384,windowBits:15,memLevel:8,strategy:0,to:""},t||{});var e=this.options;e.raw&&e.windowBits>0?e.windowBits=-e.windowBits:e.gzip&&e.windowBits>0&&e.windowBits<16&&(e.windowBits+=16),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new s,this.strm.avail_out=0;var r=n.deflateInit2(this.strm,e.level,e.method,e.windowBits,e.memLevel,e.strategy);if(0!==r)throw new Error(o[r]);if(e.header&&n.deflateSetHeader(this.strm,e.header),e.dictionary){var f;if(f="string"==typeof e.dictionary?a.string2buf(e.dictionary):"[object ArrayBuffer]"===l.call(e.dictionary)?new Uint8Array(e.dictionary):e.dictionary,0!==(r=n.deflateSetDictionary(this.strm,f)))throw new Error(o[r]);this._dict_set=!0}}function f(t,e){var r=new u(e);if(r.push(t,!0),r.err)throw r.msg||o[r.err];return r.result}u.prototype.push=function(t,e){var r,o,s=this.strm,u=this.options.chunkSize;if(this.ended)return!1;o=e===~~e?e:!0===e?4:0,"string"==typeof t?s.input=a.string2buf(t):"[object ArrayBuffer]"===l.call(t)?s.input=new Uint8Array(t):s.input=t,s.next_in=0,s.avail_in=s.input.length;do{if(0===s.avail_out&&(s.output=new i.Buf8(u),s.next_out=0,s.avail_out=u),1!==(r=n.deflate(s,o))&&0!==r)return this.onEnd(r),this.ended=!0,!1;0!==s.avail_out&&(0!==s.avail_in||4!==o&&2!==o)||("string"===this.options.to?this.onData(a.buf2binstring(i.shrinkBuf(s.output,s.next_out))):this.onData(i.shrinkBuf(s.output,s.next_out)))}while((s.avail_in>0||0===s.avail_out)&&1!==r);return 4===o?(r=n.deflateEnd(this.strm),this.onEnd(r),this.ended=!0,0===r):2!==o||(this.onEnd(0),s.avail_out=0,!0)},u.prototype.onData=function(t){this.chunks.push(t)},u.prototype.onEnd=function(t){0===t&&("string"===this.options.to?this.result=this.chunks.join(""):this.result=i.flattenChunks(this.chunks)),this.chunks=[],this.err=t,this.msg=this.strm.msg},r.Deflate=u,r.deflate=f,r.deflateRaw=function(t,e){return(e=e||{}).raw=!0,f(t,e)},r.gzip=function(t,e){return(e=e||{}).gzip=!0,f(t,e)}},{"./utils/common":268,"./utils/strings":269,"./zlib/deflate":273,"./zlib/messages":278,"./zlib/zstream":280}],267:[function(t,e,r){"use strict";var n=t("./zlib/inflate"),i=t("./utils/common"),a=t("./utils/strings"),o=t("./zlib/constants"),s=t("./zlib/messages"),l=t("./zlib/zstream"),u=t("./zlib/gzheader"),f=Object.prototype.toString;function h(t){if(!(this instanceof h))return new h(t);this.options=i.assign({chunkSize:16384,windowBits:0,to:""},t||{});var e=this.options;e.raw&&e.windowBits>=0&&e.windowBits<16&&(e.windowBits=-e.windowBits,0===e.windowBits&&(e.windowBits=-15)),!(e.windowBits>=0&&e.windowBits<16)||t&&t.windowBits||(e.windowBits+=32),e.windowBits>15&&e.windowBits<48&&(15&e.windowBits||(e.windowBits|=15)),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new l,this.strm.avail_out=0;var r=n.inflateInit2(this.strm,e.windowBits);if(r!==o.Z_OK)throw new Error(s[r]);this.header=new u,n.inflateGetHeader(this.strm,this.header)}function c(t,e){var r=new h(e);if(r.push(t,!0),r.err)throw r.msg||s[r.err];return r.result}h.prototype.push=function(t,e){var r,s,l,u,h,c,d=this.strm,p=this.options.chunkSize,b=this.options.dictionary,m=!1;if(this.ended)return!1;s=e===~~e?e:!0===e?o.Z_FINISH:o.Z_NO_FLUSH,"string"==typeof t?d.input=a.binstring2buf(t):"[object ArrayBuffer]"===f.call(t)?d.input=new Uint8Array(t):d.input=t,d.next_in=0,d.avail_in=d.input.length;do{if(0===d.avail_out&&(d.output=new i.Buf8(p),d.next_out=0,d.avail_out=p),(r=n.inflate(d,o.Z_NO_FLUSH))===o.Z_NEED_DICT&&b&&(c="string"==typeof b?a.string2buf(b):"[object ArrayBuffer]"===f.call(b)?new Uint8Array(b):b,r=n.inflateSetDictionary(this.strm,c)),r===o.Z_BUF_ERROR&&!0===m&&(r=o.Z_OK,m=!1),r!==o.Z_STREAM_END&&r!==o.Z_OK)return this.onEnd(r),this.ended=!0,!1;d.next_out&&(0!==d.avail_out&&r!==o.Z_STREAM_END&&(0!==d.avail_in||s!==o.Z_FINISH&&s!==o.Z_SYNC_FLUSH)||("string"===this.options.to?(l=a.utf8border(d.output,d.next_out),u=d.next_out-l,h=a.buf2string(d.output,l),d.next_out=u,d.avail_out=p-u,u&&i.arraySet(d.output,d.output,l,u,0),this.onData(h)):this.onData(i.shrinkBuf(d.output,d.next_out)))),0===d.avail_in&&0===d.avail_out&&(m=!0)}while((d.avail_in>0||0===d.avail_out)&&r!==o.Z_STREAM_END);return r===o.Z_STREAM_END&&(s=o.Z_FINISH),s===o.Z_FINISH?(r=n.inflateEnd(this.strm),this.onEnd(r),this.ended=!0,r===o.Z_OK):s!==o.Z_SYNC_FLUSH||(this.onEnd(o.Z_OK),d.avail_out=0,!0)},h.prototype.onData=function(t){this.chunks.push(t)},h.prototype.onEnd=function(t){t===o.Z_OK&&("string"===this.options.to?this.result=this.chunks.join(""):this.result=i.flattenChunks(this.chunks)),this.chunks=[],this.err=t,this.msg=this.strm.msg},r.Inflate=h,r.inflate=c,r.inflateRaw=function(t,e){return(e=e||{}).raw=!0,c(t,e)},r.ungzip=c},{"./utils/common":268,"./utils/strings":269,"./zlib/constants":271,"./zlib/gzheader":274,"./zlib/inflate":276,"./zlib/messages":278,"./zlib/zstream":280}],268:[function(t,e,r){arguments[4][35][0].apply(r,arguments)},{dup:35}],269:[function(t,e,r){"use strict";var n=t("./common"),i=!0,a=!0;try{String.fromCharCode.apply(null,[0])}catch(t){i=!1}try{String.fromCharCode.apply(null,new Uint8Array(1))}catch(t){a=!1}for(var o=new n.Buf8(256),s=0;s<256;s++)o[s]=s>=252?6:s>=248?5:s>=240?4:s>=224?3:s>=192?2:1;function l(t,e){if(e<65537&&(t.subarray&&a||!t.subarray&&i))return String.fromCharCode.apply(null,n.shrinkBuf(t,e));for(var r="",o=0;o<e;o++)r+=String.fromCharCode(t[o]);return r}o[254]=o[254]=1,r.string2buf=function(t){var e,r,i,a,o,s=t.length,l=0;for(a=0;a<s;a++)55296==(64512&(r=t.charCodeAt(a)))&&a+1<s&&56320==(64512&(i=t.charCodeAt(a+1)))&&(r=65536+(r-55296<<10)+(i-56320),a++),l+=r<128?1:r<2048?2:r<65536?3:4;for(e=new n.Buf8(l),o=0,a=0;o<l;a++)55296==(64512&(r=t.charCodeAt(a)))&&a+1<s&&56320==(64512&(i=t.charCodeAt(a+1)))&&(r=65536+(r-55296<<10)+(i-56320),a++),r<128?e[o++]=r:r<2048?(e[o++]=192|r>>>6,e[o++]=128|63&r):r<65536?(e[o++]=224|r>>>12,e[o++]=128|r>>>6&63,e[o++]=128|63&r):(e[o++]=240|r>>>18,e[o++]=128|r>>>12&63,e[o++]=128|r>>>6&63,e[o++]=128|63&r);return e},r.buf2binstring=function(t){return l(t,t.length)},r.binstring2buf=function(t){for(var e=new n.Buf8(t.length),r=0,i=e.length;r<i;r++)e[r]=t.charCodeAt(r);return e},r.buf2string=function(t,e){var r,n,i,a,s=e||t.length,u=new Array(2*s);for(n=0,r=0;r<s;)if((i=t[r++])<128)u[n++]=i;else if((a=o[i])>4)u[n++]=65533,r+=a-1;else{for(i&=2===a?31:3===a?15:7;a>1&&r<s;)i=i<<6|63&t[r++],a--;a>1?u[n++]=65533:i<65536?u[n++]=i:(i-=65536,u[n++]=55296|i>>10&1023,u[n++]=56320|1023&i)}return l(u,n)},r.utf8border=function(t,e){var r;for((e=e||t.length)>t.length&&(e=t.length),r=e-1;r>=0&&128==(192&t[r]);)r--;return r<0||0===r?e:r+o[t[r]]>e?r:e}},{"./common":268}],270:[function(t,e,r){arguments[4][36][0].apply(r,arguments)},{dup:36}],271:[function(t,e,r){arguments[4][37][0].apply(r,arguments)},{dup:37}],272:[function(t,e,r){arguments[4][38][0].apply(r,arguments)},{dup:38}],273:[function(t,e,r){"use strict";var n,i=t("../utils/common"),a=t("./trees"),o=t("./adler32"),s=t("./crc32"),l=t("./messages"),u=-2,f=258,h=262,c=103,d=113,p=666;function b(t,e){return t.msg=l[e],e}function m(t){return(t<<1)-(t>4?9:0)}function g(t){for(var e=t.length;--e>=0;)t[e]=0}function y(t){var e=t.state,r=e.pending;r>t.avail_out&&(r=t.avail_out),0!==r&&(i.arraySet(t.output,e.pending_buf,e.pending_out,r,t.next_out),t.next_out+=r,e.pending_out+=r,t.total_out+=r,t.avail_out-=r,e.pending-=r,0===e.pending&&(e.pending_out=0))}function v(t,e){a._tr_flush_block(t,t.block_start>=0?t.block_start:-1,t.strstart-t.block_start,e),t.block_start=t.strstart,y(t.strm)}function _(t,e){t.pending_buf[t.pending++]=e}function w(t,e){t.pending_buf[t.pending++]=e>>>8&255,t.pending_buf[t.pending++]=255&e}function x(t,e){var r,n,i=t.max_chain_length,a=t.strstart,o=t.prev_length,s=t.nice_match,l=t.strstart>t.w_size-h?t.strstart-(t.w_size-h):0,u=t.window,c=t.w_mask,d=t.prev,p=t.strstart+f,b=u[a+o-1],m=u[a+o];t.prev_length>=t.good_match&&(i>>=2),s>t.lookahead&&(s=t.lookahead);do{if(u[(r=e)+o]===m&&u[r+o-1]===b&&u[r]===u[a]&&u[++r]===u[a+1]){a+=2,r++;do{}while(u[++a]===u[++r]&&u[++a]===u[++r]&&u[++a]===u[++r]&&u[++a]===u[++r]&&u[++a]===u[++r]&&u[++a]===u[++r]&&u[++a]===u[++r]&&u[++a]===u[++r]&&a<p);if(n=f-(p-a),a=p-f,n>o){if(t.match_start=e,o=n,n>=s)break;b=u[a+o-1],m=u[a+o]}}}while((e=d[e&c])>l&&0!==--i);return o<=t.lookahead?o:t.lookahead}function E(t){var e,r,n,a,l,u,f,c,d,p,b=t.w_size;do{if(a=t.window_size-t.lookahead-t.strstart,t.strstart>=b+(b-h)){i.arraySet(t.window,t.window,b,b,0),t.match_start-=b,t.strstart-=b,t.block_start-=b,e=r=t.hash_size;do{n=t.head[--e],t.head[e]=n>=b?n-b:0}while(--r);e=r=b;do{n=t.prev[--e],t.prev[e]=n>=b?n-b:0}while(--r);a+=b}if(0===t.strm.avail_in)break;if(u=t.strm,f=t.window,c=t.strstart+t.lookahead,d=a,p=void 0,(p=u.avail_in)>d&&(p=d),r=0===p?0:(u.avail_in-=p,i.arraySet(f,u.input,u.next_in,p,c),1===u.state.wrap?u.adler=o(u.adler,f,p,c):2===u.state.wrap&&(u.adler=s(u.adler,f,p,c)),u.next_in+=p,u.total_in+=p,p),t.lookahead+=r,t.lookahead+t.insert>=3)for(l=t.strstart-t.insert,t.ins_h=t.window[l],t.ins_h=(t.ins_h<<t.hash_shift^t.window[l+1])&t.hash_mask;t.insert&&(t.ins_h=(t.ins_h<<t.hash_shift^t.window[l+3-1])&t.hash_mask,t.prev[l&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=l,l++,t.insert--,!(t.lookahead+t.insert<3)););}while(t.lookahead<h&&0!==t.strm.avail_in)}function k(t,e){for(var r,n;;){if(t.lookahead<h){if(E(t),t.lookahead<h&&0===e)return 1;if(0===t.lookahead)break}if(r=0,t.lookahead>=3&&(t.ins_h=(t.ins_h<<t.hash_shift^t.window[t.strstart+3-1])&t.hash_mask,r=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),0!==r&&t.strstart-r<=t.w_size-h&&(t.match_length=x(t,r)),t.match_length>=3)if(n=a._tr_tally(t,t.strstart-t.match_start,t.match_length-3),t.lookahead-=t.match_length,t.match_length<=t.max_lazy_match&&t.lookahead>=3){t.match_length--;do{t.strstart++,t.ins_h=(t.ins_h<<t.hash_shift^t.window[t.strstart+3-1])&t.hash_mask,r=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart}while(0!==--t.match_length);t.strstart++}else t.strstart+=t.match_length,t.match_length=0,t.ins_h=t.window[t.strstart],t.ins_h=(t.ins_h<<t.hash_shift^t.window[t.strstart+1])&t.hash_mask;else n=a._tr_tally(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++;if(n&&(v(t,!1),0===t.strm.avail_out))return 1}return t.insert=t.strstart<2?t.strstart:2,4===e?(v(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(v(t,!1),0===t.strm.avail_out)?1:2}function j(t,e){for(var r,n,i;;){if(t.lookahead<h){if(E(t),t.lookahead<h&&0===e)return 1;if(0===t.lookahead)break}if(r=0,t.lookahead>=3&&(t.ins_h=(t.ins_h<<t.hash_shift^t.window[t.strstart+3-1])&t.hash_mask,r=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),t.prev_length=t.match_length,t.prev_match=t.match_start,t.match_length=2,0!==r&&t.prev_length<t.max_lazy_match&&t.strstart-r<=t.w_size-h&&(t.match_length=x(t,r),t.match_length<=5&&(1===t.strategy||3===t.match_length&&t.strstart-t.match_start>4096)&&(t.match_length=2)),t.prev_length>=3&&t.match_length<=t.prev_length){i=t.strstart+t.lookahead-3,n=a._tr_tally(t,t.strstart-1-t.prev_match,t.prev_length-3),t.lookahead-=t.prev_length-1,t.prev_length-=2;do{++t.strstart<=i&&(t.ins_h=(t.ins_h<<t.hash_shift^t.window[t.strstart+3-1])&t.hash_mask,r=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart)}while(0!==--t.prev_length);if(t.match_available=0,t.match_length=2,t.strstart++,n&&(v(t,!1),0===t.strm.avail_out))return 1}else if(t.match_available){if((n=a._tr_tally(t,0,t.window[t.strstart-1]))&&v(t,!1),t.strstart++,t.lookahead--,0===t.strm.avail_out)return 1}else t.match_available=1,t.strstart++,t.lookahead--}return t.match_available&&(n=a._tr_tally(t,0,t.window[t.strstart-1]),t.match_available=0),t.insert=t.strstart<2?t.strstart:2,4===e?(v(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(v(t,!1),0===t.strm.avail_out)?1:2}function S(t,e,r,n,i){this.good_length=t,this.max_lazy=e,this.nice_length=r,this.max_chain=n,this.func=i}function A(){this.strm=null,this.status=0,this.pending_buf=null,this.pending_buf_size=0,this.pending_out=0,this.pending=0,this.wrap=0,this.gzhead=null,this.gzindex=0,this.method=8,this.last_flush=-1,this.w_size=0,this.w_bits=0,this.w_mask=0,this.window=null,this.window_size=0,this.prev=null,this.head=null,this.ins_h=0,this.hash_size=0,this.hash_bits=0,this.hash_mask=0,this.hash_shift=0,this.block_start=0,this.match_length=0,this.prev_match=0,this.match_available=0,this.strstart=0,this.match_start=0,this.lookahead=0,this.prev_length=0,this.max_chain_length=0,this.max_lazy_match=0,this.level=0,this.strategy=0,this.good_match=0,this.nice_match=0,this.dyn_ltree=new i.Buf16(1146),this.dyn_dtree=new i.Buf16(122),this.bl_tree=new i.Buf16(78),g(this.dyn_ltree),g(this.dyn_dtree),g(this.bl_tree),this.l_desc=null,this.d_desc=null,this.bl_desc=null,this.bl_count=new i.Buf16(16),this.heap=new i.Buf16(573),g(this.heap),this.heap_len=0,this.heap_max=0,this.depth=new i.Buf16(573),g(this.depth),this.l_buf=0,this.lit_bufsize=0,this.last_lit=0,this.d_buf=0,this.opt_len=0,this.static_len=0,this.matches=0,this.insert=0,this.bi_buf=0,this.bi_valid=0}function T(t){var e;return t&&t.state?(t.total_in=t.total_out=0,t.data_type=2,(e=t.state).pending=0,e.pending_out=0,e.wrap<0&&(e.wrap=-e.wrap),e.status=e.wrap?42:d,t.adler=2===e.wrap?0:1,e.last_flush=0,a._tr_init(e),0):b(t,u)}function I(t){var e,r=T(t);return 0===r&&((e=t.state).window_size=2*e.w_size,g(e.head),e.max_lazy_match=n[e.level].max_lazy,e.good_match=n[e.level].good_length,e.nice_match=n[e.level].nice_length,e.max_chain_length=n[e.level].max_chain,e.strstart=0,e.block_start=0,e.lookahead=0,e.insert=0,e.match_length=e.prev_length=2,e.match_available=0,e.ins_h=0),r}function P(t,e,r,n,a,o){if(!t)return u;var s=1;if(-1===e&&(e=6),n<0?(s=0,n=-n):n>15&&(s=2,n-=16),a<1||a>9||8!==r||n<8||n>15||e<0||e>9||o<0||o>4)return b(t,u);8===n&&(n=9);var l=new A;return t.state=l,l.strm=t,l.wrap=s,l.gzhead=null,l.w_bits=n,l.w_size=1<<l.w_bits,l.w_mask=l.w_size-1,l.hash_bits=a+7,l.hash_size=1<<l.hash_bits,l.hash_mask=l.hash_size-1,l.hash_shift=~~((l.hash_bits+3-1)/3),l.window=new i.Buf8(2*l.w_size),l.head=new i.Buf16(l.hash_size),l.prev=new i.Buf16(l.w_size),l.lit_bufsize=1<<a+6,l.pending_buf_size=4*l.lit_bufsize,l.pending_buf=new i.Buf8(l.pending_buf_size),l.d_buf=1*l.lit_bufsize,l.l_buf=3*l.lit_bufsize,l.level=e,l.strategy=o,l.method=r,I(t)}n=[new S(0,0,0,0,(function(t,e){var r=65535;for(r>t.pending_buf_size-5&&(r=t.pending_buf_size-5);;){if(t.lookahead<=1){if(E(t),0===t.lookahead&&0===e)return 1;if(0===t.lookahead)break}t.strstart+=t.lookahead,t.lookahead=0;var n=t.block_start+r;if((0===t.strstart||t.strstart>=n)&&(t.lookahead=t.strstart-n,t.strstart=n,v(t,!1),0===t.strm.avail_out))return 1;if(t.strstart-t.block_start>=t.w_size-h&&(v(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,4===e?(v(t,!0),0===t.strm.avail_out?3:4):(t.strstart>t.block_start&&(v(t,!1),t.strm.avail_out),1)})),new S(4,4,8,4,k),new S(4,5,16,8,k),new S(4,6,32,32,k),new S(4,4,16,16,j),new S(8,16,32,32,j),new S(8,16,128,128,j),new S(8,32,128,256,j),new S(32,128,258,1024,j),new S(32,258,258,4096,j)],r.deflateInit=function(t,e){return P(t,e,8,15,8,0)},r.deflateInit2=P,r.deflateReset=I,r.deflateResetKeep=T,r.deflateSetHeader=function(t,e){return t&&t.state?2!==t.state.wrap?u:(t.state.gzhead=e,0):u},r.deflate=function(t,e){var r,i,o,l;if(!t||!t.state||e>5||e<0)return t?b(t,u):u;if(i=t.state,!t.output||!t.input&&0!==t.avail_in||i.status===p&&4!==e)return b(t,0===t.avail_out?-5:u);if(i.strm=t,r=i.last_flush,i.last_flush=e,42===i.status)if(2===i.wrap)t.adler=0,_(i,31),_(i,139),_(i,8),i.gzhead?(_(i,(i.gzhead.text?1:0)+(i.gzhead.hcrc?2:0)+(i.gzhead.extra?4:0)+(i.gzhead.name?8:0)+(i.gzhead.comment?16:0)),_(i,255&i.gzhead.time),_(i,i.gzhead.time>>8&255),_(i,i.gzhead.time>>16&255),_(i,i.gzhead.time>>24&255),_(i,9===i.level?2:i.strategy>=2||i.level<2?4:0),_(i,255&i.gzhead.os),i.gzhead.extra&&i.gzhead.extra.length&&(_(i,255&i.gzhead.extra.length),_(i,i.gzhead.extra.length>>8&255)),i.gzhead.hcrc&&(t.adler=s(t.adler,i.pending_buf,i.pending,0)),i.gzindex=0,i.status=69):(_(i,0),_(i,0),_(i,0),_(i,0),_(i,0),_(i,9===i.level?2:i.strategy>=2||i.level<2?4:0),_(i,3),i.status=d);else{var h=8+(i.w_bits-8<<4)<<8;h|=(i.strategy>=2||i.level<2?0:i.level<6?1:6===i.level?2:3)<<6,0!==i.strstart&&(h|=32),h+=31-h%31,i.status=d,w(i,h),0!==i.strstart&&(w(i,t.adler>>>16),w(i,65535&t.adler)),t.adler=1}if(69===i.status)if(i.gzhead.extra){for(o=i.pending;i.gzindex<(65535&i.gzhead.extra.length)&&(i.pending!==i.pending_buf_size||(i.gzhead.hcrc&&i.pending>o&&(t.adler=s(t.adler,i.pending_buf,i.pending-o,o)),y(t),o=i.pending,i.pending!==i.pending_buf_size));)_(i,255&i.gzhead.extra[i.gzindex]),i.gzindex++;i.gzhead.hcrc&&i.pending>o&&(t.adler=s(t.adler,i.pending_buf,i.pending-o,o)),i.gzindex===i.gzhead.extra.length&&(i.gzindex=0,i.status=73)}else i.status=73;if(73===i.status)if(i.gzhead.name){o=i.pending;do{if(i.pending===i.pending_buf_size&&(i.gzhead.hcrc&&i.pending>o&&(t.adler=s(t.adler,i.pending_buf,i.pending-o,o)),y(t),o=i.pending,i.pending===i.pending_buf_size)){l=1;break}l=i.gzindex<i.gzhead.name.length?255&i.gzhead.name.charCodeAt(i.gzindex++):0,_(i,l)}while(0!==l);i.gzhead.hcrc&&i.pending>o&&(t.adler=s(t.adler,i.pending_buf,i.pending-o,o)),0===l&&(i.gzindex=0,i.status=91)}else i.status=91;if(91===i.status)if(i.gzhead.comment){o=i.pending;do{if(i.pending===i.pending_buf_size&&(i.gzhead.hcrc&&i.pending>o&&(t.adler=s(t.adler,i.pending_buf,i.pending-o,o)),y(t),o=i.pending,i.pending===i.pending_buf_size)){l=1;break}l=i.gzindex<i.gzhead.comment.length?255&i.gzhead.comment.charCodeAt(i.gzindex++):0,_(i,l)}while(0!==l);i.gzhead.hcrc&&i.pending>o&&(t.adler=s(t.adler,i.pending_buf,i.pending-o,o)),0===l&&(i.status=c)}else i.status=c;if(i.status===c&&(i.gzhead.hcrc?(i.pending+2>i.pending_buf_size&&y(t),i.pending+2<=i.pending_buf_size&&(_(i,255&t.adler),_(i,t.adler>>8&255),t.adler=0,i.status=d)):i.status=d),0!==i.pending){if(y(t),0===t.avail_out)return i.last_flush=-1,0}else if(0===t.avail_in&&m(e)<=m(r)&&4!==e)return b(t,-5);if(i.status===p&&0!==t.avail_in)return b(t,-5);if(0!==t.avail_in||0!==i.lookahead||0!==e&&i.status!==p){var x=2===i.strategy?function(t,e){for(var r;;){if(0===t.lookahead&&(E(t),0===t.lookahead)){if(0===e)return 1;break}if(t.match_length=0,r=a._tr_tally(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++,r&&(v(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,4===e?(v(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(v(t,!1),0===t.strm.avail_out)?1:2}(i,e):3===i.strategy?function(t,e){for(var r,n,i,o,s=t.window;;){if(t.lookahead<=f){if(E(t),t.lookahead<=f&&0===e)return 1;if(0===t.lookahead)break}if(t.match_length=0,t.lookahead>=3&&t.strstart>0&&(n=s[i=t.strstart-1])===s[++i]&&n===s[++i]&&n===s[++i]){o=t.strstart+f;do{}while(n===s[++i]&&n===s[++i]&&n===s[++i]&&n===s[++i]&&n===s[++i]&&n===s[++i]&&n===s[++i]&&n===s[++i]&&i<o);t.match_length=f-(o-i),t.match_length>t.lookahead&&(t.match_length=t.lookahead)}if(t.match_length>=3?(r=a._tr_tally(t,1,t.match_length-3),t.lookahead-=t.match_length,t.strstart+=t.match_length,t.match_length=0):(r=a._tr_tally(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++),r&&(v(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,4===e?(v(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(v(t,!1),0===t.strm.avail_out)?1:2}(i,e):n[i.level].func(i,e);if(3!==x&&4!==x||(i.status=p),1===x||3===x)return 0===t.avail_out&&(i.last_flush=-1),0;if(2===x&&(1===e?a._tr_align(i):5!==e&&(a._tr_stored_block(i,0,0,!1),3===e&&(g(i.head),0===i.lookahead&&(i.strstart=0,i.block_start=0,i.insert=0))),y(t),0===t.avail_out))return i.last_flush=-1,0}return 4!==e?0:i.wrap<=0?1:(2===i.wrap?(_(i,255&t.adler),_(i,t.adler>>8&255),_(i,t.adler>>16&255),_(i,t.adler>>24&255),_(i,255&t.total_in),_(i,t.total_in>>8&255),_(i,t.total_in>>16&255),_(i,t.total_in>>24&255)):(w(i,t.adler>>>16),w(i,65535&t.adler)),y(t),i.wrap>0&&(i.wrap=-i.wrap),0!==i.pending?0:1)},r.deflateEnd=function(t){var e;return t&&t.state?42!==(e=t.state.status)&&69!==e&&73!==e&&91!==e&&e!==c&&e!==d&&e!==p?b(t,u):(t.state=null,e===d?b(t,-3):0):u},r.deflateSetDictionary=function(t,e){var r,n,a,s,l,f,h,c,d=e.length;if(!t||!t.state)return u;if(2===(s=(r=t.state).wrap)||1===s&&42!==r.status||r.lookahead)return u;for(1===s&&(t.adler=o(t.adler,e,d,0)),r.wrap=0,d>=r.w_size&&(0===s&&(g(r.head),r.strstart=0,r.block_start=0,r.insert=0),c=new i.Buf8(r.w_size),i.arraySet(c,e,d-r.w_size,r.w_size,0),e=c,d=r.w_size),l=t.avail_in,f=t.next_in,h=t.input,t.avail_in=d,t.next_in=0,t.input=e,E(r);r.lookahead>=3;){n=r.strstart,a=r.lookahead-2;do{r.ins_h=(r.ins_h<<r.hash_shift^r.window[n+3-1])&r.hash_mask,r.prev[n&r.w_mask]=r.head[r.ins_h],r.head[r.ins_h]=n,n++}while(--a);r.strstart=n,r.lookahead=2,E(r)}return r.strstart+=r.lookahead,r.block_start=r.strstart,r.insert=r.lookahead,r.lookahead=0,r.match_length=r.prev_length=2,r.match_available=0,t.next_in=f,t.input=h,t.avail_in=l,r.wrap=s,0},r.deflateInfo="pako deflate (from Nodeca project)"},{"../utils/common":268,"./adler32":270,"./crc32":272,"./messages":278,"./trees":279}],274:[function(t,e,r){"use strict";e.exports=function(){this.text=0,this.time=0,this.xflags=0,this.os=0,this.extra=null,this.extra_len=0,this.name="",this.comment="",this.hcrc=0,this.done=!1}},{}],275:[function(t,e,r){arguments[4][40][0].apply(r,arguments)},{dup:40}],276:[function(t,e,r){arguments[4][41][0].apply(r,arguments)},{"../utils/common":268,"./adler32":270,"./crc32":272,"./inffast":275,"./inftrees":277,dup:41}],277:[function(t,e,r){arguments[4][42][0].apply(r,arguments)},{"../utils/common":268,dup:42}],278:[function(t,e,r){arguments[4][43][0].apply(r,arguments)},{dup:43}],279:[function(t,e,r){"use strict";var n=t("../utils/common");function i(t){for(var e=t.length;--e>=0;)t[e]=0}var a=256,o=286,s=30,l=15,u=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0],f=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13],h=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7],c=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],d=new Array(576);i(d);var p=new Array(60);i(p);var b=new Array(512);i(b);var m=new Array(256);i(m);var g=new Array(29);i(g);var y,v,_,w=new Array(s);function x(t,e,r,n,i){this.static_tree=t,this.extra_bits=e,this.extra_base=r,this.elems=n,this.max_length=i,this.has_stree=t&&t.length}function E(t,e){this.dyn_tree=t,this.max_code=0,this.stat_desc=e}function k(t){return t<256?b[t]:b[256+(t>>>7)]}function j(t,e){t.pending_buf[t.pending++]=255&e,t.pending_buf[t.pending++]=e>>>8&255}function S(t,e,r){t.bi_valid>16-r?(t.bi_buf|=e<<t.bi_valid&65535,j(t,t.bi_buf),t.bi_buf=e>>16-t.bi_valid,t.bi_valid+=r-16):(t.bi_buf|=e<<t.bi_valid&65535,t.bi_valid+=r)}function A(t,e,r){S(t,r[2*e],r[2*e+1])}function T(t,e){var r=0;do{r|=1&t,t>>>=1,r<<=1}while(--e>0);return r>>>1}function I(t,e,r){var n,i,a=new Array(16),o=0;for(n=1;n<=l;n++)a[n]=o=o+r[n-1]<<1;for(i=0;i<=e;i++){var s=t[2*i+1];0!==s&&(t[2*i]=T(a[s]++,s))}}function P(t){var e;for(e=0;e<o;e++)t.dyn_ltree[2*e]=0;for(e=0;e<s;e++)t.dyn_dtree[2*e]=0;for(e=0;e<19;e++)t.bl_tree[2*e]=0;t.dyn_ltree[512]=1,t.opt_len=t.static_len=0,t.last_lit=t.matches=0}function M(t){t.bi_valid>8?j(t,t.bi_buf):t.bi_valid>0&&(t.pending_buf[t.pending++]=t.bi_buf),t.bi_buf=0,t.bi_valid=0}function O(t,e,r,n){var i=2*e,a=2*r;return t[i]<t[a]||t[i]===t[a]&&n[e]<=n[r]}function R(t,e,r){for(var n=t.heap[r],i=r<<1;i<=t.heap_len&&(i<t.heap_len&&O(e,t.heap[i+1],t.heap[i],t.depth)&&i++,!O(e,n,t.heap[i],t.depth));)t.heap[r]=t.heap[i],r=i,i<<=1;t.heap[r]=n}function L(t,e,r){var n,i,o,s,l=0;if(0!==t.last_lit)do{n=t.pending_buf[t.d_buf+2*l]<<8|t.pending_buf[t.d_buf+2*l+1],i=t.pending_buf[t.l_buf+l],l++,0===n?A(t,i,e):(A(t,(o=m[i])+a+1,e),0!==(s=u[o])&&S(t,i-=g[o],s),A(t,o=k(--n),r),0!==(s=f[o])&&S(t,n-=w[o],s))}while(l<t.last_lit);A(t,256,e)}function C(t,e){var r,n,i,a=e.dyn_tree,o=e.stat_desc.static_tree,s=e.stat_desc.has_stree,u=e.stat_desc.elems,f=-1;for(t.heap_len=0,t.heap_max=573,r=0;r<u;r++)0!==a[2*r]?(t.heap[++t.heap_len]=f=r,t.depth[r]=0):a[2*r+1]=0;for(;t.heap_len<2;)a[2*(i=t.heap[++t.heap_len]=f<2?++f:0)]=1,t.depth[i]=0,t.opt_len--,s&&(t.static_len-=o[2*i+1]);for(e.max_code=f,r=t.heap_len>>1;r>=1;r--)R(t,a,r);i=u;do{r=t.heap[1],t.heap[1]=t.heap[t.heap_len--],R(t,a,1),n=t.heap[1],t.heap[--t.heap_max]=r,t.heap[--t.heap_max]=n,a[2*i]=a[2*r]+a[2*n],t.depth[i]=(t.depth[r]>=t.depth[n]?t.depth[r]:t.depth[n])+1,a[2*r+1]=a[2*n+1]=i,t.heap[1]=i++,R(t,a,1)}while(t.heap_len>=2);t.heap[--t.heap_max]=t.heap[1],function(t,e){var r,n,i,a,o,s,u=e.dyn_tree,f=e.max_code,h=e.stat_desc.static_tree,c=e.stat_desc.has_stree,d=e.stat_desc.extra_bits,p=e.stat_desc.extra_base,b=e.stat_desc.max_length,m=0;for(a=0;a<=l;a++)t.bl_count[a]=0;for(u[2*t.heap[t.heap_max]+1]=0,r=t.heap_max+1;r<573;r++)(a=u[2*u[2*(n=t.heap[r])+1]+1]+1)>b&&(a=b,m++),u[2*n+1]=a,n>f||(t.bl_count[a]++,o=0,n>=p&&(o=d[n-p]),s=u[2*n],t.opt_len+=s*(a+o),c&&(t.static_len+=s*(h[2*n+1]+o)));if(0!==m){do{for(a=b-1;0===t.bl_count[a];)a--;t.bl_count[a]--,t.bl_count[a+1]+=2,t.bl_count[b]--,m-=2}while(m>0);for(a=b;0!==a;a--)for(n=t.bl_count[a];0!==n;)(i=t.heap[--r])>f||(u[2*i+1]!==a&&(t.opt_len+=(a-u[2*i+1])*u[2*i],u[2*i+1]=a),n--)}}(t,e),I(a,f,t.bl_count)}function B(t,e,r){var n,i,a=-1,o=e[1],s=0,l=7,u=4;for(0===o&&(l=138,u=3),e[2*(r+1)+1]=65535,n=0;n<=r;n++)i=o,o=e[2*(n+1)+1],++s<l&&i===o||(s<u?t.bl_tree[2*i]+=s:0!==i?(i!==a&&t.bl_tree[2*i]++,t.bl_tree[32]++):s<=10?t.bl_tree[34]++:t.bl_tree[36]++,s=0,a=i,0===o?(l=138,u=3):i===o?(l=6,u=3):(l=7,u=4))}function D(t,e,r){var n,i,a=-1,o=e[1],s=0,l=7,u=4;for(0===o&&(l=138,u=3),n=0;n<=r;n++)if(i=o,o=e[2*(n+1)+1],!(++s<l&&i===o)){if(s<u)do{A(t,i,t.bl_tree)}while(0!==--s);else 0!==i?(i!==a&&(A(t,i,t.bl_tree),s--),A(t,16,t.bl_tree),S(t,s-3,2)):s<=10?(A(t,17,t.bl_tree),S(t,s-3,3)):(A(t,18,t.bl_tree),S(t,s-11,7));s=0,a=i,0===o?(l=138,u=3):i===o?(l=6,u=3):(l=7,u=4)}}i(w);var N=!1;function U(t,e,r,i){S(t,0+(i?1:0),3),function(t,e,r,i){M(t),i&&(j(t,r),j(t,~r)),n.arraySet(t.pending_buf,t.window,e,r,t.pending),t.pending+=r}(t,e,r,!0)}r._tr_init=function(t){N||(function(){var t,e,r,n,i,a=new Array(16);for(r=0,n=0;n<28;n++)for(g[n]=r,t=0;t<1<<u[n];t++)m[r++]=n;for(m[r-1]=n,i=0,n=0;n<16;n++)for(w[n]=i,t=0;t<1<<f[n];t++)b[i++]=n;for(i>>=7;n<s;n++)for(w[n]=i<<7,t=0;t<1<<f[n]-7;t++)b[256+i++]=n;for(e=0;e<=l;e++)a[e]=0;for(t=0;t<=143;)d[2*t+1]=8,t++,a[8]++;for(;t<=255;)d[2*t+1]=9,t++,a[9]++;for(;t<=279;)d[2*t+1]=7,t++,a[7]++;for(;t<=287;)d[2*t+1]=8,t++,a[8]++;for(I(d,287,a),t=0;t<s;t++)p[2*t+1]=5,p[2*t]=T(t,5);y=new x(d,u,257,o,l),v=new x(p,f,0,s,l),_=new x(new Array(0),h,0,19,7)}(),N=!0),t.l_desc=new E(t.dyn_ltree,y),t.d_desc=new E(t.dyn_dtree,v),t.bl_desc=new E(t.bl_tree,_),t.bi_buf=0,t.bi_valid=0,P(t)},r._tr_stored_block=U,r._tr_flush_block=function(t,e,r,n){var i,o,s=0;t.level>0?(2===t.strm.data_type&&(t.strm.data_type=function(t){var e,r=4093624447;for(e=0;e<=31;e++,r>>>=1)if(1&r&&0!==t.dyn_ltree[2*e])return 0;if(0!==t.dyn_ltree[18]||0!==t.dyn_ltree[20]||0!==t.dyn_ltree[26])return 1;for(e=32;e<a;e++)if(0!==t.dyn_ltree[2*e])return 1;return 0}(t)),C(t,t.l_desc),C(t,t.d_desc),s=function(t){var e;for(B(t,t.dyn_ltree,t.l_desc.max_code),B(t,t.dyn_dtree,t.d_desc.max_code),C(t,t.bl_desc),e=18;e>=3&&0===t.bl_tree[2*c[e]+1];e--);return t.opt_len+=3*(e+1)+5+5+4,e}(t),i=t.opt_len+3+7>>>3,(o=t.static_len+3+7>>>3)<=i&&(i=o)):i=o=r+5,r+4<=i&&-1!==e?U(t,e,r,n):4===t.strategy||o===i?(S(t,2+(n?1:0),3),L(t,d,p)):(S(t,4+(n?1:0),3),function(t,e,r,n){var i;for(S(t,e-257,5),S(t,r-1,5),S(t,n-4,4),i=0;i<n;i++)S(t,t.bl_tree[2*c[i]+1],3);D(t,t.dyn_ltree,e-1),D(t,t.dyn_dtree,r-1)}(t,t.l_desc.max_code+1,t.d_desc.max_code+1,s+1),L(t,t.dyn_ltree,t.dyn_dtree)),P(t),n&&M(t)},r._tr_tally=function(t,e,r){return t.pending_buf[t.d_buf+2*t.last_lit]=e>>>8&255,t.pending_buf[t.d_buf+2*t.last_lit+1]=255&e,t.pending_buf[t.l_buf+t.last_lit]=255&r,t.last_lit++,0===e?t.dyn_ltree[2*r]++:(t.matches++,e--,t.dyn_ltree[2*(m[r]+a+1)]++,t.dyn_dtree[2*k(e)]++),t.last_lit===t.lit_bufsize-1},r._tr_align=function(t){S(t,2,3),A(t,256,d),function(t){16===t.bi_valid?(j(t,t.bi_buf),t.bi_buf=0,t.bi_valid=0):t.bi_valid>=8&&(t.pending_buf[t.pending++]=255&t.bi_buf,t.bi_buf>>=8,t.bi_valid-=8)}(t)}},{"../utils/common":268}],280:[function(t,e,r){arguments[4][45][0].apply(r,arguments)},{dup:45}],281:[function(t,e,r){function n(t,e){if(!(t=t.replace(/\t+/g," ").trim()))return null;var r=t.indexOf(" ");if(-1===r)throw new Error("no named row at line "+e);var n=t.substring(0,r);t=(t=(t=(t=t.substring(r+1)).replace(/letter=[\'\"]\S+[\'\"]/gi,"")).split("=")).map((function(t){return t.trim().match(/(".*?"|[^"\s]+)+(?=\s*|\s*$)/g)}));for(var a=[],o=0;o<t.length;o++){var s=t[o];0===o?a.push({key:s[0],data:""}):o===t.length-1?a[a.length-1].data=i(s[0]):(a[a.length-1].data=i(s[0]),a.push({key:s[1],data:""}))}var l={key:n,data:{}};return a.forEach((function(t){l.data[t.key]=t.data})),l}function i(t){return t&&0!==t.length?0===t.indexOf('"')||0===t.indexOf("'")?t.substring(1,t.length-1):-1!==t.indexOf(",")?function(t){return t.split(",").map((function(t){return parseInt(t,10)}))}(t):parseInt(t,10):""}e.exports=function(t){if(!t)throw new Error("no data provided");var e={pages:[],chars:[],kernings:[]},r=(t=t.toString().trim()).split(/\r\n?|\n/g);if(0===r.length)throw new Error("no data in BMFont file");for(var i=0;i<r.length;i++){var a=n(r[i],i);if(a)if("page"===a.key){if("number"!=typeof a.data.id)throw new Error("malformed file at line "+i+" -- needs page id=N");if("string"!=typeof a.data.file)throw new Error("malformed file at line "+i+' -- needs page file="path"');e.pages[a.data.id]=a.data.file}else"chars"===a.key||"kernings"===a.key||("char"===a.key?e.chars.push(a.data):"kerning"===a.key?e.kernings.push(a.data):e[a.key]=a.data)}return e}},{}],282:[function(t,e,r){var n=[66,77,70];function i(t,e,r){if(r>e.length-1)return 0;var n=e.readUInt8(r++),i=e.readInt32LE(r);switch(r+=4,n){case 1:t.info=function(t,e){var r={};r.size=t.readInt16LE(e);var n=t.readUInt8(e+2);return r.smooth=n>>7&1,r.unicode=n>>6&1,r.italic=n>>5&1,r.bold=n>>4&1,n>>3&1&&(r.fixedHeight=1),r.charset=t.readUInt8(e+3)||"",r.stretchH=t.readUInt16LE(e+4),r.aa=t.readUInt8(e+6),r.padding=[t.readInt8(e+7),t.readInt8(e+8),t.readInt8(e+9),t.readInt8(e+10)],r.spacing=[t.readInt8(e+11),t.readInt8(e+12)],r.outline=t.readUInt8(e+13),r.face=function(t,e){return a(t,e).toString("utf8")}(t,e+14),r}(e,r);break;case 2:t.common=function(t,e){var r={};return r.lineHeight=t.readUInt16LE(e),r.base=t.readUInt16LE(e+2),r.scaleW=t.readUInt16LE(e+4),r.scaleH=t.readUInt16LE(e+6),r.pages=t.readUInt16LE(e+8),t.readUInt8(e+10),r.packed=0,r.alphaChnl=t.readUInt8(e+11),r.redChnl=t.readUInt8(e+12),r.greenChnl=t.readUInt8(e+13),r.blueChnl=t.readUInt8(e+14),r}(e,r);break;case 3:t.pages=function(t,e,r){for(var n=[],i=a(t,e),o=i.length+1,s=r/o,l=0;l<s;l++)n[l]=t.slice(e,e+i.length).toString("utf8"),e+=o;return n}(e,r,i);break;case 4:t.chars=function(t,e,r){for(var n=[],i=r/20,a=0;a<i;a++){var o={},s=20*a;o.id=t.readUInt32LE(e+0+s),o.x=t.readUInt16LE(e+4+s),o.y=t.readUInt16LE(e+6+s),o.width=t.readUInt16LE(e+8+s),o.height=t.readUInt16LE(e+10+s),o.xoffset=t.readInt16LE(e+12+s),o.yoffset=t.readInt16LE(e+14+s),o.xadvance=t.readInt16LE(e+16+s),o.page=t.readUInt8(e+18+s),o.chnl=t.readUInt8(e+19+s),n[a]=o}return n}(e,r,i);break;case 5:t.kernings=function(t,e,r){for(var n=[],i=r/10,a=0;a<i;a++){var o={},s=10*a;o.first=t.readUInt32LE(e+0+s),o.second=t.readUInt32LE(e+4+s),o.amount=t.readInt16LE(e+8+s),n[a]=o}return n}(e,r,i)}return 5+i}function a(t,e){for(var r=e;r<t.length&&0!==t[r];r++);return t.slice(e,r)}e.exports=function(t){if(t.length<6)throw new Error("invalid buffer length for BMFont");var e=n.every((function(e,r){return t.readUInt8(r)===e}));if(!e)throw new Error("BMFont missing BMF byte header");var r=3;if(t.readUInt8(r++)>3)throw new Error("Only supports BMFont Binary v3 (BMFont App v1.10)");for(var a={kernings:[],chars:[]},o=0;o<5;o++)r+=i(a,t,r);return a}},{}],283:[function(t,e,r){var n=t("./parse-attribs"),i=t("xml-parse-from-string"),a={scaleh:"scaleH",scalew:"scaleW",stretchh:"stretchH",lineheight:"lineHeight",alphachnl:"alphaChnl",redchnl:"redChnl",greenchnl:"greenChnl",bluechnl:"blueChnl"};function o(t){return function(t){for(var e=[],r=0;r<t.attributes.length;r++)e.push(t.attributes[r]);return e}(t).reduce((function(t,e){return t[(r=e.nodeName,a[r.toLowerCase()]||r)]=e.nodeValue,t;var r}),{})}e.exports=function(t){t=t.toString();var e=i(t),r={pages:[],chars:[],kernings:[]};["info","common"].forEach((function(t){var i=e.getElementsByTagName(t)[0];i&&(r[t]=n(o(i)))}));var a=e.getElementsByTagName("pages")[0];if(!a)throw new Error("malformed file -- no <pages> element");for(var s=a.getElementsByTagName("page"),l=0;l<s.length;l++){var u=s[l],f=parseInt(u.getAttribute("id"),10),h=u.getAttribute("file");if(isNaN(f))throw new Error('malformed file -- page "id" attribute is NaN');if(!h)throw new Error('malformed file -- needs page "file" attribute');r.pages[parseInt(f,10)]=h}return["chars","kernings"].forEach((function(t){var i=e.getElementsByTagName(t)[0];if(i)for(var a=t.substring(0,t.length-1),s=i.getElementsByTagName(a),l=0;l<s.length;l++){var u=s[l];r[t].push(n(o(u)))}})),r}},{"./parse-attribs":284,"xml-parse-from-string":367}],284:[function(t,e,r){var n="chasrset";e.exports=function(t){for(var e in n in t&&(t.charset=t[n],delete t[n]),t)"face"!==e&&"charset"!==e&&(t[e]="padding"===e||"spacing"===e?t[e].split(",").map((function(t){return parseInt(t,10)})):parseInt(t[e],10));return t}},{}],285:[function(t,e,r){var n=t("trim"),i=t("for-each");e.exports=function(t){if(!t)return{};var e={};return i(n(t).split("\n"),(function(t){var r,i=t.indexOf(":"),a=n(t.slice(0,i)).toLowerCase(),o=n(t.slice(i+1));void 0===e[a]?e[a]=o:(r=e[a],"[object Array]"===Object.prototype.toString.call(r)?e[a].push(o):e[a]=[e[a],o])})),e}},{"for-each":250,trim:358}],286:[function(t,e,r){(function(t){function e(t,e){for(var r=0,n=t.length-1;n>=0;n--){var i=t[n];"."===i?t.splice(n,1):".."===i?(t.splice(n,1),r++):r&&(t.splice(n,1),r--)}if(e)for(;r--;r)t.unshift("..");return t}function n(t,e){if(t.filter)return t.filter(e);for(var r=[],n=0;n<t.length;n++)e(t[n],n,t)&&r.push(t[n]);return r}r.resolve=function(){for(var r="",i=!1,a=arguments.length-1;a>=-1&&!i;a--){var o=a>=0?arguments[a]:t.cwd();if("string"!=typeof o)throw new TypeError("Arguments to path.resolve must be strings");o&&(r=o+"/"+r,i="/"===o.charAt(0))}return(i?"/":"")+(r=e(n(r.split("/"),(function(t){return!!t})),!i).join("/"))||"."},r.normalize=function(t){var a=r.isAbsolute(t),o="/"===i(t,-1);return(t=e(n(t.split("/"),(function(t){return!!t})),!a).join("/"))||a||(t="."),t&&o&&(t+="/"),(a?"/":"")+t},r.isAbsolute=function(t){return"/"===t.charAt(0)},r.join=function(){var t=Array.prototype.slice.call(arguments,0);return r.normalize(n(t,(function(t,e){if("string"!=typeof t)throw new TypeError("Arguments to path.join must be strings");return t})).join("/"))},r.relative=function(t,e){function n(t){for(var e=0;e<t.length&&""===t[e];e++);for(var r=t.length-1;r>=0&&""===t[r];r--);return e>r?[]:t.slice(e,r-e+1)}t=r.resolve(t).substr(1),e=r.resolve(e).substr(1);for(var i=n(t.split("/")),a=n(e.split("/")),o=Math.min(i.length,a.length),s=o,l=0;l<o;l++)if(i[l]!==a[l]){s=l;break}var u=[];for(l=s;l<i.length;l++)u.push("..");return(u=u.concat(a.slice(s))).join("/")},r.sep="/",r.delimiter=":",r.dirname=function(t){if("string"!=typeof t&&(t+=""),0===t.length)return".";for(var e=t.charCodeAt(0),r=47===e,n=-1,i=!0,a=t.length-1;a>=1;--a)if(47===(e=t.charCodeAt(a))){if(!i){n=a;break}}else i=!1;return-1===n?r?"/":".":r&&1===n?"/":t.slice(0,n)},r.basename=function(t,e){var r=function(t){"string"!=typeof t&&(t+="");var e,r=0,n=-1,i=!0;for(e=t.length-1;e>=0;--e)if(47===t.charCodeAt(e)){if(!i){r=e+1;break}}else-1===n&&(i=!1,n=e+1);return-1===n?"":t.slice(r,n)}(t);return e&&r.substr(-1*e.length)===e&&(r=r.substr(0,r.length-e.length)),r},r.extname=function(t){"string"!=typeof t&&(t+="");for(var e=-1,r=0,n=-1,i=!0,a=0,o=t.length-1;o>=0;--o){var s=t.charCodeAt(o);if(47!==s)-1===n&&(i=!1,n=o+1),46===s?-1===e?e=o:1!==a&&(a=1):-1!==e&&(a=-1);else if(!i){r=o+1;break}}return-1===e||-1===n||0===a||1===a&&e===n-1&&e===r+1?"":t.slice(e,n)};var i=function(t,e,r){return t.substr(e,r)}}).call(this,t("_process"))},{_process:312}],287:[function(t,e,r){(function(r){"use strict";var n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},i=t("http"),a=t("https"),o=t("url"),s=t("querystring"),l=t("zlib"),u=t("util"),f=function(t,e){if("string"!=typeof t&&!t.hasOwnProperty("url"))throw new Error("Missing url option from options for request method.");var u="object"===(void 0===t?"undefined":n(t))?o.parse(t.url):o.parse(t),f={hostname:u.hostname,port:u.port||("http:"===u.protocol.toLowerCase()?80:443),path:u.path,method:"GET",headers:{},auth:u.auth||null,parse:"none",stream:!1};if("object"===(void 0===t?"undefined":n(t))&&(f=Object.assign(f,t)),f.port=Number(f.port),f.hasOwnProperty("timeout")&&delete f.timeout,!0===f.compressed&&(f.headers["accept-encoding"]="gzip, deflate"),t.hasOwnProperty("form")){if("object"!==n(t.form))throw new Error("phin 'form' option must be of type Object if present.");var h=s.stringify(t.form);f.headers["Content-Type"]="application/x-www-form-urlencoded",f.headers["Content-Length"]=r.byteLength(h),t.data=h}var c=void 0,d=function(t){var n=t;!0===f.compressed&&("gzip"===t.headers["content-encoding"]?n=t.pipe(l.createGunzip()):"deflate"===t.headers["content-encoding"]&&(n=t.pipe(l.createInflate()))),!0===f.stream?(t.stream=n,e(null,t)):(t.body=new r([]),n.on("data",(function(e){t.body=r.concat([t.body,e])})),n.on("end",(function(){if(e){if("json"===f.parse)try{t.body=JSON.parse(t.body.toString())}catch(r){return void e("Invalid JSON received.",t)}e(null,t)}})))};switch(u.protocol.toLowerCase()){case"http:":c=i.request(f,d);break;case"https:":c=a.request(f,d);break;default:return void(e&&e(new Error("Invalid / unknown URL protocol. Expected HTTP or HTTPS."),null))}if("number"==typeof t.timeout&&c.setTimeout(t.timeout,(function(){c.abort(),e(new Error("Timeout has been reached."),null),e=null})),c.on("error",(function(t){e&&e(t,null)})),t.hasOwnProperty("data")){var p=t.data;if(!(t.data instanceof r)&&"object"===n(t.data))if("application/x-www-form-urlencoded"===(f.headers["content-type"]||f.headers["Content-Type"]))p=s.stringify(t.data);else try{p=JSON.stringify(t.data)}catch(t){e(new Error("Couldn't stringify object. (Likely due to a circular reference.)"),null)}c.write(p)}c.end()};f.promisified=function(t,e){return new Promise((function(e,r){f(t,(function(t,n){t?r(t):e(n)}))}))},u.promisify&&(f[u.promisify.custom]=f.promisified),e.exports=f}).call(this,t("buffer").Buffer)},{buffer:47,http:335,https:252,querystring:316,url:359,util:365,zlib:34}],288:[function(t,e,r){"use strict";function n(t,e,r,a,o,s){for(var l,u,f,h,c=Math.max(e-1,0),d=Math.max(r-1,0),p=Math.min(e+1,a-1),b=Math.min(r+1,o-1),m=4*(r*a+e),g=0,y=0,v=0,_=0,w=0,x=c;x<=p;x++)for(var E=d;E<=b;E++)if(x!==e||E!==r){var k=i(t,t,m,4*(E*a+x),!0);if(0===k?g++:k<0?v++:k>0&&y++,g>2)return!1;s&&(k<_&&(_=k,l=x,u=E),k>w&&(w=k,f=x,h=E))}return!s||0!==v&&0!==y&&(!n(t,l,u,a,o)&&!n(s,l,u,a,o)||!n(t,f,h,a,o)&&!n(s,f,h,a,o))}function i(t,e,r,n,i){var u=t[r+3]/255,f=e[n+3]/255,h=l(t[r+0],u),c=l(t[r+1],u),d=l(t[r+2],u),p=l(e[n+0],f),b=l(e[n+1],f),m=l(e[n+2],f),g=a(h,c,d)-a(p,b,m);if(i)return g;var y=o(h,c,d)-o(p,b,m),v=s(h,c,d)-s(p,b,m);return.5053*g*g+.299*y*y+.1957*v*v}function a(t,e,r){return.29889531*t+.58662247*e+.11448223*r}function o(t,e,r){return.59597799*t-.2741761*e-.32180189*r}function s(t,e,r){return.21147017*t-.52261711*e+.31114694*r}function l(t,e){return 255+(t-255)*e}function u(t,e,r,n,i){t[e+0]=r,t[e+1]=n,t[e+2]=i,t[e+3]=255}e.exports=function(t,e,r,o,s,f){f||(f={});for(var h=void 0===f.threshold?.1:f.threshold,c=35215*h*h,d=0,p=0;p<s;p++)for(var b=0;b<o;b++){var m=4*(p*o+b);if(i(t,e,m,m)>c)f.includeAA||!n(t,b,p,o,s,e)&&!n(e,b,p,o,s,t)?(r&&u(r,m,255,0,0),d++):r&&u(r,m,255,255,0);else if(r){var g=l((_=void 0,_=(y=t)[(v=m)+3]/255,a(l(y[v+0],_),l(y[v+1],_),l(y[v+2],_))),.1);u(r,m,g,g,g)}}var y,v,_;return d}},{}],289:[function(t,e,r){(function(e){"use strict";var n=t("./interlace"),i={1:{0:0,1:0,2:0,3:255},2:{0:0,1:0,2:0,3:1},3:{0:0,1:1,2:2,3:255},4:{0:0,1:1,2:2,3:3}};function a(t,e,r,n,a,o){for(var s=t.width,l=t.height,u=t.index,f=0;f<l;f++)for(var h=0;h<s;h++){for(var c=r(h,f,u),d=0;d<4;d++){var p=i[n][d];if(255===p)e[c+d]=255;else{var b=p+o;if(b===a.length)throw new Error("Ran out of data");e[c+d]=a[b]}}o+=n}return o}function o(t,e,r,n,a,o){for(var s=t.width,l=t.height,u=t.index,f=0;f<l;f++){for(var h=0;h<s;h++)for(var c=a.get(n),d=r(h,f,u),p=0;p<4;p++){var b=i[n][p];e[d+p]=255!==b?c[b]:o}a.resetAfterLine()}}r.dataToBitMap=function(t,r){var i,s=r.width,l=r.height,u=r.depth,f=r.bpp,h=r.interlace;if(8!==u)var c=function(t,e){var r=[],n=0;function i(){if(n===t.length)throw new Error("Ran out of data");var i,a,o,s,l,u,f,h,c=t[n];switch(n++,e){default:throw new Error("unrecognised depth");case 16:f=t[n],n++,r.push((c<<8)+f);break;case 4:f=15&c,h=c>>4,r.push(h,f);break;case 2:l=3&c,u=c>>2&3,f=c>>4&3,h=c>>6&3,r.push(h,f,u,l);break;case 1:i=1&c,a=c>>1&1,o=c>>2&1,s=c>>3&1,l=c>>4&1,u=c>>5&1,f=c>>6&1,h=c>>7&1,r.push(h,f,u,l,s,o,a,i)}}return{get:function(t){for(;r.length<t;)i();var e=r.slice(0,t);return r=r.slice(t),e},resetAfterLine:function(){r.length=0},end:function(){if(n!==t.length)throw new Error("extra data found")}}}(t,u);i=u<=8?new e(s*l*4):new Uint16Array(s*l*4);var d,p,b=Math.pow(2,u)-1,m=0;if(h)d=n.getImagePasses(s,l),p=n.getInterlaceIterator(s,l);else{var g=0;p=function(){var t=g;return g+=4,t},d=[{width:s,height:l}]}for(var y=0;y<d.length;y++)8===u?m=a(d[y],i,p,f,t,m):o(d[y],i,p,f,c,b);if(8===u){if(m!==t.length)throw new Error("extra data found")}else c.end();return i}}).call(this,t("buffer").Buffer)},{"./interlace":299,buffer:47}],290:[function(t,e,r){(function(r){"use strict";var n=t("./constants");e.exports=function(t,e,i,a){var o,s=-1!==[n.COLORTYPE_COLOR_ALPHA,n.COLORTYPE_ALPHA].indexOf(a.colorType);if(a.colorType===a.inputColorType){var l=(o=new ArrayBuffer(2),new DataView(o).setInt16(0,256,!0),256!==new Int16Array(o)[0]);if(8===a.bitDepth||16===a.bitDepth&&l)return t}var u=16!==a.bitDepth?t:new Uint16Array(t.buffer),f=255,h=n.COLORTYPE_TO_BPP_MAP[a.inputColorType];4!=h||a.inputHasAlpha||(h=3);var c=n.COLORTYPE_TO_BPP_MAP[a.colorType];16===a.bitDepth&&(f=65535,c*=2);var d=new r(e*i*c),p=0,b=0,m=a.bgColor||{};function g(t,e){var r,i,o,l=f;switch(a.inputColorType){case n.COLORTYPE_COLOR_ALPHA:l=t[e+3],r=t[e],i=t[e+1],o=t[e+2];break;case n.COLORTYPE_COLOR:r=t[e],i=t[e+1],o=t[e+2];break;case n.COLORTYPE_ALPHA:l=t[e+1],i=r=t[e],o=r;break;case n.COLORTYPE_GRAYSCALE:i=r=t[e],o=r;break;default:throw new Error("input color type:"+a.inputColorType+" is not supported at present")}return a.inputHasAlpha&&(s||(l/=f,r=Math.min(Math.max(Math.round((1-l)*m.red+l*r),0),f),i=Math.min(Math.max(Math.round((1-l)*m.green+l*i),0),f),o=Math.min(Math.max(Math.round((1-l)*m.blue+l*o),0),f))),{red:r,green:i,blue:o,alpha:l}}void 0===m.red&&(m.red=f),void 0===m.green&&(m.green=f),void 0===m.blue&&(m.blue=f);for(var y=0;y<i;y++)for(var v=0;v<e;v++){var _=g(u,p);switch(a.colorType){case n.COLORTYPE_COLOR_ALPHA:case n.COLORTYPE_COLOR:8===a.bitDepth?(d[b]=_.red,d[b+1]=_.green,d[b+2]=_.blue,s&&(d[b+3]=_.alpha)):(d.writeUInt16BE(_.red,b),d.writeUInt16BE(_.green,b+2),d.writeUInt16BE(_.blue,b+4),s&&d.writeUInt16BE(_.alpha,b+6));break;case n.COLORTYPE_ALPHA:case n.COLORTYPE_GRAYSCALE:var w=(_.red+_.green+_.blue)/3;8===a.bitDepth?(d[b]=w,s&&(d[b+1]=_.alpha)):(d.writeUInt16BE(w,b),s&&d.writeUInt16BE(_.alpha,b+2))}p+=h,b+=c}return d}}).call(this,t("buffer").Buffer)},{"./constants":292,buffer:47}],291:[function(t,e,r){(function(r,n){"use strict";var i=t("util"),a=t("stream"),o=e.exports=function(){a.call(this),this._buffers=[],this._buffered=0,this._reads=[],this._paused=!1,this._encoding="utf8",this.writable=!0};i.inherits(o,a),o.prototype.read=function(t,e){this._reads.push({length:Math.abs(t),allowLess:t<0,func:e}),r.nextTick(function(){this._process(),this._paused&&this._reads.length>0&&(this._paused=!1,this.emit("drain"))}.bind(this))},o.prototype.write=function(t,e){return this.writable?(r=n.isBuffer(t)?t:new n(t,e||this._encoding),this._buffers.push(r),this._buffered+=r.length,this._process(),this._reads&&0===this._reads.length&&(this._paused=!0),this.writable&&!this._paused):(this.emit("error",new Error("Stream not writable")),!1);var r},o.prototype.end=function(t,e){t&&this.write(t,e),this.writable=!1,this._buffers&&(0===this._buffers.length?this._end():(this._buffers.push(null),this._process()))},o.prototype.destroySoon=o.prototype.end,o.prototype._end=function(){this._reads.length>0&&this.emit("error",new Error("There are some read requests waiting on finished stream")),this.destroy()},o.prototype.destroy=function(){this._buffers&&(this.writable=!1,this._reads=null,this._buffers=null,this.emit("close"))},o.prototype._processReadAllowingLess=function(t){this._reads.shift();var e=this._buffers[0];e.length>t.length?(this._buffered-=t.length,this._buffers[0]=e.slice(t.length),t.func.call(this,e.slice(0,t.length))):(this._buffered-=e.length,this._buffers.shift(),t.func.call(this,e))},o.prototype._processRead=function(t){this._reads.shift();for(var e=0,r=0,i=new n(t.length);e<t.length;){var a=this._buffers[r++],o=Math.min(a.length,t.length-e);a.copy(i,e,0,o),e+=o,o!==a.length&&(this._buffers[--r]=a.slice(o))}r>0&&this._buffers.splice(0,r),this._buffered-=t.length,t.func.call(this,i)},o.prototype._process=function(){try{for(;this._buffered>0&&this._reads&&this._reads.length>0;){var t=this._reads[0];if(t.allowLess)this._processReadAllowingLess(t);else{if(!(this._buffered>=t.length))break;this._processRead(t)}}this._buffers&&this._buffers.length>0&&null===this._buffers[0]&&this._end()}catch(t){this.emit("error",t)}}}).call(this,t("_process"),t("buffer").Buffer)},{_process:312,buffer:47,stream:334,util:365}],292:[function(t,e,r){"use strict";e.exports={PNG_SIGNATURE:[137,80,78,71,13,10,26,10],TYPE_IHDR:1229472850,TYPE_IEND:1229278788,TYPE_IDAT:1229209940,TYPE_PLTE:1347179589,TYPE_tRNS:1951551059,TYPE_gAMA:1732332865,COLORTYPE_GRAYSCALE:0,COLORTYPE_PALETTE:1,COLORTYPE_COLOR:2,COLORTYPE_ALPHA:4,COLORTYPE_PALETTE_COLOR:3,COLORTYPE_COLOR_ALPHA:6,COLORTYPE_TO_BPP_MAP:{0:1,2:3,3:1,4:2,6:4},GAMMA_DIVISION:1e5}},{}],293:[function(t,e,r){"use strict";var n=[];!function(){for(var t=0;t<256;t++){for(var e=t,r=0;r<8;r++)1&e?e=3988292384^e>>>1:e>>>=1;n[t]=e}}();var i=e.exports=function(){this._crc=-1};i.prototype.write=function(t){for(var e=0;e<t.length;e++)this._crc=n[255&(this._crc^t[e])]^this._crc>>>8;return!0},i.prototype.crc32=function(){return-1^this._crc},i.crc32=function(t){for(var e=-1,r=0;r<t.length;r++)e=n[255&(e^t[r])]^e>>>8;return-1^e}},{}],294:[function(t,e,r){(function(r){"use strict";var n=t("./paeth-predictor"),i={0:function(t,e,r,n,i){for(var a=0;a<r;a++)n[i+a]=t[e+a]},1:function(t,e,r,n,i,a){for(var o=0;o<r;o++){var s=o>=a?t[e+o-a]:0,l=t[e+o]-s;n[i+o]=l}},2:function(t,e,r,n,i){for(var a=0;a<r;a++){var o=e>0?t[e+a-r]:0,s=t[e+a]-o;n[i+a]=s}},3:function(t,e,r,n,i,a){for(var o=0;o<r;o++){var s=o>=a?t[e+o-a]:0,l=e>0?t[e+o-r]:0,u=t[e+o]-(s+l>>1);n[i+o]=u}},4:function(t,e,r,i,a,o){for(var s=0;s<r;s++){var l=s>=o?t[e+s-o]:0,u=e>0?t[e+s-r]:0,f=e>0&&s>=o?t[e+s-(r+o)]:0,h=t[e+s]-n(l,u,f);i[a+s]=h}}},a={0:function(t,e,r){for(var n=0,i=e+r,a=e;a<i;a++)n+=Math.abs(t[a]);return n},1:function(t,e,r,n){for(var i=0,a=0;a<r;a++){var o=a>=n?t[e+a-n]:0,s=t[e+a]-o;i+=Math.abs(s)}return i},2:function(t,e,r){for(var n=0,i=e+r,a=e;a<i;a++){var o=e>0?t[a-r]:0,s=t[a]-o;n+=Math.abs(s)}return n},3:function(t,e,r,n){for(var i=0,a=0;a<r;a++){var o=a>=n?t[e+a-n]:0,s=e>0?t[e+a-r]:0,l=t[e+a]-(o+s>>1);i+=Math.abs(l)}return i},4:function(t,e,r,i){for(var a=0,o=0;o<r;o++){var s=o>=i?t[e+o-i]:0,l=e>0?t[e+o-r]:0,u=e>0&&o>=i?t[e+o-(r+i)]:0,f=t[e+o]-n(s,l,u);a+=Math.abs(f)}return a}};e.exports=function(t,e,n,o,s){var l;if("filterType"in o&&-1!==o.filterType){if("number"!=typeof o.filterType)throw new Error("unrecognised filter types");l=[o.filterType]}else l=[0,1,2,3,4];16===o.bitDepth&&(s*=2);for(var u=e*s,f=0,h=0,c=new r((u+1)*n),d=l[0],p=0;p<n;p++){if(l.length>1)for(var b=1/0,m=0;m<l.length;m++){var g=a[l[m]](t,h,u,s);g<b&&(d=l[m],b=g)}c[f]=d,f++,i[d](t,h,u,c,f,s),f+=u,h+=u}return c}}).call(this,t("buffer").Buffer)},{"./paeth-predictor":303,buffer:47}],295:[function(t,e,r){(function(r){"use strict";var n=t("util"),i=t("./chunkstream"),a=t("./filter-parse"),o=e.exports=function(t){i.call(this);var e=[],n=this;this._filter=new a(t,{read:this.read.bind(this),write:function(t){e.push(t)},complete:function(){n.emit("complete",r.concat(e))}}),this._filter.start()};n.inherits(o,i)}).call(this,t("buffer").Buffer)},{"./chunkstream":291,"./filter-parse":297,buffer:47,util:365}],296:[function(t,e,r){(function(e){"use strict";var n=t("./sync-reader"),i=t("./filter-parse");r.process=function(t,r){var a=[],o=new n(t);return new i(r,{read:o.read.bind(o),write:function(t){a.push(t)},complete:function(){}}).start(),o.process(),e.concat(a)}}).call(this,t("buffer").Buffer)},{"./filter-parse":297,"./sync-reader":310,buffer:47}],297:[function(t,e,r){(function(r){"use strict";var n=t("./interlace"),i=t("./paeth-predictor");function a(t,e,r){var n=t*e;return 8!==r&&(n=Math.ceil(n/(8/r))),n}var o=e.exports=function(t,e){var r=t.width,i=t.height,o=t.interlace,s=t.bpp,l=t.depth;if(this.read=e.read,this.write=e.write,this.complete=e.complete,this._imageIndex=0,this._images=[],o)for(var u=n.getImagePasses(r,i),f=0;f<u.length;f++)this._images.push({byteWidth:a(u[f].width,s,l),height:u[f].height,lineIndex:0});else this._images.push({byteWidth:a(r,s,l),height:i,lineIndex:0});this._xComparison=8===l?s:16===l?2*s:1};o.prototype.start=function(){this.read(this._images[this._imageIndex].byteWidth+1,this._reverseFilterLine.bind(this))},o.prototype._unFilterType1=function(t,e,r){for(var n=this._xComparison,i=n-1,a=0;a<r;a++){var o=t[1+a],s=a>i?e[a-n]:0;e[a]=o+s}},o.prototype._unFilterType2=function(t,e,r){for(var n=this._lastLine,i=0;i<r;i++){var a=t[1+i],o=n?n[i]:0;e[i]=a+o}},o.prototype._unFilterType3=function(t,e,r){for(var n=this._xComparison,i=n-1,a=this._lastLine,o=0;o<r;o++){var s=t[1+o],l=a?a[o]:0,u=o>i?e[o-n]:0,f=Math.floor((u+l)/2);e[o]=s+f}},o.prototype._unFilterType4=function(t,e,r){for(var n=this._xComparison,a=n-1,o=this._lastLine,s=0;s<r;s++){var l=t[1+s],u=o?o[s]:0,f=s>a?e[s-n]:0,h=s>a&&o?o[s-n]:0,c=i(f,u,h);e[s]=l+c}},o.prototype._reverseFilterLine=function(t){var e,n=t[0],i=this._images[this._imageIndex],a=i.byteWidth;if(0===n)e=t.slice(1,a+1);else switch(e=new r(a),n){case 1:this._unFilterType1(t,e,a);break;case 2:this._unFilterType2(t,e,a);break;case 3:this._unFilterType3(t,e,a);break;case 4:this._unFilterType4(t,e,a);break;default:throw new Error("Unrecognised filter type - "+n)}this.write(e),i.lineIndex++,i.lineIndex>=i.height?(this._lastLine=null,this._imageIndex++,i=this._images[this._imageIndex]):this._lastLine=e,i?this.read(i.byteWidth+1,this._reverseFilterLine.bind(this)):(this._lastLine=null,this.complete())}}).call(this,t("buffer").Buffer)},{"./interlace":299,"./paeth-predictor":303,buffer:47}],298:[function(t,e,r){(function(t){"use strict";e.exports=function(e,r){var n=r.depth,i=r.width,a=r.height,o=r.colorType,s=r.transColor,l=r.palette,u=e;return 3===o?function(t,e,r,n,i){for(var a=0,o=0;o<n;o++)for(var s=0;s<r;s++){var l=i[t[a]];if(!l)throw new Error("index "+t[a]+" not in palette");for(var u=0;u<4;u++)e[a+u]=l[u];a+=4}}(e,u,i,a,l):(s&&function(t,e,r,n,i){for(var a=0,o=0;o<n;o++)for(var s=0;s<r;s++){var l=!1;if(1===i.length?i[0]===t[a]&&(l=!0):i[0]===t[a]&&i[1]===t[a+1]&&i[2]===t[a+2]&&(l=!0),l)for(var u=0;u<4;u++)e[a+u]=0;a+=4}}(e,u,i,a,s),8!==n&&(16===n&&(u=new t(i*a*4)),function(t,e,r,n,i){for(var a=Math.pow(2,i)-1,o=0,s=0;s<n;s++)for(var l=0;l<r;l++){for(var u=0;u<4;u++)e[o+u]=Math.floor(255*t[o+u]/a+.5);o+=4}}(e,u,i,a,n))),u}}).call(this,t("buffer").Buffer)},{buffer:47}],299:[function(t,e,r){"use strict";var n=[{x:[0],y:[0]},{x:[4],y:[0]},{x:[0,4],y:[4]},{x:[2,6],y:[0,4]},{x:[0,2,4,6],y:[2,6]},{x:[1,3,5,7],y:[0,2,4,6]},{x:[0,1,2,3,4,5,6,7],y:[1,3,5,7]}];r.getImagePasses=function(t,e){for(var r=[],i=t%8,a=e%8,o=(t-i)/8,s=(e-a)/8,l=0;l<n.length;l++){for(var u=n[l],f=o*u.x.length,h=s*u.y.length,c=0;c<u.x.length&&u.x[c]<i;c++)f++;for(c=0;c<u.y.length&&u.y[c]<a;c++)h++;f>0&&h>0&&r.push({width:f,height:h,index:l})}return r},r.getInterlaceIterator=function(t){return function(e,r,i){var a=e%n[i].x.length,o=(e-a)/n[i].x.length*8+n[i].x[a],s=r%n[i].y.length;return 4*o+((r-s)/n[i].y.length*8+n[i].y[s])*t*4}}},{}],300:[function(t,e,r){(function(r){"use strict";var n=t("util"),i=t("stream"),a=t("./constants"),o=t("./packer"),s=e.exports=function(t){i.call(this);var e=t||{};this._packer=new o(e),this._deflate=this._packer.createDeflate(),this.readable=!0};n.inherits(s,i),s.prototype.pack=function(t,e,n,i){this.emit("data",new r(a.PNG_SIGNATURE)),this.emit("data",this._packer.packIHDR(e,n)),i&&this.emit("data",this._packer.packGAMA(i));var o=this._packer.filterData(t,e,n);this._deflate.on("error",this.emit.bind(this,"error")),this._deflate.on("data",function(t){this.emit("data",this._packer.packIDAT(t))}.bind(this)),this._deflate.on("end",function(){this.emit("data",this._packer.packIEND()),this.emit("end")}.bind(this)),this._deflate.end(o)}}).call(this,t("buffer").Buffer)},{"./constants":292,"./packer":302,buffer:47,stream:334,util:365}],301:[function(t,e,r){(function(r){"use strict";var n=!0,i=t("zlib");i.deflateSync||(n=!1);var a=t("./constants"),o=t("./packer");e.exports=function(t,e){if(!n)throw new Error("To use the sync capability of this library in old node versions, please pin pngjs to v2.3.0");var s=new o(e||{}),l=[];l.push(new r(a.PNG_SIGNATURE)),l.push(s.packIHDR(t.width,t.height)),t.gamma&&l.push(s.packGAMA(t.gamma));var u=s.filterData(t.data,t.width,t.height),f=i.deflateSync(u,s.getDeflateOptions());if(u=null,!f||!f.length)throw new Error("bad png - invalid compressed data response");return l.push(s.packIDAT(f)),l.push(s.packIEND()),r.concat(l)}}).call(this,t("buffer").Buffer)},{"./constants":292,"./packer":302,buffer:47,zlib:34}],302:[function(t,e,r){(function(r){"use strict";var n=t("./constants"),i=t("./crc"),a=t("./bitpacker"),o=t("./filter-pack"),s=t("zlib"),l=e.exports=function(t){if(this._options=t,t.deflateChunkSize=t.deflateChunkSize||32768,t.deflateLevel=null!=t.deflateLevel?t.deflateLevel:9,t.deflateStrategy=null!=t.deflateStrategy?t.deflateStrategy:3,t.inputHasAlpha=null==t.inputHasAlpha||t.inputHasAlpha,t.deflateFactory=t.deflateFactory||s.createDeflate,t.bitDepth=t.bitDepth||8,t.colorType="number"==typeof t.colorType?t.colorType:n.COLORTYPE_COLOR_ALPHA,t.inputColorType="number"==typeof t.inputColorType?t.inputColorType:n.COLORTYPE_COLOR_ALPHA,-1===[n.COLORTYPE_GRAYSCALE,n.COLORTYPE_COLOR,n.COLORTYPE_COLOR_ALPHA,n.COLORTYPE_ALPHA].indexOf(t.colorType))throw new Error("option color type:"+t.colorType+" is not supported at present");if(-1===[n.COLORTYPE_GRAYSCALE,n.COLORTYPE_COLOR,n.COLORTYPE_COLOR_ALPHA,n.COLORTYPE_ALPHA].indexOf(t.inputColorType))throw new Error("option input color type:"+t.inputColorType+" is not supported at present");if(8!==t.bitDepth&&16!==t.bitDepth)throw new Error("option bit depth:"+t.bitDepth+" is not supported at present")};l.prototype.getDeflateOptions=function(){return{chunkSize:this._options.deflateChunkSize,level:this._options.deflateLevel,strategy:this._options.deflateStrategy}},l.prototype.createDeflate=function(){return this._options.deflateFactory(this.getDeflateOptions())},l.prototype.filterData=function(t,e,r){var i=a(t,e,r,this._options),s=n.COLORTYPE_TO_BPP_MAP[this._options.colorType];return o(i,e,r,this._options,s)},l.prototype._packChunk=function(t,e){var n=e?e.length:0,a=new r(n+12);return a.writeUInt32BE(n,0),a.writeUInt32BE(t,4),e&&e.copy(a,8),a.writeInt32BE(i.crc32(a.slice(4,a.length-4)),a.length-4),a},l.prototype.packGAMA=function(t){var e=new r(4);return e.writeUInt32BE(Math.floor(t*n.GAMMA_DIVISION),0),this._packChunk(n.TYPE_gAMA,e)},l.prototype.packIHDR=function(t,e){var i=new r(13);return i.writeUInt32BE(t,0),i.writeUInt32BE(e,4),i[8]=this._options.bitDepth,i[9]=this._options.colorType,i[10]=0,i[11]=0,i[12]=0,this._packChunk(n.TYPE_IHDR,i)},l.prototype.packIDAT=function(t){return this._packChunk(n.TYPE_IDAT,t)},l.prototype.packIEND=function(){return this._packChunk(n.TYPE_IEND,null)}}).call(this,t("buffer").Buffer)},{"./bitpacker":290,"./constants":292,"./crc":293,"./filter-pack":294,buffer:47,zlib:34}],303:[function(t,e,r){"use strict";e.exports=function(t,e,r){var n=t+e-r,i=Math.abs(n-t),a=Math.abs(n-e),o=Math.abs(n-r);return i<=a&&i<=o?t:a<=o?e:r}},{}],304:[function(t,e,r){"use strict";var n=t("util"),i=t("zlib"),a=t("./chunkstream"),o=t("./filter-parse-async"),s=t("./parser"),l=t("./bitmapper"),u=t("./format-normaliser"),f=e.exports=function(t){a.call(this),this._parser=new s(t,{read:this.read.bind(this),error:this._handleError.bind(this),metadata:this._handleMetaData.bind(this),gamma:this.emit.bind(this,"gamma"),palette:this._handlePalette.bind(this),transColor:this._handleTransColor.bind(this),finished:this._finished.bind(this),inflateData:this._inflateData.bind(this)}),this._options=t,this.writable=!0,this._parser.start()};n.inherits(f,a),f.prototype._handleError=function(t){this.emit("error",t),this.writable=!1,this.destroy(),this._inflate&&this._inflate.destroy&&this._inflate.destroy(),this._filter&&(this._filter.destroy(),this._filter.on("error",(function(){}))),this.errord=!0},f.prototype._inflateData=function(t){if(!this._inflate)if(this._bitmapInfo.interlace)this._inflate=i.createInflate(),this._inflate.on("error",this.emit.bind(this,"error")),this._filter.on("complete",this._complete.bind(this)),this._inflate.pipe(this._filter);else{var e=(1+(this._bitmapInfo.width*this._bitmapInfo.bpp*this._bitmapInfo.depth+7>>3))*this._bitmapInfo.height,r=Math.max(e,i.Z_MIN_CHUNK);this._inflate=i.createInflate({chunkSize:r});var n=e,a=this.emit.bind(this,"error");this._inflate.on("error",(function(t){n&&a(t)})),this._filter.on("complete",this._complete.bind(this));var o=this._filter.write.bind(this._filter);this._inflate.on("data",(function(t){n&&(t.length>n&&(t=t.slice(0,n)),n-=t.length,o(t))})),this._inflate.on("end",this._filter.end.bind(this._filter))}this._inflate.write(t)},f.prototype._handleMetaData=function(t){this.emit("metadata",t),this._bitmapInfo=Object.create(t),this._filter=new o(this._bitmapInfo)},f.prototype._handleTransColor=function(t){this._bitmapInfo.transColor=t},f.prototype._handlePalette=function(t){this._bitmapInfo.palette=t},f.prototype._finished=function(){this.errord||(this._inflate?this._inflate.end():this.emit("error","No Inflate block"),this.destroySoon())},f.prototype._complete=function(t){if(!this.errord){try{var e=l.dataToBitMap(t,this._bitmapInfo),r=u(e,this._bitmapInfo);e=null}catch(t){return void this._handleError(t)}this.emit("parsed",r)}}},{"./bitmapper":289,"./chunkstream":291,"./filter-parse-async":295,"./format-normaliser":298,"./parser":306,util:365,zlib:34}],305:[function(t,e,r){(function(r){"use strict";var n=!0,i=t("zlib"),a=t("./sync-inflate");i.deflateSync||(n=!1);var o=t("./sync-reader"),s=t("./filter-parse-sync"),l=t("./parser"),u=t("./bitmapper"),f=t("./format-normaliser");e.exports=function(t,e){if(!n)throw new Error("To use the sync capability of this library in old node versions, please pin pngjs to v2.3.0");var h,c,d,p=[],b=new o(t);if(new l(e,{read:b.read.bind(b),error:function(t){h=t},metadata:function(t){c=t},gamma:function(t){d=t},palette:function(t){c.palette=t},transColor:function(t){c.transColor=t},inflateData:function(t){p.push(t)}}).start(),b.process(),h)throw h;var m,g=r.concat(p);if(p.length=0,c.interlace)m=i.inflateSync(g);else{var y=(1+(c.width*c.bpp*c.depth+7>>3))*c.height;m=a(g,{chunkSize:y,maxLength:y})}if(g=null,!m||!m.length)throw new Error("bad png - invalid inflate data response");var v=s.process(m,c);g=null;var _=u.dataToBitMap(v,c);v=null;var w=f(_,c);return c.data=w,c.gamma=d||0,c}}).call(this,t("buffer").Buffer)},{"./bitmapper":289,"./filter-parse-sync":296,"./format-normaliser":298,"./parser":306,"./sync-inflate":309,"./sync-reader":310,buffer:47,zlib:34}],306:[function(t,e,r){(function(r){"use strict";var n=t("./constants"),i=t("./crc"),a=e.exports=function(t,e){this._options=t,t.checkCRC=!1!==t.checkCRC,this._hasIHDR=!1,this._hasIEND=!1,this._palette=[],this._colorType=0,this._chunks={},this._chunks[n.TYPE_IHDR]=this._handleIHDR.bind(this),this._chunks[n.TYPE_IEND]=this._handleIEND.bind(this),this._chunks[n.TYPE_IDAT]=this._handleIDAT.bind(this),this._chunks[n.TYPE_PLTE]=this._handlePLTE.bind(this),this._chunks[n.TYPE_tRNS]=this._handleTRNS.bind(this),this._chunks[n.TYPE_gAMA]=this._handleGAMA.bind(this),this.read=e.read,this.error=e.error,this.metadata=e.metadata,this.gamma=e.gamma,this.transColor=e.transColor,this.palette=e.palette,this.parsed=e.parsed,this.inflateData=e.inflateData,this.finished=e.finished};a.prototype.start=function(){this.read(n.PNG_SIGNATURE.length,this._parseSignature.bind(this))},a.prototype._parseSignature=function(t){for(var e=n.PNG_SIGNATURE,r=0;r<e.length;r++)if(t[r]!==e[r])return void this.error(new Error("Invalid file signature"));this.read(8,this._parseChunkBegin.bind(this))},a.prototype._parseChunkBegin=function(t){for(var e=t.readUInt32BE(0),a=t.readUInt32BE(4),o="",s=4;s<8;s++)o+=String.fromCharCode(t[s]);var l=Boolean(32&t[4]);if(this._hasIHDR||a===n.TYPE_IHDR){if(this._crc=new i,this._crc.write(new r(o)),this._chunks[a])return this._chunks[a](e);l?this.read(e+4,this._skipChunk.bind(this)):this.error(new Error("Unsupported critical chunk type "+o))}else this.error(new Error("Expected IHDR on beggining"))},a.prototype._skipChunk=function(){this.read(8,this._parseChunkBegin.bind(this))},a.prototype._handleChunkEnd=function(){this.read(4,this._parseChunkEnd.bind(this))},a.prototype._parseChunkEnd=function(t){var e=t.readInt32BE(0),r=this._crc.crc32();this._options.checkCRC&&r!==e?this.error(new Error("Crc error - "+e+" - "+r)):this._hasIEND||this.read(8,this._parseChunkBegin.bind(this))},a.prototype._handleIHDR=function(t){this.read(t,this._parseIHDR.bind(this))},a.prototype._parseIHDR=function(t){this._crc.write(t);var e=t.readUInt32BE(0),r=t.readUInt32BE(4),i=t[8],a=t[9],o=t[10],s=t[11],l=t[12];if(8===i||4===i||2===i||1===i||16===i)if(a in n.COLORTYPE_TO_BPP_MAP)if(0===o)if(0===s)if(0===l||1===l){this._colorType=a;var u=n.COLORTYPE_TO_BPP_MAP[this._colorType];this._hasIHDR=!0,this.metadata({width:e,height:r,depth:i,interlace:Boolean(l),palette:Boolean(a&n.COLORTYPE_PALETTE),color:Boolean(a&n.COLORTYPE_COLOR),alpha:Boolean(a&n.COLORTYPE_ALPHA),bpp:u,colorType:a}),this._handleChunkEnd()}else this.error(new Error("Unsupported interlace method"));else this.error(new Error("Unsupported filter method"));else this.error(new Error("Unsupported compression method"));else this.error(new Error("Unsupported color type"));else this.error(new Error("Unsupported bit depth "+i))},a.prototype._handlePLTE=function(t){this.read(t,this._parsePLTE.bind(this))},a.prototype._parsePLTE=function(t){this._crc.write(t);for(var e=Math.floor(t.length/3),r=0;r<e;r++)this._palette.push([t[3*r],t[3*r+1],t[3*r+2],255]);this.palette(this._palette),this._handleChunkEnd()},a.prototype._handleTRNS=function(t){this.read(t,this._parseTRNS.bind(this))},a.prototype._parseTRNS=function(t){if(this._crc.write(t),this._colorType===n.COLORTYPE_PALETTE_COLOR){if(0===this._palette.length)return void this.error(new Error("Transparency chunk must be after palette"));if(t.length>this._palette.length)return void this.error(new Error("More transparent colors than palette size"));for(var e=0;e<t.length;e++)this._palette[e][3]=t[e];this.palette(this._palette)}this._colorType===n.COLORTYPE_GRAYSCALE&&this.transColor([t.readUInt16BE(0)]),this._colorType===n.COLORTYPE_COLOR&&this.transColor([t.readUInt16BE(0),t.readUInt16BE(2),t.readUInt16BE(4)]),this._handleChunkEnd()},a.prototype._handleGAMA=function(t){this.read(t,this._parseGAMA.bind(this))},a.prototype._parseGAMA=function(t){this._crc.write(t),this.gamma(t.readUInt32BE(0)/n.GAMMA_DIVISION),this._handleChunkEnd()},a.prototype._handleIDAT=function(t){this.read(-t,this._parseIDAT.bind(this,t))},a.prototype._parseIDAT=function(t,e){if(this._crc.write(e),this._colorType===n.COLORTYPE_PALETTE_COLOR&&0===this._palette.length)throw new Error("Expected palette not found");this.inflateData(e);var r=t-e.length;r>0?this._handleIDAT(r):this._handleChunkEnd()},a.prototype._handleIEND=function(t){this.read(t,this._parseIEND.bind(this))},a.prototype._parseIEND=function(t){this._crc.write(t),this._hasIEND=!0,this._handleChunkEnd(),this.finished&&this.finished()}}).call(this,t("buffer").Buffer)},{"./constants":292,"./crc":293,buffer:47}],307:[function(t,e,r){"use strict";var n=t("./parser-sync"),i=t("./packer-sync");r.read=function(t,e){return n(t,e||{})},r.write=function(t,e){return i(t,e)}},{"./packer-sync":301,"./parser-sync":305}],308:[function(t,e,r){(function(e,n){"use strict";var i=t("util"),a=t("stream"),o=t("./parser-async"),s=t("./packer-async"),l=t("./png-sync"),u=r.PNG=function(t){a.call(this),t=t||{},this.width=0|t.width,this.height=0|t.height,this.data=this.width>0&&this.height>0?new n(4*this.width*this.height):null,t.fill&&this.data&&this.data.fill(0),this.gamma=0,this.readable=this.writable=!0,this._parser=new o(t),this._parser.on("error",this.emit.bind(this,"error")),this._parser.on("close",this._handleClose.bind(this)),this._parser.on("metadata",this._metadata.bind(this)),this._parser.on("gamma",this._gamma.bind(this)),this._parser.on("parsed",function(t){this.data=t,this.emit("parsed",t)}.bind(this)),this._packer=new s(t),this._packer.on("data",this.emit.bind(this,"data")),this._packer.on("end",this.emit.bind(this,"end")),this._parser.on("close",this._handleClose.bind(this)),this._packer.on("error",this.emit.bind(this,"error"))};i.inherits(u,a),u.sync=l,u.prototype.pack=function(){return this.data&&this.data.length?(e.nextTick(function(){this._packer.pack(this.data,this.width,this.height,this.gamma)}.bind(this)),this):(this.emit("error","No data provided"),this)},u.prototype.parse=function(t,e){var r,n;return e&&(r=function(t){this.removeListener("error",n),this.data=t,e(null,this)}.bind(this),n=function(t){this.removeListener("parsed",r),e(t,null)}.bind(this),this.once("parsed",r),this.once("error",n)),this.end(t),this},u.prototype.write=function(t){return this._parser.write(t),!0},u.prototype.end=function(t){this._parser.end(t)},u.prototype._metadata=function(t){this.width=t.width,this.height=t.height,this.emit("metadata",t)},u.prototype._gamma=function(t){this.gamma=t},u.prototype._handleClose=function(){this._parser.writable||this._packer.readable||this.emit("close")},u.bitblt=function(t,e,r,n,i,a,o,s){if(n|=0,i|=0,a|=0,o|=0,s|=0,(r|=0)>t.width||n>t.height||r+i>t.width||n+a>t.height)throw new Error("bitblt reading outside image");if(o>e.width||s>e.height||o+i>e.width||s+a>e.height)throw new Error("bitblt writing outside image");for(var l=0;l<a;l++)t.data.copy(e.data,(s+l)*e.width+o<<2,(n+l)*t.width+r<<2,(n+l)*t.width+r+i<<2)},u.prototype.bitblt=function(t,e,r,n,i,a,o){return u.bitblt(this,t,e,r,n,i,a,o),this},u.adjustGamma=function(t){if(t.gamma){for(var e=0;e<t.height;e++)for(var r=0;r<t.width;r++)for(var n=t.width*e+r<<2,i=0;i<3;i++){var a=t.data[n+i]/255;a=Math.pow(a,1/2.2/t.gamma),t.data[n+i]=Math.round(255*a)}t.gamma=0}},u.prototype.adjustGamma=function(){u.adjustGamma(this)}}).call(this,t("_process"),t("buffer").Buffer)},{"./packer-async":300,"./parser-async":304,"./png-sync":307,_process:312,buffer:47,stream:334,util:365}],309:[function(t,e,r){(function(n,i){"use strict";var a=t("assert").ok,o=t("zlib"),s=t("util"),l=t("buffer").kMaxLength;function u(t){if(!(this instanceof u))return new u(t);t&&t.chunkSize<o.Z_MIN_CHUNK&&(t.chunkSize=o.Z_MIN_CHUNK),o.Inflate.call(this,t),this._offset=void 0===this._offset?this._outOffset:this._offset,this._buffer=this._buffer||this._outBuffer,t&&null!=t.maxLength&&(this._maxLength=t.maxLength)}function f(t,e){e&&n.nextTick(e),t._handle&&(t._handle.close(),t._handle=null)}function h(t,e){return function(t,e){if("string"==typeof e&&(e=i.from(e)),!(e instanceof i))throw new TypeError("Not a string or buffer");var r=t._finishFlushFlag;return null==r&&(r=o.Z_FINISH),t._processChunk(e,r)}(new u(e),t)}u.prototype._processChunk=function(t,e,r){if("function"==typeof r)return o.Inflate._processChunk.call(this,t,e,r);var n,s=this,u=t&&t.length,h=this._chunkSize-this._offset,c=this._maxLength,d=0,p=[],b=0;function m(t,e){if(!s._hadError){var r=h-e;if(a(r>=0,"have should not go down"),r>0){var n=s._buffer.slice(s._offset,s._offset+r);if(s._offset+=r,n.length>c&&(n=n.slice(0,c)),p.push(n),b+=n.length,0===(c-=n.length))return!1}return(0===e||s._offset>=s._chunkSize)&&(h=s._chunkSize,s._offset=0,s._buffer=i.allocUnsafe(s._chunkSize)),0===e&&(d+=u-t,u=t,!0)}}this.on("error",(function(t){n=t})),a(this._handle,"zlib binding closed");do{var g=this._handle.writeSync(e,t,d,u,this._buffer,this._offset,h);g=g||this._writeState}while(!this._hadError&&m(g[0],g[1]));if(this._hadError)throw n;if(b>=l)throw f(this),new RangeError("Cannot create final Buffer. It would be larger than 0x"+l.toString(16)+" bytes");var y=i.concat(p,b);return f(this),y},s.inherits(u,o.Inflate),e.exports=r=h,r.Inflate=u,r.createInflate=function(t){return new u(t)},r.inflateSync=h}).call(this,t("_process"),t("buffer").Buffer)},{_process:312,assert:24,buffer:47,util:365,zlib:34}],310:[function(t,e,r){"use strict";var n=e.exports=function(t){this._buffer=t,this._reads=[]};n.prototype.read=function(t,e){this._reads.push({length:Math.abs(t),allowLess:t<0,func:e})},n.prototype.process=function(){for(;this._reads.length>0&&this._buffer.length;){var t=this._reads[0];if(!this._buffer.length||!(this._buffer.length>=t.length||t.allowLess))break;this._reads.shift();var e=this._buffer;this._buffer=e.slice(t.length),t.func.call(this,e.slice(0,t.length))}return this._reads.length>0?new Error("There are some read requests waitng on finished stream"):this._buffer.length>0?new Error("unrecognised content at end of stream"):void 0}},{}],311:[function(t,e,r){(function(t){"use strict";void 0===t||!t.version||0===t.version.indexOf("v0.")||0===t.version.indexOf("v1.")&&0!==t.version.indexOf("v1.8.")?e.exports={nextTick:function(e,r,n,i){if("function"!=typeof e)throw new TypeError('"callback" argument must be a function');var a,o,s=arguments.length;switch(s){case 0:case 1:return t.nextTick(e);case 2:return t.nextTick((function(){e.call(null,r)}));case 3:return t.nextTick((function(){e.call(null,r,n)}));case 4:return t.nextTick((function(){e.call(null,r,n,i)}));default:for(a=new Array(s-1),o=0;o<a.length;)a[o++]=arguments[o];return t.nextTick((function(){e.apply(null,a)}))}}}:e.exports=t}).call(this,t("_process"))},{_process:312}],312:[function(t,e,r){var n,i,a=e.exports={};function o(){throw new Error("setTimeout has not been defined")}function s(){throw new Error("clearTimeout has not been defined")}function l(t){if(n===setTimeout)return setTimeout(t,0);if((n===o||!n)&&setTimeout)return n=setTimeout,setTimeout(t,0);try{return n(t,0)}catch(e){try{return n.call(null,t,0)}catch(e){return n.call(this,t,0)}}}!function(){try{n="function"==typeof setTimeout?setTimeout:o}catch(t){n=o}try{i="function"==typeof clearTimeout?clearTimeout:s}catch(t){i=s}}();var u,f=[],h=!1,c=-1;function d(){h&&u&&(h=!1,u.length?f=u.concat(f):c=-1,f.length&&p())}function p(){if(!h){var t=l(d);h=!0;for(var e=f.length;e;){for(u=f,f=[];++c<e;)u&&u[c].run();c=-1,e=f.length}u=null,h=!1,function(t){if(i===clearTimeout)return clearTimeout(t);if((i===s||!i)&&clearTimeout)return i=clearTimeout,clearTimeout(t);try{return i(t)}catch(e){try{return i.call(null,t)}catch(e){return i.call(this,t)}}}(t)}}function b(t,e){this.fun=t,this.array=e}function m(){}a.nextTick=function(t){var e=new Array(arguments.length-1);if(arguments.length>1)for(var r=1;r<arguments.length;r++)e[r-1]=arguments[r];f.push(new b(t,e)),1!==f.length||h||l(p)},b.prototype.run=function(){this.fun.apply(null,this.array)},a.title="browser",a.browser=!0,a.env={},a.argv=[],a.version="",a.versions={},a.on=m,a.addListener=m,a.once=m,a.off=m,a.removeListener=m,a.removeAllListeners=m,a.emit=m,a.prependListener=m,a.prependOnceListener=m,a.listeners=function(t){return[]},a.binding=function(t){throw new Error("process.binding is not supported")},a.cwd=function(){return"/"},a.chdir=function(t){throw new Error("process.chdir is not supported")},a.umask=function(){return 0}},{}],313:[function(t,e,i){(function(t){!function(r){var n="object"==typeof i&&i&&!i.nodeType&&i,a="object"==typeof e&&e&&!e.nodeType&&e,o="object"==typeof t&&t;o.global!==o&&o.window!==o&&o.self!==o||(r=o);var s,l,u=2147483647,f=36,h=/^xn--/,c=/[^\x20-\x7E]/,d=/[\x2E\u3002\uFF0E\uFF61]/g,p={overflow:"Overflow: input needs wider integers to process","not-basic":"Illegal input >= 0x80 (not a basic code point)","invalid-input":"Invalid input"},b=Math.floor,m=String.fromCharCode;function g(t){throw new RangeError(p[t])}function y(t,e){for(var r=t.length,n=[];r--;)n[r]=e(t[r]);return n}function v(t,e){var r=t.split("@"),n="";return r.length>1&&(n=r[0]+"@",t=r[1]),n+y((t=t.replace(d,".")).split("."),e).join(".")}function _(t){for(var e,r,n=[],i=0,a=t.length;i<a;)(e=t.charCodeAt(i++))>=55296&&e<=56319&&i<a?56320==(64512&(r=t.charCodeAt(i++)))?n.push(((1023&e)<<10)+(1023&r)+65536):(n.push(e),i--):n.push(e);return n}function w(t){return y(t,(function(t){var e="";return t>65535&&(e+=m((t-=65536)>>>10&1023|55296),t=56320|1023&t),e+m(t)})).join("")}function x(t,e){return t+22+75*(t<26)-((0!=e)<<5)}function E(t,e,r){var n=0;for(t=r?b(t/700):t>>1,t+=b(t/e);t>455;n+=f)t=b(t/35);return b(n+36*t/(t+38))}function k(t){var e,r,n,i,a,o,s,l,h,c,d,p=[],m=t.length,y=0,v=128,_=72;for((r=t.lastIndexOf("-"))<0&&(r=0),n=0;n<r;++n)t.charCodeAt(n)>=128&&g("not-basic"),p.push(t.charCodeAt(n));for(i=r>0?r+1:0;i<m;){for(a=y,o=1,s=f;i>=m&&g("invalid-input"),((l=(d=t.charCodeAt(i++))-48<10?d-22:d-65<26?d-65:d-97<26?d-97:f)>=f||l>b((u-y)/o))&&g("overflow"),y+=l*o,!(l<(h=s<=_?1:s>=_+26?26:s-_));s+=f)o>b(u/(c=f-h))&&g("overflow"),o*=c;_=E(y-a,e=p.length+1,0==a),b(y/e)>u-v&&g("overflow"),v+=b(y/e),y%=e,p.splice(y++,0,v)}return w(p)}function j(t){var e,r,n,i,a,o,s,l,h,c,d,p,y,v,w,k=[];for(p=(t=_(t)).length,e=128,r=0,a=72,o=0;o<p;++o)(d=t[o])<128&&k.push(m(d));for(n=i=k.length,i&&k.push("-");n<p;){for(s=u,o=0;o<p;++o)(d=t[o])>=e&&d<s&&(s=d);for(s-e>b((u-r)/(y=n+1))&&g("overflow"),r+=(s-e)*y,e=s,o=0;o<p;++o)if((d=t[o])<e&&++r>u&&g("overflow"),d==e){for(l=r,h=f;!(l<(c=h<=a?1:h>=a+26?26:h-a));h+=f)w=l-c,v=f-c,k.push(m(x(c+w%v,0))),l=b(w/v);k.push(m(x(l,0))),a=E(r,y,n==i),r=0,++n}++r,++e}return k.join("")}if(s={version:"1.4.1",ucs2:{decode:_,encode:w},decode:k,encode:j,toASCII:function(t){return v(t,(function(t){return c.test(t)?"xn--"+j(t):t}))},toUnicode:function(t){return v(t,(function(t){return h.test(t)?k(t.slice(4).toLowerCase()):t}))}},n&&a)if(e.exports==n)a.exports=s;else for(l in s)s.hasOwnProperty(l)&&(n[l]=s[l]);else r.punycode=s}(this)}).call(this,void 0!==r.g?r.g:"undefined"!=typeof self?self:void 0!==n?n:{})},{}],314:[function(t,e,r){"use strict";function n(t,e){return Object.prototype.hasOwnProperty.call(t,e)}e.exports=function(t,e,r,a){e=e||"&",r=r||"=";var o={};if("string"!=typeof t||0===t.length)return o;var s=/\+/g;t=t.split(e);var l=1e3;a&&"number"==typeof a.maxKeys&&(l=a.maxKeys);var u=t.length;l>0&&u>l&&(u=l);for(var f=0;f<u;++f){var h,c,d,p,b=t[f].replace(s,"%20"),m=b.indexOf(r);m>=0?(h=b.substr(0,m),c=b.substr(m+1)):(h=b,c=""),d=decodeURIComponent(h),p=decodeURIComponent(c),n(o,d)?i(o[d])?o[d].push(p):o[d]=[o[d],p]:o[d]=p}return o};var i=Array.isArray||function(t){return"[object Array]"===Object.prototype.toString.call(t)}},{}],315:[function(t,e,r){"use strict";var n=function(t){switch(typeof t){case"string":return t;case"boolean":return t?"true":"false";case"number":return isFinite(t)?t:"";default:return""}};e.exports=function(t,e,r,s){return e=e||"&",r=r||"=",null===t&&(t=void 0),"object"==typeof t?a(o(t),(function(o){var s=encodeURIComponent(n(o))+r;return i(t[o])?a(t[o],(function(t){return s+encodeURIComponent(n(t))})).join(e):s+encodeURIComponent(n(t[o]))})).join(e):s?encodeURIComponent(n(s))+r+encodeURIComponent(n(t)):""};var i=Array.isArray||function(t){return"[object Array]"===Object.prototype.toString.call(t)};function a(t,e){if(t.map)return t.map(e);for(var r=[],n=0;n<t.length;n++)r.push(e(t[n],n));return r}var o=Object.keys||function(t){var e=[];for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&e.push(r);return e}},{}],316:[function(t,e,r){"use strict";r.decode=r.parse=t("./decode"),r.encode=r.stringify=t("./encode")},{"./decode":314,"./encode":315}],317:[function(t,e,r){e.exports=t("./lib/_stream_duplex.js")},{"./lib/_stream_duplex.js":318}],318:[function(t,e,r){"use strict";var n=t("process-nextick-args"),i=Object.keys||function(t){var e=[];for(var r in t)e.push(r);return e};e.exports=h;var a=t("core-util-is");a.inherits=t("inherits");var o=t("./_stream_readable"),s=t("./_stream_writable");a.inherits(h,o);for(var l=i(s.prototype),u=0;u<l.length;u++){var f=l[u];h.prototype[f]||(h.prototype[f]=s.prototype[f])}function h(t){if(!(this instanceof h))return new h(t);o.call(this,t),s.call(this,t),t&&!1===t.readable&&(this.readable=!1),t&&!1===t.writable&&(this.writable=!1),this.allowHalfOpen=!0,t&&!1===t.allowHalfOpen&&(this.allowHalfOpen=!1),this.once("end",c)}function c(){this.allowHalfOpen||this._writableState.ended||n.nextTick(d,this)}function d(t){t.end()}Object.defineProperty(h.prototype,"writableHighWaterMark",{enumerable:!1,get:function(){return this._writableState.highWaterMark}}),Object.defineProperty(h.prototype,"destroyed",{get:function(){return void 0!==this._readableState&&void 0!==this._writableState&&this._readableState.destroyed&&this._writableState.destroyed},set:function(t){void 0!==this._readableState&&void 0!==this._writableState&&(this._readableState.destroyed=t,this._writableState.destroyed=t)}}),h.prototype._destroy=function(t,e){this.push(null),this.end(),n.nextTick(e,t)}},{"./_stream_readable":320,"./_stream_writable":322,"core-util-is":238,inherits:254,"process-nextick-args":311}],319:[function(t,e,r){"use strict";e.exports=a;var n=t("./_stream_transform"),i=t("core-util-is");function a(t){if(!(this instanceof a))return new a(t);n.call(this,t)}i.inherits=t("inherits"),i.inherits(a,n),a.prototype._transform=function(t,e,r){r(null,t)}},{"./_stream_transform":321,"core-util-is":238,inherits:254}],320:[function(t,e,i){(function(r,n){"use strict";var i=t("process-nextick-args");e.exports=v;var a,o=t("isarray");v.ReadableState=y,t("events").EventEmitter;var s=function(t,e){return t.listeners(e).length},l=t("./internal/streams/stream"),u=t("safe-buffer").Buffer,f=n.Uint8Array||function(){},h=t("core-util-is");h.inherits=t("inherits");var c=t("util"),d=void 0;d=c&&c.debuglog?c.debuglog("stream"):function(){};var p,b=t("./internal/streams/BufferList"),m=t("./internal/streams/destroy");h.inherits(v,l);var g=["error","close","destroy","pause","resume"];function y(e,r){e=e||{};var n=r instanceof(a=a||t("./_stream_duplex"));this.objectMode=!!e.objectMode,n&&(this.objectMode=this.objectMode||!!e.readableObjectMode);var i=e.highWaterMark,o=e.readableHighWaterMark,s=this.objectMode?16:16384;this.highWaterMark=i||0===i?i:n&&(o||0===o)?o:s,this.highWaterMark=Math.floor(this.highWaterMark),this.buffer=new b,this.length=0,this.pipes=null,this.pipesCount=0,this.flowing=null,this.ended=!1,this.endEmitted=!1,this.reading=!1,this.sync=!0,this.needReadable=!1,this.emittedReadable=!1,this.readableListening=!1,this.resumeScheduled=!1,this.destroyed=!1,this.defaultEncoding=e.defaultEncoding||"utf8",this.awaitDrain=0,this.readingMore=!1,this.decoder=null,this.encoding=null,e.encoding&&(p||(p=t("string_decoder/").StringDecoder),this.decoder=new p(e.encoding),this.encoding=e.encoding)}function v(e){if(a=a||t("./_stream_duplex"),!(this instanceof v))return new v(e);this._readableState=new y(e,this),this.readable=!0,e&&("function"==typeof e.read&&(this._read=e.read),"function"==typeof e.destroy&&(this._destroy=e.destroy)),l.call(this)}function _(t,e,r,n,i){var a,o=t._readableState;return null===e?(o.reading=!1,function(t,e){if(!e.ended){if(e.decoder){var r=e.decoder.end();r&&r.length&&(e.buffer.push(r),e.length+=e.objectMode?1:r.length)}e.ended=!0,k(t)}}(t,o)):(i||(a=function(t,e){var r,n;return n=e,u.isBuffer(n)||n instanceof f||"string"==typeof e||void 0===e||t.objectMode||(r=new TypeError("Invalid non-string/buffer chunk")),r}(o,e)),a?t.emit("error",a):o.objectMode||e&&e.length>0?("string"==typeof e||o.objectMode||Object.getPrototypeOf(e)===u.prototype||(e=function(t){return u.from(t)}(e)),n?o.endEmitted?t.emit("error",new Error("stream.unshift() after end event")):w(t,o,e,!0):o.ended?t.emit("error",new Error("stream.push() after EOF")):(o.reading=!1,o.decoder&&!r?(e=o.decoder.write(e),o.objectMode||0!==e.length?w(t,o,e,!1):S(t,o)):w(t,o,e,!1))):n||(o.reading=!1)),function(t){return!t.ended&&(t.needReadable||t.length<t.highWaterMark||0===t.length)}(o)}function w(t,e,r,n){e.flowing&&0===e.length&&!e.sync?(t.emit("data",r),t.read(0)):(e.length+=e.objectMode?1:r.length,n?e.buffer.unshift(r):e.buffer.push(r),e.needReadable&&k(t)),S(t,e)}Object.defineProperty(v.prototype,"destroyed",{get:function(){return void 0!==this._readableState&&this._readableState.destroyed},set:function(t){this._readableState&&(this._readableState.destroyed=t)}}),v.prototype.destroy=m.destroy,v.prototype._undestroy=m.undestroy,v.prototype._destroy=function(t,e){this.push(null),e(t)},v.prototype.push=function(t,e){var r,n=this._readableState;return n.objectMode?r=!0:"string"==typeof t&&((e=e||n.defaultEncoding)!==n.encoding&&(t=u.from(t,e),e=""),r=!0),_(this,t,e,!1,r)},v.prototype.unshift=function(t){return _(this,t,null,!0,!1)},v.prototype.isPaused=function(){return!1===this._readableState.flowing},v.prototype.setEncoding=function(e){return p||(p=t("string_decoder/").StringDecoder),this._readableState.decoder=new p(e),this._readableState.encoding=e,this};var x=8388608;function E(t,e){return t<=0||0===e.length&&e.ended?0:e.objectMode?1:t!=t?e.flowing&&e.length?e.buffer.head.data.length:e.length:(t>e.highWaterMark&&(e.highWaterMark=function(t){return t>=x?t=x:(t--,t|=t>>>1,t|=t>>>2,t|=t>>>4,t|=t>>>8,t|=t>>>16,t++),t}(t)),t<=e.length?t:e.ended?e.length:(e.needReadable=!0,0))}function k(t){var e=t._readableState;e.needReadable=!1,e.emittedReadable||(d("emitReadable",e.flowing),e.emittedReadable=!0,e.sync?i.nextTick(j,t):j(t))}function j(t){d("emit readable"),t.emit("readable"),P(t)}function S(t,e){e.readingMore||(e.readingMore=!0,i.nextTick(A,t,e))}function A(t,e){for(var r=e.length;!e.reading&&!e.flowing&&!e.ended&&e.length<e.highWaterMark&&(d("maybeReadMore read 0"),t.read(0),r!==e.length);)r=e.length;e.readingMore=!1}function T(t){d("readable nexttick read 0"),t.read(0)}function I(t,e){e.reading||(d("resume read 0"),t.read(0)),e.resumeScheduled=!1,e.awaitDrain=0,t.emit("resume"),P(t),e.flowing&&!e.reading&&t.read(0)}function P(t){var e=t._readableState;for(d("flow",e.flowing);e.flowing&&null!==t.read(););}function M(t,e){return 0===e.length?null:(e.objectMode?r=e.buffer.shift():!t||t>=e.length?(r=e.decoder?e.buffer.join(""):1===e.buffer.length?e.buffer.head.data:e.buffer.concat(e.length),e.buffer.clear()):r=function(t,e,r){var n;return t<e.head.data.length?(n=e.head.data.slice(0,t),e.head.data=e.head.data.slice(t)):n=t===e.head.data.length?e.shift():r?function(t,e){var r=e.head,n=1,i=r.data;for(t-=i.length;r=r.next;){var a=r.data,o=t>a.length?a.length:t;if(o===a.length?i+=a:i+=a.slice(0,t),0===(t-=o)){o===a.length?(++n,r.next?e.head=r.next:e.head=e.tail=null):(e.head=r,r.data=a.slice(o));break}++n}return e.length-=n,i}(t,e):function(t,e){var r=u.allocUnsafe(t),n=e.head,i=1;for(n.data.copy(r),t-=n.data.length;n=n.next;){var a=n.data,o=t>a.length?a.length:t;if(a.copy(r,r.length-t,0,o),0===(t-=o)){o===a.length?(++i,n.next?e.head=n.next:e.head=e.tail=null):(e.head=n,n.data=a.slice(o));break}++i}return e.length-=i,r}(t,e),n}(t,e.buffer,e.decoder),r);var r}function O(t){var e=t._readableState;if(e.length>0)throw new Error('"endReadable()" called on non-empty stream');e.endEmitted||(e.ended=!0,i.nextTick(R,e,t))}function R(t,e){t.endEmitted||0!==t.length||(t.endEmitted=!0,e.readable=!1,e.emit("end"))}function L(t,e){for(var r=0,n=t.length;r<n;r++)if(t[r]===e)return r;return-1}v.prototype.read=function(t){d("read",t),t=parseInt(t,10);var e=this._readableState,r=t;if(0!==t&&(e.emittedReadable=!1),0===t&&e.needReadable&&(e.length>=e.highWaterMark||e.ended))return d("read: emitReadable",e.length,e.ended),0===e.length&&e.ended?O(this):k(this),null;if(0===(t=E(t,e))&&e.ended)return 0===e.length&&O(this),null;var n,i=e.needReadable;return d("need readable",i),(0===e.length||e.length-t<e.highWaterMark)&&d("length less than watermark",i=!0),e.ended||e.reading?d("reading or ended",i=!1):i&&(d("do read"),e.reading=!0,e.sync=!0,0===e.length&&(e.needReadable=!0),this._read(e.highWaterMark),e.sync=!1,e.reading||(t=E(r,e))),null===(n=t>0?M(t,e):null)?(e.needReadable=!0,t=0):e.length-=t,0===e.length&&(e.ended||(e.needReadable=!0),r!==t&&e.ended&&O(this)),null!==n&&this.emit("data",n),n},v.prototype._read=function(t){this.emit("error",new Error("_read() is not implemented"))},v.prototype.pipe=function(t,e){var n=this,a=this._readableState;switch(a.pipesCount){case 0:a.pipes=t;break;case 1:a.pipes=[a.pipes,t];break;default:a.pipes.push(t)}a.pipesCount+=1,d("pipe count=%d opts=%j",a.pipesCount,e);var l=e&&!1===e.end||t===r.stdout||t===r.stderr?v:f;function u(e,r){d("onunpipe"),e===n&&r&&!1===r.hasUnpiped&&(r.hasUnpiped=!0,d("cleanup"),t.removeListener("close",g),t.removeListener("finish",y),t.removeListener("drain",h),t.removeListener("error",m),t.removeListener("unpipe",u),n.removeListener("end",f),n.removeListener("end",v),n.removeListener("data",b),c=!0,!a.awaitDrain||t._writableState&&!t._writableState.needDrain||h())}function f(){d("onend"),t.end()}a.endEmitted?i.nextTick(l):n.once("end",l),t.on("unpipe",u);var h=function(t){return function(){var e=t._readableState;d("pipeOnDrain",e.awaitDrain),e.awaitDrain&&e.awaitDrain--,0===e.awaitDrain&&s(t,"data")&&(e.flowing=!0,P(t))}}(n);t.on("drain",h);var c=!1,p=!1;function b(e){d("ondata"),p=!1,!1!==t.write(e)||p||((1===a.pipesCount&&a.pipes===t||a.pipesCount>1&&-1!==L(a.pipes,t))&&!c&&(d("false write response, pause",n._readableState.awaitDrain),n._readableState.awaitDrain++,p=!0),n.pause())}function m(e){d("onerror",e),v(),t.removeListener("error",m),0===s(t,"error")&&t.emit("error",e)}function g(){t.removeListener("finish",y),v()}function y(){d("onfinish"),t.removeListener("close",g),v()}function v(){d("unpipe"),n.unpipe(t)}return n.on("data",b),function(t,e,r){if("function"==typeof t.prependListener)return t.prependListener(e,r);t._events&&t._events[e]?o(t._events[e])?t._events[e].unshift(r):t._events[e]=[r,t._events[e]]:t.on(e,r)}(t,"error",m),t.once("close",g),t.once("finish",y),t.emit("pipe",n),a.flowing||(d("pipe resume"),n.resume()),t},v.prototype.unpipe=function(t){var e=this._readableState,r={hasUnpiped:!1};if(0===e.pipesCount)return this;if(1===e.pipesCount)return t&&t!==e.pipes||(t||(t=e.pipes),e.pipes=null,e.pipesCount=0,e.flowing=!1,t&&t.emit("unpipe",this,r)),this;if(!t){var n=e.pipes,i=e.pipesCount;e.pipes=null,e.pipesCount=0,e.flowing=!1;for(var a=0;a<i;a++)n[a].emit("unpipe",this,r);return this}var o=L(e.pipes,t);return-1===o||(e.pipes.splice(o,1),e.pipesCount-=1,1===e.pipesCount&&(e.pipes=e.pipes[0]),t.emit("unpipe",this,r)),this},v.prototype.on=function(t,e){var r=l.prototype.on.call(this,t,e);if("data"===t)!1!==this._readableState.flowing&&this.resume();else if("readable"===t){var n=this._readableState;n.endEmitted||n.readableListening||(n.readableListening=n.needReadable=!0,n.emittedReadable=!1,n.reading?n.length&&k(this):i.nextTick(T,this))}return r},v.prototype.addListener=v.prototype.on,v.prototype.resume=function(){var t=this._readableState;return t.flowing||(d("resume"),t.flowing=!0,function(t,e){e.resumeScheduled||(e.resumeScheduled=!0,i.nextTick(I,t,e))}(this,t)),this},v.prototype.pause=function(){return d("call pause flowing=%j",this._readableState.flowing),!1!==this._readableState.flowing&&(d("pause"),this._readableState.flowing=!1,this.emit("pause")),this},v.prototype.wrap=function(t){var e=this,r=this._readableState,n=!1;for(var i in t.on("end",(function(){if(d("wrapped end"),r.decoder&&!r.ended){var t=r.decoder.end();t&&t.length&&e.push(t)}e.push(null)})),t.on("data",(function(i){d("wrapped data"),r.decoder&&(i=r.decoder.write(i)),r.objectMode&&null==i||(r.objectMode||i&&i.length)&&(e.push(i)||(n=!0,t.pause()))})),t)void 0===this[i]&&"function"==typeof t[i]&&(this[i]=function(e){return function(){return t[e].apply(t,arguments)}}(i));for(var a=0;a<g.length;a++)t.on(g[a],this.emit.bind(this,g[a]));return this._read=function(e){d("wrapped _read",e),n&&(n=!1,t.resume())},this},Object.defineProperty(v.prototype,"readableHighWaterMark",{enumerable:!1,get:function(){return this._readableState.highWaterMark}}),v._fromList=M}).call(this,t("_process"),void 0!==r.g?r.g:"undefined"!=typeof self?self:void 0!==n?n:{})},{"./_stream_duplex":318,"./internal/streams/BufferList":323,"./internal/streams/destroy":324,"./internal/streams/stream":325,_process:312,"core-util-is":238,events:239,inherits:254,isarray:258,"process-nextick-args":311,"safe-buffer":326,"string_decoder/":327,util:32}],321:[function(t,e,r){"use strict";e.exports=o;var n=t("./_stream_duplex"),i=t("core-util-is");function a(t,e){var r=this._transformState;r.transforming=!1;var n=r.writecb;if(!n)return this.emit("error",new Error("write callback called multiple times"));r.writechunk=null,r.writecb=null,null!=e&&this.push(e),n(t);var i=this._readableState;i.reading=!1,(i.needReadable||i.length<i.highWaterMark)&&this._read(i.highWaterMark)}function o(t){if(!(this instanceof o))return new o(t);n.call(this,t),this._transformState={afterTransform:a.bind(this),needTransform:!1,transforming:!1,writecb:null,writechunk:null,writeencoding:null},this._readableState.needReadable=!0,this._readableState.sync=!1,t&&("function"==typeof t.transform&&(this._transform=t.transform),"function"==typeof t.flush&&(this._flush=t.flush)),this.on("prefinish",s)}function s(){var t=this;"function"==typeof this._flush?this._flush((function(e,r){l(t,e,r)})):l(this,null,null)}function l(t,e,r){if(e)return t.emit("error",e);if(null!=r&&t.push(r),t._writableState.length)throw new Error("Calling transform done when ws.length != 0");if(t._transformState.transforming)throw new Error("Calling transform done when still transforming");return t.push(null)}i.inherits=t("inherits"),i.inherits(o,n),o.prototype.push=function(t,e){return this._transformState.needTransform=!1,n.prototype.push.call(this,t,e)},o.prototype._transform=function(t,e,r){throw new Error("_transform() is not implemented")},o.prototype._write=function(t,e,r){var n=this._transformState;if(n.writecb=r,n.writechunk=t,n.writeencoding=e,!n.transforming){var i=this._readableState;(n.needTransform||i.needReadable||i.length<i.highWaterMark)&&this._read(i.highWaterMark)}},o.prototype._read=function(t){var e=this._transformState;null!==e.writechunk&&e.writecb&&!e.transforming?(e.transforming=!0,this._transform(e.writechunk,e.writeencoding,e.afterTransform)):e.needTransform=!0},o.prototype._destroy=function(t,e){var r=this;n.prototype._destroy.call(this,t,(function(t){e(t),r.emit("close")}))}},{"./_stream_duplex":318,"core-util-is":238,inherits:254}],322:[function(t,e,i){(function(r,n,i){"use strict";var a=t("process-nextick-args");function o(t){var e=this;this.next=null,this.entry=null,this.finish=function(){!function(t,e,r){var n=t.entry;for(t.entry=null;n;){var i=n.callback;e.pendingcb--,i(r),n=n.next}e.corkedRequestsFree?e.corkedRequestsFree.next=t:e.corkedRequestsFree=t}(e,t)}}e.exports=y;var s,l=!r.browser&&["v0.10","v0.9."].indexOf(r.version.slice(0,5))>-1?i:a.nextTick;y.WritableState=g;var u=t("core-util-is");u.inherits=t("inherits");var f,h={deprecate:t("util-deprecate")},c=t("./internal/streams/stream"),d=t("safe-buffer").Buffer,p=n.Uint8Array||function(){},b=t("./internal/streams/destroy");function m(){}function g(e,r){s=s||t("./_stream_duplex"),e=e||{};var n=r instanceof s;this.objectMode=!!e.objectMode,n&&(this.objectMode=this.objectMode||!!e.writableObjectMode);var i=e.highWaterMark,u=e.writableHighWaterMark,f=this.objectMode?16:16384;this.highWaterMark=i||0===i?i:n&&(u||0===u)?u:f,this.highWaterMark=Math.floor(this.highWaterMark),this.finalCalled=!1,this.needDrain=!1,this.ending=!1,this.ended=!1,this.finished=!1,this.destroyed=!1;var h=!1===e.decodeStrings;this.decodeStrings=!h,this.defaultEncoding=e.defaultEncoding||"utf8",this.length=0,this.writing=!1,this.corked=0,this.sync=!0,this.bufferProcessing=!1,this.onwrite=function(t){!function(t,e){var r=t._writableState,n=r.sync,i=r.writecb;if(function(t){t.writing=!1,t.writecb=null,t.length-=t.writelen,t.writelen=0}(r),e)!function(t,e,r,n,i){--e.pendingcb,r?(a.nextTick(i,n),a.nextTick(j,t,e),t._writableState.errorEmitted=!0,t.emit("error",n)):(i(n),t._writableState.errorEmitted=!0,t.emit("error",n),j(t,e))}(t,r,n,e,i);else{var o=E(r);o||r.corked||r.bufferProcessing||!r.bufferedRequest||x(t,r),n?l(w,t,r,o,i):w(t,r,o,i)}}(r,t)},this.writecb=null,this.writelen=0,this.bufferedRequest=null,this.lastBufferedRequest=null,this.pendingcb=0,this.prefinished=!1,this.errorEmitted=!1,this.bufferedRequestCount=0,this.corkedRequestsFree=new o(this)}function y(e){if(s=s||t("./_stream_duplex"),!(f.call(y,this)||this instanceof s))return new y(e);this._writableState=new g(e,this),this.writable=!0,e&&("function"==typeof e.write&&(this._write=e.write),"function"==typeof e.writev&&(this._writev=e.writev),"function"==typeof e.destroy&&(this._destroy=e.destroy),"function"==typeof e.final&&(this._final=e.final)),c.call(this)}function v(t,e,r,n,i,a){if(!r){var o=function(t,e,r){return t.objectMode||!1===t.decodeStrings||"string"!=typeof e||(e=d.from(e,r)),e}(e,n,i);n!==o&&(r=!0,i="buffer",n=o)}var s=e.objectMode?1:n.length;e.length+=s;var l=e.length<e.highWaterMark;if(l||(e.needDrain=!0),e.writing||e.corked){var u=e.lastBufferedRequest;e.lastBufferedRequest={chunk:n,encoding:i,isBuf:r,callback:a,next:null},u?u.next=e.lastBufferedRequest:e.bufferedRequest=e.lastBufferedRequest,e.bufferedRequestCount+=1}else _(t,e,!1,s,n,i,a);return l}function _(t,e,r,n,i,a,o){e.writelen=n,e.writecb=o,e.writing=!0,e.sync=!0,r?t._writev(i,e.onwrite):t._write(i,a,e.onwrite),e.sync=!1}function w(t,e,r,n){r||function(t,e){0===e.length&&e.needDrain&&(e.needDrain=!1,t.emit("drain"))}(t,e),e.pendingcb--,n(),j(t,e)}function x(t,e){e.bufferProcessing=!0;var r=e.bufferedRequest;if(t._writev&&r&&r.next){var n=e.bufferedRequestCount,i=new Array(n),a=e.corkedRequestsFree;a.entry=r;for(var s=0,l=!0;r;)i[s]=r,r.isBuf||(l=!1),r=r.next,s+=1;i.allBuffers=l,_(t,e,!0,e.length,i,"",a.finish),e.pendingcb++,e.lastBufferedRequest=null,a.next?(e.corkedRequestsFree=a.next,a.next=null):e.corkedRequestsFree=new o(e),e.bufferedRequestCount=0}else{for(;r;){var u=r.chunk,f=r.encoding,h=r.callback;if(_(t,e,!1,e.objectMode?1:u.length,u,f,h),r=r.next,e.bufferedRequestCount--,e.writing)break}null===r&&(e.lastBufferedRequest=null)}e.bufferedRequest=r,e.bufferProcessing=!1}function E(t){return t.ending&&0===t.length&&null===t.bufferedRequest&&!t.finished&&!t.writing}function k(t,e){t._final((function(r){e.pendingcb--,r&&t.emit("error",r),e.prefinished=!0,t.emit("prefinish"),j(t,e)}))}function j(t,e){var r=E(e);return r&&(function(t,e){e.prefinished||e.finalCalled||("function"==typeof t._final?(e.pendingcb++,e.finalCalled=!0,a.nextTick(k,t,e)):(e.prefinished=!0,t.emit("prefinish")))}(t,e),0===e.pendingcb&&(e.finished=!0,t.emit("finish"))),r}u.inherits(y,c),g.prototype.getBuffer=function(){for(var t=this.bufferedRequest,e=[];t;)e.push(t),t=t.next;return e},function(){try{Object.defineProperty(g.prototype,"buffer",{get:h.deprecate((function(){return this.getBuffer()}),"_writableState.buffer is deprecated. Use _writableState.getBuffer instead.","DEP0003")})}catch(t){}}(),"function"==typeof Symbol&&Symbol.hasInstance&&"function"==typeof Function.prototype[Symbol.hasInstance]?(f=Function.prototype[Symbol.hasInstance],Object.defineProperty(y,Symbol.hasInstance,{value:function(t){return!!f.call(this,t)||this===y&&t&&t._writableState instanceof g}})):f=function(t){return t instanceof this},y.prototype.pipe=function(){this.emit("error",new Error("Cannot pipe, not readable"))},y.prototype.write=function(t,e,r){var n,i=this._writableState,o=!1,s=!i.objectMode&&(n=t,d.isBuffer(n)||n instanceof p);return s&&!d.isBuffer(t)&&(t=function(t){return d.from(t)}(t)),"function"==typeof e&&(r=e,e=null),s?e="buffer":e||(e=i.defaultEncoding),"function"!=typeof r&&(r=m),i.ended?function(t,e){var r=new Error("write after end");t.emit("error",r),a.nextTick(e,r)}(this,r):(s||function(t,e,r,n){var i=!0,o=!1;return null===r?o=new TypeError("May not write null values to stream"):"string"==typeof r||void 0===r||e.objectMode||(o=new TypeError("Invalid non-string/buffer chunk")),o&&(t.emit("error",o),a.nextTick(n,o),i=!1),i}(this,i,t,r))&&(i.pendingcb++,o=v(this,i,s,t,e,r)),o},y.prototype.cork=function(){this._writableState.corked++},y.prototype.uncork=function(){var t=this._writableState;t.corked&&(t.corked--,t.writing||t.corked||t.finished||t.bufferProcessing||!t.bufferedRequest||x(this,t))},y.prototype.setDefaultEncoding=function(t){if("string"==typeof t&&(t=t.toLowerCase()),!(["hex","utf8","utf-8","ascii","binary","base64","ucs2","ucs-2","utf16le","utf-16le","raw"].indexOf((t+"").toLowerCase())>-1))throw new TypeError("Unknown encoding: "+t);return this._writableState.defaultEncoding=t,this},Object.defineProperty(y.prototype,"writableHighWaterMark",{enumerable:!1,get:function(){return this._writableState.highWaterMark}}),y.prototype._write=function(t,e,r){r(new Error("_write() is not implemented"))},y.prototype._writev=null,y.prototype.end=function(t,e,r){var n=this._writableState;"function"==typeof t?(r=t,t=null,e=null):"function"==typeof e&&(r=e,e=null),null!=t&&this.write(t,e),n.corked&&(n.corked=1,this.uncork()),n.ending||n.finished||function(t,e,r){e.ending=!0,j(t,e),r&&(e.finished?a.nextTick(r):t.once("finish",r)),e.ended=!0,t.writable=!1}(this,n,r)},Object.defineProperty(y.prototype,"destroyed",{get:function(){return void 0!==this._writableState&&this._writableState.destroyed},set:function(t){this._writableState&&(this._writableState.destroyed=t)}}),y.prototype.destroy=b.destroy,y.prototype._undestroy=b.undestroy,y.prototype._destroy=function(t,e){this.end(),e(t)}}).call(this,t("_process"),void 0!==r.g?r.g:"undefined"!=typeof self?self:void 0!==n?n:{},t("timers").setImmediate)},{"./_stream_duplex":318,"./internal/streams/destroy":324,"./internal/streams/stream":325,_process:312,"core-util-is":238,inherits:254,"process-nextick-args":311,"safe-buffer":326,timers:355,"util-deprecate":362}],323:[function(t,e,r){"use strict";var n=t("safe-buffer").Buffer,i=t("util");e.exports=function(){function t(){(function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")})(this,t),this.head=null,this.tail=null,this.length=0}return t.prototype.push=function(t){var e={data:t,next:null};this.length>0?this.tail.next=e:this.head=e,this.tail=e,++this.length},t.prototype.unshift=function(t){var e={data:t,next:this.head};0===this.length&&(this.tail=e),this.head=e,++this.length},t.prototype.shift=function(){if(0!==this.length){var t=this.head.data;return 1===this.length?this.head=this.tail=null:this.head=this.head.next,--this.length,t}},t.prototype.clear=function(){this.head=this.tail=null,this.length=0},t.prototype.join=function(t){if(0===this.length)return"";for(var e=this.head,r=""+e.data;e=e.next;)r+=t+e.data;return r},t.prototype.concat=function(t){if(0===this.length)return n.alloc(0);if(1===this.length)return this.head.data;for(var e=n.allocUnsafe(t>>>0),r=this.head,i=0;r;)a=r.data,o=e,s=i,a.copy(o,s),i+=r.data.length,r=r.next;var a,o,s;return e},t}(),i&&i.inspect&&i.inspect.custom&&(e.exports.prototype[i.inspect.custom]=function(){var t=i.inspect({length:this.length});return this.constructor.name+" "+t})},{"safe-buffer":326,util:32}],324:[function(t,e,r){"use strict";var n=t("process-nextick-args");function i(t,e){t.emit("error",e)}e.exports={destroy:function(t,e){var r=this,a=this._readableState&&this._readableState.destroyed,o=this._writableState&&this._writableState.destroyed;return a||o?(e?e(t):!t||this._writableState&&this._writableState.errorEmitted||n.nextTick(i,this,t),this):(this._readableState&&(this._readableState.destroyed=!0),this._writableState&&(this._writableState.destroyed=!0),this._destroy(t||null,(function(t){!e&&t?(n.nextTick(i,r,t),r._writableState&&(r._writableState.errorEmitted=!0)):e&&e(t)})),this)},undestroy:function(){this._readableState&&(this._readableState.destroyed=!1,this._readableState.reading=!1,this._readableState.ended=!1,this._readableState.endEmitted=!1),this._writableState&&(this._writableState.destroyed=!1,this._writableState.ended=!1,this._writableState.ending=!1,this._writableState.finished=!1,this._writableState.errorEmitted=!1)}}},{"process-nextick-args":311}],325:[function(t,e,r){e.exports=t("events").EventEmitter},{events:239}],326:[function(t,e,r){var n=t("buffer"),i=n.Buffer;function a(t,e){for(var r in t)e[r]=t[r]}function o(t,e,r){return i(t,e,r)}i.from&&i.alloc&&i.allocUnsafe&&i.allocUnsafeSlow?e.exports=n:(a(n,r),r.Buffer=o),a(i,o),o.from=function(t,e,r){if("number"==typeof t)throw new TypeError("Argument must not be a number");return i(t,e,r)},o.alloc=function(t,e,r){if("number"!=typeof t)throw new TypeError("Argument must be a number");var n=i(t);return void 0!==e?"string"==typeof r?n.fill(e,r):n.fill(e):n.fill(0),n},o.allocUnsafe=function(t){if("number"!=typeof t)throw new TypeError("Argument must be a number");return i(t)},o.allocUnsafeSlow=function(t){if("number"!=typeof t)throw new TypeError("Argument must be a number");return n.SlowBuffer(t)}},{buffer:47}],327:[function(t,e,r){"use strict";var n=t("safe-buffer").Buffer,i=n.isEncoding||function(t){switch((t=""+t)&&t.toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":case"raw":return!0;default:return!1}};function a(t){var e;switch(this.encoding=function(t){var e=function(t){if(!t)return"utf8";for(var e;;)switch(t){case"utf8":case"utf-8":return"utf8";case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return"utf16le";case"latin1":case"binary":return"latin1";case"base64":case"ascii":case"hex":return t;default:if(e)return;t=(""+t).toLowerCase(),e=!0}}(t);if("string"!=typeof e&&(n.isEncoding===i||!i(t)))throw new Error("Unknown encoding: "+t);return e||t}(t),this.encoding){case"utf16le":this.text=l,this.end=u,e=4;break;case"utf8":this.fillLast=s,e=4;break;case"base64":this.text=f,this.end=h,e=3;break;default:return this.write=c,void(this.end=d)}this.lastNeed=0,this.lastTotal=0,this.lastChar=n.allocUnsafe(e)}function o(t){return t<=127?0:t>>5==6?2:t>>4==14?3:t>>3==30?4:t>>6==2?-1:-2}function s(t){var e=this.lastTotal-this.lastNeed,r=function(t,e){if(128!=(192&e[0]))return t.lastNeed=0,"�";if(t.lastNeed>1&&e.length>1){if(128!=(192&e[1]))return t.lastNeed=1,"�";if(t.lastNeed>2&&e.length>2&&128!=(192&e[2]))return t.lastNeed=2,"�"}}(this,t);return void 0!==r?r:this.lastNeed<=t.length?(t.copy(this.lastChar,e,0,this.lastNeed),this.lastChar.toString(this.encoding,0,this.lastTotal)):(t.copy(this.lastChar,e,0,t.length),void(this.lastNeed-=t.length))}function l(t,e){if((t.length-e)%2==0){var r=t.toString("utf16le",e);if(r){var n=r.charCodeAt(r.length-1);if(n>=55296&&n<=56319)return this.lastNeed=2,this.lastTotal=4,this.lastChar[0]=t[t.length-2],this.lastChar[1]=t[t.length-1],r.slice(0,-1)}return r}return this.lastNeed=1,this.lastTotal=2,this.lastChar[0]=t[t.length-1],t.toString("utf16le",e,t.length-1)}function u(t){var e=t&&t.length?this.write(t):"";if(this.lastNeed){var r=this.lastTotal-this.lastNeed;return e+this.lastChar.toString("utf16le",0,r)}return e}function f(t,e){var r=(t.length-e)%3;return 0===r?t.toString("base64",e):(this.lastNeed=3-r,this.lastTotal=3,1===r?this.lastChar[0]=t[t.length-1]:(this.lastChar[0]=t[t.length-2],this.lastChar[1]=t[t.length-1]),t.toString("base64",e,t.length-r))}function h(t){var e=t&&t.length?this.write(t):"";return this.lastNeed?e+this.lastChar.toString("base64",0,3-this.lastNeed):e}function c(t){return t.toString(this.encoding)}function d(t){return t&&t.length?this.write(t):""}r.StringDecoder=a,a.prototype.write=function(t){if(0===t.length)return"";var e,r;if(this.lastNeed){if(void 0===(e=this.fillLast(t)))return"";r=this.lastNeed,this.lastNeed=0}else r=0;return r<t.length?e?e+this.text(t,r):this.text(t,r):e||""},a.prototype.end=function(t){var e=t&&t.length?this.write(t):"";return this.lastNeed?e+"�":e},a.prototype.text=function(t,e){var r=function(t,e,r){var n=e.length-1;if(n<r)return 0;var i=o(e[n]);return i>=0?(i>0&&(t.lastNeed=i-1),i):--n<r||-2===i?0:(i=o(e[n]))>=0?(i>0&&(t.lastNeed=i-2),i):--n<r||-2===i?0:(i=o(e[n]))>=0?(i>0&&(2===i?i=0:t.lastNeed=i-3),i):0}(this,t,e);if(!this.lastNeed)return t.toString("utf8",e);this.lastTotal=r;var n=t.length-(r-this.lastNeed);return t.copy(this.lastChar,0,n),t.toString("utf8",e,n)},a.prototype.fillLast=function(t){if(this.lastNeed<=t.length)return t.copy(this.lastChar,this.lastTotal-this.lastNeed,0,this.lastNeed),this.lastChar.toString(this.encoding,0,this.lastTotal);t.copy(this.lastChar,this.lastTotal-this.lastNeed,0,t.length),this.lastNeed-=t.length}},{"safe-buffer":326}],328:[function(t,e,r){e.exports=t("./readable").PassThrough},{"./readable":329}],329:[function(t,e,r){(r=e.exports=t("./lib/_stream_readable.js")).Stream=r,r.Readable=r,r.Writable=t("./lib/_stream_writable.js"),r.Duplex=t("./lib/_stream_duplex.js"),r.Transform=t("./lib/_stream_transform.js"),r.PassThrough=t("./lib/_stream_passthrough.js")},{"./lib/_stream_duplex.js":318,"./lib/_stream_passthrough.js":319,"./lib/_stream_readable.js":320,"./lib/_stream_transform.js":321,"./lib/_stream_writable.js":322}],330:[function(t,e,r){e.exports=t("./readable").Transform},{"./readable":329}],331:[function(t,e,r){e.exports=t("./lib/_stream_writable.js")},{"./lib/_stream_writable.js":322}],332:[function(t,e,r){var n=function(t){"use strict";var e,r=Object.prototype,n=r.hasOwnProperty,i="function"==typeof Symbol?Symbol:{},a=i.iterator||"@@iterator",o=i.asyncIterator||"@@asyncIterator",s=i.toStringTag||"@@toStringTag";function l(t,e,r,n){var i=e&&e.prototype instanceof b?e:b,a=Object.create(i.prototype),o=new A(n||[]);return a._invoke=function(t,e,r){var n=f;return function(i,a){if(n===c)throw new Error("Generator is already running");if(n===d){if("throw"===i)throw a;return I()}for(r.method=i,r.arg=a;;){var o=r.delegate;if(o){var s=k(o,r);if(s){if(s===p)continue;return s}}if("next"===r.method)r.sent=r._sent=r.arg;else if("throw"===r.method){if(n===f)throw n=d,r.arg;r.dispatchException(r.arg)}else"return"===r.method&&r.abrupt("return",r.arg);n=c;var l=u(t,e,r);if("normal"===l.type){if(n=r.done?d:h,l.arg===p)continue;return{value:l.arg,done:r.done}}"throw"===l.type&&(n=d,r.method="throw",r.arg=l.arg)}}}(t,r,o),a}function u(t,e,r){try{return{type:"normal",arg:t.call(e,r)}}catch(t){return{type:"throw",arg:t}}}t.wrap=l;var f="suspendedStart",h="suspendedYield",c="executing",d="completed",p={};function b(){}function m(){}function g(){}var y={};y[a]=function(){return this};var v=Object.getPrototypeOf,_=v&&v(v(T([])));_&&_!==r&&n.call(_,a)&&(y=_);var w=g.prototype=b.prototype=Object.create(y);function x(t){["next","throw","return"].forEach((function(e){t[e]=function(t){return this._invoke(e,t)}}))}function E(t){function e(r,i,a,o){var s=u(t[r],t,i);if("throw"!==s.type){var l=s.arg,f=l.value;return f&&"object"==typeof f&&n.call(f,"__await")?Promise.resolve(f.__await).then((function(t){e("next",t,a,o)}),(function(t){e("throw",t,a,o)})):Promise.resolve(f).then((function(t){l.value=t,a(l)}),(function(t){return e("throw",t,a,o)}))}o(s.arg)}var r;this._invoke=function(t,n){function i(){return new Promise((function(r,i){e(t,n,r,i)}))}return r=r?r.then(i,i):i()}}function k(t,r){var n=t.iterator[r.method];if(n===e){if(r.delegate=null,"throw"===r.method){if(t.iterator.return&&(r.method="return",r.arg=e,k(t,r),"throw"===r.method))return p;r.method="throw",r.arg=new TypeError("The iterator does not provide a 'throw' method")}return p}var i=u(n,t.iterator,r.arg);if("throw"===i.type)return r.method="throw",r.arg=i.arg,r.delegate=null,p;var a=i.arg;return a?a.done?(r[t.resultName]=a.value,r.next=t.nextLoc,"return"!==r.method&&(r.method="next",r.arg=e),r.delegate=null,p):a:(r.method="throw",r.arg=new TypeError("iterator result is not an object"),r.delegate=null,p)}function j(t){var e={tryLoc:t[0]};1 in t&&(e.catchLoc=t[1]),2 in t&&(e.finallyLoc=t[2],e.afterLoc=t[3]),this.tryEntries.push(e)}function S(t){var e=t.completion||{};e.type="normal",delete e.arg,t.completion=e}function A(t){this.tryEntries=[{tryLoc:"root"}],t.forEach(j,this),this.reset(!0)}function T(t){if(t){var r=t[a];if(r)return r.call(t);if("function"==typeof t.next)return t;if(!isNaN(t.length)){var i=-1,o=function r(){for(;++i<t.length;)if(n.call(t,i))return r.value=t[i],r.done=!1,r;return r.value=e,r.done=!0,r};return o.next=o}}return{next:I}}function I(){return{value:e,done:!0}}return m.prototype=w.constructor=g,g.constructor=m,g[s]=m.displayName="GeneratorFunction",t.isGeneratorFunction=function(t){var e="function"==typeof t&&t.constructor;return!!e&&(e===m||"GeneratorFunction"===(e.displayName||e.name))},t.mark=function(t){return Object.setPrototypeOf?Object.setPrototypeOf(t,g):(t.__proto__=g,s in t||(t[s]="GeneratorFunction")),t.prototype=Object.create(w),t},t.awrap=function(t){return{__await:t}},x(E.prototype),E.prototype[o]=function(){return this},t.AsyncIterator=E,t.async=function(e,r,n,i){var a=new E(l(e,r,n,i));return t.isGeneratorFunction(r)?a:a.next().then((function(t){return t.done?t.value:a.next()}))},x(w),w[s]="Generator",w[a]=function(){return this},w.toString=function(){return"[object Generator]"},t.keys=function(t){var e=[];for(var r in t)e.push(r);return e.reverse(),function r(){for(;e.length;){var n=e.pop();if(n in t)return r.value=n,r.done=!1,r}return r.done=!0,r}},t.values=T,A.prototype={constructor:A,reset:function(t){if(this.prev=0,this.next=0,this.sent=this._sent=e,this.done=!1,this.delegate=null,this.method="next",this.arg=e,this.tryEntries.forEach(S),!t)for(var r in this)"t"===r.charAt(0)&&n.call(this,r)&&!isNaN(+r.slice(1))&&(this[r]=e)},stop:function(){this.done=!0;var t=this.tryEntries[0].completion;if("throw"===t.type)throw t.arg;return this.rval},dispatchException:function(t){if(this.done)throw t;var r=this;function i(n,i){return s.type="throw",s.arg=t,r.next=n,i&&(r.method="next",r.arg=e),!!i}for(var a=this.tryEntries.length-1;a>=0;--a){var o=this.tryEntries[a],s=o.completion;if("root"===o.tryLoc)return i("end");if(o.tryLoc<=this.prev){var l=n.call(o,"catchLoc"),u=n.call(o,"finallyLoc");if(l&&u){if(this.prev<o.catchLoc)return i(o.catchLoc,!0);if(this.prev<o.finallyLoc)return i(o.finallyLoc)}else if(l){if(this.prev<o.catchLoc)return i(o.catchLoc,!0)}else{if(!u)throw new Error("try statement without catch or finally");if(this.prev<o.finallyLoc)return i(o.finallyLoc)}}}},abrupt:function(t,e){for(var r=this.tryEntries.length-1;r>=0;--r){var i=this.tryEntries[r];if(i.tryLoc<=this.prev&&n.call(i,"finallyLoc")&&this.prev<i.finallyLoc){var a=i;break}}a&&("break"===t||"continue"===t)&&a.tryLoc<=e&&e<=a.finallyLoc&&(a=null);var o=a?a.completion:{};return o.type=t,o.arg=e,a?(this.method="next",this.next=a.finallyLoc,p):this.complete(o)},complete:function(t,e){if("throw"===t.type)throw t.arg;return"break"===t.type||"continue"===t.type?this.next=t.arg:"return"===t.type?(this.rval=this.arg=t.arg,this.method="return",this.next="end"):"normal"===t.type&&e&&(this.next=e),p},finish:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var r=this.tryEntries[e];if(r.finallyLoc===t)return this.complete(r.completion,r.afterLoc),S(r),p}},catch:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var r=this.tryEntries[e];if(r.tryLoc===t){var n=r.completion;if("throw"===n.type){var i=n.arg;S(r)}return i}}throw new Error("illegal catch attempt")},delegateYield:function(t,r,n){return this.delegate={iterator:T(t),resultName:r,nextLoc:n},"next"===this.method&&(this.arg=e),p}},t}("object"==typeof e?e.exports:{});try{regeneratorRuntime=n}catch(t){Function("r","regeneratorRuntime = r")(n)}},{}],333:[function(t,e,r){var n=t("buffer"),i=n.Buffer;function a(t,e){for(var r in t)e[r]=t[r]}function o(t,e,r){return i(t,e,r)}i.from&&i.alloc&&i.allocUnsafe&&i.allocUnsafeSlow?e.exports=n:(a(n,r),r.Buffer=o),o.prototype=Object.create(i.prototype),a(i,o),o.from=function(t,e,r){if("number"==typeof t)throw new TypeError("Argument must not be a number");return i(t,e,r)},o.alloc=function(t,e,r){if("number"!=typeof t)throw new TypeError("Argument must be a number");var n=i(t);return void 0!==e?"string"==typeof r?n.fill(e,r):n.fill(e):n.fill(0),n},o.allocUnsafe=function(t){if("number"!=typeof t)throw new TypeError("Argument must be a number");return i(t)},o.allocUnsafeSlow=function(t){if("number"!=typeof t)throw new TypeError("Argument must be a number");return n.SlowBuffer(t)}},{buffer:47}],334:[function(t,e,r){e.exports=i;var n=t("events").EventEmitter;function i(){n.call(this)}t("inherits")(i,n),i.Readable=t("readable-stream/readable.js"),i.Writable=t("readable-stream/writable.js"),i.Duplex=t("readable-stream/duplex.js"),i.Transform=t("readable-stream/transform.js"),i.PassThrough=t("readable-stream/passthrough.js"),i.Stream=i,i.prototype.pipe=function(t,e){var r=this;function i(e){t.writable&&!1===t.write(e)&&r.pause&&r.pause()}function a(){r.readable&&r.resume&&r.resume()}r.on("data",i),t.on("drain",a),t._isStdio||e&&!1===e.end||(r.on("end",s),r.on("close",l));var o=!1;function s(){o||(o=!0,t.end())}function l(){o||(o=!0,"function"==typeof t.destroy&&t.destroy())}function u(t){if(f(),0===n.listenerCount(this,"error"))throw t}function f(){r.removeListener("data",i),t.removeListener("drain",a),r.removeListener("end",s),r.removeListener("close",l),r.removeListener("error",u),t.removeListener("error",u),r.removeListener("end",f),r.removeListener("close",f),t.removeListener("close",f)}return r.on("error",u),t.on("error",u),r.on("end",f),r.on("close",f),t.on("close",f),t.emit("pipe",r),t}},{events:239,inherits:254,"readable-stream/duplex.js":317,"readable-stream/passthrough.js":328,"readable-stream/readable.js":329,"readable-stream/transform.js":330,"readable-stream/writable.js":331}],335:[function(t,e,i){(function(e){var r=t("./lib/request"),n=t("./lib/response"),a=t("xtend"),o=t("builtin-status-codes"),s=t("url"),l=i;l.request=function(t,n){t="string"==typeof t?s.parse(t):a(t);var i=-1===e.location.protocol.search(/^https?:$/)?"http:":"",o=t.protocol||i,l=t.hostname||t.host,u=t.port,f=t.path||"/";l&&-1!==l.indexOf(":")&&(l="["+l+"]"),t.url=(l?o+"//"+l:"")+(u?":"+u:"")+f,t.method=(t.method||"GET").toUpperCase(),t.headers=t.headers||{};var h=new r(t);return n&&h.on("response",n),h},l.get=function(t,e){var r=l.request(t,e);return r.end(),r},l.ClientRequest=r,l.IncomingMessage=n.IncomingMessage,l.Agent=function(){},l.Agent.defaultMaxSockets=4,l.globalAgent=new l.Agent,l.STATUS_CODES=o,l.METHODS=["CHECKOUT","CONNECT","COPY","DELETE","GET","HEAD","LOCK","M-SEARCH","MERGE","MKACTIVITY","MKCOL","MOVE","NOTIFY","OPTIONS","PATCH","POST","PROPFIND","PROPPATCH","PURGE","PUT","REPORT","SEARCH","SUBSCRIBE","TRACE","UNLOCK","UNSUBSCRIBE"]}).call(this,void 0!==r.g?r.g:"undefined"!=typeof self?self:void 0!==n?n:{})},{"./lib/request":337,"./lib/response":338,"builtin-status-codes":49,url:359,xtend:368}],336:[function(t,e,i){(function(t){var e;function r(){if(void 0!==e)return e;if(t.XMLHttpRequest){e=new t.XMLHttpRequest;try{e.open("GET",t.XDomainRequest?"/":"https://example.com")}catch(t){e=null}}else e=null;return e}function n(t){var e=r();if(!e)return!1;try{return e.responseType=t,e.responseType===t}catch(t){}return!1}function a(t){return"function"==typeof t}i.fetch=a(t.fetch)&&a(t.ReadableStream),i.writableStream=a(t.WritableStream),i.abortController=a(t.AbortController),i.arraybuffer=i.fetch||n("arraybuffer"),i.msstream=!i.fetch&&n("ms-stream"),i.mozchunkedarraybuffer=!i.fetch&&n("moz-chunked-arraybuffer"),i.overrideMimeType=i.fetch||!!r()&&a(r().overrideMimeType),e=null}).call(this,void 0!==r.g?r.g:"undefined"!=typeof self?self:void 0!==n?n:{})},{}],337:[function(t,e,i){(function(r,n,i){var a=t("./capability"),o=t("inherits"),s=t("./response"),l=t("readable-stream"),u=s.IncomingMessage,f=s.readyStates,h=e.exports=function(t){var e,r=this;l.Writable.call(r),r._opts=t,r._body=[],r._headers={},t.auth&&r.setHeader("Authorization","Basic "+i.from(t.auth).toString("base64")),Object.keys(t.headers).forEach((function(e){r.setHeader(e,t.headers[e])}));var n=!0;if("disable-fetch"===t.mode||"requestTimeout"in t&&!a.abortController)n=!1,e=!0;else if("prefer-streaming"===t.mode)e=!1;else if("allow-wrong-content-type"===t.mode)e=!a.overrideMimeType;else{if(t.mode&&"default"!==t.mode&&"prefer-fast"!==t.mode)throw new Error("Invalid value for opts.mode");e=!0}r._mode=function(t,e){return a.fetch&&e?"fetch":a.mozchunkedarraybuffer?"moz-chunked-arraybuffer":a.msstream?"ms-stream":a.arraybuffer&&t?"arraybuffer":"text"}(e,n),r._fetchTimer=null,r.on("finish",(function(){r._onFinish()}))};o(h,l.Writable),h.prototype.setHeader=function(t,e){var r=t.toLowerCase();-1===c.indexOf(r)&&(this._headers[r]={name:t,value:e})},h.prototype.getHeader=function(t){var e=this._headers[t.toLowerCase()];return e?e.value:null},h.prototype.removeHeader=function(t){delete this._headers[t.toLowerCase()]},h.prototype._onFinish=function(){var t=this;if(!t._destroyed){var e=t._opts,i=t._headers,o=null;"GET"!==e.method&&"HEAD"!==e.method&&(o=new Blob(t._body,{type:(i["content-type"]||{}).value||""}));var s=[];if(Object.keys(i).forEach((function(t){var e=i[t].name,r=i[t].value;Array.isArray(r)?r.forEach((function(t){s.push([e,t])})):s.push([e,r])})),"fetch"===t._mode){var l=null;if(a.abortController){var u=new AbortController;l=u.signal,t._fetchAbortController=u,"requestTimeout"in e&&0!==e.requestTimeout&&(t._fetchTimer=n.setTimeout((function(){t.emit("requestTimeout"),t._fetchAbortController&&t._fetchAbortController.abort()}),e.requestTimeout))}n.fetch(t._opts.url,{method:t._opts.method,headers:s,body:o||void 0,mode:"cors",credentials:e.withCredentials?"include":"same-origin",signal:l}).then((function(e){t._fetchResponse=e,t._connect()}),(function(e){n.clearTimeout(t._fetchTimer),t._destroyed||t.emit("error",e)}))}else{var h=t._xhr=new n.XMLHttpRequest;try{h.open(t._opts.method,t._opts.url,!0)}catch(e){return void r.nextTick((function(){t.emit("error",e)}))}"responseType"in h&&(h.responseType=t._mode),"withCredentials"in h&&(h.withCredentials=!!e.withCredentials),"text"===t._mode&&"overrideMimeType"in h&&h.overrideMimeType("text/plain; charset=x-user-defined"),"requestTimeout"in e&&(h.timeout=e.requestTimeout,h.ontimeout=function(){t.emit("requestTimeout")}),s.forEach((function(t){h.setRequestHeader(t[0],t[1])})),t._response=null,h.onreadystatechange=function(){switch(h.readyState){case f.LOADING:case f.DONE:t._onXHRProgress()}},"moz-chunked-arraybuffer"===t._mode&&(h.onprogress=function(){t._onXHRProgress()}),h.onerror=function(){t._destroyed||t.emit("error",new Error("XHR error"))};try{h.send(o)}catch(e){return void r.nextTick((function(){t.emit("error",e)}))}}}},h.prototype._onXHRProgress=function(){var t=this;(function(t){try{var e=t.status;return null!==e&&0!==e}catch(t){return!1}})(t._xhr)&&!t._destroyed&&(t._response||t._connect(),t._response._onXHRProgress())},h.prototype._connect=function(){var t=this;t._destroyed||(t._response=new u(t._xhr,t._fetchResponse,t._mode,t._fetchTimer),t._response.on("error",(function(e){t.emit("error",e)})),t.emit("response",t._response))},h.prototype._write=function(t,e,r){this._body.push(t),r()},h.prototype.abort=h.prototype.destroy=function(){var t=this;t._destroyed=!0,n.clearTimeout(t._fetchTimer),t._response&&(t._response._destroyed=!0),t._xhr?t._xhr.abort():t._fetchAbortController&&t._fetchAbortController.abort()},h.prototype.end=function(t,e,r){"function"==typeof t&&(r=t,t=void 0),l.Writable.prototype.end.call(this,t,e,r)},h.prototype.flushHeaders=function(){},h.prototype.setTimeout=function(){},h.prototype.setNoDelay=function(){},h.prototype.setSocketKeepAlive=function(){};var c=["accept-charset","accept-encoding","access-control-request-headers","access-control-request-method","connection","content-length","cookie","cookie2","date","dnt","expect","host","keep-alive","origin","referer","te","trailer","transfer-encoding","upgrade","via"]}).call(this,t("_process"),void 0!==r.g?r.g:"undefined"!=typeof self?self:void 0!==n?n:{},t("buffer").Buffer)},{"./capability":336,"./response":338,_process:312,buffer:47,inherits:254,"readable-stream":353}],338:[function(t,e,i){(function(e,r,n){var a=t("./capability"),o=t("inherits"),s=t("readable-stream"),l=i.readyStates={UNSENT:0,OPENED:1,HEADERS_RECEIVED:2,LOADING:3,DONE:4},u=i.IncomingMessage=function(t,i,o,l){var u=this;if(s.Readable.call(u),u._mode=o,u.headers={},u.rawHeaders=[],u.trailers={},u.rawTrailers=[],u.on("end",(function(){e.nextTick((function(){u.emit("close")}))})),"fetch"===o){if(u._fetchResponse=i,u.url=i.url,u.statusCode=i.status,u.statusMessage=i.statusText,i.headers.forEach((function(t,e){u.headers[e.toLowerCase()]=t,u.rawHeaders.push(e,t)})),a.writableStream){var f=new WritableStream({write:function(t){return new Promise((function(e,r){u._destroyed?r():u.push(n.from(t))?e():u._resumeFetch=e}))},close:function(){r.clearTimeout(l),u._destroyed||u.push(null)},abort:function(t){u._destroyed||u.emit("error",t)}});try{return void i.body.pipeTo(f).catch((function(t){r.clearTimeout(l),u._destroyed||u.emit("error",t)}))}catch(t){}}var h=i.body.getReader();!function t(){h.read().then((function(e){if(!u._destroyed){if(e.done)return r.clearTimeout(l),void u.push(null);u.push(n.from(e.value)),t()}})).catch((function(t){r.clearTimeout(l),u._destroyed||u.emit("error",t)}))}()}else if(u._xhr=t,u._pos=0,u.url=t.responseURL,u.statusCode=t.status,u.statusMessage=t.statusText,t.getAllResponseHeaders().split(/\r?\n/).forEach((function(t){var e=t.match(/^([^:]+):\s*(.*)/);if(e){var r=e[1].toLowerCase();"set-cookie"===r?(void 0===u.headers[r]&&(u.headers[r]=[]),u.headers[r].push(e[2])):void 0!==u.headers[r]?u.headers[r]+=", "+e[2]:u.headers[r]=e[2],u.rawHeaders.push(e[1],e[2])}})),u._charset="x-user-defined",!a.overrideMimeType){var c=u.rawHeaders["mime-type"];if(c){var d=c.match(/;\s*charset=([^;])(;|$)/);d&&(u._charset=d[1].toLowerCase())}u._charset||(u._charset="utf-8")}};o(u,s.Readable),u.prototype._read=function(){var t=this._resumeFetch;t&&(this._resumeFetch=null,t())},u.prototype._onXHRProgress=function(){var t=this,e=t._xhr,i=null;switch(t._mode){case"text":if((i=e.responseText).length>t._pos){var a=i.substr(t._pos);if("x-user-defined"===t._charset){for(var o=n.alloc(a.length),s=0;s<a.length;s++)o[s]=255&a.charCodeAt(s);t.push(o)}else t.push(a,t._charset);t._pos=i.length}break;case"arraybuffer":if(e.readyState!==l.DONE||!e.response)break;i=e.response,t.push(n.from(new Uint8Array(i)));break;case"moz-chunked-arraybuffer":if(i=e.response,e.readyState!==l.LOADING||!i)break;t.push(n.from(new Uint8Array(i)));break;case"ms-stream":if(i=e.response,e.readyState!==l.LOADING)break;var u=new r.MSStreamReader;u.onprogress=function(){u.result.byteLength>t._pos&&(t.push(n.from(new Uint8Array(u.result.slice(t._pos)))),t._pos=u.result.byteLength)},u.onload=function(){t.push(null)},u.readAsArrayBuffer(i)}t._xhr.readyState===l.DONE&&"ms-stream"!==t._mode&&t.push(null)}}).call(this,t("_process"),void 0!==r.g?r.g:"undefined"!=typeof self?self:void 0!==n?n:{},t("buffer").Buffer)},{"./capability":336,_process:312,buffer:47,inherits:254,"readable-stream":353}],339:[function(t,e,r){"use strict";var n={};function i(t,e,r){r||(r=Error);var i=function(t){function r(r,n,i){return t.call(this,function(t,r,n){return"string"==typeof e?e:e(t,r,n)}(r,n,i))||this}return i=t,(n=r).prototype=Object.create(i.prototype),n.prototype.constructor=n,n.__proto__=i,r;var n,i}(r);i.prototype.name=r.name,i.prototype.code=t,n[t]=i}function a(t,e){if(Array.isArray(t)){var r=t.length;return t=t.map((function(t){return String(t)})),r>2?"one of ".concat(e," ").concat(t.slice(0,r-1).join(", "),", or ")+t[r-1]:2===r?"one of ".concat(e," ").concat(t[0]," or ").concat(t[1]):"of ".concat(e," ").concat(t[0])}return"of ".concat(e," ").concat(String(t))}i("ERR_INVALID_OPT_VALUE",(function(t,e){return'The value "'+e+'" is invalid for option "'+t+'"'}),TypeError),i("ERR_INVALID_ARG_TYPE",(function(t,e,r){var n,i,o,s;if("string"==typeof e&&(o="not ",e.substr(!s||s<0?0:+s,o.length)===o)?(n="must not be",e=e.replace(/^not /,"")):n="must be",function(t,e,r){return(void 0===r||r>t.length)&&(r=t.length),t.substring(r-e.length,r)===e}(t," argument"))i="The ".concat(t," ").concat(n," ").concat(a(e,"type"));else{var l=function(t,e,r){return"number"!=typeof r&&(r=0),!(r+e.length>t.length)&&-1!==t.indexOf(e,r)}(t,".")?"property":"argument";i='The "'.concat(t,'" ').concat(l," ").concat(n," ").concat(a(e,"type"))}return i+". Received type ".concat(typeof r)}),TypeError),i("ERR_STREAM_PUSH_AFTER_EOF","stream.push() after EOF"),i("ERR_METHOD_NOT_IMPLEMENTED",(function(t){return"The "+t+" method is not implemented"})),i("ERR_STREAM_PREMATURE_CLOSE","Premature close"),i("ERR_STREAM_DESTROYED",(function(t){return"Cannot call "+t+" after a stream was destroyed"})),i("ERR_MULTIPLE_CALLBACK","Callback called multiple times"),i("ERR_STREAM_CANNOT_PIPE","Cannot pipe, not readable"),i("ERR_STREAM_WRITE_AFTER_END","write after end"),i("ERR_STREAM_NULL_VALUES","May not write null values to stream",TypeError),i("ERR_UNKNOWN_ENCODING",(function(t){return"Unknown encoding: "+t}),TypeError),i("ERR_STREAM_UNSHIFT_AFTER_END_EVENT","stream.unshift() after end event"),e.exports.codes=n},{}],340:[function(t,e,r){(function(t){"use strict";var r=new Set;e.exports.emitExperimentalWarning=t.emitWarning?function(e){if(!r.has(e)){var n=e+" is an experimental feature. This feature could change at any time";r.add(e),t.emitWarning(n,"ExperimentalWarning")}}:function(){}}).call(this,t("_process"))},{_process:312}],341:[function(t,e,r){(function(r){"use strict";var n=Object.keys||function(t){var e=[];for(var r in t)e.push(r);return e};e.exports=u;var i=t("./_stream_readable"),a=t("./_stream_writable");t("inherits")(u,i);for(var o=n(a.prototype),s=0;s<o.length;s++){var l=o[s];u.prototype[l]||(u.prototype[l]=a.prototype[l])}function u(t){if(!(this instanceof u))return new u(t);i.call(this,t),a.call(this,t),this.allowHalfOpen=!0,t&&(!1===t.readable&&(this.readable=!1),!1===t.writable&&(this.writable=!1),!1===t.allowHalfOpen&&(this.allowHalfOpen=!1,this.once("end",f)))}function f(){this._writableState.ended||r.nextTick(h,this)}function h(t){t.end()}Object.defineProperty(u.prototype,"writableHighWaterMark",{enumerable:!1,get:function(){return this._writableState.highWaterMark}}),Object.defineProperty(u.prototype,"writableBuffer",{enumerable:!1,get:function(){return this._writableState&&this._writableState.getBuffer()}}),Object.defineProperty(u.prototype,"writableLength",{enumerable:!1,get:function(){return this._writableState.length}}),Object.defineProperty(u.prototype,"destroyed",{enumerable:!1,get:function(){return void 0!==this._readableState&&void 0!==this._writableState&&this._readableState.destroyed&&this._writableState.destroyed},set:function(t){void 0!==this._readableState&&void 0!==this._writableState&&(this._readableState.destroyed=t,this._writableState.destroyed=t)}})}).call(this,t("_process"))},{"./_stream_readable":343,"./_stream_writable":345,_process:312,inherits:254}],342:[function(t,e,r){"use strict";e.exports=i;var n=t("./_stream_transform");function i(t){if(!(this instanceof i))return new i(t);n.call(this,t)}t("inherits")(i,n),i.prototype._transform=function(t,e,r){r(null,t)}},{"./_stream_transform":344,inherits:254}],343:[function(t,e,i){(function(r,n){"use strict";var i;e.exports=k,k.ReadableState=E,t("events").EventEmitter;var a,o=function(t,e){return t.listeners(e).length},s=t("./internal/streams/stream"),l=t("buffer").Buffer,u=n.Uint8Array||function(){},f=t("util");a=f&&f.debuglog?f.debuglog("stream"):function(){};var h,c,d=t("./internal/streams/buffer_list"),p=t("./internal/streams/destroy"),b=t("./internal/streams/state").getHighWaterMark,m=t("../errors").codes,g=m.ERR_INVALID_ARG_TYPE,y=m.ERR_STREAM_PUSH_AFTER_EOF,v=m.ERR_METHOD_NOT_IMPLEMENTED,_=m.ERR_STREAM_UNSHIFT_AFTER_END_EVENT,w=t("../experimentalWarning").emitExperimentalWarning;t("inherits")(k,s);var x=["error","close","destroy","pause","resume"];function E(e,r,n){i=i||t("./_stream_duplex"),e=e||{},"boolean"!=typeof n&&(n=r instanceof i),this.objectMode=!!e.objectMode,n&&(this.objectMode=this.objectMode||!!e.readableObjectMode),this.highWaterMark=b(this,e,"readableHighWaterMark",n),this.buffer=new d,this.length=0,this.pipes=null,this.pipesCount=0,this.flowing=null,this.ended=!1,this.endEmitted=!1,this.reading=!1,this.sync=!0,this.needReadable=!1,this.emittedReadable=!1,this.readableListening=!1,this.resumeScheduled=!1,this.paused=!0,this.emitClose=!1!==e.emitClose,this.destroyed=!1,this.defaultEncoding=e.defaultEncoding||"utf8",this.awaitDrain=0,this.readingMore=!1,this.decoder=null,this.encoding=null,e.encoding&&(h||(h=t("string_decoder/").StringDecoder),this.decoder=new h(e.encoding),this.encoding=e.encoding)}function k(e){if(i=i||t("./_stream_duplex"),!(this instanceof k))return new k(e);var r=this instanceof i;this._readableState=new E(e,this,r),this.readable=!0,e&&("function"==typeof e.read&&(this._read=e.read),"function"==typeof e.destroy&&(this._destroy=e.destroy)),s.call(this)}function j(t,e,r,n,i){a("readableAddChunk",e);var o,s=t._readableState;if(null===e)s.reading=!1,function(t,e){if(!e.ended){if(e.decoder){var r=e.decoder.end();r&&r.length&&(e.buffer.push(r),e.length+=e.objectMode?1:r.length)}e.ended=!0,e.sync?I(t):(e.needReadable=!1,e.emittedReadable||(e.emittedReadable=!0,P(t)))}}(t,s);else if(i||(o=function(t,e){var r,n;return n=e,l.isBuffer(n)||n instanceof u||"string"==typeof e||void 0===e||t.objectMode||(r=new g("chunk",["string","Buffer","Uint8Array"],e)),r}(s,e)),o)t.emit("error",o);else if(s.objectMode||e&&e.length>0)if("string"==typeof e||s.objectMode||Object.getPrototypeOf(e)===l.prototype||(e=function(t){return l.from(t)}(e)),n)s.endEmitted?t.emit("error",new _):S(t,s,e,!0);else if(s.ended)t.emit("error",new y);else{if(s.destroyed)return!1;s.reading=!1,s.decoder&&!r?(e=s.decoder.write(e),s.objectMode||0!==e.length?S(t,s,e,!1):M(t,s)):S(t,s,e,!1)}else n||(s.reading=!1,M(t,s));return!s.ended&&(s.length<s.highWaterMark||0===s.length)}function S(t,e,r,n){e.flowing&&0===e.length&&!e.sync?(e.awaitDrain=0,t.emit("data",r)):(e.length+=e.objectMode?1:r.length,n?e.buffer.unshift(r):e.buffer.push(r),e.needReadable&&I(t)),M(t,e)}Object.defineProperty(k.prototype,"destroyed",{enumerable:!1,get:function(){return void 0!==this._readableState&&this._readableState.destroyed},set:function(t){this._readableState&&(this._readableState.destroyed=t)}}),k.prototype.destroy=p.destroy,k.prototype._undestroy=p.undestroy,k.prototype._destroy=function(t,e){e(t)},k.prototype.push=function(t,e){var r,n=this._readableState;return n.objectMode?r=!0:"string"==typeof t&&((e=e||n.defaultEncoding)!==n.encoding&&(t=l.from(t,e),e=""),r=!0),j(this,t,e,!1,r)},k.prototype.unshift=function(t){return j(this,t,null,!0,!1)},k.prototype.isPaused=function(){return!1===this._readableState.flowing},k.prototype.setEncoding=function(e){return h||(h=t("string_decoder/").StringDecoder),this._readableState.decoder=new h(e),this._readableState.encoding=this._readableState.decoder.encoding,this};var A=8388608;function T(t,e){return t<=0||0===e.length&&e.ended?0:e.objectMode?1:t!=t?e.flowing&&e.length?e.buffer.head.data.length:e.length:(t>e.highWaterMark&&(e.highWaterMark=function(t){return t>=A?t=A:(t--,t|=t>>>1,t|=t>>>2,t|=t>>>4,t|=t>>>8,t|=t>>>16,t++),t}(t)),t<=e.length?t:e.ended?e.length:(e.needReadable=!0,0))}function I(t){var e=t._readableState;e.needReadable=!1,e.emittedReadable||(a("emitReadable",e.flowing),e.emittedReadable=!0,r.nextTick(P,t))}function P(t){var e=t._readableState;a("emitReadable_",e.destroyed,e.length,e.ended),e.destroyed||!e.length&&!e.ended||t.emit("readable"),e.needReadable=!e.flowing&&!e.ended&&e.length<=e.highWaterMark,B(t)}function M(t,e){e.readingMore||(e.readingMore=!0,r.nextTick(O,t,e))}function O(t,e){for(;!e.reading&&!e.ended&&(e.length<e.highWaterMark||e.flowing&&0===e.length);){var r=e.length;if(a("maybeReadMore read 0"),t.read(0),r===e.length)break}e.readingMore=!1}function R(t){var e=t._readableState;e.readableListening=t.listenerCount("readable")>0,e.resumeScheduled&&!e.paused?e.flowing=!0:t.listenerCount("data")>0&&t.resume()}function L(t){a("readable nexttick read 0"),t.read(0)}function C(t,e){a("resume",e.reading),e.reading||t.read(0),e.resumeScheduled=!1,t.emit("resume"),B(t),e.flowing&&!e.reading&&t.read(0)}function B(t){var e=t._readableState;for(a("flow",e.flowing);e.flowing&&null!==t.read(););}function D(t,e){return 0===e.length?null:(e.objectMode?r=e.buffer.shift():!t||t>=e.length?(r=e.decoder?e.buffer.join(""):1===e.buffer.length?e.buffer.first():e.buffer.concat(e.length),e.buffer.clear()):r=e.buffer.consume(t,e.decoder),r);var r}function N(t){var e=t._readableState;a("endReadable",e.endEmitted),e.endEmitted||(e.ended=!0,r.nextTick(U,e,t))}function U(t,e){a("endReadableNT",t.endEmitted,t.length),t.endEmitted||0!==t.length||(t.endEmitted=!0,e.readable=!1,e.emit("end"))}function z(t,e){for(var r=0,n=t.length;r<n;r++)if(t[r]===e)return r;return-1}k.prototype.read=function(t){a("read",t),t=parseInt(t,10);var e=this._readableState,r=t;if(0!==t&&(e.emittedReadable=!1),0===t&&e.needReadable&&((0!==e.highWaterMark?e.length>=e.highWaterMark:e.length>0)||e.ended))return a("read: emitReadable",e.length,e.ended),0===e.length&&e.ended?N(this):I(this),null;if(0===(t=T(t,e))&&e.ended)return 0===e.length&&N(this),null;var n,i=e.needReadable;return a("need readable",i),(0===e.length||e.length-t<e.highWaterMark)&&a("length less than watermark",i=!0),e.ended||e.reading?a("reading or ended",i=!1):i&&(a("do read"),e.reading=!0,e.sync=!0,0===e.length&&(e.needReadable=!0),this._read(e.highWaterMark),e.sync=!1,e.reading||(t=T(r,e))),null===(n=t>0?D(t,e):null)?(e.needReadable=!0,t=0):(e.length-=t,e.awaitDrain=0),0===e.length&&(e.ended||(e.needReadable=!0),r!==t&&e.ended&&N(this)),null!==n&&this.emit("data",n),n},k.prototype._read=function(t){this.emit("error",new v("_read()"))},k.prototype.pipe=function(t,e){var n=this,i=this._readableState;switch(i.pipesCount){case 0:i.pipes=t;break;case 1:i.pipes=[i.pipes,t];break;default:i.pipes.push(t)}i.pipesCount+=1,a("pipe count=%d opts=%j",i.pipesCount,e);var s=e&&!1===e.end||t===r.stdout||t===r.stderr?m:u;function l(e,r){a("onunpipe"),e===n&&r&&!1===r.hasUnpiped&&(r.hasUnpiped=!0,a("cleanup"),t.removeListener("close",p),t.removeListener("finish",b),t.removeListener("drain",f),t.removeListener("error",d),t.removeListener("unpipe",l),n.removeListener("end",u),n.removeListener("end",m),n.removeListener("data",c),h=!0,!i.awaitDrain||t._writableState&&!t._writableState.needDrain||f())}function u(){a("onend"),t.end()}i.endEmitted?r.nextTick(s):n.once("end",s),t.on("unpipe",l);var f=function(t){return function(){var e=t._readableState;a("pipeOnDrain",e.awaitDrain),e.awaitDrain&&e.awaitDrain--,0===e.awaitDrain&&o(t,"data")&&(e.flowing=!0,B(t))}}(n);t.on("drain",f);var h=!1;function c(e){a("ondata");var r=t.write(e);a("dest.write",r),!1===r&&((1===i.pipesCount&&i.pipes===t||i.pipesCount>1&&-1!==z(i.pipes,t))&&!h&&(a("false write response, pause",i.awaitDrain),i.awaitDrain++),n.pause())}function d(e){a("onerror",e),m(),t.removeListener("error",d),0===o(t,"error")&&t.emit("error",e)}function p(){t.removeListener("finish",b),m()}function b(){a("onfinish"),t.removeListener("close",p),m()}function m(){a("unpipe"),n.unpipe(t)}return n.on("data",c),function(t,e,r){if("function"==typeof t.prependListener)return t.prependListener(e,r);t._events&&t._events[e]?Array.isArray(t._events[e])?t._events[e].unshift(r):t._events[e]=[r,t._events[e]]:t.on(e,r)}(t,"error",d),t.once("close",p),t.once("finish",b),t.emit("pipe",n),i.flowing||(a("pipe resume"),n.resume()),t},k.prototype.unpipe=function(t){var e=this._readableState,r={hasUnpiped:!1};if(0===e.pipesCount)return this;if(1===e.pipesCount)return t&&t!==e.pipes||(t||(t=e.pipes),e.pipes=null,e.pipesCount=0,e.flowing=!1,t&&t.emit("unpipe",this,r)),this;if(!t){var n=e.pipes,i=e.pipesCount;e.pipes=null,e.pipesCount=0,e.flowing=!1;for(var a=0;a<i;a++)n[a].emit("unpipe",this,{hasUnpiped:!1});return this}var o=z(e.pipes,t);return-1===o||(e.pipes.splice(o,1),e.pipesCount-=1,1===e.pipesCount&&(e.pipes=e.pipes[0]),t.emit("unpipe",this,r)),this},k.prototype.on=function(t,e){var n=s.prototype.on.call(this,t,e),i=this._readableState;return"data"===t?(i.readableListening=this.listenerCount("readable")>0,!1!==i.flowing&&this.resume()):"readable"===t&&(i.endEmitted||i.readableListening||(i.readableListening=i.needReadable=!0,i.flowing=!1,i.emittedReadable=!1,a("on readable",i.length,i.reading),i.length?I(this):i.reading||r.nextTick(L,this))),n},k.prototype.addListener=k.prototype.on,k.prototype.removeListener=function(t,e){var n=s.prototype.removeListener.call(this,t,e);return"readable"===t&&r.nextTick(R,this),n},k.prototype.removeAllListeners=function(t){var e=s.prototype.removeAllListeners.apply(this,arguments);return"readable"!==t&&void 0!==t||r.nextTick(R,this),e},k.prototype.resume=function(){var t=this._readableState;return t.flowing||(a("resume"),t.flowing=!t.readableListening,function(t,e){e.resumeScheduled||(e.resumeScheduled=!0,r.nextTick(C,t,e))}(this,t)),t.paused=!1,this},k.prototype.pause=function(){return a("call pause flowing=%j",this._readableState.flowing),!1!==this._readableState.flowing&&(a("pause"),this._readableState.flowing=!1,this.emit("pause")),this._readableState.paused=!0,this},k.prototype.wrap=function(t){var e=this,r=this._readableState,n=!1;for(var i in t.on("end",(function(){if(a("wrapped end"),r.decoder&&!r.ended){var t=r.decoder.end();t&&t.length&&e.push(t)}e.push(null)})),t.on("data",(function(i){a("wrapped data"),r.decoder&&(i=r.decoder.write(i)),r.objectMode&&null==i||(r.objectMode||i&&i.length)&&(e.push(i)||(n=!0,t.pause()))})),t)void 0===this[i]&&"function"==typeof t[i]&&(this[i]=function(e){return function(){return t[e].apply(t,arguments)}}(i));for(var o=0;o<x.length;o++)t.on(x[o],this.emit.bind(this,x[o]));return this._read=function(e){a("wrapped _read",e),n&&(n=!1,t.resume())},this},"function"==typeof Symbol&&(k.prototype[Symbol.asyncIterator]=function(){return w("Readable[Symbol.asyncIterator]"),void 0===c&&(c=t("./internal/streams/async_iterator")),c(this)}),Object.defineProperty(k.prototype,"readableHighWaterMark",{enumerable:!1,get:function(){return this._readableState.highWaterMark}}),Object.defineProperty(k.prototype,"readableBuffer",{enumerable:!1,get:function(){return this._readableState&&this._readableState.buffer}}),Object.defineProperty(k.prototype,"readableFlowing",{enumerable:!1,get:function(){return this._readableState.flowing},set:function(t){this._readableState&&(this._readableState.flowing=t)}}),k._fromList=D,Object.defineProperty(k.prototype,"readableLength",{enumerable:!1,get:function(){return this._readableState.length}})}).call(this,t("_process"),void 0!==r.g?r.g:"undefined"!=typeof self?self:void 0!==n?n:{})},{"../errors":339,"../experimentalWarning":340,"./_stream_duplex":341,"./internal/streams/async_iterator":346,"./internal/streams/buffer_list":347,"./internal/streams/destroy":348,"./internal/streams/state":351,"./internal/streams/stream":352,_process:312,buffer:47,events:239,inherits:254,"string_decoder/":354,util:32}],344:[function(t,e,r){"use strict";e.exports=f;var n=t("../errors").codes,i=n.ERR_METHOD_NOT_IMPLEMENTED,a=n.ERR_MULTIPLE_CALLBACK,o=n.ERR_TRANSFORM_ALREADY_TRANSFORMING,s=n.ERR_TRANSFORM_WITH_LENGTH_0,l=t("./_stream_duplex");function u(t,e){var r=this._transformState;r.transforming=!1;var n=r.writecb;if(null===n)return this.emit("error",new a);r.writechunk=null,r.writecb=null,null!=e&&this.push(e),n(t);var i=this._readableState;i.reading=!1,(i.needReadable||i.length<i.highWaterMark)&&this._read(i.highWaterMark)}function f(t){if(!(this instanceof f))return new f(t);l.call(this,t),this._transformState={afterTransform:u.bind(this),needTransform:!1,transforming:!1,writecb:null,writechunk:null,writeencoding:null},this._readableState.needReadable=!0,this._readableState.sync=!1,t&&("function"==typeof t.transform&&(this._transform=t.transform),"function"==typeof t.flush&&(this._flush=t.flush)),this.on("prefinish",h)}function h(){var t=this;"function"!=typeof this._flush||this._readableState.destroyed?c(this,null,null):this._flush((function(e,r){c(t,e,r)}))}function c(t,e,r){if(e)return t.emit("error",e);if(null!=r&&t.push(r),t._writableState.length)throw new s;if(t._transformState.transforming)throw new o;return t.push(null)}t("inherits")(f,l),f.prototype.push=function(t,e){return this._transformState.needTransform=!1,l.prototype.push.call(this,t,e)},f.prototype._transform=function(t,e,r){r(new i("_transform()"))},f.prototype._write=function(t,e,r){var n=this._transformState;if(n.writecb=r,n.writechunk=t,n.writeencoding=e,!n.transforming){var i=this._readableState;(n.needTransform||i.needReadable||i.length<i.highWaterMark)&&this._read(i.highWaterMark)}},f.prototype._read=function(t){var e=this._transformState;null===e.writechunk||e.transforming?e.needTransform=!0:(e.transforming=!0,this._transform(e.writechunk,e.writeencoding,e.afterTransform))},f.prototype._destroy=function(t,e){l.prototype._destroy.call(this,t,(function(t){e(t)}))}},{"../errors":339,"./_stream_duplex":341,inherits:254}],345:[function(t,e,i){(function(r,n){"use strict";function i(t){var e=this;this.next=null,this.entry=null,this.finish=function(){!function(t,e,r){var n=t.entry;for(t.entry=null;n;){var i=n.callback;e.pendingcb--,i(r),n=n.next}e.corkedRequestsFree.next=t}(e,t)}}var a;e.exports=k,k.WritableState=E;var o,s={deprecate:t("util-deprecate")},l=t("./internal/streams/stream"),u=t("buffer").Buffer,f=n.Uint8Array||function(){},h=t("./internal/streams/destroy"),c=t("./internal/streams/state").getHighWaterMark,d=t("../errors").codes,p=d.ERR_INVALID_ARG_TYPE,b=d.ERR_METHOD_NOT_IMPLEMENTED,m=d.ERR_MULTIPLE_CALLBACK,g=d.ERR_STREAM_CANNOT_PIPE,y=d.ERR_STREAM_DESTROYED,v=d.ERR_STREAM_NULL_VALUES,_=d.ERR_STREAM_WRITE_AFTER_END,w=d.ERR_UNKNOWN_ENCODING;function x(){}function E(e,n,o){a=a||t("./_stream_duplex"),e=e||{},"boolean"!=typeof o&&(o=n instanceof a),this.objectMode=!!e.objectMode,o&&(this.objectMode=this.objectMode||!!e.writableObjectMode),this.highWaterMark=c(this,e,"writableHighWaterMark",o),this.finalCalled=!1,this.needDrain=!1,this.ending=!1,this.ended=!1,this.finished=!1,this.destroyed=!1;var s=!1===e.decodeStrings;this.decodeStrings=!s,this.defaultEncoding=e.defaultEncoding||"utf8",this.length=0,this.writing=!1,this.corked=0,this.sync=!0,this.bufferProcessing=!1,this.onwrite=function(t){!function(t,e){var n=t._writableState,i=n.sync,a=n.writecb;if("function"!=typeof a)throw new m;if(function(t){t.writing=!1,t.writecb=null,t.length-=t.writelen,t.writelen=0}(n),e)!function(t,e,n,i,a){--e.pendingcb,n?(r.nextTick(a,i),r.nextTick(M,t,e),t._writableState.errorEmitted=!0,t.emit("error",i)):(a(i),t._writableState.errorEmitted=!0,t.emit("error",i),M(t,e))}(t,n,i,e,a);else{var o=I(n)||t.destroyed;o||n.corked||n.bufferProcessing||!n.bufferedRequest||T(t,n),i?r.nextTick(A,t,n,o,a):A(t,n,o,a)}}(n,t)},this.writecb=null,this.writelen=0,this.bufferedRequest=null,this.lastBufferedRequest=null,this.pendingcb=0,this.prefinished=!1,this.errorEmitted=!1,this.emitClose=!1!==e.emitClose,this.bufferedRequestCount=0,this.corkedRequestsFree=new i(this)}function k(e){var r=this instanceof(a=a||t("./_stream_duplex"));if(!r&&!o.call(k,this))return new k(e);this._writableState=new E(e,this,r),this.writable=!0,e&&("function"==typeof e.write&&(this._write=e.write),"function"==typeof e.writev&&(this._writev=e.writev),"function"==typeof e.destroy&&(this._destroy=e.destroy),"function"==typeof e.final&&(this._final=e.final)),l.call(this)}function j(t,e,r,n,i,a){if(!r){var o=function(t,e,r){return t.objectMode||!1===t.decodeStrings||"string"!=typeof e||(e=u.from(e,r)),e}(e,n,i);n!==o&&(r=!0,i="buffer",n=o)}var s=e.objectMode?1:n.length;e.length+=s;var l=e.length<e.highWaterMark;if(l||(e.needDrain=!0),e.writing||e.corked){var f=e.lastBufferedRequest;e.lastBufferedRequest={chunk:n,encoding:i,isBuf:r,callback:a,next:null},f?f.next=e.lastBufferedRequest:e.bufferedRequest=e.lastBufferedRequest,e.bufferedRequestCount+=1}else S(t,e,!1,s,n,i,a);return l}function S(t,e,r,n,i,a,o){e.writelen=n,e.writecb=o,e.writing=!0,e.sync=!0,e.destroyed?e.onwrite(new y("write")):r?t._writev(i,e.onwrite):t._write(i,a,e.onwrite),e.sync=!1}function A(t,e,r,n){r||function(t,e){0===e.length&&e.needDrain&&(e.needDrain=!1,t.emit("drain"))}(t,e),e.pendingcb--,n(),M(t,e)}function T(t,e){e.bufferProcessing=!0;var r=e.bufferedRequest;if(t._writev&&r&&r.next){var n=e.bufferedRequestCount,a=new Array(n),o=e.corkedRequestsFree;o.entry=r;for(var s=0,l=!0;r;)a[s]=r,r.isBuf||(l=!1),r=r.next,s+=1;a.allBuffers=l,S(t,e,!0,e.length,a,"",o.finish),e.pendingcb++,e.lastBufferedRequest=null,o.next?(e.corkedRequestsFree=o.next,o.next=null):e.corkedRequestsFree=new i(e),e.bufferedRequestCount=0}else{for(;r;){var u=r.chunk,f=r.encoding,h=r.callback;if(S(t,e,!1,e.objectMode?1:u.length,u,f,h),r=r.next,e.bufferedRequestCount--,e.writing)break}null===r&&(e.lastBufferedRequest=null)}e.bufferedRequest=r,e.bufferProcessing=!1}function I(t){return t.ending&&0===t.length&&null===t.bufferedRequest&&!t.finished&&!t.writing}function P(t,e){t._final((function(r){e.pendingcb--,r&&t.emit("error",r),e.prefinished=!0,t.emit("prefinish"),M(t,e)}))}function M(t,e){var n=I(e);return n&&(function(t,e){e.prefinished||e.finalCalled||("function"!=typeof t._final||e.destroyed?(e.prefinished=!0,t.emit("prefinish")):(e.pendingcb++,e.finalCalled=!0,r.nextTick(P,t,e)))}(t,e),0===e.pendingcb&&(e.finished=!0,t.emit("finish"))),n}t("inherits")(k,l),E.prototype.getBuffer=function(){for(var t=this.bufferedRequest,e=[];t;)e.push(t),t=t.next;return e},function(){try{Object.defineProperty(E.prototype,"buffer",{get:s.deprecate((function(){return this.getBuffer()}),"_writableState.buffer is deprecated. Use _writableState.getBuffer instead.","DEP0003")})}catch(t){}}(),"function"==typeof Symbol&&Symbol.hasInstance&&"function"==typeof Function.prototype[Symbol.hasInstance]?(o=Function.prototype[Symbol.hasInstance],Object.defineProperty(k,Symbol.hasInstance,{value:function(t){return!!o.call(this,t)||this===k&&t&&t._writableState instanceof E}})):o=function(t){return t instanceof this},k.prototype.pipe=function(){this.emit("error",new g)},k.prototype.write=function(t,e,n){var i,a=this._writableState,o=!1,s=!a.objectMode&&(i=t,u.isBuffer(i)||i instanceof f);return s&&!u.isBuffer(t)&&(t=function(t){return u.from(t)}(t)),"function"==typeof e&&(n=e,e=null),s?e="buffer":e||(e=a.defaultEncoding),"function"!=typeof n&&(n=x),a.ending?function(t,e){var n=new _;t.emit("error",n),r.nextTick(e,n)}(this,n):(s||function(t,e,n,i){var a;return null===n?a=new v:"string"==typeof n||e.objectMode||(a=new p("chunk",["string","Buffer"],n)),!a||(t.emit("error",a),r.nextTick(i,a),!1)}(this,a,t,n))&&(a.pendingcb++,o=j(this,a,s,t,e,n)),o},k.prototype.cork=function(){this._writableState.corked++},k.prototype.uncork=function(){var t=this._writableState;t.corked&&(t.corked--,t.writing||t.corked||t.bufferProcessing||!t.bufferedRequest||T(this,t))},k.prototype.setDefaultEncoding=function(t){if("string"==typeof t&&(t=t.toLowerCase()),!(["hex","utf8","utf-8","ascii","binary","base64","ucs2","ucs-2","utf16le","utf-16le","raw"].indexOf((t+"").toLowerCase())>-1))throw new w(t);return this._writableState.defaultEncoding=t,this},Object.defineProperty(k.prototype,"writableBuffer",{enumerable:!1,get:function(){return this._writableState&&this._writableState.getBuffer()}}),Object.defineProperty(k.prototype,"writableHighWaterMark",{enumerable:!1,get:function(){return this._writableState.highWaterMark}}),k.prototype._write=function(t,e,r){r(new b("_write()"))},k.prototype._writev=null,k.prototype.end=function(t,e,n){var i=this._writableState;return"function"==typeof t?(n=t,t=null,e=null):"function"==typeof e&&(n=e,e=null),null!=t&&this.write(t,e),i.corked&&(i.corked=1,this.uncork()),i.ending||function(t,e,n){e.ending=!0,M(t,e),n&&(e.finished?r.nextTick(n):t.once("finish",n)),e.ended=!0,t.writable=!1}(this,i,n),this},Object.defineProperty(k.prototype,"writableLength",{enumerable:!1,get:function(){return this._writableState.length}}),Object.defineProperty(k.prototype,"destroyed",{enumerable:!1,get:function(){return void 0!==this._writableState&&this._writableState.destroyed},set:function(t){this._writableState&&(this._writableState.destroyed=t)}}),k.prototype.destroy=h.destroy,k.prototype._undestroy=h.undestroy,k.prototype._destroy=function(t,e){e(t)}}).call(this,t("_process"),void 0!==r.g?r.g:"undefined"!=typeof self?self:void 0!==n?n:{})},{"../errors":339,"./_stream_duplex":341,"./internal/streams/destroy":348,"./internal/streams/state":351,"./internal/streams/stream":352,_process:312,buffer:47,inherits:254,"util-deprecate":362}],346:[function(t,e,r){(function(r){"use strict";var n;function i(t,e,r){return e in t?Object.defineProperty(t,e,{value:r,enumerable:!0,configurable:!0,writable:!0}):t[e]=r,t}var a=t("./end-of-stream"),o=Symbol("lastResolve"),s=Symbol("lastReject"),l=Symbol("error"),u=Symbol("ended"),f=Symbol("lastPromise"),h=Symbol("handlePromise"),c=Symbol("stream");function d(t,e){return{value:t,done:e}}function p(t){var e=t[o];if(null!==e){var r=t[c].read();null!==r&&(t[f]=null,t[o]=null,t[s]=null,e(d(r,!1)))}}function b(t){r.nextTick(p,t)}var m=Object.getPrototypeOf((function(){})),g=Object.setPrototypeOf((i(n={get stream(){return this[c]},next:function(){var t=this,e=this[l];if(null!==e)return Promise.reject(e);if(this[u])return Promise.resolve(d(void 0,!0));if(this[c].destroyed)return new Promise((function(e,n){r.nextTick((function(){t[l]?n(t[l]):e(d(void 0,!0))}))}));var n,i=this[f];if(i)n=new Promise(function(t,e){return function(r,n){t.then((function(){e[u]?r(d(void 0,!0)):e[h](r,n)}),n)}}(i,this));else{var a=this[c].read();if(null!==a)return Promise.resolve(d(a,!1));n=new Promise(this[h])}return this[f]=n,n}},Symbol.asyncIterator,(function(){return this})),i(n,"return",(function(){var t=this;return new Promise((function(e,r){t[c].destroy(null,(function(t){t?r(t):e(d(void 0,!0))}))}))})),n),m);e.exports=function(t){var e,r=Object.create(g,(i(e={},c,{value:t,writable:!0}),i(e,o,{value:null,writable:!0}),i(e,s,{value:null,writable:!0}),i(e,l,{value:null,writable:!0}),i(e,u,{value:t._readableState.endEmitted,writable:!0}),i(e,h,{value:function(t,e){var n=r[c].read();n?(r[f]=null,r[o]=null,r[s]=null,t(d(n,!1))):(r[o]=t,r[s]=e)},writable:!0}),e));return r[f]=null,a(t,(function(t){if(t&&"ERR_STREAM_PREMATURE_CLOSE"!==t.code){var e=r[s];return null!==e&&(r[f]=null,r[o]=null,r[s]=null,e(t)),void(r[l]=t)}var n=r[o];null!==n&&(r[f]=null,r[o]=null,r[s]=null,n(d(void 0,!0))),r[u]=!0})),t.on("readable",b.bind(null,r)),r}}).call(this,t("_process"))},{"./end-of-stream":349,_process:312}],347:[function(t,e,r){"use strict";function n(t,e,r){return e in t?Object.defineProperty(t,e,{value:r,enumerable:!0,configurable:!0,writable:!0}):t[e]=r,t}var i=t("buffer").Buffer,a=t("util").inspect,o=a&&a.custom||"inspect";e.exports=function(){function t(){this.head=null,this.tail=null,this.length=0}var e=t.prototype;return e.push=function(t){var e={data:t,next:null};this.length>0?this.tail.next=e:this.head=e,this.tail=e,++this.length},e.unshift=function(t){var e={data:t,next:this.head};0===this.length&&(this.tail=e),this.head=e,++this.length},e.shift=function(){if(0!==this.length){var t=this.head.data;return 1===this.length?this.head=this.tail=null:this.head=this.head.next,--this.length,t}},e.clear=function(){this.head=this.tail=null,this.length=0},e.join=function(t){if(0===this.length)return"";for(var e=this.head,r=""+e.data;e=e.next;)r+=t+e.data;return r},e.concat=function(t){if(0===this.length)return i.alloc(0);for(var e=i.allocUnsafe(t>>>0),r=this.head,n=0;r;)a=r.data,o=e,s=n,i.prototype.copy.call(a,o,s),n+=r.data.length,r=r.next;var a,o,s;return e},e.consume=function(t,e){var r;return t<this.head.data.length?(r=this.head.data.slice(0,t),this.head.data=this.head.data.slice(t)):r=t===this.head.data.length?this.shift():e?this._getString(t):this._getBuffer(t),r},e.first=function(){return this.head.data},e._getString=function(t){var e=this.head,r=1,n=e.data;for(t-=n.length;e=e.next;){var i=e.data,a=t>i.length?i.length:t;if(a===i.length?n+=i:n+=i.slice(0,t),0===(t-=a)){a===i.length?(++r,e.next?this.head=e.next:this.head=this.tail=null):(this.head=e,e.data=i.slice(a));break}++r}return this.length-=r,n},e._getBuffer=function(t){var e=i.allocUnsafe(t),r=this.head,n=1;for(r.data.copy(e),t-=r.data.length;r=r.next;){var a=r.data,o=t>a.length?a.length:t;if(a.copy(e,e.length-t,0,o),0===(t-=o)){o===a.length?(++n,r.next?this.head=r.next:this.head=this.tail=null):(this.head=r,r.data=a.slice(o));break}++n}return this.length-=n,e},e[o]=function(t,e){return a(this,function(t){for(var e=1;e<arguments.length;e++){var r=null!=arguments[e]?arguments[e]:{},i=Object.keys(r);"function"==typeof Object.getOwnPropertySymbols&&(i=i.concat(Object.getOwnPropertySymbols(r).filter((function(t){return Object.getOwnPropertyDescriptor(r,t).enumerable})))),i.forEach((function(e){n(t,e,r[e])}))}return t}({},e,{depth:0,customInspect:!1}))},t}()},{buffer:47,util:32}],348:[function(t,e,r){(function(t){"use strict";function r(t,e){i(t,e),n(t)}function n(t){t._writableState&&!t._writableState.emitClose||t._readableState&&!t._readableState.emitClose||t.emit("close")}function i(t,e){t.emit("error",e)}e.exports={destroy:function(e,a){var o=this,s=this._readableState&&this._readableState.destroyed,l=this._writableState&&this._writableState.destroyed;return s||l?(a?a(e):!e||this._writableState&&this._writableState.errorEmitted||t.nextTick(i,this,e),this):(this._readableState&&(this._readableState.destroyed=!0),this._writableState&&(this._writableState.destroyed=!0),this._destroy(e||null,(function(e){!a&&e?(t.nextTick(r,o,e),o._writableState&&(o._writableState.errorEmitted=!0)):a?(t.nextTick(n,o),a(e)):t.nextTick(n,o)})),this)},undestroy:function(){this._readableState&&(this._readableState.destroyed=!1,this._readableState.reading=!1,this._readableState.ended=!1,this._readableState.endEmitted=!1),this._writableState&&(this._writableState.destroyed=!1,this._writableState.ended=!1,this._writableState.ending=!1,this._writableState.finalCalled=!1,this._writableState.prefinished=!1,this._writableState.finished=!1,this._writableState.errorEmitted=!1)}}}).call(this,t("_process"))},{_process:312}],349:[function(t,e,r){"use strict";var n=t("../../../errors").codes.ERR_STREAM_PREMATURE_CLOSE;function i(){}e.exports=function t(e,r,a){if("function"==typeof r)return t(e,null,r);r||(r={}),a=function(t){var e=!1;return function(){if(!e){e=!0;for(var r=arguments.length,n=new Array(r),i=0;i<r;i++)n[i]=arguments[i];t.apply(this,n)}}}(a||i);var o=r.readable||!1!==r.readable&&e.readable,s=r.writable||!1!==r.writable&&e.writable,l=function(){e.writable||f()},u=e._writableState&&e._writableState.finished,f=function(){s=!1,u=!0,o||a.call(e)},h=e._readableState&&e._readableState.endEmitted,c=function(){o=!1,h=!0,s||a.call(e)},d=function(t){a.call(e,t)},p=function(){var t;return o&&!h?(e._readableState&&e._readableState.ended||(t=new n),a.call(e,t)):s&&!u?(e._writableState&&e._writableState.ended||(t=new n),a.call(e,t)):void 0},b=function(){e.req.on("finish",f)};return function(t){return t.setHeader&&"function"==typeof t.abort}(e)?(e.on("complete",f),e.on("abort",p),e.req?b():e.on("request",b)):s&&!e._writableState&&(e.on("end",l),e.on("close",l)),e.on("end",c),e.on("finish",f),!1!==r.error&&e.on("error",d),e.on("close",p),function(){e.removeListener("complete",f),e.removeListener("abort",p),e.removeListener("request",b),e.req&&e.req.removeListener("finish",f),e.removeListener("end",l),e.removeListener("close",l),e.removeListener("finish",f),e.removeListener("end",c),e.removeListener("error",d),e.removeListener("close",p)}}},{"../../../errors":339}],350:[function(t,e,r){"use strict";var n,i=t("../../../errors").codes,a=i.ERR_MISSING_ARGS,o=i.ERR_STREAM_DESTROYED;function s(t){if(t)throw t}function l(t){t()}function u(t,e){return t.pipe(e)}e.exports=function(){for(var e=arguments.length,r=new Array(e),i=0;i<e;i++)r[i]=arguments[i];var f,h=function(t){return t.length?"function"!=typeof t[t.length-1]?s:t.pop():s}(r);if(Array.isArray(r[0])&&(r=r[0]),r.length<2)throw new a("streams");var c=r.map((function(e,i){var a=i<r.length-1;return function(e,r,i,a){a=function(t){var e=!1;return function(){e||(e=!0,t.apply(void 0,arguments))}}(a);var s=!1;e.on("close",(function(){s=!0})),void 0===n&&(n=t("./end-of-stream")),n(e,{readable:r,writable:i},(function(t){if(t)return a(t);s=!0,a()}));var l=!1;return function(t){if(!s&&!l)return l=!0,function(t){return t.setHeader&&"function"==typeof t.abort}(e)?e.abort():"function"==typeof e.destroy?e.destroy():void a(t||new o("pipe"))}}(e,a,i>0,(function(t){f||(f=t),t&&c.forEach(l),a||(c.forEach(l),h(f))}))}));return r.reduce(u)}},{"../../../errors":339,"./end-of-stream":349}],351:[function(t,e,r){"use strict";var n=t("../../../errors").codes.ERR_INVALID_OPT_VALUE;e.exports={getHighWaterMark:function(t,e,r,i){var a=function(t,e,r){return null!=t.highWaterMark?t.highWaterMark:e?t[r]:null}(e,i,r);if(null!=a){if(!isFinite(a)||Math.floor(a)!==a||a<0)throw new n(i?r:"highWaterMark",a);return Math.floor(a)}return t.objectMode?16:16384}}},{"../../../errors":339}],352:[function(t,e,r){arguments[4][325][0].apply(r,arguments)},{dup:325,events:239}],353:[function(t,e,r){(r=e.exports=t("./lib/_stream_readable.js")).Stream=r,r.Readable=r,r.Writable=t("./lib/_stream_writable.js"),r.Duplex=t("./lib/_stream_duplex.js"),r.Transform=t("./lib/_stream_transform.js"),r.PassThrough=t("./lib/_stream_passthrough.js"),r.finished=t("./lib/internal/streams/end-of-stream.js"),r.pipeline=t("./lib/internal/streams/pipeline.js")},{"./lib/_stream_duplex.js":341,"./lib/_stream_passthrough.js":342,"./lib/_stream_readable.js":343,"./lib/_stream_transform.js":344,"./lib/_stream_writable.js":345,"./lib/internal/streams/end-of-stream.js":349,"./lib/internal/streams/pipeline.js":350}],354:[function(t,e,r){arguments[4][327][0].apply(r,arguments)},{dup:327,"safe-buffer":333}],355:[function(t,e,r){(function(e,i){var a=t("process/browser.js").nextTick,o=Function.prototype.apply,s=Array.prototype.slice,l={},u=0;function f(t,e){this._id=t,this._clearFn=e}r.setTimeout=function(){return new f(o.call(setTimeout,n,arguments),clearTimeout)},r.setInterval=function(){return new f(o.call(setInterval,n,arguments),clearInterval)},r.clearTimeout=r.clearInterval=function(t){t.close()},f.prototype.unref=f.prototype.ref=function(){},f.prototype.close=function(){this._clearFn.call(n,this._id)},r.enroll=function(t,e){clearTimeout(t._idleTimeoutId),t._idleTimeout=e},r.unenroll=function(t){clearTimeout(t._idleTimeoutId),t._idleTimeout=-1},r._unrefActive=r.active=function(t){clearTimeout(t._idleTimeoutId);var e=t._idleTimeout;e>=0&&(t._idleTimeoutId=setTimeout((function(){t._onTimeout&&t._onTimeout()}),e))},r.setImmediate="function"==typeof e?e:function(t){var e=u++,n=!(arguments.length<2)&&s.call(arguments,1);return l[e]=!0,a((function(){l[e]&&(n?t.apply(null,n):t.call(null),r.clearImmediate(e))})),e},r.clearImmediate="function"==typeof i?i:function(t){delete l[t]}}).call(this,t("timers").setImmediate,t("timers").clearImmediate)},{"process/browser.js":312,timers:355}],356:[function(t,e,r){(function(t){"use strict";Object.defineProperty(r,"__esModule",{value:!0});var e="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t};r.clone=s,r.addLast=f,r.addFirst=h,r.removeLast=c,r.removeFirst=d,r.insert=p,r.removeAt=b,r.replaceAt=m,r.getIn=g,r.set=y,r.setIn=_,r.update=w,r.updateIn=x,r.merge=E,r.mergeDeep=k,r.mergeIn=j,r.omit=S,r.addDefaults=A;var n="INVALID_ARGS";function i(t){throw new Error(t)}function a(t){var e=Object.keys(t);return Object.getOwnPropertySymbols?e.concat(Object.getOwnPropertySymbols(t)):e}var o={}.hasOwnProperty;function s(t){if(Array.isArray(t))return t.slice();for(var e=a(t),r={},n=0;n<e.length;n++){var i=e[n];r[i]=t[i]}return r}function l(e,r,o){var f=o;null==f&&i("production"!==t.env.NODE_ENV?"At least one object should be provided to merge()":n);for(var h=!1,c=arguments.length,d=Array(c>3?c-3:0),p=3;p<c;p++)d[p-3]=arguments[p];for(var b=0;b<d.length;b++){var m=d[b];if(null!=m){var g=a(m);if(g.length)for(var y=0;y<=g.length;y++){var v=g[y];if(!e||void 0===f[v]){var _=m[v];r&&u(f[v])&&u(_)&&(_=l(e,r,f[v],_)),void 0!==_&&_!==f[v]&&(h||(h=!0,f=s(f)),f[v]=_)}}}}return f}function u(t){var r=void 0===t?"undefined":e(t);return null!=t&&"object"===r}function f(t,e){return Array.isArray(e)?t.concat(e):t.concat([e])}function h(t,e){return Array.isArray(e)?e.concat(t):[e].concat(t)}function c(t){return t.length?t.slice(0,t.length-1):t}function d(t){return t.length?t.slice(1):t}function p(t,e,r){return t.slice(0,e).concat(Array.isArray(r)?r:[r]).concat(t.slice(e))}function b(t,e){return e>=t.length||e<0?t:t.slice(0,e).concat(t.slice(e+1))}function m(t,e,r){if(t[e]===r)return t;for(var n=t.length,i=Array(n),a=0;a<n;a++)i[a]=t[a];return i[e]=r,i}function g(e,r){if(!Array.isArray(r)&&i("production"!==t.env.NODE_ENV?"A path array should be provided when calling getIn()":n),null!=e){for(var a=e,o=0;o<r.length;o++){var s=r[o];if(void 0===(a=null!=a?a[s]:void 0))return a}return a}}function y(t,e,r){var n=null==t?"number"==typeof e?[]:{}:t;if(n[e]===r)return n;var i=s(n);return i[e]=r,i}function v(t,e,r,n){var i=e[n];return y(t,i,n===e.length-1?r:v(u(t)&&u(t[i])?t[i]:"number"==typeof e[n+1]?[]:{},e,r,n+1))}function _(t,e,r){return e.length?v(t,e,r,0):r}function w(t,e,r){return y(t,e,r(null==t?void 0:t[e]))}function x(t,e,r){return _(t,e,r(g(t,e)))}function E(t,e,r,n,i,a){for(var o=arguments.length,s=Array(o>6?o-6:0),u=6;u<o;u++)s[u-6]=arguments[u];return s.length?l.call.apply(l,[null,!1,!1,t,e,r,n,i,a].concat(s)):l(!1,!1,t,e,r,n,i,a)}function k(t,e,r,n,i,a){for(var o=arguments.length,s=Array(o>6?o-6:0),u=6;u<o;u++)s[u-6]=arguments[u];return s.length?l.call.apply(l,[null,!1,!0,t,e,r,n,i,a].concat(s)):l(!1,!0,t,e,r,n,i,a)}function j(t,e,r,n,i,a,o){var s=g(t,e);null==s&&(s={});for(var u=arguments.length,f=Array(u>7?u-7:0),h=7;h<u;h++)f[h-7]=arguments[h];return _(t,e,f.length?l.call.apply(l,[null,!1,!1,s,r,n,i,a,o].concat(f)):l(!1,!1,s,r,n,i,a,o))}function S(t,e){for(var r=Array.isArray(e)?e:[e],n=!1,i=0;i<r.length;i++)if(o.call(t,r[i])){n=!0;break}if(!n)return t;for(var s={},l=a(t),u=0;u<l.length;u++){var f=l[u];r.indexOf(f)>=0||(s[f]=t[f])}return s}function A(t,e,r,n,i,a){for(var o=arguments.length,s=Array(o>6?o-6:0),u=6;u<o;u++)s[u-6]=arguments[u];return s.length?l.call.apply(l,[null,!0,!1,t,e,r,n,i,a].concat(s)):l(!0,!1,t,e,r,n,i,a)}var T={clone:s,addLast:f,addFirst:h,removeLast:c,removeFirst:d,insert:p,removeAt:b,replaceAt:m,getIn:g,set:y,setIn:_,update:w,updateIn:x,merge:E,mergeDeep:k,mergeIn:j,omit:S,addDefaults:A};r.default=T}).call(this,t("_process"))},{_process:312}],357:[function(t,e,r){!function(t){var r=/^\s+/,i=/\s+$/,a=0,o=t.round,s=t.min,l=t.max,u=t.random;function f(e,n){if(n=n||{},(e=e||"")instanceof f)return e;if(!(this instanceof f))return new f(e,n);var u=function(e){var n,a,o,u={r:0,g:0,b:0},f=1,h=null,c=null,d=null,p=!1,b=!1;return"string"==typeof e&&(e=function(t){t=t.replace(r,"").replace(i,"").toLowerCase();var e,n=!1;if(T[t])t=T[t],n=!0;else if("transparent"==t)return{r:0,g:0,b:0,a:0,format:"name"};return(e=F.rgb.exec(t))?{r:e[1],g:e[2],b:e[3]}:(e=F.rgba.exec(t))?{r:e[1],g:e[2],b:e[3],a:e[4]}:(e=F.hsl.exec(t))?{h:e[1],s:e[2],l:e[3]}:(e=F.hsla.exec(t))?{h:e[1],s:e[2],l:e[3],a:e[4]}:(e=F.hsv.exec(t))?{h:e[1],s:e[2],v:e[3]}:(e=F.hsva.exec(t))?{h:e[1],s:e[2],v:e[3],a:e[4]}:(e=F.hex8.exec(t))?{r:R(e[1]),g:R(e[2]),b:R(e[3]),a:D(e[4]),format:n?"name":"hex8"}:(e=F.hex6.exec(t))?{r:R(e[1]),g:R(e[2]),b:R(e[3]),format:n?"name":"hex"}:(e=F.hex4.exec(t))?{r:R(e[1]+""+e[1]),g:R(e[2]+""+e[2]),b:R(e[3]+""+e[3]),a:D(e[4]+""+e[4]),format:n?"name":"hex8"}:!!(e=F.hex3.exec(t))&&{r:R(e[1]+""+e[1]),g:R(e[2]+""+e[2]),b:R(e[3]+""+e[3]),format:n?"name":"hex"}}(e)),"object"==typeof e&&(H(e.r)&&H(e.g)&&H(e.b)?(n=e.r,a=e.g,o=e.b,u={r:255*M(n,255),g:255*M(a,255),b:255*M(o,255)},p=!0,b="%"===String(e.r).substr(-1)?"prgb":"rgb"):H(e.h)&&H(e.s)&&H(e.v)?(h=C(e.s),c=C(e.v),u=function(e,r,n){e=6*M(e,360),r=M(r,100),n=M(n,100);var i=t.floor(e),a=e-i,o=n*(1-r),s=n*(1-a*r),l=n*(1-(1-a)*r),u=i%6;return{r:255*[n,s,o,o,l,n][u],g:255*[l,n,n,s,o,o][u],b:255*[o,o,l,n,n,s][u]}}(e.h,h,c),p=!0,b="hsv"):H(e.h)&&H(e.s)&&H(e.l)&&(h=C(e.s),d=C(e.l),u=function(t,e,r){var n,i,a;function o(t,e,r){return r<0&&(r+=1),r>1&&(r-=1),r<1/6?t+6*(e-t)*r:r<.5?e:r<2/3?t+(e-t)*(2/3-r)*6:t}if(t=M(t,360),e=M(e,100),r=M(r,100),0===e)n=i=a=r;else{var s=r<.5?r*(1+e):r+e-r*e,l=2*r-s;n=o(l,s,t+1/3),i=o(l,s,t),a=o(l,s,t-1/3)}return{r:255*n,g:255*i,b:255*a}}(e.h,h,d),p=!0,b="hsl"),e.hasOwnProperty("a")&&(f=e.a)),f=P(f),{ok:p,format:e.format||b,r:s(255,l(u.r,0)),g:s(255,l(u.g,0)),b:s(255,l(u.b,0)),a:f}}(e);this._originalInput=e,this._r=u.r,this._g=u.g,this._b=u.b,this._a=u.a,this._roundA=o(100*this._a)/100,this._format=n.format||u.format,this._gradientType=n.gradientType,this._r<1&&(this._r=o(this._r)),this._g<1&&(this._g=o(this._g)),this._b<1&&(this._b=o(this._b)),this._ok=u.ok,this._tc_id=a++}function h(t,e,r){t=M(t,255),e=M(e,255),r=M(r,255);var n,i,a=l(t,e,r),o=s(t,e,r),u=(a+o)/2;if(a==o)n=i=0;else{var f=a-o;switch(i=u>.5?f/(2-a-o):f/(a+o),a){case t:n=(e-r)/f+(e<r?6:0);break;case e:n=(r-t)/f+2;break;case r:n=(t-e)/f+4}n/=6}return{h:n,s:i,l:u}}function c(t,e,r){t=M(t,255),e=M(e,255),r=M(r,255);var n,i,a=l(t,e,r),o=s(t,e,r),u=a,f=a-o;if(i=0===a?0:f/a,a==o)n=0;else{switch(a){case t:n=(e-r)/f+(e<r?6:0);break;case e:n=(r-t)/f+2;break;case r:n=(t-e)/f+4}n/=6}return{h:n,s:i,v:u}}function d(t,e,r,n){var i=[L(o(t).toString(16)),L(o(e).toString(16)),L(o(r).toString(16))];return n&&i[0].charAt(0)==i[0].charAt(1)&&i[1].charAt(0)==i[1].charAt(1)&&i[2].charAt(0)==i[2].charAt(1)?i[0].charAt(0)+i[1].charAt(0)+i[2].charAt(0):i.join("")}function p(t,e,r,n){return[L(B(n)),L(o(t).toString(16)),L(o(e).toString(16)),L(o(r).toString(16))].join("")}function b(t,e){e=0===e?0:e||10;var r=f(t).toHsl();return r.s-=e/100,r.s=O(r.s),f(r)}function m(t,e){e=0===e?0:e||10;var r=f(t).toHsl();return r.s+=e/100,r.s=O(r.s),f(r)}function g(t){return f(t).desaturate(100)}function y(t,e){e=0===e?0:e||10;var r=f(t).toHsl();return r.l+=e/100,r.l=O(r.l),f(r)}function v(t,e){e=0===e?0:e||10;var r=f(t).toRgb();return r.r=l(0,s(255,r.r-o(-e/100*255))),r.g=l(0,s(255,r.g-o(-e/100*255))),r.b=l(0,s(255,r.b-o(-e/100*255))),f(r)}function _(t,e){e=0===e?0:e||10;var r=f(t).toHsl();return r.l-=e/100,r.l=O(r.l),f(r)}function w(t,e){var r=f(t).toHsl(),n=(r.h+e)%360;return r.h=n<0?360+n:n,f(r)}function x(t){var e=f(t).toHsl();return e.h=(e.h+180)%360,f(e)}function E(t){var e=f(t).toHsl(),r=e.h;return[f(t),f({h:(r+120)%360,s:e.s,l:e.l}),f({h:(r+240)%360,s:e.s,l:e.l})]}function k(t){var e=f(t).toHsl(),r=e.h;return[f(t),f({h:(r+90)%360,s:e.s,l:e.l}),f({h:(r+180)%360,s:e.s,l:e.l}),f({h:(r+270)%360,s:e.s,l:e.l})]}function j(t){var e=f(t).toHsl(),r=e.h;return[f(t),f({h:(r+72)%360,s:e.s,l:e.l}),f({h:(r+216)%360,s:e.s,l:e.l})]}function S(t,e,r){e=e||6,r=r||30;var n=f(t).toHsl(),i=360/r,a=[f(t)];for(n.h=(n.h-(i*e>>1)+720)%360;--e;)n.h=(n.h+i)%360,a.push(f(n));return a}function A(t,e){e=e||6;for(var r=f(t).toHsv(),n=r.h,i=r.s,a=r.v,o=[],s=1/e;e--;)o.push(f({h:n,s:i,v:a})),a=(a+s)%1;return o}f.prototype={isDark:function(){return this.getBrightness()<128},isLight:function(){return!this.isDark()},isValid:function(){return this._ok},getOriginalInput:function(){return this._originalInput},getFormat:function(){return this._format},getAlpha:function(){return this._a},getBrightness:function(){var t=this.toRgb();return(299*t.r+587*t.g+114*t.b)/1e3},getLuminance:function(){var e,r,n,i=this.toRgb();return e=i.r/255,r=i.g/255,n=i.b/255,.2126*(e<=.03928?e/12.92:t.pow((e+.055)/1.055,2.4))+.7152*(r<=.03928?r/12.92:t.pow((r+.055)/1.055,2.4))+.0722*(n<=.03928?n/12.92:t.pow((n+.055)/1.055,2.4))},setAlpha:function(t){return this._a=P(t),this._roundA=o(100*this._a)/100,this},toHsv:function(){var t=c(this._r,this._g,this._b);return{h:360*t.h,s:t.s,v:t.v,a:this._a}},toHsvString:function(){var t=c(this._r,this._g,this._b),e=o(360*t.h),r=o(100*t.s),n=o(100*t.v);return 1==this._a?"hsv("+e+", "+r+"%, "+n+"%)":"hsva("+e+", "+r+"%, "+n+"%, "+this._roundA+")"},toHsl:function(){var t=h(this._r,this._g,this._b);return{h:360*t.h,s:t.s,l:t.l,a:this._a}},toHslString:function(){var t=h(this._r,this._g,this._b),e=o(360*t.h),r=o(100*t.s),n=o(100*t.l);return 1==this._a?"hsl("+e+", "+r+"%, "+n+"%)":"hsla("+e+", "+r+"%, "+n+"%, "+this._roundA+")"},toHex:function(t){return d(this._r,this._g,this._b,t)},toHexString:function(t){return"#"+this.toHex(t)},toHex8:function(t){return function(t,e,r,n,i){var a=[L(o(t).toString(16)),L(o(e).toString(16)),L(o(r).toString(16)),L(B(n))];return i&&a[0].charAt(0)==a[0].charAt(1)&&a[1].charAt(0)==a[1].charAt(1)&&a[2].charAt(0)==a[2].charAt(1)&&a[3].charAt(0)==a[3].charAt(1)?a[0].charAt(0)+a[1].charAt(0)+a[2].charAt(0)+a[3].charAt(0):a.join("")}(this._r,this._g,this._b,this._a,t)},toHex8String:function(t){return"#"+this.toHex8(t)},toRgb:function(){return{r:o(this._r),g:o(this._g),b:o(this._b),a:this._a}},toRgbString:function(){return 1==this._a?"rgb("+o(this._r)+", "+o(this._g)+", "+o(this._b)+")":"rgba("+o(this._r)+", "+o(this._g)+", "+o(this._b)+", "+this._roundA+")"},toPercentageRgb:function(){return{r:o(100*M(this._r,255))+"%",g:o(100*M(this._g,255))+"%",b:o(100*M(this._b,255))+"%",a:this._a}},toPercentageRgbString:function(){return 1==this._a?"rgb("+o(100*M(this._r,255))+"%, "+o(100*M(this._g,255))+"%, "+o(100*M(this._b,255))+"%)":"rgba("+o(100*M(this._r,255))+"%, "+o(100*M(this._g,255))+"%, "+o(100*M(this._b,255))+"%, "+this._roundA+")"},toName:function(){return 0===this._a?"transparent":!(this._a<1)&&(I[d(this._r,this._g,this._b,!0)]||!1)},toFilter:function(t){var e="#"+p(this._r,this._g,this._b,this._a),r=e,n=this._gradientType?"GradientType = 1, ":"";if(t){var i=f(t);r="#"+p(i._r,i._g,i._b,i._a)}return"progid:DXImageTransform.Microsoft.gradient("+n+"startColorstr="+e+",endColorstr="+r+")"},toString:function(t){var e=!!t;t=t||this._format;var r=!1,n=this._a<1&&this._a>=0;return e||!n||"hex"!==t&&"hex6"!==t&&"hex3"!==t&&"hex4"!==t&&"hex8"!==t&&"name"!==t?("rgb"===t&&(r=this.toRgbString()),"prgb"===t&&(r=this.toPercentageRgbString()),"hex"!==t&&"hex6"!==t||(r=this.toHexString()),"hex3"===t&&(r=this.toHexString(!0)),"hex4"===t&&(r=this.toHex8String(!0)),"hex8"===t&&(r=this.toHex8String()),"name"===t&&(r=this.toName()),"hsl"===t&&(r=this.toHslString()),"hsv"===t&&(r=this.toHsvString()),r||this.toHexString()):"name"===t&&0===this._a?this.toName():this.toRgbString()},clone:function(){return f(this.toString())},_applyModification:function(t,e){var r=t.apply(null,[this].concat([].slice.call(e)));return this._r=r._r,this._g=r._g,this._b=r._b,this.setAlpha(r._a),this},lighten:function(){return this._applyModification(y,arguments)},brighten:function(){return this._applyModification(v,arguments)},darken:function(){return this._applyModification(_,arguments)},desaturate:function(){return this._applyModification(b,arguments)},saturate:function(){return this._applyModification(m,arguments)},greyscale:function(){return this._applyModification(g,arguments)},spin:function(){return this._applyModification(w,arguments)},_applyCombination:function(t,e){return t.apply(null,[this].concat([].slice.call(e)))},analogous:function(){return this._applyCombination(S,arguments)},complement:function(){return this._applyCombination(x,arguments)},monochromatic:function(){return this._applyCombination(A,arguments)},splitcomplement:function(){return this._applyCombination(j,arguments)},triad:function(){return this._applyCombination(E,arguments)},tetrad:function(){return this._applyCombination(k,arguments)}},f.fromRatio=function(t,e){if("object"==typeof t){var r={};for(var n in t)t.hasOwnProperty(n)&&(r[n]="a"===n?t[n]:C(t[n]));t=r}return f(t,e)},f.equals=function(t,e){return!(!t||!e)&&f(t).toRgbString()==f(e).toRgbString()},f.random=function(){return f.fromRatio({r:u(),g:u(),b:u()})},f.mix=function(t,e,r){r=0===r?0:r||50;var n=f(t).toRgb(),i=f(e).toRgb(),a=r/100;return f({r:(i.r-n.r)*a+n.r,g:(i.g-n.g)*a+n.g,b:(i.b-n.b)*a+n.b,a:(i.a-n.a)*a+n.a})},f.readability=function(e,r){var n=f(e),i=f(r);return(t.max(n.getLuminance(),i.getLuminance())+.05)/(t.min(n.getLuminance(),i.getLuminance())+.05)},f.isReadable=function(t,e,r){var n,i,a,o,s,l=f.readability(t,e);switch(i=!1,(a=r,"AA"!==(o=((a=a||{level:"AA",size:"small"}).level||"AA").toUpperCase())&&"AAA"!==o&&(o="AA"),"small"!==(s=(a.size||"small").toLowerCase())&&"large"!==s&&(s="small"),n={level:o,size:s}).level+n.size){case"AAsmall":case"AAAlarge":i=l>=4.5;break;case"AAlarge":i=l>=3;break;case"AAAsmall":i=l>=7}return i},f.mostReadable=function(t,e,r){var n,i,a,o,s=null,l=0;i=(r=r||{}).includeFallbackColors,a=r.level,o=r.size;for(var u=0;u<e.length;u++)(n=f.readability(t,e[u]))>l&&(l=n,s=f(e[u]));return f.isReadable(t,s,{level:a,size:o})||!i?s:(r.includeFallbackColors=!1,f.mostReadable(t,["#fff","#000"],r))};var T=f.names={aliceblue:"f0f8ff",antiquewhite:"faebd7",aqua:"0ff",aquamarine:"7fffd4",azure:"f0ffff",beige:"f5f5dc",bisque:"ffe4c4",black:"000",blanchedalmond:"ffebcd",blue:"00f",blueviolet:"8a2be2",brown:"a52a2a",burlywood:"deb887",burntsienna:"ea7e5d",cadetblue:"5f9ea0",chartreuse:"7fff00",chocolate:"d2691e",coral:"ff7f50",cornflowerblue:"6495ed",cornsilk:"fff8dc",crimson:"dc143c",cyan:"0ff",darkblue:"00008b",darkcyan:"008b8b",darkgoldenrod:"b8860b",darkgray:"a9a9a9",darkgreen:"006400",darkgrey:"a9a9a9",darkkhaki:"bdb76b",darkmagenta:"8b008b",darkolivegreen:"556b2f",darkorange:"ff8c00",darkorchid:"9932cc",darkred:"8b0000",darksalmon:"e9967a",darkseagreen:"8fbc8f",darkslateblue:"483d8b",darkslategray:"2f4f4f",darkslategrey:"2f4f4f",darkturquoise:"00ced1",darkviolet:"9400d3",deeppink:"ff1493",deepskyblue:"00bfff",dimgray:"696969",dimgrey:"696969",dodgerblue:"1e90ff",firebrick:"b22222",floralwhite:"fffaf0",forestgreen:"228b22",fuchsia:"f0f",gainsboro:"dcdcdc",ghostwhite:"f8f8ff",gold:"ffd700",goldenrod:"daa520",gray:"808080",green:"008000",greenyellow:"adff2f",grey:"808080",honeydew:"f0fff0",hotpink:"ff69b4",indianred:"cd5c5c",indigo:"4b0082",ivory:"fffff0",khaki:"f0e68c",lavender:"e6e6fa",lavenderblush:"fff0f5",lawngreen:"7cfc00",lemonchiffon:"fffacd",lightblue:"add8e6",lightcoral:"f08080",lightcyan:"e0ffff",lightgoldenrodyellow:"fafad2",lightgray:"d3d3d3",lightgreen:"90ee90",lightgrey:"d3d3d3",lightpink:"ffb6c1",lightsalmon:"ffa07a",lightseagreen:"20b2aa",lightskyblue:"87cefa",lightslategray:"789",lightslategrey:"789",lightsteelblue:"b0c4de",lightyellow:"ffffe0",lime:"0f0",limegreen:"32cd32",linen:"faf0e6",magenta:"f0f",maroon:"800000",mediumaquamarine:"66cdaa",mediumblue:"0000cd",mediumorchid:"ba55d3",mediumpurple:"9370db",mediumseagreen:"3cb371",mediumslateblue:"7b68ee",mediumspringgreen:"00fa9a",mediumturquoise:"48d1cc",mediumvioletred:"c71585",midnightblue:"191970",mintcream:"f5fffa",mistyrose:"ffe4e1",moccasin:"ffe4b5",navajowhite:"ffdead",navy:"000080",oldlace:"fdf5e6",olive:"808000",olivedrab:"6b8e23",orange:"ffa500",orangered:"ff4500",orchid:"da70d6",palegoldenrod:"eee8aa",palegreen:"98fb98",paleturquoise:"afeeee",palevioletred:"db7093",papayawhip:"ffefd5",peachpuff:"ffdab9",peru:"cd853f",pink:"ffc0cb",plum:"dda0dd",powderblue:"b0e0e6",purple:"800080",rebeccapurple:"663399",red:"f00",rosybrown:"bc8f8f",royalblue:"4169e1",saddlebrown:"8b4513",salmon:"fa8072",sandybrown:"f4a460",seagreen:"2e8b57",seashell:"fff5ee",sienna:"a0522d",silver:"c0c0c0",skyblue:"87ceeb",slateblue:"6a5acd",slategray:"708090",slategrey:"708090",snow:"fffafa",springgreen:"00ff7f",steelblue:"4682b4",tan:"d2b48c",teal:"008080",thistle:"d8bfd8",tomato:"ff6347",turquoise:"40e0d0",violet:"ee82ee",wheat:"f5deb3",white:"fff",whitesmoke:"f5f5f5",yellow:"ff0",yellowgreen:"9acd32"},I=f.hexNames=function(t){var e={};for(var r in t)t.hasOwnProperty(r)&&(e[t[r]]=r);return e}(T);function P(t){return t=parseFloat(t),(isNaN(t)||t<0||t>1)&&(t=1),t}function M(e,r){(function(t){return"string"==typeof t&&-1!=t.indexOf(".")&&1===parseFloat(t)})(e)&&(e="100%");var n=function(t){return"string"==typeof t&&-1!=t.indexOf("%")}(e);return e=s(r,l(0,parseFloat(e))),n&&(e=parseInt(e*r,10)/100),t.abs(e-r)<1e-6?1:e%r/parseFloat(r)}function O(t){return s(1,l(0,t))}function R(t){return parseInt(t,16)}function L(t){return 1==t.length?"0"+t:""+t}function C(t){return t<=1&&(t=100*t+"%"),t}function B(e){return t.round(255*parseFloat(e)).toString(16)}function D(t){return R(t)/255}var N,U,z,F=(U="[\\s|\\(]+("+(N="(?:[-\\+]?\\d*\\.\\d+%?)|(?:[-\\+]?\\d+%?)")+")[,|\\s]+("+N+")[,|\\s]+("+N+")\\s*\\)?",z="[\\s|\\(]+("+N+")[,|\\s]+("+N+")[,|\\s]+("+N+")[,|\\s]+("+N+")\\s*\\)?",{CSS_UNIT:new RegExp(N),rgb:new RegExp("rgb"+U),rgba:new RegExp("rgba"+z),hsl:new RegExp("hsl"+U),hsla:new RegExp("hsla"+z),hsv:new RegExp("hsv"+U),hsva:new RegExp("hsva"+z),hex3:/^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,hex6:/^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,hex4:/^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,hex8:/^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/});function H(t){return!!F.CSS_UNIT.exec(t)}void 0!==e&&e.exports?e.exports=f:n.tinycolor=f}(Math)},{}],358:[function(t,e,r){(r=e.exports=function(t){return t.replace(/^\s*|\s*$/g,"")}).left=function(t){return t.replace(/^\s*/,"")},r.right=function(t){return t.replace(/\s*$/,"")}},{}],359:[function(t,e,r){"use strict";var n=t("punycode"),i=t("./util");function a(){this.protocol=null,this.slashes=null,this.auth=null,this.host=null,this.port=null,this.hostname=null,this.hash=null,this.search=null,this.query=null,this.pathname=null,this.path=null,this.href=null}r.parse=v,r.resolve=function(t,e){return v(t,!1,!0).resolve(e)},r.resolveObject=function(t,e){return t?v(t,!1,!0).resolveObject(e):e},r.format=function(t){return i.isString(t)&&(t=v(t)),t instanceof a?t.format():a.prototype.format.call(t)},r.Url=a;var o=/^([a-z0-9.+-]+:)/i,s=/:[0-9]*$/,l=/^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,u=["{","}","|","\\","^","`"].concat(["<",">",'"',"`"," ","\r","\n","\t"]),f=["'"].concat(u),h=["%","/","?",";","#"].concat(f),c=["/","?","#"],d=/^[+a-z0-9A-Z_-]{0,63}$/,p=/^([+a-z0-9A-Z_-]{0,63})(.*)$/,b={javascript:!0,"javascript:":!0},m={javascript:!0,"javascript:":!0},g={http:!0,https:!0,ftp:!0,gopher:!0,file:!0,"http:":!0,"https:":!0,"ftp:":!0,"gopher:":!0,"file:":!0},y=t("querystring");function v(t,e,r){if(t&&i.isObject(t)&&t instanceof a)return t;var n=new a;return n.parse(t,e,r),n}a.prototype.parse=function(t,e,r){if(!i.isString(t))throw new TypeError("Parameter 'url' must be a string, not "+typeof t);var a=t.indexOf("?"),s=-1!==a&&a<t.indexOf("#")?"?":"#",u=t.split(s);u[0]=u[0].replace(/\\/g,"/");var v=t=u.join(s);if(v=v.trim(),!r&&1===t.split("#").length){var _=l.exec(v);if(_)return this.path=v,this.href=v,this.pathname=_[1],_[2]?(this.search=_[2],this.query=e?y.parse(this.search.substr(1)):this.search.substr(1)):e&&(this.search="",this.query={}),this}var w=o.exec(v);if(w){var x=(w=w[0]).toLowerCase();this.protocol=x,v=v.substr(w.length)}if(r||w||v.match(/^\/\/[^@\/]+@[^@\/]+/)){var E="//"===v.substr(0,2);!E||w&&m[w]||(v=v.substr(2),this.slashes=!0)}if(!m[w]&&(E||w&&!g[w])){for(var k,j,S=-1,A=0;A<c.length;A++)-1!==(T=v.indexOf(c[A]))&&(-1===S||T<S)&&(S=T);for(-1!==(j=-1===S?v.lastIndexOf("@"):v.lastIndexOf("@",S))&&(k=v.slice(0,j),v=v.slice(j+1),this.auth=decodeURIComponent(k)),S=-1,A=0;A<h.length;A++){var T;-1!==(T=v.indexOf(h[A]))&&(-1===S||T<S)&&(S=T)}-1===S&&(S=v.length),this.host=v.slice(0,S),v=v.slice(S),this.parseHost(),this.hostname=this.hostname||"";var I="["===this.hostname[0]&&"]"===this.hostname[this.hostname.length-1];if(!I)for(var P=this.hostname.split(/\./),M=(A=0,P.length);A<M;A++){var O=P[A];if(O&&!O.match(d)){for(var R="",L=0,C=O.length;L<C;L++)O.charCodeAt(L)>127?R+="x":R+=O[L];if(!R.match(d)){var B=P.slice(0,A),D=P.slice(A+1),N=O.match(p);N&&(B.push(N[1]),D.unshift(N[2])),D.length&&(v="/"+D.join(".")+v),this.hostname=B.join(".");break}}}this.hostname.length>255?this.hostname="":this.hostname=this.hostname.toLowerCase(),I||(this.hostname=n.toASCII(this.hostname));var U=this.port?":"+this.port:"",z=this.hostname||"";this.host=z+U,this.href+=this.host,I&&(this.hostname=this.hostname.substr(1,this.hostname.length-2),"/"!==v[0]&&(v="/"+v))}if(!b[x])for(A=0,M=f.length;A<M;A++){var F=f[A];if(-1!==v.indexOf(F)){var H=encodeURIComponent(F);H===F&&(H=escape(F)),v=v.split(F).join(H)}}var G=v.indexOf("#");-1!==G&&(this.hash=v.substr(G),v=v.slice(0,G));var q=v.indexOf("?");if(-1!==q?(this.search=v.substr(q),this.query=v.substr(q+1),e&&(this.query=y.parse(this.query)),v=v.slice(0,q)):e&&(this.search="",this.query={}),v&&(this.pathname=v),g[x]&&this.hostname&&!this.pathname&&(this.pathname="/"),this.pathname||this.search){U=this.pathname||"";var W=this.search||"";this.path=U+W}return this.href=this.format(),this},a.prototype.format=function(){var t=this.auth||"";t&&(t=(t=encodeURIComponent(t)).replace(/%3A/i,":"),t+="@");var e=this.protocol||"",r=this.pathname||"",n=this.hash||"",a=!1,o="";this.host?a=t+this.host:this.hostname&&(a=t+(-1===this.hostname.indexOf(":")?this.hostname:"["+this.hostname+"]"),this.port&&(a+=":"+this.port)),this.query&&i.isObject(this.query)&&Object.keys(this.query).length&&(o=y.stringify(this.query));var s=this.search||o&&"?"+o||"";return e&&":"!==e.substr(-1)&&(e+=":"),this.slashes||(!e||g[e])&&!1!==a?(a="//"+(a||""),r&&"/"!==r.charAt(0)&&(r="/"+r)):a||(a=""),n&&"#"!==n.charAt(0)&&(n="#"+n),s&&"?"!==s.charAt(0)&&(s="?"+s),e+a+(r=r.replace(/[?#]/g,(function(t){return encodeURIComponent(t)})))+(s=s.replace("#","%23"))+n},a.prototype.resolve=function(t){return this.resolveObject(v(t,!1,!0)).format()},a.prototype.resolveObject=function(t){if(i.isString(t)){var e=new a;e.parse(t,!1,!0),t=e}for(var r=new a,n=Object.keys(this),o=0;o<n.length;o++){var s=n[o];r[s]=this[s]}if(r.hash=t.hash,""===t.href)return r.href=r.format(),r;if(t.slashes&&!t.protocol){for(var l=Object.keys(t),u=0;u<l.length;u++){var f=l[u];"protocol"!==f&&(r[f]=t[f])}return g[r.protocol]&&r.hostname&&!r.pathname&&(r.path=r.pathname="/"),r.href=r.format(),r}if(t.protocol&&t.protocol!==r.protocol){if(!g[t.protocol]){for(var h=Object.keys(t),c=0;c<h.length;c++){var d=h[c];r[d]=t[d]}return r.href=r.format(),r}if(r.protocol=t.protocol,t.host||m[t.protocol])r.pathname=t.pathname;else{for(var p=(t.pathname||"").split("/");p.length&&!(t.host=p.shift()););t.host||(t.host=""),t.hostname||(t.hostname=""),""!==p[0]&&p.unshift(""),p.length<2&&p.unshift(""),r.pathname=p.join("/")}if(r.search=t.search,r.query=t.query,r.host=t.host||"",r.auth=t.auth,r.hostname=t.hostname||t.host,r.port=t.port,r.pathname||r.search){var b=r.pathname||"",y=r.search||"";r.path=b+y}return r.slashes=r.slashes||t.slashes,r.href=r.format(),r}var v=r.pathname&&"/"===r.pathname.charAt(0),_=t.host||t.pathname&&"/"===t.pathname.charAt(0),w=_||v||r.host&&t.pathname,x=w,E=r.pathname&&r.pathname.split("/")||[],k=(p=t.pathname&&t.pathname.split("/")||[],r.protocol&&!g[r.protocol]);if(k&&(r.hostname="",r.port=null,r.host&&(""===E[0]?E[0]=r.host:E.unshift(r.host)),r.host="",t.protocol&&(t.hostname=null,t.port=null,t.host&&(""===p[0]?p[0]=t.host:p.unshift(t.host)),t.host=null),w=w&&(""===p[0]||""===E[0])),_)r.host=t.host||""===t.host?t.host:r.host,r.hostname=t.hostname||""===t.hostname?t.hostname:r.hostname,r.search=t.search,r.query=t.query,E=p;else if(p.length)E||(E=[]),E.pop(),E=E.concat(p),r.search=t.search,r.query=t.query;else if(!i.isNullOrUndefined(t.search))return k&&(r.hostname=r.host=E.shift(),(I=!!(r.host&&r.host.indexOf("@")>0)&&r.host.split("@"))&&(r.auth=I.shift(),r.host=r.hostname=I.shift())),r.search=t.search,r.query=t.query,i.isNull(r.pathname)&&i.isNull(r.search)||(r.path=(r.pathname?r.pathname:"")+(r.search?r.search:"")),r.href=r.format(),r;if(!E.length)return r.pathname=null,r.search?r.path="/"+r.search:r.path=null,r.href=r.format(),r;for(var j=E.slice(-1)[0],S=(r.host||t.host||E.length>1)&&("."===j||".."===j)||""===j,A=0,T=E.length;T>=0;T--)"."===(j=E[T])?E.splice(T,1):".."===j?(E.splice(T,1),A++):A&&(E.splice(T,1),A--);if(!w&&!x)for(;A--;A)E.unshift("..");!w||""===E[0]||E[0]&&"/"===E[0].charAt(0)||E.unshift(""),S&&"/"!==E.join("/").substr(-1)&&E.push("");var I,P=""===E[0]||E[0]&&"/"===E[0].charAt(0);return k&&(r.hostname=r.host=P?"":E.length?E.shift():"",(I=!!(r.host&&r.host.indexOf("@")>0)&&r.host.split("@"))&&(r.auth=I.shift(),r.host=r.hostname=I.shift())),(w=w||r.host&&E.length)&&!P&&E.unshift(""),E.length?r.pathname=E.join("/"):(r.pathname=null,r.path=null),i.isNull(r.pathname)&&i.isNull(r.search)||(r.path=(r.pathname?r.pathname:"")+(r.search?r.search:"")),r.auth=t.auth||r.auth,r.slashes=r.slashes||t.slashes,r.href=r.format(),r},a.prototype.parseHost=function(){var t=this.host,e=s.exec(t);e&&(":"!==(e=e[0])&&(this.port=e.substr(1)),t=t.substr(0,t.length-e.length)),t&&(this.hostname=t)}},{"./util":360,punycode:313,querystring:316}],360:[function(t,e,r){"use strict";e.exports={isString:function(t){return"string"==typeof t},isObject:function(t){return"object"==typeof t&&null!==t},isNull:function(t){return null===t},isNullOrUndefined:function(t){return null==t}}},{}],361:[function(t,e,r){(function(r){!function(){var n={};function i(){void 0!==r&&"development"!=r.env.NODE_ENV||console.log.apply(console,arguments)}"object"==typeof e?e.exports=n:self.UTIF=n,function(t,e){var r,n,a;r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},n=function(){function t(t){this.message="JPEG error: "+t}return t.prototype=Error(),t.prototype.name="JpegError",t.constructor=t}(),a=function(){function t(t,e){this.message=t,this.g=e}return t.prototype=Error(),t.prototype.name="DNLMarkerError",t.constructor=t}(),function(){function e(){this.M=null,this.B=-1}function i(t,e){for(var r,n,i=0,a=[],o=16;0<o&&!t[o-1];)o--;a.push({children:[],index:0});var s,l=a[0];for(r=0;r<o;r++){for(n=0;n<t[r];n++){for((l=a.pop()).children[l.index]=e[i];0<l.index;)l=a.pop();for(l.index++,a.push(l);a.length<=r;)a.push(s={children:[],index:0}),l.children[l.index]=s.children,l=s;i++}r+1<o&&(a.push(s={children:[],index:0}),l.children[l.index]=s.children,l=s)}return a[0].children}function o(t,e,i,o,s,f,h,c,d){function p(){if(0<I)return I--,T>>I&1;if(255===(T=t[e++])){var r=t[e++];if(r){if(220===r&&j){e+=2;var o=t[e++]<<8|t[e++];if(0<o&&o!==i.g)throw new a("Found DNL marker (0xFFDC) while parsing scan data",o)}throw new n("unexpected marker "+(T<<8|r).toString(16))}}return I=7,T>>>7}function b(t){for(;;){if("number"==typeof(t=t[p()]))return t;if("object"!==(void 0===t?"undefined":r(t)))throw new n("invalid huffman sequence")}}function m(t){for(var e=0;0<t;)e=e<<1|p(),t--;return e}function g(t){if(1===t)return 1===p()?1:-1;var e=m(t);return e>=1<<t-1?e:e+(-1<<t)+1}for(var y,v,_,w,x,E,k,j=9<arguments.length&&void 0!==arguments[9]&&arguments[9],S=i.P,A=e,T=0,I=0,P=0,M=0,O=o.length,R=i.S?0===f?0===c?function(t,e){var r=b(t.D);r=0===r?0:g(r)<<d,t.a[e]=t.m+=r}:function(t,e){t.a[e]|=p()<<d}:0===c?function(t,e){if(0<P)P--;else for(var r=f;r<=h;){var n=b(t.o),i=15&n;if(n>>=4,0===i){if(15>n){P=m(n)+(1<<n)-1;break}r+=16}else r+=n,t.a[e+u[r]]=g(i)*(1<<d),r++}}:function(t,e){for(var r,i=f,a=0;i<=h;){r=e+u[i];var o=0>t.a[r]?-1:1;switch(M){case 0:if(r=15&(a=b(t.o)),a>>=4,0===r)15>a?(P=m(a)+(1<<a),M=4):(a=16,M=1);else{if(1!==r)throw new n("invalid ACn encoding");y=g(r),M=a?2:3}continue;case 1:case 2:t.a[r]?t.a[r]+=o*(p()<<d):0===--a&&(M=2===M?3:0);break;case 3:t.a[r]?t.a[r]+=o*(p()<<d):(t.a[r]=y<<d,M=0);break;case 4:t.a[r]&&(t.a[r]+=o*(p()<<d))}i++}4===M&&0===--P&&(M=0)}:function(t,e){var r=b(t.D);for(r=0===r?0:g(r),t.a[e]=t.m+=r,r=1;64>r;){var n=b(t.o),i=15&n;if(n>>=4,0===i){if(15>n)break;r+=16}else r+=n,t.a[e+u[r]]=g(i),r++}},L=0,C=1===O?o[0].c*o[0].l:S*i.O;L<C;){var B=s?Math.min(C-L,s):C;for(v=0;v<O;v++)o[v].m=0;if(P=0,1===O){var D=o[0];for(x=0;x<B;x++)R(D,64*((D.c+1)*(L/D.c|0)+L%D.c)),L++}else for(x=0;x<B;x++){for(v=0;v<O;v++)for(E=(D=o[v]).h,k=D.j,_=0;_<k;_++)for(w=0;w<E;w++)R(D,64*((D.c+1)*((L/S|0)*D.j+_)+(L%S*D.h+w)));L++}if(I=0,(D=l(t,e))&&D.f&&((0,_util.warn)("decodeScan - unexpected MCU data, current marker is: "+D.f),e=D.offset),!(D=D&&D.F)||65280>=D)throw new n("marker was not found");if(!(65488<=D&&65495>=D))break;e+=2}return(D=l(t,e))&&D.f&&((0,_util.warn)("decodeScan - unexpected Scan data, current marker is: "+D.f),e=D.offset),e-A}function s(t,e){for(var r=e.c,i=e.l,a=new Int16Array(64),o=0;o<i;o++)for(var s=0;s<r;s++){var l=64*((e.c+1)*o+s),u=a,f=e.G,h=e.a;if(!f)throw new n("missing required Quantization Table.");for(var c=0;64>c;c+=8){var d=h[l+c],p=h[l+c+1],b=h[l+c+2],m=h[l+c+3],g=h[l+c+4],y=h[l+c+5],v=h[l+c+6],_=h[l+c+7];if(d*=f[c],0===(p|b|m|g|y|v|_))d=5793*d+512>>10,u[c]=d,u[c+1]=d,u[c+2]=d,u[c+3]=d,u[c+4]=d,u[c+5]=d,u[c+6]=d,u[c+7]=d;else{p*=f[c+1],b*=f[c+2],m*=f[c+3],g*=f[c+4],y*=f[c+5];var w=5793*d+128>>8,x=5793*g+128>>8,E=b,k=v*=f[c+6];x=(w=w+x+1>>1)-x,d=3784*E+1567*k+128>>8,E=1567*E-3784*k+128>>8,y=(g=(g=2896*(p-(_*=f[c+7]))+128>>8)+(y<<=4)+1>>1)-y,m=(_=(_=2896*(p+_)+128>>8)+(m<<=4)+1>>1)-m,k=(w=w+(k=d)+1>>1)-k,E=(x=x+E+1>>1)-E,d=2276*g+3406*_+2048>>12,g=3406*g-2276*_+2048>>12,_=d,d=799*m+4017*y+2048>>12,m=4017*m-799*y+2048>>12,y=d,u[c]=w+_,u[c+7]=w-_,u[c+1]=x+y,u[c+6]=x-y,u[c+2]=E+m,u[c+5]=E-m,u[c+3]=k+g,u[c+4]=k-g}}for(f=0;8>f;++f)d=u[f],0===((p=u[f+8])|(b=u[f+16])|(m=u[f+24])|(g=u[f+32])|(y=u[f+40])|(v=u[f+48])|(_=u[f+56]))?(d=-2040>(d=5793*d+8192>>14)?0:2024<=d?255:d+2056>>4,h[l+f]=d,h[l+f+8]=d,h[l+f+16]=d,h[l+f+24]=d,h[l+f+32]=d,h[l+f+40]=d,h[l+f+48]=d,h[l+f+56]=d):(w=5793*d+2048>>12,x=5793*g+2048>>12,d=3784*(E=b)+1567*(k=v)+2048>>12,E=1567*E-3784*k+2048>>12,k=d,y=(g=(g=2896*(p-_)+2048>>12)+y+1>>1)-y,m=(_=(_=2896*(p+_)+2048>>12)+m+1>>1)-m,d=2276*g+3406*_+2048>>12,g=3406*g-2276*_+2048>>12,_=d,d=799*m+4017*y+2048>>12,m=4017*m-799*y+2048>>12,p=(x=(x=(w=4112+(w+x+1>>1))-x)+E+1>>1)+(y=d),v=x-y,y=(E=x-E)-m,d=16>(d=(w=w+k+1>>1)+_)?0:4080<=d?255:d>>4,p=16>p?0:4080<=p?255:p>>4,b=16>(b=E+m)?0:4080<=b?255:b>>4,m=16>(m=(k=w-k)+g)?0:4080<=m?255:m>>4,g=16>(g=k-g)?0:4080<=g?255:g>>4,y=16>y?0:4080<=y?255:y>>4,v=16>v?0:4080<=v?255:v>>4,_=16>(_=w-_)?0:4080<=_?255:_>>4,h[l+f]=d,h[l+f+8]=p,h[l+f+16]=b,h[l+f+24]=m,h[l+f+32]=g,h[l+f+40]=y,h[l+f+48]=v,h[l+f+56]=_)}return e.a}function l(t,e){var r=2<arguments.length&&void 0!==arguments[2]?arguments[2]:e,n=t.length-1;if(r=r<e?r:e,e>=n)return null;var i=t[e]<<8|t[e+1];if(65472<=i&&65534>=i)return{f:null,F:i,offset:e};for(var a=t[r]<<8|t[r+1];!(65472<=a&&65534>=a);){if(++r>=n)return null;a=t[r]<<8|t[r+1]}return{f:i.toString(16),F:a,offset:r}}var u=new Uint8Array([0,1,8,16,9,2,3,10,17,24,32,25,18,11,4,5,12,19,26,33,40,48,41,34,27,20,13,6,7,14,21,28,35,42,49,56,57,50,43,36,29,22,15,23,30,37,44,51,58,59,52,45,38,31,39,46,53,60,61,54,47,55,62,63]);e.prototype={parse:function(t){function e(){var e=t[d]<<8|t[d+1];return d+=2,e}function r(){var r=e(),n=l(t,r=d+r-2,d);return n&&n.f&&((0,_util.warn)("readDataBlock - incorrect length, current marker is: "+n.f),r=n.offset),r=t.subarray(d,r),d+=r.length,r}function f(t){for(var e=Math.ceil(t.v/8/t.s),r=Math.ceil(t.g/8/t.u),n=0;n<t.b.length;n++){A=t.b[n];var i=Math.ceil(Math.ceil(t.v/8)*A.h/t.s),a=Math.ceil(Math.ceil(t.g/8)*A.j/t.u);A.a=new Int16Array(64*r*A.j*(e*A.h+1)),A.c=i,A.l=a}t.P=e,t.O=r}var h=(1<arguments.length&&void 0!==arguments[1]?arguments[1]:{}).N,c=void 0===h?null:h,d=0,p=null,b=0;h=[];var m=[],g=[],y=e();if(65496!==y)throw new n("SOI not found");for(y=e();65497!==y;){switch(y){case 65504:case 65505:case 65506:case 65507:case 65508:case 65509:case 65510:case 65511:case 65512:case 65513:case 65514:case 65515:case 65516:case 65517:case 65518:case 65519:case 65534:var v=r();65518===y&&65===v[0]&&100===v[1]&&111===v[2]&&98===v[3]&&101===v[4]&&(p={version:v[5]<<8|v[6],Y:v[7]<<8|v[8],Z:v[9]<<8|v[10],W:v[11]});break;case 65499:y=e()+d-2;for(var _;d<y;){var w=t[d++],x=new Uint16Array(64);if(w>>4){if(1!=w>>4)throw new n("DQT - invalid table spec");for(v=0;64>v;v++)x[_=u[v]]=e()}else for(v=0;64>v;v++)x[_=u[v]]=t[d++];h[15&w]=x}break;case 65472:case 65473:case 65474:if(E)throw new n("Only single frame JPEGs supported");e();var E={};for(E.X=65473===y,E.S=65474===y,E.precision=t[d++],y=e(),E.g=c||y,E.v=e(),E.b=[],E.C={},v=t[d++],y=x=w=0;y<v;y++){_=t[d];var k=t[d+1]>>4,j=15&t[d+1];w<k&&(w=k),x<j&&(x=j),k=E.b.push({h:k,j,T:t[d+2],G:null}),E.C[_]=k-1,d+=3}E.s=w,E.u=x,f(E);break;case 65476:for(_=e(),y=2;y<_;){for(w=t[d++],x=new Uint8Array(16),v=k=0;16>v;v++,d++)k+=x[v]=t[d];for(j=new Uint8Array(k),v=0;v<k;v++,d++)j[v]=t[d];y+=17+k,(w>>4?m:g)[15&w]=i(x,j)}break;case 65501:e();var S=e();break;case 65498:for(v=1===++b&&!c,e(),w=t[d++],_=[],y=0;y<w;y++){x=E.C[t[d++]];var A=E.b[x];x=t[d++],A.D=g[x>>4],A.o=m[15&x],_.push(A)}y=t[d++],w=t[d++],x=t[d++];try{var T=o(t,d,E,_,S,y,w,x>>4,15&x,v);d+=T}catch(e){if(e instanceof a)return(0,_util.warn)('Attempting to re-parse JPEG image using "scanLines" parameter found in DNL marker (0xFFDC) segment.'),this.parse(t,{N:e.g});throw e}break;case 65500:d+=4;break;case 65535:255!==t[d]&&d--;break;default:if(255===t[d-3]&&192<=t[d-2]&&254>=t[d-2])d-=3;else{if(!(v=l(t,d-2))||!v.f)throw new n("unknown marker "+y.toString(16));(0,_util.warn)("JpegImage.parse - unexpected data, current marker is: "+v.f),d=v.offset}}y=e()}for(this.width=E.v,this.height=E.g,this.A=p,this.b=[],y=0;y<E.b.length;y++)(S=h[(A=E.b[y]).T])&&(A.G=S),this.b.push({R:s(0,A),U:A.h/E.s,V:A.j/E.u,c:A.c,l:A.l});this.i=this.b.length},L:function(t,e){var r,n,i=this.width/t,a=this.height/e,o=this.b.length,s=t*e*o,l=new Uint8ClampedArray(s),u=new Uint32Array(t);for(n=0;n<o;n++){var f=this.b[n],h=f.U*i,c=f.V*a,d=n,p=f.R,b=f.c+1<<3;for(r=0;r<t;r++)f=0|r*h,u[r]=(4294967288&f)<<3|7&f;for(h=0;h<e;h++)for(f=b*(4294967288&(f=0|h*c))|(7&f)<<3,r=0;r<t;r++)l[d]=p[f+u[r]],d+=o}if(a=this.M)for(n=0;n<s;)for(i=f=0;f<o;f++,n++,i+=2)l[n]=(l[n]*a[i]>>8)+a[i+1];return l},w:function(){return this.A?!!this.A.W:3===this.i?0!==this.B:1===this.B},I:function(t){for(var e,r,n,i=0,a=t.length;i<a;i+=3)e=t[i],r=t[i+1],n=t[i+2],t[i]=e-179.456+1.402*n,t[i+1]=e+135.459-.344*r-.714*n,t[i+2]=e-226.816+1.772*r;return t},K:function(t){for(var e,r,n,i,a=0,o=0,s=t.length;o<s;o+=4)e=t[o],r=t[o+1],n=t[o+2],i=t[o+3],t[a++]=r*(-660635669420364e-19*r+.000437130475926232*n-54080610064599e-18*e+.00048449797120281*i-.154362151871126)-122.67195406894+n*(-.000957964378445773*n+.000817076911346625*e-.00477271405408747*i+1.53380253221734)+e*(.000961250184130688*e-.00266257332283933*i+.48357088451265)+i*(-.000336197177618394*i+.484791561490776),t[a++]=107.268039397724+r*(219927104525741e-19*r-.000640992018297945*n+.000659397001245577*e+.000426105652938837*i-.176491792462875)+n*(-.000778269941513683*n+.00130872261408275*e+.000770482631801132*i-.151051492775562)+e*(.00126935368114843*e-.00265090189010898*i+.25802910206845)+i*(-.000318913117588328*i-.213742400323665),t[a++]=r*(-.000570115196973677*r-263409051004589e-19*n+.0020741088115012*e-.00288260236853442*i+.814272968359295)-20.810012546947+n*(-153496057440975e-19*n-.000132689043961446*e+.000560833691242812*i-.195152027534049)+e*(.00174418132927582*e-.00255243321439347*i+.116935020465145)+i*(-.000343531996510555*i+.24165260232407);return t.subarray(0,a)},J:function(t){for(var e,r,n,i=0,a=t.length;i<a;i+=4)e=t[i],r=t[i+1],n=t[i+2],t[i]=434.456-e-1.402*n,t[i+1]=119.541-e+.344*r+.714*n,t[i+2]=481.816-e-1.772*r;return t},H:function(t){for(var e,r,n,i,a=0,o=1/255,s=0,l=t.length;s<l;s+=4)e=t[s]*o,r=t[s+1]*o,n=t[s+2]*o,i=t[s+3]*o,t[a++]=255+e*(-4.387332384609988*e+54.48615194189176*r+18.82290502165302*n+212.25662451639585*i-285.2331026137004)+r*(1.7149763477362134*r-5.6096736904047315*n-17.873870861415444*i-5.497006427196366)+n*(-2.5217340131683033*n-21.248923337353073*i+17.5119270841813)-i*(21.86122147463605*i+189.48180835922747),t[a++]=255+e*(8.841041422036149*e+60.118027045597366*r+6.871425592049007*n+31.159100130055922*i-79.2970844816548)+r*(-15.310361306967817*r+17.575251261109482*n+131.35250912493976*i-190.9453302588951)+n*(4.444339102852739*n+9.8632861493405*i-24.86741582555878)-i*(20.737325471181034*i+187.80453709719578),t[a++]=255+e*(.8842522430003296*e+8.078677503112928*r+30.89978309703729*n-.23883238689178934*i-14.183576799673286)+r*(10.49593273432072*r+63.02378494754052*n+50.606957656360734*i-112.23884253719248)+n*(.03296041114873217*n+115.60384449646641*i-193.58209356861505)-i*(22.33816807309886*i+180.12613974708367);return t.subarray(0,a)},getData:function(t,e,r){if(4<this.i)throw new n("Unsupported color mode");if(t=this.L(t,e),1===this.i&&r){r=t.length,e=new Uint8ClampedArray(3*r);for(var i=0,a=0;a<r;a++){var o=t[a];e[i++]=o,e[i++]=o,e[i++]=o}return e}if(3===this.i&&this.w())return this.I(t);if(4===this.i){if(this.w())return r?this.K(t):this.J(t);if(r)return this.H(t)}return t}},t.JpegDecoder=e}(),t.encodeImage=function(e,r,n,i){var a={t256:[r],t257:[n],t258:[8,8,8,8],t259:[1],t262:[2],t273:[1e3],t277:[4],t278:[n],t279:[r*n*4],t282:[1],t283:[1],t284:[1],t286:[0],t287:[0],t296:[1],t305:["Photopea (UTIF.js)"],t338:[1]};if(i)for(var o in i)a[o]=i[o];var s=new Uint8Array(t.encode([a])),l=new Uint8Array(e),u=new Uint8Array(1e3+r*n*4);for(o=0;o<s.length;o++)u[o]=s[o];for(o=0;o<l.length;o++)u[1e3+o]=l[o];return u.buffer},t.encode=function(e){var r=new Uint8Array(2e4),n=4,i=t._binBE;r[0]=77,r[1]=77,r[3]=42;var a=8;i.writeUint(r,n,a),n+=4;for(var o=0;o<e.length;o++){var s=t._writeIFD(i,r,a,e[o]);a=s[1],o<e.length-1&&i.writeUint(r,s[0],a)}return r.slice(0,a).buffer},t.decode=function(e){t.decode._decodeG3.allow2D=null;var r=new Uint8Array(e),n=0,i=t._binBE.readASCII(r,n,2);n+=2;var a="II"==i?t._binLE:t._binBE;a.readUshort(r,n),n+=2;var o=a.readUint(r,n);n+=4;for(var s=[];;){var l=t._readIFD(a,r,o,s);if(0==(o=a.readUint(r,l)))break}return s},t.decodeImages=function(e,r){for(var n=new Uint8Array(e),a=t._binBE.readASCII(n,0,2),o=0;o<r.length;o++){var s=r[o];if(null!=s.t256){s.isLE="II"==a,s.width=s.t256[0],s.height=s.t257[0];var l=s.t259?s.t259[0]:1,u=s.t266?s.t266[0]:1;s.t284&&2==s.t284[0]&&i("PlanarConfiguration 2 should not be used!");var f=(s.t258?Math.min(32,s.t258[0]):1)*(s.t277?s.t277[0]:1),h=8*Math.ceil(s.width*f/8),c=s.t273;null==c&&(c=s.t324);var d=s.t279;1==l&&1==c.length&&(d=[s.height*(h>>>3)]),null==d&&(d=s.t325);var p=new Uint8Array(s.height*(h>>>3)),b=0;if(null!=s.t322){for(var m=s.t322[0],g=s.t323[0],y=Math.floor((s.width+m-1)/m),v=Math.floor((s.height+g-1)/g),_=new Uint8Array(0|Math.ceil(m*g*f/8)),w=0;w<v;w++)for(var x=0;x<y;x++){for(var E=w*y+x,k=0;k<_.length;k++)_[k]=0;t.decode._decompress(s,n,c[E],d[E],l,_,0,u),6==l?p=_:t._copyTile(_,0|Math.ceil(m*f/8),g,p,0|Math.ceil(s.width*f/8),s.height,0|Math.ceil(x*m*f/8),w*g)}b=8*p.length}else{var j=s.t278?s.t278[0]:s.height;for(j=Math.min(j,s.height),E=0;E<c.length;E++)t.decode._decompress(s,n,c[E],d[E],l,p,0|Math.ceil(b/8),u),b+=h*j;b=Math.min(b,8*p.length)}s.data=new Uint8Array(p.buffer,0,0|Math.ceil(b/8))}}},t.decode._decompress=function(r,n,a,o,s,l,u,f){if(1==s)for(var h=0;h<o;h++)l[u+h]=n[a+h];else if(3==s)t.decode._decodeG3(n,a,o,l,u,r.width,f);else if(4==s)t.decode._decodeG4(n,a,o,l,u,r.width,f);else if(5==s)t.decode._decodeLZW(n,a,l,u);else if(6==s)t.decode._decodeOldJPEG(r,n,a,o,l,u);else if(7==s)t.decode._decodeNewJPEG(r,n,a,o,l,u);else if(8==s)for(var c=new Uint8Array(n.buffer,a,o),d=e.inflate(c),p=0;p<d.length;p++)l[u+p]=d[p];else 32773==s?t.decode._decodePackBits(n,a,o,l,u):32809==s?t.decode._decodeThunder(n,a,o,l,u):i("Unknown compression",s);if(r.t317&&2==r.t317[0])for(var b=r.t277?r.t277[0]:1,m=r.t278?r.t278[0]:r.height,g=r.width*b,y=0;y<m;y++){var v=u+y*g;if(3==b)for(h=3;h<g;h+=3)l[v+h]=l[v+h]+l[v+h-3]&255,l[v+h+1]=l[v+h+1]+l[v+h-2]&255,l[v+h+2]=l[v+h+2]+l[v+h-1]&255;else for(h=b;h<g;h++)l[v+h]=l[v+h]+l[v+h-b]&255}},t.decode._decodeNikon=function(t,e,r,n,a){var o,s;i(t.slice(e,e+100)),o=t[e],s=t[++e],e++,i(o.toString(16),s.toString(16),r)},t.decode._decodeNewJPEG=function(e,r,n,i,a,o){var s=e.t347,l=s?s.length:0,u=new Uint8Array(l+i);if(s){for(var f=0,h=0;h<l-1&&(255!=s[h]||217!=s[h+1]);h++)u[f++]=s[h];var c=r[n],d=r[n+1];for(255==c&&216==d||(u[f++]=c,u[f++]=d),h=2;h<i;h++)u[f++]=r[n+h]}else for(h=0;h<i;h++)u[h]=r[n+h];if(32803==e.t262){var p=e.t258[0],b=(new LosslessJpegDecoder).decode(u),m=b.length;if(16==p)for(h=0;h<m;h++)a[o++]=255&b[h],a[o++]=b[h]>>>8;else{if(12!=p)throw new Error("unsupported bit depth "+p);for(h=0;h<m;h+=2)a[o++]=b[h]>>>4,a[o++]=255&(b[h]<<4|b[h+1]>>>8),a[o++]=255&b[h+1]}}else{var g=new t.JpegDecoder;g.parse(u);var y=g.getData(g.width,g.height);for(h=0;h<y.length;h++)a[o+h]=y[h]}6==e.t262[0]&&(e.t262[0]=2)},t.decode._decodeOldJPEGInit=function(t,e,r,n){var a,o,s,l,u,f=216,h=0,c=0,d=!1,p=t.t513,b=p?p[0]:0,m=t.t514,g=m?m[0]:0,y=t.t324||t.t273||p,v=t.t530,_=0,w=0,x=t.t277?t.t277[0]:1,E=t.t515;if(y&&(c=y[0],d=y.length>1),!d){if(255==e[r]&&e[r+1]==f)return{jpegOffset:r};if(null!=p&&(255==e[r+b]&&e[r+b+1]==f?h=r+b:i("JPEGInterchangeFormat does not point to SOI"),null==m?i("JPEGInterchangeFormatLength field is missing"):(b>=c||b+g<=c)&&i("JPEGInterchangeFormatLength field value is invalid"),null!=h))return{jpegOffset:h}}if(null!=v&&(_=v[0],w=v[1]),null!=p&&null!=m)if(g>=2&&b+g<=c){for(a=255==e[r+b+g-2]&&e[r+b+g-1]==f?new Uint8Array(g-2):new Uint8Array(g),s=0;s<a.length;s++)a[s]=e[r+b+s];i("Incorrect JPEG interchange format: using JPEGInterchangeFormat offset to derive tables")}else i("JPEGInterchangeFormat+JPEGInterchangeFormatLength > offset to first strip or tile");if(null==a){var k=0,j=[];j[k++]=255,j[k++]=f;var S=t.t519;if(null==S)throw new Error("JPEGQTables tag is missing");for(s=0;s<S.length;s++)for(j[k++]=255,j[k++]=219,j[k++]=0,j[k++]=67,j[k++]=s,l=0;l<64;l++)j[k++]=e[r+S[s]+l];for(u=0;u<2;u++){var A=t[0==u?"t520":"t521"];if(null==A)throw new Error((0==u?"JPEGDCTables":"JPEGACTables")+" tag is missing");for(s=0;s<A.length;s++){j[k++]=255,j[k++]=196;var T=19;for(l=0;l<16;l++)T+=e[r+A[s]+l];for(j[k++]=T>>>8,j[k++]=255&T,j[k++]=s|u<<4,l=0;l<16;l++)j[k++]=e[r+A[s]+l];for(l=0;l<T;l++)j[k++]=e[r+A[s]+16+l]}}if(j[k++]=255,j[k++]=192,j[k++]=0,j[k++]=8+3*x,j[k++]=8,j[k++]=t.height>>>8&255,j[k++]=255&t.height,j[k++]=t.width>>>8&255,j[k++]=255&t.width,j[k++]=x,1==x)j[k++]=1,j[k++]=17,j[k++]=0;else for(s=0;s<3;s++)j[k++]=s+1,j[k++]=0!=s?17:(15&_)<<4|15&w,j[k++]=s;null!=E&&0!=E[0]&&(j[k++]=255,j[k++]=221,j[k++]=0,j[k++]=4,j[k++]=E[0]>>>8&255,j[k++]=255&E[0]),a=new Uint8Array(j)}var I=-1;for(s=0;s<a.length-1;){if(255==a[s]&&192==a[s+1]){I=s;break}s++}if(-1==I){var P=new Uint8Array(a.length+10+3*x);P.set(a);var M=a.length;if(I=a.length,(a=P)[M++]=255,a[M++]=192,a[M++]=0,a[M++]=8+3*x,a[M++]=8,a[M++]=t.height>>>8&255,a[M++]=255&t.height,a[M++]=t.width>>>8&255,a[M++]=255&t.width,a[M++]=x,1==x)a[M++]=1,a[M++]=17,a[M++]=0;else for(s=0;s<3;s++)a[M++]=s+1,a[M++]=0!=s?17:(15&_)<<4|15&w,a[M++]=s}if(255==e[c]&&218==e[c+1]){var O=e[c+2]<<8|e[c+3];for((o=new Uint8Array(O+2))[0]=e[c],o[1]=e[c+1],o[2]=e[c+2],o[3]=e[c+3],s=0;s<O-2;s++)o[s+4]=e[c+s+4]}else{var R=0;if((o=new Uint8Array(8+2*x))[R++]=255,o[R++]=218,o[R++]=0,o[R++]=6+2*x,o[R++]=x,1==x)o[R++]=1,o[R++]=0;else for(s=0;s<3;s++)o[R++]=s+1,o[R++]=s<<4|s;o[R++]=0,o[R++]=63,o[R++]=0}return{jpegOffset:r,tables:a,sosMarker:o,sofPosition:I}},t.decode._decodeOldJPEG=function(e,r,n,i,a,o){var s,l,u,f=t.decode._decodeOldJPEGInit(e,r,n,i);if(null!=f.jpegOffset)for(s=n+i-f.jpegOffset,u=new Uint8Array(s),d=0;d<s;d++)u[d]=r[f.jpegOffset+d];else{for(l=f.tables.length,(u=new Uint8Array(l+f.sosMarker.length+i+2)).set(f.tables),u[f.sofPosition+5]=e.height>>>8&255,u[f.sofPosition+6]=255&e.height,u[f.sofPosition+7]=e.width>>>8&255,u[f.sofPosition+8]=255&e.width,255==r[n]&&r[n+1]==SOS||(u.set(f.sosMarker,bufoff),bufoff+=sosMarker.length),d=0;d<i;d++)u[bufoff++]=r[n+d];u[bufoff++]=255,u[bufoff++]=EOI}var h=new t.JpegDecoder;h.parse(u);for(var c=h.getData(h.width,h.height),d=0;d<c.length;d++)a[o+d]=c[d];6==e.t262[0]&&(e.t262[0]=2)},t.decode._decodePackBits=function(t,e,r,n,i){for(var a=new Int8Array(t.buffer),o=new Int8Array(n.buffer),s=e+r;e<s;){var l=a[e];if(e++,l>=0&&l<128)for(var u=0;u<l+1;u++)o[i]=a[e],i++,e++;if(l>=-127&&l<0){for(u=0;u<1-l;u++)o[i]=a[e],i++;e++}}},t.decode._decodeThunder=function(t,e,r,n,i){for(var a=[0,1,0,-1],o=[0,1,2,3,0,-3,-2,-1],s=e+r,l=2*i,u=0;e<s;){var f=t[e],h=f>>>6,c=63&f;if(e++,3==h&&(u=15&c,n[l>>>1]|=u<<4*(1-l&1),l++),0==h)for(var d=0;d<c;d++)n[l>>>1]|=u<<4*(1-l&1),l++;if(2==h)for(d=0;d<2;d++)4!=(p=c>>>3*(1-d)&7)&&(u+=o[p],n[l>>>1]|=u<<4*(1-l&1),l++);if(1==h)for(d=0;d<3;d++){var p;2!=(p=c>>>2*(2-d)&3)&&(u+=a[p],n[l>>>1]|=u<<4*(1-l&1),l++)}}},t.decode._dmap={1:0,"011":1,"000011":2,"0000011":3,"010":-1,"000010":-2,"0000010":-3},t.decode._lens=function(){var t=function(t,e,r,n){for(var i=0;i<e.length;i++)t[e[i]]=r+i*n},e="00110101,000111,0111,1000,1011,1100,1110,1111,10011,10100,00111,01000,001000,000011,110100,110101,101010,101011,0100111,0001100,0001000,0010111,0000011,0000100,0101000,0101011,0010011,0100100,0011000,00000010,00000011,00011010,00011011,00010010,00010011,00010100,00010101,00010110,00010111,00101000,00101001,00101010,00101011,00101100,00101101,00000100,00000101,00001010,00001011,01010010,01010011,01010100,01010101,00100100,00100101,01011000,01011001,01011010,01011011,01001010,01001011,00110010,00110011,00110100",r="0000110111,010,11,10,011,0011,0010,00011,000101,000100,0000100,0000101,0000111,00000100,00000111,000011000,0000010111,0000011000,0000001000,00001100111,00001101000,00001101100,00000110111,00000101000,00000010111,00000011000,000011001010,000011001011,000011001100,000011001101,000001101000,000001101001,000001101010,000001101011,000011010010,000011010011,000011010100,000011010101,000011010110,000011010111,000001101100,000001101101,000011011010,000011011011,000001010100,000001010101,000001010110,000001010111,000001100100,000001100101,000001010010,000001010011,000000100100,000000110111,000000111000,000000100111,000000101000,000001011000,000001011001,000000101011,000000101100,000001011010,000001100110,000001100111",n="11011,10010,010111,0110111,00110110,00110111,01100100,01100101,01101000,01100111,011001100,011001101,011010010,011010011,011010100,011010101,011010110,011010111,011011000,011011001,011011010,011011011,010011000,010011001,010011010,011000,010011011",i="0000001111,000011001000,000011001001,000001011011,000000110011,000000110100,000000110101,0000001101100,0000001101101,0000001001010,0000001001011,0000001001100,0000001001101,0000001110010,0000001110011,0000001110100,0000001110101,0000001110110,0000001110111,0000001010010,0000001010011,0000001010100,0000001010101,0000001011010,0000001011011,0000001100100,0000001100101",a="00000001000,00000001100,00000001101,000000010010,000000010011,000000010100,000000010101,000000010110,000000010111,000000011100,000000011101,000000011110,000000011111";e=e.split(","),r=r.split(","),n=n.split(","),i=i.split(","),a=a.split(",");var o={},s={};return t(o,e,0,1),t(o,n,64,64),t(o,a,1792,64),t(s,r,0,1),t(s,i,64,64),t(s,a,1792,64),[o,s]}(),t.decode._decodeG4=function(e,r,n,i,a,o,s){for(var l=t.decode,u=r<<3,f=0,h="",c=[],d=[],p=0;p<o;p++)d.push(0);d=l._makeDiff(d);for(var b=0,m=0,g=0,y=0,v=0,_=0,w="",x=0,E=8*Math.ceil(o/8);u>>>3<r+n;){g=l._findDiff(d,b+(0==b?0:1),1-v),y=l._findDiff(d,g,v);var k=0;if(1==s&&(k=e[u>>>3]>>>7-(7&u)&1),2==s&&(k=e[u>>>3]>>>(7&u)&1),u++,h+=k,"H"==w){if(null!=l._lens[v][h]){var j=l._lens[v][h];h="",f+=j,j<64&&(l._addNtimes(c,f,v),b+=f,v=1-v,f=0,0==--x&&(w=""))}}else"0001"==h&&(h="",l._addNtimes(c,y-b,v),b=y),"001"==h&&(h="",w="H",x=2),null!=l._dmap[h]&&(m=g+l._dmap[h],l._addNtimes(c,m-b,v),b=m,h="",v=1-v);c.length==o&&""==w&&(l._writeBits(c,i,8*a+_*E),v=0,_++,b=0,d=l._makeDiff(c),c=[])}},t.decode._findDiff=function(t,e,r){for(var n=0;n<t.length;n+=2)if(t[n]>=e&&t[n+1]==r)return t[n]},t.decode._makeDiff=function(t){var e=[];1==t[0]&&e.push(0,1);for(var r=1;r<t.length;r++)t[r-1]!=t[r]&&e.push(r,t[r]);return e.push(t.length,0,t.length,1),e},t.decode._decodeG3=function(e,r,n,i,a,o,s){for(var l=t.decode,u=r<<3,f=0,h="",c=[],d=[],p=0;p<o;p++)c.push(0);for(var b=0,m=0,g=0,y=0,v=0,_=-1,w="",x=0,E=!1,k=8*Math.ceil(o/8);u>>>3<r+n;){g=l._findDiff(d,b+(0==b?0:1),1-v),y=l._findDiff(d,g,v);var j=0;if(1==s&&(j=e[u>>>3]>>>7-(7&u)&1),2==s&&(j=e[u>>>3]>>>(7&u)&1),u++,h+=j,E){if(null!=l._lens[v][h]){var S=l._lens[v][h];h="",f+=S,S<64&&(l._addNtimes(c,f,v),v=1-v,f=0)}}else"H"==w?null!=l._lens[v][h]&&(S=l._lens[v][h],h="",f+=S,S<64&&(l._addNtimes(c,f,v),b+=f,v=1-v,f=0,0==--x&&(w=""))):("0001"==h&&(h="",l._addNtimes(c,y-b,v),b=y),"001"==h&&(h="",w="H",x=2),null!=l._dmap[h]&&(m=g+l._dmap[h],l._addNtimes(c,m-b,v),b=m,h="",v=1-v));h.endsWith("000000000001")&&(_>=0&&l._writeBits(c,i,8*a+_*k),1==s&&(E=1==(e[u>>>3]>>>7-(7&u)&1)),2==s&&(E=1==(e[u>>>3]>>>(7&u)&1)),u++,null==l._decodeG3.allow2D&&(l._decodeG3.allow2D=E),l._decodeG3.allow2D||(E=!0,u--),h="",v=0,_++,b=0,d=l._makeDiff(c),c=[])}c.length==o&&l._writeBits(c,i,8*a+_*k)},t.decode._addNtimes=function(t,e,r){for(var n=0;n<e;n++)t.push(r)},t.decode._writeBits=function(t,e,r){for(var n=0;n<t.length;n++)e[r+n>>>3]|=t[n]<<7-(r+n&7)},t.decode._decodeLZW=function(e,r,n,i){if(null==t.decode._lzwTab){for(var a=new Uint32Array(65535),o=new Uint16Array(65535),s=new Uint8Array(2e6),l=0;l<256;l++)s[l<<2]=l,a[l]=l<<2,o[l]=1;t.decode._lzwTab=[a,o,s]}for(var u=t.decode._copyData,f=t.decode._lzwTab[0],h=t.decode._lzwTab[1],c=(s=t.decode._lzwTab[2],258),d=1032,p=9,b=r<<3,m=0,g=0;m=(e[b>>>3]<<16|e[b+8>>>3]<<8|e[b+16>>>3])>>24-(7&b)-p&(1<<p)-1,b+=p,257!=m;){if(256==m){if(p=9,c=258,d=1032,m=(e[b>>>3]<<16|e[b+8>>>3]<<8|e[b+16>>>3])>>24-(7&b)-p&(1<<p)-1,b+=p,257==m)break;n[i]=m,i++}else if(m<c){var y=f[m],v=h[m];u(s,y,n,i,v),i+=v,g>=c?(f[c]=d,s[f[c]]=y[0],h[c]=1,d=d+1+3&-4,c++):(f[c]=d,u(s,f[g],s,d,_=h[g]),s[d+_]=s[y],_++,h[c]=_,c++,d=d+_+3&-4),c+1==1<<p&&p++}else{var _;g>=c?(f[c]=d,h[c]=0,c++):(f[c]=d,u(s,f[g],s,d,_=h[g]),s[d+_]=s[d],_++,h[c]=_,c++,u(s,d,n,i,_),i+=_,d=d+_+3&-4),c+1==1<<p&&p++}g=m}},t.decode._copyData=function(t,e,r,n,i){for(var a=0;a<i;a+=4)r[n+a]=t[e+a],r[n+a+1]=t[e+a+1],r[n+a+2]=t[e+a+2],r[n+a+3]=t[e+a+3]},t.tags={254:"NewSubfileType",255:"SubfileType",256:"ImageWidth",257:"ImageLength",258:"BitsPerSample",259:"Compression",262:"PhotometricInterpretation",266:"FillOrder",269:"DocumentName",270:"ImageDescription",271:"Make",272:"Model",273:"StripOffset",274:"Orientation",277:"SamplesPerPixel",278:"RowsPerStrip",279:"StripByteCounts",280:"MinSampleValue",281:"MaxSampleValue",282:"XResolution",283:"YResolution",284:"PlanarConfiguration",285:"PageName",286:"XPosition",287:"YPosition",292:"T4Options",296:"ResolutionUnit",297:"PageNumber",305:"Software",306:"DateTime",315:"Artist",316:"HostComputer",317:"Predictor",318:"WhitePoint",319:"PrimaryChromaticities",320:"ColorMap",321:"HalftoneHints",322:"TileWidth",323:"TileLength",324:"TileOffset",325:"TileByteCounts",330:"SubIFDs",336:"DotRange",338:"ExtraSample",339:"SampleFormat",347:"JPEGTables",512:"JPEGProc",513:"JPEGInterchangeFormat",514:"JPEGInterchangeFormatLength",519:"JPEGQTables",520:"JPEGDCTables",521:"JPEGACTables",529:"YCbCrCoefficients",530:"YCbCrSubSampling",531:"YCbCrPositioning",532:"ReferenceBlackWhite",700:"XMP",33421:"CFARepeatPatternDim",33422:"CFAPattern",33432:"Copyright",33434:"ExposureTime",33437:"FNumber",33723:"IPTC/NAA",34377:"Photoshop",34665:"ExifIFD",34675:"ICC Profile",34850:"ExposureProgram",34853:"GPSInfo",34855:"ISOSpeedRatings",34858:"TimeZoneOffset",34859:"SelfTimeMode",36867:"DateTimeOriginal",36868:"DateTimeDigitized",37377:"ShutterSpeedValue",37378:"ApertureValue",37380:"ExposureBiasValue",37383:"MeteringMode",37385:"Flash",37386:"FocalLength",37390:"FocalPlaneXResolution",37391:"FocalPlaneYResolution",37392:"FocalPlaneResolutionUnit",37393:"ImageNumber",37398:"TIFF/EPStandardID",37399:"SensingMethod",37500:"MakerNote",37510:"UserComment",37724:"ImageSourceData",40092:"XPComment",40094:"XPKeywords",40961:"ColorSpace",40962:"PixelXDimension",40963:"PixelXDimension",41486:"FocalPlaneXResolution",41487:"FocalPlaneYResolution",41488:"FocalPlaneResolutionUnit",41985:"CustomRendered",41986:"ExposureMode",41987:"WhiteBalance",41990:"SceneCaptureType",50706:"DNGVersion",50707:"DNGBackwardVersion",50708:"UniqueCameraModel",50709:"LocalizedCameraModel",50710:"CFAPlaneColor",50711:"CFALayout",50712:"LinearizationTable",50713:"BlackLevelRepeatDim",50714:"BlackLevel",50716:"BlackLevelDeltaV",50717:"WhiteLevel",50718:"DefaultScale",50719:"DefaultCropOrigin",50720:"DefaultCropSize",50733:"BayerGreenSplit",50738:"AntiAliasStrength",50721:"ColorMatrix1",50722:"ColorMatrix2",50723:"CameraCalibration1",50724:"CameraCalibration2",50727:"AnalogBalance",50728:"AsShotNeutral",50730:"BaselineExposure",50731:"BaselineNoise",50732:"BaselineSharpness",50734:"LinearResponseLimit",50735:"CameraSerialNumber",50736:"LensInfo",50739:"ShadowScale",50740:"DNGPrivateData",50741:"MakerNoteSafety",50778:"CalibrationIlluminant1",50779:"CalibrationIlluminant2",50780:"BestQualityScale",50781:"RawDataUniqueID",50827:"OriginalRawFileName",50829:"ActiveArea",50830:"MaskedAreas",50931:"CameraCalibrationSignature",50932:"ProfileCalibrationSignature",50935:"NoiseReductionApplied",50936:"ProfileName",50937:"ProfileHueSatMapDims",50938:"ProfileHueSatMapData1",50939:"ProfileHueSatMapData2",50940:"ProfileToneCurve",50941:"ProfileEmbedPolicy",50942:"ProfileCopyright",50964:"ForwardMatrix1",50965:"ForwardMatrix2",50966:"PreviewApplicationName",50967:"PreviewApplicationVersion",50969:"PreviewSettingsDigest",50970:"PreviewColorSpace",50971:"PreviewDateTime",50972:"RawImageDigest",51008:"OpcodeList1",51009:"OpcodeList2",51022:"OpcodeList3",51041:"NoiseProfile",51089:"OriginalDefaultFinalSize",51090:"OriginalBestQualityFinalSize",51091:"OriginalDefaultCropSize",51125:"DefaultUserCrop"},t.ttypes={256:3,257:3,258:3,259:3,262:3,273:4,274:3,277:3,278:4,279:4,282:5,283:5,284:3,286:5,287:5,296:3,305:2,306:2,338:3,513:4,514:4,34665:4},t._readIFD=function(e,r,n,a){var o=e.readUshort(r,n);n+=2;var s={};a.push(s);for(var l=0;l<o;l++){var u=e.readUshort(r,n);n+=2;var f=e.readUshort(r,n);n+=2;var h=e.readUint(r,n);n+=4;var c=e.readUint(r,n);n+=4;var d=[];if(s["t"+u]=d,1==f||7==f)for(var p=0;p<h;p++)d.push(r[(h<5?n-4:c)+p]);if(2==f&&d.push(e.readASCII(r,h<5?n-4:c,h-1)),3==f)for(p=0;p<h;p++)d.push(e.readUshort(r,(h<3?n-4:c)+2*p));if(4==f)for(p=0;p<h;p++)d.push(e.readUint(r,(h<2?n-4:c)+4*p));if(5==f)for(p=0;p<h;p++)d.push(e.readUint(r,c+8*p)/e.readUint(r,c+8*p+4));if(8==f)for(p=0;p<h;p++)d.push(e.readShort(r,(h<3?n-4:c)+2*p));if(9==f)for(p=0;p<h;p++)d.push(e.readInt(r,(h<2?n-4:c)+4*p));if(10==f)for(p=0;p<h;p++)d.push(e.readInt(r,c+8*p)/e.readInt(r,c+8*p+4));if(11==f)for(p=0;p<h;p++)d.push(e.readFloat(r,c+4*p));if(12==f)for(p=0;p<h;p++)d.push(e.readDouble(r,c+8*p));if(0!=h&&0==d.length&&i("unknown TIFF tag type: ",f,"num:",h),330==u)for(p=0;p<h;p++)t._readIFD(e,r,d[p],a)}return n},t._writeIFD=function(e,r,n,i){var a=Object.keys(i);e.writeUshort(r,n,a.length);for(var o=(n+=2)+12*a.length+4,s=0;s<a.length;s++){var l=a[s],u=parseInt(l.slice(1)),f=t.ttypes[u];if(null==f)throw new Error("unknown type of tag: "+u);var h=i[l];2==f&&(h=h[0]+"\0");var c=h.length;e.writeUshort(r,n,u),n+=2,e.writeUshort(r,n,f),n+=2,e.writeUint(r,n,c);var d=[-1,1,1,2,4,8,0,0,0,0,0,0,8][f]*c,p=n+=4;if(d>4&&(e.writeUint(r,n,o),p=o),2==f&&e.writeASCII(r,p,h),3==f)for(var b=0;b<c;b++)e.writeUshort(r,p+2*b,h[b]);if(4==f)for(b=0;b<c;b++)e.writeUint(r,p+4*b,h[b]);if(5==f)for(b=0;b<c;b++)e.writeUint(r,p+8*b,Math.round(1e4*h[b])),e.writeUint(r,p+8*b+4,1e4);if(12==f)for(b=0;b<c;b++)e.writeDouble(r,p+8*b,h[b]);d>4&&(o+=d+=1&d),n+=4}return[n,o]},t.toRGBA8=function(t){var e=t.width,r=t.height,n=e*r,a=4*n,o=t.data,s=new Uint8Array(4*n),l=t.t262[0],u=t.t258?Math.min(32,t.t258[0]):1,f=t.isLE?1:0;if(0==l)for(var h=Math.ceil(u*e/8),c=0;c<r;c++){var d=c*h,p=c*e;if(1==u)for(var b=0;b<e;b++){var m=p+b<<2,g=o[d+(b>>3)]>>7-(7&b)&1;s[m]=s[m+1]=s[m+2]=255*(1-g),s[m+3]=255}if(4==u)for(b=0;b<e;b++)m=p+b<<2,g=o[d+(b>>1)]>>4-4*(1&b)&15,s[m]=s[m+1]=s[m+2]=17*(15-g),s[m+3]=255;if(8==u)for(b=0;b<e;b++)m=p+b<<2,g=o[d+b],s[m]=s[m+1]=s[m+2]=255-g,s[m+3]=255}else if(1==l)for(h=Math.ceil(u*e/8),c=0;c<r;c++){if(d=c*h,p=c*e,1==u)for(b=0;b<e;b++)m=p+b<<2,g=o[d+(b>>3)]>>7-(7&b)&1,s[m]=s[m+1]=s[m+2]=255*g,s[m+3]=255;if(2==u)for(b=0;b<e;b++)m=p+b<<2,g=o[d+(b>>2)]>>6-2*(3&b)&3,s[m]=s[m+1]=s[m+2]=85*g,s[m+3]=255;if(8==u)for(b=0;b<e;b++)m=p+b<<2,g=o[d+b],s[m]=s[m+1]=s[m+2]=g,s[m+3]=255;if(16==u)for(b=0;b<e;b++)m=p+b<<2,g=o[d+(2*b+f)],s[m]=s[m+1]=s[m+2]=Math.min(255,g),s[m+3]=255}else if(2==l)if(8==u)if(t.t338)if(t.t338[0]>0)for(b=0;b<a;b++)s[b]=o[b];else for(b=0;b<a;b+=4)s[b]=o[b],s[b+1]=o[b+1],s[b+2]=o[b+2],s[b+3]=255;else{if(4==(w=t.t258?t.t258.length:3))for(b=0;b<a;b++)s[b]=o[b];if(3==w)for(b=0;b<n;b++){var y=3*b;s[m=b<<2]=o[y],s[m+1]=o[y+1],s[m+2]=o[y+2],s[m+3]=255}}else for(b=0;b<n;b++)y=6*b,s[m=b<<2]=o[y],s[m+1]=o[y+2],s[m+2]=o[y+4],s[m+3]=255;else if(3==l){var v=t.t320;for(b=0;b<n;b++){m=b<<2;var _=o[b];s[m]=v[_]>>8,s[m+1]=v[256+_]>>8,s[m+2]=v[512+_]>>8,s[m+3]=255}}else if(5==l){var w,x=(w=t.t258?t.t258.length:4)>4?1:0;for(b=0;b<n;b++){m=b<<2;var E=b*w,k=255-o[E],j=255-o[E+1],S=255-o[E+2],A=(255-o[E+3])*(1/255);s[m]=~~(k*A+.5),s[m+1]=~~(j*A+.5),s[m+2]=~~(S*A+.5),s[m+3]=255*(1-x)+o[E+4]*x}}else i("Unknown Photometric interpretation: "+l);return s},t.replaceIMG=function(){for(var e=document.getElementsByTagName("img"),r=0;r<e.length;r++){var n=e[r],i=n.getAttribute("src");if(null!=i){var a=i.split(".").pop().toLowerCase();if("tif"==a||"tiff"==a){var o=new XMLHttpRequest;t._xhrs.push(o),t._imgs.push(n),o.open("GET",i),o.responseType="arraybuffer",o.onload=t._imgLoaded,o.send()}}}},t._xhrs=[],t._imgs=[],t._imgLoaded=function(e){var r=e.target.response,n=t.decode(r),i=n[0];t.decodeImages(r,n);var a=t.toRGBA8(i),o=i.width,s=i.height,l=t._xhrs.indexOf(e.target),u=t._imgs[l];t._xhrs.splice(l,1),t._imgs.splice(l,1);var f=document.createElement("canvas");f.width=o,f.height=s;for(var h=f.getContext("2d"),c=h.createImageData(o,s),d=0;d<a.length;d++)c.data[d]=a[d];h.putImageData(c,0,0);var p=["style","class","id"];for(d=0;d<p.length;d++)f.setAttribute(p[d],u.getAttribute(p[d]));u.parentNode.replaceChild(f,u)},t._binBE={nextZero:function(t,e){for(;0!=t[e];)e++;return e},readUshort:function(t,e){return t[e]<<8|t[e+1]},readShort:function(e,r){var n=t._binBE.ui8;return n[0]=e[r+1],n[1]=e[r+0],t._binBE.i16[0]},readInt:function(e,r){var n=t._binBE.ui8;return n[0]=e[r+3],n[1]=e[r+2],n[2]=e[r+1],n[3]=e[r+0],t._binBE.i32[0]},readUint:function(e,r){var n=t._binBE.ui8;return n[0]=e[r+3],n[1]=e[r+2],n[2]=e[r+1],n[3]=e[r+0],t._binBE.ui32[0]},readASCII:function(t,e,r){for(var n="",i=0;i<r;i++)n+=String.fromCharCode(t[e+i]);return n},readFloat:function(e,r){for(var n=t._binBE.ui8,i=0;i<4;i++)n[i]=e[r+3-i];return t._binBE.fl32[0]},readDouble:function(e,r){for(var n=t._binBE.ui8,i=0;i<8;i++)n[i]=e[r+7-i];return t._binBE.fl64[0]},writeUshort:function(t,e,r){t[e]=r>>8&255,t[e+1]=255&r},writeUint:function(t,e,r){t[e]=r>>24&255,t[e+1]=r>>16&255,t[e+2]=r>>8&255,t[e+3]=255&r},writeASCII:function(t,e,r){for(var n=0;n<r.length;n++)t[e+n]=r.charCodeAt(n)},writeDouble:function(e,r,n){t._binBE.fl64[0]=n;for(var i=0;i<8;i++)e[r+i]=t._binBE.ui8[7-i]}},t._binBE.ui8=new Uint8Array(8),t._binBE.i16=new Int16Array(t._binBE.ui8.buffer),t._binBE.i32=new Int32Array(t._binBE.ui8.buffer),t._binBE.ui32=new Uint32Array(t._binBE.ui8.buffer),t._binBE.fl32=new Float32Array(t._binBE.ui8.buffer),t._binBE.fl64=new Float64Array(t._binBE.ui8.buffer),t._binLE={nextZero:t._binBE.nextZero,readUshort:function(t,e){return t[e+1]<<8|t[e]},readShort:function(e,r){var n=t._binBE.ui8;return n[0]=e[r+0],n[1]=e[r+1],t._binBE.i16[0]},readInt:function(e,r){var n=t._binBE.ui8;return n[0]=e[r+0],n[1]=e[r+1],n[2]=e[r+2],n[3]=e[r+3],t._binBE.i32[0]},readUint:function(e,r){var n=t._binBE.ui8;return n[0]=e[r+0],n[1]=e[r+1],n[2]=e[r+2],n[3]=e[r+3],t._binBE.ui32[0]},readASCII:t._binBE.readASCII,readFloat:function(e,r){for(var n=t._binBE.ui8,i=0;i<4;i++)n[i]=e[r+i];return t._binBE.fl32[0]},readDouble:function(e,r){for(var n=t._binBE.ui8,i=0;i<8;i++)n[i]=e[r+i];return t._binBE.fl64[0]}},t._copyTile=function(t,e,r,n,i,a,o,s){for(var l=Math.min(e,i-o),u=Math.min(r,a-s),f=0;f<u;f++)for(var h=(s+f)*i+o,c=f*e,d=0;d<l;d++)n[h+d]=t[c+d]}}(n,"function"==typeof t?t("pako"):self.pako)}()}).call(this,t("_process"))},{_process:312,pako:265}],362:[function(t,e,i){(function(t){function r(e){try{if(!t.localStorage)return!1}catch(t){return!1}var r=t.localStorage[e];return null!=r&&"true"===String(r).toLowerCase()}e.exports=function(t,e){if(r("noDeprecation"))return t;var n=!1;return function(){if(!n){if(r("throwDeprecation"))throw new Error(e);r("traceDeprecation")?console.trace(e):console.warn(e),n=!0}return t.apply(this,arguments)}}}).call(this,void 0!==r.g?r.g:"undefined"!=typeof self?self:void 0!==n?n:{})},{}],363:[function(t,e,r){arguments[4][25][0].apply(r,arguments)},{dup:25}],364:[function(t,e,r){arguments[4][26][0].apply(r,arguments)},{dup:26}],365:[function(t,e,r){arguments[4][27][0].apply(r,arguments)},{"./support/isBuffer":364,_process:312,dup:27,inherits:363}],366:[function(t,e,r){"use strict";var n=t("global/window"),i=t("is-function"),a=t("parse-headers"),o=t("xtend");function s(t,e,r){var n=t;return i(e)?(r=e,"string"==typeof t&&(n={uri:t})):n=o(e,{uri:t}),n.callback=r,n}function l(t,e,r){return u(e=s(t,e,r))}function u(t){if(void 0===t.callback)throw new Error("callback argument missing");var e=!1,r=function(r,n,i){e||(e=!0,t.callback(r,n,i))};function n(){var t=void 0;if(t=f.response?f.response:f.responseText||function(t){try{if("document"===t.responseType)return t.responseXML;var e=t.responseXML&&"parsererror"===t.responseXML.documentElement.nodeName;if(""===t.responseType&&!e)return t.responseXML}catch(t){}return null}(f),g)try{t=JSON.parse(t)}catch(t){}return t}function i(t){return clearTimeout(h),t instanceof Error||(t=new Error(""+(t||"Unknown XMLHttpRequest Error"))),t.statusCode=0,r(t,y)}function o(){if(!u){var e;clearTimeout(h),e=t.useXDR&&void 0===f.status?200:1223===f.status?204:f.status;var i=y,o=null;return 0!==e?(i={body:n(),statusCode:e,method:d,headers:{},url:c,rawRequest:f},f.getAllResponseHeaders&&(i.headers=a(f.getAllResponseHeaders()))):o=new Error("Internal XMLHttpRequest Error"),r(o,i,i.body)}}var s,u,f=t.xhr||null;f||(f=t.cors||t.useXDR?new l.XDomainRequest:new l.XMLHttpRequest);var h,c=f.url=t.uri||t.url,d=f.method=t.method||"GET",p=t.body||t.data,b=f.headers=t.headers||{},m=!!t.sync,g=!1,y={body:void 0,headers:{},statusCode:0,method:d,url:c,rawRequest:f};if("json"in t&&!1!==t.json&&(g=!0,b.accept||b.Accept||(b.Accept="application/json"),"GET"!==d&&"HEAD"!==d&&(b["content-type"]||b["Content-Type"]||(b["Content-Type"]="application/json"),p=JSON.stringify(!0===t.json?p:t.json))),f.onreadystatechange=function(){4===f.readyState&&setTimeout(o,0)},f.onload=o,f.onerror=i,f.onprogress=function(){},f.onabort=function(){u=!0},f.ontimeout=i,f.open(d,c,!m,t.username,t.password),m||(f.withCredentials=!!t.withCredentials),!m&&t.timeout>0&&(h=setTimeout((function(){if(!u){u=!0,f.abort("timeout");var t=new Error("XMLHttpRequest timeout");t.code="ETIMEDOUT",i(t)}}),t.timeout)),f.setRequestHeader)for(s in b)b.hasOwnProperty(s)&&f.setRequestHeader(s,b[s]);else if(t.headers&&!function(t){for(var e in t)if(t.hasOwnProperty(e))return!1;return!0}(t.headers))throw new Error("Headers cannot be set on an XDomainRequest object");return"responseType"in t&&(f.responseType=t.responseType),"beforeSend"in t&&"function"==typeof t.beforeSend&&t.beforeSend(f),f.send(p||null),f}e.exports=l,e.exports.default=l,l.XMLHttpRequest=n.XMLHttpRequest||function(){},l.XDomainRequest="withCredentials"in new l.XMLHttpRequest?l.XMLHttpRequest:n.XDomainRequest,function(t,e){for(var r=0;r<t.length;r++)e(t[r])}(["get","put","post","patch","head","delete"],(function(t){l["delete"===t?"del":t]=function(e,r,n){return(r=s(e,r,n)).method=t.toUpperCase(),u(r)}}))},{"global/window":251,"is-function":257,"parse-headers":285,xtend:368}],367:[function(t,e,r){e.exports=void 0!==self.DOMParser?function(t){return(new self.DOMParser).parseFromString(t,"application/xml")}:void 0!==self.ActiveXObject&&new self.ActiveXObject("Microsoft.XMLDOM")?function(t){var e=new self.ActiveXObject("Microsoft.XMLDOM");return e.async="false",e.loadXML(t),e}:function(t){var e=document.createElement("div");return e.innerHTML=t,e}},{}],368:[function(t,e,r){e.exports=function(){for(var t={},e=0;e<arguments.length;e++){var r=arguments[e];for(var i in r)n.call(r,i)&&(t[i]=r[i])}return t};var n=Object.prototype.hasOwnProperty},{}],369:[function(t,e,r){"use strict";Object.defineProperty(r,"__esModule",{value:!0}),r.srcOver=function(t,e){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:1;t.a*=r;var n=e.a+t.a-e.a*t.a;return{r:(t.r*t.a+e.r*e.a*(1-t.a))/n,g:(t.g*t.a+e.g*e.a*(1-t.a))/n,b:(t.b*t.a+e.b*e.a*(1-t.a))/n,a:n}},r.dstOver=function(t,e){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:1;t.a*=r;var n=e.a+t.a-e.a*t.a;return{r:(e.r*e.a+t.r*t.a*(1-e.a))/n,g:(e.g*e.a+t.g*t.a*(1-e.a))/n,b:(e.b*e.a+t.b*t.a*(1-e.a))/n,a:n}},r.multiply=function(t,e){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:1;t.a*=r;var n=e.a+t.a-e.a*t.a,i=t.r*t.a,a=t.g*t.a,o=t.b*t.a,s=e.r*e.a,l=e.g*e.a,u=e.b*e.a;return{r:(i*s+i*(1-e.a)+s*(1-t.a))/n,g:(a*l+a*(1-e.a)+l*(1-t.a))/n,b:(o*u+o*(1-e.a)+u*(1-t.a))/n,a:n}},r.screen=function(t,e){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:1;t.a*=r;var n=e.a+t.a-e.a*t.a,i=t.r*t.a,a=t.g*t.a,o=t.b*t.a,s=e.r*e.a,l=e.g*e.a,u=e.b*e.a;return{r:(i*e.a+s*t.a-i*s+i*(1-e.a)+s*(1-t.a))/n,g:(a*e.a+l*t.a-a*l+a*(1-e.a)+l*(1-t.a))/n,b:(o*e.a+u*t.a-o*u+o*(1-e.a)+u*(1-t.a))/n,a:n}},r.overlay=function(t,e){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:1;t.a*=r;var n=e.a+t.a-e.a*t.a,i=t.r*t.a,a=t.g*t.a,o=t.b*t.a,s=e.r*e.a,l=e.g*e.a,u=e.b*e.a;return{r:(2*s<=e.a?2*i*s+i*(1-e.a)+s*(1-t.a):i*(1+e.a)+s*(1+t.a)-2*s*i-e.a*t.a)/n,g:(2*l<=e.a?2*a*l+a*(1-e.a)+l*(1-t.a):a*(1+e.a)+l*(1+t.a)-2*l*a-e.a*t.a)/n,b:(2*u<=e.a?2*o*u+o*(1-e.a)+u*(1-t.a):o*(1+e.a)+u*(1+t.a)-2*u*o-e.a*t.a)/n,a:n}},r.darken=function(t,e){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:1;t.a*=r;var n=e.a+t.a-e.a*t.a,i=t.r*t.a,a=t.g*t.a,o=t.b*t.a,s=e.r*e.a,l=e.g*e.a,u=e.b*e.a;return{r:(Math.min(i*e.a,s*t.a)+i*(1-e.a)+s*(1-t.a))/n,g:(Math.min(a*e.a,l*t.a)+a*(1-e.a)+l*(1-t.a))/n,b:(Math.min(o*e.a,u*t.a)+o*(1-e.a)+u*(1-t.a))/n,a:n}},r.lighten=function(t,e){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:1;t.a*=r;var n=e.a+t.a-e.a*t.a,i=t.r*t.a,a=t.g*t.a,o=t.b*t.a,s=e.r*e.a,l=e.g*e.a,u=e.b*e.a;return{r:(Math.max(i*e.a,s*t.a)+i*(1-e.a)+s*(1-t.a))/n,g:(Math.max(a*e.a,l*t.a)+a*(1-e.a)+l*(1-t.a))/n,b:(Math.max(o*e.a,u*t.a)+o*(1-e.a)+u*(1-t.a))/n,a:n}},r.hardLight=function(t,e){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:1;t.a*=r;var n=e.a+t.a-e.a*t.a,i=t.r*t.a,a=t.g*t.a,o=t.b*t.a,s=e.r*e.a,l=e.g*e.a,u=e.b*e.a;return{r:(2*i<=t.a?2*i*s+i*(1-e.a)+s*(1-t.a):i*(1+e.a)+s*(1+t.a)-2*s*i-e.a*t.a)/n,g:(2*a<=t.a?2*a*l+a*(1-e.a)+l*(1-t.a):a*(1+e.a)+l*(1+t.a)-2*l*a-e.a*t.a)/n,b:(2*o<=t.a?2*o*u+o*(1-e.a)+u*(1-t.a):o*(1+e.a)+u*(1+t.a)-2*u*o-e.a*t.a)/n,a:n}},r.difference=function(t,e){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:1;t.a*=r;var n=e.a+t.a-e.a*t.a,i=t.r*t.a,a=t.g*t.a,o=t.b*t.a,s=e.r*e.a,l=e.g*e.a,u=e.b*e.a;return{r:(i+s-2*Math.min(i*e.a,s*t.a))/n,g:(a+l-2*Math.min(a*e.a,l*t.a))/n,b:(o+u-2*Math.min(o*e.a,u*t.a))/n,a:n}},r.exclusion=function(t,e){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:1;t.a*=r;var n=e.a+t.a-e.a*t.a,i=t.r*t.a,a=t.g*t.a,o=t.b*t.a,s=e.r*e.a,l=e.g*e.a,u=e.b*e.a;return{r:(i*e.a+s*t.a-2*i*s+i*(1-e.a)+s*(1-t.a))/n,g:(a*e.a+l*t.a-2*a*l+a*(1-e.a)+l*(1-t.a))/n,b:(o*e.a+u*t.a-2*o*u+o*(1-e.a)+u*(1-t.a))/n,a:n}}},{}],370:[function(t,e,r){"use strict";var n=t("@babel/runtime/helpers/interopRequireWildcard");Object.defineProperty(r,"__esModule",{value:!0}),r.default=function(t,e,r){var n=arguments.length>3&&void 0!==arguments[3]?arguments[3]:{},s=arguments.length>4?arguments[4]:void 0;if("function"==typeof n&&(s=n,n={}),!(t instanceof this.constructor))return i.throwError.call(this,"The source must be a Jimp image",s);if("number"!=typeof e||"number"!=typeof r)return i.throwError.call(this,"x and y must be numbers",s);var l=n,u=l.mode,f=l.opacitySource,h=l.opacityDest;u||(u=a.BLEND_SOURCE_OVER),("number"!=typeof f||f<0||f>1)&&(f=1),("number"!=typeof h||h<0||h>1)&&(h=1);var c=o[u];e=Math.round(e),r=Math.round(r);var d=this;return 1!==h&&d.opacity(h),t.scanQuiet(0,0,t.bitmap.width,t.bitmap.height,(function(t,n,i){var o=d.getPixelIndex(e+t,r+n,a.EDGE_CROP),s=c({r:this.bitmap.data[i+0]/255,g:this.bitmap.data[i+1]/255,b:this.bitmap.data[i+2]/255,a:this.bitmap.data[i+3]/255},{r:d.bitmap.data[o+0]/255,g:d.bitmap.data[o+1]/255,b:d.bitmap.data[o+2]/255,a:d.bitmap.data[o+3]/255},f);d.bitmap.data[o+0]=this.constructor.limit255(255*s.r),d.bitmap.data[o+1]=this.constructor.limit255(255*s.g),d.bitmap.data[o+2]=this.constructor.limit255(255*s.b),d.bitmap.data[o+3]=this.constructor.limit255(255*s.a)})),(0,i.isNodePattern)(s)&&s.call(this,null,this),this};var i=t("@jimp/utils"),a=n(t("../constants")),o=n(t("./composite-modes"));e.exports=r.default},{"../constants":371,"./composite-modes":369,"@babel/runtime/helpers/interopRequireWildcard":11,"@jimp/utils":414}],371:[function(t,e,r){"use strict";Object.defineProperty(r,"__esModule",{value:!0}),r.EDGE_CROP=r.EDGE_WRAP=r.EDGE_EXTEND=r.BLEND_EXCLUSION=r.BLEND_DIFFERENCE=r.BLEND_HARDLIGHT=r.BLEND_LIGHTEN=r.BLEND_DARKEN=r.BLEND_OVERLAY=r.BLEND_SCREEN=r.BLEND_MULTIPLY=r.BLEND_DESTINATION_OVER=r.BLEND_SOURCE_OVER=r.VERTICAL_ALIGN_BOTTOM=r.VERTICAL_ALIGN_MIDDLE=r.VERTICAL_ALIGN_TOP=r.HORIZONTAL_ALIGN_RIGHT=r.HORIZONTAL_ALIGN_CENTER=r.HORIZONTAL_ALIGN_LEFT=r.AUTO=void 0,r.AUTO=-1,r.HORIZONTAL_ALIGN_LEFT=1,r.HORIZONTAL_ALIGN_CENTER=2,r.HORIZONTAL_ALIGN_RIGHT=4,r.VERTICAL_ALIGN_TOP=8,r.VERTICAL_ALIGN_MIDDLE=16,r.VERTICAL_ALIGN_BOTTOM=32,r.BLEND_SOURCE_OVER="srcOver",r.BLEND_DESTINATION_OVER="dstOver",r.BLEND_MULTIPLY="multiply",r.BLEND_SCREEN="screen",r.BLEND_OVERLAY="overlay",r.BLEND_DARKEN="darken",r.BLEND_LIGHTEN="lighten",r.BLEND_HARDLIGHT="hardLight",r.BLEND_DIFFERENCE="difference",r.BLEND_EXCLUSION="exclusion",r.EDGE_EXTEND=1,r.EDGE_WRAP=2,r.EDGE_CROP=3},{}],372:[function(t,e,r){(function(e){"use strict";var i=t("@babel/runtime/helpers/interopRequireWildcard"),a=t("@babel/runtime/helpers/interopRequireDefault");t("core-js/modules/es.array.concat"),t("core-js/modules/es.array.find"),t("core-js/modules/es.array.for-each"),t("core-js/modules/es.array.index-of"),t("core-js/modules/es.array.iterator"),t("core-js/modules/es.array.join"),t("core-js/modules/es.array-buffer.slice"),t("core-js/modules/es.date.to-string"),t("core-js/modules/es.number.constructor"),t("core-js/modules/es.object.assign"),t("core-js/modules/es.object.entries"),t("core-js/modules/es.object.to-string"),t("core-js/modules/es.parse-int"),t("core-js/modules/es.promise"),t("core-js/modules/es.regexp.exec"),t("core-js/modules/es.regexp.to-string"),t("core-js/modules/es.string.match"),t("core-js/modules/es.string.replace"),t("core-js/modules/es.typed-array.uint8-array"),t("core-js/modules/es.typed-array.uint8-clamped-array"),t("core-js/modules/es.typed-array.copy-within"),t("core-js/modules/es.typed-array.every"),t("core-js/modules/es.typed-array.fill"),t("core-js/modules/es.typed-array.filter"),t("core-js/modules/es.typed-array.find"),t("core-js/modules/es.typed-array.find-index"),t("core-js/modules/es.typed-array.for-each"),t("core-js/modules/es.typed-array.includes"),t("core-js/modules/es.typed-array.index-of"),t("core-js/modules/es.typed-array.iterator"),t("core-js/modules/es.typed-array.join"),t("core-js/modules/es.typed-array.last-index-of"),t("core-js/modules/es.typed-array.map"),t("core-js/modules/es.typed-array.reduce"),t("core-js/modules/es.typed-array.reduce-right"),t("core-js/modules/es.typed-array.reverse"),t("core-js/modules/es.typed-array.set"),t("core-js/modules/es.typed-array.slice"),t("core-js/modules/es.typed-array.some"),t("core-js/modules/es.typed-array.sort"),t("core-js/modules/es.typed-array.subarray"),t("core-js/modules/es.typed-array.to-locale-string"),t("core-js/modules/es.typed-array.to-string"),t("core-js/modules/web.dom-collections.for-each"),t("core-js/modules/web.timers"),Object.defineProperty(r,"__esModule",{value:!0}),r.addConstants=z,r.addJimpMethods=F,r.jimpEvMethod=H,r.jimpEvChange=G,Object.defineProperty(r,"addType",{enumerable:!0,get:function(){return T.addType}}),r.default=void 0;for(var o=a(t("@babel/runtime/helpers/construct")),s=a(t("@babel/runtime/helpers/slicedToArray")),l=a(t("@babel/runtime/helpers/classCallCheck")),u=a(t("@babel/runtime/helpers/createClass")),f=a(t("@babel/runtime/helpers/possibleConstructorReturn")),h=a(t("@babel/runtime/helpers/getPrototypeOf")),c=a(t("@babel/runtime/helpers/assertThisInitialized")),d=a(t("@babel/runtime/helpers/inherits")),p=a(t("@babel/runtime/helpers/defineProperty")),b=a(t("@babel/runtime/helpers/typeof")),m=a(t("fs")),g=a(t("path")),y=a(t("events")),v=t("@jimp/utils"),_=a(t("any-base")),w=a(t("mkdirp")),x=a(t("pixelmatch")),E=a(t("tinycolor2")),k=a(t("./modules/phash")),j=a(t("./request")),S=a(t("./composite")),A=a(t("./utils/promisify")),T=i(t("./utils/mime")),I=t("./utils/image-bitmap"),P=i(t("./constants")),M="0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_",O=[NaN,NaN],R=2;R<65;R++){var L=(0,_.default)(_.default.BIN,M.slice(0,R))(new Array(65).join("1"));O.push(L.length)}function C(){}function B(t,r){(0,j.default)(t,(function(n,i,a){if(n)return r(n);if("headers"in i&&"location"in i.headers)return t.url=i.headers.location,B(t,r);if("object"===(0,b.default)(a)&&e.isBuffer(a))return r(null,a);var o="Could not load Buffer from <"+t.url+"> (HTTP: "+i.statusCode+")";return new Error(o)}))}var D,N={data:null,width:null,height:null},U=function(t){function r(){for(var t,n=arguments.length,i=new Array(n),a=0;a<n;a++)i[a]=arguments[a];(0,l.default)(this,r),t=(0,f.default)(this,(0,h.default)(r).call(this)),(0,p.default)((0,c.default)(t),"bitmap",N),(0,p.default)((0,c.default)(t),"_background",0),(0,p.default)((0,c.default)(t),"_originalMime",r.MIME_PNG),(0,p.default)((0,c.default)(t),"_exif",null),(0,p.default)((0,c.default)(t),"_rgba",!0),(0,p.default)((0,c.default)(t),"writeAsync",(function(e){return(0,A.default)(t.write,(0,c.default)(t),e)})),(0,p.default)((0,c.default)(t),"getBase64Async",(function(e){return(0,A.default)(t.getBase64,(0,c.default)(t),e)})),(0,p.default)((0,c.default)(t),"getBuffer",I.getBuffer),(0,p.default)((0,c.default)(t),"getBufferAsync",I.getBufferAsync),(0,p.default)((0,c.default)(t),"getPixelColour",t.getPixelColor),(0,p.default)((0,c.default)(t),"setPixelColour",t.setPixelColor);var o,s,u=(0,c.default)(t),d=C;function g(){for(var t=arguments.length,e=new Array(t),r=0;r<t;r++)e[r]=arguments[r];var n=e[0];(n||{}).methodName="constructor",setTimeout((function(){var t;n&&d===C?u.emitError("constructor",n):n||u.emitMulti("constructor","initialized"),(t=d).call.apply(t,[u].concat(e))}),1)}if(s=i[0],Object.prototype.toString.call(s).toLowerCase().indexOf("arraybuffer")>-1&&(i[0]=function(t){for(var r=e.alloc(t.byteLength),n=new Uint8Array(t),i=0;i<r.length;++i)r[i]=n[i];return r}(i[0])),"number"==typeof i[0]&&"number"==typeof i[1]||parseInt(i[0],10)&&parseInt(i[1],10)){var y=parseInt(i[0],10),_=parseInt(i[1],10);if(d=i[2],"number"==typeof i[2]&&(t._background=i[2],d=i[3]),"string"==typeof i[2]&&(t._background=r.cssColorToHex(i[2]),d=i[3]),void 0===d&&(d=C),"function"!=typeof d)return(0,f.default)(t,v.throwError.call((0,c.default)(t),"cb must be a function",g));t.bitmap={data:e.alloc(y*_*4),width:y,height:_};for(var w=0;w<t.bitmap.data.length;w+=4)t.bitmap.data.writeUInt32BE(t._background,w);g(null,(0,c.default)(t))}else if("object"===(0,b.default)(i[0])&&i[0].url){if("function"!=typeof(d=i[1]||C))return(0,f.default)(t,v.throwError.call((0,c.default)(t),"cb must be a function",g));B(i[0],(function(e,r){if(e)return v.throwError.call((0,c.default)(t),e,g);t.parseBitmap(r,i[0].url,g)}))}else if(i[0]instanceof r){var x=i[0];if(void 0===(d=i[1])&&(d=C),"function"!=typeof d)return(0,f.default)(t,v.throwError.call((0,c.default)(t),"cb must be a function",g));t.bitmap={data:e.from(x.bitmap.data),width:x.bitmap.width,height:x.bitmap.height},t._quality=x._quality,t._deflateLevel=x._deflateLevel,t._deflateStrategy=x._deflateStrategy,t._filterType=x._filterType,t._rgba=x._rgba,t._background=x._background,t._originalMime=x._originalMime,g(null,(0,c.default)(t))}else if((o=i[0])&&"object"===(0,b.default)(o)&&"number"==typeof o.width&&"number"==typeof o.height&&(e.isBuffer(o.data)||o.data instanceof Uint8Array||"function"==typeof Uint8ClampedArray&&o.data instanceof Uint8ClampedArray)&&(o.data.length===o.width*o.height*4||o.data.length===o.width*o.height*3)){var E=i[0];d=i[1]||C;var k=E.width*E.height*4===E.data.length?e.from(E.data):function(t){if(t.length%3!=0)throw new Error("Buffer length is incorrect");for(var r=e.allocUnsafe(t.length/3*4),n=0,i=0;i<t.length;i++)r[n]=t[i],(i+1)%3==0&&(r[++n]=255),n++;return r}(E.data);t.bitmap={data:k,width:E.width,height:E.height},g(null,(0,c.default)(t))}else if("string"==typeof i[0]){var j=i[0];if(void 0===(d=i[1])&&(d=C),"function"!=typeof d)return(0,f.default)(t,v.throwError.call((0,c.default)(t),"cb must be a function",g));!function(t,e){m.default&&"function"==typeof m.default.readFile&&!t.match(/^(http|ftp)s?:\/\/./)?m.default.readFile(t,e):B({url:t},e)}(j,(function(e,r){if(e)return v.throwError.call((0,c.default)(t),e,g);t.parseBitmap(r,j,g)}))}else if("object"===(0,b.default)(i[0])&&e.isBuffer(i[0])){var S=i[0];if("function"!=typeof(d=i[1]))return(0,f.default)(t,v.throwError.call((0,c.default)(t),"cb must be a function",g));t.parseBitmap(S,null,g)}else{"function"!=typeof(d=i[i.length-1])&&"function"!=typeof(d=i[i.length-2])&&(d=C);var T=r.__extraConstructors.find((function(t){return t.test.apply(t,i)}));if(!T)return(0,f.default)(t,v.throwError.call((0,c.default)(t),"No matching constructor overloading was found. Please see the docs for how to call the Jimp constructor.",g));new Promise((function(e,r){var n;return(n=T.run).call.apply(n,[(0,c.default)(t),e,r].concat(i))})).then((function(){return g(null,(0,c.default)(t))})).catch(g)}return t}return(0,d.default)(r,t),(0,u.default)(r,[{key:"parseBitmap",value:function(t,e,r){I.parseBitmap.call(this,t,null,r)}},{key:"rgba",value:function(t,e){return"boolean"!=typeof t?v.throwError.call(this,"bool must be a boolean, true for RGBA or false for RGB",e):(this._rgba=t,(0,v.isNodePattern)(e)&&e.call(this,null,this),this)}},{key:"emitMulti",value:function(t,e){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};r=Object.assign(r,{methodName:t,eventName:e}),this.emit("any",r),t&&this.emit(t,r),this.emit(e,r)}},{key:"emitError",value:function(t,e){this.emitMulti(t,"error",e)}},{key:"getHeight",value:function(){return this.bitmap.height}},{key:"getWidth",value:function(){return this.bitmap.width}},{key:"inspect",value:function(){return"<Jimp "+(this.bitmap===N?"pending...":this.bitmap.width+"x"+this.bitmap.height)+">"}},{key:"toString",value:function(){return"[object Jimp]"}},{key:"getMIME",value:function(){return this._originalMime||r.MIME_PNG}},{key:"getExtension",value:function(){var t=this.getMIME();return T.getExtension(t)}},{key:"write",value:function(t,e){var r=this;if(!m.default||!m.default.createWriteStream)throw new Error("Cant access the filesystem. You can use the getBase64 method.");if("string"!=typeof t)return v.throwError.call(this,"path must be a string",e);if(void 0===e&&(e=C),"function"!=typeof e)return v.throwError.call(this,"cb must be a function",e);var n=T.getType(t)||this.getMIME(),i=g.default.parse(t);return i.dir&&w.default.sync(i.dir),this.getBuffer(n,(function(n,i){if(n)return v.throwError.call(r,n,e);var a=m.default.createWriteStream(t);a.on("open",(function(){a.write(i),a.end()})).on("error",(function(t){return v.throwError.call(r,t,e)})),a.on("finish",(function(){e.call(r,null,r)}))})),this}},{key:"getBase64",value:function(t,e){return t===r.AUTO&&(t=this.getMIME()),"string"!=typeof t?v.throwError.call(this,"mime must be a string",e):"function"!=typeof e?v.throwError.call(this,"cb must be a function",e):(this.getBuffer(t,(function(r,n){if(r)return v.throwError.call(this,r,e);var i="data:"+t+";base64,"+n.toString("base64");e.call(this,null,i)})),this)}},{key:"hash",value:function(t,e){if("function"==typeof(t=t||64)&&(e=t,t=64),"number"!=typeof t)return v.throwError.call(this,"base must be a number",e);if(t<2||t>64)return v.throwError.call(this,"base must be a number between 2 and 64",e);var r=this.pHash();for(r=(0,_.default)(_.default.BIN,M.slice(0,t))(r);r.length<O[t];)r="0"+r;return(0,v.isNodePattern)(e)&&e.call(this,null,r),r}},{key:"pHash",value:function(){return(new k.default).getHash(this)}},{key:"distanceFromHash",value:function(t){var e=new k.default,r=e.getHash(this);return e.distance(r,t)}},{key:"getPixelIndex",value:function(t,e,n,i){var a,o;if("function"==typeof n&&void 0===i&&(i=n,n=null),n||(n=r.EDGE_EXTEND),"number"!=typeof t||"number"!=typeof e)return v.throwError.call(this,"x and y must be numbers",i);a=t=Math.round(t),o=e=Math.round(e),n===r.EDGE_EXTEND&&(t<0&&(a=0),t>=this.bitmap.width&&(a=this.bitmap.width-1),e<0&&(o=0),e>=this.bitmap.height&&(o=this.bitmap.height-1)),n===r.EDGE_WRAP&&(t<0&&(a=this.bitmap.width+t),t>=this.bitmap.width&&(a=t%this.bitmap.width),e<0&&(a=this.bitmap.height+e),e>=this.bitmap.height&&(o=e%this.bitmap.height));var s=this.bitmap.width*o+a<<2;return(a<0||a>=this.bitmap.width)&&(s=-1),(o<0||o>=this.bitmap.height)&&(s=-1),(0,v.isNodePattern)(i)&&i.call(this,null,s),s}},{key:"getPixelColor",value:function(t,e,r){if("number"!=typeof t||"number"!=typeof e)return v.throwError.call(this,"x and y must be numbers",r);t=Math.round(t),e=Math.round(e);var n=this.getPixelIndex(t,e),i=this.bitmap.data.readUInt32BE(n);return(0,v.isNodePattern)(r)&&r.call(this,null,i),i}},{key:"setPixelColor",value:function(t,e,r,n){if("number"!=typeof t||"number"!=typeof e||"number"!=typeof r)return v.throwError.call(this,"hex, x and y must be numbers",n);e=Math.round(e),r=Math.round(r);var i=this.getPixelIndex(e,r);return this.bitmap.data.writeUInt32BE(t,i),(0,v.isNodePattern)(n)&&n.call(this,null,this),this}},{key:"hasAlpha",value:function(){for(var t=0;t<this.bitmap.height;t++)for(var e=0;e<this.bitmap.width;e++){var r=this.bitmap.width*t+e<<2;if(255!==this.bitmap.data[r+3])return!0}return!1}},{key:"scanIterator",value:function(t,e,r,n){return"number"!=typeof t||"number"!=typeof e?v.throwError.call(this,"x and y must be numbers"):"number"!=typeof r||"number"!=typeof n?v.throwError.call(this,"w and h must be numbers"):(0,v.scanIterator)(this,t,e,r,n)}}]),r}(y.default);function z(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:U;Object.entries(t).forEach((function(t){var r=(0,s.default)(t,2),n=r[0],i=r[1];e[n]=i}))}function F(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:U;Object.entries(t).forEach((function(t){var r=(0,s.default)(t,2),n=r[0],i=r[1];e.prototype[n]=i}))}function H(t,e,r){var n="before-"+e,i=e.replace(/e$/,"")+"ed";U.prototype[t]=function(){for(var e,a=arguments.length,o=new Array(a),s=0;s<a;s++)o[s]=arguments[s];var l,u=o[r.length-1],f=this;"function"==typeof u?(e=function(){for(var e=arguments.length,r=new Array(e),n=0;n<e;n++)r[n]=arguments[n];var a=r[0],o=r[1];a?f.emitError(t,a):f.emitMulti(t,i,(0,p.default)({},t,o)),u.apply(this,r)},o[o.length-1]=e):e=!1,this.emitMulti(t,n);try{l=r.apply(this,o),e||this.emitMulti(t,i,(0,p.default)({},t,l))}catch(e){e.methodName=t,this.emitError(t,e)}return l},U.prototype[t+"Quiet"]=r}function G(t,e){H(t,"change",e)}z(P),F({composite:S.default}),U.__extraConstructors=[],U.appendConstructorOption=function(t,e,r){U.__extraConstructors.push({name:t,test:e,run:r})},U.read=function(){for(var t=arguments.length,e=new Array(t),r=0;r<t;r++)e[r]=arguments[r];return new Promise((function(t,r){(0,o.default)(U,e.concat([function(e,n){e?r(e):t(n)}]))}))},U.create=U.read,U.rgbaToInt=function(t,e,r,n,i){if("number"!=typeof t||"number"!=typeof e||"number"!=typeof r||"number"!=typeof n)return v.throwError.call(this,"r, g, b and a must be numbers",i);if(t<0||t>255)return v.throwError.call(this,"r must be between 0 and 255",i);if((e<0||e>255)&&v.throwError.call(this,"g must be between 0 and 255",i),r<0||r>255)return v.throwError.call(this,"b must be between 0 and 255",i);if(n<0||n>255)return v.throwError.call(this,"a must be between 0 and 255",i);t=Math.round(t),r=Math.round(r),e=Math.round(e),n=Math.round(n);var a=t*Math.pow(256,3)+e*Math.pow(256,2)+r*Math.pow(256,1)+n*Math.pow(256,0);return(0,v.isNodePattern)(i)&&i.call(this,null,a),a},U.intToRGBA=function(t,e){if("number"!=typeof t)return v.throwError.call(this,"i must be a number",e);var r={};return r.r=Math.floor(t/Math.pow(256,3)),r.g=Math.floor((t-r.r*Math.pow(256,3))/Math.pow(256,2)),r.b=Math.floor((t-r.r*Math.pow(256,3)-r.g*Math.pow(256,2))/Math.pow(256,1)),r.a=Math.floor((t-r.r*Math.pow(256,3)-r.g*Math.pow(256,2)-r.b*Math.pow(256,1))/Math.pow(256,0)),(0,v.isNodePattern)(e)&&e.call(this,null,r),r},U.cssColorToHex=function(t){return"number"==typeof(t=t||0)?Number(t):parseInt((0,E.default)(t).toHex8(),16)},U.limit255=function(t){return t=Math.max(t,0),Math.min(t,255)},U.diff=function(t,e){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:.1;if(!(t instanceof U&&e instanceof U))return v.throwError.call(this,"img1 and img2 must be an Jimp images");var n=t.bitmap,i=e.bitmap;if(n.width===i.width&&n.height===i.height||(n.width*n.height>i.width*i.height?t=t.cloneQuiet().resize(i.width,i.height):e=e.cloneQuiet().resize(n.width,n.height)),"number"!=typeof r||r<0||r>1)return v.throwError.call(this,"threshold must be a number between 0 and 1");var a=new U(n.width,n.height,4294967295);return{percent:(0,x.default)(n.data,i.data,a.bitmap.data,a.bitmap.width,a.bitmap.height,{threshold:r})/(a.bitmap.width*a.bitmap.height),image:a}},U.distance=function(t,e){var r=new k.default,n=r.getHash(t),i=r.getHash(e);return r.distance(n,i)},U.compareHashes=function(t,e){return(new k.default).distance(t,e)},U.colorDiff=function(t,e){var r=function(t){return Math.pow(t,2)},n=Math.max;return 0===t.a||t.a||(t.a=255),0===e.a||e.a||(e.a=255),(n(r(t.r-e.r),r(t.r-e.r-t.a+e.a))+n(r(t.g-e.g),r(t.g-e.g-t.a+e.a))+n(r(t.b-e.b),r(t.b-e.b-t.a+e.a)))/195075},H("clone","clone",(function(t){var e=new U(this);return(0,v.isNodePattern)(t)&&t.call(e,null,e),e})),G("background",(function(t,e){return"number"!=typeof t?v.throwError.call(this,"hex must be a hexadecimal rgba value",e):(this._background=t,(0,v.isNodePattern)(e)&&e.call(this,null,this),this)})),G("scan",(function(t,e,r,n,i,a){if("number"!=typeof t||"number"!=typeof e)return v.throwError.call(this,"x and y must be numbers",a);if("number"!=typeof r||"number"!=typeof n)return v.throwError.call(this,"w and h must be numbers",a);if("function"!=typeof i)return v.throwError.call(this,"f must be a function",a);var o=(0,v.scan)(this,t,e,r,n,i);return(0,v.isNodePattern)(a)&&a.call(this,null,o),o})),void 0!==n&&"object"===(void 0===n?"undefined":(0,b.default)(n))&&(D=n),"undefined"!=typeof self&&"object"===("undefined"==typeof self?"undefined":(0,b.default)(self))&&(D=self),D.Jimp=U,D.Buffer=e;var q=U;r.default=q}).call(this,t("buffer").Buffer)},{"./composite":370,"./constants":371,"./modules/phash":373,"./request":374,"./utils/image-bitmap":375,"./utils/mime":376,"./utils/promisify":377,"@babel/runtime/helpers/assertThisInitialized":3,"@babel/runtime/helpers/classCallCheck":4,"@babel/runtime/helpers/construct":5,"@babel/runtime/helpers/createClass":6,"@babel/runtime/helpers/defineProperty":7,"@babel/runtime/helpers/getPrototypeOf":8,"@babel/runtime/helpers/inherits":9,"@babel/runtime/helpers/interopRequireDefault":10,"@babel/runtime/helpers/interopRequireWildcard":11,"@babel/runtime/helpers/possibleConstructorReturn":16,"@babel/runtime/helpers/slicedToArray":18,"@babel/runtime/helpers/typeof":20,"@jimp/utils":414,"any-base":22,buffer:47,"core-js/modules/es.array-buffer.slice":172,"core-js/modules/es.array.concat":173,"core-js/modules/es.array.find":177,"core-js/modules/es.array.for-each":178,"core-js/modules/es.array.index-of":180,"core-js/modules/es.array.iterator":182,"core-js/modules/es.array.join":183,"core-js/modules/es.date.to-string":187,"core-js/modules/es.number.constructor":189,"core-js/modules/es.object.assign":190,"core-js/modules/es.object.entries":193,"core-js/modules/es.object.to-string":197,"core-js/modules/es.parse-int":198,"core-js/modules/es.promise":199,"core-js/modules/es.regexp.exec":200,"core-js/modules/es.regexp.to-string":201,"core-js/modules/es.string.match":204,"core-js/modules/es.string.replace":205,"core-js/modules/es.typed-array.copy-within":208,"core-js/modules/es.typed-array.every":209,"core-js/modules/es.typed-array.fill":210,"core-js/modules/es.typed-array.filter":211,"core-js/modules/es.typed-array.find":213,"core-js/modules/es.typed-array.find-index":212,"core-js/modules/es.typed-array.for-each":216,"core-js/modules/es.typed-array.includes":217,"core-js/modules/es.typed-array.index-of":218,"core-js/modules/es.typed-array.iterator":219,"core-js/modules/es.typed-array.join":220,"core-js/modules/es.typed-array.last-index-of":221,"core-js/modules/es.typed-array.map":222,"core-js/modules/es.typed-array.reduce":224,"core-js/modules/es.typed-array.reduce-right":223,"core-js/modules/es.typed-array.reverse":225,"core-js/modules/es.typed-array.set":226,"core-js/modules/es.typed-array.slice":227,"core-js/modules/es.typed-array.some":228,"core-js/modules/es.typed-array.sort":229,"core-js/modules/es.typed-array.subarray":230,"core-js/modules/es.typed-array.to-locale-string":231,"core-js/modules/es.typed-array.to-string":232,"core-js/modules/es.typed-array.uint8-array":233,"core-js/modules/es.typed-array.uint8-clamped-array":234,"core-js/modules/web.dom-collections.for-each":235,"core-js/modules/web.timers":237,events:239,fs:46,mkdirp:262,path:286,pixelmatch:288,tinycolor2:357}],373:[function(t,e,r){"use strict";function n(t,e){this.size=this.size||t,this.smallerSize=this.smallerSize||e,function(t){for(var e=1;e<t;e++)i[e]=1;i[0]=1/Math.sqrt(2)}(this.size)}n.prototype.size=32,n.prototype.smallerSize=8,n.prototype.distance=function(t,e){for(var r=0,n=0;n<t.length;n++)t[n]!==e[n]&&r++;return r/t.length},n.prototype.getHash=function(t){(t=t.clone().resize(this.size,this.size)).grayscale();for(var e=[],r=0;r<t.bitmap.width;r++){e[r]=[];for(var n=0;n<t.bitmap.height;n++)e[r][n]=(a=t.getPixelColor(r,n),o=void 0,o={},o.r=Math.floor(a/Math.pow(256,3)),o.g=Math.floor((a-o.r*Math.pow(256,3))/Math.pow(256,2)),o.b=Math.floor((a-o.r*Math.pow(256,3)-o.g*Math.pow(256,2))/Math.pow(256,1)),o.a=Math.floor((a-o.r*Math.pow(256,3)-o.g*Math.pow(256,2)-o.b*Math.pow(256,1))/Math.pow(256,0)),o).b}for(var a,o,s=function(t,e){for(var r=e,n=[],a=0;a<r;a++){n[a]=[];for(var o=0;o<r;o++){for(var s=0,l=0;l<r;l++)for(var u=0;u<r;u++)s+=Math.cos((2*l+1)/(2*r)*a*Math.PI)*Math.cos((2*u+1)/(2*r)*o*Math.PI)*t[l][u];s*=i[a]*i[o]/4,n[a][o]=s}}return n}(e,this.size),l=0,u=0;u<this.smallerSize;u++)for(var f=0;f<this.smallerSize;f++)l+=s[u][f];for(var h=l/(this.smallerSize*this.smallerSize),c="",d=0;d<this.smallerSize;d++)for(var p=0;p<this.smallerSize;p++)c+=s[d][p]>h?"1":"0";return c};var i=[];e.exports=n},{}],374:[function(t,e,r){(function(r,n){"use strict";var i=t("@babel/runtime/helpers/interopRequireDefault");t("core-js/modules/es.symbol"),t("core-js/modules/es.array.filter"),t("core-js/modules/es.array.for-each"),t("core-js/modules/es.object.assign"),t("core-js/modules/es.object.define-properties"),t("core-js/modules/es.object.define-property"),t("core-js/modules/es.object.get-own-property-descriptor"),t("core-js/modules/es.object.get-own-property-descriptors"),t("core-js/modules/es.object.keys"),t("core-js/modules/web.dom-collections.for-each"),i(t("@babel/runtime/helpers/defineProperty")),r.browser,e.exports=function(t,e){var r=new XMLHttpRequest;r.open("GET",t.url,!0),r.responseType="arraybuffer",r.addEventListener("load",(function(){if(r.status<400)try{var i=n.from(this.response);e(null,r,i)}catch(r){return e(new Error("Response is not a buffer for url "+t.url+". Error: "+r.message))}else e(new Error("HTTP Status "+r.status+" for url "+t.url))})),r.addEventListener("error",(function(t){e(t)})),r.send()}}).call(this,t("_process"),t("buffer").Buffer)},{"@babel/runtime/helpers/defineProperty":7,"@babel/runtime/helpers/interopRequireDefault":10,_process:312,buffer:47,"core-js/modules/es.array.filter":175,"core-js/modules/es.array.for-each":178,"core-js/modules/es.object.assign":190,"core-js/modules/es.object.define-properties":191,"core-js/modules/es.object.define-property":192,"core-js/modules/es.object.get-own-property-descriptor":194,"core-js/modules/es.object.get-own-property-descriptors":195,"core-js/modules/es.object.keys":196,"core-js/modules/es.symbol":207,"core-js/modules/web.dom-collections.for-each":235,phin:287}],375:[function(t,e,r){(function(e){"use strict";var n=t("@babel/runtime/helpers/interopRequireWildcard"),i=t("@babel/runtime/helpers/interopRequireDefault");Object.defineProperty(r,"__esModule",{value:!0}),r.parseBitmap=function(t,e,r){var n=function(t,e){var r=(0,a.default)(t);return r?r.mime:e?u.getType(e):null}(t,e);if("string"!=typeof n)return r(new Error("Could not find MIME for Buffer <"+e+">"));this._originalMime=n.toLowerCase();try{var i=this.getMIME();if(!this.constructor.decoders[i])return s.throwError.call(this,"Unsupported MIME type: "+i,r);this.bitmap=this.constructor.decoders[i](t)}catch(t){return r.call(this,t,this)}try{this._exif=o.default.create(t).parse(),function(t){var e=t._exif;if(e&&e.tags&&e.tags.Orientation)switch(t._exif.tags.Orientation){case 1:default:break;case 2:t.mirror(!0,!1);break;case 3:t.rotate(180);break;case 4:t.mirror(!1,!0);break;case 5:t.rotate(-90).mirror(!0,!1);break;case 6:t.rotate(-90);break;case 7:t.rotate(90).mirror(!0,!1);break;case 8:t.rotate(-270)}}(this)}catch(t){}return r.call(this,null,this),this},r.getBuffer=h,r.getBufferAsync=function(t){return(0,f.default)(h,this,t)};var a=i(t("file-type")),o=i(t("exif-parser")),s=t("@jimp/utils"),l=n(t("../constants")),u=n(t("./mime")),f=i(t("./promisify"));function h(t,r){if(t===l.AUTO&&(t=this.getMIME()),"string"!=typeof t)return s.throwError.call(this,"mime must be a string",r);if("function"!=typeof r)return s.throwError.call(this,"cb must be a function",r);if(t=t.toLowerCase(),this._rgba&&this.constructor.hasAlpha[t]?this.bitmap.data=e.from(this.bitmap.data):this.bitmap.data=(i=this.constructor,a=this,new i(a.bitmap.width,a.bitmap.height,a._background).composite(a,0,0).bitmap).data,this.constructor.encoders[t]){var n=this.constructor.encoders[t](this);r.call(this,null,n)}else r.call(this,"Unsupported MIME type: "+t);var i,a;return this}}).call(this,t("buffer").Buffer)},{"../constants":371,"./mime":376,"./promisify":377,"@babel/runtime/helpers/interopRequireDefault":10,"@babel/runtime/helpers/interopRequireWildcard":11,"@jimp/utils":414,buffer:47,"exif-parser":240,"file-type":249}],376:[function(t,e,r){"use strict";t("core-js/modules/es.array.find"),t("core-js/modules/es.array.includes"),t("core-js/modules/es.array.slice"),t("core-js/modules/es.object.entries"),t("core-js/modules/es.regexp.exec"),t("core-js/modules/es.string.includes"),t("core-js/modules/es.string.split"),Object.defineProperty(r,"__esModule",{value:!0}),r.getExtension=r.getType=r.addType=void 0;var n={};r.addType=function(t,e){n[t]=e},r.getType=function(t){var e=t.split("/").slice(-1);return function(t){return Object.entries(n).find((function(e){return e[1].includes(t)}))||[]}(e[e.length-1].split(".").pop())[0]},r.getExtension=function(t){return(n[t.toLowerCase()]||[])[0]}},{"core-js/modules/es.array.find":177,"core-js/modules/es.array.includes":179,"core-js/modules/es.array.slice":186,"core-js/modules/es.object.entries":193,"core-js/modules/es.regexp.exec":200,"core-js/modules/es.string.includes":202,"core-js/modules/es.string.split":206}],377:[function(t,e,r){"use strict";t("core-js/modules/es.function.bind"),t("core-js/modules/es.object.to-string"),t("core-js/modules/es.promise"),Object.defineProperty(r,"__esModule",{value:!0}),r.default=void 0;var n=function(t,e){for(var r=arguments.length,n=new Array(r>2?r-2:0),i=2;i<r;i++)n[i-2]=arguments[i];return new Promise((function(r,i){n.push((function(t,e){t&&i(t),r(e)})),t.bind(e).apply(void 0,n)}))};r.default=n,e.exports=r.default},{"core-js/modules/es.function.bind":188,"core-js/modules/es.object.to-string":197,"core-js/modules/es.promise":199}],378:[function(t,e,r){"use strict";var n=t("@babel/runtime/helpers/interopRequireWildcard"),i=t("@babel/runtime/helpers/interopRequireDefault");t("core-js/modules/es.symbol"),t("core-js/modules/es.array.filter"),t("core-js/modules/es.array.for-each"),t("core-js/modules/es.array.is-array"),t("core-js/modules/es.object.define-properties"),t("core-js/modules/es.object.define-property"),t("core-js/modules/es.object.entries"),t("core-js/modules/es.object.get-own-property-descriptor"),t("core-js/modules/es.object.get-own-property-descriptors"),t("core-js/modules/es.object.keys"),t("core-js/modules/web.dom-collections.for-each"),Object.defineProperty(r,"__esModule",{value:!0}),r.default=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:l.default,r={hasAlpha:{},encoders:{},decoders:{},class:{},constants:{}};function n(t){Object.entries(t).forEach((function(t){var e=(0,s.default)(t,2),n=e[0],i=e[1];r[n]=f({},r[n],{},i)}))}return t.types&&(t.types.forEach((function(t){var e=t();Array.isArray(e.mime)?l.addType.apply(void 0,(0,a.default)(e.mime)):Object.entries(e.mime).forEach((function(t){return l.addType.apply(void 0,(0,a.default)(t))})),delete e.mime,n(e)})),e.decoders=f({},e.decoders,{},r.decoders),e.encoders=f({},e.encoders,{},r.encoders),e.hasAlpha=f({},e.hasAlpha,{},r.hasAlpha)),t.plugins&&t.plugins.forEach((function(t){var e=t(l.jimpEvChange)||{};e.class||e.constants?n(e):n({class:e})})),(0,l.addJimpMethods)(r.class,e),(0,l.addConstants)(r.constants,e),l.default};var a=i(t("@babel/runtime/helpers/toConsumableArray")),o=i(t("@babel/runtime/helpers/defineProperty")),s=i(t("@babel/runtime/helpers/slicedToArray")),l=n(t("@jimp/core"));function u(t,e){var r=Object.keys(t);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(t);e&&(n=n.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),r.push.apply(r,n)}return r}function f(t){for(var e=1;e<arguments.length;e++){var r=null!=arguments[e]?arguments[e]:{};e%2?u(r,!0).forEach((function(e){(0,o.default)(t,e,r[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(r)):u(r).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(r,e))}))}return t}e.exports=r.default},{"@babel/runtime/helpers/defineProperty":7,"@babel/runtime/helpers/interopRequireDefault":10,"@babel/runtime/helpers/interopRequireWildcard":11,"@babel/runtime/helpers/slicedToArray":18,"@babel/runtime/helpers/toConsumableArray":19,"@jimp/core":372,"core-js/modules/es.array.filter":175,"core-js/modules/es.array.for-each":178,"core-js/modules/es.array.is-array":181,"core-js/modules/es.object.define-properties":191,"core-js/modules/es.object.define-property":192,"core-js/modules/es.object.entries":193,"core-js/modules/es.object.get-own-property-descriptor":194,"core-js/modules/es.object.get-own-property-descriptors":195,"core-js/modules/es.object.keys":196,"core-js/modules/es.symbol":207,"core-js/modules/web.dom-collections.for-each":235}],379:[function(t,e,r){"use strict";var n=t("@babel/runtime/helpers/interopRequireDefault");Object.defineProperty(r,"__esModule",{value:!0}),r.default=void 0;var i=n(t("@jimp/custom")),a=n(t("@jimp/types")),o=n(t("@jimp/plugins")),s=(0,i.default)({types:[a.default],plugins:[o.default]});r.default=s,e.exports=r.default},{"@babel/runtime/helpers/interopRequireDefault":10,"@jimp/custom":378,"@jimp/plugins":407,"@jimp/types":413}],380:[function(t,e,r){"use strict";var n=t("@babel/runtime/helpers/interopRequireDefault");Object.defineProperty(r,"__esModule",{value:!0}),r.default=void 0;var i=n(t("@babel/runtime/helpers/typeof")),a=t("@jimp/utils");r.default=function(){return{blit:function(t,e,r,n,o,s,l,u){if(!(t instanceof this.constructor))return a.throwError.call(this,"The source must be a Jimp image",u);if("number"!=typeof e||"number"!=typeof r)return a.throwError.call(this,"x and y must be numbers",u);if("function"==typeof n)u=n,n=0,o=0,s=t.bitmap.width,l=t.bitmap.height;else{if((0,i.default)(n)!==(0,i.default)(o)||(0,i.default)(o)!==(0,i.default)(s)||(0,i.default)(s)!==(0,i.default)(l))return a.throwError.call(this,"srcx, srcy, srcw, srch must be numbers",u);n=n||0,o=o||0,s=s||t.bitmap.width,l=l||t.bitmap.height}e=Math.round(e),r=Math.round(r),n=Math.round(n),o=Math.round(o),s=Math.round(s),l=Math.round(l);var f=this.bitmap.width,h=this.bitmap.height,c=this;return t.scanQuiet(n,o,s,l,(function(t,i,a){var s=e+t-n,l=r+i-o;if(s>=0&&l>=0&&f-s>0&&h-l>0){var u=c.getPixelIndex(s,l),d={r:this.bitmap.data[a],g:this.bitmap.data[a+1],b:this.bitmap.data[a+2],a:this.bitmap.data[a+3]},p={r:c.bitmap.data[u],g:c.bitmap.data[u+1],b:c.bitmap.data[u+2],a:c.bitmap.data[u+3]};c.bitmap.data[u]=(d.a*(d.r-p.r)-p.r+255>>8)+p.r,c.bitmap.data[u+1]=(d.a*(d.g-p.g)-p.g+255>>8)+p.g,c.bitmap.data[u+2]=(d.a*(d.b-p.b)-p.b+255>>8)+p.b,c.bitmap.data[u+3]=this.constructor.limit255(p.a+d.a)}})),(0,a.isNodePattern)(u)&&u.call(this,null,this),this}}},e.exports=r.default},{"@babel/runtime/helpers/interopRequireDefault":10,"@babel/runtime/helpers/typeof":20,"@jimp/utils":414}],381:[function(t,e,r){"use strict";Object.defineProperty(r,"__esModule",{value:!0}),r.shgTable=r.mulTable=void 0,r.mulTable=[1,57,41,21,203,34,97,73,227,91,149,62,105,45,39,137,241,107,3,173,39,71,65,238,219,101,187,87,81,151,141,133,249,117,221,209,197,187,177,169,5,153,73,139,133,127,243,233,223,107,103,99,191,23,177,171,165,159,77,149,9,139,135,131,253,245,119,231,224,109,211,103,25,195,189,23,45,175,171,83,81,79,155,151,147,9,141,137,67,131,129,251,123,30,235,115,113,221,217,53,13,51,50,49,193,189,185,91,179,175,43,169,83,163,5,79,155,19,75,147,145,143,35,69,17,67,33,65,255,251,247,243,239,59,29,229,113,111,219,27,213,105,207,51,201,199,49,193,191,47,93,183,181,179,11,87,43,85,167,165,163,161,159,157,155,77,19,75,37,73,145,143,141,35,138,137,135,67,33,131,129,255,63,250,247,61,121,239,237,117,29,229,227,225,111,55,109,216,213,211,209,207,205,203,201,199,197,195,193,48,190,47,93,185,183,181,179,178,176,175,173,171,85,21,167,165,41,163,161,5,79,157,78,154,153,19,75,149,74,147,73,144,143,71,141,140,139,137,17,135,134,133,66,131,65,129,1],r.shgTable=[0,9,10,10,14,12,14,14,16,15,16,15,16,15,15,17,18,17,12,18,16,17,17,19,19,18,19,18,18,19,19,19,20,19,20,20,20,20,20,20,15,20,19,20,20,20,21,21,21,20,20,20,21,18,21,21,21,21,20,21,17,21,21,21,22,22,21,22,22,21,22,21,19,22,22,19,20,22,22,21,21,21,22,22,22,18,22,22,21,22,22,23,22,20,23,22,22,23,23,21,19,21,21,21,23,23,23,22,23,23,21,23,22,23,18,22,23,20,22,23,23,23,21,22,20,22,21,22,24,24,24,24,24,22,21,24,23,23,24,21,24,23,24,22,24,24,22,24,24,22,23,24,24,24,20,23,22,23,24,24,24,24,24,24,24,23,21,23,22,23,24,24,24,22,24,24,24,23,22,24,24,25,23,25,25,23,24,25,25,24,22,25,25,25,24,23,24,25,25,25,25,25,25,25,25,25,25,25,25,23,25,23,24,25,25,25,25,25,25,25,25,25,24,22,25,25,23,25,25,20,24,25,24,25,25,22,24,25,24,25,24,25,25,24,25,25,25,25,22,25,25,25,24,25,24,25,18]},{}],382:[function(t,e,r){"use strict";Object.defineProperty(r,"__esModule",{value:!0}),r.default=void 0;var n=t("@jimp/utils"),i=t("./blur-tables");r.default=function(){return{blur:function(t,e){if("number"!=typeof t)return n.throwError.call(this,"r must be a number",e);if(t<1)return n.throwError.call(this,"r must be greater than 0",e);for(var r,a,o,s,l,u,f,h,c,d,p,b,m,g,y=this.bitmap.width-1,v=this.bitmap.height-1,_=t+1,w=i.mulTable[t],x=i.shgTable[t],E=[],k=[],j=[],S=[],A=[],T=[],I=2;I-- >0;){for(b=0,m=0,u=0;u<this.bitmap.height;u++){for(r=this.bitmap.data[m]*_,a=this.bitmap.data[m+1]*_,o=this.bitmap.data[m+2]*_,s=this.bitmap.data[m+3]*_,f=1;f<=t;f++)h=m+((f>y?y:f)<<2),r+=this.bitmap.data[h++],a+=this.bitmap.data[h++],o+=this.bitmap.data[h++],s+=this.bitmap.data[h];for(l=0;l<this.bitmap.width;l++)E[b]=r,k[b]=a,j[b]=o,S[b]=s,0===u&&(A[l]=((h=l+_)<y?h:y)<<2,T[l]=(h=l-t)>0?h<<2:0),c=m+A[l],d=m+T[l],r+=this.bitmap.data[c++]-this.bitmap.data[d++],a+=this.bitmap.data[c++]-this.bitmap.data[d++],o+=this.bitmap.data[c++]-this.bitmap.data[d++],s+=this.bitmap.data[c]-this.bitmap.data[d],b++;m+=this.bitmap.width<<2}for(l=0;l<this.bitmap.width;l++){for(r=E[p=l]*_,a=k[p]*_,o=j[p]*_,s=S[p]*_,f=1;f<=t;f++)r+=E[p+=f>v?0:this.bitmap.width],a+=k[p],o+=j[p],s+=S[p];for(b=l<<2,u=0;u<this.bitmap.height;u++)g=s*w>>>x,this.bitmap.data[b+3]=g,g>255&&(this.bitmap.data[b+3]=255),g>0?(g=255/g,this.bitmap.data[b]=(r*w>>>x)*g,this.bitmap.data[b+1]=(a*w>>>x)*g,this.bitmap.data[b+2]=(o*w>>>x)*g):(this.bitmap.data[b+2]=0,this.bitmap.data[b+1]=0,this.bitmap.data[b]=0),0===l&&(A[u]=((h=u+_)<v?h:v)*this.bitmap.width,T[u]=(h=u-t)>0?h*this.bitmap.width:0),c=l+A[u],d=l+T[u],r+=E[c]-E[d],a+=k[c]-k[d],o+=j[c]-j[d],s+=S[c]-S[d],b+=this.bitmap.width<<2}}return(0,n.isNodePattern)(e)&&e.call(this,null,this),this}}},e.exports=r.default},{"./blur-tables":381,"@jimp/utils":414}],383:[function(t,e,r){"use strict";Object.defineProperty(r,"__esModule",{value:!0}),r.default=void 0;var n=t("@jimp/utils");r.default=function(){return{circle:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},e=arguments.length>1?arguments[1]:void 0;"function"==typeof t&&(e=t,t={});var r=t.radius||(this.bitmap.width>this.bitmap.height?this.bitmap.height:this.bitmap.width)/2,i="number"==typeof t.x?t.x:this.bitmap.width/2,a="number"==typeof t.y?t.y:this.bitmap.height/2;return this.scanQuiet(0,0,this.bitmap.width,this.bitmap.height,(function(t,e,n){var o=Math.sqrt(Math.pow(t-i,2)+Math.pow(e-a,2));r-o<=0?this.bitmap.data[n+3]=0:r-o<1&&(this.bitmap.data[n+3]=255*(r-o))})),(0,n.isNodePattern)(e)&&e.call(this,null,this),this}}},e.exports=r.default},{"@jimp/utils":414}],384:[function(t,e,r){(function(n){"use strict";var i=t("@babel/runtime/helpers/interopRequireDefault");t("core-js/modules/es.array.for-each"),t("core-js/modules/es.array.is-array"),t("core-js/modules/es.array.map"),t("core-js/modules/es.parse-int"),t("core-js/modules/web.dom-collections.for-each"),Object.defineProperty(r,"__esModule",{value:!0}),r.default=void 0;var a=i(t("@babel/runtime/helpers/toConsumableArray")),o=i(t("tinycolor2")),s=t("@jimp/utils");function l(t,e,r,n){for(var i=[0,0,0],a=(e.length-1)/2,o=0;o<e.length;o+=1)for(var s=0;s<e[o].length;s+=1){var l=t.getPixelIndex(r+o-a,n+s-a);i[0]+=t.bitmap.data[l]*e[o][s],i[1]+=t.bitmap.data[l+1]*e[o][s],i[2]+=t.bitmap.data[l+2]*e[o][s]}return i}var u=function(t){return null!=t};function f(t){return this.scanQuiet(0,0,this.bitmap.width,this.bitmap.height,(function(t,e,r){var n=parseInt(.2126*this.bitmap.data[r]+.7152*this.bitmap.data[r+1]+.0722*this.bitmap.data[r+2],10);this.bitmap.data[r]=n,this.bitmap.data[r+1]=n,this.bitmap.data[r+2]=n})),(0,s.isNodePattern)(t)&&t.call(this,null,this),this}function h(t,e){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:50;return{r:(e.r-t.r)*(r/100)+t.r,g:(e.g-t.g)*(r/100)+t.g,b:(e.b-t.b)*(r/100)+t.b}}function c(t,e){var r=this;return t&&Array.isArray(t)?(t=t.map((function(t){return"xor"!==t.apply&&"mix"!==t.apply||(t.params[0]=(0,o.default)(t.params[0]).toRgb()),t})),this.scanQuiet(0,0,this.bitmap.width,this.bitmap.height,(function(n,i,l){var u={r:r.bitmap.data[l],g:r.bitmap.data[l+1],b:r.bitmap.data[l+2]},f=function(t,e){return r.constructor.limit255(u[t]+e)};t.forEach((function(t){if("mix"===t.apply)u=h(u,t.params[0],t.params[1]);else if("tint"===t.apply)u=h(u,{r:255,g:255,b:255},t.params[0]);else if("shade"===t.apply)u=h(u,{r:0,g:0,b:0},t.params[0]);else if("xor"===t.apply)u={r:u.r^t.params[0].r,g:u.g^t.params[0].g,b:u.b^t.params[0].b};else if("red"===t.apply)u.r=f("r",t.params[0]);else if("green"===t.apply)u.g=f("g",t.params[0]);else if("blue"===t.apply)u.b=f("b",t.params[0]);else{var n;if("hue"===t.apply&&(t.apply="spin"),!(u=(0,o.default)(u))[t.apply])return s.throwError.call(r,"action "+t.apply+" not supported",e);u=(n=u)[t.apply].apply(n,(0,a.default)(t.params)).toRgb()}})),r.bitmap.data[l]=u.r,r.bitmap.data[l+1]=u.g,r.bitmap.data[l+2]=u.b})),(0,s.isNodePattern)(e)&&e.call(this,null,this),this):s.throwError.call(this,"actions must be an array",e)}r.default=function(){return{brightness:function(t,e){return"number"!=typeof t?s.throwError.call(this,"val must be numbers",e):t<-1||t>1?s.throwError.call(this,"val must be a number between -1 and +1",e):(this.scanQuiet(0,0,this.bitmap.width,this.bitmap.height,(function(e,r,n){t<0?(this.bitmap.data[n]=this.bitmap.data[n]*(1+t),this.bitmap.data[n+1]=this.bitmap.data[n+1]*(1+t),this.bitmap.data[n+2]=this.bitmap.data[n+2]*(1+t)):(this.bitmap.data[n]=this.bitmap.data[n]+(255-this.bitmap.data[n])*t,this.bitmap.data[n+1]=this.bitmap.data[n+1]+(255-this.bitmap.data[n+1])*t,this.bitmap.data[n+2]=this.bitmap.data[n+2]+(255-this.bitmap.data[n+2])*t)})),(0,s.isNodePattern)(e)&&e.call(this,null,this),this)},contrast:function(t,e){if("number"!=typeof t)return s.throwError.call(this,"val must be numbers",e);if(t<-1||t>1)return s.throwError.call(this,"val must be a number between -1 and +1",e);var r=(t+1)/(1-t);function n(t){return(t=Math.floor(r*(t-127)+127))<0?0:t>255?255:t}return this.scanQuiet(0,0,this.bitmap.width,this.bitmap.height,(function(t,e,r){this.bitmap.data[r]=n(this.bitmap.data[r]),this.bitmap.data[r+1]=n(this.bitmap.data[r+1]),this.bitmap.data[r+2]=n(this.bitmap.data[r+2])})),(0,s.isNodePattern)(e)&&e.call(this,null,this),this},posterize:function(t,e){return"number"!=typeof t?s.throwError.call(this,"n must be numbers",e):(t<2&&(t=2),this.scanQuiet(0,0,this.bitmap.width,this.bitmap.height,(function(e,r,n){this.bitmap.data[n]=Math.floor(this.bitmap.data[n]/255*(t-1))/(t-1)*255,this.bitmap.data[n+1]=Math.floor(this.bitmap.data[n+1]/255*(t-1))/(t-1)*255,this.bitmap.data[n+2]=Math.floor(this.bitmap.data[n+2]/255*(t-1))/(t-1)*255})),(0,s.isNodePattern)(e)&&e.call(this,null,this),this)},greyscale:f,grayscale:f,opacity:function(t,e){return"number"!=typeof t?s.throwError.call(this,"f must be a number",e):t<0||t>1?s.throwError.call(this,"f must be a number from 0 to 1",e):(this.scanQuiet(0,0,this.bitmap.width,this.bitmap.height,(function(e,r,n){var i=this.bitmap.data[n+3]*t;this.bitmap.data[n+3]=i})),(0,s.isNodePattern)(e)&&e.call(this,null,this),this)},sepia:function(t){return this.scanQuiet(0,0,this.bitmap.width,this.bitmap.height,(function(t,e,r){var n=this.bitmap.data[r],i=this.bitmap.data[r+1],a=this.bitmap.data[r+2];a=.272*(n=.393*n+.769*i+.189*a)+.534*(i=.349*n+.686*i+.168*a)+.131*a,this.bitmap.data[r]=n<255?n:255,this.bitmap.data[r+1]=i<255?i:255,this.bitmap.data[r+2]=a<255?a:255})),(0,s.isNodePattern)(t)&&t.call(this,null,this),this},fade:function(t,e){return"number"!=typeof t?s.throwError.call(this,"f must be a number",e):t<0||t>1?s.throwError.call(this,"f must be a number from 0 to 1",e):(this.opacity(1-t),(0,s.isNodePattern)(e)&&e.call(this,null,this),this)},convolution:function(t,e,r){"function"==typeof e&&void 0===r&&(r=e,e=null),e||(e=this.constructor.EDGE_EXTEND);var i,a,o,l,u,f,h,c,d,p,b=n.from(this.bitmap.data),m=t.length,g=t[0].length,y=Math.floor(m/2),v=Math.floor(g/2),_=-y,w=-v;return this.scanQuiet(0,0,this.bitmap.width,this.bitmap.height,(function(r,n,s){l=0,o=0,a=0;for(var m=_;m<=y;m++)for(var g=w;g<=v;g++)c=r+g,d=n+m,i=t[m+y][g+v],-1===(p=this.getPixelIndex(c,d,e))?(h=0,f=0,u=0):(u=this.bitmap.data[p+0],f=this.bitmap.data[p+1],h=this.bitmap.data[p+2]),a+=i*u,o+=i*f,l+=i*h;a<0&&(a=0),o<0&&(o=0),l<0&&(l=0),a>255&&(a=255),o>255&&(o=255),l>255&&(l=255),b[s+0]=a,b[s+1]=o,b[s+2]=l})),this.bitmap.data=b,(0,s.isNodePattern)(r)&&r.call(this,null,this),this},opaque:function(t){return this.scanQuiet(0,0,this.bitmap.width,this.bitmap.height,(function(t,e,r){this.bitmap.data[r+3]=255})),(0,s.isNodePattern)(t)&&t.call(this,null,this),this},pixelate:function(t,e,r,n,i,a){if("function"==typeof e)a=e,i=null,n=null,r=null,e=null;else{if("number"!=typeof t)return s.throwError.call(this,"size must be a number",a);if(u(e)&&"number"!=typeof e)return s.throwError.call(this,"x must be a number",a);if(u(r)&&"number"!=typeof r)return s.throwError.call(this,"y must be a number",a);if(u(n)&&"number"!=typeof n)return s.throwError.call(this,"w must be a number",a);if(u(i)&&"number"!=typeof i)return s.throwError.call(this,"h must be a number",a)}var o=[[1/16,2/16,1/16],[2/16,.25,2/16],[1/16,2/16,1/16]];e=e||0,r=r||0,n=u(n)?n:this.bitmap.width-e,i=u(i)?i:this.bitmap.height-r;var f=this.cloneQuiet();return this.scanQuiet(e,r,n,i,(function(e,r,n){e=t*Math.floor(e/t),r=t*Math.floor(r/t);var i=l(f,o,e,r);this.bitmap.data[n]=i[0],this.bitmap.data[n+1]=i[1],this.bitmap.data[n+2]=i[2]})),(0,s.isNodePattern)(a)&&a.call(this,null,this),this},convolute:function(t,e,r,n,i,a){if(!Array.isArray(t))return s.throwError.call(this,"the kernel must be an array",a);if("function"==typeof e)a=e,e=null,r=null,n=null,i=null;else{if(u(e)&&"number"!=typeof e)return s.throwError.call(this,"x must be a number",a);if(u(r)&&"number"!=typeof r)return s.throwError.call(this,"y must be a number",a);if(u(n)&&"number"!=typeof n)return s.throwError.call(this,"w must be a number",a);if(u(i)&&"number"!=typeof i)return s.throwError.call(this,"h must be a number",a)}var o=(t.length-1)/2;e=u(e)?e:o,r=u(r)?r:o,n=u(n)?n:this.bitmap.width-e,i=u(i)?i:this.bitmap.height-r;var f=this.cloneQuiet();return this.scanQuiet(e,r,n,i,(function(e,r,n){var i=l(f,t,e,r);this.bitmap.data[n]=this.constructor.limit255(i[0]),this.bitmap.data[n+1]=this.constructor.limit255(i[1]),this.bitmap.data[n+2]=this.constructor.limit255(i[2])})),(0,s.isNodePattern)(a)&&a.call(this,null,this),this},color:c,colour:c}},e.exports=r.default}).call(this,t("buffer").Buffer)},{"@babel/runtime/helpers/interopRequireDefault":10,"@babel/runtime/helpers/toConsumableArray":19,"@jimp/utils":414,buffer:47,"core-js/modules/es.array.for-each":178,"core-js/modules/es.array.is-array":181,"core-js/modules/es.array.map":184,"core-js/modules/es.parse-int":198,"core-js/modules/web.dom-collections.for-each":235,tinycolor2:357}],385:[function(t,e,r){"use strict";Object.defineProperty(r,"__esModule",{value:!0}),r.default=void 0;var n=t("@jimp/utils");r.default=function(){return{contain:function(t,e,r,i,a){if("number"!=typeof t||"number"!=typeof e)return n.throwError.call(this,"w and h must be numbers",a);"string"==typeof r&&("function"==typeof i&&void 0===a&&(a=i),i=r,r=null),"function"==typeof r&&(void 0===a&&(a=r),i=null,r=null),"function"==typeof i&&void 0===a&&(a=i,i=null);var o=7&(r=r||this.constructor.HORIZONTAL_ALIGN_CENTER|this.constructor.VERTICAL_ALIGN_MIDDLE),s=r>>3;if((0===o||o&o-1)&&(0===s||s&s-1))return n.throwError.call(this,"only use one flag per alignment direction",a);var l=o>>1,u=s>>1,f=t/e>this.bitmap.width/this.bitmap.height?e/this.bitmap.height:t/this.bitmap.width,h=this.cloneQuiet().scale(f,i);return this.resize(t,e,i),this.scanQuiet(0,0,this.bitmap.width,this.bitmap.height,(function(t,e,r){this.bitmap.data.writeUInt32BE(this._background,r)})),this.blit(h,(this.bitmap.width-h.bitmap.width)/2*l,(this.bitmap.height-h.bitmap.height)/2*u),(0,n.isNodePattern)(a)&&a.call(this,null,this),this}}},e.exports=r.default},{"@jimp/utils":414}],386:[function(t,e,r){"use strict";Object.defineProperty(r,"__esModule",{value:!0}),r.default=void 0;var n=t("@jimp/utils");r.default=function(){return{cover:function(t,e,r,i,a){if("number"!=typeof t||"number"!=typeof e)return n.throwError.call(this,"w and h must be numbers",a);r&&"function"==typeof r&&void 0===a?(a=r,r=null,i=null):"function"==typeof i&&void 0===a&&(a=i,i=null);var o=7&(r=r||this.constructor.HORIZONTAL_ALIGN_CENTER|this.constructor.VERTICAL_ALIGN_MIDDLE),s=r>>3;if((0===o||o&o-1)&&(0===s||s&s-1))return n.throwError.call(this,"only use one flag per alignment direction",a);var l=o>>1,u=s>>1,f=t/e>this.bitmap.width/this.bitmap.height?t/this.bitmap.width:e/this.bitmap.height;return this.scale(f,i),this.crop((this.bitmap.width-t)/2*l,(this.bitmap.height-e)/2*u,t,e),(0,n.isNodePattern)(a)&&a.call(this,null,this),this}}},e.exports=r.default},{"@jimp/utils":414}],387:[function(t,e,r){(function(n){"use strict";var i=t("@babel/runtime/helpers/interopRequireDefault");t("core-js/modules/es.array.slice"),Object.defineProperty(r,"__esModule",{value:!0}),r.default=function(t){return t("crop",(function(t,e,r,i,a){if("number"!=typeof t||"number"!=typeof e)return o.throwError.call(this,"x and y must be numbers",a);if("number"!=typeof r||"number"!=typeof i)return o.throwError.call(this,"w and h must be numbers",a);if(t=Math.round(t),e=Math.round(e),r=Math.round(r),i=Math.round(i),0===t&&r===this.bitmap.width){var s=r*e+t<<2,l=s+i*r<<2;this.bitmap.data=this.bitmap.data.slice(s,l)}else{var u=n.allocUnsafe(r*i*4),f=0;this.scanQuiet(t,e,r,i,(function(t,e,r){var n=this.bitmap.data.readUInt32BE(r,!0);u.writeUInt32BE(n,f,!0),f+=4})),this.bitmap.data=u}return this.bitmap.width=r,this.bitmap.height=i,(0,o.isNodePattern)(a)&&a.call(this,null,this),this})),{class:{autocrop:function(){for(var t,e=this.bitmap.width,r=this.bitmap.height,n=0,i=2e-4,s=!0,l=!1,u=arguments.length,f=new Array(u),h=0;h<u;h++)f[h]=arguments[h];for(var c=0,d=f.length;c<d;c++)if("number"==typeof f[c]&&(i=f[c]),"boolean"==typeof f[c]&&(s=f[c]),"function"==typeof f[c]&&(t=f[c]),"object"===(0,a.default)(f[c])){var p=f[c];void 0!==p.tolerance&&(i=p.tolerance),void 0!==p.cropOnlyFrames&&(s=p.cropOnlyFrames),void 0!==p.cropSymmetric&&(l=p.cropSymmetric),void 0!==p.leaveBorder&&(n=p.leaveBorder)}var b=this.getPixelColor(0,0),m=this.constructor.intToRGBA(b),g=0,y=0,v=0,_=0;b=this.getPixelColor(0,0);t:for(var w=0;w<r-1;w++){for(var x=0;x<e;x++){var E=this.getPixelColor(x,w),k=this.constructor.intToRGBA(E);if(this.constructor.colorDiff(m,k)>i)break t}g++}b=this.getPixelColor(e,0);t:for(var j=0;j<e-1;j++){for(var S=0+g;S<r;S++){var A=this.getPixelColor(j,S),T=this.constructor.intToRGBA(A);if(this.constructor.colorDiff(m,T)>i)break t}y++}b=this.getPixelColor(0,r);t:for(var I=r-1;I>=g+1;I--){for(var P=e-y-1;P>=0;P--){var M=this.getPixelColor(P,I),O=this.constructor.intToRGBA(M);if(this.constructor.colorDiff(m,O)>i)break t}v++}b=this.getPixelColor(e,r);t:for(var R=e-1;R>=0+y+1;R--){for(var L=r-1;L>=0+g;L--){var C=this.getPixelColor(R,L),B=this.constructor.intToRGBA(C);if(this.constructor.colorDiff(m,B)>i)break t}_++}if(_-=n,y-=n,g-=n,v-=n,l){var D=Math.min(y,_),N=Math.min(g,v);_=D,y=D,g=N,v=N}var U=e-((_=_>=0?_:0)+(y=y>=0?y:0)),z=r-((v=v>=0?v:0)+(g=g>=0?g:0));return(s?0!==y&&0!==g&&0!==_&&0!==v:0!==y||0!==g||0!==_||0!==v)&&this.crop(y,g,U,z),(0,o.isNodePattern)(t)&&t.call(this,null,this),this}}}};var a=i(t("@babel/runtime/helpers/typeof")),o=t("@jimp/utils");e.exports=r.default}).call(this,t("buffer").Buffer)},{"@babel/runtime/helpers/interopRequireDefault":10,"@babel/runtime/helpers/typeof":20,"@jimp/utils":414,buffer:47,"core-js/modules/es.array.slice":186}],388:[function(t,e,r){"use strict";var n=t("@babel/runtime/helpers/interopRequireDefault");Object.defineProperty(r,"__esModule",{value:!0}),r.default=void 0;var i=n(t("@babel/runtime/helpers/typeof")),a=t("@jimp/utils");r.default=function(){return{displace:function(t,e,r){if("object"!==(0,i.default)(t)||t.constructor!==this.constructor)return a.throwError.call(this,"The source must be a Jimp image",r);if("number"!=typeof e)return a.throwError.call(this,"factor must be a number",r);var n=this.cloneQuiet();return this.scanQuiet(0,0,this.bitmap.width,this.bitmap.height,(function(r,i,a){var o=t.bitmap.data[a]/256*e;o=Math.round(o);var s=this.getPixelIndex(r+o,i);this.bitmap.data[s]=n.bitmap.data[a],this.bitmap.data[s+1]=n.bitmap.data[a+1],this.bitmap.data[s+2]=n.bitmap.data[a+2]})),(0,a.isNodePattern)(r)&&r.call(this,null,this),this}}},e.exports=r.default},{"@babel/runtime/helpers/interopRequireDefault":10,"@babel/runtime/helpers/typeof":20,"@jimp/utils":414}],389:[function(t,e,r){"use strict";Object.defineProperty(r,"__esModule",{value:!0}),r.default=void 0;var n=t("@jimp/utils");function i(t){var e=[1,9,3,11,13,5,15,7,4,12,2,10,16,8,14,6];return this.scanQuiet(0,0,this.bitmap.width,this.bitmap.height,(function(t,r,n){var i=e[((3&r)<<2)+t%4];this.bitmap.data[n]=Math.min(this.bitmap.data[n]+i,255),this.bitmap.data[n+1]=Math.min(this.bitmap.data[n+1]+i,255),this.bitmap.data[n+2]=Math.min(this.bitmap.data[n+2]+i,255)})),(0,n.isNodePattern)(t)&&t.call(this,null,this),this}r.default=function(){return{dither565:i,dither16:i}},e.exports=r.default},{"@jimp/utils":414}],390:[function(t,e,r){"use strict";Object.defineProperty(r,"__esModule",{value:!0}),r.default=void 0;var n=t("@jimp/utils");r.default=function(){return{fisheye:function(){var t=this,e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{r:2.5},r=arguments.length>1?arguments[1]:void 0;"function"==typeof e&&(r=e,e={r:2.5});var i=this.cloneQuiet(),a=i.bitmap,o=a.width,s=a.height;return i.scanQuiet(0,0,o,s,(function(r,n){var a=r/o,l=n/s,u=Math.sqrt(Math.pow(a-.5,2)+Math.pow(l-.5,2)),f=2*Math.pow(u,e.r),h=(a-.5)/u,c=(l-.5)/u,d=Math.round((f*h+.5)*o),p=Math.round((f*c+.5)*s),b=i.getPixelColor(d,p);t.setPixelColor(b,r,n)})),this.setPixelColor(i.getPixelColor(o/2,s/2),o/2,s/2),(0,n.isNodePattern)(r)&&r.call(this,null,this),this}}},e.exports=r.default},{"@jimp/utils":414}],391:[function(t,e,r){(function(n){"use strict";Object.defineProperty(r,"__esModule",{value:!0}),r.default=void 0;var i=t("@jimp/utils");function a(t,e,r){if("boolean"!=typeof t||"boolean"!=typeof e)return i.throwError.call(this,"horizontal and vertical must be Booleans",r);if(t&&e)return this.rotate(180,!0,r);var a=n.alloc(this.bitmap.data.length);return this.scanQuiet(0,0,this.bitmap.width,this.bitmap.height,(function(r,n,i){var o=t?this.bitmap.width-1-r:r,s=e?this.bitmap.height-1-n:n,l=this.bitmap.width*s+o<<2,u=this.bitmap.data.readUInt32BE(i);a.writeUInt32BE(u,l)})),this.bitmap.data=n.from(a),(0,i.isNodePattern)(r)&&r.call(this,null,this),this}r.default=function(){return{flip:a,mirror:a}},e.exports=r.default}).call(this,t("buffer").Buffer)},{"@jimp/utils":414,buffer:47}],392:[function(t,e,r){"use strict";Object.defineProperty(r,"__esModule",{value:!0}),r.default=void 0;var n=t("@jimp/utils");r.default=function(){return{gaussian:function(t,e){if("number"!=typeof t)return n.throwError.call(this,"r must be a number",e);if(t<1)return n.throwError.call(this,"r must be greater than 0",e);for(var r=Math.ceil(2.57*t),i=2*r+1,a=t*t*2,o=a*Math.PI,s=[],l=0;l<i;l++){s[l]=[];for(var u=0;u<i;u++){var f=Math.pow(u-r,2)+Math.pow(l-r,2);s[l][u]=Math.exp(-f/a)/o}}for(var h=0;h<this.bitmap.height;h++)for(var c=0;c<this.bitmap.width;c++)for(var d=0,p=0,b=0,m=0,g=0,y=0;y<i;y++){for(var v=0;v<i;v++){var _=Math.min(this.bitmap.width-1,Math.max(0,v+c-r)),w=Math.min(this.bitmap.height-1,Math.max(0,y+h-r)),x=s[y][v],E=w*this.bitmap.width+_<<2;d+=this.bitmap.data[E]*x,p+=this.bitmap.data[E+1]*x,b+=this.bitmap.data[E+2]*x,m+=this.bitmap.data[E+3]*x,g+=x}var k=h*this.bitmap.width+c<<2;this.bitmap.data[k]=Math.round(d/g),this.bitmap.data[k+1]=Math.round(p/g),this.bitmap.data[k+2]=Math.round(b/g),this.bitmap.data[k+3]=Math.round(m/g)}return(0,n.isNodePattern)(e)&&e.call(this,null,this),this}}},e.exports=r.default},{"@jimp/utils":414}],393:[function(t,e,r){"use strict";Object.defineProperty(r,"__esModule",{value:!0}),r.default=void 0;var n=t("@jimp/utils");r.default=function(){return{invert:function(t){return this.scanQuiet(0,0,this.bitmap.width,this.bitmap.height,(function(t,e,r){this.bitmap.data[r]=255-this.bitmap.data[r],this.bitmap.data[r+1]=255-this.bitmap.data[r+1],this.bitmap.data[r+2]=255-this.bitmap.data[r+2]})),(0,n.isNodePattern)(t)&&t.call(this,null,this),this}}},e.exports=r.default},{"@jimp/utils":414}],394:[function(t,e,r){"use strict";Object.defineProperty(r,"__esModule",{value:!0}),r.default=void 0;var n=t("@jimp/utils");r.default=function(){return{mask:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0,i=arguments.length>3?arguments[3]:void 0;if(!(t instanceof this.constructor))return n.throwError.call(this,"The source must be a Jimp image",i);if("number"!=typeof e||"number"!=typeof r)return n.throwError.call(this,"x and y must be numbers",i);e=Math.round(e),r=Math.round(r);var a=this.bitmap.width,o=this.bitmap.height,s=this;return t.scanQuiet(0,0,t.bitmap.width,t.bitmap.height,(function(t,n,i){var l=e+t,u=r+n;if(l>=0&&u>=0&&l<a&&u<o){var f=s.getPixelIndex(l,u),h=this.bitmap.data,c=(h[i+0]+h[i+1]+h[i+2])/3;s.bitmap.data[f+3]*=c/255}})),(0,n.isNodePattern)(i)&&i.call(this,null,this),this}}},e.exports=r.default},{"@jimp/utils":414}],395:[function(t,e,r){"use strict";t("core-js/modules/es.array.fill"),t("core-js/modules/es.array.find-index"),t("core-js/modules/es.array.reverse"),t("core-js/modules/es.array.slice"),Object.defineProperty(r,"__esModule",{value:!0}),r.default=void 0;var n=t("@jimp/utils");function i(){var t={r:new Array(256).fill(0),g:new Array(256).fill(0),b:new Array(256).fill(0)};return this.scanQuiet(0,0,this.bitmap.width,this.bitmap.height,(function(e,r,n){t.r[this.bitmap.data[n+0]]++,t.g[this.bitmap.data[n+1]]++,t.b[this.bitmap.data[n+2]]++})),t}var a=function(t,e,r){return 255*(t-e)/(r-e)},o=function(t){return[t.findIndex((function(t){return t>0})),255-t.slice().reverse().findIndex((function(t){return t>0}))]};r.default=function(){return{normalize:function(t){var e=i.call(this),r={r:o(e.r),g:o(e.g),b:o(e.b)};return this.scanQuiet(0,0,this.bitmap.width,this.bitmap.height,(function(t,e,n){var i=this.bitmap.data[n+0],o=this.bitmap.data[n+1],s=this.bitmap.data[n+2];this.bitmap.data[n+0]=a(i,r.r[0],r.r[1]),this.bitmap.data[n+1]=a(o,r.g[0],r.g[1]),this.bitmap.data[n+2]=a(s,r.b[0],r.b[1])})),(0,n.isNodePattern)(t)&&t.call(this,null,this),this}}},e.exports=r.default},{"@jimp/utils":414,"core-js/modules/es.array.fill":174,"core-js/modules/es.array.find-index":176,"core-js/modules/es.array.reverse":185,"core-js/modules/es.array.slice":186}],396:[function(t,e,r){(function(n){"use strict";var i=t("@babel/runtime/helpers/interopRequireDefault");t("core-js/modules/es.array.concat"),t("core-js/modules/es.array.for-each"),t("core-js/modules/es.array.iterator"),t("core-js/modules/es.array.join"),t("core-js/modules/es.array.map"),t("core-js/modules/es.date.to-string"),t("core-js/modules/es.object.entries"),t("core-js/modules/es.object.to-string"),t("core-js/modules/es.promise"),t("core-js/modules/es.regexp.exec"),t("core-js/modules/es.regexp.to-string"),t("core-js/modules/es.string.iterator"),t("core-js/modules/es.string.split"),t("core-js/modules/web.dom-collections.for-each"),t("core-js/modules/web.dom-collections.iterator"),Object.defineProperty(r,"__esModule",{value:!0}),r.default=void 0;var a=i(t("@babel/runtime/helpers/typeof")),o=i(t("@babel/runtime/helpers/toConsumableArray")),s=i(t("path")),l=i(t("load-bmfont")),u=t("@jimp/utils"),f=t("./measure-text");function h(t,e,r,n,i){if(i.width>0&&i.height>0){var a=e.pages[i.page];t.blit(a,r+i.xoffset,n+i.yoffset,i.x,i.y,i.width,i.height)}return t}function c(t,e,r,n,i){for(var a=0;a<n.length;a++){var o;o=t.chars[n[a]]?n[a]:/\s/.test(n[a])?"":"?";var s=t.chars[o]||{},l=t.kernings[o];h(this,t,e,r,s||{}),e+=(l&&l[n[a+1]]?l[n[a+1]]:0)+(s.xadvance||i)}}var d="browser/lib/";r.default=function(){return{constants:{measureText:f.measureText,measureTextHeight:f.measureTextHeight,FONT_SANS_8_BLACK:s.default.join(d,"fonts/open-sans/open-sans-8-black/open-sans-8-black.fnt"),FONT_SANS_10_BLACK:s.default.join(d,"fonts/open-sans/open-sans-10-black/open-sans-10-black.fnt"),FONT_SANS_12_BLACK:s.default.join(d,"fonts/open-sans/open-sans-12-black/open-sans-12-black.fnt"),FONT_SANS_14_BLACK:s.default.join(d,"fonts/open-sans/open-sans-14-black/open-sans-14-black.fnt"),FONT_SANS_16_BLACK:s.default.join(d,"fonts/open-sans/open-sans-16-black/open-sans-16-black.fnt"),FONT_SANS_32_BLACK:s.default.join(d,"fonts/open-sans/open-sans-32-black/open-sans-32-black.fnt"),FONT_SANS_64_BLACK:s.default.join(d,"fonts/open-sans/open-sans-64-black/open-sans-64-black.fnt"),FONT_SANS_128_BLACK:s.default.join(d,"fonts/open-sans/open-sans-128-black/open-sans-128-black.fnt"),FONT_SANS_8_WHITE:s.default.join(d,"fonts/open-sans/open-sans-8-white/open-sans-8-white.fnt"),FONT_SANS_16_WHITE:s.default.join(d,"fonts/open-sans/open-sans-16-white/open-sans-16-white.fnt"),FONT_SANS_32_WHITE:s.default.join(d,"fonts/open-sans/open-sans-32-white/open-sans-32-white.fnt"),FONT_SANS_64_WHITE:s.default.join(d,"fonts/open-sans/open-sans-64-white/open-sans-64-white.fnt"),FONT_SANS_128_WHITE:s.default.join(d,"fonts/open-sans/open-sans-128-white/open-sans-128-white.fnt"),loadFont:function(t,e){var r=this;return"string"!=typeof t?u.throwError.call(this,"file must be a string",e):new Promise((function(n,i){e=e||function(t,e){t?i(t):n(e)},(0,l.default)(t,(function(n,i){var a={},o={};if(n)return u.throwError.call(r,n,e);for(var l=0;l<i.chars.length;l++)a[String.fromCharCode(i.chars[l].id)]=i.chars[l];for(var f=0;f<i.kernings.length;f++){var h=String.fromCharCode(i.kernings[f].first);o[h]=o[h]||{},o[h][String.fromCharCode(i.kernings[f].second)]=i.kernings[f].amount}(function(t,e,r){var n=r.map((function(r){return t.read(e+"/"+r)}));return Promise.all(n)})(r,s.default.dirname(t),i.pages).then((function(t){e(null,{chars:a,kernings:o,pages:t,common:i.common,info:i.info})}))}))}))}},class:{print:function(t,e,r,n,i,s,l){var h,d,p=this;if("function"==typeof i&&void 0===l&&(l=i,i=1/0),void 0===i&&(i=1/0),"function"==typeof s&&void 0===l&&(l=s,s=1/0),void 0===s&&(s=1/0),"object"!==(0,a.default)(t))return u.throwError.call(this,"font must be a Jimp loadFont",l);if("number"!=typeof e||"number"!=typeof r||"number"!=typeof i)return u.throwError.call(this,"x, y and maxWidth must be numbers",l);if("number"!=typeof i)return u.throwError.call(this,"maxWidth must be a number",l);if("number"!=typeof s)return u.throwError.call(this,"maxHeight must be a number",l);"object"===(0,a.default)(n)&&null!==n.text&&void 0!==n.text?(h=n.alignmentX||this.constructor.HORIZONTAL_ALIGN_LEFT,d=n.alignmentY||this.constructor.VERTICAL_ALIGN_TOP,n=n.text):(h=this.constructor.HORIZONTAL_ALIGN_LEFT,d=this.constructor.VERTICAL_ALIGN_TOP,n=n.toString()),s!==1/0&&d===this.constructor.VERTICAL_ALIGN_BOTTOM?r+=s-(0,f.measureTextHeight)(t,n,i):s!==1/0&&d===this.constructor.VERTICAL_ALIGN_MIDDLE&&(r+=s/2-(0,f.measureTextHeight)(t,n,i)/2);var b=Object.entries(t.chars)[0][1].xadvance,m=function(t,e,r){var n=e.split(" "),i=[],a=[],s=0;return n.forEach((function(e){var n=[].concat((0,o.default)(a),[e]).join(" "),l=(0,f.measureText)(t,n);l<=r?(l>s&&(s=l),a.push(e)):(i.push(a),a=[e])})),i.push(a),{lines:i,longestLine:s}}(t,n,i),g=m.lines,y=m.longestLine;return g.forEach((function(n){var a=n.join(" "),o=function(t,e,r,n,i){return i===t.HORIZONTAL_ALIGN_LEFT?0:i===t.HORIZONTAL_ALIGN_CENTER?(n-(0,f.measureText)(e,r))/2:n-(0,f.measureText)(e,r)}(p.constructor,t,a,i,h);c.call(p,t,e+o,r,a,b),r+=t.common.lineHeight})),(0,u.isNodePattern)(l)&&l.call(this,null,this,{x:e+y,y:r}),this}}}},e.exports=r.default}).call(this,"/../../node_modules/@jimp/plugin-print/dist")},{"./measure-text":397,"@babel/runtime/helpers/interopRequireDefault":10,"@babel/runtime/helpers/toConsumableArray":19,"@babel/runtime/helpers/typeof":20,"@jimp/utils":414,"core-js/modules/es.array.concat":173,"core-js/modules/es.array.for-each":178,"core-js/modules/es.array.iterator":182,"core-js/modules/es.array.join":183,"core-js/modules/es.array.map":184,"core-js/modules/es.date.to-string":187,"core-js/modules/es.object.entries":193,"core-js/modules/es.object.to-string":197,"core-js/modules/es.promise":199,"core-js/modules/es.regexp.exec":200,"core-js/modules/es.regexp.to-string":201,"core-js/modules/es.string.iterator":203,"core-js/modules/es.string.split":206,"core-js/modules/web.dom-collections.for-each":235,"core-js/modules/web.dom-collections.iterator":236,"load-bmfont":398,path:286}],397:[function(t,e,r){"use strict";function n(t,e){for(var r=0,n=0;n<e.length;n++)if(t.chars[e[n]]){var i=t.kernings[e[n]]&&t.kernings[e[n]][e[n+1]]?t.kernings[e[n]][e[n+1]]:0;r+=(t.chars[e[n]].xadvance||0)+i}return r}t("core-js/modules/es.regexp.exec"),t("core-js/modules/es.string.split"),Object.defineProperty(r,"__esModule",{value:!0}),r.measureText=n,r.measureTextHeight=function(t,e,r){for(var i=e.split(" "),a="",o=t.common.lineHeight,s=0;s<i.length;s++){var l=a+i[s]+" ";n(t,l)>r&&s>0?(o+=t.common.lineHeight,a=i[s]+" "):a=l}return o}},{"core-js/modules/es.regexp.exec":200,"core-js/modules/es.string.split":206}],398:[function(t,e,r){(function(r){var n=t("xhr"),i=function(){},a=t("parse-bmfont-ascii"),o=t("parse-bmfont-xml"),s=t("parse-bmfont-binary"),l=t("./lib/is-binary"),u=t("xtend"),f=self.XMLHttpRequest&&"withCredentials"in new XMLHttpRequest;e.exports=function(t,e){e="function"==typeof e?e:i,"string"==typeof t?t={uri:t}:t||(t={}),t.binary&&(t=function(t){if(f)return u(t,{responseType:"arraybuffer"});if(void 0===self.XMLHttpRequest)throw new Error("your browser does not support XHR loading");var e=new self.XMLHttpRequest;return e.overrideMimeType("text/plain; charset=x-user-defined"),u({xhr:e},t)}(t)),n(t,(function(n,u,f){if(n)return e(n);if(!/^2/.test(u.statusCode))return e(new Error("http status code: "+u.statusCode));if(!f)return e(new Error("no body result"));var h,c,d=!1;if(c=f,"[object ArrayBuffer]"===Object.prototype.toString.call(c)){var p=new Uint8Array(f);f=new r(p,"binary")}l(f)&&(d=!0,"string"==typeof f&&(f=new r(f,"binary"))),d||(r.isBuffer(f)&&(f=f.toString(t.encoding)),f=f.trim());try{var b=u.headers["content-type"];h=d?s(f):/json/.test(b)||"{"===f.charAt(0)?JSON.parse(f):/xml/.test(b)||"<"===f.charAt(0)?o(f):a(f)}catch(t){e(new Error("error parsing font "+t.message)),e=i}e(null,h)}))}}).call(this,t("buffer").Buffer)},{"./lib/is-binary":399,buffer:47,"parse-bmfont-ascii":281,"parse-bmfont-binary":282,"parse-bmfont-xml":283,xhr:366,xtend:368}],399:[function(t,e,r){(function(r){var n=t("buffer-equal"),i=new r([66,77,70,3]);e.exports=function(t){return"string"==typeof t?"BMF"===t.substring(0,3):t.length>4&&n(t.slice(0,4),i)}}).call(this,t("buffer").Buffer)},{buffer:47,"buffer-equal":48}],400:[function(t,e,r){(function(n){"use strict";var i=t("@babel/runtime/helpers/interopRequireDefault");Object.defineProperty(r,"__esModule",{value:!0}),r.default=void 0;var a=t("@jimp/utils"),o=i(t("./modules/resize")),s=i(t("./modules/resize2"));r.default=function(){return{constants:{RESIZE_NEAREST_NEIGHBOR:"nearestNeighbor",RESIZE_BILINEAR:"bilinearInterpolation",RESIZE_BICUBIC:"bicubicInterpolation",RESIZE_HERMITE:"hermiteInterpolation",RESIZE_BEZIER:"bezierInterpolation"},class:{resize:function(t,e,r,i){if("number"!=typeof t||"number"!=typeof e)return a.throwError.call(this,"w and h must be numbers",i);if("function"==typeof r&&void 0===i&&(i=r,r=null),t===this.constructor.AUTO&&e===this.constructor.AUTO)return a.throwError.call(this,"w and h cannot both be set to auto",i);if(t===this.constructor.AUTO&&(t=this.bitmap.width*(e/this.bitmap.height)),e===this.constructor.AUTO&&(e=this.bitmap.height*(t/this.bitmap.width)),t<0||e<0)return a.throwError.call(this,"w and h must be positive numbers",i);if(t=Math.round(t),e=Math.round(e),"function"==typeof s.default[r]){var l={data:n.alloc(t*e*4),width:t,height:e};s.default[r](this.bitmap,l),this.bitmap=l}else{var u=this;new o.default(this.bitmap.width,this.bitmap.height,t,e,!0,!0,(function(r){u.bitmap.data=n.from(r),u.bitmap.width=t,u.bitmap.height=e})).resize(this.bitmap.data)}return(0,a.isNodePattern)(i)&&i.call(this,null,this),this}}}},e.exports=r.default}).call(this,t("buffer").Buffer)},{"./modules/resize":401,"./modules/resize2":402,"@babel/runtime/helpers/interopRequireDefault":10,"@jimp/utils":414,buffer:47}],401:[function(t,e,r){"use strict";function n(t,e,r,n,i,a,o){this.widthOriginal=Math.abs(Math.floor(t)||0),this.heightOriginal=Math.abs(Math.floor(e)||0),this.targetWidth=Math.abs(Math.floor(r)||0),this.targetHeight=Math.abs(Math.floor(n)||0),this.colorChannels=i?4:3,this.interpolationPass=Boolean(a),this.resizeCallback="function"==typeof o?o:function(){},this.targetWidthMultipliedByChannels=this.targetWidth*this.colorChannels,this.originalWidthMultipliedByChannels=this.widthOriginal*this.colorChannels,this.originalHeightMultipliedByChannels=this.heightOriginal*this.colorChannels,this.widthPassResultSize=this.targetWidthMultipliedByChannels*this.heightOriginal,this.finalResultSize=this.targetWidthMultipliedByChannels*this.targetHeight,this.initialize()}t("core-js/modules/es.array.iterator"),t("core-js/modules/es.array-buffer.slice"),t("core-js/modules/es.object.to-string"),t("core-js/modules/es.typed-array.float32-array"),t("core-js/modules/es.typed-array.float64-array"),t("core-js/modules/es.typed-array.uint8-array"),t("core-js/modules/es.typed-array.copy-within"),t("core-js/modules/es.typed-array.every"),t("core-js/modules/es.typed-array.fill"),t("core-js/modules/es.typed-array.filter"),t("core-js/modules/es.typed-array.find"),t("core-js/modules/es.typed-array.find-index"),t("core-js/modules/es.typed-array.for-each"),t("core-js/modules/es.typed-array.includes"),t("core-js/modules/es.typed-array.index-of"),t("core-js/modules/es.typed-array.iterator"),t("core-js/modules/es.typed-array.join"),t("core-js/modules/es.typed-array.last-index-of"),t("core-js/modules/es.typed-array.map"),t("core-js/modules/es.typed-array.reduce"),t("core-js/modules/es.typed-array.reduce-right"),t("core-js/modules/es.typed-array.reverse"),t("core-js/modules/es.typed-array.set"),t("core-js/modules/es.typed-array.slice"),t("core-js/modules/es.typed-array.some"),t("core-js/modules/es.typed-array.sort"),t("core-js/modules/es.typed-array.subarray"),t("core-js/modules/es.typed-array.to-locale-string"),t("core-js/modules/es.typed-array.to-string"),n.prototype.initialize=function(){if(!(this.widthOriginal>0&&this.heightOriginal>0&&this.targetWidth>0&&this.targetHeight>0))throw new Error("Invalid settings specified for the resizer.");this.configurePasses()},n.prototype.configurePasses=function(){this.widthOriginal===this.targetWidth?this.resizeWidth=this.bypassResizer:(this.ratioWeightWidthPass=this.widthOriginal/this.targetWidth,this.ratioWeightWidthPass<1&&this.interpolationPass?(this.initializeFirstPassBuffers(!0),this.resizeWidth=4===this.colorChannels?this.resizeWidthInterpolatedRGBA:this.resizeWidthInterpolatedRGB):(this.initializeFirstPassBuffers(!1),this.resizeWidth=4===this.colorChannels?this.resizeWidthRGBA:this.resizeWidthRGB)),this.heightOriginal===this.targetHeight?this.resizeHeight=this.bypassResizer:(this.ratioWeightHeightPass=this.heightOriginal/this.targetHeight,this.ratioWeightHeightPass<1&&this.interpolationPass?(this.initializeSecondPassBuffers(!0),this.resizeHeight=this.resizeHeightInterpolated):(this.initializeSecondPassBuffers(!1),this.resizeHeight=4===this.colorChannels?this.resizeHeightRGBA:this.resizeHeightRGB))},n.prototype._resizeWidthInterpolatedRGBChannels=function(t,e){var r,n,i=e?4:3,a=this.ratioWeightWidthPass,o=this.widthBuffer,s=0,l=0,u=0,f=0,h=0;for(r=0;s<1/3;r+=i,s+=a)for(l=r,u=0;l<this.widthPassResultSize;u+=this.originalWidthMultipliedByChannels,l+=this.targetWidthMultipliedByChannels)o[l]=t[u],o[l+1]=t[u+1],o[l+2]=t[u+2],e&&(o[l+3]=t[u+3]);for(s-=1/3,n=this.widthOriginal-1;s<n;r+=i,s+=a)for(f=1-(h=s%1),l=r,u=Math.floor(s)*i;l<this.widthPassResultSize;u+=this.originalWidthMultipliedByChannels,l+=this.targetWidthMultipliedByChannels)o[l+0]=t[u+0]*f+t[u+i+0]*h,o[l+1]=t[u+1]*f+t[u+i+1]*h,o[l+2]=t[u+2]*f+t[u+i+2]*h,e&&(o[l+3]=t[u+3]*f+t[u+i+3]*h);for(n=this.originalWidthMultipliedByChannels-i;r<this.targetWidthMultipliedByChannels;r+=i)for(l=r,u=n;l<this.widthPassResultSize;u+=this.originalWidthMultipliedByChannels,l+=this.targetWidthMultipliedByChannels)o[l]=t[u],o[l+1]=t[u+1],o[l+2]=t[u+2],e&&(o[l+3]=t[u+3]);return o},n.prototype._resizeWidthRGBChannels=function(t,e){var r=e?4:3,n=this.ratioWeightWidthPass,i=1/n,a=this.originalWidthMultipliedByChannels-r+1,o=this.targetWidthMultipliedByChannels-r+1,s=this.outputWidthWorkBench,l=this.widthBuffer,u=this.outputWidthWorkBenchOpaquePixelsCount,f=0,h=0,c=0,d=0,p=0,b=0,m=0,g=1,y=0,v=0,_=0,w=0;do{for(p=0;p<this.originalHeightMultipliedByChannels;)s[p++]=0,s[p++]=0,s[p++]=0,e&&(s[p++]=0,u[p/r-1]=0);f=n;do{for(h=1+c-d,g=Math.min(f,h),p=0,b=c;p<this.originalHeightMultipliedByChannels;b+=a)y=t[b],v=t[++b],_=t[++b],w=e?t[++b]:255,s[p++]+=(w?y:0)*g,s[p++]+=(w?v:0)*g,s[p++]+=(w?_:0)*g,e&&(s[p++]+=w*g,u[p/r-1]+=w?g:0);if(!(f>=h)){d+=f;break}d=c+=r,f-=h}while(f>0&&c<this.originalWidthMultipliedByChannels);for(p=0,b=m;p<this.originalHeightMultipliedByChannels;b+=o)f=e?u[p/r]:1,g=e?f?1/f:0:i,l[b]=s[p++]*g,l[++b]=s[p++]*g,l[++b]=s[p++]*g,e&&(l[++b]=s[p++]*i);m+=r}while(m<this.targetWidthMultipliedByChannels);return l},n.prototype._resizeHeightRGBChannels=function(t,e){var r=this.ratioWeightHeightPass,n=1/r,i=this.outputHeightWorkBench,a=this.heightBuffer,o=this.outputHeightWorkBenchOpaquePixelsCount,s=0,l=0,u=0,f=0,h=0,c=0,d=0,p=1,b=0,m=0,g=0,y=0;do{for(h=0;h<this.targetWidthMultipliedByChannels;)i[h++]=0,i[h++]=0,i[h++]=0,e&&(i[h++]=0,o[h/4-1]=0);s=r;do{for(l=1+u-f,p=Math.min(s,l),d=u,h=0;h<this.targetWidthMultipliedByChannels;)b=t[d++],m=t[d++],g=t[d++],y=e?t[d++]:255,i[h++]+=(y?b:0)*p,i[h++]+=(y?m:0)*p,i[h++]+=(y?g:0)*p,e&&(i[h++]+=y*p,o[h/4-1]+=y?p:0);if(!(s>=l)){f+=s;break}f=u=d,s-=l}while(s>0&&u<this.widthPassResultSize);for(h=0;h<this.targetWidthMultipliedByChannels;)s=e?o[h/4]:1,p=e?s?1/s:0:n,a[c++]=Math.round(i[h++]*p),a[c++]=Math.round(i[h++]*p),a[c++]=Math.round(i[h++]*p),e&&(a[c++]=Math.round(i[h++]*n))}while(c<this.finalResultSize);return a},n.prototype.resizeWidthInterpolatedRGB=function(t){return this._resizeWidthInterpolatedRGBChannels(t,!1)},n.prototype.resizeWidthInterpolatedRGBA=function(t){return this._resizeWidthInterpolatedRGBChannels(t,!0)},n.prototype.resizeWidthRGB=function(t){return this._resizeWidthRGBChannels(t,!1)},n.prototype.resizeWidthRGBA=function(t){return this._resizeWidthRGBChannels(t,!0)},n.prototype.resizeHeightInterpolated=function(t){for(var e,r=this.ratioWeightHeightPass,n=this.heightBuffer,i=0,a=0,o=0,s=0,l=0,u=0,f=0;i<1/3;i+=r)for(o=0;o<this.targetWidthMultipliedByChannels;)n[a++]=Math.round(t[o++]);for(i-=1/3,e=this.heightOriginal-1;i<e;i+=r)for(u=1-(f=i%1),l=(s=Math.floor(i)*this.targetWidthMultipliedByChannels)+this.targetWidthMultipliedByChannels,o=0;o<this.targetWidthMultipliedByChannels;++o)n[a++]=Math.round(t[s++]*u+t[l++]*f);for(;a<this.finalResultSize;)for(o=0,s=e*this.targetWidthMultipliedByChannels;o<this.targetWidthMultipliedByChannels;++o)n[a++]=Math.round(t[s++]);return n},n.prototype.resizeHeightRGB=function(t){return this._resizeHeightRGBChannels(t,!1)},n.prototype.resizeHeightRGBA=function(t){return this._resizeHeightRGBChannels(t,!0)},n.prototype.resize=function(t){this.resizeCallback(this.resizeHeight(this.resizeWidth(t)))},n.prototype.bypassResizer=function(t){return t},n.prototype.initializeFirstPassBuffers=function(t){this.widthBuffer=this.generateFloatBuffer(this.widthPassResultSize),t||(this.outputWidthWorkBench=this.generateFloatBuffer(this.originalHeightMultipliedByChannels),this.colorChannels>3&&(this.outputWidthWorkBenchOpaquePixelsCount=this.generateFloat64Buffer(this.heightOriginal)))},n.prototype.initializeSecondPassBuffers=function(t){this.heightBuffer=this.generateUint8Buffer(this.finalResultSize),t||(this.outputHeightWorkBench=this.generateFloatBuffer(this.targetWidthMultipliedByChannels),this.colorChannels>3&&(this.outputHeightWorkBenchOpaquePixelsCount=this.generateFloat64Buffer(this.targetWidth)))},n.prototype.generateFloatBuffer=function(t){try{return new Float32Array(t)}catch(t){return[]}},n.prototype.generateFloat64Buffer=function(t){try{return new Float64Array(t)}catch(t){return[]}},n.prototype.generateUint8Buffer=function(t){try{return new Uint8Array(t)}catch(t){return[]}},e.exports=n},{"core-js/modules/es.array-buffer.slice":172,"core-js/modules/es.array.iterator":182,"core-js/modules/es.object.to-string":197,"core-js/modules/es.typed-array.copy-within":208,"core-js/modules/es.typed-array.every":209,"core-js/modules/es.typed-array.fill":210,"core-js/modules/es.typed-array.filter":211,"core-js/modules/es.typed-array.find":213,"core-js/modules/es.typed-array.find-index":212,"core-js/modules/es.typed-array.float32-array":214,"core-js/modules/es.typed-array.float64-array":215,"core-js/modules/es.typed-array.for-each":216,"core-js/modules/es.typed-array.includes":217,"core-js/modules/es.typed-array.index-of":218,"core-js/modules/es.typed-array.iterator":219,"core-js/modules/es.typed-array.join":220,"core-js/modules/es.typed-array.last-index-of":221,"core-js/modules/es.typed-array.map":222,"core-js/modules/es.typed-array.reduce":224,"core-js/modules/es.typed-array.reduce-right":223,"core-js/modules/es.typed-array.reverse":225,"core-js/modules/es.typed-array.set":226,"core-js/modules/es.typed-array.slice":227,"core-js/modules/es.typed-array.some":228,"core-js/modules/es.typed-array.sort":229,"core-js/modules/es.typed-array.subarray":230,"core-js/modules/es.typed-array.to-locale-string":231,"core-js/modules/es.typed-array.to-string":232,"core-js/modules/es.typed-array.uint8-array":233}],402:[function(t,e,r){(function(t){"use strict";e.exports={nearestNeighbor:function(t,e){for(var r=t.width,n=t.height,i=e.width,a=e.height,o=t.data,s=e.data,l=0;l<a;l++)for(var u=0;u<i;u++){var f=4*(l*i+u),h=4*(Math.floor(l*n/a)*r+Math.floor(u*r/i));s[f++]=o[h++],s[f++]=o[h++],s[f++]=o[h++],s[f++]=o[h++]}},bilinearInterpolation:function(t,e){for(var r=t.width,n=t.height,i=e.width,a=e.height,o=t.data,s=e.data,l=function(t,e,r,n,i){return e===n?r:Math.round((t-e)*i+(n-t)*r)},u=function(t,e,n,i,a,u,f,h){var c=4*(f*r+i)+e,d=4*(f*r+a)+e,p=l(n,i,o[c],a,o[d]);if(h===f)s[t+e]=p;else{d=4*(h*r+a)+e;var b=l(n,i,o[c=4*(h*r+i)+e],a,o[d]);s[t+e]=l(u,f,p,h,b)}},f=0;f<a;f++)for(var h=0;h<i;h++){var c=4*(f*i+h),d=h*r/i,p=Math.floor(d),b=Math.min(Math.ceil(d),r-1),m=f*n/a,g=Math.floor(m),y=Math.min(Math.ceil(m),n-1);u(c,0,d,p,b,m,g,y),u(c,1,d,p,b,m,g,y),u(c,2,d,p,b,m,g,y),u(c,3,d,p,b,m,g,y)}},_interpolate2D:function(e,r,n,i){for(var a=e.data,o=r.data,s=e.width,l=e.height,u=r.width,f=r.height,h=Math.max(1,Math.floor(s/u)),c=u*h,d=Math.max(1,Math.floor(l/f)),p=f*d,b=t.alloc(c*l*4),m=0;m<l;m++)for(var g=0;g<c;g++)for(var y=g*(s-1)/c,v=Math.floor(y),_=y-v,w=4*(m*s+v),x=4*(m*c+g),E=0;E<4;E++){var k=w+E,j=v>0?a[k-4]:2*a[k]-a[k+4],S=a[k],A=a[k+4],T=v<s-2?a[k+8]:2*a[k+4]-a[k];b[x+E]=i(j,S,A,T,_)}for(var I=t.alloc(c*p*4),P=0;P<p;P++)for(var M=0;M<c;M++)for(var O=P*(l-1)/p,R=Math.floor(O),L=O-R,C=4*(R*c+M),B=4*(P*c+M),D=0;D<4;D++){var N=C+D,U=R>0?b[N-4*c]:2*b[N]-b[N+4*c],z=b[N],F=b[N+4*c],H=R<l-2?b[N+8*c]:2*b[N+4*c]-b[N];I[B+D]=i(U,z,F,H,L)}var G=h*d;if(G>1)for(var q=0;q<f;q++)for(var W=0;W<u;W++){for(var Z=0,V=0,Y=0,X=0,J=0,K=0;K<d;K++)for(var Q=q*d+K,$=0;$<h;$++){var tt=4*(Q*c+(W*h+$)),et=I[tt+3];et&&(Z+=I[tt],V+=I[tt+1],Y+=I[tt+2],J++),X+=et}var rt=4*(q*u+W);o[rt]=J?Math.round(Z/J):0,o[rt+1]=J?Math.round(V/J):0,o[rt+2]=J?Math.round(Y/J):0,o[rt+3]=Math.round(X/G)}else r.data=I},bicubicInterpolation:function(t,e,r){return this._interpolate2D(t,e,r,(function(t,e,r,n,i){var a=n-r-t+e,o=t-e-a,s=r-t,l=e;return Math.max(0,Math.min(255,a*(i*i*i)+o*(i*i)+s*i+l))}))},hermiteInterpolation:function(t,e,r){return this._interpolate2D(t,e,r,(function(t,e,r,n,i){var a=e,o=.5*(r-t),s=t-2.5*e+2*r-.5*n,l=.5*(n-t)+1.5*(e-r);return Math.max(0,Math.min(255,Math.round(((l*i+s)*i+o)*i+a)))}))},bezierInterpolation:function(t,e,r){return this._interpolate2D(t,e,r,(function(t,e,r,n,i){var a=1-i,o=e*a*a*a,s=3*(e+(r-t)/4)*a*a*i,l=3*(r-(n-e)/4)*a*i*i,u=r*i*i*i;return Math.max(0,Math.min(255,Math.round(o+s+l+u)))}))}}}).call(this,t("buffer").Buffer)},{buffer:47}],403:[function(t,e,r){(function(n){"use strict";Object.defineProperty(r,"__esModule",{value:!0}),r.default=void 0;var i=t("@jimp/utils");function a(t,e){var r=(t%=360)*Math.PI/180,i=Math.cos(r),a=Math.sin(r),o=this.bitmap.width,s=this.bitmap.height;if(!0===e||"string"==typeof e){(o=Math.ceil(Math.abs(this.bitmap.width*i)+Math.abs(this.bitmap.height*a))+1)%2!=0&&o++,(s=Math.ceil(Math.abs(this.bitmap.width*a)+Math.abs(this.bitmap.height*i))+1)%2!=0&&s++;var l=this.cloneQuiet();this.scanQuiet(0,0,this.bitmap.width,this.bitmap.height,(function(t,e,r){this.bitmap.data.writeUInt32BE(this._background,r)}));var u=Math.max(o,s,this.bitmap.width,this.bitmap.height);this.resize(u,u,e),this.blit(l,this.bitmap.width/2-l.bitmap.width/2,this.bitmap.height/2-l.bitmap.height/2)}var f=this.bitmap.width,h=this.bitmap.height,c=n.alloc(this.bitmap.data.length);function d(t,e){return function(r,n){return{x:r+t,y:n+e}}}for(var p=d(-f/2,-h/2),b=d(f/2+.5,h/2+.5),m=1;m<=h;m++)for(var g=1;g<=f;g++){var y=p(g,m),v=b(i*y.x-a*y.y,i*y.y+a*y.x),_=f*(m-1)+g-1<<2;if(v.x>=0&&v.x<f&&v.y>=0&&v.y<h){var w=f*(0|v.y)+v.x<<2,x=this.bitmap.data.readUInt32BE(w);c.writeUInt32BE(x,_)}else c.writeUInt32BE(this._background,_)}if(this.bitmap.data=c,!0===e||"string"==typeof e){var E=f/2-o/2,k=h/2-s/2;this.crop(E,k,o,s)}}r.default=function(){return{rotate:function(t,e,r){return null==e&&(e=!0),"function"==typeof e&&void 0===r&&(r=e,e=!0),"number"!=typeof t?i.throwError.call(this,"deg must be a number",r):"boolean"!=typeof e&&"string"!=typeof e?i.throwError.call(this,"mode must be a boolean or a string",r):(a.call(this,t,e,r),(0,i.isNodePattern)(r)&&r.call(this,null,this),this)}}},e.exports=r.default}).call(this,t("buffer").Buffer)},{"@jimp/utils":414,buffer:47}],404:[function(t,e,r){"use strict";Object.defineProperty(r,"__esModule",{value:!0}),r.default=void 0;var n=t("@jimp/utils");r.default=function(){return{scale:function(t,e,r){if("number"!=typeof t)return n.throwError.call(this,"f must be a number",r);if(t<0)return n.throwError.call(this,"f must be a positive number",r);"function"==typeof e&&void 0===r&&(r=e,e=null);var i=this.bitmap.width*t,a=this.bitmap.height*t;return this.resize(i,a,e),(0,n.isNodePattern)(r)&&r.call(this,null,this),this},scaleToFit:function(t,e,r,i){if("number"!=typeof t||"number"!=typeof e)return n.throwError.call(this,"w and h must be numbers",i);"function"==typeof r&&void 0===i&&(i=r,r=null);var a=t/e>this.bitmap.width/this.bitmap.height?e/this.bitmap.height:t/this.bitmap.width;return this.scale(a,r),(0,n.isNodePattern)(i)&&i.call(this,null,this),this}}},e.exports=r.default},{"@jimp/utils":414}],405:[function(t,e,r){"use strict";Object.defineProperty(r,"__esModule",{value:!0}),r.default=void 0;var n=t("@jimp/utils");r.default=function(){return{shadow:function(){var t=this,e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=arguments.length>1?arguments[1]:void 0;"function"==typeof e&&(r=e,e={});var i=e,a=i.opacity,o=void 0===a?.7:a,s=i.size,l=void 0===s?1.1:s,u=i.x,f=void 0===u?-25:u,h=i.y,c=void 0===h?25:h,d=i.blur,p=void 0===d?5:d,b=this.clone(),m=this.clone();return m.scan(0,0,m.bitmap.width,m.bitmap.height,(function(e,r,n){m.bitmap.data[n]=0,m.bitmap.data[n+1]=0,m.bitmap.data[n+2]=0,m.bitmap.data[n+3]=m.constructor.limit255(m.bitmap.data[n+3]*o),t.bitmap.data[n]=0,t.bitmap.data[n+1]=0,t.bitmap.data[n+2]=0,t.bitmap.data[n+3]=0})),m.resize(m.bitmap.width*l,m.bitmap.height*l).blur(p),this.composite(m,f,c),this.composite(b,0,0),(0,n.isNodePattern)(r)&&r.call(this,null,this),this}}},e.exports=r.default},{"@jimp/utils":414}],406:[function(t,e,r){"use strict";t("core-js/modules/es.regexp.exec"),t("core-js/modules/es.string.replace"),Object.defineProperty(r,"__esModule",{value:!0}),r.default=void 0;var n=t("@jimp/utils");r.default=function(){return{threshold:function(t,e){var r=this,i=t.max,a=t.replace,o=void 0===a?255:a,s=t.autoGreyscale,l=void 0===s||s;return"number"!=typeof i?n.throwError.call(this,"max must be a number",e):"number"!=typeof o?n.throwError.call(this,"replace must be a number",e):"boolean"!=typeof l?n.throwError.call(this,"autoGreyscale must be a boolean",e):(i=this.constructor.limit255(i),o=this.constructor.limit255(o),l&&this.greyscale(),this.scanQuiet(0,0,this.bitmap.width,this.bitmap.height,(function(t,e,n){var a=r.bitmap.data[n]<i?r.bitmap.data[n]:o;r.bitmap.data[n]=a,r.bitmap.data[n+1]=a,r.bitmap.data[n+2]=a})),(0,n.isNodePattern)(e)&&e.call(this,null,this),this)}}},e.exports=r.default},{"@jimp/utils":414,"core-js/modules/es.regexp.exec":200,"core-js/modules/es.string.replace":205}],407:[function(t,e,r){"use strict";var n=t("@babel/runtime/helpers/interopRequireDefault");t("core-js/modules/es.array.map"),Object.defineProperty(r,"__esModule",{value:!0}),r.default=void 0;var i=n(t("@babel/runtime/helpers/toConsumableArray")),a=t("timm"),o=n(t("@jimp/plugin-blit")),s=n(t("@jimp/plugin-blur")),l=n(t("@jimp/plugin-circle")),u=n(t("@jimp/plugin-color")),f=n(t("@jimp/plugin-contain")),h=n(t("@jimp/plugin-cover")),c=n(t("@jimp/plugin-crop")),d=n(t("@jimp/plugin-displace")),p=n(t("@jimp/plugin-dither")),b=n(t("@jimp/plugin-fisheye")),m=n(t("@jimp/plugin-flip")),g=n(t("@jimp/plugin-gaussian")),y=n(t("@jimp/plugin-invert")),v=n(t("@jimp/plugin-mask")),_=n(t("@jimp/plugin-normalize")),w=n(t("@jimp/plugin-print")),x=n(t("@jimp/plugin-resize")),E=n(t("@jimp/plugin-rotate")),k=n(t("@jimp/plugin-scale")),j=n(t("@jimp/plugin-shadow")),S=n(t("@jimp/plugin-threshold")),A=[o.default,s.default,l.default,u.default,f.default,h.default,c.default,d.default,p.default,b.default,m.default,g.default,y.default,v.default,_.default,w.default,x.default,E.default,k.default,j.default,S.default];r.default=function(t){var e=A.map((function(e){var r=e(t)||{};return r.class||r.constants||(r={class:r}),r}));return a.mergeDeep.apply(void 0,(0,i.default)(e))},e.exports=r.default},{"@babel/runtime/helpers/interopRequireDefault":10,"@babel/runtime/helpers/toConsumableArray":19,"@jimp/plugin-blit":380,"@jimp/plugin-blur":382,"@jimp/plugin-circle":383,"@jimp/plugin-color":384,"@jimp/plugin-contain":385,"@jimp/plugin-cover":386,"@jimp/plugin-crop":387,"@jimp/plugin-displace":388,"@jimp/plugin-dither":389,"@jimp/plugin-fisheye":390,"@jimp/plugin-flip":391,"@jimp/plugin-gaussian":392,"@jimp/plugin-invert":393,"@jimp/plugin-mask":394,"@jimp/plugin-normalize":395,"@jimp/plugin-print":396,"@jimp/plugin-resize":400,"@jimp/plugin-rotate":403,"@jimp/plugin-scale":404,"@jimp/plugin-shadow":405,"@jimp/plugin-threshold":406,"core-js/modules/es.array.map":184,timm:356}],408:[function(t,e,r){"use strict";var n=t("@babel/runtime/helpers/interopRequireDefault");Object.defineProperty(r,"__esModule",{value:!0}),r.default=void 0;var i=n(t("@babel/runtime/helpers/defineProperty")),a=n(t("bmp-js")),o=t("@jimp/utils"),s="image/bmp",l="image/x-ms-bmp",u=function(t){return e=a.default.decode(t),(0,o.scan)({bitmap:e},0,0,e.width,e.height,(function(t,r,n){var i=this.bitmap.data[n+0],a=this.bitmap.data[n+1],o=this.bitmap.data[n+2],s=this.bitmap.data[n+3];this.bitmap.data[n+0]=s,this.bitmap.data[n+1]=o,this.bitmap.data[n+2]=a,this.bitmap.data[n+3]=e.is_with_alpha?i:255})).bitmap;var e},f=function(t){return a.default.encode(function(t){return(0,o.scan)(t,0,0,t.bitmap.width,t.bitmap.height,(function(t,e,r){var n=this.bitmap.data[r+0],i=this.bitmap.data[r+1],a=this.bitmap.data[r+2],o=this.bitmap.data[r+3];this.bitmap.data[r+0]=o,this.bitmap.data[r+1]=a,this.bitmap.data[r+2]=i,this.bitmap.data[r+3]=n})).bitmap}(t)).data};r.default=function(){var t,e;return{mime:(0,i.default)({},s,["bmp"]),constants:{MIME_BMP:s,MIME_X_MS_BMP:l},decoders:(t={},(0,i.default)(t,s,u),(0,i.default)(t,l,u),t),encoders:(e={},(0,i.default)(e,s,f),(0,i.default)(e,l,f),e)}},e.exports=r.default},{"@babel/runtime/helpers/defineProperty":7,"@babel/runtime/helpers/interopRequireDefault":10,"@jimp/utils":414,"bmp-js":29}],409:[function(t,e,r){(function(n){"use strict";var i=t("@babel/runtime/helpers/interopRequireDefault");Object.defineProperty(r,"__esModule",{value:!0}),r.default=void 0;var a=i(t("@babel/runtime/helpers/defineProperty")),o=i(t("omggif")),s="image/gif";r.default=function(){return{mime:(0,a.default)({},s,["gif"]),constants:{MIME_GIF:s},decoders:(0,a.default)({},s,(function(t){var e=new o.default.GifReader(t),r=n.alloc(e.width*e.height*4);return e.decodeAndBlitFrameRGBA(0,r),{data:r,width:e.width,height:e.height}}))}},e.exports=r.default}).call(this,t("buffer").Buffer)},{"@babel/runtime/helpers/defineProperty":7,"@babel/runtime/helpers/interopRequireDefault":10,buffer:47,omggif:264}],410:[function(t,e,r){"use strict";var n=t("@babel/runtime/helpers/interopRequireDefault");Object.defineProperty(r,"__esModule",{value:!0}),r.default=void 0;var i=n(t("@babel/runtime/helpers/defineProperty")),a=n(t("jpeg-js")),o=t("@jimp/utils"),s="image/jpeg";r.default=function(){return{mime:(0,i.default)({},s,["jpeg","jpg","jpe"]),constants:{MIME_JPEG:s},decoders:(0,i.default)({},s,a.default.decode),encoders:(0,i.default)({},s,(function(t){return a.default.encode(t.bitmap,t._quality).data})),class:{_quality:100,quality:function(t,e){return"number"!=typeof t?o.throwError.call(this,"n must be a number",e):t<0||t>100?o.throwError.call(this,"n must be a number 0 - 100",e):(this._quality=Math.round(t),(0,o.isNodePattern)(e)&&e.call(this,null,this),this)}}}},e.exports=r.default},{"@babel/runtime/helpers/defineProperty":7,"@babel/runtime/helpers/interopRequireDefault":10,"@jimp/utils":414,"jpeg-js":259}],411:[function(t,e,r){"use strict";var n=t("@babel/runtime/helpers/interopRequireDefault");Object.defineProperty(r,"__esModule",{value:!0}),r.default=void 0;var i=n(t("@babel/runtime/helpers/defineProperty")),a=t("pngjs"),o=t("@jimp/utils"),s="image/png";r.default=function(){return{mime:(0,i.default)({},s,["png"]),constants:{MIME_PNG:s,PNG_FILTER_AUTO:-1,PNG_FILTER_NONE:0,PNG_FILTER_SUB:1,PNG_FILTER_UP:2,PNG_FILTER_AVERAGE:3,PNG_FILTER_PATH:4},hasAlpha:(0,i.default)({},s,!0),decoders:(0,i.default)({},s,a.PNG.sync.read),encoders:(0,i.default)({},s,(function(t){var e=new a.PNG({width:t.bitmap.width,height:t.bitmap.height});return e.data=t.bitmap.data,a.PNG.sync.write(e,{width:t.bitmap.width,height:t.bitmap.height,deflateLevel:t._deflateLevel,deflateStrategy:t._deflateStrategy,filterType:t._filterType,colorType:"number"==typeof t._colorType?t._colorType:t._rgba?6:2,inputHasAlpha:t._rgba})})),class:{_deflateLevel:9,_deflateStrategy:3,_filterType:-1,_colorType:null,deflateLevel:function(t,e){return"number"!=typeof t?o.throwError.call(this,"l must be a number",e):t<0||t>9?o.throwError.call(this,"l must be a number 0 - 9",e):(this._deflateLevel=Math.round(t),(0,o.isNodePattern)(e)&&e.call(this,null,this),this)},deflateStrategy:function(t,e){return"number"!=typeof t?o.throwError.call(this,"s must be a number",e):t<0||t>3?o.throwError.call(this,"s must be a number 0 - 3",e):(this._deflateStrategy=Math.round(t),(0,o.isNodePattern)(e)&&e.call(this,null,this),this)},filterType:function(t,e){return"number"!=typeof t?o.throwError.call(this,"n must be a number",e):t<-1||t>4?o.throwError.call(this,"n must be -1 (auto) or a number 0 - 4",e):(this._filterType=Math.round(t),(0,o.isNodePattern)(e)&&e.call(this,null,this),this)},colorType:function(t,e){return"number"!=typeof t?o.throwError.call(this,"s must be a number",e):0!==t&&2!==t&&4!==t&&6!==t?o.throwError.call(this,"s must be a number 0, 2, 4, 6.",e):(this._colorType=Math.round(t),(0,o.isNodePattern)(e)&&e.call(this,null,this),this)}}}},e.exports=r.default},{"@babel/runtime/helpers/defineProperty":7,"@babel/runtime/helpers/interopRequireDefault":10,"@jimp/utils":414,pngjs:308}],412:[function(t,e,r){(function(n){"use strict";var i=t("@babel/runtime/helpers/interopRequireDefault");Object.defineProperty(r,"__esModule",{value:!0}),r.default=void 0;var a=i(t("@babel/runtime/helpers/defineProperty")),o=i(t("utif")),s="image/tiff";r.default=function(){return{mime:(0,a.default)({},s,["tiff","tif"]),constants:{MIME_TIFF:s},decoders:(0,a.default)({},s,(function(t){var e=o.default.decode(t),r=e[0];o.default.decodeImages(t,e);var i=o.default.toRGBA8(r);return{data:n.from(i),width:r.t256[0],height:r.t257[0]}})),encoders:(0,a.default)({},s,(function(t){var e=o.default.encodeImage(t.bitmap.data,t.bitmap.width,t.bitmap.height);return n.from(e)}))}},e.exports=r.default}).call(this,t("buffer").Buffer)},{"@babel/runtime/helpers/defineProperty":7,"@babel/runtime/helpers/interopRequireDefault":10,buffer:47,utif:361}],413:[function(t,e,r){"use strict";var n=t("@babel/runtime/helpers/interopRequireDefault");Object.defineProperty(r,"__esModule",{value:!0}),r.default=void 0;var i=t("timm"),a=n(t("@jimp/jpeg")),o=n(t("@jimp/png")),s=n(t("@jimp/bmp")),l=n(t("@jimp/tiff")),u=n(t("@jimp/gif"));r.default=function(){return(0,i.mergeDeep)((0,a.default)(),(0,o.default)(),(0,s.default)(),(0,l.default)(),(0,u.default)())},e.exports=r.default},{"@babel/runtime/helpers/interopRequireDefault":10,"@jimp/bmp":408,"@jimp/gif":409,"@jimp/jpeg":410,"@jimp/png":411,"@jimp/tiff":412,timm:356}],414:[function(t,e,r){"use strict";var n=t("@babel/runtime/helpers/interopRequireDefault");Object.defineProperty(r,"__esModule",{value:!0}),r.isNodePattern=function(t){if(void 0===t)return!1;if("function"!=typeof t)throw new TypeError("Callback must be a function");return!0},r.throwError=function(t,e){if("string"==typeof t&&(t=new Error(t)),"function"==typeof e)return e.call(this,t);throw t},r.scan=function(t,e,r,n,i,a){e=Math.round(e),r=Math.round(r),n=Math.round(n),i=Math.round(i);for(var o=r;o<r+i;o++)for(var s=e;s<e+n;s++){var l=t.bitmap.width*o+s<<2;a.call(t,s,o,l)}return t},r.scanIterator=o;var i=n(t("@babel/runtime/regenerator"));t("regenerator-runtime/runtime");var a=i.default.mark(o);function o(t,e,r,n,o){var s,l,u;return i.default.wrap((function(i){for(;;)switch(i.prev=i.next){case 0:e=Math.round(e),r=Math.round(r),n=Math.round(n),o=Math.round(o),s=r;case 5:if(!(s<r+o)){i.next=17;break}l=e;case 7:if(!(l<e+n)){i.next=14;break}return u=t.bitmap.width*s+l<<2,i.next=11,{x:l,y:s,idx:u,image:t};case 11:l++,i.next=7;break;case 14:s++,i.next=5;break;case 17:case"end":return i.stop()}}),a)}},{"@babel/runtime/helpers/interopRequireDefault":10,"@babel/runtime/regenerator":21,"regenerator-runtime/runtime":332}]},{},[379])(379)},267:t=>{"use strict";function e(t,e,r){var n=Math.sqrt,i=Math.pow;this.x1=t,this.x2=e,this.weights=r||{},this.ksubL=this.weights.lightness||1,this.ksubC=this.weights.chroma||1,this.ksubH=this.weights.hue||1,this.deltaLPrime=e.L-t.L,this.LBar=(t.L+e.L)/2,this.C1=n(i(t.A,2)+i(t.B,2)),this.C2=n(i(e.A,2)+i(e.B,2)),this.CBar=(this.C1+this.C2)/2,this.aPrime1=t.A+t.A/2*(1-n(i(this.CBar,7)/(i(this.CBar,7)+i(25,7)))),this.aPrime2=e.A+e.A/2*(1-n(i(this.CBar,7)/(i(this.CBar,7)+i(25,7)))),this.CPrime1=n(i(this.aPrime1,2)+i(t.B,2)),this.CPrime2=n(i(this.aPrime2,2)+i(e.B,2)),this.CBarPrime=(this.CPrime1+this.CPrime2)/2,this.deltaCPrime=this.CPrime2-this.CPrime1,this.SsubL=1+.015*i(this.LBar-50,2)/n(20+i(this.LBar-50,2)),this.SsubC=1+.045*this.CBarPrime,this.hPrime1=0,this.hPrime2=0,this.deltahPrime=0,this.deltaHPrime=0,this.HBarPrime=0,this.T=0,this.SsubH=0,this.RsubT=0}e.prototype.getDeltaE=function(){var t=Math.sqrt,e=Math.sin,r=Math.pow;this.hPrime1=this.gethPrime1(),this.hPrime2=this.gethPrime2(),this.deltahPrime=this.getDeltahPrime(),this.deltaHPrime=2*t(this.CPrime1*this.CPrime2)*e(this.degreesToRadians(this.deltahPrime)/2),this.HBarPrime=this.getHBarPrime(),this.T=this.getT(),this.SsubH=1+.015*this.CBarPrime*this.T,this.RsubT=this.getRsubT();var n=this.deltaLPrime/(this.ksubL*this.SsubL),i=this.deltaCPrime/(this.ksubC*this.SsubC),a=this.deltaHPrime/(this.ksubH*this.SsubH);return t(r(n,2)+r(i,2)+r(a,2)+this.RsubT*i*a)},e.prototype.getRsubT=function(){var t=Math.sin,e=Math.sqrt,r=Math.pow,n=Math.exp;return-2*e(r(this.CBarPrime,7)/(r(this.CBarPrime,7)+r(25,7)))*t(this.degreesToRadians(60*n(-r((this.HBarPrime-275)/25,2))))},e.prototype.getT=function(){var t=Math.cos;return 1-.17*t(this.degreesToRadians(this.HBarPrime-30))+.24*t(this.degreesToRadians(2*this.HBarPrime))+.32*t(this.degreesToRadians(3*this.HBarPrime+6))-.2*t(this.degreesToRadians(4*this.HBarPrime-63))},e.prototype.getHBarPrime=function(){return(0,Math.abs)(this.hPrime1-this.hPrime2)>180?(this.hPrime1+this.hPrime2+360)/2:(this.hPrime1+this.hPrime2)/2},e.prototype.getDeltahPrime=function(){var t=Math.abs;return 0===this.C1||0===this.C2?0:t(this.hPrime1-this.hPrime2)<=180?this.hPrime2-this.hPrime1:this.hPrime2<=this.hPrime1?this.hPrime2-this.hPrime1+360:this.hPrime2-this.hPrime1-360},e.prototype.gethPrime1=function(){return this._gethPrimeFn(this.x1.B,this.aPrime1)},e.prototype.gethPrime2=function(){return this._gethPrimeFn(this.x2.B,this.aPrime2)},e.prototype._gethPrimeFn=function(t,e){var r;return 0===t&&0===e?0:(r=this.radiansToDegrees(Math.atan2(t,e)))>=0?r:r+360},e.prototype.radiansToDegrees=function(t){return t*(180/Math.PI)},e.prototype.degreesToRadians=function(t){return t*(Math.PI/180)},t.exports=e},315:t=>{const e={PARAMETER_INVALID:"Parameter is not valid",PARAMETER_REQUIRED:"Parameter is required"};t.exports=class extends Error{constructor(t,r){super(e[t]),this.name=this.constructor.name,this.code=t,this.field=r}}},335:(t,e,r)=>{const n=r(658);t.exports=t=>{if(!t)return{code:"PARAMETER_REQUIRED",field:"options.colors"};if(!["hex","rgb"].includes(t.type))return{code:"PARAMETER_INVALID",field:"options.colors.type"};let e,r;return"hex"===t.type&&(e="string"==typeof t.targetColor&&7===t.targetColor.length&&n({strict:!0}).test(t.targetColor),r="string"==typeof t.replaceColor&&(7===t.targetColor.length||9===t.targetColor.length)&&n({strict:!0}).test(t.replaceColor)),"rgb"===t.type&&(e=Array.isArray(t.targetColor)&&3===t.targetColor.length&&t.targetColor.every((t=>t>=0&&t<=255)),r=!!Array.isArray(t.replaceColor)&&(3===t.replaceColor.length?t.replaceColor.every((t=>t>=0&&t<=255)):4===t.replaceColor.length&&t.replaceColor.slice(0,3).every((t=>t>=0&&t<=255))&&t.replaceColor[3]>=0&&t.replaceColor[3]<=1)),e?r?null:{code:"PARAMETER_INVALID",field:"options.colors.replaceColor"}:{code:"PARAMETER_INVALID",field:"options.colors.targetColor"}}},415:(t,e,r)=>{const n=r(734);t.exports=(t,e,r)=>{let i=null;return"hex"===t&&9===r.length&&(i=r.slice(1,3),r=r.slice(0,1)+r.slice(3),i=parseInt(i,16)),"rgb"===t&&4===r.length&&(i=r.pop(),i=Math.round(255*i)),t===e?[...r,i]:[...n[t][e](r),i]}},507:(t,e,r)=>{var n=r(659);function i(t,e){return function(r){return e(t(r))}}function a(t,e){for(var r=[e[t].parent,t],a=n[e[t].parent][t],o=e[t].parent;e[o].parent;)r.unshift(e[o].parent),a=i(n[e[o].parent][o],a),o=e[o].parent;return a.conversion=r,a}t.exports=function(t){for(var e=function(t){var e=function(){for(var t={},e=Object.keys(n),r=e.length,i=0;i<r;i++)t[e[i]]={distance:-1,parent:null};return t}(),r=[t];for(e[t].distance=0;r.length;)for(var i=r.pop(),a=Object.keys(n[i]),o=a.length,s=0;s<o;s++){var l=a[s],u=e[l];-1===u.distance&&(u.distance=e[i].distance+1,u.parent=i,r.unshift(l))}return e}(t),r={},i=Object.keys(e),o=i.length,s=0;s<o;s++){var l=i[s];null!==e[l].parent&&(r[l]=a(l,e))}return r}},658:t=>{"use strict";t.exports=function(t){return(t=t&&"object"==typeof t?t:{}).strict?/^#([a-f0-9]{3,4}|[a-f0-9]{4}(?:[a-f0-9]{2}){1,2})\b$/i:/#([a-f0-9]{3}|[a-f0-9]{4}(?:[a-f0-9]{2}){0,2})\b/gi}},659:(t,e,r)=>{var n=r(31),i={};for(var a in n)n.hasOwnProperty(a)&&(i[n[a]]=a);var o=t.exports={rgb:{channels:3,labels:"rgb"},hsl:{channels:3,labels:"hsl"},hsv:{channels:3,labels:"hsv"},hwb:{channels:3,labels:"hwb"},cmyk:{channels:4,labels:"cmyk"},xyz:{channels:3,labels:"xyz"},lab:{channels:3,labels:"lab"},lch:{channels:3,labels:"lch"},hex:{channels:1,labels:["hex"]},keyword:{channels:1,labels:["keyword"]},ansi16:{channels:1,labels:["ansi16"]},ansi256:{channels:1,labels:["ansi256"]},hcg:{channels:3,labels:["h","c","g"]},apple:{channels:3,labels:["r16","g16","b16"]},gray:{channels:1,labels:["gray"]}};for(var s in o)if(o.hasOwnProperty(s)){if(!("channels"in o[s]))throw new Error("missing channels property: "+s);if(!("labels"in o[s]))throw new Error("missing channel labels property: "+s);if(o[s].labels.length!==o[s].channels)throw new Error("channel and label counts mismatch: "+s);var l=o[s].channels,u=o[s].labels;delete o[s].channels,delete o[s].labels,Object.defineProperty(o[s],"channels",{value:l}),Object.defineProperty(o[s],"labels",{value:u})}o.rgb.hsl=function(t){var e,r,n=t[0]/255,i=t[1]/255,a=t[2]/255,o=Math.min(n,i,a),s=Math.max(n,i,a),l=s-o;return s===o?e=0:n===s?e=(i-a)/l:i===s?e=2+(a-n)/l:a===s&&(e=4+(n-i)/l),(e=Math.min(60*e,360))<0&&(e+=360),r=(o+s)/2,[e,100*(s===o?0:r<=.5?l/(s+o):l/(2-s-o)),100*r]},o.rgb.hsv=function(t){var e,r,n,i,a,o=t[0]/255,s=t[1]/255,l=t[2]/255,u=Math.max(o,s,l),f=u-Math.min(o,s,l),h=function(t){return(u-t)/6/f+.5};return 0===f?i=a=0:(a=f/u,e=h(o),r=h(s),n=h(l),o===u?i=n-r:s===u?i=1/3+e-n:l===u&&(i=2/3+r-e),i<0?i+=1:i>1&&(i-=1)),[360*i,100*a,100*u]},o.rgb.hwb=function(t){var e=t[0],r=t[1],n=t[2];return[o.rgb.hsl(t)[0],1/255*Math.min(e,Math.min(r,n))*100,100*(n=1-1/255*Math.max(e,Math.max(r,n)))]},o.rgb.cmyk=function(t){var e,r=t[0]/255,n=t[1]/255,i=t[2]/255;return[100*((1-r-(e=Math.min(1-r,1-n,1-i)))/(1-e)||0),100*((1-n-e)/(1-e)||0),100*((1-i-e)/(1-e)||0),100*e]},o.rgb.keyword=function(t){var e=i[t];if(e)return e;var r,a,o,s=1/0;for(var l in n)if(n.hasOwnProperty(l)){var u=(a=t,o=n[l],Math.pow(a[0]-o[0],2)+Math.pow(a[1]-o[1],2)+Math.pow(a[2]-o[2],2));u<s&&(s=u,r=l)}return r},o.keyword.rgb=function(t){return n[t]},o.rgb.xyz=function(t){var e=t[0]/255,r=t[1]/255,n=t[2]/255;return[100*(.4124*(e=e>.04045?Math.pow((e+.055)/1.055,2.4):e/12.92)+.3576*(r=r>.04045?Math.pow((r+.055)/1.055,2.4):r/12.92)+.1805*(n=n>.04045?Math.pow((n+.055)/1.055,2.4):n/12.92)),100*(.2126*e+.7152*r+.0722*n),100*(.0193*e+.1192*r+.9505*n)]},o.rgb.lab=function(t){var e=o.rgb.xyz(t),r=e[0],n=e[1],i=e[2];return n/=100,i/=108.883,r=(r/=95.047)>.008856?Math.pow(r,1/3):7.787*r+16/116,[116*(n=n>.008856?Math.pow(n,1/3):7.787*n+16/116)-16,500*(r-n),200*(n-(i=i>.008856?Math.pow(i,1/3):7.787*i+16/116))]},o.hsl.rgb=function(t){var e,r,n,i,a,o=t[0]/360,s=t[1]/100,l=t[2]/100;if(0===s)return[a=255*l,a,a];e=2*l-(r=l<.5?l*(1+s):l+s-l*s),i=[0,0,0];for(var u=0;u<3;u++)(n=o+1/3*-(u-1))<0&&n++,n>1&&n--,a=6*n<1?e+6*(r-e)*n:2*n<1?r:3*n<2?e+(r-e)*(2/3-n)*6:e,i[u]=255*a;return i},o.hsl.hsv=function(t){var e=t[0],r=t[1]/100,n=t[2]/100,i=r,a=Math.max(n,.01);return r*=(n*=2)<=1?n:2-n,i*=a<=1?a:2-a,[e,100*(0===n?2*i/(a+i):2*r/(n+r)),(n+r)/2*100]},o.hsv.rgb=function(t){var e=t[0]/60,r=t[1]/100,n=t[2]/100,i=Math.floor(e)%6,a=e-Math.floor(e),o=255*n*(1-r),s=255*n*(1-r*a),l=255*n*(1-r*(1-a));switch(n*=255,i){case 0:return[n,l,o];case 1:return[s,n,o];case 2:return[o,n,l];case 3:return[o,s,n];case 4:return[l,o,n];case 5:return[n,o,s]}},o.hsv.hsl=function(t){var e,r,n,i=t[0],a=t[1]/100,o=t[2]/100,s=Math.max(o,.01);return n=(2-a)*o,r=a*s,[i,100*(r=(r/=(e=(2-a)*s)<=1?e:2-e)||0),100*(n/=2)]},o.hwb.rgb=function(t){var e,r,n,i,a,o,s,l=t[0]/360,u=t[1]/100,f=t[2]/100,h=u+f;switch(h>1&&(u/=h,f/=h),n=6*l-(e=Math.floor(6*l)),1&e&&(n=1-n),i=u+n*((r=1-f)-u),e){default:case 6:case 0:a=r,o=i,s=u;break;case 1:a=i,o=r,s=u;break;case 2:a=u,o=r,s=i;break;case 3:a=u,o=i,s=r;break;case 4:a=i,o=u,s=r;break;case 5:a=r,o=u,s=i}return[255*a,255*o,255*s]},o.cmyk.rgb=function(t){var e=t[0]/100,r=t[1]/100,n=t[2]/100,i=t[3]/100;return[255*(1-Math.min(1,e*(1-i)+i)),255*(1-Math.min(1,r*(1-i)+i)),255*(1-Math.min(1,n*(1-i)+i))]},o.xyz.rgb=function(t){var e,r,n,i=t[0]/100,a=t[1]/100,o=t[2]/100;return r=-.9689*i+1.8758*a+.0415*o,n=.0557*i+-.204*a+1.057*o,e=(e=3.2406*i+-1.5372*a+-.4986*o)>.0031308?1.055*Math.pow(e,1/2.4)-.055:12.92*e,r=r>.0031308?1.055*Math.pow(r,1/2.4)-.055:12.92*r,n=n>.0031308?1.055*Math.pow(n,1/2.4)-.055:12.92*n,[255*(e=Math.min(Math.max(0,e),1)),255*(r=Math.min(Math.max(0,r),1)),255*(n=Math.min(Math.max(0,n),1))]},o.xyz.lab=function(t){var e=t[0],r=t[1],n=t[2];return r/=100,n/=108.883,e=(e/=95.047)>.008856?Math.pow(e,1/3):7.787*e+16/116,[116*(r=r>.008856?Math.pow(r,1/3):7.787*r+16/116)-16,500*(e-r),200*(r-(n=n>.008856?Math.pow(n,1/3):7.787*n+16/116))]},o.lab.xyz=function(t){var e,r,n,i=t[0];e=t[1]/500+(r=(i+16)/116),n=r-t[2]/200;var a=Math.pow(r,3),o=Math.pow(e,3),s=Math.pow(n,3);return r=a>.008856?a:(r-16/116)/7.787,e=o>.008856?o:(e-16/116)/7.787,n=s>.008856?s:(n-16/116)/7.787,[e*=95.047,r*=100,n*=108.883]},o.lab.lch=function(t){var e,r=t[0],n=t[1],i=t[2];return(e=360*Math.atan2(i,n)/2/Math.PI)<0&&(e+=360),[r,Math.sqrt(n*n+i*i),e]},o.lch.lab=function(t){var e,r=t[0],n=t[1];return e=t[2]/360*2*Math.PI,[r,n*Math.cos(e),n*Math.sin(e)]},o.rgb.ansi16=function(t){var e=t[0],r=t[1],n=t[2],i=1 in arguments?arguments[1]:o.rgb.hsv(t)[2];if(0===(i=Math.round(i/50)))return 30;var a=30+(Math.round(n/255)<<2|Math.round(r/255)<<1|Math.round(e/255));return 2===i&&(a+=60),a},o.hsv.ansi16=function(t){return o.rgb.ansi16(o.hsv.rgb(t),t[2])},o.rgb.ansi256=function(t){var e=t[0],r=t[1],n=t[2];return e===r&&r===n?e<8?16:e>248?231:Math.round((e-8)/247*24)+232:16+36*Math.round(e/255*5)+6*Math.round(r/255*5)+Math.round(n/255*5)},o.ansi16.rgb=function(t){var e=t%10;if(0===e||7===e)return t>50&&(e+=3.5),[e=e/10.5*255,e,e];var r=.5*(1+~~(t>50));return[(1&e)*r*255,(e>>1&1)*r*255,(e>>2&1)*r*255]},o.ansi256.rgb=function(t){if(t>=232){var e=10*(t-232)+8;return[e,e,e]}var r;return t-=16,[Math.floor(t/36)/5*255,Math.floor((r=t%36)/6)/5*255,r%6/5*255]},o.rgb.hex=function(t){var e=(((255&Math.round(t[0]))<<16)+((255&Math.round(t[1]))<<8)+(255&Math.round(t[2]))).toString(16).toUpperCase();return"000000".substring(e.length)+e},o.hex.rgb=function(t){var e=t.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);if(!e)return[0,0,0];var r=e[0];3===e[0].length&&(r=r.split("").map((function(t){return t+t})).join(""));var n=parseInt(r,16);return[n>>16&255,n>>8&255,255&n]},o.rgb.hcg=function(t){var e,r=t[0]/255,n=t[1]/255,i=t[2]/255,a=Math.max(Math.max(r,n),i),o=Math.min(Math.min(r,n),i),s=a-o;return e=s<=0?0:a===r?(n-i)/s%6:a===n?2+(i-r)/s:4+(r-n)/s+4,e/=6,[360*(e%=1),100*s,100*(s<1?o/(1-s):0)]},o.hsl.hcg=function(t){var e,r=t[1]/100,n=t[2]/100,i=0;return(e=n<.5?2*r*n:2*r*(1-n))<1&&(i=(n-.5*e)/(1-e)),[t[0],100*e,100*i]},o.hsv.hcg=function(t){var e=t[1]/100,r=t[2]/100,n=e*r,i=0;return n<1&&(i=(r-n)/(1-n)),[t[0],100*n,100*i]},o.hcg.rgb=function(t){var e=t[0]/360,r=t[1]/100,n=t[2]/100;if(0===r)return[255*n,255*n,255*n];var i,a=[0,0,0],o=e%1*6,s=o%1,l=1-s;switch(Math.floor(o)){case 0:a[0]=1,a[1]=s,a[2]=0;break;case 1:a[0]=l,a[1]=1,a[2]=0;break;case 2:a[0]=0,a[1]=1,a[2]=s;break;case 3:a[0]=0,a[1]=l,a[2]=1;break;case 4:a[0]=s,a[1]=0,a[2]=1;break;default:a[0]=1,a[1]=0,a[2]=l}return i=(1-r)*n,[255*(r*a[0]+i),255*(r*a[1]+i),255*(r*a[2]+i)]},o.hcg.hsv=function(t){var e=t[1]/100,r=e+t[2]/100*(1-e),n=0;return r>0&&(n=e/r),[t[0],100*n,100*r]},o.hcg.hsl=function(t){var e=t[1]/100,r=t[2]/100*(1-e)+.5*e,n=0;return r>0&&r<.5?n=e/(2*r):r>=.5&&r<1&&(n=e/(2*(1-r))),[t[0],100*n,100*r]},o.hcg.hwb=function(t){var e=t[1]/100,r=e+t[2]/100*(1-e);return[t[0],100*(r-e),100*(1-r)]},o.hwb.hcg=function(t){var e=t[1]/100,r=1-t[2]/100,n=r-e,i=0;return n<1&&(i=(r-n)/(1-n)),[t[0],100*n,100*i]},o.apple.rgb=function(t){return[t[0]/65535*255,t[1]/65535*255,t[2]/65535*255]},o.rgb.apple=function(t){return[t[0]/255*65535,t[1]/255*65535,t[2]/255*65535]},o.gray.rgb=function(t){return[t[0]/100*255,t[0]/100*255,t[0]/100*255]},o.gray.hsl=o.gray.hsv=function(t){return[0,0,t[0]]},o.gray.hwb=function(t){return[0,100,t[0]]},o.gray.cmyk=function(t){return[0,0,0,t[0]]},o.gray.lab=function(t){return[t[0],0,0]},o.gray.hex=function(t){var e=255&Math.round(t[0]/100*255),r=((e<<16)+(e<<8)+e).toString(16).toUpperCase();return"000000".substring(r.length)+r},o.rgb.gray=function(t){return[(t[0]+t[1]+t[2])/3/255*100]}},734:(t,e,r)=>{var n=r(659),i=r(507),a={};Object.keys(n).forEach((function(t){a[t]={},Object.defineProperty(a[t],"channels",{value:n[t].channels}),Object.defineProperty(a[t],"labels",{value:n[t].labels});var e=i(t);Object.keys(e).forEach((function(r){var n=e[r];a[t][r]=function(t){var e=function(e){if(null==e)return e;arguments.length>1&&(e=Array.prototype.slice.call(arguments));var r=t(e);if("object"==typeof r)for(var n=r.length,i=0;i<n;i++)r[i]=Math.round(r[i]);return r};return"conversion"in t&&(e.conversion=t.conversion),e}(n),a[t][r].raw=function(t){var e=function(e){return null==e?e:(arguments.length>1&&(e=Array.prototype.slice.call(arguments)),t(e))};return"conversion"in t&&(e.conversion=t.conversion),e}(n)}))})),t.exports=a},794:t=>{"use strict";function e(t,e,r){this.x1=t,this.x2=e,this.weights=r||{},this.weights.lightness=this.weights.lightness||1,this.weights.chroma=this.weights.chroma||1,this.weights.hue=this.weights.hue||1,1===this.weights.lightness?(this.weights.K1=.045,this.weights.K2=.015):(this.weights.K1=.048,this.weights.K2=.014)}e.prototype.getDeltaE=function(){var t=this.x1,e=this.x2,r=Math.sqrt,n=Math.pow;return r(n(this.calculateL(t,e),2)+n(this.calculateA(t,e),2)+n(this.calculateB(t,e),2))},e.prototype.calculateL=function(t,e){return(t.L-e.L)/this.weights.lightness},e.prototype.calculateA=function(t,e){var r=Math.sqrt,n=Math.pow,i=r(n(t.A,2)+n(t.B,2)),a=i-r(n(e.A,2)+n(e.B,2)),o=1+this.weights.K1*i;return a/(this.weights.chroma*o)},e.prototype.calculateB=function(t,e){var r=Math.sqrt,n=Math.pow,i=r(n(t.A,2)+n(t.B,2))-r(n(e.A,2)+n(e.B,2)),a=t.A-e.A,o=t.B-e.B,s=r(n(a,2)+n(o,2)-n(i,2)),l=r(n(t.A,2)+n(t.B,2));return s/(1+this.weights.K2*l)},t.exports=e},962:(t,e,r)=>{const n=r(415),i=r(997),a=r(76),o=r(220),s=r(315),l=r(335);t.exports=({image:t,colors:e,formula:r="E00",deltaE:u=2.3}={},f)=>{if(f&&"function"!=typeof f)throw new s("PARAMETER_INVALID","callback");return new Promise(((h,c)=>{if(f=f||((t,e)=>t?c(t):h(e)),!t)return f(new s("PARAMETER_REQUIRED","options.image"));const d=l(e);return d?f(new s(d.code,d.field)):"string"==typeof r&&["E76","E94","E00"].includes(r)?a(u)&&u>=0&&u<=100?void o.read(t).then((t=>{const a=n(e.type,"lab",e.targetColor),o=n(e.type,"rgb",e.replaceColor);t.scan(0,0,t.bitmap.width,t.bitmap.height,((e,s,l)=>{const f=n("rgb","lab",[t.bitmap.data[l],t.bitmap.data[l+1],t.bitmap.data[l+2]]);i(f,a,r)<=u&&(t.bitmap.data[l]=o[0],t.bitmap.data[l+1]=o[1],t.bitmap.data[l+2]=o[2],null!==o[3]&&(t.bitmap.data[l+3]=o[3]))})),f(null,t)})).catch(f):f(new s("PARAMETER_INVALID","options.deltaE")):f(new s("PARAMETER_INVALID","options.formula"))}))}},997:(t,e,r)=>{const n=r(54);t.exports=(t,e,r)=>n[`getDelta${r}`]({L:t[0],A:t[1],B:t[2]},{L:e[0],A:e[1],B:e[2]})}},e={};function r(n){var i=e[n];if(void 0!==i)return i.exports;var a=e[n]={exports:{}};return t[n](a,a.exports,r),a.exports}r.n=t=>{var e=t&&t.__esModule?()=>t.default:()=>t;return r.d(e,{a:e}),e},r.d=(t,e)=>{for(var n in e)r.o(e,n)&&!r.o(t,n)&&Object.defineProperty(t,n,{enumerable:!0,get:e[n]})},r.g=function(){if("object"==typeof globalThis)return globalThis;try{return this||new Function("return this")()}catch(t){if("object"==typeof window)return window}}(),r.o=(t,e)=>Object.prototype.hasOwnProperty.call(t,e),r.r=t=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})};var n={};return(()=>{"use strict";r.r(n),r.d(n,{replace_color:()=>e});var t=r(133),e=r.n(t)()})(),n})()));
//# sourceMappingURL=assets\customizer\Scripts\libs\replace_color\replace_color.js.map
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var ArrayHelper;
(function (ArrayHelper) {
    function match(array1, array2) {
        for (var _i = 0, array1_1 = array1; _i < array1_1.length; _i++) {
            var item = array1_1[_i];
            if (array2.indexOf(item) == -1) {
                return false;
            }
        }
        return true;
    }
    ArrayHelper.match = match;
})(ArrayHelper || (ArrayHelper = {}));
var DateHelper;
(function (DateHelper) {
    function fromJsonToDate(str) {
        if (str == null)
            return null;
        var ticks = /-?\d+/.exec(str)[0];
        var d = new Date(parseInt(ticks));
        return d;
    }
    DateHelper.fromJsonToDate = fromJsonToDate;
})(DateHelper || (DateHelper = {}));
var StringHelper;
(function (StringHelper) {
    function padLeft(str, width, char) {
        var newStr = str.toString();
        for (var i = 0; i < width - newStr.length; i++)
            newStr = char + newStr;
        return newStr;
    }
    StringHelper.padLeft = padLeft;
    function padRight(str, width, char) {
        var newStr = str.toString();
        for (var i = 0; i < width - newStr.length; i++)
            newStr = newStr + char;
        return newStr;
    }
    StringHelper.padRight = padRight;
    function format(str) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return args.reduce(function (prev, current, idx) { return prev.replace("{".concat(idx, "}"), current); }, str);
    }
    StringHelper.format = format;
    function rgbToHex(r, g, b) {
        return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
    }
    StringHelper.rgbToHex = rgbToHex;
    function hex2rgb(c) {
        var c = c.substring(1); // strip #
        var rgb = parseInt(c, 16); // convert rrggbb to decimal
        var r = (rgb >> 16) & 0xff; // extract red
        var g = (rgb >> 8) & 0xff; // extract green
        var b = (rgb >> 0) & 0xff; // extract blue
        return [r, g, b];
    }
    StringHelper.hex2rgb = hex2rgb;
    function rgbToHexArray(rgb) {
        var r = rgb[0];
        var g = rgb[1];
        var b = rgb[2];
        return rgbToHex(r, g, b);
    }
    StringHelper.rgbToHexArray = rgbToHexArray;
    //RGB to Decimal Array RGB (eg. rgb(0,0,0) ==> [0,0,0])
    function rgbCssToArray(rgbCss) {
        if (!rgbCss.startsWith('rgb'))
            return [255, 255, 255];
        if (rgbCss.startsWith('rgba')) {
            var rgbArr = rgbCss.substring(5, rgbCss.lastIndexOf(",")).split(",");
            return [parseInt(rgbArr[0]), parseInt(rgbArr[1]), parseInt(rgbArr[2])];
        }
        else {
            var rgbArr = rgbCss.substring(4, rgbCss.lastIndexOf(")")).split(",");
            return [parseInt(rgbArr[0]), parseInt(rgbArr[1]), parseInt(rgbArr[2])];
        }
    }
    StringHelper.rgbCssToArray = rgbCssToArray;
    // RGB to HEX string (eg. rgb(0,0,0) ==> #000000)
    function rgbToHexCss(rgbCss) {
        if (!rgbCss.startsWith('rgb'))
            return '#ffffff';
        if (rgbCss.startsWith('rgba')) {
            var rgbArr = rgbCss.substring(5, rgbCss.lastIndexOf(",")).split(",");
            return rgbToHex(parseInt(rgbArr[0]), parseInt(rgbArr[1]), parseInt(rgbArr[2]));
        }
        else {
            var rgbArr = rgbCss.substring(4, rgbCss.lastIndexOf(")")).split(",");
            return rgbToHex(parseInt(rgbArr[0]), parseInt(rgbArr[1]), parseInt(rgbArr[2]));
        }
    }
    StringHelper.rgbToHexCss = rgbToHexCss;
    function componentToHex(c) {
        var hex = c.toString(16);
        return hex.length == 1 ? "0" + hex : hex;
    }
})(StringHelper || (StringHelper = {}));
var ValidationHelper;
(function (ValidationHelper) {
    ValidationHelper.EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    ValidationHelper.NFT_WALLET_ADDRESS_REGEX = /^0x[a-fA-F0-9]{40}$/;
    ValidationHelper.checkEmail = function (email) {
        return ValidationHelper.EMAIL_REGEX.test(email);
    };
    ValidationHelper.checkNFTWalletAddress = function (address) {
        return ValidationHelper.NFT_WALLET_ADDRESS_REGEX.test(address);
    };
})(ValidationHelper || (ValidationHelper = {}));
var Pagination;
(function (Pagination) {
    function nextPage(headerLink) {
        var matches = /.*<(.*)>; rel="next".*/.exec(headerLink);
        if (!matches) {
            return null;
        }
        return matches[1];
    }
    Pagination.nextPage = nextPage;
})(Pagination || (Pagination = {}));
var Browser;
(function (Browser) {
    function openWindow(url, width, height) {
        return window.open(url, "width=" + width + ",height=" + height + ";menubar=no,location=no,status=no,toolbar=no");
    }
    Browser.openWindow = openWindow;
})(Browser || (Browser = {}));
var Logger;
(function (Logger) {
    function info() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (typeof window == "undefined")
            return;
        if (window.location.href.indexOf("localhost") != -1 || window.location.href.indexOf("test-portal.zakeke.com") != -1)
            console.log.apply(window, args);
    }
    Logger.info = info;
    function error() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (typeof window == "undefined")
            return;
        console.error.apply(window, args);
    }
    Logger.error = error;
})(Logger || (Logger = {}));
var BlobHelpers;
(function (BlobHelpers) {
    function b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;
        var byteCharacters = atob(b64Data);
        var byteArrays = [];
        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);
            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }
    BlobHelpers.b64toBlob = b64toBlob;
    function blobTob64(blob) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) {
                        var a = new FileReader();
                        a.onload = function (e) { resolve(e.target.result); };
                        a.readAsDataURL(blob);
                    })];
            });
        });
    }
    BlobHelpers.blobTob64 = blobTob64;
})(BlobHelpers || (BlobHelpers = {}));
var ImageColorHelpers;
(function (ImageColorHelpers) {
    // Color difference (color input in rgb(x,y,z) or rgba(x,y,z) format)
    function deltaE(rgbA, rgbB) {
        var rgbA_arr = StringHelper.rgbCssToArray(rgbA);
        var rgbB_arr = StringHelper.rgbCssToArray(rgbB);
        var labA = rgb2lab(rgbA_arr);
        var labB = rgb2lab(rgbB_arr);
        var deltaL = labA[0] - labB[0];
        var deltaA = labA[1] - labB[1];
        var deltaB = labA[2] - labB[2];
        var c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
        var c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
        var deltaC = c1 - c2;
        var deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
        deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
        var sc = 1.0 + 0.045 * c1;
        var sh = 1.0 + 0.015 * c1;
        var deltaLKlsl = deltaL / (1.0);
        var deltaCkcsc = deltaC / (sc);
        var deltaHkhsh = deltaH / (sh);
        var i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
        return i < 0 ? 0 : Math.sqrt(i);
    }
    function rgb2lab(rgb) {
        var r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, x, y, z;
        r = (r > 0.04045) ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
        g = (g > 0.04045) ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
        b = (b > 0.04045) ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
        x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
        y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.00000;
        z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
        x = (x > 0.008856) ? Math.pow(x, 1 / 3) : (7.787 * x) + 16 / 116;
        y = (y > 0.008856) ? Math.pow(y, 1 / 3) : (7.787 * y) + 16 / 116;
        z = (z > 0.008856) ? Math.pow(z, 1 / 3) : (7.787 * z) + 16 / 116;
        return [(116 * y) - 16, 500 * (x - y), 200 * (y - z)];
    }
    // Replace colors into a raster image 
    // imageBuffer: image bytes
    // hexTargetColor: HEX Colors list of image to replace
    // hexNewColor: new replacement HEX colors list for image
    // deltaE:  value which corresponds to a JND (just noticeable difference). The default value is 2.3
    function ReplaceColorImage(imageBuffer, hexTargetColor, hexNewColor, deltaE) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            // Substitution colors and upload
            replaceColorLib.replace_color({
                image: imageBuffer,
                colors: {
                    type: 'hex',
                    targetColor: hexTargetColor,
                    replaceColor: hexNewColor
                },
                deltaE: deltaE ? deltaE : 2.3
            })
                .then(function (jimpObj) { return __awaiter(_this, void 0, void 0, function () {
                var bufferImageConverted;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, jimpObj.getBufferAsync(jimpObj.getMIME())];
                        case 1:
                            bufferImageConverted = _a.sent();
                            resolve(bufferImageConverted);
                            return [2 /*return*/];
                    }
                });
            }); })
                .catch(function (err) {
                console.log(err);
                reject(err);
            });
        });
    }
    // Get colors in an array of hex codes from a Base64 code image
    // b6image: image in base64 format
    // threshold: number for JND needed to recognize colors
    // minPercOccurrences: limit percentage of color occurrences found
    function GetColorsFromImageB64(b64image, threshold, minPercOccurrences, scale) {
        return __awaiter(this, void 0, void 0, function () {
            var palette, grabColors, minPercOccurrencesColors, numberColorsFound, _loop_1, i, grabColorsHex;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, rgbAsterLib.rgbAster(b64image, { scale: scale ? scale : 1 })];
                    case 1:
                        palette = _a.sent();
                        grabColors = [];
                        minPercOccurrencesColors = (minPercOccurrences) || 10;
                        numberColorsFound = 0;
                        palette.forEach(function (colorfound, i) {
                            if (!colorfound.color.startsWith('rgba'))
                                numberColorsFound += colorfound.count;
                        });
                        _loop_1 = function (i) {
                            var percColorsOccurrences = (100 * palette[i].count) / numberColorsFound;
                            if ((percColorsOccurrences <= minPercOccurrencesColors) || palette[i].color.startsWith('rgba'))
                                return "continue";
                            var isValid = true;
                            if (grabColors.length > 0) {
                                grabColors.forEach(function (color, index) {
                                    if (deltaE(color, palette[i].color) < threshold)
                                        isValid = false;
                                });
                            }
                            if (isValid) {
                                grabColors.push(palette[i].color);
                            }
                        };
                        for (i = 0; i < palette.length; i++) {
                            _loop_1(i);
                        }
                        grabColorsHex = grabColors.map(function (color) { return StringHelper.rgbToHexCss(color); });
                        return [2 /*return*/, grabColorsHex];
                }
            });
        });
    }
    ImageColorHelpers.GetColorsFromImageB64 = GetColorsFromImageB64;
    function GetColorsFromImageUrl(imageUrl, threshold, minPercOccurrences, scale) {
        return __awaiter(this, void 0, void 0, function () {
            var palette, grabColors, minPercOccurrencesColors, numberColorsFound, _loop_2, i, grabColorsHex;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, rgbAsterLib.rgbAster(imageUrl, { scale: scale ? scale : 1 })];
                    case 1:
                        palette = _a.sent();
                        grabColors = [];
                        minPercOccurrencesColors = (minPercOccurrences) || 10;
                        numberColorsFound = 0;
                        palette.forEach(function (colorfound, i) {
                            if (!colorfound.color.startsWith('rgba'))
                                numberColorsFound += colorfound.count;
                        });
                        _loop_2 = function (i) {
                            var percColorsOccurrences = (100 * palette[i].count) / numberColorsFound;
                            if ((percColorsOccurrences <= minPercOccurrencesColors) || palette[i].color.startsWith('rgba'))
                                return "continue";
                            var isValid = true;
                            if (grabColors.length > 0) {
                                grabColors.forEach(function (color, index) {
                                    if (deltaE(color, palette[i].color) < threshold)
                                        isValid = false;
                                });
                            }
                            if (isValid) {
                                grabColors.push(palette[i].color);
                            }
                        };
                        for (i = 0; i < palette.length; i++) {
                            _loop_2(i);
                        }
                        grabColorsHex = grabColors.map(function (color) { return StringHelper.rgbToHexCss(color); });
                        return [2 /*return*/, grabColorsHex];
                }
            });
        });
    }
    ImageColorHelpers.GetColorsFromImageUrl = GetColorsFromImageUrl;
    // Recoloring image
    function ReplaceColorsIntoImage(file, hexSourceColors, hexNewColors, threshold) {
        return __awaiter(this, void 0, void 0, function () {
            var bufferImageConverted, indx;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        bufferImageConverted = file;
                        indx = 0;
                        _a.label = 1;
                    case 1:
                        if (!(indx < hexSourceColors.length)) return [3 /*break*/, 4];
                        return [4 /*yield*/, ReplaceColorImage(bufferImageConverted, hexSourceColors[indx], hexNewColors[indx % hexNewColors.length], threshold)];
                    case 2:
                        bufferImageConverted = _a.sent();
                        _a.label = 3;
                    case 3:
                        indx++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/, new Blob([bufferImageConverted])];
                }
            });
        });
    }
    ImageColorHelpers.ReplaceColorsIntoImage = ReplaceColorsIntoImage;
})(ImageColorHelpers || (ImageColorHelpers = {}));

(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.sanitizeHtml = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

var htmlparser = require('htmlparser2');
var extend = require('xtend');
var quoteRegexp = require('lodash.escaperegexp');
var cloneDeep = require('lodash.clonedeep');
var mergeWith = require('lodash.mergewith');
var isString = require('lodash.isstring');
var isPlainObject = require('lodash.isplainobject');
var srcset = require('srcset');
var postcss = require('postcss');
var url = require('url');

function each(obj, cb) {
  if (obj) Object.keys(obj).forEach(function (key) {
    cb(obj[key], key);
  });
}

// Avoid false positives with .__proto__, .hasOwnProperty, etc.
function has(obj, key) {
  return {}.hasOwnProperty.call(obj, key);
}

// Returns those elements of `a` for which `cb(a)` returns truthy
function filter(a, cb) {
  var n = [];
  each(a, function (v) {
    if (cb(v)) {
      n.push(v);
    }
  });
  return n;
}

module.exports = sanitizeHtml;

// A valid attribute name.
// We use a tolerant definition based on the set of strings defined by
// html.spec.whatwg.org/multipage/parsing.html#before-attribute-name-state
// and html.spec.whatwg.org/multipage/parsing.html#attribute-name-state .
// The characters accepted are ones which can be appended to the attribute
// name buffer without triggering a parse error:
//   * unexpected-equals-sign-before-attribute-name
//   * unexpected-null-character
//   * unexpected-character-in-attribute-name
// We exclude the empty string because it's impossible to get to the after
// attribute name state with an empty attribute name buffer.
var VALID_HTML_ATTRIBUTE_NAME = /^[^\0\t\n\f\r /<=>]+$/;

// Ignore the _recursing flag; it's there for recursive
// invocation as a guard against this exploit:
// https://github.com/fb55/htmlparser2/issues/105

function sanitizeHtml(html, options, _recursing) {
  var result = '';

  function Frame(tag, attribs) {
    var that = this;
    this.tag = tag;
    this.attribs = attribs || {};
    this.tagPosition = result.length;
    this.text = ''; // Node inner text

    this.updateParentNodeText = function () {
      if (stack.length) {
        var parentFrame = stack[stack.length - 1];
        parentFrame.text += that.text;
      }
    };
  }

  if (!options) {
    options = sanitizeHtml.defaults;
    options.parser = htmlParserDefaults;
  } else {
    options = extend(sanitizeHtml.defaults, options);
    if (options.parser) {
      options.parser = extend(htmlParserDefaults, options.parser);
    } else {
      options.parser = htmlParserDefaults;
    }
  }

  // Tags that contain something other than HTML, or where discarding
  // the text when the tag is disallowed makes sense for other reasons.
  // If we are not allowing these tags, we should drop their content too.
  // For other tags you would drop the tag but keep its content.
  var nonTextTagsArray = options.nonTextTags || ['script', 'style', 'textarea'];
  var allowedAttributesMap;
  var allowedAttributesGlobMap;
  if (options.allowedAttributes) {
    allowedAttributesMap = {};
    allowedAttributesGlobMap = {};
    each(options.allowedAttributes, function (attributes, tag) {
      allowedAttributesMap[tag] = [];
      var globRegex = [];
      attributes.forEach(function (obj) {
        if (isString(obj) && obj.indexOf('*') >= 0) {
          globRegex.push(quoteRegexp(obj).replace(/\\\*/g, '.*'));
        } else {
          allowedAttributesMap[tag].push(obj);
        }
      });
      allowedAttributesGlobMap[tag] = new RegExp('^(' + globRegex.join('|') + ')$');
    });
  }
  var allowedClassesMap = {};
  each(options.allowedClasses, function (classes, tag) {
    // Implicitly allows the class attribute
    if (allowedAttributesMap) {
      if (!has(allowedAttributesMap, tag)) {
        allowedAttributesMap[tag] = [];
      }
      allowedAttributesMap[tag].push('class');
    }

    allowedClassesMap[tag] = classes;
  });

  var transformTagsMap = {};
  var transformTagsAll;
  each(options.transformTags, function (transform, tag) {
    var transFun;
    if (typeof transform === 'function') {
      transFun = transform;
    } else if (typeof transform === "string") {
      transFun = sanitizeHtml.simpleTransform(transform);
    }
    if (tag === '*') {
      transformTagsAll = transFun;
    } else {
      transformTagsMap[tag] = transFun;
    }
  });

  var depth = 0;
  var stack = [];
  var skipMap = {};
  var transformMap = {};
  var skipText = false;
  var skipTextDepth = 0;

  var parser = new htmlparser.Parser({
    onopentag: function onopentag(name, attribs) {
      if (skipText) {
        skipTextDepth++;
        return;
      }
      var frame = new Frame(name, attribs);
      stack.push(frame);

      var skip = false;
      var hasText = frame.text ? true : false;
      var transformedTag;
      if (has(transformTagsMap, name)) {
        transformedTag = transformTagsMap[name](name, attribs);

        frame.attribs = attribs = transformedTag.attribs;

        if (transformedTag.text !== undefined) {
          frame.innerText = transformedTag.text;
        }

        if (name !== transformedTag.tagName) {
          frame.name = name = transformedTag.tagName;
          transformMap[depth] = transformedTag.tagName;
        }
      }
      if (transformTagsAll) {
        transformedTag = transformTagsAll(name, attribs);

        frame.attribs = attribs = transformedTag.attribs;
        if (name !== transformedTag.tagName) {
          frame.name = name = transformedTag.tagName;
          transformMap[depth] = transformedTag.tagName;
        }
      }

      if (options.allowedTags && options.allowedTags.indexOf(name) === -1) {
        skip = true;
        if (nonTextTagsArray.indexOf(name) !== -1) {
          skipText = true;
          skipTextDepth = 1;
        }
        skipMap[depth] = true;
      }
      depth++;
      if (skip) {
        // We want the contents but not this tag
        return;
      }
      result += '<' + name;
      if (!allowedAttributesMap || has(allowedAttributesMap, name) || allowedAttributesMap['*']) {
        each(attribs, function (value, a) {
          if (!VALID_HTML_ATTRIBUTE_NAME.test(a)) {
            // This prevents part of an attribute name in the output from being
            // interpreted as the end of an attribute, or end of a tag.
            delete frame.attribs[a];
            return;
          }
          var parsed;
          // check allowedAttributesMap for the element and attribute and modify the value
          // as necessary if there are specific values defined.
          var passedAllowedAttributesMapCheck = false;
          if (!allowedAttributesMap || has(allowedAttributesMap, name) && allowedAttributesMap[name].indexOf(a) !== -1 || allowedAttributesMap['*'] && allowedAttributesMap['*'].indexOf(a) !== -1 || has(allowedAttributesGlobMap, name) && allowedAttributesGlobMap[name].test(a) || allowedAttributesGlobMap['*'] && allowedAttributesGlobMap['*'].test(a)) {
            passedAllowedAttributesMapCheck = true;
          } else if (allowedAttributesMap && allowedAttributesMap[name]) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = allowedAttributesMap[name][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var o = _step.value;

                if (isPlainObject(o) && o.name && o.name === a) {
                  passedAllowedAttributesMapCheck = true;
                  var newValue = '';
                  if (o.multiple === true) {
                    // verify the values that are allowed
                    var splitStrArray = value.split(' ');
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                      for (var _iterator2 = splitStrArray[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var s = _step2.value;

                        if (o.values.indexOf(s) !== -1) {
                          if (newValue === '') {
                            newValue = s;
                          } else {
                            newValue += ' ' + s;
                          }
                        }
                      }
                    } catch (err) {
                      _didIteratorError2 = true;
                      _iteratorError2 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                          _iterator2.return();
                        }
                      } finally {
                        if (_didIteratorError2) {
                          throw _iteratorError2;
                        }
                      }
                    }
                  } else if (o.values.indexOf(value) >= 0) {
                    // verified an allowed value matches the entire attribute value
                    newValue = value;
                  }
                  value = newValue;
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          }
          if (passedAllowedAttributesMapCheck) {
            if (options.allowedSchemesAppliedToAttributes.indexOf(a) !== -1) {
              if (naughtyHref(name, value)) {
                delete frame.attribs[a];
                return;
              }
            }
            if (name === 'iframe' && a === 'src') {
              var allowed = true;
              try {
                // naughtyHref is in charge of whether protocol relative URLs
                // are cool. We should just accept them
                parsed = url.parse(value, false, true);
                var isRelativeUrl = parsed && parsed.host === null && parsed.protocol === null;
                if (isRelativeUrl) {
                  // default value of allowIframeRelativeUrls is true unless allowIframeHostnames specified
                  allowed = has(options, "allowIframeRelativeUrls") ? options.allowIframeRelativeUrls : !options.allowedIframeHostnames;
                } else if (options.allowedIframeHostnames) {
                  allowed = options.allowedIframeHostnames.find(function (hostname) {
                    return hostname === parsed.hostname;
                  });
                }
              } catch (e) {
                // Unparseable iframe src
                allowed = false;
              }
              if (!allowed) {
                delete frame.attribs[a];
                return;
              }
            }
            if (a === 'srcset') {
              try {
                parsed = srcset.parse(value);
                each(parsed, function (value) {
                  if (naughtyHref('srcset', value.url)) {
                    value.evil = true;
                  }
                });
                parsed = filter(parsed, function (v) {
                  return !v.evil;
                });
                if (!parsed.length) {
                  delete frame.attribs[a];
                  return;
                } else {
                  value = srcset.stringify(filter(parsed, function (v) {
                    return !v.evil;
                  }));
                  frame.attribs[a] = value;
                }
              } catch (e) {
                // Unparseable srcset
                delete frame.attribs[a];
                return;
              }
            }
            if (a === 'class') {
              value = filterClasses(value, allowedClassesMap[name]);
              if (!value.length) {
                delete frame.attribs[a];
                return;
              }
            }
            if (a === 'style') {
              try {
                var abstractSyntaxTree = postcss.parse(name + " {" + value + "}");
                var filteredAST = filterCss(abstractSyntaxTree, options.allowedStyles);

                value = stringifyStyleAttributes(filteredAST);

                if (value.length === 0) {
                  delete frame.attribs[a];
                  return;
                }
              } catch (e) {
                delete frame.attribs[a];
                return;
              }
            }
            result += ' ' + a;
            if (value.length) {
              result += '="' + escapeHtml(value, true) + '"';
            }
          } else {
            delete frame.attribs[a];
          }
        });
      }
      if (options.selfClosing.indexOf(name) !== -1) {
        result += " />";
      } else {
        result += ">";
        if (frame.innerText && !hasText && !options.textFilter) {
          result += frame.innerText;
        }
      }
    },
    ontext: function ontext(text) {
      if (skipText) {
        return;
      }
      var lastFrame = stack[stack.length - 1];
      var tag;

      if (lastFrame) {
        tag = lastFrame.tag;
        // If inner text was set by transform function then let's use it
        text = lastFrame.innerText !== undefined ? lastFrame.innerText : text;
      }

      if (tag === 'script' || tag === 'style') {
        // htmlparser2 gives us these as-is. Escaping them ruins the content. Allowing
        // script tags is, by definition, game over for XSS protection, so if that's
        // your concern, don't allow them. The same is essentially true for style tags
        // which have their own collection of XSS vectors.
        result += text;
      } else {
        var escaped = escapeHtml(text, false);
        if (options.textFilter) {
          result += options.textFilter(escaped);
        } else {
          result += escaped;
        }
      }
      if (stack.length) {
        var frame = stack[stack.length - 1];
        frame.text += text;
      }
    },
    onclosetag: function onclosetag(name) {

      if (skipText) {
        skipTextDepth--;
        if (!skipTextDepth) {
          skipText = false;
        } else {
          return;
        }
      }

      var frame = stack.pop();
      if (!frame) {
        // Do not crash on bad markup
        return;
      }
      skipText = false;
      depth--;
      if (skipMap[depth]) {
        delete skipMap[depth];
        frame.updateParentNodeText();
        return;
      }

      if (transformMap[depth]) {
        name = transformMap[depth];
        delete transformMap[depth];
      }

      if (options.exclusiveFilter && options.exclusiveFilter(frame)) {
        result = result.substr(0, frame.tagPosition);
        return;
      }

      frame.updateParentNodeText();

      if (options.selfClosing.indexOf(name) !== -1) {
        // Already output />
        return;
      }

      result += "</" + name + ">";
    }
  }, options.parser);
  parser.write(html);
  parser.end();

  return result;

  function escapeHtml(s, quote) {
    if (typeof s !== 'string') {
      s = s + '';
    }
    if (options.parser.decodeEntities) {
      s = s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/\>/g, '&gt;');
      if (quote) {
        s = s.replace(/\"/g, '&quot;');
      }
    }
    // TODO: this is inadequate because it will pass `&0;`. This approach
    // will not work, each & must be considered with regard to whether it
    // is followed by a 100% syntactically valid entity or not, and escaped
    // if it is not. If this bothers you, don't set parser.decodeEntities
    // to false. (The default is true.)
    s = s.replace(/&(?![a-zA-Z0-9#]{1,20};)/g, '&amp;') // Match ampersands not part of existing HTML entity
    .replace(/</g, '&lt;').replace(/\>/g, '&gt;');
    if (quote) {
      s = s.replace(/\"/g, '&quot;');
    }
    return s;
  }

  function naughtyHref(name, href) {
    // Browsers ignore character codes of 32 (space) and below in a surprising
    // number of situations. Start reading here:
    // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet#Embedded_tab
    href = href.replace(/[\x00-\x20]+/g, '');
    // Clobber any comments in URLs, which the browser might
    // interpret inside an XML data island, allowing
    // a javascript: URL to be snuck through
    href = href.replace(/<\!\-\-.*?\-\-\>/g, '');
    // Case insensitive so we don't get faked out by JAVASCRIPT #1
    var matches = href.match(/^([a-zA-Z]+)\:/);
    if (!matches) {
      // Protocol-relative URL starting with any combination of '/' and '\'
      if (href.match(/^[\/\\]{2}/)) {
        return !options.allowProtocolRelative;
      }

      // No scheme
      return false;
    }
    var scheme = matches[1].toLowerCase();

    if (has(options.allowedSchemesByTag, name)) {
      return options.allowedSchemesByTag[name].indexOf(scheme) === -1;
    }

    return !options.allowedSchemes || options.allowedSchemes.indexOf(scheme) === -1;
  }

  /**
   * Filters user input css properties by whitelisted regex attributes.
   *
   * @param {object} abstractSyntaxTree  - Object representation of CSS attributes.
   * @property {array[Declaration]} abstractSyntaxTree.nodes[0] - Each object cointains prop and value key, i.e { prop: 'color', value: 'red' }.
   * @param {object} allowedStyles       - Keys are properties (i.e color), value is list of permitted regex rules (i.e /green/i).
   * @return {object}                    - Abstract Syntax Tree with filtered style attributes.
   */
  function filterCss(abstractSyntaxTree, allowedStyles) {
    if (!allowedStyles) {
      return abstractSyntaxTree;
    }

    var filteredAST = cloneDeep(abstractSyntaxTree);
    var astRules = abstractSyntaxTree.nodes[0];
    var selectedRule;

    // Merge global and tag-specific styles into new AST.
    if (allowedStyles[astRules.selector] && allowedStyles['*']) {
      selectedRule = mergeWith(cloneDeep(allowedStyles[astRules.selector]), allowedStyles['*'], function (objValue, srcValue) {
        if (Array.isArray(objValue)) {
          return objValue.concat(srcValue);
        }
      });
    } else {
      selectedRule = allowedStyles[astRules.selector] || allowedStyles['*'];
    }

    if (selectedRule) {
      filteredAST.nodes[0].nodes = astRules.nodes.reduce(filterDeclarations(selectedRule), []);
    }

    return filteredAST;
  }

  /**
   * Extracts the style attribues from an AbstractSyntaxTree and formats those
   * values in the inline style attribute format.
   *
   * @param  {AbstractSyntaxTree} filteredAST
   * @return {string}             - Example: "color:yellow;text-align:center;font-family:helvetica;"
   */
  function stringifyStyleAttributes(filteredAST) {
    return filteredAST.nodes[0].nodes.reduce(function (extractedAttributes, attributeObject) {
      extractedAttributes.push(attributeObject.prop + ':' + attributeObject.value);
      return extractedAttributes;
    }, []).join(';');
  }

  /**
    * Filters the existing attributes for the given property. Discards any attributes
    * which don't match the whitelist.
    *
    * @param  {object} selectedRule             - Example: { color: red, font-family: helvetica }
    * @param  {array} allowedDeclarationsList   - List of declarations which pass whitelisting.
    * @param  {object} attributeObject          - Object representing the current css property.
    * @property {string} attributeObject.type   - Typically 'declaration'.
    * @property {string} attributeObject.prop   - The CSS property, i.e 'color'.
    * @property {string} attributeObject.value  - The corresponding value to the css property, i.e 'red'.
    * @return {function}                        - When used in Array.reduce, will return an array of Declaration objects
    */
  function filterDeclarations(selectedRule) {
    return function (allowedDeclarationsList, attributeObject) {
      // If this property is whitelisted...
      if (selectedRule.hasOwnProperty(attributeObject.prop)) {
        var matchesRegex = selectedRule[attributeObject.prop].some(function (regularExpression) {
          return regularExpression.test(attributeObject.value);
        });

        if (matchesRegex) {
          allowedDeclarationsList.push(attributeObject);
        }
      }
      return allowedDeclarationsList;
    };
  }

  function filterClasses(classes, allowed) {
    if (!allowed) {
      // The class attribute is allowed without filtering on this tag
      return classes;
    }
    classes = classes.split(/\s+/);
    return classes.filter(function (clss) {
      return allowed.indexOf(clss) !== -1;
    }).join(' ');
  }
}

// Defaults are accessible to you so that you can use them as a starting point
// programmatically if you wish

var htmlParserDefaults = {
  decodeEntities: true
};
sanitizeHtml.defaults = {
  allowedTags: ['h3', 'h4', 'h5', 'h6', 'blockquote', 'p', 'a', 'ul', 'ol', 'nl', 'li', 'b', 'i', 'strong', 'em', 'strike', 'code', 'hr', 'br', 'div', 'table', 'thead', 'caption', 'tbody', 'tr', 'th', 'td', 'pre', 'iframe'],
  allowedAttributes: {
    a: ['href', 'name', 'target'],
    // We don't currently allow img itself by default, but this
    // would make sense if we did. You could add srcset here,
    // and if you do the URL is checked for safety
    img: ['src']
  },
  // Lots of these won't come up by default because we don't allow them
  selfClosing: ['img', 'br', 'hr', 'area', 'base', 'basefont', 'input', 'link', 'meta'],
  // URL schemes we permit
  allowedSchemes: ['http', 'https', 'ftp', 'mailto'],
  allowedSchemesByTag: {},
  allowedSchemesAppliedToAttributes: ['href', 'src', 'cite'],
  allowProtocolRelative: true
};

sanitizeHtml.simpleTransform = function (newTagName, newAttribs, merge) {
  merge = merge === undefined ? true : merge;
  newAttribs = newAttribs || {};

  return function (tagName, attribs) {
    var attrib;
    if (merge) {
      for (attrib in newAttribs) {
        attribs[attrib] = newAttribs[attrib];
      }
    } else {
      attribs = newAttribs;
    }

    return {
      tagName: newTagName,
      attribs: attribs
    };
  };
};
},{"htmlparser2":34,"lodash.clonedeep":37,"lodash.escaperegexp":38,"lodash.isplainobject":39,"lodash.isstring":40,"lodash.mergewith":41,"postcss":56,"srcset":85,"url":87,"xtend":89}],2:[function(require,module,exports){
(function (global){
'use strict';

// there's 3 implementations written in increasing order of efficiency

// 1 - no Set type is defined
function uniqNoSet(arr) {
	var ret = [];

	for (var i = 0; i < arr.length; i++) {
		if (ret.indexOf(arr[i]) === -1) {
			ret.push(arr[i]);
		}
	}

	return ret;
}

// 2 - a simple Set type is defined
function uniqSet(arr) {
	var seen = new Set();
	return arr.filter(function (el) {
		if (!seen.has(el)) {
			seen.add(el);
			return true;
		}

		return false;
	});
}

// 3 - a standard Set type is defined and it has a forEach method
function uniqSetWithForEach(arr) {
	var ret = [];

	(new Set(arr)).forEach(function (el) {
		ret.push(el);
	});

	return ret;
}

// V8 currently has a broken implementation
// https://github.com/joyent/node/issues/8449
function doesForEachActuallyWork() {
	var ret = false;

	(new Set([true])).forEach(function (el) {
		ret = el;
	});

	return ret === true;
}

if ('Set' in global) {
	if (typeof Set.prototype.forEach === 'function' && doesForEachActuallyWork()) {
		module.exports = uniqSetWithForEach;
	} else {
		module.exports = uniqSet;
	}
} else {
	module.exports = uniqNoSet;
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],3:[function(require,module,exports){
'use strict'

exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  for (var i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}

},{}],4:[function(require,module,exports){

},{}],5:[function(require,module,exports){
(function (Buffer){
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */

'use strict'

var base64 = require('base64-js')
var ieee754 = require('ieee754')

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

var K_MAX_LENGTH = 0x7fffffff
exports.kMaxLength = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = { __proto__: Uint8Array.prototype, foo: function () { return 42 } }
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  var buf = new Uint8Array(length)
  buf.__proto__ = Buffer.prototype
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

// Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
if (typeof Symbol !== 'undefined' && Symbol.species != null &&
    Buffer[Symbol.species] === Buffer) {
  Object.defineProperty(Buffer, Symbol.species, {
    value: null,
    configurable: true,
    enumerable: false,
    writable: false
  })
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayLike(value)
  }

  if (value == null) {
    throw TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  var valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  var b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(
      value[Symbol.toPrimitive]('string'), encodingOrOffset, length
    )
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Buffer.prototype.__proto__ = Uint8Array.prototype
Buffer.__proto__ = Uint8Array

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  var length = byteLength(string, encoding) | 0
  var buf = createBuffer(length)

  var actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  var buf = createBuffer(length)
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  var buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  buf.__proto__ = Buffer.prototype
  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    var buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      buf = Buffer.from(buf)
    }
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  var len = string.length
  var mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  var strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
        : (firstByte > 0xBF) ? 2
          : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  newBuf.__proto__ = Buffer.prototype
  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (var i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    var len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

}).call(this,require("buffer").Buffer)
},{"base64-js":3,"buffer":5,"ieee754":35}],6:[function(require,module,exports){
/*
  Module dependencies
*/
var ElementType = require('domelementtype');
var entities = require('entities');

var unencodedElements = {
  __proto__: null,
  style: true,
  script: true,
  xmp: true,
  iframe: true,
  noembed: true,
  noframes: true,
  plaintext: true,
  noscript: true
};

/*
  Format attributes
*/
function formatAttrs(attributes, opts) {
  if (!attributes) return;

  var output = '',
      value;

  // Loop through the attributes
  for (var key in attributes) {
    value = attributes[key];
    if (output) {
      output += ' ';
    }

    output += key;
    if ((value !== null && value !== '') || opts.xmlMode) {
        output += '="' + (opts.decodeEntities ? entities.encodeXML(value) : value) + '"';
    }
  }

  return output;
}

/*
  Self-enclosing tags (stolen from node-htmlparser)
*/
var singleTag = {
  __proto__: null,
  area: true,
  base: true,
  basefont: true,
  br: true,
  col: true,
  command: true,
  embed: true,
  frame: true,
  hr: true,
  img: true,
  input: true,
  isindex: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true,
};


var render = module.exports = function(dom, opts) {
  if (!Array.isArray(dom) && !dom.cheerio) dom = [dom];
  opts = opts || {};

  var output = '';

  for(var i = 0; i < dom.length; i++){
    var elem = dom[i];

    if (elem.type === 'root')
      output += render(elem.children, opts);
    else if (ElementType.isTag(elem))
      output += renderTag(elem, opts);
    else if (elem.type === ElementType.Directive)
      output += renderDirective(elem);
    else if (elem.type === ElementType.Comment)
      output += renderComment(elem);
    else if (elem.type === ElementType.CDATA)
      output += renderCdata(elem);
    else
      output += renderText(elem, opts);
  }

  return output;
};

function renderTag(elem, opts) {
  // Handle SVG
  if (elem.name === "svg") opts = {decodeEntities: opts.decodeEntities, xmlMode: true};

  var tag = '<' + elem.name,
      attribs = formatAttrs(elem.attribs, opts);

  if (attribs) {
    tag += ' ' + attribs;
  }

  if (
    opts.xmlMode
    && (!elem.children || elem.children.length === 0)
  ) {
    tag += '/>';
  } else {
    tag += '>';
    if (elem.children) {
      tag += render(elem.children, opts);
    }

    if (!singleTag[elem.name] || opts.xmlMode) {
      tag += '</' + elem.name + '>';
    }
  }

  return tag;
}

function renderDirective(elem) {
  return '<' + elem.data + '>';
}

function renderText(elem, opts) {
  var data = elem.data || '';

  // if entities weren't decoded, no need to encode them back
  if (opts.decodeEntities && !(elem.parent && elem.parent.name in unencodedElements)) {
    data = entities.encodeXML(data);
  }

  return data;
}

function renderCdata(elem) {
  return '<![CDATA[' + elem.children[0].data + ']]>';
}

function renderComment(elem) {
  return '<!--' + elem.data + '-->';
}

},{"domelementtype":7,"entities":18}],7:[function(require,module,exports){
//Types of elements found in the DOM
module.exports = {
	Text: "text", //Text
	Directive: "directive", //<? ... ?>
	Comment: "comment", //<!-- ... -->
	Script: "script", //<script> tags
	Style: "style", //<style> tags
	Tag: "tag", //Any tag
	CDATA: "cdata", //<![CDATA[ ... ]]>
	Doctype: "doctype",

	isTag: function(elem){
		return elem.type === "tag" || elem.type === "script" || elem.type === "style";
	}
};

},{}],8:[function(require,module,exports){
var ElementType = require("domelementtype");

var re_whitespace = /\s+/g;
var NodePrototype = require("./lib/node");
var ElementPrototype = require("./lib/element");

function DomHandler(callback, options, elementCB){
	if(typeof callback === "object"){
		elementCB = options;
		options = callback;
		callback = null;
	} else if(typeof options === "function"){
		elementCB = options;
		options = defaultOpts;
	}
	this._callback = callback;
	this._options = options || defaultOpts;
	this._elementCB = elementCB;
	this.dom = [];
	this._done = false;
	this._tagStack = [];
	this._parser = this._parser || null;
}

//default options
var defaultOpts = {
	normalizeWhitespace: false, //Replace all whitespace with single spaces
	withStartIndices: false, //Add startIndex properties to nodes
	withEndIndices: false, //Add endIndex properties to nodes
};

DomHandler.prototype.onparserinit = function(parser){
	this._parser = parser;
};

//Resets the handler back to starting state
DomHandler.prototype.onreset = function(){
	DomHandler.call(this, this._callback, this._options, this._elementCB);
};

//Signals the handler that parsing is done
DomHandler.prototype.onend = function(){
	if(this._done) return;
	this._done = true;
	this._parser = null;
	this._handleCallback(null);
};

DomHandler.prototype._handleCallback =
DomHandler.prototype.onerror = function(error){
	if(typeof this._callback === "function"){
		this._callback(error, this.dom);
	} else {
		if(error) throw error;
	}
};

DomHandler.prototype.onclosetag = function(){
	//if(this._tagStack.pop().name !== name) this._handleCallback(Error("Tagname didn't match!"));
	
	var elem = this._tagStack.pop();

	if(this._options.withEndIndices && elem){
		elem.endIndex = this._parser.endIndex;
	}

	if(this._elementCB) this._elementCB(elem);
};

DomHandler.prototype._createDomElement = function(properties){
	if (!this._options.withDomLvl1) return properties;

	var element;
	if (properties.type === "tag") {
		element = Object.create(ElementPrototype);
	} else {
		element = Object.create(NodePrototype);
	}

	for (var key in properties) {
		if (properties.hasOwnProperty(key)) {
			element[key] = properties[key];
		}
	}

	return element;
};

DomHandler.prototype._addDomElement = function(element){
	var parent = this._tagStack[this._tagStack.length - 1];
	var siblings = parent ? parent.children : this.dom;
	var previousSibling = siblings[siblings.length - 1];

	element.next = null;

	if(this._options.withStartIndices){
		element.startIndex = this._parser.startIndex;
	}
	if(this._options.withEndIndices){
		element.endIndex = this._parser.endIndex;
	}

	if(previousSibling){
		element.prev = previousSibling;
		previousSibling.next = element;
	} else {
		element.prev = null;
	}

	siblings.push(element);
	element.parent = parent || null;
};

DomHandler.prototype.onopentag = function(name, attribs){
	var properties = {
		type: name === "script" ? ElementType.Script : name === "style" ? ElementType.Style : ElementType.Tag,
		name: name,
		attribs: attribs,
		children: []
	};

	var element = this._createDomElement(properties);

	this._addDomElement(element);

	this._tagStack.push(element);
};

DomHandler.prototype.ontext = function(data){
	//the ignoreWhitespace is officially dropped, but for now,
	//it's an alias for normalizeWhitespace
	var normalize = this._options.normalizeWhitespace || this._options.ignoreWhitespace;

	var lastTag;

	if(!this._tagStack.length && this.dom.length && (lastTag = this.dom[this.dom.length-1]).type === ElementType.Text){
		if(normalize){
			lastTag.data = (lastTag.data + data).replace(re_whitespace, " ");
		} else {
			lastTag.data += data;
		}
	} else {
		if(
			this._tagStack.length &&
			(lastTag = this._tagStack[this._tagStack.length - 1]) &&
			(lastTag = lastTag.children[lastTag.children.length - 1]) &&
			lastTag.type === ElementType.Text
		){
			if(normalize){
				lastTag.data = (lastTag.data + data).replace(re_whitespace, " ");
			} else {
				lastTag.data += data;
			}
		} else {
			if(normalize){
				data = data.replace(re_whitespace, " ");
			}

			var element = this._createDomElement({
				data: data,
				type: ElementType.Text
			});

			this._addDomElement(element);
		}
	}
};

DomHandler.prototype.oncomment = function(data){
	var lastTag = this._tagStack[this._tagStack.length - 1];

	if(lastTag && lastTag.type === ElementType.Comment){
		lastTag.data += data;
		return;
	}

	var properties = {
		data: data,
		type: ElementType.Comment
	};

	var element = this._createDomElement(properties);

	this._addDomElement(element);
	this._tagStack.push(element);
};

DomHandler.prototype.oncdatastart = function(){
	var properties = {
		children: [{
			data: "",
			type: ElementType.Text
		}],
		type: ElementType.CDATA
	};

	var element = this._createDomElement(properties);

	this._addDomElement(element);
	this._tagStack.push(element);
};

DomHandler.prototype.oncommentend = DomHandler.prototype.oncdataend = function(){
	this._tagStack.pop();
};

DomHandler.prototype.onprocessinginstruction = function(name, data){
	var element = this._createDomElement({
		name: name,
		data: data,
		type: ElementType.Directive
	});

	this._addDomElement(element);
};

module.exports = DomHandler;

},{"./lib/element":9,"./lib/node":10,"domelementtype":7}],9:[function(require,module,exports){
// DOM-Level-1-compliant structure
var NodePrototype = require('./node');
var ElementPrototype = module.exports = Object.create(NodePrototype);

var domLvl1 = {
	tagName: "name"
};

Object.keys(domLvl1).forEach(function(key) {
	var shorthand = domLvl1[key];
	Object.defineProperty(ElementPrototype, key, {
		get: function() {
			return this[shorthand] || null;
		},
		set: function(val) {
			this[shorthand] = val;
			return val;
		}
	});
});

},{"./node":10}],10:[function(require,module,exports){
// This object will be used as the prototype for Nodes when creating a
// DOM-Level-1-compliant structure.
var NodePrototype = module.exports = {
	get firstChild() {
		var children = this.children;
		return children && children[0] || null;
	},
	get lastChild() {
		var children = this.children;
		return children && children[children.length - 1] || null;
	},
	get nodeType() {
		return nodeTypes[this.type] || nodeTypes.element;
	}
};

var domLvl1 = {
	tagName: "name",
	childNodes: "children",
	parentNode: "parent",
	previousSibling: "prev",
	nextSibling: "next",
	nodeValue: "data"
};

var nodeTypes = {
	element: 1,
	text: 3,
	cdata: 4,
	comment: 8
};

Object.keys(domLvl1).forEach(function(key) {
	var shorthand = domLvl1[key];
	Object.defineProperty(NodePrototype, key, {
		get: function() {
			return this[shorthand] || null;
		},
		set: function(val) {
			this[shorthand] = val;
			return val;
		}
	});
});

},{}],11:[function(require,module,exports){
var DomUtils = module.exports;

[
	require("./lib/stringify"),
	require("./lib/traversal"),
	require("./lib/manipulation"),
	require("./lib/querying"),
	require("./lib/legacy"),
	require("./lib/helpers")
].forEach(function(ext){
	Object.keys(ext).forEach(function(key){
		DomUtils[key] = ext[key].bind(DomUtils);
	});
});

},{"./lib/helpers":12,"./lib/legacy":13,"./lib/manipulation":14,"./lib/querying":15,"./lib/stringify":16,"./lib/traversal":17}],12:[function(require,module,exports){
// removeSubsets
// Given an array of nodes, remove any member that is contained by another.
exports.removeSubsets = function(nodes) {
	var idx = nodes.length, node, ancestor, replace;

	// Check if each node (or one of its ancestors) is already contained in the
	// array.
	while (--idx > -1) {
		node = ancestor = nodes[idx];

		// Temporarily remove the node under consideration
		nodes[idx] = null;
		replace = true;

		while (ancestor) {
			if (nodes.indexOf(ancestor) > -1) {
				replace = false;
				nodes.splice(idx, 1);
				break;
			}
			ancestor = ancestor.parent;
		}

		// If the node has been found to be unique, re-insert it.
		if (replace) {
			nodes[idx] = node;
		}
	}

	return nodes;
};

// Source: http://dom.spec.whatwg.org/#dom-node-comparedocumentposition
var POSITION = {
	DISCONNECTED: 1,
	PRECEDING: 2,
	FOLLOWING: 4,
	CONTAINS: 8,
	CONTAINED_BY: 16
};

// Compare the position of one node against another node in any other document.
// The return value is a bitmask with the following values:
//
// document order:
// > There is an ordering, document order, defined on all the nodes in the
// > document corresponding to the order in which the first character of the
// > XML representation of each node occurs in the XML representation of the
// > document after expansion of general entities. Thus, the document element
// > node will be the first node. Element nodes occur before their children.
// > Thus, document order orders element nodes in order of the occurrence of
// > their start-tag in the XML (after expansion of entities). The attribute
// > nodes of an element occur after the element and before its children. The
// > relative order of attribute nodes is implementation-dependent./
// Source:
// http://www.w3.org/TR/DOM-Level-3-Core/glossary.html#dt-document-order
//
// @argument {Node} nodaA The first node to use in the comparison
// @argument {Node} nodeB The second node to use in the comparison
//
// @return {Number} A bitmask describing the input nodes' relative position.
//         See http://dom.spec.whatwg.org/#dom-node-comparedocumentposition for
//         a description of these values.
var comparePos = exports.compareDocumentPosition = function(nodeA, nodeB) {
	var aParents = [];
	var bParents = [];
	var current, sharedParent, siblings, aSibling, bSibling, idx;

	if (nodeA === nodeB) {
		return 0;
	}

	current = nodeA;
	while (current) {
		aParents.unshift(current);
		current = current.parent;
	}
	current = nodeB;
	while (current) {
		bParents.unshift(current);
		current = current.parent;
	}

	idx = 0;
	while (aParents[idx] === bParents[idx]) {
		idx++;
	}

	if (idx === 0) {
		return POSITION.DISCONNECTED;
	}

	sharedParent = aParents[idx - 1];
	siblings = sharedParent.children;
	aSibling = aParents[idx];
	bSibling = bParents[idx];

	if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
		if (sharedParent === nodeB) {
			return POSITION.FOLLOWING | POSITION.CONTAINED_BY;
		}
		return POSITION.FOLLOWING;
	} else {
		if (sharedParent === nodeA) {
			return POSITION.PRECEDING | POSITION.CONTAINS;
		}
		return POSITION.PRECEDING;
	}
};

// Sort an array of nodes based on their relative position in the document and
// remove any duplicate nodes. If the array contains nodes that do not belong
// to the same document, sort order is unspecified.
//
// @argument {Array} nodes Array of DOM nodes
//
// @returns {Array} collection of unique nodes, sorted in document order
exports.uniqueSort = function(nodes) {
	var idx = nodes.length, node, position;

	nodes = nodes.slice();

	while (--idx > -1) {
		node = nodes[idx];
		position = nodes.indexOf(node);
		if (position > -1 && position < idx) {
			nodes.splice(idx, 1);
		}
	}
	nodes.sort(function(a, b) {
		var relative = comparePos(a, b);
		if (relative & POSITION.PRECEDING) {
			return -1;
		} else if (relative & POSITION.FOLLOWING) {
			return 1;
		}
		return 0;
	});

	return nodes;
};

},{}],13:[function(require,module,exports){
var ElementType = require("domelementtype");
var isTag = exports.isTag = ElementType.isTag;

exports.testElement = function(options, element){
	for(var key in options){
		if(!options.hasOwnProperty(key));
		else if(key === "tag_name"){
			if(!isTag(element) || !options.tag_name(element.name)){
				return false;
			}
		} else if(key === "tag_type"){
			if(!options.tag_type(element.type)) return false;
		} else if(key === "tag_contains"){
			if(isTag(element) || !options.tag_contains(element.data)){
				return false;
			}
		} else if(!element.attribs || !options[key](element.attribs[key])){
			return false;
		}
	}
	return true;
};

var Checks = {
	tag_name: function(name){
		if(typeof name === "function"){
			return function(elem){ return isTag(elem) && name(elem.name); };
		} else if(name === "*"){
			return isTag;
		} else {
			return function(elem){ return isTag(elem) && elem.name === name; };
		}
	},
	tag_type: function(type){
		if(typeof type === "function"){
			return function(elem){ return type(elem.type); };
		} else {
			return function(elem){ return elem.type === type; };
		}
	},
	tag_contains: function(data){
		if(typeof data === "function"){
			return function(elem){ return !isTag(elem) && data(elem.data); };
		} else {
			return function(elem){ return !isTag(elem) && elem.data === data; };
		}
	}
};

function getAttribCheck(attrib, value){
	if(typeof value === "function"){
		return function(elem){ return elem.attribs && value(elem.attribs[attrib]); };
	} else {
		return function(elem){ return elem.attribs && elem.attribs[attrib] === value; };
	}
}

function combineFuncs(a, b){
	return function(elem){
		return a(elem) || b(elem);
	};
}

exports.getElements = function(options, element, recurse, limit){
	var funcs = Object.keys(options).map(function(key){
		var value = options[key];
		return key in Checks ? Checks[key](value) : getAttribCheck(key, value);
	});

	return funcs.length === 0 ? [] : this.filter(
		funcs.reduce(combineFuncs),
		element, recurse, limit
	);
};

exports.getElementById = function(id, element, recurse){
	if(!Array.isArray(element)) element = [element];
	return this.findOne(getAttribCheck("id", id), element, recurse !== false);
};

exports.getElementsByTagName = function(name, element, recurse, limit){
	return this.filter(Checks.tag_name(name), element, recurse, limit);
};

exports.getElementsByTagType = function(type, element, recurse, limit){
	return this.filter(Checks.tag_type(type), element, recurse, limit);
};

},{"domelementtype":7}],14:[function(require,module,exports){
exports.removeElement = function(elem){
	if(elem.prev) elem.prev.next = elem.next;
	if(elem.next) elem.next.prev = elem.prev;

	if(elem.parent){
		var childs = elem.parent.children;
		childs.splice(childs.lastIndexOf(elem), 1);
	}
};

exports.replaceElement = function(elem, replacement){
	var prev = replacement.prev = elem.prev;
	if(prev){
		prev.next = replacement;
	}

	var next = replacement.next = elem.next;
	if(next){
		next.prev = replacement;
	}

	var parent = replacement.parent = elem.parent;
	if(parent){
		var childs = parent.children;
		childs[childs.lastIndexOf(elem)] = replacement;
	}
};

exports.appendChild = function(elem, child){
	child.parent = elem;

	if(elem.children.push(child) !== 1){
		var sibling = elem.children[elem.children.length - 2];
		sibling.next = child;
		child.prev = sibling;
		child.next = null;
	}
};

exports.append = function(elem, next){
	var parent = elem.parent,
		currNext = elem.next;

	next.next = currNext;
	next.prev = elem;
	elem.next = next;
	next.parent = parent;

	if(currNext){
		currNext.prev = next;
		if(parent){
			var childs = parent.children;
			childs.splice(childs.lastIndexOf(currNext), 0, next);
		}
	} else if(parent){
		parent.children.push(next);
	}
};

exports.prepend = function(elem, prev){
	var parent = elem.parent;
	if(parent){
		var childs = parent.children;
		childs.splice(childs.lastIndexOf(elem), 0, prev);
	}

	if(elem.prev){
		elem.prev.next = prev;
	}
	
	prev.parent = parent;
	prev.prev = elem.prev;
	prev.next = elem;
	elem.prev = prev;
};



},{}],15:[function(require,module,exports){
var isTag = require("domelementtype").isTag;

module.exports = {
	filter: filter,
	find: find,
	findOneChild: findOneChild,
	findOne: findOne,
	existsOne: existsOne,
	findAll: findAll
};

function filter(test, element, recurse, limit){
	if(!Array.isArray(element)) element = [element];

	if(typeof limit !== "number" || !isFinite(limit)){
		limit = Infinity;
	}
	return find(test, element, recurse !== false, limit);
}

function find(test, elems, recurse, limit){
	var result = [], childs;

	for(var i = 0, j = elems.length; i < j; i++){
		if(test(elems[i])){
			result.push(elems[i]);
			if(--limit <= 0) break;
		}

		childs = elems[i].children;
		if(recurse && childs && childs.length > 0){
			childs = find(test, childs, recurse, limit);
			result = result.concat(childs);
			limit -= childs.length;
			if(limit <= 0) break;
		}
	}

	return result;
}

function findOneChild(test, elems){
	for(var i = 0, l = elems.length; i < l; i++){
		if(test(elems[i])) return elems[i];
	}

	return null;
}

function findOne(test, elems){
	var elem = null;

	for(var i = 0, l = elems.length; i < l && !elem; i++){
		if(!isTag(elems[i])){
			continue;
		} else if(test(elems[i])){
			elem = elems[i];
		} else if(elems[i].children.length > 0){
			elem = findOne(test, elems[i].children);
		}
	}

	return elem;
}

function existsOne(test, elems){
	for(var i = 0, l = elems.length; i < l; i++){
		if(
			isTag(elems[i]) && (
				test(elems[i]) || (
					elems[i].children.length > 0 &&
					existsOne(test, elems[i].children)
				)
			)
		){
			return true;
		}
	}

	return false;
}

function findAll(test, rootElems){
	var result = [];
	var stack = rootElems.slice();
	while(stack.length){
		var elem = stack.shift();
		if(!isTag(elem)) continue;
		if (elem.children && elem.children.length > 0) {
			stack.unshift.apply(stack, elem.children);
		}
		if(test(elem)) result.push(elem);
	}
	return result;
}

},{"domelementtype":7}],16:[function(require,module,exports){
var ElementType = require("domelementtype"),
    getOuterHTML = require("dom-serializer"),
    isTag = ElementType.isTag;

module.exports = {
	getInnerHTML: getInnerHTML,
	getOuterHTML: getOuterHTML,
	getText: getText
};

function getInnerHTML(elem, opts){
	return elem.children ? elem.children.map(function(elem){
		return getOuterHTML(elem, opts);
	}).join("") : "";
}

function getText(elem){
	if(Array.isArray(elem)) return elem.map(getText).join("");
	if(isTag(elem)) return elem.name === "br" ? "\n" : getText(elem.children);
	if(elem.type === ElementType.CDATA) return getText(elem.children);
	if(elem.type === ElementType.Text) return elem.data;
	return "";
}

},{"dom-serializer":6,"domelementtype":7}],17:[function(require,module,exports){
var getChildren = exports.getChildren = function(elem){
	return elem.children;
};

var getParent = exports.getParent = function(elem){
	return elem.parent;
};

exports.getSiblings = function(elem){
	var parent = getParent(elem);
	return parent ? getChildren(parent) : [elem];
};

exports.getAttributeValue = function(elem, name){
	return elem.attribs && elem.attribs[name];
};

exports.hasAttrib = function(elem, name){
	return !!elem.attribs && hasOwnProperty.call(elem.attribs, name);
};

exports.getName = function(elem){
	return elem.name;
};

},{}],18:[function(require,module,exports){
var encode = require("./lib/encode.js"),
    decode = require("./lib/decode.js");

exports.decode = function(data, level) {
    return (!level || level <= 0 ? decode.XML : decode.HTML)(data);
};

exports.decodeStrict = function(data, level) {
    return (!level || level <= 0 ? decode.XML : decode.HTMLStrict)(data);
};

exports.encode = function(data, level) {
    return (!level || level <= 0 ? encode.XML : encode.HTML)(data);
};

exports.encodeXML = encode.XML;

exports.encodeHTML4 = exports.encodeHTML5 = exports.encodeHTML = encode.HTML;

exports.decodeXML = exports.decodeXMLStrict = decode.XML;

exports.decodeHTML4 = exports.decodeHTML5 = exports.decodeHTML = decode.HTML;

exports.decodeHTML4Strict = exports.decodeHTML5Strict = exports.decodeHTMLStrict = decode.HTMLStrict;

exports.escape = encode.escape;

},{"./lib/decode.js":19,"./lib/encode.js":21}],19:[function(require,module,exports){
var entityMap = require("../maps/entities.json"),
    legacyMap = require("../maps/legacy.json"),
    xmlMap = require("../maps/xml.json"),
    decodeCodePoint = require("./decode_codepoint.js");

var decodeXMLStrict = getStrictDecoder(xmlMap),
    decodeHTMLStrict = getStrictDecoder(entityMap);

function getStrictDecoder(map) {
    var keys = Object.keys(map).join("|"),
        replace = getReplacer(map);

    keys += "|#[xX][\\da-fA-F]+|#\\d+";

    var re = new RegExp("&(?:" + keys + ");", "g");

    return function(str) {
        return String(str).replace(re, replace);
    };
}

var decodeHTML = (function() {
    var legacy = Object.keys(legacyMap).sort(sorter);

    var keys = Object.keys(entityMap).sort(sorter);

    for (var i = 0, j = 0; i < keys.length; i++) {
        if (legacy[j] === keys[i]) {
            keys[i] += ";?";
            j++;
        } else {
            keys[i] += ";";
        }
    }

    var re = new RegExp("&(?:" + keys.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g"),
        replace = getReplacer(entityMap);

    function replacer(str) {
        if (str.substr(-1) !== ";") str += ";";
        return replace(str);
    }

    //TODO consider creating a merged map
    return function(str) {
        return String(str).replace(re, replacer);
    };
})();

function sorter(a, b) {
    return a < b ? 1 : -1;
}

function getReplacer(map) {
    return function replace(str) {
        if (str.charAt(1) === "#") {
            if (str.charAt(2) === "X" || str.charAt(2) === "x") {
                return decodeCodePoint(parseInt(str.substr(3), 16));
            }
            return decodeCodePoint(parseInt(str.substr(2), 10));
        }
        return map[str.slice(1, -1)];
    };
}

module.exports = {
    XML: decodeXMLStrict,
    HTML: decodeHTML,
    HTMLStrict: decodeHTMLStrict
};

},{"../maps/entities.json":23,"../maps/legacy.json":24,"../maps/xml.json":25,"./decode_codepoint.js":20}],20:[function(require,module,exports){
var decodeMap = require("../maps/decode.json");

module.exports = decodeCodePoint;

// modified version of https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
function decodeCodePoint(codePoint) {
    if ((codePoint >= 0xd800 && codePoint <= 0xdfff) || codePoint > 0x10ffff) {
        return "\uFFFD";
    }

    if (codePoint in decodeMap) {
        codePoint = decodeMap[codePoint];
    }

    var output = "";

    if (codePoint > 0xffff) {
        codePoint -= 0x10000;
        output += String.fromCharCode(((codePoint >>> 10) & 0x3ff) | 0xd800);
        codePoint = 0xdc00 | (codePoint & 0x3ff);
    }

    output += String.fromCharCode(codePoint);
    return output;
}

},{"../maps/decode.json":22}],21:[function(require,module,exports){
var inverseXML = getInverseObj(require("../maps/xml.json")),
    xmlReplacer = getInverseReplacer(inverseXML);

exports.XML = getInverse(inverseXML, xmlReplacer);

var inverseHTML = getInverseObj(require("../maps/entities.json")),
    htmlReplacer = getInverseReplacer(inverseHTML);

exports.HTML = getInverse(inverseHTML, htmlReplacer);

function getInverseObj(obj) {
    return Object.keys(obj)
        .sort()
        .reduce(function(inverse, name) {
            inverse[obj[name]] = "&" + name + ";";
            return inverse;
        }, {});
}

function getInverseReplacer(inverse) {
    var single = [],
        multiple = [];

    Object.keys(inverse).forEach(function(k) {
        if (k.length === 1) {
            single.push("\\" + k);
        } else {
            multiple.push(k);
        }
    });

    //TODO add ranges
    multiple.unshift("[" + single.join("") + "]");

    return new RegExp(multiple.join("|"), "g");
}

var re_nonASCII = /[^\0-\x7F]/g,
    re_astralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;

function singleCharReplacer(c) {
    return (
        "&#x" +
        c
            .charCodeAt(0)
            .toString(16)
            .toUpperCase() +
        ";"
    );
}

function astralReplacer(c) {
    // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
    var high = c.charCodeAt(0);
    var low = c.charCodeAt(1);
    var codePoint = (high - 0xd800) * 0x400 + low - 0xdc00 + 0x10000;
    return "&#x" + codePoint.toString(16).toUpperCase() + ";";
}

function getInverse(inverse, re) {
    function func(name) {
        return inverse[name];
    }

    return function(data) {
        return data
            .replace(re, func)
            .replace(re_astralSymbols, astralReplacer)
            .replace(re_nonASCII, singleCharReplacer);
    };
}

var re_xmlChars = getInverseReplacer(inverseXML);

function escapeXML(data) {
    return data
        .replace(re_xmlChars, singleCharReplacer)
        .replace(re_astralSymbols, astralReplacer)
        .replace(re_nonASCII, singleCharReplacer);
}

exports.escape = escapeXML;

},{"../maps/entities.json":23,"../maps/xml.json":25}],22:[function(require,module,exports){
module.exports={"0":65533,"128":8364,"130":8218,"131":402,"132":8222,"133":8230,"134":8224,"135":8225,"136":710,"137":8240,"138":352,"139":8249,"140":338,"142":381,"145":8216,"146":8217,"147":8220,"148":8221,"149":8226,"150":8211,"151":8212,"152":732,"153":8482,"154":353,"155":8250,"156":339,"158":382,"159":376}
},{}],23:[function(require,module,exports){
module.exports={"Aacute":"\u00C1","aacute":"\u00E1","Abreve":"\u0102","abreve":"\u0103","ac":"\u223E","acd":"\u223F","acE":"\u223E\u0333","Acirc":"\u00C2","acirc":"\u00E2","acute":"\u00B4","Acy":"\u0410","acy":"\u0430","AElig":"\u00C6","aelig":"\u00E6","af":"\u2061","Afr":"\uD835\uDD04","afr":"\uD835\uDD1E","Agrave":"\u00C0","agrave":"\u00E0","alefsym":"\u2135","aleph":"\u2135","Alpha":"\u0391","alpha":"\u03B1","Amacr":"\u0100","amacr":"\u0101","amalg":"\u2A3F","amp":"&","AMP":"&","andand":"\u2A55","And":"\u2A53","and":"\u2227","andd":"\u2A5C","andslope":"\u2A58","andv":"\u2A5A","ang":"\u2220","ange":"\u29A4","angle":"\u2220","angmsdaa":"\u29A8","angmsdab":"\u29A9","angmsdac":"\u29AA","angmsdad":"\u29AB","angmsdae":"\u29AC","angmsdaf":"\u29AD","angmsdag":"\u29AE","angmsdah":"\u29AF","angmsd":"\u2221","angrt":"\u221F","angrtvb":"\u22BE","angrtvbd":"\u299D","angsph":"\u2222","angst":"\u00C5","angzarr":"\u237C","Aogon":"\u0104","aogon":"\u0105","Aopf":"\uD835\uDD38","aopf":"\uD835\uDD52","apacir":"\u2A6F","ap":"\u2248","apE":"\u2A70","ape":"\u224A","apid":"\u224B","apos":"'","ApplyFunction":"\u2061","approx":"\u2248","approxeq":"\u224A","Aring":"\u00C5","aring":"\u00E5","Ascr":"\uD835\uDC9C","ascr":"\uD835\uDCB6","Assign":"\u2254","ast":"*","asymp":"\u2248","asympeq":"\u224D","Atilde":"\u00C3","atilde":"\u00E3","Auml":"\u00C4","auml":"\u00E4","awconint":"\u2233","awint":"\u2A11","backcong":"\u224C","backepsilon":"\u03F6","backprime":"\u2035","backsim":"\u223D","backsimeq":"\u22CD","Backslash":"\u2216","Barv":"\u2AE7","barvee":"\u22BD","barwed":"\u2305","Barwed":"\u2306","barwedge":"\u2305","bbrk":"\u23B5","bbrktbrk":"\u23B6","bcong":"\u224C","Bcy":"\u0411","bcy":"\u0431","bdquo":"\u201E","becaus":"\u2235","because":"\u2235","Because":"\u2235","bemptyv":"\u29B0","bepsi":"\u03F6","bernou":"\u212C","Bernoullis":"\u212C","Beta":"\u0392","beta":"\u03B2","beth":"\u2136","between":"\u226C","Bfr":"\uD835\uDD05","bfr":"\uD835\uDD1F","bigcap":"\u22C2","bigcirc":"\u25EF","bigcup":"\u22C3","bigodot":"\u2A00","bigoplus":"\u2A01","bigotimes":"\u2A02","bigsqcup":"\u2A06","bigstar":"\u2605","bigtriangledown":"\u25BD","bigtriangleup":"\u25B3","biguplus":"\u2A04","bigvee":"\u22C1","bigwedge":"\u22C0","bkarow":"\u290D","blacklozenge":"\u29EB","blacksquare":"\u25AA","blacktriangle":"\u25B4","blacktriangledown":"\u25BE","blacktriangleleft":"\u25C2","blacktriangleright":"\u25B8","blank":"\u2423","blk12":"\u2592","blk14":"\u2591","blk34":"\u2593","block":"\u2588","bne":"=\u20E5","bnequiv":"\u2261\u20E5","bNot":"\u2AED","bnot":"\u2310","Bopf":"\uD835\uDD39","bopf":"\uD835\uDD53","bot":"\u22A5","bottom":"\u22A5","bowtie":"\u22C8","boxbox":"\u29C9","boxdl":"\u2510","boxdL":"\u2555","boxDl":"\u2556","boxDL":"\u2557","boxdr":"\u250C","boxdR":"\u2552","boxDr":"\u2553","boxDR":"\u2554","boxh":"\u2500","boxH":"\u2550","boxhd":"\u252C","boxHd":"\u2564","boxhD":"\u2565","boxHD":"\u2566","boxhu":"\u2534","boxHu":"\u2567","boxhU":"\u2568","boxHU":"\u2569","boxminus":"\u229F","boxplus":"\u229E","boxtimes":"\u22A0","boxul":"\u2518","boxuL":"\u255B","boxUl":"\u255C","boxUL":"\u255D","boxur":"\u2514","boxuR":"\u2558","boxUr":"\u2559","boxUR":"\u255A","boxv":"\u2502","boxV":"\u2551","boxvh":"\u253C","boxvH":"\u256A","boxVh":"\u256B","boxVH":"\u256C","boxvl":"\u2524","boxvL":"\u2561","boxVl":"\u2562","boxVL":"\u2563","boxvr":"\u251C","boxvR":"\u255E","boxVr":"\u255F","boxVR":"\u2560","bprime":"\u2035","breve":"\u02D8","Breve":"\u02D8","brvbar":"\u00A6","bscr":"\uD835\uDCB7","Bscr":"\u212C","bsemi":"\u204F","bsim":"\u223D","bsime":"\u22CD","bsolb":"\u29C5","bsol":"\\","bsolhsub":"\u27C8","bull":"\u2022","bullet":"\u2022","bump":"\u224E","bumpE":"\u2AAE","bumpe":"\u224F","Bumpeq":"\u224E","bumpeq":"\u224F","Cacute":"\u0106","cacute":"\u0107","capand":"\u2A44","capbrcup":"\u2A49","capcap":"\u2A4B","cap":"\u2229","Cap":"\u22D2","capcup":"\u2A47","capdot":"\u2A40","CapitalDifferentialD":"\u2145","caps":"\u2229\uFE00","caret":"\u2041","caron":"\u02C7","Cayleys":"\u212D","ccaps":"\u2A4D","Ccaron":"\u010C","ccaron":"\u010D","Ccedil":"\u00C7","ccedil":"\u00E7","Ccirc":"\u0108","ccirc":"\u0109","Cconint":"\u2230","ccups":"\u2A4C","ccupssm":"\u2A50","Cdot":"\u010A","cdot":"\u010B","cedil":"\u00B8","Cedilla":"\u00B8","cemptyv":"\u29B2","cent":"\u00A2","centerdot":"\u00B7","CenterDot":"\u00B7","cfr":"\uD835\uDD20","Cfr":"\u212D","CHcy":"\u0427","chcy":"\u0447","check":"\u2713","checkmark":"\u2713","Chi":"\u03A7","chi":"\u03C7","circ":"\u02C6","circeq":"\u2257","circlearrowleft":"\u21BA","circlearrowright":"\u21BB","circledast":"\u229B","circledcirc":"\u229A","circleddash":"\u229D","CircleDot":"\u2299","circledR":"\u00AE","circledS":"\u24C8","CircleMinus":"\u2296","CirclePlus":"\u2295","CircleTimes":"\u2297","cir":"\u25CB","cirE":"\u29C3","cire":"\u2257","cirfnint":"\u2A10","cirmid":"\u2AEF","cirscir":"\u29C2","ClockwiseContourIntegral":"\u2232","CloseCurlyDoubleQuote":"\u201D","CloseCurlyQuote":"\u2019","clubs":"\u2663","clubsuit":"\u2663","colon":":","Colon":"\u2237","Colone":"\u2A74","colone":"\u2254","coloneq":"\u2254","comma":",","commat":"@","comp":"\u2201","compfn":"\u2218","complement":"\u2201","complexes":"\u2102","cong":"\u2245","congdot":"\u2A6D","Congruent":"\u2261","conint":"\u222E","Conint":"\u222F","ContourIntegral":"\u222E","copf":"\uD835\uDD54","Copf":"\u2102","coprod":"\u2210","Coproduct":"\u2210","copy":"\u00A9","COPY":"\u00A9","copysr":"\u2117","CounterClockwiseContourIntegral":"\u2233","crarr":"\u21B5","cross":"\u2717","Cross":"\u2A2F","Cscr":"\uD835\uDC9E","cscr":"\uD835\uDCB8","csub":"\u2ACF","csube":"\u2AD1","csup":"\u2AD0","csupe":"\u2AD2","ctdot":"\u22EF","cudarrl":"\u2938","cudarrr":"\u2935","cuepr":"\u22DE","cuesc":"\u22DF","cularr":"\u21B6","cularrp":"\u293D","cupbrcap":"\u2A48","cupcap":"\u2A46","CupCap":"\u224D","cup":"\u222A","Cup":"\u22D3","cupcup":"\u2A4A","cupdot":"\u228D","cupor":"\u2A45","cups":"\u222A\uFE00","curarr":"\u21B7","curarrm":"\u293C","curlyeqprec":"\u22DE","curlyeqsucc":"\u22DF","curlyvee":"\u22CE","curlywedge":"\u22CF","curren":"\u00A4","curvearrowleft":"\u21B6","curvearrowright":"\u21B7","cuvee":"\u22CE","cuwed":"\u22CF","cwconint":"\u2232","cwint":"\u2231","cylcty":"\u232D","dagger":"\u2020","Dagger":"\u2021","daleth":"\u2138","darr":"\u2193","Darr":"\u21A1","dArr":"\u21D3","dash":"\u2010","Dashv":"\u2AE4","dashv":"\u22A3","dbkarow":"\u290F","dblac":"\u02DD","Dcaron":"\u010E","dcaron":"\u010F","Dcy":"\u0414","dcy":"\u0434","ddagger":"\u2021","ddarr":"\u21CA","DD":"\u2145","dd":"\u2146","DDotrahd":"\u2911","ddotseq":"\u2A77","deg":"\u00B0","Del":"\u2207","Delta":"\u0394","delta":"\u03B4","demptyv":"\u29B1","dfisht":"\u297F","Dfr":"\uD835\uDD07","dfr":"\uD835\uDD21","dHar":"\u2965","dharl":"\u21C3","dharr":"\u21C2","DiacriticalAcute":"\u00B4","DiacriticalDot":"\u02D9","DiacriticalDoubleAcute":"\u02DD","DiacriticalGrave":"`","DiacriticalTilde":"\u02DC","diam":"\u22C4","diamond":"\u22C4","Diamond":"\u22C4","diamondsuit":"\u2666","diams":"\u2666","die":"\u00A8","DifferentialD":"\u2146","digamma":"\u03DD","disin":"\u22F2","div":"\u00F7","divide":"\u00F7","divideontimes":"\u22C7","divonx":"\u22C7","DJcy":"\u0402","djcy":"\u0452","dlcorn":"\u231E","dlcrop":"\u230D","dollar":"$","Dopf":"\uD835\uDD3B","dopf":"\uD835\uDD55","Dot":"\u00A8","dot":"\u02D9","DotDot":"\u20DC","doteq":"\u2250","doteqdot":"\u2251","DotEqual":"\u2250","dotminus":"\u2238","dotplus":"\u2214","dotsquare":"\u22A1","doublebarwedge":"\u2306","DoubleContourIntegral":"\u222F","DoubleDot":"\u00A8","DoubleDownArrow":"\u21D3","DoubleLeftArrow":"\u21D0","DoubleLeftRightArrow":"\u21D4","DoubleLeftTee":"\u2AE4","DoubleLongLeftArrow":"\u27F8","DoubleLongLeftRightArrow":"\u27FA","DoubleLongRightArrow":"\u27F9","DoubleRightArrow":"\u21D2","DoubleRightTee":"\u22A8","DoubleUpArrow":"\u21D1","DoubleUpDownArrow":"\u21D5","DoubleVerticalBar":"\u2225","DownArrowBar":"\u2913","downarrow":"\u2193","DownArrow":"\u2193","Downarrow":"\u21D3","DownArrowUpArrow":"\u21F5","DownBreve":"\u0311","downdownarrows":"\u21CA","downharpoonleft":"\u21C3","downharpoonright":"\u21C2","DownLeftRightVector":"\u2950","DownLeftTeeVector":"\u295E","DownLeftVectorBar":"\u2956","DownLeftVector":"\u21BD","DownRightTeeVector":"\u295F","DownRightVectorBar":"\u2957","DownRightVector":"\u21C1","DownTeeArrow":"\u21A7","DownTee":"\u22A4","drbkarow":"\u2910","drcorn":"\u231F","drcrop":"\u230C","Dscr":"\uD835\uDC9F","dscr":"\uD835\uDCB9","DScy":"\u0405","dscy":"\u0455","dsol":"\u29F6","Dstrok":"\u0110","dstrok":"\u0111","dtdot":"\u22F1","dtri":"\u25BF","dtrif":"\u25BE","duarr":"\u21F5","duhar":"\u296F","dwangle":"\u29A6","DZcy":"\u040F","dzcy":"\u045F","dzigrarr":"\u27FF","Eacute":"\u00C9","eacute":"\u00E9","easter":"\u2A6E","Ecaron":"\u011A","ecaron":"\u011B","Ecirc":"\u00CA","ecirc":"\u00EA","ecir":"\u2256","ecolon":"\u2255","Ecy":"\u042D","ecy":"\u044D","eDDot":"\u2A77","Edot":"\u0116","edot":"\u0117","eDot":"\u2251","ee":"\u2147","efDot":"\u2252","Efr":"\uD835\uDD08","efr":"\uD835\uDD22","eg":"\u2A9A","Egrave":"\u00C8","egrave":"\u00E8","egs":"\u2A96","egsdot":"\u2A98","el":"\u2A99","Element":"\u2208","elinters":"\u23E7","ell":"\u2113","els":"\u2A95","elsdot":"\u2A97","Emacr":"\u0112","emacr":"\u0113","empty":"\u2205","emptyset":"\u2205","EmptySmallSquare":"\u25FB","emptyv":"\u2205","EmptyVerySmallSquare":"\u25AB","emsp13":"\u2004","emsp14":"\u2005","emsp":"\u2003","ENG":"\u014A","eng":"\u014B","ensp":"\u2002","Eogon":"\u0118","eogon":"\u0119","Eopf":"\uD835\uDD3C","eopf":"\uD835\uDD56","epar":"\u22D5","eparsl":"\u29E3","eplus":"\u2A71","epsi":"\u03B5","Epsilon":"\u0395","epsilon":"\u03B5","epsiv":"\u03F5","eqcirc":"\u2256","eqcolon":"\u2255","eqsim":"\u2242","eqslantgtr":"\u2A96","eqslantless":"\u2A95","Equal":"\u2A75","equals":"=","EqualTilde":"\u2242","equest":"\u225F","Equilibrium":"\u21CC","equiv":"\u2261","equivDD":"\u2A78","eqvparsl":"\u29E5","erarr":"\u2971","erDot":"\u2253","escr":"\u212F","Escr":"\u2130","esdot":"\u2250","Esim":"\u2A73","esim":"\u2242","Eta":"\u0397","eta":"\u03B7","ETH":"\u00D0","eth":"\u00F0","Euml":"\u00CB","euml":"\u00EB","euro":"\u20AC","excl":"!","exist":"\u2203","Exists":"\u2203","expectation":"\u2130","exponentiale":"\u2147","ExponentialE":"\u2147","fallingdotseq":"\u2252","Fcy":"\u0424","fcy":"\u0444","female":"\u2640","ffilig":"\uFB03","fflig":"\uFB00","ffllig":"\uFB04","Ffr":"\uD835\uDD09","ffr":"\uD835\uDD23","filig":"\uFB01","FilledSmallSquare":"\u25FC","FilledVerySmallSquare":"\u25AA","fjlig":"fj","flat":"\u266D","fllig":"\uFB02","fltns":"\u25B1","fnof":"\u0192","Fopf":"\uD835\uDD3D","fopf":"\uD835\uDD57","forall":"\u2200","ForAll":"\u2200","fork":"\u22D4","forkv":"\u2AD9","Fouriertrf":"\u2131","fpartint":"\u2A0D","frac12":"\u00BD","frac13":"\u2153","frac14":"\u00BC","frac15":"\u2155","frac16":"\u2159","frac18":"\u215B","frac23":"\u2154","frac25":"\u2156","frac34":"\u00BE","frac35":"\u2157","frac38":"\u215C","frac45":"\u2158","frac56":"\u215A","frac58":"\u215D","frac78":"\u215E","frasl":"\u2044","frown":"\u2322","fscr":"\uD835\uDCBB","Fscr":"\u2131","gacute":"\u01F5","Gamma":"\u0393","gamma":"\u03B3","Gammad":"\u03DC","gammad":"\u03DD","gap":"\u2A86","Gbreve":"\u011E","gbreve":"\u011F","Gcedil":"\u0122","Gcirc":"\u011C","gcirc":"\u011D","Gcy":"\u0413","gcy":"\u0433","Gdot":"\u0120","gdot":"\u0121","ge":"\u2265","gE":"\u2267","gEl":"\u2A8C","gel":"\u22DB","geq":"\u2265","geqq":"\u2267","geqslant":"\u2A7E","gescc":"\u2AA9","ges":"\u2A7E","gesdot":"\u2A80","gesdoto":"\u2A82","gesdotol":"\u2A84","gesl":"\u22DB\uFE00","gesles":"\u2A94","Gfr":"\uD835\uDD0A","gfr":"\uD835\uDD24","gg":"\u226B","Gg":"\u22D9","ggg":"\u22D9","gimel":"\u2137","GJcy":"\u0403","gjcy":"\u0453","gla":"\u2AA5","gl":"\u2277","glE":"\u2A92","glj":"\u2AA4","gnap":"\u2A8A","gnapprox":"\u2A8A","gne":"\u2A88","gnE":"\u2269","gneq":"\u2A88","gneqq":"\u2269","gnsim":"\u22E7","Gopf":"\uD835\uDD3E","gopf":"\uD835\uDD58","grave":"`","GreaterEqual":"\u2265","GreaterEqualLess":"\u22DB","GreaterFullEqual":"\u2267","GreaterGreater":"\u2AA2","GreaterLess":"\u2277","GreaterSlantEqual":"\u2A7E","GreaterTilde":"\u2273","Gscr":"\uD835\uDCA2","gscr":"\u210A","gsim":"\u2273","gsime":"\u2A8E","gsiml":"\u2A90","gtcc":"\u2AA7","gtcir":"\u2A7A","gt":">","GT":">","Gt":"\u226B","gtdot":"\u22D7","gtlPar":"\u2995","gtquest":"\u2A7C","gtrapprox":"\u2A86","gtrarr":"\u2978","gtrdot":"\u22D7","gtreqless":"\u22DB","gtreqqless":"\u2A8C","gtrless":"\u2277","gtrsim":"\u2273","gvertneqq":"\u2269\uFE00","gvnE":"\u2269\uFE00","Hacek":"\u02C7","hairsp":"\u200A","half":"\u00BD","hamilt":"\u210B","HARDcy":"\u042A","hardcy":"\u044A","harrcir":"\u2948","harr":"\u2194","hArr":"\u21D4","harrw":"\u21AD","Hat":"^","hbar":"\u210F","Hcirc":"\u0124","hcirc":"\u0125","hearts":"\u2665","heartsuit":"\u2665","hellip":"\u2026","hercon":"\u22B9","hfr":"\uD835\uDD25","Hfr":"\u210C","HilbertSpace":"\u210B","hksearow":"\u2925","hkswarow":"\u2926","hoarr":"\u21FF","homtht":"\u223B","hookleftarrow":"\u21A9","hookrightarrow":"\u21AA","hopf":"\uD835\uDD59","Hopf":"\u210D","horbar":"\u2015","HorizontalLine":"\u2500","hscr":"\uD835\uDCBD","Hscr":"\u210B","hslash":"\u210F","Hstrok":"\u0126","hstrok":"\u0127","HumpDownHump":"\u224E","HumpEqual":"\u224F","hybull":"\u2043","hyphen":"\u2010","Iacute":"\u00CD","iacute":"\u00ED","ic":"\u2063","Icirc":"\u00CE","icirc":"\u00EE","Icy":"\u0418","icy":"\u0438","Idot":"\u0130","IEcy":"\u0415","iecy":"\u0435","iexcl":"\u00A1","iff":"\u21D4","ifr":"\uD835\uDD26","Ifr":"\u2111","Igrave":"\u00CC","igrave":"\u00EC","ii":"\u2148","iiiint":"\u2A0C","iiint":"\u222D","iinfin":"\u29DC","iiota":"\u2129","IJlig":"\u0132","ijlig":"\u0133","Imacr":"\u012A","imacr":"\u012B","image":"\u2111","ImaginaryI":"\u2148","imagline":"\u2110","imagpart":"\u2111","imath":"\u0131","Im":"\u2111","imof":"\u22B7","imped":"\u01B5","Implies":"\u21D2","incare":"\u2105","in":"\u2208","infin":"\u221E","infintie":"\u29DD","inodot":"\u0131","intcal":"\u22BA","int":"\u222B","Int":"\u222C","integers":"\u2124","Integral":"\u222B","intercal":"\u22BA","Intersection":"\u22C2","intlarhk":"\u2A17","intprod":"\u2A3C","InvisibleComma":"\u2063","InvisibleTimes":"\u2062","IOcy":"\u0401","iocy":"\u0451","Iogon":"\u012E","iogon":"\u012F","Iopf":"\uD835\uDD40","iopf":"\uD835\uDD5A","Iota":"\u0399","iota":"\u03B9","iprod":"\u2A3C","iquest":"\u00BF","iscr":"\uD835\uDCBE","Iscr":"\u2110","isin":"\u2208","isindot":"\u22F5","isinE":"\u22F9","isins":"\u22F4","isinsv":"\u22F3","isinv":"\u2208","it":"\u2062","Itilde":"\u0128","itilde":"\u0129","Iukcy":"\u0406","iukcy":"\u0456","Iuml":"\u00CF","iuml":"\u00EF","Jcirc":"\u0134","jcirc":"\u0135","Jcy":"\u0419","jcy":"\u0439","Jfr":"\uD835\uDD0D","jfr":"\uD835\uDD27","jmath":"\u0237","Jopf":"\uD835\uDD41","jopf":"\uD835\uDD5B","Jscr":"\uD835\uDCA5","jscr":"\uD835\uDCBF","Jsercy":"\u0408","jsercy":"\u0458","Jukcy":"\u0404","jukcy":"\u0454","Kappa":"\u039A","kappa":"\u03BA","kappav":"\u03F0","Kcedil":"\u0136","kcedil":"\u0137","Kcy":"\u041A","kcy":"\u043A","Kfr":"\uD835\uDD0E","kfr":"\uD835\uDD28","kgreen":"\u0138","KHcy":"\u0425","khcy":"\u0445","KJcy":"\u040C","kjcy":"\u045C","Kopf":"\uD835\uDD42","kopf":"\uD835\uDD5C","Kscr":"\uD835\uDCA6","kscr":"\uD835\uDCC0","lAarr":"\u21DA","Lacute":"\u0139","lacute":"\u013A","laemptyv":"\u29B4","lagran":"\u2112","Lambda":"\u039B","lambda":"\u03BB","lang":"\u27E8","Lang":"\u27EA","langd":"\u2991","langle":"\u27E8","lap":"\u2A85","Laplacetrf":"\u2112","laquo":"\u00AB","larrb":"\u21E4","larrbfs":"\u291F","larr":"\u2190","Larr":"\u219E","lArr":"\u21D0","larrfs":"\u291D","larrhk":"\u21A9","larrlp":"\u21AB","larrpl":"\u2939","larrsim":"\u2973","larrtl":"\u21A2","latail":"\u2919","lAtail":"\u291B","lat":"\u2AAB","late":"\u2AAD","lates":"\u2AAD\uFE00","lbarr":"\u290C","lBarr":"\u290E","lbbrk":"\u2772","lbrace":"{","lbrack":"[","lbrke":"\u298B","lbrksld":"\u298F","lbrkslu":"\u298D","Lcaron":"\u013D","lcaron":"\u013E","Lcedil":"\u013B","lcedil":"\u013C","lceil":"\u2308","lcub":"{","Lcy":"\u041B","lcy":"\u043B","ldca":"\u2936","ldquo":"\u201C","ldquor":"\u201E","ldrdhar":"\u2967","ldrushar":"\u294B","ldsh":"\u21B2","le":"\u2264","lE":"\u2266","LeftAngleBracket":"\u27E8","LeftArrowBar":"\u21E4","leftarrow":"\u2190","LeftArrow":"\u2190","Leftarrow":"\u21D0","LeftArrowRightArrow":"\u21C6","leftarrowtail":"\u21A2","LeftCeiling":"\u2308","LeftDoubleBracket":"\u27E6","LeftDownTeeVector":"\u2961","LeftDownVectorBar":"\u2959","LeftDownVector":"\u21C3","LeftFloor":"\u230A","leftharpoondown":"\u21BD","leftharpoonup":"\u21BC","leftleftarrows":"\u21C7","leftrightarrow":"\u2194","LeftRightArrow":"\u2194","Leftrightarrow":"\u21D4","leftrightarrows":"\u21C6","leftrightharpoons":"\u21CB","leftrightsquigarrow":"\u21AD","LeftRightVector":"\u294E","LeftTeeArrow":"\u21A4","LeftTee":"\u22A3","LeftTeeVector":"\u295A","leftthreetimes":"\u22CB","LeftTriangleBar":"\u29CF","LeftTriangle":"\u22B2","LeftTriangleEqual":"\u22B4","LeftUpDownVector":"\u2951","LeftUpTeeVector":"\u2960","LeftUpVectorBar":"\u2958","LeftUpVector":"\u21BF","LeftVectorBar":"\u2952","LeftVector":"\u21BC","lEg":"\u2A8B","leg":"\u22DA","leq":"\u2264","leqq":"\u2266","leqslant":"\u2A7D","lescc":"\u2AA8","les":"\u2A7D","lesdot":"\u2A7F","lesdoto":"\u2A81","lesdotor":"\u2A83","lesg":"\u22DA\uFE00","lesges":"\u2A93","lessapprox":"\u2A85","lessdot":"\u22D6","lesseqgtr":"\u22DA","lesseqqgtr":"\u2A8B","LessEqualGreater":"\u22DA","LessFullEqual":"\u2266","LessGreater":"\u2276","lessgtr":"\u2276","LessLess":"\u2AA1","lesssim":"\u2272","LessSlantEqual":"\u2A7D","LessTilde":"\u2272","lfisht":"\u297C","lfloor":"\u230A","Lfr":"\uD835\uDD0F","lfr":"\uD835\uDD29","lg":"\u2276","lgE":"\u2A91","lHar":"\u2962","lhard":"\u21BD","lharu":"\u21BC","lharul":"\u296A","lhblk":"\u2584","LJcy":"\u0409","ljcy":"\u0459","llarr":"\u21C7","ll":"\u226A","Ll":"\u22D8","llcorner":"\u231E","Lleftarrow":"\u21DA","llhard":"\u296B","lltri":"\u25FA","Lmidot":"\u013F","lmidot":"\u0140","lmoustache":"\u23B0","lmoust":"\u23B0","lnap":"\u2A89","lnapprox":"\u2A89","lne":"\u2A87","lnE":"\u2268","lneq":"\u2A87","lneqq":"\u2268","lnsim":"\u22E6","loang":"\u27EC","loarr":"\u21FD","lobrk":"\u27E6","longleftarrow":"\u27F5","LongLeftArrow":"\u27F5","Longleftarrow":"\u27F8","longleftrightarrow":"\u27F7","LongLeftRightArrow":"\u27F7","Longleftrightarrow":"\u27FA","longmapsto":"\u27FC","longrightarrow":"\u27F6","LongRightArrow":"\u27F6","Longrightarrow":"\u27F9","looparrowleft":"\u21AB","looparrowright":"\u21AC","lopar":"\u2985","Lopf":"\uD835\uDD43","lopf":"\uD835\uDD5D","loplus":"\u2A2D","lotimes":"\u2A34","lowast":"\u2217","lowbar":"_","LowerLeftArrow":"\u2199","LowerRightArrow":"\u2198","loz":"\u25CA","lozenge":"\u25CA","lozf":"\u29EB","lpar":"(","lparlt":"\u2993","lrarr":"\u21C6","lrcorner":"\u231F","lrhar":"\u21CB","lrhard":"\u296D","lrm":"\u200E","lrtri":"\u22BF","lsaquo":"\u2039","lscr":"\uD835\uDCC1","Lscr":"\u2112","lsh":"\u21B0","Lsh":"\u21B0","lsim":"\u2272","lsime":"\u2A8D","lsimg":"\u2A8F","lsqb":"[","lsquo":"\u2018","lsquor":"\u201A","Lstrok":"\u0141","lstrok":"\u0142","ltcc":"\u2AA6","ltcir":"\u2A79","lt":"<","LT":"<","Lt":"\u226A","ltdot":"\u22D6","lthree":"\u22CB","ltimes":"\u22C9","ltlarr":"\u2976","ltquest":"\u2A7B","ltri":"\u25C3","ltrie":"\u22B4","ltrif":"\u25C2","ltrPar":"\u2996","lurdshar":"\u294A","luruhar":"\u2966","lvertneqq":"\u2268\uFE00","lvnE":"\u2268\uFE00","macr":"\u00AF","male":"\u2642","malt":"\u2720","maltese":"\u2720","Map":"\u2905","map":"\u21A6","mapsto":"\u21A6","mapstodown":"\u21A7","mapstoleft":"\u21A4","mapstoup":"\u21A5","marker":"\u25AE","mcomma":"\u2A29","Mcy":"\u041C","mcy":"\u043C","mdash":"\u2014","mDDot":"\u223A","measuredangle":"\u2221","MediumSpace":"\u205F","Mellintrf":"\u2133","Mfr":"\uD835\uDD10","mfr":"\uD835\uDD2A","mho":"\u2127","micro":"\u00B5","midast":"*","midcir":"\u2AF0","mid":"\u2223","middot":"\u00B7","minusb":"\u229F","minus":"\u2212","minusd":"\u2238","minusdu":"\u2A2A","MinusPlus":"\u2213","mlcp":"\u2ADB","mldr":"\u2026","mnplus":"\u2213","models":"\u22A7","Mopf":"\uD835\uDD44","mopf":"\uD835\uDD5E","mp":"\u2213","mscr":"\uD835\uDCC2","Mscr":"\u2133","mstpos":"\u223E","Mu":"\u039C","mu":"\u03BC","multimap":"\u22B8","mumap":"\u22B8","nabla":"\u2207","Nacute":"\u0143","nacute":"\u0144","nang":"\u2220\u20D2","nap":"\u2249","napE":"\u2A70\u0338","napid":"\u224B\u0338","napos":"\u0149","napprox":"\u2249","natural":"\u266E","naturals":"\u2115","natur":"\u266E","nbsp":"\u00A0","nbump":"\u224E\u0338","nbumpe":"\u224F\u0338","ncap":"\u2A43","Ncaron":"\u0147","ncaron":"\u0148","Ncedil":"\u0145","ncedil":"\u0146","ncong":"\u2247","ncongdot":"\u2A6D\u0338","ncup":"\u2A42","Ncy":"\u041D","ncy":"\u043D","ndash":"\u2013","nearhk":"\u2924","nearr":"\u2197","neArr":"\u21D7","nearrow":"\u2197","ne":"\u2260","nedot":"\u2250\u0338","NegativeMediumSpace":"\u200B","NegativeThickSpace":"\u200B","NegativeThinSpace":"\u200B","NegativeVeryThinSpace":"\u200B","nequiv":"\u2262","nesear":"\u2928","nesim":"\u2242\u0338","NestedGreaterGreater":"\u226B","NestedLessLess":"\u226A","NewLine":"\n","nexist":"\u2204","nexists":"\u2204","Nfr":"\uD835\uDD11","nfr":"\uD835\uDD2B","ngE":"\u2267\u0338","nge":"\u2271","ngeq":"\u2271","ngeqq":"\u2267\u0338","ngeqslant":"\u2A7E\u0338","nges":"\u2A7E\u0338","nGg":"\u22D9\u0338","ngsim":"\u2275","nGt":"\u226B\u20D2","ngt":"\u226F","ngtr":"\u226F","nGtv":"\u226B\u0338","nharr":"\u21AE","nhArr":"\u21CE","nhpar":"\u2AF2","ni":"\u220B","nis":"\u22FC","nisd":"\u22FA","niv":"\u220B","NJcy":"\u040A","njcy":"\u045A","nlarr":"\u219A","nlArr":"\u21CD","nldr":"\u2025","nlE":"\u2266\u0338","nle":"\u2270","nleftarrow":"\u219A","nLeftarrow":"\u21CD","nleftrightarrow":"\u21AE","nLeftrightarrow":"\u21CE","nleq":"\u2270","nleqq":"\u2266\u0338","nleqslant":"\u2A7D\u0338","nles":"\u2A7D\u0338","nless":"\u226E","nLl":"\u22D8\u0338","nlsim":"\u2274","nLt":"\u226A\u20D2","nlt":"\u226E","nltri":"\u22EA","nltrie":"\u22EC","nLtv":"\u226A\u0338","nmid":"\u2224","NoBreak":"\u2060","NonBreakingSpace":"\u00A0","nopf":"\uD835\uDD5F","Nopf":"\u2115","Not":"\u2AEC","not":"\u00AC","NotCongruent":"\u2262","NotCupCap":"\u226D","NotDoubleVerticalBar":"\u2226","NotElement":"\u2209","NotEqual":"\u2260","NotEqualTilde":"\u2242\u0338","NotExists":"\u2204","NotGreater":"\u226F","NotGreaterEqual":"\u2271","NotGreaterFullEqual":"\u2267\u0338","NotGreaterGreater":"\u226B\u0338","NotGreaterLess":"\u2279","NotGreaterSlantEqual":"\u2A7E\u0338","NotGreaterTilde":"\u2275","NotHumpDownHump":"\u224E\u0338","NotHumpEqual":"\u224F\u0338","notin":"\u2209","notindot":"\u22F5\u0338","notinE":"\u22F9\u0338","notinva":"\u2209","notinvb":"\u22F7","notinvc":"\u22F6","NotLeftTriangleBar":"\u29CF\u0338","NotLeftTriangle":"\u22EA","NotLeftTriangleEqual":"\u22EC","NotLess":"\u226E","NotLessEqual":"\u2270","NotLessGreater":"\u2278","NotLessLess":"\u226A\u0338","NotLessSlantEqual":"\u2A7D\u0338","NotLessTilde":"\u2274","NotNestedGreaterGreater":"\u2AA2\u0338","NotNestedLessLess":"\u2AA1\u0338","notni":"\u220C","notniva":"\u220C","notnivb":"\u22FE","notnivc":"\u22FD","NotPrecedes":"\u2280","NotPrecedesEqual":"\u2AAF\u0338","NotPrecedesSlantEqual":"\u22E0","NotReverseElement":"\u220C","NotRightTriangleBar":"\u29D0\u0338","NotRightTriangle":"\u22EB","NotRightTriangleEqual":"\u22ED","NotSquareSubset":"\u228F\u0338","NotSquareSubsetEqual":"\u22E2","NotSquareSuperset":"\u2290\u0338","NotSquareSupersetEqual":"\u22E3","NotSubset":"\u2282\u20D2","NotSubsetEqual":"\u2288","NotSucceeds":"\u2281","NotSucceedsEqual":"\u2AB0\u0338","NotSucceedsSlantEqual":"\u22E1","NotSucceedsTilde":"\u227F\u0338","NotSuperset":"\u2283\u20D2","NotSupersetEqual":"\u2289","NotTilde":"\u2241","NotTildeEqual":"\u2244","NotTildeFullEqual":"\u2247","NotTildeTilde":"\u2249","NotVerticalBar":"\u2224","nparallel":"\u2226","npar":"\u2226","nparsl":"\u2AFD\u20E5","npart":"\u2202\u0338","npolint":"\u2A14","npr":"\u2280","nprcue":"\u22E0","nprec":"\u2280","npreceq":"\u2AAF\u0338","npre":"\u2AAF\u0338","nrarrc":"\u2933\u0338","nrarr":"\u219B","nrArr":"\u21CF","nrarrw":"\u219D\u0338","nrightarrow":"\u219B","nRightarrow":"\u21CF","nrtri":"\u22EB","nrtrie":"\u22ED","nsc":"\u2281","nsccue":"\u22E1","nsce":"\u2AB0\u0338","Nscr":"\uD835\uDCA9","nscr":"\uD835\uDCC3","nshortmid":"\u2224","nshortparallel":"\u2226","nsim":"\u2241","nsime":"\u2244","nsimeq":"\u2244","nsmid":"\u2224","nspar":"\u2226","nsqsube":"\u22E2","nsqsupe":"\u22E3","nsub":"\u2284","nsubE":"\u2AC5\u0338","nsube":"\u2288","nsubset":"\u2282\u20D2","nsubseteq":"\u2288","nsubseteqq":"\u2AC5\u0338","nsucc":"\u2281","nsucceq":"\u2AB0\u0338","nsup":"\u2285","nsupE":"\u2AC6\u0338","nsupe":"\u2289","nsupset":"\u2283\u20D2","nsupseteq":"\u2289","nsupseteqq":"\u2AC6\u0338","ntgl":"\u2279","Ntilde":"\u00D1","ntilde":"\u00F1","ntlg":"\u2278","ntriangleleft":"\u22EA","ntrianglelefteq":"\u22EC","ntriangleright":"\u22EB","ntrianglerighteq":"\u22ED","Nu":"\u039D","nu":"\u03BD","num":"#","numero":"\u2116","numsp":"\u2007","nvap":"\u224D\u20D2","nvdash":"\u22AC","nvDash":"\u22AD","nVdash":"\u22AE","nVDash":"\u22AF","nvge":"\u2265\u20D2","nvgt":">\u20D2","nvHarr":"\u2904","nvinfin":"\u29DE","nvlArr":"\u2902","nvle":"\u2264\u20D2","nvlt":"<\u20D2","nvltrie":"\u22B4\u20D2","nvrArr":"\u2903","nvrtrie":"\u22B5\u20D2","nvsim":"\u223C\u20D2","nwarhk":"\u2923","nwarr":"\u2196","nwArr":"\u21D6","nwarrow":"\u2196","nwnear":"\u2927","Oacute":"\u00D3","oacute":"\u00F3","oast":"\u229B","Ocirc":"\u00D4","ocirc":"\u00F4","ocir":"\u229A","Ocy":"\u041E","ocy":"\u043E","odash":"\u229D","Odblac":"\u0150","odblac":"\u0151","odiv":"\u2A38","odot":"\u2299","odsold":"\u29BC","OElig":"\u0152","oelig":"\u0153","ofcir":"\u29BF","Ofr":"\uD835\uDD12","ofr":"\uD835\uDD2C","ogon":"\u02DB","Ograve":"\u00D2","ograve":"\u00F2","ogt":"\u29C1","ohbar":"\u29B5","ohm":"\u03A9","oint":"\u222E","olarr":"\u21BA","olcir":"\u29BE","olcross":"\u29BB","oline":"\u203E","olt":"\u29C0","Omacr":"\u014C","omacr":"\u014D","Omega":"\u03A9","omega":"\u03C9","Omicron":"\u039F","omicron":"\u03BF","omid":"\u29B6","ominus":"\u2296","Oopf":"\uD835\uDD46","oopf":"\uD835\uDD60","opar":"\u29B7","OpenCurlyDoubleQuote":"\u201C","OpenCurlyQuote":"\u2018","operp":"\u29B9","oplus":"\u2295","orarr":"\u21BB","Or":"\u2A54","or":"\u2228","ord":"\u2A5D","order":"\u2134","orderof":"\u2134","ordf":"\u00AA","ordm":"\u00BA","origof":"\u22B6","oror":"\u2A56","orslope":"\u2A57","orv":"\u2A5B","oS":"\u24C8","Oscr":"\uD835\uDCAA","oscr":"\u2134","Oslash":"\u00D8","oslash":"\u00F8","osol":"\u2298","Otilde":"\u00D5","otilde":"\u00F5","otimesas":"\u2A36","Otimes":"\u2A37","otimes":"\u2297","Ouml":"\u00D6","ouml":"\u00F6","ovbar":"\u233D","OverBar":"\u203E","OverBrace":"\u23DE","OverBracket":"\u23B4","OverParenthesis":"\u23DC","para":"\u00B6","parallel":"\u2225","par":"\u2225","parsim":"\u2AF3","parsl":"\u2AFD","part":"\u2202","PartialD":"\u2202","Pcy":"\u041F","pcy":"\u043F","percnt":"%","period":".","permil":"\u2030","perp":"\u22A5","pertenk":"\u2031","Pfr":"\uD835\uDD13","pfr":"\uD835\uDD2D","Phi":"\u03A6","phi":"\u03C6","phiv":"\u03D5","phmmat":"\u2133","phone":"\u260E","Pi":"\u03A0","pi":"\u03C0","pitchfork":"\u22D4","piv":"\u03D6","planck":"\u210F","planckh":"\u210E","plankv":"\u210F","plusacir":"\u2A23","plusb":"\u229E","pluscir":"\u2A22","plus":"+","plusdo":"\u2214","plusdu":"\u2A25","pluse":"\u2A72","PlusMinus":"\u00B1","plusmn":"\u00B1","plussim":"\u2A26","plustwo":"\u2A27","pm":"\u00B1","Poincareplane":"\u210C","pointint":"\u2A15","popf":"\uD835\uDD61","Popf":"\u2119","pound":"\u00A3","prap":"\u2AB7","Pr":"\u2ABB","pr":"\u227A","prcue":"\u227C","precapprox":"\u2AB7","prec":"\u227A","preccurlyeq":"\u227C","Precedes":"\u227A","PrecedesEqual":"\u2AAF","PrecedesSlantEqual":"\u227C","PrecedesTilde":"\u227E","preceq":"\u2AAF","precnapprox":"\u2AB9","precneqq":"\u2AB5","precnsim":"\u22E8","pre":"\u2AAF","prE":"\u2AB3","precsim":"\u227E","prime":"\u2032","Prime":"\u2033","primes":"\u2119","prnap":"\u2AB9","prnE":"\u2AB5","prnsim":"\u22E8","prod":"\u220F","Product":"\u220F","profalar":"\u232E","profline":"\u2312","profsurf":"\u2313","prop":"\u221D","Proportional":"\u221D","Proportion":"\u2237","propto":"\u221D","prsim":"\u227E","prurel":"\u22B0","Pscr":"\uD835\uDCAB","pscr":"\uD835\uDCC5","Psi":"\u03A8","psi":"\u03C8","puncsp":"\u2008","Qfr":"\uD835\uDD14","qfr":"\uD835\uDD2E","qint":"\u2A0C","qopf":"\uD835\uDD62","Qopf":"\u211A","qprime":"\u2057","Qscr":"\uD835\uDCAC","qscr":"\uD835\uDCC6","quaternions":"\u210D","quatint":"\u2A16","quest":"?","questeq":"\u225F","quot":"\"","QUOT":"\"","rAarr":"\u21DB","race":"\u223D\u0331","Racute":"\u0154","racute":"\u0155","radic":"\u221A","raemptyv":"\u29B3","rang":"\u27E9","Rang":"\u27EB","rangd":"\u2992","range":"\u29A5","rangle":"\u27E9","raquo":"\u00BB","rarrap":"\u2975","rarrb":"\u21E5","rarrbfs":"\u2920","rarrc":"\u2933","rarr":"\u2192","Rarr":"\u21A0","rArr":"\u21D2","rarrfs":"\u291E","rarrhk":"\u21AA","rarrlp":"\u21AC","rarrpl":"\u2945","rarrsim":"\u2974","Rarrtl":"\u2916","rarrtl":"\u21A3","rarrw":"\u219D","ratail":"\u291A","rAtail":"\u291C","ratio":"\u2236","rationals":"\u211A","rbarr":"\u290D","rBarr":"\u290F","RBarr":"\u2910","rbbrk":"\u2773","rbrace":"}","rbrack":"]","rbrke":"\u298C","rbrksld":"\u298E","rbrkslu":"\u2990","Rcaron":"\u0158","rcaron":"\u0159","Rcedil":"\u0156","rcedil":"\u0157","rceil":"\u2309","rcub":"}","Rcy":"\u0420","rcy":"\u0440","rdca":"\u2937","rdldhar":"\u2969","rdquo":"\u201D","rdquor":"\u201D","rdsh":"\u21B3","real":"\u211C","realine":"\u211B","realpart":"\u211C","reals":"\u211D","Re":"\u211C","rect":"\u25AD","reg":"\u00AE","REG":"\u00AE","ReverseElement":"\u220B","ReverseEquilibrium":"\u21CB","ReverseUpEquilibrium":"\u296F","rfisht":"\u297D","rfloor":"\u230B","rfr":"\uD835\uDD2F","Rfr":"\u211C","rHar":"\u2964","rhard":"\u21C1","rharu":"\u21C0","rharul":"\u296C","Rho":"\u03A1","rho":"\u03C1","rhov":"\u03F1","RightAngleBracket":"\u27E9","RightArrowBar":"\u21E5","rightarrow":"\u2192","RightArrow":"\u2192","Rightarrow":"\u21D2","RightArrowLeftArrow":"\u21C4","rightarrowtail":"\u21A3","RightCeiling":"\u2309","RightDoubleBracket":"\u27E7","RightDownTeeVector":"\u295D","RightDownVectorBar":"\u2955","RightDownVector":"\u21C2","RightFloor":"\u230B","rightharpoondown":"\u21C1","rightharpoonup":"\u21C0","rightleftarrows":"\u21C4","rightleftharpoons":"\u21CC","rightrightarrows":"\u21C9","rightsquigarrow":"\u219D","RightTeeArrow":"\u21A6","RightTee":"\u22A2","RightTeeVector":"\u295B","rightthreetimes":"\u22CC","RightTriangleBar":"\u29D0","RightTriangle":"\u22B3","RightTriangleEqual":"\u22B5","RightUpDownVector":"\u294F","RightUpTeeVector":"\u295C","RightUpVectorBar":"\u2954","RightUpVector":"\u21BE","RightVectorBar":"\u2953","RightVector":"\u21C0","ring":"\u02DA","risingdotseq":"\u2253","rlarr":"\u21C4","rlhar":"\u21CC","rlm":"\u200F","rmoustache":"\u23B1","rmoust":"\u23B1","rnmid":"\u2AEE","roang":"\u27ED","roarr":"\u21FE","robrk":"\u27E7","ropar":"\u2986","ropf":"\uD835\uDD63","Ropf":"\u211D","roplus":"\u2A2E","rotimes":"\u2A35","RoundImplies":"\u2970","rpar":")","rpargt":"\u2994","rppolint":"\u2A12","rrarr":"\u21C9","Rrightarrow":"\u21DB","rsaquo":"\u203A","rscr":"\uD835\uDCC7","Rscr":"\u211B","rsh":"\u21B1","Rsh":"\u21B1","rsqb":"]","rsquo":"\u2019","rsquor":"\u2019","rthree":"\u22CC","rtimes":"\u22CA","rtri":"\u25B9","rtrie":"\u22B5","rtrif":"\u25B8","rtriltri":"\u29CE","RuleDelayed":"\u29F4","ruluhar":"\u2968","rx":"\u211E","Sacute":"\u015A","sacute":"\u015B","sbquo":"\u201A","scap":"\u2AB8","Scaron":"\u0160","scaron":"\u0161","Sc":"\u2ABC","sc":"\u227B","sccue":"\u227D","sce":"\u2AB0","scE":"\u2AB4","Scedil":"\u015E","scedil":"\u015F","Scirc":"\u015C","scirc":"\u015D","scnap":"\u2ABA","scnE":"\u2AB6","scnsim":"\u22E9","scpolint":"\u2A13","scsim":"\u227F","Scy":"\u0421","scy":"\u0441","sdotb":"\u22A1","sdot":"\u22C5","sdote":"\u2A66","searhk":"\u2925","searr":"\u2198","seArr":"\u21D8","searrow":"\u2198","sect":"\u00A7","semi":";","seswar":"\u2929","setminus":"\u2216","setmn":"\u2216","sext":"\u2736","Sfr":"\uD835\uDD16","sfr":"\uD835\uDD30","sfrown":"\u2322","sharp":"\u266F","SHCHcy":"\u0429","shchcy":"\u0449","SHcy":"\u0428","shcy":"\u0448","ShortDownArrow":"\u2193","ShortLeftArrow":"\u2190","shortmid":"\u2223","shortparallel":"\u2225","ShortRightArrow":"\u2192","ShortUpArrow":"\u2191","shy":"\u00AD","Sigma":"\u03A3","sigma":"\u03C3","sigmaf":"\u03C2","sigmav":"\u03C2","sim":"\u223C","simdot":"\u2A6A","sime":"\u2243","simeq":"\u2243","simg":"\u2A9E","simgE":"\u2AA0","siml":"\u2A9D","simlE":"\u2A9F","simne":"\u2246","simplus":"\u2A24","simrarr":"\u2972","slarr":"\u2190","SmallCircle":"\u2218","smallsetminus":"\u2216","smashp":"\u2A33","smeparsl":"\u29E4","smid":"\u2223","smile":"\u2323","smt":"\u2AAA","smte":"\u2AAC","smtes":"\u2AAC\uFE00","SOFTcy":"\u042C","softcy":"\u044C","solbar":"\u233F","solb":"\u29C4","sol":"/","Sopf":"\uD835\uDD4A","sopf":"\uD835\uDD64","spades":"\u2660","spadesuit":"\u2660","spar":"\u2225","sqcap":"\u2293","sqcaps":"\u2293\uFE00","sqcup":"\u2294","sqcups":"\u2294\uFE00","Sqrt":"\u221A","sqsub":"\u228F","sqsube":"\u2291","sqsubset":"\u228F","sqsubseteq":"\u2291","sqsup":"\u2290","sqsupe":"\u2292","sqsupset":"\u2290","sqsupseteq":"\u2292","square":"\u25A1","Square":"\u25A1","SquareIntersection":"\u2293","SquareSubset":"\u228F","SquareSubsetEqual":"\u2291","SquareSuperset":"\u2290","SquareSupersetEqual":"\u2292","SquareUnion":"\u2294","squarf":"\u25AA","squ":"\u25A1","squf":"\u25AA","srarr":"\u2192","Sscr":"\uD835\uDCAE","sscr":"\uD835\uDCC8","ssetmn":"\u2216","ssmile":"\u2323","sstarf":"\u22C6","Star":"\u22C6","star":"\u2606","starf":"\u2605","straightepsilon":"\u03F5","straightphi":"\u03D5","strns":"\u00AF","sub":"\u2282","Sub":"\u22D0","subdot":"\u2ABD","subE":"\u2AC5","sube":"\u2286","subedot":"\u2AC3","submult":"\u2AC1","subnE":"\u2ACB","subne":"\u228A","subplus":"\u2ABF","subrarr":"\u2979","subset":"\u2282","Subset":"\u22D0","subseteq":"\u2286","subseteqq":"\u2AC5","SubsetEqual":"\u2286","subsetneq":"\u228A","subsetneqq":"\u2ACB","subsim":"\u2AC7","subsub":"\u2AD5","subsup":"\u2AD3","succapprox":"\u2AB8","succ":"\u227B","succcurlyeq":"\u227D","Succeeds":"\u227B","SucceedsEqual":"\u2AB0","SucceedsSlantEqual":"\u227D","SucceedsTilde":"\u227F","succeq":"\u2AB0","succnapprox":"\u2ABA","succneqq":"\u2AB6","succnsim":"\u22E9","succsim":"\u227F","SuchThat":"\u220B","sum":"\u2211","Sum":"\u2211","sung":"\u266A","sup1":"\u00B9","sup2":"\u00B2","sup3":"\u00B3","sup":"\u2283","Sup":"\u22D1","supdot":"\u2ABE","supdsub":"\u2AD8","supE":"\u2AC6","supe":"\u2287","supedot":"\u2AC4","Superset":"\u2283","SupersetEqual":"\u2287","suphsol":"\u27C9","suphsub":"\u2AD7","suplarr":"\u297B","supmult":"\u2AC2","supnE":"\u2ACC","supne":"\u228B","supplus":"\u2AC0","supset":"\u2283","Supset":"\u22D1","supseteq":"\u2287","supseteqq":"\u2AC6","supsetneq":"\u228B","supsetneqq":"\u2ACC","supsim":"\u2AC8","supsub":"\u2AD4","supsup":"\u2AD6","swarhk":"\u2926","swarr":"\u2199","swArr":"\u21D9","swarrow":"\u2199","swnwar":"\u292A","szlig":"\u00DF","Tab":"\t","target":"\u2316","Tau":"\u03A4","tau":"\u03C4","tbrk":"\u23B4","Tcaron":"\u0164","tcaron":"\u0165","Tcedil":"\u0162","tcedil":"\u0163","Tcy":"\u0422","tcy":"\u0442","tdot":"\u20DB","telrec":"\u2315","Tfr":"\uD835\uDD17","tfr":"\uD835\uDD31","there4":"\u2234","therefore":"\u2234","Therefore":"\u2234","Theta":"\u0398","theta":"\u03B8","thetasym":"\u03D1","thetav":"\u03D1","thickapprox":"\u2248","thicksim":"\u223C","ThickSpace":"\u205F\u200A","ThinSpace":"\u2009","thinsp":"\u2009","thkap":"\u2248","thksim":"\u223C","THORN":"\u00DE","thorn":"\u00FE","tilde":"\u02DC","Tilde":"\u223C","TildeEqual":"\u2243","TildeFullEqual":"\u2245","TildeTilde":"\u2248","timesbar":"\u2A31","timesb":"\u22A0","times":"\u00D7","timesd":"\u2A30","tint":"\u222D","toea":"\u2928","topbot":"\u2336","topcir":"\u2AF1","top":"\u22A4","Topf":"\uD835\uDD4B","topf":"\uD835\uDD65","topfork":"\u2ADA","tosa":"\u2929","tprime":"\u2034","trade":"\u2122","TRADE":"\u2122","triangle":"\u25B5","triangledown":"\u25BF","triangleleft":"\u25C3","trianglelefteq":"\u22B4","triangleq":"\u225C","triangleright":"\u25B9","trianglerighteq":"\u22B5","tridot":"\u25EC","trie":"\u225C","triminus":"\u2A3A","TripleDot":"\u20DB","triplus":"\u2A39","trisb":"\u29CD","tritime":"\u2A3B","trpezium":"\u23E2","Tscr":"\uD835\uDCAF","tscr":"\uD835\uDCC9","TScy":"\u0426","tscy":"\u0446","TSHcy":"\u040B","tshcy":"\u045B","Tstrok":"\u0166","tstrok":"\u0167","twixt":"\u226C","twoheadleftarrow":"\u219E","twoheadrightarrow":"\u21A0","Uacute":"\u00DA","uacute":"\u00FA","uarr":"\u2191","Uarr":"\u219F","uArr":"\u21D1","Uarrocir":"\u2949","Ubrcy":"\u040E","ubrcy":"\u045E","Ubreve":"\u016C","ubreve":"\u016D","Ucirc":"\u00DB","ucirc":"\u00FB","Ucy":"\u0423","ucy":"\u0443","udarr":"\u21C5","Udblac":"\u0170","udblac":"\u0171","udhar":"\u296E","ufisht":"\u297E","Ufr":"\uD835\uDD18","ufr":"\uD835\uDD32","Ugrave":"\u00D9","ugrave":"\u00F9","uHar":"\u2963","uharl":"\u21BF","uharr":"\u21BE","uhblk":"\u2580","ulcorn":"\u231C","ulcorner":"\u231C","ulcrop":"\u230F","ultri":"\u25F8","Umacr":"\u016A","umacr":"\u016B","uml":"\u00A8","UnderBar":"_","UnderBrace":"\u23DF","UnderBracket":"\u23B5","UnderParenthesis":"\u23DD","Union":"\u22C3","UnionPlus":"\u228E","Uogon":"\u0172","uogon":"\u0173","Uopf":"\uD835\uDD4C","uopf":"\uD835\uDD66","UpArrowBar":"\u2912","uparrow":"\u2191","UpArrow":"\u2191","Uparrow":"\u21D1","UpArrowDownArrow":"\u21C5","updownarrow":"\u2195","UpDownArrow":"\u2195","Updownarrow":"\u21D5","UpEquilibrium":"\u296E","upharpoonleft":"\u21BF","upharpoonright":"\u21BE","uplus":"\u228E","UpperLeftArrow":"\u2196","UpperRightArrow":"\u2197","upsi":"\u03C5","Upsi":"\u03D2","upsih":"\u03D2","Upsilon":"\u03A5","upsilon":"\u03C5","UpTeeArrow":"\u21A5","UpTee":"\u22A5","upuparrows":"\u21C8","urcorn":"\u231D","urcorner":"\u231D","urcrop":"\u230E","Uring":"\u016E","uring":"\u016F","urtri":"\u25F9","Uscr":"\uD835\uDCB0","uscr":"\uD835\uDCCA","utdot":"\u22F0","Utilde":"\u0168","utilde":"\u0169","utri":"\u25B5","utrif":"\u25B4","uuarr":"\u21C8","Uuml":"\u00DC","uuml":"\u00FC","uwangle":"\u29A7","vangrt":"\u299C","varepsilon":"\u03F5","varkappa":"\u03F0","varnothing":"\u2205","varphi":"\u03D5","varpi":"\u03D6","varpropto":"\u221D","varr":"\u2195","vArr":"\u21D5","varrho":"\u03F1","varsigma":"\u03C2","varsubsetneq":"\u228A\uFE00","varsubsetneqq":"\u2ACB\uFE00","varsupsetneq":"\u228B\uFE00","varsupsetneqq":"\u2ACC\uFE00","vartheta":"\u03D1","vartriangleleft":"\u22B2","vartriangleright":"\u22B3","vBar":"\u2AE8","Vbar":"\u2AEB","vBarv":"\u2AE9","Vcy":"\u0412","vcy":"\u0432","vdash":"\u22A2","vDash":"\u22A8","Vdash":"\u22A9","VDash":"\u22AB","Vdashl":"\u2AE6","veebar":"\u22BB","vee":"\u2228","Vee":"\u22C1","veeeq":"\u225A","vellip":"\u22EE","verbar":"|","Verbar":"\u2016","vert":"|","Vert":"\u2016","VerticalBar":"\u2223","VerticalLine":"|","VerticalSeparator":"\u2758","VerticalTilde":"\u2240","VeryThinSpace":"\u200A","Vfr":"\uD835\uDD19","vfr":"\uD835\uDD33","vltri":"\u22B2","vnsub":"\u2282\u20D2","vnsup":"\u2283\u20D2","Vopf":"\uD835\uDD4D","vopf":"\uD835\uDD67","vprop":"\u221D","vrtri":"\u22B3","Vscr":"\uD835\uDCB1","vscr":"\uD835\uDCCB","vsubnE":"\u2ACB\uFE00","vsubne":"\u228A\uFE00","vsupnE":"\u2ACC\uFE00","vsupne":"\u228B\uFE00","Vvdash":"\u22AA","vzigzag":"\u299A","Wcirc":"\u0174","wcirc":"\u0175","wedbar":"\u2A5F","wedge":"\u2227","Wedge":"\u22C0","wedgeq":"\u2259","weierp":"\u2118","Wfr":"\uD835\uDD1A","wfr":"\uD835\uDD34","Wopf":"\uD835\uDD4E","wopf":"\uD835\uDD68","wp":"\u2118","wr":"\u2240","wreath":"\u2240","Wscr":"\uD835\uDCB2","wscr":"\uD835\uDCCC","xcap":"\u22C2","xcirc":"\u25EF","xcup":"\u22C3","xdtri":"\u25BD","Xfr":"\uD835\uDD1B","xfr":"\uD835\uDD35","xharr":"\u27F7","xhArr":"\u27FA","Xi":"\u039E","xi":"\u03BE","xlarr":"\u27F5","xlArr":"\u27F8","xmap":"\u27FC","xnis":"\u22FB","xodot":"\u2A00","Xopf":"\uD835\uDD4F","xopf":"\uD835\uDD69","xoplus":"\u2A01","xotime":"\u2A02","xrarr":"\u27F6","xrArr":"\u27F9","Xscr":"\uD835\uDCB3","xscr":"\uD835\uDCCD","xsqcup":"\u2A06","xuplus":"\u2A04","xutri":"\u25B3","xvee":"\u22C1","xwedge":"\u22C0","Yacute":"\u00DD","yacute":"\u00FD","YAcy":"\u042F","yacy":"\u044F","Ycirc":"\u0176","ycirc":"\u0177","Ycy":"\u042B","ycy":"\u044B","yen":"\u00A5","Yfr":"\uD835\uDD1C","yfr":"\uD835\uDD36","YIcy":"\u0407","yicy":"\u0457","Yopf":"\uD835\uDD50","yopf":"\uD835\uDD6A","Yscr":"\uD835\uDCB4","yscr":"\uD835\uDCCE","YUcy":"\u042E","yucy":"\u044E","yuml":"\u00FF","Yuml":"\u0178","Zacute":"\u0179","zacute":"\u017A","Zcaron":"\u017D","zcaron":"\u017E","Zcy":"\u0417","zcy":"\u0437","Zdot":"\u017B","zdot":"\u017C","zeetrf":"\u2128","ZeroWidthSpace":"\u200B","Zeta":"\u0396","zeta":"\u03B6","zfr":"\uD835\uDD37","Zfr":"\u2128","ZHcy":"\u0416","zhcy":"\u0436","zigrarr":"\u21DD","zopf":"\uD835\uDD6B","Zopf":"\u2124","Zscr":"\uD835\uDCB5","zscr":"\uD835\uDCCF","zwj":"\u200D","zwnj":"\u200C"}
},{}],24:[function(require,module,exports){
module.exports={"Aacute":"\u00C1","aacute":"\u00E1","Acirc":"\u00C2","acirc":"\u00E2","acute":"\u00B4","AElig":"\u00C6","aelig":"\u00E6","Agrave":"\u00C0","agrave":"\u00E0","amp":"&","AMP":"&","Aring":"\u00C5","aring":"\u00E5","Atilde":"\u00C3","atilde":"\u00E3","Auml":"\u00C4","auml":"\u00E4","brvbar":"\u00A6","Ccedil":"\u00C7","ccedil":"\u00E7","cedil":"\u00B8","cent":"\u00A2","copy":"\u00A9","COPY":"\u00A9","curren":"\u00A4","deg":"\u00B0","divide":"\u00F7","Eacute":"\u00C9","eacute":"\u00E9","Ecirc":"\u00CA","ecirc":"\u00EA","Egrave":"\u00C8","egrave":"\u00E8","ETH":"\u00D0","eth":"\u00F0","Euml":"\u00CB","euml":"\u00EB","frac12":"\u00BD","frac14":"\u00BC","frac34":"\u00BE","gt":">","GT":">","Iacute":"\u00CD","iacute":"\u00ED","Icirc":"\u00CE","icirc":"\u00EE","iexcl":"\u00A1","Igrave":"\u00CC","igrave":"\u00EC","iquest":"\u00BF","Iuml":"\u00CF","iuml":"\u00EF","laquo":"\u00AB","lt":"<","LT":"<","macr":"\u00AF","micro":"\u00B5","middot":"\u00B7","nbsp":"\u00A0","not":"\u00AC","Ntilde":"\u00D1","ntilde":"\u00F1","Oacute":"\u00D3","oacute":"\u00F3","Ocirc":"\u00D4","ocirc":"\u00F4","Ograve":"\u00D2","ograve":"\u00F2","ordf":"\u00AA","ordm":"\u00BA","Oslash":"\u00D8","oslash":"\u00F8","Otilde":"\u00D5","otilde":"\u00F5","Ouml":"\u00D6","ouml":"\u00F6","para":"\u00B6","plusmn":"\u00B1","pound":"\u00A3","quot":"\"","QUOT":"\"","raquo":"\u00BB","reg":"\u00AE","REG":"\u00AE","sect":"\u00A7","shy":"\u00AD","sup1":"\u00B9","sup2":"\u00B2","sup3":"\u00B3","szlig":"\u00DF","THORN":"\u00DE","thorn":"\u00FE","times":"\u00D7","Uacute":"\u00DA","uacute":"\u00FA","Ucirc":"\u00DB","ucirc":"\u00FB","Ugrave":"\u00D9","ugrave":"\u00F9","uml":"\u00A8","Uuml":"\u00DC","uuml":"\u00FC","Yacute":"\u00DD","yacute":"\u00FD","yen":"\u00A5","yuml":"\u00FF"}
},{}],25:[function(require,module,exports){
module.exports={"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""}

},{}],26:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var objectCreate = Object.create || objectCreatePolyfill
var objectKeys = Object.keys || objectKeysPolyfill
var bind = Function.prototype.bind || functionBindPolyfill

function EventEmitter() {
  if (!this._events || !Object.prototype.hasOwnProperty.call(this, '_events')) {
    this._events = objectCreate(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

var hasDefineProperty;
try {
  var o = {};
  if (Object.defineProperty) Object.defineProperty(o, 'x', { value: 0 });
  hasDefineProperty = o.x === 0;
} catch (err) { hasDefineProperty = false }
if (hasDefineProperty) {
  Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
      return defaultMaxListeners;
    },
    set: function(arg) {
      // check whether the input is a positive number (whose value is zero or
      // greater and not a NaN).
      if (typeof arg !== 'number' || arg < 0 || arg !== arg)
        throw new TypeError('"defaultMaxListeners" must be a positive number');
      defaultMaxListeners = arg;
    }
  });
} else {
  EventEmitter.defaultMaxListeners = defaultMaxListeners;
}

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || isNaN(n))
    throw new TypeError('"n" argument must be a positive number');
  this._maxListeners = n;
  return this;
};

function $getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return $getMaxListeners(this);
};

// These standalone emit* functions are used to optimize calling of event
// handlers for fast cases because emit() itself often has a variable number of
// arguments and can be deoptimized because of that. These functions always have
// the same number of arguments and thus do not get deoptimized, so the code
// inside them can execute faster.
function emitNone(handler, isFn, self) {
  if (isFn)
    handler.call(self);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self);
  }
}
function emitOne(handler, isFn, self, arg1) {
  if (isFn)
    handler.call(self, arg1);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self, arg1);
  }
}
function emitTwo(handler, isFn, self, arg1, arg2) {
  if (isFn)
    handler.call(self, arg1, arg2);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self, arg1, arg2);
  }
}
function emitThree(handler, isFn, self, arg1, arg2, arg3) {
  if (isFn)
    handler.call(self, arg1, arg2, arg3);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self, arg1, arg2, arg3);
  }
}

function emitMany(handler, isFn, self, args) {
  if (isFn)
    handler.apply(self, args);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].apply(self, args);
  }
}

EventEmitter.prototype.emit = function emit(type) {
  var er, handler, len, args, i, events;
  var doError = (type === 'error');

  events = this._events;
  if (events)
    doError = (doError && events.error == null);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    if (arguments.length > 1)
      er = arguments[1];
    if (er instanceof Error) {
      throw er; // Unhandled 'error' event
    } else {
      // At least give some kind of context to the user
      var err = new Error('Unhandled "error" event. (' + er + ')');
      err.context = er;
      throw err;
    }
    return false;
  }

  handler = events[type];

  if (!handler)
    return false;

  var isFn = typeof handler === 'function';
  len = arguments.length;
  switch (len) {
      // fast cases
    case 1:
      emitNone(handler, isFn, this);
      break;
    case 2:
      emitOne(handler, isFn, this, arguments[1]);
      break;
    case 3:
      emitTwo(handler, isFn, this, arguments[1], arguments[2]);
      break;
    case 4:
      emitThree(handler, isFn, this, arguments[1], arguments[2], arguments[3]);
      break;
      // slower
    default:
      args = new Array(len - 1);
      for (i = 1; i < len; i++)
        args[i - 1] = arguments[i];
      emitMany(handler, isFn, this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  if (typeof listener !== 'function')
    throw new TypeError('"listener" argument must be a function');

  events = target._events;
  if (!events) {
    events = target._events = objectCreate(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener) {
      target.emit('newListener', type,
          listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (!existing) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
          prepend ? [listener, existing] : [existing, listener];
    } else {
      // If we've already got an array, just append.
      if (prepend) {
        existing.unshift(listener);
      } else {
        existing.push(listener);
      }
    }

    // Check for listener leak
    if (!existing.warned) {
      m = $getMaxListeners(target);
      if (m && m > 0 && existing.length > m) {
        existing.warned = true;
        var w = new Error('Possible EventEmitter memory leak detected. ' +
            existing.length + ' "' + String(type) + '" listeners ' +
            'added. Use emitter.setMaxListeners() to ' +
            'increase limit.');
        w.name = 'MaxListenersExceededWarning';
        w.emitter = target;
        w.type = type;
        w.count = existing.length;
        if (typeof console === 'object' && console.warn) {
          console.warn('%s: %s', w.name, w.message);
        }
      }
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    switch (arguments.length) {
      case 0:
        return this.listener.call(this.target);
      case 1:
        return this.listener.call(this.target, arguments[0]);
      case 2:
        return this.listener.call(this.target, arguments[0], arguments[1]);
      case 3:
        return this.listener.call(this.target, arguments[0], arguments[1],
            arguments[2]);
      default:
        var args = new Array(arguments.length);
        for (var i = 0; i < args.length; ++i)
          args[i] = arguments[i];
        this.listener.apply(this.target, args);
    }
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = bind.call(onceWrapper, state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  if (typeof listener !== 'function')
    throw new TypeError('"listener" argument must be a function');
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      if (typeof listener !== 'function')
        throw new TypeError('"listener" argument must be a function');
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      if (typeof listener !== 'function')
        throw new TypeError('"listener" argument must be a function');

      events = this._events;
      if (!events)
        return this;

      list = events[type];
      if (!list)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = objectCreate(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else
          spliceOne(list, position);

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (!events)
        return this;

      // not listening for removeListener, no need to emit
      if (!events.removeListener) {
        if (arguments.length === 0) {
          this._events = objectCreate(null);
          this._eventsCount = 0;
        } else if (events[type]) {
          if (--this._eventsCount === 0)
            this._events = objectCreate(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = objectKeys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = objectCreate(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (!events)
    return [];

  var evlistener = events[type];
  if (!evlistener)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
};

// About 1.5x faster than the two-arg version of Array#splice().
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)
    list[i] = list[k];
  list.pop();
}

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function objectCreatePolyfill(proto) {
  var F = function() {};
  F.prototype = proto;
  return new F;
}
function objectKeysPolyfill(obj) {
  var keys = [];
  for (var k in obj) if (Object.prototype.hasOwnProperty.call(obj, k)) {
    keys.push(k);
  }
  return k;
}
function functionBindPolyfill(context) {
  var fn = this;
  return function () {
    return fn.apply(context, arguments);
  };
}

},{}],27:[function(require,module,exports){
module.exports = CollectingHandler;

function CollectingHandler(cbs) {
    this._cbs = cbs || {};
    this.events = [];
}

var EVENTS = require("./").EVENTS;
Object.keys(EVENTS).forEach(function(name) {
    if (EVENTS[name] === 0) {
        name = "on" + name;
        CollectingHandler.prototype[name] = function() {
            this.events.push([name]);
            if (this._cbs[name]) this._cbs[name]();
        };
    } else if (EVENTS[name] === 1) {
        name = "on" + name;
        CollectingHandler.prototype[name] = function(a) {
            this.events.push([name, a]);
            if (this._cbs[name]) this._cbs[name](a);
        };
    } else if (EVENTS[name] === 2) {
        name = "on" + name;
        CollectingHandler.prototype[name] = function(a, b) {
            this.events.push([name, a, b]);
            if (this._cbs[name]) this._cbs[name](a, b);
        };
    } else {
        throw Error("wrong number of arguments");
    }
});

CollectingHandler.prototype.onreset = function() {
    this.events = [];
    if (this._cbs.onreset) this._cbs.onreset();
};

CollectingHandler.prototype.restart = function() {
    if (this._cbs.onreset) this._cbs.onreset();

    for (var i = 0, len = this.events.length; i < len; i++) {
        if (this._cbs[this.events[i][0]]) {
            var num = this.events[i].length;

            if (num === 1) {
                this._cbs[this.events[i][0]]();
            } else if (num === 2) {
                this._cbs[this.events[i][0]](this.events[i][1]);
            } else {
                this._cbs[this.events[i][0]](
                    this.events[i][1],
                    this.events[i][2]
                );
            }
        }
    }
};

},{"./":34}],28:[function(require,module,exports){
var DomHandler = require("domhandler");
var DomUtils = require("domutils");

//TODO: make this a streamable handler
function FeedHandler(callback, options) {
    this.init(callback, options);
}

require("inherits")(FeedHandler, DomHandler);

FeedHandler.prototype.init = DomHandler;

function getElements(what, where) {
    return DomUtils.getElementsByTagName(what, where, true);
}
function getOneElement(what, where) {
    return DomUtils.getElementsByTagName(what, where, true, 1)[0];
}
function fetch(what, where, recurse) {
    return DomUtils.getText(
        DomUtils.getElementsByTagName(what, where, recurse, 1)
    ).trim();
}

function addConditionally(obj, prop, what, where, recurse) {
    var tmp = fetch(what, where, recurse);
    if (tmp) obj[prop] = tmp;
}

var isValidFeed = function(value) {
    return value === "rss" || value === "feed" || value === "rdf:RDF";
};

FeedHandler.prototype.onend = function() {
    var feed = {},
        feedRoot = getOneElement(isValidFeed, this.dom),
        tmp,
        childs;

    if (feedRoot) {
        if (feedRoot.name === "feed") {
            childs = feedRoot.children;

            feed.type = "atom";
            addConditionally(feed, "id", "id", childs);
            addConditionally(feed, "title", "title", childs);
            if (
                (tmp = getOneElement("link", childs)) &&
                (tmp = tmp.attribs) &&
                (tmp = tmp.href)
            )
                feed.link = tmp;
            addConditionally(feed, "description", "subtitle", childs);
            if ((tmp = fetch("updated", childs))) feed.updated = new Date(tmp);
            addConditionally(feed, "author", "email", childs, true);

            feed.items = getElements("entry", childs).map(function(item) {
                var entry = {},
                    tmp;

                item = item.children;

                addConditionally(entry, "id", "id", item);
                addConditionally(entry, "title", "title", item);
                if (
                    (tmp = getOneElement("link", item)) &&
                    (tmp = tmp.attribs) &&
                    (tmp = tmp.href)
                )
                    entry.link = tmp;
                if ((tmp = fetch("summary", item) || fetch("content", item)))
                    entry.description = tmp;
                if ((tmp = fetch("updated", item)))
                    entry.pubDate = new Date(tmp);
                return entry;
            });
        } else {
            childs = getOneElement("channel", feedRoot.children).children;

            feed.type = feedRoot.name.substr(0, 3);
            feed.id = "";
            addConditionally(feed, "title", "title", childs);
            addConditionally(feed, "link", "link", childs);
            addConditionally(feed, "description", "description", childs);
            if ((tmp = fetch("lastBuildDate", childs)))
                feed.updated = new Date(tmp);
            addConditionally(feed, "author", "managingEditor", childs, true);

            feed.items = getElements("item", feedRoot.children).map(function(
                item
            ) {
                var entry = {},
                    tmp;

                item = item.children;

                addConditionally(entry, "id", "guid", item);
                addConditionally(entry, "title", "title", item);
                addConditionally(entry, "link", "link", item);
                addConditionally(entry, "description", "description", item);
                if ((tmp = fetch("pubDate", item)))
                    entry.pubDate = new Date(tmp);
                return entry;
            });
        }
    }
    this.dom = feed;
    DomHandler.prototype._handleCallback.call(
        this,
        feedRoot ? null : Error("couldn't find root of feed")
    );
};

module.exports = FeedHandler;

},{"domhandler":8,"domutils":11,"inherits":36}],29:[function(require,module,exports){
var Tokenizer = require("./Tokenizer.js");

/*
	Options:

	xmlMode: Disables the special behavior for script/style tags (false by default)
	lowerCaseAttributeNames: call .toLowerCase for each attribute name (true if xmlMode is `false`)
	lowerCaseTags: call .toLowerCase for each tag name (true if xmlMode is `false`)
*/

/*
	Callbacks:

	oncdataend,
	oncdatastart,
	onclosetag,
	oncomment,
	oncommentend,
	onerror,
	onopentag,
	onprocessinginstruction,
	onreset,
	ontext
*/

var formTags = {
    input: true,
    option: true,
    optgroup: true,
    select: true,
    button: true,
    datalist: true,
    textarea: true
};

var openImpliesClose = {
    tr: { tr: true, th: true, td: true },
    th: { th: true },
    td: { thead: true, th: true, td: true },
    body: { head: true, link: true, script: true },
    li: { li: true },
    p: { p: true },
    h1: { p: true },
    h2: { p: true },
    h3: { p: true },
    h4: { p: true },
    h5: { p: true },
    h6: { p: true },
    select: formTags,
    input: formTags,
    output: formTags,
    button: formTags,
    datalist: formTags,
    textarea: formTags,
    option: { option: true },
    optgroup: { optgroup: true }
};

var voidElements = {
    __proto__: null,
    area: true,
    base: true,
    basefont: true,
    br: true,
    col: true,
    command: true,
    embed: true,
    frame: true,
    hr: true,
    img: true,
    input: true,
    isindex: true,
    keygen: true,
    link: true,
    meta: true,
    param: true,
    source: true,
    track: true,
    wbr: true
};

var foreignContextElements = {
    __proto__: null,
    math: true,
    svg: true
};
var htmlIntegrationElements = {
    __proto__: null,
    mi: true,
    mo: true,
    mn: true,
    ms: true,
    mtext: true,
    "annotation-xml": true,
    foreignObject: true,
    desc: true,
    title: true
};

var re_nameEnd = /\s|\//;

function Parser(cbs, options) {
    this._options = options || {};
    this._cbs = cbs || {};

    this._tagname = "";
    this._attribname = "";
    this._attribvalue = "";
    this._attribs = null;
    this._stack = [];
    this._foreignContext = [];

    this.startIndex = 0;
    this.endIndex = null;

    this._lowerCaseTagNames =
        "lowerCaseTags" in this._options
            ? !!this._options.lowerCaseTags
            : !this._options.xmlMode;
    this._lowerCaseAttributeNames =
        "lowerCaseAttributeNames" in this._options
            ? !!this._options.lowerCaseAttributeNames
            : !this._options.xmlMode;

    if (this._options.Tokenizer) {
        Tokenizer = this._options.Tokenizer;
    }
    this._tokenizer = new Tokenizer(this._options, this);

    if (this._cbs.onparserinit) this._cbs.onparserinit(this);
}

require("inherits")(Parser, require("events").EventEmitter);

Parser.prototype._updatePosition = function(initialOffset) {
    if (this.endIndex === null) {
        if (this._tokenizer._sectionStart <= initialOffset) {
            this.startIndex = 0;
        } else {
            this.startIndex = this._tokenizer._sectionStart - initialOffset;
        }
    } else this.startIndex = this.endIndex + 1;
    this.endIndex = this._tokenizer.getAbsoluteIndex();
};

//Tokenizer event handlers
Parser.prototype.ontext = function(data) {
    this._updatePosition(1);
    this.endIndex--;

    if (this._cbs.ontext) this._cbs.ontext(data);
};

Parser.prototype.onopentagname = function(name) {
    if (this._lowerCaseTagNames) {
        name = name.toLowerCase();
    }

    this._tagname = name;

    if (!this._options.xmlMode && name in openImpliesClose) {
        for (
            var el;
            (el = this._stack[this._stack.length - 1]) in
            openImpliesClose[name];
            this.onclosetag(el)
        );
    }

    if (this._options.xmlMode || !(name in voidElements)) {
        this._stack.push(name);
        if (name in foreignContextElements) this._foreignContext.push(true);
        else if (name in htmlIntegrationElements)
            this._foreignContext.push(false);
    }

    if (this._cbs.onopentagname) this._cbs.onopentagname(name);
    if (this._cbs.onopentag) this._attribs = {};
};

Parser.prototype.onopentagend = function() {
    this._updatePosition(1);

    if (this._attribs) {
        if (this._cbs.onopentag)
            this._cbs.onopentag(this._tagname, this._attribs);
        this._attribs = null;
    }

    if (
        !this._options.xmlMode &&
        this._cbs.onclosetag &&
        this._tagname in voidElements
    ) {
        this._cbs.onclosetag(this._tagname);
    }

    this._tagname = "";
};

Parser.prototype.onclosetag = function(name) {
    this._updatePosition(1);

    if (this._lowerCaseTagNames) {
        name = name.toLowerCase();
    }
    
    if (name in foreignContextElements || name in htmlIntegrationElements) {
        this._foreignContext.pop();
    }

    if (
        this._stack.length &&
        (!(name in voidElements) || this._options.xmlMode)
    ) {
        var pos = this._stack.lastIndexOf(name);
        if (pos !== -1) {
            if (this._cbs.onclosetag) {
                pos = this._stack.length - pos;
                while (pos--) this._cbs.onclosetag(this._stack.pop());
            } else this._stack.length = pos;
        } else if (name === "p" && !this._options.xmlMode) {
            this.onopentagname(name);
            this._closeCurrentTag();
        }
    } else if (!this._options.xmlMode && (name === "br" || name === "p")) {
        this.onopentagname(name);
        this._closeCurrentTag();
    }
};

Parser.prototype.onselfclosingtag = function() {
    if (
        this._options.xmlMode ||
        this._options.recognizeSelfClosing ||
        this._foreignContext[this._foreignContext.length - 1]
    ) {
        this._closeCurrentTag();
    } else {
        this.onopentagend();
    }
};

Parser.prototype._closeCurrentTag = function() {
    var name = this._tagname;

    this.onopentagend();

    //self-closing tags will be on the top of the stack
    //(cheaper check than in onclosetag)
    if (this._stack[this._stack.length - 1] === name) {
        if (this._cbs.onclosetag) {
            this._cbs.onclosetag(name);
        }
        this._stack.pop();
        
    }
};

Parser.prototype.onattribname = function(name) {
    if (this._lowerCaseAttributeNames) {
        name = name.toLowerCase();
    }
    this._attribname = name;
};

Parser.prototype.onattribdata = function(value) {
    this._attribvalue += value;
};

Parser.prototype.onattribend = function() {
    if (this._cbs.onattribute)
        this._cbs.onattribute(this._attribname, this._attribvalue);
    if (
        this._attribs &&
        !Object.prototype.hasOwnProperty.call(this._attribs, this._attribname)
    ) {
        this._attribs[this._attribname] = this._attribvalue;
    }
    this._attribname = "";
    this._attribvalue = "";
};

Parser.prototype._getInstructionName = function(value) {
    var idx = value.search(re_nameEnd),
        name = idx < 0 ? value : value.substr(0, idx);

    if (this._lowerCaseTagNames) {
        name = name.toLowerCase();
    }

    return name;
};

Parser.prototype.ondeclaration = function(value) {
    if (this._cbs.onprocessinginstruction) {
        var name = this._getInstructionName(value);
        this._cbs.onprocessinginstruction("!" + name, "!" + value);
    }
};

Parser.prototype.onprocessinginstruction = function(value) {
    if (this._cbs.onprocessinginstruction) {
        var name = this._getInstructionName(value);
        this._cbs.onprocessinginstruction("?" + name, "?" + value);
    }
};

Parser.prototype.oncomment = function(value) {
    this._updatePosition(4);

    if (this._cbs.oncomment) this._cbs.oncomment(value);
    if (this._cbs.oncommentend) this._cbs.oncommentend();
};

Parser.prototype.oncdata = function(value) {
    this._updatePosition(1);

    if (this._options.xmlMode || this._options.recognizeCDATA) {
        if (this._cbs.oncdatastart) this._cbs.oncdatastart();
        if (this._cbs.ontext) this._cbs.ontext(value);
        if (this._cbs.oncdataend) this._cbs.oncdataend();
    } else {
        this.oncomment("[CDATA[" + value + "]]");
    }
};

Parser.prototype.onerror = function(err) {
    if (this._cbs.onerror) this._cbs.onerror(err);
};

Parser.prototype.onend = function() {
    if (this._cbs.onclosetag) {
        for (
            var i = this._stack.length;
            i > 0;
            this._cbs.onclosetag(this._stack[--i])
        );
    }
    if (this._cbs.onend) this._cbs.onend();
};

//Resets the parser to a blank state, ready to parse a new HTML document
Parser.prototype.reset = function() {
    if (this._cbs.onreset) this._cbs.onreset();
    this._tokenizer.reset();

    this._tagname = "";
    this._attribname = "";
    this._attribs = null;
    this._stack = [];

    if (this._cbs.onparserinit) this._cbs.onparserinit(this);
};

//Parses a complete HTML document and pushes it to the handler
Parser.prototype.parseComplete = function(data) {
    this.reset();
    this.end(data);
};

Parser.prototype.write = function(chunk) {
    this._tokenizer.write(chunk);
};

Parser.prototype.end = function(chunk) {
    this._tokenizer.end(chunk);
};

Parser.prototype.pause = function() {
    this._tokenizer.pause();
};

Parser.prototype.resume = function() {
    this._tokenizer.resume();
};

//alias for backwards compat
Parser.prototype.parseChunk = Parser.prototype.write;
Parser.prototype.done = Parser.prototype.end;

module.exports = Parser;

},{"./Tokenizer.js":32,"events":26,"inherits":36}],30:[function(require,module,exports){
module.exports = ProxyHandler;

function ProxyHandler(cbs) {
    this._cbs = cbs || {};
}

var EVENTS = require("./").EVENTS;
Object.keys(EVENTS).forEach(function(name) {
    if (EVENTS[name] === 0) {
        name = "on" + name;
        ProxyHandler.prototype[name] = function() {
            if (this._cbs[name]) this._cbs[name]();
        };
    } else if (EVENTS[name] === 1) {
        name = "on" + name;
        ProxyHandler.prototype[name] = function(a) {
            if (this._cbs[name]) this._cbs[name](a);
        };
    } else if (EVENTS[name] === 2) {
        name = "on" + name;
        ProxyHandler.prototype[name] = function(a, b) {
            if (this._cbs[name]) this._cbs[name](a, b);
        };
    } else {
        throw Error("wrong number of arguments");
    }
});

},{"./":34}],31:[function(require,module,exports){
module.exports = Stream;

var Parser = require("./WritableStream.js");

function Stream(options) {
    Parser.call(this, new Cbs(this), options);
}

require("inherits")(Stream, Parser);

Stream.prototype.readable = true;

function Cbs(scope) {
    this.scope = scope;
}

var EVENTS = require("../").EVENTS;

Object.keys(EVENTS).forEach(function(name) {
    if (EVENTS[name] === 0) {
        Cbs.prototype["on" + name] = function() {
            this.scope.emit(name);
        };
    } else if (EVENTS[name] === 1) {
        Cbs.prototype["on" + name] = function(a) {
            this.scope.emit(name, a);
        };
    } else if (EVENTS[name] === 2) {
        Cbs.prototype["on" + name] = function(a, b) {
            this.scope.emit(name, a, b);
        };
    } else {
        throw Error("wrong number of arguments!");
    }
});

},{"../":34,"./WritableStream.js":33,"inherits":36}],32:[function(require,module,exports){
module.exports = Tokenizer;

var decodeCodePoint = require("entities/lib/decode_codepoint.js");
var entityMap = require("entities/maps/entities.json");
var legacyMap = require("entities/maps/legacy.json");
var xmlMap = require("entities/maps/xml.json");

var i = 0;

var TEXT = i++;
var BEFORE_TAG_NAME = i++; //after <
var IN_TAG_NAME = i++;
var IN_SELF_CLOSING_TAG = i++;
var BEFORE_CLOSING_TAG_NAME = i++;
var IN_CLOSING_TAG_NAME = i++;
var AFTER_CLOSING_TAG_NAME = i++;

//attributes
var BEFORE_ATTRIBUTE_NAME = i++;
var IN_ATTRIBUTE_NAME = i++;
var AFTER_ATTRIBUTE_NAME = i++;
var BEFORE_ATTRIBUTE_VALUE = i++;
var IN_ATTRIBUTE_VALUE_DQ = i++; // "
var IN_ATTRIBUTE_VALUE_SQ = i++; // '
var IN_ATTRIBUTE_VALUE_NQ = i++;

//declarations
var BEFORE_DECLARATION = i++; // !
var IN_DECLARATION = i++;

//processing instructions
var IN_PROCESSING_INSTRUCTION = i++; // ?

//comments
var BEFORE_COMMENT = i++;
var IN_COMMENT = i++;
var AFTER_COMMENT_1 = i++;
var AFTER_COMMENT_2 = i++;

//cdata
var BEFORE_CDATA_1 = i++; // [
var BEFORE_CDATA_2 = i++; // C
var BEFORE_CDATA_3 = i++; // D
var BEFORE_CDATA_4 = i++; // A
var BEFORE_CDATA_5 = i++; // T
var BEFORE_CDATA_6 = i++; // A
var IN_CDATA = i++; // [
var AFTER_CDATA_1 = i++; // ]
var AFTER_CDATA_2 = i++; // ]

//special tags
var BEFORE_SPECIAL = i++; //S
var BEFORE_SPECIAL_END = i++; //S

var BEFORE_SCRIPT_1 = i++; //C
var BEFORE_SCRIPT_2 = i++; //R
var BEFORE_SCRIPT_3 = i++; //I
var BEFORE_SCRIPT_4 = i++; //P
var BEFORE_SCRIPT_5 = i++; //T
var AFTER_SCRIPT_1 = i++; //C
var AFTER_SCRIPT_2 = i++; //R
var AFTER_SCRIPT_3 = i++; //I
var AFTER_SCRIPT_4 = i++; //P
var AFTER_SCRIPT_5 = i++; //T

var BEFORE_STYLE_1 = i++; //T
var BEFORE_STYLE_2 = i++; //Y
var BEFORE_STYLE_3 = i++; //L
var BEFORE_STYLE_4 = i++; //E
var AFTER_STYLE_1 = i++; //T
var AFTER_STYLE_2 = i++; //Y
var AFTER_STYLE_3 = i++; //L
var AFTER_STYLE_4 = i++; //E

var BEFORE_ENTITY = i++; //&
var BEFORE_NUMERIC_ENTITY = i++; //#
var IN_NAMED_ENTITY = i++;
var IN_NUMERIC_ENTITY = i++;
var IN_HEX_ENTITY = i++; //X

var j = 0;

var SPECIAL_NONE = j++;
var SPECIAL_SCRIPT = j++;
var SPECIAL_STYLE = j++;

function whitespace(c) {
    return c === " " || c === "\n" || c === "\t" || c === "\f" || c === "\r";
}

function ifElseState(upper, SUCCESS, FAILURE) {
    var lower = upper.toLowerCase();

    if (upper === lower) {
        return function(c) {
            if (c === lower) {
                this._state = SUCCESS;
            } else {
                this._state = FAILURE;
                this._index--;
            }
        };
    } else {
        return function(c) {
            if (c === lower || c === upper) {
                this._state = SUCCESS;
            } else {
                this._state = FAILURE;
                this._index--;
            }
        };
    }
}

function consumeSpecialNameChar(upper, NEXT_STATE) {
    var lower = upper.toLowerCase();

    return function(c) {
        if (c === lower || c === upper) {
            this._state = NEXT_STATE;
        } else {
            this._state = IN_TAG_NAME;
            this._index--; //consume the token again
        }
    };
}

function Tokenizer(options, cbs) {
    this._state = TEXT;
    this._buffer = "";
    this._sectionStart = 0;
    this._index = 0;
    this._bufferOffset = 0; //chars removed from _buffer
    this._baseState = TEXT;
    this._special = SPECIAL_NONE;
    this._cbs = cbs;
    this._running = true;
    this._ended = false;
    this._xmlMode = !!(options && options.xmlMode);
    this._decodeEntities = !!(options && options.decodeEntities);
}

Tokenizer.prototype._stateText = function(c) {
    if (c === "<") {
        if (this._index > this._sectionStart) {
            this._cbs.ontext(this._getSection());
        }
        this._state = BEFORE_TAG_NAME;
        this._sectionStart = this._index;
    } else if (
        this._decodeEntities &&
        this._special === SPECIAL_NONE &&
        c === "&"
    ) {
        if (this._index > this._sectionStart) {
            this._cbs.ontext(this._getSection());
        }
        this._baseState = TEXT;
        this._state = BEFORE_ENTITY;
        this._sectionStart = this._index;
    }
};

Tokenizer.prototype._stateBeforeTagName = function(c) {
    if (c === "/") {
        this._state = BEFORE_CLOSING_TAG_NAME;
    } else if (c === "<") {
        this._cbs.ontext(this._getSection());
        this._sectionStart = this._index;
    } else if (c === ">" || this._special !== SPECIAL_NONE || whitespace(c)) {
        this._state = TEXT;
    } else if (c === "!") {
        this._state = BEFORE_DECLARATION;
        this._sectionStart = this._index + 1;
    } else if (c === "?") {
        this._state = IN_PROCESSING_INSTRUCTION;
        this._sectionStart = this._index + 1;
    } else {
        this._state =
            !this._xmlMode && (c === "s" || c === "S")
                ? BEFORE_SPECIAL
                : IN_TAG_NAME;
        this._sectionStart = this._index;
    }
};

Tokenizer.prototype._stateInTagName = function(c) {
    if (c === "/" || c === ">" || whitespace(c)) {
        this._emitToken("onopentagname");
        this._state = BEFORE_ATTRIBUTE_NAME;
        this._index--;
    }
};

Tokenizer.prototype._stateBeforeCloseingTagName = function(c) {
    if (whitespace(c));
    else if (c === ">") {
        this._state = TEXT;
    } else if (this._special !== SPECIAL_NONE) {
        if (c === "s" || c === "S") {
            this._state = BEFORE_SPECIAL_END;
        } else {
            this._state = TEXT;
            this._index--;
        }
    } else {
        this._state = IN_CLOSING_TAG_NAME;
        this._sectionStart = this._index;
    }
};

Tokenizer.prototype._stateInCloseingTagName = function(c) {
    if (c === ">" || whitespace(c)) {
        this._emitToken("onclosetag");
        this._state = AFTER_CLOSING_TAG_NAME;
        this._index--;
    }
};

Tokenizer.prototype._stateAfterCloseingTagName = function(c) {
    //skip everything until ">"
    if (c === ">") {
        this._state = TEXT;
        this._sectionStart = this._index + 1;
    }
};

Tokenizer.prototype._stateBeforeAttributeName = function(c) {
    if (c === ">") {
        this._cbs.onopentagend();
        this._state = TEXT;
        this._sectionStart = this._index + 1;
    } else if (c === "/") {
        this._state = IN_SELF_CLOSING_TAG;
    } else if (!whitespace(c)) {
        this._state = IN_ATTRIBUTE_NAME;
        this._sectionStart = this._index;
    }
};

Tokenizer.prototype._stateInSelfClosingTag = function(c) {
    if (c === ">") {
        this._cbs.onselfclosingtag();
        this._state = TEXT;
        this._sectionStart = this._index + 1;
    } else if (!whitespace(c)) {
        this._state = BEFORE_ATTRIBUTE_NAME;
        this._index--;
    }
};

Tokenizer.prototype._stateInAttributeName = function(c) {
    if (c === "=" || c === "/" || c === ">" || whitespace(c)) {
        this._cbs.onattribname(this._getSection());
        this._sectionStart = -1;
        this._state = AFTER_ATTRIBUTE_NAME;
        this._index--;
    }
};

Tokenizer.prototype._stateAfterAttributeName = function(c) {
    if (c === "=") {
        this._state = BEFORE_ATTRIBUTE_VALUE;
    } else if (c === "/" || c === ">") {
        this._cbs.onattribend();
        this._state = BEFORE_ATTRIBUTE_NAME;
        this._index--;
    } else if (!whitespace(c)) {
        this._cbs.onattribend();
        this._state = IN_ATTRIBUTE_NAME;
        this._sectionStart = this._index;
    }
};

Tokenizer.prototype._stateBeforeAttributeValue = function(c) {
    if (c === '"') {
        this._state = IN_ATTRIBUTE_VALUE_DQ;
        this._sectionStart = this._index + 1;
    } else if (c === "'") {
        this._state = IN_ATTRIBUTE_VALUE_SQ;
        this._sectionStart = this._index + 1;
    } else if (!whitespace(c)) {
        this._state = IN_ATTRIBUTE_VALUE_NQ;
        this._sectionStart = this._index;
        this._index--; //reconsume token
    }
};

Tokenizer.prototype._stateInAttributeValueDoubleQuotes = function(c) {
    if (c === '"') {
        this._emitToken("onattribdata");
        this._cbs.onattribend();
        this._state = BEFORE_ATTRIBUTE_NAME;
    } else if (this._decodeEntities && c === "&") {
        this._emitToken("onattribdata");
        this._baseState = this._state;
        this._state = BEFORE_ENTITY;
        this._sectionStart = this._index;
    }
};

Tokenizer.prototype._stateInAttributeValueSingleQuotes = function(c) {
    if (c === "'") {
        this._emitToken("onattribdata");
        this._cbs.onattribend();
        this._state = BEFORE_ATTRIBUTE_NAME;
    } else if (this._decodeEntities && c === "&") {
        this._emitToken("onattribdata");
        this._baseState = this._state;
        this._state = BEFORE_ENTITY;
        this._sectionStart = this._index;
    }
};

Tokenizer.prototype._stateInAttributeValueNoQuotes = function(c) {
    if (whitespace(c) || c === ">") {
        this._emitToken("onattribdata");
        this._cbs.onattribend();
        this._state = BEFORE_ATTRIBUTE_NAME;
        this._index--;
    } else if (this._decodeEntities && c === "&") {
        this._emitToken("onattribdata");
        this._baseState = this._state;
        this._state = BEFORE_ENTITY;
        this._sectionStart = this._index;
    }
};

Tokenizer.prototype._stateBeforeDeclaration = function(c) {
    this._state =
        c === "["
            ? BEFORE_CDATA_1
            : c === "-"
                ? BEFORE_COMMENT
                : IN_DECLARATION;
};

Tokenizer.prototype._stateInDeclaration = function(c) {
    if (c === ">") {
        this._cbs.ondeclaration(this._getSection());
        this._state = TEXT;
        this._sectionStart = this._index + 1;
    }
};

Tokenizer.prototype._stateInProcessingInstruction = function(c) {
    if (c === ">") {
        this._cbs.onprocessinginstruction(this._getSection());
        this._state = TEXT;
        this._sectionStart = this._index + 1;
    }
};

Tokenizer.prototype._stateBeforeComment = function(c) {
    if (c === "-") {
        this._state = IN_COMMENT;
        this._sectionStart = this._index + 1;
    } else {
        this._state = IN_DECLARATION;
    }
};

Tokenizer.prototype._stateInComment = function(c) {
    if (c === "-") this._state = AFTER_COMMENT_1;
};

Tokenizer.prototype._stateAfterComment1 = function(c) {
    if (c === "-") {
        this._state = AFTER_COMMENT_2;
    } else {
        this._state = IN_COMMENT;
    }
};

Tokenizer.prototype._stateAfterComment2 = function(c) {
    if (c === ">") {
        //remove 2 trailing chars
        this._cbs.oncomment(
            this._buffer.substring(this._sectionStart, this._index - 2)
        );
        this._state = TEXT;
        this._sectionStart = this._index + 1;
    } else if (c !== "-") {
        this._state = IN_COMMENT;
    }
    // else: stay in AFTER_COMMENT_2 (`--->`)
};

Tokenizer.prototype._stateBeforeCdata1 = ifElseState(
    "C",
    BEFORE_CDATA_2,
    IN_DECLARATION
);
Tokenizer.prototype._stateBeforeCdata2 = ifElseState(
    "D",
    BEFORE_CDATA_3,
    IN_DECLARATION
);
Tokenizer.prototype._stateBeforeCdata3 = ifElseState(
    "A",
    BEFORE_CDATA_4,
    IN_DECLARATION
);
Tokenizer.prototype._stateBeforeCdata4 = ifElseState(
    "T",
    BEFORE_CDATA_5,
    IN_DECLARATION
);
Tokenizer.prototype._stateBeforeCdata5 = ifElseState(
    "A",
    BEFORE_CDATA_6,
    IN_DECLARATION
);

Tokenizer.prototype._stateBeforeCdata6 = function(c) {
    if (c === "[") {
        this._state = IN_CDATA;
        this._sectionStart = this._index + 1;
    } else {
        this._state = IN_DECLARATION;
        this._index--;
    }
};

Tokenizer.prototype._stateInCdata = function(c) {
    if (c === "]") this._state = AFTER_CDATA_1;
};

Tokenizer.prototype._stateAfterCdata1 = function(c) {
    if (c === "]") this._state = AFTER_CDATA_2;
    else this._state = IN_CDATA;
};

Tokenizer.prototype._stateAfterCdata2 = function(c) {
    if (c === ">") {
        //remove 2 trailing chars
        this._cbs.oncdata(
            this._buffer.substring(this._sectionStart, this._index - 2)
        );
        this._state = TEXT;
        this._sectionStart = this._index + 1;
    } else if (c !== "]") {
        this._state = IN_CDATA;
    }
    //else: stay in AFTER_CDATA_2 (`]]]>`)
};

Tokenizer.prototype._stateBeforeSpecial = function(c) {
    if (c === "c" || c === "C") {
        this._state = BEFORE_SCRIPT_1;
    } else if (c === "t" || c === "T") {
        this._state = BEFORE_STYLE_1;
    } else {
        this._state = IN_TAG_NAME;
        this._index--; //consume the token again
    }
};

Tokenizer.prototype._stateBeforeSpecialEnd = function(c) {
    if (this._special === SPECIAL_SCRIPT && (c === "c" || c === "C")) {
        this._state = AFTER_SCRIPT_1;
    } else if (this._special === SPECIAL_STYLE && (c === "t" || c === "T")) {
        this._state = AFTER_STYLE_1;
    } else this._state = TEXT;
};

Tokenizer.prototype._stateBeforeScript1 = consumeSpecialNameChar(
    "R",
    BEFORE_SCRIPT_2
);
Tokenizer.prototype._stateBeforeScript2 = consumeSpecialNameChar(
    "I",
    BEFORE_SCRIPT_3
);
Tokenizer.prototype._stateBeforeScript3 = consumeSpecialNameChar(
    "P",
    BEFORE_SCRIPT_4
);
Tokenizer.prototype._stateBeforeScript4 = consumeSpecialNameChar(
    "T",
    BEFORE_SCRIPT_5
);

Tokenizer.prototype._stateBeforeScript5 = function(c) {
    if (c === "/" || c === ">" || whitespace(c)) {
        this._special = SPECIAL_SCRIPT;
    }
    this._state = IN_TAG_NAME;
    this._index--; //consume the token again
};

Tokenizer.prototype._stateAfterScript1 = ifElseState("R", AFTER_SCRIPT_2, TEXT);
Tokenizer.prototype._stateAfterScript2 = ifElseState("I", AFTER_SCRIPT_3, TEXT);
Tokenizer.prototype._stateAfterScript3 = ifElseState("P", AFTER_SCRIPT_4, TEXT);
Tokenizer.prototype._stateAfterScript4 = ifElseState("T", AFTER_SCRIPT_5, TEXT);

Tokenizer.prototype._stateAfterScript5 = function(c) {
    if (c === ">" || whitespace(c)) {
        this._special = SPECIAL_NONE;
        this._state = IN_CLOSING_TAG_NAME;
        this._sectionStart = this._index - 6;
        this._index--; //reconsume the token
    } else this._state = TEXT;
};

Tokenizer.prototype._stateBeforeStyle1 = consumeSpecialNameChar(
    "Y",
    BEFORE_STYLE_2
);
Tokenizer.prototype._stateBeforeStyle2 = consumeSpecialNameChar(
    "L",
    BEFORE_STYLE_3
);
Tokenizer.prototype._stateBeforeStyle3 = consumeSpecialNameChar(
    "E",
    BEFORE_STYLE_4
);

Tokenizer.prototype._stateBeforeStyle4 = function(c) {
    if (c === "/" || c === ">" || whitespace(c)) {
        this._special = SPECIAL_STYLE;
    }
    this._state = IN_TAG_NAME;
    this._index--; //consume the token again
};

Tokenizer.prototype._stateAfterStyle1 = ifElseState("Y", AFTER_STYLE_2, TEXT);
Tokenizer.prototype._stateAfterStyle2 = ifElseState("L", AFTER_STYLE_3, TEXT);
Tokenizer.prototype._stateAfterStyle3 = ifElseState("E", AFTER_STYLE_4, TEXT);

Tokenizer.prototype._stateAfterStyle4 = function(c) {
    if (c === ">" || whitespace(c)) {
        this._special = SPECIAL_NONE;
        this._state = IN_CLOSING_TAG_NAME;
        this._sectionStart = this._index - 5;
        this._index--; //reconsume the token
    } else this._state = TEXT;
};

Tokenizer.prototype._stateBeforeEntity = ifElseState(
    "#",
    BEFORE_NUMERIC_ENTITY,
    IN_NAMED_ENTITY
);
Tokenizer.prototype._stateBeforeNumericEntity = ifElseState(
    "X",
    IN_HEX_ENTITY,
    IN_NUMERIC_ENTITY
);

//for entities terminated with a semicolon
Tokenizer.prototype._parseNamedEntityStrict = function() {
    //offset = 1
    if (this._sectionStart + 1 < this._index) {
        var entity = this._buffer.substring(
                this._sectionStart + 1,
                this._index
            ),
            map = this._xmlMode ? xmlMap : entityMap;

        if (map.hasOwnProperty(entity)) {
            this._emitPartial(map[entity]);
            this._sectionStart = this._index + 1;
        }
    }
};

//parses legacy entities (without trailing semicolon)
Tokenizer.prototype._parseLegacyEntity = function() {
    var start = this._sectionStart + 1,
        limit = this._index - start;

    if (limit > 6) limit = 6; //the max length of legacy entities is 6

    while (limit >= 2) {
        //the min length of legacy entities is 2
        var entity = this._buffer.substr(start, limit);

        if (legacyMap.hasOwnProperty(entity)) {
            this._emitPartial(legacyMap[entity]);
            this._sectionStart += limit + 1;
            return;
        } else {
            limit--;
        }
    }
};

Tokenizer.prototype._stateInNamedEntity = function(c) {
    if (c === ";") {
        this._parseNamedEntityStrict();
        if (this._sectionStart + 1 < this._index && !this._xmlMode) {
            this._parseLegacyEntity();
        }
        this._state = this._baseState;
    } else if (
        (c < "a" || c > "z") &&
        (c < "A" || c > "Z") &&
        (c < "0" || c > "9")
    ) {
        if (this._xmlMode);
        else if (this._sectionStart + 1 === this._index);
        else if (this._baseState !== TEXT) {
            if (c !== "=") {
                this._parseNamedEntityStrict();
            }
        } else {
            this._parseLegacyEntity();
        }

        this._state = this._baseState;
        this._index--;
    }
};

Tokenizer.prototype._decodeNumericEntity = function(offset, base) {
    var sectionStart = this._sectionStart + offset;

    if (sectionStart !== this._index) {
        //parse entity
        var entity = this._buffer.substring(sectionStart, this._index);
        var parsed = parseInt(entity, base);

        this._emitPartial(decodeCodePoint(parsed));
        this._sectionStart = this._index;
    } else {
        this._sectionStart--;
    }

    this._state = this._baseState;
};

Tokenizer.prototype._stateInNumericEntity = function(c) {
    if (c === ";") {
        this._decodeNumericEntity(2, 10);
        this._sectionStart++;
    } else if (c < "0" || c > "9") {
        if (!this._xmlMode) {
            this._decodeNumericEntity(2, 10);
        } else {
            this._state = this._baseState;
        }
        this._index--;
    }
};

Tokenizer.prototype._stateInHexEntity = function(c) {
    if (c === ";") {
        this._decodeNumericEntity(3, 16);
        this._sectionStart++;
    } else if (
        (c < "a" || c > "f") &&
        (c < "A" || c > "F") &&
        (c < "0" || c > "9")
    ) {
        if (!this._xmlMode) {
            this._decodeNumericEntity(3, 16);
        } else {
            this._state = this._baseState;
        }
        this._index--;
    }
};

Tokenizer.prototype._cleanup = function() {
    if (this._sectionStart < 0) {
        this._buffer = "";
        this._bufferOffset += this._index;
        this._index = 0;
    } else if (this._running) {
        if (this._state === TEXT) {
            if (this._sectionStart !== this._index) {
                this._cbs.ontext(this._buffer.substr(this._sectionStart));
            }
            this._buffer = "";
            this._bufferOffset += this._index;
            this._index = 0;
        } else if (this._sectionStart === this._index) {
            //the section just started
            this._buffer = "";
            this._bufferOffset += this._index;
            this._index = 0;
        } else {
            //remove everything unnecessary
            this._buffer = this._buffer.substr(this._sectionStart);
            this._index -= this._sectionStart;
            this._bufferOffset += this._sectionStart;
        }

        this._sectionStart = 0;
    }
};

//TODO make events conditional
Tokenizer.prototype.write = function(chunk) {
    if (this._ended) this._cbs.onerror(Error(".write() after done!"));

    this._buffer += chunk;
    this._parse();
};

Tokenizer.prototype._parse = function() {
    while (this._index < this._buffer.length && this._running) {
        var c = this._buffer.charAt(this._index);
        if (this._state === TEXT) {
            this._stateText(c);
        } else if (this._state === BEFORE_TAG_NAME) {
            this._stateBeforeTagName(c);
        } else if (this._state === IN_TAG_NAME) {
            this._stateInTagName(c);
        } else if (this._state === BEFORE_CLOSING_TAG_NAME) {
            this._stateBeforeCloseingTagName(c);
        } else if (this._state === IN_CLOSING_TAG_NAME) {
            this._stateInCloseingTagName(c);
        } else if (this._state === AFTER_CLOSING_TAG_NAME) {
            this._stateAfterCloseingTagName(c);
        } else if (this._state === IN_SELF_CLOSING_TAG) {
            this._stateInSelfClosingTag(c);
        } else if (this._state === BEFORE_ATTRIBUTE_NAME) {

        /*
		*	attributes
		*/
            this._stateBeforeAttributeName(c);
        } else if (this._state === IN_ATTRIBUTE_NAME) {
            this._stateInAttributeName(c);
        } else if (this._state === AFTER_ATTRIBUTE_NAME) {
            this._stateAfterAttributeName(c);
        } else if (this._state === BEFORE_ATTRIBUTE_VALUE) {
            this._stateBeforeAttributeValue(c);
        } else if (this._state === IN_ATTRIBUTE_VALUE_DQ) {
            this._stateInAttributeValueDoubleQuotes(c);
        } else if (this._state === IN_ATTRIBUTE_VALUE_SQ) {
            this._stateInAttributeValueSingleQuotes(c);
        } else if (this._state === IN_ATTRIBUTE_VALUE_NQ) {
            this._stateInAttributeValueNoQuotes(c);
        } else if (this._state === BEFORE_DECLARATION) {

        /*
		*	declarations
		*/
            this._stateBeforeDeclaration(c);
        } else if (this._state === IN_DECLARATION) {
            this._stateInDeclaration(c);
        } else if (this._state === IN_PROCESSING_INSTRUCTION) {

        /*
		*	processing instructions
		*/
            this._stateInProcessingInstruction(c);
        } else if (this._state === BEFORE_COMMENT) {

        /*
		*	comments
		*/
            this._stateBeforeComment(c);
        } else if (this._state === IN_COMMENT) {
            this._stateInComment(c);
        } else if (this._state === AFTER_COMMENT_1) {
            this._stateAfterComment1(c);
        } else if (this._state === AFTER_COMMENT_2) {
            this._stateAfterComment2(c);
        } else if (this._state === BEFORE_CDATA_1) {

        /*
		*	cdata
		*/
            this._stateBeforeCdata1(c);
        } else if (this._state === BEFORE_CDATA_2) {
            this._stateBeforeCdata2(c);
        } else if (this._state === BEFORE_CDATA_3) {
            this._stateBeforeCdata3(c);
        } else if (this._state === BEFORE_CDATA_4) {
            this._stateBeforeCdata4(c);
        } else if (this._state === BEFORE_CDATA_5) {
            this._stateBeforeCdata5(c);
        } else if (this._state === BEFORE_CDATA_6) {
            this._stateBeforeCdata6(c);
        } else if (this._state === IN_CDATA) {
            this._stateInCdata(c);
        } else if (this._state === AFTER_CDATA_1) {
            this._stateAfterCdata1(c);
        } else if (this._state === AFTER_CDATA_2) {
            this._stateAfterCdata2(c);
        } else if (this._state === BEFORE_SPECIAL) {

        /*
		* special tags
		*/
            this._stateBeforeSpecial(c);
        } else if (this._state === BEFORE_SPECIAL_END) {
            this._stateBeforeSpecialEnd(c);
        } else if (this._state === BEFORE_SCRIPT_1) {

        /*
		* script
		*/
            this._stateBeforeScript1(c);
        } else if (this._state === BEFORE_SCRIPT_2) {
            this._stateBeforeScript2(c);
        } else if (this._state === BEFORE_SCRIPT_3) {
            this._stateBeforeScript3(c);
        } else if (this._state === BEFORE_SCRIPT_4) {
            this._stateBeforeScript4(c);
        } else if (this._state === BEFORE_SCRIPT_5) {
            this._stateBeforeScript5(c);
        } else if (this._state === AFTER_SCRIPT_1) {
            this._stateAfterScript1(c);
        } else if (this._state === AFTER_SCRIPT_2) {
            this._stateAfterScript2(c);
        } else if (this._state === AFTER_SCRIPT_3) {
            this._stateAfterScript3(c);
        } else if (this._state === AFTER_SCRIPT_4) {
            this._stateAfterScript4(c);
        } else if (this._state === AFTER_SCRIPT_5) {
            this._stateAfterScript5(c);
        } else if (this._state === BEFORE_STYLE_1) {

        /*
		* style
		*/
            this._stateBeforeStyle1(c);
        } else if (this._state === BEFORE_STYLE_2) {
            this._stateBeforeStyle2(c);
        } else if (this._state === BEFORE_STYLE_3) {
            this._stateBeforeStyle3(c);
        } else if (this._state === BEFORE_STYLE_4) {
            this._stateBeforeStyle4(c);
        } else if (this._state === AFTER_STYLE_1) {
            this._stateAfterStyle1(c);
        } else if (this._state === AFTER_STYLE_2) {
            this._stateAfterStyle2(c);
        } else if (this._state === AFTER_STYLE_3) {
            this._stateAfterStyle3(c);
        } else if (this._state === AFTER_STYLE_4) {
            this._stateAfterStyle4(c);
        } else if (this._state === BEFORE_ENTITY) {

        /*
		* entities
		*/
            this._stateBeforeEntity(c);
        } else if (this._state === BEFORE_NUMERIC_ENTITY) {
            this._stateBeforeNumericEntity(c);
        } else if (this._state === IN_NAMED_ENTITY) {
            this._stateInNamedEntity(c);
        } else if (this._state === IN_NUMERIC_ENTITY) {
            this._stateInNumericEntity(c);
        } else if (this._state === IN_HEX_ENTITY) {
            this._stateInHexEntity(c);
        } else {
            this._cbs.onerror(Error("unknown _state"), this._state);
        }

        this._index++;
    }

    this._cleanup();
};

Tokenizer.prototype.pause = function() {
    this._running = false;
};
Tokenizer.prototype.resume = function() {
    this._running = true;

    if (this._index < this._buffer.length) {
        this._parse();
    }
    if (this._ended) {
        this._finish();
    }
};

Tokenizer.prototype.end = function(chunk) {
    if (this._ended) this._cbs.onerror(Error(".end() after done!"));
    if (chunk) this.write(chunk);

    this._ended = true;

    if (this._running) this._finish();
};

Tokenizer.prototype._finish = function() {
    //if there is remaining data, emit it in a reasonable way
    if (this._sectionStart < this._index) {
        this._handleTrailingData();
    }

    this._cbs.onend();
};

Tokenizer.prototype._handleTrailingData = function() {
    var data = this._buffer.substr(this._sectionStart);

    if (
        this._state === IN_CDATA ||
        this._state === AFTER_CDATA_1 ||
        this._state === AFTER_CDATA_2
    ) {
        this._cbs.oncdata(data);
    } else if (
        this._state === IN_COMMENT ||
        this._state === AFTER_COMMENT_1 ||
        this._state === AFTER_COMMENT_2
    ) {
        this._cbs.oncomment(data);
    } else if (this._state === IN_NAMED_ENTITY && !this._xmlMode) {
        this._parseLegacyEntity();
        if (this._sectionStart < this._index) {
            this._state = this._baseState;
            this._handleTrailingData();
        }
    } else if (this._state === IN_NUMERIC_ENTITY && !this._xmlMode) {
        this._decodeNumericEntity(2, 10);
        if (this._sectionStart < this._index) {
            this._state = this._baseState;
            this._handleTrailingData();
        }
    } else if (this._state === IN_HEX_ENTITY && !this._xmlMode) {
        this._decodeNumericEntity(3, 16);
        if (this._sectionStart < this._index) {
            this._state = this._baseState;
            this._handleTrailingData();
        }
    } else if (
        this._state !== IN_TAG_NAME &&
        this._state !== BEFORE_ATTRIBUTE_NAME &&
        this._state !== BEFORE_ATTRIBUTE_VALUE &&
        this._state !== AFTER_ATTRIBUTE_NAME &&
        this._state !== IN_ATTRIBUTE_NAME &&
        this._state !== IN_ATTRIBUTE_VALUE_SQ &&
        this._state !== IN_ATTRIBUTE_VALUE_DQ &&
        this._state !== IN_ATTRIBUTE_VALUE_NQ &&
        this._state !== IN_CLOSING_TAG_NAME
    ) {
        this._cbs.ontext(data);
    }
    //else, ignore remaining data
    //TODO add a way to remove current tag
};

Tokenizer.prototype.reset = function() {
    Tokenizer.call(
        this,
        { xmlMode: this._xmlMode, decodeEntities: this._decodeEntities },
        this._cbs
    );
};

Tokenizer.prototype.getAbsoluteIndex = function() {
    return this._bufferOffset + this._index;
};

Tokenizer.prototype._getSection = function() {
    return this._buffer.substring(this._sectionStart, this._index);
};

Tokenizer.prototype._emitToken = function(name) {
    this._cbs[name](this._getSection());
    this._sectionStart = -1;
};

Tokenizer.prototype._emitPartial = function(value) {
    if (this._baseState !== TEXT) {
        this._cbs.onattribdata(value); //TODO implement the new event
    } else {
        this._cbs.ontext(value);
    }
};

},{"entities/lib/decode_codepoint.js":20,"entities/maps/entities.json":23,"entities/maps/legacy.json":24,"entities/maps/xml.json":25}],33:[function(require,module,exports){
module.exports = Stream;

var Parser = require("./Parser.js");
var WritableStream = require("readable-stream").Writable;
var StringDecoder = require("string_decoder").StringDecoder;
var Buffer = require("buffer").Buffer;

function Stream(cbs, options) {
    var parser = (this._parser = new Parser(cbs, options));
    var decoder = (this._decoder = new StringDecoder());

    WritableStream.call(this, { decodeStrings: false });

    this.once("finish", function() {
        parser.end(decoder.end());
    });
}

require("inherits")(Stream, WritableStream);

Stream.prototype._write = function(chunk, encoding, cb) {
    if (chunk instanceof Buffer) chunk = this._decoder.write(chunk);
    this._parser.write(chunk);
    cb();
};

},{"./Parser.js":29,"buffer":5,"inherits":36,"readable-stream":4,"string_decoder":86}],34:[function(require,module,exports){
var Parser = require("./Parser.js");
var DomHandler = require("domhandler");

function defineProp(name, value) {
    delete module.exports[name];
    module.exports[name] = value;
    return value;
}

module.exports = {
    Parser: Parser,
    Tokenizer: require("./Tokenizer.js"),
    ElementType: require("domelementtype"),
    DomHandler: DomHandler,
    get FeedHandler() {
        return defineProp("FeedHandler", require("./FeedHandler.js"));
    },
    get Stream() {
        return defineProp("Stream", require("./Stream.js"));
    },
    get WritableStream() {
        return defineProp("WritableStream", require("./WritableStream.js"));
    },
    get ProxyHandler() {
        return defineProp("ProxyHandler", require("./ProxyHandler.js"));
    },
    get DomUtils() {
        return defineProp("DomUtils", require("domutils"));
    },
    get CollectingHandler() {
        return defineProp(
            "CollectingHandler",
            require("./CollectingHandler.js")
        );
    },
    // For legacy support
    DefaultHandler: DomHandler,
    get RssHandler() {
        return defineProp("RssHandler", this.FeedHandler);
    },
    //helper methods
    parseDOM: function(data, options) {
        var handler = new DomHandler(options);
        new Parser(handler, options).end(data);
        return handler.dom;
    },
    parseFeed: function(feed, options) {
        var handler = new module.exports.FeedHandler(options);
        new Parser(handler, options).end(feed);
        return handler.dom;
    },
    createDomStream: function(cb, options, elementCb) {
        var handler = new DomHandler(cb, options, elementCb);
        return new Parser(handler, options);
    },
    // List of all events that the parser emits
    EVENTS: {
        /* Format: eventname: number of arguments */
        attribute: 2,
        cdatastart: 0,
        cdataend: 0,
        text: 1,
        processinginstruction: 2,
        comment: 1,
        commentend: 0,
        closetag: 1,
        opentag: 2,
        opentagname: 1,
        error: 1,
        end: 0
    }
};

},{"./CollectingHandler.js":27,"./FeedHandler.js":28,"./Parser.js":29,"./ProxyHandler.js":30,"./Stream.js":31,"./Tokenizer.js":32,"./WritableStream.js":33,"domelementtype":7,"domhandler":8,"domutils":11}],35:[function(require,module,exports){
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}

},{}],36:[function(require,module,exports){
if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}

},{}],37:[function(require,module,exports){
(function (global){
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
  var result;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      if (isHostObject(value)) {
        return object ? value : {};
      }
      result = initCloneObject(isFunc ? {} : value);
      if (!isDeep) {
        return copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (!isArr) {
    var props = isFull ? getAllKeys(value) : keys(value);
  }
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
  });
  return result;
}

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
function baseCreate(proto) {
  return isObject(proto) ? objectCreate(proto) : {};
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var result = new buffer.constructor(buffer.length);
  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, true, true);
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = cloneDeep;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],38:[function(require,module,exports){
(function (global){
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
    reHasRegExpChar = RegExp(reRegExpChar.source);

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escapeRegExp('[lodash](https://lodash.com/)');
 * // => '\[lodash\]\(https://lodash\.com/\)'
 */
function escapeRegExp(string) {
  string = toString(string);
  return (string && reHasRegExpChar.test(string))
    ? string.replace(reRegExpChar, '\\$&')
    : string;
}

module.exports = escapeRegExp;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],39:[function(require,module,exports){
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) ||
      objectToString.call(value) != objectTag || isHostObject(value)) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return (typeof Ctor == 'function' &&
    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
}

module.exports = isPlainObject;

},{}],40:[function(require,module,exports){
/**
 * lodash 4.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var stringTag = '[object String]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @type Function
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
}

module.exports = isString;

},{}],41:[function(require,module,exports){
(function (global){
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    asyncTag = '[object AsyncFunction]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    nullTag = '[object Null]',
    objectTag = '[object Object]',
    proxyTag = '[object Proxy]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    undefinedTag = '[object Undefined]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Gets the value at `key`, unless `key` is "__proto__".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  return key == '__proto__'
    ? undefined
    : object[key];
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeMax = Math.max,
    nativeNow = Date.now;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    if (isObject(srcValue)) {
      stack || (stack = new Stack);
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */
var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
  baseMerge(object, source, srcIndex, customizer);
});

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = mergeWith;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],42:[function(require,module,exports){
'use strict';
module.exports = Number.isNaN || function (x) {
	return x !== x;
};

},{}],43:[function(require,module,exports){
(function (process){
// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

}).call(this,require('_process'))
},{"_process":68}],44:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.default = void 0;

var _container = _interopRequireDefault(require("./container"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * Represents an at-rule.
 *
 * If it’s followed in the CSS by a {} block, this node will have
 * a nodes property representing its children.
 *
 * @extends Container
 *
 * @example
 * const root = postcss.parse('@charset "UTF-8"; @media print {}')
 *
 * const charset = root.first
 * charset.type  //=> 'atrule'
 * charset.nodes //=> undefined
 *
 * const media = root.last
 * media.nodes   //=> []
 */
var AtRule =
/*#__PURE__*/
function (_Container) {
  _inheritsLoose(AtRule, _Container);

  function AtRule(defaults) {
    var _this;

    _this = _Container.call(this, defaults) || this;
    _this.type = 'atrule';
    return _this;
  }

  var _proto = AtRule.prototype;

  _proto.append = function append() {
    var _Container$prototype$;

    if (!this.nodes) this.nodes = [];

    for (var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++) {
      children[_key] = arguments[_key];
    }

    return (_Container$prototype$ = _Container.prototype.append).call.apply(_Container$prototype$, [this].concat(children));
  };

  _proto.prepend = function prepend() {
    var _Container$prototype$2;

    if (!this.nodes) this.nodes = [];

    for (var _len2 = arguments.length, children = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      children[_key2] = arguments[_key2];
    }

    return (_Container$prototype$2 = _Container.prototype.prepend).call.apply(_Container$prototype$2, [this].concat(children));
  }
  /**
   * @memberof AtRule#
   * @member {string} name The at-rule’s name immediately follows the `@`.
   *
   * @example
   * const root  = postcss.parse('@media print {}')
   * media.name //=> 'media'
   * const media = root.first
   */

  /**
   * @memberof AtRule#
   * @member {string} params The at-rule’s parameters, the values
   *                         that follow the at-rule’s name but precede
   *                         any {} block.
   *
   * @example
   * const root  = postcss.parse('@media print, screen {}')
   * const media = root.first
   * media.params //=> 'print, screen'
   */

  /**
   * @memberof AtRule#
   * @member {object} raws Information to generate byte-to-byte equal
   *                        node string as it was in the origin input.
   *
   * Every parser saves its own properties,
   * but the default CSS parser uses:
   *
   * * `before`: the space symbols before the node. It also stores `*`
   *   and `_` symbols before the declaration (IE hack).
   * * `after`: the space symbols after the last child of the node
   *   to the end of the node.
   * * `between`: the symbols between the property and value
   *   for declarations, selector and `{` for rules, or last parameter
   *   and `{` for at-rules.
   * * `semicolon`: contains true if the last child has
   *   an (optional) semicolon.
   * * `afterName`: the space between the at-rule name and its parameters.
   *
   * PostCSS cleans at-rule parameters from comments and extra spaces,
   * but it stores origin content in raws properties.
   * As such, if you don’t change a declaration’s value,
   * PostCSS will use the raw value with comments.
   *
   * @example
   * const root = postcss.parse('  @media\nprint {\n}')
   * root.first.first.raws //=> { before: '  ',
   *                       //     between: ' ',
   *                       //     afterName: '\n',
   *                       //     after: '\n' }
   */
  ;

  return AtRule;
}(_container.default);

var _default = AtRule;
exports.default = _default;
module.exports = exports.default;


},{"./container":46}],45:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.default = void 0;

var _node = _interopRequireDefault(require("./node"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * Represents a comment between declarations or statements (rule and at-rules).
 *
 * Comments inside selectors, at-rule parameters, or declaration values
 * will be stored in the `raws` properties explained above.
 *
 * @extends Node
 */
var Comment =
/*#__PURE__*/
function (_Node) {
  _inheritsLoose(Comment, _Node);

  function Comment(defaults) {
    var _this;

    _this = _Node.call(this, defaults) || this;
    _this.type = 'comment';
    return _this;
  }
  /**
   * @memberof Comment#
   * @member {string} text The comment’s text.
   */

  /**
   * @memberof Comment#
   * @member {object} raws Information to generate byte-to-byte equal
   *                       node string as it was in the origin input.
   *
   * Every parser saves its own properties,
   * but the default CSS parser uses:
   *
   * * `before`: the space symbols before the node.
   * * `left`: the space symbols between `/*` and the comment’s text.
   * * `right`: the space symbols between the comment’s text.
   */


  return Comment;
}(_node.default);

var _default = Comment;
exports.default = _default;
module.exports = exports.default;


},{"./node":53}],46:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.default = void 0;

var _declaration = _interopRequireDefault(require("./declaration"));

var _comment = _interopRequireDefault(require("./comment"));

var _node = _interopRequireDefault(require("./node"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function cleanSource(nodes) {
  return nodes.map(function (i) {
    if (i.nodes) i.nodes = cleanSource(i.nodes);
    delete i.source;
    return i;
  });
}
/**
 * The {@link Root}, {@link AtRule}, and {@link Rule} container nodes
 * inherit some common methods to help work with their children.
 *
 * Note that all containers can store any content. If you write a rule inside
 * a rule, PostCSS will parse it.
 *
 * @extends Node
 * @abstract
 */


var Container =
/*#__PURE__*/
function (_Node) {
  _inheritsLoose(Container, _Node);

  function Container() {
    return _Node.apply(this, arguments) || this;
  }

  var _proto = Container.prototype;

  _proto.push = function push(child) {
    child.parent = this;
    this.nodes.push(child);
    return this;
  }
  /**
   * Iterates through the container’s immediate children,
   * calling `callback` for each child.
   *
   * Returning `false` in the callback will break iteration.
   *
   * This method only iterates through the container’s immediate children.
   * If you need to recursively iterate through all the container’s descendant
   * nodes, use {@link Container#walk}.
   *
   * Unlike the for `{}`-cycle or `Array#forEach` this iterator is safe
   * if you are mutating the array of child nodes during iteration.
   * PostCSS will adjust the current index to match the mutations.
   *
   * @param {childIterator} callback Iterator receives each node and index.
   *
   * @return {false|undefined} Returns `false` if iteration was broke.
   *
   * @example
   * const root = postcss.parse('a { color: black; z-index: 1 }')
   * const rule = root.first
   *
   * for (const decl of rule.nodes) {
   *   decl.cloneBefore({ prop: '-webkit-' + decl.prop })
   *   // Cycle will be infinite, because cloneBefore moves the current node
   *   // to the next index
   * }
   *
   * rule.each(decl => {
   *   decl.cloneBefore({ prop: '-webkit-' + decl.prop })
   *   // Will be executed only for color and z-index
   * })
   */
  ;

  _proto.each = function each(callback) {
    if (!this.lastEach) this.lastEach = 0;
    if (!this.indexes) this.indexes = {};
    this.lastEach += 1;
    var id = this.lastEach;
    this.indexes[id] = 0;
    if (!this.nodes) return undefined;
    var index, result;

    while (this.indexes[id] < this.nodes.length) {
      index = this.indexes[id];
      result = callback(this.nodes[index], index);
      if (result === false) break;
      this.indexes[id] += 1;
    }

    delete this.indexes[id];
    return result;
  }
  /**
   * Traverses the container’s descendant nodes, calling callback
   * for each node.
   *
   * Like container.each(), this method is safe to use
   * if you are mutating arrays during iteration.
   *
   * If you only need to iterate through the container’s immediate children,
   * use {@link Container#each}.
   *
   * @param {childIterator} callback Iterator receives each node and index.
   *
   * @return {false|undefined} Returns `false` if iteration was broke.
   *
   * @example
   * root.walk(node => {
   *   // Traverses all descendant nodes.
   * })
   */
  ;

  _proto.walk = function walk(callback) {
    return this.each(function (child, i) {
      var result;

      try {
        result = callback(child, i);
      } catch (e) {
        e.postcssNode = child;

        if (e.stack && child.source && /\n\s{4}at /.test(e.stack)) {
          var s = child.source;
          e.stack = e.stack.replace(/\n\s{4}at /, "$&" + s.input.from + ":" + s.start.line + ":" + s.start.column + "$&");
        }

        throw e;
      }

      if (result !== false && child.walk) {
        result = child.walk(callback);
      }

      return result;
    });
  }
  /**
   * Traverses the container’s descendant nodes, calling callback
   * for each declaration node.
   *
   * If you pass a filter, iteration will only happen over declarations
   * with matching properties.
   *
   * Like {@link Container#each}, this method is safe
   * to use if you are mutating arrays during iteration.
   *
   * @param {string|RegExp} [prop]   String or regular expression
   *                                 to filter declarations by property name.
   * @param {childIterator} callback Iterator receives each node and index.
   *
   * @return {false|undefined} Returns `false` if iteration was broke.
   *
   * @example
   * root.walkDecls(decl => {
   *   checkPropertySupport(decl.prop)
   * })
   *
   * root.walkDecls('border-radius', decl => {
   *   decl.remove()
   * })
   *
   * root.walkDecls(/^background/, decl => {
   *   decl.value = takeFirstColorFromGradient(decl.value)
   * })
   */
  ;

  _proto.walkDecls = function walkDecls(prop, callback) {
    if (!callback) {
      callback = prop;
      return this.walk(function (child, i) {
        if (child.type === 'decl') {
          return callback(child, i);
        }
      });
    }

    if (prop instanceof RegExp) {
      return this.walk(function (child, i) {
        if (child.type === 'decl' && prop.test(child.prop)) {
          return callback(child, i);
        }
      });
    }

    return this.walk(function (child, i) {
      if (child.type === 'decl' && child.prop === prop) {
        return callback(child, i);
      }
    });
  }
  /**
   * Traverses the container’s descendant nodes, calling callback
   * for each rule node.
   *
   * If you pass a filter, iteration will only happen over rules
   * with matching selectors.
   *
   * Like {@link Container#each}, this method is safe
   * to use if you are mutating arrays during iteration.
   *
   * @param {string|RegExp} [selector] String or regular expression
   *                                   to filter rules by selector.
   * @param {childIterator} callback   Iterator receives each node and index.
   *
   * @return {false|undefined} returns `false` if iteration was broke.
   *
   * @example
   * const selectors = []
   * root.walkRules(rule => {
   *   selectors.push(rule.selector)
   * })
   * console.log(`Your CSS uses ${ selectors.length } selectors`)
   */
  ;

  _proto.walkRules = function walkRules(selector, callback) {
    if (!callback) {
      callback = selector;
      return this.walk(function (child, i) {
        if (child.type === 'rule') {
          return callback(child, i);
        }
      });
    }

    if (selector instanceof RegExp) {
      return this.walk(function (child, i) {
        if (child.type === 'rule' && selector.test(child.selector)) {
          return callback(child, i);
        }
      });
    }

    return this.walk(function (child, i) {
      if (child.type === 'rule' && child.selector === selector) {
        return callback(child, i);
      }
    });
  }
  /**
   * Traverses the container’s descendant nodes, calling callback
   * for each at-rule node.
   *
   * If you pass a filter, iteration will only happen over at-rules
   * that have matching names.
   *
   * Like {@link Container#each}, this method is safe
   * to use if you are mutating arrays during iteration.
   *
   * @param {string|RegExp} [name]   String or regular expression
   *                                 to filter at-rules by name.
   * @param {childIterator} callback Iterator receives each node and index.
   *
   * @return {false|undefined} Returns `false` if iteration was broke.
   *
   * @example
   * root.walkAtRules(rule => {
   *   if (isOld(rule.name)) rule.remove()
   * })
   *
   * let first = false
   * root.walkAtRules('charset', rule => {
   *   if (!first) {
   *     first = true
   *   } else {
   *     rule.remove()
   *   }
   * })
   */
  ;

  _proto.walkAtRules = function walkAtRules(name, callback) {
    if (!callback) {
      callback = name;
      return this.walk(function (child, i) {
        if (child.type === 'atrule') {
          return callback(child, i);
        }
      });
    }

    if (name instanceof RegExp) {
      return this.walk(function (child, i) {
        if (child.type === 'atrule' && name.test(child.name)) {
          return callback(child, i);
        }
      });
    }

    return this.walk(function (child, i) {
      if (child.type === 'atrule' && child.name === name) {
        return callback(child, i);
      }
    });
  }
  /**
   * Traverses the container’s descendant nodes, calling callback
   * for each comment node.
   *
   * Like {@link Container#each}, this method is safe
   * to use if you are mutating arrays during iteration.
   *
   * @param {childIterator} callback Iterator receives each node and index.
   *
   * @return {false|undefined} Returns `false` if iteration was broke.
   *
   * @example
   * root.walkComments(comment => {
   *   comment.remove()
   * })
   */
  ;

  _proto.walkComments = function walkComments(callback) {
    return this.walk(function (child, i) {
      if (child.type === 'comment') {
        return callback(child, i);
      }
    });
  }
  /**
   * Inserts new nodes to the end of the container.
   *
   * @param {...(Node|object|string|Node[])} children New nodes.
   *
   * @return {Node} This node for methods chain.
   *
   * @example
   * const decl1 = postcss.decl({ prop: 'color', value: 'black' })
   * const decl2 = postcss.decl({ prop: 'background-color', value: 'white' })
   * rule.append(decl1, decl2)
   *
   * root.append({ name: 'charset', params: '"UTF-8"' })  // at-rule
   * root.append({ selector: 'a' })                       // rule
   * rule.append({ prop: 'color', value: 'black' })       // declaration
   * rule.append({ text: 'Comment' })                     // comment
   *
   * root.append('a {}')
   * root.first.append('color: black; z-index: 1')
   */
  ;

  _proto.append = function append() {
    for (var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++) {
      children[_key] = arguments[_key];
    }

    for (var _i = 0; _i < children.length; _i++) {
      var child = children[_i];
      var nodes = this.normalize(child, this.last);

      for (var _iterator = nodes, _isArray = Array.isArray(_iterator), _i2 = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i2 >= _iterator.length) break;
          _ref = _iterator[_i2++];
        } else {
          _i2 = _iterator.next();
          if (_i2.done) break;
          _ref = _i2.value;
        }

        var node = _ref;
        this.nodes.push(node);
      }
    }

    return this;
  }
  /**
   * Inserts new nodes to the start of the container.
   *
   * @param {...(Node|object|string|Node[])} children New nodes.
   *
   * @return {Node} This node for methods chain.
   *
   * @example
   * const decl1 = postcss.decl({ prop: 'color', value: 'black' })
   * const decl2 = postcss.decl({ prop: 'background-color', value: 'white' })
   * rule.prepend(decl1, decl2)
   *
   * root.append({ name: 'charset', params: '"UTF-8"' })  // at-rule
   * root.append({ selector: 'a' })                       // rule
   * rule.append({ prop: 'color', value: 'black' })       // declaration
   * rule.append({ text: 'Comment' })                     // comment
   *
   * root.append('a {}')
   * root.first.append('color: black; z-index: 1')
   */
  ;

  _proto.prepend = function prepend() {
    for (var _len2 = arguments.length, children = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      children[_key2] = arguments[_key2];
    }

    children = children.reverse();

    for (var _iterator2 = children, _isArray2 = Array.isArray(_iterator2), _i3 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
      var _ref2;

      if (_isArray2) {
        if (_i3 >= _iterator2.length) break;
        _ref2 = _iterator2[_i3++];
      } else {
        _i3 = _iterator2.next();
        if (_i3.done) break;
        _ref2 = _i3.value;
      }

      var child = _ref2;
      var nodes = this.normalize(child, this.first, 'prepend').reverse();

      for (var _iterator3 = nodes, _isArray3 = Array.isArray(_iterator3), _i4 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
        var _ref3;

        if (_isArray3) {
          if (_i4 >= _iterator3.length) break;
          _ref3 = _iterator3[_i4++];
        } else {
          _i4 = _iterator3.next();
          if (_i4.done) break;
          _ref3 = _i4.value;
        }

        var node = _ref3;
        this.nodes.unshift(node);
      }

      for (var id in this.indexes) {
        this.indexes[id] = this.indexes[id] + nodes.length;
      }
    }

    return this;
  };

  _proto.cleanRaws = function cleanRaws(keepBetween) {
    _Node.prototype.cleanRaws.call(this, keepBetween);

    if (this.nodes) {
      for (var _iterator4 = this.nodes, _isArray4 = Array.isArray(_iterator4), _i5 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
        var _ref4;

        if (_isArray4) {
          if (_i5 >= _iterator4.length) break;
          _ref4 = _iterator4[_i5++];
        } else {
          _i5 = _iterator4.next();
          if (_i5.done) break;
          _ref4 = _i5.value;
        }

        var node = _ref4;
        node.cleanRaws(keepBetween);
      }
    }
  }
  /**
   * Insert new node before old node within the container.
   *
   * @param {Node|number} exist             Child or child’s index.
   * @param {Node|object|string|Node[]} add New node.
   *
   * @return {Node} This node for methods chain.
   *
   * @example
   * rule.insertBefore(decl, decl.clone({ prop: '-webkit-' + decl.prop }))
   */
  ;

  _proto.insertBefore = function insertBefore(exist, add) {
    exist = this.index(exist);
    var type = exist === 0 ? 'prepend' : false;
    var nodes = this.normalize(add, this.nodes[exist], type).reverse();

    for (var _iterator5 = nodes, _isArray5 = Array.isArray(_iterator5), _i6 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {
      var _ref5;

      if (_isArray5) {
        if (_i6 >= _iterator5.length) break;
        _ref5 = _iterator5[_i6++];
      } else {
        _i6 = _iterator5.next();
        if (_i6.done) break;
        _ref5 = _i6.value;
      }

      var node = _ref5;
      this.nodes.splice(exist, 0, node);
    }

    var index;

    for (var id in this.indexes) {
      index = this.indexes[id];

      if (exist <= index) {
        this.indexes[id] = index + nodes.length;
      }
    }

    return this;
  }
  /**
   * Insert new node after old node within the container.
   *
   * @param {Node|number} exist             Child or child’s index.
   * @param {Node|object|string|Node[]} add New node.
   *
   * @return {Node} This node for methods chain.
   */
  ;

  _proto.insertAfter = function insertAfter(exist, add) {
    exist = this.index(exist);
    var nodes = this.normalize(add, this.nodes[exist]).reverse();

    for (var _iterator6 = nodes, _isArray6 = Array.isArray(_iterator6), _i7 = 0, _iterator6 = _isArray6 ? _iterator6 : _iterator6[Symbol.iterator]();;) {
      var _ref6;

      if (_isArray6) {
        if (_i7 >= _iterator6.length) break;
        _ref6 = _iterator6[_i7++];
      } else {
        _i7 = _iterator6.next();
        if (_i7.done) break;
        _ref6 = _i7.value;
      }

      var node = _ref6;
      this.nodes.splice(exist + 1, 0, node);
    }

    var index;

    for (var id in this.indexes) {
      index = this.indexes[id];

      if (exist < index) {
        this.indexes[id] = index + nodes.length;
      }
    }

    return this;
  }
  /**
   * Removes node from the container and cleans the parent properties
   * from the node and its children.
   *
   * @param {Node|number} child Child or child’s index.
   *
   * @return {Node} This node for methods chain
   *
   * @example
   * rule.nodes.length  //=> 5
   * rule.removeChild(decl)
   * rule.nodes.length  //=> 4
   * decl.parent        //=> undefined
   */
  ;

  _proto.removeChild = function removeChild(child) {
    child = this.index(child);
    this.nodes[child].parent = undefined;
    this.nodes.splice(child, 1);
    var index;

    for (var id in this.indexes) {
      index = this.indexes[id];

      if (index >= child) {
        this.indexes[id] = index - 1;
      }
    }

    return this;
  }
  /**
   * Removes all children from the container
   * and cleans their parent properties.
   *
   * @return {Node} This node for methods chain.
   *
   * @example
   * rule.removeAll()
   * rule.nodes.length //=> 0
   */
  ;

  _proto.removeAll = function removeAll() {
    for (var _iterator7 = this.nodes, _isArray7 = Array.isArray(_iterator7), _i8 = 0, _iterator7 = _isArray7 ? _iterator7 : _iterator7[Symbol.iterator]();;) {
      var _ref7;

      if (_isArray7) {
        if (_i8 >= _iterator7.length) break;
        _ref7 = _iterator7[_i8++];
      } else {
        _i8 = _iterator7.next();
        if (_i8.done) break;
        _ref7 = _i8.value;
      }

      var node = _ref7;
      node.parent = undefined;
    }

    this.nodes = [];
    return this;
  }
  /**
   * Passes all declaration values within the container that match pattern
   * through callback, replacing those values with the returned result
   * of callback.
   *
   * This method is useful if you are using a custom unit or function
   * and need to iterate through all values.
   *
   * @param {string|RegExp} pattern      Replace pattern.
   * @param {object} opts                Options to speed up the search.
   * @param {string|string[]} opts.props An array of property names.
   * @param {string} opts.fast           String that’s used to narrow down
   *                                     values and speed up the regexp search.
   * @param {function|string} callback   String to replace pattern or callback
   *                                     that returns a new value. The callback
   *                                     will receive the same arguments
   *                                     as those passed to a function parameter
   *                                     of `String#replace`.
   *
   * @return {Node} This node for methods chain.
   *
   * @example
   * root.replaceValues(/\d+rem/, { fast: 'rem' }, string => {
   *   return 15 * parseInt(string) + 'px'
   * })
   */
  ;

  _proto.replaceValues = function replaceValues(pattern, opts, callback) {
    if (!callback) {
      callback = opts;
      opts = {};
    }

    this.walkDecls(function (decl) {
      if (opts.props && opts.props.indexOf(decl.prop) === -1) return;
      if (opts.fast && decl.value.indexOf(opts.fast) === -1) return;
      decl.value = decl.value.replace(pattern, callback);
    });
    return this;
  }
  /**
   * Returns `true` if callback returns `true`
   * for all of the container’s children.
   *
   * @param {childCondition} condition Iterator returns true or false.
   *
   * @return {boolean} Is every child pass condition.
   *
   * @example
   * const noPrefixes = rule.every(i => i.prop[0] !== '-')
   */
  ;

  _proto.every = function every(condition) {
    return this.nodes.every(condition);
  }
  /**
   * Returns `true` if callback returns `true` for (at least) one
   * of the container’s children.
   *
   * @param {childCondition} condition Iterator returns true or false.
   *
   * @return {boolean} Is some child pass condition.
   *
   * @example
   * const hasPrefix = rule.some(i => i.prop[0] === '-')
   */
  ;

  _proto.some = function some(condition) {
    return this.nodes.some(condition);
  }
  /**
   * Returns a `child`’s index within the {@link Container#nodes} array.
   *
   * @param {Node} child Child of the current container.
   *
   * @return {number} Child index.
   *
   * @example
   * rule.index( rule.nodes[2] ) //=> 2
   */
  ;

  _proto.index = function index(child) {
    if (typeof child === 'number') {
      return child;
    }

    return this.nodes.indexOf(child);
  }
  /**
   * The container’s first child.
   *
   * @type {Node}
   *
   * @example
   * rule.first === rules.nodes[0]
   */
  ;

  _proto.normalize = function normalize(nodes, sample) {
    var _this = this;

    if (typeof nodes === 'string') {
      var parse = require('./parse');

      nodes = cleanSource(parse(nodes).nodes);
    } else if (Array.isArray(nodes)) {
      nodes = nodes.slice(0);

      for (var _iterator8 = nodes, _isArray8 = Array.isArray(_iterator8), _i9 = 0, _iterator8 = _isArray8 ? _iterator8 : _iterator8[Symbol.iterator]();;) {
        var _ref8;

        if (_isArray8) {
          if (_i9 >= _iterator8.length) break;
          _ref8 = _iterator8[_i9++];
        } else {
          _i9 = _iterator8.next();
          if (_i9.done) break;
          _ref8 = _i9.value;
        }

        var i = _ref8;
        if (i.parent) i.parent.removeChild(i, 'ignore');
      }
    } else if (nodes.type === 'root') {
      nodes = nodes.nodes.slice(0);

      for (var _iterator9 = nodes, _isArray9 = Array.isArray(_iterator9), _i10 = 0, _iterator9 = _isArray9 ? _iterator9 : _iterator9[Symbol.iterator]();;) {
        var _ref9;

        if (_isArray9) {
          if (_i10 >= _iterator9.length) break;
          _ref9 = _iterator9[_i10++];
        } else {
          _i10 = _iterator9.next();
          if (_i10.done) break;
          _ref9 = _i10.value;
        }

        var _i11 = _ref9;
        if (_i11.parent) _i11.parent.removeChild(_i11, 'ignore');
      }
    } else if (nodes.type) {
      nodes = [nodes];
    } else if (nodes.prop) {
      if (typeof nodes.value === 'undefined') {
        throw new Error('Value field is missed in node creation');
      } else if (typeof nodes.value !== 'string') {
        nodes.value = String(nodes.value);
      }

      nodes = [new _declaration.default(nodes)];
    } else if (nodes.selector) {
      var Rule = require('./rule');

      nodes = [new Rule(nodes)];
    } else if (nodes.name) {
      var AtRule = require('./at-rule');

      nodes = [new AtRule(nodes)];
    } else if (nodes.text) {
      nodes = [new _comment.default(nodes)];
    } else {
      throw new Error('Unknown node type in node creation');
    }

    var processed = nodes.map(function (i) {
      if (i.parent) i.parent.removeChild(i);

      if (typeof i.raws.before === 'undefined') {
        if (sample && typeof sample.raws.before !== 'undefined') {
          i.raws.before = sample.raws.before.replace(/[^\s]/g, '');
        }
      }

      i.parent = _this;
      return i;
    });
    return processed;
  }
  /**
   * @memberof Container#
   * @member {Node[]} nodes An array containing the container’s children.
   *
   * @example
   * const root = postcss.parse('a { color: black }')
   * root.nodes.length           //=> 1
   * root.nodes[0].selector      //=> 'a'
   * root.nodes[0].nodes[0].prop //=> 'color'
   */
  ;

  _createClass(Container, [{
    key: "first",
    get: function get() {
      if (!this.nodes) return undefined;
      return this.nodes[0];
    }
    /**
     * The container’s last child.
     *
     * @type {Node}
     *
     * @example
     * rule.last === rule.nodes[rule.nodes.length - 1]
     */

  }, {
    key: "last",
    get: function get() {
      if (!this.nodes) return undefined;
      return this.nodes[this.nodes.length - 1];
    }
  }]);

  return Container;
}(_node.default);

var _default = Container;
/**
 * @callback childCondition
 * @param {Node} node    Container child.
 * @param {number} index Child index.
 * @param {Node[]} nodes All container children.
 * @return {boolean}
 */

/**
 * @callback childIterator
 * @param {Node} node    Container child.
 * @param {number} index Child index.
 * @return {false|undefined} Returning `false` will break iteration.
 */

exports.default = _default;
module.exports = exports.default;


},{"./at-rule":44,"./comment":45,"./declaration":48,"./node":53,"./parse":54,"./rule":61}],47:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.default = void 0;

var _supportsColor = _interopRequireDefault(require("supports-color"));

var _chalk = _interopRequireDefault(require("chalk"));

var _terminalHighlight = _interopRequireDefault(require("./terminal-highlight"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _construct(Parent, args, Class) { if (isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * The CSS parser throws this error for broken CSS.
 *
 * Custom parsers can throw this error for broken custom syntax using
 * the {@link Node#error} method.
 *
 * PostCSS will use the input source map to detect the original error location.
 * If you wrote a Sass file, compiled it to CSS and then parsed it with PostCSS,
 * PostCSS will show the original position in the Sass file.
 *
 * If you need the position in the PostCSS input
 * (e.g., to debug the previous compiler), use `error.input.file`.
 *
 * @example
 * // Catching and checking syntax error
 * try {
 *   postcss.parse('a{')
 * } catch (error) {
 *   if (error.name === 'CssSyntaxError') {
 *     error //=> CssSyntaxError
 *   }
 * }
 *
 * @example
 * // Raising error from plugin
 * throw node.error('Unknown variable', { plugin: 'postcss-vars' })
 */
var CssSyntaxError =
/*#__PURE__*/
function (_Error) {
  _inheritsLoose(CssSyntaxError, _Error);

  /**
   * @param {string} message  Error message.
   * @param {number} [line]   Source line of the error.
   * @param {number} [column] Source column of the error.
   * @param {string} [source] Source code of the broken file.
   * @param {string} [file]   Absolute path to the broken file.
   * @param {string} [plugin] PostCSS plugin name, if error came from plugin.
   */
  function CssSyntaxError(message, line, column, source, file, plugin) {
    var _this;

    _this = _Error.call(this, message) || this;
    /**
     * Always equal to `'CssSyntaxError'`. You should always check error type
     * by `error.name === 'CssSyntaxError'`
     * instead of `error instanceof CssSyntaxError`,
     * because npm could have several PostCSS versions.
     *
     * @type {string}
     *
     * @example
     * if (error.name === 'CssSyntaxError') {
     *   error //=> CssSyntaxError
     * }
     */

    _this.name = 'CssSyntaxError';
    /**
     * Error message.
     *
     * @type {string}
     *
     * @example
     * error.message //=> 'Unclosed block'
     */

    _this.reason = message;

    if (file) {
      /**
       * Absolute path to the broken file.
       *
       * @type {string}
       *
       * @example
       * error.file       //=> 'a.sass'
       * error.input.file //=> 'a.css'
       */
      _this.file = file;
    }

    if (source) {
      /**
       * Source code of the broken file.
       *
       * @type {string}
       *
       * @example
       * error.source       //=> 'a { b {} }'
       * error.input.column //=> 'a b { }'
       */
      _this.source = source;
    }

    if (plugin) {
      /**
       * Plugin name, if error came from plugin.
       *
       * @type {string}
       *
       * @example
       * error.plugin //=> 'postcss-vars'
       */
      _this.plugin = plugin;
    }

    if (typeof line !== 'undefined' && typeof column !== 'undefined') {
      /**
       * Source line of the error.
       *
       * @type {number}
       *
       * @example
       * error.line       //=> 2
       * error.input.line //=> 4
       */
      _this.line = line;
      /**
       * Source column of the error.
       *
       * @type {number}
       *
       * @example
       * error.column       //=> 1
       * error.input.column //=> 4
       */

      _this.column = column;
    }

    _this.setMessage();

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_assertThisInitialized(_this)), CssSyntaxError);
    }

    return _this;
  }

  var _proto = CssSyntaxError.prototype;

  _proto.setMessage = function setMessage() {
    /**
     * Full error text in the GNU error format
     * with plugin, file, line and column.
     *
     * @type {string}
     *
     * @example
     * error.message //=> 'a.css:1:1: Unclosed block'
     */
    this.message = this.plugin ? this.plugin + ': ' : '';
    this.message += this.file ? this.file : '<css input>';

    if (typeof this.line !== 'undefined') {
      this.message += ':' + this.line + ':' + this.column;
    }

    this.message += ': ' + this.reason;
  }
  /**
   * Returns a few lines of CSS source that caused the error.
   *
   * If the CSS has an input source map without `sourceContent`,
   * this method will return an empty string.
   *
   * @param {boolean} [color] Whether arrow will be colored red by terminal
   *                          color codes. By default, PostCSS will detect
   *                          color support by `process.stdout.isTTY`
   *                          and `process.env.NODE_DISABLE_COLORS`.
   *
   * @example
   * error.showSourceCode() //=> "  4 | }
   *                        //      5 | a {
   *                        //    > 6 |   bad
   *                        //        |   ^
   *                        //      7 | }
   *                        //      8 | b {"
   *
   * @return {string} Few lines of CSS source that caused the error.
   */
  ;

  _proto.showSourceCode = function showSourceCode(color) {
    var _this2 = this;

    if (!this.source) return '';
    var css = this.source;

    if (_terminalHighlight.default) {
      if (typeof color === 'undefined') color = _supportsColor.default.stdout;
      if (color) css = (0, _terminalHighlight.default)(css);
    }

    var lines = css.split(/\r?\n/);
    var start = Math.max(this.line - 3, 0);
    var end = Math.min(this.line + 2, lines.length);
    var maxWidth = String(end).length;

    function mark(text) {
      if (color && _chalk.default.red) {
        return _chalk.default.red.bold(text);
      }

      return text;
    }

    function aside(text) {
      if (color && _chalk.default.gray) {
        return _chalk.default.gray(text);
      }

      return text;
    }

    return lines.slice(start, end).map(function (line, index) {
      var number = start + 1 + index;
      var gutter = ' ' + (' ' + number).slice(-maxWidth) + ' | ';

      if (number === _this2.line) {
        var spacing = aside(gutter.replace(/\d/g, ' ')) + line.slice(0, _this2.column - 1).replace(/[^\t]/g, ' ');
        return mark('>') + aside(gutter) + line + '\n ' + spacing + mark('^');
      }

      return ' ' + aside(gutter) + line;
    }).join('\n');
  }
  /**
   * Returns error position, message and source code of the broken part.
   *
   * @example
   * error.toString() //=> "CssSyntaxError: app.css:1:1: Unclosed block
   *                  //    > 1 | a {
   *                  //        | ^"
   *
   * @return {string} Error position, message and source code.
   */
  ;

  _proto.toString = function toString() {
    var code = this.showSourceCode();

    if (code) {
      code = '\n\n' + code + '\n';
    }

    return this.name + ': ' + this.message + code;
  }
  /**
   * @memberof CssSyntaxError#
   * @member {Input} input Input object with PostCSS internal information
   *                       about input file. If input has source map
   *                       from previous tool, PostCSS will use origin
   *                       (for example, Sass) source. You can use this
   *                       object to get PostCSS input source.
   *
   * @example
   * error.input.file //=> 'a.css'
   * error.file       //=> 'a.sass'
   */
  ;

  return CssSyntaxError;
}(_wrapNativeSuper(Error));

var _default = CssSyntaxError;
exports.default = _default;
module.exports = exports.default;


},{"./terminal-highlight":4,"chalk":4,"supports-color":4}],48:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.default = void 0;

var _node = _interopRequireDefault(require("./node"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * Represents a CSS declaration.
 *
 * @extends Node
 *
 * @example
 * const root = postcss.parse('a { color: black }')
 * const decl = root.first.first
 * decl.type       //=> 'decl'
 * decl.toString() //=> ' color: black'
 */
var Declaration =
/*#__PURE__*/
function (_Node) {
  _inheritsLoose(Declaration, _Node);

  function Declaration(defaults) {
    var _this;

    _this = _Node.call(this, defaults) || this;
    _this.type = 'decl';
    return _this;
  }
  /**
   * @memberof Declaration#
   * @member {string} prop The declaration’s property name.
   *
   * @example
   * const root = postcss.parse('a { color: black }')
   * const decl = root.first.first
   * decl.prop //=> 'color'
   */

  /**
   * @memberof Declaration#
   * @member {string} value The declaration’s value.
   *
   * @example
   * const root = postcss.parse('a { color: black }')
   * const decl = root.first.first
   * decl.value //=> 'black'
   */

  /**
   * @memberof Declaration#
   * @member {boolean} important `true` if the declaration
   *                             has an !important annotation.
   *
   * @example
   * const root = postcss.parse('a { color: black !important; color: red }')
   * root.first.first.important //=> true
   * root.first.last.important  //=> undefined
   */

  /**
   * @memberof Declaration#
   * @member {object} raws Information to generate byte-to-byte equal
   *                       node string as it was in the origin input.
   *
   * Every parser saves its own properties,
   * but the default CSS parser uses:
   *
   * * `before`: the space symbols before the node. It also stores `*`
   *   and `_` symbols before the declaration (IE hack).
   * * `between`: the symbols between the property and value
   *   for declarations.
   * * `important`: the content of the important statement,
   *   if it is not just `!important`.
   *
   * PostCSS cleans declaration from comments and extra spaces,
   * but it stores origin content in raws properties.
   * As such, if you don’t change a declaration’s value,
   * PostCSS will use the raw value with comments.
   *
   * @example
   * const root = postcss.parse('a {\n  color:black\n}')
   * root.first.first.raws //=> { before: '\n  ', between: ':' }
   */


  return Declaration;
}(_node.default);

var _default = Declaration;
exports.default = _default;
module.exports = exports.default;


},{"./node":53}],49:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.default = void 0;

var _cssSyntaxError = _interopRequireDefault(require("./css-syntax-error"));

var _previousMap = _interopRequireDefault(require("./previous-map"));

var _path = _interopRequireDefault(require("path"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var sequence = 0;
/**
 * Represents the source CSS.
 *
 * @example
 * const root  = postcss.parse(css, { from: file })
 * const input = root.source.input
 */

var Input =
/*#__PURE__*/
function () {
  /**
   * @param {string} css    Input CSS source.
   * @param {object} [opts] {@link Processor#process} options.
   */
  function Input(css, opts) {
    if (opts === void 0) {
      opts = {};
    }

    if (css === null || typeof css === 'object' && !css.toString) {
      throw new Error("PostCSS received " + css + " instead of CSS string");
    }
    /**
     * Input CSS source
     *
     * @type {string}
     *
     * @example
     * const input = postcss.parse('a{}', { from: file }).input
     * input.css //=> "a{}"
     */


    this.css = css.toString();

    if (this.css[0] === "\uFEFF" || this.css[0] === "\uFFFE") {
      this.hasBOM = true;
      this.css = this.css.slice(1);
    } else {
      this.hasBOM = false;
    }

    if (opts.from) {
      if (/^\w+:\/\//.test(opts.from)) {
        /**
         * The absolute path to the CSS source file defined
         * with the `from` option.
         *
         * @type {string}
         *
         * @example
         * const root = postcss.parse(css, { from: 'a.css' })
         * root.source.input.file //=> '/home/ai/a.css'
         */
        this.file = opts.from;
      } else {
        this.file = _path.default.resolve(opts.from);
      }
    }

    var map = new _previousMap.default(this.css, opts);

    if (map.text) {
      /**
       * The input source map passed from a compilation step before PostCSS
       * (for example, from Sass compiler).
       *
       * @type {PreviousMap}
       *
       * @example
       * root.source.input.map.consumer().sources //=> ['a.sass']
       */
      this.map = map;
      var file = map.consumer().file;
      if (!this.file && file) this.file = this.mapResolve(file);
    }

    if (!this.file) {
      sequence += 1;
      /**
       * The unique ID of the CSS source. It will be created if `from` option
       * is not provided (because PostCSS does not know the file path).
       *
       * @type {string}
       *
       * @example
       * const root = postcss.parse(css)
       * root.source.input.file //=> undefined
       * root.source.input.id   //=> "<input css 1>"
       */

      this.id = '<input css ' + sequence + '>';
    }

    if (this.map) this.map.file = this.from;
  }

  var _proto = Input.prototype;

  _proto.error = function error(message, line, column, opts) {
    if (opts === void 0) {
      opts = {};
    }

    var result;
    var origin = this.origin(line, column);

    if (origin) {
      result = new _cssSyntaxError.default(message, origin.line, origin.column, origin.source, origin.file, opts.plugin);
    } else {
      result = new _cssSyntaxError.default(message, line, column, this.css, this.file, opts.plugin);
    }

    result.input = {
      line: line,
      column: column,
      source: this.css
    };
    if (this.file) result.input.file = this.file;
    return result;
  }
  /**
   * Reads the input source map and returns a symbol position
   * in the input source (e.g., in a Sass file that was compiled
   * to CSS before being passed to PostCSS).
   *
   * @param {number} line   Line in input CSS.
   * @param {number} column Column in input CSS.
   *
   * @return {filePosition} Position in input source.
   *
   * @example
   * root.source.input.origin(1, 1) //=> { file: 'a.css', line: 3, column: 1 }
   */
  ;

  _proto.origin = function origin(line, column) {
    if (!this.map) return false;
    var consumer = this.map.consumer();
    var from = consumer.originalPositionFor({
      line: line,
      column: column
    });
    if (!from.source) return false;
    var result = {
      file: this.mapResolve(from.source),
      line: from.line,
      column: from.column
    };
    var source = consumer.sourceContentFor(from.source);
    if (source) result.source = source;
    return result;
  };

  _proto.mapResolve = function mapResolve(file) {
    if (/^\w+:\/\//.test(file)) {
      return file;
    }

    return _path.default.resolve(this.map.consumer().sourceRoot || '.', file);
  }
  /**
   * The CSS source identifier. Contains {@link Input#file} if the user
   * set the `from` option, or {@link Input#id} if they did not.
   *
   * @type {string}
   *
   * @example
   * const root = postcss.parse(css, { from: 'a.css' })
   * root.source.input.from //=> "/home/ai/a.css"
   *
   * const root = postcss.parse(css)
   * root.source.input.from //=> "<input css 1>"
   */
  ;

  _createClass(Input, [{
    key: "from",
    get: function get() {
      return this.file || this.id;
    }
  }]);

  return Input;
}();

var _default = Input;
/**
 * @typedef  {object} filePosition
 * @property {string} file   Path to file.
 * @property {number} line   Source line in file.
 * @property {number} column Source column in file.
 */

exports.default = _default;
module.exports = exports.default;


},{"./css-syntax-error":47,"./previous-map":57,"path":43}],50:[function(require,module,exports){
(function (process){
"use strict";

exports.__esModule = true;
exports.default = void 0;

var _mapGenerator = _interopRequireDefault(require("./map-generator"));

var _stringify2 = _interopRequireDefault(require("./stringify"));

var _warnOnce = _interopRequireDefault(require("./warn-once"));

var _result = _interopRequireDefault(require("./result"));

var _parse = _interopRequireDefault(require("./parse"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function isPromise(obj) {
  return typeof obj === 'object' && typeof obj.then === 'function';
}
/**
 * A Promise proxy for the result of PostCSS transformations.
 *
 * A `LazyResult` instance is returned by {@link Processor#process}.
 *
 * @example
 * const lazy = postcss([autoprefixer]).process(css)
 */


var LazyResult =
/*#__PURE__*/
function () {
  function LazyResult(processor, css, opts) {
    this.stringified = false;
    this.processed = false;
    var root;

    if (typeof css === 'object' && css !== null && css.type === 'root') {
      root = css;
    } else if (css instanceof LazyResult || css instanceof _result.default) {
      root = css.root;

      if (css.map) {
        if (typeof opts.map === 'undefined') opts.map = {};
        if (!opts.map.inline) opts.map.inline = false;
        opts.map.prev = css.map;
      }
    } else {
      var parser = _parse.default;
      if (opts.syntax) parser = opts.syntax.parse;
      if (opts.parser) parser = opts.parser;
      if (parser.parse) parser = parser.parse;

      try {
        root = parser(css, opts);
      } catch (error) {
        this.error = error;
      }
    }

    this.result = new _result.default(processor, root, opts);
  }
  /**
   * Returns a {@link Processor} instance, which will be used
   * for CSS transformations.
   *
   * @type {Processor}
   */


  var _proto = LazyResult.prototype;

  /**
   * Processes input CSS through synchronous plugins
   * and calls {@link Result#warnings()}.
   *
   * @return {Warning[]} Warnings from plugins.
   */
  _proto.warnings = function warnings() {
    return this.sync().warnings();
  }
  /**
   * Alias for the {@link LazyResult#css} property.
   *
   * @example
   * lazy + '' === lazy.css
   *
   * @return {string} Output CSS.
   */
  ;

  _proto.toString = function toString() {
    return this.css;
  }
  /**
   * Processes input CSS through synchronous and asynchronous plugins
   * and calls `onFulfilled` with a Result instance. If a plugin throws
   * an error, the `onRejected` callback will be executed.
   *
   * It implements standard Promise API.
   *
   * @param {onFulfilled} onFulfilled Callback will be executed
   *                                  when all plugins will finish work.
   * @param {onRejected}  onRejected  Callback will be executed on any error.
   *
   * @return {Promise} Promise API to make queue.
   *
   * @example
   * postcss([autoprefixer]).process(css, { from: cssPath }).then(result => {
   *   console.log(result.css)
   * })
   */
  ;

  _proto.then = function then(onFulfilled, onRejected) {
    if (process.env.NODE_ENV !== 'production') {
      if (!('from' in this.opts)) {
        (0, _warnOnce.default)('Without `from` option PostCSS could generate wrong source map ' + 'and will not find Browserslist config. Set it to CSS file path ' + 'or to `undefined` to prevent this warning.');
      }
    }

    return this.async().then(onFulfilled, onRejected);
  }
  /**
   * Processes input CSS through synchronous and asynchronous plugins
   * and calls onRejected for each error thrown in any plugin.
   *
   * It implements standard Promise API.
   *
   * @param {onRejected} onRejected Callback will be executed on any error.
   *
   * @return {Promise} Promise API to make queue.
   *
   * @example
   * postcss([autoprefixer]).process(css).then(result => {
   *   console.log(result.css)
   * }).catch(error => {
   *   console.error(error)
   * })
   */
  ;

  _proto.catch = function _catch(onRejected) {
    return this.async().catch(onRejected);
  }
  /**
   * Processes input CSS through synchronous and asynchronous plugins
   * and calls onFinally on any error or when all plugins will finish work.
   *
   * It implements standard Promise API.
   *
   * @param {onFinally} onFinally Callback will be executed on any error or
   *                              when all plugins will finish work.
   *
   * @return {Promise} Promise API to make queue.
   *
   * @example
   * postcss([autoprefixer]).process(css).finally(() => {
   *   console.log('processing ended')
   * })
   */
  ;

  _proto.finally = function _finally(onFinally) {
    return this.async().then(onFinally, onFinally);
  };

  _proto.handleError = function handleError(error, plugin) {
    try {
      this.error = error;

      if (error.name === 'CssSyntaxError' && !error.plugin) {
        error.plugin = plugin.postcssPlugin;
        error.setMessage();
      } else if (plugin.postcssVersion) {
        if (process.env.NODE_ENV !== 'production') {
          var pluginName = plugin.postcssPlugin;
          var pluginVer = plugin.postcssVersion;
          var runtimeVer = this.result.processor.version;
          var a = pluginVer.split('.');
          var b = runtimeVer.split('.');

          if (a[0] !== b[0] || parseInt(a[1]) > parseInt(b[1])) {
            console.error('Unknown error from PostCSS plugin. Your current PostCSS ' + 'version is ' + runtimeVer + ', but ' + pluginName + ' uses ' + pluginVer + '. Perhaps this is the source of the error below.');
          }
        }
      }
    } catch (err) {
      if (console && console.error) console.error(err);
    }
  };

  _proto.asyncTick = function asyncTick(resolve, reject) {
    var _this = this;

    if (this.plugin >= this.processor.plugins.length) {
      this.processed = true;
      return resolve();
    }

    try {
      var plugin = this.processor.plugins[this.plugin];
      var promise = this.run(plugin);
      this.plugin += 1;

      if (isPromise(promise)) {
        promise.then(function () {
          _this.asyncTick(resolve, reject);
        }).catch(function (error) {
          _this.handleError(error, plugin);

          _this.processed = true;
          reject(error);
        });
      } else {
        this.asyncTick(resolve, reject);
      }
    } catch (error) {
      this.processed = true;
      reject(error);
    }
  };

  _proto.async = function async() {
    var _this2 = this;

    if (this.processed) {
      return new Promise(function (resolve, reject) {
        if (_this2.error) {
          reject(_this2.error);
        } else {
          resolve(_this2.stringify());
        }
      });
    }

    if (this.processing) {
      return this.processing;
    }

    this.processing = new Promise(function (resolve, reject) {
      if (_this2.error) return reject(_this2.error);
      _this2.plugin = 0;

      _this2.asyncTick(resolve, reject);
    }).then(function () {
      _this2.processed = true;
      return _this2.stringify();
    });
    return this.processing;
  };

  _proto.sync = function sync() {
    if (this.processed) return this.result;
    this.processed = true;

    if (this.processing) {
      throw new Error('Use process(css).then(cb) to work with async plugins');
    }

    if (this.error) throw this.error;

    for (var _iterator = this.result.processor.plugins, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var plugin = _ref;
      var promise = this.run(plugin);

      if (isPromise(promise)) {
        throw new Error('Use process(css).then(cb) to work with async plugins');
      }
    }

    return this.result;
  };

  _proto.run = function run(plugin) {
    this.result.lastPlugin = plugin;

    try {
      return plugin(this.result.root, this.result);
    } catch (error) {
      this.handleError(error, plugin);
      throw error;
    }
  };

  _proto.stringify = function stringify() {
    if (this.stringified) return this.result;
    this.stringified = true;
    this.sync();
    var opts = this.result.opts;
    var str = _stringify2.default;
    if (opts.syntax) str = opts.syntax.stringify;
    if (opts.stringifier) str = opts.stringifier;
    if (str.stringify) str = str.stringify;
    var map = new _mapGenerator.default(str, this.result.root, this.result.opts);
    var data = map.generate();
    this.result.css = data[0];
    this.result.map = data[1];
    return this.result;
  };

  _createClass(LazyResult, [{
    key: "processor",
    get: function get() {
      return this.result.processor;
    }
    /**
     * Options from the {@link Processor#process} call.
     *
     * @type {processOptions}
     */

  }, {
    key: "opts",
    get: function get() {
      return this.result.opts;
    }
    /**
     * Processes input CSS through synchronous plugins, converts `Root`
     * to a CSS string and returns {@link Result#css}.
     *
     * This property will only work with synchronous plugins.
     * If the processor contains any asynchronous plugins
     * it will throw an error. This is why this method is only
     * for debug purpose, you should always use {@link LazyResult#then}.
     *
     * @type {string}
     * @see Result#css
     */

  }, {
    key: "css",
    get: function get() {
      return this.stringify().css;
    }
    /**
     * An alias for the `css` property. Use it with syntaxes
     * that generate non-CSS output.
     *
     * This property will only work with synchronous plugins.
     * If the processor contains any asynchronous plugins
     * it will throw an error. This is why this method is only
     * for debug purpose, you should always use {@link LazyResult#then}.
     *
     * @type {string}
     * @see Result#content
     */

  }, {
    key: "content",
    get: function get() {
      return this.stringify().content;
    }
    /**
     * Processes input CSS through synchronous plugins
     * and returns {@link Result#map}.
     *
     * This property will only work with synchronous plugins.
     * If the processor contains any asynchronous plugins
     * it will throw an error. This is why this method is only
     * for debug purpose, you should always use {@link LazyResult#then}.
     *
     * @type {SourceMapGenerator}
     * @see Result#map
     */

  }, {
    key: "map",
    get: function get() {
      return this.stringify().map;
    }
    /**
     * Processes input CSS through synchronous plugins
     * and returns {@link Result#root}.
     *
     * This property will only work with synchronous plugins. If the processor
     * contains any asynchronous plugins it will throw an error.
     *
     * This is why this method is only for debug purpose,
     * you should always use {@link LazyResult#then}.
     *
     * @type {Root}
     * @see Result#root
     */

  }, {
    key: "root",
    get: function get() {
      return this.sync().root;
    }
    /**
     * Processes input CSS through synchronous plugins
     * and returns {@link Result#messages}.
     *
     * This property will only work with synchronous plugins. If the processor
     * contains any asynchronous plugins it will throw an error.
     *
     * This is why this method is only for debug purpose,
     * you should always use {@link LazyResult#then}.
     *
     * @type {Message[]}
     * @see Result#messages
     */

  }, {
    key: "messages",
    get: function get() {
      return this.sync().messages;
    }
  }]);

  return LazyResult;
}();

var _default = LazyResult;
/**
 * @callback onFulfilled
 * @param {Result} result
 */

/**
 * @callback onRejected
 * @param {Error} error
 */

exports.default = _default;
module.exports = exports.default;


}).call(this,require('_process'))
},{"./map-generator":52,"./parse":54,"./result":59,"./stringify":63,"./warn-once":66,"_process":68}],51:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.default = void 0;

/**
 * Contains helpers for safely splitting lists of CSS values,
 * preserving parentheses and quotes.
 *
 * @example
 * const list = postcss.list
 *
 * @namespace list
 */
var list = {
  split: function split(string, separators, last) {
    var array = [];
    var current = '';
    var split = false;
    var func = 0;
    var quote = false;
    var escape = false;

    for (var i = 0; i < string.length; i++) {
      var letter = string[i];

      if (quote) {
        if (escape) {
          escape = false;
        } else if (letter === '\\') {
          escape = true;
        } else if (letter === quote) {
          quote = false;
        }
      } else if (letter === '"' || letter === '\'') {
        quote = letter;
      } else if (letter === '(') {
        func += 1;
      } else if (letter === ')') {
        if (func > 0) func -= 1;
      } else if (func === 0) {
        if (separators.indexOf(letter) !== -1) split = true;
      }

      if (split) {
        if (current !== '') array.push(current.trim());
        current = '';
        split = false;
      } else {
        current += letter;
      }
    }

    if (last || current !== '') array.push(current.trim());
    return array;
  },

  /**
   * Safely splits space-separated values (such as those for `background`,
   * `border-radius`, and other shorthand properties).
   *
   * @param {string} string Space-separated values.
   *
   * @return {string[]} Split values.
   *
   * @example
   * postcss.list.space('1px calc(10% + 1px)') //=> ['1px', 'calc(10% + 1px)']
   */
  space: function space(string) {
    var spaces = [' ', '\n', '\t'];
    return list.split(string, spaces);
  },

  /**
   * Safely splits comma-separated values (such as those for `transition-*`
   * and `background` properties).
   *
   * @param {string} string Comma-separated values.
   *
   * @return {string[]} Split values.
   *
   * @example
   * postcss.list.comma('black, linear-gradient(white, black)')
   * //=> ['black', 'linear-gradient(white, black)']
   */
  comma: function comma(string) {
    return list.split(string, [','], true);
  }
};
var _default = list;
exports.default = _default;
module.exports = exports.default;


},{}],52:[function(require,module,exports){
(function (Buffer){
"use strict";

exports.__esModule = true;
exports.default = void 0;

var _sourceMap = _interopRequireDefault(require("source-map"));

var _path = _interopRequireDefault(require("path"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapGenerator =
/*#__PURE__*/
function () {
  function MapGenerator(stringify, root, opts) {
    this.stringify = stringify;
    this.mapOpts = opts.map || {};
    this.root = root;
    this.opts = opts;
  }

  var _proto = MapGenerator.prototype;

  _proto.isMap = function isMap() {
    if (typeof this.opts.map !== 'undefined') {
      return !!this.opts.map;
    }

    return this.previous().length > 0;
  };

  _proto.previous = function previous() {
    var _this = this;

    if (!this.previousMaps) {
      this.previousMaps = [];
      this.root.walk(function (node) {
        if (node.source && node.source.input.map) {
          var map = node.source.input.map;

          if (_this.previousMaps.indexOf(map) === -1) {
            _this.previousMaps.push(map);
          }
        }
      });
    }

    return this.previousMaps;
  };

  _proto.isInline = function isInline() {
    if (typeof this.mapOpts.inline !== 'undefined') {
      return this.mapOpts.inline;
    }

    var annotation = this.mapOpts.annotation;

    if (typeof annotation !== 'undefined' && annotation !== true) {
      return false;
    }

    if (this.previous().length) {
      return this.previous().some(function (i) {
        return i.inline;
      });
    }

    return true;
  };

  _proto.isSourcesContent = function isSourcesContent() {
    if (typeof this.mapOpts.sourcesContent !== 'undefined') {
      return this.mapOpts.sourcesContent;
    }

    if (this.previous().length) {
      return this.previous().some(function (i) {
        return i.withContent();
      });
    }

    return true;
  };

  _proto.clearAnnotation = function clearAnnotation() {
    if (this.mapOpts.annotation === false) return;
    var node;

    for (var i = this.root.nodes.length - 1; i >= 0; i--) {
      node = this.root.nodes[i];
      if (node.type !== 'comment') continue;

      if (node.text.indexOf('# sourceMappingURL=') === 0) {
        this.root.removeChild(i);
      }
    }
  };

  _proto.setSourcesContent = function setSourcesContent() {
    var _this2 = this;

    var already = {};
    this.root.walk(function (node) {
      if (node.source) {
        var from = node.source.input.from;

        if (from && !already[from]) {
          already[from] = true;

          var relative = _this2.relative(from);

          _this2.map.setSourceContent(relative, node.source.input.css);
        }
      }
    });
  };

  _proto.applyPrevMaps = function applyPrevMaps() {
    for (var _iterator = this.previous(), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var prev = _ref;
      var from = this.relative(prev.file);

      var root = prev.root || _path.default.dirname(prev.file);

      var map = void 0;

      if (this.mapOpts.sourcesContent === false) {
        map = new _sourceMap.default.SourceMapConsumer(prev.text);

        if (map.sourcesContent) {
          map.sourcesContent = map.sourcesContent.map(function () {
            return null;
          });
        }
      } else {
        map = prev.consumer();
      }

      this.map.applySourceMap(map, from, this.relative(root));
    }
  };

  _proto.isAnnotation = function isAnnotation() {
    if (this.isInline()) {
      return true;
    }

    if (typeof this.mapOpts.annotation !== 'undefined') {
      return this.mapOpts.annotation;
    }

    if (this.previous().length) {
      return this.previous().some(function (i) {
        return i.annotation;
      });
    }

    return true;
  };

  _proto.toBase64 = function toBase64(str) {
    if (Buffer) {
      return Buffer.from(str).toString('base64');
    }

    return window.btoa(unescape(encodeURIComponent(str)));
  };

  _proto.addAnnotation = function addAnnotation() {
    var content;

    if (this.isInline()) {
      content = 'data:application/json;base64,' + this.toBase64(this.map.toString());
    } else if (typeof this.mapOpts.annotation === 'string') {
      content = this.mapOpts.annotation;
    } else {
      content = this.outputFile() + '.map';
    }

    var eol = '\n';
    if (this.css.indexOf('\r\n') !== -1) eol = '\r\n';
    this.css += eol + '/*# sourceMappingURL=' + content + ' */';
  };

  _proto.outputFile = function outputFile() {
    if (this.opts.to) {
      return this.relative(this.opts.to);
    }

    if (this.opts.from) {
      return this.relative(this.opts.from);
    }

    return 'to.css';
  };

  _proto.generateMap = function generateMap() {
    this.generateString();
    if (this.isSourcesContent()) this.setSourcesContent();
    if (this.previous().length > 0) this.applyPrevMaps();
    if (this.isAnnotation()) this.addAnnotation();

    if (this.isInline()) {
      return [this.css];
    }

    return [this.css, this.map];
  };

  _proto.relative = function relative(file) {
    if (file.indexOf('<') === 0) return file;
    if (/^\w+:\/\//.test(file)) return file;
    var from = this.opts.to ? _path.default.dirname(this.opts.to) : '.';

    if (typeof this.mapOpts.annotation === 'string') {
      from = _path.default.dirname(_path.default.resolve(from, this.mapOpts.annotation));
    }

    file = _path.default.relative(from, file);

    if (_path.default.sep === '\\') {
      return file.replace(/\\/g, '/');
    }

    return file;
  };

  _proto.sourcePath = function sourcePath(node) {
    if (this.mapOpts.from) {
      return this.mapOpts.from;
    }

    return this.relative(node.source.input.from);
  };

  _proto.generateString = function generateString() {
    var _this3 = this;

    this.css = '';
    this.map = new _sourceMap.default.SourceMapGenerator({
      file: this.outputFile()
    });
    var line = 1;
    var column = 1;
    var lines, last;
    this.stringify(this.root, function (str, node, type) {
      _this3.css += str;

      if (node && type !== 'end') {
        if (node.source && node.source.start) {
          _this3.map.addMapping({
            source: _this3.sourcePath(node),
            generated: {
              line: line,
              column: column - 1
            },
            original: {
              line: node.source.start.line,
              column: node.source.start.column - 1
            }
          });
        } else {
          _this3.map.addMapping({
            source: '<no source>',
            original: {
              line: 1,
              column: 0
            },
            generated: {
              line: line,
              column: column - 1
            }
          });
        }
      }

      lines = str.match(/\n/g);

      if (lines) {
        line += lines.length;
        last = str.lastIndexOf('\n');
        column = str.length - last;
      } else {
        column += str.length;
      }

      if (node && type !== 'start') {
        var p = node.parent || {
          raws: {}
        };

        if (node.type !== 'decl' || node !== p.last || p.raws.semicolon) {
          if (node.source && node.source.end) {
            _this3.map.addMapping({
              source: _this3.sourcePath(node),
              generated: {
                line: line,
                column: column - 2
              },
              original: {
                line: node.source.end.line,
                column: node.source.end.column - 1
              }
            });
          } else {
            _this3.map.addMapping({
              source: '<no source>',
              original: {
                line: 1,
                column: 0
              },
              generated: {
                line: line,
                column: column - 1
              }
            });
          }
        }
      }
    });
  };

  _proto.generate = function generate() {
    this.clearAnnotation();

    if (this.isMap()) {
      return this.generateMap();
    }

    var result = '';
    this.stringify(this.root, function (i) {
      result += i;
    });
    return [result];
  };

  return MapGenerator;
}();

var _default = MapGenerator;
exports.default = _default;
module.exports = exports.default;


}).call(this,require("buffer").Buffer)
},{"buffer":5,"path":43,"source-map":84}],53:[function(require,module,exports){
(function (process){
"use strict";

exports.__esModule = true;
exports.default = void 0;

var _cssSyntaxError = _interopRequireDefault(require("./css-syntax-error"));

var _stringifier = _interopRequireDefault(require("./stringifier"));

var _stringify = _interopRequireDefault(require("./stringify"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function cloneNode(obj, parent) {
  var cloned = new obj.constructor();

  for (var i in obj) {
    if (!obj.hasOwnProperty(i)) continue;
    var value = obj[i];
    var type = typeof value;

    if (i === 'parent' && type === 'object') {
      if (parent) cloned[i] = parent;
    } else if (i === 'source') {
      cloned[i] = value;
    } else if (value instanceof Array) {
      cloned[i] = value.map(function (j) {
        return cloneNode(j, cloned);
      });
    } else {
      if (type === 'object' && value !== null) value = cloneNode(value);
      cloned[i] = value;
    }
  }

  return cloned;
}
/**
 * All node classes inherit the following common methods.
 *
 * @abstract
 */


var Node =
/*#__PURE__*/
function () {
  /**
   * @param {object} [defaults] Value for node properties.
   */
  function Node(defaults) {
    if (defaults === void 0) {
      defaults = {};
    }

    this.raws = {};

    if (process.env.NODE_ENV !== 'production') {
      if (typeof defaults !== 'object' && typeof defaults !== 'undefined') {
        throw new Error('PostCSS nodes constructor accepts object, not ' + JSON.stringify(defaults));
      }
    }

    for (var name in defaults) {
      this[name] = defaults[name];
    }
  }
  /**
   * Returns a `CssSyntaxError` instance containing the original position
   * of the node in the source, showing line and column numbers and also
   * a small excerpt to facilitate debugging.
   *
   * If present, an input source map will be used to get the original position
   * of the source, even from a previous compilation step
   * (e.g., from Sass compilation).
   *
   * This method produces very useful error messages.
   *
   * @param {string} message     Error description.
   * @param {object} [opts]      Options.
   * @param {string} opts.plugin Plugin name that created this error.
   *                             PostCSS will set it automatically.
   * @param {string} opts.word   A word inside a node’s string that should
   *                             be highlighted as the source of the error.
   * @param {number} opts.index  An index inside a node’s string that should
   *                             be highlighted as the source of the error.
   *
   * @return {CssSyntaxError} Error object to throw it.
   *
   * @example
   * if (!variables[name]) {
   *   throw decl.error('Unknown variable ' + name, { word: name })
   *   // CssSyntaxError: postcss-vars:a.sass:4:3: Unknown variable $black
   *   //   color: $black
   *   // a
   *   //          ^
   *   //   background: white
   * }
   */


  var _proto = Node.prototype;

  _proto.error = function error(message, opts) {
    if (opts === void 0) {
      opts = {};
    }

    if (this.source) {
      var pos = this.positionBy(opts);
      return this.source.input.error(message, pos.line, pos.column, opts);
    }

    return new _cssSyntaxError.default(message);
  }
  /**
   * This method is provided as a convenience wrapper for {@link Result#warn}.
   *
   * @param {Result} result      The {@link Result} instance
   *                             that will receive the warning.
   * @param {string} text        Warning message.
   * @param {object} [opts]      Options
   * @param {string} opts.plugin Plugin name that created this warning.
   *                             PostCSS will set it automatically.
   * @param {string} opts.word   A word inside a node’s string that should
   *                             be highlighted as the source of the warning.
   * @param {number} opts.index  An index inside a node’s string that should
   *                             be highlighted as the source of the warning.
   *
   * @return {Warning} Created warning object.
   *
   * @example
   * const plugin = postcss.plugin('postcss-deprecated', () => {
   *   return (root, result) => {
   *     root.walkDecls('bad', decl => {
   *       decl.warn(result, 'Deprecated property bad')
   *     })
   *   }
   * })
   */
  ;

  _proto.warn = function warn(result, text, opts) {
    var data = {
      node: this
    };

    for (var i in opts) {
      data[i] = opts[i];
    }

    return result.warn(text, data);
  }
  /**
   * Removes the node from its parent and cleans the parent properties
   * from the node and its children.
   *
   * @example
   * if (decl.prop.match(/^-webkit-/)) {
   *   decl.remove()
   * }
   *
   * @return {Node} Node to make calls chain.
   */
  ;

  _proto.remove = function remove() {
    if (this.parent) {
      this.parent.removeChild(this);
    }

    this.parent = undefined;
    return this;
  }
  /**
   * Returns a CSS string representing the node.
   *
   * @param {stringifier|syntax} [stringifier] A syntax to use
   *                                           in string generation.
   *
   * @return {string} CSS string of this node.
   *
   * @example
   * postcss.rule({ selector: 'a' }).toString() //=> "a {}"
   */
  ;

  _proto.toString = function toString(stringifier) {
    if (stringifier === void 0) {
      stringifier = _stringify.default;
    }

    if (stringifier.stringify) stringifier = stringifier.stringify;
    var result = '';
    stringifier(this, function (i) {
      result += i;
    });
    return result;
  }
  /**
   * Returns an exact clone of the node.
   *
   * The resulting cloned node and its (cloned) children will retain
   * code style properties.
   *
   * @param {object} [overrides] New properties to override in the clone.
   *
   * @example
   * decl.raws.before    //=> "\n  "
   * const cloned = decl.clone({ prop: '-moz-' + decl.prop })
   * cloned.raws.before  //=> "\n  "
   * cloned.toString()   //=> -moz-transform: scale(0)
   *
   * @return {Node} Clone of the node.
   */
  ;

  _proto.clone = function clone(overrides) {
    if (overrides === void 0) {
      overrides = {};
    }

    var cloned = cloneNode(this);

    for (var name in overrides) {
      cloned[name] = overrides[name];
    }

    return cloned;
  }
  /**
   * Shortcut to clone the node and insert the resulting cloned node
   * before the current node.
   *
   * @param {object} [overrides] Mew properties to override in the clone.
   *
   * @example
   * decl.cloneBefore({ prop: '-moz-' + decl.prop })
   *
   * @return {Node} New node
   */
  ;

  _proto.cloneBefore = function cloneBefore(overrides) {
    if (overrides === void 0) {
      overrides = {};
    }

    var cloned = this.clone(overrides);
    this.parent.insertBefore(this, cloned);
    return cloned;
  }
  /**
   * Shortcut to clone the node and insert the resulting cloned node
   * after the current node.
   *
   * @param {object} [overrides] New properties to override in the clone.
   *
   * @return {Node} New node.
   */
  ;

  _proto.cloneAfter = function cloneAfter(overrides) {
    if (overrides === void 0) {
      overrides = {};
    }

    var cloned = this.clone(overrides);
    this.parent.insertAfter(this, cloned);
    return cloned;
  }
  /**
   * Inserts node(s) before the current node and removes the current node.
   *
   * @param {...Node} nodes Mode(s) to replace current one.
   *
   * @example
   * if (atrule.name === 'mixin') {
   *   atrule.replaceWith(mixinRules[atrule.params])
   * }
   *
   * @return {Node} Current node to methods chain.
   */
  ;

  _proto.replaceWith = function replaceWith() {
    if (this.parent) {
      for (var _len = arguments.length, nodes = new Array(_len), _key = 0; _key < _len; _key++) {
        nodes[_key] = arguments[_key];
      }

      for (var _i = 0; _i < nodes.length; _i++) {
        var node = nodes[_i];
        this.parent.insertBefore(this, node);
      }

      this.remove();
    }

    return this;
  }
  /**
   * Returns the next child of the node’s parent.
   * Returns `undefined` if the current node is the last child.
   *
   * @return {Node|undefined} Next node.
   *
   * @example
   * if (comment.text === 'delete next') {
   *   const next = comment.next()
   *   if (next) {
   *     next.remove()
   *   }
   * }
   */
  ;

  _proto.next = function next() {
    if (!this.parent) return undefined;
    var index = this.parent.index(this);
    return this.parent.nodes[index + 1];
  }
  /**
   * Returns the previous child of the node’s parent.
   * Returns `undefined` if the current node is the first child.
   *
   * @return {Node|undefined} Previous node.
   *
   * @example
   * const annotation = decl.prev()
   * if (annotation.type === 'comment') {
   *   readAnnotation(annotation.text)
   * }
   */
  ;

  _proto.prev = function prev() {
    if (!this.parent) return undefined;
    var index = this.parent.index(this);
    return this.parent.nodes[index - 1];
  }
  /**
   * Insert new node before current node to current node’s parent.
   *
   * Just alias for `node.parent.insertBefore(node, add)`.
   *
   * @param {Node|object|string|Node[]} add New node.
   *
   * @return {Node} This node for methods chain.
   *
   * @example
   * decl.before('content: ""')
   */
  ;

  _proto.before = function before(add) {
    this.parent.insertBefore(this, add);
    return this;
  }
  /**
   * Insert new node after current node to current node’s parent.
   *
   * Just alias for `node.parent.insertAfter(node, add)`.
   *
   * @param {Node|object|string|Node[]} add New node.
   *
   * @return {Node} This node for methods chain.
   *
   * @example
   * decl.after('color: black')
   */
  ;

  _proto.after = function after(add) {
    this.parent.insertAfter(this, add);
    return this;
  };

  _proto.toJSON = function toJSON() {
    var fixed = {};

    for (var name in this) {
      if (!this.hasOwnProperty(name)) continue;
      if (name === 'parent') continue;
      var value = this[name];

      if (value instanceof Array) {
        fixed[name] = value.map(function (i) {
          if (typeof i === 'object' && i.toJSON) {
            return i.toJSON();
          } else {
            return i;
          }
        });
      } else if (typeof value === 'object' && value.toJSON) {
        fixed[name] = value.toJSON();
      } else {
        fixed[name] = value;
      }
    }

    return fixed;
  }
  /**
   * Returns a {@link Node#raws} value. If the node is missing
   * the code style property (because the node was manually built or cloned),
   * PostCSS will try to autodetect the code style property by looking
   * at other nodes in the tree.
   *
   * @param {string} prop          Name of code style property.
   * @param {string} [defaultType] Name of default value, it can be missed
   *                               if the value is the same as prop.
   *
   * @example
   * const root = postcss.parse('a { background: white }')
   * root.nodes[0].append({ prop: 'color', value: 'black' })
   * root.nodes[0].nodes[1].raws.before   //=> undefined
   * root.nodes[0].nodes[1].raw('before') //=> ' '
   *
   * @return {string} Code style value.
   */
  ;

  _proto.raw = function raw(prop, defaultType) {
    var str = new _stringifier.default();
    return str.raw(this, prop, defaultType);
  }
  /**
   * Finds the Root instance of the node’s tree.
   *
   * @example
   * root.nodes[0].nodes[0].root() === root
   *
   * @return {Root} Root parent.
   */
  ;

  _proto.root = function root() {
    var result = this;

    while (result.parent) {
      result = result.parent;
    }

    return result;
  }
  /**
   * Clear the code style properties for the node and its children.
   *
   * @param {boolean} [keepBetween] Keep the raws.between symbols.
   *
   * @return {undefined}
   *
   * @example
   * node.raws.before  //=> ' '
   * node.cleanRaws()
   * node.raws.before  //=> undefined
   */
  ;

  _proto.cleanRaws = function cleanRaws(keepBetween) {
    delete this.raws.before;
    delete this.raws.after;
    if (!keepBetween) delete this.raws.between;
  };

  _proto.positionInside = function positionInside(index) {
    var string = this.toString();
    var column = this.source.start.column;
    var line = this.source.start.line;

    for (var i = 0; i < index; i++) {
      if (string[i] === '\n') {
        column = 1;
        line += 1;
      } else {
        column += 1;
      }
    }

    return {
      line: line,
      column: column
    };
  };

  _proto.positionBy = function positionBy(opts) {
    var pos = this.source.start;

    if (opts.index) {
      pos = this.positionInside(opts.index);
    } else if (opts.word) {
      var index = this.toString().indexOf(opts.word);
      if (index !== -1) pos = this.positionInside(index);
    }

    return pos;
  }
  /**
   * @memberof Node#
   * @member {string} type String representing the node’s type.
   *                       Possible values are `root`, `atrule`, `rule`,
   *                       `decl`, or `comment`.
   *
   * @example
   * postcss.decl({ prop: 'color', value: 'black' }).type //=> 'decl'
   */

  /**
   * @memberof Node#
   * @member {Container} parent The node’s parent node.
   *
   * @example
   * root.nodes[0].parent === root
   */

  /**
   * @memberof Node#
   * @member {source} source The input source of the node.
   *
   * The property is used in source map generation.
   *
   * If you create a node manually (e.g., with `postcss.decl()`),
   * that node will not have a `source` property and will be absent
   * from the source map. For this reason, the plugin developer should
   * consider cloning nodes to create new ones (in which case the new node’s
   * source will reference the original, cloned node) or setting
   * the `source` property manually.
   *
   * ```js
   * // Bad
   * const prefixed = postcss.decl({
   *   prop: '-moz-' + decl.prop,
   *   value: decl.value
   * })
   *
   * // Good
   * const prefixed = decl.clone({ prop: '-moz-' + decl.prop })
   * ```
   *
   * ```js
   * if (atrule.name === 'add-link') {
   *   const rule = postcss.rule({ selector: 'a', source: atrule.source })
   *   atrule.parent.insertBefore(atrule, rule)
   * }
   * ```
   *
   * @example
   * decl.source.input.from //=> '/home/ai/a.sass'
   * decl.source.start      //=> { line: 10, column: 2 }
   * decl.source.end        //=> { line: 10, column: 12 }
   */

  /**
   * @memberof Node#
   * @member {object} raws Information to generate byte-to-byte equal
   *                       node string as it was in the origin input.
   *
   * Every parser saves its own properties,
   * but the default CSS parser uses:
   *
   * * `before`: the space symbols before the node. It also stores `*`
   *   and `_` symbols before the declaration (IE hack).
   * * `after`: the space symbols after the last child of the node
   *   to the end of the node.
   * * `between`: the symbols between the property and value
   *   for declarations, selector and `{` for rules, or last parameter
   *   and `{` for at-rules.
   * * `semicolon`: contains true if the last child has
   *   an (optional) semicolon.
   * * `afterName`: the space between the at-rule name and its parameters.
   * * `left`: the space symbols between `/*` and the comment’s text.
   * * `right`: the space symbols between the comment’s text
   *   and <code>*&#47;</code>.
   * * `important`: the content of the important statement,
   *   if it is not just `!important`.
   *
   * PostCSS cleans selectors, declaration values and at-rule parameters
   * from comments and extra spaces, but it stores origin content in raws
   * properties. As such, if you don’t change a declaration’s value,
   * PostCSS will use the raw value with comments.
   *
   * @example
   * const root = postcss.parse('a {\n  color:black\n}')
   * root.first.first.raws //=> { before: '\n  ', between: ':' }
   */
  ;

  return Node;
}();

var _default = Node;
/**
 * @typedef {object} position
 * @property {number} line   Source line in file.
 * @property {number} column Source column in file.
 */

/**
 * @typedef {object} source
 * @property {Input} input    {@link Input} with input file
 * @property {position} start The starting position of the node’s source.
 * @property {position} end   The ending position of the node’s source.
 */

exports.default = _default;
module.exports = exports.default;


}).call(this,require('_process'))
},{"./css-syntax-error":47,"./stringifier":62,"./stringify":63,"_process":68}],54:[function(require,module,exports){
(function (process){
"use strict";

exports.__esModule = true;
exports.default = void 0;

var _parser = _interopRequireDefault(require("./parser"));

var _input = _interopRequireDefault(require("./input"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function parse(css, opts) {
  var input = new _input.default(css, opts);
  var parser = new _parser.default(input);

  try {
    parser.parse();
  } catch (e) {
    if (process.env.NODE_ENV !== 'production') {
      if (e.name === 'CssSyntaxError' && opts && opts.from) {
        if (/\.scss$/i.test(opts.from)) {
          e.message += '\nYou tried to parse SCSS with ' + 'the standard CSS parser; ' + 'try again with the postcss-scss parser';
        } else if (/\.sass/i.test(opts.from)) {
          e.message += '\nYou tried to parse Sass with ' + 'the standard CSS parser; ' + 'try again with the postcss-sass parser';
        } else if (/\.less$/i.test(opts.from)) {
          e.message += '\nYou tried to parse Less with ' + 'the standard CSS parser; ' + 'try again with the postcss-less parser';
        }
      }
    }

    throw e;
  }

  return parser.root;
}

var _default = parse;
exports.default = _default;
module.exports = exports.default;


}).call(this,require('_process'))
},{"./input":49,"./parser":55,"_process":68}],55:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.default = void 0;

var _declaration = _interopRequireDefault(require("./declaration"));

var _tokenize = _interopRequireDefault(require("./tokenize"));

var _comment = _interopRequireDefault(require("./comment"));

var _atRule = _interopRequireDefault(require("./at-rule"));

var _root = _interopRequireDefault(require("./root"));

var _rule = _interopRequireDefault(require("./rule"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Parser =
/*#__PURE__*/
function () {
  function Parser(input) {
    this.input = input;
    this.root = new _root.default();
    this.current = this.root;
    this.spaces = '';
    this.semicolon = false;
    this.createTokenizer();
    this.root.source = {
      input: input,
      start: {
        line: 1,
        column: 1
      }
    };
  }

  var _proto = Parser.prototype;

  _proto.createTokenizer = function createTokenizer() {
    this.tokenizer = (0, _tokenize.default)(this.input);
  };

  _proto.parse = function parse() {
    var token;

    while (!this.tokenizer.endOfFile()) {
      token = this.tokenizer.nextToken();

      switch (token[0]) {
        case 'space':
          this.spaces += token[1];
          break;

        case ';':
          this.freeSemicolon(token);
          break;

        case '}':
          this.end(token);
          break;

        case 'comment':
          this.comment(token);
          break;

        case 'at-word':
          this.atrule(token);
          break;

        case '{':
          this.emptyRule(token);
          break;

        default:
          this.other(token);
          break;
      }
    }

    this.endFile();
  };

  _proto.comment = function comment(token) {
    var node = new _comment.default();
    this.init(node, token[2], token[3]);
    node.source.end = {
      line: token[4],
      column: token[5]
    };
    var text = token[1].slice(2, -2);

    if (/^\s*$/.test(text)) {
      node.text = '';
      node.raws.left = text;
      node.raws.right = '';
    } else {
      var match = text.match(/^(\s*)([^]*[^\s])(\s*)$/);
      node.text = match[2];
      node.raws.left = match[1];
      node.raws.right = match[3];
    }
  };

  _proto.emptyRule = function emptyRule(token) {
    var node = new _rule.default();
    this.init(node, token[2], token[3]);
    node.selector = '';
    node.raws.between = '';
    this.current = node;
  };

  _proto.other = function other(start) {
    var end = false;
    var type = null;
    var colon = false;
    var bracket = null;
    var brackets = [];
    var tokens = [];
    var token = start;

    while (token) {
      type = token[0];
      tokens.push(token);

      if (type === '(' || type === '[') {
        if (!bracket) bracket = token;
        brackets.push(type === '(' ? ')' : ']');
      } else if (brackets.length === 0) {
        if (type === ';') {
          if (colon) {
            this.decl(tokens);
            return;
          } else {
            break;
          }
        } else if (type === '{') {
          this.rule(tokens);
          return;
        } else if (type === '}') {
          this.tokenizer.back(tokens.pop());
          end = true;
          break;
        } else if (type === ':') {
          colon = true;
        }
      } else if (type === brackets[brackets.length - 1]) {
        brackets.pop();
        if (brackets.length === 0) bracket = null;
      }

      token = this.tokenizer.nextToken();
    }

    if (this.tokenizer.endOfFile()) end = true;
    if (brackets.length > 0) this.unclosedBracket(bracket);

    if (end && colon) {
      while (tokens.length) {
        token = tokens[tokens.length - 1][0];
        if (token !== 'space' && token !== 'comment') break;
        this.tokenizer.back(tokens.pop());
      }

      this.decl(tokens);
    } else {
      this.unknownWord(tokens);
    }
  };

  _proto.rule = function rule(tokens) {
    tokens.pop();
    var node = new _rule.default();
    this.init(node, tokens[0][2], tokens[0][3]);
    node.raws.between = this.spacesAndCommentsFromEnd(tokens);
    this.raw(node, 'selector', tokens);
    this.current = node;
  };

  _proto.decl = function decl(tokens) {
    var node = new _declaration.default();
    this.init(node);
    var last = tokens[tokens.length - 1];

    if (last[0] === ';') {
      this.semicolon = true;
      tokens.pop();
    }

    if (last[4]) {
      node.source.end = {
        line: last[4],
        column: last[5]
      };
    } else {
      node.source.end = {
        line: last[2],
        column: last[3]
      };
    }

    while (tokens[0][0] !== 'word') {
      if (tokens.length === 1) this.unknownWord(tokens);
      node.raws.before += tokens.shift()[1];
    }

    node.source.start = {
      line: tokens[0][2],
      column: tokens[0][3]
    };
    node.prop = '';

    while (tokens.length) {
      var type = tokens[0][0];

      if (type === ':' || type === 'space' || type === 'comment') {
        break;
      }

      node.prop += tokens.shift()[1];
    }

    node.raws.between = '';
    var token;

    while (tokens.length) {
      token = tokens.shift();

      if (token[0] === ':') {
        node.raws.between += token[1];
        break;
      } else {
        if (token[0] === 'word' && /\w/.test(token[1])) {
          this.unknownWord([token]);
        }

        node.raws.between += token[1];
      }
    }

    if (node.prop[0] === '_' || node.prop[0] === '*') {
      node.raws.before += node.prop[0];
      node.prop = node.prop.slice(1);
    }

    node.raws.between += this.spacesAndCommentsFromStart(tokens);
    this.precheckMissedSemicolon(tokens);

    for (var i = tokens.length - 1; i > 0; i--) {
      token = tokens[i];

      if (token[1].toLowerCase() === '!important') {
        node.important = true;
        var string = this.stringFrom(tokens, i);
        string = this.spacesFromEnd(tokens) + string;
        if (string !== ' !important') node.raws.important = string;
        break;
      } else if (token[1].toLowerCase() === 'important') {
        var cache = tokens.slice(0);
        var str = '';

        for (var j = i; j > 0; j--) {
          var _type = cache[j][0];

          if (str.trim().indexOf('!') === 0 && _type !== 'space') {
            break;
          }

          str = cache.pop()[1] + str;
        }

        if (str.trim().indexOf('!') === 0) {
          node.important = true;
          node.raws.important = str;
          tokens = cache;
        }
      }

      if (token[0] !== 'space' && token[0] !== 'comment') {
        break;
      }
    }

    this.raw(node, 'value', tokens);
    if (node.value.indexOf(':') !== -1) this.checkMissedSemicolon(tokens);
  };

  _proto.atrule = function atrule(token) {
    var node = new _atRule.default();
    node.name = token[1].slice(1);

    if (node.name === '') {
      this.unnamedAtrule(node, token);
    }

    this.init(node, token[2], token[3]);
    var prev;
    var shift;
    var last = false;
    var open = false;
    var params = [];

    while (!this.tokenizer.endOfFile()) {
      token = this.tokenizer.nextToken();

      if (token[0] === ';') {
        node.source.end = {
          line: token[2],
          column: token[3]
        };
        this.semicolon = true;
        break;
      } else if (token[0] === '{') {
        open = true;
        break;
      } else if (token[0] === '}') {
        if (params.length > 0) {
          shift = params.length - 1;
          prev = params[shift];

          while (prev && prev[0] === 'space') {
            prev = params[--shift];
          }

          if (prev) {
            node.source.end = {
              line: prev[4],
              column: prev[5]
            };
          }
        }

        this.end(token);
        break;
      } else {
        params.push(token);
      }

      if (this.tokenizer.endOfFile()) {
        last = true;
        break;
      }
    }

    node.raws.between = this.spacesAndCommentsFromEnd(params);

    if (params.length) {
      node.raws.afterName = this.spacesAndCommentsFromStart(params);
      this.raw(node, 'params', params);

      if (last) {
        token = params[params.length - 1];
        node.source.end = {
          line: token[4],
          column: token[5]
        };
        this.spaces = node.raws.between;
        node.raws.between = '';
      }
    } else {
      node.raws.afterName = '';
      node.params = '';
    }

    if (open) {
      node.nodes = [];
      this.current = node;
    }
  };

  _proto.end = function end(token) {
    if (this.current.nodes && this.current.nodes.length) {
      this.current.raws.semicolon = this.semicolon;
    }

    this.semicolon = false;
    this.current.raws.after = (this.current.raws.after || '') + this.spaces;
    this.spaces = '';

    if (this.current.parent) {
      this.current.source.end = {
        line: token[2],
        column: token[3]
      };
      this.current = this.current.parent;
    } else {
      this.unexpectedClose(token);
    }
  };

  _proto.endFile = function endFile() {
    if (this.current.parent) this.unclosedBlock();

    if (this.current.nodes && this.current.nodes.length) {
      this.current.raws.semicolon = this.semicolon;
    }

    this.current.raws.after = (this.current.raws.after || '') + this.spaces;
  };

  _proto.freeSemicolon = function freeSemicolon(token) {
    this.spaces += token[1];

    if (this.current.nodes) {
      var prev = this.current.nodes[this.current.nodes.length - 1];

      if (prev && prev.type === 'rule' && !prev.raws.ownSemicolon) {
        prev.raws.ownSemicolon = this.spaces;
        this.spaces = '';
      }
    }
  } // Helpers
  ;

  _proto.init = function init(node, line, column) {
    this.current.push(node);
    node.source = {
      start: {
        line: line,
        column: column
      },
      input: this.input
    };
    node.raws.before = this.spaces;
    this.spaces = '';
    if (node.type !== 'comment') this.semicolon = false;
  };

  _proto.raw = function raw(node, prop, tokens) {
    var token, type;
    var length = tokens.length;
    var value = '';
    var clean = true;
    var next, prev;
    var pattern = /^([.|#])?([\w])+/i;

    for (var i = 0; i < length; i += 1) {
      token = tokens[i];
      type = token[0];

      if (type === 'comment' && node.type === 'rule') {
        prev = tokens[i - 1];
        next = tokens[i + 1];

        if (prev[0] !== 'space' && next[0] !== 'space' && pattern.test(prev[1]) && pattern.test(next[1])) {
          value += token[1];
        } else {
          clean = false;
        }

        continue;
      }

      if (type === 'comment' || type === 'space' && i === length - 1) {
        clean = false;
      } else {
        value += token[1];
      }
    }

    if (!clean) {
      var raw = tokens.reduce(function (all, i) {
        return all + i[1];
      }, '');
      node.raws[prop] = {
        value: value,
        raw: raw
      };
    }

    node[prop] = value;
  };

  _proto.spacesAndCommentsFromEnd = function spacesAndCommentsFromEnd(tokens) {
    var lastTokenType;
    var spaces = '';

    while (tokens.length) {
      lastTokenType = tokens[tokens.length - 1][0];
      if (lastTokenType !== 'space' && lastTokenType !== 'comment') break;
      spaces = tokens.pop()[1] + spaces;
    }

    return spaces;
  };

  _proto.spacesAndCommentsFromStart = function spacesAndCommentsFromStart(tokens) {
    var next;
    var spaces = '';

    while (tokens.length) {
      next = tokens[0][0];
      if (next !== 'space' && next !== 'comment') break;
      spaces += tokens.shift()[1];
    }

    return spaces;
  };

  _proto.spacesFromEnd = function spacesFromEnd(tokens) {
    var lastTokenType;
    var spaces = '';

    while (tokens.length) {
      lastTokenType = tokens[tokens.length - 1][0];
      if (lastTokenType !== 'space') break;
      spaces = tokens.pop()[1] + spaces;
    }

    return spaces;
  };

  _proto.stringFrom = function stringFrom(tokens, from) {
    var result = '';

    for (var i = from; i < tokens.length; i++) {
      result += tokens[i][1];
    }

    tokens.splice(from, tokens.length - from);
    return result;
  };

  _proto.colon = function colon(tokens) {
    var brackets = 0;
    var token, type, prev;

    for (var i = 0; i < tokens.length; i++) {
      token = tokens[i];
      type = token[0];

      if (type === '(') {
        brackets += 1;
      }

      if (type === ')') {
        brackets -= 1;
      }

      if (brackets === 0 && type === ':') {
        if (!prev) {
          this.doubleColon(token);
        } else if (prev[0] === 'word' && prev[1] === 'progid') {
          continue;
        } else {
          return i;
        }
      }

      prev = token;
    }

    return false;
  } // Errors
  ;

  _proto.unclosedBracket = function unclosedBracket(bracket) {
    throw this.input.error('Unclosed bracket', bracket[2], bracket[3]);
  };

  _proto.unknownWord = function unknownWord(tokens) {
    throw this.input.error('Unknown word', tokens[0][2], tokens[0][3]);
  };

  _proto.unexpectedClose = function unexpectedClose(token) {
    throw this.input.error('Unexpected }', token[2], token[3]);
  };

  _proto.unclosedBlock = function unclosedBlock() {
    var pos = this.current.source.start;
    throw this.input.error('Unclosed block', pos.line, pos.column);
  };

  _proto.doubleColon = function doubleColon(token) {
    throw this.input.error('Double colon', token[2], token[3]);
  };

  _proto.unnamedAtrule = function unnamedAtrule(node, token) {
    throw this.input.error('At-rule without name', token[2], token[3]);
  };

  _proto.precheckMissedSemicolon = function precheckMissedSemicolon()
  /* tokens */
  {// Hook for Safe Parser
  };

  _proto.checkMissedSemicolon = function checkMissedSemicolon(tokens) {
    var colon = this.colon(tokens);
    if (colon === false) return;
    var founded = 0;
    var token;

    for (var j = colon - 1; j >= 0; j--) {
      token = tokens[j];

      if (token[0] !== 'space') {
        founded += 1;
        if (founded === 2) break;
      }
    }

    throw this.input.error('Missed semicolon', token[2], token[3]);
  };

  return Parser;
}();

exports.default = Parser;
module.exports = exports.default;


},{"./at-rule":44,"./comment":45,"./declaration":48,"./root":60,"./rule":61,"./tokenize":64}],56:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.default = void 0;

var _declaration = _interopRequireDefault(require("./declaration"));

var _processor = _interopRequireDefault(require("./processor"));

var _stringify = _interopRequireDefault(require("./stringify"));

var _comment = _interopRequireDefault(require("./comment"));

var _atRule = _interopRequireDefault(require("./at-rule"));

var _vendor = _interopRequireDefault(require("./vendor"));

var _parse = _interopRequireDefault(require("./parse"));

var _list = _interopRequireDefault(require("./list"));

var _rule = _interopRequireDefault(require("./rule"));

var _root = _interopRequireDefault(require("./root"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Create a new {@link Processor} instance that will apply `plugins`
 * as CSS processors.
 *
 * @param {Array.<Plugin|pluginFunction>|Processor} plugins PostCSS plugins.
 *        See {@link Processor#use} for plugin format.
 *
 * @return {Processor} Processor to process multiple CSS.
 *
 * @example
 * import postcss from 'postcss'
 *
 * postcss(plugins).process(css, { from, to }).then(result => {
 *   console.log(result.css)
 * })
 *
 * @namespace postcss
 */
function postcss() {
  for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
    plugins[_key] = arguments[_key];
  }

  if (plugins.length === 1 && Array.isArray(plugins[0])) {
    plugins = plugins[0];
  }

  return new _processor.default(plugins);
}
/**
 * Creates a PostCSS plugin with a standard API.
 *
 * The newly-wrapped function will provide both the name and PostCSS
 * version of the plugin.
 *
 * ```js
 * const processor = postcss([replace])
 * processor.plugins[0].postcssPlugin  //=> 'postcss-replace'
 * processor.plugins[0].postcssVersion //=> '6.0.0'
 * ```
 *
 * The plugin function receives 2 arguments: {@link Root}
 * and {@link Result} instance. The function should mutate the provided
 * `Root` node. Alternatively, you can create a new `Root` node
 * and override the `result.root` property.
 *
 * ```js
 * const cleaner = postcss.plugin('postcss-cleaner', () => {
 *   return (root, result) => {
 *     result.root = postcss.root()
 *   }
 * })
 * ```
 *
 * As a convenience, plugins also expose a `process` method so that you can use
 * them as standalone tools.
 *
 * ```js
 * cleaner.process(css, processOpts, pluginOpts)
 * // This is equivalent to:
 * postcss([ cleaner(pluginOpts) ]).process(css, processOpts)
 * ```
 *
 * Asynchronous plugins should return a `Promise` instance.
 *
 * ```js
 * postcss.plugin('postcss-import', () => {
 *   return (root, result) => {
 *     return new Promise( (resolve, reject) => {
 *       fs.readFile('base.css', (base) => {
 *         root.prepend(base)
 *         resolve()
 *       })
 *     })
 *   }
 * })
 * ```
 *
 * Add warnings using the {@link Node#warn} method.
 * Send data to other plugins using the {@link Result#messages} array.
 *
 * ```js
 * postcss.plugin('postcss-caniuse-test', () => {
 *   return (root, result) => {
 *     root.walkDecls(decl => {
 *       if (!caniuse.support(decl.prop)) {
 *         decl.warn(result, 'Some browsers do not support ' + decl.prop)
 *       }
 *     })
 *   }
 * })
 * ```
 *
 * @param {string} name          PostCSS plugin name. Same as in `name`
 *                               property in `package.json`. It will be saved
 *                               in `plugin.postcssPlugin` property.
 * @param {function} initializer Will receive plugin options
 *                               and should return {@link pluginFunction}
 *
 * @return {Plugin} PostCSS plugin.
 */


postcss.plugin = function plugin(name, initializer) {
  function creator() {
    var transformer = initializer.apply(void 0, arguments);
    transformer.postcssPlugin = name;
    transformer.postcssVersion = new _processor.default().version;
    return transformer;
  }

  var cache;
  Object.defineProperty(creator, 'postcss', {
    get: function get() {
      if (!cache) cache = creator();
      return cache;
    }
  });

  creator.process = function (css, processOpts, pluginOpts) {
    return postcss([creator(pluginOpts)]).process(css, processOpts);
  };

  return creator;
};
/**
 * Default function to convert a node tree into a CSS string.
 *
 * @param {Node} node       Start node for stringifing. Usually {@link Root}.
 * @param {builder} builder Function to concatenate CSS from node’s parts
 *                          or generate string and source map.
 *
 * @return {void}
 *
 * @function
 */


postcss.stringify = _stringify.default;
/**
 * Parses source css and returns a new {@link Root} node,
 * which contains the source CSS nodes.
 *
 * @param {string|toString} css   String with input CSS or any object
 *                                with toString() method, like a Buffer
 * @param {processOptions} [opts] Options with only `from` and `map` keys.
 *
 * @return {Root} PostCSS AST.
 *
 * @example
 * // Simple CSS concatenation with source map support
 * const root1 = postcss.parse(css1, { from: file1 })
 * const root2 = postcss.parse(css2, { from: file2 })
 * root1.append(root2).toResult().css
 *
 * @function
 */

postcss.parse = _parse.default;
/**
 * Contains the {@link vendor} module.
 *
 * @type {vendor}
 *
 * @example
 * postcss.vendor.unprefixed('-moz-tab') //=> ['tab']
 */

postcss.vendor = _vendor.default;
/**
 * Contains the {@link list} module.
 *
 * @member {list}
 *
 * @example
 * postcss.list.space('5px calc(10% + 5px)') //=> ['5px', 'calc(10% + 5px)']
 */

postcss.list = _list.default;
/**
 * Creates a new {@link Comment} node.
 *
 * @param {object} [defaults] Properties for the new node.
 *
 * @return {Comment} New comment node
 *
 * @example
 * postcss.comment({ text: 'test' })
 */

postcss.comment = function (defaults) {
  return new _comment.default(defaults);
};
/**
 * Creates a new {@link AtRule} node.
 *
 * @param {object} [defaults] Properties for the new node.
 *
 * @return {AtRule} new at-rule node
 *
 * @example
 * postcss.atRule({ name: 'charset' }).toString() //=> "@charset"
 */


postcss.atRule = function (defaults) {
  return new _atRule.default(defaults);
};
/**
 * Creates a new {@link Declaration} node.
 *
 * @param {object} [defaults] Properties for the new node.
 *
 * @return {Declaration} new declaration node
 *
 * @example
 * postcss.decl({ prop: 'color', value: 'red' }).toString() //=> "color: red"
 */


postcss.decl = function (defaults) {
  return new _declaration.default(defaults);
};
/**
 * Creates a new {@link Rule} node.
 *
 * @param {object} [defaults] Properties for the new node.
 *
 * @return {Rule} new rule node
 *
 * @example
 * postcss.rule({ selector: 'a' }).toString() //=> "a {\n}"
 */


postcss.rule = function (defaults) {
  return new _rule.default(defaults);
};
/**
 * Creates a new {@link Root} node.
 *
 * @param {object} [defaults] Properties for the new node.
 *
 * @return {Root} new root node.
 *
 * @example
 * postcss.root({ after: '\n' }).toString() //=> "\n"
 */


postcss.root = function (defaults) {
  return new _root.default(defaults);
};

var _default = postcss;
exports.default = _default;
module.exports = exports.default;


},{"./at-rule":44,"./comment":45,"./declaration":48,"./list":51,"./parse":54,"./processor":58,"./root":60,"./rule":61,"./stringify":63,"./vendor":65}],57:[function(require,module,exports){
(function (Buffer){
"use strict";

exports.__esModule = true;
exports.default = void 0;

var _sourceMap = _interopRequireDefault(require("source-map"));

var _path = _interopRequireDefault(require("path"));

var _fs = _interopRequireDefault(require("fs"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fromBase64(str) {
  if (Buffer) {
    return Buffer.from(str, 'base64').toString();
  } else {
    return window.atob(str);
  }
}
/**
 * Source map information from input CSS.
 * For example, source map after Sass compiler.
 *
 * This class will automatically find source map in input CSS or in file system
 * near input file (according `from` option).
 *
 * @example
 * const root = postcss.parse(css, { from: 'a.sass.css' })
 * root.input.map //=> PreviousMap
 */


var PreviousMap =
/*#__PURE__*/
function () {
  /**
   * @param {string}         css    Input CSS source.
   * @param {processOptions} [opts] {@link Processor#process} options.
   */
  function PreviousMap(css, opts) {
    this.loadAnnotation(css);
    /**
     * Was source map inlined by data-uri to input CSS.
     *
     * @type {boolean}
     */

    this.inline = this.startWith(this.annotation, 'data:');
    var prev = opts.map ? opts.map.prev : undefined;
    var text = this.loadMap(opts.from, prev);
    if (text) this.text = text;
  }
  /**
   * Create a instance of `SourceMapGenerator` class
   * from the `source-map` library to work with source map information.
   *
   * It is lazy method, so it will create object only on first call
   * and then it will use cache.
   *
   * @return {SourceMapGenerator} Object with source map information.
   */


  var _proto = PreviousMap.prototype;

  _proto.consumer = function consumer() {
    if (!this.consumerCache) {
      this.consumerCache = new _sourceMap.default.SourceMapConsumer(this.text);
    }

    return this.consumerCache;
  }
  /**
   * Does source map contains `sourcesContent` with input source text.
   *
   * @return {boolean} Is `sourcesContent` present.
   */
  ;

  _proto.withContent = function withContent() {
    return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
  };

  _proto.startWith = function startWith(string, start) {
    if (!string) return false;
    return string.substr(0, start.length) === start;
  };

  _proto.loadAnnotation = function loadAnnotation(css) {
    var match = css.match(/\/\*\s*# sourceMappingURL=(.*)\s*\*\//);
    if (match) this.annotation = match[1].trim();
  };

  _proto.decodeInline = function decodeInline(text) {
    var baseCharsetUri = /^data:application\/json;charset=utf-?8;base64,/;
    var baseUri = /^data:application\/json;base64,/;
    var uri = 'data:application/json,';

    if (this.startWith(text, uri)) {
      return decodeURIComponent(text.substr(uri.length));
    }

    if (baseCharsetUri.test(text) || baseUri.test(text)) {
      return fromBase64(text.substr(RegExp.lastMatch.length));
    }

    var encoding = text.match(/data:application\/json;([^,]+),/)[1];
    throw new Error('Unsupported source map encoding ' + encoding);
  };

  _proto.loadMap = function loadMap(file, prev) {
    if (prev === false) return false;

    if (prev) {
      if (typeof prev === 'string') {
        return prev;
      } else if (typeof prev === 'function') {
        var prevPath = prev(file);

        if (prevPath && _fs.default.existsSync && _fs.default.existsSync(prevPath)) {
          return _fs.default.readFileSync(prevPath, 'utf-8').toString().trim();
        } else {
          throw new Error('Unable to load previous source map: ' + prevPath.toString());
        }
      } else if (prev instanceof _sourceMap.default.SourceMapConsumer) {
        return _sourceMap.default.SourceMapGenerator.fromSourceMap(prev).toString();
      } else if (prev instanceof _sourceMap.default.SourceMapGenerator) {
        return prev.toString();
      } else if (this.isMap(prev)) {
        return JSON.stringify(prev);
      } else {
        throw new Error('Unsupported previous source map format: ' + prev.toString());
      }
    } else if (this.inline) {
      return this.decodeInline(this.annotation);
    } else if (this.annotation) {
      var map = this.annotation;
      if (file) map = _path.default.join(_path.default.dirname(file), map);
      this.root = _path.default.dirname(map);

      if (_fs.default.existsSync && _fs.default.existsSync(map)) {
        return _fs.default.readFileSync(map, 'utf-8').toString().trim();
      } else {
        return false;
      }
    }
  };

  _proto.isMap = function isMap(map) {
    if (typeof map !== 'object') return false;
    return typeof map.mappings === 'string' || typeof map._mappings === 'string';
  };

  return PreviousMap;
}();

var _default = PreviousMap;
exports.default = _default;
module.exports = exports.default;


}).call(this,require("buffer").Buffer)
},{"buffer":5,"fs":4,"path":43,"source-map":84}],58:[function(require,module,exports){
(function (process){
"use strict";

exports.__esModule = true;
exports.default = void 0;

var _lazyResult = _interopRequireDefault(require("./lazy-result"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Contains plugins to process CSS. Create one `Processor` instance,
 * initialize its plugins, and then use that instance on numerous CSS files.
 *
 * @example
 * const processor = postcss([autoprefixer, precss])
 * processor.process(css1).then(result => console.log(result.css))
 * processor.process(css2).then(result => console.log(result.css))
 */
var Processor =
/*#__PURE__*/
function () {
  /**
   * @param {Array.<Plugin|pluginFunction>|Processor} plugins PostCSS plugins.
   *        See {@link Processor#use} for plugin format.
   */
  function Processor(plugins) {
    if (plugins === void 0) {
      plugins = [];
    }

    /**
     * Current PostCSS version.
     *
     * @type {string}
     *
     * @example
     * if (result.processor.version.split('.')[0] !== '6') {
     *   throw new Error('This plugin works only with PostCSS 6')
     * }
     */
    this.version = '7.0.14';
    /**
     * Plugins added to this processor.
     *
     * @type {pluginFunction[]}
     *
     * @example
     * const processor = postcss([autoprefixer, precss])
     * processor.plugins.length //=> 2
     */

    this.plugins = this.normalize(plugins);
  }
  /**
   * Adds a plugin to be used as a CSS processor.
   *
   * PostCSS plugin can be in 4 formats:
   * * A plugin created by {@link postcss.plugin} method.
   * * A function. PostCSS will pass the function a @{link Root}
   *   as the first argument and current {@link Result} instance
   *   as the second.
   * * An object with a `postcss` method. PostCSS will use that method
   *   as described in #2.
   * * Another {@link Processor} instance. PostCSS will copy plugins
   *   from that instance into this one.
   *
   * Plugins can also be added by passing them as arguments when creating
   * a `postcss` instance (see [`postcss(plugins)`]).
   *
   * Asynchronous plugins should return a `Promise` instance.
   *
   * @param {Plugin|pluginFunction|Processor} plugin PostCSS plugin
   *                                                 or {@link Processor}
   *                                                 with plugins.
   *
   * @example
   * const processor = postcss()
   *   .use(autoprefixer)
   *   .use(precss)
   *
   * @return {Processes} Current processor to make methods chain.
   */


  var _proto = Processor.prototype;

  _proto.use = function use(plugin) {
    this.plugins = this.plugins.concat(this.normalize([plugin]));
    return this;
  }
  /**
   * Parses source CSS and returns a {@link LazyResult} Promise proxy.
   * Because some plugins can be asynchronous it doesn’t make
   * any transformations. Transformations will be applied
   * in the {@link LazyResult} methods.
   *
   * @param {string|toString|Result} css String with input CSS or any object
   *                                     with a `toString()` method,
   *                                     like a Buffer. Optionally, send
   *                                     a {@link Result} instance
   *                                     and the processor will take
   *                                     the {@link Root} from it.
   * @param {processOptions} [opts]      Options.
   *
   * @return {LazyResult} Promise proxy.
   *
   * @example
   * processor.process(css, { from: 'a.css', to: 'a.out.css' })
   *   .then(result => {
   *      console.log(result.css)
   *   })
   */
  ;

  _proto.process = function (_process) {
    function process(_x) {
      return _process.apply(this, arguments);
    }

    process.toString = function () {
      return _process.toString();
    };

    return process;
  }(function (css, opts) {
    if (opts === void 0) {
      opts = {};
    }

    if (this.plugins.length === 0 && opts.parser === opts.stringifier) {
      if (process.env.NODE_ENV !== 'production') {
        if (typeof console !== 'undefined' && console.warn) {
          console.warn('You did not set any plugins, parser, or stringifier. ' + 'Right now, PostCSS does nothing. Pick plugins for your case ' + 'on https://www.postcss.parts/ and use them in postcss.config.js.');
        }
      }
    }

    return new _lazyResult.default(this, css, opts);
  });

  _proto.normalize = function normalize(plugins) {
    var normalized = [];

    for (var _iterator = plugins, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var i = _ref;
      if (i.postcss) i = i.postcss;

      if (typeof i === 'object' && Array.isArray(i.plugins)) {
        normalized = normalized.concat(i.plugins);
      } else if (typeof i === 'function') {
        normalized.push(i);
      } else if (typeof i === 'object' && (i.parse || i.stringify)) {
        if (process.env.NODE_ENV !== 'production') {
          throw new Error('PostCSS syntaxes cannot be used as plugins. Instead, please use ' + 'one of the syntax/parser/stringifier options as outlined ' + 'in your PostCSS runner documentation.');
        }
      } else {
        throw new Error(i + ' is not a PostCSS plugin');
      }
    }

    return normalized;
  };

  return Processor;
}();

var _default = Processor;
/**
 * @callback builder
 * @param {string} part          Part of generated CSS connected to this node.
 * @param {Node}   node          AST node.
 * @param {"start"|"end"} [type] Node’s part type.
 */

/**
 * @callback parser
 *
 * @param {string|toString} css   String with input CSS or any object
 *                                with toString() method, like a Buffer.
 * @param {processOptions} [opts] Options with only `from` and `map` keys.
 *
 * @return {Root} PostCSS AST
 */

/**
 * @callback stringifier
 *
 * @param {Node} node       Start node for stringifing. Usually {@link Root}.
 * @param {builder} builder Function to concatenate CSS from node’s parts
 *                          or generate string and source map.
 *
 * @return {void}
 */

/**
 * @typedef {object} syntax
 * @property {parser} parse          Function to generate AST by string.
 * @property {stringifier} stringify Function to generate string by AST.
 */

/**
 * @typedef {object} toString
 * @property {function} toString
 */

/**
 * @callback pluginFunction
 * @param {Root} root     Parsed input CSS.
 * @param {Result} result Result to set warnings or check other plugins.
 */

/**
 * @typedef {object} Plugin
 * @property {function} postcss PostCSS plugin function.
 */

/**
 * @typedef {object} processOptions
 * @property {string} from             The path of the CSS source file.
 *                                     You should always set `from`,
 *                                     because it is used in source map
 *                                     generation and syntax error messages.
 * @property {string} to               The path where you’ll put the output
 *                                     CSS file. You should always set `to`
 *                                     to generate correct source maps.
 * @property {parser} parser           Function to generate AST by string.
 * @property {stringifier} stringifier Class to generate string by AST.
 * @property {syntax} syntax           Object with `parse` and `stringify`.
 * @property {object} map              Source map options.
 * @property {boolean} map.inline                    Does source map should
 *                                                   be embedded in the output
 *                                                   CSS as a base64-encoded
 *                                                   comment.
 * @property {string|object|false|function} map.prev Source map content
 *                                                   from a previous
 *                                                   processing step
 *                                                   (for example, Sass).
 *                                                   PostCSS will try to find
 *                                                   previous map automatically,
 *                                                   so you could disable it by
 *                                                   `false` value.
 * @property {boolean} map.sourcesContent            Does PostCSS should set
 *                                                   the origin content to map.
 * @property {string|false} map.annotation           Does PostCSS should set
 *                                                   annotation comment to map.
 * @property {string} map.from                       Override `from` in map’s
 *                                                   sources`.
 */

exports.default = _default;
module.exports = exports.default;


}).call(this,require('_process'))
},{"./lazy-result":50,"_process":68}],59:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.default = void 0;

var _warning = _interopRequireDefault(require("./warning"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Provides the result of the PostCSS transformations.
 *
 * A Result instance is returned by {@link LazyResult#then}
 * or {@link Root#toResult} methods.
 *
 * @example
 * postcss([autoprefixer]).process(css).then(result => {
 *  console.log(result.css)
 * })
 *
 * @example
 * const result2 = postcss.parse(css).toResult()
 */
var Result =
/*#__PURE__*/
function () {
  /**
   * @param {Processor} processor Processor used for this transformation.
   * @param {Root}      root      Root node after all transformations.
   * @param {processOptions} opts Options from the {@link Processor#process}
   *                              or {@link Root#toResult}.
   */
  function Result(processor, root, opts) {
    /**
     * The Processor instance used for this transformation.
     *
     * @type {Processor}
     *
     * @example
     * for (const plugin of result.processor.plugins) {
     *   if (plugin.postcssPlugin === 'postcss-bad') {
     *     throw 'postcss-good is incompatible with postcss-bad'
     *   }
     * })
     */
    this.processor = processor;
    /**
     * Contains messages from plugins (e.g., warnings or custom messages).
     * Each message should have type and plugin properties.
     *
     * @type {Message[]}
     *
     * @example
     * postcss.plugin('postcss-min-browser', () => {
     *   return (root, result) => {
     *     const browsers = detectMinBrowsersByCanIUse(root)
     *     result.messages.push({
     *       type: 'min-browser',
     *       plugin: 'postcss-min-browser',
     *       browsers
     *     })
     *   }
     * })
     */

    this.messages = [];
    /**
     * Root node after all transformations.
     *
     * @type {Root}
     *
     * @example
     * root.toResult().root === root
     */

    this.root = root;
    /**
     * Options from the {@link Processor#process} or {@link Root#toResult} call
     * that produced this Result instance.
     *
     * @type {processOptions}
     *
     * @example
     * root.toResult(opts).opts === opts
     */

    this.opts = opts;
    /**
     * A CSS string representing of {@link Result#root}.
     *
     * @type {string}
     *
     * @example
     * postcss.parse('a{}').toResult().css //=> "a{}"
     */

    this.css = undefined;
    /**
     * An instance of `SourceMapGenerator` class from the `source-map` library,
     * representing changes to the {@link Result#root} instance.
     *
     * @type {SourceMapGenerator}
     *
     * @example
     * result.map.toJSON() //=> { version: 3, file: 'a.css', … }
     *
     * @example
     * if (result.map) {
     *   fs.writeFileSync(result.opts.to + '.map', result.map.toString())
     * }
     */

    this.map = undefined;
  }
  /**
   * Returns for @{link Result#css} content.
   *
   * @example
   * result + '' === result.css
   *
   * @return {string} String representing of {@link Result#root}.
   */


  var _proto = Result.prototype;

  _proto.toString = function toString() {
    return this.css;
  }
  /**
   * Creates an instance of {@link Warning} and adds it
   * to {@link Result#messages}.
   *
   * @param {string} text        Warning message.
   * @param {Object} [opts]      Warning options.
   * @param {Node}   opts.node   CSS node that caused the warning.
   * @param {string} opts.word   Word in CSS source that caused the warning.
   * @param {number} opts.index  Index in CSS node string that caused
   *                             the warning.
   * @param {string} opts.plugin Name of the plugin that created
   *                             this warning. {@link Result#warn} fills
   *                             this property automatically.
   *
   * @return {Warning} Created warning.
   */
  ;

  _proto.warn = function warn(text, opts) {
    if (opts === void 0) {
      opts = {};
    }

    if (!opts.plugin) {
      if (this.lastPlugin && this.lastPlugin.postcssPlugin) {
        opts.plugin = this.lastPlugin.postcssPlugin;
      }
    }

    var warning = new _warning.default(text, opts);
    this.messages.push(warning);
    return warning;
  }
  /**
     * Returns warnings from plugins. Filters {@link Warning} instances
     * from {@link Result#messages}.
     *
     * @example
     * result.warnings().forEach(warn => {
     *   console.warn(warn.toString())
     * })
     *
     * @return {Warning[]} Warnings from plugins.
     */
  ;

  _proto.warnings = function warnings() {
    return this.messages.filter(function (i) {
      return i.type === 'warning';
    });
  }
  /**
   * An alias for the {@link Result#css} property.
   * Use it with syntaxes that generate non-CSS output.
   *
   * @type {string}
   *
   * @example
   * result.css === result.content
   */
  ;

  _createClass(Result, [{
    key: "content",
    get: function get() {
      return this.css;
    }
  }]);

  return Result;
}();

var _default = Result;
/**
 * @typedef  {object} Message
 * @property {string} type   Message type.
 * @property {string} plugin Source PostCSS plugin name.
 */

exports.default = _default;
module.exports = exports.default;


},{"./warning":67}],60:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.default = void 0;

var _container = _interopRequireDefault(require("./container"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * Represents a CSS file and contains all its parsed nodes.
 *
 * @extends Container
 *
 * @example
 * const root = postcss.parse('a{color:black} b{z-index:2}')
 * root.type         //=> 'root'
 * root.nodes.length //=> 2
 */
var Root =
/*#__PURE__*/
function (_Container) {
  _inheritsLoose(Root, _Container);

  function Root(defaults) {
    var _this;

    _this = _Container.call(this, defaults) || this;
    _this.type = 'root';
    if (!_this.nodes) _this.nodes = [];
    return _this;
  }

  var _proto = Root.prototype;

  _proto.removeChild = function removeChild(child, ignore) {
    var index = this.index(child);

    if (!ignore && index === 0 && this.nodes.length > 1) {
      this.nodes[1].raws.before = this.nodes[index].raws.before;
    }

    return _Container.prototype.removeChild.call(this, child);
  };

  _proto.normalize = function normalize(child, sample, type) {
    var nodes = _Container.prototype.normalize.call(this, child);

    if (sample) {
      if (type === 'prepend') {
        if (this.nodes.length > 1) {
          sample.raws.before = this.nodes[1].raws.before;
        } else {
          delete sample.raws.before;
        }
      } else if (this.first !== sample) {
        for (var _iterator = nodes, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
          var _ref;

          if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
          } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
          }

          var node = _ref;
          node.raws.before = sample.raws.before;
        }
      }
    }

    return nodes;
  }
  /**
   * Returns a {@link Result} instance representing the root’s CSS.
   *
   * @param {processOptions} [opts] Options with only `to` and `map` keys.
   *
   * @return {Result} Result with current root’s CSS.
   *
   * @example
   * const root1 = postcss.parse(css1, { from: 'a.css' })
   * const root2 = postcss.parse(css2, { from: 'b.css' })
   * root1.append(root2)
   * const result = root1.toResult({ to: 'all.css', map: true })
   */
  ;

  _proto.toResult = function toResult(opts) {
    if (opts === void 0) {
      opts = {};
    }

    var LazyResult = require('./lazy-result');

    var Processor = require('./processor');

    var lazy = new LazyResult(new Processor(), this, opts);
    return lazy.stringify();
  }
  /**
   * @memberof Root#
   * @member {object} raws Information to generate byte-to-byte equal
   *                       node string as it was in the origin input.
   *
   * Every parser saves its own properties,
   * but the default CSS parser uses:
   *
   * * `after`: the space symbols after the last child to the end of file.
   * * `semicolon`: is the last child has an (optional) semicolon.
   *
   * @example
   * postcss.parse('a {}\n').raws //=> { after: '\n' }
   * postcss.parse('a {}').raws   //=> { after: '' }
   */
  ;

  return Root;
}(_container.default);

var _default = Root;
exports.default = _default;
module.exports = exports.default;


},{"./container":46,"./lazy-result":50,"./processor":58}],61:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.default = void 0;

var _container = _interopRequireDefault(require("./container"));

var _list = _interopRequireDefault(require("./list"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * Represents a CSS rule: a selector followed by a declaration block.
 *
 * @extends Container
 *
 * @example
 * const root = postcss.parse('a{}')
 * const rule = root.first
 * rule.type       //=> 'rule'
 * rule.toString() //=> 'a{}'
 */
var Rule =
/*#__PURE__*/
function (_Container) {
  _inheritsLoose(Rule, _Container);

  function Rule(defaults) {
    var _this;

    _this = _Container.call(this, defaults) || this;
    _this.type = 'rule';
    if (!_this.nodes) _this.nodes = [];
    return _this;
  }
  /**
   * An array containing the rule’s individual selectors.
   * Groups of selectors are split at commas.
   *
   * @type {string[]}
   *
   * @example
   * const root = postcss.parse('a, b { }')
   * const rule = root.first
   *
   * rule.selector  //=> 'a, b'
   * rule.selectors //=> ['a', 'b']
   *
   * rule.selectors = ['a', 'strong']
   * rule.selector //=> 'a, strong'
   */


  _createClass(Rule, [{
    key: "selectors",
    get: function get() {
      return _list.default.comma(this.selector);
    },
    set: function set(values) {
      var match = this.selector ? this.selector.match(/,\s*/) : null;
      var sep = match ? match[0] : ',' + this.raw('between', 'beforeOpen');
      this.selector = values.join(sep);
    }
    /**
     * @memberof Rule#
     * @member {string} selector The rule’s full selector represented
     *                           as a string.
     *
     * @example
     * const root = postcss.parse('a, b { }')
     * const rule = root.first
     * rule.selector //=> 'a, b'
     */

    /**
     * @memberof Rule#
     * @member {object} raws Information to generate byte-to-byte equal
     *                       node string as it was in the origin input.
     *
     * Every parser saves its own properties,
     * but the default CSS parser uses:
     *
     * * `before`: the space symbols before the node. It also stores `*`
     *   and `_` symbols before the declaration (IE hack).
     * * `after`: the space symbols after the last child of the node
     *   to the end of the node.
     * * `between`: the symbols between the property and value
     *   for declarations, selector and `{` for rules, or last parameter
     *   and `{` for at-rules.
     * * `semicolon`: contains `true` if the last child has
     *   an (optional) semicolon.
     * * `ownSemicolon`: contains `true` if there is semicolon after rule.
     *
     * PostCSS cleans selectors from comments and extra spaces,
     * but it stores origin content in raws properties.
     * As such, if you don’t change a declaration’s value,
     * PostCSS will use the raw value with comments.
     *
     * @example
     * const root = postcss.parse('a {\n  color:black\n}')
     * root.first.first.raws //=> { before: '', between: ' ', after: '\n' }
     */

  }]);

  return Rule;
}(_container.default);

var _default = Rule;
exports.default = _default;
module.exports = exports.default;


},{"./container":46,"./list":51}],62:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.default = void 0;
var DEFAULT_RAW = {
  colon: ': ',
  indent: '    ',
  beforeDecl: '\n',
  beforeRule: '\n',
  beforeOpen: ' ',
  beforeClose: '\n',
  beforeComment: '\n',
  after: '\n',
  emptyBody: '',
  commentLeft: ' ',
  commentRight: ' ',
  semicolon: false
};

function capitalize(str) {
  return str[0].toUpperCase() + str.slice(1);
}

var Stringifier =
/*#__PURE__*/
function () {
  function Stringifier(builder) {
    this.builder = builder;
  }

  var _proto = Stringifier.prototype;

  _proto.stringify = function stringify(node, semicolon) {
    this[node.type](node, semicolon);
  };

  _proto.root = function root(node) {
    this.body(node);
    if (node.raws.after) this.builder(node.raws.after);
  };

  _proto.comment = function comment(node) {
    var left = this.raw(node, 'left', 'commentLeft');
    var right = this.raw(node, 'right', 'commentRight');
    this.builder('/*' + left + node.text + right + '*/', node);
  };

  _proto.decl = function decl(node, semicolon) {
    var between = this.raw(node, 'between', 'colon');
    var string = node.prop + between + this.rawValue(node, 'value');

    if (node.important) {
      string += node.raws.important || ' !important';
    }

    if (semicolon) string += ';';
    this.builder(string, node);
  };

  _proto.rule = function rule(node) {
    this.block(node, this.rawValue(node, 'selector'));

    if (node.raws.ownSemicolon) {
      this.builder(node.raws.ownSemicolon, node, 'end');
    }
  };

  _proto.atrule = function atrule(node, semicolon) {
    var name = '@' + node.name;
    var params = node.params ? this.rawValue(node, 'params') : '';

    if (typeof node.raws.afterName !== 'undefined') {
      name += node.raws.afterName;
    } else if (params) {
      name += ' ';
    }

    if (node.nodes) {
      this.block(node, name + params);
    } else {
      var end = (node.raws.between || '') + (semicolon ? ';' : '');
      this.builder(name + params + end, node);
    }
  };

  _proto.body = function body(node) {
    var last = node.nodes.length - 1;

    while (last > 0) {
      if (node.nodes[last].type !== 'comment') break;
      last -= 1;
    }

    var semicolon = this.raw(node, 'semicolon');

    for (var i = 0; i < node.nodes.length; i++) {
      var child = node.nodes[i];
      var before = this.raw(child, 'before');
      if (before) this.builder(before);
      this.stringify(child, last !== i || semicolon);
    }
  };

  _proto.block = function block(node, start) {
    var between = this.raw(node, 'between', 'beforeOpen');
    this.builder(start + between + '{', node, 'start');
    var after;

    if (node.nodes && node.nodes.length) {
      this.body(node);
      after = this.raw(node, 'after');
    } else {
      after = this.raw(node, 'after', 'emptyBody');
    }

    if (after) this.builder(after);
    this.builder('}', node, 'end');
  };

  _proto.raw = function raw(node, own, detect) {
    var value;
    if (!detect) detect = own; // Already had

    if (own) {
      value = node.raws[own];
      if (typeof value !== 'undefined') return value;
    }

    var parent = node.parent; // Hack for first rule in CSS

    if (detect === 'before') {
      if (!parent || parent.type === 'root' && parent.first === node) {
        return '';
      }
    } // Floating child without parent


    if (!parent) return DEFAULT_RAW[detect]; // Detect style by other nodes

    var root = node.root();
    if (!root.rawCache) root.rawCache = {};

    if (typeof root.rawCache[detect] !== 'undefined') {
      return root.rawCache[detect];
    }

    if (detect === 'before' || detect === 'after') {
      return this.beforeAfter(node, detect);
    } else {
      var method = 'raw' + capitalize(detect);

      if (this[method]) {
        value = this[method](root, node);
      } else {
        root.walk(function (i) {
          value = i.raws[own];
          if (typeof value !== 'undefined') return false;
        });
      }
    }

    if (typeof value === 'undefined') value = DEFAULT_RAW[detect];
    root.rawCache[detect] = value;
    return value;
  };

  _proto.rawSemicolon = function rawSemicolon(root) {
    var value;
    root.walk(function (i) {
      if (i.nodes && i.nodes.length && i.last.type === 'decl') {
        value = i.raws.semicolon;
        if (typeof value !== 'undefined') return false;
      }
    });
    return value;
  };

  _proto.rawEmptyBody = function rawEmptyBody(root) {
    var value;
    root.walk(function (i) {
      if (i.nodes && i.nodes.length === 0) {
        value = i.raws.after;
        if (typeof value !== 'undefined') return false;
      }
    });
    return value;
  };

  _proto.rawIndent = function rawIndent(root) {
    if (root.raws.indent) return root.raws.indent;
    var value;
    root.walk(function (i) {
      var p = i.parent;

      if (p && p !== root && p.parent && p.parent === root) {
        if (typeof i.raws.before !== 'undefined') {
          var parts = i.raws.before.split('\n');
          value = parts[parts.length - 1];
          value = value.replace(/[^\s]/g, '');
          return false;
        }
      }
    });
    return value;
  };

  _proto.rawBeforeComment = function rawBeforeComment(root, node) {
    var value;
    root.walkComments(function (i) {
      if (typeof i.raws.before !== 'undefined') {
        value = i.raws.before;

        if (value.indexOf('\n') !== -1) {
          value = value.replace(/[^\n]+$/, '');
        }

        return false;
      }
    });

    if (typeof value === 'undefined') {
      value = this.raw(node, null, 'beforeDecl');
    } else if (value) {
      value = value.replace(/[^\s]/g, '');
    }

    return value;
  };

  _proto.rawBeforeDecl = function rawBeforeDecl(root, node) {
    var value;
    root.walkDecls(function (i) {
      if (typeof i.raws.before !== 'undefined') {
        value = i.raws.before;

        if (value.indexOf('\n') !== -1) {
          value = value.replace(/[^\n]+$/, '');
        }

        return false;
      }
    });

    if (typeof value === 'undefined') {
      value = this.raw(node, null, 'beforeRule');
    } else if (value) {
      value = value.replace(/[^\s]/g, '');
    }

    return value;
  };

  _proto.rawBeforeRule = function rawBeforeRule(root) {
    var value;
    root.walk(function (i) {
      if (i.nodes && (i.parent !== root || root.first !== i)) {
        if (typeof i.raws.before !== 'undefined') {
          value = i.raws.before;

          if (value.indexOf('\n') !== -1) {
            value = value.replace(/[^\n]+$/, '');
          }

          return false;
        }
      }
    });
    if (value) value = value.replace(/[^\s]/g, '');
    return value;
  };

  _proto.rawBeforeClose = function rawBeforeClose(root) {
    var value;
    root.walk(function (i) {
      if (i.nodes && i.nodes.length > 0) {
        if (typeof i.raws.after !== 'undefined') {
          value = i.raws.after;

          if (value.indexOf('\n') !== -1) {
            value = value.replace(/[^\n]+$/, '');
          }

          return false;
        }
      }
    });
    if (value) value = value.replace(/[^\s]/g, '');
    return value;
  };

  _proto.rawBeforeOpen = function rawBeforeOpen(root) {
    var value;
    root.walk(function (i) {
      if (i.type !== 'decl') {
        value = i.raws.between;
        if (typeof value !== 'undefined') return false;
      }
    });
    return value;
  };

  _proto.rawColon = function rawColon(root) {
    var value;
    root.walkDecls(function (i) {
      if (typeof i.raws.between !== 'undefined') {
        value = i.raws.between.replace(/[^\s:]/g, '');
        return false;
      }
    });
    return value;
  };

  _proto.beforeAfter = function beforeAfter(node, detect) {
    var value;

    if (node.type === 'decl') {
      value = this.raw(node, null, 'beforeDecl');
    } else if (node.type === 'comment') {
      value = this.raw(node, null, 'beforeComment');
    } else if (detect === 'before') {
      value = this.raw(node, null, 'beforeRule');
    } else {
      value = this.raw(node, null, 'beforeClose');
    }

    var buf = node.parent;
    var depth = 0;

    while (buf && buf.type !== 'root') {
      depth += 1;
      buf = buf.parent;
    }

    if (value.indexOf('\n') !== -1) {
      var indent = this.raw(node, null, 'indent');

      if (indent.length) {
        for (var step = 0; step < depth; step++) {
          value += indent;
        }
      }
    }

    return value;
  };

  _proto.rawValue = function rawValue(node, prop) {
    var value = node[prop];
    var raw = node.raws[prop];

    if (raw && raw.value === value) {
      return raw.raw;
    }

    return value;
  };

  return Stringifier;
}();

var _default = Stringifier;
exports.default = _default;
module.exports = exports.default;


},{}],63:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.default = void 0;

var _stringifier = _interopRequireDefault(require("./stringifier"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function stringify(node, builder) {
  var str = new _stringifier.default(builder);
  str.stringify(node);
}

var _default = stringify;
exports.default = _default;
module.exports = exports.default;


},{"./stringifier":62}],64:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.default = tokenizer;
var SINGLE_QUOTE = '\''.charCodeAt(0);
var DOUBLE_QUOTE = '"'.charCodeAt(0);
var BACKSLASH = '\\'.charCodeAt(0);
var SLASH = '/'.charCodeAt(0);
var NEWLINE = '\n'.charCodeAt(0);
var SPACE = ' '.charCodeAt(0);
var FEED = '\f'.charCodeAt(0);
var TAB = '\t'.charCodeAt(0);
var CR = '\r'.charCodeAt(0);
var OPEN_SQUARE = '['.charCodeAt(0);
var CLOSE_SQUARE = ']'.charCodeAt(0);
var OPEN_PARENTHESES = '('.charCodeAt(0);
var CLOSE_PARENTHESES = ')'.charCodeAt(0);
var OPEN_CURLY = '{'.charCodeAt(0);
var CLOSE_CURLY = '}'.charCodeAt(0);
var SEMICOLON = ';'.charCodeAt(0);
var ASTERISK = '*'.charCodeAt(0);
var COLON = ':'.charCodeAt(0);
var AT = '@'.charCodeAt(0);
var RE_AT_END = /[ \n\t\r\f{}()'"\\;/[\]#]/g;
var RE_WORD_END = /[ \n\t\r\f(){}:;@!'"\\\][#]|\/(?=\*)/g;
var RE_BAD_BRACKET = /.[\\/("'\n]/;
var RE_HEX_ESCAPE = /[a-f0-9]/i;

function tokenizer(input, options) {
  if (options === void 0) {
    options = {};
  }

  var css = input.css.valueOf();
  var ignore = options.ignoreErrors;
  var code, next, quote, lines, last, content, escape;
  var nextLine, nextOffset, escaped, escapePos, prev, n, currentToken;
  var length = css.length;
  var offset = -1;
  var line = 1;
  var pos = 0;
  var buffer = [];
  var returned = [];

  function position() {
    return pos;
  }

  function unclosed(what) {
    throw input.error('Unclosed ' + what, line, pos - offset);
  }

  function endOfFile() {
    return returned.length === 0 && pos >= length;
  }

  function nextToken(opts) {
    if (returned.length) return returned.pop();
    if (pos >= length) return;
    var ignoreUnclosed = opts ? opts.ignoreUnclosed : false;
    code = css.charCodeAt(pos);

    if (code === NEWLINE || code === FEED || code === CR && css.charCodeAt(pos + 1) !== NEWLINE) {
      offset = pos;
      line += 1;
    }

    switch (code) {
      case NEWLINE:
      case SPACE:
      case TAB:
      case CR:
      case FEED:
        next = pos;

        do {
          next += 1;
          code = css.charCodeAt(next);

          if (code === NEWLINE) {
            offset = next;
            line += 1;
          }
        } while (code === SPACE || code === NEWLINE || code === TAB || code === CR || code === FEED);

        currentToken = ['space', css.slice(pos, next)];
        pos = next - 1;
        break;

      case OPEN_SQUARE:
      case CLOSE_SQUARE:
      case OPEN_CURLY:
      case CLOSE_CURLY:
      case COLON:
      case SEMICOLON:
      case CLOSE_PARENTHESES:
        var controlChar = String.fromCharCode(code);
        currentToken = [controlChar, controlChar, line, pos - offset];
        break;

      case OPEN_PARENTHESES:
        prev = buffer.length ? buffer.pop()[1] : '';
        n = css.charCodeAt(pos + 1);

        if (prev === 'url' && n !== SINGLE_QUOTE && n !== DOUBLE_QUOTE && n !== SPACE && n !== NEWLINE && n !== TAB && n !== FEED && n !== CR) {
          next = pos;

          do {
            escaped = false;
            next = css.indexOf(')', next + 1);

            if (next === -1) {
              if (ignore || ignoreUnclosed) {
                next = pos;
                break;
              } else {
                unclosed('bracket');
              }
            }

            escapePos = next;

            while (css.charCodeAt(escapePos - 1) === BACKSLASH) {
              escapePos -= 1;
              escaped = !escaped;
            }
          } while (escaped);

          currentToken = ['brackets', css.slice(pos, next + 1), line, pos - offset, line, next - offset];
          pos = next;
        } else {
          next = css.indexOf(')', pos + 1);
          content = css.slice(pos, next + 1);

          if (next === -1 || RE_BAD_BRACKET.test(content)) {
            currentToken = ['(', '(', line, pos - offset];
          } else {
            currentToken = ['brackets', content, line, pos - offset, line, next - offset];
            pos = next;
          }
        }

        break;

      case SINGLE_QUOTE:
      case DOUBLE_QUOTE:
        quote = code === SINGLE_QUOTE ? '\'' : '"';
        next = pos;

        do {
          escaped = false;
          next = css.indexOf(quote, next + 1);

          if (next === -1) {
            if (ignore || ignoreUnclosed) {
              next = pos + 1;
              break;
            } else {
              unclosed('string');
            }
          }

          escapePos = next;

          while (css.charCodeAt(escapePos - 1) === BACKSLASH) {
            escapePos -= 1;
            escaped = !escaped;
          }
        } while (escaped);

        content = css.slice(pos, next + 1);
        lines = content.split('\n');
        last = lines.length - 1;

        if (last > 0) {
          nextLine = line + last;
          nextOffset = next - lines[last].length;
        } else {
          nextLine = line;
          nextOffset = offset;
        }

        currentToken = ['string', css.slice(pos, next + 1), line, pos - offset, nextLine, next - nextOffset];
        offset = nextOffset;
        line = nextLine;
        pos = next;
        break;

      case AT:
        RE_AT_END.lastIndex = pos + 1;
        RE_AT_END.test(css);

        if (RE_AT_END.lastIndex === 0) {
          next = css.length - 1;
        } else {
          next = RE_AT_END.lastIndex - 2;
        }

        currentToken = ['at-word', css.slice(pos, next + 1), line, pos - offset, line, next - offset];
        pos = next;
        break;

      case BACKSLASH:
        next = pos;
        escape = true;

        while (css.charCodeAt(next + 1) === BACKSLASH) {
          next += 1;
          escape = !escape;
        }

        code = css.charCodeAt(next + 1);

        if (escape && code !== SLASH && code !== SPACE && code !== NEWLINE && code !== TAB && code !== CR && code !== FEED) {
          next += 1;

          if (RE_HEX_ESCAPE.test(css.charAt(next))) {
            while (RE_HEX_ESCAPE.test(css.charAt(next + 1))) {
              next += 1;
            }

            if (css.charCodeAt(next + 1) === SPACE) {
              next += 1;
            }
          }
        }

        currentToken = ['word', css.slice(pos, next + 1), line, pos - offset, line, next - offset];
        pos = next;
        break;

      default:
        if (code === SLASH && css.charCodeAt(pos + 1) === ASTERISK) {
          next = css.indexOf('*/', pos + 2) + 1;

          if (next === 0) {
            if (ignore || ignoreUnclosed) {
              next = css.length;
            } else {
              unclosed('comment');
            }
          }

          content = css.slice(pos, next + 1);
          lines = content.split('\n');
          last = lines.length - 1;

          if (last > 0) {
            nextLine = line + last;
            nextOffset = next - lines[last].length;
          } else {
            nextLine = line;
            nextOffset = offset;
          }

          currentToken = ['comment', content, line, pos - offset, nextLine, next - nextOffset];
          offset = nextOffset;
          line = nextLine;
          pos = next;
        } else {
          RE_WORD_END.lastIndex = pos + 1;
          RE_WORD_END.test(css);

          if (RE_WORD_END.lastIndex === 0) {
            next = css.length - 1;
          } else {
            next = RE_WORD_END.lastIndex - 2;
          }

          currentToken = ['word', css.slice(pos, next + 1), line, pos - offset, line, next - offset];
          buffer.push(currentToken);
          pos = next;
        }

        break;
    }

    pos++;
    return currentToken;
  }

  function back(token) {
    returned.push(token);
  }

  return {
    back: back,
    nextToken: nextToken,
    endOfFile: endOfFile,
    position: position
  };
}

module.exports = exports.default;


},{}],65:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.default = void 0;

/**
 * Contains helpers for working with vendor prefixes.
 *
 * @example
 * const vendor = postcss.vendor
 *
 * @namespace vendor
 */
var vendor = {
  /**
   * Returns the vendor prefix extracted from an input string.
   *
   * @param {string} prop String with or without vendor prefix.
   *
   * @return {string} vendor prefix or empty string
   *
   * @example
   * postcss.vendor.prefix('-moz-tab-size') //=> '-moz-'
   * postcss.vendor.prefix('tab-size')      //=> ''
   */
  prefix: function prefix(prop) {
    var match = prop.match(/^(-\w+-)/);

    if (match) {
      return match[0];
    }

    return '';
  },

  /**
     * Returns the input string stripped of its vendor prefix.
     *
     * @param {string} prop String with or without vendor prefix.
     *
     * @return {string} String name without vendor prefixes.
     *
     * @example
     * postcss.vendor.unprefixed('-moz-tab-size') //=> 'tab-size'
     */
  unprefixed: function unprefixed(prop) {
    return prop.replace(/^-\w+-/, '');
  }
};
var _default = vendor;
exports.default = _default;
module.exports = exports.default;


},{}],66:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.default = warnOnce;
var printed = {};

function warnOnce(message) {
  if (printed[message]) return;
  printed[message] = true;

  if (typeof console !== 'undefined' && console.warn) {
    console.warn(message);
  }
}

module.exports = exports.default;


},{}],67:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.default = void 0;

/**
 * Represents a plugin’s warning. It can be created using {@link Node#warn}.
 *
 * @example
 * if (decl.important) {
 *   decl.warn(result, 'Avoid !important', { word: '!important' })
 * }
 */
var Warning =
/*#__PURE__*/
function () {
  /**
   * @param {string} text        Warning message.
   * @param {Object} [opts]      Warning options.
   * @param {Node}   opts.node   CSS node that caused the warning.
   * @param {string} opts.word   Word in CSS source that caused the warning.
   * @param {number} opts.index  Index in CSS node string that caused
   *                             the warning.
   * @param {string} opts.plugin Name of the plugin that created
   *                             this warning. {@link Result#warn} fills
   *                             this property automatically.
   */
  function Warning(text, opts) {
    if (opts === void 0) {
      opts = {};
    }

    /**
     * Type to filter warnings from {@link Result#messages}.
     * Always equal to `"warning"`.
     *
     * @type {string}
     *
     * @example
     * const nonWarning = result.messages.filter(i => i.type !== 'warning')
     */
    this.type = 'warning';
    /**
     * The warning message.
     *
     * @type {string}
     *
     * @example
     * warning.text //=> 'Try to avoid !important'
     */

    this.text = text;

    if (opts.node && opts.node.source) {
      var pos = opts.node.positionBy(opts);
      /**
       * Line in the input file with this warning’s source.
       * @type {number}
       *
       * @example
       * warning.line //=> 5
       */

      this.line = pos.line;
      /**
       * Column in the input file with this warning’s source.
       *
       * @type {number}
       *
       * @example
       * warning.column //=> 6
       */

      this.column = pos.column;
    }

    for (var opt in opts) {
      this[opt] = opts[opt];
    }
  }
  /**
   * Returns a warning position and message.
   *
   * @example
   * warning.toString() //=> 'postcss-lint:a.css:10:14: Avoid !important'
   *
   * @return {string} Warning position and message.
   */


  var _proto = Warning.prototype;

  _proto.toString = function toString() {
    if (this.node) {
      return this.node.error(this.text, {
        plugin: this.plugin,
        index: this.index,
        word: this.word
      }).message;
    }

    if (this.plugin) {
      return this.plugin + ': ' + this.text;
    }

    return this.text;
  }
  /**
   * @memberof Warning#
   * @member {string} plugin The name of the plugin that created
   *                         it will fill this property automatically.
   *                         this warning. When you call {@link Node#warn}
   *
   * @example
   * warning.plugin //=> 'postcss-important'
   */

  /**
   * @memberof Warning#
   * @member {Node} node Contains the CSS node that caused the warning.
   *
   * @example
   * warning.node.toString() //=> 'color: white !important'
   */
  ;

  return Warning;
}();

var _default = Warning;
exports.default = _default;
module.exports = exports.default;


},{}],68:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],69:[function(require,module,exports){
(function (global){
/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.4.1',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		typeof define == 'function' &&
		typeof define.amd == 'object' &&
		define.amd
	) {
		define('punycode', function() {
			return punycode;
		});
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],70:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

},{}],71:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};

},{}],72:[function(require,module,exports){
'use strict';

exports.decode = exports.parse = require('./decode');
exports.encode = exports.stringify = require('./encode');

},{"./decode":70,"./encode":71}],73:[function(require,module,exports){
/* eslint-disable node/no-deprecated-api */
var buffer = require('buffer')
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}

},{"buffer":5}],74:[function(require,module,exports){
/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

var util = require('./util');
var has = Object.prototype.hasOwnProperty;
var hasNativeMap = typeof Map !== "undefined";

/**
 * A data structure which is a combination of an array and a set. Adding a new
 * member is O(1), testing for membership is O(1), and finding the index of an
 * element is O(1). Removing elements from the set is not supported. Only
 * strings are supported for membership.
 */
function ArraySet() {
  this._array = [];
  this._set = hasNativeMap ? new Map() : Object.create(null);
}

/**
 * Static method for creating ArraySet instances from an existing array.
 */
ArraySet.fromArray = function ArraySet_fromArray(aArray, aAllowDuplicates) {
  var set = new ArraySet();
  for (var i = 0, len = aArray.length; i < len; i++) {
    set.add(aArray[i], aAllowDuplicates);
  }
  return set;
};

/**
 * Return how many unique items are in this ArraySet. If duplicates have been
 * added, than those do not count towards the size.
 *
 * @returns Number
 */
ArraySet.prototype.size = function ArraySet_size() {
  return hasNativeMap ? this._set.size : Object.getOwnPropertyNames(this._set).length;
};

/**
 * Add the given string to this set.
 *
 * @param String aStr
 */
ArraySet.prototype.add = function ArraySet_add(aStr, aAllowDuplicates) {
  var sStr = hasNativeMap ? aStr : util.toSetString(aStr);
  var isDuplicate = hasNativeMap ? this.has(aStr) : has.call(this._set, sStr);
  var idx = this._array.length;
  if (!isDuplicate || aAllowDuplicates) {
    this._array.push(aStr);
  }
  if (!isDuplicate) {
    if (hasNativeMap) {
      this._set.set(aStr, idx);
    } else {
      this._set[sStr] = idx;
    }
  }
};

/**
 * Is the given string a member of this set?
 *
 * @param String aStr
 */
ArraySet.prototype.has = function ArraySet_has(aStr) {
  if (hasNativeMap) {
    return this._set.has(aStr);
  } else {
    var sStr = util.toSetString(aStr);
    return has.call(this._set, sStr);
  }
};

/**
 * What is the index of the given string in the array?
 *
 * @param String aStr
 */
ArraySet.prototype.indexOf = function ArraySet_indexOf(aStr) {
  if (hasNativeMap) {
    var idx = this._set.get(aStr);
    if (idx >= 0) {
        return idx;
    }
  } else {
    var sStr = util.toSetString(aStr);
    if (has.call(this._set, sStr)) {
      return this._set[sStr];
    }
  }

  throw new Error('"' + aStr + '" is not in the set.');
};

/**
 * What is the element at the given index?
 *
 * @param Number aIdx
 */
ArraySet.prototype.at = function ArraySet_at(aIdx) {
  if (aIdx >= 0 && aIdx < this._array.length) {
    return this._array[aIdx];
  }
  throw new Error('No element indexed by ' + aIdx);
};

/**
 * Returns the array representation of this set (which has the proper indices
 * indicated by indexOf). Note that this is a copy of the internal array used
 * for storing the members so that no one can mess with internal state.
 */
ArraySet.prototype.toArray = function ArraySet_toArray() {
  return this._array.slice();
};

exports.ArraySet = ArraySet;

},{"./util":83}],75:[function(require,module,exports){
/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 *
 * Based on the Base 64 VLQ implementation in Closure Compiler:
 * https://code.google.com/p/closure-compiler/source/browse/trunk/src/com/google/debugging/sourcemap/Base64VLQ.java
 *
 * Copyright 2011 The Closure Compiler Authors. All rights reserved.
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 *  * Redistributions of source code must retain the above copyright
 *    notice, this list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above
 *    copyright notice, this list of conditions and the following
 *    disclaimer in the documentation and/or other materials provided
 *    with the distribution.
 *  * Neither the name of Google Inc. nor the names of its
 *    contributors may be used to endorse or promote products derived
 *    from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 * LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
 * THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

var base64 = require('./base64');

// A single base 64 digit can contain 6 bits of data. For the base 64 variable
// length quantities we use in the source map spec, the first bit is the sign,
// the next four bits are the actual value, and the 6th bit is the
// continuation bit. The continuation bit tells us whether there are more
// digits in this value following this digit.
//
//   Continuation
//   |    Sign
//   |    |
//   V    V
//   101011

var VLQ_BASE_SHIFT = 5;

// binary: 100000
var VLQ_BASE = 1 << VLQ_BASE_SHIFT;

// binary: 011111
var VLQ_BASE_MASK = VLQ_BASE - 1;

// binary: 100000
var VLQ_CONTINUATION_BIT = VLQ_BASE;

/**
 * Converts from a two-complement value to a value where the sign bit is
 * placed in the least significant bit.  For example, as decimals:
 *   1 becomes 2 (10 binary), -1 becomes 3 (11 binary)
 *   2 becomes 4 (100 binary), -2 becomes 5 (101 binary)
 */
function toVLQSigned(aValue) {
  return aValue < 0
    ? ((-aValue) << 1) + 1
    : (aValue << 1) + 0;
}

/**
 * Converts to a two-complement value from a value where the sign bit is
 * placed in the least significant bit.  For example, as decimals:
 *   2 (10 binary) becomes 1, 3 (11 binary) becomes -1
 *   4 (100 binary) becomes 2, 5 (101 binary) becomes -2
 */
function fromVLQSigned(aValue) {
  var isNegative = (aValue & 1) === 1;
  var shifted = aValue >> 1;
  return isNegative
    ? -shifted
    : shifted;
}

/**
 * Returns the base 64 VLQ encoded value.
 */
exports.encode = function base64VLQ_encode(aValue) {
  var encoded = "";
  var digit;

  var vlq = toVLQSigned(aValue);

  do {
    digit = vlq & VLQ_BASE_MASK;
    vlq >>>= VLQ_BASE_SHIFT;
    if (vlq > 0) {
      // There are still more digits in this value, so we must make sure the
      // continuation bit is marked.
      digit |= VLQ_CONTINUATION_BIT;
    }
    encoded += base64.encode(digit);
  } while (vlq > 0);

  return encoded;
};

/**
 * Decodes the next base 64 VLQ value from the given string and returns the
 * value and the rest of the string via the out parameter.
 */
exports.decode = function base64VLQ_decode(aStr, aIndex, aOutParam) {
  var strLen = aStr.length;
  var result = 0;
  var shift = 0;
  var continuation, digit;

  do {
    if (aIndex >= strLen) {
      throw new Error("Expected more digits in base 64 VLQ value.");
    }

    digit = base64.decode(aStr.charCodeAt(aIndex++));
    if (digit === -1) {
      throw new Error("Invalid base64 digit: " + aStr.charAt(aIndex - 1));
    }

    continuation = !!(digit & VLQ_CONTINUATION_BIT);
    digit &= VLQ_BASE_MASK;
    result = result + (digit << shift);
    shift += VLQ_BASE_SHIFT;
  } while (continuation);

  aOutParam.value = fromVLQSigned(result);
  aOutParam.rest = aIndex;
};

},{"./base64":76}],76:[function(require,module,exports){
/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

var intToCharMap = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'.split('');

/**
 * Encode an integer in the range of 0 to 63 to a single base 64 digit.
 */
exports.encode = function (number) {
  if (0 <= number && number < intToCharMap.length) {
    return intToCharMap[number];
  }
  throw new TypeError("Must be between 0 and 63: " + number);
};

/**
 * Decode a single base 64 character code digit to an integer. Returns -1 on
 * failure.
 */
exports.decode = function (charCode) {
  var bigA = 65;     // 'A'
  var bigZ = 90;     // 'Z'

  var littleA = 97;  // 'a'
  var littleZ = 122; // 'z'

  var zero = 48;     // '0'
  var nine = 57;     // '9'

  var plus = 43;     // '+'
  var slash = 47;    // '/'

  var littleOffset = 26;
  var numberOffset = 52;

  // 0 - 25: ABCDEFGHIJKLMNOPQRSTUVWXYZ
  if (bigA <= charCode && charCode <= bigZ) {
    return (charCode - bigA);
  }

  // 26 - 51: abcdefghijklmnopqrstuvwxyz
  if (littleA <= charCode && charCode <= littleZ) {
    return (charCode - littleA + littleOffset);
  }

  // 52 - 61: 0123456789
  if (zero <= charCode && charCode <= nine) {
    return (charCode - zero + numberOffset);
  }

  // 62: +
  if (charCode == plus) {
    return 62;
  }

  // 63: /
  if (charCode == slash) {
    return 63;
  }

  // Invalid base64 digit.
  return -1;
};

},{}],77:[function(require,module,exports){
/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

exports.GREATEST_LOWER_BOUND = 1;
exports.LEAST_UPPER_BOUND = 2;

/**
 * Recursive implementation of binary search.
 *
 * @param aLow Indices here and lower do not contain the needle.
 * @param aHigh Indices here and higher do not contain the needle.
 * @param aNeedle The element being searched for.
 * @param aHaystack The non-empty array being searched.
 * @param aCompare Function which takes two elements and returns -1, 0, or 1.
 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 */
function recursiveSearch(aLow, aHigh, aNeedle, aHaystack, aCompare, aBias) {
  // This function terminates when one of the following is true:
  //
  //   1. We find the exact element we are looking for.
  //
  //   2. We did not find the exact element, but we can return the index of
  //      the next-closest element.
  //
  //   3. We did not find the exact element, and there is no next-closest
  //      element than the one we are searching for, so we return -1.
  var mid = Math.floor((aHigh - aLow) / 2) + aLow;
  var cmp = aCompare(aNeedle, aHaystack[mid], true);
  if (cmp === 0) {
    // Found the element we are looking for.
    return mid;
  }
  else if (cmp > 0) {
    // Our needle is greater than aHaystack[mid].
    if (aHigh - mid > 1) {
      // The element is in the upper half.
      return recursiveSearch(mid, aHigh, aNeedle, aHaystack, aCompare, aBias);
    }

    // The exact needle element was not found in this haystack. Determine if
    // we are in termination case (3) or (2) and return the appropriate thing.
    if (aBias == exports.LEAST_UPPER_BOUND) {
      return aHigh < aHaystack.length ? aHigh : -1;
    } else {
      return mid;
    }
  }
  else {
    // Our needle is less than aHaystack[mid].
    if (mid - aLow > 1) {
      // The element is in the lower half.
      return recursiveSearch(aLow, mid, aNeedle, aHaystack, aCompare, aBias);
    }

    // we are in termination case (3) or (2) and return the appropriate thing.
    if (aBias == exports.LEAST_UPPER_BOUND) {
      return mid;
    } else {
      return aLow < 0 ? -1 : aLow;
    }
  }
}

/**
 * This is an implementation of binary search which will always try and return
 * the index of the closest element if there is no exact hit. This is because
 * mappings between original and generated line/col pairs are single points,
 * and there is an implicit region between each of them, so a miss just means
 * that you aren't on the very start of a region.
 *
 * @param aNeedle The element you are looking for.
 * @param aHaystack The array that is being searched.
 * @param aCompare A function which takes the needle and an element in the
 *     array and returns -1, 0, or 1 depending on whether the needle is less
 *     than, equal to, or greater than the element, respectively.
 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 *     Defaults to 'binarySearch.GREATEST_LOWER_BOUND'.
 */
exports.search = function search(aNeedle, aHaystack, aCompare, aBias) {
  if (aHaystack.length === 0) {
    return -1;
  }

  var index = recursiveSearch(-1, aHaystack.length, aNeedle, aHaystack,
                              aCompare, aBias || exports.GREATEST_LOWER_BOUND);
  if (index < 0) {
    return -1;
  }

  // We have found either the exact element, or the next-closest element than
  // the one we are searching for. However, there may be more than one such
  // element. Make sure we always return the smallest of these.
  while (index - 1 >= 0) {
    if (aCompare(aHaystack[index], aHaystack[index - 1], true) !== 0) {
      break;
    }
    --index;
  }

  return index;
};

},{}],78:[function(require,module,exports){
/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2014 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

var util = require('./util');

/**
 * Determine whether mappingB is after mappingA with respect to generated
 * position.
 */
function generatedPositionAfter(mappingA, mappingB) {
  // Optimized for most common case
  var lineA = mappingA.generatedLine;
  var lineB = mappingB.generatedLine;
  var columnA = mappingA.generatedColumn;
  var columnB = mappingB.generatedColumn;
  return lineB > lineA || lineB == lineA && columnB >= columnA ||
         util.compareByGeneratedPositionsInflated(mappingA, mappingB) <= 0;
}

/**
 * A data structure to provide a sorted view of accumulated mappings in a
 * performance conscious manner. It trades a neglibable overhead in general
 * case for a large speedup in case of mappings being added in order.
 */
function MappingList() {
  this._array = [];
  this._sorted = true;
  // Serves as infimum
  this._last = {generatedLine: -1, generatedColumn: 0};
}

/**
 * Iterate through internal items. This method takes the same arguments that
 * `Array.prototype.forEach` takes.
 *
 * NOTE: The order of the mappings is NOT guaranteed.
 */
MappingList.prototype.unsortedForEach =
  function MappingList_forEach(aCallback, aThisArg) {
    this._array.forEach(aCallback, aThisArg);
  };

/**
 * Add the given source mapping.
 *
 * @param Object aMapping
 */
MappingList.prototype.add = function MappingList_add(aMapping) {
  if (generatedPositionAfter(this._last, aMapping)) {
    this._last = aMapping;
    this._array.push(aMapping);
  } else {
    this._sorted = false;
    this._array.push(aMapping);
  }
};

/**
 * Returns the flat, sorted array of mappings. The mappings are sorted by
 * generated position.
 *
 * WARNING: This method returns internal data without copying, for
 * performance. The return value must NOT be mutated, and should be treated as
 * an immutable borrow. If you want to take ownership, you must make your own
 * copy.
 */
MappingList.prototype.toArray = function MappingList_toArray() {
  if (!this._sorted) {
    this._array.sort(util.compareByGeneratedPositionsInflated);
    this._sorted = true;
  }
  return this._array;
};

exports.MappingList = MappingList;

},{"./util":83}],79:[function(require,module,exports){
/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

// It turns out that some (most?) JavaScript engines don't self-host
// `Array.prototype.sort`. This makes sense because C++ will likely remain
// faster than JS when doing raw CPU-intensive sorting. However, when using a
// custom comparator function, calling back and forth between the VM's C++ and
// JIT'd JS is rather slow *and* loses JIT type information, resulting in
// worse generated code for the comparator function than would be optimal. In
// fact, when sorting with a comparator, these costs outweigh the benefits of
// sorting in C++. By using our own JS-implemented Quick Sort (below), we get
// a ~3500ms mean speed-up in `bench/bench.html`.

/**
 * Swap the elements indexed by `x` and `y` in the array `ary`.
 *
 * @param {Array} ary
 *        The array.
 * @param {Number} x
 *        The index of the first item.
 * @param {Number} y
 *        The index of the second item.
 */
function swap(ary, x, y) {
  var temp = ary[x];
  ary[x] = ary[y];
  ary[y] = temp;
}

/**
 * Returns a random integer within the range `low .. high` inclusive.
 *
 * @param {Number} low
 *        The lower bound on the range.
 * @param {Number} high
 *        The upper bound on the range.
 */
function randomIntInRange(low, high) {
  return Math.round(low + (Math.random() * (high - low)));
}

/**
 * The Quick Sort algorithm.
 *
 * @param {Array} ary
 *        An array to sort.
 * @param {function} comparator
 *        Function to use to compare two items.
 * @param {Number} p
 *        Start index of the array
 * @param {Number} r
 *        End index of the array
 */
function doQuickSort(ary, comparator, p, r) {
  // If our lower bound is less than our upper bound, we (1) partition the
  // array into two pieces and (2) recurse on each half. If it is not, this is
  // the empty array and our base case.

  if (p < r) {
    // (1) Partitioning.
    //
    // The partitioning chooses a pivot between `p` and `r` and moves all
    // elements that are less than or equal to the pivot to the before it, and
    // all the elements that are greater than it after it. The effect is that
    // once partition is done, the pivot is in the exact place it will be when
    // the array is put in sorted order, and it will not need to be moved
    // again. This runs in O(n) time.

    // Always choose a random pivot so that an input array which is reverse
    // sorted does not cause O(n^2) running time.
    var pivotIndex = randomIntInRange(p, r);
    var i = p - 1;

    swap(ary, pivotIndex, r);
    var pivot = ary[r];

    // Immediately after `j` is incremented in this loop, the following hold
    // true:
    //
    //   * Every element in `ary[p .. i]` is less than or equal to the pivot.
    //
    //   * Every element in `ary[i+1 .. j-1]` is greater than the pivot.
    for (var j = p; j < r; j++) {
      if (comparator(ary[j], pivot) <= 0) {
        i += 1;
        swap(ary, i, j);
      }
    }

    swap(ary, i + 1, j);
    var q = i + 1;

    // (2) Recurse on each half.

    doQuickSort(ary, comparator, p, q - 1);
    doQuickSort(ary, comparator, q + 1, r);
  }
}

/**
 * Sort the given array in-place with the given comparator function.
 *
 * @param {Array} ary
 *        An array to sort.
 * @param {function} comparator
 *        Function to use to compare two items.
 */
exports.quickSort = function (ary, comparator) {
  doQuickSort(ary, comparator, 0, ary.length - 1);
};

},{}],80:[function(require,module,exports){
/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

var util = require('./util');
var binarySearch = require('./binary-search');
var ArraySet = require('./array-set').ArraySet;
var base64VLQ = require('./base64-vlq');
var quickSort = require('./quick-sort').quickSort;

function SourceMapConsumer(aSourceMap, aSourceMapURL) {
  var sourceMap = aSourceMap;
  if (typeof aSourceMap === 'string') {
    sourceMap = util.parseSourceMapInput(aSourceMap);
  }

  return sourceMap.sections != null
    ? new IndexedSourceMapConsumer(sourceMap, aSourceMapURL)
    : new BasicSourceMapConsumer(sourceMap, aSourceMapURL);
}

SourceMapConsumer.fromSourceMap = function(aSourceMap, aSourceMapURL) {
  return BasicSourceMapConsumer.fromSourceMap(aSourceMap, aSourceMapURL);
}

/**
 * The version of the source mapping spec that we are consuming.
 */
SourceMapConsumer.prototype._version = 3;

// `__generatedMappings` and `__originalMappings` are arrays that hold the
// parsed mapping coordinates from the source map's "mappings" attribute. They
// are lazily instantiated, accessed via the `_generatedMappings` and
// `_originalMappings` getters respectively, and we only parse the mappings
// and create these arrays once queried for a source location. We jump through
// these hoops because there can be many thousands of mappings, and parsing
// them is expensive, so we only want to do it if we must.
//
// Each object in the arrays is of the form:
//
//     {
//       generatedLine: The line number in the generated code,
//       generatedColumn: The column number in the generated code,
//       source: The path to the original source file that generated this
//               chunk of code,
//       originalLine: The line number in the original source that
//                     corresponds to this chunk of generated code,
//       originalColumn: The column number in the original source that
//                       corresponds to this chunk of generated code,
//       name: The name of the original symbol which generated this chunk of
//             code.
//     }
//
// All properties except for `generatedLine` and `generatedColumn` can be
// `null`.
//
// `_generatedMappings` is ordered by the generated positions.
//
// `_originalMappings` is ordered by the original positions.

SourceMapConsumer.prototype.__generatedMappings = null;
Object.defineProperty(SourceMapConsumer.prototype, '_generatedMappings', {
  configurable: true,
  enumerable: true,
  get: function () {
    if (!this.__generatedMappings) {
      this._parseMappings(this._mappings, this.sourceRoot);
    }

    return this.__generatedMappings;
  }
});

SourceMapConsumer.prototype.__originalMappings = null;
Object.defineProperty(SourceMapConsumer.prototype, '_originalMappings', {
  configurable: true,
  enumerable: true,
  get: function () {
    if (!this.__originalMappings) {
      this._parseMappings(this._mappings, this.sourceRoot);
    }

    return this.__originalMappings;
  }
});

SourceMapConsumer.prototype._charIsMappingSeparator =
  function SourceMapConsumer_charIsMappingSeparator(aStr, index) {
    var c = aStr.charAt(index);
    return c === ";" || c === ",";
  };

/**
 * Parse the mappings in a string in to a data structure which we can easily
 * query (the ordered arrays in the `this.__generatedMappings` and
 * `this.__originalMappings` properties).
 */
SourceMapConsumer.prototype._parseMappings =
  function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
    throw new Error("Subclasses must implement _parseMappings");
  };

SourceMapConsumer.GENERATED_ORDER = 1;
SourceMapConsumer.ORIGINAL_ORDER = 2;

SourceMapConsumer.GREATEST_LOWER_BOUND = 1;
SourceMapConsumer.LEAST_UPPER_BOUND = 2;

/**
 * Iterate over each mapping between an original source/line/column and a
 * generated line/column in this source map.
 *
 * @param Function aCallback
 *        The function that is called with each mapping.
 * @param Object aContext
 *        Optional. If specified, this object will be the value of `this` every
 *        time that `aCallback` is called.
 * @param aOrder
 *        Either `SourceMapConsumer.GENERATED_ORDER` or
 *        `SourceMapConsumer.ORIGINAL_ORDER`. Specifies whether you want to
 *        iterate over the mappings sorted by the generated file's line/column
 *        order or the original's source/line/column order, respectively. Defaults to
 *        `SourceMapConsumer.GENERATED_ORDER`.
 */
SourceMapConsumer.prototype.eachMapping =
  function SourceMapConsumer_eachMapping(aCallback, aContext, aOrder) {
    var context = aContext || null;
    var order = aOrder || SourceMapConsumer.GENERATED_ORDER;

    var mappings;
    switch (order) {
    case SourceMapConsumer.GENERATED_ORDER:
      mappings = this._generatedMappings;
      break;
    case SourceMapConsumer.ORIGINAL_ORDER:
      mappings = this._originalMappings;
      break;
    default:
      throw new Error("Unknown order of iteration.");
    }

    var sourceRoot = this.sourceRoot;
    mappings.map(function (mapping) {
      var source = mapping.source === null ? null : this._sources.at(mapping.source);
      source = util.computeSourceURL(sourceRoot, source, this._sourceMapURL);
      return {
        source: source,
        generatedLine: mapping.generatedLine,
        generatedColumn: mapping.generatedColumn,
        originalLine: mapping.originalLine,
        originalColumn: mapping.originalColumn,
        name: mapping.name === null ? null : this._names.at(mapping.name)
      };
    }, this).forEach(aCallback, context);
  };

/**
 * Returns all generated line and column information for the original source,
 * line, and column provided. If no column is provided, returns all mappings
 * corresponding to a either the line we are searching for or the next
 * closest line that has any mappings. Otherwise, returns all mappings
 * corresponding to the given line and either the column we are searching for
 * or the next closest column that has any offsets.
 *
 * The only argument is an object with the following properties:
 *
 *   - source: The filename of the original source.
 *   - line: The line number in the original source.  The line number is 1-based.
 *   - column: Optional. the column number in the original source.
 *    The column number is 0-based.
 *
 * and an array of objects is returned, each with the following properties:
 *
 *   - line: The line number in the generated source, or null.  The
 *    line number is 1-based.
 *   - column: The column number in the generated source, or null.
 *    The column number is 0-based.
 */
SourceMapConsumer.prototype.allGeneratedPositionsFor =
  function SourceMapConsumer_allGeneratedPositionsFor(aArgs) {
    var line = util.getArg(aArgs, 'line');

    // When there is no exact match, BasicSourceMapConsumer.prototype._findMapping
    // returns the index of the closest mapping less than the needle. By
    // setting needle.originalColumn to 0, we thus find the last mapping for
    // the given line, provided such a mapping exists.
    var needle = {
      source: util.getArg(aArgs, 'source'),
      originalLine: line,
      originalColumn: util.getArg(aArgs, 'column', 0)
    };

    needle.source = this._findSourceIndex(needle.source);
    if (needle.source < 0) {
      return [];
    }

    var mappings = [];

    var index = this._findMapping(needle,
                                  this._originalMappings,
                                  "originalLine",
                                  "originalColumn",
                                  util.compareByOriginalPositions,
                                  binarySearch.LEAST_UPPER_BOUND);
    if (index >= 0) {
      var mapping = this._originalMappings[index];

      if (aArgs.column === undefined) {
        var originalLine = mapping.originalLine;

        // Iterate until either we run out of mappings, or we run into
        // a mapping for a different line than the one we found. Since
        // mappings are sorted, this is guaranteed to find all mappings for
        // the line we found.
        while (mapping && mapping.originalLine === originalLine) {
          mappings.push({
            line: util.getArg(mapping, 'generatedLine', null),
            column: util.getArg(mapping, 'generatedColumn', null),
            lastColumn: util.getArg(mapping, 'lastGeneratedColumn', null)
          });

          mapping = this._originalMappings[++index];
        }
      } else {
        var originalColumn = mapping.originalColumn;

        // Iterate until either we run out of mappings, or we run into
        // a mapping for a different line than the one we were searching for.
        // Since mappings are sorted, this is guaranteed to find all mappings for
        // the line we are searching for.
        while (mapping &&
               mapping.originalLine === line &&
               mapping.originalColumn == originalColumn) {
          mappings.push({
            line: util.getArg(mapping, 'generatedLine', null),
            column: util.getArg(mapping, 'generatedColumn', null),
            lastColumn: util.getArg(mapping, 'lastGeneratedColumn', null)
          });

          mapping = this._originalMappings[++index];
        }
      }
    }

    return mappings;
  };

exports.SourceMapConsumer = SourceMapConsumer;

/**
 * A BasicSourceMapConsumer instance represents a parsed source map which we can
 * query for information about the original file positions by giving it a file
 * position in the generated source.
 *
 * The first parameter is the raw source map (either as a JSON string, or
 * already parsed to an object). According to the spec, source maps have the
 * following attributes:
 *
 *   - version: Which version of the source map spec this map is following.
 *   - sources: An array of URLs to the original source files.
 *   - names: An array of identifiers which can be referrenced by individual mappings.
 *   - sourceRoot: Optional. The URL root from which all sources are relative.
 *   - sourcesContent: Optional. An array of contents of the original source files.
 *   - mappings: A string of base64 VLQs which contain the actual mappings.
 *   - file: Optional. The generated file this source map is associated with.
 *
 * Here is an example source map, taken from the source map spec[0]:
 *
 *     {
 *       version : 3,
 *       file: "out.js",
 *       sourceRoot : "",
 *       sources: ["foo.js", "bar.js"],
 *       names: ["src", "maps", "are", "fun"],
 *       mappings: "AA,AB;;ABCDE;"
 *     }
 *
 * The second parameter, if given, is a string whose value is the URL
 * at which the source map was found.  This URL is used to compute the
 * sources array.
 *
 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit?pli=1#
 */
function BasicSourceMapConsumer(aSourceMap, aSourceMapURL) {
  var sourceMap = aSourceMap;
  if (typeof aSourceMap === 'string') {
    sourceMap = util.parseSourceMapInput(aSourceMap);
  }

  var version = util.getArg(sourceMap, 'version');
  var sources = util.getArg(sourceMap, 'sources');
  // Sass 3.3 leaves out the 'names' array, so we deviate from the spec (which
  // requires the array) to play nice here.
  var names = util.getArg(sourceMap, 'names', []);
  var sourceRoot = util.getArg(sourceMap, 'sourceRoot', null);
  var sourcesContent = util.getArg(sourceMap, 'sourcesContent', null);
  var mappings = util.getArg(sourceMap, 'mappings');
  var file = util.getArg(sourceMap, 'file', null);

  // Once again, Sass deviates from the spec and supplies the version as a
  // string rather than a number, so we use loose equality checking here.
  if (version != this._version) {
    throw new Error('Unsupported version: ' + version);
  }

  if (sourceRoot) {
    sourceRoot = util.normalize(sourceRoot);
  }

  sources = sources
    .map(String)
    // Some source maps produce relative source paths like "./foo.js" instead of
    // "foo.js".  Normalize these first so that future comparisons will succeed.
    // See bugzil.la/1090768.
    .map(util.normalize)
    // Always ensure that absolute sources are internally stored relative to
    // the source root, if the source root is absolute. Not doing this would
    // be particularly problematic when the source root is a prefix of the
    // source (valid, but why??). See github issue #199 and bugzil.la/1188982.
    .map(function (source) {
      return sourceRoot && util.isAbsolute(sourceRoot) && util.isAbsolute(source)
        ? util.relative(sourceRoot, source)
        : source;
    });

  // Pass `true` below to allow duplicate names and sources. While source maps
  // are intended to be compressed and deduplicated, the TypeScript compiler
  // sometimes generates source maps with duplicates in them. See Github issue
  // #72 and bugzil.la/889492.
  this._names = ArraySet.fromArray(names.map(String), true);
  this._sources = ArraySet.fromArray(sources, true);

  this._absoluteSources = this._sources.toArray().map(function (s) {
    return util.computeSourceURL(sourceRoot, s, aSourceMapURL);
  });

  this.sourceRoot = sourceRoot;
  this.sourcesContent = sourcesContent;
  this._mappings = mappings;
  this._sourceMapURL = aSourceMapURL;
  this.file = file;
}

BasicSourceMapConsumer.prototype = Object.create(SourceMapConsumer.prototype);
BasicSourceMapConsumer.prototype.consumer = SourceMapConsumer;

/**
 * Utility function to find the index of a source.  Returns -1 if not
 * found.
 */
BasicSourceMapConsumer.prototype._findSourceIndex = function(aSource) {
  var relativeSource = aSource;
  if (this.sourceRoot != null) {
    relativeSource = util.relative(this.sourceRoot, relativeSource);
  }

  if (this._sources.has(relativeSource)) {
    return this._sources.indexOf(relativeSource);
  }

  // Maybe aSource is an absolute URL as returned by |sources|.  In
  // this case we can't simply undo the transform.
  var i;
  for (i = 0; i < this._absoluteSources.length; ++i) {
    if (this._absoluteSources[i] == aSource) {
      return i;
    }
  }

  return -1;
};

/**
 * Create a BasicSourceMapConsumer from a SourceMapGenerator.
 *
 * @param SourceMapGenerator aSourceMap
 *        The source map that will be consumed.
 * @param String aSourceMapURL
 *        The URL at which the source map can be found (optional)
 * @returns BasicSourceMapConsumer
 */
BasicSourceMapConsumer.fromSourceMap =
  function SourceMapConsumer_fromSourceMap(aSourceMap, aSourceMapURL) {
    var smc = Object.create(BasicSourceMapConsumer.prototype);

    var names = smc._names = ArraySet.fromArray(aSourceMap._names.toArray(), true);
    var sources = smc._sources = ArraySet.fromArray(aSourceMap._sources.toArray(), true);
    smc.sourceRoot = aSourceMap._sourceRoot;
    smc.sourcesContent = aSourceMap._generateSourcesContent(smc._sources.toArray(),
                                                            smc.sourceRoot);
    smc.file = aSourceMap._file;
    smc._sourceMapURL = aSourceMapURL;
    smc._absoluteSources = smc._sources.toArray().map(function (s) {
      return util.computeSourceURL(smc.sourceRoot, s, aSourceMapURL);
    });

    // Because we are modifying the entries (by converting string sources and
    // names to indices into the sources and names ArraySets), we have to make
    // a copy of the entry or else bad things happen. Shared mutable state
    // strikes again! See github issue #191.

    var generatedMappings = aSourceMap._mappings.toArray().slice();
    var destGeneratedMappings = smc.__generatedMappings = [];
    var destOriginalMappings = smc.__originalMappings = [];

    for (var i = 0, length = generatedMappings.length; i < length; i++) {
      var srcMapping = generatedMappings[i];
      var destMapping = new Mapping;
      destMapping.generatedLine = srcMapping.generatedLine;
      destMapping.generatedColumn = srcMapping.generatedColumn;

      if (srcMapping.source) {
        destMapping.source = sources.indexOf(srcMapping.source);
        destMapping.originalLine = srcMapping.originalLine;
        destMapping.originalColumn = srcMapping.originalColumn;

        if (srcMapping.name) {
          destMapping.name = names.indexOf(srcMapping.name);
        }

        destOriginalMappings.push(destMapping);
      }

      destGeneratedMappings.push(destMapping);
    }

    quickSort(smc.__originalMappings, util.compareByOriginalPositions);

    return smc;
  };

/**
 * The version of the source mapping spec that we are consuming.
 */
BasicSourceMapConsumer.prototype._version = 3;

/**
 * The list of original sources.
 */
Object.defineProperty(BasicSourceMapConsumer.prototype, 'sources', {
  get: function () {
    return this._absoluteSources.slice();
  }
});

/**
 * Provide the JIT with a nice shape / hidden class.
 */
function Mapping() {
  this.generatedLine = 0;
  this.generatedColumn = 0;
  this.source = null;
  this.originalLine = null;
  this.originalColumn = null;
  this.name = null;
}

/**
 * Parse the mappings in a string in to a data structure which we can easily
 * query (the ordered arrays in the `this.__generatedMappings` and
 * `this.__originalMappings` properties).
 */
BasicSourceMapConsumer.prototype._parseMappings =
  function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
    var generatedLine = 1;
    var previousGeneratedColumn = 0;
    var previousOriginalLine = 0;
    var previousOriginalColumn = 0;
    var previousSource = 0;
    var previousName = 0;
    var length = aStr.length;
    var index = 0;
    var cachedSegments = {};
    var temp = {};
    var originalMappings = [];
    var generatedMappings = [];
    var mapping, str, segment, end, value;

    while (index < length) {
      if (aStr.charAt(index) === ';') {
        generatedLine++;
        index++;
        previousGeneratedColumn = 0;
      }
      else if (aStr.charAt(index) === ',') {
        index++;
      }
      else {
        mapping = new Mapping();
        mapping.generatedLine = generatedLine;

        // Because each offset is encoded relative to the previous one,
        // many segments often have the same encoding. We can exploit this
        // fact by caching the parsed variable length fields of each segment,
        // allowing us to avoid a second parse if we encounter the same
        // segment again.
        for (end = index; end < length; end++) {
          if (this._charIsMappingSeparator(aStr, end)) {
            break;
          }
        }
        str = aStr.slice(index, end);

        segment = cachedSegments[str];
        if (segment) {
          index += str.length;
        } else {
          segment = [];
          while (index < end) {
            base64VLQ.decode(aStr, index, temp);
            value = temp.value;
            index = temp.rest;
            segment.push(value);
          }

          if (segment.length === 2) {
            throw new Error('Found a source, but no line and column');
          }

          if (segment.length === 3) {
            throw new Error('Found a source and line, but no column');
          }

          cachedSegments[str] = segment;
        }

        // Generated column.
        mapping.generatedColumn = previousGeneratedColumn + segment[0];
        previousGeneratedColumn = mapping.generatedColumn;

        if (segment.length > 1) {
          // Original source.
          mapping.source = previousSource + segment[1];
          previousSource += segment[1];

          // Original line.
          mapping.originalLine = previousOriginalLine + segment[2];
          previousOriginalLine = mapping.originalLine;
          // Lines are stored 0-based
          mapping.originalLine += 1;

          // Original column.
          mapping.originalColumn = previousOriginalColumn + segment[3];
          previousOriginalColumn = mapping.originalColumn;

          if (segment.length > 4) {
            // Original name.
            mapping.name = previousName + segment[4];
            previousName += segment[4];
          }
        }

        generatedMappings.push(mapping);
        if (typeof mapping.originalLine === 'number') {
          originalMappings.push(mapping);
        }
      }
    }

    quickSort(generatedMappings, util.compareByGeneratedPositionsDeflated);
    this.__generatedMappings = generatedMappings;

    quickSort(originalMappings, util.compareByOriginalPositions);
    this.__originalMappings = originalMappings;
  };

/**
 * Find the mapping that best matches the hypothetical "needle" mapping that
 * we are searching for in the given "haystack" of mappings.
 */
BasicSourceMapConsumer.prototype._findMapping =
  function SourceMapConsumer_findMapping(aNeedle, aMappings, aLineName,
                                         aColumnName, aComparator, aBias) {
    // To return the position we are searching for, we must first find the
    // mapping for the given position and then return the opposite position it
    // points to. Because the mappings are sorted, we can use binary search to
    // find the best mapping.

    if (aNeedle[aLineName] <= 0) {
      throw new TypeError('Line must be greater than or equal to 1, got '
                          + aNeedle[aLineName]);
    }
    if (aNeedle[aColumnName] < 0) {
      throw new TypeError('Column must be greater than or equal to 0, got '
                          + aNeedle[aColumnName]);
    }

    return binarySearch.search(aNeedle, aMappings, aComparator, aBias);
  };

/**
 * Compute the last column for each generated mapping. The last column is
 * inclusive.
 */
BasicSourceMapConsumer.prototype.computeColumnSpans =
  function SourceMapConsumer_computeColumnSpans() {
    for (var index = 0; index < this._generatedMappings.length; ++index) {
      var mapping = this._generatedMappings[index];

      // Mappings do not contain a field for the last generated columnt. We
      // can come up with an optimistic estimate, however, by assuming that
      // mappings are contiguous (i.e. given two consecutive mappings, the
      // first mapping ends where the second one starts).
      if (index + 1 < this._generatedMappings.length) {
        var nextMapping = this._generatedMappings[index + 1];

        if (mapping.generatedLine === nextMapping.generatedLine) {
          mapping.lastGeneratedColumn = nextMapping.generatedColumn - 1;
          continue;
        }
      }

      // The last mapping for each line spans the entire line.
      mapping.lastGeneratedColumn = Infinity;
    }
  };

/**
 * Returns the original source, line, and column information for the generated
 * source's line and column positions provided. The only argument is an object
 * with the following properties:
 *
 *   - line: The line number in the generated source.  The line number
 *     is 1-based.
 *   - column: The column number in the generated source.  The column
 *     number is 0-based.
 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
 *
 * and an object is returned with the following properties:
 *
 *   - source: The original source file, or null.
 *   - line: The line number in the original source, or null.  The
 *     line number is 1-based.
 *   - column: The column number in the original source, or null.  The
 *     column number is 0-based.
 *   - name: The original identifier, or null.
 */
BasicSourceMapConsumer.prototype.originalPositionFor =
  function SourceMapConsumer_originalPositionFor(aArgs) {
    var needle = {
      generatedLine: util.getArg(aArgs, 'line'),
      generatedColumn: util.getArg(aArgs, 'column')
    };

    var index = this._findMapping(
      needle,
      this._generatedMappings,
      "generatedLine",
      "generatedColumn",
      util.compareByGeneratedPositionsDeflated,
      util.getArg(aArgs, 'bias', SourceMapConsumer.GREATEST_LOWER_BOUND)
    );

    if (index >= 0) {
      var mapping = this._generatedMappings[index];

      if (mapping.generatedLine === needle.generatedLine) {
        var source = util.getArg(mapping, 'source', null);
        if (source !== null) {
          source = this._sources.at(source);
          source = util.computeSourceURL(this.sourceRoot, source, this._sourceMapURL);
        }
        var name = util.getArg(mapping, 'name', null);
        if (name !== null) {
          name = this._names.at(name);
        }
        return {
          source: source,
          line: util.getArg(mapping, 'originalLine', null),
          column: util.getArg(mapping, 'originalColumn', null),
          name: name
        };
      }
    }

    return {
      source: null,
      line: null,
      column: null,
      name: null
    };
  };

/**
 * Return true if we have the source content for every source in the source
 * map, false otherwise.
 */
BasicSourceMapConsumer.prototype.hasContentsOfAllSources =
  function BasicSourceMapConsumer_hasContentsOfAllSources() {
    if (!this.sourcesContent) {
      return false;
    }
    return this.sourcesContent.length >= this._sources.size() &&
      !this.sourcesContent.some(function (sc) { return sc == null; });
  };

/**
 * Returns the original source content. The only argument is the url of the
 * original source file. Returns null if no original source content is
 * available.
 */
BasicSourceMapConsumer.prototype.sourceContentFor =
  function SourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
    if (!this.sourcesContent) {
      return null;
    }

    var index = this._findSourceIndex(aSource);
    if (index >= 0) {
      return this.sourcesContent[index];
    }

    var relativeSource = aSource;
    if (this.sourceRoot != null) {
      relativeSource = util.relative(this.sourceRoot, relativeSource);
    }

    var url;
    if (this.sourceRoot != null
        && (url = util.urlParse(this.sourceRoot))) {
      // XXX: file:// URIs and absolute paths lead to unexpected behavior for
      // many users. We can help them out when they expect file:// URIs to
      // behave like it would if they were running a local HTTP server. See
      // https://bugzilla.mozilla.org/show_bug.cgi?id=885597.
      var fileUriAbsPath = relativeSource.replace(/^file:\/\//, "");
      if (url.scheme == "file"
          && this._sources.has(fileUriAbsPath)) {
        return this.sourcesContent[this._sources.indexOf(fileUriAbsPath)]
      }

      if ((!url.path || url.path == "/")
          && this._sources.has("/" + relativeSource)) {
        return this.sourcesContent[this._sources.indexOf("/" + relativeSource)];
      }
    }

    // This function is used recursively from
    // IndexedSourceMapConsumer.prototype.sourceContentFor. In that case, we
    // don't want to throw if we can't find the source - we just want to
    // return null, so we provide a flag to exit gracefully.
    if (nullOnMissing) {
      return null;
    }
    else {
      throw new Error('"' + relativeSource + '" is not in the SourceMap.');
    }
  };

/**
 * Returns the generated line and column information for the original source,
 * line, and column positions provided. The only argument is an object with
 * the following properties:
 *
 *   - source: The filename of the original source.
 *   - line: The line number in the original source.  The line number
 *     is 1-based.
 *   - column: The column number in the original source.  The column
 *     number is 0-based.
 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
 *
 * and an object is returned with the following properties:
 *
 *   - line: The line number in the generated source, or null.  The
 *     line number is 1-based.
 *   - column: The column number in the generated source, or null.
 *     The column number is 0-based.
 */
BasicSourceMapConsumer.prototype.generatedPositionFor =
  function SourceMapConsumer_generatedPositionFor(aArgs) {
    var source = util.getArg(aArgs, 'source');
    source = this._findSourceIndex(source);
    if (source < 0) {
      return {
        line: null,
        column: null,
        lastColumn: null
      };
    }

    var needle = {
      source: source,
      originalLine: util.getArg(aArgs, 'line'),
      originalColumn: util.getArg(aArgs, 'column')
    };

    var index = this._findMapping(
      needle,
      this._originalMappings,
      "originalLine",
      "originalColumn",
      util.compareByOriginalPositions,
      util.getArg(aArgs, 'bias', SourceMapConsumer.GREATEST_LOWER_BOUND)
    );

    if (index >= 0) {
      var mapping = this._originalMappings[index];

      if (mapping.source === needle.source) {
        return {
          line: util.getArg(mapping, 'generatedLine', null),
          column: util.getArg(mapping, 'generatedColumn', null),
          lastColumn: util.getArg(mapping, 'lastGeneratedColumn', null)
        };
      }
    }

    return {
      line: null,
      column: null,
      lastColumn: null
    };
  };

exports.BasicSourceMapConsumer = BasicSourceMapConsumer;

/**
 * An IndexedSourceMapConsumer instance represents a parsed source map which
 * we can query for information. It differs from BasicSourceMapConsumer in
 * that it takes "indexed" source maps (i.e. ones with a "sections" field) as
 * input.
 *
 * The first parameter is a raw source map (either as a JSON string, or already
 * parsed to an object). According to the spec for indexed source maps, they
 * have the following attributes:
 *
 *   - version: Which version of the source map spec this map is following.
 *   - file: Optional. The generated file this source map is associated with.
 *   - sections: A list of section definitions.
 *
 * Each value under the "sections" field has two fields:
 *   - offset: The offset into the original specified at which this section
 *       begins to apply, defined as an object with a "line" and "column"
 *       field.
 *   - map: A source map definition. This source map could also be indexed,
 *       but doesn't have to be.
 *
 * Instead of the "map" field, it's also possible to have a "url" field
 * specifying a URL to retrieve a source map from, but that's currently
 * unsupported.
 *
 * Here's an example source map, taken from the source map spec[0], but
 * modified to omit a section which uses the "url" field.
 *
 *  {
 *    version : 3,
 *    file: "app.js",
 *    sections: [{
 *      offset: {line:100, column:10},
 *      map: {
 *        version : 3,
 *        file: "section.js",
 *        sources: ["foo.js", "bar.js"],
 *        names: ["src", "maps", "are", "fun"],
 *        mappings: "AAAA,E;;ABCDE;"
 *      }
 *    }],
 *  }
 *
 * The second parameter, if given, is a string whose value is the URL
 * at which the source map was found.  This URL is used to compute the
 * sources array.
 *
 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit#heading=h.535es3xeprgt
 */
function IndexedSourceMapConsumer(aSourceMap, aSourceMapURL) {
  var sourceMap = aSourceMap;
  if (typeof aSourceMap === 'string') {
    sourceMap = util.parseSourceMapInput(aSourceMap);
  }

  var version = util.getArg(sourceMap, 'version');
  var sections = util.getArg(sourceMap, 'sections');

  if (version != this._version) {
    throw new Error('Unsupported version: ' + version);
  }

  this._sources = new ArraySet();
  this._names = new ArraySet();

  var lastOffset = {
    line: -1,
    column: 0
  };
  this._sections = sections.map(function (s) {
    if (s.url) {
      // The url field will require support for asynchronicity.
      // See https://github.com/mozilla/source-map/issues/16
      throw new Error('Support for url field in sections not implemented.');
    }
    var offset = util.getArg(s, 'offset');
    var offsetLine = util.getArg(offset, 'line');
    var offsetColumn = util.getArg(offset, 'column');

    if (offsetLine < lastOffset.line ||
        (offsetLine === lastOffset.line && offsetColumn < lastOffset.column)) {
      throw new Error('Section offsets must be ordered and non-overlapping.');
    }
    lastOffset = offset;

    return {
      generatedOffset: {
        // The offset fields are 0-based, but we use 1-based indices when
        // encoding/decoding from VLQ.
        generatedLine: offsetLine + 1,
        generatedColumn: offsetColumn + 1
      },
      consumer: new SourceMapConsumer(util.getArg(s, 'map'), aSourceMapURL)
    }
  });
}

IndexedSourceMapConsumer.prototype = Object.create(SourceMapConsumer.prototype);
IndexedSourceMapConsumer.prototype.constructor = SourceMapConsumer;

/**
 * The version of the source mapping spec that we are consuming.
 */
IndexedSourceMapConsumer.prototype._version = 3;

/**
 * The list of original sources.
 */
Object.defineProperty(IndexedSourceMapConsumer.prototype, 'sources', {
  get: function () {
    var sources = [];
    for (var i = 0; i < this._sections.length; i++) {
      for (var j = 0; j < this._sections[i].consumer.sources.length; j++) {
        sources.push(this._sections[i].consumer.sources[j]);
      }
    }
    return sources;
  }
});

/**
 * Returns the original source, line, and column information for the generated
 * source's line and column positions provided. The only argument is an object
 * with the following properties:
 *
 *   - line: The line number in the generated source.  The line number
 *     is 1-based.
 *   - column: The column number in the generated source.  The column
 *     number is 0-based.
 *
 * and an object is returned with the following properties:
 *
 *   - source: The original source file, or null.
 *   - line: The line number in the original source, or null.  The
 *     line number is 1-based.
 *   - column: The column number in the original source, or null.  The
 *     column number is 0-based.
 *   - name: The original identifier, or null.
 */
IndexedSourceMapConsumer.prototype.originalPositionFor =
  function IndexedSourceMapConsumer_originalPositionFor(aArgs) {
    var needle = {
      generatedLine: util.getArg(aArgs, 'line'),
      generatedColumn: util.getArg(aArgs, 'column')
    };

    // Find the section containing the generated position we're trying to map
    // to an original position.
    var sectionIndex = binarySearch.search(needle, this._sections,
      function(needle, section) {
        var cmp = needle.generatedLine - section.generatedOffset.generatedLine;
        if (cmp) {
          return cmp;
        }

        return (needle.generatedColumn -
                section.generatedOffset.generatedColumn);
      });
    var section = this._sections[sectionIndex];

    if (!section) {
      return {
        source: null,
        line: null,
        column: null,
        name: null
      };
    }

    return section.consumer.originalPositionFor({
      line: needle.generatedLine -
        (section.generatedOffset.generatedLine - 1),
      column: needle.generatedColumn -
        (section.generatedOffset.generatedLine === needle.generatedLine
         ? section.generatedOffset.generatedColumn - 1
         : 0),
      bias: aArgs.bias
    });
  };

/**
 * Return true if we have the source content for every source in the source
 * map, false otherwise.
 */
IndexedSourceMapConsumer.prototype.hasContentsOfAllSources =
  function IndexedSourceMapConsumer_hasContentsOfAllSources() {
    return this._sections.every(function (s) {
      return s.consumer.hasContentsOfAllSources();
    });
  };

/**
 * Returns the original source content. The only argument is the url of the
 * original source file. Returns null if no original source content is
 * available.
 */
IndexedSourceMapConsumer.prototype.sourceContentFor =
  function IndexedSourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
    for (var i = 0; i < this._sections.length; i++) {
      var section = this._sections[i];

      var content = section.consumer.sourceContentFor(aSource, true);
      if (content) {
        return content;
      }
    }
    if (nullOnMissing) {
      return null;
    }
    else {
      throw new Error('"' + aSource + '" is not in the SourceMap.');
    }
  };

/**
 * Returns the generated line and column information for the original source,
 * line, and column positions provided. The only argument is an object with
 * the following properties:
 *
 *   - source: The filename of the original source.
 *   - line: The line number in the original source.  The line number
 *     is 1-based.
 *   - column: The column number in the original source.  The column
 *     number is 0-based.
 *
 * and an object is returned with the following properties:
 *
 *   - line: The line number in the generated source, or null.  The
 *     line number is 1-based. 
 *   - column: The column number in the generated source, or null.
 *     The column number is 0-based.
 */
IndexedSourceMapConsumer.prototype.generatedPositionFor =
  function IndexedSourceMapConsumer_generatedPositionFor(aArgs) {
    for (var i = 0; i < this._sections.length; i++) {
      var section = this._sections[i];

      // Only consider this section if the requested source is in the list of
      // sources of the consumer.
      if (section.consumer._findSourceIndex(util.getArg(aArgs, 'source')) === -1) {
        continue;
      }
      var generatedPosition = section.consumer.generatedPositionFor(aArgs);
      if (generatedPosition) {
        var ret = {
          line: generatedPosition.line +
            (section.generatedOffset.generatedLine - 1),
          column: generatedPosition.column +
            (section.generatedOffset.generatedLine === generatedPosition.line
             ? section.generatedOffset.generatedColumn - 1
             : 0)
        };
        return ret;
      }
    }

    return {
      line: null,
      column: null
    };
  };

/**
 * Parse the mappings in a string in to a data structure which we can easily
 * query (the ordered arrays in the `this.__generatedMappings` and
 * `this.__originalMappings` properties).
 */
IndexedSourceMapConsumer.prototype._parseMappings =
  function IndexedSourceMapConsumer_parseMappings(aStr, aSourceRoot) {
    this.__generatedMappings = [];
    this.__originalMappings = [];
    for (var i = 0; i < this._sections.length; i++) {
      var section = this._sections[i];
      var sectionMappings = section.consumer._generatedMappings;
      for (var j = 0; j < sectionMappings.length; j++) {
        var mapping = sectionMappings[j];

        var source = section.consumer._sources.at(mapping.source);
        source = util.computeSourceURL(section.consumer.sourceRoot, source, this._sourceMapURL);
        this._sources.add(source);
        source = this._sources.indexOf(source);

        var name = null;
        if (mapping.name) {
          name = section.consumer._names.at(mapping.name);
          this._names.add(name);
          name = this._names.indexOf(name);
        }

        // The mappings coming from the consumer for the section have
        // generated positions relative to the start of the section, so we
        // need to offset them to be relative to the start of the concatenated
        // generated file.
        var adjustedMapping = {
          source: source,
          generatedLine: mapping.generatedLine +
            (section.generatedOffset.generatedLine - 1),
          generatedColumn: mapping.generatedColumn +
            (section.generatedOffset.generatedLine === mapping.generatedLine
            ? section.generatedOffset.generatedColumn - 1
            : 0),
          originalLine: mapping.originalLine,
          originalColumn: mapping.originalColumn,
          name: name
        };

        this.__generatedMappings.push(adjustedMapping);
        if (typeof adjustedMapping.originalLine === 'number') {
          this.__originalMappings.push(adjustedMapping);
        }
      }
    }

    quickSort(this.__generatedMappings, util.compareByGeneratedPositionsDeflated);
    quickSort(this.__originalMappings, util.compareByOriginalPositions);
  };

exports.IndexedSourceMapConsumer = IndexedSourceMapConsumer;

},{"./array-set":74,"./base64-vlq":75,"./binary-search":77,"./quick-sort":79,"./util":83}],81:[function(require,module,exports){
/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

var base64VLQ = require('./base64-vlq');
var util = require('./util');
var ArraySet = require('./array-set').ArraySet;
var MappingList = require('./mapping-list').MappingList;

/**
 * An instance of the SourceMapGenerator represents a source map which is
 * being built incrementally. You may pass an object with the following
 * properties:
 *
 *   - file: The filename of the generated source.
 *   - sourceRoot: A root for all relative URLs in this source map.
 */
function SourceMapGenerator(aArgs) {
  if (!aArgs) {
    aArgs = {};
  }
  this._file = util.getArg(aArgs, 'file', null);
  this._sourceRoot = util.getArg(aArgs, 'sourceRoot', null);
  this._skipValidation = util.getArg(aArgs, 'skipValidation', false);
  this._sources = new ArraySet();
  this._names = new ArraySet();
  this._mappings = new MappingList();
  this._sourcesContents = null;
}

SourceMapGenerator.prototype._version = 3;

/**
 * Creates a new SourceMapGenerator based on a SourceMapConsumer
 *
 * @param aSourceMapConsumer The SourceMap.
 */
SourceMapGenerator.fromSourceMap =
  function SourceMapGenerator_fromSourceMap(aSourceMapConsumer) {
    var sourceRoot = aSourceMapConsumer.sourceRoot;
    var generator = new SourceMapGenerator({
      file: aSourceMapConsumer.file,
      sourceRoot: sourceRoot
    });
    aSourceMapConsumer.eachMapping(function (mapping) {
      var newMapping = {
        generated: {
          line: mapping.generatedLine,
          column: mapping.generatedColumn
        }
      };

      if (mapping.source != null) {
        newMapping.source = mapping.source;
        if (sourceRoot != null) {
          newMapping.source = util.relative(sourceRoot, newMapping.source);
        }

        newMapping.original = {
          line: mapping.originalLine,
          column: mapping.originalColumn
        };

        if (mapping.name != null) {
          newMapping.name = mapping.name;
        }
      }

      generator.addMapping(newMapping);
    });
    aSourceMapConsumer.sources.forEach(function (sourceFile) {
      var sourceRelative = sourceFile;
      if (sourceRoot !== null) {
        sourceRelative = util.relative(sourceRoot, sourceFile);
      }

      if (!generator._sources.has(sourceRelative)) {
        generator._sources.add(sourceRelative);
      }

      var content = aSourceMapConsumer.sourceContentFor(sourceFile);
      if (content != null) {
        generator.setSourceContent(sourceFile, content);
      }
    });
    return generator;
  };

/**
 * Add a single mapping from original source line and column to the generated
 * source's line and column for this source map being created. The mapping
 * object should have the following properties:
 *
 *   - generated: An object with the generated line and column positions.
 *   - original: An object with the original line and column positions.
 *   - source: The original source file (relative to the sourceRoot).
 *   - name: An optional original token name for this mapping.
 */
SourceMapGenerator.prototype.addMapping =
  function SourceMapGenerator_addMapping(aArgs) {
    var generated = util.getArg(aArgs, 'generated');
    var original = util.getArg(aArgs, 'original', null);
    var source = util.getArg(aArgs, 'source', null);
    var name = util.getArg(aArgs, 'name', null);

    if (!this._skipValidation) {
      this._validateMapping(generated, original, source, name);
    }

    if (source != null) {
      source = String(source);
      if (!this._sources.has(source)) {
        this._sources.add(source);
      }
    }

    if (name != null) {
      name = String(name);
      if (!this._names.has(name)) {
        this._names.add(name);
      }
    }

    this._mappings.add({
      generatedLine: generated.line,
      generatedColumn: generated.column,
      originalLine: original != null && original.line,
      originalColumn: original != null && original.column,
      source: source,
      name: name
    });
  };

/**
 * Set the source content for a source file.
 */
SourceMapGenerator.prototype.setSourceContent =
  function SourceMapGenerator_setSourceContent(aSourceFile, aSourceContent) {
    var source = aSourceFile;
    if (this._sourceRoot != null) {
      source = util.relative(this._sourceRoot, source);
    }

    if (aSourceContent != null) {
      // Add the source content to the _sourcesContents map.
      // Create a new _sourcesContents map if the property is null.
      if (!this._sourcesContents) {
        this._sourcesContents = Object.create(null);
      }
      this._sourcesContents[util.toSetString(source)] = aSourceContent;
    } else if (this._sourcesContents) {
      // Remove the source file from the _sourcesContents map.
      // If the _sourcesContents map is empty, set the property to null.
      delete this._sourcesContents[util.toSetString(source)];
      if (Object.keys(this._sourcesContents).length === 0) {
        this._sourcesContents = null;
      }
    }
  };

/**
 * Applies the mappings of a sub-source-map for a specific source file to the
 * source map being generated. Each mapping to the supplied source file is
 * rewritten using the supplied source map. Note: The resolution for the
 * resulting mappings is the minimium of this map and the supplied map.
 *
 * @param aSourceMapConsumer The source map to be applied.
 * @param aSourceFile Optional. The filename of the source file.
 *        If omitted, SourceMapConsumer's file property will be used.
 * @param aSourceMapPath Optional. The dirname of the path to the source map
 *        to be applied. If relative, it is relative to the SourceMapConsumer.
 *        This parameter is needed when the two source maps aren't in the same
 *        directory, and the source map to be applied contains relative source
 *        paths. If so, those relative source paths need to be rewritten
 *        relative to the SourceMapGenerator.
 */
SourceMapGenerator.prototype.applySourceMap =
  function SourceMapGenerator_applySourceMap(aSourceMapConsumer, aSourceFile, aSourceMapPath) {
    var sourceFile = aSourceFile;
    // If aSourceFile is omitted, we will use the file property of the SourceMap
    if (aSourceFile == null) {
      if (aSourceMapConsumer.file == null) {
        throw new Error(
          'SourceMapGenerator.prototype.applySourceMap requires either an explicit source file, ' +
          'or the source map\'s "file" property. Both were omitted.'
        );
      }
      sourceFile = aSourceMapConsumer.file;
    }
    var sourceRoot = this._sourceRoot;
    // Make "sourceFile" relative if an absolute Url is passed.
    if (sourceRoot != null) {
      sourceFile = util.relative(sourceRoot, sourceFile);
    }
    // Applying the SourceMap can add and remove items from the sources and
    // the names array.
    var newSources = new ArraySet();
    var newNames = new ArraySet();

    // Find mappings for the "sourceFile"
    this._mappings.unsortedForEach(function (mapping) {
      if (mapping.source === sourceFile && mapping.originalLine != null) {
        // Check if it can be mapped by the source map, then update the mapping.
        var original = aSourceMapConsumer.originalPositionFor({
          line: mapping.originalLine,
          column: mapping.originalColumn
        });
        if (original.source != null) {
          // Copy mapping
          mapping.source = original.source;
          if (aSourceMapPath != null) {
            mapping.source = util.join(aSourceMapPath, mapping.source)
          }
          if (sourceRoot != null) {
            mapping.source = util.relative(sourceRoot, mapping.source);
          }
          mapping.originalLine = original.line;
          mapping.originalColumn = original.column;
          if (original.name != null) {
            mapping.name = original.name;
          }
        }
      }

      var source = mapping.source;
      if (source != null && !newSources.has(source)) {
        newSources.add(source);
      }

      var name = mapping.name;
      if (name != null && !newNames.has(name)) {
        newNames.add(name);
      }

    }, this);
    this._sources = newSources;
    this._names = newNames;

    // Copy sourcesContents of applied map.
    aSourceMapConsumer.sources.forEach(function (sourceFile) {
      var content = aSourceMapConsumer.sourceContentFor(sourceFile);
      if (content != null) {
        if (aSourceMapPath != null) {
          sourceFile = util.join(aSourceMapPath, sourceFile);
        }
        if (sourceRoot != null) {
          sourceFile = util.relative(sourceRoot, sourceFile);
        }
        this.setSourceContent(sourceFile, content);
      }
    }, this);
  };

/**
 * A mapping can have one of the three levels of data:
 *
 *   1. Just the generated position.
 *   2. The Generated position, original position, and original source.
 *   3. Generated and original position, original source, as well as a name
 *      token.
 *
 * To maintain consistency, we validate that any new mapping being added falls
 * in to one of these categories.
 */
SourceMapGenerator.prototype._validateMapping =
  function SourceMapGenerator_validateMapping(aGenerated, aOriginal, aSource,
                                              aName) {
    // When aOriginal is truthy but has empty values for .line and .column,
    // it is most likely a programmer error. In this case we throw a very
    // specific error message to try to guide them the right way.
    // For example: https://github.com/Polymer/polymer-bundler/pull/519
    if (aOriginal && typeof aOriginal.line !== 'number' && typeof aOriginal.column !== 'number') {
        throw new Error(
            'original.line and original.column are not numbers -- you probably meant to omit ' +
            'the original mapping entirely and only map the generated position. If so, pass ' +
            'null for the original mapping instead of an object with empty or null values.'
        );
    }

    if (aGenerated && 'line' in aGenerated && 'column' in aGenerated
        && aGenerated.line > 0 && aGenerated.column >= 0
        && !aOriginal && !aSource && !aName) {
      // Case 1.
      return;
    }
    else if (aGenerated && 'line' in aGenerated && 'column' in aGenerated
             && aOriginal && 'line' in aOriginal && 'column' in aOriginal
             && aGenerated.line > 0 && aGenerated.column >= 0
             && aOriginal.line > 0 && aOriginal.column >= 0
             && aSource) {
      // Cases 2 and 3.
      return;
    }
    else {
      throw new Error('Invalid mapping: ' + JSON.stringify({
        generated: aGenerated,
        source: aSource,
        original: aOriginal,
        name: aName
      }));
    }
  };

/**
 * Serialize the accumulated mappings in to the stream of base 64 VLQs
 * specified by the source map format.
 */
SourceMapGenerator.prototype._serializeMappings =
  function SourceMapGenerator_serializeMappings() {
    var previousGeneratedColumn = 0;
    var previousGeneratedLine = 1;
    var previousOriginalColumn = 0;
    var previousOriginalLine = 0;
    var previousName = 0;
    var previousSource = 0;
    var result = '';
    var next;
    var mapping;
    var nameIdx;
    var sourceIdx;

    var mappings = this._mappings.toArray();
    for (var i = 0, len = mappings.length; i < len; i++) {
      mapping = mappings[i];
      next = ''

      if (mapping.generatedLine !== previousGeneratedLine) {
        previousGeneratedColumn = 0;
        while (mapping.generatedLine !== previousGeneratedLine) {
          next += ';';
          previousGeneratedLine++;
        }
      }
      else {
        if (i > 0) {
          if (!util.compareByGeneratedPositionsInflated(mapping, mappings[i - 1])) {
            continue;
          }
          next += ',';
        }
      }

      next += base64VLQ.encode(mapping.generatedColumn
                                 - previousGeneratedColumn);
      previousGeneratedColumn = mapping.generatedColumn;

      if (mapping.source != null) {
        sourceIdx = this._sources.indexOf(mapping.source);
        next += base64VLQ.encode(sourceIdx - previousSource);
        previousSource = sourceIdx;

        // lines are stored 0-based in SourceMap spec version 3
        next += base64VLQ.encode(mapping.originalLine - 1
                                   - previousOriginalLine);
        previousOriginalLine = mapping.originalLine - 1;

        next += base64VLQ.encode(mapping.originalColumn
                                   - previousOriginalColumn);
        previousOriginalColumn = mapping.originalColumn;

        if (mapping.name != null) {
          nameIdx = this._names.indexOf(mapping.name);
          next += base64VLQ.encode(nameIdx - previousName);
          previousName = nameIdx;
        }
      }

      result += next;
    }

    return result;
  };

SourceMapGenerator.prototype._generateSourcesContent =
  function SourceMapGenerator_generateSourcesContent(aSources, aSourceRoot) {
    return aSources.map(function (source) {
      if (!this._sourcesContents) {
        return null;
      }
      if (aSourceRoot != null) {
        source = util.relative(aSourceRoot, source);
      }
      var key = util.toSetString(source);
      return Object.prototype.hasOwnProperty.call(this._sourcesContents, key)
        ? this._sourcesContents[key]
        : null;
    }, this);
  };

/**
 * Externalize the source map.
 */
SourceMapGenerator.prototype.toJSON =
  function SourceMapGenerator_toJSON() {
    var map = {
      version: this._version,
      sources: this._sources.toArray(),
      names: this._names.toArray(),
      mappings: this._serializeMappings()
    };
    if (this._file != null) {
      map.file = this._file;
    }
    if (this._sourceRoot != null) {
      map.sourceRoot = this._sourceRoot;
    }
    if (this._sourcesContents) {
      map.sourcesContent = this._generateSourcesContent(map.sources, map.sourceRoot);
    }

    return map;
  };

/**
 * Render the source map being generated to a string.
 */
SourceMapGenerator.prototype.toString =
  function SourceMapGenerator_toString() {
    return JSON.stringify(this.toJSON());
  };

exports.SourceMapGenerator = SourceMapGenerator;

},{"./array-set":74,"./base64-vlq":75,"./mapping-list":78,"./util":83}],82:[function(require,module,exports){
/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

var SourceMapGenerator = require('./source-map-generator').SourceMapGenerator;
var util = require('./util');

// Matches a Windows-style `\r\n` newline or a `\n` newline used by all other
// operating systems these days (capturing the result).
var REGEX_NEWLINE = /(\r?\n)/;

// Newline character code for charCodeAt() comparisons
var NEWLINE_CODE = 10;

// Private symbol for identifying `SourceNode`s when multiple versions of
// the source-map library are loaded. This MUST NOT CHANGE across
// versions!
var isSourceNode = "$$$isSourceNode$$$";

/**
 * SourceNodes provide a way to abstract over interpolating/concatenating
 * snippets of generated JavaScript source code while maintaining the line and
 * column information associated with the original source code.
 *
 * @param aLine The original line number.
 * @param aColumn The original column number.
 * @param aSource The original source's filename.
 * @param aChunks Optional. An array of strings which are snippets of
 *        generated JS, or other SourceNodes.
 * @param aName The original identifier.
 */
function SourceNode(aLine, aColumn, aSource, aChunks, aName) {
  this.children = [];
  this.sourceContents = {};
  this.line = aLine == null ? null : aLine;
  this.column = aColumn == null ? null : aColumn;
  this.source = aSource == null ? null : aSource;
  this.name = aName == null ? null : aName;
  this[isSourceNode] = true;
  if (aChunks != null) this.add(aChunks);
}

/**
 * Creates a SourceNode from generated code and a SourceMapConsumer.
 *
 * @param aGeneratedCode The generated code
 * @param aSourceMapConsumer The SourceMap for the generated code
 * @param aRelativePath Optional. The path that relative sources in the
 *        SourceMapConsumer should be relative to.
 */
SourceNode.fromStringWithSourceMap =
  function SourceNode_fromStringWithSourceMap(aGeneratedCode, aSourceMapConsumer, aRelativePath) {
    // The SourceNode we want to fill with the generated code
    // and the SourceMap
    var node = new SourceNode();

    // All even indices of this array are one line of the generated code,
    // while all odd indices are the newlines between two adjacent lines
    // (since `REGEX_NEWLINE` captures its match).
    // Processed fragments are accessed by calling `shiftNextLine`.
    var remainingLines = aGeneratedCode.split(REGEX_NEWLINE);
    var remainingLinesIndex = 0;
    var shiftNextLine = function() {
      var lineContents = getNextLine();
      // The last line of a file might not have a newline.
      var newLine = getNextLine() || "";
      return lineContents + newLine;

      function getNextLine() {
        return remainingLinesIndex < remainingLines.length ?
            remainingLines[remainingLinesIndex++] : undefined;
      }
    };

    // We need to remember the position of "remainingLines"
    var lastGeneratedLine = 1, lastGeneratedColumn = 0;

    // The generate SourceNodes we need a code range.
    // To extract it current and last mapping is used.
    // Here we store the last mapping.
    var lastMapping = null;

    aSourceMapConsumer.eachMapping(function (mapping) {
      if (lastMapping !== null) {
        // We add the code from "lastMapping" to "mapping":
        // First check if there is a new line in between.
        if (lastGeneratedLine < mapping.generatedLine) {
          // Associate first line with "lastMapping"
          addMappingWithCode(lastMapping, shiftNextLine());
          lastGeneratedLine++;
          lastGeneratedColumn = 0;
          // The remaining code is added without mapping
        } else {
          // There is no new line in between.
          // Associate the code between "lastGeneratedColumn" and
          // "mapping.generatedColumn" with "lastMapping"
          var nextLine = remainingLines[remainingLinesIndex] || '';
          var code = nextLine.substr(0, mapping.generatedColumn -
                                        lastGeneratedColumn);
          remainingLines[remainingLinesIndex] = nextLine.substr(mapping.generatedColumn -
                                              lastGeneratedColumn);
          lastGeneratedColumn = mapping.generatedColumn;
          addMappingWithCode(lastMapping, code);
          // No more remaining code, continue
          lastMapping = mapping;
          return;
        }
      }
      // We add the generated code until the first mapping
      // to the SourceNode without any mapping.
      // Each line is added as separate string.
      while (lastGeneratedLine < mapping.generatedLine) {
        node.add(shiftNextLine());
        lastGeneratedLine++;
      }
      if (lastGeneratedColumn < mapping.generatedColumn) {
        var nextLine = remainingLines[remainingLinesIndex] || '';
        node.add(nextLine.substr(0, mapping.generatedColumn));
        remainingLines[remainingLinesIndex] = nextLine.substr(mapping.generatedColumn);
        lastGeneratedColumn = mapping.generatedColumn;
      }
      lastMapping = mapping;
    }, this);
    // We have processed all mappings.
    if (remainingLinesIndex < remainingLines.length) {
      if (lastMapping) {
        // Associate the remaining code in the current line with "lastMapping"
        addMappingWithCode(lastMapping, shiftNextLine());
      }
      // and add the remaining lines without any mapping
      node.add(remainingLines.splice(remainingLinesIndex).join(""));
    }

    // Copy sourcesContent into SourceNode
    aSourceMapConsumer.sources.forEach(function (sourceFile) {
      var content = aSourceMapConsumer.sourceContentFor(sourceFile);
      if (content != null) {
        if (aRelativePath != null) {
          sourceFile = util.join(aRelativePath, sourceFile);
        }
        node.setSourceContent(sourceFile, content);
      }
    });

    return node;

    function addMappingWithCode(mapping, code) {
      if (mapping === null || mapping.source === undefined) {
        node.add(code);
      } else {
        var source = aRelativePath
          ? util.join(aRelativePath, mapping.source)
          : mapping.source;
        node.add(new SourceNode(mapping.originalLine,
                                mapping.originalColumn,
                                source,
                                code,
                                mapping.name));
      }
    }
  };

/**
 * Add a chunk of generated JS to this source node.
 *
 * @param aChunk A string snippet of generated JS code, another instance of
 *        SourceNode, or an array where each member is one of those things.
 */
SourceNode.prototype.add = function SourceNode_add(aChunk) {
  if (Array.isArray(aChunk)) {
    aChunk.forEach(function (chunk) {
      this.add(chunk);
    }, this);
  }
  else if (aChunk[isSourceNode] || typeof aChunk === "string") {
    if (aChunk) {
      this.children.push(aChunk);
    }
  }
  else {
    throw new TypeError(
      "Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + aChunk
    );
  }
  return this;
};

/**
 * Add a chunk of generated JS to the beginning of this source node.
 *
 * @param aChunk A string snippet of generated JS code, another instance of
 *        SourceNode, or an array where each member is one of those things.
 */
SourceNode.prototype.prepend = function SourceNode_prepend(aChunk) {
  if (Array.isArray(aChunk)) {
    for (var i = aChunk.length-1; i >= 0; i--) {
      this.prepend(aChunk[i]);
    }
  }
  else if (aChunk[isSourceNode] || typeof aChunk === "string") {
    this.children.unshift(aChunk);
  }
  else {
    throw new TypeError(
      "Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + aChunk
    );
  }
  return this;
};

/**
 * Walk over the tree of JS snippets in this node and its children. The
 * walking function is called once for each snippet of JS and is passed that
 * snippet and the its original associated source's line/column location.
 *
 * @param aFn The traversal function.
 */
SourceNode.prototype.walk = function SourceNode_walk(aFn) {
  var chunk;
  for (var i = 0, len = this.children.length; i < len; i++) {
    chunk = this.children[i];
    if (chunk[isSourceNode]) {
      chunk.walk(aFn);
    }
    else {
      if (chunk !== '') {
        aFn(chunk, { source: this.source,
                     line: this.line,
                     column: this.column,
                     name: this.name });
      }
    }
  }
};

/**
 * Like `String.prototype.join` except for SourceNodes. Inserts `aStr` between
 * each of `this.children`.
 *
 * @param aSep The separator.
 */
SourceNode.prototype.join = function SourceNode_join(aSep) {
  var newChildren;
  var i;
  var len = this.children.length;
  if (len > 0) {
    newChildren = [];
    for (i = 0; i < len-1; i++) {
      newChildren.push(this.children[i]);
      newChildren.push(aSep);
    }
    newChildren.push(this.children[i]);
    this.children = newChildren;
  }
  return this;
};

/**
 * Call String.prototype.replace on the very right-most source snippet. Useful
 * for trimming whitespace from the end of a source node, etc.
 *
 * @param aPattern The pattern to replace.
 * @param aReplacement The thing to replace the pattern with.
 */
SourceNode.prototype.replaceRight = function SourceNode_replaceRight(aPattern, aReplacement) {
  var lastChild = this.children[this.children.length - 1];
  if (lastChild[isSourceNode]) {
    lastChild.replaceRight(aPattern, aReplacement);
  }
  else if (typeof lastChild === 'string') {
    this.children[this.children.length - 1] = lastChild.replace(aPattern, aReplacement);
  }
  else {
    this.children.push(''.replace(aPattern, aReplacement));
  }
  return this;
};

/**
 * Set the source content for a source file. This will be added to the SourceMapGenerator
 * in the sourcesContent field.
 *
 * @param aSourceFile The filename of the source file
 * @param aSourceContent The content of the source file
 */
SourceNode.prototype.setSourceContent =
  function SourceNode_setSourceContent(aSourceFile, aSourceContent) {
    this.sourceContents[util.toSetString(aSourceFile)] = aSourceContent;
  };

/**
 * Walk over the tree of SourceNodes. The walking function is called for each
 * source file content and is passed the filename and source content.
 *
 * @param aFn The traversal function.
 */
SourceNode.prototype.walkSourceContents =
  function SourceNode_walkSourceContents(aFn) {
    for (var i = 0, len = this.children.length; i < len; i++) {
      if (this.children[i][isSourceNode]) {
        this.children[i].walkSourceContents(aFn);
      }
    }

    var sources = Object.keys(this.sourceContents);
    for (var i = 0, len = sources.length; i < len; i++) {
      aFn(util.fromSetString(sources[i]), this.sourceContents[sources[i]]);
    }
  };

/**
 * Return the string representation of this source node. Walks over the tree
 * and concatenates all the various snippets together to one string.
 */
SourceNode.prototype.toString = function SourceNode_toString() {
  var str = "";
  this.walk(function (chunk) {
    str += chunk;
  });
  return str;
};

/**
 * Returns the string representation of this source node along with a source
 * map.
 */
SourceNode.prototype.toStringWithSourceMap = function SourceNode_toStringWithSourceMap(aArgs) {
  var generated = {
    code: "",
    line: 1,
    column: 0
  };
  var map = new SourceMapGenerator(aArgs);
  var sourceMappingActive = false;
  var lastOriginalSource = null;
  var lastOriginalLine = null;
  var lastOriginalColumn = null;
  var lastOriginalName = null;
  this.walk(function (chunk, original) {
    generated.code += chunk;
    if (original.source !== null
        && original.line !== null
        && original.column !== null) {
      if(lastOriginalSource !== original.source
         || lastOriginalLine !== original.line
         || lastOriginalColumn !== original.column
         || lastOriginalName !== original.name) {
        map.addMapping({
          source: original.source,
          original: {
            line: original.line,
            column: original.column
          },
          generated: {
            line: generated.line,
            column: generated.column
          },
          name: original.name
        });
      }
      lastOriginalSource = original.source;
      lastOriginalLine = original.line;
      lastOriginalColumn = original.column;
      lastOriginalName = original.name;
      sourceMappingActive = true;
    } else if (sourceMappingActive) {
      map.addMapping({
        generated: {
          line: generated.line,
          column: generated.column
        }
      });
      lastOriginalSource = null;
      sourceMappingActive = false;
    }
    for (var idx = 0, length = chunk.length; idx < length; idx++) {
      if (chunk.charCodeAt(idx) === NEWLINE_CODE) {
        generated.line++;
        generated.column = 0;
        // Mappings end at eol
        if (idx + 1 === length) {
          lastOriginalSource = null;
          sourceMappingActive = false;
        } else if (sourceMappingActive) {
          map.addMapping({
            source: original.source,
            original: {
              line: original.line,
              column: original.column
            },
            generated: {
              line: generated.line,
              column: generated.column
            },
            name: original.name
          });
        }
      } else {
        generated.column++;
      }
    }
  });
  this.walkSourceContents(function (sourceFile, sourceContent) {
    map.setSourceContent(sourceFile, sourceContent);
  });

  return { code: generated.code, map: map };
};

exports.SourceNode = SourceNode;

},{"./source-map-generator":81,"./util":83}],83:[function(require,module,exports){
/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

/**
 * This is a helper function for getting values from parameter/options
 * objects.
 *
 * @param args The object we are extracting values from
 * @param name The name of the property we are getting.
 * @param defaultValue An optional value to return if the property is missing
 * from the object. If this is not specified and the property is missing, an
 * error will be thrown.
 */
function getArg(aArgs, aName, aDefaultValue) {
  if (aName in aArgs) {
    return aArgs[aName];
  } else if (arguments.length === 3) {
    return aDefaultValue;
  } else {
    throw new Error('"' + aName + '" is a required argument.');
  }
}
exports.getArg = getArg;

var urlRegexp = /^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.-]*)(?::(\d+))?(.*)$/;
var dataUrlRegexp = /^data:.+\,.+$/;

function urlParse(aUrl) {
  var match = aUrl.match(urlRegexp);
  if (!match) {
    return null;
  }
  return {
    scheme: match[1],
    auth: match[2],
    host: match[3],
    port: match[4],
    path: match[5]
  };
}
exports.urlParse = urlParse;

function urlGenerate(aParsedUrl) {
  var url = '';
  if (aParsedUrl.scheme) {
    url += aParsedUrl.scheme + ':';
  }
  url += '//';
  if (aParsedUrl.auth) {
    url += aParsedUrl.auth + '@';
  }
  if (aParsedUrl.host) {
    url += aParsedUrl.host;
  }
  if (aParsedUrl.port) {
    url += ":" + aParsedUrl.port
  }
  if (aParsedUrl.path) {
    url += aParsedUrl.path;
  }
  return url;
}
exports.urlGenerate = urlGenerate;

/**
 * Normalizes a path, or the path portion of a URL:
 *
 * - Replaces consecutive slashes with one slash.
 * - Removes unnecessary '.' parts.
 * - Removes unnecessary '<dir>/..' parts.
 *
 * Based on code in the Node.js 'path' core module.
 *
 * @param aPath The path or url to normalize.
 */
function normalize(aPath) {
  var path = aPath;
  var url = urlParse(aPath);
  if (url) {
    if (!url.path) {
      return aPath;
    }
    path = url.path;
  }
  var isAbsolute = exports.isAbsolute(path);

  var parts = path.split(/\/+/);
  for (var part, up = 0, i = parts.length - 1; i >= 0; i--) {
    part = parts[i];
    if (part === '.') {
      parts.splice(i, 1);
    } else if (part === '..') {
      up++;
    } else if (up > 0) {
      if (part === '') {
        // The first part is blank if the path is absolute. Trying to go
        // above the root is a no-op. Therefore we can remove all '..' parts
        // directly after the root.
        parts.splice(i + 1, up);
        up = 0;
      } else {
        parts.splice(i, 2);
        up--;
      }
    }
  }
  path = parts.join('/');

  if (path === '') {
    path = isAbsolute ? '/' : '.';
  }

  if (url) {
    url.path = path;
    return urlGenerate(url);
  }
  return path;
}
exports.normalize = normalize;

/**
 * Joins two paths/URLs.
 *
 * @param aRoot The root path or URL.
 * @param aPath The path or URL to be joined with the root.
 *
 * - If aPath is a URL or a data URI, aPath is returned, unless aPath is a
 *   scheme-relative URL: Then the scheme of aRoot, if any, is prepended
 *   first.
 * - Otherwise aPath is a path. If aRoot is a URL, then its path portion
 *   is updated with the result and aRoot is returned. Otherwise the result
 *   is returned.
 *   - If aPath is absolute, the result is aPath.
 *   - Otherwise the two paths are joined with a slash.
 * - Joining for example 'http://' and 'www.example.com' is also supported.
 */
function join(aRoot, aPath) {
  if (aRoot === "") {
    aRoot = ".";
  }
  if (aPath === "") {
    aPath = ".";
  }
  var aPathUrl = urlParse(aPath);
  var aRootUrl = urlParse(aRoot);
  if (aRootUrl) {
    aRoot = aRootUrl.path || '/';
  }

  // `join(foo, '//www.example.org')`
  if (aPathUrl && !aPathUrl.scheme) {
    if (aRootUrl) {
      aPathUrl.scheme = aRootUrl.scheme;
    }
    return urlGenerate(aPathUrl);
  }

  if (aPathUrl || aPath.match(dataUrlRegexp)) {
    return aPath;
  }

  // `join('http://', 'www.example.com')`
  if (aRootUrl && !aRootUrl.host && !aRootUrl.path) {
    aRootUrl.host = aPath;
    return urlGenerate(aRootUrl);
  }

  var joined = aPath.charAt(0) === '/'
    ? aPath
    : normalize(aRoot.replace(/\/+$/, '') + '/' + aPath);

  if (aRootUrl) {
    aRootUrl.path = joined;
    return urlGenerate(aRootUrl);
  }
  return joined;
}
exports.join = join;

exports.isAbsolute = function (aPath) {
  return aPath.charAt(0) === '/' || urlRegexp.test(aPath);
};

/**
 * Make a path relative to a URL or another path.
 *
 * @param aRoot The root path or URL.
 * @param aPath The path or URL to be made relative to aRoot.
 */
function relative(aRoot, aPath) {
  if (aRoot === "") {
    aRoot = ".";
  }

  aRoot = aRoot.replace(/\/$/, '');

  // It is possible for the path to be above the root. In this case, simply
  // checking whether the root is a prefix of the path won't work. Instead, we
  // need to remove components from the root one by one, until either we find
  // a prefix that fits, or we run out of components to remove.
  var level = 0;
  while (aPath.indexOf(aRoot + '/') !== 0) {
    var index = aRoot.lastIndexOf("/");
    if (index < 0) {
      return aPath;
    }

    // If the only part of the root that is left is the scheme (i.e. http://,
    // file:///, etc.), one or more slashes (/), or simply nothing at all, we
    // have exhausted all components, so the path is not relative to the root.
    aRoot = aRoot.slice(0, index);
    if (aRoot.match(/^([^\/]+:\/)?\/*$/)) {
      return aPath;
    }

    ++level;
  }

  // Make sure we add a "../" for each component we removed from the root.
  return Array(level + 1).join("../") + aPath.substr(aRoot.length + 1);
}
exports.relative = relative;

var supportsNullProto = (function () {
  var obj = Object.create(null);
  return !('__proto__' in obj);
}());

function identity (s) {
  return s;
}

/**
 * Because behavior goes wacky when you set `__proto__` on objects, we
 * have to prefix all the strings in our set with an arbitrary character.
 *
 * See https://github.com/mozilla/source-map/pull/31 and
 * https://github.com/mozilla/source-map/issues/30
 *
 * @param String aStr
 */
function toSetString(aStr) {
  if (isProtoString(aStr)) {
    return '$' + aStr;
  }

  return aStr;
}
exports.toSetString = supportsNullProto ? identity : toSetString;

function fromSetString(aStr) {
  if (isProtoString(aStr)) {
    return aStr.slice(1);
  }

  return aStr;
}
exports.fromSetString = supportsNullProto ? identity : fromSetString;

function isProtoString(s) {
  if (!s) {
    return false;
  }

  var length = s.length;

  if (length < 9 /* "__proto__".length */) {
    return false;
  }

  if (s.charCodeAt(length - 1) !== 95  /* '_' */ ||
      s.charCodeAt(length - 2) !== 95  /* '_' */ ||
      s.charCodeAt(length - 3) !== 111 /* 'o' */ ||
      s.charCodeAt(length - 4) !== 116 /* 't' */ ||
      s.charCodeAt(length - 5) !== 111 /* 'o' */ ||
      s.charCodeAt(length - 6) !== 114 /* 'r' */ ||
      s.charCodeAt(length - 7) !== 112 /* 'p' */ ||
      s.charCodeAt(length - 8) !== 95  /* '_' */ ||
      s.charCodeAt(length - 9) !== 95  /* '_' */) {
    return false;
  }

  for (var i = length - 10; i >= 0; i--) {
    if (s.charCodeAt(i) !== 36 /* '$' */) {
      return false;
    }
  }

  return true;
}

/**
 * Comparator between two mappings where the original positions are compared.
 *
 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
 * mappings with the same original source/line/column, but different generated
 * line and column the same. Useful when searching for a mapping with a
 * stubbed out mapping.
 */
function compareByOriginalPositions(mappingA, mappingB, onlyCompareOriginal) {
  var cmp = strcmp(mappingA.source, mappingB.source);
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.originalLine - mappingB.originalLine;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.originalColumn - mappingB.originalColumn;
  if (cmp !== 0 || onlyCompareOriginal) {
    return cmp;
  }

  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.generatedLine - mappingB.generatedLine;
  if (cmp !== 0) {
    return cmp;
  }

  return strcmp(mappingA.name, mappingB.name);
}
exports.compareByOriginalPositions = compareByOriginalPositions;

/**
 * Comparator between two mappings with deflated source and name indices where
 * the generated positions are compared.
 *
 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
 * mappings with the same generated line and column, but different
 * source/name/original line and column the same. Useful when searching for a
 * mapping with a stubbed out mapping.
 */
function compareByGeneratedPositionsDeflated(mappingA, mappingB, onlyCompareGenerated) {
  var cmp = mappingA.generatedLine - mappingB.generatedLine;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
  if (cmp !== 0 || onlyCompareGenerated) {
    return cmp;
  }

  cmp = strcmp(mappingA.source, mappingB.source);
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.originalLine - mappingB.originalLine;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.originalColumn - mappingB.originalColumn;
  if (cmp !== 0) {
    return cmp;
  }

  return strcmp(mappingA.name, mappingB.name);
}
exports.compareByGeneratedPositionsDeflated = compareByGeneratedPositionsDeflated;

function strcmp(aStr1, aStr2) {
  if (aStr1 === aStr2) {
    return 0;
  }

  if (aStr1 === null) {
    return 1; // aStr2 !== null
  }

  if (aStr2 === null) {
    return -1; // aStr1 !== null
  }

  if (aStr1 > aStr2) {
    return 1;
  }

  return -1;
}

/**
 * Comparator between two mappings with inflated source and name strings where
 * the generated positions are compared.
 */
function compareByGeneratedPositionsInflated(mappingA, mappingB) {
  var cmp = mappingA.generatedLine - mappingB.generatedLine;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = strcmp(mappingA.source, mappingB.source);
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.originalLine - mappingB.originalLine;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.originalColumn - mappingB.originalColumn;
  if (cmp !== 0) {
    return cmp;
  }

  return strcmp(mappingA.name, mappingB.name);
}
exports.compareByGeneratedPositionsInflated = compareByGeneratedPositionsInflated;

/**
 * Strip any JSON XSSI avoidance prefix from the string (as documented
 * in the source maps specification), and then parse the string as
 * JSON.
 */
function parseSourceMapInput(str) {
  return JSON.parse(str.replace(/^\)]}'[^\n]*\n/, ''));
}
exports.parseSourceMapInput = parseSourceMapInput;

/**
 * Compute the URL of a source given the the source root, the source's
 * URL, and the source map's URL.
 */
function computeSourceURL(sourceRoot, sourceURL, sourceMapURL) {
  sourceURL = sourceURL || '';

  if (sourceRoot) {
    // This follows what Chrome does.
    if (sourceRoot[sourceRoot.length - 1] !== '/' && sourceURL[0] !== '/') {
      sourceRoot += '/';
    }
    // The spec says:
    //   Line 4: An optional source root, useful for relocating source
    //   files on a server or removing repeated values in the
    //   “sources” entry.  This value is prepended to the individual
    //   entries in the “source” field.
    sourceURL = sourceRoot + sourceURL;
  }

  // Historically, SourceMapConsumer did not take the sourceMapURL as
  // a parameter.  This mode is still somewhat supported, which is why
  // this code block is conditional.  However, it's preferable to pass
  // the source map URL to SourceMapConsumer, so that this function
  // can implement the source URL resolution algorithm as outlined in
  // the spec.  This block is basically the equivalent of:
  //    new URL(sourceURL, sourceMapURL).toString()
  // ... except it avoids using URL, which wasn't available in the
  // older releases of node still supported by this library.
  //
  // The spec says:
  //   If the sources are not absolute URLs after prepending of the
  //   “sourceRoot”, the sources are resolved relative to the
  //   SourceMap (like resolving script src in a html document).
  if (sourceMapURL) {
    var parsed = urlParse(sourceMapURL);
    if (!parsed) {
      throw new Error("sourceMapURL could not be parsed");
    }
    if (parsed.path) {
      // Strip the last path component, but keep the "/".
      var index = parsed.path.lastIndexOf('/');
      if (index >= 0) {
        parsed.path = parsed.path.substring(0, index + 1);
      }
    }
    sourceURL = join(urlGenerate(parsed), sourceURL);
  }

  return normalize(sourceURL);
}
exports.computeSourceURL = computeSourceURL;

},{}],84:[function(require,module,exports){
/*
 * Copyright 2009-2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE.txt or:
 * http://opensource.org/licenses/BSD-3-Clause
 */
exports.SourceMapGenerator = require('./lib/source-map-generator').SourceMapGenerator;
exports.SourceMapConsumer = require('./lib/source-map-consumer').SourceMapConsumer;
exports.SourceNode = require('./lib/source-node').SourceNode;

},{"./lib/source-map-consumer":80,"./lib/source-map-generator":81,"./lib/source-node":82}],85:[function(require,module,exports){
'use strict';
var numberIsNan = require('number-is-nan');
var arrayUniq = require('array-uniq');
var reInt = /^\d+$/;

function deepUnique(arr) {
	return arr.sort().filter(function (el, i) {
		return JSON.stringify(el) !== JSON.stringify(arr[i - 1]);
	});
}

exports.parse = function (str) {
	return deepUnique(str.split(',').map(function (el) {
		var ret = {};

		el.trim().split(/\s+/).forEach(function (el, i) {
			if (i === 0) {
				return ret.url = el;
			}

			var value = el.substring(0, el.length - 1);
			var postfix = el[el.length - 1];
			var intVal = parseInt(value, 10);
			var floatVal = parseFloat(value);

			if (postfix === 'w' && reInt.test(value)) {
				ret.width = intVal;
			} else if (postfix === 'h' && reInt.test(value)) {
				ret.height = intVal;
			} else if (postfix === 'x' && !numberIsNan(floatVal)) {
				ret.density = floatVal;
			} else {
				throw new Error('Invalid srcset descriptor: ' + el + '.');
			}
		});

		return ret;
	}));
}

exports.stringify = function (arr) {
	return arrayUniq(arr.map(function (el) {
		if (!el.url) {
			throw new Error('URL is required.');
		}

		var ret = [el.url];

		if (el.width) {
			ret.push(el.width + 'w');
		}

		if (el.height) {
			ret.push(el.height + 'h');
		}

		if (el.density) {
			ret.push(el.density + 'x');
		}

		return ret.join(' ');
	})).join(', ');
}

},{"array-uniq":2,"number-is-nan":42}],86:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

/*<replacement>*/

var Buffer = require('safe-buffer').Buffer;
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}
},{"safe-buffer":73}],87:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

var punycode = require('punycode');
var util = require('./util');

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,

    // Special case for a simple path URL
    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

    // RFC 2396: characters not allowed for various reasons.
    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = ['\''].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    unsafeProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that never have a hostname.
    hostlessProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
      'http': true,
      'https': true,
      'ftp': true,
      'gopher': true,
      'file': true,
      'http:': true,
      'https:': true,
      'ftp:': true,
      'gopher:': true,
      'file:': true
    },
    querystring = require('querystring');

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;

  var u = new Url;
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
      splitter =
          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
      uSplit = url.split(splitter),
      slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] &&
      (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1)
      hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' &&
        this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1)
        continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }


  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] &&
      this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function() {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ?
        this.hostname :
        '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query &&
      util.isObject(this.query) &&
      Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes ||
      (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function(match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function(relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function(relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol')
        result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] &&
        result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift()));
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
      isRelAbs = (
          relative.host ||
          relative.pathname && relative.pathname.charAt(0) === '/'
      ),
      mustEndAbs = (isRelAbs || isSourceAbs ||
                    (result.host && relative.pathname)),
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;
      else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;
        else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = (relative.host || relative.host === '') ?
                  relative.host : result.host;
    result.hostname = (relative.hostname || relative.hostname === '') ?
                      relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ?
                       result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') +
                    (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (
      (result.host || relative.host || srcPath.length > 1) &&
      (last === '.' || last === '..') || last === '');

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' &&
      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' ||
      (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' :
                                    srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ?
                     result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') +
                  (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function() {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};

},{"./util":88,"punycode":69,"querystring":72}],88:[function(require,module,exports){
'use strict';

module.exports = {
  isString: function(arg) {
    return typeof(arg) === 'string';
  },
  isObject: function(arg) {
    return typeof(arg) === 'object' && arg !== null;
  },
  isNull: function(arg) {
    return arg === null;
  },
  isNullOrUndefined: function(arg) {
    return arg == null;
  }
};

},{}],89:[function(require,module,exports){
module.exports = extend

var hasOwnProperty = Object.prototype.hasOwnProperty;

function extend() {
    var target = {}

    for (var i = 0; i < arguments.length; i++) {
        var source = arguments[i]

        for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
                target[key] = source[key]
            }
        }
    }

    return target
}

},{}]},{},[1])(1)
});
/*!
 * jQuery JavaScript Library v3.1.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2016-09-22T22:30Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var document = window.document;

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};



	function DOMEval( code, doc ) {
		doc = doc || document;

		var script = doc.createElement( "script" );

		script.text = code;
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.1.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,

	// Matches dashed string for camelizing
	rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g,

	// Used by jQuery.camelCase as callback to replace()
	fcamelCase = function( all, letter ) {
		return letter.toUpperCase();
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = jQuery.isArray( copy ) ) ) ) {

					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && jQuery.isArray( src ) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject( src ) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isFunction: function( obj ) {
		return jQuery.type( obj ) === "function";
	},

	isArray: Array.isArray,

	isWindow: function( obj ) {
		return obj != null && obj === obj.window;
	},

	isNumeric: function( obj ) {

		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&

			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {

		/* eslint-disable no-unused-vars */
		// See https://github.com/eslint/eslint/issues/6125
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	type: function( obj ) {
		if ( obj == null ) {
			return obj + "";
		}

		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		DOMEval( code );
	},

	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 13
	// Microsoft forgot to hump their vendor prefix (#9572)
	camelCase: function( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	},

	nodeName: function( elem, name ) {
		return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// Bind a function to a context, optionally partially applying any
	// arguments.
	proxy: function( fn, context ) {
		var tmp, args, proxy;

		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}

		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !jQuery.isFunction( fn ) ) {
			return undefined;
		}

		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};

		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;

		return proxy;
	},

	now: Date.now,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = jQuery.type( obj );

	if ( type === "function" || jQuery.isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.3
 * https://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-08-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	disabledAncestor = addCombinator(
		function( elem ) {
			return elem.disabled === true && ("form" in elem || "label" in elem);
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						disabledAncestor( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;

var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



var risSimple = /^.[^:#\[\.,]*$/;

// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( jQuery.isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Simple selector that can be filtered directly, removing non-Elements
	if ( risSimple.test( qualifier ) ) {
		return jQuery.filter( qualifier, elements, not );
	}

	// Complex selector, compare the two sets, removing non-Elements
	qualifier = jQuery.filter( qualifier, elements );
	return jQuery.grep( elements, function( elem ) {
		return ( indexOf.call( qualifier, elem ) > -1 ) !== not && elem.nodeType === 1;
	} );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( jQuery.isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( jQuery.isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		return elem.contentDocument || jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( jQuery.isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && jQuery.isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && jQuery.isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			resolve.call( undefined, value );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.call( undefined, value );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = jQuery.isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && jQuery.isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( jQuery.isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				jQuery.isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Hold (or release) the ready event
	holdReady: function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	},

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( jQuery.type( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !jQuery.isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ jQuery.camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ jQuery.camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ jQuery.camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( jQuery.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( jQuery.camelCase );
			} else {
				key = jQuery.camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = jQuery.camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || jQuery.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			jQuery.contains( elem.ownerDocument, elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};




function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted,
		scale = 1,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		do {

			// If previous iteration zeroed out, double until we get *something*.
			// Use string for doubling so we don't accidentally see scale as unchanged below
			scale = scale || ".5";

			// Adjust and apply
			initialInUnit = initialInUnit / scale;
			jQuery.style( elem, prop, initialInUnit + unit );

		// Update scale, tolerating zero or NaN from tween.cur()
		// Break the loop if scale is unchanged or perfect, or if we've just had enough.
		} while (
			scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
		);
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );

var rscriptType = ( /^$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && jQuery.nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, contains, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( jQuery.type( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		contains = jQuery.contains( elem.ownerDocument, elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( contains ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();
var documentElement = document.documentElement;



var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 only
// See #13393 for more info
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: jQuery.isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {

			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {

			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && jQuery.nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return jQuery.nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || jQuery.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rscriptTypeMasked = /^true\/(.*)/,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

function manipulationTarget( elem, content ) {
	if ( jQuery.nodeName( elem, "table" ) &&
		jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return elem.getElementsByTagName( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	var match = rscriptTypeMasked.exec( elem.type );

	if ( match ) {
		elem.type = match[ 1 ];
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		isFunction = jQuery.isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( isFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( isFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl ) {
								jQuery._evalUrl( node.src );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rmargin = ( /^margin/ );

var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		div.style.cssText =
			"box-sizing:border-box;" +
			"position:relative;display:block;" +
			"margin:auto;border:1px;padding:1px;" +
			"top:1%;width:50%";
		div.innerHTML = "";
		documentElement.appendChild( container );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = divStyle.marginLeft === "2px";
		boxSizingReliableVal = divStyle.width === "4px";

		// Support: Android 4.0 - 4.3 only
		// Some styles come back with percentage values, even though they shouldn't
		div.style.marginRight = "50%";
		pixelMarginRightVal = divStyle.marginRight === "4px";

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
		"padding:0;margin-top:1px;position:absolute";
	container.appendChild( div );

	jQuery.extend( support, {
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelMarginRight: function() {
			computeStyleTests();
			return pixelMarginRightVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,
		style = elem.style;

	computed = computed || getStyles( elem );

	// Support: IE <=9 only
	// getPropertyValue is only needed for .css('filter') (#12537)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style;

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in emptyStyle ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
	var i,
		val = 0;

	// If we already have the right measurement, avoid augmentation
	if ( extra === ( isBorderBox ? "border" : "content" ) ) {
		i = 4;

	// Otherwise initialize for horizontal or vertical properties
	} else {
		i = name === "width" ? 1 : 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin, so add it if we want it
		if ( extra === "margin" ) {
			val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
		}

		if ( isBorderBox ) {

			// border-box includes padding, so remove it if we want content
			if ( extra === "content" ) {
				val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// At this point, extra isn't border nor margin, so remove border
			if ( extra !== "margin" ) {
				val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		} else {

			// At this point, extra isn't content, so add padding
			val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// At this point, extra isn't content nor padding, so add border
			if ( extra !== "padding" ) {
				val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	return val;
}

function getWidthOrHeight( elem, name, extra ) {

	// Start with offset property, which is equivalent to the border-box value
	var val,
		valueIsBorderBox = true,
		styles = getStyles( elem ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

	// Support: IE <=11 only
	// Running getBoundingClientRect on a disconnected node
	// in IE throws an error.
	if ( elem.getClientRects().length ) {
		val = elem.getBoundingClientRect()[ name ];
	}

	// Some non-html elements return undefined for offsetWidth, so check for null/undefined
	// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
	// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
	if ( val <= 0 || val == null ) {

		// Fall back to computed then uncomputed css if necessary
		val = curCSS( elem, name, styles );
		if ( val < 0 || val == null ) {
			val = elem.style[ name ];
		}

		// Computed unit is not pixels. Stop here and return.
		if ( rnumnonpx.test( val ) ) {
			return val;
		}

		// Check for style in case a browser which returns unreliable values
		// for getComputedStyle silently falls back to the reliable elem.style
		valueIsBorderBox = isBorderBox &&
			( support.boxSizingReliable() || val === elem.style[ name ] );

		// Normalize "", auto, and prepare for extra
		val = parseFloat( val ) || 0;
	}

	// Use the active box-sizing model to add/subtract irrelevant styles
	return ( val +
		augmentWidthOrHeight(
			elem,
			name,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {
		"float": "cssFloat"
	},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = jQuery.camelCase( name ),
			style = elem.style;

		name = jQuery.cssProps[ origName ] ||
			( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				style[ name ] = value;
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = jQuery.camelCase( name );

		// Make sure that we're working with the right name
		name = jQuery.cssProps[ origName ] ||
			( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}
		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, name ) {
	jQuery.cssHooks[ name ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, name, extra );
						} ) :
						getWidthOrHeight( elem, name, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = extra && getStyles( elem ),
				subtract = extra && augmentWidthOrHeight(
					elem,
					name,
					extra,
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					styles
				);

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ name ] = value;
				value = jQuery.css( elem, name );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( !rmargin.test( prefix ) ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( jQuery.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 &&
				( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
					jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, timerId,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function raf() {
	if ( timerId ) {
		window.requestAnimationFrame( raf );
		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = jQuery.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 13
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = jQuery.camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( jQuery.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			if ( percent < 1 && length ) {
				return remaining;
			} else {
				deferred.resolveWith( elem, [ animation ] );
				return false;
			}
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( jQuery.isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					jQuery.proxy( result.stop, result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( jQuery.isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	// attach callbacks from options
	return animation.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( jQuery.isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			jQuery.isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
	};

	// Go to the end state if fx are off or if document is hidden
	if ( jQuery.fx.off || document.hidden ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( jQuery.isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = jQuery.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Checks the timer has not already been removed
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	if ( timer() ) {
		jQuery.fx.start();
	} else {
		jQuery.timers.pop();
	}
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( !timerId ) {
		timerId = window.requestAnimationFrame ?
			window.requestAnimationFrame( raf ) :
			window.setInterval( jQuery.fx.tick, jQuery.fx.interval );
	}
};

jQuery.fx.stop = function() {
	if ( window.cancelAnimationFrame ) {
		window.cancelAnimationFrame( timerId );
	} else {
		window.clearInterval( timerId );
	}

	timerId = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					jQuery.nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://html.spec.whatwg.org/multipage/infrastructure.html#strip-and-collapse-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnothtmlwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnothtmlwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value;

		if ( typeof stateVal === "boolean" && type === "string" ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( type === "string" ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = value.match( rnothtmlwhite ) || [];

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, isFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		isFunction = jQuery.isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( isFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( jQuery.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( jQuery.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {

			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;
					elem[ type ]();
					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




support.focusin = "onfocusin" in window;


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = jQuery.now();

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( jQuery.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && jQuery.type( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = jQuery.isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	// If an array was passed in, assume that it is an array of form elements.
	if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( jQuery.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( jQuery.isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 13
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available, append data to url
			if ( s.data ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( jQuery.isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,
		"throws": true
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( jQuery.isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( jQuery.isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var isFunction = jQuery.isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" ).prop( {
					charset: s.scriptCharset,
					src: s.url
				} ).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && jQuery.isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( jQuery.isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




/**
 * Gets a window from an element
 */
function getWindow( elem ) {
	return jQuery.isWindow( elem ) ? elem : elem.nodeType === 9 && elem.defaultView;
}

jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( jQuery.isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var docElem, win, rect, doc,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		rect = elem.getBoundingClientRect();

		// Make sure element is not hidden (display: none)
		if ( rect.width || rect.height ) {
			doc = elem.ownerDocument;
			win = getWindow( doc );
			docElem = doc.documentElement;

			return {
				top: rect.top + win.pageYOffset - docElem.clientTop,
				left: rect.left + win.pageXOffset - docElem.clientLeft
			};
		}

		// Return zeros for disconnected and hidden elements (gh-2310)
		return rect;
	},

	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
		// because it is its only offset parent
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume getBoundingClientRect is there when computed position is fixed
			offset = elem.getBoundingClientRect();

		} else {

			// Get *real* offsetParent
			offsetParent = this.offsetParent();

			// Get correct offsets
			offset = this.offset();
			if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
				parentOffset = offsetParent.offset();
			}

			// Add offsetParent borders
			parentOffset = {
				top: parentOffset.top + jQuery.css( offsetParent[ 0 ], "borderTopWidth", true ),
				left: parentOffset.left + jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true )
			};
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {
			var win = getWindow( elem );

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( jQuery.isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

jQuery.parseJSON = JSON.parse;




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( typeof define === "function" && define.amd ) {
	define( "jquery", [], function() {
		return jQuery;
	} );
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}





return jQuery;
} );

/*!
 * jQuery Mousewheel 3.1.13
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 */

(function (factory) {
    if ( typeof define === 'function' && define.amd ) {
        // AMD. Register as an anonymous module.
        define(['jquery'], factory);
    } else if (typeof exports === 'object') {
        // Node/CommonJS style for Browserify
        module.exports = factory;
    } else {
        // Browser globals
        factory(jQuery);
    }
}(function ($) {

    var toFix  = ['wheel', 'mousewheel', 'DOMMouseScroll', 'MozMousePixelScroll'],
        toBind = ( 'onwheel' in document || document.documentMode >= 9 ) ?
                    ['wheel'] : ['mousewheel', 'DomMouseScroll', 'MozMousePixelScroll'],
        slice  = Array.prototype.slice,
        nullLowestDeltaTimeout, lowestDelta;

    if ( $.event.fixHooks ) {
        for ( var i = toFix.length; i; ) {
            $.event.fixHooks[ toFix[--i] ] = $.event.mouseHooks;
        }
    }

    var special = $.event.special.mousewheel = {
        version: '3.1.12',

        setup: function() {
            if ( this.addEventListener ) {
                for ( var i = toBind.length; i; ) {
                    this.addEventListener( toBind[--i], handler, false );
                }
            } else {
                this.onmousewheel = handler;
            }
            // Store the line height and page height for this particular element
            $.data(this, 'mousewheel-line-height', special.getLineHeight(this));
            $.data(this, 'mousewheel-page-height', special.getPageHeight(this));
        },

        teardown: function() {
            if ( this.removeEventListener ) {
                for ( var i = toBind.length; i; ) {
                    this.removeEventListener( toBind[--i], handler, false );
                }
            } else {
                this.onmousewheel = null;
            }
            // Clean up the data we added to the element
            $.removeData(this, 'mousewheel-line-height');
            $.removeData(this, 'mousewheel-page-height');
        },

        getLineHeight: function(elem) {
            var $elem = $(elem),
                $parent = $elem['offsetParent' in $.fn ? 'offsetParent' : 'parent']();
            if (!$parent.length) {
                $parent = $('body');
            }
            return parseInt($parent.css('fontSize'), 10) || parseInt($elem.css('fontSize'), 10) || 16;
        },

        getPageHeight: function(elem) {
            return $(elem).height();
        },

        settings: {
            adjustOldDeltas: true, // see shouldAdjustOldDeltas() below
            normalizeOffset: true  // calls getBoundingClientRect for each event
        }
    };

    $.fn.extend({
        mousewheel: function(fn) {
            return fn ? this.bind('mousewheel', fn) : this.trigger('mousewheel');
        },

        unmousewheel: function(fn) {
            return this.unbind('mousewheel', fn);
        }
    });


    function handler(event) {
        var orgEvent   = event || window.event,
            args       = slice.call(arguments, 1),
            delta      = 0,
            deltaX     = 0,
            deltaY     = 0,
            absDelta   = 0,
            offsetX    = 0,
            offsetY    = 0;
        event = $.event.fix(orgEvent);
        event.type = 'mousewheel';

        // Old school scrollwheel delta
        if ( 'detail'      in orgEvent ) { deltaY = orgEvent.detail * -1;      }
        if ( 'wheelDelta'  in orgEvent ) { deltaY = orgEvent.wheelDelta;       }
        if ( 'wheelDeltaY' in orgEvent ) { deltaY = orgEvent.wheelDeltaY;      }
        if ( 'wheelDeltaX' in orgEvent ) { deltaX = orgEvent.wheelDeltaX * -1; }

        // Firefox < 17 horizontal scrolling related to DOMMouseScroll event
        if ( 'axis' in orgEvent && orgEvent.axis === orgEvent.HORIZONTAL_AXIS ) {
            deltaX = deltaY * -1;
            deltaY = 0;
        }

        // Set delta to be deltaY or deltaX if deltaY is 0 for backwards compatabilitiy
        delta = deltaY === 0 ? deltaX : deltaY;

        // New school wheel delta (wheel event)
        if ( 'deltaY' in orgEvent ) {
            deltaY = orgEvent.deltaY * -1;
            delta  = deltaY;
        }
        if ( 'deltaX' in orgEvent ) {
            deltaX = orgEvent.deltaX;
            if ( deltaY === 0 ) { delta  = deltaX * -1; }
        }

        // No change actually happened, no reason to go any further
        if ( deltaY === 0 && deltaX === 0 ) { return; }

        // Need to convert lines and pages to pixels if we aren't already in pixels
        // There are three delta modes:
        //   * deltaMode 0 is by pixels, nothing to do
        //   * deltaMode 1 is by lines
        //   * deltaMode 2 is by pages
        if ( orgEvent.deltaMode === 1 ) {
            var lineHeight = $.data(this, 'mousewheel-line-height');
            delta  *= lineHeight;
            deltaY *= lineHeight;
            deltaX *= lineHeight;
        } else if ( orgEvent.deltaMode === 2 ) {
            var pageHeight = $.data(this, 'mousewheel-page-height');
            delta  *= pageHeight;
            deltaY *= pageHeight;
            deltaX *= pageHeight;
        }

        // Store lowest absolute delta to normalize the delta values
        absDelta = Math.max( Math.abs(deltaY), Math.abs(deltaX) );

        if ( !lowestDelta || absDelta < lowestDelta ) {
            lowestDelta = absDelta;

            // Adjust older deltas if necessary
            if ( shouldAdjustOldDeltas(orgEvent, absDelta) ) {
                lowestDelta /= 40;
            }
        }

        // Adjust older deltas if necessary
        if ( shouldAdjustOldDeltas(orgEvent, absDelta) ) {
            // Divide all the things by 40!
            delta  /= 40;
            deltaX /= 40;
            deltaY /= 40;
        }

        // Get a whole, normalized value for the deltas
        delta  = Math[ delta  >= 1 ? 'floor' : 'ceil' ](delta  / lowestDelta);
        deltaX = Math[ deltaX >= 1 ? 'floor' : 'ceil' ](deltaX / lowestDelta);
        deltaY = Math[ deltaY >= 1 ? 'floor' : 'ceil' ](deltaY / lowestDelta);

        // Normalise offsetX and offsetY properties
        if ( special.settings.normalizeOffset && this.getBoundingClientRect ) {
            var boundingRect = this.getBoundingClientRect();
            offsetX = event.clientX - boundingRect.left;
            offsetY = event.clientY - boundingRect.top;
        }

        // Add information to the event object
        event.deltaX = deltaX;
        event.deltaY = deltaY;
        event.deltaFactor = lowestDelta;
        event.offsetX = offsetX;
        event.offsetY = offsetY;
        // Go ahead and set deltaMode to 0 since we converted to pixels
        // Although this is a little odd since we overwrite the deltaX/Y
        // properties with normalized deltas.
        event.deltaMode = 0;

        // Add event and delta to the front of the arguments
        args.unshift(event, delta, deltaX, deltaY);

        // Clearout lowestDelta after sometime to better
        // handle multiple device types that give different
        // a different lowestDelta
        // Ex: trackpad = 3 and mouse wheel = 120
        if (nullLowestDeltaTimeout) { clearTimeout(nullLowestDeltaTimeout); }
        nullLowestDeltaTimeout = setTimeout(nullLowestDelta, 200);

        return ($.event.dispatch || $.event.handle).apply(this, args);
    }

    function nullLowestDelta() {
        lowestDelta = null;
    }

    function shouldAdjustOldDeltas(orgEvent, absDelta) {
        // If this is an older event and the delta is divisable by 120,
        // then we are assuming that the browser is treating this as an
        // older mouse wheel event and that we should divide the deltas
        // by 40 to try and get a more usable deltaFactor.
        // Side note, this actually impacts the reported scroll distance
        // in older browsers and can cause scrolling to be slower than native.
        // Turn this off by setting $.event.special.mousewheel.settings.adjustOldDeltas to false.
        return special.settings.adjustOldDeltas && orgEvent.type === 'mousewheel' && absDelta % 120 === 0;
    }

}));

/*! Hammer.JS - v2.0.8 - 2016-04-23
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
!function(a,b,c,d){"use strict";function e(a,b,c){return setTimeout(j(a,c),b)}function f(a,b,c){return Array.isArray(a)?(g(a,c[b],c),!0):!1}function g(a,b,c){var e;if(a)if(a.forEach)a.forEach(b,c);else if(a.length!==d)for(e=0;e<a.length;)b.call(c,a[e],e,a),e++;else for(e in a)a.hasOwnProperty(e)&&b.call(c,a[e],e,a)}function h(b,c,d){var e="DEPRECATED METHOD: "+c+"\n"+d+" AT \n";return function(){var c=new Error("get-stack-trace"),d=c&&c.stack?c.stack.replace(/^[^\(]+?[\n$]/gm,"").replace(/^\s+at\s+/gm,"").replace(/^Object.<anonymous>\s*\(/gm,"{anonymous}()@"):"Unknown Stack Trace",f=a.console&&(a.console.warn||a.Logger.info);return f&&f.call(a.console,e,d),b.apply(this,arguments)}}function i(a,b,c){var d,e=b.prototype;d=a.prototype=Object.create(e),d.constructor=a,d._super=e,c&&la(d,c)}function j(a,b){return function(){return a.apply(b,arguments)}}function k(a,b){return typeof a==oa?a.apply(b?b[0]||d:d,b):a}function l(a,b){return a===d?b:a}function m(a,b,c){g(q(b),function(b){a.addEventListener(b,c,!1)})}function n(a,b,c){g(q(b),function(b){a.removeEventListener(b,c,!1)})}function o(a,b){for(;a;){if(a==b)return!0;a=a.parentNode}return!1}function p(a,b){return a.indexOf(b)>-1}function q(a){return a.trim().split(/\s+/g)}function r(a,b,c){if(a.indexOf&&!c)return a.indexOf(b);for(var d=0;d<a.length;){if(c&&a[d][c]==b||!c&&a[d]===b)return d;d++}return-1}function s(a){return Array.prototype.slice.call(a,0)}function t(a,b,c){for(var d=[],e=[],f=0;f<a.length;){var g=b?a[f][b]:a[f];r(e,g)<0&&d.push(a[f]),e[f]=g,f++}return c&&(d=b?d.sort(function(a,c){return a[b]>c[b]}):d.sort()),d}function u(a,b){for(var c,e,f=b[0].toUpperCase()+b.slice(1),g=0;g<ma.length;){if(c=ma[g],e=c?c+f:b,e in a)return e;g++}return d}function v(){return ua++}function w(b){var c=b.ownerDocument||b;return c.defaultView||c.parentWindow||a}function x(a,b){var c=this;this.manager=a,this.callback=b,this.element=a.element,this.target=a.options.inputTarget,this.domHandler=function(b){k(a.options.enable,[a])&&c.handler(b)},this.init()}function y(a){var b,c=a.options.inputClass;return new(b=c?c:xa?M:ya?P:wa?R:L)(a,z)}function z(a,b,c){var d=c.pointers.length,e=c.changedPointers.length,f=b&Ea&&d-e===0,g=b&(Ga|Ha)&&d-e===0;c.isFirst=!!f,c.isFinal=!!g,f&&(a.session={}),c.eventType=b,A(a,c),a.emit("hammer.input",c),a.recognize(c),a.session.prevInput=c}function A(a,b){var c=a.session,d=b.pointers,e=d.length;c.firstInput||(c.firstInput=D(b)),e>1&&!c.firstMultiple?c.firstMultiple=D(b):1===e&&(c.firstMultiple=!1);var f=c.firstInput,g=c.firstMultiple,h=g?g.center:f.center,i=b.center=E(d);b.timeStamp=ra(),b.deltaTime=b.timeStamp-f.timeStamp,b.angle=I(h,i),b.distance=H(h,i),B(c,b),b.offsetDirection=G(b.deltaX,b.deltaY);var j=F(b.deltaTime,b.deltaX,b.deltaY);b.overallVelocityX=j.x,b.overallVelocityY=j.y,b.overallVelocity=qa(j.x)>qa(j.y)?j.x:j.y,b.scale=g?K(g.pointers,d):1,b.rotation=g?J(g.pointers,d):0,b.maxPointers=c.prevInput?b.pointers.length>c.prevInput.maxPointers?b.pointers.length:c.prevInput.maxPointers:b.pointers.length,C(c,b);var k=a.element;o(b.srcEvent.target,k)&&(k=b.srcEvent.target),b.target=k}function B(a,b){var c=b.center,d=a.offsetDelta||{},e=a.prevDelta||{},f=a.prevInput||{};b.eventType!==Ea&&f.eventType!==Ga||(e=a.prevDelta={x:f.deltaX||0,y:f.deltaY||0},d=a.offsetDelta={x:c.x,y:c.y}),b.deltaX=e.x+(c.x-d.x),b.deltaY=e.y+(c.y-d.y)}function C(a,b){var c,e,f,g,h=a.lastInterval||b,i=b.timeStamp-h.timeStamp;if(b.eventType!=Ha&&(i>Da||h.velocity===d)){var j=b.deltaX-h.deltaX,k=b.deltaY-h.deltaY,l=F(i,j,k);e=l.x,f=l.y,c=qa(l.x)>qa(l.y)?l.x:l.y,g=G(j,k),a.lastInterval=b}else c=h.velocity,e=h.velocityX,f=h.velocityY,g=h.direction;b.velocity=c,b.velocityX=e,b.velocityY=f,b.direction=g}function D(a){for(var b=[],c=0;c<a.pointers.length;)b[c]={clientX:pa(a.pointers[c].clientX),clientY:pa(a.pointers[c].clientY)},c++;return{timeStamp:ra(),pointers:b,center:E(b),deltaX:a.deltaX,deltaY:a.deltaY}}function E(a){var b=a.length;if(1===b)return{x:pa(a[0].clientX),y:pa(a[0].clientY)};for(var c=0,d=0,e=0;b>e;)c+=a[e].clientX,d+=a[e].clientY,e++;return{x:pa(c/b),y:pa(d/b)}}function F(a,b,c){return{x:b/a||0,y:c/a||0}}function G(a,b){return a===b?Ia:qa(a)>=qa(b)?0>a?Ja:Ka:0>b?La:Ma}function H(a,b,c){c||(c=Qa);var d=b[c[0]]-a[c[0]],e=b[c[1]]-a[c[1]];return Math.sqrt(d*d+e*e)}function I(a,b,c){c||(c=Qa);var d=b[c[0]]-a[c[0]],e=b[c[1]]-a[c[1]];return 180*Math.atan2(e,d)/Math.PI}function J(a,b){return I(b[1],b[0],Ra)+I(a[1],a[0],Ra)}function K(a,b){return H(b[0],b[1],Ra)/H(a[0],a[1],Ra)}function L(){this.evEl=Ta,this.evWin=Ua,this.pressed=!1,x.apply(this,arguments)}function M(){this.evEl=Xa,this.evWin=Ya,x.apply(this,arguments),this.store=this.manager.session.pointerEvents=[]}function N(){this.evTarget=$a,this.evWin=_a,this.started=!1,x.apply(this,arguments)}function O(a,b){var c=s(a.touches),d=s(a.changedTouches);return b&(Ga|Ha)&&(c=t(c.concat(d),"identifier",!0)),[c,d]}function P(){this.evTarget=bb,this.targetIds={},x.apply(this,arguments)}function Q(a,b){var c=s(a.touches),d=this.targetIds;if(b&(Ea|Fa)&&1===c.length)return d[c[0].identifier]=!0,[c,c];var e,f,g=s(a.changedTouches),h=[],i=this.target;if(f=c.filter(function(a){return o(a.target,i)}),b===Ea)for(e=0;e<f.length;)d[f[e].identifier]=!0,e++;for(e=0;e<g.length;)d[g[e].identifier]&&h.push(g[e]),b&(Ga|Ha)&&delete d[g[e].identifier],e++;return h.length?[t(f.concat(h),"identifier",!0),h]:void 0}function R(){x.apply(this,arguments);var a=j(this.handler,this);this.touch=new P(this.manager,a),this.mouse=new L(this.manager,a),this.primaryTouch=null,this.lastTouches=[]}function S(a,b){a&Ea?(this.primaryTouch=b.changedPointers[0].identifier,T.call(this,b)):a&(Ga|Ha)&&T.call(this,b)}function T(a){var b=a.changedPointers[0];if(b.identifier===this.primaryTouch){var c={x:b.clientX,y:b.clientY};this.lastTouches.push(c);var d=this.lastTouches,e=function(){var a=d.indexOf(c);a>-1&&d.splice(a,1)};setTimeout(e,cb)}}function U(a){for(var b=a.srcEvent.clientX,c=a.srcEvent.clientY,d=0;d<this.lastTouches.length;d++){var e=this.lastTouches[d],f=Math.abs(b-e.x),g=Math.abs(c-e.y);if(db>=f&&db>=g)return!0}return!1}function V(a,b){this.manager=a,this.set(b)}function W(a){if(p(a,jb))return jb;var b=p(a,kb),c=p(a,lb);return b&&c?jb:b||c?b?kb:lb:p(a,ib)?ib:hb}function X(){if(!fb)return!1;var b={},c=a.CSS&&a.CSS.supports;return["auto","manipulation","pan-y","pan-x","pan-x pan-y","none"].forEach(function(d){b[d]=c?a.CSS.supports("touch-action",d):!0}),b}function Y(a){this.options=la({},this.defaults,a||{}),this.id=v(),this.manager=null,this.options.enable=l(this.options.enable,!0),this.state=nb,this.simultaneous={},this.requireFail=[]}function Z(a){return a&sb?"cancel":a&qb?"end":a&pb?"move":a&ob?"start":""}function $(a){return a==Ma?"down":a==La?"up":a==Ja?"left":a==Ka?"right":""}function _(a,b){var c=b.manager;return c?c.get(a):a}function aa(){Y.apply(this,arguments)}function ba(){aa.apply(this,arguments),this.pX=null,this.pY=null}function ca(){aa.apply(this,arguments)}function da(){Y.apply(this,arguments),this._timer=null,this._input=null}function ea(){aa.apply(this,arguments)}function fa(){aa.apply(this,arguments)}function ga(){Y.apply(this,arguments),this.pTime=!1,this.pCenter=!1,this._timer=null,this._input=null,this.count=0}function ha(a,b){return b=b||{},b.recognizers=l(b.recognizers,ha.defaults.preset),new ia(a,b)}function ia(a,b){this.options=la({},ha.defaults,b||{}),this.options.inputTarget=this.options.inputTarget||a,this.handlers={},this.session={},this.recognizers=[],this.oldCssProps={},this.element=a,this.input=y(this),this.touchAction=new V(this,this.options.touchAction),ja(this,!0),g(this.options.recognizers,function(a){var b=this.add(new a[0](a[1]));a[2]&&b.recognizeWith(a[2]),a[3]&&b.requireFailure(a[3])},this)}function ja(a,b){var c=a.element;if(c.style){var d;g(a.options.cssProps,function(e,f){d=u(c.style,f),b?(a.oldCssProps[d]=c.style[d],c.style[d]=e):c.style[d]=a.oldCssProps[d]||""}),b||(a.oldCssProps={})}}function ka(a,c){var d=b.createEvent("Event");d.initEvent(a,!0,!0),d.gesture=c,c.target.dispatchEvent(d)}var la,ma=["","webkit","Moz","MS","ms","o"],na=b.createElement("div"),oa="function",pa=Math.round,qa=Math.abs,ra=Date.now;la="function"!=typeof Object.assign?function(a){if(a===d||null===a)throw new TypeError("Cannot convert undefined or null to object");for(var b=Object(a),c=1;c<arguments.length;c++){var e=arguments[c];if(e!==d&&null!==e)for(var f in e)e.hasOwnProperty(f)&&(b[f]=e[f])}return b}:Object.assign;var sa=h(function(a,b,c){for(var e=Object.keys(b),f=0;f<e.length;)(!c||c&&a[e[f]]===d)&&(a[e[f]]=b[e[f]]),f++;return a},"extend","Use `assign`."),ta=h(function(a,b){return sa(a,b,!0)},"merge","Use `assign`."),ua=1,va=/mobile|tablet|ip(ad|hone|od)|android/i,wa="ontouchstart"in a,xa=u(a,"PointerEvent")!==d,ya=wa&&va.test(navigator.userAgent),za="touch",Aa="pen",Ba="mouse",Ca="kinect",Da=25,Ea=1,Fa=2,Ga=4,Ha=8,Ia=1,Ja=2,Ka=4,La=8,Ma=16,Na=Ja|Ka,Oa=La|Ma,Pa=Na|Oa,Qa=["x","y"],Ra=["clientX","clientY"];x.prototype={handler:function(){},init:function(){this.evEl&&m(this.element,this.evEl,this.domHandler),this.evTarget&&m(this.target,this.evTarget,this.domHandler),this.evWin&&m(w(this.element),this.evWin,this.domHandler)},destroy:function(){this.evEl&&n(this.element,this.evEl,this.domHandler),this.evTarget&&n(this.target,this.evTarget,this.domHandler),this.evWin&&n(w(this.element),this.evWin,this.domHandler)}};var Sa={mousedown:Ea,mousemove:Fa,mouseup:Ga},Ta="mousedown",Ua="mousemove mouseup";i(L,x,{handler:function(a){var b=Sa[a.type];b&Ea&&0===a.button&&(this.pressed=!0),b&Fa&&1!==a.which&&(b=Ga),this.pressed&&(b&Ga&&(this.pressed=!1),this.callback(this.manager,b,{pointers:[a],changedPointers:[a],pointerType:Ba,srcEvent:a}))}});var Va={pointerdown:Ea,pointermove:Fa,pointerup:Ga,pointercancel:Ha,pointerout:Ha},Wa={2:za,3:Aa,4:Ba,5:Ca},Xa="pointerdown",Ya="pointermove pointerup pointercancel";a.MSPointerEvent&&!a.PointerEvent&&(Xa="MSPointerDown",Ya="MSPointerMove MSPointerUp MSPointerCancel"),i(M,x,{handler:function(a){var b=this.store,c=!1,d=a.type.toLowerCase().replace("ms",""),e=Va[d],f=Wa[a.pointerType]||a.pointerType,g=f==za,h=r(b,a.pointerId,"pointerId");e&Ea&&(0===a.button||g)?0>h&&(b.push(a),h=b.length-1):e&(Ga|Ha)&&(c=!0),0>h||(b[h]=a,this.callback(this.manager,e,{pointers:b,changedPointers:[a],pointerType:f,srcEvent:a}),c&&b.splice(h,1))}});var Za={touchstart:Ea,touchmove:Fa,touchend:Ga,touchcancel:Ha},$a="touchstart",_a="touchstart touchmove touchend touchcancel";i(N,x,{handler:function(a){var b=Za[a.type];if(b===Ea&&(this.started=!0),this.started){var c=O.call(this,a,b);b&(Ga|Ha)&&c[0].length-c[1].length===0&&(this.started=!1),this.callback(this.manager,b,{pointers:c[0],changedPointers:c[1],pointerType:za,srcEvent:a})}}});var ab={touchstart:Ea,touchmove:Fa,touchend:Ga,touchcancel:Ha},bb="touchstart touchmove touchend touchcancel";i(P,x,{handler:function(a){var b=ab[a.type],c=Q.call(this,a,b);c&&this.callback(this.manager,b,{pointers:c[0],changedPointers:c[1],pointerType:za,srcEvent:a})}});var cb=2500,db=25;i(R,x,{handler:function(a,b,c){var d=c.pointerType==za,e=c.pointerType==Ba;if(!(e&&c.sourceCapabilities&&c.sourceCapabilities.firesTouchEvents)){if(d)S.call(this,b,c);else if(e&&U.call(this,c))return;this.callback(a,b,c)}},destroy:function(){this.touch.destroy(),this.mouse.destroy()}});var eb=u(na.style,"touchAction"),fb=eb!==d,gb="compute",hb="auto",ib="manipulation",jb="none",kb="pan-x",lb="pan-y",mb=X();V.prototype={set:function(a){a==gb&&(a=this.compute()),fb&&this.manager.element.style&&mb[a]&&(this.manager.element.style[eb]=a),this.actions=a.toLowerCase().trim()},update:function(){this.set(this.manager.options.touchAction)},compute:function(){var a=[];return g(this.manager.recognizers,function(b){k(b.options.enable,[b])&&(a=a.concat(b.getTouchAction()))}),W(a.join(" "))},preventDefaults:function(a){var b=a.srcEvent,c=a.offsetDirection;if(this.manager.session.prevented)return void b.preventDefault();var d=this.actions,e=p(d,jb)&&!mb[jb],f=p(d,lb)&&!mb[lb],g=p(d,kb)&&!mb[kb];if(e){var h=1===a.pointers.length,i=a.distance<2,j=a.deltaTime<250;if(h&&i&&j)return}return g&&f?void 0:e||f&&c&Na||g&&c&Oa?this.preventSrc(b):void 0},preventSrc:function(a){this.manager.session.prevented=!0,a.preventDefault()}};var nb=1,ob=2,pb=4,qb=8,rb=qb,sb=16,tb=32;Y.prototype={defaults:{},set:function(a){return la(this.options,a),this.manager&&this.manager.touchAction.update(),this},recognizeWith:function(a){if(f(a,"recognizeWith",this))return this;var b=this.simultaneous;return a=_(a,this),b[a.id]||(b[a.id]=a,a.recognizeWith(this)),this},dropRecognizeWith:function(a){return f(a,"dropRecognizeWith",this)?this:(a=_(a,this),delete this.simultaneous[a.id],this)},requireFailure:function(a){if(f(a,"requireFailure",this))return this;var b=this.requireFail;return a=_(a,this),-1===r(b,a)&&(b.push(a),a.requireFailure(this)),this},dropRequireFailure:function(a){if(f(a,"dropRequireFailure",this))return this;a=_(a,this);var b=r(this.requireFail,a);return b>-1&&this.requireFail.splice(b,1),this},hasRequireFailures:function(){return this.requireFail.length>0},canRecognizeWith:function(a){return!!this.simultaneous[a.id]},emit:function(a){function b(b){c.manager.emit(b,a)}var c=this,d=this.state;qb>d&&b(c.options.event+Z(d)),b(c.options.event),a.additionalEvent&&b(a.additionalEvent),d>=qb&&b(c.options.event+Z(d))},tryEmit:function(a){return this.canEmit()?this.emit(a):void(this.state=tb)},canEmit:function(){for(var a=0;a<this.requireFail.length;){if(!(this.requireFail[a].state&(tb|nb)))return!1;a++}return!0},recognize:function(a){var b=la({},a);return k(this.options.enable,[this,b])?(this.state&(rb|sb|tb)&&(this.state=nb),this.state=this.process(b),void(this.state&(ob|pb|qb|sb)&&this.tryEmit(b))):(this.reset(),void(this.state=tb))},process:function(a){},getTouchAction:function(){},reset:function(){}},i(aa,Y,{defaults:{pointers:1},attrTest:function(a){var b=this.options.pointers;return 0===b||a.pointers.length===b},process:function(a){var b=this.state,c=a.eventType,d=b&(ob|pb),e=this.attrTest(a);return d&&(c&Ha||!e)?b|sb:d||e?c&Ga?b|qb:b&ob?b|pb:ob:tb}}),i(ba,aa,{defaults:{event:"pan",threshold:10,pointers:1,direction:Pa},getTouchAction:function(){var a=this.options.direction,b=[];return a&Na&&b.push(lb),a&Oa&&b.push(kb),b},directionTest:function(a){var b=this.options,c=!0,d=a.distance,e=a.direction,f=a.deltaX,g=a.deltaY;return e&b.direction||(b.direction&Na?(e=0===f?Ia:0>f?Ja:Ka,c=f!=this.pX,d=Math.abs(a.deltaX)):(e=0===g?Ia:0>g?La:Ma,c=g!=this.pY,d=Math.abs(a.deltaY))),a.direction=e,c&&d>b.threshold&&e&b.direction},attrTest:function(a){return aa.prototype.attrTest.call(this,a)&&(this.state&ob||!(this.state&ob)&&this.directionTest(a))},emit:function(a){this.pX=a.deltaX,this.pY=a.deltaY;var b=$(a.direction);b&&(a.additionalEvent=this.options.event+b),this._super.emit.call(this,a)}}),i(ca,aa,{defaults:{event:"pinch",threshold:0,pointers:2},getTouchAction:function(){return[jb]},attrTest:function(a){return this._super.attrTest.call(this,a)&&(Math.abs(a.scale-1)>this.options.threshold||this.state&ob)},emit:function(a){if(1!==a.scale){var b=a.scale<1?"in":"out";a.additionalEvent=this.options.event+b}this._super.emit.call(this,a)}}),i(da,Y,{defaults:{event:"press",pointers:1,time:251,threshold:9},getTouchAction:function(){return[hb]},process:function(a){var b=this.options,c=a.pointers.length===b.pointers,d=a.distance<b.threshold,f=a.deltaTime>b.time;if(this._input=a,!d||!c||a.eventType&(Ga|Ha)&&!f)this.reset();else if(a.eventType&Ea)this.reset(),this._timer=e(function(){this.state=rb,this.tryEmit()},b.time,this);else if(a.eventType&Ga)return rb;return tb},reset:function(){clearTimeout(this._timer)},emit:function(a){this.state===rb&&(a&&a.eventType&Ga?this.manager.emit(this.options.event+"up",a):(this._input.timeStamp=ra(),this.manager.emit(this.options.event,this._input)))}}),i(ea,aa,{defaults:{event:"rotate",threshold:0,pointers:2},getTouchAction:function(){return[jb]},attrTest:function(a){return this._super.attrTest.call(this,a)&&(Math.abs(a.rotation)>this.options.threshold||this.state&ob)}}),i(fa,aa,{defaults:{event:"swipe",threshold:10,velocity:.3,direction:Na|Oa,pointers:1},getTouchAction:function(){return ba.prototype.getTouchAction.call(this)},attrTest:function(a){var b,c=this.options.direction;return c&(Na|Oa)?b=a.overallVelocity:c&Na?b=a.overallVelocityX:c&Oa&&(b=a.overallVelocityY),this._super.attrTest.call(this,a)&&c&a.offsetDirection&&a.distance>this.options.threshold&&a.maxPointers==this.options.pointers&&qa(b)>this.options.velocity&&a.eventType&Ga},emit:function(a){var b=$(a.offsetDirection);b&&this.manager.emit(this.options.event+b,a),this.manager.emit(this.options.event,a)}}),i(ga,Y,{defaults:{event:"tap",pointers:1,taps:1,interval:300,time:250,threshold:9,posThreshold:10},getTouchAction:function(){return[ib]},process:function(a){var b=this.options,c=a.pointers.length===b.pointers,d=a.distance<b.threshold,f=a.deltaTime<b.time;if(this.reset(),a.eventType&Ea&&0===this.count)return this.failTimeout();if(d&&f&&c){if(a.eventType!=Ga)return this.failTimeout();var g=this.pTime?a.timeStamp-this.pTime<b.interval:!0,h=!this.pCenter||H(this.pCenter,a.center)<b.posThreshold;this.pTime=a.timeStamp,this.pCenter=a.center,h&&g?this.count+=1:this.count=1,this._input=a;var i=this.count%b.taps;if(0===i)return this.hasRequireFailures()?(this._timer=e(function(){this.state=rb,this.tryEmit()},b.interval,this),ob):rb}return tb},failTimeout:function(){return this._timer=e(function(){this.state=tb},this.options.interval,this),tb},reset:function(){clearTimeout(this._timer)},emit:function(){this.state==rb&&(this._input.tapCount=this.count,this.manager.emit(this.options.event,this._input))}}),ha.VERSION="2.0.8",ha.defaults={domEvents:!1,touchAction:gb,enable:!0,inputTarget:null,inputClass:null,preset:[[ea,{enable:!1}],[ca,{enable:!1},["rotate"]],[fa,{direction:Na}],[ba,{direction:Na},["swipe"]],[ga],[ga,{event:"doubletap",taps:2},["tap"]],[da]],cssProps:{userSelect:"none",touchSelect:"none",touchCallout:"none",contentZooming:"none",userDrag:"none",tapHighlightColor:"rgba(0,0,0,0)"}};var ub=1,vb=2;ia.prototype={set:function(a){return la(this.options,a),a.touchAction&&this.touchAction.update(),a.inputTarget&&(this.input.destroy(),this.input.target=a.inputTarget,this.input.init()),this},stop:function(a){this.session.stopped=a?vb:ub},recognize:function(a){var b=this.session;if(!b.stopped){this.touchAction.preventDefaults(a);var c,d=this.recognizers,e=b.curRecognizer;(!e||e&&e.state&rb)&&(e=b.curRecognizer=null);for(var f=0;f<d.length;)c=d[f],b.stopped===vb||e&&c!=e&&!c.canRecognizeWith(e)?c.reset():c.recognize(a),!e&&c.state&(ob|pb|qb)&&(e=b.curRecognizer=c),f++}},get:function(a){if(a instanceof Y)return a;for(var b=this.recognizers,c=0;c<b.length;c++)if(b[c].options.event==a)return b[c];return null},add:function(a){if(f(a,"add",this))return this;var b=this.get(a.options.event);return b&&this.remove(b),this.recognizers.push(a),a.manager=this,this.touchAction.update(),a},remove:function(a){if(f(a,"remove",this))return this;if(a=this.get(a)){var b=this.recognizers,c=r(b,a);-1!==c&&(b.splice(c,1),this.touchAction.update())}return this},on:function(a,b){if(a!==d&&b!==d){var c=this.handlers;return g(q(a),function(a){c[a]=c[a]||[],c[a].push(b)}),this}},off:function(a,b){if(a!==d){var c=this.handlers;return g(q(a),function(a){b?c[a]&&c[a].splice(r(c[a],b),1):delete c[a]}),this}},emit:function(a,b){this.options.domEvents&&ka(a,b);var c=this.handlers[a]&&this.handlers[a].slice();if(c&&c.length){b.type=a,b.preventDefault=function(){b.srcEvent.preventDefault()};for(var d=0;d<c.length;)c[d](b),d++}},destroy:function(){this.element&&ja(this,!1),this.handlers={},this.session={},this.input.destroy(),this.element=null}},la(ha,{INPUT_START:Ea,INPUT_MOVE:Fa,INPUT_END:Ga,INPUT_CANCEL:Ha,STATE_POSSIBLE:nb,STATE_BEGAN:ob,STATE_CHANGED:pb,STATE_ENDED:qb,STATE_RECOGNIZED:rb,STATE_CANCELLED:sb,STATE_FAILED:tb,DIRECTION_NONE:Ia,DIRECTION_LEFT:Ja,DIRECTION_RIGHT:Ka,DIRECTION_UP:La,DIRECTION_DOWN:Ma,DIRECTION_HORIZONTAL:Na,DIRECTION_VERTICAL:Oa,DIRECTION_ALL:Pa,Manager:ia,Input:x,TouchAction:V,TouchInput:P,MouseInput:L,PointerEventInput:M,TouchMouseInput:R,SingleTouchInput:N,Recognizer:Y,AttrRecognizer:aa,Tap:ga,Pan:ba,Swipe:fa,Pinch:ca,Rotate:ea,Press:da,on:m,off:n,each:g,merge:ta,extend:sa,assign:la,inherit:i,bindFn:j,prefixed:u});var wb="undefined"!=typeof a?a:"undefined"!=typeof self?self:{};wb.Hammer=ha,"function"==typeof define&&define.amd?define(function(){return ha}):"undefined"!=typeof module&&module.exports?module.exports=ha:a[c]=ha}(window,document,"Hammer");
//# sourceMappingURL=hammer.min.js.map
/*! For license information please see DesignPriceCalculatorRuleBased.js.LICENSE.txt */
!function(t,n){"object"==typeof exports&&"object"==typeof module?module.exports=n():"function"==typeof define&&define.amd?define([],n):"object"==typeof exports?exports.pricingCalculatorLib=n():t.pricingCalculatorLib=n()}(this,(()=>(()=>{var t={12:t=>{"use strict";t.exports=function(t,n){return function(){for(var e=new Array(arguments.length),r=0;r<e.length;r++)e[r]=arguments[r];return t.apply(n,e)}}},15:(t,n,e)=>{"use strict";var r=e(516),i=e(12),u=e(155),o=e(987);function a(t){var n=new u(t),e=i(u.prototype.request,n);return r.extend(e,u.prototype,n),r.extend(e,n),e}var c=a(o);c.Axios=u,c.create=function(t){return a(r.merge(o,t))},c.Cancel=e(928),c.CancelToken=e(191),c.isCancel=e(864),c.all=function(t){return Promise.all(t)},c.spread=e(980),t.exports=c,t.exports.default=c},18:(t,n,e)=>{"use strict";var r=e(516);t.exports=function(t,n){r.forEach(t,(function(e,r){r!==n&&r.toUpperCase()===n.toUpperCase()&&(t[n]=e,delete t[r])}))}},106:(t,n,e)=>{"use strict";var r=e(516);function i(t){return encodeURIComponent(t).replace(/%40/gi,"@").replace(/%3A/gi,":").replace(/%24/g,"$").replace(/%2C/gi,",").replace(/%20/g,"+").replace(/%5B/gi,"[").replace(/%5D/gi,"]")}t.exports=function(t,n,e){if(!n)return t;var u;if(e)u=e(n);else if(r.isURLSearchParams(n))u=n.toString();else{var o=[];r.forEach(n,(function(t,n){null!=t&&(r.isArray(t)?n+="[]":t=[t],r.forEach(t,(function(t){r.isDate(t)?t=t.toISOString():r.isObject(t)&&(t=JSON.stringify(t)),o.push(i(n)+"="+i(t))})))})),u=o.join("&")}return u&&(t+=(-1===t.indexOf("?")?"?":"&")+u),t}},137:t=>{"use strict";t.exports=function(t){return/^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(t)}},155:(t,n,e)=>{"use strict";var r=e(987),i=e(516),u=e(471),o=e(490);function a(t){this.defaults=t,this.interceptors={request:new u,response:new u}}a.prototype.request=function(t){"string"==typeof t&&(t=i.merge({url:arguments[0]},arguments[1])),(t=i.merge(r,{method:"get"},this.defaults,t)).method=t.method.toLowerCase();var n=[o,void 0],e=Promise.resolve(t);for(this.interceptors.request.forEach((function(t){n.unshift(t.fulfilled,t.rejected)})),this.interceptors.response.forEach((function(t){n.push(t.fulfilled,t.rejected)}));n.length;)e=e.then(n.shift(),n.shift());return e},i.forEach(["delete","get","head","options"],(function(t){a.prototype[t]=function(n,e){return this.request(i.merge(e||{},{method:t,url:n}))}})),i.forEach(["post","put","patch"],(function(t){a.prototype[t]=function(n,e,r){return this.request(i.merge(r||{},{method:t,url:n,data:e}))}})),t.exports=a},191:(t,n,e)=>{"use strict";var r=e(928);function i(t){if("function"!=typeof t)throw new TypeError("executor must be a function.");var n;this.promise=new Promise((function(t){n=t}));var e=this;t((function(t){e.reason||(e.reason=new r(t),n(e.reason))}))}i.prototype.throwIfRequested=function(){if(this.reason)throw this.reason},i.source=function(){var t;return{token:new i((function(n){t=n})),cancel:t}},t.exports=i},202:(t,n,e)=>{"use strict";var r=e(516);t.exports=r.isStandardBrowserEnv()?function(){var t,n=/(msie|trident)/i.test(navigator.userAgent),e=document.createElement("a");function i(t){var r=t;return n&&(e.setAttribute("href",r),r=e.href),e.setAttribute("href",r),{href:e.href,protocol:e.protocol?e.protocol.replace(/:$/,""):"",host:e.host,search:e.search?e.search.replace(/^\?/,""):"",hash:e.hash?e.hash.replace(/^#/,""):"",hostname:e.hostname,port:e.port,pathname:"/"===e.pathname.charAt(0)?e.pathname:"/"+e.pathname}}return t=i(window.location.href),function(n){var e=r.isString(n)?i(n):n;return e.protocol===t.protocol&&e.host===t.host}}():function(){return!0}},206:t=>{t.exports=function(t){return null!=t&&null!=t.constructor&&"function"==typeof t.constructor.isBuffer&&t.constructor.isBuffer(t)}},449:t=>{"use strict";t.exports=function(t,n,e,r,i){return t.config=n,e&&(t.code=e),t.request=r,t.response=i,t}},471:(t,n,e)=>{"use strict";var r=e(516);function i(){this.handlers=[]}i.prototype.use=function(t,n){return this.handlers.push({fulfilled:t,rejected:n}),this.handlers.length-1},i.prototype.eject=function(t){this.handlers[t]&&(this.handlers[t]=null)},i.prototype.forEach=function(t){r.forEach(this.handlers,(function(n){null!==n&&t(n)}))},t.exports=i},490:(t,n,e)=>{"use strict";var r=e(516),i=e(881),u=e(864),o=e(987),a=e(137),c=e(680);function s(t){t.cancelToken&&t.cancelToken.throwIfRequested()}t.exports=function(t){return s(t),t.baseURL&&!a(t.url)&&(t.url=c(t.baseURL,t.url)),t.headers=t.headers||{},t.data=i(t.data,t.headers,t.transformRequest),t.headers=r.merge(t.headers.common||{},t.headers[t.method]||{},t.headers||{}),r.forEach(["delete","get","head","post","put","patch","common"],(function(n){delete t.headers[n]})),(t.adapter||o.adapter)(t).then((function(n){return s(t),n.data=i(n.data,n.headers,t.transformResponse),n}),(function(n){return u(n)||(s(t),n&&n.response&&(n.response.data=i(n.response.data,n.response.headers,t.transformResponse))),Promise.reject(n)}))}},505:(t,n,e)=>{t.exports=e(15)},516:(t,n,e)=>{"use strict";var r=e(12),i=e(206),u=Object.prototype.toString;function o(t){return"[object Array]"===u.call(t)}function a(t){return null!==t&&"object"==typeof t}function c(t){return"[object Function]"===u.call(t)}function s(t,n){if(null!=t)if("object"!=typeof t&&(t=[t]),o(t))for(var e=0,r=t.length;e<r;e++)n.call(null,t[e],e,t);else for(var i in t)Object.prototype.hasOwnProperty.call(t,i)&&n.call(null,t[i],i,t)}t.exports={isArray:o,isArrayBuffer:function(t){return"[object ArrayBuffer]"===u.call(t)},isBuffer:i,isFormData:function(t){return"undefined"!=typeof FormData&&t instanceof FormData},isArrayBufferView:function(t){return"undefined"!=typeof ArrayBuffer&&ArrayBuffer.isView?ArrayBuffer.isView(t):t&&t.buffer&&t.buffer instanceof ArrayBuffer},isString:function(t){return"string"==typeof t},isNumber:function(t){return"number"==typeof t},isObject:a,isUndefined:function(t){return void 0===t},isDate:function(t){return"[object Date]"===u.call(t)},isFile:function(t){return"[object File]"===u.call(t)},isBlob:function(t){return"[object Blob]"===u.call(t)},isFunction:c,isStream:function(t){return a(t)&&c(t.pipe)},isURLSearchParams:function(t){return"undefined"!=typeof URLSearchParams&&t instanceof URLSearchParams},isStandardBrowserEnv:function(){return("undefined"==typeof navigator||"ReactNative"!==navigator.product)&&"undefined"!=typeof window&&"undefined"!=typeof document},forEach:s,merge:function t(){var n={};function e(e,r){"object"==typeof n[r]&&"object"==typeof e?n[r]=t(n[r],e):n[r]=e}for(var r=0,i=arguments.length;r<i;r++)s(arguments[r],e);return n},extend:function(t,n,e){return s(n,(function(n,i){t[i]=e&&"function"==typeof n?r(n,e):n})),t},trim:function(t){return t.replace(/^\s*/,"").replace(/\s*$/,"")}}},522:(t,n,e)=>{"use strict";var r=e(763);t.exports=function(t,n,e){var i=e.config.validateStatus;e.status&&i&&!i(e.status)?n(r("Request failed with status code "+e.status,e.config,null,e.request,e)):t(e)}},543:function(t,n,e){var r;t=e.nmd(t),function(){var i,u="Expected a function",o="__lodash_hash_undefined__",a="__lodash_placeholder__",c=32,s=128,f=1/0,l=9007199254740991,p=NaN,h=4294967295,g=[["ary",s],["bind",1],["bindKey",2],["curry",8],["curryRight",16],["flip",512],["partial",c],["partialRight",64],["rearg",256]],d="[object Arguments]",v="[object Array]",m="[object Boolean]",_="[object Date]",y="[object Error]",w="[object Function]",x="[object GeneratorFunction]",b="[object Map]",I="[object Number]",A="[object Object]",T="[object Promise]",D="[object RegExp]",E="[object Set]",j="[object String]",C="[object Symbol]",S="[object WeakMap]",O="[object ArrayBuffer]",P="[object DataView]",R="[object Float32Array]",k="[object Float64Array]",L="[object Int8Array]",U="[object Int16Array]",F="[object Int32Array]",z="[object Uint8Array]",B="[object Uint8ClampedArray]",N="[object Uint16Array]",q="[object Uint32Array]",W=/\b__p \+= '';/g,M=/\b(__p \+=) '' \+/g,$=/(__e\(.*?\)|\b__t\)) \+\n'';/g,V=/&(?:amp|lt|gt|quot|#39);/g,J=/[&<>"']/g,G=RegExp(V.source),X=RegExp(J.source),H=/<%-([\s\S]+?)%>/g,K=/<%([\s\S]+?)%>/g,Y=/<%=([\s\S]+?)%>/g,Q=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,Z=/^\w*$/,tt=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,nt=/[\\^$.*+?()[\]{}|]/g,et=RegExp(nt.source),rt=/^\s+/,it=/\s/,ut=/\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,ot=/\{\n\/\* \[wrapped with (.+)\] \*/,at=/,? & /,ct=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,st=/[()=,{}\[\]\/\s]/,ft=/\\(\\)?/g,lt=/\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,pt=/\w*$/,ht=/^[-+]0x[0-9a-f]+$/i,gt=/^0b[01]+$/i,dt=/^\[object .+?Constructor\]$/,vt=/^0o[0-7]+$/i,mt=/^(?:0|[1-9]\d*)$/,_t=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,yt=/($^)/,wt=/['\n\r\u2028\u2029\\]/g,xt="\\ud800-\\udfff",bt="\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff",It="\\u2700-\\u27bf",At="a-z\\xdf-\\xf6\\xf8-\\xff",Tt="A-Z\\xc0-\\xd6\\xd8-\\xde",Dt="\\ufe0e\\ufe0f",Et="\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",jt="["+xt+"]",Ct="["+Et+"]",St="["+bt+"]",Ot="\\d+",Pt="["+It+"]",Rt="["+At+"]",kt="[^"+xt+Et+Ot+It+At+Tt+"]",Lt="\\ud83c[\\udffb-\\udfff]",Ut="[^"+xt+"]",Ft="(?:\\ud83c[\\udde6-\\uddff]){2}",zt="[\\ud800-\\udbff][\\udc00-\\udfff]",Bt="["+Tt+"]",Nt="\\u200d",qt="(?:"+Rt+"|"+kt+")",Wt="(?:"+Bt+"|"+kt+")",Mt="(?:['’](?:d|ll|m|re|s|t|ve))?",$t="(?:['’](?:D|LL|M|RE|S|T|VE))?",Vt="(?:"+St+"|"+Lt+")?",Jt="["+Dt+"]?",Gt=Jt+Vt+"(?:"+Nt+"(?:"+[Ut,Ft,zt].join("|")+")"+Jt+Vt+")*",Xt="(?:"+[Pt,Ft,zt].join("|")+")"+Gt,Ht="(?:"+[Ut+St+"?",St,Ft,zt,jt].join("|")+")",Kt=RegExp("['’]","g"),Yt=RegExp(St,"g"),Qt=RegExp(Lt+"(?="+Lt+")|"+Ht+Gt,"g"),Zt=RegExp([Bt+"?"+Rt+"+"+Mt+"(?="+[Ct,Bt,"$"].join("|")+")",Wt+"+"+$t+"(?="+[Ct,Bt+qt,"$"].join("|")+")",Bt+"?"+qt+"+"+Mt,Bt+"+"+$t,"\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])","\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])",Ot,Xt].join("|"),"g"),tn=RegExp("["+Nt+xt+bt+Dt+"]"),nn=/[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,en=["Array","Buffer","DataView","Date","Error","Float32Array","Float64Array","Function","Int8Array","Int16Array","Int32Array","Map","Math","Object","Promise","RegExp","Set","String","Symbol","TypeError","Uint8Array","Uint8ClampedArray","Uint16Array","Uint32Array","WeakMap","_","clearTimeout","isFinite","parseInt","setTimeout"],rn=-1,un={};un[R]=un[k]=un[L]=un[U]=un[F]=un[z]=un[B]=un[N]=un[q]=!0,un[d]=un[v]=un[O]=un[m]=un[P]=un[_]=un[y]=un[w]=un[b]=un[I]=un[A]=un[D]=un[E]=un[j]=un[S]=!1;var on={};on[d]=on[v]=on[O]=on[P]=on[m]=on[_]=on[R]=on[k]=on[L]=on[U]=on[F]=on[b]=on[I]=on[A]=on[D]=on[E]=on[j]=on[C]=on[z]=on[B]=on[N]=on[q]=!0,on[y]=on[w]=on[S]=!1;var an={"\\":"\\","'":"'","\n":"n","\r":"r","\u2028":"u2028","\u2029":"u2029"},cn=parseFloat,sn=parseInt,fn="object"==typeof e.g&&e.g&&e.g.Object===Object&&e.g,ln="object"==typeof self&&self&&self.Object===Object&&self,pn=fn||ln||Function("return this")(),hn=n&&!n.nodeType&&n,gn=hn&&t&&!t.nodeType&&t,dn=gn&&gn.exports===hn,vn=dn&&fn.process,mn=function(){try{return gn&&gn.require&&gn.require("util").types||vn&&vn.binding&&vn.binding("util")}catch(t){}}(),_n=mn&&mn.isArrayBuffer,yn=mn&&mn.isDate,wn=mn&&mn.isMap,xn=mn&&mn.isRegExp,bn=mn&&mn.isSet,In=mn&&mn.isTypedArray;function An(t,n,e){switch(e.length){case 0:return t.call(n);case 1:return t.call(n,e[0]);case 2:return t.call(n,e[0],e[1]);case 3:return t.call(n,e[0],e[1],e[2])}return t.apply(n,e)}function Tn(t,n,e,r){for(var i=-1,u=null==t?0:t.length;++i<u;){var o=t[i];n(r,o,e(o),t)}return r}function Dn(t,n){for(var e=-1,r=null==t?0:t.length;++e<r&&!1!==n(t[e],e,t););return t}function En(t,n){for(var e=null==t?0:t.length;e--&&!1!==n(t[e],e,t););return t}function jn(t,n){for(var e=-1,r=null==t?0:t.length;++e<r;)if(!n(t[e],e,t))return!1;return!0}function Cn(t,n){for(var e=-1,r=null==t?0:t.length,i=0,u=[];++e<r;){var o=t[e];n(o,e,t)&&(u[i++]=o)}return u}function Sn(t,n){return!(null==t||!t.length)&&Nn(t,n,0)>-1}function On(t,n,e){for(var r=-1,i=null==t?0:t.length;++r<i;)if(e(n,t[r]))return!0;return!1}function Pn(t,n){for(var e=-1,r=null==t?0:t.length,i=Array(r);++e<r;)i[e]=n(t[e],e,t);return i}function Rn(t,n){for(var e=-1,r=n.length,i=t.length;++e<r;)t[i+e]=n[e];return t}function kn(t,n,e,r){var i=-1,u=null==t?0:t.length;for(r&&u&&(e=t[++i]);++i<u;)e=n(e,t[i],i,t);return e}function Ln(t,n,e,r){var i=null==t?0:t.length;for(r&&i&&(e=t[--i]);i--;)e=n(e,t[i],i,t);return e}function Un(t,n){for(var e=-1,r=null==t?0:t.length;++e<r;)if(n(t[e],e,t))return!0;return!1}var Fn=$n("length");function zn(t,n,e){var r;return e(t,(function(t,e,i){if(n(t,e,i))return r=e,!1})),r}function Bn(t,n,e,r){for(var i=t.length,u=e+(r?1:-1);r?u--:++u<i;)if(n(t[u],u,t))return u;return-1}function Nn(t,n,e){return n==n?function(t,n,e){for(var r=e-1,i=t.length;++r<i;)if(t[r]===n)return r;return-1}(t,n,e):Bn(t,Wn,e)}function qn(t,n,e,r){for(var i=e-1,u=t.length;++i<u;)if(r(t[i],n))return i;return-1}function Wn(t){return t!=t}function Mn(t,n){var e=null==t?0:t.length;return e?Gn(t,n)/e:p}function $n(t){return function(n){return null==n?i:n[t]}}function Vn(t){return function(n){return null==t?i:t[n]}}function Jn(t,n,e,r,i){return i(t,(function(t,i,u){e=r?(r=!1,t):n(e,t,i,u)})),e}function Gn(t,n){for(var e,r=-1,u=t.length;++r<u;){var o=n(t[r]);o!==i&&(e=e===i?o:e+o)}return e}function Xn(t,n){for(var e=-1,r=Array(t);++e<t;)r[e]=n(e);return r}function Hn(t){return t?t.slice(0,pe(t)+1).replace(rt,""):t}function Kn(t){return function(n){return t(n)}}function Yn(t,n){return Pn(n,(function(n){return t[n]}))}function Qn(t,n){return t.has(n)}function Zn(t,n){for(var e=-1,r=t.length;++e<r&&Nn(n,t[e],0)>-1;);return e}function te(t,n){for(var e=t.length;e--&&Nn(n,t[e],0)>-1;);return e}var ne=Vn({À:"A",Á:"A",Â:"A",Ã:"A",Ä:"A",Å:"A",à:"a",á:"a",â:"a",ã:"a",ä:"a",å:"a",Ç:"C",ç:"c",Ð:"D",ð:"d",È:"E",É:"E",Ê:"E",Ë:"E",è:"e",é:"e",ê:"e",ë:"e",Ì:"I",Í:"I",Î:"I",Ï:"I",ì:"i",í:"i",î:"i",ï:"i",Ñ:"N",ñ:"n",Ò:"O",Ó:"O",Ô:"O",Õ:"O",Ö:"O",Ø:"O",ò:"o",ó:"o",ô:"o",õ:"o",ö:"o",ø:"o",Ù:"U",Ú:"U",Û:"U",Ü:"U",ù:"u",ú:"u",û:"u",ü:"u",Ý:"Y",ý:"y",ÿ:"y",Æ:"Ae",æ:"ae",Þ:"Th",þ:"th",ß:"ss",Ā:"A",Ă:"A",Ą:"A",ā:"a",ă:"a",ą:"a",Ć:"C",Ĉ:"C",Ċ:"C",Č:"C",ć:"c",ĉ:"c",ċ:"c",č:"c",Ď:"D",Đ:"D",ď:"d",đ:"d",Ē:"E",Ĕ:"E",Ė:"E",Ę:"E",Ě:"E",ē:"e",ĕ:"e",ė:"e",ę:"e",ě:"e",Ĝ:"G",Ğ:"G",Ġ:"G",Ģ:"G",ĝ:"g",ğ:"g",ġ:"g",ģ:"g",Ĥ:"H",Ħ:"H",ĥ:"h",ħ:"h",Ĩ:"I",Ī:"I",Ĭ:"I",Į:"I",İ:"I",ĩ:"i",ī:"i",ĭ:"i",į:"i",ı:"i",Ĵ:"J",ĵ:"j",Ķ:"K",ķ:"k",ĸ:"k",Ĺ:"L",Ļ:"L",Ľ:"L",Ŀ:"L",Ł:"L",ĺ:"l",ļ:"l",ľ:"l",ŀ:"l",ł:"l",Ń:"N",Ņ:"N",Ň:"N",Ŋ:"N",ń:"n",ņ:"n",ň:"n",ŋ:"n",Ō:"O",Ŏ:"O",Ő:"O",ō:"o",ŏ:"o",ő:"o",Ŕ:"R",Ŗ:"R",Ř:"R",ŕ:"r",ŗ:"r",ř:"r",Ś:"S",Ŝ:"S",Ş:"S",Š:"S",ś:"s",ŝ:"s",ş:"s",š:"s",Ţ:"T",Ť:"T",Ŧ:"T",ţ:"t",ť:"t",ŧ:"t",Ũ:"U",Ū:"U",Ŭ:"U",Ů:"U",Ű:"U",Ų:"U",ũ:"u",ū:"u",ŭ:"u",ů:"u",ű:"u",ų:"u",Ŵ:"W",ŵ:"w",Ŷ:"Y",ŷ:"y",Ÿ:"Y",Ź:"Z",Ż:"Z",Ž:"Z",ź:"z",ż:"z",ž:"z",Ĳ:"IJ",ĳ:"ij",Œ:"Oe",œ:"oe",ŉ:"'n",ſ:"s"}),ee=Vn({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"});function re(t){return"\\"+an[t]}function ie(t){return tn.test(t)}function ue(t){var n=-1,e=Array(t.size);return t.forEach((function(t,r){e[++n]=[r,t]})),e}function oe(t,n){return function(e){return t(n(e))}}function ae(t,n){for(var e=-1,r=t.length,i=0,u=[];++e<r;){var o=t[e];o!==n&&o!==a||(t[e]=a,u[i++]=e)}return u}function ce(t){var n=-1,e=Array(t.size);return t.forEach((function(t){e[++n]=t})),e}function se(t){var n=-1,e=Array(t.size);return t.forEach((function(t){e[++n]=[t,t]})),e}function fe(t){return ie(t)?function(t){for(var n=Qt.lastIndex=0;Qt.test(t);)++n;return n}(t):Fn(t)}function le(t){return ie(t)?function(t){return t.match(Qt)||[]}(t):function(t){return t.split("")}(t)}function pe(t){for(var n=t.length;n--&&it.test(t.charAt(n)););return n}var he=Vn({"&amp;":"&","&lt;":"<","&gt;":">","&quot;":'"',"&#39;":"'"}),ge=function t(n){var e,r=(n=null==n?pn:ge.defaults(pn.Object(),n,ge.pick(pn,en))).Array,it=n.Date,xt=n.Error,bt=n.Function,It=n.Math,At=n.Object,Tt=n.RegExp,Dt=n.String,Et=n.TypeError,jt=r.prototype,Ct=bt.prototype,St=At.prototype,Ot=n["__core-js_shared__"],Pt=Ct.toString,Rt=St.hasOwnProperty,kt=0,Lt=(e=/[^.]+$/.exec(Ot&&Ot.keys&&Ot.keys.IE_PROTO||""))?"Symbol(src)_1."+e:"",Ut=St.toString,Ft=Pt.call(At),zt=pn._,Bt=Tt("^"+Pt.call(Rt).replace(nt,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),Nt=dn?n.Buffer:i,qt=n.Symbol,Wt=n.Uint8Array,Mt=Nt?Nt.allocUnsafe:i,$t=oe(At.getPrototypeOf,At),Vt=At.create,Jt=St.propertyIsEnumerable,Gt=jt.splice,Xt=qt?qt.isConcatSpreadable:i,Ht=qt?qt.iterator:i,Qt=qt?qt.toStringTag:i,tn=function(){try{var t=cu(At,"defineProperty");return t({},"",{}),t}catch(t){}}(),an=n.clearTimeout!==pn.clearTimeout&&n.clearTimeout,fn=it&&it.now!==pn.Date.now&&it.now,ln=n.setTimeout!==pn.setTimeout&&n.setTimeout,hn=It.ceil,gn=It.floor,vn=At.getOwnPropertySymbols,mn=Nt?Nt.isBuffer:i,Fn=n.isFinite,Vn=jt.join,de=oe(At.keys,At),ve=It.max,me=It.min,_e=it.now,ye=n.parseInt,we=It.random,xe=jt.reverse,be=cu(n,"DataView"),Ie=cu(n,"Map"),Ae=cu(n,"Promise"),Te=cu(n,"Set"),De=cu(n,"WeakMap"),Ee=cu(At,"create"),je=De&&new De,Ce={},Se=Uu(be),Oe=Uu(Ie),Pe=Uu(Ae),Re=Uu(Te),ke=Uu(De),Le=qt?qt.prototype:i,Ue=Le?Le.valueOf:i,Fe=Le?Le.toString:i;function ze(t){if(ta(t)&&!Mo(t)&&!(t instanceof We)){if(t instanceof qe)return t;if(Rt.call(t,"__wrapped__"))return Fu(t)}return new qe(t)}var Be=function(){function t(){}return function(n){if(!Zo(n))return{};if(Vt)return Vt(n);t.prototype=n;var e=new t;return t.prototype=i,e}}();function Ne(){}function qe(t,n){this.__wrapped__=t,this.__actions__=[],this.__chain__=!!n,this.__index__=0,this.__values__=i}function We(t){this.__wrapped__=t,this.__actions__=[],this.__dir__=1,this.__filtered__=!1,this.__iteratees__=[],this.__takeCount__=h,this.__views__=[]}function Me(t){var n=-1,e=null==t?0:t.length;for(this.clear();++n<e;){var r=t[n];this.set(r[0],r[1])}}function $e(t){var n=-1,e=null==t?0:t.length;for(this.clear();++n<e;){var r=t[n];this.set(r[0],r[1])}}function Ve(t){var n=-1,e=null==t?0:t.length;for(this.clear();++n<e;){var r=t[n];this.set(r[0],r[1])}}function Je(t){var n=-1,e=null==t?0:t.length;for(this.__data__=new Ve;++n<e;)this.add(t[n])}function Ge(t){var n=this.__data__=new $e(t);this.size=n.size}function Xe(t,n){var e=Mo(t),r=!e&&Wo(t),i=!e&&!r&&Go(t),u=!e&&!r&&!i&&ca(t),o=e||r||i||u,a=o?Xn(t.length,Dt):[],c=a.length;for(var s in t)!n&&!Rt.call(t,s)||o&&("length"==s||i&&("offset"==s||"parent"==s)||u&&("buffer"==s||"byteLength"==s||"byteOffset"==s)||du(s,c))||a.push(s);return a}function He(t){var n=t.length;return n?t[Vr(0,n-1)]:i}function Ke(t,n){return Ou(Di(t),ur(n,0,t.length))}function Ye(t){return Ou(Di(t))}function Qe(t,n,e){(e!==i&&!Bo(t[n],e)||e===i&&!(n in t))&&rr(t,n,e)}function Ze(t,n,e){var r=t[n];Rt.call(t,n)&&Bo(r,e)&&(e!==i||n in t)||rr(t,n,e)}function tr(t,n){for(var e=t.length;e--;)if(Bo(t[e][0],n))return e;return-1}function nr(t,n,e,r){return fr(t,(function(t,i,u){n(r,t,e(t),u)})),r}function er(t,n){return t&&Ei(n,Sa(n),t)}function rr(t,n,e){"__proto__"==n&&tn?tn(t,n,{configurable:!0,enumerable:!0,value:e,writable:!0}):t[n]=e}function ir(t,n){for(var e=-1,u=n.length,o=r(u),a=null==t;++e<u;)o[e]=a?i:Ta(t,n[e]);return o}function ur(t,n,e){return t==t&&(e!==i&&(t=t<=e?t:e),n!==i&&(t=t>=n?t:n)),t}function or(t,n,e,r,u,o){var a,c=1&n,s=2&n,f=4&n;if(e&&(a=u?e(t,r,u,o):e(t)),a!==i)return a;if(!Zo(t))return t;var l=Mo(t);if(l){if(a=function(t){var n=t.length,e=new t.constructor(n);return n&&"string"==typeof t[0]&&Rt.call(t,"index")&&(e.index=t.index,e.input=t.input),e}(t),!c)return Di(t,a)}else{var p=lu(t),h=p==w||p==x;if(Go(t))return wi(t,c);if(p==A||p==d||h&&!u){if(a=s||h?{}:hu(t),!c)return s?function(t,n){return Ei(t,fu(t),n)}(t,function(t,n){return t&&Ei(n,Oa(n),t)}(a,t)):function(t,n){return Ei(t,su(t),n)}(t,er(a,t))}else{if(!on[p])return u?t:{};a=function(t,n,e){var r,i=t.constructor;switch(n){case O:return xi(t);case m:case _:return new i(+t);case P:return function(t,n){var e=n?xi(t.buffer):t.buffer;return new t.constructor(e,t.byteOffset,t.byteLength)}(t,e);case R:case k:case L:case U:case F:case z:case B:case N:case q:return bi(t,e);case b:return new i;case I:case j:return new i(t);case D:return function(t){var n=new t.constructor(t.source,pt.exec(t));return n.lastIndex=t.lastIndex,n}(t);case E:return new i;case C:return r=t,Ue?At(Ue.call(r)):{}}}(t,p,c)}}o||(o=new Ge);var g=o.get(t);if(g)return g;o.set(t,a),ua(t)?t.forEach((function(r){a.add(or(r,n,e,r,t,o))})):na(t)&&t.forEach((function(r,i){a.set(i,or(r,n,e,i,t,o))}));var v=l?i:(f?s?nu:tu:s?Oa:Sa)(t);return Dn(v||t,(function(r,i){v&&(r=t[i=r]),Ze(a,i,or(r,n,e,i,t,o))})),a}function ar(t,n,e){var r=e.length;if(null==t)return!r;for(t=At(t);r--;){var u=e[r],o=n[u],a=t[u];if(a===i&&!(u in t)||!o(a))return!1}return!0}function cr(t,n,e){if("function"!=typeof t)throw new Et(u);return Eu((function(){t.apply(i,e)}),n)}function sr(t,n,e,r){var i=-1,u=Sn,o=!0,a=t.length,c=[],s=n.length;if(!a)return c;e&&(n=Pn(n,Kn(e))),r?(u=On,o=!1):n.length>=200&&(u=Qn,o=!1,n=new Je(n));t:for(;++i<a;){var f=t[i],l=null==e?f:e(f);if(f=r||0!==f?f:0,o&&l==l){for(var p=s;p--;)if(n[p]===l)continue t;c.push(f)}else u(n,l,r)||c.push(f)}return c}ze.templateSettings={escape:H,evaluate:K,interpolate:Y,variable:"",imports:{_:ze}},ze.prototype=Ne.prototype,ze.prototype.constructor=ze,qe.prototype=Be(Ne.prototype),qe.prototype.constructor=qe,We.prototype=Be(Ne.prototype),We.prototype.constructor=We,Me.prototype.clear=function(){this.__data__=Ee?Ee(null):{},this.size=0},Me.prototype.delete=function(t){var n=this.has(t)&&delete this.__data__[t];return this.size-=n?1:0,n},Me.prototype.get=function(t){var n=this.__data__;if(Ee){var e=n[t];return e===o?i:e}return Rt.call(n,t)?n[t]:i},Me.prototype.has=function(t){var n=this.__data__;return Ee?n[t]!==i:Rt.call(n,t)},Me.prototype.set=function(t,n){var e=this.__data__;return this.size+=this.has(t)?0:1,e[t]=Ee&&n===i?o:n,this},$e.prototype.clear=function(){this.__data__=[],this.size=0},$e.prototype.delete=function(t){var n=this.__data__,e=tr(n,t);return!(e<0||(e==n.length-1?n.pop():Gt.call(n,e,1),--this.size,0))},$e.prototype.get=function(t){var n=this.__data__,e=tr(n,t);return e<0?i:n[e][1]},$e.prototype.has=function(t){return tr(this.__data__,t)>-1},$e.prototype.set=function(t,n){var e=this.__data__,r=tr(e,t);return r<0?(++this.size,e.push([t,n])):e[r][1]=n,this},Ve.prototype.clear=function(){this.size=0,this.__data__={hash:new Me,map:new(Ie||$e),string:new Me}},Ve.prototype.delete=function(t){var n=ou(this,t).delete(t);return this.size-=n?1:0,n},Ve.prototype.get=function(t){return ou(this,t).get(t)},Ve.prototype.has=function(t){return ou(this,t).has(t)},Ve.prototype.set=function(t,n){var e=ou(this,t),r=e.size;return e.set(t,n),this.size+=e.size==r?0:1,this},Je.prototype.add=Je.prototype.push=function(t){return this.__data__.set(t,o),this},Je.prototype.has=function(t){return this.__data__.has(t)},Ge.prototype.clear=function(){this.__data__=new $e,this.size=0},Ge.prototype.delete=function(t){var n=this.__data__,e=n.delete(t);return this.size=n.size,e},Ge.prototype.get=function(t){return this.__data__.get(t)},Ge.prototype.has=function(t){return this.__data__.has(t)},Ge.prototype.set=function(t,n){var e=this.__data__;if(e instanceof $e){var r=e.__data__;if(!Ie||r.length<199)return r.push([t,n]),this.size=++e.size,this;e=this.__data__=new Ve(r)}return e.set(t,n),this.size=e.size,this};var fr=Si(_r),lr=Si(yr,!0);function pr(t,n){var e=!0;return fr(t,(function(t,r,i){return e=!!n(t,r,i)})),e}function hr(t,n,e){for(var r=-1,u=t.length;++r<u;){var o=t[r],a=n(o);if(null!=a&&(c===i?a==a&&!aa(a):e(a,c)))var c=a,s=o}return s}function gr(t,n){var e=[];return fr(t,(function(t,r,i){n(t,r,i)&&e.push(t)})),e}function dr(t,n,e,r,i){var u=-1,o=t.length;for(e||(e=gu),i||(i=[]);++u<o;){var a=t[u];n>0&&e(a)?n>1?dr(a,n-1,e,r,i):Rn(i,a):r||(i[i.length]=a)}return i}var vr=Oi(),mr=Oi(!0);function _r(t,n){return t&&vr(t,n,Sa)}function yr(t,n){return t&&mr(t,n,Sa)}function wr(t,n){return Cn(n,(function(n){return Ko(t[n])}))}function xr(t,n){for(var e=0,r=(n=vi(n,t)).length;null!=t&&e<r;)t=t[Lu(n[e++])];return e&&e==r?t:i}function br(t,n,e){var r=n(t);return Mo(t)?r:Rn(r,e(t))}function Ir(t){return null==t?t===i?"[object Undefined]":"[object Null]":Qt&&Qt in At(t)?function(t){var n=Rt.call(t,Qt),e=t[Qt];try{t[Qt]=i;var r=!0}catch(t){}var u=Ut.call(t);return r&&(n?t[Qt]=e:delete t[Qt]),u}(t):function(t){return Ut.call(t)}(t)}function Ar(t,n){return t>n}function Tr(t,n){return null!=t&&Rt.call(t,n)}function Dr(t,n){return null!=t&&n in At(t)}function Er(t,n,e){for(var u=e?On:Sn,o=t[0].length,a=t.length,c=a,s=r(a),f=1/0,l=[];c--;){var p=t[c];c&&n&&(p=Pn(p,Kn(n))),f=me(p.length,f),s[c]=!e&&(n||o>=120&&p.length>=120)?new Je(c&&p):i}p=t[0];var h=-1,g=s[0];t:for(;++h<o&&l.length<f;){var d=p[h],v=n?n(d):d;if(d=e||0!==d?d:0,!(g?Qn(g,v):u(l,v,e))){for(c=a;--c;){var m=s[c];if(!(m?Qn(m,v):u(t[c],v,e)))continue t}g&&g.push(v),l.push(d)}}return l}function jr(t,n,e){var r=null==(t=Au(t,n=vi(n,t)))?t:t[Lu(Xu(n))];return null==r?i:An(r,t,e)}function Cr(t){return ta(t)&&Ir(t)==d}function Sr(t,n,e,r,u){return t===n||(null==t||null==n||!ta(t)&&!ta(n)?t!=t&&n!=n:function(t,n,e,r,u,o){var a=Mo(t),c=Mo(n),s=a?v:lu(t),f=c?v:lu(n),l=(s=s==d?A:s)==A,p=(f=f==d?A:f)==A,h=s==f;if(h&&Go(t)){if(!Go(n))return!1;a=!0,l=!1}if(h&&!l)return o||(o=new Ge),a||ca(t)?Qi(t,n,e,r,u,o):function(t,n,e,r,i,u,o){switch(e){case P:if(t.byteLength!=n.byteLength||t.byteOffset!=n.byteOffset)return!1;t=t.buffer,n=n.buffer;case O:return!(t.byteLength!=n.byteLength||!u(new Wt(t),new Wt(n)));case m:case _:case I:return Bo(+t,+n);case y:return t.name==n.name&&t.message==n.message;case D:case j:return t==n+"";case b:var a=ue;case E:var c=1&r;if(a||(a=ce),t.size!=n.size&&!c)return!1;var s=o.get(t);if(s)return s==n;r|=2,o.set(t,n);var f=Qi(a(t),a(n),r,i,u,o);return o.delete(t),f;case C:if(Ue)return Ue.call(t)==Ue.call(n)}return!1}(t,n,s,e,r,u,o);if(!(1&e)){var g=l&&Rt.call(t,"__wrapped__"),w=p&&Rt.call(n,"__wrapped__");if(g||w){var x=g?t.value():t,T=w?n.value():n;return o||(o=new Ge),u(x,T,e,r,o)}}return!!h&&(o||(o=new Ge),function(t,n,e,r,u,o){var a=1&e,c=tu(t),s=c.length;if(s!=tu(n).length&&!a)return!1;for(var f=s;f--;){var l=c[f];if(!(a?l in n:Rt.call(n,l)))return!1}var p=o.get(t),h=o.get(n);if(p&&h)return p==n&&h==t;var g=!0;o.set(t,n),o.set(n,t);for(var d=a;++f<s;){var v=t[l=c[f]],m=n[l];if(r)var _=a?r(m,v,l,n,t,o):r(v,m,l,t,n,o);if(!(_===i?v===m||u(v,m,e,r,o):_)){g=!1;break}d||(d="constructor"==l)}if(g&&!d){var y=t.constructor,w=n.constructor;y==w||!("constructor"in t)||!("constructor"in n)||"function"==typeof y&&y instanceof y&&"function"==typeof w&&w instanceof w||(g=!1)}return o.delete(t),o.delete(n),g}(t,n,e,r,u,o))}(t,n,e,r,Sr,u))}function Or(t,n,e,r){var u=e.length,o=u,a=!r;if(null==t)return!o;for(t=At(t);u--;){var c=e[u];if(a&&c[2]?c[1]!==t[c[0]]:!(c[0]in t))return!1}for(;++u<o;){var s=(c=e[u])[0],f=t[s],l=c[1];if(a&&c[2]){if(f===i&&!(s in t))return!1}else{var p=new Ge;if(r)var h=r(f,l,s,t,n,p);if(!(h===i?Sr(l,f,3,r,p):h))return!1}}return!0}function Pr(t){return!(!Zo(t)||(n=t,Lt&&Lt in n))&&(Ko(t)?Bt:dt).test(Uu(t));var n}function Rr(t){return"function"==typeof t?t:null==t?ec:"object"==typeof t?Mo(t)?zr(t[0],t[1]):Fr(t):lc(t)}function kr(t){if(!wu(t))return de(t);var n=[];for(var e in At(t))Rt.call(t,e)&&"constructor"!=e&&n.push(e);return n}function Lr(t,n){return t<n}function Ur(t,n){var e=-1,i=Vo(t)?r(t.length):[];return fr(t,(function(t,r,u){i[++e]=n(t,r,u)})),i}function Fr(t){var n=au(t);return 1==n.length&&n[0][2]?bu(n[0][0],n[0][1]):function(e){return e===t||Or(e,t,n)}}function zr(t,n){return mu(t)&&xu(n)?bu(Lu(t),n):function(e){var r=Ta(e,t);return r===i&&r===n?Da(e,t):Sr(n,r,3)}}function Br(t,n,e,r,u){t!==n&&vr(n,(function(o,a){if(u||(u=new Ge),Zo(o))!function(t,n,e,r,u,o,a){var c=Tu(t,e),s=Tu(n,e),f=a.get(s);if(f)Qe(t,e,f);else{var l=o?o(c,s,e+"",t,n,a):i,p=l===i;if(p){var h=Mo(s),g=!h&&Go(s),d=!h&&!g&&ca(s);l=s,h||g||d?Mo(c)?l=c:Jo(c)?l=Di(c):g?(p=!1,l=wi(s,!0)):d?(p=!1,l=bi(s,!0)):l=[]:ra(s)||Wo(s)?(l=c,Wo(c)?l=va(c):Zo(c)&&!Ko(c)||(l=hu(s))):p=!1}p&&(a.set(s,l),u(l,s,r,o,a),a.delete(s)),Qe(t,e,l)}}(t,n,a,e,Br,r,u);else{var c=r?r(Tu(t,a),o,a+"",t,n,u):i;c===i&&(c=o),Qe(t,a,c)}}),Oa)}function Nr(t,n){var e=t.length;if(e)return du(n+=n<0?e:0,e)?t[n]:i}function qr(t,n,e){n=n.length?Pn(n,(function(t){return Mo(t)?function(n){return xr(n,1===t.length?t[0]:t)}:t})):[ec];var r=-1;n=Pn(n,Kn(uu()));var i=Ur(t,(function(t,e,i){var u=Pn(n,(function(n){return n(t)}));return{criteria:u,index:++r,value:t}}));return function(t){var n=t.length;for(t.sort((function(t,n){return function(t,n,e){for(var r=-1,i=t.criteria,u=n.criteria,o=i.length,a=e.length;++r<o;){var c=Ii(i[r],u[r]);if(c)return r>=a?c:c*("desc"==e[r]?-1:1)}return t.index-n.index}(t,n,e)}));n--;)t[n]=t[n].value;return t}(i)}function Wr(t,n,e){for(var r=-1,i=n.length,u={};++r<i;){var o=n[r],a=xr(t,o);e(a,o)&&Kr(u,vi(o,t),a)}return u}function Mr(t,n,e,r){var i=r?qn:Nn,u=-1,o=n.length,a=t;for(t===n&&(n=Di(n)),e&&(a=Pn(t,Kn(e)));++u<o;)for(var c=0,s=n[u],f=e?e(s):s;(c=i(a,f,c,r))>-1;)a!==t&&Gt.call(a,c,1),Gt.call(t,c,1);return t}function $r(t,n){for(var e=t?n.length:0,r=e-1;e--;){var i=n[e];if(e==r||i!==u){var u=i;du(i)?Gt.call(t,i,1):ci(t,i)}}return t}function Vr(t,n){return t+gn(we()*(n-t+1))}function Jr(t,n){var e="";if(!t||n<1||n>l)return e;do{n%2&&(e+=t),(n=gn(n/2))&&(t+=t)}while(n);return e}function Gr(t,n){return ju(Iu(t,n,ec),t+"")}function Xr(t){return He(Ba(t))}function Hr(t,n){var e=Ba(t);return Ou(e,ur(n,0,e.length))}function Kr(t,n,e,r){if(!Zo(t))return t;for(var u=-1,o=(n=vi(n,t)).length,a=o-1,c=t;null!=c&&++u<o;){var s=Lu(n[u]),f=e;if("__proto__"===s||"constructor"===s||"prototype"===s)return t;if(u!=a){var l=c[s];(f=r?r(l,s,c):i)===i&&(f=Zo(l)?l:du(n[u+1])?[]:{})}Ze(c,s,f),c=c[s]}return t}var Yr=je?function(t,n){return je.set(t,n),t}:ec,Qr=tn?function(t,n){return tn(t,"toString",{configurable:!0,enumerable:!1,value:Za(n),writable:!0})}:ec;function Zr(t){return Ou(Ba(t))}function ti(t,n,e){var i=-1,u=t.length;n<0&&(n=-n>u?0:u+n),(e=e>u?u:e)<0&&(e+=u),u=n>e?0:e-n>>>0,n>>>=0;for(var o=r(u);++i<u;)o[i]=t[i+n];return o}function ni(t,n){var e;return fr(t,(function(t,r,i){return!(e=n(t,r,i))})),!!e}function ei(t,n,e){var r=0,i=null==t?r:t.length;if("number"==typeof n&&n==n&&i<=2147483647){for(;r<i;){var u=r+i>>>1,o=t[u];null!==o&&!aa(o)&&(e?o<=n:o<n)?r=u+1:i=u}return i}return ri(t,n,ec,e)}function ri(t,n,e,r){var u=0,o=null==t?0:t.length;if(0===o)return 0;for(var a=(n=e(n))!=n,c=null===n,s=aa(n),f=n===i;u<o;){var l=gn((u+o)/2),p=e(t[l]),h=p!==i,g=null===p,d=p==p,v=aa(p);if(a)var m=r||d;else m=f?d&&(r||h):c?d&&h&&(r||!g):s?d&&h&&!g&&(r||!v):!g&&!v&&(r?p<=n:p<n);m?u=l+1:o=l}return me(o,4294967294)}function ii(t,n){for(var e=-1,r=t.length,i=0,u=[];++e<r;){var o=t[e],a=n?n(o):o;if(!e||!Bo(a,c)){var c=a;u[i++]=0===o?0:o}}return u}function ui(t){return"number"==typeof t?t:aa(t)?p:+t}function oi(t){if("string"==typeof t)return t;if(Mo(t))return Pn(t,oi)+"";if(aa(t))return Fe?Fe.call(t):"";var n=t+"";return"0"==n&&1/t==-1/0?"-0":n}function ai(t,n,e){var r=-1,i=Sn,u=t.length,o=!0,a=[],c=a;if(e)o=!1,i=On;else if(u>=200){var s=n?null:Ji(t);if(s)return ce(s);o=!1,i=Qn,c=new Je}else c=n?[]:a;t:for(;++r<u;){var f=t[r],l=n?n(f):f;if(f=e||0!==f?f:0,o&&l==l){for(var p=c.length;p--;)if(c[p]===l)continue t;n&&c.push(l),a.push(f)}else i(c,l,e)||(c!==a&&c.push(l),a.push(f))}return a}function ci(t,n){return null==(t=Au(t,n=vi(n,t)))||delete t[Lu(Xu(n))]}function si(t,n,e,r){return Kr(t,n,e(xr(t,n)),r)}function fi(t,n,e,r){for(var i=t.length,u=r?i:-1;(r?u--:++u<i)&&n(t[u],u,t););return e?ti(t,r?0:u,r?u+1:i):ti(t,r?u+1:0,r?i:u)}function li(t,n){var e=t;return e instanceof We&&(e=e.value()),kn(n,(function(t,n){return n.func.apply(n.thisArg,Rn([t],n.args))}),e)}function pi(t,n,e){var i=t.length;if(i<2)return i?ai(t[0]):[];for(var u=-1,o=r(i);++u<i;)for(var a=t[u],c=-1;++c<i;)c!=u&&(o[u]=sr(o[u]||a,t[c],n,e));return ai(dr(o,1),n,e)}function hi(t,n,e){for(var r=-1,u=t.length,o=n.length,a={};++r<u;){var c=r<o?n[r]:i;e(a,t[r],c)}return a}function gi(t){return Jo(t)?t:[]}function di(t){return"function"==typeof t?t:ec}function vi(t,n){return Mo(t)?t:mu(t,n)?[t]:ku(ma(t))}var mi=Gr;function _i(t,n,e){var r=t.length;return e=e===i?r:e,!n&&e>=r?t:ti(t,n,e)}var yi=an||function(t){return pn.clearTimeout(t)};function wi(t,n){if(n)return t.slice();var e=t.length,r=Mt?Mt(e):new t.constructor(e);return t.copy(r),r}function xi(t){var n=new t.constructor(t.byteLength);return new Wt(n).set(new Wt(t)),n}function bi(t,n){var e=n?xi(t.buffer):t.buffer;return new t.constructor(e,t.byteOffset,t.length)}function Ii(t,n){if(t!==n){var e=t!==i,r=null===t,u=t==t,o=aa(t),a=n!==i,c=null===n,s=n==n,f=aa(n);if(!c&&!f&&!o&&t>n||o&&a&&s&&!c&&!f||r&&a&&s||!e&&s||!u)return 1;if(!r&&!o&&!f&&t<n||f&&e&&u&&!r&&!o||c&&e&&u||!a&&u||!s)return-1}return 0}function Ai(t,n,e,i){for(var u=-1,o=t.length,a=e.length,c=-1,s=n.length,f=ve(o-a,0),l=r(s+f),p=!i;++c<s;)l[c]=n[c];for(;++u<a;)(p||u<o)&&(l[e[u]]=t[u]);for(;f--;)l[c++]=t[u++];return l}function Ti(t,n,e,i){for(var u=-1,o=t.length,a=-1,c=e.length,s=-1,f=n.length,l=ve(o-c,0),p=r(l+f),h=!i;++u<l;)p[u]=t[u];for(var g=u;++s<f;)p[g+s]=n[s];for(;++a<c;)(h||u<o)&&(p[g+e[a]]=t[u++]);return p}function Di(t,n){var e=-1,i=t.length;for(n||(n=r(i));++e<i;)n[e]=t[e];return n}function Ei(t,n,e,r){var u=!e;e||(e={});for(var o=-1,a=n.length;++o<a;){var c=n[o],s=r?r(e[c],t[c],c,e,t):i;s===i&&(s=t[c]),u?rr(e,c,s):Ze(e,c,s)}return e}function ji(t,n){return function(e,r){var i=Mo(e)?Tn:nr,u=n?n():{};return i(e,t,uu(r,2),u)}}function Ci(t){return Gr((function(n,e){var r=-1,u=e.length,o=u>1?e[u-1]:i,a=u>2?e[2]:i;for(o=t.length>3&&"function"==typeof o?(u--,o):i,a&&vu(e[0],e[1],a)&&(o=u<3?i:o,u=1),n=At(n);++r<u;){var c=e[r];c&&t(n,c,r,o)}return n}))}function Si(t,n){return function(e,r){if(null==e)return e;if(!Vo(e))return t(e,r);for(var i=e.length,u=n?i:-1,o=At(e);(n?u--:++u<i)&&!1!==r(o[u],u,o););return e}}function Oi(t){return function(n,e,r){for(var i=-1,u=At(n),o=r(n),a=o.length;a--;){var c=o[t?a:++i];if(!1===e(u[c],c,u))break}return n}}function Pi(t){return function(n){var e=ie(n=ma(n))?le(n):i,r=e?e[0]:n.charAt(0),u=e?_i(e,1).join(""):n.slice(1);return r[t]()+u}}function Ri(t){return function(n){return kn(Ka(Wa(n).replace(Kt,"")),t,"")}}function ki(t){return function(){var n=arguments;switch(n.length){case 0:return new t;case 1:return new t(n[0]);case 2:return new t(n[0],n[1]);case 3:return new t(n[0],n[1],n[2]);case 4:return new t(n[0],n[1],n[2],n[3]);case 5:return new t(n[0],n[1],n[2],n[3],n[4]);case 6:return new t(n[0],n[1],n[2],n[3],n[4],n[5]);case 7:return new t(n[0],n[1],n[2],n[3],n[4],n[5],n[6])}var e=Be(t.prototype),r=t.apply(e,n);return Zo(r)?r:e}}function Li(t){return function(n,e,r){var u=At(n);if(!Vo(n)){var o=uu(e,3);n=Sa(n),e=function(t){return o(u[t],t,u)}}var a=t(n,e,r);return a>-1?u[o?n[a]:a]:i}}function Ui(t){return Zi((function(n){var e=n.length,r=e,o=qe.prototype.thru;for(t&&n.reverse();r--;){var a=n[r];if("function"!=typeof a)throw new Et(u);if(o&&!c&&"wrapper"==ru(a))var c=new qe([],!0)}for(r=c?r:e;++r<e;){var s=ru(a=n[r]),f="wrapper"==s?eu(a):i;c=f&&_u(f[0])&&424==f[1]&&!f[4].length&&1==f[9]?c[ru(f[0])].apply(c,f[3]):1==a.length&&_u(a)?c[s]():c.thru(a)}return function(){var t=arguments,r=t[0];if(c&&1==t.length&&Mo(r))return c.plant(r).value();for(var i=0,u=e?n[i].apply(this,t):r;++i<e;)u=n[i].call(this,u);return u}}))}function Fi(t,n,e,u,o,a,c,f,l,p){var h=n&s,g=1&n,d=2&n,v=24&n,m=512&n,_=d?i:ki(t);return function s(){for(var y=arguments.length,w=r(y),x=y;x--;)w[x]=arguments[x];if(v)var b=iu(s),I=function(t,n){for(var e=t.length,r=0;e--;)t[e]===n&&++r;return r}(w,b);if(u&&(w=Ai(w,u,o,v)),a&&(w=Ti(w,a,c,v)),y-=I,v&&y<p){var A=ae(w,b);return $i(t,n,Fi,s.placeholder,e,w,A,f,l,p-y)}var T=g?e:this,D=d?T[t]:t;return y=w.length,f?w=function(t,n){for(var e=t.length,r=me(n.length,e),u=Di(t);r--;){var o=n[r];t[r]=du(o,e)?u[o]:i}return t}(w,f):m&&y>1&&w.reverse(),h&&l<y&&(w.length=l),this&&this!==pn&&this instanceof s&&(D=_||ki(D)),D.apply(T,w)}}function zi(t,n){return function(e,r){return function(t,n,e,r){return _r(t,(function(t,i,u){n(r,e(t),i,u)})),r}(e,t,n(r),{})}}function Bi(t,n){return function(e,r){var u;if(e===i&&r===i)return n;if(e!==i&&(u=e),r!==i){if(u===i)return r;"string"==typeof e||"string"==typeof r?(e=oi(e),r=oi(r)):(e=ui(e),r=ui(r)),u=t(e,r)}return u}}function Ni(t){return Zi((function(n){return n=Pn(n,Kn(uu())),Gr((function(e){var r=this;return t(n,(function(t){return An(t,r,e)}))}))}))}function qi(t,n){var e=(n=n===i?" ":oi(n)).length;if(e<2)return e?Jr(n,t):n;var r=Jr(n,hn(t/fe(n)));return ie(n)?_i(le(r),0,t).join(""):r.slice(0,t)}function Wi(t){return function(n,e,u){return u&&"number"!=typeof u&&vu(n,e,u)&&(e=u=i),n=pa(n),e===i?(e=n,n=0):e=pa(e),function(t,n,e,i){for(var u=-1,o=ve(hn((n-t)/(e||1)),0),a=r(o);o--;)a[i?o:++u]=t,t+=e;return a}(n,e,u=u===i?n<e?1:-1:pa(u),t)}}function Mi(t){return function(n,e){return"string"==typeof n&&"string"==typeof e||(n=da(n),e=da(e)),t(n,e)}}function $i(t,n,e,r,u,o,a,s,f,l){var p=8&n;n|=p?c:64,4&(n&=~(p?64:c))||(n&=-4);var h=[t,n,u,p?o:i,p?a:i,p?i:o,p?i:a,s,f,l],g=e.apply(i,h);return _u(t)&&Du(g,h),g.placeholder=r,Cu(g,t,n)}function Vi(t){var n=It[t];return function(t,e){if(t=da(t),(e=null==e?0:me(ha(e),292))&&Fn(t)){var r=(ma(t)+"e").split("e");return+((r=(ma(n(r[0]+"e"+(+r[1]+e)))+"e").split("e"))[0]+"e"+(+r[1]-e))}return n(t)}}var Ji=Te&&1/ce(new Te([,-0]))[1]==f?function(t){return new Te(t)}:ac;function Gi(t){return function(n){var e=lu(n);return e==b?ue(n):e==E?se(n):function(t,n){return Pn(n,(function(n){return[n,t[n]]}))}(n,t(n))}}function Xi(t,n,e,o,f,l,p,h){var g=2&n;if(!g&&"function"!=typeof t)throw new Et(u);var d=o?o.length:0;if(d||(n&=-97,o=f=i),p=p===i?p:ve(ha(p),0),h=h===i?h:ha(h),d-=f?f.length:0,64&n){var v=o,m=f;o=f=i}var _=g?i:eu(t),y=[t,n,e,o,f,v,m,l,p,h];if(_&&function(t,n){var e=t[1],r=n[1],i=e|r,u=i<131,o=r==s&&8==e||r==s&&256==e&&t[7].length<=n[8]||384==r&&n[7].length<=n[8]&&8==e;if(!u&&!o)return t;1&r&&(t[2]=n[2],i|=1&e?0:4);var c=n[3];if(c){var f=t[3];t[3]=f?Ai(f,c,n[4]):c,t[4]=f?ae(t[3],a):n[4]}(c=n[5])&&(f=t[5],t[5]=f?Ti(f,c,n[6]):c,t[6]=f?ae(t[5],a):n[6]),(c=n[7])&&(t[7]=c),r&s&&(t[8]=null==t[8]?n[8]:me(t[8],n[8])),null==t[9]&&(t[9]=n[9]),t[0]=n[0],t[1]=i}(y,_),t=y[0],n=y[1],e=y[2],o=y[3],f=y[4],!(h=y[9]=y[9]===i?g?0:t.length:ve(y[9]-d,0))&&24&n&&(n&=-25),n&&1!=n)w=8==n||16==n?function(t,n,e){var u=ki(t);return function o(){for(var a=arguments.length,c=r(a),s=a,f=iu(o);s--;)c[s]=arguments[s];var l=a<3&&c[0]!==f&&c[a-1]!==f?[]:ae(c,f);return(a-=l.length)<e?$i(t,n,Fi,o.placeholder,i,c,l,i,i,e-a):An(this&&this!==pn&&this instanceof o?u:t,this,c)}}(t,n,h):n!=c&&33!=n||f.length?Fi.apply(i,y):function(t,n,e,i){var u=1&n,o=ki(t);return function n(){for(var a=-1,c=arguments.length,s=-1,f=i.length,l=r(f+c),p=this&&this!==pn&&this instanceof n?o:t;++s<f;)l[s]=i[s];for(;c--;)l[s++]=arguments[++a];return An(p,u?e:this,l)}}(t,n,e,o);else var w=function(t,n,e){var r=1&n,i=ki(t);return function n(){return(this&&this!==pn&&this instanceof n?i:t).apply(r?e:this,arguments)}}(t,n,e);return Cu((_?Yr:Du)(w,y),t,n)}function Hi(t,n,e,r){return t===i||Bo(t,St[e])&&!Rt.call(r,e)?n:t}function Ki(t,n,e,r,u,o){return Zo(t)&&Zo(n)&&(o.set(n,t),Br(t,n,i,Ki,o),o.delete(n)),t}function Yi(t){return ra(t)?i:t}function Qi(t,n,e,r,u,o){var a=1&e,c=t.length,s=n.length;if(c!=s&&!(a&&s>c))return!1;var f=o.get(t),l=o.get(n);if(f&&l)return f==n&&l==t;var p=-1,h=!0,g=2&e?new Je:i;for(o.set(t,n),o.set(n,t);++p<c;){var d=t[p],v=n[p];if(r)var m=a?r(v,d,p,n,t,o):r(d,v,p,t,n,o);if(m!==i){if(m)continue;h=!1;break}if(g){if(!Un(n,(function(t,n){if(!Qn(g,n)&&(d===t||u(d,t,e,r,o)))return g.push(n)}))){h=!1;break}}else if(d!==v&&!u(d,v,e,r,o)){h=!1;break}}return o.delete(t),o.delete(n),h}function Zi(t){return ju(Iu(t,i,Mu),t+"")}function tu(t){return br(t,Sa,su)}function nu(t){return br(t,Oa,fu)}var eu=je?function(t){return je.get(t)}:ac;function ru(t){for(var n=t.name+"",e=Ce[n],r=Rt.call(Ce,n)?e.length:0;r--;){var i=e[r],u=i.func;if(null==u||u==t)return i.name}return n}function iu(t){return(Rt.call(ze,"placeholder")?ze:t).placeholder}function uu(){var t=ze.iteratee||rc;return t=t===rc?Rr:t,arguments.length?t(arguments[0],arguments[1]):t}function ou(t,n){var e,r,i=t.__data__;return("string"==(r=typeof(e=n))||"number"==r||"symbol"==r||"boolean"==r?"__proto__"!==e:null===e)?i["string"==typeof n?"string":"hash"]:i.map}function au(t){for(var n=Sa(t),e=n.length;e--;){var r=n[e],i=t[r];n[e]=[r,i,xu(i)]}return n}function cu(t,n){var e=function(t,n){return null==t?i:t[n]}(t,n);return Pr(e)?e:i}var su=vn?function(t){return null==t?[]:(t=At(t),Cn(vn(t),(function(n){return Jt.call(t,n)})))}:gc,fu=vn?function(t){for(var n=[];t;)Rn(n,su(t)),t=$t(t);return n}:gc,lu=Ir;function pu(t,n,e){for(var r=-1,i=(n=vi(n,t)).length,u=!1;++r<i;){var o=Lu(n[r]);if(!(u=null!=t&&e(t,o)))break;t=t[o]}return u||++r!=i?u:!!(i=null==t?0:t.length)&&Qo(i)&&du(o,i)&&(Mo(t)||Wo(t))}function hu(t){return"function"!=typeof t.constructor||wu(t)?{}:Be($t(t))}function gu(t){return Mo(t)||Wo(t)||!!(Xt&&t&&t[Xt])}function du(t,n){var e=typeof t;return!!(n=null==n?l:n)&&("number"==e||"symbol"!=e&&mt.test(t))&&t>-1&&t%1==0&&t<n}function vu(t,n,e){if(!Zo(e))return!1;var r=typeof n;return!!("number"==r?Vo(e)&&du(n,e.length):"string"==r&&n in e)&&Bo(e[n],t)}function mu(t,n){if(Mo(t))return!1;var e=typeof t;return!("number"!=e&&"symbol"!=e&&"boolean"!=e&&null!=t&&!aa(t))||Z.test(t)||!Q.test(t)||null!=n&&t in At(n)}function _u(t){var n=ru(t),e=ze[n];if("function"!=typeof e||!(n in We.prototype))return!1;if(t===e)return!0;var r=eu(e);return!!r&&t===r[0]}(be&&lu(new be(new ArrayBuffer(1)))!=P||Ie&&lu(new Ie)!=b||Ae&&lu(Ae.resolve())!=T||Te&&lu(new Te)!=E||De&&lu(new De)!=S)&&(lu=function(t){var n=Ir(t),e=n==A?t.constructor:i,r=e?Uu(e):"";if(r)switch(r){case Se:return P;case Oe:return b;case Pe:return T;case Re:return E;case ke:return S}return n});var yu=Ot?Ko:dc;function wu(t){var n=t&&t.constructor;return t===("function"==typeof n&&n.prototype||St)}function xu(t){return t==t&&!Zo(t)}function bu(t,n){return function(e){return null!=e&&e[t]===n&&(n!==i||t in At(e))}}function Iu(t,n,e){return n=ve(n===i?t.length-1:n,0),function(){for(var i=arguments,u=-1,o=ve(i.length-n,0),a=r(o);++u<o;)a[u]=i[n+u];u=-1;for(var c=r(n+1);++u<n;)c[u]=i[u];return c[n]=e(a),An(t,this,c)}}function Au(t,n){return n.length<2?t:xr(t,ti(n,0,-1))}function Tu(t,n){if(("constructor"!==n||"function"!=typeof t[n])&&"__proto__"!=n)return t[n]}var Du=Su(Yr),Eu=ln||function(t,n){return pn.setTimeout(t,n)},ju=Su(Qr);function Cu(t,n,e){var r=n+"";return ju(t,function(t,n){var e=n.length;if(!e)return t;var r=e-1;return n[r]=(e>1?"& ":"")+n[r],n=n.join(e>2?", ":" "),t.replace(ut,"{\n/* [wrapped with "+n+"] */\n")}(r,function(t,n){return Dn(g,(function(e){var r="_."+e[0];n&e[1]&&!Sn(t,r)&&t.push(r)})),t.sort()}(function(t){var n=t.match(ot);return n?n[1].split(at):[]}(r),e)))}function Su(t){var n=0,e=0;return function(){var r=_e(),u=16-(r-e);if(e=r,u>0){if(++n>=800)return arguments[0]}else n=0;return t.apply(i,arguments)}}function Ou(t,n){var e=-1,r=t.length,u=r-1;for(n=n===i?r:n;++e<n;){var o=Vr(e,u),a=t[o];t[o]=t[e],t[e]=a}return t.length=n,t}var Pu,Ru,ku=(Pu=Ro((function(t){var n=[];return 46===t.charCodeAt(0)&&n.push(""),t.replace(tt,(function(t,e,r,i){n.push(r?i.replace(ft,"$1"):e||t)})),n}),(function(t){return 500===Ru.size&&Ru.clear(),t})),Ru=Pu.cache,Pu);function Lu(t){if("string"==typeof t||aa(t))return t;var n=t+"";return"0"==n&&1/t==-1/0?"-0":n}function Uu(t){if(null!=t){try{return Pt.call(t)}catch(t){}try{return t+""}catch(t){}}return""}function Fu(t){if(t instanceof We)return t.clone();var n=new qe(t.__wrapped__,t.__chain__);return n.__actions__=Di(t.__actions__),n.__index__=t.__index__,n.__values__=t.__values__,n}var zu=Gr((function(t,n){return Jo(t)?sr(t,dr(n,1,Jo,!0)):[]})),Bu=Gr((function(t,n){var e=Xu(n);return Jo(e)&&(e=i),Jo(t)?sr(t,dr(n,1,Jo,!0),uu(e,2)):[]})),Nu=Gr((function(t,n){var e=Xu(n);return Jo(e)&&(e=i),Jo(t)?sr(t,dr(n,1,Jo,!0),i,e):[]}));function qu(t,n,e){var r=null==t?0:t.length;if(!r)return-1;var i=null==e?0:ha(e);return i<0&&(i=ve(r+i,0)),Bn(t,uu(n,3),i)}function Wu(t,n,e){var r=null==t?0:t.length;if(!r)return-1;var u=r-1;return e!==i&&(u=ha(e),u=e<0?ve(r+u,0):me(u,r-1)),Bn(t,uu(n,3),u,!0)}function Mu(t){return null!=t&&t.length?dr(t,1):[]}function $u(t){return t&&t.length?t[0]:i}var Vu=Gr((function(t){var n=Pn(t,gi);return n.length&&n[0]===t[0]?Er(n):[]})),Ju=Gr((function(t){var n=Xu(t),e=Pn(t,gi);return n===Xu(e)?n=i:e.pop(),e.length&&e[0]===t[0]?Er(e,uu(n,2)):[]})),Gu=Gr((function(t){var n=Xu(t),e=Pn(t,gi);return(n="function"==typeof n?n:i)&&e.pop(),e.length&&e[0]===t[0]?Er(e,i,n):[]}));function Xu(t){var n=null==t?0:t.length;return n?t[n-1]:i}var Hu=Gr(Ku);function Ku(t,n){return t&&t.length&&n&&n.length?Mr(t,n):t}var Yu=Zi((function(t,n){var e=null==t?0:t.length,r=ir(t,n);return $r(t,Pn(n,(function(t){return du(t,e)?+t:t})).sort(Ii)),r}));function Qu(t){return null==t?t:xe.call(t)}var Zu=Gr((function(t){return ai(dr(t,1,Jo,!0))})),to=Gr((function(t){var n=Xu(t);return Jo(n)&&(n=i),ai(dr(t,1,Jo,!0),uu(n,2))})),no=Gr((function(t){var n=Xu(t);return n="function"==typeof n?n:i,ai(dr(t,1,Jo,!0),i,n)}));function eo(t){if(!t||!t.length)return[];var n=0;return t=Cn(t,(function(t){if(Jo(t))return n=ve(t.length,n),!0})),Xn(n,(function(n){return Pn(t,$n(n))}))}function ro(t,n){if(!t||!t.length)return[];var e=eo(t);return null==n?e:Pn(e,(function(t){return An(n,i,t)}))}var io=Gr((function(t,n){return Jo(t)?sr(t,n):[]})),uo=Gr((function(t){return pi(Cn(t,Jo))})),oo=Gr((function(t){var n=Xu(t);return Jo(n)&&(n=i),pi(Cn(t,Jo),uu(n,2))})),ao=Gr((function(t){var n=Xu(t);return n="function"==typeof n?n:i,pi(Cn(t,Jo),i,n)})),co=Gr(eo),so=Gr((function(t){var n=t.length,e=n>1?t[n-1]:i;return e="function"==typeof e?(t.pop(),e):i,ro(t,e)}));function fo(t){var n=ze(t);return n.__chain__=!0,n}function lo(t,n){return n(t)}var po=Zi((function(t){var n=t.length,e=n?t[0]:0,r=this.__wrapped__,u=function(n){return ir(n,t)};return!(n>1||this.__actions__.length)&&r instanceof We&&du(e)?((r=r.slice(e,+e+(n?1:0))).__actions__.push({func:lo,args:[u],thisArg:i}),new qe(r,this.__chain__).thru((function(t){return n&&!t.length&&t.push(i),t}))):this.thru(u)})),ho=ji((function(t,n,e){Rt.call(t,e)?++t[e]:rr(t,e,1)})),go=Li(qu),vo=Li(Wu);function mo(t,n){return(Mo(t)?Dn:fr)(t,uu(n,3))}function _o(t,n){return(Mo(t)?En:lr)(t,uu(n,3))}var yo=ji((function(t,n,e){Rt.call(t,e)?t[e].push(n):rr(t,e,[n])})),wo=Gr((function(t,n,e){var i=-1,u="function"==typeof n,o=Vo(t)?r(t.length):[];return fr(t,(function(t){o[++i]=u?An(n,t,e):jr(t,n,e)})),o})),xo=ji((function(t,n,e){rr(t,e,n)}));function bo(t,n){return(Mo(t)?Pn:Ur)(t,uu(n,3))}var Io=ji((function(t,n,e){t[e?0:1].push(n)}),(function(){return[[],[]]})),Ao=Gr((function(t,n){if(null==t)return[];var e=n.length;return e>1&&vu(t,n[0],n[1])?n=[]:e>2&&vu(n[0],n[1],n[2])&&(n=[n[0]]),qr(t,dr(n,1),[])})),To=fn||function(){return pn.Date.now()};function Do(t,n,e){return n=e?i:n,n=t&&null==n?t.length:n,Xi(t,s,i,i,i,i,n)}function Eo(t,n){var e;if("function"!=typeof n)throw new Et(u);return t=ha(t),function(){return--t>0&&(e=n.apply(this,arguments)),t<=1&&(n=i),e}}var jo=Gr((function(t,n,e){var r=1;if(e.length){var i=ae(e,iu(jo));r|=c}return Xi(t,r,n,e,i)})),Co=Gr((function(t,n,e){var r=3;if(e.length){var i=ae(e,iu(Co));r|=c}return Xi(n,r,t,e,i)}));function So(t,n,e){var r,o,a,c,s,f,l=0,p=!1,h=!1,g=!0;if("function"!=typeof t)throw new Et(u);function d(n){var e=r,u=o;return r=o=i,l=n,c=t.apply(u,e)}function v(t){var e=t-f;return f===i||e>=n||e<0||h&&t-l>=a}function m(){var t=To();if(v(t))return _(t);s=Eu(m,function(t){var e=n-(t-f);return h?me(e,a-(t-l)):e}(t))}function _(t){return s=i,g&&r?d(t):(r=o=i,c)}function y(){var t=To(),e=v(t);if(r=arguments,o=this,f=t,e){if(s===i)return function(t){return l=t,s=Eu(m,n),p?d(t):c}(f);if(h)return yi(s),s=Eu(m,n),d(f)}return s===i&&(s=Eu(m,n)),c}return n=da(n)||0,Zo(e)&&(p=!!e.leading,a=(h="maxWait"in e)?ve(da(e.maxWait)||0,n):a,g="trailing"in e?!!e.trailing:g),y.cancel=function(){s!==i&&yi(s),l=0,r=f=o=s=i},y.flush=function(){return s===i?c:_(To())},y}var Oo=Gr((function(t,n){return cr(t,1,n)})),Po=Gr((function(t,n,e){return cr(t,da(n)||0,e)}));function Ro(t,n){if("function"!=typeof t||null!=n&&"function"!=typeof n)throw new Et(u);var e=function(){var r=arguments,i=n?n.apply(this,r):r[0],u=e.cache;if(u.has(i))return u.get(i);var o=t.apply(this,r);return e.cache=u.set(i,o)||u,o};return e.cache=new(Ro.Cache||Ve),e}function ko(t){if("function"!=typeof t)throw new Et(u);return function(){var n=arguments;switch(n.length){case 0:return!t.call(this);case 1:return!t.call(this,n[0]);case 2:return!t.call(this,n[0],n[1]);case 3:return!t.call(this,n[0],n[1],n[2])}return!t.apply(this,n)}}Ro.Cache=Ve;var Lo=mi((function(t,n){var e=(n=1==n.length&&Mo(n[0])?Pn(n[0],Kn(uu())):Pn(dr(n,1),Kn(uu()))).length;return Gr((function(r){for(var i=-1,u=me(r.length,e);++i<u;)r[i]=n[i].call(this,r[i]);return An(t,this,r)}))})),Uo=Gr((function(t,n){var e=ae(n,iu(Uo));return Xi(t,c,i,n,e)})),Fo=Gr((function(t,n){var e=ae(n,iu(Fo));return Xi(t,64,i,n,e)})),zo=Zi((function(t,n){return Xi(t,256,i,i,i,n)}));function Bo(t,n){return t===n||t!=t&&n!=n}var No=Mi(Ar),qo=Mi((function(t,n){return t>=n})),Wo=Cr(function(){return arguments}())?Cr:function(t){return ta(t)&&Rt.call(t,"callee")&&!Jt.call(t,"callee")},Mo=r.isArray,$o=_n?Kn(_n):function(t){return ta(t)&&Ir(t)==O};function Vo(t){return null!=t&&Qo(t.length)&&!Ko(t)}function Jo(t){return ta(t)&&Vo(t)}var Go=mn||dc,Xo=yn?Kn(yn):function(t){return ta(t)&&Ir(t)==_};function Ho(t){if(!ta(t))return!1;var n=Ir(t);return n==y||"[object DOMException]"==n||"string"==typeof t.message&&"string"==typeof t.name&&!ra(t)}function Ko(t){if(!Zo(t))return!1;var n=Ir(t);return n==w||n==x||"[object AsyncFunction]"==n||"[object Proxy]"==n}function Yo(t){return"number"==typeof t&&t==ha(t)}function Qo(t){return"number"==typeof t&&t>-1&&t%1==0&&t<=l}function Zo(t){var n=typeof t;return null!=t&&("object"==n||"function"==n)}function ta(t){return null!=t&&"object"==typeof t}var na=wn?Kn(wn):function(t){return ta(t)&&lu(t)==b};function ea(t){return"number"==typeof t||ta(t)&&Ir(t)==I}function ra(t){if(!ta(t)||Ir(t)!=A)return!1;var n=$t(t);if(null===n)return!0;var e=Rt.call(n,"constructor")&&n.constructor;return"function"==typeof e&&e instanceof e&&Pt.call(e)==Ft}var ia=xn?Kn(xn):function(t){return ta(t)&&Ir(t)==D},ua=bn?Kn(bn):function(t){return ta(t)&&lu(t)==E};function oa(t){return"string"==typeof t||!Mo(t)&&ta(t)&&Ir(t)==j}function aa(t){return"symbol"==typeof t||ta(t)&&Ir(t)==C}var ca=In?Kn(In):function(t){return ta(t)&&Qo(t.length)&&!!un[Ir(t)]},sa=Mi(Lr),fa=Mi((function(t,n){return t<=n}));function la(t){if(!t)return[];if(Vo(t))return oa(t)?le(t):Di(t);if(Ht&&t[Ht])return function(t){for(var n,e=[];!(n=t.next()).done;)e.push(n.value);return e}(t[Ht]());var n=lu(t);return(n==b?ue:n==E?ce:Ba)(t)}function pa(t){return t?(t=da(t))===f||t===-1/0?17976931348623157e292*(t<0?-1:1):t==t?t:0:0===t?t:0}function ha(t){var n=pa(t),e=n%1;return n==n?e?n-e:n:0}function ga(t){return t?ur(ha(t),0,h):0}function da(t){if("number"==typeof t)return t;if(aa(t))return p;if(Zo(t)){var n="function"==typeof t.valueOf?t.valueOf():t;t=Zo(n)?n+"":n}if("string"!=typeof t)return 0===t?t:+t;t=Hn(t);var e=gt.test(t);return e||vt.test(t)?sn(t.slice(2),e?2:8):ht.test(t)?p:+t}function va(t){return Ei(t,Oa(t))}function ma(t){return null==t?"":oi(t)}var _a=Ci((function(t,n){if(wu(n)||Vo(n))Ei(n,Sa(n),t);else for(var e in n)Rt.call(n,e)&&Ze(t,e,n[e])})),ya=Ci((function(t,n){Ei(n,Oa(n),t)})),wa=Ci((function(t,n,e,r){Ei(n,Oa(n),t,r)})),xa=Ci((function(t,n,e,r){Ei(n,Sa(n),t,r)})),ba=Zi(ir),Ia=Gr((function(t,n){t=At(t);var e=-1,r=n.length,u=r>2?n[2]:i;for(u&&vu(n[0],n[1],u)&&(r=1);++e<r;)for(var o=n[e],a=Oa(o),c=-1,s=a.length;++c<s;){var f=a[c],l=t[f];(l===i||Bo(l,St[f])&&!Rt.call(t,f))&&(t[f]=o[f])}return t})),Aa=Gr((function(t){return t.push(i,Ki),An(Ra,i,t)}));function Ta(t,n,e){var r=null==t?i:xr(t,n);return r===i?e:r}function Da(t,n){return null!=t&&pu(t,n,Dr)}var Ea=zi((function(t,n,e){null!=n&&"function"!=typeof n.toString&&(n=Ut.call(n)),t[n]=e}),Za(ec)),ja=zi((function(t,n,e){null!=n&&"function"!=typeof n.toString&&(n=Ut.call(n)),Rt.call(t,n)?t[n].push(e):t[n]=[e]}),uu),Ca=Gr(jr);function Sa(t){return Vo(t)?Xe(t):kr(t)}function Oa(t){return Vo(t)?Xe(t,!0):function(t){if(!Zo(t))return function(t){var n=[];if(null!=t)for(var e in At(t))n.push(e);return n}(t);var n=wu(t),e=[];for(var r in t)("constructor"!=r||!n&&Rt.call(t,r))&&e.push(r);return e}(t)}var Pa=Ci((function(t,n,e){Br(t,n,e)})),Ra=Ci((function(t,n,e,r){Br(t,n,e,r)})),ka=Zi((function(t,n){var e={};if(null==t)return e;var r=!1;n=Pn(n,(function(n){return n=vi(n,t),r||(r=n.length>1),n})),Ei(t,nu(t),e),r&&(e=or(e,7,Yi));for(var i=n.length;i--;)ci(e,n[i]);return e})),La=Zi((function(t,n){return null==t?{}:function(t,n){return Wr(t,n,(function(n,e){return Da(t,e)}))}(t,n)}));function Ua(t,n){if(null==t)return{};var e=Pn(nu(t),(function(t){return[t]}));return n=uu(n),Wr(t,e,(function(t,e){return n(t,e[0])}))}var Fa=Gi(Sa),za=Gi(Oa);function Ba(t){return null==t?[]:Yn(t,Sa(t))}var Na=Ri((function(t,n,e){return n=n.toLowerCase(),t+(e?qa(n):n)}));function qa(t){return Ha(ma(t).toLowerCase())}function Wa(t){return(t=ma(t))&&t.replace(_t,ne).replace(Yt,"")}var Ma=Ri((function(t,n,e){return t+(e?"-":"")+n.toLowerCase()})),$a=Ri((function(t,n,e){return t+(e?" ":"")+n.toLowerCase()})),Va=Pi("toLowerCase"),Ja=Ri((function(t,n,e){return t+(e?"_":"")+n.toLowerCase()})),Ga=Ri((function(t,n,e){return t+(e?" ":"")+Ha(n)})),Xa=Ri((function(t,n,e){return t+(e?" ":"")+n.toUpperCase()})),Ha=Pi("toUpperCase");function Ka(t,n,e){return t=ma(t),(n=e?i:n)===i?function(t){return nn.test(t)}(t)?function(t){return t.match(Zt)||[]}(t):function(t){return t.match(ct)||[]}(t):t.match(n)||[]}var Ya=Gr((function(t,n){try{return An(t,i,n)}catch(t){return Ho(t)?t:new xt(t)}})),Qa=Zi((function(t,n){return Dn(n,(function(n){n=Lu(n),rr(t,n,jo(t[n],t))})),t}));function Za(t){return function(){return t}}var tc=Ui(),nc=Ui(!0);function ec(t){return t}function rc(t){return Rr("function"==typeof t?t:or(t,1))}var ic=Gr((function(t,n){return function(e){return jr(e,t,n)}})),uc=Gr((function(t,n){return function(e){return jr(t,e,n)}}));function oc(t,n,e){var r=Sa(n),i=wr(n,r);null!=e||Zo(n)&&(i.length||!r.length)||(e=n,n=t,t=this,i=wr(n,Sa(n)));var u=!(Zo(e)&&"chain"in e&&!e.chain),o=Ko(t);return Dn(i,(function(e){var r=n[e];t[e]=r,o&&(t.prototype[e]=function(){var n=this.__chain__;if(u||n){var e=t(this.__wrapped__);return(e.__actions__=Di(this.__actions__)).push({func:r,args:arguments,thisArg:t}),e.__chain__=n,e}return r.apply(t,Rn([this.value()],arguments))})})),t}function ac(){}var cc=Ni(Pn),sc=Ni(jn),fc=Ni(Un);function lc(t){return mu(t)?$n(Lu(t)):function(t){return function(n){return xr(n,t)}}(t)}var pc=Wi(),hc=Wi(!0);function gc(){return[]}function dc(){return!1}var vc,mc=Bi((function(t,n){return t+n}),0),_c=Vi("ceil"),yc=Bi((function(t,n){return t/n}),1),wc=Vi("floor"),xc=Bi((function(t,n){return t*n}),1),bc=Vi("round"),Ic=Bi((function(t,n){return t-n}),0);return ze.after=function(t,n){if("function"!=typeof n)throw new Et(u);return t=ha(t),function(){if(--t<1)return n.apply(this,arguments)}},ze.ary=Do,ze.assign=_a,ze.assignIn=ya,ze.assignInWith=wa,ze.assignWith=xa,ze.at=ba,ze.before=Eo,ze.bind=jo,ze.bindAll=Qa,ze.bindKey=Co,ze.castArray=function(){if(!arguments.length)return[];var t=arguments[0];return Mo(t)?t:[t]},ze.chain=fo,ze.chunk=function(t,n,e){n=(e?vu(t,n,e):n===i)?1:ve(ha(n),0);var u=null==t?0:t.length;if(!u||n<1)return[];for(var o=0,a=0,c=r(hn(u/n));o<u;)c[a++]=ti(t,o,o+=n);return c},ze.compact=function(t){for(var n=-1,e=null==t?0:t.length,r=0,i=[];++n<e;){var u=t[n];u&&(i[r++]=u)}return i},ze.concat=function(){var t=arguments.length;if(!t)return[];for(var n=r(t-1),e=arguments[0],i=t;i--;)n[i-1]=arguments[i];return Rn(Mo(e)?Di(e):[e],dr(n,1))},ze.cond=function(t){var n=null==t?0:t.length,e=uu();return t=n?Pn(t,(function(t){if("function"!=typeof t[1])throw new Et(u);return[e(t[0]),t[1]]})):[],Gr((function(e){for(var r=-1;++r<n;){var i=t[r];if(An(i[0],this,e))return An(i[1],this,e)}}))},ze.conforms=function(t){return function(t){var n=Sa(t);return function(e){return ar(e,t,n)}}(or(t,1))},ze.constant=Za,ze.countBy=ho,ze.create=function(t,n){var e=Be(t);return null==n?e:er(e,n)},ze.curry=function t(n,e,r){var u=Xi(n,8,i,i,i,i,i,e=r?i:e);return u.placeholder=t.placeholder,u},ze.curryRight=function t(n,e,r){var u=Xi(n,16,i,i,i,i,i,e=r?i:e);return u.placeholder=t.placeholder,u},ze.debounce=So,ze.defaults=Ia,ze.defaultsDeep=Aa,ze.defer=Oo,ze.delay=Po,ze.difference=zu,ze.differenceBy=Bu,ze.differenceWith=Nu,ze.drop=function(t,n,e){var r=null==t?0:t.length;return r?ti(t,(n=e||n===i?1:ha(n))<0?0:n,r):[]},ze.dropRight=function(t,n,e){var r=null==t?0:t.length;return r?ti(t,0,(n=r-(n=e||n===i?1:ha(n)))<0?0:n):[]},ze.dropRightWhile=function(t,n){return t&&t.length?fi(t,uu(n,3),!0,!0):[]},ze.dropWhile=function(t,n){return t&&t.length?fi(t,uu(n,3),!0):[]},ze.fill=function(t,n,e,r){var u=null==t?0:t.length;return u?(e&&"number"!=typeof e&&vu(t,n,e)&&(e=0,r=u),function(t,n,e,r){var u=t.length;for((e=ha(e))<0&&(e=-e>u?0:u+e),(r=r===i||r>u?u:ha(r))<0&&(r+=u),r=e>r?0:ga(r);e<r;)t[e++]=n;return t}(t,n,e,r)):[]},ze.filter=function(t,n){return(Mo(t)?Cn:gr)(t,uu(n,3))},ze.flatMap=function(t,n){return dr(bo(t,n),1)},ze.flatMapDeep=function(t,n){return dr(bo(t,n),f)},ze.flatMapDepth=function(t,n,e){return e=e===i?1:ha(e),dr(bo(t,n),e)},ze.flatten=Mu,ze.flattenDeep=function(t){return null!=t&&t.length?dr(t,f):[]},ze.flattenDepth=function(t,n){return null!=t&&t.length?dr(t,n=n===i?1:ha(n)):[]},ze.flip=function(t){return Xi(t,512)},ze.flow=tc,ze.flowRight=nc,ze.fromPairs=function(t){for(var n=-1,e=null==t?0:t.length,r={};++n<e;){var i=t[n];r[i[0]]=i[1]}return r},ze.functions=function(t){return null==t?[]:wr(t,Sa(t))},ze.functionsIn=function(t){return null==t?[]:wr(t,Oa(t))},ze.groupBy=yo,ze.initial=function(t){return null!=t&&t.length?ti(t,0,-1):[]},ze.intersection=Vu,ze.intersectionBy=Ju,ze.intersectionWith=Gu,ze.invert=Ea,ze.invertBy=ja,ze.invokeMap=wo,ze.iteratee=rc,ze.keyBy=xo,ze.keys=Sa,ze.keysIn=Oa,ze.map=bo,ze.mapKeys=function(t,n){var e={};return n=uu(n,3),_r(t,(function(t,r,i){rr(e,n(t,r,i),t)})),e},ze.mapValues=function(t,n){var e={};return n=uu(n,3),_r(t,(function(t,r,i){rr(e,r,n(t,r,i))})),e},ze.matches=function(t){return Fr(or(t,1))},ze.matchesProperty=function(t,n){return zr(t,or(n,1))},ze.memoize=Ro,ze.merge=Pa,ze.mergeWith=Ra,ze.method=ic,ze.methodOf=uc,ze.mixin=oc,ze.negate=ko,ze.nthArg=function(t){return t=ha(t),Gr((function(n){return Nr(n,t)}))},ze.omit=ka,ze.omitBy=function(t,n){return Ua(t,ko(uu(n)))},ze.once=function(t){return Eo(2,t)},ze.orderBy=function(t,n,e,r){return null==t?[]:(Mo(n)||(n=null==n?[]:[n]),Mo(e=r?i:e)||(e=null==e?[]:[e]),qr(t,n,e))},ze.over=cc,ze.overArgs=Lo,ze.overEvery=sc,ze.overSome=fc,ze.partial=Uo,ze.partialRight=Fo,ze.partition=Io,ze.pick=La,ze.pickBy=Ua,ze.property=lc,ze.propertyOf=function(t){return function(n){return null==t?i:xr(t,n)}},ze.pull=Hu,ze.pullAll=Ku,ze.pullAllBy=function(t,n,e){return t&&t.length&&n&&n.length?Mr(t,n,uu(e,2)):t},ze.pullAllWith=function(t,n,e){return t&&t.length&&n&&n.length?Mr(t,n,i,e):t},ze.pullAt=Yu,ze.range=pc,ze.rangeRight=hc,ze.rearg=zo,ze.reject=function(t,n){return(Mo(t)?Cn:gr)(t,ko(uu(n,3)))},ze.remove=function(t,n){var e=[];if(!t||!t.length)return e;var r=-1,i=[],u=t.length;for(n=uu(n,3);++r<u;){var o=t[r];n(o,r,t)&&(e.push(o),i.push(r))}return $r(t,i),e},ze.rest=function(t,n){if("function"!=typeof t)throw new Et(u);return Gr(t,n=n===i?n:ha(n))},ze.reverse=Qu,ze.sampleSize=function(t,n,e){return n=(e?vu(t,n,e):n===i)?1:ha(n),(Mo(t)?Ke:Hr)(t,n)},ze.set=function(t,n,e){return null==t?t:Kr(t,n,e)},ze.setWith=function(t,n,e,r){return r="function"==typeof r?r:i,null==t?t:Kr(t,n,e,r)},ze.shuffle=function(t){return(Mo(t)?Ye:Zr)(t)},ze.slice=function(t,n,e){var r=null==t?0:t.length;return r?(e&&"number"!=typeof e&&vu(t,n,e)?(n=0,e=r):(n=null==n?0:ha(n),e=e===i?r:ha(e)),ti(t,n,e)):[]},ze.sortBy=Ao,ze.sortedUniq=function(t){return t&&t.length?ii(t):[]},ze.sortedUniqBy=function(t,n){return t&&t.length?ii(t,uu(n,2)):[]},ze.split=function(t,n,e){return e&&"number"!=typeof e&&vu(t,n,e)&&(n=e=i),(e=e===i?h:e>>>0)?(t=ma(t))&&("string"==typeof n||null!=n&&!ia(n))&&!(n=oi(n))&&ie(t)?_i(le(t),0,e):t.split(n,e):[]},ze.spread=function(t,n){if("function"!=typeof t)throw new Et(u);return n=null==n?0:ve(ha(n),0),Gr((function(e){var r=e[n],i=_i(e,0,n);return r&&Rn(i,r),An(t,this,i)}))},ze.tail=function(t){var n=null==t?0:t.length;return n?ti(t,1,n):[]},ze.take=function(t,n,e){return t&&t.length?ti(t,0,(n=e||n===i?1:ha(n))<0?0:n):[]},ze.takeRight=function(t,n,e){var r=null==t?0:t.length;return r?ti(t,(n=r-(n=e||n===i?1:ha(n)))<0?0:n,r):[]},ze.takeRightWhile=function(t,n){return t&&t.length?fi(t,uu(n,3),!1,!0):[]},ze.takeWhile=function(t,n){return t&&t.length?fi(t,uu(n,3)):[]},ze.tap=function(t,n){return n(t),t},ze.throttle=function(t,n,e){var r=!0,i=!0;if("function"!=typeof t)throw new Et(u);return Zo(e)&&(r="leading"in e?!!e.leading:r,i="trailing"in e?!!e.trailing:i),So(t,n,{leading:r,maxWait:n,trailing:i})},ze.thru=lo,ze.toArray=la,ze.toPairs=Fa,ze.toPairsIn=za,ze.toPath=function(t){return Mo(t)?Pn(t,Lu):aa(t)?[t]:Di(ku(ma(t)))},ze.toPlainObject=va,ze.transform=function(t,n,e){var r=Mo(t),i=r||Go(t)||ca(t);if(n=uu(n,4),null==e){var u=t&&t.constructor;e=i?r?new u:[]:Zo(t)&&Ko(u)?Be($t(t)):{}}return(i?Dn:_r)(t,(function(t,r,i){return n(e,t,r,i)})),e},ze.unary=function(t){return Do(t,1)},ze.union=Zu,ze.unionBy=to,ze.unionWith=no,ze.uniq=function(t){return t&&t.length?ai(t):[]},ze.uniqBy=function(t,n){return t&&t.length?ai(t,uu(n,2)):[]},ze.uniqWith=function(t,n){return n="function"==typeof n?n:i,t&&t.length?ai(t,i,n):[]},ze.unset=function(t,n){return null==t||ci(t,n)},ze.unzip=eo,ze.unzipWith=ro,ze.update=function(t,n,e){return null==t?t:si(t,n,di(e))},ze.updateWith=function(t,n,e,r){return r="function"==typeof r?r:i,null==t?t:si(t,n,di(e),r)},ze.values=Ba,ze.valuesIn=function(t){return null==t?[]:Yn(t,Oa(t))},ze.without=io,ze.words=Ka,ze.wrap=function(t,n){return Uo(di(n),t)},ze.xor=uo,ze.xorBy=oo,ze.xorWith=ao,ze.zip=co,ze.zipObject=function(t,n){return hi(t||[],n||[],Ze)},ze.zipObjectDeep=function(t,n){return hi(t||[],n||[],Kr)},ze.zipWith=so,ze.entries=Fa,ze.entriesIn=za,ze.extend=ya,ze.extendWith=wa,oc(ze,ze),ze.add=mc,ze.attempt=Ya,ze.camelCase=Na,ze.capitalize=qa,ze.ceil=_c,ze.clamp=function(t,n,e){return e===i&&(e=n,n=i),e!==i&&(e=(e=da(e))==e?e:0),n!==i&&(n=(n=da(n))==n?n:0),ur(da(t),n,e)},ze.clone=function(t){return or(t,4)},ze.cloneDeep=function(t){return or(t,5)},ze.cloneDeepWith=function(t,n){return or(t,5,n="function"==typeof n?n:i)},ze.cloneWith=function(t,n){return or(t,4,n="function"==typeof n?n:i)},ze.conformsTo=function(t,n){return null==n||ar(t,n,Sa(n))},ze.deburr=Wa,ze.defaultTo=function(t,n){return null==t||t!=t?n:t},ze.divide=yc,ze.endsWith=function(t,n,e){t=ma(t),n=oi(n);var r=t.length,u=e=e===i?r:ur(ha(e),0,r);return(e-=n.length)>=0&&t.slice(e,u)==n},ze.eq=Bo,ze.escape=function(t){return(t=ma(t))&&X.test(t)?t.replace(J,ee):t},ze.escapeRegExp=function(t){return(t=ma(t))&&et.test(t)?t.replace(nt,"\\$&"):t},ze.every=function(t,n,e){var r=Mo(t)?jn:pr;return e&&vu(t,n,e)&&(n=i),r(t,uu(n,3))},ze.find=go,ze.findIndex=qu,ze.findKey=function(t,n){return zn(t,uu(n,3),_r)},ze.findLast=vo,ze.findLastIndex=Wu,ze.findLastKey=function(t,n){return zn(t,uu(n,3),yr)},ze.floor=wc,ze.forEach=mo,ze.forEachRight=_o,ze.forIn=function(t,n){return null==t?t:vr(t,uu(n,3),Oa)},ze.forInRight=function(t,n){return null==t?t:mr(t,uu(n,3),Oa)},ze.forOwn=function(t,n){return t&&_r(t,uu(n,3))},ze.forOwnRight=function(t,n){return t&&yr(t,uu(n,3))},ze.get=Ta,ze.gt=No,ze.gte=qo,ze.has=function(t,n){return null!=t&&pu(t,n,Tr)},ze.hasIn=Da,ze.head=$u,ze.identity=ec,ze.includes=function(t,n,e,r){t=Vo(t)?t:Ba(t),e=e&&!r?ha(e):0;var i=t.length;return e<0&&(e=ve(i+e,0)),oa(t)?e<=i&&t.indexOf(n,e)>-1:!!i&&Nn(t,n,e)>-1},ze.indexOf=function(t,n,e){var r=null==t?0:t.length;if(!r)return-1;var i=null==e?0:ha(e);return i<0&&(i=ve(r+i,0)),Nn(t,n,i)},ze.inRange=function(t,n,e){return n=pa(n),e===i?(e=n,n=0):e=pa(e),function(t,n,e){return t>=me(n,e)&&t<ve(n,e)}(t=da(t),n,e)},ze.invoke=Ca,ze.isArguments=Wo,ze.isArray=Mo,ze.isArrayBuffer=$o,ze.isArrayLike=Vo,ze.isArrayLikeObject=Jo,ze.isBoolean=function(t){return!0===t||!1===t||ta(t)&&Ir(t)==m},ze.isBuffer=Go,ze.isDate=Xo,ze.isElement=function(t){return ta(t)&&1===t.nodeType&&!ra(t)},ze.isEmpty=function(t){if(null==t)return!0;if(Vo(t)&&(Mo(t)||"string"==typeof t||"function"==typeof t.splice||Go(t)||ca(t)||Wo(t)))return!t.length;var n=lu(t);if(n==b||n==E)return!t.size;if(wu(t))return!kr(t).length;for(var e in t)if(Rt.call(t,e))return!1;return!0},ze.isEqual=function(t,n){return Sr(t,n)},ze.isEqualWith=function(t,n,e){var r=(e="function"==typeof e?e:i)?e(t,n):i;return r===i?Sr(t,n,i,e):!!r},ze.isError=Ho,ze.isFinite=function(t){return"number"==typeof t&&Fn(t)},ze.isFunction=Ko,ze.isInteger=Yo,ze.isLength=Qo,ze.isMap=na,ze.isMatch=function(t,n){return t===n||Or(t,n,au(n))},ze.isMatchWith=function(t,n,e){return e="function"==typeof e?e:i,Or(t,n,au(n),e)},ze.isNaN=function(t){return ea(t)&&t!=+t},ze.isNative=function(t){if(yu(t))throw new xt("Unsupported core-js use. Try https://npms.io/search?q=ponyfill.");return Pr(t)},ze.isNil=function(t){return null==t},ze.isNull=function(t){return null===t},ze.isNumber=ea,ze.isObject=Zo,ze.isObjectLike=ta,ze.isPlainObject=ra,ze.isRegExp=ia,ze.isSafeInteger=function(t){return Yo(t)&&t>=-9007199254740991&&t<=l},ze.isSet=ua,ze.isString=oa,ze.isSymbol=aa,ze.isTypedArray=ca,ze.isUndefined=function(t){return t===i},ze.isWeakMap=function(t){return ta(t)&&lu(t)==S},ze.isWeakSet=function(t){return ta(t)&&"[object WeakSet]"==Ir(t)},ze.join=function(t,n){return null==t?"":Vn.call(t,n)},ze.kebabCase=Ma,ze.last=Xu,ze.lastIndexOf=function(t,n,e){var r=null==t?0:t.length;if(!r)return-1;var u=r;return e!==i&&(u=(u=ha(e))<0?ve(r+u,0):me(u,r-1)),n==n?function(t,n,e){for(var r=e+1;r--;)if(t[r]===n)return r;return r}(t,n,u):Bn(t,Wn,u,!0)},ze.lowerCase=$a,ze.lowerFirst=Va,ze.lt=sa,ze.lte=fa,ze.max=function(t){return t&&t.length?hr(t,ec,Ar):i},ze.maxBy=function(t,n){return t&&t.length?hr(t,uu(n,2),Ar):i},ze.mean=function(t){return Mn(t,ec)},ze.meanBy=function(t,n){return Mn(t,uu(n,2))},ze.min=function(t){return t&&t.length?hr(t,ec,Lr):i},ze.minBy=function(t,n){return t&&t.length?hr(t,uu(n,2),Lr):i},ze.stubArray=gc,ze.stubFalse=dc,ze.stubObject=function(){return{}},ze.stubString=function(){return""},ze.stubTrue=function(){return!0},ze.multiply=xc,ze.nth=function(t,n){return t&&t.length?Nr(t,ha(n)):i},ze.noConflict=function(){return pn._===this&&(pn._=zt),this},ze.noop=ac,ze.now=To,ze.pad=function(t,n,e){t=ma(t);var r=(n=ha(n))?fe(t):0;if(!n||r>=n)return t;var i=(n-r)/2;return qi(gn(i),e)+t+qi(hn(i),e)},ze.padEnd=function(t,n,e){t=ma(t);var r=(n=ha(n))?fe(t):0;return n&&r<n?t+qi(n-r,e):t},ze.padStart=function(t,n,e){t=ma(t);var r=(n=ha(n))?fe(t):0;return n&&r<n?qi(n-r,e)+t:t},ze.parseInt=function(t,n,e){return e||null==n?n=0:n&&(n=+n),ye(ma(t).replace(rt,""),n||0)},ze.random=function(t,n,e){if(e&&"boolean"!=typeof e&&vu(t,n,e)&&(n=e=i),e===i&&("boolean"==typeof n?(e=n,n=i):"boolean"==typeof t&&(e=t,t=i)),t===i&&n===i?(t=0,n=1):(t=pa(t),n===i?(n=t,t=0):n=pa(n)),t>n){var r=t;t=n,n=r}if(e||t%1||n%1){var u=we();return me(t+u*(n-t+cn("1e-"+((u+"").length-1))),n)}return Vr(t,n)},ze.reduce=function(t,n,e){var r=Mo(t)?kn:Jn,i=arguments.length<3;return r(t,uu(n,4),e,i,fr)},ze.reduceRight=function(t,n,e){var r=Mo(t)?Ln:Jn,i=arguments.length<3;return r(t,uu(n,4),e,i,lr)},ze.repeat=function(t,n,e){return n=(e?vu(t,n,e):n===i)?1:ha(n),Jr(ma(t),n)},ze.replace=function(){var t=arguments,n=ma(t[0]);return t.length<3?n:n.replace(t[1],t[2])},ze.result=function(t,n,e){var r=-1,u=(n=vi(n,t)).length;for(u||(u=1,t=i);++r<u;){var o=null==t?i:t[Lu(n[r])];o===i&&(r=u,o=e),t=Ko(o)?o.call(t):o}return t},ze.round=bc,ze.runInContext=t,ze.sample=function(t){return(Mo(t)?He:Xr)(t)},ze.size=function(t){if(null==t)return 0;if(Vo(t))return oa(t)?fe(t):t.length;var n=lu(t);return n==b||n==E?t.size:kr(t).length},ze.snakeCase=Ja,ze.some=function(t,n,e){var r=Mo(t)?Un:ni;return e&&vu(t,n,e)&&(n=i),r(t,uu(n,3))},ze.sortedIndex=function(t,n){return ei(t,n)},ze.sortedIndexBy=function(t,n,e){return ri(t,n,uu(e,2))},ze.sortedIndexOf=function(t,n){var e=null==t?0:t.length;if(e){var r=ei(t,n);if(r<e&&Bo(t[r],n))return r}return-1},ze.sortedLastIndex=function(t,n){return ei(t,n,!0)},ze.sortedLastIndexBy=function(t,n,e){return ri(t,n,uu(e,2),!0)},ze.sortedLastIndexOf=function(t,n){if(null!=t&&t.length){var e=ei(t,n,!0)-1;if(Bo(t[e],n))return e}return-1},ze.startCase=Ga,ze.startsWith=function(t,n,e){return t=ma(t),e=null==e?0:ur(ha(e),0,t.length),n=oi(n),t.slice(e,e+n.length)==n},ze.subtract=Ic,ze.sum=function(t){return t&&t.length?Gn(t,ec):0},ze.sumBy=function(t,n){return t&&t.length?Gn(t,uu(n,2)):0},ze.template=function(t,n,e){var r=ze.templateSettings;e&&vu(t,n,e)&&(n=i),t=ma(t),n=wa({},n,r,Hi);var u,o,a=wa({},n.imports,r.imports,Hi),c=Sa(a),s=Yn(a,c),f=0,l=n.interpolate||yt,p="__p += '",h=Tt((n.escape||yt).source+"|"+l.source+"|"+(l===Y?lt:yt).source+"|"+(n.evaluate||yt).source+"|$","g"),g="//# sourceURL="+(Rt.call(n,"sourceURL")?(n.sourceURL+"").replace(/\s/g," "):"lodash.templateSources["+ ++rn+"]")+"\n";t.replace(h,(function(n,e,r,i,a,c){return r||(r=i),p+=t.slice(f,c).replace(wt,re),e&&(u=!0,p+="' +\n__e("+e+") +\n'"),a&&(o=!0,p+="';\n"+a+";\n__p += '"),r&&(p+="' +\n((__t = ("+r+")) == null ? '' : __t) +\n'"),f=c+n.length,n})),p+="';\n";var d=Rt.call(n,"variable")&&n.variable;if(d){if(st.test(d))throw new xt("Invalid `variable` option passed into `_.template`")}else p="with (obj) {\n"+p+"\n}\n";p=(o?p.replace(W,""):p).replace(M,"$1").replace($,"$1;"),p="function("+(d||"obj")+") {\n"+(d?"":"obj || (obj = {});\n")+"var __t, __p = ''"+(u?", __e = _.escape":"")+(o?", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n":";\n")+p+"return __p\n}";var v=Ya((function(){return bt(c,g+"return "+p).apply(i,s)}));if(v.source=p,Ho(v))throw v;return v},ze.times=function(t,n){if((t=ha(t))<1||t>l)return[];var e=h,r=me(t,h);n=uu(n),t-=h;for(var i=Xn(r,n);++e<t;)n(e);return i},ze.toFinite=pa,ze.toInteger=ha,ze.toLength=ga,ze.toLower=function(t){return ma(t).toLowerCase()},ze.toNumber=da,ze.toSafeInteger=function(t){return t?ur(ha(t),-9007199254740991,l):0===t?t:0},ze.toString=ma,ze.toUpper=function(t){return ma(t).toUpperCase()},ze.trim=function(t,n,e){if((t=ma(t))&&(e||n===i))return Hn(t);if(!t||!(n=oi(n)))return t;var r=le(t),u=le(n);return _i(r,Zn(r,u),te(r,u)+1).join("")},ze.trimEnd=function(t,n,e){if((t=ma(t))&&(e||n===i))return t.slice(0,pe(t)+1);if(!t||!(n=oi(n)))return t;var r=le(t);return _i(r,0,te(r,le(n))+1).join("")},ze.trimStart=function(t,n,e){if((t=ma(t))&&(e||n===i))return t.replace(rt,"");if(!t||!(n=oi(n)))return t;var r=le(t);return _i(r,Zn(r,le(n))).join("")},ze.truncate=function(t,n){var e=30,r="...";if(Zo(n)){var u="separator"in n?n.separator:u;e="length"in n?ha(n.length):e,r="omission"in n?oi(n.omission):r}var o=(t=ma(t)).length;if(ie(t)){var a=le(t);o=a.length}if(e>=o)return t;var c=e-fe(r);if(c<1)return r;var s=a?_i(a,0,c).join(""):t.slice(0,c);if(u===i)return s+r;if(a&&(c+=s.length-c),ia(u)){if(t.slice(c).search(u)){var f,l=s;for(u.global||(u=Tt(u.source,ma(pt.exec(u))+"g")),u.lastIndex=0;f=u.exec(l);)var p=f.index;s=s.slice(0,p===i?c:p)}}else if(t.indexOf(oi(u),c)!=c){var h=s.lastIndexOf(u);h>-1&&(s=s.slice(0,h))}return s+r},ze.unescape=function(t){return(t=ma(t))&&G.test(t)?t.replace(V,he):t},ze.uniqueId=function(t){var n=++kt;return ma(t)+n},ze.upperCase=Xa,ze.upperFirst=Ha,ze.each=mo,ze.eachRight=_o,ze.first=$u,oc(ze,(vc={},_r(ze,(function(t,n){Rt.call(ze.prototype,n)||(vc[n]=t)})),vc),{chain:!1}),ze.VERSION="4.17.21",Dn(["bind","bindKey","curry","curryRight","partial","partialRight"],(function(t){ze[t].placeholder=ze})),Dn(["drop","take"],(function(t,n){We.prototype[t]=function(e){e=e===i?1:ve(ha(e),0);var r=this.__filtered__&&!n?new We(this):this.clone();return r.__filtered__?r.__takeCount__=me(e,r.__takeCount__):r.__views__.push({size:me(e,h),type:t+(r.__dir__<0?"Right":"")}),r},We.prototype[t+"Right"]=function(n){return this.reverse()[t](n).reverse()}})),Dn(["filter","map","takeWhile"],(function(t,n){var e=n+1,r=1==e||3==e;We.prototype[t]=function(t){var n=this.clone();return n.__iteratees__.push({iteratee:uu(t,3),type:e}),n.__filtered__=n.__filtered__||r,n}})),Dn(["head","last"],(function(t,n){var e="take"+(n?"Right":"");We.prototype[t]=function(){return this[e](1).value()[0]}})),Dn(["initial","tail"],(function(t,n){var e="drop"+(n?"":"Right");We.prototype[t]=function(){return this.__filtered__?new We(this):this[e](1)}})),We.prototype.compact=function(){return this.filter(ec)},We.prototype.find=function(t){return this.filter(t).head()},We.prototype.findLast=function(t){return this.reverse().find(t)},We.prototype.invokeMap=Gr((function(t,n){return"function"==typeof t?new We(this):this.map((function(e){return jr(e,t,n)}))})),We.prototype.reject=function(t){return this.filter(ko(uu(t)))},We.prototype.slice=function(t,n){t=ha(t);var e=this;return e.__filtered__&&(t>0||n<0)?new We(e):(t<0?e=e.takeRight(-t):t&&(e=e.drop(t)),n!==i&&(e=(n=ha(n))<0?e.dropRight(-n):e.take(n-t)),e)},We.prototype.takeRightWhile=function(t){return this.reverse().takeWhile(t).reverse()},We.prototype.toArray=function(){return this.take(h)},_r(We.prototype,(function(t,n){var e=/^(?:filter|find|map|reject)|While$/.test(n),r=/^(?:head|last)$/.test(n),u=ze[r?"take"+("last"==n?"Right":""):n],o=r||/^find/.test(n);u&&(ze.prototype[n]=function(){var n=this.__wrapped__,a=r?[1]:arguments,c=n instanceof We,s=a[0],f=c||Mo(n),l=function(t){var n=u.apply(ze,Rn([t],a));return r&&p?n[0]:n};f&&e&&"function"==typeof s&&1!=s.length&&(c=f=!1);var p=this.__chain__,h=!!this.__actions__.length,g=o&&!p,d=c&&!h;if(!o&&f){n=d?n:new We(this);var v=t.apply(n,a);return v.__actions__.push({func:lo,args:[l],thisArg:i}),new qe(v,p)}return g&&d?t.apply(this,a):(v=this.thru(l),g?r?v.value()[0]:v.value():v)})})),Dn(["pop","push","shift","sort","splice","unshift"],(function(t){var n=jt[t],e=/^(?:push|sort|unshift)$/.test(t)?"tap":"thru",r=/^(?:pop|shift)$/.test(t);ze.prototype[t]=function(){var t=arguments;if(r&&!this.__chain__){var i=this.value();return n.apply(Mo(i)?i:[],t)}return this[e]((function(e){return n.apply(Mo(e)?e:[],t)}))}})),_r(We.prototype,(function(t,n){var e=ze[n];if(e){var r=e.name+"";Rt.call(Ce,r)||(Ce[r]=[]),Ce[r].push({name:n,func:e})}})),Ce[Fi(i,2).name]=[{name:"wrapper",func:i}],We.prototype.clone=function(){var t=new We(this.__wrapped__);return t.__actions__=Di(this.__actions__),t.__dir__=this.__dir__,t.__filtered__=this.__filtered__,t.__iteratees__=Di(this.__iteratees__),t.__takeCount__=this.__takeCount__,t.__views__=Di(this.__views__),t},We.prototype.reverse=function(){if(this.__filtered__){var t=new We(this);t.__dir__=-1,t.__filtered__=!0}else(t=this.clone()).__dir__*=-1;return t},We.prototype.value=function(){var t=this.__wrapped__.value(),n=this.__dir__,e=Mo(t),r=n<0,i=e?t.length:0,u=function(t,n,e){for(var r=-1,i=e.length;++r<i;){var u=e[r],o=u.size;switch(u.type){case"drop":t+=o;break;case"dropRight":n-=o;break;case"take":n=me(n,t+o);break;case"takeRight":t=ve(t,n-o)}}return{start:t,end:n}}(0,i,this.__views__),o=u.start,a=u.end,c=a-o,s=r?a:o-1,f=this.__iteratees__,l=f.length,p=0,h=me(c,this.__takeCount__);if(!e||!r&&i==c&&h==c)return li(t,this.__actions__);var g=[];t:for(;c--&&p<h;){for(var d=-1,v=t[s+=n];++d<l;){var m=f[d],_=m.iteratee,y=m.type,w=_(v);if(2==y)v=w;else if(!w){if(1==y)continue t;break t}}g[p++]=v}return g},ze.prototype.at=po,ze.prototype.chain=function(){return fo(this)},ze.prototype.commit=function(){return new qe(this.value(),this.__chain__)},ze.prototype.next=function(){this.__values__===i&&(this.__values__=la(this.value()));var t=this.__index__>=this.__values__.length;return{done:t,value:t?i:this.__values__[this.__index__++]}},ze.prototype.plant=function(t){for(var n,e=this;e instanceof Ne;){var r=Fu(e);r.__index__=0,r.__values__=i,n?u.__wrapped__=r:n=r;var u=r;e=e.__wrapped__}return u.__wrapped__=t,n},ze.prototype.reverse=function(){var t=this.__wrapped__;if(t instanceof We){var n=t;return this.__actions__.length&&(n=new We(this)),(n=n.reverse()).__actions__.push({func:lo,args:[Qu],thisArg:i}),new qe(n,this.__chain__)}return this.thru(Qu)},ze.prototype.toJSON=ze.prototype.valueOf=ze.prototype.value=function(){return li(this.__wrapped__,this.__actions__)},ze.prototype.first=ze.prototype.head,Ht&&(ze.prototype[Ht]=function(){return this}),ze}();pn._=ge,(r=function(){return ge}.call(n,e,n,t))===i||(t.exports=r)}.call(this)},592:(t,n,e)=>{"use strict";var r=e(516),i=e(522),u=e(106),o=e(631),a=e(202),c=e(763);t.exports=function(t){return new Promise((function(n,s){var f=t.data,l=t.headers;r.isFormData(f)&&delete l["Content-Type"];var p=new XMLHttpRequest;if(t.auth){var h=t.auth.username||"",g=t.auth.password||"";l.Authorization="Basic "+btoa(h+":"+g)}if(p.open(t.method.toUpperCase(),u(t.url,t.params,t.paramsSerializer),!0),p.timeout=t.timeout,p.onreadystatechange=function(){if(p&&4===p.readyState&&(0!==p.status||p.responseURL&&0===p.responseURL.indexOf("file:"))){var e="getAllResponseHeaders"in p?o(p.getAllResponseHeaders()):null,r={data:t.responseType&&"text"!==t.responseType?p.response:p.responseText,status:p.status,statusText:p.statusText,headers:e,config:t,request:p};i(n,s,r),p=null}},p.onerror=function(){s(c("Network Error",t,null,p)),p=null},p.ontimeout=function(){s(c("timeout of "+t.timeout+"ms exceeded",t,"ECONNABORTED",p)),p=null},r.isStandardBrowserEnv()){var d=e(948),v=(t.withCredentials||a(t.url))&&t.xsrfCookieName?d.read(t.xsrfCookieName):void 0;v&&(l[t.xsrfHeaderName]=v)}if("setRequestHeader"in p&&r.forEach(l,(function(t,n){void 0===f&&"content-type"===n.toLowerCase()?delete l[n]:p.setRequestHeader(n,t)})),t.withCredentials&&(p.withCredentials=!0),t.responseType)try{p.responseType=t.responseType}catch(n){if("json"!==t.responseType)throw n}"function"==typeof t.onDownloadProgress&&p.addEventListener("progress",t.onDownloadProgress),"function"==typeof t.onUploadProgress&&p.upload&&p.upload.addEventListener("progress",t.onUploadProgress),t.cancelToken&&t.cancelToken.promise.then((function(t){p&&(p.abort(),s(t),p=null)})),void 0===f&&(f=null),p.send(f)}))}},631:(t,n,e)=>{"use strict";var r=e(516),i=["age","authorization","content-length","content-type","etag","expires","from","host","if-modified-since","if-unmodified-since","last-modified","location","max-forwards","proxy-authorization","referer","retry-after","user-agent"];t.exports=function(t){var n,e,u,o={};return t?(r.forEach(t.split("\n"),(function(t){if(u=t.indexOf(":"),n=r.trim(t.substr(0,u)).toLowerCase(),e=r.trim(t.substr(u+1)),n){if(o[n]&&i.indexOf(n)>=0)return;o[n]="set-cookie"===n?(o[n]?o[n]:[]).concat([e]):o[n]?o[n]+", "+e:e}})),o):o}},680:t=>{"use strict";t.exports=function(t,n){return n?t.replace(/\/+$/,"")+"/"+n.replace(/^\/+/,""):t}},763:(t,n,e)=>{"use strict";var r=e(449);t.exports=function(t,n,e,i,u){var o=new Error(t);return r(o,n,e,i,u)}},864:t=>{"use strict";t.exports=function(t){return!(!t||!t.__CANCEL__)}},881:(t,n,e)=>{"use strict";var r=e(516);t.exports=function(t,n,e){return r.forEach(e,(function(e){t=e(t,n)})),t}},928:t=>{"use strict";function n(t){this.message=t}n.prototype.toString=function(){return"Cancel"+(this.message?": "+this.message:"")},n.prototype.__CANCEL__=!0,t.exports=n},948:(t,n,e)=>{"use strict";var r=e(516);t.exports=r.isStandardBrowserEnv()?{write:function(t,n,e,i,u,o){var a=[];a.push(t+"="+encodeURIComponent(n)),r.isNumber(e)&&a.push("expires="+new Date(e).toGMTString()),r.isString(i)&&a.push("path="+i),r.isString(u)&&a.push("domain="+u),!0===o&&a.push("secure"),document.cookie=a.join("; ")},read:function(t){var n=document.cookie.match(new RegExp("(^|;\\s*)("+t+")=([^;]*)"));return n?decodeURIComponent(n[3]):null},remove:function(t){this.write(t,"",Date.now()-864e5)}}:{write:function(){},read:function(){return null},remove:function(){}}},980:t=>{"use strict";t.exports=function(t){return function(n){return t.apply(null,n)}}},987:(t,n,e)=>{"use strict";var r=e(516),i=e(18),u={"Content-Type":"application/x-www-form-urlencoded"};function o(t,n){!r.isUndefined(t)&&r.isUndefined(t["Content-Type"])&&(t["Content-Type"]=n)}var a,c={adapter:(("undefined"!=typeof XMLHttpRequest||"undefined"!=typeof process)&&(a=e(592)),a),transformRequest:[function(t,n){return i(n,"Content-Type"),r.isFormData(t)||r.isArrayBuffer(t)||r.isBuffer(t)||r.isStream(t)||r.isFile(t)||r.isBlob(t)?t:r.isArrayBufferView(t)?t.buffer:r.isURLSearchParams(t)?(o(n,"application/x-www-form-urlencoded;charset=utf-8"),t.toString()):r.isObject(t)?(o(n,"application/json;charset=utf-8"),JSON.stringify(t)):t}],transformResponse:[function(t){if("string"==typeof t)try{t=JSON.parse(t)}catch(t){}return t}],timeout:0,xsrfCookieName:"XSRF-TOKEN",xsrfHeaderName:"X-XSRF-TOKEN",maxContentLength:-1,validateStatus:function(t){return t>=200&&t<300},headers:{common:{Accept:"application/json, text/plain, */*"}}};r.forEach(["delete","get","head"],(function(t){c.headers[t]={}})),r.forEach(["post","put","patch"],(function(t){c.headers[t]=r.merge(u)})),t.exports=c}},n={};function e(r){var i=n[r];if(void 0!==i)return i.exports;var u=n[r]={id:r,loaded:!1,exports:{}};return t[r].call(u.exports,u,u.exports,e),u.loaded=!0,u.exports}e.n=t=>{var n=t&&t.__esModule?()=>t.default:()=>t;return e.d(n,{a:n}),n},e.d=(t,n)=>{for(var r in n)e.o(n,r)&&!e.o(t,r)&&Object.defineProperty(t,r,{enumerable:!0,get:n[r]})},e.g=function(){if("object"==typeof globalThis)return globalThis;try{return this||new Function("return this")()}catch(t){if("object"==typeof window)return window}}(),e.o=(t,n)=>Object.prototype.hasOwnProperty.call(t,n),e.r=t=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},e.nmd=t=>(t.paths=[],t.children||(t.children=[]),t);var r={};return(()=>{"use strict";e.r(r),e.d(r,{DesignPriceCalculatorRuleBased:()=>p,DesignPriceCalculatorRuleFactory:()=>l});var t,n=e(505),i=e.n(n),u=e(543),o=e.n(u),a=function(t,n,e){if(e||2===arguments.length)for(var r,i=0,u=n.length;i<u;i++)!r&&i in n||(r||(r=Array.prototype.slice.call(n,0,i)),r[i]=n[i]);return t.concat(r||Array.prototype.slice.call(n))},c=function(t,n,e,r){var i=this;this.maxX=function(){return i.x+i.width},this.maxY=function(){return i.y+i.height},this.area=function(){return i.width*i.height},this.areaPPCM=function(t){return i.width/t*(i.height/t)},this.equals=function(t){return i.width.toFixed(4)==t.width.toFixed(4)&&i.height.toFixed(4)==t.height.toFixed(4)&&i.x==t.x&&i.y==t.y},this.width=t,this.height=n,this.x=e,this.y=r},s=function(t,n,e){return e.indexOf(t)===n};!function(t){t[t.Tutti=1]="Tutti",t[t.AllElementsNoTemplateItems=18]="AllElementsNoTemplateItems",t[t.AllTexts=8]="AllTexts",t[t.AllCustomText=9]="AllCustomText",t[t.SingleElement=10]="SingleElement",t[t.AllImages=11]="AllImages",t[t.UploadedImages=12]="UploadedImages",t[t.AllTextArt=13]="AllTextArt",t[t.AllCustomTextArt=14]="AllCustomTextArt",t[t.AllCustomElements=15]="AllCustomElements",t[t.ClipartImages=16]="ClipartImages",t[t.TemplatesImages=17]="TemplatesImages",t[t.OnlyVectorImages=19]="OnlyVectorImages",t[t.OnlyRasterImages=20]="OnlyRasterImages"}(t||(t={}));const f=t=>{const n=[{operator:">",func:(t,n)=>t>n},{operator:"<",func:(t,n)=>t<n},{operator:"=",func:(t,n)=>t==n},{operator:">=",func:(t,n)=>t>=n},{operator:"<=",func:(t,n)=>t<=n},{operator:"!=",func:(t,n)=>t!=n}].find((n=>n.operator==t))?.func;if(null==n)throw new Error(`Function  for operator ${t} not found`);return n};class l{}l.create=async(t,n,e,r,i,u,o)=>{let a=new p(n,e,r,i,u,o);return await a.init(t).catch((t=>console.log(t))),a};class p{constructor(n,e,r,l,p,h){this.colorID=-1,this.config={isOwin:!0,apiUrl:"https://test-api.zakeke.com/api/graphql",cloudFlareApiUrl:null,token:"Gw6IL2Q7e66r3osC16_T6XSlsrnuUAHmw59Y3-qJv2LaPPV-nuzDkC0eOGAU8ef_i94HLlu8vDVXpk9MAWBtwrXWN7_XizPAeIfKXArfol19Ek7wmZMR3zRQWwHChqPmYDJMrI3WeCIQGRJxsR7q8hh5xywTqdOwVi6LT7_8-qP9jkc_tdBUPiMUrT6HI1i1ygnEGEk6Eoa97zvbVGRE3NRt-W5nXKGv4_INB_VBdpOihHVXIzl7PtchqPyBr7AaW5Hdrbh_KoFwEhLTcTixXpxfzOcjecbyqFHw20fNFlg2ny6Cb375i7hpnFWD7Q4lj9xI3R6jbkpFHsQEFfBK-UF1f9vli0liCWQ3WdAYGQEmUYx7QjCy240GuR_cK6c28JHoabSGQdW91K7KEAug4o19nokKfzbWoZM7WD4T4RVXNB_ob_gjeYKsK7EJIt6qGiPpnJEbSeFCjz1EhE31Jw6MO-oawNSASxgYk1D6Z3XkLw1G",clientLang:null,graphqlUrl:"https://apollo-test.zakeke.com/graphql"},this.init=t=>(this.product=t,new Promise(((n,e)=>{try{this.getPricings(t,((t,e)=>{this.pricings=t,this.properties=e,n()}))}catch(t){e(t)}}))),this.getPricings=async(t,n)=>{if(this.pricings)n(this.pricings,this.properties);else{const e={name:"pricingsConfigurationQuery",query:"query pricingsQuery($first: Int!, $productID: Long!, $languageCulture: String) {\n                                    pricingProperties { propertyID functionName }\n                                    pricingsDetailed(first: $first, productID: $productID, isForFrontEnd: true, languageCulture: $languageCulture) {\n                                        edges {\n                                            node {\n                                                id\n                                                description\n                                                infoPricingText\n                                                priceDescriptionEnabled\n                                                priceStructure\n                                                products {\n                                                    productID\n                                                }\n                                                printTypes {\n                                                    printTypeID\n                                                }\n                                                rules {\n                                                    ruleID\n                                                    propertyID\n                                                    allMatchType\n                                                    elementID\n                                                    elementTitle\n                                                    isSetupPrice\n                                                    priceType\n                                                    targets {\n                                                        area\n                                                        color\n                                                        side\n                                                        targetID\n                                                    }\n                                                    conditions {\n                                                        conditionID\n                                                        formula\n                                                        position\n                                                        priceToAdd\n                                                        quantity\n                                                    }\n                                                }\n                                            }\n                                        }\n                                    }\n                                }",variables:{first:50,productID:t.get("modelID"),languageCulture:this.config.clientLang}},r={headers:{"Content-Type":"application/json",withCredentials:!1,Accept:"application/json"}};this.config.isOwin?r.headers.Authorization="Bearer "+this.config.token:r.headers["X-Auth-Token"]=this.config.token;const u={type:"POST",url:this.config.graphqlUrl,data:JSON.stringify(e),contentType:"application/json",dataType:"json"};this.config.isOwin?u.Authorization="Bearer "+this.config.token:u["X-Auth-Token"]=this.config.token;try{if(void 0!==this.config.cloudFlareApiUrl&&null!==this.config.cloudFlareApiUrl&&""!==this.config.cloudFlareApiUrl){const t=await i().post(this.config.cloudFlareApiUrl,e,r);return void n(t.data.data.pricingsDetailed.edges.map((t=>t.node)),t.data.data.pricingProperties)}}catch(t){}try{const t=await i().post(this.config.graphqlUrl,e,r);n(t.data.data.pricingsDetailed.edges.map((t=>t.node)),t.data.data.pricingProperties)}catch(t){console.log(t)}}},this.getPricing=t=>{if(this.pricings){let n,e=this.pricings.find((t=>t.products.find((t=>t.productID==this.product.get("modelID")))));if(e&&-1!==this.colorID&&(n=[[e,this.product.get("colors").find((t=>t.get("colorID")===this.colorID)).get("sides").map((t=>t.get("sideID")))]]),!e&&-1!==this.colorID){let e=this.product.get("colors").find((t=>t.get("colorID")===this.colorID)).get("sides").map((t=>t.get("sideID"))).map((n=>{const e=t.get("sidesPrintTypes").find((t=>t.get("sideID")===n));return[n,e?e.get("printTypeID"):t.get("printTypeID")]})),r=new Map,i=[e.map((t=>[t[0],this.pricings?.find((n=>n.printTypes.find((n=>n.printTypeID===t[1]))))||null]))];i[0].forEach((([t,n])=>{if(r.get(n)){let e=r.get(n);e.push(t),r.set(n,e)}else r.set(n,[t])})),n=Array.from(r)}return n}},this.distinct=(t,n,e)=>e.indexOf(t)===n,this.ElementSizeFunction=(t,n)=>{let e={result:!1,multiplier:0,items:t.items};if(!n.values||0==n.values.length)throw"values missing in formula";if(null==n.values||0==n.values.length)throw"ElementSize invalid value";return t.items.forEach((r=>{const i=JSON.parse(r.get("json"))[1];var u=i.data.transformsData.dimensions.width,o=i.data.transformsData.dimensions.height;if(!Boolean(i.data.isImagePlaceholder)){var a=r.get("areas").at(0).get("sideID"),c=t.sides.find((t=>t.get("sideID")==a));if(null!=u&&null!=o&&null!=c&&c.get("ppcm")>0){var s=u/c.get("ppcm"),l=o/c.get("ppcm")*s;f(n.operator)(l,n.values[0])&&(e.result=!0,e.multiplier+=1,e.items=e.items.filter((t=>t!=r)))}}})),e},this.NumberOfElementsSimplifiedFunction=(t,n)=>({result:t.items.length>0,multiplier:t.items.length,items:t.items}),this.LinesLengthFunction=(t,n)=>{let e={result:!1,multiplier:0};if(!n.values||0==n.values.length)throw"values missing in formula";return t.items.forEach((t=>{const r=JSON.parse(t.get("json"))[1];var i=r.data.isText,o=r.data.isTextArea,a=r.data.isTextOnPath;let c=r.data.isTextArt,s="";if(null!=i&&i?s=r.content.toString():(null!=o&&o||null!=a&&a)&&(s=r.data.text.toString()),null!=c&&c&&(s=t.get("textArt").get("text")),!(0,u.isEmpty)(s)){const t=s.split("\n").length;f(n.operator)(t,n.values[0])&&(e.result=!0,e.multiplier+=1)}})),e},this.AmountOfElementsFunction=(t,n)=>{let e={result:!1,multiplier:0};if(!n.values||0==n.values.length)throw"values missing in formula";return f(n.operator)(t.items.length,n.values[0])&&(e.result=!0,e.multiplier=1),e},this.AmountOfUsedColorsFunction=(t,n)=>{let e={result:!1,multiplier:0};if(!n.values||0==n.values.length)throw"values missing in formula";const r=(0,u.uniq)(t.items.filter((t=>t.get("itemColors")&&!(0,u.isEmpty)(t.get("itemColors")))).flatMap((t=>t.get("itemColors"))));return f(n.operator)(r.filter(this.distinct).length,n.values[0])&&(e.result=!0,e.multiplier=1),e},this.CanvasSizeFunction=(t,n)=>{let e={result:!1,multiplier:0};if(!n.values||0==n.values.length)throw"values missing in formula";return t.sides&&!(0,u.isEmpty)(t.sides)&&t.sides.flatMap((t=>t.get("areas").models)).forEach((r=>{var i=r.get("boundsWidth"),u=r.get("boundsHeight");const o=t.design?.get("options")?.find((t=>t.get("colorID")==r.getColorID()&&(t.get("sideID")===r.getSideID()||null===t.get("sideID"))));o&&o.get("width")&&o.get("height")&&(i=o.get("width"),u=o.get("height"));var a=t.sides.find((t=>t.get("sideID")==r.getSideID()));if(null!=a&&a.get("ppcm")>0){var c=i/a.get("ppcm"),s=u/a.get("ppcm"),l=(c=Math.round(100*c)/100)*(s=Math.round(100*s)/100);f(n.operator)(l,n.values[0])&&(e.result=!0,e.multiplier+=1)}})),e},this.DesignSizeFunction=(t,n)=>{let e={result:!1,multiplier:0},r=0;if(!n.values||0==n.values.length)throw"values missing in formula";return t.sides&&!(0,u.isEmpty)(t.sides)&&t.sides.flatMap((t=>t.get("areas").models)).forEach((n=>{let e=t.items.filter((t=>t.get("areas").filter((t=>t.get("colorID")==n.getColorID()&&t.get("sideID")==n.getSideID()&&t.get("areaID")==n.get("areaID"))).length>0)),i=t.sides.find((t=>t.get("sideID")==n.getSideID()));if(null!=i&&i.get("ppcm")>0){const t=e.map((t=>JSON.parse(t.get("json"))[1])).filter((t=>!Boolean(t.data.isImagePlaceholder))).map((t=>{const n=t.data.transformsData.dimensions.width,e=t.data.transformsData.dimensions.height,r=t.data.transformsData.position.x,i=t.data.transformsData.position.y;return new c(n,e,r-n/2,i-e/2)}));r+=function(t,n){var e=t.reduce((function(t,n){return a(a([],t,!0),[n.x,n.maxX()],!1)}),[]).filter(s).sort((function(t,n){return t-n})),r=a([],t,!0);e.forEach((function(t){var n=r.filter((function(n){return function(t,n){return t.x<n&&t.maxX()>n}(n,t)})),e=r.filter((function(n){return function(t,n){return t.x>=n||t.maxX()<=n}(n,t)})),i=n.map((function(n){return function(t,n){return n<=t.x||n>=t.x+t.width?[t]:[new c(n-t.x,t.height,t.x,t.y),new c(t.maxX()-n,t.height,n,t.y)]}(n,t)})).reduce((function(t,n){return t.concat(n)}),[]);r=a(a([],e,!0),i,!0)}));var i=r.reduce((function(t,n){return a(a([],t,!0),[n.y,n.maxY()],!1)}),[]).filter(s).sort((function(t,n){return t-n})),u=a([],r,!0);return i.forEach((function(t){var n=u.filter((function(n){return function(t,n){return t.y<n&&t.maxY()>n}(n,t)})),e=u.filter((function(n){return function(t,n){return t.y>=n||t.maxY()<=n}(n,t)})),r=n.map((function(n){return function(t,n){return n<=t.y||n>=t.y+t.height?[t]:[new c(t.width,n-t.y,t.x,t.y),new c(t.width,t.maxY()-n,t.x,n)]}(n,t)})).reduce((function(t,n){return t.concat(n)}),[]);u=a(a([],e,!0),r,!0)})),u.filter((function(t,n,e){return e.findIndex((function(n){return n.equals(t)}))==n})).reduce((function(t,e){return n?t+e.areaPPCM(n):t+e.area()}),0)}(t,i.get("ppcm"))}})),r>0&&f(n.operator)(r,n.values[0])&&(e.result=!0,e.multiplier+=1),e},this.DesignTextLengthFunction=(t,n)=>{let e={result:!1,multiplier:0};if(!n.values||0==n.values.length)throw"values missing in formula";let r=0;return t.items.forEach((t=>{const n=JSON.parse(t.get("json"))[1];let e=n.data.isText,i=n.data.isTextArea,o=n.data.isTextOnPath,a=n.data.isTextArt,c="";null!=e&&e?c=n.content.toString():null!=i&&i||null!=o&&o?c=n.data.text.toString():null!=a&&a&&(c=t.get("textArt").get("text")),(0,u.isEmpty)(c)||(r+=c.trim().split(" ").join("").replace(/(\r\n|\n|\r)/gm,"").length)})),f(n.operator)(r,n.values[0])&&(e.result=!0,e.multiplier=1),e},this.CustomizedSidesFunction=(t,n)=>{let e={result:!1,multiplier:0};if(!n.values||0==n.values.length)throw"values missing in formula";let r=0;return t.sides.forEach((n=>{t.items.filter((t=>t.get("areas").filter((t=>t.get("sideID")==n.get("sideID"))).length>0)).length>0&&r++})),t.sides.length>0&&f(n.operator)(r,n.values[0])&&(e.result=!0,e.multiplier=1),e},this.TextLengthFunction=(t,n)=>{let e={result:!1,multiplier:0};if(!n.values||0==n.values.length)throw"values missing in formula";return t.items.forEach((t=>{let r=JSON.parse(t.get("json"))[1],i=r.data.isText,o=r.data.isTextArea,a=r.data.isTextOnPath,c=r.data.isTextArt,s="";null!=i&&i?s=r.content.toString():null!=o&&o||null!=a&&a?s=r.data.text.toString():null!=c&&c&&(s=t.get("textArt").get("text")),!(0,u.isEmpty)(s)&&f(n.operator)(s.trim().split(" ").join("").length,n.values[0])&&(e.result=!0,e.multiplier+=1)})),e},this.conditionsToConditionsGroupByFormula=t=>{const n=o().groupBy(t,(t=>t?.formula?t?.formula:""));return Object.keys(n).map((t=>({formula:t,position:n[t][0]?.position,conditions:n[t]})))},this.getFunctionName=(t,n)=>{try{return t?.filter((t=>t.propertyID==n.propertyID)).map((t=>t.functionName))[0]}catch(t){throw"function or operator don't exist in dictionaries"}},this.GetContextForRule=(n,e,r,i,a=null)=>{let c={sides:[],items:[],design:r},s=r.get("designItems").toArray();var f=[];let l="";const p=a?e.get("colors").find((t=>t.get("colorID")==a)):null,h=e.get("colors").find((t=>t.get("colorID")==this.colorID));if(null==h||null==h)return c;l=p?p.get("name"):h.get("name");const g=h.get("sides");c.sides=[],0==n.targets.length?(f=s,c.sides=g.toArray()):n.targets.forEach((t=>{let n=!1,r=null,i=s;if((0,u.isEmpty)(t.color)||t.color.toLowerCase()==l.toLowerCase())for(const t of g.toArray())-1===c.sides.indexOf(t)&&c.sides.push(t);else n=!0;if(!(0,u.isEmpty)(t.side))if(r=g.find((n=>n.get("name").toLowerCase()==t.side.toLowerCase())),null!=r&&r.get("areas")){let t=[];const n=(t,n)=>t.get("areas").filter((t=>t.get("modelID")==e.get("modelID")&&t.get("colorID")==n.getSide().getColor().get("colorID")&&t.get("sideID")==n.getSide().get("sideID")&&t.get("areaID")==n.get("areaID"))).length>0;r.get("areas").forEach((e=>{t=t.concat(s.filter((t=>n(t,e))))})),i=t}else n=!0;if(!(0,u.isEmpty)(t.area)){let n=[],r=[];g.forEach((n=>{r=r.concat(n.get("areas").filter((n=>n.get("name").toLowerCase()==t.area.toLowerCase())))})),r.forEach((t=>{n=[...i.filter((n=>n.get("areas").filter((n=>n.get("modelID")==e.get("modelID")&&n.get("colorID")==t.getSide().getColor().get("colorID")&&n.get("sideID")==t.getSide().get("sideID")&&n.get("areaID")==t.get("areaID"))).length>0))]})),i=n}n||(f=[...f,...i])})),n.elementID==t.AllTexts?f=f.filter((t=>{let n=JSON.parse(t.get("json"))[1];return null!=n.data.isText&&n.data.isText||null!=n.data.isTextArea&&n.data.isTextArea||null!=n.data.isTextOnPath&&n.data.isTextOnPath||null!=n.data.isTextArt&&n.data.isTextArt})):n.elementID==t.AllElementsNoTemplateItems?f=f.filter((t=>!JSON.parse(t.get("json"))[1].data.isTemplateElement)):n.elementID==t.AllCustomText?f=f.filter((t=>{var n=JSON.parse(t.get("json"))[1];return null!=n.data.isTemplateElement&&!n.data.isTemplateElement&&(null!=n.data.isText&&n.data.isText||null!=n.data.isTextArea&&n.data.isTextArea||null!=n.data.isTextOnPath&&n.data.isTextOnPath||null!=n.data.isTextArt&&n.data.isTextArt)||null==n.data.isTemplateElement&&(null!=n.data.isText&&n.data.isText||null!=n.data.isTextArea&&n.data.isTextArea||null!=n.data.isTextOnPath&&n.data.isTextOnPath||null!=n.data.isTextArt&&n.data.isTextArt)})):n.elementID==t.AllImages?f=f.filter((t=>t.get("imageID")>0)).filter((t=>!JSON.parse(t.get("json"))[1].data.isTemplateElement)):n.elementID==t.UploadedImages?f=f.filter((t=>{if(t.get("imageID")>0){if(t.get("imageVisitorCode")||t.get("imageCustomerCode"))return!0;if(t.get("imageVisitorID")>0||t.get("imageCustomerID")>0)return!0}return!1})).filter((t=>!JSON.parse(t.get("json"))[1].data.isTemplateElement)):n.elementID==t.ClipartImages?f=f.filter((t=>t.get("imageID")>0&&!t.get("imageVisitorCode")&&!t.get("imageCustomerCode")&&!(t.get("imageVisitorID")>0||t.get("imageCustomerID")>0))).filter((t=>!JSON.parse(t.get("json"))[1].data.isTemplateElement)):n.elementID==t.TemplatesImages?f=f.filter((t=>t.get("imageID")>0)).filter((t=>JSON.parse(t.get("json"))[1].data.isTemplateElement)):n.elementID==t.SingleElement?f=f.filter((t=>t.get("name").toLowerCase()==n.elementTitle.toLowerCase())):n.elementID==t.AllTextArt?f=f.filter((t=>{let n=JSON.parse(t.get("json"))[1];return null!=n.data.isTextArt&&n.data.isTextArt})):n.elementID==t.AllCustomTextArt||(n.elementID==t.AllCustomElements?f=f.filter((t=>{const n=JSON.parse(t.get("json"))[1];return t.get("imageID")>0&&!n.data.isTemplateElement&&(t.get("imageVisitorCode")||t.get("imageCustomerCode")||t.get("imageVisitorID")>0||t.get("imageCustomerID")>0)||null!=n.data.isTemplateElement&&!n.data.isTemplateElement&&(null!=n.data.isText&&n.data.isText||null!=n.data.isTextArea&&n.data.isTextArea||null!=n.data.isTextOnPath&&n.data.isTextOnPath||null!=n.data.isTextArt&&n.data.isTextArt)||null==n.data.isTemplateElement&&(null!=n.data.isText&&n.data.isText||null!=n.data.isTextArea&&n.data.isTextArea||null!=n.data.isTextOnPath&&n.data.isTextOnPath||null!=n.data.isTextArt&&n.data.isTextArt)})):n.elementID==t.UploadedImages?f=f.filter((t=>{if(t.get("imageID")>0){if(t.get("imageVisitorCode")||t.get("imageCustomerCode"))return!0;if(t.get("imageVisitorID")>0||t.get("imageCustomerID")>0)return!0}return!1})):n.elementID===t.OnlyVectorImages?f=f.filter((t=>t.get("imageID")>0&&"Vector"===t.get("imageType"))):n.elementID===t.OnlyRasterImages&&(f=f.filter((t=>t.get("imageID")>0&&"Raster"===t.get("imageType")||"Vector+Raster"===t.get("imageType")))));const d=o().groupBy(f,(t=>t.get("itemGuid")));return c.items=Object.keys(d).map((t=>d[t][0])),c.items=c.items.filter((t=>{if(0===t.get("areas").length)return!1;const n=t.get("areas").at(0).get("sideID");return i.includes(n)})),c},this.isUsingAmountOfColors=t=>{if(this.pricings){let n=this.pricings.find((t=>t.products.find((t=>t.productID==this.product.get("modelID")))));if(n)return null!=n.rules.find((t=>10==t.propertyID));{let n=this.pricings.find((n=>n.printTypes.find((n=>n.printTypeID===t))));if(n)return null!=n.rules.find((t=>10==t.propertyID))}}return!1},this.getPremiumPhotosPrice=(t,n)=>{const e=[];let r=0;for(var i=0;i<t.get("designItems").length;i++){const u=t.get("designItems").at(i);if(u.get("imageID")>0&&u.get("imagePrice")>0&&null!=u.get("providerImageID")&&u.get("providerImageID")?.length>0&&!e.find((t=>t.get("providerImageID")===u.get("providerImageID")))){e.push(u);let t=u.get("imagePrice");t=this.product.get("hasAdditionalFeeOnImagesProvider")||null===u.get("applyImagePriceForQuantity")||u.get("applyImagePriceForQuantity")?u.get("imagePrice")*n:u.get("imagePrice"),r+=t}}return Logger.info("Premium photo price: ",r),r},this.getImagePrice=(t,n)=>{let e=0;for(var r=0;r<t.get("designItems").length;r++){const i=t.get("designItems").at(r);if(i.get("imageID")>0&&i.get("imagePrice")>0&&!i.get("providerImageID")){let t=i.get("imagePrice");t=i.get("imagePrice")*n,e+=t}}return Logger.info("Image price: ",e),e},this.getMatchedConditions=(t,n,e,r=null)=>{let i=this.getPricing(t);if(!i)return[];let u=[];return i.forEach((i=>{if(!i[0])return;let o=i[1];i[0].rules.forEach((i=>{if(!e&&1==i.priceType)return;const a=this.GetContextForRule(i,this.product,t,o,r);if(0===a.sides.length)return;const c=this.conditionsToConditionsGroupByFormula(i.conditions);let s={};try{c.sort(((t,n)=>t&&n&&t.position>n.position?1:-1)).forEach((t=>{let e=JSON.parse(t.formula);if(!e.operator)throw"operator missing in formula";const r=this[this.getFunctionName(this.properties,i)+"Function"](a,e);if(r.result){let e=t.conditions.filter((t=>t.quantity<=n)).sort(((t,n)=>n.quantity-t.quantity))[0];if(null!=e){const t=e.priceToAdd,n=i.isSetupPrice,o=r.multiplier,c=i.priceType;u.push({priceToAdd:t,isSetupPrice:n,multiplier:o,priceType:c});const f=!r.items||0==r.items.length;if(!i.allMatchType&&r.items&&(a.items=r.items),!i.allMatchType&&f)throw s}}}))}catch(t){if(t!==s)throw t}}))})),u},this.calculate=(t,n,e=null,r=!0)=>{let i=[],u=this.getPremiumPhotosPrice(t,n);return u+=this.getImagePrice(t,n),r&&(i=this.getMatchedConditions(t,n,!1,e),i.forEach((t=>{let e=t.priceToAdd*t.multiplier;t.isSetupPrice||(e*=n),u+=e}))),Logger.info("Total custom price: ",u),u},this.getPricingAdditionalInfo=t=>{let n;if(this.pricings&&(n=this.pricings.find((t=>t.products.find((t=>t.productID==this.product.get("modelID"))))),n||(n=this.pricings.find((n=>n.printTypes.find((n=>n.printTypeID===t)))))),n)return{description:n.description,priceDescriptionEnabled:n.priceDescriptionEnabled,infoPricingText:n.infoPricingText,priceStructure:n.priceStructure}},void 0!==n&&(this.config.apiUrl=n+"graphql"),void 0!==e&&(this.config.token=e),void 0!==r&&(this.config.isOwin=r),l&&(this.config.cloudFlareApiUrl=l+"graphql"),p&&(this.config.clientLang=p),h&&(this.config.graphqlUrl=h)}}})(),r})()));
//# sourceMappingURL=assets\customizer\Scripts\libs\pricingRuleBase\DesignPriceCalculatorRuleBased.js.map
/*! For license information please see quoteForm.js.LICENSE.txt */
!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.quoteFormLib=t():e.quoteFormLib=t()}(self,(()=>(()=>{var e={72:(e,t,n)=>{"use strict";var r,o=function(){var e={};return function(t){if(void 0===e[t]){var n=document.querySelector(t);if(window.HTMLIFrameElement&&n instanceof window.HTMLIFrameElement)try{n=n.contentDocument.head}catch(e){n=null}e[t]=n}return e[t]}}(),l=[];function a(e){for(var t=-1,n=0;n<l.length;n++)if(l[n].identifier===e){t=n;break}return t}function i(e,t){for(var n={},r=[],o=0;o<e.length;o++){var i=e[o],u=t.base?i[0]+t.base:i[0],s=n[u]||0,c="".concat(u," ").concat(s);n[u]=s+1;var f=a(c),p={css:i[1],media:i[2],sourceMap:i[3]};-1!==f?(l[f].references++,l[f].updater(p)):l.push({identifier:c,updater:h(p,t),references:1}),r.push(c)}return r}function u(e){var t=document.createElement("style"),r=e.attributes||{};if(void 0===r.nonce){var l=n.nc;l&&(r.nonce=l)}if(Object.keys(r).forEach((function(e){t.setAttribute(e,r[e])})),"function"==typeof e.insert)e.insert(t);else{var a=o(e.insert||"head");if(!a)throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");a.appendChild(t)}return t}var s,c=(s=[],function(e,t){return s[e]=t,s.filter(Boolean).join("\n")});function f(e,t,n,r){var o=n?"":r.media?"@media ".concat(r.media," {").concat(r.css,"}"):r.css;if(e.styleSheet)e.styleSheet.cssText=c(t,o);else{var l=document.createTextNode(o),a=e.childNodes;a[t]&&e.removeChild(a[t]),a.length?e.insertBefore(l,a[t]):e.appendChild(l)}}function p(e,t,n){var r=n.css,o=n.media,l=n.sourceMap;if(o?e.setAttribute("media",o):e.removeAttribute("media"),l&&"undefined"!=typeof btoa&&(r+="\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(l))))," */")),e.styleSheet)e.styleSheet.cssText=r;else{for(;e.firstChild;)e.removeChild(e.firstChild);e.appendChild(document.createTextNode(r))}}var d=null,m=0;function h(e,t){var n,r,o;if(t.singleton){var l=m++;n=d||(d=u(t)),r=f.bind(null,n,l,!1),o=f.bind(null,n,l,!0)}else n=u(t),r=p.bind(null,n,t),o=function(){!function(e){if(null===e.parentNode)return!1;e.parentNode.removeChild(e)}(n)};return r(e),function(t){if(t){if(t.css===e.css&&t.media===e.media&&t.sourceMap===e.sourceMap)return;r(e=t)}else o()}}e.exports=function(e,t){(t=t||{}).singleton||"boolean"==typeof t.singleton||(t.singleton=(void 0===r&&(r=Boolean(window&&document&&document.all&&!window.atob)),r));var n=i(e=e||[],t);return function(e){if(e=e||[],"[object Array]"===Object.prototype.toString.call(e)){for(var r=0;r<n.length;r++){var o=a(n[r]);l[o].references--}for(var u=i(e,t),s=0;s<n.length;s++){var c=a(n[s]);0===l[c].references&&(l[c].updater(),l.splice(c,1))}n=u}}}},228:e=>{"use strict";var t=Object.getOwnPropertySymbols,n=Object.prototype.hasOwnProperty,r=Object.prototype.propertyIsEnumerable;e.exports=function(){try{if(!Object.assign)return!1;var e=new String("abc");if(e[5]="de","5"===Object.getOwnPropertyNames(e)[0])return!1;for(var t={},n=0;n<10;n++)t["_"+String.fromCharCode(n)]=n;if("0123456789"!==Object.getOwnPropertyNames(t).map((function(e){return t[e]})).join(""))return!1;var r={};return"abcdefghijklmnopqrst".split("").forEach((function(e){r[e]=e})),"abcdefghijklmnopqrst"===Object.keys(Object.assign({},r)).join("")}catch(e){return!1}}()?Object.assign:function(e,o){for(var l,a,i=function(e){if(null==e)throw new TypeError("Object.assign cannot be called with null or undefined");return Object(e)}(e),u=1;u<arguments.length;u++){for(var s in l=Object(arguments[u]))n.call(l,s)&&(i[s]=l[s]);if(t){a=t(l);for(var c=0;c<a.length;c++)r.call(l,a[c])&&(i[a[c]]=l[a[c]])}}return i}},270:(e,t,n)=>{(e.exports=n(765)(!1)).push([e.id,".form-group {\r\n    margin-bottom: 20px;\r\n}\r\n\r\nform {\r\n    background: #fff;\r\n}\r\n\r\nfieldset {\r\n    overflow-y: auto;\r\n    max-height: 600px;\r\n    border: none;\r\n}\r\nfieldset span.formLabel {\r\n    margin-bottom: 3px;\r\n    font-size: 14px;\r\n    display: block;\r\n}\r\n\r\nfieldset button[type=submit] {\r\n    padding: 10px 20px;\r\n    float: right;\r\n    margin-top: 20px;\r\n    text-transform: uppercase;\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n}\r\n\r\n.quote-details {\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n.quote-details > ul {\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n.quote-details > ul > li {\r\n    display: flex;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.quote-details > ul > li > label {\r\n    display: flex;\r\n}\r\n\r\n.quote-details > ul > li > label > div {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 100%;\r\n}\r\n\r\n.quote-details > ul > li > label:first-child{\r\n    width: 100px;\r\n    margin-right: 10px;\r\n}\r\n\r\n.quote-details > ul > li > label:last-child{\r\n    width: calc(100% - 110px);\r\n}\r\n\r\n.quote-details > ul > li button.btn-remove-option{\r\n    padding: 20px 0 0;\r\n    min-height: unset;\r\n    min-width: unset;\r\n    margin-left: 10px;\r\n    background-color: transparent !important;\r\n    color: #333;\r\n    cursor: pointer;\r\n    \r\n}\r\n\r\n.quote-details > ul > li button.btn-remove-option > i{\r\n    font-size: 22px;\r\n}\r\n\r\n.quote-details .buttons {\r\n    display: flex;\r\n    flex-direction: row;\r\n}\r\n\r\n.quote-details .buttons > button {\r\n    cursor: pointer;\r\n    margin: 0 10px 0 0;\r\n    padding: 0;\r\n    min-width: unset;\r\n    min-height: unset;\r\n    background-color: transparent;\r\n    color: #333;\r\n    text-transform: uppercase;\r\n    font-weight: 600;\r\n    margin-top: 5px;\r\n}\r\n\r\n.quote-details .buttons > button:hover {\r\n    background-color: transparent !important;\r\n    color: lighten(#333, 20%) !important;\r\n}\r\n\r\ntextarea {\r\n    height: 100px !important;\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n\r\n    #formPreview {\r\n        height: 100%;\r\n    }\r\n\r\n    #formPreview > form {\r\n        height: 100%;\r\n    }\r\n\r\n    fieldset {\r\n        padding: 0;\r\n        margin: 0;\r\n        max-height: calc(100% - 54px);\r\n    }\r\n    \r\n    fieldset button[type=submit] {\r\n        position: fixed;\r\n        bottom: 40px;\r\n        width: calc(100% - 82px);\r\n    }\r\n}",""])},287:(e,t,n)=>{"use strict";var r=n(228),o="function"==typeof Symbol&&Symbol.for,l=o?Symbol.for("react.element"):60103,a=o?Symbol.for("react.portal"):60106,i=o?Symbol.for("react.fragment"):60107,u=o?Symbol.for("react.strict_mode"):60108,s=o?Symbol.for("react.profiler"):60114,c=o?Symbol.for("react.provider"):60109,f=o?Symbol.for("react.context"):60110,p=o?Symbol.for("react.forward_ref"):60112,d=o?Symbol.for("react.suspense"):60113,m=o?Symbol.for("react.memo"):60115,h=o?Symbol.for("react.lazy"):60116,y="function"==typeof Symbol&&Symbol.iterator;function v(e){for(var t="https://reactjs.org/docs/error-decoder.html?invariant="+e,n=1;n<arguments.length;n++)t+="&args[]="+encodeURIComponent(arguments[n]);return"Minified React error #"+e+"; visit "+t+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}var g={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},b={};function w(e,t,n){this.props=e,this.context=t,this.refs=b,this.updater=n||g}function x(){}function k(e,t,n){this.props=e,this.context=t,this.refs=b,this.updater=n||g}w.prototype.isReactComponent={},w.prototype.setState=function(e,t){if("object"!=typeof e&&"function"!=typeof e&&null!=e)throw Error(v(85));this.updater.enqueueSetState(this,e,t,"setState")},w.prototype.forceUpdate=function(e){this.updater.enqueueForceUpdate(this,e,"forceUpdate")},x.prototype=w.prototype;var E=k.prototype=new x;E.constructor=k,r(E,w.prototype),E.isPureReactComponent=!0;var T={current:null},S=Object.prototype.hasOwnProperty,C={key:!0,ref:!0,__self:!0,__source:!0};function P(e,t,n){var r,o={},a=null,i=null;if(null!=t)for(r in void 0!==t.ref&&(i=t.ref),void 0!==t.key&&(a=""+t.key),t)S.call(t,r)&&!C.hasOwnProperty(r)&&(o[r]=t[r]);var u=arguments.length-2;if(1===u)o.children=n;else if(1<u){for(var s=Array(u),c=0;c<u;c++)s[c]=arguments[c+2];o.children=s}if(e&&e.defaultProps)for(r in u=e.defaultProps)void 0===o[r]&&(o[r]=u[r]);return{$$typeof:l,type:e,key:a,ref:i,props:o,_owner:T.current}}function _(e){return"object"==typeof e&&null!==e&&e.$$typeof===l}var O=/\/+/g,N=[];function R(e,t,n,r){if(N.length){var o=N.pop();return o.result=e,o.keyPrefix=t,o.func=n,o.context=r,o.count=0,o}return{result:e,keyPrefix:t,func:n,context:r,count:0}}function z(e){e.result=null,e.keyPrefix=null,e.func=null,e.context=null,e.count=0,10>N.length&&N.push(e)}function L(e,t,n,r){var o=typeof e;"undefined"!==o&&"boolean"!==o||(e=null);var i=!1;if(null===e)i=!0;else switch(o){case"string":case"number":i=!0;break;case"object":switch(e.$$typeof){case l:case a:i=!0}}if(i)return n(r,e,""===t?"."+M(e,0):t),1;if(i=0,t=""===t?".":t+":",Array.isArray(e))for(var u=0;u<e.length;u++){var s=t+M(o=e[u],u);i+=L(o,s,n,r)}else if("function"==typeof(s=null===e||"object"!=typeof e?null:"function"==typeof(s=y&&e[y]||e["@@iterator"])?s:null))for(e=s.call(e),u=0;!(o=e.next()).done;)i+=L(o=o.value,s=t+M(o,u++),n,r);else if("object"===o)throw n=""+e,Error(v(31,"[object Object]"===n?"object with keys {"+Object.keys(e).join(", ")+"}":n,""));return i}function D(e,t,n){return null==e?0:L(e,"",t,n)}function M(e,t){return"object"==typeof e&&null!==e&&null!=e.key?function(e){var t={"=":"=0",":":"=2"};return"$"+(""+e).replace(/[=:]/g,(function(e){return t[e]}))}(e.key):t.toString(36)}function j(e,t){e.func.call(e.context,t,e.count++)}function J(e,t,n){var r=e.result,o=e.keyPrefix;e=e.func.call(e.context,t,e.count++),Array.isArray(e)?I(e,r,n,(function(e){return e})):null!=e&&(_(e)&&(e=function(e,t){return{$$typeof:l,type:e.type,key:t,ref:e.ref,props:e.props,_owner:e._owner}}(e,o+(!e.key||t&&t.key===e.key?"":(""+e.key).replace(O,"$&/")+"/")+n)),r.push(e))}function I(e,t,n,r,o){var l="";null!=n&&(l=(""+n).replace(O,"$&/")+"/"),D(e,J,t=R(t,l,r,o)),z(t)}var F={current:null};function A(){var e=F.current;if(null===e)throw Error(v(321));return e}var U={ReactCurrentDispatcher:F,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:T,IsSomeRendererActing:{current:!1},assign:r};t.Children={map:function(e,t,n){if(null==e)return e;var r=[];return I(e,r,null,t,n),r},forEach:function(e,t,n){if(null==e)return e;D(e,j,t=R(null,null,t,n)),z(t)},count:function(e){return D(e,(function(){return null}),null)},toArray:function(e){var t=[];return I(e,t,null,(function(e){return e})),t},only:function(e){if(!_(e))throw Error(v(143));return e}},t.Component=w,t.Fragment=i,t.Profiler=s,t.PureComponent=k,t.StrictMode=u,t.Suspense=d,t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=U,t.cloneElement=function(e,t,n){if(null==e)throw Error(v(267,e));var o=r({},e.props),a=e.key,i=e.ref,u=e._owner;if(null!=t){if(void 0!==t.ref&&(i=t.ref,u=T.current),void 0!==t.key&&(a=""+t.key),e.type&&e.type.defaultProps)var s=e.type.defaultProps;for(c in t)S.call(t,c)&&!C.hasOwnProperty(c)&&(o[c]=void 0===t[c]&&void 0!==s?s[c]:t[c])}var c=arguments.length-2;if(1===c)o.children=n;else if(1<c){s=Array(c);for(var f=0;f<c;f++)s[f]=arguments[f+2];o.children=s}return{$$typeof:l,type:e.type,key:a,ref:i,props:o,_owner:u}},t.createContext=function(e,t){return void 0===t&&(t=null),(e={$$typeof:f,_calculateChangedBits:t,_currentValue:e,_currentValue2:e,_threadCount:0,Provider:null,Consumer:null}).Provider={$$typeof:c,_context:e},e.Consumer=e},t.createElement=P,t.createFactory=function(e){var t=P.bind(null,e);return t.type=e,t},t.createRef=function(){return{current:null}},t.forwardRef=function(e){return{$$typeof:p,render:e}},t.isValidElement=_,t.lazy=function(e){return{$$typeof:h,_ctor:e,_status:-1,_result:null}},t.memo=function(e,t){return{$$typeof:m,type:e,compare:void 0===t?null:t}},t.useCallback=function(e,t){return A().useCallback(e,t)},t.useContext=function(e,t){return A().useContext(e,t)},t.useDebugValue=function(){},t.useEffect=function(e,t){return A().useEffect(e,t)},t.useImperativeHandle=function(e,t,n){return A().useImperativeHandle(e,t,n)},t.useLayoutEffect=function(e,t){return A().useLayoutEffect(e,t)},t.useMemo=function(e,t){return A().useMemo(e,t)},t.useReducer=function(e,t,n){return A().useReducer(e,t,n)},t.useRef=function(e){return A().useRef(e)},t.useState=function(e){return A().useState(e)},t.version="16.14.0"},463:(e,t)=>{"use strict";var n,r,o,l,a;if("undefined"==typeof window||"function"!=typeof MessageChannel){var i=null,u=null,s=function(){if(null!==i)try{var e=t.unstable_now();i(!0,e),i=null}catch(e){throw setTimeout(s,0),e}},c=Date.now();t.unstable_now=function(){return Date.now()-c},n=function(e){null!==i?setTimeout(n,0,e):(i=e,setTimeout(s,0))},r=function(e,t){u=setTimeout(e,t)},o=function(){clearTimeout(u)},l=function(){return!1},a=t.unstable_forceFrameRate=function(){}}else{var f=window.performance,p=window.Date,d=window.setTimeout,m=window.clearTimeout;if("undefined"!=typeof console){var h=window.cancelAnimationFrame;"function"!=typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"),"function"!=typeof h&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"==typeof f&&"function"==typeof f.now)t.unstable_now=function(){return f.now()};else{var y=p.now();t.unstable_now=function(){return p.now()-y}}var v=!1,g=null,b=-1,w=5,x=0;l=function(){return t.unstable_now()>=x},a=function(){},t.unstable_forceFrameRate=function(e){0>e||125<e?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):w=0<e?Math.floor(1e3/e):5};var k=new MessageChannel,E=k.port2;k.port1.onmessage=function(){if(null!==g){var e=t.unstable_now();x=e+w;try{g(!0,e)?E.postMessage(null):(v=!1,g=null)}catch(e){throw E.postMessage(null),e}}else v=!1},n=function(e){g=e,v||(v=!0,E.postMessage(null))},r=function(e,n){b=d((function(){e(t.unstable_now())}),n)},o=function(){m(b),b=-1}}function T(e,t){var n=e.length;e.push(t);e:for(;;){var r=n-1>>>1,o=e[r];if(!(void 0!==o&&0<P(o,t)))break e;e[r]=t,e[n]=o,n=r}}function S(e){return void 0===(e=e[0])?null:e}function C(e){var t=e[0];if(void 0!==t){var n=e.pop();if(n!==t){e[0]=n;e:for(var r=0,o=e.length;r<o;){var l=2*(r+1)-1,a=e[l],i=l+1,u=e[i];if(void 0!==a&&0>P(a,n))void 0!==u&&0>P(u,a)?(e[r]=u,e[i]=n,r=i):(e[r]=a,e[l]=n,r=l);else{if(!(void 0!==u&&0>P(u,n)))break e;e[r]=u,e[i]=n,r=i}}}return t}return null}function P(e,t){var n=e.sortIndex-t.sortIndex;return 0!==n?n:e.id-t.id}var _=[],O=[],N=1,R=null,z=3,L=!1,D=!1,M=!1;function j(e){for(var t=S(O);null!==t;){if(null===t.callback)C(O);else{if(!(t.startTime<=e))break;C(O),t.sortIndex=t.expirationTime,T(_,t)}t=S(O)}}function J(e){if(M=!1,j(e),!D)if(null!==S(_))D=!0,n(I);else{var t=S(O);null!==t&&r(J,t.startTime-e)}}function I(e,n){D=!1,M&&(M=!1,o()),L=!0;var a=z;try{for(j(n),R=S(_);null!==R&&(!(R.expirationTime>n)||e&&!l());){var i=R.callback;if(null!==i){R.callback=null,z=R.priorityLevel;var u=i(R.expirationTime<=n);n=t.unstable_now(),"function"==typeof u?R.callback=u:R===S(_)&&C(_),j(n)}else C(_);R=S(_)}if(null!==R)var s=!0;else{var c=S(O);null!==c&&r(J,c.startTime-n),s=!1}return s}finally{R=null,z=a,L=!1}}function F(e){switch(e){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1e4;default:return 5e3}}var A=a;t.unstable_IdlePriority=5,t.unstable_ImmediatePriority=1,t.unstable_LowPriority=4,t.unstable_NormalPriority=3,t.unstable_Profiling=null,t.unstable_UserBlockingPriority=2,t.unstable_cancelCallback=function(e){e.callback=null},t.unstable_continueExecution=function(){D||L||(D=!0,n(I))},t.unstable_getCurrentPriorityLevel=function(){return z},t.unstable_getFirstCallbackNode=function(){return S(_)},t.unstable_next=function(e){switch(z){case 1:case 2:case 3:var t=3;break;default:t=z}var n=z;z=t;try{return e()}finally{z=n}},t.unstable_pauseExecution=function(){},t.unstable_requestPaint=A,t.unstable_runWithPriority=function(e,t){switch(e){case 1:case 2:case 3:case 4:case 5:break;default:e=3}var n=z;z=e;try{return t()}finally{z=n}},t.unstable_scheduleCallback=function(e,l,a){var i=t.unstable_now();if("object"==typeof a&&null!==a){var u=a.delay;u="number"==typeof u&&0<u?i+u:i,a="number"==typeof a.timeout?a.timeout:F(e)}else a=F(e),u=i;return e={id:N++,callback:l,priorityLevel:e,startTime:u,expirationTime:a=u+a,sortIndex:-1},u>i?(e.sortIndex=u,T(O,e),null===S(_)&&e===S(O)&&(M?o():M=!0,r(J,u-i))):(e.sortIndex=a,T(_,e),D||L||(D=!0,n(I))),e},t.unstable_shouldYield=function(){var e=t.unstable_now();j(e);var n=S(_);return n!==R&&null!==R&&null!==n&&null!==n.callback&&n.startTime<=e&&n.expirationTime<R.expirationTime||l()},t.unstable_wrapCallback=function(e){var t=z;return function(){var n=z;z=t;try{return e.apply(this,arguments)}finally{z=n}}}},540:(e,t,n)=>{"use strict";e.exports=n(287)},551:(e,t,n)=>{"use strict";var r=n(540),o=n(228),l=n(982);function a(e){for(var t="https://reactjs.org/docs/error-decoder.html?invariant="+e,n=1;n<arguments.length;n++)t+="&args[]="+encodeURIComponent(arguments[n]);return"Minified React error #"+e+"; visit "+t+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!r)throw Error(a(227));function i(e,t,n,r,o,l,a,i,u){var s=Array.prototype.slice.call(arguments,3);try{t.apply(n,s)}catch(e){this.onError(e)}}var u=!1,s=null,c=!1,f=null,p={onError:function(e){u=!0,s=e}};function d(e,t,n,r,o,l,a,c,f){u=!1,s=null,i.apply(p,arguments)}var m=null,h=null,y=null;function v(e,t,n){var r=e.type||"unknown-event";e.currentTarget=y(n),function(e,t,n,r,o,l,i,p,m){if(d.apply(this,arguments),u){if(!u)throw Error(a(198));var h=s;u=!1,s=null,c||(c=!0,f=h)}}(r,t,void 0,e),e.currentTarget=null}var g=null,b={};function w(){if(g)for(var e in b){var t=b[e],n=g.indexOf(e);if(!(-1<n))throw Error(a(96,e));if(!k[n]){if(!t.extractEvents)throw Error(a(97,e));for(var r in k[n]=t,n=t.eventTypes){var o=void 0,l=n[r],i=t,u=r;if(E.hasOwnProperty(u))throw Error(a(99,u));E[u]=l;var s=l.phasedRegistrationNames;if(s){for(o in s)s.hasOwnProperty(o)&&x(s[o],i,u);o=!0}else l.registrationName?(x(l.registrationName,i,u),o=!0):o=!1;if(!o)throw Error(a(98,r,e))}}}}function x(e,t,n){if(T[e])throw Error(a(100,e));T[e]=t,S[e]=t.eventTypes[n].dependencies}var k=[],E={},T={},S={};function C(e){var t,n=!1;for(t in e)if(e.hasOwnProperty(t)){var r=e[t];if(!b.hasOwnProperty(t)||b[t]!==r){if(b[t])throw Error(a(102,t));b[t]=r,n=!0}}n&&w()}var P=!("undefined"==typeof window||void 0===window.document||void 0===window.document.createElement),_=null,O=null,N=null;function R(e){if(e=h(e)){if("function"!=typeof _)throw Error(a(280));var t=e.stateNode;t&&(t=m(t),_(e.stateNode,e.type,t))}}function z(e){O?N?N.push(e):N=[e]:O=e}function L(){if(O){var e=O,t=N;if(N=O=null,R(e),t)for(e=0;e<t.length;e++)R(t[e])}}function D(e,t){return e(t)}function M(e,t,n,r,o){return e(t,n,r,o)}function j(){}var J=D,I=!1,F=!1;function A(){null===O&&null===N||(j(),L())}function U(e,t,n){if(F)return e(t,n);F=!0;try{return J(e,t,n)}finally{F=!1,A()}}var V=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,B=Object.prototype.hasOwnProperty,q={},Q={};function W(e,t,n,r,o,l){this.acceptsBooleans=2===t||3===t||4===t,this.attributeName=r,this.attributeNamespace=o,this.mustUseProperty=n,this.propertyName=e,this.type=t,this.sanitizeURL=l}var H={};"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach((function(e){H[e]=new W(e,0,!1,e,null,!1)})),[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach((function(e){var t=e[0];H[t]=new W(t,1,!1,e[1],null,!1)})),["contentEditable","draggable","spellCheck","value"].forEach((function(e){H[e]=new W(e,2,!1,e.toLowerCase(),null,!1)})),["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach((function(e){H[e]=new W(e,2,!1,e,null,!1)})),"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach((function(e){H[e]=new W(e,3,!1,e.toLowerCase(),null,!1)})),["checked","multiple","muted","selected"].forEach((function(e){H[e]=new W(e,3,!0,e,null,!1)})),["capture","download"].forEach((function(e){H[e]=new W(e,4,!1,e,null,!1)})),["cols","rows","size","span"].forEach((function(e){H[e]=new W(e,6,!1,e,null,!1)})),["rowSpan","start"].forEach((function(e){H[e]=new W(e,5,!1,e.toLowerCase(),null,!1)}));var $=/[\-:]([a-z])/g;function K(e){return e[1].toUpperCase()}"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach((function(e){var t=e.replace($,K);H[t]=new W(t,1,!1,e,null,!1)})),"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach((function(e){var t=e.replace($,K);H[t]=new W(t,1,!1,e,"http://www.w3.org/1999/xlink",!1)})),["xml:base","xml:lang","xml:space"].forEach((function(e){var t=e.replace($,K);H[t]=new W(t,1,!1,e,"http://www.w3.org/XML/1998/namespace",!1)})),["tabIndex","crossOrigin"].forEach((function(e){H[e]=new W(e,1,!1,e.toLowerCase(),null,!1)})),H.xlinkHref=new W("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0),["src","href","action","formAction"].forEach((function(e){H[e]=new W(e,1,!1,e.toLowerCase(),null,!0)}));var X=r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;function Y(e,t,n,r){var o=H.hasOwnProperty(t)?H[t]:null;(null!==o?0===o.type:!r&&2<t.length&&("o"===t[0]||"O"===t[0])&&("n"===t[1]||"N"===t[1]))||(function(e,t,n,r){if(null==t||function(e,t,n,r){if(null!==n&&0===n.type)return!1;switch(typeof t){case"function":case"symbol":return!0;case"boolean":return!r&&(null!==n?!n.acceptsBooleans:"data-"!==(e=e.toLowerCase().slice(0,5))&&"aria-"!==e);default:return!1}}(e,t,n,r))return!0;if(r)return!1;if(null!==n)switch(n.type){case 3:return!t;case 4:return!1===t;case 5:return isNaN(t);case 6:return isNaN(t)||1>t}return!1}(t,n,o,r)&&(n=null),r||null===o?function(e){return!!B.call(Q,e)||!B.call(q,e)&&(V.test(e)?Q[e]=!0:(q[e]=!0,!1))}(t)&&(null===n?e.removeAttribute(t):e.setAttribute(t,""+n)):o.mustUseProperty?e[o.propertyName]=null===n?3!==o.type&&"":n:(t=o.attributeName,r=o.attributeNamespace,null===n?e.removeAttribute(t):(n=3===(o=o.type)||4===o&&!0===n?"":""+n,r?e.setAttributeNS(r,t,n):e.setAttribute(t,n))))}X.hasOwnProperty("ReactCurrentDispatcher")||(X.ReactCurrentDispatcher={current:null}),X.hasOwnProperty("ReactCurrentBatchConfig")||(X.ReactCurrentBatchConfig={suspense:null});var G=/^(.*)[\\\/]/,Z="function"==typeof Symbol&&Symbol.for,ee=Z?Symbol.for("react.element"):60103,te=Z?Symbol.for("react.portal"):60106,ne=Z?Symbol.for("react.fragment"):60107,re=Z?Symbol.for("react.strict_mode"):60108,oe=Z?Symbol.for("react.profiler"):60114,le=Z?Symbol.for("react.provider"):60109,ae=Z?Symbol.for("react.context"):60110,ie=Z?Symbol.for("react.concurrent_mode"):60111,ue=Z?Symbol.for("react.forward_ref"):60112,se=Z?Symbol.for("react.suspense"):60113,ce=Z?Symbol.for("react.suspense_list"):60120,fe=Z?Symbol.for("react.memo"):60115,pe=Z?Symbol.for("react.lazy"):60116,de=Z?Symbol.for("react.block"):60121,me="function"==typeof Symbol&&Symbol.iterator;function he(e){return null===e||"object"!=typeof e?null:"function"==typeof(e=me&&e[me]||e["@@iterator"])?e:null}function ye(e){if(null==e)return null;if("function"==typeof e)return e.displayName||e.name||null;if("string"==typeof e)return e;switch(e){case ne:return"Fragment";case te:return"Portal";case oe:return"Profiler";case re:return"StrictMode";case se:return"Suspense";case ce:return"SuspenseList"}if("object"==typeof e)switch(e.$$typeof){case ae:return"Context.Consumer";case le:return"Context.Provider";case ue:var t=e.render;return t=t.displayName||t.name||"",e.displayName||(""!==t?"ForwardRef("+t+")":"ForwardRef");case fe:return ye(e.type);case de:return ye(e.render);case pe:if(e=1===e._status?e._result:null)return ye(e)}return null}function ve(e){var t="";do{e:switch(e.tag){case 3:case 4:case 6:case 7:case 10:case 9:var n="";break e;default:var r=e._debugOwner,o=e._debugSource,l=ye(e.type);n=null,r&&(n=ye(r.type)),r=l,l="",o?l=" (at "+o.fileName.replace(G,"")+":"+o.lineNumber+")":n&&(l=" (created by "+n+")"),n="\n    in "+(r||"Unknown")+l}t+=n,e=e.return}while(e);return t}function ge(e){switch(typeof e){case"boolean":case"number":case"object":case"string":case"undefined":return e;default:return""}}function be(e){var t=e.type;return(e=e.nodeName)&&"input"===e.toLowerCase()&&("checkbox"===t||"radio"===t)}function we(e){e._valueTracker||(e._valueTracker=function(e){var t=be(e)?"checked":"value",n=Object.getOwnPropertyDescriptor(e.constructor.prototype,t),r=""+e[t];if(!e.hasOwnProperty(t)&&void 0!==n&&"function"==typeof n.get&&"function"==typeof n.set){var o=n.get,l=n.set;return Object.defineProperty(e,t,{configurable:!0,get:function(){return o.call(this)},set:function(e){r=""+e,l.call(this,e)}}),Object.defineProperty(e,t,{enumerable:n.enumerable}),{getValue:function(){return r},setValue:function(e){r=""+e},stopTracking:function(){e._valueTracker=null,delete e[t]}}}}(e))}function xe(e){if(!e)return!1;var t=e._valueTracker;if(!t)return!0;var n=t.getValue(),r="";return e&&(r=be(e)?e.checked?"true":"false":e.value),(e=r)!==n&&(t.setValue(e),!0)}function ke(e,t){var n=t.checked;return o({},t,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=n?n:e._wrapperState.initialChecked})}function Ee(e,t){var n=null==t.defaultValue?"":t.defaultValue,r=null!=t.checked?t.checked:t.defaultChecked;n=ge(null!=t.value?t.value:n),e._wrapperState={initialChecked:r,initialValue:n,controlled:"checkbox"===t.type||"radio"===t.type?null!=t.checked:null!=t.value}}function Te(e,t){null!=(t=t.checked)&&Y(e,"checked",t,!1)}function Se(e,t){Te(e,t);var n=ge(t.value),r=t.type;if(null!=n)"number"===r?(0===n&&""===e.value||e.value!=n)&&(e.value=""+n):e.value!==""+n&&(e.value=""+n);else if("submit"===r||"reset"===r)return void e.removeAttribute("value");t.hasOwnProperty("value")?Pe(e,t.type,n):t.hasOwnProperty("defaultValue")&&Pe(e,t.type,ge(t.defaultValue)),null==t.checked&&null!=t.defaultChecked&&(e.defaultChecked=!!t.defaultChecked)}function Ce(e,t,n){if(t.hasOwnProperty("value")||t.hasOwnProperty("defaultValue")){var r=t.type;if(!("submit"!==r&&"reset"!==r||void 0!==t.value&&null!==t.value))return;t=""+e._wrapperState.initialValue,n||t===e.value||(e.value=t),e.defaultValue=t}""!==(n=e.name)&&(e.name=""),e.defaultChecked=!!e._wrapperState.initialChecked,""!==n&&(e.name=n)}function Pe(e,t,n){"number"===t&&e.ownerDocument.activeElement===e||(null==n?e.defaultValue=""+e._wrapperState.initialValue:e.defaultValue!==""+n&&(e.defaultValue=""+n))}function _e(e,t){return e=o({children:void 0},t),(t=function(e){var t="";return r.Children.forEach(e,(function(e){null!=e&&(t+=e)})),t}(t.children))&&(e.children=t),e}function Oe(e,t,n,r){if(e=e.options,t){t={};for(var o=0;o<n.length;o++)t["$"+n[o]]=!0;for(n=0;n<e.length;n++)o=t.hasOwnProperty("$"+e[n].value),e[n].selected!==o&&(e[n].selected=o),o&&r&&(e[n].defaultSelected=!0)}else{for(n=""+ge(n),t=null,o=0;o<e.length;o++){if(e[o].value===n)return e[o].selected=!0,void(r&&(e[o].defaultSelected=!0));null!==t||e[o].disabled||(t=e[o])}null!==t&&(t.selected=!0)}}function Ne(e,t){if(null!=t.dangerouslySetInnerHTML)throw Error(a(91));return o({},t,{value:void 0,defaultValue:void 0,children:""+e._wrapperState.initialValue})}function Re(e,t){var n=t.value;if(null==n){if(n=t.children,t=t.defaultValue,null!=n){if(null!=t)throw Error(a(92));if(Array.isArray(n)){if(!(1>=n.length))throw Error(a(93));n=n[0]}t=n}null==t&&(t=""),n=t}e._wrapperState={initialValue:ge(n)}}function ze(e,t){var n=ge(t.value),r=ge(t.defaultValue);null!=n&&((n=""+n)!==e.value&&(e.value=n),null==t.defaultValue&&e.defaultValue!==n&&(e.defaultValue=n)),null!=r&&(e.defaultValue=""+r)}function Le(e){var t=e.textContent;t===e._wrapperState.initialValue&&""!==t&&null!==t&&(e.value=t)}function De(e){switch(e){case"svg":return"http://www.w3.org/2000/svg";case"math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Me(e,t){return null==e||"http://www.w3.org/1999/xhtml"===e?De(t):"http://www.w3.org/2000/svg"===e&&"foreignObject"===t?"http://www.w3.org/1999/xhtml":e}var je,Je,Ie=(Je=function(e,t){if("http://www.w3.org/2000/svg"!==e.namespaceURI||"innerHTML"in e)e.innerHTML=t;else{for((je=je||document.createElement("div")).innerHTML="<svg>"+t.valueOf().toString()+"</svg>",t=je.firstChild;e.firstChild;)e.removeChild(e.firstChild);for(;t.firstChild;)e.appendChild(t.firstChild)}},"undefined"!=typeof MSApp&&MSApp.execUnsafeLocalFunction?function(e,t,n,r){MSApp.execUnsafeLocalFunction((function(){return Je(e,t)}))}:Je);function Fe(e,t){if(t){var n=e.firstChild;if(n&&n===e.lastChild&&3===n.nodeType)return void(n.nodeValue=t)}e.textContent=t}function Ae(e,t){var n={};return n[e.toLowerCase()]=t.toLowerCase(),n["Webkit"+e]="webkit"+t,n["Moz"+e]="moz"+t,n}var Ue={animationend:Ae("Animation","AnimationEnd"),animationiteration:Ae("Animation","AnimationIteration"),animationstart:Ae("Animation","AnimationStart"),transitionend:Ae("Transition","TransitionEnd")},Ve={},Be={};function qe(e){if(Ve[e])return Ve[e];if(!Ue[e])return e;var t,n=Ue[e];for(t in n)if(n.hasOwnProperty(t)&&t in Be)return Ve[e]=n[t];return e}P&&(Be=document.createElement("div").style,"AnimationEvent"in window||(delete Ue.animationend.animation,delete Ue.animationiteration.animation,delete Ue.animationstart.animation),"TransitionEvent"in window||delete Ue.transitionend.transition);var Qe=qe("animationend"),We=qe("animationiteration"),He=qe("animationstart"),$e=qe("transitionend"),Ke="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),Xe=new("function"==typeof WeakMap?WeakMap:Map);function Ye(e){var t=Xe.get(e);return void 0===t&&(t=new Map,Xe.set(e,t)),t}function Ge(e){var t=e,n=e;if(e.alternate)for(;t.return;)t=t.return;else{e=t;do{!!(1026&(t=e).effectTag)&&(n=t.return),e=t.return}while(e)}return 3===t.tag?n:null}function Ze(e){if(13===e.tag){var t=e.memoizedState;if(null===t&&null!==(e=e.alternate)&&(t=e.memoizedState),null!==t)return t.dehydrated}return null}function et(e){if(Ge(e)!==e)throw Error(a(188))}function tt(e){if(e=function(e){var t=e.alternate;if(!t){if(null===(t=Ge(e)))throw Error(a(188));return t!==e?null:e}for(var n=e,r=t;;){var o=n.return;if(null===o)break;var l=o.alternate;if(null===l){if(null!==(r=o.return)){n=r;continue}break}if(o.child===l.child){for(l=o.child;l;){if(l===n)return et(o),e;if(l===r)return et(o),t;l=l.sibling}throw Error(a(188))}if(n.return!==r.return)n=o,r=l;else{for(var i=!1,u=o.child;u;){if(u===n){i=!0,n=o,r=l;break}if(u===r){i=!0,r=o,n=l;break}u=u.sibling}if(!i){for(u=l.child;u;){if(u===n){i=!0,n=l,r=o;break}if(u===r){i=!0,r=l,n=o;break}u=u.sibling}if(!i)throw Error(a(189))}}if(n.alternate!==r)throw Error(a(190))}if(3!==n.tag)throw Error(a(188));return n.stateNode.current===n?e:t}(e),!e)return null;for(var t=e;;){if(5===t.tag||6===t.tag)return t;if(t.child)t.child.return=t,t=t.child;else{if(t===e)break;for(;!t.sibling;){if(!t.return||t.return===e)return null;t=t.return}t.sibling.return=t.return,t=t.sibling}}return null}function nt(e,t){if(null==t)throw Error(a(30));return null==e?t:Array.isArray(e)?Array.isArray(t)?(e.push.apply(e,t),e):(e.push(t),e):Array.isArray(t)?[e].concat(t):[e,t]}function rt(e,t,n){Array.isArray(e)?e.forEach(t,n):e&&t.call(n,e)}var ot=null;function lt(e){if(e){var t=e._dispatchListeners,n=e._dispatchInstances;if(Array.isArray(t))for(var r=0;r<t.length&&!e.isPropagationStopped();r++)v(e,t[r],n[r]);else t&&v(e,t,n);e._dispatchListeners=null,e._dispatchInstances=null,e.isPersistent()||e.constructor.release(e)}}function at(e){if(null!==e&&(ot=nt(ot,e)),e=ot,ot=null,e){if(rt(e,lt),ot)throw Error(a(95));if(c)throw e=f,c=!1,f=null,e}}function it(e){return(e=e.target||e.srcElement||window).correspondingUseElement&&(e=e.correspondingUseElement),3===e.nodeType?e.parentNode:e}function ut(e){if(!P)return!1;var t=(e="on"+e)in document;return t||((t=document.createElement("div")).setAttribute(e,"return;"),t="function"==typeof t[e]),t}var st=[];function ct(e){e.topLevelType=null,e.nativeEvent=null,e.targetInst=null,e.ancestors.length=0,10>st.length&&st.push(e)}function ft(e,t,n,r){if(st.length){var o=st.pop();return o.topLevelType=e,o.eventSystemFlags=r,o.nativeEvent=t,o.targetInst=n,o}return{topLevelType:e,eventSystemFlags:r,nativeEvent:t,targetInst:n,ancestors:[]}}function pt(e){var t=e.targetInst,n=t;do{if(!n){e.ancestors.push(n);break}var r=n;if(3===r.tag)r=r.stateNode.containerInfo;else{for(;r.return;)r=r.return;r=3!==r.tag?null:r.stateNode.containerInfo}if(!r)break;5!==(t=n.tag)&&6!==t||e.ancestors.push(n),n=Rn(r)}while(n);for(n=0;n<e.ancestors.length;n++){t=e.ancestors[n];var o=it(e.nativeEvent);r=e.topLevelType;var l=e.nativeEvent,a=e.eventSystemFlags;0===n&&(a|=64);for(var i=null,u=0;u<k.length;u++){var s=k[u];s&&(s=s.extractEvents(r,t,l,o,a))&&(i=nt(i,s))}at(i)}}function dt(e,t,n){if(!n.has(e)){switch(e){case"scroll":Ht(t,"scroll",!0);break;case"focus":case"blur":Ht(t,"focus",!0),Ht(t,"blur",!0),n.set("blur",null),n.set("focus",null);break;case"cancel":case"close":ut(e)&&Ht(t,e,!0);break;case"invalid":case"submit":case"reset":break;default:-1===Ke.indexOf(e)&&Wt(e,t)}n.set(e,null)}}var mt,ht,yt,vt=!1,gt=[],bt=null,wt=null,xt=null,kt=new Map,Et=new Map,Tt=[],St="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ct="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");function Pt(e,t,n,r,o){return{blockedOn:e,topLevelType:t,eventSystemFlags:32|n,nativeEvent:o,container:r}}function _t(e,t){switch(e){case"focus":case"blur":bt=null;break;case"dragenter":case"dragleave":wt=null;break;case"mouseover":case"mouseout":xt=null;break;case"pointerover":case"pointerout":kt.delete(t.pointerId);break;case"gotpointercapture":case"lostpointercapture":Et.delete(t.pointerId)}}function Ot(e,t,n,r,o,l){return null===e||e.nativeEvent!==l?(e=Pt(t,n,r,o,l),null!==t&&null!==(t=zn(t))&&ht(t),e):(e.eventSystemFlags|=r,e)}function Nt(e){var t=Rn(e.target);if(null!==t){var n=Ge(t);if(null!==n)if(13===(t=n.tag)){if(null!==(t=Ze(n)))return e.blockedOn=t,void l.unstable_runWithPriority(e.priority,(function(){yt(n)}))}else if(3===t&&n.stateNode.hydrate)return void(e.blockedOn=3===n.tag?n.stateNode.containerInfo:null)}e.blockedOn=null}function Rt(e){if(null!==e.blockedOn)return!1;var t=Yt(e.topLevelType,e.eventSystemFlags,e.container,e.nativeEvent);if(null!==t){var n=zn(t);return null!==n&&ht(n),e.blockedOn=t,!1}return!0}function zt(e,t,n){Rt(e)&&n.delete(t)}function Lt(){for(vt=!1;0<gt.length;){var e=gt[0];if(null!==e.blockedOn){null!==(e=zn(e.blockedOn))&&mt(e);break}var t=Yt(e.topLevelType,e.eventSystemFlags,e.container,e.nativeEvent);null!==t?e.blockedOn=t:gt.shift()}null!==bt&&Rt(bt)&&(bt=null),null!==wt&&Rt(wt)&&(wt=null),null!==xt&&Rt(xt)&&(xt=null),kt.forEach(zt),Et.forEach(zt)}function Dt(e,t){e.blockedOn===t&&(e.blockedOn=null,vt||(vt=!0,l.unstable_scheduleCallback(l.unstable_NormalPriority,Lt)))}function Mt(e){function t(t){return Dt(t,e)}if(0<gt.length){Dt(gt[0],e);for(var n=1;n<gt.length;n++){var r=gt[n];r.blockedOn===e&&(r.blockedOn=null)}}for(null!==bt&&Dt(bt,e),null!==wt&&Dt(wt,e),null!==xt&&Dt(xt,e),kt.forEach(t),Et.forEach(t),n=0;n<Tt.length;n++)(r=Tt[n]).blockedOn===e&&(r.blockedOn=null);for(;0<Tt.length&&null===(n=Tt[0]).blockedOn;)Nt(n),null===n.blockedOn&&Tt.shift()}var jt={},Jt=new Map,It=new Map,Ft=["abort","abort",Qe,"animationEnd",We,"animationIteration",He,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking","seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$e,"transitionEnd","waiting","waiting"];function At(e,t){for(var n=0;n<e.length;n+=2){var r=e[n],o=e[n+1],l="on"+(o[0].toUpperCase()+o.slice(1));l={phasedRegistrationNames:{bubbled:l,captured:l+"Capture"},dependencies:[r],eventPriority:t},It.set(r,t),Jt.set(r,l),jt[o]=l}}At("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0),At("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1),At(Ft,2);for(var Ut="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),Vt=0;Vt<Ut.length;Vt++)It.set(Ut[Vt],0);var Bt=l.unstable_UserBlockingPriority,qt=l.unstable_runWithPriority,Qt=!0;function Wt(e,t){Ht(t,e,!1)}function Ht(e,t,n){var r=It.get(t);switch(void 0===r?2:r){case 0:r=$t.bind(null,t,1,e);break;case 1:r=Kt.bind(null,t,1,e);break;default:r=Xt.bind(null,t,1,e)}n?e.addEventListener(t,r,!0):e.addEventListener(t,r,!1)}function $t(e,t,n,r){I||j();var o=Xt,l=I;I=!0;try{M(o,e,t,n,r)}finally{(I=l)||A()}}function Kt(e,t,n,r){qt(Bt,Xt.bind(null,e,t,n,r))}function Xt(e,t,n,r){if(Qt)if(0<gt.length&&-1<St.indexOf(e))e=Pt(null,e,t,n,r),gt.push(e);else{var o=Yt(e,t,n,r);if(null===o)_t(e,r);else if(-1<St.indexOf(e))e=Pt(o,e,t,n,r),gt.push(e);else if(!function(e,t,n,r,o){switch(t){case"focus":return bt=Ot(bt,e,t,n,r,o),!0;case"dragenter":return wt=Ot(wt,e,t,n,r,o),!0;case"mouseover":return xt=Ot(xt,e,t,n,r,o),!0;case"pointerover":var l=o.pointerId;return kt.set(l,Ot(kt.get(l)||null,e,t,n,r,o)),!0;case"gotpointercapture":return l=o.pointerId,Et.set(l,Ot(Et.get(l)||null,e,t,n,r,o)),!0}return!1}(o,e,t,n,r)){_t(e,r),e=ft(e,r,null,t);try{U(pt,e)}finally{ct(e)}}}}function Yt(e,t,n,r){if(null!==(n=Rn(n=it(r)))){var o=Ge(n);if(null===o)n=null;else{var l=o.tag;if(13===l){if(null!==(n=Ze(o)))return n;n=null}else if(3===l){if(o.stateNode.hydrate)return 3===o.tag?o.stateNode.containerInfo:null;n=null}else o!==n&&(n=null)}}e=ft(e,r,n,t);try{U(pt,e)}finally{ct(e)}return null}var Gt={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Zt=["Webkit","ms","Moz","O"];function en(e,t,n){return null==t||"boolean"==typeof t||""===t?"":n||"number"!=typeof t||0===t||Gt.hasOwnProperty(e)&&Gt[e]?(""+t).trim():t+"px"}function tn(e,t){for(var n in e=e.style,t)if(t.hasOwnProperty(n)){var r=0===n.indexOf("--"),o=en(n,t[n],r);"float"===n&&(n="cssFloat"),r?e.setProperty(n,o):e[n]=o}}Object.keys(Gt).forEach((function(e){Zt.forEach((function(t){t=t+e.charAt(0).toUpperCase()+e.substring(1),Gt[t]=Gt[e]}))}));var nn=o({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});function rn(e,t){if(t){if(nn[e]&&(null!=t.children||null!=t.dangerouslySetInnerHTML))throw Error(a(137,e,""));if(null!=t.dangerouslySetInnerHTML){if(null!=t.children)throw Error(a(60));if("object"!=typeof t.dangerouslySetInnerHTML||!("__html"in t.dangerouslySetInnerHTML))throw Error(a(61))}if(null!=t.style&&"object"!=typeof t.style)throw Error(a(62,""))}}function on(e,t){if(-1===e.indexOf("-"))return"string"==typeof t.is;switch(e){case"annotation-xml":case"color-profile":case"font-face":case"font-face-src":case"font-face-uri":case"font-face-format":case"font-face-name":case"missing-glyph":return!1;default:return!0}}var ln="http://www.w3.org/1999/xhtml";function an(e,t){var n=Ye(e=9===e.nodeType||11===e.nodeType?e:e.ownerDocument);t=S[t];for(var r=0;r<t.length;r++)dt(t[r],e,n)}function un(){}function sn(e){if(void 0===(e=e||("undefined"!=typeof document?document:void 0)))return null;try{return e.activeElement||e.body}catch(t){return e.body}}function cn(e){for(;e&&e.firstChild;)e=e.firstChild;return e}function fn(e,t){var n,r=cn(e);for(e=0;r;){if(3===r.nodeType){if(n=e+r.textContent.length,e<=t&&n>=t)return{node:r,offset:t-e};e=n}e:{for(;r;){if(r.nextSibling){r=r.nextSibling;break e}r=r.parentNode}r=void 0}r=cn(r)}}function pn(e,t){return!(!e||!t)&&(e===t||(!e||3!==e.nodeType)&&(t&&3===t.nodeType?pn(e,t.parentNode):"contains"in e?e.contains(t):!!e.compareDocumentPosition&&!!(16&e.compareDocumentPosition(t))))}function dn(){for(var e=window,t=sn();t instanceof e.HTMLIFrameElement;){try{var n="string"==typeof t.contentWindow.location.href}catch(e){n=!1}if(!n)break;t=sn((e=t.contentWindow).document)}return t}function mn(e){var t=e&&e.nodeName&&e.nodeName.toLowerCase();return t&&("input"===t&&("text"===e.type||"search"===e.type||"tel"===e.type||"url"===e.type||"password"===e.type)||"textarea"===t||"true"===e.contentEditable)}var hn="$",yn="/$",vn="$?",gn="$!",bn=null,wn=null;function xn(e,t){switch(e){case"button":case"input":case"select":case"textarea":return!!t.autoFocus}return!1}function kn(e,t){return"textarea"===e||"option"===e||"noscript"===e||"string"==typeof t.children||"number"==typeof t.children||"object"==typeof t.dangerouslySetInnerHTML&&null!==t.dangerouslySetInnerHTML&&null!=t.dangerouslySetInnerHTML.__html}var En="function"==typeof setTimeout?setTimeout:void 0,Tn="function"==typeof clearTimeout?clearTimeout:void 0;function Sn(e){for(;null!=e;e=e.nextSibling){var t=e.nodeType;if(1===t||3===t)break}return e}function Cn(e){e=e.previousSibling;for(var t=0;e;){if(8===e.nodeType){var n=e.data;if(n===hn||n===gn||n===vn){if(0===t)return e;t--}else n===yn&&t++}e=e.previousSibling}return null}var Pn=Math.random().toString(36).slice(2),_n="__reactInternalInstance$"+Pn,On="__reactEventHandlers$"+Pn,Nn="__reactContainere$"+Pn;function Rn(e){var t=e[_n];if(t)return t;for(var n=e.parentNode;n;){if(t=n[Nn]||n[_n]){if(n=t.alternate,null!==t.child||null!==n&&null!==n.child)for(e=Cn(e);null!==e;){if(n=e[_n])return n;e=Cn(e)}return t}n=(e=n).parentNode}return null}function zn(e){return!(e=e[_n]||e[Nn])||5!==e.tag&&6!==e.tag&&13!==e.tag&&3!==e.tag?null:e}function Ln(e){if(5===e.tag||6===e.tag)return e.stateNode;throw Error(a(33))}function Dn(e){return e[On]||null}function Mn(e){do{e=e.return}while(e&&5!==e.tag);return e||null}function jn(e,t){var n=e.stateNode;if(!n)return null;var r=m(n);if(!r)return null;n=r[t];e:switch(t){case"onClick":case"onClickCapture":case"onDoubleClick":case"onDoubleClickCapture":case"onMouseDown":case"onMouseDownCapture":case"onMouseMove":case"onMouseMoveCapture":case"onMouseUp":case"onMouseUpCapture":case"onMouseEnter":(r=!r.disabled)||(r=!("button"===(e=e.type)||"input"===e||"select"===e||"textarea"===e)),e=!r;break e;default:e=!1}if(e)return null;if(n&&"function"!=typeof n)throw Error(a(231,t,typeof n));return n}function Jn(e,t,n){(t=jn(e,n.dispatchConfig.phasedRegistrationNames[t]))&&(n._dispatchListeners=nt(n._dispatchListeners,t),n._dispatchInstances=nt(n._dispatchInstances,e))}function In(e){if(e&&e.dispatchConfig.phasedRegistrationNames){for(var t=e._targetInst,n=[];t;)n.push(t),t=Mn(t);for(t=n.length;0<t--;)Jn(n[t],"captured",e);for(t=0;t<n.length;t++)Jn(n[t],"bubbled",e)}}function Fn(e,t,n){e&&n&&n.dispatchConfig.registrationName&&(t=jn(e,n.dispatchConfig.registrationName))&&(n._dispatchListeners=nt(n._dispatchListeners,t),n._dispatchInstances=nt(n._dispatchInstances,e))}function An(e){e&&e.dispatchConfig.registrationName&&Fn(e._targetInst,null,e)}function Un(e){rt(e,In)}var Vn=null,Bn=null,qn=null;function Qn(){if(qn)return qn;var e,t,n=Bn,r=n.length,o="value"in Vn?Vn.value:Vn.textContent,l=o.length;for(e=0;e<r&&n[e]===o[e];e++);var a=r-e;for(t=1;t<=a&&n[r-t]===o[l-t];t++);return qn=o.slice(e,1<t?1-t:void 0)}function Wn(){return!0}function Hn(){return!1}function $n(e,t,n,r){for(var o in this.dispatchConfig=e,this._targetInst=t,this.nativeEvent=n,e=this.constructor.Interface)e.hasOwnProperty(o)&&((t=e[o])?this[o]=t(n):"target"===o?this.target=r:this[o]=n[o]);return this.isDefaultPrevented=(null!=n.defaultPrevented?n.defaultPrevented:!1===n.returnValue)?Wn:Hn,this.isPropagationStopped=Hn,this}function Kn(e,t,n,r){if(this.eventPool.length){var o=this.eventPool.pop();return this.call(o,e,t,n,r),o}return new this(e,t,n,r)}function Xn(e){if(!(e instanceof this))throw Error(a(279));e.destructor(),10>this.eventPool.length&&this.eventPool.push(e)}function Yn(e){e.eventPool=[],e.getPooled=Kn,e.release=Xn}o($n.prototype,{preventDefault:function(){this.defaultPrevented=!0;var e=this.nativeEvent;e&&(e.preventDefault?e.preventDefault():"unknown"!=typeof e.returnValue&&(e.returnValue=!1),this.isDefaultPrevented=Wn)},stopPropagation:function(){var e=this.nativeEvent;e&&(e.stopPropagation?e.stopPropagation():"unknown"!=typeof e.cancelBubble&&(e.cancelBubble=!0),this.isPropagationStopped=Wn)},persist:function(){this.isPersistent=Wn},isPersistent:Hn,destructor:function(){var e,t=this.constructor.Interface;for(e in t)this[e]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null,this.isPropagationStopped=this.isDefaultPrevented=Hn,this._dispatchInstances=this._dispatchListeners=null}}),$n.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(e){return e.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null},$n.extend=function(e){function t(){}function n(){return r.apply(this,arguments)}var r=this;t.prototype=r.prototype;var l=new t;return o(l,n.prototype),n.prototype=l,n.prototype.constructor=n,n.Interface=o({},r.Interface,e),n.extend=r.extend,Yn(n),n},Yn($n);var Gn=$n.extend({data:null}),Zn=$n.extend({data:null}),er=[9,13,27,32],tr=P&&"CompositionEvent"in window,nr=null;P&&"documentMode"in document&&(nr=document.documentMode);var rr=P&&"TextEvent"in window&&!nr,or=P&&(!tr||nr&&8<nr&&11>=nr),lr=String.fromCharCode(32),ar={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},ir=!1;function ur(e,t){switch(e){case"keyup":return-1!==er.indexOf(t.keyCode);case"keydown":return 229!==t.keyCode;case"keypress":case"mousedown":case"blur":return!0;default:return!1}}function sr(e){return"object"==typeof(e=e.detail)&&"data"in e?e.data:null}var cr=!1,fr={eventTypes:ar,extractEvents:function(e,t,n,r){var o;if(tr)e:{switch(e){case"compositionstart":var l=ar.compositionStart;break e;case"compositionend":l=ar.compositionEnd;break e;case"compositionupdate":l=ar.compositionUpdate;break e}l=void 0}else cr?ur(e,n)&&(l=ar.compositionEnd):"keydown"===e&&229===n.keyCode&&(l=ar.compositionStart);return l?(or&&"ko"!==n.locale&&(cr||l!==ar.compositionStart?l===ar.compositionEnd&&cr&&(o=Qn()):(Bn="value"in(Vn=r)?Vn.value:Vn.textContent,cr=!0)),l=Gn.getPooled(l,t,n,r),(o||null!==(o=sr(n)))&&(l.data=o),Un(l),o=l):o=null,(e=rr?function(e,t){switch(e){case"compositionend":return sr(t);case"keypress":return 32!==t.which?null:(ir=!0,lr);case"textInput":return(e=t.data)===lr&&ir?null:e;default:return null}}(e,n):function(e,t){if(cr)return"compositionend"===e||!tr&&ur(e,t)?(e=Qn(),qn=Bn=Vn=null,cr=!1,e):null;switch(e){case"paste":default:return null;case"keypress":if(!(t.ctrlKey||t.altKey||t.metaKey)||t.ctrlKey&&t.altKey){if(t.char&&1<t.char.length)return t.char;if(t.which)return String.fromCharCode(t.which)}return null;case"compositionend":return or&&"ko"!==t.locale?null:t.data}}(e,n))?((t=Zn.getPooled(ar.beforeInput,t,n,r)).data=e,Un(t)):t=null,null===o?t:null===t?o:[o,t]}},pr={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function dr(e){var t=e&&e.nodeName&&e.nodeName.toLowerCase();return"input"===t?!!pr[e.type]:"textarea"===t}var mr={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function hr(e,t,n){return(e=$n.getPooled(mr.change,e,t,n)).type="change",z(n),Un(e),e}var yr=null,vr=null;function gr(e){at(e)}function br(e){if(xe(Ln(e)))return e}function wr(e,t){if("change"===e)return t}var xr=!1;function kr(){yr&&(yr.detachEvent("onpropertychange",Er),vr=yr=null)}function Er(e){if("value"===e.propertyName&&br(vr))if(e=hr(vr,e,it(e)),I)at(e);else{I=!0;try{D(gr,e)}finally{I=!1,A()}}}function Tr(e,t,n){"focus"===e?(kr(),vr=n,(yr=t).attachEvent("onpropertychange",Er)):"blur"===e&&kr()}function Sr(e){if("selectionchange"===e||"keyup"===e||"keydown"===e)return br(vr)}function Cr(e,t){if("click"===e)return br(t)}function Pr(e,t){if("input"===e||"change"===e)return br(t)}P&&(xr=ut("input")&&(!document.documentMode||9<document.documentMode));var _r={eventTypes:mr,_isInputEventSupported:xr,extractEvents:function(e,t,n,r){var o=t?Ln(t):window,l=o.nodeName&&o.nodeName.toLowerCase();if("select"===l||"input"===l&&"file"===o.type)var a=wr;else if(dr(o))if(xr)a=Pr;else{a=Sr;var i=Tr}else(l=o.nodeName)&&"input"===l.toLowerCase()&&("checkbox"===o.type||"radio"===o.type)&&(a=Cr);if(a&&(a=a(e,t)))return hr(a,n,r);i&&i(e,o,t),"blur"===e&&(e=o._wrapperState)&&e.controlled&&"number"===o.type&&Pe(o,"number",o.value)}},Or=$n.extend({view:null,detail:null}),Nr={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Rr(e){var t=this.nativeEvent;return t.getModifierState?t.getModifierState(e):!!(e=Nr[e])&&!!t[e]}function zr(){return Rr}var Lr=0,Dr=0,Mr=!1,jr=!1,Jr=Or.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:zr,button:null,buttons:null,relatedTarget:function(e){return e.relatedTarget||(e.fromElement===e.srcElement?e.toElement:e.fromElement)},movementX:function(e){if("movementX"in e)return e.movementX;var t=Lr;return Lr=e.screenX,Mr?"mousemove"===e.type?e.screenX-t:0:(Mr=!0,0)},movementY:function(e){if("movementY"in e)return e.movementY;var t=Dr;return Dr=e.screenY,jr?"mousemove"===e.type?e.screenY-t:0:(jr=!0,0)}}),Ir=Jr.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Fr={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",dependencies:["pointerout","pointerover"]}},Ar={eventTypes:Fr,extractEvents:function(e,t,n,r,o){var l="mouseover"===e||"pointerover"===e,a="mouseout"===e||"pointerout"===e;if(l&&!(32&o)&&(n.relatedTarget||n.fromElement)||!a&&!l)return null;if(l=r.window===r?r:(l=r.ownerDocument)?l.defaultView||l.parentWindow:window,a?(a=t,null!==(t=(t=n.relatedTarget||n.toElement)?Rn(t):null)&&(t!==Ge(t)||5!==t.tag&&6!==t.tag)&&(t=null)):a=null,a===t)return null;if("mouseout"===e||"mouseover"===e)var i=Jr,u=Fr.mouseLeave,s=Fr.mouseEnter,c="mouse";else"pointerout"!==e&&"pointerover"!==e||(i=Ir,u=Fr.pointerLeave,s=Fr.pointerEnter,c="pointer");if(e=null==a?l:Ln(a),l=null==t?l:Ln(t),(u=i.getPooled(u,a,n,r)).type=c+"leave",u.target=e,u.relatedTarget=l,(n=i.getPooled(s,t,n,r)).type=c+"enter",n.target=l,n.relatedTarget=e,c=t,(r=a)&&c)e:{for(s=c,a=0,e=i=r;e;e=Mn(e))a++;for(e=0,t=s;t;t=Mn(t))e++;for(;0<a-e;)i=Mn(i),a--;for(;0<e-a;)s=Mn(s),e--;for(;a--;){if(i===s||i===s.alternate)break e;i=Mn(i),s=Mn(s)}i=null}else i=null;for(s=i,i=[];r&&r!==s&&(null===(a=r.alternate)||a!==s);)i.push(r),r=Mn(r);for(r=[];c&&c!==s&&(null===(a=c.alternate)||a!==s);)r.push(c),c=Mn(c);for(c=0;c<i.length;c++)Fn(i[c],"bubbled",u);for(c=r.length;0<c--;)Fn(r[c],"captured",n);return 64&o?[u,n]:[u]}},Ur="function"==typeof Object.is?Object.is:function(e,t){return e===t&&(0!==e||1/e==1/t)||e!=e&&t!=t},Vr=Object.prototype.hasOwnProperty;function Br(e,t){if(Ur(e,t))return!0;if("object"!=typeof e||null===e||"object"!=typeof t||null===t)return!1;var n=Object.keys(e),r=Object.keys(t);if(n.length!==r.length)return!1;for(r=0;r<n.length;r++)if(!Vr.call(t,n[r])||!Ur(e[n[r]],t[n[r]]))return!1;return!0}var qr=P&&"documentMode"in document&&11>=document.documentMode,Qr={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Wr=null,Hr=null,$r=null,Kr=!1;function Xr(e,t){var n=t.window===t?t.document:9===t.nodeType?t:t.ownerDocument;return Kr||null==Wr||Wr!==sn(n)?null:(n="selectionStart"in(n=Wr)&&mn(n)?{start:n.selectionStart,end:n.selectionEnd}:{anchorNode:(n=(n.ownerDocument&&n.ownerDocument.defaultView||window).getSelection()).anchorNode,anchorOffset:n.anchorOffset,focusNode:n.focusNode,focusOffset:n.focusOffset},$r&&Br($r,n)?null:($r=n,(e=$n.getPooled(Qr.select,Hr,e,t)).type="select",e.target=Wr,Un(e),e))}var Yr={eventTypes:Qr,extractEvents:function(e,t,n,r,o,l){if(!(l=!(o=l||(r.window===r?r.document:9===r.nodeType?r:r.ownerDocument)))){e:{o=Ye(o),l=S.onSelect;for(var a=0;a<l.length;a++)if(!o.has(l[a])){o=!1;break e}o=!0}l=!o}if(l)return null;switch(o=t?Ln(t):window,e){case"focus":(dr(o)||"true"===o.contentEditable)&&(Wr=o,Hr=t,$r=null);break;case"blur":$r=Hr=Wr=null;break;case"mousedown":Kr=!0;break;case"contextmenu":case"mouseup":case"dragend":return Kr=!1,Xr(n,r);case"selectionchange":if(qr)break;case"keydown":case"keyup":return Xr(n,r)}return null}},Gr=$n.extend({animationName:null,elapsedTime:null,pseudoElement:null}),Zr=$n.extend({clipboardData:function(e){return"clipboardData"in e?e.clipboardData:window.clipboardData}}),eo=Or.extend({relatedTarget:null});function to(e){var t=e.keyCode;return"charCode"in e?0===(e=e.charCode)&&13===t&&(e=13):e=t,10===e&&(e=13),32<=e||13===e?e:0}var no={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},ro={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},oo=Or.extend({key:function(e){if(e.key){var t=no[e.key]||e.key;if("Unidentified"!==t)return t}return"keypress"===e.type?13===(e=to(e))?"Enter":String.fromCharCode(e):"keydown"===e.type||"keyup"===e.type?ro[e.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:zr,charCode:function(e){return"keypress"===e.type?to(e):0},keyCode:function(e){return"keydown"===e.type||"keyup"===e.type?e.keyCode:0},which:function(e){return"keypress"===e.type?to(e):"keydown"===e.type||"keyup"===e.type?e.keyCode:0}}),lo=Jr.extend({dataTransfer:null}),ao=Or.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:zr}),io=$n.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),uo=Jr.extend({deltaX:function(e){return"deltaX"in e?e.deltaX:"wheelDeltaX"in e?-e.wheelDeltaX:0},deltaY:function(e){return"deltaY"in e?e.deltaY:"wheelDeltaY"in e?-e.wheelDeltaY:"wheelDelta"in e?-e.wheelDelta:0},deltaZ:null,deltaMode:null}),so={eventTypes:jt,extractEvents:function(e,t,n,r){var o=Jt.get(e);if(!o)return null;switch(e){case"keypress":if(0===to(n))return null;case"keydown":case"keyup":e=oo;break;case"blur":case"focus":e=eo;break;case"click":if(2===n.button)return null;case"auxclick":case"dblclick":case"mousedown":case"mousemove":case"mouseup":case"mouseout":case"mouseover":case"contextmenu":e=Jr;break;case"drag":case"dragend":case"dragenter":case"dragexit":case"dragleave":case"dragover":case"dragstart":case"drop":e=lo;break;case"touchcancel":case"touchend":case"touchmove":case"touchstart":e=ao;break;case Qe:case We:case He:e=Gr;break;case $e:e=io;break;case"scroll":e=Or;break;case"wheel":e=uo;break;case"copy":case"cut":case"paste":e=Zr;break;case"gotpointercapture":case"lostpointercapture":case"pointercancel":case"pointerdown":case"pointermove":case"pointerout":case"pointerover":case"pointerup":e=Ir;break;default:e=$n}return Un(t=e.getPooled(o,t,n,r)),t}};if(g)throw Error(a(101));g=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" ")),w(),m=Dn,h=zn,y=Ln,C({SimpleEventPlugin:so,EnterLeaveEventPlugin:Ar,ChangeEventPlugin:_r,SelectEventPlugin:Yr,BeforeInputEventPlugin:fr});var co=[],fo=-1;function po(e){0>fo||(e.current=co[fo],co[fo]=null,fo--)}function mo(e,t){fo++,co[fo]=e.current,e.current=t}var ho={},yo={current:ho},vo={current:!1},go=ho;function bo(e,t){var n=e.type.contextTypes;if(!n)return ho;var r=e.stateNode;if(r&&r.__reactInternalMemoizedUnmaskedChildContext===t)return r.__reactInternalMemoizedMaskedChildContext;var o,l={};for(o in n)l[o]=t[o];return r&&((e=e.stateNode).__reactInternalMemoizedUnmaskedChildContext=t,e.__reactInternalMemoizedMaskedChildContext=l),l}function wo(e){return null!=e.childContextTypes}function xo(){po(vo),po(yo)}function ko(e,t,n){if(yo.current!==ho)throw Error(a(168));mo(yo,t),mo(vo,n)}function Eo(e,t,n){var r=e.stateNode;if(e=t.childContextTypes,"function"!=typeof r.getChildContext)return n;for(var l in r=r.getChildContext())if(!(l in e))throw Error(a(108,ye(t)||"Unknown",l));return o({},n,{},r)}function To(e){return e=(e=e.stateNode)&&e.__reactInternalMemoizedMergedChildContext||ho,go=yo.current,mo(yo,e),mo(vo,vo.current),!0}function So(e,t,n){var r=e.stateNode;if(!r)throw Error(a(169));n?(e=Eo(e,t,go),r.__reactInternalMemoizedMergedChildContext=e,po(vo),po(yo),mo(yo,e)):po(vo),mo(vo,n)}var Co=l.unstable_runWithPriority,Po=l.unstable_scheduleCallback,_o=l.unstable_cancelCallback,Oo=l.unstable_requestPaint,No=l.unstable_now,Ro=l.unstable_getCurrentPriorityLevel,zo=l.unstable_ImmediatePriority,Lo=l.unstable_UserBlockingPriority,Do=l.unstable_NormalPriority,Mo=l.unstable_LowPriority,jo=l.unstable_IdlePriority,Jo={},Io=l.unstable_shouldYield,Fo=void 0!==Oo?Oo:function(){},Ao=null,Uo=null,Vo=!1,Bo=No(),qo=1e4>Bo?No:function(){return No()-Bo};function Qo(){switch(Ro()){case zo:return 99;case Lo:return 98;case Do:return 97;case Mo:return 96;case jo:return 95;default:throw Error(a(332))}}function Wo(e){switch(e){case 99:return zo;case 98:return Lo;case 97:return Do;case 96:return Mo;case 95:return jo;default:throw Error(a(332))}}function Ho(e,t){return e=Wo(e),Co(e,t)}function $o(e,t,n){return e=Wo(e),Po(e,t,n)}function Ko(e){return null===Ao?(Ao=[e],Uo=Po(zo,Yo)):Ao.push(e),Jo}function Xo(){if(null!==Uo){var e=Uo;Uo=null,_o(e)}Yo()}function Yo(){if(!Vo&&null!==Ao){Vo=!0;var e=0;try{var t=Ao;Ho(99,(function(){for(;e<t.length;e++){var n=t[e];do{n=n(!0)}while(null!==n)}})),Ao=null}catch(t){throw null!==Ao&&(Ao=Ao.slice(e+1)),Po(zo,Xo),t}finally{Vo=!1}}}function Go(e,t,n){return 1073741821-(1+((1073741821-e+t/10)/(n/=10)|0))*n}function Zo(e,t){if(e&&e.defaultProps)for(var n in t=o({},t),e=e.defaultProps)void 0===t[n]&&(t[n]=e[n]);return t}var el={current:null},tl=null,nl=null,rl=null;function ol(){rl=nl=tl=null}function ll(e){var t=el.current;po(el),e.type._context._currentValue=t}function al(e,t){for(;null!==e;){var n=e.alternate;if(e.childExpirationTime<t)e.childExpirationTime=t,null!==n&&n.childExpirationTime<t&&(n.childExpirationTime=t);else{if(!(null!==n&&n.childExpirationTime<t))break;n.childExpirationTime=t}e=e.return}}function il(e,t){tl=e,rl=nl=null,null!==(e=e.dependencies)&&null!==e.firstContext&&(e.expirationTime>=t&&(Da=!0),e.firstContext=null)}function ul(e,t){if(rl!==e&&!1!==t&&0!==t)if("number"==typeof t&&1073741823!==t||(rl=e,t=1073741823),t={context:e,observedBits:t,next:null},null===nl){if(null===tl)throw Error(a(308));nl=t,tl.dependencies={expirationTime:0,firstContext:t,responders:null}}else nl=nl.next=t;return e._currentValue}var sl=!1;function cl(e){e.updateQueue={baseState:e.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}function fl(e,t){e=e.updateQueue,t.updateQueue===e&&(t.updateQueue={baseState:e.baseState,baseQueue:e.baseQueue,shared:e.shared,effects:e.effects})}function pl(e,t){return(e={expirationTime:e,suspenseConfig:t,tag:0,payload:null,callback:null,next:null}).next=e}function dl(e,t){if(null!==(e=e.updateQueue)){var n=(e=e.shared).pending;null===n?t.next=t:(t.next=n.next,n.next=t),e.pending=t}}function ml(e,t){var n=e.alternate;null!==n&&fl(n,e),null===(n=(e=e.updateQueue).baseQueue)?(e.baseQueue=t.next=t,t.next=t):(t.next=n.next,n.next=t)}function hl(e,t,n,r){var l=e.updateQueue;sl=!1;var a=l.baseQueue,i=l.shared.pending;if(null!==i){if(null!==a){var u=a.next;a.next=i.next,i.next=u}a=i,l.shared.pending=null,null!==(u=e.alternate)&&null!==(u=u.updateQueue)&&(u.baseQueue=i)}if(null!==a){u=a.next;var s=l.baseState,c=0,f=null,p=null,d=null;if(null!==u)for(var m=u;;){if((i=m.expirationTime)<r){var h={expirationTime:m.expirationTime,suspenseConfig:m.suspenseConfig,tag:m.tag,payload:m.payload,callback:m.callback,next:null};null===d?(p=d=h,f=s):d=d.next=h,i>c&&(c=i)}else{null!==d&&(d=d.next={expirationTime:1073741823,suspenseConfig:m.suspenseConfig,tag:m.tag,payload:m.payload,callback:m.callback,next:null}),wu(i,m.suspenseConfig);e:{var y=e,v=m;switch(i=t,h=n,v.tag){case 1:if("function"==typeof(y=v.payload)){s=y.call(h,s,i);break e}s=y;break e;case 3:y.effectTag=-4097&y.effectTag|64;case 0:if(null==(i="function"==typeof(y=v.payload)?y.call(h,s,i):y))break e;s=o({},s,i);break e;case 2:sl=!0}}null!==m.callback&&(e.effectTag|=32,null===(i=l.effects)?l.effects=[m]:i.push(m))}if(null===(m=m.next)||m===u){if(null===(i=l.shared.pending))break;m=a.next=i.next,i.next=u,l.baseQueue=a=i,l.shared.pending=null}}null===d?f=s:d.next=p,l.baseState=f,l.baseQueue=d,xu(c),e.expirationTime=c,e.memoizedState=s}}function yl(e,t,n){if(e=t.effects,t.effects=null,null!==e)for(t=0;t<e.length;t++){var r=e[t],o=r.callback;if(null!==o){if(r.callback=null,r=o,o=n,"function"!=typeof r)throw Error(a(191,r));r.call(o)}}}var vl=X.ReactCurrentBatchConfig,gl=(new r.Component).refs;function bl(e,t,n,r){n=null==(n=n(r,t=e.memoizedState))?t:o({},t,n),e.memoizedState=n,0===e.expirationTime&&(e.updateQueue.baseState=n)}var wl={isMounted:function(e){return!!(e=e._reactInternalFiber)&&Ge(e)===e},enqueueSetState:function(e,t,n){e=e._reactInternalFiber;var r=iu(),o=vl.suspense;(o=pl(r=uu(r,e,o),o)).payload=t,null!=n&&(o.callback=n),dl(e,o),su(e,r)},enqueueReplaceState:function(e,t,n){e=e._reactInternalFiber;var r=iu(),o=vl.suspense;(o=pl(r=uu(r,e,o),o)).tag=1,o.payload=t,null!=n&&(o.callback=n),dl(e,o),su(e,r)},enqueueForceUpdate:function(e,t){e=e._reactInternalFiber;var n=iu(),r=vl.suspense;(r=pl(n=uu(n,e,r),r)).tag=2,null!=t&&(r.callback=t),dl(e,r),su(e,n)}};function xl(e,t,n,r,o,l,a){return"function"==typeof(e=e.stateNode).shouldComponentUpdate?e.shouldComponentUpdate(r,l,a):!(t.prototype&&t.prototype.isPureReactComponent&&Br(n,r)&&Br(o,l))}function kl(e,t,n){var r=!1,o=ho,l=t.contextType;return"object"==typeof l&&null!==l?l=ul(l):(o=wo(t)?go:yo.current,l=(r=null!=(r=t.contextTypes))?bo(e,o):ho),t=new t(n,l),e.memoizedState=null!==t.state&&void 0!==t.state?t.state:null,t.updater=wl,e.stateNode=t,t._reactInternalFiber=e,r&&((e=e.stateNode).__reactInternalMemoizedUnmaskedChildContext=o,e.__reactInternalMemoizedMaskedChildContext=l),t}function El(e,t,n,r){e=t.state,"function"==typeof t.componentWillReceiveProps&&t.componentWillReceiveProps(n,r),"function"==typeof t.UNSAFE_componentWillReceiveProps&&t.UNSAFE_componentWillReceiveProps(n,r),t.state!==e&&wl.enqueueReplaceState(t,t.state,null)}function Tl(e,t,n,r){var o=e.stateNode;o.props=n,o.state=e.memoizedState,o.refs=gl,cl(e);var l=t.contextType;"object"==typeof l&&null!==l?o.context=ul(l):(l=wo(t)?go:yo.current,o.context=bo(e,l)),hl(e,n,o,r),o.state=e.memoizedState,"function"==typeof(l=t.getDerivedStateFromProps)&&(bl(e,t,l,n),o.state=e.memoizedState),"function"==typeof t.getDerivedStateFromProps||"function"==typeof o.getSnapshotBeforeUpdate||"function"!=typeof o.UNSAFE_componentWillMount&&"function"!=typeof o.componentWillMount||(t=o.state,"function"==typeof o.componentWillMount&&o.componentWillMount(),"function"==typeof o.UNSAFE_componentWillMount&&o.UNSAFE_componentWillMount(),t!==o.state&&wl.enqueueReplaceState(o,o.state,null),hl(e,n,o,r),o.state=e.memoizedState),"function"==typeof o.componentDidMount&&(e.effectTag|=4)}var Sl=Array.isArray;function Cl(e,t,n){if(null!==(e=n.ref)&&"function"!=typeof e&&"object"!=typeof e){if(n._owner){if(n=n._owner){if(1!==n.tag)throw Error(a(309));var r=n.stateNode}if(!r)throw Error(a(147,e));var o=""+e;return null!==t&&null!==t.ref&&"function"==typeof t.ref&&t.ref._stringRef===o?t.ref:(t=function(e){var t=r.refs;t===gl&&(t=r.refs={}),null===e?delete t[o]:t[o]=e},t._stringRef=o,t)}if("string"!=typeof e)throw Error(a(284));if(!n._owner)throw Error(a(290,e))}return e}function Pl(e,t){if("textarea"!==e.type)throw Error(a(31,"[object Object]"===Object.prototype.toString.call(t)?"object with keys {"+Object.keys(t).join(", ")+"}":t,""))}function _l(e){function t(t,n){if(e){var r=t.lastEffect;null!==r?(r.nextEffect=n,t.lastEffect=n):t.firstEffect=t.lastEffect=n,n.nextEffect=null,n.effectTag=8}}function n(n,r){if(!e)return null;for(;null!==r;)t(n,r),r=r.sibling;return null}function r(e,t){for(e=new Map;null!==t;)null!==t.key?e.set(t.key,t):e.set(t.index,t),t=t.sibling;return e}function o(e,t){return(e=Uu(e,t)).index=0,e.sibling=null,e}function l(t,n,r){return t.index=r,e?null!==(r=t.alternate)?(r=r.index)<n?(t.effectTag=2,n):r:(t.effectTag=2,n):n}function i(t){return e&&null===t.alternate&&(t.effectTag=2),t}function u(e,t,n,r){return null===t||6!==t.tag?((t=qu(n,e.mode,r)).return=e,t):((t=o(t,n)).return=e,t)}function s(e,t,n,r){return null!==t&&t.elementType===n.type?((r=o(t,n.props)).ref=Cl(e,t,n),r.return=e,r):((r=Vu(n.type,n.key,n.props,null,e.mode,r)).ref=Cl(e,t,n),r.return=e,r)}function c(e,t,n,r){return null===t||4!==t.tag||t.stateNode.containerInfo!==n.containerInfo||t.stateNode.implementation!==n.implementation?((t=Qu(n,e.mode,r)).return=e,t):((t=o(t,n.children||[])).return=e,t)}function f(e,t,n,r,l){return null===t||7!==t.tag?((t=Bu(n,e.mode,r,l)).return=e,t):((t=o(t,n)).return=e,t)}function p(e,t,n){if("string"==typeof t||"number"==typeof t)return(t=qu(""+t,e.mode,n)).return=e,t;if("object"==typeof t&&null!==t){switch(t.$$typeof){case ee:return(n=Vu(t.type,t.key,t.props,null,e.mode,n)).ref=Cl(e,null,t),n.return=e,n;case te:return(t=Qu(t,e.mode,n)).return=e,t}if(Sl(t)||he(t))return(t=Bu(t,e.mode,n,null)).return=e,t;Pl(e,t)}return null}function d(e,t,n,r){var o=null!==t?t.key:null;if("string"==typeof n||"number"==typeof n)return null!==o?null:u(e,t,""+n,r);if("object"==typeof n&&null!==n){switch(n.$$typeof){case ee:return n.key===o?n.type===ne?f(e,t,n.props.children,r,o):s(e,t,n,r):null;case te:return n.key===o?c(e,t,n,r):null}if(Sl(n)||he(n))return null!==o?null:f(e,t,n,r,null);Pl(e,n)}return null}function m(e,t,n,r,o){if("string"==typeof r||"number"==typeof r)return u(t,e=e.get(n)||null,""+r,o);if("object"==typeof r&&null!==r){switch(r.$$typeof){case ee:return e=e.get(null===r.key?n:r.key)||null,r.type===ne?f(t,e,r.props.children,o,r.key):s(t,e,r,o);case te:return c(t,e=e.get(null===r.key?n:r.key)||null,r,o)}if(Sl(r)||he(r))return f(t,e=e.get(n)||null,r,o,null);Pl(t,r)}return null}function h(o,a,i,u){for(var s=null,c=null,f=a,h=a=0,y=null;null!==f&&h<i.length;h++){f.index>h?(y=f,f=null):y=f.sibling;var v=d(o,f,i[h],u);if(null===v){null===f&&(f=y);break}e&&f&&null===v.alternate&&t(o,f),a=l(v,a,h),null===c?s=v:c.sibling=v,c=v,f=y}if(h===i.length)return n(o,f),s;if(null===f){for(;h<i.length;h++)null!==(f=p(o,i[h],u))&&(a=l(f,a,h),null===c?s=f:c.sibling=f,c=f);return s}for(f=r(o,f);h<i.length;h++)null!==(y=m(f,o,h,i[h],u))&&(e&&null!==y.alternate&&f.delete(null===y.key?h:y.key),a=l(y,a,h),null===c?s=y:c.sibling=y,c=y);return e&&f.forEach((function(e){return t(o,e)})),s}function y(o,i,u,s){var c=he(u);if("function"!=typeof c)throw Error(a(150));if(null==(u=c.call(u)))throw Error(a(151));for(var f=c=null,h=i,y=i=0,v=null,g=u.next();null!==h&&!g.done;y++,g=u.next()){h.index>y?(v=h,h=null):v=h.sibling;var b=d(o,h,g.value,s);if(null===b){null===h&&(h=v);break}e&&h&&null===b.alternate&&t(o,h),i=l(b,i,y),null===f?c=b:f.sibling=b,f=b,h=v}if(g.done)return n(o,h),c;if(null===h){for(;!g.done;y++,g=u.next())null!==(g=p(o,g.value,s))&&(i=l(g,i,y),null===f?c=g:f.sibling=g,f=g);return c}for(h=r(o,h);!g.done;y++,g=u.next())null!==(g=m(h,o,y,g.value,s))&&(e&&null!==g.alternate&&h.delete(null===g.key?y:g.key),i=l(g,i,y),null===f?c=g:f.sibling=g,f=g);return e&&h.forEach((function(e){return t(o,e)})),c}return function(e,r,l,u){var s="object"==typeof l&&null!==l&&l.type===ne&&null===l.key;s&&(l=l.props.children);var c="object"==typeof l&&null!==l;if(c)switch(l.$$typeof){case ee:e:{for(c=l.key,s=r;null!==s;){if(s.key===c){if(7===s.tag){if(l.type===ne){n(e,s.sibling),(r=o(s,l.props.children)).return=e,e=r;break e}}else if(s.elementType===l.type){n(e,s.sibling),(r=o(s,l.props)).ref=Cl(e,s,l),r.return=e,e=r;break e}n(e,s);break}t(e,s),s=s.sibling}l.type===ne?((r=Bu(l.props.children,e.mode,u,l.key)).return=e,e=r):((u=Vu(l.type,l.key,l.props,null,e.mode,u)).ref=Cl(e,r,l),u.return=e,e=u)}return i(e);case te:e:{for(s=l.key;null!==r;){if(r.key===s){if(4===r.tag&&r.stateNode.containerInfo===l.containerInfo&&r.stateNode.implementation===l.implementation){n(e,r.sibling),(r=o(r,l.children||[])).return=e,e=r;break e}n(e,r);break}t(e,r),r=r.sibling}(r=Qu(l,e.mode,u)).return=e,e=r}return i(e)}if("string"==typeof l||"number"==typeof l)return l=""+l,null!==r&&6===r.tag?(n(e,r.sibling),(r=o(r,l)).return=e,e=r):(n(e,r),(r=qu(l,e.mode,u)).return=e,e=r),i(e);if(Sl(l))return h(e,r,l,u);if(he(l))return y(e,r,l,u);if(c&&Pl(e,l),void 0===l&&!s)switch(e.tag){case 1:case 0:throw e=e.type,Error(a(152,e.displayName||e.name||"Component"))}return n(e,r)}}var Ol=_l(!0),Nl=_l(!1),Rl={},zl={current:Rl},Ll={current:Rl},Dl={current:Rl};function Ml(e){if(e===Rl)throw Error(a(174));return e}function jl(e,t){switch(mo(Dl,t),mo(Ll,e),mo(zl,Rl),e=t.nodeType){case 9:case 11:t=(t=t.documentElement)?t.namespaceURI:Me(null,"");break;default:t=Me(t=(e=8===e?t.parentNode:t).namespaceURI||null,e=e.tagName)}po(zl),mo(zl,t)}function Jl(){po(zl),po(Ll),po(Dl)}function Il(e){Ml(Dl.current);var t=Ml(zl.current),n=Me(t,e.type);t!==n&&(mo(Ll,e),mo(zl,n))}function Fl(e){Ll.current===e&&(po(zl),po(Ll))}var Al={current:0};function Ul(e){for(var t=e;null!==t;){if(13===t.tag){var n=t.memoizedState;if(null!==n&&(null===(n=n.dehydrated)||n.data===vn||n.data===gn))return t}else if(19===t.tag&&void 0!==t.memoizedProps.revealOrder){if(64&t.effectTag)return t}else if(null!==t.child){t.child.return=t,t=t.child;continue}if(t===e)break;for(;null===t.sibling;){if(null===t.return||t.return===e)return null;t=t.return}t.sibling.return=t.return,t=t.sibling}return null}function Vl(e,t){return{responder:e,props:t}}var Bl=X.ReactCurrentDispatcher,ql=X.ReactCurrentBatchConfig,Ql=0,Wl=null,Hl=null,$l=null,Kl=!1;function Xl(){throw Error(a(321))}function Yl(e,t){if(null===t)return!1;for(var n=0;n<t.length&&n<e.length;n++)if(!Ur(e[n],t[n]))return!1;return!0}function Gl(e,t,n,r,o,l){if(Ql=l,Wl=t,t.memoizedState=null,t.updateQueue=null,t.expirationTime=0,Bl.current=null===e||null===e.memoizedState?xa:ka,e=n(r,o),t.expirationTime===Ql){l=0;do{if(t.expirationTime=0,!(25>l))throw Error(a(301));l+=1,$l=Hl=null,t.updateQueue=null,Bl.current=Ea,e=n(r,o)}while(t.expirationTime===Ql)}if(Bl.current=wa,t=null!==Hl&&null!==Hl.next,Ql=0,$l=Hl=Wl=null,Kl=!1,t)throw Error(a(300));return e}function Zl(){var e={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};return null===$l?Wl.memoizedState=$l=e:$l=$l.next=e,$l}function ea(){if(null===Hl){var e=Wl.alternate;e=null!==e?e.memoizedState:null}else e=Hl.next;var t=null===$l?Wl.memoizedState:$l.next;if(null!==t)$l=t,Hl=e;else{if(null===e)throw Error(a(310));e={memoizedState:(Hl=e).memoizedState,baseState:Hl.baseState,baseQueue:Hl.baseQueue,queue:Hl.queue,next:null},null===$l?Wl.memoizedState=$l=e:$l=$l.next=e}return $l}function ta(e,t){return"function"==typeof t?t(e):t}function na(e){var t=ea(),n=t.queue;if(null===n)throw Error(a(311));n.lastRenderedReducer=e;var r=Hl,o=r.baseQueue,l=n.pending;if(null!==l){if(null!==o){var i=o.next;o.next=l.next,l.next=i}r.baseQueue=o=l,n.pending=null}if(null!==o){o=o.next,r=r.baseState;var u=i=l=null,s=o;do{var c=s.expirationTime;if(c<Ql){var f={expirationTime:s.expirationTime,suspenseConfig:s.suspenseConfig,action:s.action,eagerReducer:s.eagerReducer,eagerState:s.eagerState,next:null};null===u?(i=u=f,l=r):u=u.next=f,c>Wl.expirationTime&&(Wl.expirationTime=c,xu(c))}else null!==u&&(u=u.next={expirationTime:1073741823,suspenseConfig:s.suspenseConfig,action:s.action,eagerReducer:s.eagerReducer,eagerState:s.eagerState,next:null}),wu(c,s.suspenseConfig),r=s.eagerReducer===e?s.eagerState:e(r,s.action);s=s.next}while(null!==s&&s!==o);null===u?l=r:u.next=i,Ur(r,t.memoizedState)||(Da=!0),t.memoizedState=r,t.baseState=l,t.baseQueue=u,n.lastRenderedState=r}return[t.memoizedState,n.dispatch]}function ra(e){var t=ea(),n=t.queue;if(null===n)throw Error(a(311));n.lastRenderedReducer=e;var r=n.dispatch,o=n.pending,l=t.memoizedState;if(null!==o){n.pending=null;var i=o=o.next;do{l=e(l,i.action),i=i.next}while(i!==o);Ur(l,t.memoizedState)||(Da=!0),t.memoizedState=l,null===t.baseQueue&&(t.baseState=l),n.lastRenderedState=l}return[l,r]}function oa(e){var t=Zl();return"function"==typeof e&&(e=e()),t.memoizedState=t.baseState=e,e=(e=t.queue={pending:null,dispatch:null,lastRenderedReducer:ta,lastRenderedState:e}).dispatch=ba.bind(null,Wl,e),[t.memoizedState,e]}function la(e,t,n,r){return e={tag:e,create:t,destroy:n,deps:r,next:null},null===(t=Wl.updateQueue)?(t={lastEffect:null},Wl.updateQueue=t,t.lastEffect=e.next=e):null===(n=t.lastEffect)?t.lastEffect=e.next=e:(r=n.next,n.next=e,e.next=r,t.lastEffect=e),e}function aa(){return ea().memoizedState}function ia(e,t,n,r){var o=Zl();Wl.effectTag|=e,o.memoizedState=la(1|t,n,void 0,void 0===r?null:r)}function ua(e,t,n,r){var o=ea();r=void 0===r?null:r;var l=void 0;if(null!==Hl){var a=Hl.memoizedState;if(l=a.destroy,null!==r&&Yl(r,a.deps))return void la(t,n,l,r)}Wl.effectTag|=e,o.memoizedState=la(1|t,n,l,r)}function sa(e,t){return ia(516,4,e,t)}function ca(e,t){return ua(516,4,e,t)}function fa(e,t){return ua(4,2,e,t)}function pa(e,t){return"function"==typeof t?(e=e(),t(e),function(){t(null)}):null!=t?(e=e(),t.current=e,function(){t.current=null}):void 0}function da(e,t,n){return n=null!=n?n.concat([e]):null,ua(4,2,pa.bind(null,t,e),n)}function ma(){}function ha(e,t){return Zl().memoizedState=[e,void 0===t?null:t],e}function ya(e,t){var n=ea();t=void 0===t?null:t;var r=n.memoizedState;return null!==r&&null!==t&&Yl(t,r[1])?r[0]:(n.memoizedState=[e,t],e)}function va(e,t){var n=ea();t=void 0===t?null:t;var r=n.memoizedState;return null!==r&&null!==t&&Yl(t,r[1])?r[0]:(e=e(),n.memoizedState=[e,t],e)}function ga(e,t,n){var r=Qo();Ho(98>r?98:r,(function(){e(!0)})),Ho(97<r?97:r,(function(){var r=ql.suspense;ql.suspense=void 0===t?null:t;try{e(!1),n()}finally{ql.suspense=r}}))}function ba(e,t,n){var r=iu(),o=vl.suspense;o={expirationTime:r=uu(r,e,o),suspenseConfig:o,action:n,eagerReducer:null,eagerState:null,next:null};var l=t.pending;if(null===l?o.next=o:(o.next=l.next,l.next=o),t.pending=o,l=e.alternate,e===Wl||null!==l&&l===Wl)Kl=!0,o.expirationTime=Ql,Wl.expirationTime=Ql;else{if(0===e.expirationTime&&(null===l||0===l.expirationTime)&&null!==(l=t.lastRenderedReducer))try{var a=t.lastRenderedState,i=l(a,n);if(o.eagerReducer=l,o.eagerState=i,Ur(i,a))return}catch(e){}su(e,r)}}var wa={readContext:ul,useCallback:Xl,useContext:Xl,useEffect:Xl,useImperativeHandle:Xl,useLayoutEffect:Xl,useMemo:Xl,useReducer:Xl,useRef:Xl,useState:Xl,useDebugValue:Xl,useResponder:Xl,useDeferredValue:Xl,useTransition:Xl},xa={readContext:ul,useCallback:ha,useContext:ul,useEffect:sa,useImperativeHandle:function(e,t,n){return n=null!=n?n.concat([e]):null,ia(4,2,pa.bind(null,t,e),n)},useLayoutEffect:function(e,t){return ia(4,2,e,t)},useMemo:function(e,t){var n=Zl();return t=void 0===t?null:t,e=e(),n.memoizedState=[e,t],e},useReducer:function(e,t,n){var r=Zl();return t=void 0!==n?n(t):t,r.memoizedState=r.baseState=t,e=(e=r.queue={pending:null,dispatch:null,lastRenderedReducer:e,lastRenderedState:t}).dispatch=ba.bind(null,Wl,e),[r.memoizedState,e]},useRef:function(e){return e={current:e},Zl().memoizedState=e},useState:oa,useDebugValue:ma,useResponder:Vl,useDeferredValue:function(e,t){var n=oa(e),r=n[0],o=n[1];return sa((function(){var n=ql.suspense;ql.suspense=void 0===t?null:t;try{o(e)}finally{ql.suspense=n}}),[e,t]),r},useTransition:function(e){var t=oa(!1),n=t[0];return t=t[1],[ha(ga.bind(null,t,e),[t,e]),n]}},ka={readContext:ul,useCallback:ya,useContext:ul,useEffect:ca,useImperativeHandle:da,useLayoutEffect:fa,useMemo:va,useReducer:na,useRef:aa,useState:function(){return na(ta)},useDebugValue:ma,useResponder:Vl,useDeferredValue:function(e,t){var n=na(ta),r=n[0],o=n[1];return ca((function(){var n=ql.suspense;ql.suspense=void 0===t?null:t;try{o(e)}finally{ql.suspense=n}}),[e,t]),r},useTransition:function(e){var t=na(ta),n=t[0];return t=t[1],[ya(ga.bind(null,t,e),[t,e]),n]}},Ea={readContext:ul,useCallback:ya,useContext:ul,useEffect:ca,useImperativeHandle:da,useLayoutEffect:fa,useMemo:va,useReducer:ra,useRef:aa,useState:function(){return ra(ta)},useDebugValue:ma,useResponder:Vl,useDeferredValue:function(e,t){var n=ra(ta),r=n[0],o=n[1];return ca((function(){var n=ql.suspense;ql.suspense=void 0===t?null:t;try{o(e)}finally{ql.suspense=n}}),[e,t]),r},useTransition:function(e){var t=ra(ta),n=t[0];return t=t[1],[ya(ga.bind(null,t,e),[t,e]),n]}},Ta=null,Sa=null,Ca=!1;function Pa(e,t){var n=Fu(5,null,null,0);n.elementType="DELETED",n.type="DELETED",n.stateNode=t,n.return=e,n.effectTag=8,null!==e.lastEffect?(e.lastEffect.nextEffect=n,e.lastEffect=n):e.firstEffect=e.lastEffect=n}function _a(e,t){switch(e.tag){case 5:var n=e.type;return null!==(t=1!==t.nodeType||n.toLowerCase()!==t.nodeName.toLowerCase()?null:t)&&(e.stateNode=t,!0);case 6:return null!==(t=""===e.pendingProps||3!==t.nodeType?null:t)&&(e.stateNode=t,!0);default:return!1}}function Oa(e){if(Ca){var t=Sa;if(t){var n=t;if(!_a(e,t)){if(!(t=Sn(n.nextSibling))||!_a(e,t))return e.effectTag=-1025&e.effectTag|2,Ca=!1,void(Ta=e);Pa(Ta,n)}Ta=e,Sa=Sn(t.firstChild)}else e.effectTag=-1025&e.effectTag|2,Ca=!1,Ta=e}}function Na(e){for(e=e.return;null!==e&&5!==e.tag&&3!==e.tag&&13!==e.tag;)e=e.return;Ta=e}function Ra(e){if(e!==Ta)return!1;if(!Ca)return Na(e),Ca=!0,!1;var t=e.type;if(5!==e.tag||"head"!==t&&"body"!==t&&!kn(t,e.memoizedProps))for(t=Sa;t;)Pa(e,t),t=Sn(t.nextSibling);if(Na(e),13===e.tag){if(!(e=null!==(e=e.memoizedState)?e.dehydrated:null))throw Error(a(317));e:{for(e=e.nextSibling,t=0;e;){if(8===e.nodeType){var n=e.data;if(n===yn){if(0===t){Sa=Sn(e.nextSibling);break e}t--}else n!==hn&&n!==gn&&n!==vn||t++}e=e.nextSibling}Sa=null}}else Sa=Ta?Sn(e.stateNode.nextSibling):null;return!0}function za(){Sa=Ta=null,Ca=!1}var La=X.ReactCurrentOwner,Da=!1;function Ma(e,t,n,r){t.child=null===e?Nl(t,null,n,r):Ol(t,e.child,n,r)}function ja(e,t,n,r,o){n=n.render;var l=t.ref;return il(t,o),r=Gl(e,t,n,r,l,o),null===e||Da?(t.effectTag|=1,Ma(e,t,r,o),t.child):(t.updateQueue=e.updateQueue,t.effectTag&=-517,e.expirationTime<=o&&(e.expirationTime=0),Za(e,t,o))}function Ja(e,t,n,r,o,l){if(null===e){var a=n.type;return"function"!=typeof a||Au(a)||void 0!==a.defaultProps||null!==n.compare||void 0!==n.defaultProps?((e=Vu(n.type,null,r,null,t.mode,l)).ref=t.ref,e.return=t,t.child=e):(t.tag=15,t.type=a,Ia(e,t,a,r,o,l))}return a=e.child,o<l&&(o=a.memoizedProps,(n=null!==(n=n.compare)?n:Br)(o,r)&&e.ref===t.ref)?Za(e,t,l):(t.effectTag|=1,(e=Uu(a,r)).ref=t.ref,e.return=t,t.child=e)}function Ia(e,t,n,r,o,l){return null!==e&&Br(e.memoizedProps,r)&&e.ref===t.ref&&(Da=!1,o<l)?(t.expirationTime=e.expirationTime,Za(e,t,l)):Aa(e,t,n,r,l)}function Fa(e,t){var n=t.ref;(null===e&&null!==n||null!==e&&e.ref!==n)&&(t.effectTag|=128)}function Aa(e,t,n,r,o){var l=wo(n)?go:yo.current;return l=bo(t,l),il(t,o),n=Gl(e,t,n,r,l,o),null===e||Da?(t.effectTag|=1,Ma(e,t,n,o),t.child):(t.updateQueue=e.updateQueue,t.effectTag&=-517,e.expirationTime<=o&&(e.expirationTime=0),Za(e,t,o))}function Ua(e,t,n,r,o){if(wo(n)){var l=!0;To(t)}else l=!1;if(il(t,o),null===t.stateNode)null!==e&&(e.alternate=null,t.alternate=null,t.effectTag|=2),kl(t,n,r),Tl(t,n,r,o),r=!0;else if(null===e){var a=t.stateNode,i=t.memoizedProps;a.props=i;var u=a.context,s=n.contextType;s="object"==typeof s&&null!==s?ul(s):bo(t,s=wo(n)?go:yo.current);var c=n.getDerivedStateFromProps,f="function"==typeof c||"function"==typeof a.getSnapshotBeforeUpdate;f||"function"!=typeof a.UNSAFE_componentWillReceiveProps&&"function"!=typeof a.componentWillReceiveProps||(i!==r||u!==s)&&El(t,a,r,s),sl=!1;var p=t.memoizedState;a.state=p,hl(t,r,a,o),u=t.memoizedState,i!==r||p!==u||vo.current||sl?("function"==typeof c&&(bl(t,n,c,r),u=t.memoizedState),(i=sl||xl(t,n,i,r,p,u,s))?(f||"function"!=typeof a.UNSAFE_componentWillMount&&"function"!=typeof a.componentWillMount||("function"==typeof a.componentWillMount&&a.componentWillMount(),"function"==typeof a.UNSAFE_componentWillMount&&a.UNSAFE_componentWillMount()),"function"==typeof a.componentDidMount&&(t.effectTag|=4)):("function"==typeof a.componentDidMount&&(t.effectTag|=4),t.memoizedProps=r,t.memoizedState=u),a.props=r,a.state=u,a.context=s,r=i):("function"==typeof a.componentDidMount&&(t.effectTag|=4),r=!1)}else a=t.stateNode,fl(e,t),i=t.memoizedProps,a.props=t.type===t.elementType?i:Zo(t.type,i),u=a.context,s="object"==typeof(s=n.contextType)&&null!==s?ul(s):bo(t,s=wo(n)?go:yo.current),(f="function"==typeof(c=n.getDerivedStateFromProps)||"function"==typeof a.getSnapshotBeforeUpdate)||"function"!=typeof a.UNSAFE_componentWillReceiveProps&&"function"!=typeof a.componentWillReceiveProps||(i!==r||u!==s)&&El(t,a,r,s),sl=!1,u=t.memoizedState,a.state=u,hl(t,r,a,o),p=t.memoizedState,i!==r||u!==p||vo.current||sl?("function"==typeof c&&(bl(t,n,c,r),p=t.memoizedState),(c=sl||xl(t,n,i,r,u,p,s))?(f||"function"!=typeof a.UNSAFE_componentWillUpdate&&"function"!=typeof a.componentWillUpdate||("function"==typeof a.componentWillUpdate&&a.componentWillUpdate(r,p,s),"function"==typeof a.UNSAFE_componentWillUpdate&&a.UNSAFE_componentWillUpdate(r,p,s)),"function"==typeof a.componentDidUpdate&&(t.effectTag|=4),"function"==typeof a.getSnapshotBeforeUpdate&&(t.effectTag|=256)):("function"!=typeof a.componentDidUpdate||i===e.memoizedProps&&u===e.memoizedState||(t.effectTag|=4),"function"!=typeof a.getSnapshotBeforeUpdate||i===e.memoizedProps&&u===e.memoizedState||(t.effectTag|=256),t.memoizedProps=r,t.memoizedState=p),a.props=r,a.state=p,a.context=s,r=c):("function"!=typeof a.componentDidUpdate||i===e.memoizedProps&&u===e.memoizedState||(t.effectTag|=4),"function"!=typeof a.getSnapshotBeforeUpdate||i===e.memoizedProps&&u===e.memoizedState||(t.effectTag|=256),r=!1);return Va(e,t,n,r,l,o)}function Va(e,t,n,r,o,l){Fa(e,t);var a=!!(64&t.effectTag);if(!r&&!a)return o&&So(t,n,!1),Za(e,t,l);r=t.stateNode,La.current=t;var i=a&&"function"!=typeof n.getDerivedStateFromError?null:r.render();return t.effectTag|=1,null!==e&&a?(t.child=Ol(t,e.child,null,l),t.child=Ol(t,null,i,l)):Ma(e,t,i,l),t.memoizedState=r.state,o&&So(t,n,!0),t.child}function Ba(e){var t=e.stateNode;t.pendingContext?ko(0,t.pendingContext,t.pendingContext!==t.context):t.context&&ko(0,t.context,!1),jl(e,t.containerInfo)}var qa,Qa,Wa,Ha,$a={dehydrated:null,retryTime:0};function Ka(e,t,n){var r,o=t.mode,l=t.pendingProps,a=Al.current,i=!1;if((r=!!(64&t.effectTag))||(r=!!(2&a)&&(null===e||null!==e.memoizedState)),r?(i=!0,t.effectTag&=-65):null!==e&&null===e.memoizedState||void 0===l.fallback||!0===l.unstable_avoidThisFallback||(a|=1),mo(Al,1&a),null===e){if(void 0!==l.fallback&&Oa(t),i){if(i=l.fallback,(l=Bu(null,o,0,null)).return=t,!(2&t.mode))for(e=null!==t.memoizedState?t.child.child:t.child,l.child=e;null!==e;)e.return=l,e=e.sibling;return(n=Bu(i,o,n,null)).return=t,l.sibling=n,t.memoizedState=$a,t.child=l,n}return o=l.children,t.memoizedState=null,t.child=Nl(t,null,o,n)}if(null!==e.memoizedState){if(o=(e=e.child).sibling,i){if(l=l.fallback,(n=Uu(e,e.pendingProps)).return=t,!(2&t.mode)&&(i=null!==t.memoizedState?t.child.child:t.child)!==e.child)for(n.child=i;null!==i;)i.return=n,i=i.sibling;return(o=Uu(o,l)).return=t,n.sibling=o,n.childExpirationTime=0,t.memoizedState=$a,t.child=n,o}return n=Ol(t,e.child,l.children,n),t.memoizedState=null,t.child=n}if(e=e.child,i){if(i=l.fallback,(l=Bu(null,o,0,null)).return=t,l.child=e,null!==e&&(e.return=l),!(2&t.mode))for(e=null!==t.memoizedState?t.child.child:t.child,l.child=e;null!==e;)e.return=l,e=e.sibling;return(n=Bu(i,o,n,null)).return=t,l.sibling=n,n.effectTag|=2,l.childExpirationTime=0,t.memoizedState=$a,t.child=l,n}return t.memoizedState=null,t.child=Ol(t,e,l.children,n)}function Xa(e,t){e.expirationTime<t&&(e.expirationTime=t);var n=e.alternate;null!==n&&n.expirationTime<t&&(n.expirationTime=t),al(e.return,t)}function Ya(e,t,n,r,o,l){var a=e.memoizedState;null===a?e.memoizedState={isBackwards:t,rendering:null,renderingStartTime:0,last:r,tail:n,tailExpiration:0,tailMode:o,lastEffect:l}:(a.isBackwards=t,a.rendering=null,a.renderingStartTime=0,a.last=r,a.tail=n,a.tailExpiration=0,a.tailMode=o,a.lastEffect=l)}function Ga(e,t,n){var r=t.pendingProps,o=r.revealOrder,l=r.tail;if(Ma(e,t,r.children,n),2&(r=Al.current))r=1&r|2,t.effectTag|=64;else{if(null!==e&&64&e.effectTag)e:for(e=t.child;null!==e;){if(13===e.tag)null!==e.memoizedState&&Xa(e,n);else if(19===e.tag)Xa(e,n);else if(null!==e.child){e.child.return=e,e=e.child;continue}if(e===t)break e;for(;null===e.sibling;){if(null===e.return||e.return===t)break e;e=e.return}e.sibling.return=e.return,e=e.sibling}r&=1}if(mo(Al,r),2&t.mode)switch(o){case"forwards":for(n=t.child,o=null;null!==n;)null!==(e=n.alternate)&&null===Ul(e)&&(o=n),n=n.sibling;null===(n=o)?(o=t.child,t.child=null):(o=n.sibling,n.sibling=null),Ya(t,!1,o,n,l,t.lastEffect);break;case"backwards":for(n=null,o=t.child,t.child=null;null!==o;){if(null!==(e=o.alternate)&&null===Ul(e)){t.child=o;break}e=o.sibling,o.sibling=n,n=o,o=e}Ya(t,!0,n,null,l,t.lastEffect);break;case"together":Ya(t,!1,null,null,void 0,t.lastEffect);break;default:t.memoizedState=null}else t.memoizedState=null;return t.child}function Za(e,t,n){null!==e&&(t.dependencies=e.dependencies);var r=t.expirationTime;if(0!==r&&xu(r),t.childExpirationTime<n)return null;if(null!==e&&t.child!==e.child)throw Error(a(153));if(null!==t.child){for(n=Uu(e=t.child,e.pendingProps),t.child=n,n.return=t;null!==e.sibling;)e=e.sibling,(n=n.sibling=Uu(e,e.pendingProps)).return=t;n.sibling=null}return t.child}function ei(e,t){switch(e.tailMode){case"hidden":t=e.tail;for(var n=null;null!==t;)null!==t.alternate&&(n=t),t=t.sibling;null===n?e.tail=null:n.sibling=null;break;case"collapsed":n=e.tail;for(var r=null;null!==n;)null!==n.alternate&&(r=n),n=n.sibling;null===r?t||null===e.tail?e.tail=null:e.tail.sibling=null:r.sibling=null}}function ti(e,t,n){var r=t.pendingProps;switch(t.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:case 17:return wo(t.type)&&xo(),null;case 3:return Jl(),po(vo),po(yo),(n=t.stateNode).pendingContext&&(n.context=n.pendingContext,n.pendingContext=null),null!==e&&null!==e.child||!Ra(t)||(t.effectTag|=4),Qa(t),null;case 5:Fl(t),n=Ml(Dl.current);var l=t.type;if(null!==e&&null!=t.stateNode)Wa(e,t,l,r,n),e.ref!==t.ref&&(t.effectTag|=128);else{if(!r){if(null===t.stateNode)throw Error(a(166));return null}if(e=Ml(zl.current),Ra(t)){r=t.stateNode,l=t.type;var i=t.memoizedProps;switch(r[_n]=t,r[On]=i,l){case"iframe":case"object":case"embed":Wt("load",r);break;case"video":case"audio":for(e=0;e<Ke.length;e++)Wt(Ke[e],r);break;case"source":Wt("error",r);break;case"img":case"image":case"link":Wt("error",r),Wt("load",r);break;case"form":Wt("reset",r),Wt("submit",r);break;case"details":Wt("toggle",r);break;case"input":Ee(r,i),Wt("invalid",r),an(n,"onChange");break;case"select":r._wrapperState={wasMultiple:!!i.multiple},Wt("invalid",r),an(n,"onChange");break;case"textarea":Re(r,i),Wt("invalid",r),an(n,"onChange")}for(var u in rn(l,i),e=null,i)if(i.hasOwnProperty(u)){var s=i[u];"children"===u?"string"==typeof s?r.textContent!==s&&(e=["children",s]):"number"==typeof s&&r.textContent!==""+s&&(e=["children",""+s]):T.hasOwnProperty(u)&&null!=s&&an(n,u)}switch(l){case"input":we(r),Ce(r,i,!0);break;case"textarea":we(r),Le(r);break;case"select":case"option":break;default:"function"==typeof i.onClick&&(r.onclick=un)}n=e,t.updateQueue=n,null!==n&&(t.effectTag|=4)}else{switch(u=9===n.nodeType?n:n.ownerDocument,e===ln&&(e=De(l)),e===ln?"script"===l?((e=u.createElement("div")).innerHTML="<script><\/script>",e=e.removeChild(e.firstChild)):"string"==typeof r.is?e=u.createElement(l,{is:r.is}):(e=u.createElement(l),"select"===l&&(u=e,r.multiple?u.multiple=!0:r.size&&(u.size=r.size))):e=u.createElementNS(e,l),e[_n]=t,e[On]=r,qa(e,t,!1,!1),t.stateNode=e,u=on(l,r),l){case"iframe":case"object":case"embed":Wt("load",e),s=r;break;case"video":case"audio":for(s=0;s<Ke.length;s++)Wt(Ke[s],e);s=r;break;case"source":Wt("error",e),s=r;break;case"img":case"image":case"link":Wt("error",e),Wt("load",e),s=r;break;case"form":Wt("reset",e),Wt("submit",e),s=r;break;case"details":Wt("toggle",e),s=r;break;case"input":Ee(e,r),s=ke(e,r),Wt("invalid",e),an(n,"onChange");break;case"option":s=_e(e,r);break;case"select":e._wrapperState={wasMultiple:!!r.multiple},s=o({},r,{value:void 0}),Wt("invalid",e),an(n,"onChange");break;case"textarea":Re(e,r),s=Ne(e,r),Wt("invalid",e),an(n,"onChange");break;default:s=r}rn(l,s);var c=s;for(i in c)if(c.hasOwnProperty(i)){var f=c[i];"style"===i?tn(e,f):"dangerouslySetInnerHTML"===i?null!=(f=f?f.__html:void 0)&&Ie(e,f):"children"===i?"string"==typeof f?("textarea"!==l||""!==f)&&Fe(e,f):"number"==typeof f&&Fe(e,""+f):"suppressContentEditableWarning"!==i&&"suppressHydrationWarning"!==i&&"autoFocus"!==i&&(T.hasOwnProperty(i)?null!=f&&an(n,i):null!=f&&Y(e,i,f,u))}switch(l){case"input":we(e),Ce(e,r,!1);break;case"textarea":we(e),Le(e);break;case"option":null!=r.value&&e.setAttribute("value",""+ge(r.value));break;case"select":e.multiple=!!r.multiple,null!=(n=r.value)?Oe(e,!!r.multiple,n,!1):null!=r.defaultValue&&Oe(e,!!r.multiple,r.defaultValue,!0);break;default:"function"==typeof s.onClick&&(e.onclick=un)}xn(l,r)&&(t.effectTag|=4)}null!==t.ref&&(t.effectTag|=128)}return null;case 6:if(e&&null!=t.stateNode)Ha(e,t,e.memoizedProps,r);else{if("string"!=typeof r&&null===t.stateNode)throw Error(a(166));n=Ml(Dl.current),Ml(zl.current),Ra(t)?(n=t.stateNode,r=t.memoizedProps,n[_n]=t,n.nodeValue!==r&&(t.effectTag|=4)):((n=(9===n.nodeType?n:n.ownerDocument).createTextNode(r))[_n]=t,t.stateNode=n)}return null;case 13:return po(Al),r=t.memoizedState,64&t.effectTag?(t.expirationTime=n,t):(n=null!==r,r=!1,null===e?void 0!==t.memoizedProps.fallback&&Ra(t):(r=null!==(l=e.memoizedState),n||null===l||null!==(l=e.child.sibling)&&(null!==(i=t.firstEffect)?(t.firstEffect=l,l.nextEffect=i):(t.firstEffect=t.lastEffect=l,l.nextEffect=null),l.effectTag=8)),n&&!r&&2&t.mode&&(null===e&&!0!==t.memoizedProps.unstable_avoidThisFallback||1&Al.current?Ui===Ri&&(Ui=Di):(Ui!==Ri&&Ui!==Di||(Ui=Mi),0!==Wi&&null!==Ii&&($u(Ii,Ai),Ku(Ii,Wi)))),(n||r)&&(t.effectTag|=4),null);case 4:return Jl(),Qa(t),null;case 10:return ll(t),null;case 19:if(po(Al),null===(r=t.memoizedState))return null;if(l=!!(64&t.effectTag),null===(i=r.rendering)){if(l)ei(r,!1);else if(Ui!==Ri||null!==e&&64&e.effectTag)for(i=t.child;null!==i;){if(null!==(e=Ul(i))){for(t.effectTag|=64,ei(r,!1),null!==(l=e.updateQueue)&&(t.updateQueue=l,t.effectTag|=4),null===r.lastEffect&&(t.firstEffect=null),t.lastEffect=r.lastEffect,r=t.child;null!==r;)i=n,(l=r).effectTag&=2,l.nextEffect=null,l.firstEffect=null,l.lastEffect=null,null===(e=l.alternate)?(l.childExpirationTime=0,l.expirationTime=i,l.child=null,l.memoizedProps=null,l.memoizedState=null,l.updateQueue=null,l.dependencies=null):(l.childExpirationTime=e.childExpirationTime,l.expirationTime=e.expirationTime,l.child=e.child,l.memoizedProps=e.memoizedProps,l.memoizedState=e.memoizedState,l.updateQueue=e.updateQueue,i=e.dependencies,l.dependencies=null===i?null:{expirationTime:i.expirationTime,firstContext:i.firstContext,responders:i.responders}),r=r.sibling;return mo(Al,1&Al.current|2),t.child}i=i.sibling}}else{if(!l)if(null!==(e=Ul(i))){if(t.effectTag|=64,l=!0,null!==(n=e.updateQueue)&&(t.updateQueue=n,t.effectTag|=4),ei(r,!0),null===r.tail&&"hidden"===r.tailMode&&!i.alternate)return null!==(t=t.lastEffect=r.lastEffect)&&(t.nextEffect=null),null}else 2*qo()-r.renderingStartTime>r.tailExpiration&&1<n&&(t.effectTag|=64,l=!0,ei(r,!1),t.expirationTime=t.childExpirationTime=n-1);r.isBackwards?(i.sibling=t.child,t.child=i):(null!==(n=r.last)?n.sibling=i:t.child=i,r.last=i)}return null!==r.tail?(0===r.tailExpiration&&(r.tailExpiration=qo()+500),n=r.tail,r.rendering=n,r.tail=n.sibling,r.lastEffect=t.lastEffect,r.renderingStartTime=qo(),n.sibling=null,t=Al.current,mo(Al,l?1&t|2:1&t),n):null}throw Error(a(156,t.tag))}function ni(e){switch(e.tag){case 1:wo(e.type)&&xo();var t=e.effectTag;return 4096&t?(e.effectTag=-4097&t|64,e):null;case 3:if(Jl(),po(vo),po(yo),64&(t=e.effectTag))throw Error(a(285));return e.effectTag=-4097&t|64,e;case 5:return Fl(e),null;case 13:return po(Al),4096&(t=e.effectTag)?(e.effectTag=-4097&t|64,e):null;case 19:return po(Al),null;case 4:return Jl(),null;case 10:return ll(e),null;default:return null}}function ri(e,t){return{value:e,source:t,stack:ve(t)}}qa=function(e,t){for(var n=t.child;null!==n;){if(5===n.tag||6===n.tag)e.appendChild(n.stateNode);else if(4!==n.tag&&null!==n.child){n.child.return=n,n=n.child;continue}if(n===t)break;for(;null===n.sibling;){if(null===n.return||n.return===t)return;n=n.return}n.sibling.return=n.return,n=n.sibling}},Qa=function(){},Wa=function(e,t,n,r,l){var a=e.memoizedProps;if(a!==r){var i,u,s=t.stateNode;switch(Ml(zl.current),e=null,n){case"input":a=ke(s,a),r=ke(s,r),e=[];break;case"option":a=_e(s,a),r=_e(s,r),e=[];break;case"select":a=o({},a,{value:void 0}),r=o({},r,{value:void 0}),e=[];break;case"textarea":a=Ne(s,a),r=Ne(s,r),e=[];break;default:"function"!=typeof a.onClick&&"function"==typeof r.onClick&&(s.onclick=un)}for(i in rn(n,r),n=null,a)if(!r.hasOwnProperty(i)&&a.hasOwnProperty(i)&&null!=a[i])if("style"===i)for(u in s=a[i])s.hasOwnProperty(u)&&(n||(n={}),n[u]="");else"dangerouslySetInnerHTML"!==i&&"children"!==i&&"suppressContentEditableWarning"!==i&&"suppressHydrationWarning"!==i&&"autoFocus"!==i&&(T.hasOwnProperty(i)?e||(e=[]):(e=e||[]).push(i,null));for(i in r){var c=r[i];if(s=null!=a?a[i]:void 0,r.hasOwnProperty(i)&&c!==s&&(null!=c||null!=s))if("style"===i)if(s){for(u in s)!s.hasOwnProperty(u)||c&&c.hasOwnProperty(u)||(n||(n={}),n[u]="");for(u in c)c.hasOwnProperty(u)&&s[u]!==c[u]&&(n||(n={}),n[u]=c[u])}else n||(e||(e=[]),e.push(i,n)),n=c;else"dangerouslySetInnerHTML"===i?(c=c?c.__html:void 0,s=s?s.__html:void 0,null!=c&&s!==c&&(e=e||[]).push(i,c)):"children"===i?s===c||"string"!=typeof c&&"number"!=typeof c||(e=e||[]).push(i,""+c):"suppressContentEditableWarning"!==i&&"suppressHydrationWarning"!==i&&(T.hasOwnProperty(i)?(null!=c&&an(l,i),e||s===c||(e=[])):(e=e||[]).push(i,c))}n&&(e=e||[]).push("style",n),l=e,(t.updateQueue=l)&&(t.effectTag|=4)}},Ha=function(e,t,n,r){n!==r&&(t.effectTag|=4)};var oi="function"==typeof WeakSet?WeakSet:Set;function li(e,t){var n=t.source,r=t.stack;null===r&&null!==n&&(r=ve(n)),null!==n&&ye(n.type),t=t.value,null!==e&&1===e.tag&&ye(e.type);try{console.error(t)}catch(e){setTimeout((function(){throw e}))}}function ai(e){var t=e.ref;if(null!==t)if("function"==typeof t)try{t(null)}catch(t){Lu(e,t)}else t.current=null}function ii(e,t){switch(t.tag){case 0:case 11:case 15:case 22:case 3:case 5:case 6:case 4:case 17:return;case 1:if(256&t.effectTag&&null!==e){var n=e.memoizedProps,r=e.memoizedState;t=(e=t.stateNode).getSnapshotBeforeUpdate(t.elementType===t.type?n:Zo(t.type,n),r),e.__reactInternalSnapshotBeforeUpdate=t}return}throw Error(a(163))}function ui(e,t){if(null!==(t=null!==(t=t.updateQueue)?t.lastEffect:null)){var n=t=t.next;do{if((n.tag&e)===e){var r=n.destroy;n.destroy=void 0,void 0!==r&&r()}n=n.next}while(n!==t)}}function si(e,t){if(null!==(t=null!==(t=t.updateQueue)?t.lastEffect:null)){var n=t=t.next;do{if((n.tag&e)===e){var r=n.create;n.destroy=r()}n=n.next}while(n!==t)}}function ci(e,t,n){switch(n.tag){case 0:case 11:case 15:case 22:return void si(3,n);case 1:if(e=n.stateNode,4&n.effectTag)if(null===t)e.componentDidMount();else{var r=n.elementType===n.type?t.memoizedProps:Zo(n.type,t.memoizedProps);e.componentDidUpdate(r,t.memoizedState,e.__reactInternalSnapshotBeforeUpdate)}return void(null!==(t=n.updateQueue)&&yl(n,t,e));case 3:if(null!==(t=n.updateQueue)){if(e=null,null!==n.child)switch(n.child.tag){case 5:case 1:e=n.child.stateNode}yl(n,t,e)}return;case 5:return e=n.stateNode,void(null===t&&4&n.effectTag&&xn(n.type,n.memoizedProps)&&e.focus());case 6:case 4:case 12:case 19:case 17:case 20:case 21:return;case 13:return void(null===n.memoizedState&&(n=n.alternate,null!==n&&(n=n.memoizedState,null!==n&&(n=n.dehydrated,null!==n&&Mt(n)))))}throw Error(a(163))}function fi(e,t,n){switch("function"==typeof Ju&&Ju(t),t.tag){case 0:case 11:case 14:case 15:case 22:if(null!==(e=t.updateQueue)&&null!==(e=e.lastEffect)){var r=e.next;Ho(97<n?97:n,(function(){var e=r;do{var n=e.destroy;if(void 0!==n){var o=t;try{n()}catch(e){Lu(o,e)}}e=e.next}while(e!==r)}))}break;case 1:ai(t),"function"==typeof(n=t.stateNode).componentWillUnmount&&function(e,t){try{t.props=e.memoizedProps,t.state=e.memoizedState,t.componentWillUnmount()}catch(t){Lu(e,t)}}(t,n);break;case 5:ai(t);break;case 4:vi(e,t,n)}}function pi(e){var t=e.alternate;e.return=null,e.child=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null,e.alternate=null,e.firstEffect=null,e.lastEffect=null,e.pendingProps=null,e.memoizedProps=null,e.stateNode=null,null!==t&&pi(t)}function di(e){return 5===e.tag||3===e.tag||4===e.tag}function mi(e){e:{for(var t=e.return;null!==t;){if(di(t)){var n=t;break e}t=t.return}throw Error(a(160))}switch(t=n.stateNode,n.tag){case 5:var r=!1;break;case 3:case 4:t=t.containerInfo,r=!0;break;default:throw Error(a(161))}16&n.effectTag&&(Fe(t,""),n.effectTag&=-17);e:t:for(n=e;;){for(;null===n.sibling;){if(null===n.return||di(n.return)){n=null;break e}n=n.return}for(n.sibling.return=n.return,n=n.sibling;5!==n.tag&&6!==n.tag&&18!==n.tag;){if(2&n.effectTag)continue t;if(null===n.child||4===n.tag)continue t;n.child.return=n,n=n.child}if(!(2&n.effectTag)){n=n.stateNode;break e}}r?hi(e,n,t):yi(e,n,t)}function hi(e,t,n){var r=e.tag,o=5===r||6===r;if(o)e=o?e.stateNode:e.stateNode.instance,t?8===n.nodeType?n.parentNode.insertBefore(e,t):n.insertBefore(e,t):(8===n.nodeType?(t=n.parentNode).insertBefore(e,n):(t=n).appendChild(e),null!=(n=n._reactRootContainer)||null!==t.onclick||(t.onclick=un));else if(4!==r&&null!==(e=e.child))for(hi(e,t,n),e=e.sibling;null!==e;)hi(e,t,n),e=e.sibling}function yi(e,t,n){var r=e.tag,o=5===r||6===r;if(o)e=o?e.stateNode:e.stateNode.instance,t?n.insertBefore(e,t):n.appendChild(e);else if(4!==r&&null!==(e=e.child))for(yi(e,t,n),e=e.sibling;null!==e;)yi(e,t,n),e=e.sibling}function vi(e,t,n){for(var r,o,l=t,i=!1;;){if(!i){i=l.return;e:for(;;){if(null===i)throw Error(a(160));switch(r=i.stateNode,i.tag){case 5:o=!1;break e;case 3:case 4:r=r.containerInfo,o=!0;break e}i=i.return}i=!0}if(5===l.tag||6===l.tag){e:for(var u=e,s=l,c=n,f=s;;)if(fi(u,f,c),null!==f.child&&4!==f.tag)f.child.return=f,f=f.child;else{if(f===s)break e;for(;null===f.sibling;){if(null===f.return||f.return===s)break e;f=f.return}f.sibling.return=f.return,f=f.sibling}o?(u=r,s=l.stateNode,8===u.nodeType?u.parentNode.removeChild(s):u.removeChild(s)):r.removeChild(l.stateNode)}else if(4===l.tag){if(null!==l.child){r=l.stateNode.containerInfo,o=!0,l.child.return=l,l=l.child;continue}}else if(fi(e,l,n),null!==l.child){l.child.return=l,l=l.child;continue}if(l===t)break;for(;null===l.sibling;){if(null===l.return||l.return===t)return;4===(l=l.return).tag&&(i=!1)}l.sibling.return=l.return,l=l.sibling}}function gi(e,t){switch(t.tag){case 0:case 11:case 14:case 15:case 22:return void ui(3,t);case 1:case 12:case 17:return;case 5:var n=t.stateNode;if(null!=n){var r=t.memoizedProps,o=null!==e?e.memoizedProps:r;e=t.type;var l=t.updateQueue;if(t.updateQueue=null,null!==l){for(n[On]=r,"input"===e&&"radio"===r.type&&null!=r.name&&Te(n,r),on(e,o),t=on(e,r),o=0;o<l.length;o+=2){var i=l[o],u=l[o+1];"style"===i?tn(n,u):"dangerouslySetInnerHTML"===i?Ie(n,u):"children"===i?Fe(n,u):Y(n,i,u,t)}switch(e){case"input":Se(n,r);break;case"textarea":ze(n,r);break;case"select":t=n._wrapperState.wasMultiple,n._wrapperState.wasMultiple=!!r.multiple,null!=(e=r.value)?Oe(n,!!r.multiple,e,!1):t!==!!r.multiple&&(null!=r.defaultValue?Oe(n,!!r.multiple,r.defaultValue,!0):Oe(n,!!r.multiple,r.multiple?[]:"",!1))}}}return;case 6:if(null===t.stateNode)throw Error(a(162));return void(t.stateNode.nodeValue=t.memoizedProps);case 3:return void((t=t.stateNode).hydrate&&(t.hydrate=!1,Mt(t.containerInfo)));case 13:if(n=t,null===t.memoizedState?r=!1:(r=!0,n=t.child,$i=qo()),null!==n)e:for(e=n;;){if(5===e.tag)l=e.stateNode,r?"function"==typeof(l=l.style).setProperty?l.setProperty("display","none","important"):l.display="none":(l=e.stateNode,o=null!=(o=e.memoizedProps.style)&&o.hasOwnProperty("display")?o.display:null,l.style.display=en("display",o));else if(6===e.tag)e.stateNode.nodeValue=r?"":e.memoizedProps;else{if(13===e.tag&&null!==e.memoizedState&&null===e.memoizedState.dehydrated){(l=e.child.sibling).return=e,e=l;continue}if(null!==e.child){e.child.return=e,e=e.child;continue}}if(e===n)break;for(;null===e.sibling;){if(null===e.return||e.return===n)break e;e=e.return}e.sibling.return=e.return,e=e.sibling}return void bi(t);case 19:return void bi(t)}throw Error(a(163))}function bi(e){var t=e.updateQueue;if(null!==t){e.updateQueue=null;var n=e.stateNode;null===n&&(n=e.stateNode=new oi),t.forEach((function(t){var r=Mu.bind(null,e,t);n.has(t)||(n.add(t),t.then(r,r))}))}}var wi="function"==typeof WeakMap?WeakMap:Map;function xi(e,t,n){(n=pl(n,null)).tag=3,n.payload={element:null};var r=t.value;return n.callback=function(){Yi||(Yi=!0,Gi=r),li(e,t)},n}function ki(e,t,n){(n=pl(n,null)).tag=3;var r=e.type.getDerivedStateFromError;if("function"==typeof r){var o=t.value;n.payload=function(){return li(e,t),r(o)}}var l=e.stateNode;return null!==l&&"function"==typeof l.componentDidCatch&&(n.callback=function(){"function"!=typeof r&&(null===Zi?Zi=new Set([this]):Zi.add(this),li(e,t));var n=t.stack;this.componentDidCatch(t.value,{componentStack:null!==n?n:""})}),n}var Ei,Ti=Math.ceil,Si=X.ReactCurrentDispatcher,Ci=X.ReactCurrentOwner,Pi=0,_i=8,Oi=16,Ni=32,Ri=0,zi=1,Li=2,Di=3,Mi=4,ji=5,Ji=Pi,Ii=null,Fi=null,Ai=0,Ui=Ri,Vi=null,Bi=1073741823,qi=1073741823,Qi=null,Wi=0,Hi=!1,$i=0,Ki=500,Xi=null,Yi=!1,Gi=null,Zi=null,eu=!1,tu=null,nu=90,ru=null,ou=0,lu=null,au=0;function iu(){return(Ji&(Oi|Ni))!==Pi?1073741821-(qo()/10|0):0!==au?au:au=1073741821-(qo()/10|0)}function uu(e,t,n){if(!(2&(t=t.mode)))return 1073741823;var r=Qo();if(!(4&t))return 99===r?1073741823:1073741822;if((Ji&Oi)!==Pi)return Ai;if(null!==n)e=Go(e,0|n.timeoutMs||5e3,250);else switch(r){case 99:e=1073741823;break;case 98:e=Go(e,150,100);break;case 97:case 96:e=Go(e,5e3,250);break;case 95:e=2;break;default:throw Error(a(326))}return null!==Ii&&e===Ai&&--e,e}function su(e,t){if(50<ou)throw ou=0,lu=null,Error(a(185));if(null!==(e=cu(e,t))){var n=Qo();1073741823===t?(Ji&_i)!==Pi&&(Ji&(Oi|Ni))===Pi?mu(e):(pu(e),Ji===Pi&&Xo()):pu(e),(4&Ji)===Pi||98!==n&&99!==n||(null===ru?ru=new Map([[e,t]]):(void 0===(n=ru.get(e))||n>t)&&ru.set(e,t))}}function cu(e,t){e.expirationTime<t&&(e.expirationTime=t);var n=e.alternate;null!==n&&n.expirationTime<t&&(n.expirationTime=t);var r=e.return,o=null;if(null===r&&3===e.tag)o=e.stateNode;else for(;null!==r;){if(n=r.alternate,r.childExpirationTime<t&&(r.childExpirationTime=t),null!==n&&n.childExpirationTime<t&&(n.childExpirationTime=t),null===r.return&&3===r.tag){o=r.stateNode;break}r=r.return}return null!==o&&(Ii===o&&(xu(t),Ui===Mi&&$u(o,Ai)),Ku(o,t)),o}function fu(e){var t=e.lastExpiredTime;if(0!==t)return t;if(!Hu(e,t=e.firstPendingTime))return t;var n=e.lastPingedTime;return 2>=(e=n>(e=e.nextKnownPendingLevel)?n:e)&&t!==e?0:e}function pu(e){if(0!==e.lastExpiredTime)e.callbackExpirationTime=1073741823,e.callbackPriority=99,e.callbackNode=Ko(mu.bind(null,e));else{var t=fu(e),n=e.callbackNode;if(0===t)null!==n&&(e.callbackNode=null,e.callbackExpirationTime=0,e.callbackPriority=90);else{var r=iu();if(r=1073741823===t?99:1===t||2===t?95:0>=(r=10*(1073741821-t)-10*(1073741821-r))?99:250>=r?98:5250>=r?97:95,null!==n){var o=e.callbackPriority;if(e.callbackExpirationTime===t&&o>=r)return;n!==Jo&&_o(n)}e.callbackExpirationTime=t,e.callbackPriority=r,t=1073741823===t?Ko(mu.bind(null,e)):$o(r,du.bind(null,e),{timeout:10*(1073741821-t)-qo()}),e.callbackNode=t}}}function du(e,t){if(au=0,t)return Xu(e,t=iu()),pu(e),null;var n=fu(e);if(0!==n){if(t=e.callbackNode,(Ji&(Oi|Ni))!==Pi)throw Error(a(327));if(Nu(),e===Ii&&n===Ai||vu(e,n),null!==Fi){var r=Ji;Ji|=Oi;for(var o=bu();;)try{Eu();break}catch(t){gu(e,t)}if(ol(),Ji=r,Si.current=o,Ui===zi)throw t=Vi,vu(e,n),$u(e,n),pu(e),t;if(null===Fi)switch(o=e.finishedWork=e.current.alternate,e.finishedExpirationTime=n,r=Ui,Ii=null,r){case Ri:case zi:throw Error(a(345));case Li:Xu(e,2<n?2:n);break;case Di:if($u(e,n),n===(r=e.lastSuspendedTime)&&(e.nextKnownPendingLevel=Cu(o)),1073741823===Bi&&10<(o=$i+Ki-qo())){if(Hi){var l=e.lastPingedTime;if(0===l||l>=n){e.lastPingedTime=n,vu(e,n);break}}if(0!==(l=fu(e))&&l!==n)break;if(0!==r&&r!==n){e.lastPingedTime=r;break}e.timeoutHandle=En(Pu.bind(null,e),o);break}Pu(e);break;case Mi:if($u(e,n),n===(r=e.lastSuspendedTime)&&(e.nextKnownPendingLevel=Cu(o)),Hi&&(0===(o=e.lastPingedTime)||o>=n)){e.lastPingedTime=n,vu(e,n);break}if(0!==(o=fu(e))&&o!==n)break;if(0!==r&&r!==n){e.lastPingedTime=r;break}if(1073741823!==qi?r=10*(1073741821-qi)-qo():1073741823===Bi?r=0:(r=10*(1073741821-Bi)-5e3,0>(r=(o=qo())-r)&&(r=0),(n=10*(1073741821-n)-o)<(r=(120>r?120:480>r?480:1080>r?1080:1920>r?1920:3e3>r?3e3:4320>r?4320:1960*Ti(r/1960))-r)&&(r=n)),10<r){e.timeoutHandle=En(Pu.bind(null,e),r);break}Pu(e);break;case ji:if(1073741823!==Bi&&null!==Qi){l=Bi;var i=Qi;if(0>=(r=0|i.busyMinDurationMs)?r=0:(o=0|i.busyDelayMs,r=(l=qo()-(10*(1073741821-l)-(0|i.timeoutMs||5e3)))<=o?0:o+r-l),10<r){$u(e,n),e.timeoutHandle=En(Pu.bind(null,e),r);break}}Pu(e);break;default:throw Error(a(329))}if(pu(e),e.callbackNode===t)return du.bind(null,e)}}return null}function mu(e){var t=e.lastExpiredTime;if(t=0!==t?t:1073741823,(Ji&(Oi|Ni))!==Pi)throw Error(a(327));if(Nu(),e===Ii&&t===Ai||vu(e,t),null!==Fi){var n=Ji;Ji|=Oi;for(var r=bu();;)try{ku();break}catch(t){gu(e,t)}if(ol(),Ji=n,Si.current=r,Ui===zi)throw n=Vi,vu(e,t),$u(e,t),pu(e),n;if(null!==Fi)throw Error(a(261));e.finishedWork=e.current.alternate,e.finishedExpirationTime=t,Ii=null,Pu(e),pu(e)}return null}function hu(e,t){var n=Ji;Ji|=1;try{return e(t)}finally{(Ji=n)===Pi&&Xo()}}function yu(e,t){var n=Ji;Ji&=-2,Ji|=_i;try{return e(t)}finally{(Ji=n)===Pi&&Xo()}}function vu(e,t){e.finishedWork=null,e.finishedExpirationTime=0;var n=e.timeoutHandle;if(-1!==n&&(e.timeoutHandle=-1,Tn(n)),null!==Fi)for(n=Fi.return;null!==n;){var r=n;switch(r.tag){case 1:null!=(r=r.type.childContextTypes)&&xo();break;case 3:Jl(),po(vo),po(yo);break;case 5:Fl(r);break;case 4:Jl();break;case 13:case 19:po(Al);break;case 10:ll(r)}n=n.return}Ii=e,Fi=Uu(e.current,null),Ai=t,Ui=Ri,Vi=null,qi=Bi=1073741823,Qi=null,Wi=0,Hi=!1}function gu(e,t){for(;;){try{if(ol(),Bl.current=wa,Kl)for(var n=Wl.memoizedState;null!==n;){var r=n.queue;null!==r&&(r.pending=null),n=n.next}if(Ql=0,$l=Hl=Wl=null,Kl=!1,null===Fi||null===Fi.return)return Ui=zi,Vi=t,Fi=null;e:{var o=e,l=Fi.return,a=Fi,i=t;if(t=Ai,a.effectTag|=2048,a.firstEffect=a.lastEffect=null,null!==i&&"object"==typeof i&&"function"==typeof i.then){var u=i;if(!(2&a.mode)){var s=a.alternate;s?(a.updateQueue=s.updateQueue,a.memoizedState=s.memoizedState,a.expirationTime=s.expirationTime):(a.updateQueue=null,a.memoizedState=null)}var c=!!(1&Al.current),f=l;do{var p;if(p=13===f.tag){var d=f.memoizedState;if(null!==d)p=null!==d.dehydrated;else{var m=f.memoizedProps;p=void 0!==m.fallback&&(!0!==m.unstable_avoidThisFallback||!c)}}if(p){var h=f.updateQueue;if(null===h){var y=new Set;y.add(u),f.updateQueue=y}else h.add(u);if(!(2&f.mode)){if(f.effectTag|=64,a.effectTag&=-2981,1===a.tag)if(null===a.alternate)a.tag=17;else{var v=pl(1073741823,null);v.tag=2,dl(a,v)}a.expirationTime=1073741823;break e}i=void 0,a=t;var g=o.pingCache;if(null===g?(g=o.pingCache=new wi,i=new Set,g.set(u,i)):void 0===(i=g.get(u))&&(i=new Set,g.set(u,i)),!i.has(a)){i.add(a);var b=Du.bind(null,o,u,a);u.then(b,b)}f.effectTag|=4096,f.expirationTime=t;break e}f=f.return}while(null!==f);i=Error((ye(a.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+ve(a))}Ui!==ji&&(Ui=Li),i=ri(i,a),f=l;do{switch(f.tag){case 3:u=i,f.effectTag|=4096,f.expirationTime=t,ml(f,xi(f,u,t));break e;case 1:u=i;var w=f.type,x=f.stateNode;if(!(64&f.effectTag||"function"!=typeof w.getDerivedStateFromError&&(null===x||"function"!=typeof x.componentDidCatch||null!==Zi&&Zi.has(x)))){f.effectTag|=4096,f.expirationTime=t,ml(f,ki(f,u,t));break e}}f=f.return}while(null!==f)}Fi=Su(Fi)}catch(e){t=e;continue}break}}function bu(){var e=Si.current;return Si.current=wa,null===e?wa:e}function wu(e,t){e<Bi&&2<e&&(Bi=e),null!==t&&e<qi&&2<e&&(qi=e,Qi=t)}function xu(e){e>Wi&&(Wi=e)}function ku(){for(;null!==Fi;)Fi=Tu(Fi)}function Eu(){for(;null!==Fi&&!Io();)Fi=Tu(Fi)}function Tu(e){var t=Ei(e.alternate,e,Ai);return e.memoizedProps=e.pendingProps,null===t&&(t=Su(e)),Ci.current=null,t}function Su(e){Fi=e;do{var t=Fi.alternate;if(e=Fi.return,2048&Fi.effectTag){if(null!==(t=ni(Fi)))return t.effectTag&=2047,t;null!==e&&(e.firstEffect=e.lastEffect=null,e.effectTag|=2048)}else{if(t=ti(t,Fi,Ai),1===Ai||1!==Fi.childExpirationTime){for(var n=0,r=Fi.child;null!==r;){var o=r.expirationTime,l=r.childExpirationTime;o>n&&(n=o),l>n&&(n=l),r=r.sibling}Fi.childExpirationTime=n}if(null!==t)return t;null!==e&&!(2048&e.effectTag)&&(null===e.firstEffect&&(e.firstEffect=Fi.firstEffect),null!==Fi.lastEffect&&(null!==e.lastEffect&&(e.lastEffect.nextEffect=Fi.firstEffect),e.lastEffect=Fi.lastEffect),1<Fi.effectTag&&(null!==e.lastEffect?e.lastEffect.nextEffect=Fi:e.firstEffect=Fi,e.lastEffect=Fi))}if(null!==(t=Fi.sibling))return t;Fi=e}while(null!==Fi);return Ui===Ri&&(Ui=ji),null}function Cu(e){var t=e.expirationTime;return t>(e=e.childExpirationTime)?t:e}function Pu(e){var t=Qo();return Ho(99,_u.bind(null,e,t)),null}function _u(e,t){do{Nu()}while(null!==tu);if((Ji&(Oi|Ni))!==Pi)throw Error(a(327));var n=e.finishedWork,r=e.finishedExpirationTime;if(null===n)return null;if(e.finishedWork=null,e.finishedExpirationTime=0,n===e.current)throw Error(a(177));e.callbackNode=null,e.callbackExpirationTime=0,e.callbackPriority=90,e.nextKnownPendingLevel=0;var o=Cu(n);if(e.firstPendingTime=o,r<=e.lastSuspendedTime?e.firstSuspendedTime=e.lastSuspendedTime=e.nextKnownPendingLevel=0:r<=e.firstSuspendedTime&&(e.firstSuspendedTime=r-1),r<=e.lastPingedTime&&(e.lastPingedTime=0),r<=e.lastExpiredTime&&(e.lastExpiredTime=0),e===Ii&&(Fi=Ii=null,Ai=0),1<n.effectTag?null!==n.lastEffect?(n.lastEffect.nextEffect=n,o=n.firstEffect):o=n:o=n.firstEffect,null!==o){var l=Ji;Ji|=Ni,Ci.current=null,bn=Qt;var i=dn();if(mn(i)){if("selectionStart"in i)var u={start:i.selectionStart,end:i.selectionEnd};else e:{var s=(u=(u=i.ownerDocument)&&u.defaultView||window).getSelection&&u.getSelection();if(s&&0!==s.rangeCount){u=s.anchorNode;var c=s.anchorOffset,f=s.focusNode;s=s.focusOffset;try{u.nodeType,f.nodeType}catch(e){u=null;break e}var p=0,d=-1,m=-1,h=0,y=0,v=i,g=null;t:for(;;){for(var b;v!==u||0!==c&&3!==v.nodeType||(d=p+c),v!==f||0!==s&&3!==v.nodeType||(m=p+s),3===v.nodeType&&(p+=v.nodeValue.length),null!==(b=v.firstChild);)g=v,v=b;for(;;){if(v===i)break t;if(g===u&&++h===c&&(d=p),g===f&&++y===s&&(m=p),null!==(b=v.nextSibling))break;g=(v=g).parentNode}v=b}u=-1===d||-1===m?null:{start:d,end:m}}else u=null}u=u||{start:0,end:0}}else u=null;wn={activeElementDetached:null,focusedElem:i,selectionRange:u},Qt=!1,Xi=o;do{try{Ou()}catch(e){if(null===Xi)throw Error(a(330));Lu(Xi,e),Xi=Xi.nextEffect}}while(null!==Xi);Xi=o;do{try{for(i=e,u=t;null!==Xi;){var w=Xi.effectTag;if(16&w&&Fe(Xi.stateNode,""),128&w){var x=Xi.alternate;if(null!==x){var k=x.ref;null!==k&&("function"==typeof k?k(null):k.current=null)}}switch(1038&w){case 2:mi(Xi),Xi.effectTag&=-3;break;case 6:mi(Xi),Xi.effectTag&=-3,gi(Xi.alternate,Xi);break;case 1024:Xi.effectTag&=-1025;break;case 1028:Xi.effectTag&=-1025,gi(Xi.alternate,Xi);break;case 4:gi(Xi.alternate,Xi);break;case 8:vi(i,c=Xi,u),pi(c)}Xi=Xi.nextEffect}}catch(e){if(null===Xi)throw Error(a(330));Lu(Xi,e),Xi=Xi.nextEffect}}while(null!==Xi);if(k=wn,x=dn(),w=k.focusedElem,u=k.selectionRange,x!==w&&w&&w.ownerDocument&&pn(w.ownerDocument.documentElement,w)){null!==u&&mn(w)&&(x=u.start,void 0===(k=u.end)&&(k=x),"selectionStart"in w?(w.selectionStart=x,w.selectionEnd=Math.min(k,w.value.length)):(k=(x=w.ownerDocument||document)&&x.defaultView||window).getSelection&&(k=k.getSelection(),c=w.textContent.length,i=Math.min(u.start,c),u=void 0===u.end?i:Math.min(u.end,c),!k.extend&&i>u&&(c=u,u=i,i=c),c=fn(w,i),f=fn(w,u),c&&f&&(1!==k.rangeCount||k.anchorNode!==c.node||k.anchorOffset!==c.offset||k.focusNode!==f.node||k.focusOffset!==f.offset)&&((x=x.createRange()).setStart(c.node,c.offset),k.removeAllRanges(),i>u?(k.addRange(x),k.extend(f.node,f.offset)):(x.setEnd(f.node,f.offset),k.addRange(x))))),x=[];for(k=w;k=k.parentNode;)1===k.nodeType&&x.push({element:k,left:k.scrollLeft,top:k.scrollTop});for("function"==typeof w.focus&&w.focus(),w=0;w<x.length;w++)(k=x[w]).element.scrollLeft=k.left,k.element.scrollTop=k.top}Qt=!!bn,wn=bn=null,e.current=n,Xi=o;do{try{for(w=e;null!==Xi;){var E=Xi.effectTag;if(36&E&&ci(w,Xi.alternate,Xi),128&E){x=void 0;var T=Xi.ref;if(null!==T){var S=Xi.stateNode;Xi.tag,x=S,"function"==typeof T?T(x):T.current=x}}Xi=Xi.nextEffect}}catch(e){if(null===Xi)throw Error(a(330));Lu(Xi,e),Xi=Xi.nextEffect}}while(null!==Xi);Xi=null,Fo(),Ji=l}else e.current=n;if(eu)eu=!1,tu=e,nu=t;else for(Xi=o;null!==Xi;)t=Xi.nextEffect,Xi.nextEffect=null,Xi=t;if(0===(t=e.firstPendingTime)&&(Zi=null),1073741823===t?e===lu?ou++:(ou=0,lu=e):ou=0,"function"==typeof ju&&ju(n.stateNode,r),pu(e),Yi)throw Yi=!1,e=Gi,Gi=null,e;return(Ji&_i)!==Pi||Xo(),null}function Ou(){for(;null!==Xi;){var e=Xi.effectTag;256&e&&ii(Xi.alternate,Xi),!(512&e)||eu||(eu=!0,$o(97,(function(){return Nu(),null}))),Xi=Xi.nextEffect}}function Nu(){if(90!==nu){var e=97<nu?97:nu;return nu=90,Ho(e,Ru)}}function Ru(){if(null===tu)return!1;var e=tu;if(tu=null,(Ji&(Oi|Ni))!==Pi)throw Error(a(331));var t=Ji;for(Ji|=Ni,e=e.current.firstEffect;null!==e;){try{var n=e;if(512&n.effectTag)switch(n.tag){case 0:case 11:case 15:case 22:ui(5,n),si(5,n)}}catch(t){if(null===e)throw Error(a(330));Lu(e,t)}n=e.nextEffect,e.nextEffect=null,e=n}return Ji=t,Xo(),!0}function zu(e,t,n){dl(e,t=xi(e,t=ri(n,t),1073741823)),null!==(e=cu(e,1073741823))&&pu(e)}function Lu(e,t){if(3===e.tag)zu(e,e,t);else for(var n=e.return;null!==n;){if(3===n.tag){zu(n,e,t);break}if(1===n.tag){var r=n.stateNode;if("function"==typeof n.type.getDerivedStateFromError||"function"==typeof r.componentDidCatch&&(null===Zi||!Zi.has(r))){dl(n,e=ki(n,e=ri(t,e),1073741823)),null!==(n=cu(n,1073741823))&&pu(n);break}}n=n.return}}function Du(e,t,n){var r=e.pingCache;null!==r&&r.delete(t),Ii===e&&Ai===n?Ui===Mi||Ui===Di&&1073741823===Bi&&qo()-$i<Ki?vu(e,Ai):Hi=!0:Hu(e,n)&&(0!==(t=e.lastPingedTime)&&t<n||(e.lastPingedTime=n,pu(e)))}function Mu(e,t){var n=e.stateNode;null!==n&&n.delete(t),0==(t=0)&&(t=uu(t=iu(),e,null)),null!==(e=cu(e,t))&&pu(e)}Ei=function(e,t,n){var r=t.expirationTime;if(null!==e){var o=t.pendingProps;if(e.memoizedProps!==o||vo.current)Da=!0;else{if(r<n){switch(Da=!1,t.tag){case 3:Ba(t),za();break;case 5:if(Il(t),4&t.mode&&1!==n&&o.hidden)return t.expirationTime=t.childExpirationTime=1,null;break;case 1:wo(t.type)&&To(t);break;case 4:jl(t,t.stateNode.containerInfo);break;case 10:r=t.memoizedProps.value,o=t.type._context,mo(el,o._currentValue),o._currentValue=r;break;case 13:if(null!==t.memoizedState)return 0!==(r=t.child.childExpirationTime)&&r>=n?Ka(e,t,n):(mo(Al,1&Al.current),null!==(t=Za(e,t,n))?t.sibling:null);mo(Al,1&Al.current);break;case 19:if(r=t.childExpirationTime>=n,64&e.effectTag){if(r)return Ga(e,t,n);t.effectTag|=64}if(null!==(o=t.memoizedState)&&(o.rendering=null,o.tail=null),mo(Al,Al.current),!r)return null}return Za(e,t,n)}Da=!1}}else Da=!1;switch(t.expirationTime=0,t.tag){case 2:if(r=t.type,null!==e&&(e.alternate=null,t.alternate=null,t.effectTag|=2),e=t.pendingProps,o=bo(t,yo.current),il(t,n),o=Gl(null,t,r,e,o,n),t.effectTag|=1,"object"==typeof o&&null!==o&&"function"==typeof o.render&&void 0===o.$$typeof){if(t.tag=1,t.memoizedState=null,t.updateQueue=null,wo(r)){var l=!0;To(t)}else l=!1;t.memoizedState=null!==o.state&&void 0!==o.state?o.state:null,cl(t);var i=r.getDerivedStateFromProps;"function"==typeof i&&bl(t,r,i,e),o.updater=wl,t.stateNode=o,o._reactInternalFiber=t,Tl(t,r,e,n),t=Va(null,t,r,!0,l,n)}else t.tag=0,Ma(null,t,o,n),t=t.child;return t;case 16:e:{if(o=t.elementType,null!==e&&(e.alternate=null,t.alternate=null,t.effectTag|=2),e=t.pendingProps,function(e){if(-1===e._status){e._status=0;var t=e._ctor;t=t(),e._result=t,t.then((function(t){0===e._status&&(t=t.default,e._status=1,e._result=t)}),(function(t){0===e._status&&(e._status=2,e._result=t)}))}}(o),1!==o._status)throw o._result;switch(o=o._result,t.type=o,l=t.tag=function(e){if("function"==typeof e)return Au(e)?1:0;if(null!=e){if((e=e.$$typeof)===ue)return 11;if(e===fe)return 14}return 2}(o),e=Zo(o,e),l){case 0:t=Aa(null,t,o,e,n);break e;case 1:t=Ua(null,t,o,e,n);break e;case 11:t=ja(null,t,o,e,n);break e;case 14:t=Ja(null,t,o,Zo(o.type,e),r,n);break e}throw Error(a(306,o,""))}return t;case 0:return r=t.type,o=t.pendingProps,Aa(e,t,r,o=t.elementType===r?o:Zo(r,o),n);case 1:return r=t.type,o=t.pendingProps,Ua(e,t,r,o=t.elementType===r?o:Zo(r,o),n);case 3:if(Ba(t),r=t.updateQueue,null===e||null===r)throw Error(a(282));if(r=t.pendingProps,o=null!==(o=t.memoizedState)?o.element:null,fl(e,t),hl(t,r,null,n),(r=t.memoizedState.element)===o)za(),t=Za(e,t,n);else{if((o=t.stateNode.hydrate)&&(Sa=Sn(t.stateNode.containerInfo.firstChild),Ta=t,o=Ca=!0),o)for(n=Nl(t,null,r,n),t.child=n;n;)n.effectTag=-3&n.effectTag|1024,n=n.sibling;else Ma(e,t,r,n),za();t=t.child}return t;case 5:return Il(t),null===e&&Oa(t),r=t.type,o=t.pendingProps,l=null!==e?e.memoizedProps:null,i=o.children,kn(r,o)?i=null:null!==l&&kn(r,l)&&(t.effectTag|=16),Fa(e,t),4&t.mode&&1!==n&&o.hidden?(t.expirationTime=t.childExpirationTime=1,t=null):(Ma(e,t,i,n),t=t.child),t;case 6:return null===e&&Oa(t),null;case 13:return Ka(e,t,n);case 4:return jl(t,t.stateNode.containerInfo),r=t.pendingProps,null===e?t.child=Ol(t,null,r,n):Ma(e,t,r,n),t.child;case 11:return r=t.type,o=t.pendingProps,ja(e,t,r,o=t.elementType===r?o:Zo(r,o),n);case 7:return Ma(e,t,t.pendingProps,n),t.child;case 8:case 12:return Ma(e,t,t.pendingProps.children,n),t.child;case 10:e:{r=t.type._context,o=t.pendingProps,i=t.memoizedProps,l=o.value;var u=t.type._context;if(mo(el,u._currentValue),u._currentValue=l,null!==i)if(u=i.value,0==(l=Ur(u,l)?0:0|("function"==typeof r._calculateChangedBits?r._calculateChangedBits(u,l):1073741823))){if(i.children===o.children&&!vo.current){t=Za(e,t,n);break e}}else for(null!==(u=t.child)&&(u.return=t);null!==u;){var s=u.dependencies;if(null!==s){i=u.child;for(var c=s.firstContext;null!==c;){if(c.context===r&&0!==(c.observedBits&l)){1===u.tag&&((c=pl(n,null)).tag=2,dl(u,c)),u.expirationTime<n&&(u.expirationTime=n),null!==(c=u.alternate)&&c.expirationTime<n&&(c.expirationTime=n),al(u.return,n),s.expirationTime<n&&(s.expirationTime=n);break}c=c.next}}else i=10===u.tag&&u.type===t.type?null:u.child;if(null!==i)i.return=u;else for(i=u;null!==i;){if(i===t){i=null;break}if(null!==(u=i.sibling)){u.return=i.return,i=u;break}i=i.return}u=i}Ma(e,t,o.children,n),t=t.child}return t;case 9:return o=t.type,r=(l=t.pendingProps).children,il(t,n),r=r(o=ul(o,l.unstable_observedBits)),t.effectTag|=1,Ma(e,t,r,n),t.child;case 14:return l=Zo(o=t.type,t.pendingProps),Ja(e,t,o,l=Zo(o.type,l),r,n);case 15:return Ia(e,t,t.type,t.pendingProps,r,n);case 17:return r=t.type,o=t.pendingProps,o=t.elementType===r?o:Zo(r,o),null!==e&&(e.alternate=null,t.alternate=null,t.effectTag|=2),t.tag=1,wo(r)?(e=!0,To(t)):e=!1,il(t,n),kl(t,r,o),Tl(t,r,o,n),Va(null,t,r,!0,e,n);case 19:return Ga(e,t,n)}throw Error(a(156,t.tag))};var ju=null,Ju=null;function Iu(e,t,n,r){this.tag=e,this.key=n,this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null,this.index=0,this.ref=null,this.pendingProps=t,this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null,this.mode=r,this.effectTag=0,this.lastEffect=this.firstEffect=this.nextEffect=null,this.childExpirationTime=this.expirationTime=0,this.alternate=null}function Fu(e,t,n,r){return new Iu(e,t,n,r)}function Au(e){return!(!(e=e.prototype)||!e.isReactComponent)}function Uu(e,t){var n=e.alternate;return null===n?((n=Fu(e.tag,t,e.key,e.mode)).elementType=e.elementType,n.type=e.type,n.stateNode=e.stateNode,n.alternate=e,e.alternate=n):(n.pendingProps=t,n.effectTag=0,n.nextEffect=null,n.firstEffect=null,n.lastEffect=null),n.childExpirationTime=e.childExpirationTime,n.expirationTime=e.expirationTime,n.child=e.child,n.memoizedProps=e.memoizedProps,n.memoizedState=e.memoizedState,n.updateQueue=e.updateQueue,t=e.dependencies,n.dependencies=null===t?null:{expirationTime:t.expirationTime,firstContext:t.firstContext,responders:t.responders},n.sibling=e.sibling,n.index=e.index,n.ref=e.ref,n}function Vu(e,t,n,r,o,l){var i=2;if(r=e,"function"==typeof e)Au(e)&&(i=1);else if("string"==typeof e)i=5;else e:switch(e){case ne:return Bu(n.children,o,l,t);case ie:i=8,o|=7;break;case re:i=8,o|=1;break;case oe:return(e=Fu(12,n,t,8|o)).elementType=oe,e.type=oe,e.expirationTime=l,e;case se:return(e=Fu(13,n,t,o)).type=se,e.elementType=se,e.expirationTime=l,e;case ce:return(e=Fu(19,n,t,o)).elementType=ce,e.expirationTime=l,e;default:if("object"==typeof e&&null!==e)switch(e.$$typeof){case le:i=10;break e;case ae:i=9;break e;case ue:i=11;break e;case fe:i=14;break e;case pe:i=16,r=null;break e;case de:i=22;break e}throw Error(a(130,null==e?e:typeof e,""))}return(t=Fu(i,n,t,o)).elementType=e,t.type=r,t.expirationTime=l,t}function Bu(e,t,n,r){return(e=Fu(7,e,r,t)).expirationTime=n,e}function qu(e,t,n){return(e=Fu(6,e,null,t)).expirationTime=n,e}function Qu(e,t,n){return(t=Fu(4,null!==e.children?e.children:[],e.key,t)).expirationTime=n,t.stateNode={containerInfo:e.containerInfo,pendingChildren:null,implementation:e.implementation},t}function Wu(e,t,n){this.tag=t,this.current=null,this.containerInfo=e,this.pingCache=this.pendingChildren=null,this.finishedExpirationTime=0,this.finishedWork=null,this.timeoutHandle=-1,this.pendingContext=this.context=null,this.hydrate=n,this.callbackNode=null,this.callbackPriority=90,this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}function Hu(e,t){var n=e.firstSuspendedTime;return e=e.lastSuspendedTime,0!==n&&n>=t&&e<=t}function $u(e,t){var n=e.firstSuspendedTime,r=e.lastSuspendedTime;n<t&&(e.firstSuspendedTime=t),(r>t||0===n)&&(e.lastSuspendedTime=t),t<=e.lastPingedTime&&(e.lastPingedTime=0),t<=e.lastExpiredTime&&(e.lastExpiredTime=0)}function Ku(e,t){t>e.firstPendingTime&&(e.firstPendingTime=t);var n=e.firstSuspendedTime;0!==n&&(t>=n?e.firstSuspendedTime=e.lastSuspendedTime=e.nextKnownPendingLevel=0:t>=e.lastSuspendedTime&&(e.lastSuspendedTime=t+1),t>e.nextKnownPendingLevel&&(e.nextKnownPendingLevel=t))}function Xu(e,t){var n=e.lastExpiredTime;(0===n||n>t)&&(e.lastExpiredTime=t)}function Yu(e,t,n,r){var o=t.current,l=iu(),i=vl.suspense;l=uu(l,o,i);e:if(n){t:{if(Ge(n=n._reactInternalFiber)!==n||1!==n.tag)throw Error(a(170));var u=n;do{switch(u.tag){case 3:u=u.stateNode.context;break t;case 1:if(wo(u.type)){u=u.stateNode.__reactInternalMemoizedMergedChildContext;break t}}u=u.return}while(null!==u);throw Error(a(171))}if(1===n.tag){var s=n.type;if(wo(s)){n=Eo(n,s,u);break e}}n=u}else n=ho;return null===t.context?t.context=n:t.pendingContext=n,(t=pl(l,i)).payload={element:e},null!==(r=void 0===r?null:r)&&(t.callback=r),dl(o,t),su(o,l),l}function Gu(e){return(e=e.current).child?(e.child.tag,e.child.stateNode):null}function Zu(e,t){null!==(e=e.memoizedState)&&null!==e.dehydrated&&e.retryTime<t&&(e.retryTime=t)}function es(e,t){Zu(e,t),(e=e.alternate)&&Zu(e,t)}function ts(e,t,n){var r=new Wu(e,t,n=null!=n&&!0===n.hydrate),o=Fu(3,null,null,2===t?7:1===t?3:0);r.current=o,o.stateNode=r,cl(o),e[Nn]=r.current,n&&0!==t&&function(e,t){var n=Ye(t);St.forEach((function(e){dt(e,t,n)})),Ct.forEach((function(e){dt(e,t,n)}))}(0,9===e.nodeType?e:e.ownerDocument),this._internalRoot=r}function ns(e){return!(!e||1!==e.nodeType&&9!==e.nodeType&&11!==e.nodeType&&(8!==e.nodeType||" react-mount-point-unstable "!==e.nodeValue))}function rs(e,t,n,r,o){var l=n._reactRootContainer;if(l){var a=l._internalRoot;if("function"==typeof o){var i=o;o=function(){var e=Gu(a);i.call(e)}}Yu(t,a,e,o)}else{if(l=n._reactRootContainer=function(e,t){if(t||(t=!(!(t=e?9===e.nodeType?e.documentElement:e.firstChild:null)||1!==t.nodeType||!t.hasAttribute("data-reactroot"))),!t)for(var n;n=e.lastChild;)e.removeChild(n);return new ts(e,0,t?{hydrate:!0}:void 0)}(n,r),a=l._internalRoot,"function"==typeof o){var u=o;o=function(){var e=Gu(a);u.call(e)}}yu((function(){Yu(t,a,e,o)}))}return Gu(a)}function os(e,t){var n=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!ns(t))throw Error(a(200));return function(e,t,n){var r=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:te,key:null==r?null:""+r,children:e,containerInfo:t,implementation:n}}(e,t,null,n)}ts.prototype.render=function(e){Yu(e,this._internalRoot,null,null)},ts.prototype.unmount=function(){var e=this._internalRoot,t=e.containerInfo;Yu(null,e,null,(function(){t[Nn]=null}))},mt=function(e){if(13===e.tag){var t=Go(iu(),150,100);su(e,t),es(e,t)}},ht=function(e){13===e.tag&&(su(e,3),es(e,3))},yt=function(e){if(13===e.tag){var t=iu();su(e,t=uu(t,e,null)),es(e,t)}},_=function(e,t,n){switch(t){case"input":if(Se(e,n),t=n.name,"radio"===n.type&&null!=t){for(n=e;n.parentNode;)n=n.parentNode;for(n=n.querySelectorAll("input[name="+JSON.stringify(""+t)+'][type="radio"]'),t=0;t<n.length;t++){var r=n[t];if(r!==e&&r.form===e.form){var o=Dn(r);if(!o)throw Error(a(90));xe(r),Se(r,o)}}}break;case"textarea":ze(e,n);break;case"select":null!=(t=n.value)&&Oe(e,!!n.multiple,t,!1)}},D=hu,M=function(e,t,n,r,o){var l=Ji;Ji|=4;try{return Ho(98,e.bind(null,t,n,r,o))}finally{(Ji=l)===Pi&&Xo()}},j=function(){(Ji&(1|Oi|Ni))===Pi&&(function(){if(null!==ru){var e=ru;ru=null,e.forEach((function(e,t){Xu(t,e),pu(t)})),Xo()}}(),Nu())},J=function(e,t){var n=Ji;Ji|=2;try{return e(t)}finally{(Ji=n)===Pi&&Xo()}};var ls={Events:[zn,Ln,Dn,C,E,Un,function(e){rt(e,An)},z,L,Xt,at,Nu,{current:!1}]};!function(e){var t=e.findFiberByHostInstance;!function(e){if("undefined"==typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var t=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(t.isDisabled||!t.supportsFiber)return!0;try{var n=t.inject(e);ju=function(e){try{t.onCommitFiberRoot(n,e,void 0,!(64&~e.current.effectTag))}catch(e){}},Ju=function(e){try{t.onCommitFiberUnmount(n,e)}catch(e){}}}catch(e){}}(o({},e,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:X.ReactCurrentDispatcher,findHostInstanceByFiber:function(e){return null===(e=tt(e))?null:e.stateNode},findFiberByHostInstance:function(e){return t?t(e):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))}({findFiberByHostInstance:Rn,bundleType:0,version:"16.14.0",rendererPackageName:"react-dom"}),t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ls,t.createPortal=os,t.findDOMNode=function(e){if(null==e)return null;if(1===e.nodeType)return e;var t=e._reactInternalFiber;if(void 0===t){if("function"==typeof e.render)throw Error(a(188));throw Error(a(268,Object.keys(e)))}return null===(e=tt(t))?null:e.stateNode},t.flushSync=function(e,t){if((Ji&(Oi|Ni))!==Pi)throw Error(a(187));var n=Ji;Ji|=1;try{return Ho(99,e.bind(null,t))}finally{Ji=n,Xo()}},t.hydrate=function(e,t,n){if(!ns(t))throw Error(a(200));return rs(null,e,t,!0,n)},t.render=function(e,t,n){if(!ns(t))throw Error(a(200));return rs(null,e,t,!1,n)},t.unmountComponentAtNode=function(e){if(!ns(e))throw Error(a(40));return!!e._reactRootContainer&&(yu((function(){rs(null,null,e,!1,(function(){e._reactRootContainer=null,e[Nn]=null}))})),!0)},t.unstable_batchedUpdates=hu,t.unstable_createPortal=function(e,t){return os(e,t,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)},t.unstable_renderSubtreeIntoContainer=function(e,t,n,r){if(!ns(n))throw Error(a(200));if(null==e||void 0===e._reactInternalFiber)throw Error(a(38));return rs(e,t,n,!1,r)},t.version="16.14.0"},765:e=>{e.exports=function(e){var t=[];return t.toString=function(){return this.map((function(t){var n=function(e,t){var n,r=e[1]||"",o=e[3];if(!o)return r;if(t&&"function"==typeof btoa){var l=(n=o,"/*# sourceMappingURL=data:application/json;charset=utf-8;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(n))))+" */"),a=o.sources.map((function(e){return"/*# sourceURL="+o.sourceRoot+e+" */"}));return[r].concat(a).concat([l]).join("\n")}return[r].join("\n")}(t,e);return t[2]?"@media "+t[2]+"{"+n+"}":n})).join("")},t.i=function(e,n){"string"==typeof e&&(e=[[null,e,""]]);for(var r={},o=0;o<this.length;o++){var l=this[o][0];"number"==typeof l&&(r[l]=!0)}for(o=0;o<e.length;o++){var a=e[o];"number"==typeof a[0]&&r[a[0]]||(n&&!a[2]?a[2]=n:n&&(a[2]="("+a[2]+") and ("+n+")"),t.push(a))}},t}},961:(e,t,n)=>{"use strict";!function e(){if("undefined"!=typeof __REACT_DEVTOOLS_GLOBAL_HOOK__&&"function"==typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE)try{__REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(e)}catch(e){console.error(e)}}(),e.exports=n(551)},982:(e,t,n)=>{"use strict";e.exports=n(463)}},t={};function n(r){var o=t[r];if(void 0!==o)return o.exports;var l=t[r]={id:r,exports:{}};return e[r](l,l.exports,n),l.exports}n.n=e=>{var t=e&&e.__esModule?()=>e.default:()=>e;return n.d(t,{a:t}),t},n.d=(e,t)=>{for(var r in t)n.o(t,r)&&!n.o(e,r)&&Object.defineProperty(e,r,{enumerable:!0,get:t[r]})},n.o=(e,t)=>Object.prototype.hasOwnProperty.call(e,t),n.r=e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.nc=void 0;var r={};return(()=>{"use strict";n.r(r),n.d(r,{quoteForm:()=>ae});var e=n(540),t=n(961);function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function l(e){return l="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},l(e)}function a(e){var t=function(e){if("object"!=l(e)||!e)return e;var t=e[Symbol.toPrimitive];if(void 0!==t){var n=t.call(e,"string");if("object"!=l(n))return n;throw new TypeError("@@toPrimitive must return a primitive value.")}return String(e)}(e);return"symbol"==l(t)?t:t+""}function i(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,a(r.key),r)}}function u(e,t,n){return t&&i(e.prototype,t),n&&i(e,n),Object.defineProperty(e,"prototype",{writable:!1}),e}function s(e,t){if(t&&("object"==l(t)||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e)}function c(e){return c=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(e){return e.__proto__||Object.getPrototypeOf(e)},c(e)}function f(e,t){return f=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(e,t){return e.__proto__=t,e},f(e,t)}function p(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),Object.defineProperty(e,"prototype",{writable:!1}),t&&f(e,t)}function d(e,t,n){return(t=a(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}var m=n(72),h=n.n(m),y=n(270),v=n.n(y);function g(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function b(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?g(Object(n),!0).forEach((function(t){d(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):g(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function w(){try{var e=!Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){})))}catch(e){}return(w=function(){return!!e})()}h()(v(),{insert:"head",singleton:!1}),v().locals;const x=function(t){function n(e){var t,r,l,a;return o(this,n),r=this,l=c(l=n),d(t=s(r,w()?Reflect.construct(l,[],c(r).constructor):l.apply(r,a)),"state",{text:"",id:""}),d(t,"counter",0),d(t,"getCounter",(function(){return t.counter++})),t.state.text=e.formJson.value||"",t.state.connector="list_"+Math.random().toString(36).substring(9),e.addToResult(e.formJson.name,""),t}return p(n,t),u(n,[{key:"changeValue",value:function(e){var t=this;this.setState(b(b({},this.state),{},{text:e.target.value}),(function(){t.props.addToResult(t.props.formJson.name,t.state.text)}))}},{key:"render",value:function(){var t=this;return e.createElement("div",{className:"form-group"},e.createElement("label",{className:"mainLabel inputLabel"},e.createElement("span",null,this.props.formJson.label,this.props.formJson.required?e.createElement("span",{className:"required"},"*"):""),e.createElement("input",{className:this.props.formJson.class||"form-control",required:this.props.formJson.required,type:this.props.formJson.type||"text",onChange:function(e){return t.changeValue(e)},value:this.state.text,name:this.props.formJson.name,placeholder:this.props.formJson.placeholder,minLength:this.props.formJson.min_length,maxLength:this.props.formJson.max_length,list:this.state.connector}),e.createElement("datalist",{id:this.state.connector},this.props.formJson.options.map((function(n){return e.createElement("option",{key:t.getCounter(),value:n.value},n.label)}))),this.props.formJson.sufix),this.props.formJson.tipText?e.createElement("p",null,this.props.formJson.tipText):"")}}])}(e.Component);function k(){try{var e=!Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){})))}catch(e){}return(k=function(){return!!e})()}const E=function(t){function n(){return o(this,n),e=this,r=arguments,t=c(t=n),s(e,k()?Reflect.construct(t,r||[],c(e).constructor):t.apply(e,r));var e,t,r}return p(n,t),u(n,[{key:"render",value:function(){return e.createElement("button",{type:this.props.formJson.type,className:this.props.formJson.class||"form-control"},this.props.formJson.label)}}])}(e.Component);function T(){try{var e=!Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){})))}catch(e){}return(T=function(){return!!e})()}const S=function(t){function n(e){var t,r,l,a;return o(this,n),r=this,l=c(l=n),d(t=s(r,T()?Reflect.construct(l,[],c(r).constructor):l.apply(r,a)),"state",{text:"",id:""}),e.formJson.defaultSelected?t.state.text=!0:t.state.text=!1,e.addToResult(e.formJson.name,t.state.text),t}return p(n,t),u(n,[{key:"changeValue",value:function(e){this.props.addToResult(this.props.formJson.name,e.target.checked)}},{key:"render",value:function(){var t=this;return e.createElement("div",{className:"form-group"},e.createElement("label",{className:"mainLabel inputLabel"},e.createElement("span",{className:"formLabel"},this.props.formJson.label,this.props.formJson.required?e.createElement("span",{className:"required"},"*"):""),e.createElement("input",{type:"checkbox",readOnly:this.props.readOnly,required:this.props.formJson.required,defaultChecked:null==this.props.formJson.value?this.props.formJson.defaultSelected:this.props.formJson.value,onChange:function(e){t.changeValue(e)},name:this.props.formJson.name}),this.props.formJson.sufix),this.props.formJson.tipText?e.createElement("p",null,this.props.formJson.tipText):"")}}])}(e.Component);function C(){try{var e=!Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){})))}catch(e){}return(C=function(){return!!e})()}const P=function(t){function n(t){var r,l,a,i;return o(this,n),l=this,a=c(a=n),d(r=s(l,C()?Reflect.construct(a,[],c(l).constructor):a.apply(l,i)),"state",{text:""}),r.state.text=t.formJson.value||"",t.addToResult(t.formJson.name,r.state.text),r.fileInput=e.createRef(),r}return p(n,t),u(n,[{key:"changeValue",value:function(e){var t=this;this.setState({text:e.target.value},(function(){t.props.addToResult(t.props.formJson.name,t.fileInput.current.files)}))}},{key:"render",value:function(){var t=this;return e.createElement("div",{className:"form-group"},e.createElement("label",{className:"mainLabel inputLabel"},e.createElement("span",null,this.props.formJson.label,this.props.formJson.required?e.createElement("span",{className:"required"},"*"):""),e.createElement("input",{ref:this.fileInput,type:"file",className:"custom-file-input",id:"validatedCustomFile",onChange:function(e){return t.changeValue(e)}}),e.createElement("input",{className:this.props.formJson.class||"form-control",type:this.props.formJson.type||"text",onChange:function(e){return t.changeValue(e)},value:this.state.text,name:this.props.formJson.name,placeholder:this.props.formJson.placeholder,minLength:this.props.formJson.min_length,maxLength:this.props.formJson.max_length}),this.props.formJson.sufix),this.props.formJson.tipText?e.createElement("p",null,this.props.formJson.tipText):"")}}])}(e.Component);function _(){try{var e=!Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){})))}catch(e){}return(_=function(){return!!e})()}const O=function(t){function n(e){return o(this,n),t=this,r=c(r=n),s(t,_()?Reflect.construct(r,[],c(t).constructor):r.apply(t,l));var t,r,l}return p(n,t),u(n,[{key:"render",value:function(){var t=this;return e.createElement("div",{className:this.props.formJson.class+" type_"+this.props.formJson.headerlevel},function(){switch(t.props.formJson.headerlevel){case"h1":return e.createElement("h1",null,t.props.formJson.headertext);case"h2":return e.createElement("h2",null,t.props.formJson.headertext);case"h3":return e.createElement("h3",null,t.props.formJson.headertext);case"h4":return e.createElement("h4",null,t.props.formJson.headertext);case"h5":return e.createElement("h5",null,t.props.formJson.headertext);case"h6":return e.createElement("h6",null,t.props.formJson.headertext)}}())}}])}(e.Component);function N(){try{var e=!Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){})))}catch(e){}return(N=function(){return!!e})()}const R=function(t){function n(e){var t,r,l,a;return o(this,n),r=this,l=c(l=n),d(t=s(r,N()?Reflect.construct(l,[],c(r).constructor):l.apply(r,a)),"state",{text:""}),t.state.text=e.formJson.value||"",e.addToResult(e.formJson.name,t.state.text),t}return p(n,t),u(n,[{key:"changeValue",value:function(e){var t=this;this.setState({text:e.target.value},(function(){t.props.addToResult(t.props.formJson.name,t.state.text)}))}},{key:"render",value:function(){var t=this;return e.createElement("div",{className:"form-group"},e.createElement("input",{type:"hidden",onChange:function(e){return t.changeValue(e)},value:this.state.text,name:this.props.formJson.name}))}}])}(e.Component);function z(){try{var e=!Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){})))}catch(e){}return(z=function(){return!!e})()}const L=function(t){function n(e){var t,r,l,a;return o(this,n),r=this,l=c(l=n),d(t=s(r,z()?Reflect.construct(l,[],c(r).constructor):l.apply(r,a)),"state",{text:""}),t.state.text=e.formJson.value||"",e.addToResult(e.formJson.name,t.state.text),t}return p(n,t),u(n,[{key:"changeValue",value:function(e){var t=this;this.setState({text:e.target.value},(function(){t.props.addToResult(t.props.formJson.name,t.state.text)}))}},{key:"render",value:function(){var t=this;return e.createElement("div",{className:"form-group"},e.createElement("label",{className:"mainLabel inputLabel"},e.createElement("span",{className:"formLabel"},this.props.formJson.label,this.props.formJson.required?e.createElement("span",{className:"required"},"*"):""),e.createElement("input",{className:this.props.formJson.class||"form-control",readOnly:this.props.readonly,required:this.props.formJson.required,type:this.props.formJson.type||"text",onChange:function(e){return t.changeValue(e)},value:this.state.text,name:this.props.formJson.name,placeholder:this.props.formJson.placeholder,minLength:this.props.formJson.min_length,maxLength:this.props.formJson.max_length}),this.props.formJson.sufix),this.props.formJson.tipText?e.createElement("p",null,this.props.formJson.tipText):"")}}])}(e.Component);function D(){try{var e=!Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){})))}catch(e){}return(D=function(){return!!e})()}const M=function(t){function n(e){var t,r,l,a;return o(this,n),r=this,l=c(l=n),d(t=s(r,D()?Reflect.construct(l,[],c(r).constructor):l.apply(r,a)),"state",{text:""}),t.state.text=e.formJson.value||"",e.addToResult(e.formJson.name,t.state.text),t}return p(n,t),u(n,[{key:"changeValue",value:function(e){var t=this;this.setState({text:e.target.value},(function(){t.props.addToResult(t.props.formJson.name,t.state.text)}))}},{key:"render",value:function(){var t=this;return e.createElement("div",{className:"form-group"},e.createElement("label",{className:"mainLabel inputLabel"},e.createElement("span",{className:"formLabel"},this.props.formJson.label,this.props.formJson.required?e.createElement("span",{className:"required"},"*"):""),e.createElement("input",{className:this.props.formJson.class||"form-control",required:this.props.formJson.required,type:"number",onChange:function(e){return t.changeValue(e)},value:this.state.text,name:this.props.formJson.name,placeholder:this.props.formJson.placeholder,step:this.props.formJson.step,min:this.props.formJson.min_value,max:this.props.formJson.max_value}),this.props.formJson.sufix),this.props.formJson.tipText?e.createElement("p",null,this.props.formJson.tipText):"")}}])}(e.Component);function j(){try{var e=!Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){})))}catch(e){}return(j=function(){return!!e})()}const J=function(t){function n(e){return o(this,n),t=this,r=c(r=n),s(t,j()?Reflect.construct(r,[],c(t).constructor):r.apply(t,l));var t,r,l}return p(n,t),u(n,[{key:"render",value:function(){return e.createElement("div",{className:this.props.formJson.class||"form-group"},e.createElement("p",null,this.props.formJson.content))}}])}(e.Component);function I(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=Array(t);n<t;n++)r[n]=e[n];return r}function F(e){return function(e){if(Array.isArray(e))return I(e)}(e)||function(e){if("undefined"!=typeof Symbol&&null!=e[Symbol.iterator]||null!=e["@@iterator"])return Array.from(e)}(e)||function(e,t){if(e){if("string"==typeof e)return I(e,t);var n={}.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?I(e,t):void 0}}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}var A=function(){function e(){}return e._=function(e,t){return window.T._(e,t)},e}();function U(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function V(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?U(Object(n),!0).forEach((function(t){d(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):U(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function B(){try{var e=!Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){})))}catch(e){}return(B=function(){return!!e})()}(function(){function e(){}e.padLeft=function(e,t,n){for(var r=e.toString(),o=0;o<t-r.length;o++)r=n+r;return r},e.padRight=function(e,t,n){for(var r=e.toString(),o=0;o<t-r.length;o++)r+=n;return r},e.format=function(e){for(var t=[],n=1;n<arguments.length;n++)t[n-1]=arguments[n];return t.reduce((function(e,t,n){return e.replace("{".concat(n,"}"),t)}),e)}})(),function(){function e(){}e.EMAIL_REGEX=/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,e.NFT_WALLET_ADDRESS_REGEX=/^0x[a-fA-F0-9]{40}$/,e.checkEmail=function(t){return e.EMAIL_REGEX.test(t)},e.checkNFTWalletAddress=function(t){return e.NFT_WALLET_ADDRESS_REGEX.test(t)}}();const q=function(t){function n(e){var t,r,l,a;return o(this,n),r=this,l=c(l=n),d(t=s(r,B()?Reflect.construct(l,[],c(r).constructor):l.apply(r,a)),"state",{details:[],counter:2}),d(t,"getCounter",(function(){return t.state.counter++})),t.state.details=e.formJson.value||[{pos:1,quantity:"",description:""}],t.state.counter=t.state.details.length+1,e.addToResult(e.formJson.name,t.state.details),t}return p(n,t),u(n,[{key:"addQuoteDetail",value:function(e){var t=this.getCounter();this.setState(V(V({},this.state),{},{details:[].concat(F(this.state.details),[{pos:t,quantity:"",description:""}])}))}},{key:"removeQuoteDetail",value:function(e){var t=this;this.setState(V(V({},this.state),{},{details:F(this.state.details.filter((function(t){return t.pos!=e.pos})))}),(function(){t.props.addToResult(t.props.formJson.name,t.state.details)}))}},{key:"render",value:function(){var t=this;return e.createElement("div",{className:"form-group"},e.createElement("h4",null,A._("Line items","Admin")),e.createElement("span",{className:"mainLabel inputLabel"},this.props.formJson.required?e.createElement("span",{className:"required"},"*"):"",e.createElement("div",{className:"quote-details"},e.createElement("ul",{id:"ul-details"},this.state.details.map((function(n,r){return e.createElement("li",{className:"row",key:n.pos},e.createElement("label",null,e.createElement("div",null,e.createElement("span",{className:"formLabel"},A._("Quantity","Admin")),e.createElement("input",{readOnly:t.props.readonly,type:"number",placeholder:A._("Quantity","Admin"),className:"form-control",value:n.quantity,onChange:function(e){t.setState(V(V({},t.state),{},{details:F(t.state.details.map((function(t){return t.pos==n.pos&&(t.quantity=e.target.value),t})))}),(function(){t.props.addToResult(t.props.formJson.name,t.state.details)}))}}))),e.createElement("label",null,e.createElement("div",null,e.createElement("span",{className:"formLabel"},A._("Details","Admin")),e.createElement("input",{readOnly:t.props.readonly,type:"text",placeholder:A._("Product variation","Admin"),className:"form-control",value:n.description,onChange:function(e){t.setState(V(V({},t.state),{},{details:F(t.state.details.map((function(t){return t.pos==n.pos&&(t.description=e.target.value),t})))}),(function(){t.props.addToResult(t.props.formJson.name,t.state.details)}))}})),n.pos>1&&!t.props.readonly&&e.createElement("button",{className:"btn btn-secondary btn-remove-option",type:"button",title:"Remove line",onClick:function(){return t.removeQuoteDetail(n)}},e.createElement("i",{className:"material-icons"},"cancel"))))}))),!this.props.readonly&&e.createElement("div",{className:"buttons"},e.createElement("button",{type:"button",className:"btn btn-secondary",id:"btnAddDetail",onClick:function(){return t.addQuoteDetail()}},A._("Add line","Admin"))))),this.props.formJson.tipText?e.createElement("p",null,this.props.formJson.tipText):"")}}])}(e.Component);function Q(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function W(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?Q(Object(n),!0).forEach((function(t){d(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):Q(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function H(){try{var e=!Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){})))}catch(e){}return(H=function(){return!!e})()}const K=function(t){function n(e){var t,r,l,a;return o(this,n),r=this,l=c(l=n),d(t=s(r,H()?Reflect.construct(l,[],c(r).constructor):l.apply(r,a)),"state",{text:"",id:""}),d(t,"counter",0),d(t,"getCounter",(function(){return t.counter++})),t.state.text=e.formJson.value||"",t.state.connector="list_"+Math.random().toString(36).substring(9),e.addToResult(e.formJson.name,t.state.text),t}return p(n,t),u(n,[{key:"changeValue",value:function(e){var t=this;this.setState(W(W({},this.state),{},{text:e.target.value}),(function(){t.props.addToResult(t.props.formJson.name,t.state.text)}))}},{key:"render",value:function(){var t=this;return e.createElement("div",{className:"form-group"},e.createElement("legend",{className:"mainLabel inputLabel "},e.createElement("span",{className:"formLabel"},this.props.formJson.label,this.props.formJson.required?e.createElement("span",{className:"required"},"*"):"")),e.createElement("div",null,this.props.formJson.options.map((function(n){return e.createElement("div",{className:"form-check",key:t.getCounter()},e.createElement("input",{readOnly:t.props.readonly,className:"form-check-input",type:"radio",name:t.props.formJson.name,id:"gridRadios1",onChange:function(e){t.changeValue(e)},required:t.props.formJson.required,value:n.value,defaultChecked:t.props.formJson.value==n.value}),e.createElement("label",{className:"form-check-label",htmlFor:"gridRadios1"},n.label))}))),this.props.formJson.tipText?e.createElement("p",null,this.props.formJson.tipText):"")}}])}(e.Component);function X(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function Y(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?X(Object(n),!0).forEach((function(t){d(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):X(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function G(){try{var e=!Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){})))}catch(e){}return(G=function(){return!!e})()}const Z=function(t){function n(e){var t,r,l,a;return o(this,n),r=this,l=c(l=n),d(t=s(r,G()?Reflect.construct(l,[],c(r).constructor):l.apply(r,a)),"state",{text:"",id:""}),d(t,"counter",0),d(t,"getCounter",(function(){return t.counter++})),t.state.text=e.formJson.value||(e.formJson.options.length>0?e.formJson.options[0].value:""),e.addToResult(e.formJson.name,t.state.text),t}return p(n,t),u(n,[{key:"componentDidMount",value:function(){var e=this;$("#formPreview select").combobox(),$('#formPreview select[name = "'+this.props.formJson.name+'"]').change((function(){e.setState(Y(Y({},e.state),{},{text:this.value}),(function(){e.props.addToResult(e.props.formJson.name,e.state.text)}))}))}},{key:"render",value:function(){var t=this;return e.createElement("div",{className:"form-group"},e.createElement("span",{className:"mainLabel inputLabel"},e.createElement("span",{className:"formLabel"},this.props.formJson.label,this.props.formJson.required?e.createElement("span",{className:"required"},"*"):""),e.createElement("select",{disabled:this.props.readonly,required:this.props.formJson.required,className:this.props.formJson.class||"form-control",name:this.props.formJson.name,value:this.state.text},this.props.formJson.options.map((function(n){return e.createElement("option",{key:t.getCounter(),value:n.value},n.label)})))),this.props.formJson.tipText?e.createElement("p",null,this.props.formJson.tipText):"")}}])}(e.Component);function ee(){try{var e=!Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){})))}catch(e){}return(ee=function(){return!!e})()}const te=function(t){function n(e){var t,r,l,a;return o(this,n),r=this,l=c(l=n),d(t=s(r,ee()?Reflect.construct(l,[],c(r).constructor):l.apply(r,a)),"state",{text:""}),t.state.text=e.formJson.value||"",e.addToResult(e.formJson.name,t.state.text),t}return p(n,t),u(n,[{key:"changeValue",value:function(e){var t=this;this.setState({text:e.target.value},(function(){t.props.addToResult(t.props.formJson.name,t.state.text)}))}},{key:"render",value:function(){var t=this;return e.createElement("div",{className:"form-group"},e.createElement("label",{className:"mainLabel inputLabel"},e.createElement("span",{className:"formLabel"},this.props.formJson.label,this.props.formJson.required?e.createElement("span",{className:"required"},"*"):""),e.createElement("textarea",{readOnly:this.props.readonly,required:this.props.formJson.required,name:this.props.formJson.name,id:"",cols:this.props.formJson.cols||30,rows:this.props.formJson.rows||10,defaultValue:this.state.text,placeholder:this.props.formJson.placeholder,minLength:this.props.formJson.min_length,maxLength:this.props.formJson.max_length,className:this.props.formJson.class||"form-control",onChange:function(e){return t.changeValue(e)}})),this.props.formJson.tipText?e.createElement("p",null,this.props.formJson.tipText):"")}}])}(e.Component);function ne(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function re(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?ne(Object(n),!0).forEach((function(t){d(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):ne(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function oe(){try{var e=!Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){})))}catch(e){}return(oe=function(){return!!e})()}var le=function(t){function n(e){var t,r,l,a;return o(this,n),r=this,l=c(l=n),d(t=s(r,oe()?Reflect.construct(l,[],c(r).constructor):l.apply(r,a)),"getCounter",(function(){return t.counter++})),d(t,"addToResult",(function(e,n){t.setState((function(t){return{result:t.result.map((function(t){return t.name===e?re(re({},t),{},{value:n}):t}))}}))})),t.counter=0,t.state={formHasFilesUpload:!1,formJson:[],result:e.formJson},e.formJson&&e.formJson.map((function(e){"fileUpload"==e.typeField&&(t.state.formHasFilesUpload=!0)})),t}return p(n,t),u(n,[{key:"componentDidMount",value:function(){$("#formPreview input[type=checkbox]").checkbox()}},{key:"render",value:function(){var t=this,n=this.props.onFormSubmit;return e.createElement("div",{className:"field-input",id:"formPreview"},e.createElement("form",{action:"",onSubmit:function(e){e.preventDefault(),n(t.state.result)}},e.createElement("fieldset",null,this.props.formJson?e.createElement("div",null,this.state.result.map((function(n,r){return e.createElement("div",null,function(){switch(n.typeField){case"text":return e.createElement(L,{key:r,readonly:t.props.readonly,addToResult:t.addToResult,formJson:n});case"textArea":return e.createElement(te,{key:r,readonly:t.props.readonly,addToResult:t.addToResult,formJson:n});case"number":return e.createElement(M,{key:r,readonly:t.props.readonly,addToResult:t.addToResult,formJson:n});case"autocomplete":return e.createElement(x,{key:r,readonly:t.props.readonly,addToResult:t.addToResult,formJson:n});case"inputRadio":return e.createElement(K,{key:r,readonly:t.props.readonly,addToResult:t.addToResult,formJson:n});case"inputCheckbox":return e.createElement(S,{key:r,readonly:t.props.readonly,addToResult:t.addToResult,formJson:n});case"select":return e.createElement(Z,{key:r,readonly:t.props.readonly,addToResult:t.addToResult,formJson:n});case"fileUpload":return e.createElement(P,{key:r,readonly:t.props.readonly,addToResult:t.addToResult,formJson:n});case"paragraph":return e.createElement(J,{key:r,addToResult:t.addToResult,formJson:n});case"header":return e.createElement(O,{key:r,addToResult:t.addToResult,formJson:n});case"button":return e.createElement(E,{key:r,addToResult:t.addToResult,formJson:n});case"hiddenInput":return e.createElement(R,{key:r,addToResult:t.addToResult,formJson:n});case"quoteDetails":case"lineItems":return e.createElement(q,{key:r,readonly:t.props.readonly,addToResult:t.addToResult,formJson:n});case"quoteVariations":return e.createElement(q,{key:r,eadonly:t.props.readonly,addToResult:t.addToResult,formJson:n})}}())}))):"",this.props.showSubmitButton?e.createElement("button",{className:"btn btn-primary",type:"submit"},this.props.submitLabel):"")))}}])}(e.Component),ae=n=>{let r=document.getElementById(n.targetDomElement);const o=e.createElement(le,{showSubmitButton:!0,formJson:JSON.parse(n.formData),submitLabel:n.submitLabel,onFormSubmit:n.onSubmitForm});return t.render(o,r)}})(),r})()));
//# sourceMappingURL=assets\customizer\Scripts\libs\quoteForm\quoteForm.js.map
/*
* Copyright (c) 2015, Leon Sorokin
* All rights reserved. (MIT Licensed)
*
* RgbQuant.js - an image quantization lib
*/

(function(){
	function RgbQuant(opts) {
		opts = opts || {};

		// 1 = by global population, 2 = subregion population threshold
		this.method = opts.method || 2;
		// desired final palette size
		this.colors = opts.colors || 256;
		// # of highest-frequency colors to start with for palette reduction
		this.initColors = opts.initColors || 4096;
		// color-distance threshold for initial reduction pass
		this.initDist = opts.initDist || 0.01;
		// subsequent passes threshold
		this.distIncr = opts.distIncr || 0.005;
		// palette grouping
		this.hueGroups = opts.hueGroups || 10;
		this.satGroups = opts.satGroups || 10;
		this.lumGroups = opts.lumGroups || 10;
		// if > 0, enables hues stats and min-color retention per group
		this.minHueCols = opts.minHueCols || 0;
		// HueStats instance
		this.hueStats = this.minHueCols ? new HueStats(this.hueGroups, this.minHueCols) : null;

		// subregion partitioning box size
		this.boxSize = opts.boxSize || [64,64];
		// number of same pixels required within box for histogram inclusion
		this.boxPxls = opts.boxPxls || 2;
		// palette locked indicator
		this.palLocked = false;
		// palette sort order
//		this.sortPal = ['hue-','lum-','sat-'];

		// dithering/error diffusion kernel name
		this.dithKern = opts.dithKern || null;
		// dither serpentine pattern
		this.dithSerp = opts.dithSerp || false;
		// minimum color difference (0-1) needed to dither
		this.dithDelta = opts.dithDelta || 0;

		// accumulated histogram
		this.histogram = {};
		// palette - rgb triplets
		this.idxrgb = opts.palette ? opts.palette.slice(0) : [];
		// palette - int32 vals
		this.idxi32 = [];
		// reverse lookup {i32:idx}
		this.i32idx = {};
		// {i32:rgb}
		this.i32rgb = {};

		// Matteo - replacement palette
		// when a replecement palette is specified, each color of the original palette is mapped to the replacement palette
		// only used when opts.palette is specified and if the length of the two palette is the same
		// in the replacement palette is possible to indicate a transparent color, specifing null for the triplette array.
		// example with null color: [[32, 11, 90], [53,11,34], null, [250, 2, 99]]
		this.idxrgbRep = opts.palette && opts.paletteRep && opts.palette.length == opts.paletteRep.length ? opts.paletteRep.slice(0) : [];
		// Matteo - replacement palette int32 vals
		this.idxi32Rep = [];
		// reverse lookup {i32:idx}
		this.i32idxRep = {};
		// {i32:rgb}
		this.i32rgbRep = {};
		// -----------------------------------------------

		// enable color caching (also incurs overhead of cache misses and cache building)
		this.useCache = opts.useCache !== false;
		// min color occurance count needed to qualify for caching
		this.cacheFreq = opts.cacheFreq || 10;
		// allows pre-defined palettes to be re-indexed (enabling palette compacting and sorting)
		this.reIndex = opts.reIndex || this.idxrgb.length == 0;
		// selection of color-distance equation
		this.colorDist = opts.colorDist == "manhattan" ? distManhattan : distEuclidean;

		// if pre-defined palette, build lookups
		if (this.idxrgb.length > 0) {
			var self = this;
			this.idxrgb.forEach(function(rgb, i) {
				var i32 = (
					(255    << 24) |	// alpha
					(rgb[2] << 16) |	// blue
					(rgb[1] <<  8) |	// green
					 rgb[0]				// red
				) >>> 0;

				self.idxi32[i]		= i32;
				self.i32idx[i32]	= i;
				self.i32rgb[i32]	= rgb;
			});

			this.idxrgbRep.forEach(function(rgb, i) {
				var i32 = rgb != null ? (
					(255    << 24) |	// alpha
					(rgb[2] << 16) |	// blue
					(rgb[1] <<  8) |	// green
					 rgb[0]				// red
				) >>> 0 : (
					(0    << 24) |	// alpha
					(0    << 16) |	// blue
					(0    <<  8) |	// green
					 0			    // red
				) >>> 0;

				self.idxi32Rep[i]	= i32;
				self.i32idxRep[i32]	= i;
				self.i32rgbRep[i32]	= rgb;
			});
		}
	}

	// gathers histogram info
	// Matteo - autoThreshold for removing irrelevant colors (based on histogram values) - aborted tentative
	RgbQuant.prototype.sample = function sample(img, width) {
		if (this.palLocked)
			throw "Cannot sample additional images, palette already assembled.";

		var data = getImageData(img, width);

		switch (this.method) {
			case 1: this.colorStats1D(data.buf32); break;
			case 2: this.colorStats2D(data.buf32, data.width); break;
		}
	};

	// image quantizer
	// todo: memoize colors here also
	// @retType: 1 - Uint8Array (default), 2 - Indexed array, 3 - Match @img type (unimplemented, todo)
	// Matteo: @retType: 3 - Blob
	RgbQuant.prototype.reduce = function reduce(img, retType, dithKern, dithSerp) {
		if (!this.palLocked)
			this.buildPal();

		dithKern = dithKern || this.dithKern;
		dithSerp = typeof dithSerp != "undefined" ? dithSerp : this.dithSerp;

		retType = retType || 1;

		// reduce w/dither
		if (dithKern)
			var out32 = this.dither(img, dithKern, dithSerp);
		else {
			var data = getImageData(img),
				buf32 = data.buf32,
				len = buf32.length,
				out32 = new Uint32Array(len);

			for (var i = 0; i < len; i++) {
				var i32 = buf32[i];
				//out32[i] = this.nearestColor(i32);
				var i32x = this.nearestColor(i32);

				// Image pixel
				var r1 = (i32 & 0xff),
					g1 = (i32 & 0xff00) >> 8,
					b1 = (i32 & 0xff0000) >> 16,
					a1 = (i32 & 0xff000000) >> 24;

				// Reduced pixel
				var r2 = (i32x & 0xff),
					g2 = (i32x & 0xff00) >> 8,
					b2 = (i32x & 0xff0000) >> 16 
					a2 = (i32x & 0xff000000) >> 24;

				// If we have a replacement palette and the corresponding color has alpha 0 it means
				// that the corresponding color is transparente (null in the palette)
				var alpha = this.i32rgbRep != null && a2 == 0 ? a2 : a1;
				out32[i] =
					//(255 << 24)	|	// alpha
					(alpha  << 24)	|	// alpha
					(b2  << 16)	|	// blue
					(g2  <<  8)	|	// green
					 r2;
			}
		}

		if (retType == 1)
			return new Uint8Array(out32.buffer);

		if (retType == 2) {
			var out = [],
				len = out32.length;

			for (var i = 0; i < len; i++) {
				var i32 = out32[i];
				out[i] = this.i32idx[i32];
			}

			return out;
		}

		// Matteo - Esporto direttamente un blob
		if (retType == 3) {
			var can = document.createElement("canvas");
			can.width = data.width;
			can.height = data.height;
			var ctx = can.getContext("2d");

			var imgd = ctx.createImageData(can.width, can.height);

			if (typeOf(imgd.data) == "CanvasPixelArray") {
				var idxi8 = new Uint8Array(out32.buffer);
				var data = imgd.data;
				for (var i = 0, len = data.length; i < len; ++i)
					data[i] = idxi8[i];
			}
			else {
				var idxi32 = new Uint32Array(out32.buffer);
				var buf32 = new Uint32Array(imgd.data.buffer);
				buf32.set(idxi32);
			}
		
			ctx.putImageData(imgd, 0, 0);

			var dataUri = can.toDataURL("image/png");
			return this.dataURItoBlob(dataUri);
		}
	};

	RgbQuant.prototype.dataURItoBlob = function(dataURI) {
		// convert base64/URLEncoded data component to raw binary data held in a string
		var byteString;
		if (dataURI.split(',')[0].indexOf('base64') >= 0)
			byteString = atob(dataURI.split(',')[1]);
		else
			byteString = unescape(dataURI.split(',')[1]);
	
		// separate out the mime component
		var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
	
		// write the bytes of the string to a typed array
		var ia = new Uint8Array(byteString.length);
		for (var i = 0; i < byteString.length; i++) {
			ia[i] = byteString.charCodeAt(i);
		}
	
		return new Blob([ia], {type:mimeString});
	}

	// adapted from http://jsbin.com/iXofIji/2/edit by PAEz
	RgbQuant.prototype.dither = function(img, kernel, serpentine) {
		// http://www.tannerhelland.com/4660/dithering-eleven-algorithms-source-code/
		var kernels = {
			FloydSteinberg: [
				[7 / 16, 1, 0],
				[3 / 16, -1, 1],
				[5 / 16, 0, 1],
				[1 / 16, 1, 1]
			],
			FalseFloydSteinberg: [
				[3 / 8, 1, 0],
				[3 / 8, 0, 1],
				[2 / 8, 1, 1]
			],
			Stucki: [
				[8 / 42, 1, 0],
				[4 / 42, 2, 0],
				[2 / 42, -2, 1],
				[4 / 42, -1, 1],
				[8 / 42, 0, 1],
				[4 / 42, 1, 1],
				[2 / 42, 2, 1],
				[1 / 42, -2, 2],
				[2 / 42, -1, 2],
				[4 / 42, 0, 2],
				[2 / 42, 1, 2],
				[1 / 42, 2, 2]
			],
			Atkinson: [
				[1 / 8, 1, 0],
				[1 / 8, 2, 0],
				[1 / 8, -1, 1],
				[1 / 8, 0, 1],
				[1 / 8, 1, 1],
				[1 / 8, 0, 2]
			],
			Jarvis: [			// Jarvis, Judice, and Ninke / JJN?
				[7 / 48, 1, 0],
				[5 / 48, 2, 0],
				[3 / 48, -2, 1],
				[5 / 48, -1, 1],
				[7 / 48, 0, 1],
				[5 / 48, 1, 1],
				[3 / 48, 2, 1],
				[1 / 48, -2, 2],
				[3 / 48, -1, 2],
				[5 / 48, 0, 2],
				[3 / 48, 1, 2],
				[1 / 48, 2, 2]
			],
			Burkes: [
				[8 / 32, 1, 0],
				[4 / 32, 2, 0],
				[2 / 32, -2, 1],
				[4 / 32, -1, 1],
				[8 / 32, 0, 1],
				[4 / 32, 1, 1],
				[2 / 32, 2, 1],
			],
			Sierra: [
				[5 / 32, 1, 0],
				[3 / 32, 2, 0],
				[2 / 32, -2, 1],
				[4 / 32, -1, 1],
				[5 / 32, 0, 1],
				[4 / 32, 1, 1],
				[2 / 32, 2, 1],
				[2 / 32, -1, 2],
				[3 / 32, 0, 2],
				[2 / 32, 1, 2],
			],
			TwoSierra: [
				[4 / 16, 1, 0],
				[3 / 16, 2, 0],
				[1 / 16, -2, 1],
				[2 / 16, -1, 1],
				[3 / 16, 0, 1],
				[2 / 16, 1, 1],
				[1 / 16, 2, 1],
			],
			SierraLite: [
				[2 / 4, 1, 0],
				[1 / 4, -1, 1],
				[1 / 4, 0, 1],
			],
		};

		if (!kernel || !kernels[kernel]) {
			throw 'Unknown dithering kernel: ' + kernel;
		}

		var ds = kernels[kernel];

		var data = getImageData(img),
//			buf8 = data.buf8,
			buf32 = data.buf32,
			width = data.width,
			height = data.height,
			len = buf32.length;

		var dir = serpentine ? -1 : 1;

		for (var y = 0; y < height; y++) {
			if (serpentine)
				dir = dir * -1;

			var lni = y * width;

			for (var x = (dir == 1 ? 0 : width - 1), xend = (dir == 1 ? width : 0); x !== xend; x += dir) {
				// Image pixel
				var idx = lni + x,
					i32 = buf32[idx],
					r1 = (i32 & 0xff),
					g1 = (i32 & 0xff00) >> 8,
					b1 = (i32 & 0xff0000) >> 16,
					a1 = (i32 & 0xff000000) >> 24;

				// Reduced pixel
				var i32x = this.nearestColor(i32),
					r2 = (i32x & 0xff),
					g2 = (i32x & 0xff00) >> 8,
					b2 = (i32x & 0xff0000) >> 16;

				buf32[idx] =
					//(255 << 24)	|	// alpha
					(a1 << 24)	|	// alpha
					(b2  << 16)	|	// blue
					(g2  <<  8)	|	// green
					 r2;

				// dithering strength
				if (this.dithDelta) {
					var dist = this.colorDist([r1, g1, b1], [r2, g2, b2]);
					if (dist < this.dithDelta)
						continue;
				}

				// Component distance
				var er = r1 - r2,
					eg = g1 - g2,
					eb = b1 - b2;

				for (var i = (dir == 1 ? 0 : ds.length - 1), end = (dir == 1 ? ds.length : 0); i !== end; i += dir) {
					var x1 = ds[i][1] * dir,
						y1 = ds[i][2];

					var lni2 = y1 * width;

					if (x1 + x >= 0 && x1 + x < width && y1 + y >= 0 && y1 + y < height) {
						var d = ds[i][0];
						var idx2 = idx + (lni2 + x1);

						var r3 = (buf32[idx2] & 0xff),
							g3 = (buf32[idx2] & 0xff00) >> 8,
							b3 = (buf32[idx2] & 0xff0000) >> 16;

						var r4 = Math.max(0, Math.min(255, r3 + er * d)),
							g4 = Math.max(0, Math.min(255, g3 + eg * d)),
							b4 = Math.max(0, Math.min(255, b3 + eb * d));

						buf32[idx2] =
							(255 << 24)	|	// alpha
							(b4  << 16)	|	// blue
							(g4  <<  8)	|	// green
							 r4;			// red
					}
				}
			}
		}

		return buf32;
	};

	// reduces histogram to palette, remaps & memoizes reduced colors
	RgbQuant.prototype.buildPal = function buildPal(noSort) {
		if (this.palLocked || this.idxrgb.length > 0 && this.idxrgb.length <= this.colors) return;

		var histG  = this.histogram,
			sorted = sortedHashKeys(histG, true);

		if (sorted.length == 0)
			throw "Nothing has been sampled, palette cannot be built.";

		switch (this.method) {
			case 1:
				var cols = this.initColors,
					last = sorted[cols - 1],
					freq = histG[last];

				var idxi32 = sorted.slice(0, cols);

				// add any cut off colors with same freq as last
				var pos = cols, len = sorted.length;
				while (pos < len && histG[sorted[pos]] == freq)
					idxi32.push(sorted[pos++]);

				// inject min huegroup colors
				if (this.hueStats)
					this.hueStats.inject(idxi32);

				break;
			case 2:
				var idxi32 = sorted;
				break;
		}

		// int32-ify values
		idxi32 = idxi32.map(function(v){return +v;});

		this.reducePal(idxi32);

		if (!noSort && this.reIndex)
			this.sortPal();

		// build cache of top histogram colors
		if (this.useCache)
			this.cacheHistogram(idxi32);

		this.palLocked = true;
	};

	RgbQuant.prototype.palette = function palette(tuples, noSort) {
		this.buildPal(noSort);
		return tuples ? this.idxrgb : new Uint8Array((new Uint32Array(this.idxi32)).buffer);
	};

	RgbQuant.prototype.prunePal = function prunePal(keep) {
		var i32;

		for (var j = 0; j < this.idxrgb.length; j++) {
			if (!keep[j]) {
				i32 = this.idxi32[j];
				this.idxrgb[j] = null;
				this.idxi32[j] = null;
				delete this.i32idx[i32];
			}
		}

		// compact
		if (this.reIndex) {
			var idxrgb = [],
				idxi32 = [],
				i32idx = {};

			for (var j = 0, i = 0; j < this.idxrgb.length; j++) {
				if (this.idxrgb[j]) {
					i32 = this.idxi32[j];
					idxrgb[i] = this.idxrgb[j];
					i32idx[i32] = i;
					idxi32[i] = i32;
					i++;
				}
			}

			this.idxrgb = idxrgb;
			this.idxi32 = idxi32;
			this.i32idx = i32idx;
		}
	};

	// reduces similar colors from an importance-sorted Uint32 rgba array
	RgbQuant.prototype.reducePal = function reducePal(idxi32) {
		// if pre-defined palette's length exceeds target
		if (this.idxrgb.length > this.colors) {
			// quantize histogram to existing palette
			var len = idxi32.length, keep = {}, uniques = 0, idx, pruned = false;

			for (var i = 0; i < len; i++) {
				// palette length reached, unset all remaining colors (sparse palette)
				if (uniques == this.colors && !pruned) {
					this.prunePal(keep);
					pruned = true;
				}

				idx = this.nearestIndex(idxi32[i]);

				if (uniques < this.colors && !keep[idx]) {
					keep[idx] = true;
					uniques++;
				}
			}

			if (!pruned) {
				this.prunePal(keep);
				pruned = true;
			}
		}
		// reduce histogram to create initial palette
		else {
			// build full rgb palette
			var idxrgb = idxi32.map(function(i32) {
				return [
					(i32 & 0xff),
					(i32 & 0xff00) >> 8,
					(i32 & 0xff0000) >> 16,
				];
			});

			var len = idxrgb.length,
				palLen = len,
				thold = this.initDist;

			// palette already at or below desired length
			if (palLen > this.colors) {
				while (palLen > this.colors) {
					var memDist = [];

					// iterate palette
					for (var i = 0; i < len; i++) {
						var pxi = idxrgb[i], i32i = idxi32[i];
						if (!pxi) continue;

						for (var j = i + 1; j < len; j++) {
							var pxj = idxrgb[j], i32j = idxi32[j];
							if (!pxj) continue;

							var dist = this.colorDist(pxi, pxj);

							if (dist < thold) {
								// store index,rgb,dist
								memDist.push([j, pxj, i32j, dist]);

								// kill squashed value
								delete(idxrgb[j]);
								palLen--;
							}
						}
					}

					// palette reduction pass
					// console.log("palette length: " + palLen);

					// if palette is still much larger than target, increment by larger initDist
					thold += (palLen > this.colors * 3) ? this.initDist : this.distIncr;
				}

				// if palette is over-reduced, re-add removed colors with largest distances from last round
				if (palLen < this.colors) {
					// sort descending
					sort.call(memDist, function(a,b) {
						return b[3] - a[3];
					});

					var k = 0;
					while (palLen < this.colors) {
						// re-inject rgb into final palette
						idxrgb[memDist[k][0]] = memDist[k][1];

						palLen++;
						k++;
					}
				}
			}

			var len = idxrgb.length;
			for (var i = 0; i < len; i++) {
				if (!idxrgb[i]) continue;

				this.idxrgb.push(idxrgb[i]);
				this.idxi32.push(idxi32[i]);

				this.i32idx[idxi32[i]] = this.idxi32.length - 1;
				this.i32rgb[idxi32[i]] = idxrgb[i];
			}
		}
	};

	// global top-population
	RgbQuant.prototype.colorStats1D = function colorStats1D(buf32) {
		var histG = this.histogram,
			num = 0, col,
			len = buf32.length;

		for (var i = 0; i < len; i++) {
			col = buf32[i];

			// skip transparent
			if ((col & 0xff000000) >> 24 == 0) continue;

			// collect hue stats
			if (this.hueStats)
				this.hueStats.check(col);

			if (col in histG)
				histG[col]++;
			else
				histG[col] = 1;
		}
	};

	// population threshold within subregions
	// FIXME: this can over-reduce (few/no colors same?), need a way to keep
	// important colors that dont ever reach local thresholds (gradients?)
	// Matteo - autoThreshold for removing irrelevant colors (based on histogrm values) - aborted tentative
	RgbQuant.prototype.colorStats2D = function colorStats2D(buf32, width) {
		var boxW = this.boxSize[0],
			boxH = this.boxSize[1],
			area = boxW * boxH,
			boxes = makeBoxes(width, buf32.length / width, boxW, boxH),
			histG = this.histogram,
			self = this;

		boxes.forEach(function(box) {
			var effc = Math.max(Math.round((box.w * box.h) / area) * self.boxPxls, 2),
				histL = {}, col;

			iterBox(box, width, function(i) {
				col = buf32[i];

				// skip transparent
				if ((col & 0xff000000) >> 24 == 0) return;

				// collect hue stats
				if (self.hueStats)
					self.hueStats.check(col);

				if (col in histG)
					histG[col]++;
				else if (col in histL) {
					if (++histL[col] >= effc)
						histG[col] = histL[col];
				}
				else
					histL[col] = 1;
			});
		});

		// Matteo - Test removing irrelevant values
		// commented just to see the tentative to use a threshold
		/*
		if (autoThreshold != undefined && autoThreshold != null && autoThreshold) {
			var removedHistValues = {};

			var tot = 0;
			for (var col in histG) {
				tot += histG[col];
			}

			for (var col in histG) {
				var quote = histG[col] / tot;
				if (quote < 0.01) {
					removedHistValues[col] = histG[col];
					delete histG[col];
				}
			}

			// Reset the hist values if everythink has been removed
			if (Object.keys(histG).length == 0) {
				for (var col in removedHistValues) {
					histG[col] = removedHistValues[col];
				}
			}
		}
		*/
		// -----------------------------------------

		if (this.hueStats)
			this.hueStats.inject(histG);
	};

	// TODO: group very low lum and very high lum colors
	// TODO: pass custom sort order
	RgbQuant.prototype.sortPal = function sortPal() {
		var self = this;

		this.idxi32.sort(function(a,b) {
			var idxA = self.i32idx[a],
				idxB = self.i32idx[b],
				rgbA = self.idxrgb[idxA],
				rgbB = self.idxrgb[idxB];

			var hslA = rgb2hsl(rgbA[0],rgbA[1],rgbA[2]),
				hslB = rgb2hsl(rgbB[0],rgbB[1],rgbB[2]);

			// sort all grays + whites together
			var hueA = (rgbA[0] == rgbA[1] && rgbA[1] == rgbA[2]) ? -1 : hueGroup(hslA.h, self.hueGroups);
			var hueB = (rgbB[0] == rgbB[1] && rgbB[1] == rgbB[2]) ? -1 : hueGroup(hslB.h, self.hueGroups);

			var hueDiff = hueB - hueA;
			if (hueDiff) return -hueDiff;

			var lumDiff = lumGroup(+hslB.l.toFixed(2)) - lumGroup(+hslA.l.toFixed(2));
			if (lumDiff) return -lumDiff;

			var satDiff = satGroup(+hslB.s.toFixed(2)) - satGroup(+hslA.s.toFixed(2));
			if (satDiff) return -satDiff;
		});

		// sync idxrgb & i32idx
		this.idxi32.forEach(function(i32, i) {
			self.idxrgb[i] = self.i32rgb[i32];
			self.i32idx[i32] = i;
		});
	};

	// TOTRY: use HUSL - http://boronine.com/husl/
	RgbQuant.prototype.nearestColor = function nearestColor(i32) {
		var idx = this.nearestIndex(i32);

		// Matteo - using palette replacement. The index is used to take color from replacement palette instead of the original palette
		// so the idx is determined using the original palette, and the once we have the idx, we use the other palette to take the color at the same idx
		if (this.idxrgbRep && this.idxrgbRep.length > 0) 
			return idx == null ? 0 : this.idxi32Rep[idx];
		else
			return idx === null ? 0 : this.idxi32[idx];
	};

	// TOTRY: use HUSL - http://boronine.com/husl/
	RgbQuant.prototype.nearestIndex = function nearestIndex(i32) {
		// alpha 0 returns null index
		if ((i32 & 0xff000000) >> 24 == 0)
			return null;

		if (this.useCache && (""+i32) in this.i32idx)
			return this.i32idx[i32];

		var min = 1000,
			idx,
			rgb = [
				(i32 & 0xff),
				(i32 & 0xff00) >> 8,
				(i32 & 0xff0000) >> 16,
			],
			len = this.idxrgb.length;

		for (var i = 0; i < len; i++) {
			if (!this.idxrgb[i]) continue;		// sparse palettes

			var dist = this.colorDist(rgb, this.idxrgb[i]);

			if (dist < min) {
				min = dist;
				idx = i;
			}
		}

		return idx;
	};

	RgbQuant.prototype.cacheHistogram = function cacheHistogram(idxi32) {
		for (var i = 0, i32 = idxi32[i]; i < idxi32.length && this.histogram[i32] >= this.cacheFreq; i32 = idxi32[i++])
			this.i32idx[i32] = this.nearestIndex(i32);
	};

	function HueStats(numGroups, minCols) {
		this.numGroups = numGroups;
		this.minCols = minCols;
		this.stats = {};

		for (var i = -1; i < numGroups; i++)
			this.stats[i] = {num: 0, cols: []};

		this.groupsFull = 0;
	}

	HueStats.prototype.check = function checkHue(i32) {
		if (this.groupsFull == this.numGroups + 1)
			this.check = function() {return;};

		var r = (i32 & 0xff),
			g = (i32 & 0xff00) >> 8,
			b = (i32 & 0xff0000) >> 16,
			hg = (r == g && g == b) ? -1 : hueGroup(rgb2hsl(r,g,b).h, this.numGroups),
			gr = this.stats[hg],
			min = this.minCols;

		gr.num++;

		if (gr.num > min)
			return;
		if (gr.num == min)
			this.groupsFull++;

		if (gr.num <= min)
			this.stats[hg].cols.push(i32);
	};

	HueStats.prototype.inject = function injectHues(histG) {
		for (var i = -1; i < this.numGroups; i++) {
			if (this.stats[i].num <= this.minCols) {
				switch (typeOf(histG)) {
					case "Array":
						this.stats[i].cols.forEach(function(col){
							if (histG.indexOf(col) == -1)
								histG.push(col);
						});
						break;
					case "Object":
						this.stats[i].cols.forEach(function(col){
							if (!histG[col])
								histG[col] = 1;
							else
								histG[col]++;
						});
						break;
				}
			}
		}
	};

	// Rec. 709 (sRGB) luma coef
	var Pr = .2126,
		Pg = .7152,
		Pb = .0722;

	// http://alienryderflex.com/hsp.html
	function rgb2lum(r,g,b) {
		return Math.sqrt(
			Pr * r*r +
			Pg * g*g +
			Pb * b*b
		);
	}

	var rd = 255,
		gd = 255,
		bd = 255;

	var euclMax = Math.sqrt(Pr*rd*rd + Pg*gd*gd + Pb*bd*bd);
	// perceptual Euclidean color distance
	function distEuclidean(rgb0, rgb1) {
		var rd = rgb1[0]-rgb0[0],
			gd = rgb1[1]-rgb0[1],
			bd = rgb1[2]-rgb0[2];

		return Math.sqrt(Pr*rd*rd + Pg*gd*gd + Pb*bd*bd) / euclMax;
	}

	var manhMax = Pr*rd + Pg*gd + Pb*bd;
	// perceptual Manhattan color distance
	function distManhattan(rgb0, rgb1) {
		var rd = Math.abs(rgb1[0]-rgb0[0]),
			gd = Math.abs(rgb1[1]-rgb0[1]),
			bd = Math.abs(rgb1[2]-rgb0[2]);

		return (Pr*rd + Pg*gd + Pb*bd) / manhMax;
	}

	// http://rgb2hsl.nichabi.com/javascript-function.php
	function rgb2hsl(r, g, b) {
		var max, min, h, s, l, d;
		r /= 255;
		g /= 255;
		b /= 255;
		max = Math.max(r, g, b);
		min = Math.min(r, g, b);
		l = (max + min) / 2;
		if (max == min) {
			h = s = 0;
		} else {
			d = max - min;
			s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
			switch (max) {
				case r: h = (g - b) / d + (g < b ? 6 : 0); break;
				case g:	h = (b - r) / d + 2; break;
				case b:	h = (r - g) / d + 4; break
			}
			h /= 6;
		}
//		h = Math.floor(h * 360)
//		s = Math.floor(s * 100)
//		l = Math.floor(l * 100)
		return {
			h: h,
			s: s,
			l: rgb2lum(r,g,b),
		};
	}

	function hueGroup(hue, segs) {
		var seg = 1/segs,
			haf = seg/2;

		if (hue >= 1 - haf || hue <= haf)
			return 0;

		for (var i = 1; i < segs; i++) {
			var mid = i*seg;
			if (hue >= mid - haf && hue <= mid + haf)
				return i;
		}
	}

	function satGroup(sat) {
		return sat;
	}

	function lumGroup(lum) {
		return lum;
	}

	function typeOf(val) {
		return Object.prototype.toString.call(val).slice(8,-1);
	}

	var sort = isArrSortStable() ? Array.prototype.sort : stableSort;

	// must be used via stableSort.call(arr, fn)
	function stableSort(fn) {
		var type = typeOf(this[0]);

		if (type == "Number" || type == "String") {
			var ord = {}, len = this.length, val;

			for (var i = 0; i < len; i++) {
				val = this[i];
				if (ord[val] || ord[val] === 0) continue;
				ord[val] = i;
			}

			return this.sort(function(a,b) {
				return fn(a,b) || ord[a] - ord[b];
			});
		}
		else {
			var ord = this.map(function(v){return v});

			return this.sort(function(a,b) {
				return fn(a,b) || ord.indexOf(a) - ord.indexOf(b);
			});
		}
	}

	// test if js engine's Array#sort implementation is stable
	function isArrSortStable() {
		var str = "abcdefghijklmnopqrstuvwxyz";

		return "xyzvwtursopqmnklhijfgdeabc" == str.split("").sort(function(a,b) {
			return ~~(str.indexOf(b)/2.3) - ~~(str.indexOf(a)/2.3);
		}).join("");
	}

	// returns uniform pixel data from various img
	// TODO?: if array is passed, createimagedata, createlement canvas? take a pxlen?
	function getImageData(img, width) {
		var can, ctx, imgd, buf8, buf32, height;

	    var type = typeof(img);
		if (type === "object") {
			type = img.constructor.name;
		}

		switch (type) {
			case "HTMLImageElement":
				can = document.createElement("canvas");
				can.width = img.naturalWidth;
				can.height = img.naturalHeight;
				ctx = can.getContext("2d");
				ctx.drawImage(img,0,0);
			case "Canvas":
			case "HTMLCanvasElement":
				can = can || img;
				ctx = ctx || can.getContext("2d");
			case "CanvasRenderingContext2D":
				ctx = ctx || img;
				can = can || ctx.canvas;
				imgd = ctx.getImageData(0, 0, can.width, can.height);
			case "ImageData":
				imgd = imgd || img;
				width = imgd.width;
				if (typeOf(imgd.data) == "CanvasPixelArray")
					buf8 = new Uint8Array(imgd.data);
				else
					buf8 = imgd.data;
			case "Array":
			case "CanvasPixelArray":
				buf8 = buf8 || new Uint8Array(img);
			case "Uint8Array":
			case "Uint8ClampedArray":
				buf8 = buf8 || img;
				buf32 = new Uint32Array(buf8.buffer);
			case "Uint32Array":
				buf32 = buf32 || img;
				buf8 = buf8 || new Uint8Array(buf32.buffer);
				width = width || buf32.length;
				height = buf32.length / width;
		}

		return {
			can: can,
			ctx: ctx,
			imgd: imgd,
			buf8: buf8,
			buf32: buf32,
			width: width,
			height: height,
		};
	}

	// partitions a rect of wid x hgt into
	// array of bboxes of w0 x h0 (or less)
	function makeBoxes(wid, hgt, w0, h0) {
		var wnum = ~~(wid/w0), wrem = wid%w0,
			hnum = ~~(hgt/h0), hrem = hgt%h0,
			xend = wid-wrem, yend = hgt-hrem;

		var bxs = [];
		for (var y = 0; y < hgt; y += h0)
			for (var x = 0; x < wid; x += w0)
				bxs.push({x:x, y:y, w:(x==xend?wrem:w0), h:(y==yend?hrem:h0)});

		return bxs;
	}

	// iterates @bbox within a parent rect of width @wid; calls @fn, passing index within parent
	function iterBox(bbox, wid, fn) {
		var b = bbox,
			i0 = b.y * wid + b.x,
			i1 = (b.y + b.h - 1) * wid + (b.x + b.w - 1),
			cnt = 0, incr = wid - b.w + 1, i = i0;

		do {
			fn.call(this, i);
			i += (++cnt % b.w == 0) ? incr : 1;
		} while (i <= i1);
	}

	// returns array of hash keys sorted by their values
	function sortedHashKeys(obj, desc) {
		var keys = [];

		for (var key in obj)
			keys.push(key);

		return sort.call(keys, function(a,b) {
			return desc ? obj[b] - obj[a] : obj[a] - obj[b];
		});
	}

	// expose
	this.RgbQuant = RgbQuant;

	// expose to commonJS
	if (typeof module !== 'undefined' && module.exports) {
		module.exports = RgbQuant;
	}

}).call(this);
/*
CryptoJS v3.1.2
code.google.com/p/crypto-js
(c) 2009-2013 by Jeff Mott. All rights reserved.
code.google.com/p/crypto-js/wiki/License
*/
var CryptoJS=CryptoJS||function(e,m){var p={},j=p.lib={},l=function(){},f=j.Base={extend:function(a){l.prototype=this;var c=new l;a&&c.mixIn(a);c.hasOwnProperty("init")||(c.init=function(){c.$super.init.apply(this,arguments)});c.init.prototype=c;c.$super=this;return c},create:function(){var a=this.extend();a.init.apply(a,arguments);return a},init:function(){},mixIn:function(a){for(var c in a)a.hasOwnProperty(c)&&(this[c]=a[c]);a.hasOwnProperty("toString")&&(this.toString=a.toString)},clone:function(){return this.init.prototype.extend(this)}},
n=j.WordArray=f.extend({init:function(a,c){a=this.words=a||[];this.sigBytes=c!=m?c:4*a.length},toString:function(a){return(a||h).stringify(this)},concat:function(a){var c=this.words,q=a.words,d=this.sigBytes;a=a.sigBytes;this.clamp();if(d%4)for(var b=0;b<a;b++)c[d+b>>>2]|=(q[b>>>2]>>>24-8*(b%4)&255)<<24-8*((d+b)%4);else if(65535<q.length)for(b=0;b<a;b+=4)c[d+b>>>2]=q[b>>>2];else c.push.apply(c,q);this.sigBytes+=a;return this},clamp:function(){var a=this.words,c=this.sigBytes;a[c>>>2]&=4294967295<<
32-8*(c%4);a.length=e.ceil(c/4)},clone:function(){var a=f.clone.call(this);a.words=this.words.slice(0);return a},random:function(a){for(var c=[],b=0;b<a;b+=4)c.push(4294967296*e.random()|0);return new n.init(c,a)}}),b=p.enc={},h=b.Hex={stringify:function(a){var c=a.words;a=a.sigBytes;for(var b=[],d=0;d<a;d++){var f=c[d>>>2]>>>24-8*(d%4)&255;b.push((f>>>4).toString(16));b.push((f&15).toString(16))}return b.join("")},parse:function(a){for(var c=a.length,b=[],d=0;d<c;d+=2)b[d>>>3]|=parseInt(a.substr(d,
2),16)<<24-4*(d%8);return new n.init(b,c/2)}},g=b.Latin1={stringify:function(a){var c=a.words;a=a.sigBytes;for(var b=[],d=0;d<a;d++)b.push(String.fromCharCode(c[d>>>2]>>>24-8*(d%4)&255));return b.join("")},parse:function(a){for(var c=a.length,b=[],d=0;d<c;d++)b[d>>>2]|=(a.charCodeAt(d)&255)<<24-8*(d%4);return new n.init(b,c)}},r=b.Utf8={stringify:function(a){try{return decodeURIComponent(escape(g.stringify(a)))}catch(c){throw Error("Malformed UTF-8 data");}},parse:function(a){return g.parse(unescape(encodeURIComponent(a)))}},
k=j.BufferedBlockAlgorithm=f.extend({reset:function(){this._data=new n.init;this._nDataBytes=0},_append:function(a){"string"==typeof a&&(a=r.parse(a));this._data.concat(a);this._nDataBytes+=a.sigBytes},_process:function(a){var c=this._data,b=c.words,d=c.sigBytes,f=this.blockSize,h=d/(4*f),h=a?e.ceil(h):e.max((h|0)-this._minBufferSize,0);a=h*f;d=e.min(4*a,d);if(a){for(var g=0;g<a;g+=f)this._doProcessBlock(b,g);g=b.splice(0,a);c.sigBytes-=d}return new n.init(g,d)},clone:function(){var a=f.clone.call(this);
a._data=this._data.clone();return a},_minBufferSize:0});j.Hasher=k.extend({cfg:f.extend(),init:function(a){this.cfg=this.cfg.extend(a);this.reset()},reset:function(){k.reset.call(this);this._doReset()},update:function(a){this._append(a);this._process();return this},finalize:function(a){a&&this._append(a);return this._doFinalize()},blockSize:16,_createHelper:function(a){return function(c,b){return(new a.init(b)).finalize(c)}},_createHmacHelper:function(a){return function(b,f){return(new s.HMAC.init(a,
f)).finalize(b)}}});var s=p.algo={};return p}(Math);
(function(){var e=CryptoJS,m=e.lib,p=m.WordArray,j=m.Hasher,l=[],m=e.algo.SHA1=j.extend({_doReset:function(){this._hash=new p.init([1732584193,4023233417,2562383102,271733878,3285377520])},_doProcessBlock:function(f,n){for(var b=this._hash.words,h=b[0],g=b[1],e=b[2],k=b[3],j=b[4],a=0;80>a;a++){if(16>a)l[a]=f[n+a]|0;else{var c=l[a-3]^l[a-8]^l[a-14]^l[a-16];l[a]=c<<1|c>>>31}c=(h<<5|h>>>27)+j+l[a];c=20>a?c+((g&e|~g&k)+1518500249):40>a?c+((g^e^k)+1859775393):60>a?c+((g&e|g&k|e&k)-1894007588):c+((g^e^
k)-899497514);j=k;k=e;e=g<<30|g>>>2;g=h;h=c}b[0]=b[0]+h|0;b[1]=b[1]+g|0;b[2]=b[2]+e|0;b[3]=b[3]+k|0;b[4]=b[4]+j|0},_doFinalize:function(){var f=this._data,e=f.words,b=8*this._nDataBytes,h=8*f.sigBytes;e[h>>>5]|=128<<24-h%32;e[(h+64>>>9<<4)+14]=Math.floor(b/4294967296);e[(h+64>>>9<<4)+15]=b;f.sigBytes=4*e.length;this._process();return this._hash},clone:function(){var e=j.clone.call(this);e._hash=this._hash.clone();return e}});e.SHA1=j._createHelper(m);e.HmacSHA1=j._createHmacHelper(m)})();


function MarvinColorModelConverter(){}

MarvinColorModelConverter.rgbToBinary = function(img, threshold){		
	var resultImage = new MarvinImage(img.getWidth(), img.getHeight(), MarvinImage.COLOR_MODEL_BINARY);

	for(var y=0; y<img.getHeight(); y++){
		for(var x=0; x<img.getWidth(); x++){
			var gray = Math.ceil(((img.getIntComponent0(x, y)*0.3)+(img.getIntComponent1(x, y)*0.59)+(img.getIntComponent2(x, y)*0.11)));
			
			if(gray <= threshold){
				resultImage.setBinaryColor(x, y, true);
			}
			else{
				resultImage.setBinaryColor(x, y, false);
			}
		}
	}
	return resultImage;
};

MarvinColorModelConverter.binaryToRgb = function(img){
	var resultImage = new MarvinImage(img.getWidth(), img.getHeight(), MarvinImage.COLOR_MODEL_RGB);

	for(var y=0; y<img.getHeight(); y++){
		for(var x=0; x<img.getWidth(); x++){
			if(img.getBinaryColor(x, y)){
				resultImage.setIntColor(x, y, 255, 0,0,0);
			}
			else{
				resultImage.setIntColor(x, y, 255, 255,255,255);
			}
		}
	}
	return resultImage;
};
	
MarvinColorModelConverter.rgbToHsv = function(rgbArray){
	var hsvArray = new Array(rgbArray.length*3);
	
	var red,green,blue;
	for(var i=0; i<rgbArray.length; i++){
		red = (rgbArray[i] & 0xFF0000) >>> 16;
		green = (rgbArray[i] & 0x00FF00) >>> 8;
		blue = (rgbArray[i] & 0x0000FF);
		
		red /=255.0;
		green /=255.0;
		blue /=255.0;
		
		var max = Math.max(Math.max(red, green), blue);
		var min = Math.min(Math.min(red, green), blue);
		var c = max-min;
		
		// H 
		var h,s,v;
		if(c !=0 ){
			if(max == red){
				if(green >= blue){
					h = 60 * ((green-blue)/c);
				} else{
					h = 60 * ((green-blue)/c) + 360;
				}
			} else if(max == green){
				h = 60 * ((blue-red)/c) + 120;
			} else{
				h = 60 * ((red-green)/c) + 240;
			}
		} else{
			h = 0;
		}
		
		
		// V
		v = max;
		
		// S
		s = (c!=0? c/v : 0);
		
		hsvArray[(i*3)] = h;
		hsvArray[(i*3)+1] = s;
		hsvArray[(i*3)+2] = v;
		
	}
	return hsvArray;
};
	
MarvinColorModelConverter.hsvToRgb = function(hsvArray){
	var rgbArray = new Array(hsvArray.length/3);
	
	for(var i=0, j=0; i<hsvArray.length; i+=3, j++){
		var h = hsvArray[i];
		var s = hsvArray[i+1];
		var v = hsvArray[i+2];
		
		// HSV to RGB
		var hi = Math.ceil(h/60 % 6);
		var f = (h/60) - hi;
		var p = v * (1-s);
		var q = v * (1 - f*s);
		var t = v * (1 - (1 - f) * s);
		
		var iHi = Math.ceil(hi);
		
		var r=0,g=0,b=0;
		
		switch(iHi){
			case 0:	r = Math.ceil(v*255);	g = Math.ceil(t*255);	b = Math.ceil(p*255);	break;
			case 1:	r = Math.ceil(q*255);	g = Math.ceil(v*255);	b = Math.ceil(p*255);	break; 
			case 2:	r = Math.ceil(p*255);	g = Math.ceil(v*255);	b = Math.ceil(t*255);	break; 
			case 3:	r = Math.ceil(p*255);	g = Math.ceil(q*255);	b = Math.ceil(v*255);	break; 
			case 4:	r = Math.ceil(t*255);	g = Math.ceil(p*255);	b = Math.ceil(v*255);	break;
			case 5:	r = Math.ceil(v*255);	g = Math.ceil(p*255);	b = Math.ceil(q*255);	break;
		}
		
		rgbArray[j] = 0xFF000000 + (r << 16) + (g << 8) + b; 
		
	}
	
	return rgbArray;
};
function MarvinImage(width, height, colorModel){
	// properties
	this.image = null;
	this.canvas = null;
	this.ctx=null;
	this.data = null;
	
	if(colorModel == null){
		this.colorModel = MarvinImage.COLOR_MODEL_RGB;
	} else{
		this.colorModel = colorModel;
	}
	
	if(width != null){
		this.create(width, height);
	}
	
	if(colorModel == MarvinImage.COLOR_MODEL_BINARY){
		this.arrBinaryColor = new Array(width*height);
	}
}

MarvinImage.COLOR_MODEL_RGB = 0;
MarvinImage.COLOR_MODEL_BINARY = 1;

MarvinImage.prototype.create = function(width, height){
	this.canvas = document.createElement('canvas');
	this.canvas.width = width;
	this.canvas.height = height;
	this.ctx = this.canvas.getContext("2d");
	this.imageData = this.ctx.getImageData(0, 0, width, height);
	this.width = width;
	this.height = height;
};

MarvinImage.prototype.setDimension = function(width, height){
	this.create(width, height);
};

MarvinImage.prototype.load = function(url, callback){
	this.onload = callback;
	this.image = new Image();
	var ref = this;
	this.image.onload = function(){ref.callbackImageLoaded(ref)};
	this.image.crossOrigin="anonymous";
	this.image.src = url;
};

// WARN: the callback "this" object is the reference to js Image object. 
MarvinImage.prototype.callbackImageLoaded = function(marvinImage){
	marvinImage.width = marvinImage.image.width;
	marvinImage.height = marvinImage.image.height;
	marvinImage.canvas = document.createElement('canvas');
	marvinImage.canvas.width = marvinImage.image.width;
	marvinImage.canvas.height = marvinImage.image.height;
	
	
	marvinImage.ctx = marvinImage.canvas.getContext("2d");
	marvinImage.ctx.drawImage(marvinImage.image, 0, 0);
	
	this.imageData = marvinImage.ctx.getImageData(0, 0, marvinImage.getWidth(), marvinImage.getHeight());
	
	if(marvinImage.onload!=null){
		marvinImage.onload();
	}
};

MarvinImage.prototype.clone = function(){
	var image = new MarvinImage(this.getWidth(), this.getHeight(), this.colorModel);
	MarvinImage.copyColorArray(this, image);
	return image;
};

MarvinImage.prototype.update = function(color){
	this.canvas.getContext("2d").putImageData(this.imageData, 0,0);
};

MarvinImage.prototype.clear = function(color){
	for(var y=0; y<this.getHeight(); y++){
		for(var x=0; x<this.getWidth(); x++){
			this.setIntColor(x,y,color);
		}
	}
};

MarvinImage.prototype.getColorModel = function(){
	return this.colorModel;
};

MarvinImage.prototype.getAlphaComponent = function(x,y){
	var start = ((y*this.getWidth())+x)*4; 
	return this.imageData.data[start+3];
};


MarvinImage.prototype.setAlphaComponent = function(x,y, alpha){
	var start = ((y*this.getWidth())+x)*4; 
	this.imageData.data[start+3] = alpha;
};

MarvinImage.prototype.getIntComponent0 = function(x,y){
	var start = ((y*this.getWidth())+x)*4; 
	return this.imageData.data[start];
};

MarvinImage.prototype.getIntComponent1 = function(x,y){
	var start = ((y*this.getWidth())+x)*4; 
	return this.imageData.data[start+1];
};

MarvinImage.prototype.getIntComponent2 = function(x,y){
	var start = ((y*this.getWidth())+x)*4; 
	return this.imageData.data[start+2];
};

MarvinImage.prototype.setIntColor = function(x,y, a1, a2, a3, a4){
	if(a2 == null){
		this.setIntColor1(x,y,a1);
	} else if(a3 == null && a4 == null){ 
		this.setIntColor2(x,y,a1,a2);
	}
	else if(a4 == null){
		this.setIntColor3(x,y,a1,a2,a3);
	}
	else{
		this.setIntColor4(x,y,a1,a2,a3,a4);
	}
};

MarvinImage.prototype.getIntColor = function(x,y){
	var start = ((y*this.getWidth())+x)*4;
	
	return 	0x100000000 + 
			(this.imageData.data[start+3] << 24) + 
			(this.imageData.data[start] << 16) +
			(this.imageData.data[start+1] << 8) +
			(this.imageData.data[start+2]);
};

MarvinImage.prototype.setIntColor1 = function(x,y, color){
	var a = (color & 0xFF000000) >>> 24;
	var r = (color & 0x00FF0000) >> 16;
	var g = (color & 0x0000FF00) >> 8;
	var b = color & 0x000000FF;
	this.setIntColor4(x,y,a,r,g,b);
};

MarvinImage.prototype.setBinaryColor = function(x,y,value){
	var pos = ((y*this.getWidth())+x);
	this.arrBinaryColor[pos] = value;
};

MarvinImage.prototype.getBinaryColor = function(x,y){
	var pos = ((y*this.getWidth())+x);
	return this.arrBinaryColor[pos];
};

MarvinImage.copyColorArray = function(imgSource, imgDestine){
		
	if(imgSource.getColorModel() == imgDestine.getColorModel()){
		switch(imgSource.getColorModel()){
			case MarvinImage.COLOR_MODEL_RGB:
				for(var i=0; i<imgSource.imageData.data.length; i++){
					imgDestine.imageData.data[i] = imgSource.imageData.data[i];
				}
				break;
			case MarvinImage.COLOR_MODEL_BINARY:
				for(var i=0; i<imgSource.arrBinaryColor.length; i++){
					imgDestine.arrBinaryColor[i] = imgSource.arrBinaryColor[i];
				}
				break;
		}
	}
};

MarvinImage.prototype.drawRect = function(x,y, width, height, color){
	for(var i=x; i<x+width; i++){
		this.setIntColor(i, y, color);
		this.setIntColor(i, y+(height-1), color);
	}
	
	for(var i=y; i<y+height; i++){
		this.setIntColor(x, i, color);
		this.setIntColor(x+(width-1), i, color);
	}
};

MarvinImage.prototype.fillRect = function(x,y, width, height, color){
	for(var i=x; i<x+width; i++){
		for(var j=y; j<y+height; j++){
			if(i < this.getWidth() && j < this.getHeight()){
				this.setIntColor(i,j,color);
			}
		}
	}
};

MarvinImage.prototype.setColorToAlpha = function(color, alpha){
	for(var y=0; y<this.height; y++){
		for(var x=0; x<this.width; x++){
			if((this.getIntColor(x,y) & 0x00FFFFFF) == (color & 0x00FFFFFF)){
				this.setAlphaComponent(x,y,alpha);
			}
		}
	}
};

MarvinImage.prototype.setAlphaToColor = function(color){
	for(var y=0; y<this.height; y++){
		for(var x=0; x<this.width; x++){
			if(this.getAlphaComponent(x, y) == 0){
				this.setIntColor(x, y, 0xFFFFFFFF);
			}
		}
	}
};

MarvinImage.prototype.setIntColor2 = function(x,y, alpha, color){
	var r = (color & 0x00FF0000) >> 16;
	var g = (color & 0x0000FF00) >> 8;
	var b = color & 0x000000FF;
	this.setIntColor4(x,y,alpha,r,g,b);
};

MarvinImage.prototype.setIntColor3 = function(x,y, r, g, b){
	this.setIntColor4(x,y,255,r,g,b);
};

MarvinImage.prototype.setIntColor4 = function(x,y, alpha, r, g, b){
	var start = ((y*this.getWidth())+x)*4;
	this.imageData.data[start] = r;
	this.imageData.data[start+1] = g;
	this.imageData.data[start+2] = b;
	this.imageData.data[start+3] = alpha;
};

MarvinImage.prototype.getWidth = function(){
	return this.width;
};

MarvinImage.prototype.getHeight = function(){
	return this.height;
};

MarvinImage.prototype.isValidPosition = function(x, y){
	if(x >= 0 && x < this.width && y >= 0 && y < this.height){
		return true;
	}
	return false;
};

MarvinImage.prototype.draw = function(canvas, x, y, alphaCombination){
	if(x == null){x=0;}
	if(y == null){y=0;}
	canvas.getContext("2d").putImageData(this.imageData, x,y);/*
	if(alphaCombination == null || !alphaCombination){
		canvas.getContext("2d").putImageData(this.imageData, x,y);
	} else{
		this.imageData = this.ctx.getImageData(0, 0, width, height);
		var c = document.createElement('canvas');
		c.width = this.width;
		c.height = this.height;
		c.getContext('2d').putImageData(this.imageData,x,y); 
		var img = new Image();
		img.src = c.toDataURL();
		canvas.getContext("2d").drawImage(img, x, y);
	}*/
};

MarvinImage.prototype.toBlob = function(){
	this.update();
	return MarvinImage.dataURItoBlob(this.canvas.toDataURL("image/png"));
};

MarvinImage.dataURItoBlob = function(dataURI) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;
    if (dataURI.split(',')[0].indexOf('base64') >= 0)
        byteString = atob(dataURI.split(',')[1]);
    else
        byteString = unescape(dataURI.split(',')[1]);

    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ia], {type:mimeString});
}


	
	function MarvinImageMask (w, h){
		this.width = w;
		this.height = h;
		
		if(w != 0 && h != 0){
			this.arrMask = MarvinJSUtils.createMatrix2D(width, height);
		} else{
			this.arrMask = null;
		}
	};
	
	MarvinImageMask.prototype.getWidth = function(){
		return this.width;
	};
	
	MarvinImageMask.prototype.getHeight = function(){
		return this.height;
	};
	
	MarvinImageMask.prototype.addPixel = function(x, y){
		this.arrMask[x][y] = true;
	};
	
	MarvinImageMask.prototype.removePixel = function(x, y){
		this.arrMask[x][y] = false;
	};
	
	MarvinImageMask.prototype.clear = function(){
		if(this.arrMask != null){
			for(var y=0; y<height; y++){
				for(var x=0; x<width; x++){
					this.arrMask[x][y] = false;
				}
			}
		}
	};
	
	MarvinImageMask.prototype.getMask = function(){
		return this.arrMask;
	};
	
	MarvinImageMask.prototype.addRectRegion = function(startX, startY, regionWidth, regionHeight){
		for(var x=startX; x<startX+regionWidth; x++){
			for(var y=startY; y<startY+regionHeight; y++){
				this.arrMask[x][y] = true;
			}
		}
	};
	
	MarvinImageMask.createNullMask = function(){
		return new MarvinImageMask(0,0);
	};

	MarvinImageMask.NULL_MASK = MarvinImageMask.createNullMask();


	function MarvinSegment(x1, y1, x2, y2){
		this.x1 = x1;
		this.x2 = x2;
		this.y1 = y1;
		this.y2 = y2;
		
		if(x1 != -1 && y1 != -1 && x2 != -1 && y2 != -1){
			this.width = (x2-x1)+1;
			this.height = (y2-y1)+1;
			this.area = this.width*this.height;
		}
	}
	
	MarvinSegment.segmentMinDistance = function(segments, minDistance){
		var s1,s2;
		for(var i=0; i<segments.size()-1; i++){
			for(var j=i+1; j<segments.size(); j++){
				s1 = segments[i];
				s2 = segments[j];
				
				if(MarvinMath.euclidianDistance( (s1.x1+s1.x2)/2, (s1.y1+s1.y2)/2, (s2.x1+s2.x2)/2, (s2.y1+s2.y2)/2 ) < minDistance){
					segments.splice(j, 1);
					j--;
				}
			}
		}
	}



function MarvinColor(red, green, blue){
	this.red = red;
	this.green = green;
	this.blue = blue;
	return this;
}

MarvinColor.prototype.setId = function(id){
	this.id = id;
};

MarvinColor.prototype.getId = function(){
	return this.id;
};

MarvinColor.prototype.setName = function(name){
	this.name = name;
};

MarvinColor.prototype.getName = function(){
	return this.name;
};
var MarvinJSUtils = new Object();

MarvinJSUtils.createMatrix2D = function(rows, cols, value){
	var arr = new Array(rows);
	for(var i=0; i<arr.length; i++){
		arr[i] = new Array(cols);
		arr[i].fill(value)
	}
	return arr;
};

MarvinJSUtils.createMatrix3D = function(rows, cols, depth, value){
	var arr = new Array(rows);
	for(var i=0; i<arr.length; i++){
		arr[i] = new Array(cols);
		for(var j=0; j<arr[i].length; j++){
			arr[i][j] = new Array(depth);
			arr[i][j].fill(value)
		}
	}
	return arr;
};

MarvinJSUtils.createMatrix4D = function(rows, cols, depth, another, value){
	var arr = new Array(rows);
	for(var i=0; i<arr.length; i++){
		arr[i] = new Array(cols);
		for(var j=0; j<arr[i].length; j++){
			arr[i][j] = new Array(depth);
			for(var w=0; w<arr[i][j].length; w++){
				arr[i][j][w] = new Array(another);
				arr[i][j][w].fill(value);
			}
		}
	}
	return arr;
};
var MarvinMath = new Object();

MarvinMath.getTrueMatrix = function(rows, cols){
	var ret = MarvinJSUtils.createMatrix2D(rows, cols);
	
	for(var i=0; i<rows; i++){
		for(var j=0; j<cols; j++){
			ret[i][j]  = true;
		}
	}
	return ret;
};

MarvinMath.scaleMatrix = function(matrix, scale){
	var ret = MarvinJSUtils.createMatrix2D(matrix.length, matrix.length);
	
	for(var i=0; i<matrix.length; i++){
		for(var j=0; j<matrix.length; j++){
			ret[i][j] = matrix[i][j] * scale;
		}
	}
	return ret;
};

MarvinMath.euclideanDistance = function(p1, p2, p3, p4, p5, p6){
	if(p6 != null){
		return MarvinMath.euclideanDistance3D(p1, p2, p3, p4, p5, p6);
	} else{
		return MarvinMath.euclideanDistance3D(p1, p2, p3, p4);
	}
};

MarvinMath.euclideanDistance2D = function(x1, y1, x2, y2){
	var dx = (x1-x2);
	var dy = (y1-y2);
	return Math.sqrt( dx*dx + dy*dy);
};

MarvinMath.euclideanDistance3D = function(x1, y1, z1, x2, y2, z2){
	var dx = (x1-x2);
	var dy = (y1-y2);
	var dz = (z1-z2);
	return Math.sqrt( dx*dx + dy*dy + dz*dz);
};


	function DetermineFixedCameraBackground(){
		MarvinAbstractImagePlugin.super(this);
		this.load();
	}
		
	DetermineFixedCameraBackground.prototype.load = function(){
		this.initialized=false;
	}
	
	DetermineFixedCameraBackground.prototype.initialize = function(imageIn){
		this.weights = this.weights = MarvinJSUtils.createMatrix4D(imageIn.getWidth(), imageIn.getHeight(), 3, 26, 0);
		initialized=true;
	}
	
	DetermineFixedCameraBackground.prototype.process = function
	(
		imageIn, 
		imageOut,
		attributesOut,
		mask, 
		previewMode
	)
	{
		if(!this.initialized){
			this.initialize(imageIn);
		}
		
		for(var y=0; y<imageIn.getHeight(); y++){
			for(var x=0; x<imageIn.getWidth(); x++){
				var red 	= imageIn.getIntComponent0(x, y);
				var green 	= imageIn.getIntComponent1(x, y);
				var blue 	= imageIn.getIntComponent2(x, y);
				
				
				weights[x][y][0][red/10]++;
				weights[x][y][1][green/10]++;
				weights[x][y][2][blue/10]++;
				
				
				imageOut.setIntColor(x, y, 255, this.getProbableColor(weights[x][y][0]), this.getProbableColor(weights[x][y][1]), this.getProbableColor(weights[x][y][2]));
			}
		}	
	}
	
	DetermineFixedCameraBackground.prototype.getProbableColor = function(arr){
		var max = -1;
		var maxIndex = 0;
		
		for(var i=0; i<arr.length; i++){
		if(max == -1 || arr[i] > max){
				max = arr[i];
				maxIndex = i;
			}
		}
		
		return maxIndex*10;
	}


	function DetermineSceneBackground(){
		MarvinAbstractImagePlugin.super(this);
		this.load();
	}

	DetermineSceneBackground.prototype.load = function() {
		this.setAttribute("threshold", 30);
	}
	
	
	DetermineSceneBackground.prototype.process = function
	(
		images,
		imageOut
	)
	{
		var threshold = this.getAttribute("threshold");
		var image0 = images[0];
		for(var y=0; y<image0.getHeight(); y++){
			for(var x=0; x<image0.getWidth(); x++){
				imageOut.setIntColor(x, y, this.getBackgroundPixel(x,y, images, threshold));
			}
		}	
	}
	
	DetermineSceneBackground.prototype.getBackgroundPixel = function(x, y, images, threshold){
		var colors = new Array();
		for(var i in images){
			var img = images[i];
			var c = new Array(4);
			c[0] = img.getIntComponent0(x, y);
			c[1] = img.getIntComponent1(x, y);
			c[2] = img.getIntComponent2(x, y);
			c[3] = 0;
			
			if(colors.length == 0){
				colors.push(c);
			}
			else{
				var found=false;
				for(var j in colors){
					var c2 = colors[j];
					if
					(
						Math.abs(c2[0]-c[0]) < threshold*0.3 &&
						Math.abs(c2[1]-c[1]) < threshold*0.3 &&
						Math.abs(c2[2]-c[2]) < threshold*0.3
					){
						c2[0] = Math.floor((c2[0]+c[0])/2);
						c2[1] = Math.floor((c2[1]+c[1])/2);
						c2[2] = Math.floor((c2[2]+c[2])/2);
						c2[3]++;
						found=true;
						break;
					}
				}
				
				if(!found){
					colors.push(c);
				}
			}
		}
		
		var max=-1;
		var maxIndex=0;
		var c2 = null;
		for(var i=0; i<colors.length; i++){
			c2 = colors[i];
			if(max == -1 || c2[3] > max){
				max = c2[3];
				maxIndex = i; 
			}
		}
		c2 = colors[maxIndex];
		return 0xFF000000 + (c2[0] << 16) + (c2[1] << 8) + c2[2]; 
	}

	function GaussianBlur(){
		MarvinAbstractImagePlugin.super(this);
		this.load();
	}

	GaussianBlur.prototype.load = function(){
		
		this.RED = 0;
		this.GREEN = 1;
		this.BLUE = 2;

		this.kernelMatrix = null;
		this.resultMatrix = null;
		this.appiledkernelMatrix = null;
		this.radius = null;
		
		this.setAttribute("radius",3);
	}
	
	GaussianBlur.prototype.process = function
	(
		imageIn, 
		imageOut,
		attributesOut,
		mask, 
		previewMode
	)
	{
		this.radius = this.getAttribute("radius");

		var l_imageWidth = imageIn.getWidth();
		var l_imageHeight = imageIn.getHeight();

		var l_pixelColor;
		this.kernelMatrix = this.getGaussianKernel();
		this.resultMatrix = MarvinJSUtils.createMatrix3D(l_imageWidth, l_imageHeight, 3, 0);
		this.appiledkernelMatrix = MarvinJSUtils.createMatrix2D(l_imageWidth, l_imageHeight, 0);
		
		var l_arrMask = mask.getMask();
		
		for (var x = 0; x < l_imageWidth; x++) {
			for (var y = 0; y < l_imageHeight; y++) {	
				if(l_arrMask != null && !l_arrMask[x][y]){
					continue;
				}
				l_pixelColor = imageIn.getIntColor(x,y);
				this.applyKernel(x,y,l_pixelColor,imageOut);
			}
		}
		
		for (var x = 0; x < l_imageWidth; x++) {
			for (var y = 0; y < l_imageHeight; y++) {
				if(l_arrMask != null && !l_arrMask[x][y]){
					continue;
				}
				this.resultMatrix[x][y][this.RED] = ((this.resultMatrix[x][y][0]/this.appiledkernelMatrix[x][y])%256);
				this.resultMatrix[x][y][this.GREEN] = ((this.resultMatrix[x][y][1]/this.appiledkernelMatrix[x][y])%256);
				this.resultMatrix[x][y][this.BLUE] = ((this.resultMatrix[x][y][2]/this.appiledkernelMatrix[x][y])%256);
				imageOut.setIntColor(x,y,imageIn.getAlphaComponent(x, y), Math.floor(this.resultMatrix[x][y][0]), Math.floor(this.resultMatrix[x][y][1]), Math.floor(this.resultMatrix[x][y][2]));
			}		
		}
	}

	/*
	 * Calc Gaussian Matrix.
	 */
	 GaussianBlur.prototype.getGaussianKernel = function(){
		var l_matrix = MarvinJSUtils.createMatrix2D((this.radius*2)+1, (this.radius*2)+1);
		var l_q=this.radius/3.0;
		var l_distance;
		var l_x;
		var l_y;
		
		for(var x=1; x<=(this.radius*2)+1; x++){
			for(var y=1; y<=(this.radius*2)+1; y++){
				l_x = Math.abs(x-(this.radius+1));
				l_y = Math.abs(y-(this.radius+1));
				l_distance = Math.sqrt((l_x*l_x)+(l_y*l_y));
				l_matrix[y-1][x-1] = ( (1.0/(2.0*Math.PI*l_q*l_q))* Math.exp( (-(l_distance*l_distance)) / (2.0*l_q*l_q) ) );
			}
		}
		return l_matrix;
	}

	/*
	 * Apply the blur matrix on a image region. 
	 */
	GaussianBlur.prototype.applyKernel = function(centerPixel_X, centerPixel_Y, pixelColor, image)
	{
		for(var y=centerPixel_Y; y<centerPixel_Y+(this.radius*2); y++){
			for(var x=centerPixel_X; x<centerPixel_X+(this.radius*2); x++){
				if(x-this.radius >= 0 && x-this.radius < image.getWidth() && y-this.radius >= 0 && y-this.radius < image.getHeight()){
					this.resultMatrix[x-this.radius][y-this.radius][this.RED]+= (((pixelColor & 0x00FF0000) >>> 16)*this.kernelMatrix[x-centerPixel_X][y-centerPixel_Y]);
					this.resultMatrix[x-this.radius][y-this.radius][this.GREEN]+= (((pixelColor & 0x0000FF00) >>> 8)*this.kernelMatrix[x-centerPixel_X][y-centerPixel_Y]);
					this.resultMatrix[x-this.radius][y-this.radius][this.BLUE]+= ((pixelColor & 0x000000FF)*this.kernelMatrix[x-centerPixel_X][y-centerPixel_Y]);
					this.appiledkernelMatrix[x-this.radius][y-this.radius] += this.kernelMatrix[x-centerPixel_X][y-centerPixel_Y];
				}
			}
		}
	}
	function AlphaBoundary(){
		MarvinAbstractImagePlugin.super(this);
		this.load();
	}

	AlphaBoundary.prototype.load = function(){
		this.setAttribute("radius", 5);
	};
	
	AlphaBoundary.prototype.process = function
	(
		imageIn, 
		imageOut,
		attributesOut,
		mask, 
		previewMode
	)
	{
		var neighborhood = this.getAttribute("radius");
		for(var y=0; y<imageOut.getHeight(); y++){
			for(var x=0; x<imageOut.getWidth(); x++){
				this.alphaRadius(imageOut, x, y, neighborhood);
			}
		}
	};
	
	AlphaBoundary.prototype.alphaRadius = function(image, x, y, radius){
		
		var oldAlpha = image.getAlphaComponent(x, y);
		var newAlpha;
		var totalAlpha=0;
		var totalPixels=0;
		var hn = Math.floor(radius/2);
		
		for(var j=y-hn; j<y+hn; j++){
			for(var i=x-hn; i<x+hn; i++){
				
				if(i >= 0 && i< image.getWidth() && j >= 0 && j < image.getHeight()){
					totalAlpha += image.getAlphaComponent(i, j);
					totalPixels++;
				}
			}
		}
		
		newAlpha = Math.floor(totalAlpha/totalPixels);
		
		if(newAlpha < oldAlpha)
		image.setAlphaComponent(x, y, newAlpha);
	};


	function AverageColor(){
		MarvinAbstractImagePlugin.super(this);
		this.load();
	}

	AverageColor.prototype.load = function(){
	};
	
	AverageColor.prototype.process = function
	(
		imageIn, 
		imageOut,
		attributesOut,
		mask, 
		previewMode
	)
	{
		
		var totalR=0;
		var totalG=0;
		var totalB=0;
		
		for (var x = 0; x < imageIn.getWidth(); x++) {
			for (var y = 0; y < imageIn.getHeight(); y++) {
				totalR += imageIn.getIntComponent0(x,y);
				totalG += imageIn.getIntComponent1(x,y);
				totalB += imageIn.getIntComponent2(x,y);
			}
		}
		
		var totalPixels = imageIn.getWidth()*imageIn.getHeight();
		totalR = Math.round(totalR/totalPixels);
		totalG = Math.round(totalG/totalPixels);
		totalB = Math.round(totalB/totalPixels);
		
		if(attributesOut != null){
			attributesOut.set("averageColor", [totalR, totalG, totalB]);
		}
	};

	function BlackAndWhite(){
		MarvinAbstractImagePlugin.super(this);
		this.MAX_RLEVEL = 0.03;
		this.load();
	}
	
	BlackAndWhite.prototype.load = function() {
		this.grayScale = new GrayScale();
		this.setAttribute("level", 10);
	}
	
	BlackAndWhite.prototype.process = function
	(
		imageIn, 
		imageOut,
		attributesOut,
		mask, 
		previewMode
	)
	{
		this.grayScale.process(imageIn, imageOut);
		var level = this.getAttribute("level");
		var rlevel = (level/100.0)*this.MAX_RLEVEL;
		
		var c=0;
		var gray;
		for(var y=0; y<imageOut.getHeight(); y++){
			for(var x=0; x<imageOut.getWidth(); x++){
				gray = imageIn.getIntComponent0(x, y);
				
				
				if(gray <= 127){
					gray = Math.max((gray * (1 - ((127-gray)*rlevel))),0);
				}
				else{
					gray = Math.min(gray* (1+((gray-127)*rlevel)), 255);
				}
				
				if(c++ < 1){
					console.log("gray:"+gray);
					console.log("level:"+level);
					console.log("rlevel:"+rlevel);
					
				}
				
				imageOut.setIntColor(x, y, 255, Math.floor(gray), Math.floor(gray), Math.floor(gray));
			}
		}
	}

	function BrightnessAndContrast(){
		MarvinAbstractImagePlugin.super(this);
		this.load();
	}

	BrightnessAndContrast.prototype.load = function(){
		// Attributes
		this.setAttribute("brightness", 0);
		this.setAttribute("contrast", 0);
	}

	BrightnessAndContrast.prototype.process = function
	(
		imageIn, 
		imageOut,
		attributesOut,
		mask, 
		previewMode
	)
	{
		var r,g,b;
		var l_brightness = this.getAttribute("brightness");
		var l_contrast = this.getAttribute("contrast");
		l_contrast = Math.pow((127 + l_contrast)/127, 2);

		// Brightness
		for (var x = 0; x < imageIn.getWidth(); x++) {
			for (var y = 0; y < imageIn.getHeight(); y++) {
				r = imageIn.getIntComponent0(x, y);
				g = imageIn.getIntComponent1(x, y);
				b = imageIn.getIntComponent2(x, y);

				r+= (1-(r/255))*l_brightness;
				g+= (1-(g/255))*l_brightness;
				b+= (1-(b/255))*l_brightness;
				if(r < 0) r=0;
				if(r > 255) r=255;
				if(g < 0) g=0;
				if(g > 255) g=255;
				if(b < 0) b=0;
				if(b > 255) b=255;

				imageOut.setIntColor(x,y,imageIn.getAlphaComponent(x, y), Math.floor(r),Math.floor(g),Math.floor(b));
			}
		}

		// Contrast
		for (var x = 0; x < imageIn.getWidth(); x++) {
			for (var y = 0; y < imageIn.getHeight(); y++) {
				r = imageOut.getIntComponent0(x, y);
				g = imageOut.getIntComponent1(x, y);
				b = imageOut.getIntComponent2(x, y);

				
				r /= 255.0;
				r -= 0.5;
				r *= l_contrast;
				r += 0.5;
				r *= 255.0;

				g /= 255.0;
				g -= 0.5;
				g *= l_contrast;
				g += 0.5;
				g *= 255.0;

				b /= 255.0;
				b -= 0.5;
				b *= l_contrast;
				b += 0.5;
				b *= 255.0;
				

				if(r < 0) r=0;
				if(r > 255) r=255;
				if(g < 0) g=0;
				if(g > 255) g=255;
				if(b < 0) b=0;
				if(b > 255) b=255;

				imageOut.setIntColor(x,y,imageIn.getAlphaComponent(x, y), Math.floor(r),Math.floor(g),Math.floor(b));
			}
		}
	};


	function ColorChannel(){
		MarvinAbstractImagePlugin.super(this);
		this.load();
	}

	ColorChannel.prototype.load = function() {
		this.setAttribute("red", 0);
		this.setAttribute("green", 0);
		this.setAttribute("blue", 0);
	}
	
	ColorChannel.prototype.process = function
	(
		imageIn, 
		imageOut,
		attributesOut,
		mask, 
		previewMode
	)
	{
		
		var vr = this.getAttribute("red");
		var vg = this.getAttribute("green");
		var vb = this.getAttribute("blue");
		
		var mr = 1+Math.abs((vr/100.0)*2.5);
		var mg = 1+Math.abs((vg/100.0)*2.5);
		var mb = 1+Math.abs((vb/100.0)*2.5);
		
		mr = (vr > 0? mr : 1.0/mr);
		mg = (vg > 0? mg : 1.0/mg);
		mb = (vb > 0? mb : 1.0/mb);
		
		var red,green,blue;
		for(var y=0; y<imageIn.getHeight(); y++){
			for(var x=0; x<imageIn.getWidth(); x++){
				red = imageIn.getIntComponent0(x, y);
				green = imageIn.getIntComponent1(x, y);
				blue = imageIn.getIntComponent2(x, y);
				
				red 	= Math.min(red * mr, 255);
				green 	= Math.min(green * mg, 255);
				blue	= Math.min(blue * mb, 255);
				
				imageOut.setIntColor(x, y, 255, red, green, blue);
			}
		}
	}


	function Emboss(){
		MarvinAbstractImagePlugin.super(this);
		this.load();
	}

	Emboss.prototype.load = function(){}
	
	Emboss.prototype.process = function
	(
		imageIn, 
		imageOut,
		attributesOut,
		mask, 
		previewMode
	)
	{
		var l_arrMask = mask.getMask();
		
		for (var x = 0; x < imageIn.getWidth(); x++) {
			for (var y = 0; y < imageIn.getHeight(); y++) {
				if(l_arrMask != null && !l_arrMask[x][y]){
					imageOut.setIntColor(x, y, 255, imageIn.getIntColor(x, y));
					continue;
				}
				             
				var rDiff=0; 
				var gDiff=0;
				var bDiff=0;
				
	             if (y > 0 && x > 0){
     
		             // Red component difference between the current and the upperleft pixels
	            	 rDiff = imageIn.getIntComponent0(x, y) - imageIn.getIntComponent0(x-1, y-1);
		             
		             // Green component difference between the current and the upperleft pixels
	            	 gDiff = imageIn.getIntComponent1(x, y) - imageIn.getIntComponent1(x-1, y-1);
		             
		             // Blue component difference between the current and the upperleft pixels
	            	 bDiff = imageIn.getIntComponent2(x, y) - imageIn.getIntComponent2(x-1, y-1);
		             
	             }
	             else{
	            	 rDiff = 0;
	            	 gDiff = 0;
	            	 bDiff = 0;
	             }
		    
		         var diff = rDiff;
		         if (Math.abs (gDiff) > Math.abs (diff))
		              diff = gDiff;
		         if (Math.abs (bDiff) > Math.abs (diff))
		              diff = bDiff;
	
		         var grayLevel = Math.max (Math.min (128 + diff, 255),0);
	
		        imageOut.setIntColor(x, y, 255, grayLevel, grayLevel, grayLevel);
			}
		}
	}

	function GrayScale(){
		MarvinAbstractImagePlugin.super(this);
		this.load();
	}
	
	GrayScale.prototype.load = function(){};
	
	GrayScale.prototype.process = function
	(
		imageIn, 
		imageOut,
		attributesOut,
		mask, 
		previewMode
	)
	{
		// Mask
		var l_arrMask;
		if(mask != null){
			l_arrMask = mask.getMask();
		}
		
		var r,g,b,finalColor;
		for (var x = 0; x < imageIn.getWidth(); x++) {
			for (var y = 0; y < imageIn.getHeight(); y++) {
				if(l_arrMask != null && !l_arrMask[x][y]){
					continue;
				}
				//Red - 30% / Green - 59% / Blue - 11%
				r = imageIn.getIntComponent0(x, y);
				g = imageIn.getIntComponent1(x, y);
				b = imageIn.getIntComponent2(x, y);
				finalColor = Math.ceil((r*0.3)+(g*0.59)+(b*0.11));
				imageOut.setIntColor(x,y,imageIn.getAlphaComponent(x, y), finalColor,finalColor,finalColor);
								
			}
		}
	};


	function Invert(){
		MarvinAbstractImagePlugin.super(this);
		this.load();
	}
	
	Invert.prototype.load = function(){}
	
	Invert.prototype.process = function
	(
		imageIn, 
		imageOut,
		attributesOut,
		mask, 
		previewMode
	)
	{
		var l_arrMask = mask.getMask();
		
		var r, g, b;
		for (var x = 0; x < imageIn.getWidth(); x++) {
			for (var y = 0; y < imageIn.getHeight(); y++) {
				if(l_arrMask != null && !l_arrMask[x][y]){
					continue;
				}
				r = (255-imageIn.getIntComponent0(x, y));
				g = (255-imageIn.getIntComponent1(x, y));
				b = (255-imageIn.getIntComponent2(x, y));

				imageOut.setIntColor(x,y,imageIn.getAlphaComponent(x, y), r,g,b);
			}
		}
	}
	function Sepia(){
		MarvinAbstractImagePlugin.super(this);
		this.load();
	}	
	
	Sepia.prototype.load = function() {
		this.setAttribute("txtValue", "20");
		this.setAttribute("intensity", 20);
	}

	Sepia.prototype.process = function
	(
		imageIn, 
		imageOut,
		attributesOut,
		mask, 
		previewMode
	)
	{
		var r, g, b, depth, corfinal;
		
		//Define a intensidade do filtro...
		depth = this.getAttribute("intensity");
		
		var width    = imageIn.getWidth();
		var height   = imageIn.getHeight();
		
		var l_arrMask = mask.getMask();
		
		for (var x = 0; x < imageIn.getWidth(); x++) {
			for (var y = 0; y < imageIn.getHeight(); y++) {
				if(l_arrMask != null && !l_arrMask[x][y]){
					continue;
				}
				//Captura o RGB do ponto...
				r = imageIn.getIntComponent0(x, y);
				g = imageIn.getIntComponent1(x, y);
				b = imageIn.getIntComponent2(x, y);
				
				//Define a cor como a m�dia aritm�tica do pixel...
				corfinal = (r + g + b) / 3;
				r = g = b = corfinal;
				 
				r = this.truncate(r + (depth * 2));
				g = this.truncate(g + depth);
			
				//Define a nova cor do ponto...
				imageOut.setIntColor(x, y, imageIn.getAlphaComponent(x, y), r, g, b);
			}
		}
	}

	/**
	 * Sets the RGB between 0 and 255
	 * @param a
	 * @return
	 */
	Sepia.prototype.truncate = function(a) {
		if      (a <   0) return 0;
		else if (a > 255) return 255;
		else              return a;
	}

	function Thresholding(){
		MarvinAbstractImagePlugin.super(this);
		this.load();
		
		this.threshold = null;
		this.thresholdRange = null;
		this.neighborhood = null;
		this.range = null;
	}

	Thresholding.prototype.load = function(){
		
		// Attributes
		this.setAttribute("threshold", 125);
		this.setAttribute("thresholdRange", -1);
		this.setAttribute("neighborhood", -1);
		this.setAttribute("range", -1);
		
		this.pluginGray = new GrayScale();
	}
	
	Thresholding.prototype.process = function
	(
		imageIn, 
		imageOut,
		attributesOut,
		mask, 
		previewMode
	)
	{
		this.threshold = this.getAttribute("threshold");
		this.thresholdRange = this.getAttribute("thresholdRange");
		this.neighborhood = this.getAttribute("neighborhood");
		this.range = this.getAttribute("range");
		
		if(this.thresholdRange == -1){
			this.thresholdRange = 255-threshold;
		}
		
		this.pluginGray.process(imageIn, imageOut, attributesOut, mask, previewMode);
		
		var bmask = mask.getMask();
		
		if(this.neighborhood == -1 && this.range == -1){
			this.hardThreshold(imageIn, imageOut, bmask);
		}
		else{
			this.contrastThreshold(imageIn, imageOut);
		}
				
	}
	
	Thresholding.prototype.hardThreshold = function(imageIn, imageOut, mask){
		for(var y=0; y<imageIn.getHeight(); y++){
			for(var x=0; x<imageIn.getWidth(); x++){
				if(mask != null && !mask[x][y]){
					continue;
				}
				
				var gray = imageIn.getIntComponent0(x,y); 
				if(gray < this.threshold || gray > this.threshold+this.thresholdRange){
					imageOut.setIntColor(x, y, imageIn.getAlphaComponent(x,y), 0,0,0);
				}
				else{
					imageOut.setIntColor(x, y, imageIn.getAlphaComponent(x,y), 255,255,255);
				}				
			}
		}	
	}
	
	Thresholding.prototype.contrastThreshold = function(imageIn, imageOut){
		this.range = 1;
		for (var x = 0; x < imageIn.getWidth(); x++) {
			for (var y = 0; y < imageIn.getHeight(); y++) {
				if(checkNeighbors(x,y, neighborhood, neighborhood, imageIn)){
					imageOut.setIntColor(x,y,0,0,0);
				}
				else{
					imageOut.setIntColor(x,y,255,255,255);
				}
			}
		}
	}
	
	Thresholding.prototype.checkNeighbors = function(x, y, neighborhoodX, neighborhoodY, img){
		
		var color;
		var z=0;
		
		color = img.getIntComponent0(x, y);
		
		for(var i=0-neighborhoodX; i<=neighborhoodX; i++){
			for(var j=0-neighborhoodY; j<=neighborhoodY; j++){
				if(i == 0 && j == 0){
					continue;
				}
				
				if(color < getSafeColor(x+i,y+j, img)-range && getSafeColor(x+i,y+j, img) != -1){
					z++;
				}
			}
		}
		
		if(z > (neighborhoodX*neighborhoodY)*0.5){
			return true;
		}
		
		return false;
	};
	
	Thresholding.prototype.getSafeColor = function(x, y, img){
		
		if(x >= 0 && x < img.getWidth() && y >= 0 && y < img.getHeight()){
			return img.getIntComponent0(x, y);
		}
		return -1;
	};

	function ThresholdingNeighborhood(){
		MarvinAbstractImagePlugin.super(this);
		this.load();
	}

	ThresholdingNeighborhood.prototype.load = function() {
		this.setAttribute("neighborhoodSide", 10);
		this.setAttribute("samplingPixelDistance", 1);
		this.setAttribute("thresholdPercentageOfAverage", 1.0);
	}

	ThresholdingNeighborhood.prototype.process = function
	(
		imageIn, 
		imageOut,
		attributesOut,
		mask, 
		previewMode
	)
	{
		var neighborhoodSide = this.getAttribute("neighborhoodSide");
		var samplingPixelDistance = this.getAttribute("samplingPixelDistance");
		var thresholdPercentageOfAverage = this.getAttribute("thresholdPercentageOfAverage");
		
		for(var y=0; y<imageIn.getHeight(); y++){
			for(var x=0; x<imageIn.getWidth(); x++){
				this.theshold(imageIn, imageOut, x, y, thresholdPercentageOfAverage, neighborhoodSide, samplingPixelDistance);
			}
		}
	}
	
	ThresholdingNeighborhood.prototype.theshold = function(image, imageOut, x, y, thresholdPercentageOfAverage, side, neighborhoodDistance){
		
		var min=-1;
		var max=-1;
		var pixels=0;
		var average=0;
		
		var inc = neighborhoodDistance;
		
		
		for(var j=y-(side/2); j<y+(inc+side/2); j+=inc){
			for(var i=x-(side/2); i<x+(side/2); i+=inc){
				
				if(i >= 0 && j>= 0 && i < image.getWidth() && j < image.getHeight()){
					
					var color = image.getIntComponent0(i,j);
					
					if(min == -1 || color < min){
						min = color;
					}
					if(max == -1 || color > max){
						max = color;
					}
						
					average+=color;
					pixels++;
				}
			}
		}
		
		average /= pixels;
			
		var color = image.getIntComponent0(x,y);
		
		if(color < average*thresholdPercentageOfAverage || (max-min) <= 30){
			imageOut.setIntColor(x, y, 255, 0, 0, 0);
		} else{
			imageOut.setIntColor(x, y, 255, 255, 255, 255);
		}
	};

	function CombineByAlpha(){
		MarvinAbstractImagePlugin.super(this);
		this.load();
	}
	
	CombineByAlpha.prototype.load = function(){
		this.setAttribute("x", 0);
		this.setAttribute("y", 0);
		this.setAttribute("imageOther", null);
	}
	
	CombineByAlpha.prototype.process = function
	(
		imageIn, 
		imageOut,
		attributesOut,
		mask, 
		previewMode
	)
	{
		var imageOther = this.getAttribute("imageOther");
		var x = this.getAttribute("x");
		var y = this.getAttribute("y");
		
		if(imageOther != null){
			
			for(var j=0; j<imageIn.getHeight(); j++){
				for(var i=0; i<imageIn.getWidth(); i++){
					
					var ox = i-x;
					var oy = j-y;
					
					if(ox >= 0 && ox < imageOther.getWidth() && oy >= 0 && oy < imageOther.getHeight()){
						var alpha = imageOther.getAlphaComponent(ox,oy);
						if(alpha != 0){
							var factor = alpha/255;
							
							var rA = imageIn.getIntComponent0(i,j);
							var gA = imageIn.getIntComponent1(i,j);
							var bA = imageIn.getIntComponent2(i,j);
							
							var rB = imageOther.getIntComponent0(ox,oy);
							var gB = imageOther.getIntComponent1(ox,oy);
							var bB = imageOther.getIntComponent2(ox,oy);
							
							var red = Math.floor( (rA * (1-factor)) + (rB * (factor)) );
							var green = Math.floor( (gA * (1-factor)) + (gB * (factor)) );
							var blue = Math.floor( (bA * (1-factor)) + (bB * (factor)) );
							
							imageOut.setIntColor(i,j,Math.max(imageIn.getAlphaComponent(x,y), alpha), red, green, blue);
						} else{
							imageOut.setIntColor(i,j, imageIn.getIntColor(i,j));
						}
					} else{
						imageOut.setIntColor(i,j, imageIn.getIntColor(i,j));
					}
				}
			}
		}
	};
	function MergePhotos(){
		MarvinAbstractImagePlugin.super(this);
		this.load();
	}
	
	MergePhotos.prototype.load = function() {
		this.background = new DetermineSceneBackground();
		this.background.load();
		this.setAttribute("threshold", 30);
	}
	
	MergePhotos.prototype.process = function
	(
		images,
		imageOut
	)
	{
		if(images.length > 0){
			var threshold = this.getAttribute("threshold");
			this.background.setAttribute("threshold", threshold);
			var backgroundImage = images[0].clone();
			this.background.process(images, backgroundImage);
			MarvinImage.copyColorArray(backgroundImage, imageOut);
			this.mergePhotos(images, imageOut, backgroundImage, threshold);
		}
	}
	
	MergePhotos.prototype.mergePhotos = function(images, imageOut, background, threshold){
		for(var i in images){
			var img = images[i];
			this.mergePhotosSingle(img, imageOut, background, threshold);
		}
	}
	
	MergePhotos.prototype.mergePhotosSingle = function(imageA, imageB, imageBackground, threshold){
			
		var rA, gA, bA, rB, gB, bB;
		for(var y=0; y<imageA.getHeight(); y++){
			for(var x=0; x<imageA.getWidth(); x++){
				
				rA = imageA.getIntComponent0(x, y);
				gA = imageA.getIntComponent1(x, y);
				bA = imageA.getIntComponent2(x, y);
				rB = imageBackground.getIntComponent0(x, y);
				gB = imageBackground.getIntComponent1(x, y);
				bB = imageBackground.getIntComponent2(x, y);
				
				if
				(
					Math.abs(rA-rB) > threshold || 
					Math.abs(gA-gB) > threshold ||
					Math.abs(bA-bB) > threshold
				){
					
					imageB.setIntColor(x, y, 255, rA, gA, bA);
				}
			}
		}
	}


	function Convolution(){
		MarvinAbstractImagePlugin.super(this);
		this.load();
	}
	
	Convolution.prototype.load = function(){
		this.setAttribute("matrix", null);
	}
	
	Convolution.prototype.process = function
	(
		imageIn, 
		imageOut,
		attributesOut,
		mask, 
		previewMode
	)
	{
		var matrix = this.getAttribute("matrix");
		
		if(matrix != null && matrix.length > 0){
			
			for(var y=0; y<imageIn.getHeight(); y++){
				for(var x=0; x<imageIn.getWidth(); x++){
					
					if(y >= matrix.length/2 && y < imageIn.getHeight()-matrix.length/2 && x >= matrix[0].length/2 && x < imageIn.getWidth()-matrix[0].length/2){
						this.applyMatrix(x, y, matrix, imageIn, imageOut);
					}
					else{
						imageOut.setIntColor(x, y, 0xFF000000);
					}
				}
			}
		}
	};
	
	Convolution.prototype.applyMatrix = function
	(
		x,
		y,
		matrix,
		imageIn,
		imageOut
	){
		
		var nx,ny;
		var resultRed=0;
		var resultGreen=0;
		var resultBlue=0;
		
		var xC=Math.ceil(matrix[0].length/2);
		var yC=Math.ceil(matrix.length/2);
		
		for(var i=0; i<matrix.length; i++){
			for(var j=0; j<matrix[0].length; j++){
					
				if(matrix[i][j] != 0){		
					nx = x + (j-xC);
					ny = y + (i-yC);
					
					if(nx >= 0 && nx < imageOut.getWidth() && ny >= 0 && ny < imageOut.getHeight()){
						
						resultRed	+=	(matrix[i][j]*(imageIn.getIntComponent0(nx, ny)));
						resultGreen += 	(matrix[i][j]*(imageIn.getIntComponent1(nx, ny)));
						resultBlue	+=	(matrix[i][j]*(imageIn.getIntComponent2(nx, ny)));
					}
					
					
				}
				
				
				
			}
		}
		
		resultRed 	= Math.abs(resultRed);
		resultGreen = Math.abs(resultGreen);
		resultBlue = Math.abs(resultBlue);
		
		// allow the combination of multiple applications
		resultRed 	+= imageOut.getIntComponent0(x,y);
		resultGreen += imageOut.getIntComponent1(x,y);
		resultBlue 	+= imageOut.getIntComponent2(x,y);
		
		resultRed 	= Math.min(resultRed, 255);
		resultGreen = Math.min(resultGreen, 255);
		resultBlue 	= Math.min(resultBlue, 255);
		
		resultRed 	= Math.max(resultRed, 0);
		resultGreen = Math.max(resultGreen, 0);
		resultBlue 	= Math.max(resultBlue, 0);
		
		imageOut.setIntColor(x, y, imageIn.getAlphaComponent(x, y), Math.floor(resultRed), Math.floor(resultGreen), Math.floor(resultBlue));
	};

	function Moravec(){
		MarvinAbstractImagePlugin.super(this);
		this.load();
	}

	Moravec.prototype.load = function(){
		this.setAttribute("matrixSize", 3);
		this.setAttribute("threshold", 0);
	}

	Moravec.prototype.process = function
	(
		imageIn, 
		imageOut,
		attrOut,
		mask, 
		previewMode
	)
	{
		var matrixSize = this.getAttribute("matrixSize");
		var threshold = this.getAttribute("threshold");
		
		var tempImage = new MarvinImage(imageIn.getWidth(), imageIn.getHeight());
		Marvin.grayScale(imageIn, tempImage);
		
		var cornernessMap = MarvinJSUtils.createMatrix2D(tempImage.getWidth(), tempImage.getHeight(), 0);
		var cornernessMapOut = MarvinJSUtils.createMatrix2D(tempImage.getWidth(), tempImage.getHeight(), 0);
		
		for(var y=0; y<tempImage.getHeight(); y++){
			for(var x=0; x<tempImage.getWidth(); x++){
				cornernessMap[x][y] = this.c(x,y,matrixSize,tempImage);
				
				if(cornernessMap[x][y] < threshold){
					cornernessMap[x][y] = 0;
				}
			}
		}
		
		for(var x=0; x<cornernessMap.length; x++){
			for(var y=0; y<cornernessMap[x].length; y++){
				cornernessMapOut[x][y] = this.nonmax(x,y,matrixSize,cornernessMap);
				
				if(cornernessMapOut[x][y] > 0){
					cornernessMapOut[x][y] = 1;
				}
			}
		}
		
		if(attrOut != null){
			attrOut.set("cornernessMap", cornernessMapOut);
		}
	}
	
	Moravec.prototype.nonmax = function(x, y, matrixSize, matrix){
		var s = Math.floor(matrixSize/2);
		if(x-(s+1) >= 0 && x+(s+1) < matrix.length && y-(s+1) >= 0 && y+(s+1) < matrix[0].length){
			for(var i=-s; i<=s; i++){
				for(var j=-s; j<=s; j++){
					if(i != 0 || j != 0){
						if(matrix[x][y] < matrix[x+i][y+j]){
							return 0;
						}
					}
				}
			}
		}
		return matrix[x][y];
	}
	
	Moravec.directions = [[1,0], [-1, 0], [0, 1], [0,-1], [-1,-1], [1, -1], [-1, 1], [1,1]];
	
	Moravec.prototype.c = function(x, y, matrixSize, image){
		
		var ret = -1;
		var temp;
		var s = Math.floor(matrixSize/2);
		if(x-(s+1) >= 0 && x+(s+1) < image.getWidth() && y-(s+1) >= 0 && y+(s+1) < image.getHeight()){
			
			for(var d=0; d<Moravec.directions.length; d++){
				temp=0;
				for(var i=-s; i<=s; i++){
					for(var j=-s; j<=s; j++){
						temp += Math.pow(image.getIntComponent0(x+i, y+j)-image.getIntComponent0(x+i+Moravec.directions[d][0],y+j+Moravec.directions[d][1]), 2);
					}
				}
				if(ret == -1 || temp < ret){
					ret = temp;
				}
			}
			
		}
		return ret;
	}





/**
 * @author Gabriel Ambr�sio Archanjo
 */
	function Prewitt(){
		MarvinAbstractImagePlugin.super(this);
	
	
		// Definitions
		this.matrixPrewittX = [
				[1,		0,		-1],
				[1,		0,		-1],
				[1,		0,		-1]
		];
		
		this.matrixPrewittY = [
				[1,		1,		1],
				[0,		0,		0],
				[-1,	-1,		-1]
		];
		
		this.load();
		
	}
	
	Prewitt.prototype.load = function(){
		this.convolution = new Convolution();
		this.setAttribute("intensity", 1.0);
	};
	
	Prewitt.prototype.process = function
	(
		imageIn, 
		imageOut,
		attrOut,
		mask, 
		previewMode
	)
    {
		var intensity = this.getAttribute("intensity");
		
		if(intensity == 1){
			this.convolution.setAttribute("matrix", this.matrixPrewittX);
			this.convolution.process(imageIn, imageOut, null, mask, this.previewMode);
			this.convolution.setAttribute("matrix", this.matrixPrewittY);
			this.convolution.process(imageIn, imageOut, null, mask, this.previewMode);
		} else{
			this.convolution.setAttribute("matrix", MarvinMath.scaleMatrix(this.matrixPrewittX, intensity));
			this.convolution.process(imageIn, imageOut, null, mask, previewMode);
			this.convolution.setAttribute("matrix", MarvinMath.scaleMatrix(this.matrixPrewittY, intensity));
			this.convolution.process(imageIn, imageOut, null, mask, previewMode);
		}
    };

	function BoundaryFill(){
		MarvinAbstractImagePlugin.super(this);
		this.load();
	}
	
	BoundaryFill.prototype.load = function(){
		this.setAttribute("x", 0);
		this.setAttribute("y", 0);
		this.setAttribute("color", 0xFFFF0000);
		this.setAttribute("tile", null);
		this.setAttribute("threshold", 0);
	};

	BoundaryFill.prototype.process = function
	(
		imgIn, 
		imgOut,
		attributesOut,
		mask, 
		previewMode
	)
	{
		var l_list = new Array();
    	var 	l_point,
    			l_pointW,
    			l_pointE;
    
    	//MarvinImage.copyColorArray(imgIn, imgOut);
    	
    	var x = this.getAttribute("x");
    	var y = this.getAttribute("y");
    	var tileImage = this.getAttribute("tile");
    	this.threshold = this.getAttribute("threshold");
    	
    	if(!imgOut.isValidPosition(x, y)){
    		return;
    	}
    	
    	var targetColor = imgIn.getIntColor(x, y);
    	var targetRed = imgIn.getIntComponent0(x, y);
    	var targetGreen = imgIn.getIntComponent1(x, y);
    	var targetBlue = imgIn.getIntComponent2(x, y);
    	var color = this.getAttribute("color");
    	var newColor = color;
    	
    	var fillMask = MarvinJSUtils.createMatrix2D(imgOut.getWidth(), imgOut.getHeight, false);
    	fillMask[x][y] = true;
    	
    	
    	l_list.push(new MarvinPoint(x, y));
    	
    	//for(var l_i=0; l_i<l_list.size(); l_i++){
    	while(l_list.length > 0){
			l_point = l_list.splice(0,1)[0];	// list poll
    		l_pointW = new MarvinPoint(l_point.x, l_point.y);
    		l_pointE = new MarvinPoint(l_point.x, l_point.y);
    		
    		// west
    		while(true){
    			if(l_pointW.x-1 >= 0 && this.match(imgIn, l_pointW.x-1, l_pointW.y, targetRed, targetGreen, targetBlue, this.threshold) && !fillMask[l_pointW.x-1][l_pointW.y]){
    				l_pointW.x--;
    			}
    			else{
    				break;
    			}
    		 }
    		
    		// east
    		while(true){
    			if(l_pointE.x+1 < imgIn.getWidth() && this.match(imgIn, l_pointE.x+1, l_pointE.y, targetRed, targetGreen, targetBlue, this.threshold) && !fillMask[l_pointE.x+1][l_pointE.y]){
    				l_pointE.x++;
    			}
    			else{
    				break;
    			}
    		 }
    		
    		// set color of pixels between pointW and pointE
    		for(var l_px=l_pointW.x; l_px<=l_pointE.x; l_px++){
    			//imgOut.setIntColor(l_px, l_point.y, -1);
    			//drawPixel(imgOut, l_px, l_point.y, newColor, tileImage);
    			fillMask[l_px][l_point.y] = true;
    			
    			if(l_point.y-1 >= 0 && this.match(imgIn, l_px, l_point.y-1, targetRed, targetGreen, targetBlue, this.threshold) && !fillMask[l_px][l_point.y-1]){
    				l_list.push(new MarvinPoint(l_px, l_point.y-1));
    			}
    			if(l_point.y+1 < imgOut.getHeight() && this.match(imgIn, l_px, l_point.y+1, targetRed, targetGreen, targetBlue, this.threshold) && !fillMask[l_px][l_point.y+1]){
    				l_list.push(new MarvinPoint(l_px, l_point.y+1));
    			}
    		}
    	}    
    	
    	if(tileImage != null){
			/* Plugin not ported yet. */
			/*
    		var p = MarvinPluginLoader.loadImagePlugin("org.marvinproject.image.texture.tileTexture.jar");
    		p.setAttribute("lines", (int)(Math.ceil((double)imgOut.getHeight()/tileImage.getHeight())));
    		p.setAttribute("columns", (int)(Math.ceil((double)imgOut.getWidth()/tileImage.getWidth())));
    		p.setAttribute("tile", tileImage);
    		MarvinImageMask newMask = new MarvinImageMask(fillMask);    		
    		p.process(imgOut, imgOut, null, newMask, false);
			*/
    	}
    	else{
    		for(var j=0; j<imgOut.getHeight(); j++){
    			for(var i=0; i<imgOut.getWidth(); i++){
    				if(fillMask[i][j]){
    					imgOut.setIntColor(i, j, newColor);
    				}
    			}
    		}
    	}
    };
	
	BoundaryFill.prototype.match = function(image, x, y, targetRed, targetGreen, targetBlue, threshold){
		var diff = Math.abs(image.getIntComponent0(x, y) - targetRed) + Math.abs(image.getIntComponent1(x, y) - targetGreen) + Math.abs(image.getIntComponent2(x, y) - targetBlue);
		return (diff <= threshold);
	};

	function ErrorDiffusion(){
		MarvinAbstractImagePlugin.super(this);
		this.load();
	}

	ErrorDiffusion.prototype.load = function(){
		this.threshold = 128;
	}
	
	ErrorDiffusion.prototype.process = function
	(
		imageIn, 
		imageOut,
		attributesOut,
		mask, 
		previewMode
	)
	{
		var color;
		var dif;

		Marvin.grayScale(imageIn, imageOut, attributesOut, mask, previewMode);
		
		// Mask
		var l_arrMask;
		if(mask != null){
			l_arrMask = mask.getMask();
		}
		
		for (var y = 0; y < imageOut.getHeight(); y++) {
			for (var x = 0; x < imageOut.getWidth(); x++) {
				if(l_arrMask != null && !l_arrMask[x][y]){
					continue;
				}
				
				var color = imageOut.getIntComponent0(x, y);
				if(color > this.threshold){
					imageOut.setIntColor(x,y,imageIn.getAlphaComponent(x,y), 255,255,255);
					dif = -(255-color);
				}
				else{
					imageOut.setIntColor(x,y,imageIn.getAlphaComponent(x,y), 0,0,0);
					dif = color;
				}

				// Pixel Right
				if(x+1 < imageOut.getWidth()){
					color = imageOut.getIntComponent0(x+1,y);
					color+= Math.floor(0.4375*dif);
					color = this.getValidGray(color); 
					imageOut.setIntColor(x+1,y,imageIn.getAlphaComponent(x+1,y), color,color,color);

					// Pixel Right Down
					if(y+1 < imageOut.getHeight()){
						color = imageOut.getIntComponent0(x+1,y+1);
						color+=Math.floor(0.0625*dif);
						color = this.getValidGray(color); 
						imageOut.setIntColor(x+1,y+1,imageIn.getAlphaComponent(x+1,y+1), color,color,color);
					}
				}

				// Pixel Down
				if(y+1 < imageOut.getHeight()){
					color = imageOut.getIntComponent0(x,y+1);
					color+=Math.floor(0.3125*dif);
					color = this.getValidGray(color); 
					imageOut.setIntColor(x,y+1,imageIn.getAlphaComponent(x,y+1), color,color,color);

					// Pixel Down Left
					if(x-1 >= 0){
						color = imageOut.getIntComponent0(x-1,y+1);
						color+=Math.floor(0.1875*dif);
						color = this.getValidGray(color); 
						imageOut.setIntColor(x-1,y+1,imageIn.getAlphaComponent(x-1,y+1), color,color,color);
					}
				}
			}
		}
	}

	ErrorDiffusion.prototype.getValidGray = function(a_value){
		if(a_value < 0) return 0;
		if(a_value > 255) return 255;
		return a_value;
	}

var MarvinAbstractImagePlugin = new Object();

MarvinAbstractImagePlugin.super = function(ref){
	ref.attributes = {};
	ref["setAttribute"] = MarvinAbstractImagePlugin.setAttribute;
	ref["getAttribute"] = MarvinAbstractImagePlugin.getAttribute;
};

MarvinAbstractImagePlugin.setAttribute = function(label, value){
	this.attributes[label] = value;
};

MarvinAbstractImagePlugin.getAttribute = function(label, value){
	return this.attributes[label];
};
	function Closing(){
		MarvinAbstractImagePlugin.super(this);
		this.load();
	}

	Closing.prototype.load = function(){
		this.matrix = MarvinJSUtils.createMatrix2D(3,3,true);
		this.setAttribute("matrix",3);
	};

	
	Closing.prototype.process = function
	(
		imgIn, 
		imgOut,
		attributesOut,
		mask, 
		previewMode
	)
	{	
		var matrix = this.getAttribute("matrix");
		
		if(imgIn.getColorModel() == MarvinImage.COLOR_MODEL_BINARY && matrix != null){

			Marvin.morphologicalDilation(imgIn, imgOut, matrix);
			MarvinImage.copyColorArray(imgOut, imgIn);
			Marvin.morphologicalErosion(imgIn, imgOut, matrix);
		}
	};

	function Dilation(){
		MarvinAbstractImagePlugin.super(this);
		this.load();
	}

	Dilation.prototype.load = function(){
		
		this.matrix = MarvinJSUtils.createMatrix2D(3,3,true);
		this.setAttribute("matrix",3);
	}

	Dilation.prototype.process = function
	(
		imgIn, 
		imgOut,
		attributesOut,
		mask, 
		previewMode
	)
	{
		var matrix = this.getAttribute("matrix");
		
		if(imgIn.getColorModel() == MarvinImage.COLOR_MODEL_BINARY && matrix != null){
			
			MarvinImage.copyColorArray(imgIn, imgOut);
			
			for(var y=0; y<imgIn.getHeight(); y++){
				for(var x=0; x<imgIn.getWidth(); x++){
					this.applyMatrix(x, y, matrix, imgIn, imgOut);
				}
			}
		}
	}
	
	Dilation.prototype.applyMatrix = function
	(
		x,
		y,
		matrix,
		imgIn,
		imgOut
	){
		
		var nx,ny;
		var xC=matrix[0].length/2;
		var yC=matrix.length/2;
		
		if(imgIn.getBinaryColor(x, y)){
			for(var i=0; i<matrix.length; i++){
				for(var j=0; j<matrix.length; j++){
					
					if((i != yC || j != xC) && matrix[i][j]){
						
						nx = x + (j-xC);
						ny = y + (i-yC);
						
						if(nx > 0 && nx < imgOut.getWidth() && ny > 0 && ny < imgOut.getHeight()){
							imgOut.setBinaryColor(nx, ny, true);
						}
					}
				}
			}
		}
	}


	function Erosion(){
		MarvinAbstractImagePlugin.super(this);
		this.load();
	}
	
	Erosion.prototype.load = function(){
		
		this.matrix = MarvinJSUtils.createMatrix2D(3,3,true);
		this.setAttribute("matrix",3);
	}
	
	Erosion.prototype.process = function
	(
		imgIn, 
		imgOut,
		attributesOut,
		mask, 
		previewMode
	)
	{
		var matrix = this.getAttribute("matrix");
		
		if(imgIn.getColorModel() == MarvinImage.COLOR_MODEL_BINARY && matrix != null){
			
			MarvinImage.copyColorArray(imgIn, imgOut);
			
			for(var y=0; y<imgIn.getHeight(); y++){
				for(var x=0; x<imgIn.getWidth(); x++){
					this.applyMatrix(x, y, matrix, imgIn, imgOut);
				}
			}
		}
	}
	
	Erosion.prototype.applyMatrix = function
	(
		x,
		y,
		matrix,
		imgIn,
		imgOut
	){
		
		var nx,ny;
		
		var xC=Math.floor(matrix[0].length/2);
		var yC=Math.floor(matrix.length/2);
		
		if(!imgIn.getBinaryColor(x, y)){
			for(var i=0; i<matrix.length; i++){
				for(var j=0; j<matrix[0].length; j++){
					
					if((i != yC || j != xC) && matrix[i][j]){
						
						nx = x + (j-xC);
						ny = y + (i-yC);
						
						if(nx >= 0 && nx < imgOut.getWidth() && ny >= 0 && ny < imgOut.getHeight()){
							imgOut.setBinaryColor(nx, ny, false);
						}
					}
				}
			}
		}
	}


	function FindTextRegions(){
		MarvinAbstractImagePlugin.super(this);
		this.load();
	}
	
	FindTextRegions.prototype.load = function() {
		this.setAttribute("maxWhiteSpace", 10);
		this.setAttribute("maxFontLineWidth", 10);
		this.setAttribute("minTextWidth", 30);
		this.setAttribute("grayScaleThreshold", 127);
	}
	
	FindTextRegions.prototype.process = function
	(
		imageIn, 
		imageOut,
		attrOut,
		mask, 
		previewMode
	){
		// The image will be affected so it's generated a new instance
		imageIn = imageIn.clone();
		
		var maxWhiteSpace = this.getAttribute("maxWhiteSpace");
		var maxFontLineWidth = this.getAttribute("maxFontLineWidth");
		var minTextWidth = this.getAttribute("minTextWidth");
		var grayScaleThreshold = this.getAttribute("grayScaleThreshold");
		
		
		Marvin.thresholding(imageIn, imageIn, grayScaleThreshold);
		
		var segments = [];
		for(var i=0; i<imageIn.getHeight(); i++){
			segments.push([]);
		}
		
		// map of already processed pixels
		
		var processed = MarvinJSUtils.createMatrix2D(imageIn.getWidth(), imageIn.getHeight, false);
		
		var color;
		var patternStartX=-1;
		var patternLength=0;
		var whitePixels=0;
		var blackPixels=0;
		for(var y=0; y<imageIn.getHeight(); y++){
			for(var x=0; x<imageIn.getWidth(); x++){
				
				if(!processed[x][y]){
					color = imageIn.getIntColor(x, y);
					
					if(color == 0xFFFFFFFF && patternStartX != -1){
						whitePixels++;
						blackPixels=0;
					}
					
					if(color == 0xFF000000){
						
						blackPixels++;
						
						if(patternStartX == -1){
							patternStartX = x;
						}
						
						whitePixels=0;
					}
					
					// check white and black pattern maximum lenghts
					if(whitePixels > maxWhiteSpace || blackPixels > maxFontLineWidth || x == imageIn.getWidth()-1){
						
						if(patternLength >= minTextWidth){
							var list = segments[y];
							list.push([patternStartX, y, patternStartX+patternLength, y]);
						} 
						
						whitePixels=0;
						blackPixels=0;
						patternLength=0;
						patternStartX=-1;
					}
					
					if(patternStartX != -1){
						patternLength++;
					}
					
					processed[x][y] = true;
				}
			}
		}
		
		
		// Group line patterns intersecting in x coordinate and too near in y coordinate.
		for(var y=0; y<imageIn.getHeight()-2; y++){
			
			var listY = segments[y];
			
			for(var w=y+1; w<=y+2; w++){
				
				var listW = segments[w];
				
				for(var i=0; i<listY.length; i++){
					var sA = listY[i];
					for(var j=0; j<listW.length; j++){
						
						
						var sB = listW[j];
						
						// horizontal intersection
						if
						(
							(sA[0] <= sB[0] && sA[2] >= sB[2]) ||
							(sA[0] >= sB[0] && sA[0] <= sB[2]) ||
							(sA[2] >= sB[0] && sA[2] <= sB[2])
							
						){
							sA[0] = Math.min(sA[0], sB[0]);
							sA[2] = Math.max(sA[2], sB[2]);
							sA[3] = sB[3];
							
							listY.splice(i, 1);
							i--;
							
							listW.splice(j, 1);
							listW.push(sA);
							
							break;
						}
					}
				}
			}
		}
		
		// Convert the result to a List<> of MarvinSegment objects.
		var marvinSegments = [];
		for(var y=0; y<imageIn.getHeight(); y++){
			var list = segments[y];
			for(var i in list){
				var seg = list[i];
				marvinSegments.push(new MarvinSegment(seg[0], seg[1], seg[2], seg[3]));
			}
		}
		
		attrOut.set("matches", marvinSegments);
	}

	function IteratedFunctionSystem(){
		MarvinAbstractImagePlugin.super(this);
		this.load();
	}
	
	IteratedFunctionSystem.prototype.load = function(){
		this.rules = [];
		this.EXAMPLE_RULES = "0,0,0,0.16,0,0,0.01\n"+
											"0.85,0.04,-0.04,0.85,0,1.6,0.85\n"+
											"0.2,-0.26,0.23,0.22,0,1.6,0.07\n"+
											"-0.15,0.28,0.26,0.24,0,0.44,0.07\n";
											
		this.setAttribute("rules", this.EXAMPLE_RULES);
		this.setAttribute("iterations", 1000000);
	};

		/*
	private MarvinAttributesPanel	attributesPanel;
	private MarvinAttributes 		attributes;
	
	private List<Rule> rules;
	
	// Testing String
	private final static String EXAMPLE_RULES = 	"0,0,0,0.16,0,0,0.01\n"+
											"0.85,0.04,-0.04,0.85,0,1.6,0.85\n"+
											"0.2,-0.26,0.23,0.22,0,1.6,0.07\n"+
											"-0.15,0.28,0.26,0.24,0,0.44,0.07\n";
	@Override
	public void load() {
		attributes = getAttributes();
		attributes.set("rules", EXAMPLE_RULES);
		attributes.set("iterations", 1000000);
		
		rules = new ArrayList<Rule>();
	}
	*/

	IteratedFunctionSystem.prototype.process = function
	(
		imageIn, 
		imageOut,
		attributesOut,
		mask, 
		previewMode
	)
	{
		this.loadRules();
		var iterations = this.getAttribute("iterations");
		
		var x0 = 0;
		var y0 = 0;
		var x,y;
		var startX;
		var startY;
		var factor;
		
		var minX=999999999,minY=999999999,maxX=-999999999,maxY=-99999999;
		
		var tempRule;
		var point = [x0,y0];
		
		imageOut.clear(0xFFFFFFFF);
		
		for(var i=0; i<iterations; i++){
			tempRule = this.getRule();
			this.applyRule(point, tempRule);
			
			x = point[0];
			y = point[1];
			
			if(x < minX){	minX = x;	};
			if(x > maxX){	maxX = x;	};
			if(y < minY){	minY = y;	};
			if(y > maxY){	maxY = y;	};
		
		}	
		
		var width = imageOut.getWidth();
		var height = imageOut.getHeight();
		
		var deltaX = Math.abs(maxX-minX);
		var deltaY = Math.abs(maxY-minY); 
		if(deltaX > deltaY){
			factor = (width/deltaX);
			if(deltaY * factor > height){
				factor = factor * (height/(deltaY * factor));
			}
		}
		else{
			factor = (height/deltaY);
			if(deltaX * factor > width){
				factor = factor * (width/(deltaX * factor));
			}
		}
		
		factor *= 0.9;
		
		startX = Math.floor(((width/2)-((minX+((deltaX)/2))*factor)));
		startY = Math.floor((height-((height/2)-((minY+(deltaY/2))*factor))));
		
		point[0] = x0;
		point[1] = y0;
		
		for(var i=0; i<iterations; i++){
			tempRule = this.getRule();
			this.applyRule(point, tempRule);
			
			x = Math.floor((point[0]*factor)+startX);
			y = startY-Math.floor((point[1]*factor));
			
			if(x >= 0 && x<width && y >= 0 && y < height){
				imageOut.setIntColor(Math.floor(x),Math.floor(y) , 255, 0);
			}
		}
	}

	IteratedFunctionSystem.prototype.loadRules = function(){
		this.rules = [];
		var r = this.getAttribute("rules").split("\n");
		
		for(var i=0; i<r.length; i++){
			this.addRule(r[i]);
		}
	}

	IteratedFunctionSystem.prototype.addRule = function(rule){
		rule = rule.replace(/ /g, "");	//replace all spaces
		var attr = rule.split(",");
		
		if(attr.length == 7){
			var r = new Object();
			r.a = parseFloat(attr[0]);
			r.b = parseFloat(attr[1]);
			r.c = parseFloat(attr[2]);
			r.d = parseFloat(attr[3]);
			r.e = parseFloat(attr[4]);
			r.f = parseFloat(attr[5]);
			r.probability = parseFloat(attr[6]);
			
			
			/*
			(
				parseFloat(attr[0]),
				parseFloat(attr[1]),
				parseFloat(attr[2]),
				parseFloat(attr[3]),
				parseFloat(attr[4]),
				parseFloat(attr[5]),
				parseFloat(attr[6])
			);
			*/
			
			this.rules.push(r);
		}
	}
	
	IteratedFunctionSystem.prototype.getRule = function(){
		var random = Math.random();
		var sum=0;
		var i;
		for(i=0; i<this.rules.length; i++){
			sum += this.rules[i].probability;
			if(random < sum){
				return this.rules[i];
			}
		}
		
		if(i != 0){
			return this.rules[i-1];
		}
		return this.rules[0];
	};
	
	IteratedFunctionSystem.prototype.applyRule = function(point, rule){
		var nx = rule.a*point[0] + rule.b*point[1]+rule.e;
		var ny = rule.c*point[0] + rule.d*point[1]+rule.f;
		point[0] = nx;
		point[1] = ny;
	};

	function Crop(){
		MarvinAbstractImagePlugin.super(this);
		this.load();
	}

	Crop.prototype.load = function(){
		this.setAttribute("x", 0);
		this.setAttribute("y", 0);
		this.setAttribute("width", 0);
		this.setAttribute("height", 0);
	};
	
	Crop.prototype.process = function
	(
		imageIn, 
		imageOut,
		attributesOut,
		mask, 
		previewMode
	)
    {
		var x = this.getAttribute("x");
		var y = this.getAttribute("y");
		var width = this.getAttribute("width");
		var height = this.getAttribute("height");
		
		imageOut.setDimension(width, height);
		
		for(var i=x; i<x+width; i++){
			for(var j=y; j<y+height; j++){
				imageOut.setIntColor(i-x, j-y, imageIn.getIntColor(i, j));
			}
		}
    };


	function FloodfillSegmentation(){
		MarvinAbstractImagePlugin.super(this);
		this.load();
	}

	FloodfillSegmentation.prototype.load = function(){
		this.setAttribute("returnType", "MarvinSegment");
	};
	
	FloodfillSegmentation.prototype.process = function
	(
		imageIn, 
		imageOut,
		attributesOut,
		mask, 
		previewMode
	)
	{
		if(attributesOut != null){
			var returnType = this.getAttribute("returnType");
			var fillBuffer = imageIn.clone();
			var segments = this.floodfillSegmentation(imageIn, fillBuffer);
			
			switch(returnType){
				case "MarvinSegment":
					attributesOut.set("segments", segments);
					break;
				case "MarvinBlobSegment":
					attributesOut.set("blobSegments", blobSegments(fillBuffer, segments));
					break;
			}
		}
	};
	
	FloodfillSegmentation.prototype.floodfillSegmentation = function(image, fillBuffer){
		fillBuffer.clear(0xFF000000);
		
		var currentColor=1;
		for(var y=0; y<image.getHeight(); y++){
			for(var x=0; x<image.getWidth(); x++){
				
				var color = fillBuffer.getIntColor(x, y);
				
				if((color & 0x00FFFFFF) == 0 && image.getAlphaComponent(x, y) > 0){
					var c = 0xFF000000 | (currentColor++);
					Marvin.boundaryFill(image, fillBuffer, x, y, c);
				}
			}
		}
		
		var segments = new Array(currentColor-1);
		var seg;
		for(var y=0; y<fillBuffer.getHeight(); y++){
			for(var x=0; x<fillBuffer.getWidth(); x++){
				var color = (fillBuffer.getIntColor(x, y) & 0x00FFFFFF);
				
				if(color != 0x00FFFFFF && color > 0){
					
					seg = segments[color-1];
					
					if(seg == null){
						seg = new MarvinSegment();
						segments[color-1] = seg;
					}
					
					// x and width
					if(seg.x1 == -1 || x < seg.x1)	{		seg.x1 = x;		}
					if(seg.x2 == -1 || x > seg.x2)	{		seg.x2 = x;		}
					seg.width = (seg.x2-seg.x1)+1;
					
					// y and height;
					if(seg.y1 == -1 || y < seg.y1)	{		seg.y1 = y;		}
					if(seg.y2 == -1 || y > seg.y2)	{		seg.y2 = y;		}
					seg.height = (seg.y2-seg.y1)+1;
					
					seg.area++;
				}
			}
		}
		
		return segments;
	}
	
	FloodfillSegmentation.prototype.blobSegments = function(image, segments){
		
		var blobSegments = new Array(segments.length);
		
		var colorSegment;
		var seg;
		for(var i=0; i<segments.length; i++){
			seg = segments[i];
			colorSegment = 0xFF000000 + (i+1);
			
			blobSegments[i] = new MarvinBlobSegment(seg.x1, seg.y1);
			var tempBlob = new MarvinBlob(seg.width, seg.height);
			blobSegments[i].setBlob(tempBlob);
			
			for(var y=seg.y1; y<=seg.y2; y++){
				for(var x=seg.x1; x<=seg.x2; x++){
					if(image.getIntColor(x,y) == colorSegment){
						tempBlob.setValue(x-seg.x1, y-seg.y1, true);
					}
				}
			}
			
		}
		return blobSegments;
	};

	function Scale(){
		MarvinAbstractImagePlugin.super(this);
		this.load();
	};
	
	Scale.prototype.load = function(){
		// Attributes
		this.setAttribute("newWidth", 0);
		this.setAttribute("newHeight", 0);
	};
			
	Scale.prototype.process = function
	(
		imageIn, 
		imageOut,
		attributesOut,
		mask, 
		previewMode
	)
	{
		
		if(!previewMode){
			var width = imageIn.getWidth();
			var height = imageIn.getHeight();
			var newWidth = this.getAttribute("newWidth");
			var newHeight = this.getAttribute("newHeight");
			
			if(imageOut.getWidth() != newWidth || imageOut.getHeight() != newHeight){
				imageOut.setDimension(newWidth, newHeight);
			}
			
		    var x_ratio = Math.floor((width<<16)/newWidth) ;
		    var y_ratio = Math.floor((height<<16)/newHeight) ;
		    var x2, y2 ;
		    for (var i=0;i<newHeight;i++) {
		        for (var j=0;j<newWidth;j++) {
		            x2 = Math.floor((j*x_ratio)>>16) ;
		            y2 = Math.floor((i*y_ratio)>>16) ;
		            imageOut.setIntColor(j,i, imageIn.getAlphaComponent(x2,y2), imageIn.getIntColor(x2,y2));
		        }                
		    }	    
		}
	};
	
	
	function MarvinAttributes(){
		this.hashAttributes = new Object();
	}

	MarvinAttributes.prototype.set = function(name, value){
		this.hashAttributes[name] = value;
	};
	
	MarvinAttributes.prototype.get = function(name, defaultValue){
		var ret = this.hashAttributes[name];
		
		if(ret != null){
			return ret;
		}
		return defaultValue;
	};
	
	MarvinAttributes.prototype.clone = function(){
		var attrs = new MarvinAttributes();
		
		for(var key in this.hashAttributes){
			attrs.set(key, this.hashAttributes[key]);
		}
		return attrs;
	};
function MarvinPoint(x,y){
	this.x = x;
	this.y = y;
}

MarvinPoint.prototype.setX = function(x){
	this.x = x;
};

MarvinPoint.prototype.getX = function(){
	return this.x;
};

MarvinPoint.prototype.setY = function(x){
	this.y = y;
};

MarvinPoint.prototype.getY = function(){
	return this.y;
};var marvinLoadPluginMethods = function(callback){
	Marvin.plugins = new Object();
	
	// Alpha Boundary
	Marvin.plugins.alphaBoundary = new AlphaBoundary();
	Marvin.alphaBoundary = function(imageIn, imageOut, radius){
		Marvin.plugins.alphaBoundary.setAttribute("radius", radius)
		Marvin.plugins.alphaBoundary.process(imageIn, imageOut, null, MarvinImageMask.NULL_MASK, false);
	};
	
	// Average Color
	Marvin.plugins.averageColor = new AverageColor();
	Marvin.averageColor = function(imageIn){
		var attrOut = new MarvinAttributes();
		Marvin.plugins.averageColor.process(imageIn, null, attrOut, MarvinImageMask.NULL_MASK, false);
		return attrOut.get("averageColor");
	};
	
	// Black And White
	Marvin.plugins.blackAndWhite = new BlackAndWhite();
	Marvin.blackAndWhite = function(imageIn, imageOut, level){
		Marvin.plugins.blackAndWhite.setAttribute("level", level);
		Marvin.plugins.blackAndWhite.process(imageIn, imageOut, null, MarvinImageMask.NULL_MASK, false);
	};
	
	// BoundaryFill
	Marvin.plugins.boundaryFill = new BoundaryFill();
	Marvin.boundaryFill = function(imageIn, imageOut, x, y, color, threshold){
		Marvin.plugins.boundaryFill.setAttribute("x", x);
		Marvin.plugins.boundaryFill.setAttribute("y", y);
		Marvin.plugins.boundaryFill.setAttribute("color", color);
		if(threshold != null){	Marvin.plugins.boundaryFill.setAttribute("threshold", threshold);	}
		
		Marvin.plugins.boundaryFill.process(imageIn, imageOut, null, MarvinImageMask.NULL_MASK, false);
	};
	
	// Brightness and Contrast
	Marvin.plugins.brightnessAndContrast = new BrightnessAndContrast();
	Marvin.brightnessAndContrast = function(imageIn, imageOut, brightness, contrast){
		Marvin.plugins.brightnessAndContrast.setAttribute("brightness", brightness);
		Marvin.plugins.brightnessAndContrast.setAttribute("contrast", contrast);
		Marvin.plugins.brightnessAndContrast.process(imageIn, imageOut, null, MarvinImageMask.NULL_MASK, false);
	};
	
	// Color Channel
	Marvin.plugins.colorChannel = new ColorChannel();
	Marvin.colorChannel = function(imageIn, imageOut, red, green, blue){
		Marvin.plugins.colorChannel.setAttribute("red", red);
		Marvin.plugins.colorChannel.setAttribute("green", green);
		Marvin.plugins.colorChannel.setAttribute("blue", blue);
		Marvin.plugins.colorChannel.process(imageIn, imageOut, null, MarvinImageMask.NULL_MASK, false);
	};
	
	// Color Channel
	Marvin.plugins.crop = new Crop();
	Marvin.crop = function(imageIn, imageOut, x, y, width, height){
		Marvin.plugins.crop.setAttribute("x", x);
		Marvin.plugins.crop.setAttribute("y", y);
		Marvin.plugins.crop.setAttribute("width", width);
		Marvin.plugins.crop.setAttribute("height", height);
		Marvin.plugins.crop.process(imageIn, imageOut, null, MarvinImageMask.NULL_MASK, false);
	};
	
	// Combine by Alpha
	Marvin.plugins.combineByAlpha = new CombineByAlpha();
	Marvin.combineByAlpha = function(imageIn, imageOther, imageOut, x, y){
		Marvin.plugins.combineByAlpha.setAttribute("imageOther", imageOther);
		Marvin.plugins.combineByAlpha.setAttribute("x", x);
		Marvin.plugins.combineByAlpha.setAttribute("y", y);
		Marvin.plugins.combineByAlpha.process(imageIn, imageOut, null, MarvinImageMask.NULL_MASK, false);
	};
	
	// Emboss
	Marvin.plugins.emboss = new Emboss();
	Marvin.emboss = function(imageIn, imageOut){
		Marvin.plugins.emboss.process(imageIn, imageOut, null, MarvinImageMask.NULL_MASK, false);
	};
	
	// Emboss
	Marvin.plugins.halftoneErrorDiffusion = new ErrorDiffusion();
	Marvin.halftoneErrorDiffusion = function(imageIn, imageOut){
		Marvin.plugins.halftoneErrorDiffusion.process(imageIn, imageOut, null, MarvinImageMask.NULL_MASK, false);
	};
	
	// FindTextRegions
	Marvin.plugins.findTextRegions = new FindTextRegions();
	Marvin.findTextRegions = function(imageIn, maxWhiteSpace, maxFontLineWidth, minTextWidth, grayScaleThreshold){
		var attrOut = new MarvinAttributes();
		Marvin.plugins.findTextRegions.setAttribute("maxWhiteSpace", Marvin.getValue(maxWhiteSpace, 10));
		Marvin.plugins.findTextRegions.setAttribute("maxFontLineWidth", Marvin.getValue(maxFontLineWidth, 10));
		Marvin.plugins.findTextRegions.setAttribute("minTextWidth", Marvin.getValue(minTextWidth, 30));
		Marvin.plugins.findTextRegions.setAttribute("grayScaleThreshold", Marvin.getValue(grayScaleThreshold, 127));
		Marvin.plugins.findTextRegions.process(imageIn, null, attrOut,  MarvinImageMask.NULL_MASK, false);
		return attrOut.get("matches");
	};
	
	// Floodfill Segmentation
	Marvin.plugins.floodfillSegmentation = new FloodfillSegmentation();
	Marvin.floodfillSegmentation = function(imageIn){
		var attrOut = new MarvinAttributes();
		Marvin.plugins.floodfillSegmentation.setAttribute("returnType", "MarvinSegment");
		Marvin.plugins.floodfillSegmentation.process(imageIn, null, attrOut, MarvinImageMask.NULL_MASK, false);
		return attrOut.get("segments");
	};
	
	// Gaussian Blur
	Marvin.plugins.gaussianBlur = new GaussianBlur();
	Marvin.gaussianBlur = function(imageIn, imageOut, radius){
		Marvin.plugins.gaussianBlur.setAttribute("radius", Marvin.getValue(radius, 3.0));
		Marvin.plugins.gaussianBlur.process(imageIn, imageOut, null, MarvinImageMask.NULL_MASK, false);
	};
	
	// Invert
	Marvin.plugins.invertColors = new Invert();
	Marvin.invertColors = function(imageIn, imageOut){
		Marvin.plugins.invertColors.process(imageIn, imageOut, null, MarvinImageMask.NULL_MASK, false);
	};
	
	Marvin.plugins.iteratedFunctionSystem = new IteratedFunctionSystem();
	Marvin.iteratedFunctionSystem = function(imageIn, imageOut, rules, iterations){
		Marvin.plugins.iteratedFunctionSystem.setAttribute("rules", rules);
		Marvin.plugins.iteratedFunctionSystem.setAttribute("iterations", iterations);
		Marvin.plugins.iteratedFunctionSystem.process(imageIn, imageOut, null, MarvinImageMask.NULL_MASK, false);
	};
	
	// GrayScale
	Marvin.plugins.grayScale = new GrayScale();
	Marvin.grayScale = function(imageIn, imageOut){
		Marvin.plugins.grayScale.process(imageIn, imageOut, null, MarvinImageMask.NULL_MASK, false);
	};
	
	//Merge Photos
	Marvin.plugins.mergePhotos = new MergePhotos();
	Marvin.mergePhotos = function(images, imageOut, threshold){
		Marvin.plugins.mergePhotos.setAttribute("threshold", threshold);
		Marvin.plugins.mergePhotos.process(images, imageOut);
	};
	
	// Moravec
	Marvin.plugins.moravec = new Moravec();
	Marvin.moravec = function(imageIn, imageOut, matrixSize, threshold){
		var attrOut = new MarvinAttributes();
		Marvin.plugins.moravec.setAttribute("matrixSize", matrixSize);
		Marvin.plugins.moravec.setAttribute("threshold", threshold);
		Marvin.plugins.moravec.process(imageIn, imageOut, attrOut, MarvinImageMask.NULL_MASK, false);
		return attrOut.get("cornernessMap");
	};
	
	// Morphological Dilation
	Marvin.plugins.morphologicalDilation = new Dilation();
	Marvin.morphologicalDilation = function(imageIn, imageOut, matrix){
		Marvin.plugins.morphologicalDilation.setAttribute("matrix", matrix);
		Marvin.plugins.morphologicalDilation.process(imageIn, imageOut, null, MarvinImageMask.NULL_MASK, false);
	};
	
	// Morphological Erosion
	Marvin.plugins.morphologicalErosion = new Erosion();
	Marvin.morphologicalErosion = function(imageIn, imageOut, matrix){
		Marvin.plugins.morphologicalErosion.setAttribute("matrix", matrix);
		Marvin.plugins.morphologicalErosion.process(imageIn, imageOut, null, MarvinImageMask.NULL_MASK, false);
	};
	
	// Morphological Closing
	Marvin.plugins.morphologicalClosing = new Closing();
	Marvin.morphologicalClosing = function(imageIn, imageOut, matrix){
		Marvin.plugins.morphologicalClosing.setAttribute("matrix", matrix);
		Marvin.plugins.morphologicalClosing.process(imageIn, imageOut, null, MarvinImageMask.NULL_MASK, false);
	};
	
	// Prewitt
	Marvin.plugins.prewitt = new Prewitt();
	Marvin.prewitt = function(imageIn, imageOut, intensity){
		Marvin.plugins.prewitt.setAttribute("intensity", Marvin.getValue(intensity, 1.0));
		Marvin.plugins.prewitt.process(imageIn, imageOut, null, MarvinImageMask.NULL_MASK, false);
	};
	
	// Scale
	Marvin.plugins.scale = new Scale();
	Marvin.scale = function(imageIn, imageOut, newWidth, newHeight){
	
		if(newHeight == null){
			var factor = imageIn.getHeight() / imageIn.getWidth();
			newHeight = Math.floor(factor * newWidth);
		}
	
		Marvin.plugins.scale.setAttribute("newWidth", newWidth);
		Marvin.plugins.scale.setAttribute("newHeight", newHeight);
		Marvin.plugins.scale.process(imageIn, imageOut, null, MarvinImageMask.NULL_MASK, false);
	};
	
	// Sepia
	Marvin.plugins.sepia = new Sepia();
	Marvin.sepia = function(imageIn, imageOut, intensity){
		Marvin.plugins.sepia.setAttribute("intensity", intensity);
		Marvin.plugins.sepia.process(imageIn, imageOut, null, MarvinImageMask.NULL_MASK, false);
	};
	
	// Thresholding
	Marvin.plugins.thresholding = new Thresholding();
	Marvin.thresholding = function(imageIn, imageOut, threshold, thresholdRange){
		Marvin.plugins.thresholding.setAttribute("threshold", threshold);
		Marvin.plugins.thresholding.setAttribute("thresholdRange", thresholdRange);
		Marvin.plugins.thresholding.process(imageIn, imageOut, null, MarvinImageMask.NULL_MASK, false);
	};
	
	// ThresholdingNeighborhood
	Marvin.plugins.thresholdingNeighborhood = new ThresholdingNeighborhood();
	Marvin.thresholdingNeighborhood = function(imageIn, imageOut, thresholdPercentageOfAverage, neighborhoodSide, samplingPixelDistance){
		Marvin.plugins.thresholdingNeighborhood.setAttribute("thresholdPercentageOfAverage", thresholdPercentageOfAverage);
		Marvin.plugins.thresholdingNeighborhood.setAttribute("neighborhoodSide", neighborhoodSide);
		Marvin.plugins.thresholdingNeighborhood.setAttribute("samplingPixelDistance", samplingPixelDistance);
		Marvin.plugins.thresholdingNeighborhood.process(imageIn, imageOut, null, MarvinImageMask.NULL_MASK, false);
	};
}

var Marvin = new Object();

Marvin.getValue = function(value, defaultValue){
	if(value != null){
		return value;
	} else {
		return defaultValue;
	}
}

marvinLoadPluginMethods();

/**
*
* Color picker
* Author:Mauro Valvano
*
*/
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
globalThis.colorPickerGetUsedColors = function () {
    return [];
};
(function ($) {
    var recentColors = [];
    var overlay = $("<div class='colorpicker__overlay'></div>");
    $(document.body).append(overlay);
    var buildPaletteUI = function (data) {
        var _this = this;
        var html = $("<div class='colorpicker colorpicker--palette'>\n            <ul class='colorpicker--palette__list'></ul>\n        </div>");
        if (data.pantoneColors.length > 100) {
            html.find('ul').addClass('colorpicker--palette__list--extra-large');
        }
        else if (data.pantoneColors.length > 49) {
            html.find('ul').addClass('colorpicker--palette__list--large');
        }
        if (data.allowBlank) {
            var li = $("<li class='blank-color'></li>");
            li.data('color', null);
            html
                .find('.colorpicker--palette__list')
                .append(li);
        }
        for (var _i = 0, _a = data.pantoneColors; _i < _a.length; _i++) {
            var color = _a[_i];
            var li = $("<li style='background-color: ".concat(color.rgbhexcode, "'></li>"));
            li.data('color', color.rgbhexcode);
            html
                .find('.colorpicker--palette__list')
                .append(li);
        }
        html.on('click', 'li', function (e) {
            var color = $(e.currentTarget).data('color');
            change(data, color);
            $(_this).ColorPickerHide();
        });
        html.on('mousedown touchend', function (e) { return e.stopPropagation(); });
        $(document.body).append(html);
        return html;
    };
    var buildPantoneUI = function (data) {
        var _this = this;
        var html = $("<div class='colorpicker colorpicker--pantone'>\n            <input type='text' placeholder=".concat(data.placeholder || T._('Search...', 'Customizer'), " />\n            <ul class='colorpicker--pantone__list'></ul>\n        </div>"));
        for (var _i = 0, _a = data.pantoneColors; _i < _a.length; _i++) {
            var color = _a[_i];
            var li = $("<li class='colorpicker--pantone__list__item'>\n                <div class='colorpicker--pantone__list__item__color' style='background-color: ".concat(color.rgbhexcode, "'></div>\n                <div class='colorpicker--pantone__list__item__name'>\n                    <strong>").concat(color.pantonecode, "</strong>\n                    <span>").concat(color.name, "</span>\n                </div>\n            </li>"));
            li.data('color', color.rgbhexcode);
            li.data('keywords', color.name + color.pantonecode);
            html
                .find('.colorpicker--pantone__list')
                .append(li);
        }
        html.on('click', 'li', function (e) {
            var color = $(e.currentTarget).data('color');
            change(data, color);
            $(_this).ColorPickerHide();
        });
        html.on('input change', 'input', function (e) {
            var filter = $(e.currentTarget).val();
            html.find('.colorpicker--pantone__list__item').each(function (idx, el) {
                var visible = $(el).data('keywords').toLowerCase().indexOf(filter.toLowerCase()) !== -1;
                $(el).toggle(visible);
            });
        });
        $(document.body).append(html);
        return html;
    };
    var buildColorPickerUI = function (data) {
        var _this = this;
        var html = $("<div class='colorpicker colorpicker--picker'>\n\n            <div class=\"colors-row colors-row--used\">\n                <label>".concat(T._('Colors in use', 'Customizer'), "</label>\n                <ul></ul>\n            </div>\n            <div class=\"colors-row colors-row--recent\">\n                <label>").concat(T._('Last Colors Used', 'Customizer'), "</label>\n                <ul></ul>\n            </div>\n            <div class=\"colorpicker--picker__center\">\n                <div class='colorpicker--picker__color'>\n                    <div>\n                        <div></div>\n                    </div>\n                </div>\n                <div class='colorpicker--picker__current-color__preview'>\n                    <div></div>\n                    <span>").concat(T._('Current Color', 'Customizer'), "</span>\n                </div>\n                <div class='colorpicker--picker__current-color__hex'>\n                    <input class=\"colorpicker--picker__hex\" type='text' value='000000' />\n                </div>\n                <div class=\"colorpicker--picker__hue\">\n                    <div></div>\n                </div>\n                <div class='colorpicker--picker__rgbrow'>\n                    <div class='colorpicker--picker__rgblabel'>\n                        <span>").concat(T._('R', 'Customizer'), "</span>\n                    </div>\n                    <div class='colorpicker--picker__rgbvalue'>\n                        <input class='colorpicker--picker__rgb' data-rgb='r' type='number' value='0' min='0' max='255' />\n                    </div>\n                    <div class='colorpicker--picker__rgblabel'>\n                        <span>").concat(T._('G', 'Customizer'), "</span>\n                    </div>\n                    <div class='colorpicker--picker__rgbvalue'>\n                        <input class='colorpicker--picker__rgb' data-rgb='g' type='number' value='0' min='0' max='255' />\n                    </div>\n                    <div class='colorpicker--picker__rgblabel'>\n                        <span>").concat(T._('B', 'Customizer'), "</span>\n                    </div>\n                    <div class='colorpicker--picker__rgbvalue'>\n                        <input class='colorpicker--picker__rgb' data-rgb='b' type='number' value='0' min='0' max='255' />\n                    </div>\n                </div>\n            </div>\n            <button class=\"colorpicker--picker__submit btn btn-primary\">OK</div>\n        </div>"));
        html.on('click', 'li', function (e) {
            var color = $(e.currentTarget).data('color');
            change(data, color);
            $(_this).ColorPickerHide();
        });
        html.find('.colorpicker--picker__color').on('mousedown touchstart', function (e) { return downSelector.call(_this, e); });
        html.find('.colorpicker--picker__hue').on('mousedown touchstart', function (e) { return downHue.call(_this, e); });
        html.find('.btn').on('click', function (e) { return $(_this).ColorPickerHide(); });
        html.on('input change', '.colorpicker--picker__hex', function (e) {
            var hex = $(e.currentTarget).val();
            if ((hex[0] === '#' && hex.length === 7) || (hex[0] !== '#' && hex.length === 6)) {
                change(data, hex);
            }
        });
        html.on('input change', '.colorpicker--picker__rgb', function (e) {
            var rgbvalue = $(e.currentTarget).val();
            if (rgbvalue !== '0')
                rgbvalue = rgbvalue.replace(/\b0+/g, '');
            if (parseInt(rgbvalue) < 0 || !/^\d+$/.test(rgbvalue))
                rgbvalue = '0';
            if (parseInt(rgbvalue) > 255)
                rgbvalue = '255';
            $(e.currentTarget).val(rgbvalue);
            var rgb = { r: 0, g: 0, b: 0 };
            data.colorpicker.find('.colorpicker--picker__rgb').each(function () {
                if (rgb.hasOwnProperty($(this).data('rgb')))
                    rgb[$(this).data('rgb')] = $(this).val();
            });
            change(data, null, RGBToHSB(rgb));
        });
        $(document.body).append(html);
        return html;
    };
    var buildUI = function (data) {
        var html;
        if (data.pantoneEnabled && data.hideSearch) {
            // Palette
            html = buildPaletteUI.call(this, data);
        }
        else if (data.pantoneEnabled && !data.hideSearch) {
            // Pantone
            html = buildPantoneUI.call(this, data);
        }
        else {
            // Color picker
            html = buildColorPickerUI.call(this, data);
        }
        // Hide the colorpicker first time
        html.hide();
        return html;
    };
    var updateRecentColors = function (data) {
        if (recentColors && recentColors.length > 0) {
            data.colorpicker
                .find('.colors-row--recent')
                .show();
            data.colorpicker
                .find('.colors-row--recent ul')
                .empty();
            for (var _i = 0, recentColors_1 = recentColors; _i < recentColors_1.length; _i++) {
                var color = recentColors_1[_i];
                var li = $("<li style='background-color: ".concat(color, "'></li>"));
                li.data('color', color);
                data.colorpicker
                    .find('.colors-row--recent ul')
                    .append(li);
            }
        }
        else {
            data.colorpicker
                .find('.colors-row--recent')
                .hide();
        }
    };
    var updateUsedColors = function (data) {
        var usedColors = data.customUsedColors || globalThis.colorPickerGetUsedColors();
        if (usedColors && usedColors.length > 0 || data.allowBlank) {
            data.colorpicker
                .find('.colors-row--used ul')
                .empty();
            if (data.allowBlank) {
                var li = $("<li class='blank-color'></li>");
                li.data('color', null);
                data.colorpicker
                    .find('.colors-row--used ul')
                    .append(li);
            }
            for (var _i = 0, usedColors_1 = usedColors; _i < usedColors_1.length; _i++) {
                var color = usedColors_1[_i];
                var li = $("<li style='background-color: ".concat(color, "'></li>"));
                li.data('color', color);
                data.colorpicker
                    .find('.colors-row--used ul')
                    .append(li);
            }
        }
        else {
            data.colorpicker
                .find('.colors-row--used')
                .hide();
        }
    };
    var getViewport = function () {
        var m = document.compatMode == 'CSS1Compat';
        return {
            l: window.pageXOffset || (m ? document.documentElement.scrollLeft : document.body.scrollLeft),
            t: window.pageYOffset || (m ? document.documentElement.scrollTop : document.body.scrollTop),
            w: window.innerWidth || (m ? document.documentElement.clientWidth : document.body.clientWidth),
            h: window.innerHeight || (m ? document.documentElement.clientHeight : document.body.clientHeight)
        };
    };
    var updatePosition = function (el) {
        var options = $(el).data('colorPicker');
        var align = options.align;
        var colorpicker = options.colorpicker;
        var pos = $(el).offset();
        var viewPort = getViewport();
        var height = $(el).outerHeight();
        var width = $(el).outerWidth();
        var heightPicker = colorpicker.outerHeight();
        var widthPicker = colorpicker.outerWidth();
        var top = pos.top + height;
        var left = pos.left;
        // top = (viewPort.t + viewPort.h - heightPicker)/2;
        var pageHeight = viewPort.t + viewPort.h;
        if (top + heightPicker > pageHeight) {
            top = pageHeight - heightPicker;
        }
        if (align == "auto") {
            if (left + widthPicker + 10 > viewPort.l + viewPort.w) {
                left -= widthPicker;
            }
        }
        else if (align == "left") {
            left = 0;
        }
        else if (align == "right") {
            left -= widthPicker - width;
        }
        options.colorpicker.css({ left: left + 'px', top: top + 'px' });
    };
    var downSelector = function (ev) {
        var currentData = $(this).data('colorPicker');
        var current = {
            currentData: currentData,
            selectorOffset: currentData.colorpicker.find('.colorpicker--picker__color').offset()
        };
        upHue(ev);
        moveSelector(__assign(__assign({}, ev), { data: current }));
        $(document).on('mouseup', current, upSelector);
        $(document).on('mousemove', current, moveSelector);
        $(document).on("touchend", current, upSelector);
        $(document).on("touchmove", current, moveSelector);
    };
    var setSelector = function (currentData, hsb) {
        currentData.colorpicker.find('.colorpicker--picker__color').css('backgroundColor', '#' + HSBToHex({ h: hsb.h, s: 100, b: 100 }));
        currentData.colorpicker.find('.colorpicker--picker__color > div > div').css({
            left: Math.round(180 * hsb.s / 100),
            top: Math.round(180 * (100 - hsb.b) / 100)
        });
    };
    var setHue = function (currentData, hsb) {
        currentData.colorpicker.find('.colorpicker--picker__color').css('backgroundColor', '#' + HSBToHex({ h: hsb.h, s: 100, b: 100 }));
        currentData.colorpicker.find('.colorpicker--picker__hue > div').css('top', 248 - parseInt((248 * hsb.h / 360).toString(), 10) - 4);
    };
    var setRGB = function (currentData, hsb) {
        var rgb = HSBToRGB(hsb);
        var rgbinputs = currentData.colorpicker.find('.colorpicker--picker__rgb');
        for (var color in rgb) {
            rgbinputs.filter('[data-rgb="' + color + '"]').val(rgb[color]);
        }
    };
    var setPreview = function (currentData, hsb) {
        var hex = HSBToHex(currentData.hsb);
        currentData.colorpicker.find('.colorpicker--picker__current-color__preview > div').css('backgroundColor', '#' + hex);
        currentData.colorpicker.find('.colorpicker--picker__current-color__hex input').val('#' + hex.toUpperCase());
    };
    var moveSelector = function (ev) {
        var currentData = ev.data.currentData;
        var pageX = ev.originalEvent.touches && ev.originalEvent.touches.length > 0 ? ev.originalEvent.touches[0].pageX : ev.originalEvent.pageX;
        var pageY = ev.originalEvent.touches && ev.originalEvent.touches.length > 0 ? ev.originalEvent.touches[0].pageY : ev.originalEvent.pageY;
        var h = currentData.hsb.h;
        var s = parseInt((100 * (Math.max(0, Math.min(180, (pageX - ev.data.selectorOffset.left)))) / 180).toString(), 10);
        var b = parseInt((100 * (180 - Math.max(0, Math.min(180, (pageY - ev.data.selectorOffset.top)))) / 180).toString(), 10);
        change(currentData, null, { h: h, s: s, b: b });
        return false;
    };
    var upSelector = function (ev) {
        $(document).off('mouseup', upSelector);
        $(document).off('mousemove', moveSelector);
        $(document).off("touchend", upSelector);
        $(document).off("touchmove", moveSelector);
    };
    var downHue = function (ev) {
        var currentData = $(this).data('colorPicker');
        var current = {
            currentData: currentData,
            y: currentData.colorpicker.find('.colorpicker--picker__hue').offset().top
        };
        upSelector(ev);
        moveHue($.extend(ev, { data: current }));
        $(document).on('mouseup', current, upHue);
        $(document).on('mousemove', current, moveHue);
        $(document).on("touchend", current, upHue);
        $(document).on("touchmove", current, moveHue);
    };
    var moveHue = function (ev) {
        var currentData = ev.data.currentData;
        var cursorY = (ev.originalEvent.touches && ev.originalEvent.touches.length > 0 ? ev.originalEvent.touches[0].pageY : ev.originalEvent.pageY) - ev.data.y;
        var h = parseInt((360 * (248 - Math.max(0, Math.min(248, cursorY))) / 248).toString(), 10);
        var s = currentData.hsb.s;
        var b = currentData.hsb.b;
        // Avoid purple color on top of hsb row
        if (h === 360)
            h = 0;
        change(currentData, null, { h: h, s: s, b: b });
        return false;
    };
    var upHue = function (ev) {
        $(document).off('mouseup', upHue);
        $(document).off('mousemove', moveHue);
        $(document).off("touchend", upHue);
        $(document).off("touchmove", moveHue);
        return false;
    };
    var close = function (currentData) {
        var _a, _b;
        currentData.colorpicker.hide();
        overlay.hide();
        $(document).off('mousedown', documentHide);
        $(document).off("touchend", documentHide);
        if (currentData.color && currentData.colorChanged) {
            if (recentColors.indexOf(currentData.color) === -1) {
                recentColors.push(currentData.color);
                if (recentColors.length > 8)
                    recentColors.shift();
            }
            var color = HexToHSB(currentData.color);
            (_a = currentData.onHide) === null || _a === void 0 ? void 0 : _a.call(currentData.colorpicker);
            (_b = currentData.onSubmit) === null || _b === void 0 ? void 0 : _b.call(currentData.colorpicker, color, color ? HSBToHex(color) : null, color ? HSBToRGB(color) : null);
        }
    };
    var documentHide = function (ev) {
        if ($(ev.target).closest('.colorpicker').length > 0)
            return;
        close(ev.data.currentData);
    };
    var hide = function (ev) {
        close(ev.data.currentData);
        $(document).off('mousedown', hide);
        $(document).off("touchend", hide);
    };
    var change = function (currentData, hex, hsb) {
        if (hsb || hex) {
            hsb = hsb || HexToHSB(hex);
            hex = hex || '#' + HSBToHex(hsb);
            currentData.color = hex;
            currentData.hsb = hsb;
            setSelector(currentData, hsb);
            setHue(currentData, hsb);
            setPreview(currentData, hsb);
            setRGB(currentData, hsb);
            currentData.onChange.call(currentData.colorpicker, hsb, hex.substr(1), HSBToRGB(hsb));
        }
        else {
            currentData.color = null;
            currentData.hsb = null;
            currentData.onChange.call(currentData.colorpicker, null, null, null);
        }
        currentData.colorChanged = true;
    };
    var create = function (options) {
        var _this = this;
        var defaults = { align: 'auto', color: '#000000' };
        this.each(function (e) {
            var currentData = $(_this).data('colorPicker');
            // Remove old color picker
            if (currentData) {
                currentData.colorpicker.remove();
                $(_this).unbind();
            }
            var values = __assign(__assign({}, defaults), options);
            if (!values.color)
                values.color = '#000000';
            var hsb = HexToHSB(values.color);
            currentData = __assign(__assign({}, values), { id: generateUUID(), colorpicker: $('<div/>'), hsb: hsb, colorChanged: false });
            // Update later the UI
            currentData.colorpicker = buildUI.call(_this, currentData);
            setSelector(currentData, hsb);
            setHue(currentData, hsb);
            setPreview(currentData, hsb);
            setRGB(currentData, hsb);
            $(_this).data('colorPicker', currentData);
            $(_this).on('click', function () { return _this.ColorPickerShow(); });
        });
    };
    var showPicker = function () {
        var _this = this;
        var isMobile = !!$(document.body).data("mobile");
        overlay.toggle(isMobile);
        this.each(function () {
            var currentData = $(_this).data('colorPicker');
            if (!currentData)
                return;
            $(currentData.colorpicker).show().toggleClass('colorpicker--mobile', isMobile);
            // If the old color was transparent, reset to default color. 
            if (!currentData.color) {
                currentData.color = '#000000';
                currentData.hsb = HexToHSB(currentData.color);
            }
            currentData.colorChanged = false;
            updateRecentColors(currentData);
            updateUsedColors(currentData);
            updatePosition(_this);
            $(document).on('mousedown', { currentData: currentData }, documentHide);
            $(document).on("touchend", { currentData: currentData }, documentHide);
        });
    };
    var hidePicker = function () {
        var _this = this;
        this.each(function () {
            var currentData = $(_this).data('colorPicker');
            if (!currentData)
                return;
            close(currentData);
        });
    };
    var setColor = function (newColor) {
        var _this = this;
        this.each(function () {
            var currentData = $(_this).data('colorPicker');
            if (!currentData)
                return;
            change(currentData, newColor);
        });
    };
    $.fn.extend({
        ColorPicker: create,
        ColorPickerNew: create,
        ColorPickerHide: hidePicker,
        ColorPickerShow: showPicker,
        ColorPickerSetColor: setColor
    });
    var generateUUID = function () {
        var d = new Date().getTime();
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c == 'x' ? r : (r & 0x7 | 0x8)).toString(16);
        });
        return uuid;
    };
    var fixHSB = function (hsb) {
        return {
            h: Math.min(360, Math.max(0, hsb.h)),
            s: Math.min(100, Math.max(0, hsb.s)),
            b: Math.min(100, Math.max(0, hsb.b))
        };
    };
    var fixRGB = function (rgb) {
        return {
            r: Math.min(255, Math.max(0, rgb.r)),
            g: Math.min(255, Math.max(0, rgb.g)),
            b: Math.min(255, Math.max(0, rgb.b))
        };
    };
    var fixHex = function (hex) {
        var len = 6 - hex.length;
        if (len > 0) {
            var o = [];
            for (var i = 0; i < len; i++) {
                o.push('0');
            }
            o.push(hex);
            hex = o.join('');
        }
        return hex;
    };
    var HexToRGB = function (hex) {
        var hexParsed = parseInt(((hex.indexOf('#') > -1) ? hex.substring(1) : hex), 16);
        return { r: hexParsed >> 16, g: (hexParsed & 0x00FF00) >> 8, b: (hexParsed & 0x0000FF) };
    };
    var HexToHSB = function (hex) {
        return RGBToHSB(HexToRGB(hex));
    };
    var RGBToHSB = function (rgb) {
        var hsb = {
            h: 0,
            s: 0,
            b: 0
        };
        var min = Math.min(rgb.r, rgb.g, rgb.b);
        var max = Math.max(rgb.r, rgb.g, rgb.b);
        var delta = max - min;
        hsb.b = max;
        if (max != 0) {
        }
        hsb.s = max != 0 ? 255 * delta / max : 0;
        if (hsb.s != 0) {
            if (rgb.r == max) {
                hsb.h = (rgb.g - rgb.b) / delta;
            }
            else if (rgb.g == max) {
                hsb.h = 2 + (rgb.b - rgb.r) / delta;
            }
            else {
                hsb.h = 4 + (rgb.r - rgb.g) / delta;
            }
        }
        else {
            hsb.h = -1;
        }
        hsb.h *= 60;
        if (hsb.h < 0) {
            hsb.h += 360;
        }
        hsb.s *= 100 / 255;
        hsb.b *= 100 / 255;
        return hsb;
    };
    var HSBToRGB = function (hsb) {
        var h = hsb.h;
        var s = hsb.s;
        var v = hsb.b;
        var r, g, b;
        var i;
        var f, p, q, t;
        // Make sure our arguments stay in-range
        h = Math.max(0, Math.min(360, h));
        s = Math.max(0, Math.min(100, s));
        v = Math.max(0, Math.min(100, v));
        // We accept saturation and value arguments from 0 to 100 because that's
        // how Photoshop represents those values. Internally, however, the
        // saturation and value are calculated from a range of 0 to 1. We make
        // That conversion here.
        s /= 100;
        v /= 100;
        if (s == 0) {
            // Achromatic (grey)
            r = g = b = v;
            return { r: Math.round(r * 255), g: Math.round(g * 255), b: Math.round(b * 255) };
        }
        h /= 60; // sector 0 to 5
        i = Math.floor(h);
        f = h - i; // factorial part of h
        p = v * (1 - s);
        q = v * (1 - s * f);
        t = v * (1 - s * (1 - f));
        switch (i) {
            case 0:
                r = v;
                g = t;
                b = p;
                break;
            case 1:
                r = q;
                g = v;
                b = p;
                break;
            case 2:
                r = p;
                g = v;
                b = t;
                break;
            case 3:
                r = p;
                g = q;
                b = v;
                break;
            case 4:
                r = t;
                g = p;
                b = v;
                break;
            default: // case 5:
                r = v;
                g = p;
                b = q;
        }
        return { r: Math.round(r * 255), g: Math.round(g * 255), b: Math.round(b * 255) };
    };
    var RGBToHex = function (rgb) {
        var hex = [
            rgb.r.toString(16),
            rgb.g.toString(16),
            rgb.b.toString(16)
        ];
        $.each(hex, function (nr, val) {
            if (val.length == 1) {
                hex[nr] = '0' + val;
            }
        });
        return hex.join('');
    };
    var HSBToHex = function (hsb) {
        return RGBToHex(HSBToRGB(hsb));
    };
})(jQuery);

var Zakeke;
(function (Zakeke) {
    var Customizer;
    (function (Customizer) {
        var HalfoneType;
        (function (HalfoneType) {
            HalfoneType[HalfoneType["None"] = 0] = "None";
            HalfoneType[HalfoneType["ErrorDiffusion"] = 1] = "ErrorDiffusion";
            HalfoneType[HalfoneType["Dithering"] = 2] = "Dithering";
        })(HalfoneType = Customizer.HalfoneType || (Customizer.HalfoneType = {}));
        var ImageProcessor = /** @class */ (function () {
            function ImageProcessor() {
            }
            ImageProcessor.greyScale = function (url, halftone, invertColors, color) {
                var _this = this;
                if (halftone === void 0) { halftone = HalfoneType.None; }
                if (invertColors === void 0) { invertColors = false; }
                if (color === void 0) { color = null; }
                return new Promise(function (resolve, reject) {
                    var original = new MarvinImage();
                    original.load(url, function () {
                        var image = original.clone();
                        Marvin.grayScale(original, image);
                        if (halftone != HalfoneType.None) {
                            if (halftone == HalfoneType.ErrorDiffusion)
                                _this.errorDiffusion(image, image);
                            else if (halftone == HalfoneType.Dithering)
                                _this.dithering(image, image);
                            if (invertColors)
                                _this.invertImageColors(image, image);
                            if (color)
                                _this.replaceBlack(image, color.red, color.green, color.blue);
                        }
                        else {
                            if (invertColors)
                                _this.invertImageColors(image, image);
                            if (color)
                                _this.overlayColorToImage(image, image, color.red, color.green, color.blue);
                        }
                        resolve(image.toBlob());
                    });
                });
            };
            ImageProcessor.greyScalePlus = function (url, halftoneType, invertColors, color) {
                var _this = this;
                if (halftoneType === void 0) { halftoneType = HalfoneType.None; }
                if (invertColors === void 0) { invertColors = false; }
                if (color === void 0) { color = null; }
                return new Promise(function (resolve, reject) {
                    var original = new MarvinImage();
                    original.load(url, function () {
                        var image = original.clone();
                        Marvin.grayScale(original, image);
                        var hsb = [0, 0, 0];
                        for (var y = 0; y < image.getHeight(); y++) {
                            for (var x = 0; x < image.getWidth(); x++) {
                                var alpha = original.getAlphaComponent(x, y);
                                var sourceRed = image.getIntComponent0(x, y);
                                var sourceGreen = image.getIntComponent1(x, y);
                                var sourceBlue = image.getIntComponent2(x, y);
                                // desaturate
                                _this.RGBtoHSB(sourceRed, sourceGreen, sourceBlue, hsb);
                                hsb[1] = 0.0;
                                var des = _this.HSBtoRGB(hsb[0], hsb[1], hsb[2]);
                                var desColor = _this.numberToColor(des);
                                var redPart = _this.overlayColorComponentValue(desColor.red, sourceRed);
                                var greenPart = _this.overlayColorComponentValue(desColor.green, sourceGreen);
                                var bluePart = _this.overlayColorComponentValue(desColor.blue, sourceBlue);
                                image.setIntColor(x, y, alpha, redPart, greenPart, bluePart);
                            }
                        }
                        image.update();
                        if (halftoneType != HalfoneType.None) {
                            if (halftoneType == HalfoneType.ErrorDiffusion)
                                _this.errorDiffusion(image, image);
                            else if (halftoneType == HalfoneType.Dithering)
                                _this.dithering(image, image);
                            if (invertColors)
                                _this.invertImageColors(image, image);
                            if (color)
                                _this.replaceBlack(image, color.red, color.green, color.blue);
                        }
                        else {
                            if (invertColors)
                                _this.invertImageColors(image, image);
                            if (color)
                                _this.overlayColorToImage(image, image, color.red, color.green, color.blue);
                        }
                        resolve(image.toBlob());
                    });
                });
            };
            ImageProcessor.desaturate = function (url, halftoneType, invertColors, color) {
                var _this = this;
                if (halftoneType === void 0) { halftoneType = HalfoneType.None; }
                if (invertColors === void 0) { invertColors = false; }
                if (color === void 0) { color = null; }
                return new Promise(function (resolve, reject) {
                    var original = new MarvinImage();
                    original.load(url, function () {
                        var image = original.clone();
                        var hsb = [0, 0, 0];
                        for (var y = 0; y < image.getHeight(); y++) {
                            for (var x = 0; x < image.getWidth(); x++) {
                                var alpha = original.getAlphaComponent(x, y);
                                // desaturate
                                _this.RGBtoHSB(image.getIntComponent0(x, y), image.getIntComponent1(x, y), image.getIntComponent2(x, y), hsb);
                                hsb[1] = 0.0;
                                var des = _this.HSBtoRGB(hsb[0], hsb[1], hsb[2]);
                                var desColor = _this.numberToColor(des);
                                image.setIntColor(x, y, alpha, desColor.red, desColor.green, desColor.blue);
                            }
                        }
                        //image.update();
                        if (halftoneType != HalfoneType.None) {
                            if (halftoneType == HalfoneType.ErrorDiffusion)
                                _this.errorDiffusion(image, image);
                            else if (halftoneType == HalfoneType.Dithering)
                                _this.dithering(image, image);
                            if (invertColors)
                                _this.invertImageColors(image, image);
                            if (color)
                                _this.replaceBlack(image, color.red, color.green, color.blue);
                        }
                        else {
                            if (invertColors)
                                _this.invertImageColors(image, image);
                            if (color)
                                _this.overlayColorToImage(image, image, color.red, color.green, color.blue);
                        }
                        resolve(image.toBlob());
                    });
                });
            };
            ImageProcessor.blackAndWhite = function (url, halftoneType, invertColors, color) {
                var _this = this;
                if (halftoneType === void 0) { halftoneType = HalfoneType.None; }
                if (invertColors === void 0) { invertColors = false; }
                if (color === void 0) { color = null; }
                return new Promise(function (resolve, reject) {
                    var imageIn = new MarvinImage();
                    imageIn.load(url, function () {
                        var imageOut = imageIn.clone();
                        var rlevel = (20 / 100.0) * 0.03;
                        var gray = 0;
                        for (var y = 0; y < imageOut.getHeight(); y++) {
                            for (var x = 0; x < imageOut.getWidth(); x++) {
                                var alpha = imageIn.getAlphaComponent(x, y);
                                gray = imageIn.getIntComponent0(x, y);
                                if (gray <= 127) {
                                    gray = Math.max((gray * (1 - ((127 - gray) * rlevel))), 0);
                                }
                                else {
                                    gray = Math.min(gray * (1 + ((gray - 127) * rlevel)), 255);
                                }
                                imageOut.setIntColor(x, y, alpha, gray, gray, gray);
                            }
                        }
                        if (halftoneType != HalfoneType.None) {
                            if (halftoneType == HalfoneType.ErrorDiffusion)
                                _this.errorDiffusion(imageOut, imageOut);
                            else if (halftoneType == HalfoneType.Dithering)
                                _this.dithering(imageOut, imageOut);
                            if (invertColors)
                                _this.invertImageColors(imageOut, imageOut);
                            if (color)
                                _this.replaceBlack(imageOut, color.red, color.green, color.blue);
                        }
                        else {
                            if (invertColors)
                                _this.invertImageColors(imageOut, imageOut);
                            if (color)
                                _this.overlayColorToImage(imageOut, imageOut, color.red, color.green, color.blue);
                        }
                        resolve(imageOut.toBlob());
                    });
                });
            };
            ImageProcessor.thresholding = function (url, threshold, invertColors, color) {
                var _this = this;
                if (invertColors === void 0) { invertColors = false; }
                if (color === void 0) { color = null; }
                if (threshold == undefined || threshold == null)
                    threshold = 160;
                return new Promise(function (resolve, reject) {
                    var original = new MarvinImage();
                    original.load(url, function () {
                        var image = original.clone();
                        Marvin.thresholding(original, image, threshold);
                        if (invertColors)
                            _this.invertImageColors(image, image);
                        if (color)
                            _this.replaceBlack(image, color.red, color.green, color.blue);
                        resolve(image.toBlob());
                    });
                });
            };
            ImageProcessor.thresholdingTransparentWhite = function (url, threshold, invertColors, color) {
                var _this = this;
                if (invertColors === void 0) { invertColors = false; }
                if (color === void 0) { color = null; }
                if (threshold == undefined || threshold == null)
                    threshold = 160;
                return new Promise(function (resolve, reject) {
                    var original = new MarvinImage();
                    original.load(url, function () {
                        var image = original.clone();
                        Marvin.thresholding(original, image, threshold);
                        if (invertColors)
                            _this.invertImageColors(image, image);
                        _this.setWhiteTransparent(image);
                        if (color)
                            _this.replaceBlack(image, color.red, color.green, color.blue);
                        resolve(image.toBlob());
                    });
                });
            };
            ImageProcessor.thresholdingDarkAndLight = function (url, threshold, invertColors, darkColor, lightColor) {
                var _this = this;
                if (invertColors === void 0) { invertColors = false; }
                if (threshold == undefined || threshold == null)
                    threshold = 160;
                return new Promise(function (resolve, reject) {
                    var original = new MarvinImage();
                    original.load(url, function () {
                        var image = original.clone();
                        Marvin.thresholding(original, image, threshold);
                        if (invertColors)
                            _this.invertImageColors(image, image);
                        _this.replaceBlackAndWhite(image, darkColor, lightColor);
                        _this.setWhiteTransparent(image);
                        resolve(image.toBlob());
                    });
                });
            };
            ImageProcessor.halftoneErrorDiffusion = function (url) {
                return new Promise(function (resolve, reject) {
                    var original = new MarvinImage();
                    original.load(url, function () {
                        var image = original.clone();
                        Marvin.halftoneErrorDiffusion(original, image);
                        resolve(image.toBlob());
                    });
                });
            };
            ImageProcessor.overlapColor = function (url, color, removeWhite) {
                var realColor = color ? color : { red: 0, green: 0, blue: 0 };
                return new Promise(function (resolve, reject) {
                    var original = new MarvinImage();
                    original.load(url, function () {
                        var image = original.clone();
                        for (var y = 0; y < image.getHeight(); y++) {
                            for (var x = 0; x < image.getWidth(); x++) {
                                var alpha = original.getAlphaComponent(x, y);
                                var r = original.getIntComponent0(x, y);
                                var g = original.getIntComponent1(x, y);
                                var b = original.getIntComponent2(x, y);
                                if (removeWhite && r == 255 && g == 255 && b == 255)
                                    alpha = 0;
                                image.setIntColor(x, y, alpha, realColor.red, realColor.green, realColor.blue);
                            }
                        }
                        resolve(image.toBlob());
                    });
                });
            };
            // Useful for debug
            ImageProcessor.downloadImage = function (image, filename) {
                filename = filename || "test.png";
                var blob = image.toBlob();
                var aElement = document.createElement('a');
                aElement.setAttribute('download', filename);
                var href = URL.createObjectURL(blob);
                aElement.href = href;
                aElement.setAttribute('target', '_blank');
                aElement.click();
                URL.revokeObjectURL(href);
            };
            ImageProcessor.overlayColor = function (url, color) {
                var _this = this;
                var realColor = color ? color : { red: 0, green: 0, blue: 0 };
                return new Promise(function (resolve, reject) {
                    var original = new MarvinImage();
                    original.load(url, function () {
                        var image = original.clone();
                        var hsb = [0, 0, 0];
                        for (var y = 0; y < image.getHeight(); y++) {
                            for (var x = 0; x < image.getWidth(); x++) {
                                var alpha = original.getAlphaComponent(x, y);
                                // desaturate
                                _this.RGBtoHSB(original.getIntComponent0(x, y), original.getIntComponent1(x, y), original.getIntComponent2(x, y), hsb);
                                hsb[1] = 0.0;
                                var des = _this.HSBtoRGB(hsb[0], hsb[1], hsb[2]);
                                var desColor = _this.numberToColor(des);
                                var redPart = _this.multiplyColorComponentValue(desColor.red, realColor.red);
                                var greenPart = _this.multiplyColorComponentValue(desColor.green, realColor.green);
                                var bluePart = _this.multiplyColorComponentValue(desColor.blue, realColor.blue);
                                image.setIntColor(x, y, alpha, redPart, greenPart, bluePart);
                            }
                        }
                        resolve(image.toBlob());
                    });
                });
            };
            ImageProcessor.overlayColorHard = function (url, color) {
                var _this = this;
                var realColor = color ? color : { red: 0, green: 0, blue: 0 };
                return new Promise(function (resolve, reject) {
                    var imageIn = new MarvinImage();
                    imageIn.load(url, function () {
                        var imageOut = imageIn.clone();
                        var rlevel = (20 / 100.0) * 0.03;
                        var gray = 0;
                        for (var y = 0; y < imageOut.getHeight(); y++) {
                            for (var x = 0; x < imageOut.getWidth(); x++) {
                                var alpha = imageIn.getAlphaComponent(x, y);
                                gray = imageIn.getIntComponent0(x, y);
                                if (gray <= 127) {
                                    gray = Math.max((gray * (1 - ((127 - gray) * rlevel))), 0);
                                }
                                else {
                                    gray = Math.min(gray * (1 + ((gray - 127) * rlevel)), 255);
                                }
                                var r = _this.multiplyColorComponentValue(gray, realColor.red);
                                var g = _this.multiplyColorComponentValue(gray, realColor.green);
                                var b = _this.multiplyColorComponentValue(gray, realColor.blue);
                                imageOut.setIntColor(x, y, alpha, r, g, b);
                            }
                        }
                        /* To pass DataUrl
                        var blob = imageOut.toBlob()
                        var reader = new FileReader();
                        reader.readAsDataURL(blob);
                        reader.onloadend = function() {
                            var base64data = reader.result;
                            resolve(base64data);
                        }
                        */
                        resolve(imageOut.toBlob());
                    });
                });
            };
            ImageProcessor.edgeDetection2 = function (url) {
                return new Promise(function (resolve, reject) {
                    var original = new MarvinImage();
                    original.load(url, function () {
                        var image = original.clone();
                        image.clear(0xFF000000);
                        Marvin.prewitt(original, image);
                        Marvin.invertColors(image, image);
                        Marvin.thresholding(image, image, 200);
                        resolve(image.toBlob());
                    });
                });
            };
            ImageProcessor.multiplyColorComponentValue = function (source, overlay) {
                var result = source * overlay / 255;
                if (result > 255) {
                    result = 255;
                }
                else if (result < 0) {
                    result = 0;
                }
                else {
                    result = Math.floor(result);
                }
                return result;
            };
            ImageProcessor.overlayColorComponentValue = function (source, overlay) {
                var base = source / 255;
                var blend = overlay / 255;
                var result = base < 0.5 ? (2.0 * base * blend) : (1.0 - 2.0 * (1.0 - base) * (1.0 - blend));
                return Math.floor(result * 255);
            };
            ImageProcessor.RGBtoHSB = function (red, green, blue, array) {
                if (array == null)
                    array = [];
                // Calculate brightness.
                var min = 0;
                var max = 0;
                if (red < green) {
                    min = red;
                    max = green;
                }
                else {
                    min = green;
                    max = red;
                }
                if (blue > max)
                    max = blue;
                else if (blue < min)
                    min = blue;
                array[2] = max / 255;
                // Calculate saturation.
                if (max == 0)
                    array[1] = 0;
                else
                    array[1] = (max - min) / max;
                // Calculate hue.
                if (array[1] == 0)
                    array[0] = 0;
                else {
                    var delta = (max - min) * 6;
                    if (red == max)
                        array[0] = (green - blue) / delta;
                    else if (green == max)
                        array[0] = 1.0 / 3.0 + (blue - red) / delta;
                    else
                        array[0] = 2.0 / 3.0 + (red - green) / delta;
                    if (array[0] < 0)
                        array[0]++;
                }
                return array;
            };
            ImageProcessor.HSBtoRGB = function (hue, saturation, brightness) {
                if (saturation == 0)
                    return this.convert(brightness, brightness, brightness, 0);
                hue = hue - Math.floor(hue);
                var i = 6 * hue;
                var f = 6 * hue - i;
                var p = brightness * (1 - saturation);
                var q = brightness * (1 - saturation * f);
                var t = brightness * (1 - saturation * (1 - f));
                switch (i) {
                    case 0:
                        return this.convert(brightness, t, p, 0);
                    case 1:
                        return this.convert(q, brightness, p, 0);
                    case 2:
                        return this.convert(p, brightness, t, 0);
                    case 3:
                        return this.convert(p, q, brightness, 0);
                    case 4:
                        return this.convert(t, p, brightness, 0);
                    case 5:
                        return this.convert(brightness, p, q, 0);
                }
            };
            ImageProcessor.convert = function (red, green, blue, alpha) {
                var redval = Math.round(255 * red);
                var greenval = Math.round(255 * green);
                var blueval = Math.round(255 * blue);
                var alphaval = Math.round(255 * alpha);
                return (alphaval << 24) | (redval << 16) | (greenval << 8) | blueval;
            };
            ImageProcessor.numberToColor = function (value) {
                return {
                    red: (value & this.RED_MASK) >> 16,
                    green: (value & this.GREEN_MASK) >> 8,
                    blue: value & this.BLUE_MASK
                };
            };
            ImageProcessor.errorDiffusion = function (imageIn, imageOut) {
                var color = 0;
                var dif = 0;
                var threshold = 128;
                for (var y = 0; y < imageOut.getHeight(); y++) {
                    for (var x = 0; x < imageOut.getWidth(); x++) {
                        color = imageOut.getIntComponent0(x, y);
                        if (color > threshold) {
                            imageOut.setIntColor(x, y, imageIn.getAlphaComponent(x, y), 255, 255, 255);
                            dif = -(255 - color);
                        }
                        else {
                            imageOut.setIntColor(x, y, imageIn.getAlphaComponent(x, y), 0, 0, 0);
                            dif = color;
                        }
                        // Pixel Right
                        if (x + 1 < imageOut.getWidth()) {
                            color = imageOut.getIntComponent0(x + 1, y);
                            color += Math.floor(0.4375 * dif);
                            color = this.getValidGray(color);
                            imageOut.setIntColor(x + 1, y, imageIn.getAlphaComponent(x + 1, y), color, color, color);
                            // Pixel Right Down
                            if (y + 1 < imageOut.getHeight()) {
                                color = imageOut.getIntComponent0(x + 1, y + 1);
                                color += Math.floor(0.0625 * dif);
                                color = this.getValidGray(color);
                                imageOut.setIntColor(x + 1, y + 1, imageIn.getAlphaComponent(x + 1, y + 1), color, color, color);
                            }
                        }
                        // Pixel Down
                        if (y + 1 < imageOut.getHeight()) {
                            color = imageOut.getIntComponent0(x, y + 1);
                            color += Math.floor(0.3125 * dif);
                            color = this.getValidGray(color);
                            imageOut.setIntColor(x, y + 1, imageIn.getAlphaComponent(x, y + 1), color, color, color);
                            // Pixel Down Left
                            if (x - 1 >= 0) {
                                color = imageOut.getIntComponent0(x - 1, y + 1);
                                color += Math.floor(0.1875 * dif);
                                color = this.getValidGray(color);
                                imageOut.setIntColor(x - 1, y + 1, imageIn.getAlphaComponent(x - 1, y + 1), color, color, color);
                            }
                        }
                    }
                }
            };
            ImageProcessor.dithering = function (imageIn, imageOut) {
                var DOT_AREA = 5;
                var arrDither = [167, 200, 230, 216, 181,
                    94, 72, 193, 242, 232,
                    36, 52, 222, 167, 200,
                    181, 126, 210, 94, 72,
                    232, 153, 111, 36, 52];
                for (var x = 0; x < imageIn.getWidth(); x += DOT_AREA) {
                    for (var y = 0; y < imageIn.getHeight(); y += DOT_AREA) {
                        var l_grayIntensity = void 0;
                        var l_x = void 0;
                        var l_y = void 0;
                        for (var dx = 0; dx < DOT_AREA * DOT_AREA; dx++) {
                            l_x = dx % DOT_AREA;
                            l_y = dx / DOT_AREA;
                            if (x + l_x < imageIn.getWidth() && y + l_y < imageIn.getHeight()) {
                                l_grayIntensity = 255 - (imageIn.getIntComponent0(x + l_x, y + l_y));
                                if (l_grayIntensity > arrDither[dx]) {
                                    imageOut.setIntColor(x + l_x, y + l_y, imageIn.getAlphaComponent(x + l_x, y + l_y), 0, 0, 0);
                                }
                                else {
                                    imageOut.setIntColor(x + l_x, y + l_y, imageIn.getAlphaComponent(x + l_x, y + l_y), 255, 255, 255);
                                }
                            }
                        }
                    }
                }
            };
            ImageProcessor.getValidGray = function (a_value) {
                if (a_value < 0)
                    return 0;
                if (a_value > 255)
                    return 255;
                return a_value;
            };
            ImageProcessor.replaceBlack = function (imageOut, red, green, blue) {
                for (var y = 0; y < imageOut.getHeight(); y++) {
                    for (var x = 0; x < imageOut.getWidth(); x++) {
                        var alpha = imageOut.getAlphaComponent(x, y);
                        var r = imageOut.getIntComponent0(x, y);
                        var g = imageOut.getIntComponent1(x, y);
                        var b = imageOut.getIntComponent2(x, y);
                        if (r == 0 && g == 0 && b == 0) {
                            r = red;
                            g = green;
                            b = blue;
                        }
                        imageOut.setIntColor(x, y, alpha, r, g, b);
                    }
                }
            };
            ImageProcessor.replaceBlackAndWhite = function (imageOut, darkColor, lightColor) {
                for (var y = 0; y < imageOut.getHeight(); y++) {
                    for (var x = 0; x < imageOut.getWidth(); x++) {
                        var alpha = imageOut.getAlphaComponent(x, y);
                        var r = imageOut.getIntComponent0(x, y);
                        var g = imageOut.getIntComponent1(x, y);
                        var b = imageOut.getIntComponent2(x, y);
                        if (r == 0 && g == 0 && b == 0) {
                            r = darkColor.red;
                            g = darkColor.green;
                            b = darkColor.blue;
                        }
                        else if (r == 255 && g == 255 && b == 255) {
                            r = lightColor.red;
                            g = lightColor.green;
                            b = lightColor.blue;
                        }
                        imageOut.setIntColor(x, y, alpha, r, g, b);
                    }
                }
            };
            ImageProcessor.setWhiteTransparent = function (imageOut) {
                for (var y = 0; y < imageOut.getHeight(); y++) {
                    for (var x = 0; x < imageOut.getWidth(); x++) {
                        var alpha = imageOut.getAlphaComponent(x, y);
                        var r = imageOut.getIntComponent0(x, y);
                        var g = imageOut.getIntComponent1(x, y);
                        var b = imageOut.getIntComponent2(x, y);
                        if (r == 255 && g == 255 && b == 255) {
                            alpha = 0;
                        }
                        imageOut.setIntColor(x, y, alpha, r, g, b);
                    }
                }
            };
            ImageProcessor.replaceColor = function (imageOut, colorIn, colorOut) {
                for (var y = 0; y < imageOut.getHeight(); y++) {
                    for (var x = 0; x < imageOut.getWidth(); x++) {
                        var alpha = imageOut.getAlphaComponent(x, y);
                        var r = imageOut.getIntComponent0(x, y);
                        var g = imageOut.getIntComponent1(x, y);
                        var b = imageOut.getIntComponent2(x, y);
                        if (r == colorIn.red && g == colorIn.green && b == colorIn.blue) {
                            r = colorOut.red;
                            g = colorOut.green;
                            b = colorOut.blue;
                        }
                        imageOut.setIntColor(x, y, alpha, r, g, b);
                    }
                }
            };
            ImageProcessor.overlayColorToImage = function (imageIn, imageOut, red, green, blue) {
                for (var y = 0; y < imageOut.getHeight(); y++) {
                    for (var x = 0; x < imageOut.getWidth(); x++) {
                        var alpha = imageIn.getAlphaComponent(x, y);
                        var redPart = this.multiplyColorComponentValue(imageOut.getIntComponent0(x, y), red);
                        var greenPart = this.multiplyColorComponentValue(imageOut.getIntComponent1(x, y), green);
                        var bluePart = this.multiplyColorComponentValue(imageOut.getIntComponent2(x, y), blue);
                        imageOut.setIntColor(x, y, alpha, redPart, greenPart, bluePart);
                    }
                }
                imageOut.update();
            };
            ImageProcessor.invertImageColors = function (imageIn, imageOut) {
                Marvin.invertColors(imageIn, imageOut);
            };
            ImageProcessor.hexToRgb = function (hex) {
                var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
                return result ? {
                    r: parseInt(result[1], 16),
                    g: parseInt(result[2], 16),
                    b: parseInt(result[3], 16)
                } : null;
            };
            ImageProcessor.componentToHex = function (c) {
                var hex = c.toString(16);
                return hex.length == 1 ? "0" + hex : hex;
            };
            ImageProcessor.rgbToHex = function (r, g, b) {
                return "#" + this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b);
            };
            ImageProcessor.textToPalette = function (paletteText, allowNulls) {
                if (allowNulls === void 0) { allowNulls = false; }
                var palette = [];
                if (paletteText) {
                    var parts = paletteText.split(',');
                    parts.forEach(function (p) {
                        if (p && p != "null") {
                            var colorPart = ImageProcessor.hexToRgb(p);
                            if (colorPart) {
                                palette.push([colorPart.r, colorPart.g, colorPart.b]);
                            }
                        }
                        else if (allowNulls) {
                            palette.push(null);
                        }
                    });
                }
                return palette;
            };
            ImageProcessor.paletteToText = function (palette) {
                var text = "";
                if (palette && palette.length > 0) {
                    for (var i = 0; i < palette.length; i++) {
                        var rgb = palette[i];
                        if (text.length > 0)
                            text += ",";
                        text += this.rgbToHex(rgb[0], rgb[1], rgb[2]);
                    }
                }
                return text;
            };
            ImageProcessor.rgbToInt = function (r, g, b) {
                var i32 = (255 << 24) | // alpha
                    (b << 16) | // blue
                    (g << 8) | // green
                    r; // red
                return i32;
            };
            ImageProcessor.intToRgb = function (i32) {
                var rgb = [
                    (i32 & 0xff),
                    (i32 & 0xff00) >> 8,
                    (i32 & 0xff0000) >> 16,
                ];
                return rgb;
            };
            ImageProcessor.reduce = function (url, colors, palette, replacementPalette) {
                var _this = this;
                return new Promise(function (resolve, reject) {
                    var pal = _this.textToPalette(palette);
                    var repPal = null;
                    if (replacementPalette) {
                        repPal = _this.textToPalette(replacementPalette, true);
                    }
                    if (pal && repPal && pal.length != repPal.length) {
                        reject("The replacement palette must contains the same colors of main palette");
                    }
                    var image = new Image();
                    image.addEventListener('load', function () {
                        var opts = { colors: 256, palette: [], paletteRep: undefined };
                        if (colors != undefined && colors != null)
                            opts.colors = colors;
                        if (pal.length > 0) {
                            opts.colors = pal.length;
                            opts.palette = pal;
                            if (repPal && repPal.length == pal.length) {
                                opts.paletteRep = repPal;
                            }
                        }
                        var q = new RgbQuant(opts);
                        if (pal.length == 0) {
                            q.sample(image);
                            var quantizedPalette = q.palette(true);
                        }
                        var output = q.reduce(image, 3);
                        var blob = new Blob([output]);
                        resolve(blob);
                    });
                    image.crossOrigin = "Anonymous";
                    image.src = url;
                });
            };
            ImageProcessor.getImagePalette = function (url, numColors) {
                var _this = this;
                var maxColors = Math.min(256, numColors);
                var colors = maxColors;
                if (colors < 256) {
                    colors = Math.min(256, colors + 10);
                }
                return new Promise(function (resolve, reject) {
                    var image = new Image();
                    image.addEventListener('load', function () {
                        var opts = { colors: colors };
                        var q = new RgbQuant(opts);
                        q.sample(image);
                        var quantizedPalette = q.palette(true, true);
                        var output = _this.paletteToText(quantizedPalette).split(',').slice(0, maxColors);
                        output = output.filter(function (value, i, self) { return self.indexOf(value) === i; });
                        resolve(output);
                    });
                    image.crossOrigin = "Anonymous";
                    image.src = url;
                });
            };
            ImageProcessor.remapPalette = function (sourcePalette, targetPalette) {
                var targetPaletteRgb = [];
                for (var i = 0; i < targetPalette.length; i++) {
                    var colorPart = ImageProcessor.hexToRgb(targetPalette[i]);
                    if (colorPart) {
                        targetPaletteRgb.push([colorPart.r, colorPart.g, colorPart.b]);
                    }
                }
                var opts = { colors: 256, palette: [] };
                if (targetPaletteRgb.length > 0) {
                    opts.colors = targetPaletteRgb.length;
                    opts.palette = targetPaletteRgb;
                }
                var q = new RgbQuant(opts);
                var result = {};
                for (var i = 0; i < sourcePalette.length; i++) {
                    var hexColor = sourcePalette[i];
                    var rgbColor = ImageProcessor.hexToRgb(hexColor);
                    var i32 = ImageProcessor.rgbToInt(rgbColor.r, rgbColor.g, rgbColor.b);
                    var newI32 = q.nearestColor(i32);
                    var newRgbArray = ImageProcessor.intToRgb(newI32);
                    var newColor = ImageProcessor.rgbToHex(newRgbArray[0], newRgbArray[1], newRgbArray[2]);
                    result[hexColor] = newColor;
                }
                return result;
            };
            ImageProcessor.remapColor = function (hexColor, targetPalette) {
                return ImageProcessor.remapPalette([hexColor], targetPalette)[hexColor];
            };
            ImageProcessor.pixelize = function (url, tileSize) {
                if (tileSize === void 0) { tileSize = 8; }
                return new Promise(function (resolve, reject) {
                    var original = new MarvinImage();
                    original.load(url, function () {
                        var image = original.clone();
                        var width = image.getWidth();
                        var height = image.getHeight();
                        // Process each tile
                        for (var y = 0; y < height; y += tileSize) {
                            var _loop_1 = function (x) {
                                var tileWidth = Math.min(tileSize, width - x);
                                var tileHeight = Math.min(tileSize, height - y);
                                // Create a color frequency map for this tile
                                var colorMap = new Map();
                                // Count frequency of each color in the tile
                                for (var ty = 0; ty < tileHeight; ty++) {
                                    for (var tx = 0; tx < tileWidth; tx++) {
                                        var px = x + tx;
                                        var py = y + ty;
                                        var r = image.getIntComponent0(px, py);
                                        var g = image.getIntComponent1(px, py);
                                        var b = image.getIntComponent2(px, py);
                                        var a = image.getAlphaComponent(px, py);
                                        // Create a key for this color
                                        var colorKey = "".concat(r, ",").concat(g, ",").concat(b, ",").concat(a);
                                        if (!colorMap.has(colorKey)) {
                                            colorMap.set(colorKey, {
                                                count: 1,
                                                color: { r: r, g: g, b: b, a: a }
                                            });
                                        }
                                        else {
                                            var entry = colorMap.get(colorKey);
                                            entry.count++;
                                        }
                                    }
                                }
                                // Find the most frequent color
                                var dominantColor = { r: 0, g: 0, b: 0, a: 255 };
                                var maxCount = 0;
                                colorMap.forEach(function (entry) {
                                    if (entry.count > maxCount) {
                                        maxCount = entry.count;
                                        dominantColor = entry.color;
                                    }
                                });
                                // Apply the dominant color to all pixels in the tile
                                for (var ty = 0; ty < tileHeight; ty++) {
                                    for (var tx = 0; tx < tileWidth; tx++) {
                                        var px = x + tx;
                                        var py = y + ty;
                                        image.setIntColor(px, py, dominantColor.a, dominantColor.r, dominantColor.g, dominantColor.b);
                                    }
                                }
                            };
                            for (var x = 0; x < width; x += tileSize) {
                                _loop_1(x);
                            }
                        }
                        resolve(image.toBlob());
                    });
                });
            };
            ImageProcessor.RED_MASK = 255 << 16;
            ImageProcessor.GREEN_MASK = 255 << 8;
            ImageProcessor.BLUE_MASK = 255;
            return ImageProcessor;
        }());
        Customizer.ImageProcessor = ImageProcessor;
    })(Customizer = Zakeke.Customizer || (Zakeke.Customizer = {}));
})(Zakeke || (Zakeke = {}));
